(function () {
    'use strict';

    angular
    .module('plagiat2017App', [
        'ngStorage',
        'UserRegisterRequestModel',
        'DocumentRequestModel',
        'DocumentsRequestModel',
        'PaymentsRequestModel',
        'PaymentFormRequestModel',
        'tmh.dynamicLocale',
        'pascalprecht.translate',
        'ngMaterial',
        'ngMessages',
        'ngAnimate',
        'ngResource',
        'ngCookies',
        'ngAria',
        'ngSanitize',
        'ngCacheBuster',
        'ngFileUpload',
        'ui.router',
        'ui.tinymce',
        'infinite-scroll',
        'ngMessages',
        'md-steppers',
        'md.data.table',
        'fileUpload',
        'documentMetric',
        'documentButtons',
        'documentProtocol',
        'documentButtonsReport',
        'paymentsList',
        'sideNav',
        'token',
        'detectTabs',
        'bw.paging',
        'angularMoment',
        'ngBrowserUpdate',
        'ngFileSaver',
      // jhipster-needle-angularjs-add-module JHipster will add new module here
      //   'angular-loading-bar',
        'usersButtons',
        'documentParameterDefinitionsButtons',
        'organisationalUnitsButtons',
        'apKeysButtons',
        'rzSlider'
    ])
    .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    StatisticsSubmenuController.$inject = ['AccountService'];

    function StatisticsSubmenuController(AccountService) {
        var vm = this;
        vm.isAdmin = AccountService.role.isAdmin();
        vm.isSuperAdmin = AccountService.role.isSuperAdmin();
        vm.jsa = AccountService.getClientSettings().jsaIntegration;
        vm.orppdIntegration = AccountService.getClientSettings().orppdIntegration;
        vm.showInvoicesData = AccountService.account.email === 'aslowinska@antyplagiat.pl' ||
            AccountService.account.email === 'ekochanowska@antyplagiat.pl' ||
            AccountService.account.email === 'molszewski@antyplagiat.pl';
    }

    angular.module('plagiat2017App')
    .component('statisticsSubmenu', {
        templateUrl: 'app/statistics/statistics-submenu/statistics-submenu.template.html',
        controller: StatisticsSubmenuController,
        bindings: {
        	activeTab: '<'
        }
    });

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('statistics', {
            parent: 'account',
            url: '/statistics',
            data: {
                authorities: ['PERM_USER_ADMIN', 'PERM_USER_SUPERADMIN', 'PERM_USER_MINISTRY'],
                pageTitle: 'global.menu.account.statistics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/statistics/statistics.html',
                    controller: 'StatisticsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statistics');
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('client');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('StatisticsController', StatisticsController);

    StatisticsController.$inject = [
        'STATISTIC_OPTIONS', 'StatisticsService', 'AccountService', 'OPDOCUSTATUSES', 'SIMPLE_SEARCH_DELAY',
        'ClientService', 'SearchService', 'ClientQueryRequest', 'OrganisationalUnitsService', 'ModalService'];

    function StatisticsController(
        STATISTIC_OPTIONS, StatisticsService, AccountService, OPDOCUSTATUSES, SIMPLE_SEARCH_DELAY,
        ClientService, SearchService, ClientQueryRequest, OrganisationalUnitsService, ModalService
    ) {
        var vm = this;
        vm.activeTab = 'statistics';
        
        vm.clientSettings = AccountService.getClientSettings();
        if (vm.clientSettings.hideDocuSimilarityFactor && vm.clientSettings.hideDocuSimilarityFactorExt) {
            vm.noCoefficients = true;
        }
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.options = STATISTIC_OPTIONS;
        vm.option = vm.noCoefficients ? STATISTIC_OPTIONS.DOCUMENTS_CHECKED : STATISTIC_OPTIONS.COEFFICIENT_DISTRIBUTION;
        vm.dateTo = new Date();
        vm.dateFrom = new Date(vm.dateTo.getFullYear(), vm.dateTo.getMonth(), 1);

        vm.coefficientDistributionOptions = {
            organisationalUnitId: null,
            similarityFactor: !vm.clientSettings.hideDocuSimilarityFactor ? 1 : (!vm.clientSettings.showReversedSimilarityFactor ? 2 : 3),
            similarityFrom: 0,
            similarityTo: 100,
            docStatus: 1,
            step: 20,
            alerts: -1
        };

        vm.jsa = AccountService.getClientSettings().jsaIntegration;

        vm.searchRequest = {};
        vm.sumCharacters = sumCharacters;
        vm.sumPriorityCharacters = sumPriorityCharacters;
        vm.sumDocuments = sumDocuments;
        vm.generateExcelFile = generateExcelFile;
        vm.querySearchClients = querySearchClients;
        vm.clientQueryRequest = new ClientQueryRequest();
        vm.isAdmin = AccountService.role.isAdmin();
        vm.isSuperAdmin = AccountService.role.isSuperAdmin();
        vm.isReseller = AccountService.role.isReseller();
        vm.isMinistry = AccountService.role.isMinistry();

        vm.aiDetectionEnabled = AccountService.account.contractAiDetectionEnabled || vm.isSuperAdmin;
        vm.showStatisticPriorityColumn = vm.isSuperAdmin;

        vm.searchRequest.page = 1;
        vm.page = 1;
        vm.size = 20;

        vm.generate = generate;
        vm.change = change;
        vm.pageChange = pageChange;

        this.$onInit = function () {
            findOrganisationalUnits();
            vm.docStatuses = OPDOCUSTATUSES;
        };

        function findOrganisationalUnits() {
            if (vm.isSuperAdmin && vm.selectedClient) {
                OrganisationalUnitsService.findAllByClient(vm.selectedClient.id).then(function (response) {
                    vm.organisationalUnits = response.data;
                    vm.coefficientDistributionOptions.organisationalUnitId = vm.organisationalUnits[0].id;
                });
            } else if (!vm.isSuperAdmin) {
                OrganisationalUnitsService.findAllForClient().then(function (response) {
                    vm.organisationalUnits = response.data;
                    vm.coefficientDistributionOptions.organisationalUnitId = vm.organisationalUnits[0].id;
                });
            }
        }

        function checkIfParamsValid() {
            if (vm.dateTo < vm.dateFrom) {
                ModalService.showErrorModal({data: {code: 110}});
                return false;
            }
            return true;
        }
        
        function generate() {
            if (!checkIfParamsValid()) {
                return;
            }
            
            vm.loading = true;
            vm.searchRequest.dateFrom = vm.dateFrom;
            vm.searchRequest.dateTo = vm.dateTo;
            vm.searchRequest.page = vm.page - 1;
            vm.searchRequest.size = vm.size;
            vm.searchRequest.clientId = vm.selectedClient ? vm.selectedClient.id : null;

            if (vm.option == vm.options.COEFFICIENT_DISTRIBUTION) {
                vm.searchRequest.organisationalUnitId = vm.coefficientDistributionOptions.organisationalUnitId;
                vm.searchRequest.similarityFactor = vm.coefficientDistributionOptions.similarityFactor;
                vm.searchRequest.similarityFrom = vm.coefficientDistributionOptions.similarityFrom;
                vm.searchRequest.similarityTo = vm.coefficientDistributionOptions.similarityTo;
                vm.searchRequest.docStatus = vm.coefficientDistributionOptions.docStatus;
                vm.searchRequest.step = vm.coefficientDistributionOptions.step;
                vm.searchRequest.alerts = vm.coefficientDistributionOptions.alerts;
            }

            StatisticsService.getStatistics(vm.option.url, vm.searchRequest).then(function (data) {
                vm.data = data.data;
                vm.loading = false;
            });
            if (vm.option == vm.options.UNIT_CONTRACT || vm.option == vm.options.USER_CONTRACT) {
                vm.showStatisticPriorityColumn = vm.clientSettings.addPriorityFromContractEnabled || vm.data.charactersPrioritySum > 0 || vm.isSuperAdmin;
            }
        }

        function change() {
            vm.data = undefined;
        }

        function pageChange(page) {
            vm.page = page;
            generate();
        }

        vm.clientChange = function () {
            findOrganisationalUnits();
        };

        function sumCharacters(array) {
            return array.reduce(function (sum, unit) {
                return sum + unit.characterCount;
            }, 0);
        }

        function sumPriorityCharacters(array) {
            return array.reduce(function (sum, unit) {
                return sum + unit.characterPriorityCount;
            }, 0);
        }

        function sumDocuments(array) {
            return array.reduce(function (sum, unit) {
                return sum + unit.documentCount;
            }, 0);
        }

        function generateExcelFile() {
            vm.searchRequest.dateFrom = vm.dateFrom;
            vm.searchRequest.dateTo = vm.dateTo;
            vm.searchRequest.page = vm.page - 1;
            vm.searchRequest.size = 10000;
            StatisticsService.generateStatisticsFile(vm.option.url, vm.searchRequest);
        }

        function querySearchClients(query) {
            vm.searchRequest.pageNumber = 0;
            vm.searchRequest.pageSize = 20;
            vm.searchRequest.sortTab = SearchService.sort(vm.clientQueryRequest);
            vm.searchRequest.search = query;
            vm.searchRequest.simpleSearch = query;

            return ClientService.searchClients(vm.searchRequest).then(function (response) {
                return response.content;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('StatisticsService', Statistics);

    Statistics.$inject = ['$http', '$q', '$mdDialog', '$translate', 'PlagiatValidationService', 'DateUtils'];

    function Statistics($http, $q, $mdDialog, $translate, PlagiatValidationService, DateUtils) {

        var service = {
            getStatistics: getStatistics,
            generateStatisticsFile: generateStatisticsFile
        };

        var requestUrl = 'api/statistics/';
        var requestXlsUrl = 'api/statistics/xls/';

        return service;

        function getStatistics(url, search) {
            return $http.post(requestUrl + url, search).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function generateStatisticsFile(url, search) {

            var alert = $mdDialog.alert()
                .clickOutsideToClose(false)
                .escapeToClose(false)
                .textContent($translate.instant("users.report.xls.users.to.export"));

            $mdDialog.show(alert);

            $http({
                url: requestXlsUrl + url,
                method: "POST",
                data: search,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).then(function (success) {
                $mdDialog.hide();
                var blob = new Blob([success.data], {
                    type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                saveAs(blob, $translate.instant("statistics.export." + url ) + '_' + DateUtils.getDateTimeForFileName(new Date()) + '.xlsx');

            }, function (error) {
                $mdDialog.hide();
                PlagiatValidationService.getModalError(error);
            });

        }
    }
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('invoices-data', {
            parent: 'account',
            url: '/invoices-data',
            data: {
                authorities: ['PERM_USER_SUPERADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/statistics/invoices-data/invoices-data.template.html',
                    controller: 'InvoicesDataController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statistics');
                    return $translate.refresh();
                }]
            }
        })
        ;
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('InvoicesDataService', InvoicesDataService);
    
    InvoicesDataService.$inject = ['$http', '$q', 'ReportXlsService'];

    function InvoicesDataService($http, $q, ReportXlsService) {

        var service = {
            executeInvoicesData: executeInvoicesData,
            generateInvoicesDataXls: generateInvoicesDataXls,
        };
        var requestUrl = 'api/full-stats';
        return service;

        function executeInvoicesData(obj) {
            return $http.post(requestUrl + '/execute-invoices-data', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }
        
        function generateInvoicesDataXls(obj) {
            ReportXlsService.generateExcelFile(obj, requestUrl + '/generate-invoices-data-xls-report', 'statistics_');
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('InvoicesDataController', InvoicesDataController);

    function InvoicesDataController(InvoicesDataService, ModalService, PlagiatValidationService) {
        var vm = this;
        vm.activeTab = 'invoicesData';

        vm.executeInvoicesData = executeInvoicesData;
        vm.generateInvoicesDataXls = generateInvoicesDataXls;
        vm.columns = ['Name','Region', 'number of docs', 'characters', 'EUROS'];
    
        vm.pending = false;
        vm.obj = {};
        vm.result = null;
        vm.keyCodeEnter = KeyCode.KEY_RETURN;
        
        this.$onInit = function () {
            var dateToChange = new Date();
            dateToChange.setDate(1);
            dateToChange.setDate(dateToChange.getDate() - 1);
            vm.obj.dateTo = dateToChange;

            dateToChange = new Date();
            dateToChange.setMonth(dateToChange.getMonth() - 1);
            dateToChange.setDate(1)
            vm.obj.dateFrom = dateToChange;
        };

        function checkIfParamsValid() {
            if (vm.obj.dateTo && vm.obj.dateFrom && (vm.obj.dateTo < vm.obj.dateFrom)) {
                ModalService.showErrorModal({data: {code: 110}});
                return false;
            }
            return true;
        }
        
        function executeInvoicesData() {
            if (!checkIfParamsValid()) {
                return;
            }
            vm.result = null;
            vm.pending = true;
            InvoicesDataService.executeInvoicesData(vm.obj).then(function (response) {
                vm.result = response.data;
                vm.pending = false;
            }, function (errResponse) {
                vm.pending = false;
                PlagiatValidationService.getModalError(errResponse);
            });
        }
    
        function generateInvoicesDataXls(){
            InvoicesDataService.generateInvoicesDataXls(vm.obj);
        }
    
    }
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('full-stats', {
            parent: 'account',
            url: '/full-stats',
            data: {
                authorities: ['PERM_USER_SUPERADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/statistics/full-stats/full-stats.template.html',
                    controller: 'FullStatsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statistics');
                    return $translate.refresh();
                }]
            }
        })
        ;
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('FullStatsService', FullStatsService);
    
    FullStatsService.$inject = ['$http', '$q', 'ReportXlsService'];

    function FullStatsService($http, $q, ReportXlsService) {

        var service = {
            getAvailable: getAvailable,
            executeFullStats: executeFullStats,
            generateFullStatsXls: generateFullStatsXls,
        };
        var requestUrl = 'api/full-stats';
        return service;

        function getAvailable() {
            return $http.get(requestUrl + '/available').then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function executeFullStats(obj) {
            return $http.post(requestUrl + '/execute-full-stats', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }
        
        function generateFullStatsXls(obj) {
            ReportXlsService.generateExcelFile(obj, requestUrl + '/generate-xls-report', 'statistics_');
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('FullStatsController', FullStatsController);

    function FullStatsController(FullStatsService, ModalService, PlagiatValidationService) {
        var vm = this;
        vm.activeTab = 'fullStats';

        vm.loadData = loadData;
        vm.displayField = displayField;
        vm.executeFullStats = executeFullStats;
        vm.generateFullStatsXls = generateFullStatsXls;
    
        vm.pending = false;
        vm.availableStats = [];
        vm.obj = {};
        vm.obj.paymentType = '0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,99';
        vm.result = null;
        vm.keyCodeEnter = KeyCode.KEY_RETURN;
        
        this.$onInit = function () {
            vm.loadData();
            vm.obj.dateTo = new Date();
            var dateToChange = new Date();
            dateToChange.setMonth(dateToChange.getMonth() - 1);
            vm.obj.dateFrom = dateToChange;
        };

        function loadData() {
            vm.pending = true;
            FullStatsService.getAvailable().then(function (response) {
                vm.pending = false;
                vm.availableStats = response;
                vm.obj.option = vm.availableStats[0];
            });
        }
        
        function displayField(fieldName) {
            return vm.obj.option && (vm.obj.option.parameters.indexOf(fieldName) > -1);
        }
    
        function checkIfParamsValid() {
            if (vm.obj.dateTo && vm.obj.dateFrom && (vm.obj.dateTo < vm.obj.dateFrom)) {
                ModalService.showErrorModal({data: {code: 110}});
                return false;
            }
            return true;
        }
        
        function executeFullStats() {
            if (!checkIfParamsValid()) {
                return;
            }
            vm.result = null;
            vm.pending = true;
            FullStatsService.executeFullStats(vm.obj).then(function (response) {
                vm.result = response.data;
                vm.pending = false;
            }, function (errResponse) {
                vm.pending = false;
                PlagiatValidationService.getModalError(errResponse);
            });
        }
    
        function generateFullStatsXls(){
            FullStatsService.generateFullStatsXls(vm.obj);
        }
    
    }
})();

(function () {
    'use strict';


    var statisticOptions = {
        DOCUMENTS: {
            id: 0,
            url: 'documents',
            translationKey: 'statistics.option.documents'
        },
        UNIT_CONTRACT: {
            id: 1,
            url: 'units',
            translationKey: 'statistics.option.units'
        },
        USER_CONTRACT: {
            id: 2,
            url: 'users',
            translationKey: 'statistics.option.users'
        },
        DOCUMENTS_CHECKED: {
            id: 3,
            url: 'document-checks',
            translationKey: 'statistics.option.checks'
        },
        COEFFICIENT_DISTRIBUTION: {
            id: 4,
            url: 'coefficient-distribution',
            translationKey: 'statistics.option.coefficient-distribution'
        },
        NUMBER_OF_USERS: {
            id: 5,
            url: 'number-of-users',
            translationKey: 'statistics.option.number-of-users'
        },
        AI_DETECTION: {
            id: 6,
            url: 'ai-detection',
            translationKey: 'statistics.option.ai-detection'
        },
        NUMBER_OF_AUTHORS: {
            id: 7,
            url: 'number-of-authors',
            translationKey: 'statistics.option.number-of-authors'
        }
    };

    angular
        .module('plagiat2017App')
        .constant('STATISTIC_OPTIONS', statisticOptions);

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ProtocolForDocumentService', ProtocolForDocumentService);

    ProtocolForDocumentService.$inject = ['$http', '$q'];

    function ProtocolForDocumentService($http, $q) {

        var service = {
            getAllForCurrentClient: getAllForCurrentClient,
        };

        var requestUrl = 'api/protocol-for-document';

        return service;

        function getAllForCurrentClient() {
            return $http({
                url: requestUrl,
                method: 'GET'
            }).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('PolonUnitService', PolonUnitService);

    PolonUnitService.$inject = ['$http', '$q'];

    function PolonUnitService($http, $q) {

        var service = {
            getAllForCurrentClient: getAllForCurrentClient,
            getAllForClient: getAllForClient,
            getAllByStudyId: getAllByStudyId
        };

        return service;

        function getAllForCurrentClient() {
            return $http({
                url: 'api/polon-unit', method: 'GET'
            }).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }

        function getAllForClient(clientId) {
            return $http({
                url: 'api/polon-unit/client/' + clientId, method: 'GET'
            }).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }

        function getAllByStudyId(studyId) {
            return $http({
                url: 'api/polon-unit/study/' + studyId , method: 'GET'
            }).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .factory('PolonStudyService', PolonStudyService);

    PolonStudyService.$inject = ['$http', '$q'];

    function PolonStudyService($http, $q) {
        var service = {
            getOrganisationalUnitId: getOrganisationalUnitId,
            getAllNotAssignedToOrganisationalUnit: getAllNotAssignedToOrganisationalUnit
        };
        return service;
        function getOrganisationalUnitId(studyId) {
            return $http({
                url: 'api/polon-study/' + studyId + '/organisational-unit-id', method: 'GET'
            }).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }

        function getAllNotAssignedToOrganisationalUnit() {
            return $http({
                url: 'api/polon-study/not-assigned-to-organisational-unit', method: 'GET'
            }).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('DictionaryService', DictionaryService);

    DictionaryService.$inject = ['$http', '$q'];

    function DictionaryService($http, $q) {

        var service = {
            queryLanguages: queryLanguages,
            searchLanguages: searchLanguages,
            getLanguagesJsaAutocompleteItems: getLanguagesJsaAutocompleteItems
        };

        var requestUrl = 'api/dictionary/';

        return service;

        function searchLanguages(searchValue) {
            return $http.post(requestUrl + 'language/V1/search', searchValue).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function queryLanguages(req) {
            return $http({
                url: requestUrl + 'language/V1/query',
                method: 'GET',
                params: createRequestOption(req)
            }).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }

        function getLanguagesJsaAutocompleteItems(autocompleteQuery) {
            if (autocompleteQuery && autocompleteQuery.length > 0) {
                return service.searchLanguages(autocompleteQuery).then(function (responseData) {
                    var languages = responseData.data;
                    languages.push({ id: 0, code: "other"});
                    return languages;
                });
            } else {
                return service.queryLanguages({
                    page: 0,
                    size: 10,
                    sort: ['rank', 'desc']
                }).then(function (responseData) {
                    var languages = responseData.data;
                    languages.push({ id: 0, code: "other"});
                    return languages;
                });
            }
        }

        function createRequestOption(req) {
            return {
                size: req.size,
                page: req.page,
                sort: req.sort
            };
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ClientSettingService', ClientSettingService);

    ClientSettingService.$inject = ['$http', '$q'];

    function ClientSettingService($http, $q) {

        var requestUrl = 'api/client-setting';

        var service = {
            isSettingEnabledForActualClient: isSettingEnabledForActualClient,
        };
        return service;

        function isSettingEnabledForActualClient(code) {
            return $http.get(requestUrl + '/is-enabled/' + code).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('order', {
            parent: 'app',
            url: '/order?plagiatPlMode&charactersQuantity&unit&confirmationCode$training1&training2',
            data: {
                authorities: ['open'],
                pageTitle: 'global.menu.buy'
            },
            views: {
                'content@': {
                    templateUrl: 'app/online-order/online-order.html',
                    controller: 'OnlineOrderController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('online-order');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('register');

                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('OnlineOrderService', OnlineOrderService);

    OnlineOrderService.$inject = ['$http', '$q'];

    function OnlineOrderService($http, $q) {
        var requestUrl = 'api/online-order';
        var service = {
            sendObj: sendObj,
            getProformaInvoice: getProformaInvoice,
            getInitData: getInitData
        };
        return service;

        function sendObj(obj) {
            return $http.post(requestUrl, obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getInitData(currency) {
            return $http.get(requestUrl + '/init-data/' + currency).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getProformaInvoice(confirmationCode, lang) {
            return $http.get(requestUrl + '/proforma-invoice/' + lang + '/' + confirmationCode).then(
                function (success) {
                    var blob = new Blob(
                        [_base64ToArrayBuffer(success.data.pdfArray)],
                        {type: "text/pdf; encoding=UTF-8"}
                    );
                    saveAs(blob, success.data.filename);
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }

        function _base64ToArrayBuffer(base64) {
            var binary_string = window.atob(base64);
            var len = binary_string.length;
            var bytes = new Uint8Array(len);
            for (var i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }
            return bytes.buffer;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('OnlineOrderController', OnlineOrderController);

    OnlineOrderController.$inject = ['$scope', '$location', '$stateParams', '$state', '$translate', '$timeout',
        'AccountService', 'InstanceService', 'DetectInstanceService', 'OnlineOrderService', 'ModalService'];

    function OnlineOrderController($scope, $location, $stateParams, $state, $translate, $timeout,
                                   AccountService, InstanceService, DetectInstanceService, OnlineOrderService, ModalService) {
        var vm = this;

        vm.pending = false;
        vm.success = false;
        vm.uplObj = {};
        vm.uplObj.training1 = false;
        vm.uplObj.training2 = false;
        vm.uplObj.grammarCheck = false;
        vm.uplObj.integration = false;
        vm.uplObj.integrationType = 'Editorial';
        vm.calculatePrice = calculatePrice;
        vm.instance = InstanceService.instance();
        vm.brand = DetectInstanceService.instance();
        vm.currency = vm.instance.currencies.default;
        vm.uplObj.currency = vm.currency;

        vm.maxCharacters = 40000000;
        vm.aiDetectionPrice = 0;
        vm.grammarCheckPrice = 0;
        vm.integrationPrice = 0;

        vm.pricelist = {
            fixedPart: 220,
            aiDetectionTraining: 1650,
            training1: 1870,
            training2: 4400};
        if ('EUR' === vm.currency) {
            vm.pricelist = {
                fixedPart: 55,
                aiDetectionTraining: 330,
                training1: 385,
                training2: 990};
        }
        
        var rate = 13.2;
        var unitChars = 'chars';
        var unitPages = 'pages';
        var unitSheets = 'sheets';
        vm.units = [{
            value: unitChars,
            dataTranslate: 'online-order.choose-unit.chars',
        }, {
            value: unitPages,
            dataTranslate: 'online-order.choose-unit.pages',
        }, {
            value: unitSheets,
            dataTranslate: 'online-order.choose-unit.sheets',
        }];

        vm.slider = {
            options: {
                floor:  500000,
                ceil: 40000000,
                // ticksArray: [500000, 2000000, 4000000, 8000000, 12000000, 16000000, 20000000, 30000000, 40000000],
                showTicksValues: false,
                showTicks: true,
                // step: 500000,
                stepsArray: [
                    {value: 500000, legend: '500000'},
                    {value: 1000000},
                    {value: 1500000},
                    {value: 2000000, legend: '2000000'},
                    {value: 2500000},
                    {value: 3000000},
                    {value: 4000000},
                    {value: 5000000, legend: '5000000'},
                    {value: 6000000},
                    {value: 8000000},
                    {value: 10000000, legend: '10000000'},
                    {value: 12000000},
                    {value: 14000000},
                    {value: 16000000, legend: '16000000'},
                    {value: 18000000},
                    {value: 20000000},
                    {value: 25000000, legend: '25000000'},
                    {value: 30000000},
                    {value: 35000000},
                    {value: 40000000, legend: '40000000'}
                ],
                translate: function (value, sliderId, label) {
                    if ('model' == label) {
                        // console.log('val ' + value + ' ' + label);
                        return value / getFactor(vm.uplObj.unit);
                    }
                    return '';
                },
                onChange: function () {
                    vm.calculatePrice();
                }
            }
        };

        vm.$onInit = function () {
            initStateParams();
            if (vm.confirmationCode) {
                vm.success = true;
            } else {
                getInitData();
            }
            vm.watchConfirmationCodeChange();
            vm.refreshSlider();

            if (vm.plagiatPlMode) {
                angular.element('body').css({
                    'background': '#edeff2'
                });
            } else {
                angular.element('body').css({
                    'background-image': 'url(content/images/landing.jpg)',
                    'background-repeat': 'no-repeat',
                    'background-size': 'cover'
                });
            }
        };

        vm.refreshSlider = function () {

            angular.forEach(vm.slider.options.stepsArray, function (step) {
                if (step.legend) {
                    step.legend = '' + step.value / getFactor(vm.uplObj.unit);
                }
            });

            $timeout(function () {
                $scope.$broadcast('rzSliderForceRender');
            });
        };

        function initStateParams() {
            if ($stateParams.charactersQuantity) {
                vm.uplObj.charactersQuantity = +($stateParams.charactersQuantity.replace('M', '') * 1000000);
            }
            if (!vm.uplObj.charactersQuantity) {
                vm.uplObj.charactersQuantity = 5000000;
            }
            vm.uplObj.unit = $stateParams.unit;
            if (!vm.uplObj.unit) {
                vm.uplObj.unit = unitChars;
            }
            vm.confirmationCode = $stateParams.confirmationCode;
            vm.plagiatPlMode = +$stateParams.plagiatPlMode > 0;
            if ($stateParams.training1 === 'true') {
                vm.uplObj.training1 = true;
                vm.calculatePrice();
            } else if ($stateParams.training2 === 'true') {
                vm.uplObj.training2 = true;
                vm.calculatePrice();
            }
        }

        function getInitData() {
            vm.pending = true;
            OnlineOrderService.getInitData(vm.currency).then(function (response) {
                onGetInitDataSuccess(response);
            }, function (response) {
                vm.pending = false;
                ModalService.showErrorModal(response);
            });
        }

        function onGetInitDataSuccess(response) {
            vm.pending = false;
            rate = +response.data.rate;
            vm.calculatePrice();
        }

        function getFactor(unitType) {
            switch (unitType) {
                case unitChars:
                    return 1000000;
                case unitPages:
                    return 2000;
                case unitSheets:
                    return 40000;
                default:
                    return '';
            }
        }
    
        vm.toggleTraining1 = function () {
            if (vm.uplObj.training1 && vm.uplObj.training2) {
                vm.uplObj.training2 = false;
            }
            calculatePrice();
        }
    
        vm.toggleTraining2 = function () {
            if (vm.uplObj.training1 && vm.uplObj.training2) {
                vm.uplObj.training1 = false;
            }
            calculatePrice();
        }
    
        function calculatePrice() {
            if (!(vm.uplObj.training1 || vm.uplObj.training2)) {
                vm.uplObj.aiDetectionTraining = false;
            }
            if (vm.uplObj.charactersQuantity > vm.maxCharacters) {
                vm.uplObj.charactersQuantity = vm.maxCharacters;
            }
            // wyliczona kwota do zapłaty: liczba znaków razy stawka - 9 pln za 10tyś znaków + 200 pln za fatygę.
            vm.aiDetectionPrice = Math.round(vm.uplObj.charactersQuantity / 10000 * 1.32) + (480 * 1.1);
            vm.grammarCheckPrice = Math.round(vm.uplObj.charactersQuantity / 10000 * 0.66) + (240 * 1.1);
            vm.uplObj.amountToPay = Math.round(vm.uplObj.charactersQuantity / 10000 * rate) + vm.pricelist.fixedPart;
            vm.uplObj.amountDiscounted = (Math.round(vm.uplObj.amountToPay * (100 - vm.getDiscount())) / 100);
            vm.integrationPrice = vm.uplObj.amountDiscounted * 0.2;

            vm.uplObj.totalPrice =
                vm.uplObj.amountDiscounted
                + (vm.uplObj.training1 ? vm.pricelist.training1 : 0)
                + (vm.uplObj.training2 ? vm.pricelist.training2 : 0)
                + (vm.uplObj.aiDetectionTraining ? vm.pricelist.aiDetectionTraining : 0)
                + (vm.uplObj.aiDetection ? vm.aiDetectionPrice : 0)
                + (vm.uplObj.grammarCheck ? vm.grammarCheckPrice : 0)
                + (vm.uplObj.integration ? vm.integrationPrice : 0)
            ;
        }

        vm.getDiscount = function () {
            if (vm.uplObj.charactersQuantity < 4000000) {
                return 0;
            } else if (vm.uplObj.charactersQuantity > 40000000) { //nie powinno się wydarzyć
                return 0;
            } else if (vm.uplObj.charactersQuantity > 16000000) {
                return 14 + (1 * vm.uplObj.charactersQuantity / 1000000);
            } else {
                return (2 * vm.uplObj.charactersQuantity / 1000000) - 3;
            }
        };

        vm.radioChange = function (value) {
            if (value === 'online-order.integration-type-other') {
                ModalService.showSuccessModal("online-order.integration-type-other-information");
            }
        }

        vm.submitForm = function (form) {
            if (form.$invalid) {
                for (var i = 0; i < form.$$controls.length; i++) {
                    form.$$controls[i].$touched = true;
                }
                return;
            }

            if (vm.uplObj.integration && vm.uplObj.integrationType === 'online-order.integration-type-other') {
                ModalService.showSuccessModal("online-order.integration-type-other-information");
                return;
            }

            vm.pending = true;
            
            vm.uplObj.langKey = AccountService.account.pickedLang;
            if (!vm.uplObj.langKey) {
                vm.uplObj.langKey = InstanceService.instance().lang;
            }
            OnlineOrderService.sendObj(vm.uplObj).then(function (response) {
                vm.pending = false;
                vm.success = true;
                vm.confirmationCode = response.data;
            }, function (response) {
                vm.pending = false;
                ModalService.showErrorModal(response);
            });
        };

        vm.watchConfirmationCodeChange = function () {
            $scope.$watch(function () {
                return vm.confirmationCode;
            }, function (newVal) {
                $location.search("confirmationCode", newVal);
            });
        };

        vm.getProformaInvoiceClick = function () {
            vm.pending = true;
            var lang = AccountService.account.pickedLang;
            if (!lang) {
                lang = InstanceService.instance().lang;
            }
            
            OnlineOrderService.getProformaInvoice(vm.confirmationCode, lang, 'Plagiat.pl - Faktura proforma').then(function () {
                vm.pending = false;
            }, function (response) {
                vm.pending = false;
                ModalService.showErrorModal(response);
            });
        };

        vm.redirectFromMainPage = function() {
            var url = $state.href('order', {
                plagiatPlMode: "0",
                charactersQuantity: (vm.uplObj.charactersQuantity/1000000) + 'M',
                unit: vm.uplObj.unit,
                training1: vm.uplObj.training1,
                training2: vm.uplObj.training2,
            });

            window.open(url,'_blank');
        }
    }
})();

(function () {
    'use strict';

    function SideNavController($translate, $scope, $mdSidenav, $log, $localStorage, $window, $state,
                               Auth, Principal, AccountService) {
        var vm = this;

        vm.showAuthoritiesMenu = false;
        vm.collapsed = $localStorage.collapsed;
        vm.toggleMenu = toggleMenu;

        this.$onInit = function () {
            vm.show = isNotOrderPage();
            verifyAuthorities();
        };

        $scope.$on('roleIsSet', function () {
            vm.show = isNotOrderPage();
            vm.showAuthoritiesMenu = false;
            verifyAuthorities();
        });

        function isNotOrderPage() {
            return $state.current.name !== 'order';
        }

        function verifyAuthorities() {
            vm.isIndividual = AccountService.role.isIndividual();
            vm.isStudent = AccountService.role.isStudent();
            vm.isOperator = AccountService.role.isOperator();
            vm.isLecturer = AccountService.role.isLecturer();
            vm.isOrgUnitAdmin = AccountService.role.isOrgUnitAdmin();
            vm.isAdmin = AccountService.role.isAdmin();
            vm.isSuperAdmin = AccountService.role.isSuperAdmin();
            vm.isReseller = AccountService.role.isReseller();
            vm.isMinistry = AccountService.role.isMinistry();
            vm.isCodeAccount = AccountService.clientType.isCodeAccount();
            vm.showAssignments = AccountService.getClientSettings() && AccountService.getClientSettings().assignmentsEnabled 
                                 && !AccountService.role.isIndividual() && !AccountService.role.isStudent();
            vm.showFeedbacks = AccountService.getClientSettings() && AccountService.getClientSettings().assignmentsEnabled
                                 && AccountService.getClientSettings() && AccountService.getClientSettings().peerReviewEnabled
                                 && AccountService.role.isStudent();
            vm.showComparison = AccountService.role.isSuperAdmin()
                || ((AccountService.role.isAdmin() || AccountService.role.isOrgUnitAdmin() || AccountService.role.isOperator())
                    && AccountService.getClientSettings() && AccountService.getClientSettings().documentComparison);
            vm.showDocuments =  !AccountService.clientType.isPap();
            vm.showReports =  AccountService.clientType.isPap();

            if (vm.isSuperAdmin) {
                AccountService.accountType().then(function (result) {
                        vm.isAuthenticated = Principal.isAuthenticated;
                        vm.showAuthoritiesMenu = true;
                    },
                    function (errResponse) {
                        Auth.logout();
                        AccountService.setRole(null);
                    });
            } else if (vm.isAdmin) {
                AccountService.accountRole().then(function (result) {
                        vm.isAuthenticated = Principal.isAuthenticated;
                        vm.showAuthoritiesMenu = true;
                    },
                    function (errResponse) {
                        Auth.logout();
                        AccountService.setRole(null);
                    });
            } else {
                vm.isAuthenticated = Principal.isAuthenticated;
                vm.showAuthoritiesMenu = true;
            }

        }

        function toggleMenu() {
            vm.collapsed = !vm.collapsed;
            $localStorage.collapsed = vm.collapsed;
        }

        angular.element($window).bind('resize', function () {
            if ($window.innerWidth < 960) {
                vm.collapsed = true;
                $localStorage.collapsed = true;
            }
            $scope.$digest();
        });
    }

    angular.module('sideNav', [])
        .component('sideNav', {
            templateUrl: 'app/layouts/side-nav/side-nav.template.html',
            controller: SideNavController,
            controllerAs: 'vm'
        });

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$scope', 'InstanceService', '$rootScope', '$state', '$mdSidenav', '$window', 
                                'Auth', 'Principal', 'ProfileService', 'AccountService', 
                                '$localStorage', '$mdDialog', '$translate', '$log', 'tmhDynamicLocale'];

    function NavbarController($scope, InstanceService, $rootScope, $state, $mdSidenav, $window, 
                              Auth, Principal, ProfileService, AccountService, 
                              $localStorage, $mdDialog, $translate, $log, tmhDynamicLocale) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.inProduction = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.show = isNotOrderPage();
        vm.instanceLang = InstanceService.instance().lang;
        vm.account = {};
        vm.$state = $state;

        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.toggleMenu = toggleMenu;

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        function getProfile(){
            ProfileService.getProfileInfo().then(function (response) {
                vm.inProduction = response.inProduction;
                vm.swaggerEnabled = response.swaggerEnabled;
                vm.instance = response.instance;
            });
        }

        function isNotOrderPage() {
            return $state.current.name !== 'order';
        }

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.langKey = (account.langKey).toLowerCase();
                tmhDynamicLocale.set(vm.langKey).then(function(){
                    $translate.use(vm.langKey).then(function(){
                        $translate.fallbackLanguage(vm.langKey);
                        $translate.preferredLanguage(vm.langKey);
                    })
                });
                if (account !== null) {
                    vm.account = account;
                    AccountService.account = account;
                    vm.isAuthenticated = Principal.isAuthenticated;
                    $rootScope.$broadcast('roleIsSet');
                    if(vm.account.login === $localStorage.logoutToRootInfo){
                    	$localStorage.logoutToRootInfo = undefined;
                    	vm.logoutToRootInfo = undefined;
                    } else {
                        vm.logoutToRootInfo = $localStorage.logoutToRootInfo;
                    }
                }
            });
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function toggleMenu(componentId) {
            $localStorage.isClosed = true;
            $mdSidenav(componentId).toggle();
        }

        getProfile();
        getAccount();

    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    function UploadFileController ($scope) {
        var vm = this;
        vm.getTheFiles = getTheFiles;

        function getTheFiles($files,$invalidFiles) {
            vm.files = $files;
            vm.errFiles = $invalidFiles;
            vm.onGetTheFiles($files);
        }

    }

    angular.module('fileUpload', ['ngFileUpload'])
    .component('uploadFile', {
        templateUrl: 'app/components/uploadFile/uploadFile.template.html',
        controller: UploadFileController,
        bindings: {
            documentFormFile: '=',
            onGetTheFiles: '='
        }
    });

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('landing-page-ro', {
            parent: 'landing',
            url: '/verifica?key',
            data: {
                authorities: ['open'],
                pageTitle: 'global.menu.landing'
            },
            views: {
                'content@': {
                    templateUrl: 'app/landing/landing-page/landing-page.html',
                    controller: 'LandingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('landing');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('dictionary');
                    $translatePartialLoader.addPart('payments');
                    $translatePartialLoader.addPart('document');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('landing-page-int', {
            parent: 'landing',
            url: '/check?key',
            data: {
                authorities: ['open'],
                pageTitle: 'global.menu.landing-int'
            },
            views: {
                'content@': {
                    templateUrl: 'app/landing/landing-page/landing-page.html',
                    controller: 'LandingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('landing');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('dictionary');
                    $translatePartialLoader.addPart('payments');
                    $translatePartialLoader.addPart('document');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

angular.module('plagiat2017App')
    .component('landingPageInvoiceModal', {
        templateUrl: 'app/landing/landing-page/landing-page-invoice.template.html',
        controller: LandingPageInvoiceController,
        controllerAs: 'vm'
    });

LandingPageInvoiceController.$inject = ['$http', '$state', '$mdDialog', '$timeout', 'items', 'Auth', 'DetectInstanceService', 'CountryModel', 'COUNTRYCODECONSTANT'];

function LandingPageInvoiceController($http, $state, $mdDialog, $timeout, items, Auth, DetectInstanceService, CountryModel, COUNTRYCODECONSTANT) {
    var vm = this;

    vm.closeDialog = closeDialog;
    vm.goUpload = goUpload;

    vm.invoice = {};
    vm.isLoading = false;
    vm.instanceLang = DetectInstanceService.getLandingLang();
    vm.isRomania = vm.instanceLang == 'ro';
    vm.isPoland = vm.instanceLang == 'pl';
    vm.isCompany = false;
    vm.romanianCounties = [];
    vm.romanianCities = [];
    vm.countries = new CountryModel();

    if (vm.isRomania) {
        $http.get('/assets/ro-counties-cities.json').then(function (response) {
            vm.romanianCounties = response.data.counties;
        });
        vm.invoice.country = COUNTRYCODECONSTANT.ROMANIA.code;
    }

    vm.onRoCountyChange = function () {
        vm.invoice.city = '';
        getCities();
    };

    function getCities() {
        if (vm.invoice.county) {
            const selectedCounty = vm.romanianCounties.find(function(c) {
                return c.name === vm.invoice.county;
            });
            vm.romanianCities = selectedCounty ? selectedCounty.cities : [];
        }
    }

    function goUpload() {
        vm.isLoading = true;
        items.onUploadWithInvoiceData(vm.invoice);
    }

    function closeDialog() {
        $mdDialog.hide();
        $timeout(function () {
            Auth.logout();
            switch (vm.instanceLang) {
                case 'ro':
                    $state.go('landing-page-ro', {key: 'error'});
                    break;
                case 'en':
                    $state.go('landing-page-int', {key: 'error'});
                    break;
                default:
                    $state.go('landing-page', {key: 'error'});
            }
        }, 1);
    }
}

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('landing-page', {
            parent: 'landing',
            url: '/sprawdz?key',
            data: {
                authorities: ['open'],
                pageTitle: 'global.menu.landing'
            },
            views: {
                'content@': {
                    templateUrl: 'app/landing/landing-page/landing-page.html',
                    controller: 'LandingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {

                    $translatePartialLoader.addPart('landing');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('dictionary');
                    $translatePartialLoader.addPart('payments');
                    $translatePartialLoader.addPart('document');

                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .controller('LandingController', LandingController);

    LandingController.$inject = ['Principal', '$scope', '$stateParams', '$state', '$rootScope', '$translate', 'InstanceService', 'DetectInstanceService', 'JhiLanguageService', 
        '$log', '$window', 'AUTO_TRANSLATIONS_LANGS',
        'LandingService', 'Auth', '$mdDialog', '$timeout', 'PlagiatValidationService', '$sessionStorage', 'ExtraOptionsService', 'UserService', 'Utils'];

    function LandingController(Principal, $scope, $stateParams, $state, $rootScope, $translate, InstanceService, DetectInstanceService, JhiLanguageService, 
                               $log, $window, AUTO_TRANSLATIONS_LANGS,
                               LandingService, Auth, $mdDialog, $timeout, PlagiatValidationService, $sessionStorage, ExtraOptionsService, UserService, Utils) {
        var vm = this;

        vm.registerAndUpload = registerAndUpload;
        vm.uploadWithInvoiceData = uploadWithInvoiceData;
        vm.uploadButtonDisabled = uploadButtonDisabled;
        vm.clearFiles = clearFiles;
        vm.getTheFiles = getTheFiles;
        vm.setLang = setLang;
        vm.toggleShowPassword = toggleShowPassword;
        vm.checkboxChange = checkboxChange;
        vm.isAiDetectionEnabled = isAiDetectionEnabled;
        vm.isOptionDisabled = isOptionDisabled;
        vm.getPriceInCurrency = getPriceInCurrency;
        vm.getDefaultCurrency = getDefaultCurrency;
        vm.currencyChosen = currencyChosen;
        vm.chooseCurrency = chooseCurrency;
        vm.fbButtonDisabled = fbButtonDisabled;
        vm.translationsOK = translationsOK;
        vm.loginOauth2 = loginOauth2;

        vm.instance = DetectInstanceService.instance();
        vm.isRomania = (vm.instance === 'ro');
        vm.isPoland = (vm.instance === 'pl');
        vm.instanceSettings = InstanceService.instance();
        vm.landingLink = vm.instanceSettings.landingLink
        vm.loginLink = vm.landingLink.replace('https://', 'https://panel.');
        vm.instanceLang = DetectInstanceService.getLandingLang();
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.passwordPattern = Auth.getPasswordPattern();
        vm.landingPage = true;
        vm.key = $stateParams.key;
        vm.autoTranslationLangs = Utils.sortAutoTranslationsLanguages(AUTO_TRANSLATIONS_LANGS, $translate);
        vm.isCapsLockOn = null;
        vm.emailInputHaveWrongDomain = false;
        vm.wrongEmails = ["gmaill.com", "gmall.com", "gmial.com", "gmail.ocm", "gamil.com", "gmail.cojm", "gmal.com",
            "gmal.com", "gnail.com", "gmail.coim", "gmail.pl", "ineria.pl", "02.pl"];

        vm.user = {};
        vm.pending = false;
        vm.validated = false;
        vm.fileName = false;
        vm.singleTokenPrice = null;
        vm.currentLang = null;
        var formData = new FormData();
        vm.isLoading = false;
        vm.isCalculatingPrice = false;
        vm.showPassword = false;
        vm.freeChecksAvailable = true;
        vm.documentSize = null;
        vm.optionPrices = {};
        vm.availableExtensions = null;
        vm.translation = {};
        vm.translation.price = 6;
        moment.locale(vm.instanceLang);
        vm.isInvoice = vm.isRomania ? true : null;

        setLang(vm.instanceLang);
        vm.currency = vm.getDefaultCurrency();

        this.$onInit = function () {
            angular.element('body').css({
                'background-image': 'url(content/images/landing.jpg)',
                'background-repeat': 'no-repeat',
                'background-size': 'cover'
            });
            LandingService.getTokenPriceList({}).then(function (responseData) {
                vm.charactersPerToken = responseData.data.charactersPerToken;
                vm.documentExtraOptions = responseData.data.extraOptions;
            });
            LandingService.getSingleTokenPrince(vm.currency, getPaymentType()).then(function (responseData) {
                vm.singleTokenPrice = responseData.data;
            });
            LandingService.getAvailableFileExtensions().then(function (responseData) {
                vm.availableExtensions = responseData.data;
            });
        };

        function afterUploadLandingPage() {
            if (vm.key === 'error') {
                var confirm = $mdDialog.confirm()
                .title('')
                .clickOutsideToClose(true)
                .htmlContent($translate.instant("global.messages.error.error"))
                .ariaLabel('')
                .ok('Ok')
                .openFrom('#left');
                $mdDialog.show(confirm).then(function (result) {
                });
            }
        }

        if ((vm.key === 'facebook') || (vm.key === 'landing-sso')) {
            if ($sessionStorage.landingPageFileId) {
                vm.isLoading = true;
                vm.pending = true;
                toggleElements('none');
                showDialog();
                if (!vm.isRomania) {
                    uploadForm();
                }
            }
        }

        function redirect(){
            vm.isAuthenticated = Principal.isAuthenticated;
            if ( vm.isAuthenticated ) {
                $state.go('documents');
            }
        }

        function clearFiles() {
            vm.files = null;
            vm.fileName = null;
            vm.documentSize = null;
            vm.optionPrices = {};
            vm.translation = null;
        }

        function getTheFiles($files, $invalidFiles) {
            formData = new FormData();
            if ($files.length === 0) {
                vm.files = null;
                return;
            }
            if ($invalidFiles.length === 0) {
                vm.files = $files;
                angular.forEach(vm.files, function (value, key) {
                    vm.invalidFiles = {
                        maxError: false
                    };
                    vm.fileName = value.name;
                    formData.append(key, value);
                    var fileReader = new FileReader();
                    fileReader.readAsDataURL(value);
                });
                uploadFile();
            } else {
                vm.invalidFiles = {};
                angular.forEach($invalidFiles, function (value, key) {
                    vm.fileName = false;
                    vm.invalidFiles.maxError = value.$error;
                });
            }
        }

        function uploadFile() {
            vm.isCalculatingPrice = true;
            LandingService.uploadFile(formData, vm.fileName).then(function (response) {
                vm.isCalculatingPrice = false;
                vm.documentSize = response.data.documentSize;
                $sessionStorage.landingPageFileId = response.data.fileId;
                recalculatePrices();
            }, function (error) {
                catchError();
            });
        }

        function checkboxChange() {
            recalculatePrices();
        }

        function isAiDetectionEnabled() {
            return ExtraOptionsService.isAiDetectionEnabled(vm);
        }

        function isOptionDisabled(option) {
            return ExtraOptionsService.isOptionDisabled(vm, vm.size, option);
        }

        function recalculatePrices() {
            ExtraOptionsService.recalculatePrices(vm.documentSize, vm);
            $sessionStorage.landingPageDocumentExtraOptions = ExtraOptionsService.getCurrentDocumentOptions(vm);
            $sessionStorage.translation = vm.translation;
        }

        function setLang(lang){
            $translate.use( lang );
            //tmhDynamicLocale.set(languageKey);
            vm.user.langKey = lang;
        }

        function catchError(){
            toggleElements('block');
            $mdDialog.hide();
            Auth.logout();
            switch (vm.instanceLang) {
                case 'ro':
                    $state.go('landing-page-ro', {key: 'error'});
                    break;
                case 'en':
                    $state.go('landing-page-int', {key: 'error'});
                    break;
                default:
                    $state.go('landing-page', {key: 'error'});
            }
            vm.isLoading = false;
            vm.pending = false;
            vm.fileName = false;
            clearSessionStorage();
        }

        function toggleElements(style){
            $timeout(function () {
                if (document.getElementById("navbar")) {
                    document.getElementById("navbar").style.display = style;
                }
                if (document.getElementById("sidenav")) {
                    document.getElementById("sidenav").style.display = style;
                }
            }, 1);
        }

        function showDialog(){
            $mdDialog.show({
                templateUrl: 'app/landing/landing-page/landing-page-invoice.template.html',
                clickOutsideToClose: false,
                escapeToClose: false,
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('landing');
                        $translatePartialLoader.addPart('payments');
                        $translatePartialLoader.addPart('country');
                        return $translate.refresh();
                    }]
                },
                locals: {
                    items: {
                        onUploadWithInvoiceData: vm.uploadWithInvoiceData
                    }
                },
                controller: LandingPageInvoiceController
            }).finally(
                function onModalClose() {
                    // Auth.logout();
            });
        }

        function trackFbPixel() {
            if ($window.fbq) {
                var price = getPriceInCurrency();
                if (typeof price !== 'undefined') {
                    $window.fbq('track', 'InitiateCheckout', {currency: vm.currency, price: price});
                    //console.log('InitiateCheckout tracked! value=' + price + ', currency=' + vm.currency);
                } else {
                    $window.fbq('track', 'InitiateCheckout');
                    //console.log('InitiateCheckout tracked! no value=');
                }
            }
        }

        function getPriceInCurrency() {
            if (vm.totalPrice && vm.singleTokenPrice) {
                return (vm.totalPrice * vm.singleTokenPrice).toFixed(2);
            } else {
                return undefined;
            }
        }
  
        function currencyChosen(buttonCurrency) {
            return vm.currency && (vm.currency === buttonCurrency);
        }
  
        function chooseCurrency(newCurrency) {
            vm.currency = newCurrency;
            refreshSingleTokenPrice();
        }
        
        function getDefaultCurrency() {
            var cur = vm.instanceSettings.currencies.landingCurrencies.find(function (value) {
                if (vm.instanceLang === value.lang) {
                    return value.defaultCurrency;
                }
            });
            if (cur) {
                vm.availableCurrencies = cur.currencyList;
                return cur.defaultCurrency;
            } 
            return 'EUR';
        }
        
        function uploadWithInvoiceData(invoiceData) {
            toggleElements('none');
            uploadForm(invoiceData);
        }

        function registerAndUpload(form1, form2) {
            vm.validated = true;
            if (!Utils.validateForm(form1) || !Utils.validateForm(form2)) {
                console.log('form not valid');
                return;
            }
            trackFbPixel();

            if(vm.isPoland && vm.isInvoice == null){
              return;
            }

            vm.isLoading = true;
            LandingService.registerAndLogin(vm.user).then(function (response) {
                vm.pending = true;
                vm.response = response;

                if (!(vm.isRomania || (vm.isPoland && vm.isInvoice))) {

                    showDialog();

                    Auth.login({
                        username: response.data.email,
                        password: response.data.password,
                        rememberMe: false
                    }).then(function () {
                        toggleElements('none');
                        uploadForm(null);
                    }, function () {
                        catchError();
                    });
                } else {
                    Auth.login({
                        username: vm.response.data.email,
                        password: vm.response.data.password,
                        rememberMe: false
                    }).then(function () {
                        toggleElements('none');
                        showDialog();
                    }, function () {
                        catchError();
                    });
                }
            }, function (response) {
                if (response.data.code === '120') { //uzytkownik zarejestrowany na innym kliencie indywidualnym, np. 1 -> 9999
                    $.redirect(response.data.data, null, 'GET');
                } else {
                    vm.isLoading = false;
                    PlagiatValidationService.getModalError(response.data);
                }
            });
        }

        function refreshSingleTokenPrice() {
            vm.isLoading = true;
            LandingService.getSingleTokenPrince(vm.currency, getPaymentType()).then(function (responseData) {
                vm.singleTokenPrice = responseData.data;
                vm.isLoading = false;
            });
        }
        
        function getPaymentType() {
            return vm.instanceSettings.currencies.settings.find(function (value) {
                if (vm.currency === value.name) {
                    return value.methodsOfPayment;
                }
            }).methodsOfPayment[0];
        }
        
        function uploadForm(invoiceData) {
            if (Auth.getPreviousState()) {
                Auth.resetPreviousState();
            }
            const extraOptions = (!!$sessionStorage.landingPageDocumentExtraOptions && $sessionStorage.landingPageDocumentExtraOptions > 0) ?
              $sessionStorage.landingPageDocumentExtraOptions : 0;
            const translationFromStorage = ($sessionStorage.translation) ? $sessionStorage.translation : null;
            const paymentType = getPaymentType();

            if (vm.isRomania && !invoiceData) {
                throw new Error('invoice required');
            }

            LandingService
                .addDocumentFromLanding($sessionStorage.landingPageFileId, extraOptions, vm.currency, paymentType, translationFromStorage, invoiceData)
                .then(function (response) {
                    if (response.data.formAction !== "") {
                        clearSessionStorage();
                        vm.isLoading = false;
                        vm.fileName = false;
                        $rootScope.$broadcast('authenticationSuccess');
                        vm.paymentParams = response.data.paymentRedirectionParams;
                        var $redirectFormContainer = angular.element('#paymentForm');
                        var $redirectForm = $redirectFormContainer.find('form');
                        $redirectForm.attr('method', response.data.formMethod);
                        $redirectForm.attr('action', response.data.formAction);
                        $timeout(function () {
                            $redirectForm.submit();
                        }, 20);
                    } else {
                        $window.location = "#/documents";
                        $window.location.reload();
                    }
                }, function () {
                    catchError();
                });
        }

        function clearSessionStorage() {
            $sessionStorage.landingPageFileId = undefined;
            $sessionStorage.landingPageDocumentExtraOptions = undefined;
            $sessionStorage.translation = undefined;
        }
    
        function toggleShowPassword() {
            vm.showPassword = !vm.showPassword;
        }
        
        function uploadButtonDisabled() {
            return vm.pending
                || !vm.fileName 
                || vm.isCalculatingPrice 
                || (vm.instance == 'ro' && vm.user.email !== vm.user.email2) 
                || !vm.translationsOK();
        }
        
        function fbButtonDisabled() {
            return !vm.user.acceptDataProcesing || !vm.user.acceptRegulations || vm.pending || !vm.fileName || vm.isCalculatingPrice || !vm.translationsOK();
        }

        function loginOauth2(partner) {
            UserService.oauth2RedirectionUrl(partner).then(function(data) {
                $.redirect(data.data.url, "GET");
            });
        }

        function translationsOK() {
            if (vm.translation && vm.translation.chosen) {
                if (!vm.translation.autoTranslationsToLang) {
                    return false;
                }
            }
            return true;
        }
    
        afterUploadLandingPage();

        vm.checkCapsLockKey = function (event) {
            vm.isCapsLockOn = event.originalEvent.getModifierState('CapsLock');
        };

        vm.checkEmailDomain = function () {
            vm.emailInputHaveWrongDomain = false;
            if (vm.user.email.match(".") && vm.user.email.match("@")) {
                var emailArray = vm.user.email.split('@');
                if (emailArray.size > 2) {
                    vm.emailInputHaveWrongDomain = true;
                } else {
                    for (var i = 0; i < vm.wrongEmails.length; i++) {
                        if (emailArray[1].toUpperCase().match(vm.wrongEmails[i].toUpperCase())) {
                            vm.emailInputHaveWrongDomain = true;
                        }
                    }
                }
            }
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('landing', {
            abstract: true,
            parent: 'app'
        });
    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('UserImportService', UserImportService);

    UserImportService.$inject = ['$http', '$mdToast'];

    function UserImportService($http, $mdToast) {

        var service = {
        		importUsersFromXls: importUsersFromXls,
        		downloadTemplate: downloadTemplate,
        		getAvailableExtensions: getAvailableExtensions
		}
        
        return service;

        function getAvailableExtensions(){
        	return '.xls,.xlsx';
        }
		function importUsersFromXls() {
			var url = 'api/user/import-from-xls';

			$http({
				url : url,
				method : "GET",
				headers : {
					'Content-type' : 'application/json'
				},
				responseType : 'arraybuffer'
			})
					.then(
							function(success) {
								var blob = new Blob(
										[ success.data ],
										{
                                            type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
										});
								saveAs(blob, 'validation-result.xlsx');

							}, function(error) {
								$mdToast.show($mdToast.simple().textContent(error));
							});
		}
		
		
		function downloadTemplate(fileName) {
			var url = 'api/user/import-from-xls/example-of-template';

			$http({
				url : url,
				method : "GET",
				headers : {
					'Content-type' : 'application/json'
				},
				responseType : 'arraybuffer'
			})
					.then(
							function(success) {
								var blob = new Blob(
										[ success.data ],
										{
                                            type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
										});
								saveAs(blob, fileName + '.xlsx');

							}, function(error) {
								$mdToast.show($mdToast.simple().textContent(error));
							});
		}
		




    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('UserService', UserService);

    UserService.$inject = ['$http', '$q', 'UrlUtils'];

    function UserService($http, $q, UrlUtils) {

        var service = {
            getUsers: getUsers,
            searchUsers:searchUsers,
            searchUsersForClient:searchUsersForClient,
            addUser: addUser,
            getDetails: getDetails,
            userDetailsObj: {},
            editUser: editUser,
            updateUserQueryCounter: updateUserQueryCounter,
            verifyHibernateUsers: verifyHibernateUsers,
            verifyMassRemindPassword: verifyMassRemindPassword,
            setCounters: setCounters,
            activateUsers: activateUsers,
            verifyRemoveUsers: verifyRemoveUsers,
            grantMainAdminRights: grantMainAdminRights,
            revokeMainAdminRights: revokeMainAdminRights,
            loginAs: loginAs,
            logoutToRoot: logoutToRoot,
            user: {
                id: null
            },
            getUserHistory: getUserHistory,
            getUserRegions: getUserRegions,
            getCurrentUserRegions: getCurrentUserRegions,
            saveUserRegions: saveUserRegions,
            addFreeTokens: addFreeTokens,
            confirmEmail: confirmEmail,
            searchObject: null,
            isEmailUsed: isEmailUsed,
            getUserInstance: getUserInsance,
            getAvailableStudentEmails: getAvailableStudentEmails,
            samlRedirectionUrl: samlRedirectionUrl,
            oauth2RedirectionUrl: oauth2RedirectionUrl
		};
        
        return service;

        function verifyRemoveUsers(ids, searchRequest, all) {
          return all ? searchAndRemoveUsers(searchRequest) : removeUsers(ids);
        }

        function searchAndRemoveUsers(obj) {
           return $http.put('/api/user/search/remove/', obj).then(
            function (response) {
                   return response.data;
               },
               function (errResponse) {
                   return $q.reject(errResponse);
               });
        }

        function removeUsers(obj) {
           return $http.put('/api/user/remove/', obj).then(
            function (response) {
                   return response.data;
               },
               function (errResponse) {
                   return $q.reject(errResponse);
               });
        }

        function verifyMassRemindPassword(ids, searchRequest, all) {
            return all ? searchAndMassRemindPassword(searchRequest) : massRemindPassword(ids);
        }

        function searchAndMassRemindPassword(obj) {
            return $http.put('/api/user/search/remind/', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function massRemindPassword(obj) {
            return $http.put('/api/user/remind/', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function setCounters(ids, searchRequest, all, value, contractType) {
            return $http.put('/api/user/set/counters/' + (all ? 'search/' : '') + (value == null ? '' : value) + ',' + contractType, (all ? searchRequest : ids)).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function verifyHibernateUsers(ids, searchRequest, all) {
            return all ? searchAndHibernateUsers(searchRequest) : hibernateUsers(ids);
        }

        function searchAndHibernateUsers(obj) {
           return $http.put('/api/user/search/hibernate/', obj).then(
            function (response) {
                   return response.data;
               },
               function (errResponse) {
                   return $q.reject(errResponse);
               });
        }

        function hibernateUsers(obj) {
           return $http.put('/api/user/hibernate/', obj).then(
            function (response) {
                   return response.data;
               },
               function (errResponse) {
                   return $q.reject(errResponse);
               });
        }

        function getUsers(obj) {
        	return $http.post('/api/user/list', obj).then(
        			function (response) {
        				return response.data;
        			},
        			function (errResponse) {
        				return $q.reject(errResponse);
        			});
        }

        function searchUsers(obj) {
            return $http.post('/api/user/search', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function searchUsersForClient(obj) {
            return $http.post('/api/user/search-for-client', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function addUser(obj) {
            return $http.put('api/user/add', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
        
        function editUser(obj, id) {
            return $http.put('api/user/edit/' + id, obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getDetails(id) {
           return $http.get('/api/user/details/' + id).then(
               function (response) {
                   return response.data;
               },
               function (errResponse) {
                   return $q.reject(errResponse);
               });
        }
        
        function updateUserQueryCounter(obj) {
            return $http.put('api/user/query-counter', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function activateUsers(obj) {
           return $http.put('/api/user/activate/', obj).then(
            function (response) {
                   return response.data;
               },
               function (errResponse) {
                   return $q.reject(errResponse);
               });
        }
        
        function grantMainAdminRights(userId) {
            return $http.put('api/user/main-admin/grant-main-admin-rights/' + userId, undefined).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
        
        function revokeMainAdminRights(userId) {
            return $http.put('api/user/main-admin/revoke-main-admin-rights/' + userId, undefined).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function loginAs(username) {
       		username = UrlUtils.prepareUrlParam(username);
            return $http.get('/api/impersonate/login?username=' + username).then(
                    function (response) {
                        return response.data;
                    },
                    function (errResponse) {
                        return $q.reject(errResponse);
                    });
         }
        
        function logoutToRoot() {
            return $http.get('/api/impersonate/logout').then(
                    function (response) {
                        return response.data;
                    },
                    function (errResponse) {
                        return $q.reject(errResponse);
                    });
        }
        
        function getUserHistory(userId) {
            return $http.get('/api/user-history/list-for-user/' + userId).then(
                    function (response) {
                        return response.data;
                    },
                    function (errResponse) {
                        return $q.reject(errResponse);
                    });
        }

        function getUserRegions(userId) {
            return $http.get('/api/user/user-regions/' + userId).then(
                    function (response) {
                        return response.data;
                    },
                    function (errResponse) {
                        return $q.reject(errResponse);
                    });
        }

        function getCurrentUserRegions() {
            return $http.get('/api/user/current-user-regions').then(
                    function (response) {
                        return response.data;
                    },
                    function (errResponse) {
                        return $q.reject(errResponse);
                    });
        }

        function saveUserRegions(obj) {
            return $http.post('/api/user/save-user-regions', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function addFreeTokens(obj) {
            return $http.put('/api/payments/add-free-tokens/', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function confirmEmail(params) {
            return $http.put('api/user/confirm-email/', params).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function isEmailUsed(email) {
            return $http.post('api/user/isUserExists', email).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }


        function getUserInsance(email, redirectEnabled) {

            if(!redirectEnabled){
                var data = { data: ''}
                return $q.resolve(data);
            } else {
                return $http.get('api/redirect?mail=' + encodeURIComponent(email)).then(
                    function (response) {
                        return response.data;
                    },
                    function (errResponse) {
                        return $q.reject(errResponse);
                    });
            }
        }

        function getAvailableStudentEmails(emails) {
            var obj = {emails: emails};
            return $http.post('/api/user/available-student-emails', obj).then(
              function (response) {
                  return response.data;
              },
              function (errResponse) {
                  return $q.reject(errResponse);
              });
        }

        function samlRedirectionUrl(partner) {
            return $http.get('/api/saml-redirect/' + partner).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function oauth2RedirectionUrl(partner) {
            return $http.get('/api/oauth2-redirect/' + partner).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
            
            
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('UserSearchRequest', function () {

        function UserSearchRequest() {
            this.userName = '';
            this.userEmail = '';
            this.organisationalUnitId = '';
            this.status = '';
            this.hasntLogged = false;
            this.userLastLoginDateFrom = null;
            this.userLastLoginDateTo = null;
            this.role = '';
            this.registerDateFrom = null;
            this.registerDateTo = null;
        }

        return UserSearchRequest;
    });
})();
(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('QueryRequest', function () {

        function QueryRequest() {
            this.order = '-userRegisterDate';
            this.page = 1;
            this.limit = 5;
        }

        return QueryRequest;
    });
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('SimilarityReportSettingsService', SimilarityReportSettingsService);

    SimilarityReportSettingsService.$inject = ['$http', '$q'];

    function SimilarityReportSettingsService($http, $q) {

        var service = {
        	getForm: getForm,
        	edit: edit,
		}
        
        return service;
        
        function getForm(clientId) {
        	return $http.get('api/similarity-report-settings/' + clientId).then(
        			function (response) {
        				return response.data;
        			},
        			function (errResponse) {
        				return $q.reject(errResponse);
        			});
        }

        function edit(obj) {
            return $http.post('api/similarity-report-settings', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }

})();

(function () {
    'use strict';

    angular
    .module('sessionService', [])
    .factory('sessionService',
      function () {

          var service = {};

          service.subscriptions = {};

          return service;

      });
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.prod;
                        response.instance = result.data.applicationInstance;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('InstanceService', InstanceService);

    InstanceService.$inject = ['$http', '$q', '$log', '$location', 'INSTANCES', 'DetectInstanceService'];

    function InstanceService($http, $q, $log, $location, INSTANCES, DetectInstanceService) {

        var service = {
            instance: getInstance,
            findInstanceByBrand: findInstanceByBrand,
            getSubdomain: getSubdomain
        };

        var instanceSettings;
        var host = $location.host();

        function getUserTimezone() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }

        function getSubdomain() {
            if (host === 'localhost') {
                return 'st';
            } else {
                if (host.indexOf('.') < 0) {
                    return null;
                } else {
                    return host.split('.')[0];
                }
            }
        }

        function getInstance() {
            getInstanceEngine(DetectInstanceService.instance());
            return instanceSettings;
        }

        function findInstanceByBrand(brand) {
            getInstanceEngine(brand);
            return instanceSettings;
        }

        function getInstanceEngine(brand) {
            var instance = INSTANCES.find(function (currentValue) {
                return brand === currentValue.instance;
            });
            if (!instance) return null;
            instanceSettings = instance.settings;

            var timezone = instanceSettings.timezones.find(function (currentValue) {
                return getSubdomain() === currentValue.subdomain;
            });
            if (brand === 'int') {
                instanceSettings.timezone = getUserTimezone();
                instanceSettings.timezoneDocuments = getUserTimezone();
                instanceSettings.timezonePayments = getUserTimezone();
            } else {
                instanceSettings.timezone = timezone.timezone;
                instanceSettings.timezoneDocuments = timezone.documents;
                instanceSettings.timezonePayments = timezone.payments;
            }
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('AccountService', AccountService);

    AccountService.$inject = ['$http', '$q', '$log', '$sessionStorage', '$rootScope', '$localStorage', 
        'USERSCHOOLTYPE'];
    
    function AccountService($http, $q, $log, $sessionStorage, $rootScope, $localStorage, 
                            USERSCHOOLTYPE) {

        var service = {
            profile: {},
            setLang: setLang,
            setData: setData,
            setDataDetails: setDataDetails,
            getLoggedUserDetails: getLoggedUserDetails,
            setNewPassword: setNewPassword,
            acceptTerms: acceptTerms,
            forceChangePassword: forceChangePassword,
            account: {
                userAcceptsRegulations: null,
                pickedLang: null
            },
            getPermision: getPermision,
            getClientSettings: getClientSettings,
            getClientType: getClientType,
            getClientCountryId: getClientCountryId,
            getClientRegionOfficeEmail: getClientRegionOfficeEmail,
            getClientRegionHelpdeskEmail: getClientRegionHelpdeskEmail,
            role:{
                isIndividual: isIndividual,
                isOperator: isOperator,
                isStudent: isStudent,
                isLecturer: isLecturer,
                isAdmin: isAdmin,
                isUserAnAdmin: isUserAnAdmin,
                isSuperAdmin: isSuperAdmin,
                isMainSuperAdmin: isMainSuperAdmin,
                isReseller: isReseller,
                isMinistry: isMinistry,
                isOrgUnitAdmin: isOrgUnitAdmin,
                isMainAdmin: isMainAdmin
            },
            userRole: {
                isUserAnAdmin: isUserAnAdmin
            },
            broadcastRole: broadcastRole,
            accountType: accountType,
            accountRole: accountRole,
            setRole: setRole,
            clientType: {
                isClientTypeUnivStandard: isClientTypeUnivStandard,
                isClientTypeUnivAsap: isClientTypeUnivAsap,
                isPublishingHouse: isPublishingHouse,
                isSchool: isSchool,
                isPap: isPap,
                isCodeAccount: isClientTypeCodeAccount,
            },
            confirmEmail: confirmEmail,
            sendAccountDeletionConfirmationEmail: sendAccountDeletionConfirmationEmail,
            confirmAccountDeletion: confirmAccountDeletion
        };

        return service;

        function setRole(role){
            $sessionStorage.role.data.accountType = role;
            this.broadcastRole();
        }

        function getRole(){
            return $sessionStorage.role.data.accountType;
        }

        function getClientCountryId(){
            return $sessionStorage.role.data.clientCountryId;
        }

        function getClientRegionOfficeEmail() {
            return $sessionStorage.role.data.clientRegionOfficeEmail;
        }

        function getClientRegionHelpdeskEmail() {
            return $sessionStorage.role.data.clientRegionHelpdeskEmail;
        }

        function getClientType(){
            return $sessionStorage.role.data.clientType;
        }

        function broadcastRole() {
            $rootScope.$broadcast("switchRole");
        }

        function isOperator(){
            return (!angular.isUndefined($sessionStorage.role) && ($sessionStorage.role.data.accountType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_DEANERY.value
                || $sessionStorage.role.data.accountType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR.value));
        }
        function isStudent(){
            return (!angular.isUndefined($sessionStorage.role) && $sessionStorage.role.data.accountType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_STUDENT.value);
        }
        function isLecturer(){
            return (!angular.isUndefined($sessionStorage.role) && $sessionStorage.role.data.accountType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_TEACHER.value);
        }
        function isIndividual(){
            return (!angular.isUndefined($sessionStorage.role) && $sessionStorage.role.data.accountType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_INDIVIDUAL.value);
        }
        function isAdmin(){
            return (!angular.isUndefined($sessionStorage.role) && ($sessionStorage.role.data.accountType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR.value
                || $sessionStorage.role.data.accountType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_SUPERADMIN.value));
        }
        function isOrgUnitAdmin(){
            return (!angular.isUndefined($sessionStorage.role) && ($sessionStorage.role.data.accountType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_ORG_UNIT_ADMIN.value));
        }
        function isUserAnAdmin(user){
            return user && user.userSchoolTypeEnum === USERSCHOOLTYPE.USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR.value;
        }
        function isSuperAdmin(){
            return (!angular.isUndefined($sessionStorage.role) && $sessionStorage.role.data.accountType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_SUPERADMIN.value);
        }
        function isReseller(){
            return (!angular.isUndefined($sessionStorage.role) && $sessionStorage.role.data.accountType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_RESELLER.value);
        }
        function isMinistry(){
            return (!angular.isUndefined($sessionStorage.role) && $sessionStorage.role.data.accountType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_MINISTRY.value);
        }
        function isMainAdmin(){
            return !angular.isUndefined($sessionStorage.role) && $sessionStorage.role.data.mainAdmin;
        }
        function isMainSuperAdmin() {
            return !angular.isUndefined($sessionStorage.role) 
                && $sessionStorage.role.data.accountType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_SUPERADMIN.value
                && service.account.clientRegionAccess
                && service.account.clientRegionAccess.allRegions;
        }

        function isPublishingHouse() {
            return $sessionStorage.role && $sessionStorage.role.data.clientType === "PUBLISHING_HOUSE";
        }

        function isPap() {
            return $sessionStorage.role && $sessionStorage.role.data.clientType === "CLIENT_TYPE_PORTAL";
        }

        function isSchool() {
            return $sessionStorage.role && $sessionStorage.role.data.clientType === "SCHOOL";
        }

        function isClientTypeCodeAccount() {
            return $sessionStorage.role 
                && ($sessionStorage.role.data.clientType === "CODE_ACCOUNT" 
                    || $sessionStorage.role.data.clientType === "COLLEGE"
                );
        }

        function isClientTypeUnivStandard() {
            return $sessionStorage.role && $sessionStorage.role.data.clientType === "CLIENT_TYPE_STANDARD";
        }

        function isClientTypeUnivAsap() {
            return $sessionStorage.role && $sessionStorage.role.data.clientType === "CLIENT_TYPE_ASAP";
        }

        function forceChangePassword() {
            if ($localStorage.logoutToRootInfo || isIndividual()) { //nie pokazujemy dla przelogowanych i dla indywidualsów
                return false;
            }
            
            var passwordChangePeriod = getClientSettings().passwordChange;
            if (passwordChangePeriod) {
                var userLastPasswordChangeDate = new Date(service.account.userLastPasswordChangeDate);
                var forcePasswordChangeDate = new Date(userLastPasswordChangeDate.setDate(userLastPasswordChangeDate.getDate() + passwordChangePeriod));
                if (new Date() > forcePasswordChangeDate) {
                    return true;
                }
            }
            return false;
        }
        
        function getPermision(permissionKey){
        	var found = false;
            angular.forEach(service.account.authorities, function(value, key) {
                if( value === permissionKey ){
                	found = true;
                }
            });
            return found;
        }

        function getClientSettings(){
        	return service.account.clientSettings;
        }

        function setLang(languageKey) {
            return $http.post('api/internationalization/?lang=' + languageKey).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function setData(obj) {
            return $http.put('api/user/update', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function setNewPassword(obj) {
            return $http.put('api/user/password', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function acceptTerms(obj) {
            return $http.put('api/user/accept-terms', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getLoggedUserDetails(){
            return $http.get('api/user/logged-user-details').then(
                 function (response) {
                    return response.data;
                 },
                 function (errResponse) {
                    return $q.reject(errResponse);
                 });
        }

        function accountType() {
            return $http.get('api/user/account-type').then(
                 function (response) {
                    return response.data;
                 },
                 function (errResponse) {
                    return $q.reject(errResponse);
                 });
        }

        function accountRole() {
            return $http.get('api/user/account-role').then(
                 function (response) {
                    return response.data;
                 },
                 function (errResponse) {
                    return $q.reject(errResponse);
                 });
        }

        function setDataDetails(obj) {
            return $http.put('api/user/update-details', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function confirmEmail(obj) {
            return $http.put('api/user/confirm-email', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function sendAccountDeletionConfirmationEmail() {
            return $http.post('api/user/delete-account/send-confirmation-email').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function confirmAccountDeletion(accountDeletionConfirmationCode) {
            return $http.post('api/user/delete-account/confirm', {key: accountDeletionConfirmationCode}).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('ContactFormModelRequest', function () {

        function ContactFormModelRequest() {
            this.adresat = 'opcja 1';
            this.addresats = [
                { name: 'pomoc@antyplagiat.pl', email: 'pomoc@antyplagiat.pl' },
                { name: 'help@strikeplagiarism.com', email: 'help@strikeplagiarism.com' }
            ];
            this.contactForm = {
                adresat: '',
                file: '',
                message: ''
            },
            this.availableExtensions = '.pdf,.png,.jpg,.jpeg,.gif,.bmp',
            this.messages = {
                success: false,
                error: false
            };
        }

        return ContactFormModelRequest;
    });
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('ContactAddresatsModelRequest', function () {

        function ContactAddresatsModelRequest() {
            this.email = '';
            this.name = '';
        }

        return ContactAddresatsModelRequest;
    });
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('TokenService', TokenService);

    TokenService.$inject = ['$http', '$q', '$rootScope'];

    function TokenService($http, $q, $rootScope) {


        var service = {
            getInfo: getInfo,
            getTokenPriceList: getTokenPriceList,
            broadcastTokens: broadcastTokens,
            buyTokens: false,
            tokensNedded: false
        };

        return service;

        function getInfo() {
            return $http.get('api/tokens/info').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function getTokenPriceList(obj) {
            return $http.post('api/tokens/pricelist', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function broadcastTokens() {
            $rootScope.$broadcast("availableTokens");
        }

    }



})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('PaymentsService', PaymentsService);

    PaymentsService.$inject = ['$http', '$q'];

    function PaymentsService($http, $q) {

        var service = {
            save: save,
            get: get,
            getTest: getTest,
            getPaymentsForSuperadmin: getPaymentsForSuperadmin,
            getPrice: getPrice,
            useTokens: useTokens,
            pay: pay,
            getLastInvoiceInfo: getLastInvoiceInfo,
            downloadInvoice: downloadInvoice,
            markAsCanceled: markAsCanceled,
            getPaymentMethods: getPaymentMethods,
            getEasyPayAvailableForUsers: getEasyPayAvailableForUsers,
            getKassa24AvailableForUsers: getKassa24AvailableForUsers,
            getStatusForLastPayment: getStatusForLastPayment
        };

        return service;

        function getPaymentMethods(obj) {
            return $http.get('api/payments/methods', obj).then(
        function (response) {
            return response.data;
        },
        function (errResponse) {
            return $q.reject(errResponse);
        });
        }

        function useTokens(obj) {
            return $http.post('api/payments/use-tokens', obj).then(
        function (response) {
            return response.data;
        },
        function (errResponse) {
            return $q.reject(errResponse);
        });
        }

        function getLastInvoiceInfo() {
            return $http.get('api/invoice/data').then(
        function (response) {
            return response.data;
        },
        function (errResponse) {
            return $q.reject(errResponse);
        });
        }

        function getPrice(obj) {
            return $http.post('api/payments/token-price', obj).then(
        function (response) {
            return response.data;
        },
        function (errResponse) {
            return $q.reject(errResponse);
        });
        }


        function save(obj) {

            return $http.post('api/payments/save', obj).then(
        function (response) {
            return response.data;
        },
        function (errResponse) {
            return $q.reject(errResponse);
        });
        }

        function get(obj) {
            return $http.post('/api/payments', obj).then(
        function (response) {
            return response.data;
        },
        function (errResponse) {
            return $q.reject(errResponse);
        });
        }

        function getTest(obj) {
            return $http.get('/api/paymentsTest').then(
        function (response) {
            return response.data;
        },
        function (errResponse) {
            return $q.reject(errResponse);
        });
        }

        function getPaymentsForSuperadmin(obj) {
	        return $http.post('/api/payments/list-for-superadmin', obj).then(
	        function (response) {
	            return response.data;
	        },
	        function (errResponse) {
	            return $q.reject(errResponse);
	        });
        }

        function pay(obj) {
            return $http.post('/api/payments/pay', obj).then(
            function (response) {
                return response.data;
            },
            function (errResponse) {
                return $q.reject(errResponse);
            });
        }

        function getEasyPayAvailableForUsers() {
            return $http.get('api/payments/easypay-available-for-users').then(
                    function (response) {
                        return response.data;
                    },
                    function (errResponse) {
                        return $q.reject(errResponse);
                    });
        }

        function getKassa24AvailableForUsers() {
            return $http.get('api/payments/kassa24-available-for-users').then(
                    function (response) {
                        return response.data;
                    },
                    function (errResponse) {
                        return $q.reject(errResponse);
                    });
        }

        function getStatusForLastPayment() {
            return $http.get('api/payments/status-for-last-payment').then(
                    function (response) {
                        return response.data;
                    },
                    function (errResponse) {
                        return $q.reject(errResponse);
                    });
        }
    
        function downloadInvoice(invoiceNumber) {
            return $http({
                url : '/api/invoice/download',
                method: "POST",
                data: invoiceNumber,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).then(
                function(success) {
                    var blob = new Blob(
                        [ success.data ],
                        {
                            type: "text/pdf; encoding=UTF-8"
                        });
                    var fileName = 'faktura-' + invoiceNumber.replace( /[<>:"\/\\|?*]+/g, '-' ) + ".pdf";
                    saveAs(blob, fileName);
                }, function(errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }
    
        function markAsCanceled(id) {
            return $http.get('/api/payments/mark-as-canceled/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
    }



})();

(function () {
	'use strict';

	angular
	.module('plagiat2017App')
	.factory('ContractService', ContractService);

	ContractService.$inject = ['$http', '$q', '$rootScope'];

	function ContractService($http, $q, $rootScope) {


		var service = {
			getInfo: getInfo,
			getHistory: getHistory,
			broadcast: broadcast,
			buyTokens: false,
			inactive:false,
			contract: {}
		};

		return service;

		function getInfo() {
			return $http.get('api/operator/contract').then(
				function (response) {
					return response.data;
				},
				function (errResponse) {
					return $q.reject(errResponse);
				});
		}

		function getHistory(clientId) {
			return $http.get('api/contract/history?clientId='+clientId).then(
				function (response) {
					return response.data;
				},
				function (errResponse) {
					return $q.reject(errResponse);
				});
		}

		function broadcast() {
			$rootScope.$broadcast("refreshContract");
		}

	}



})();

(function () {
    'use strict';

    angular.module('PaymentsRequestModel', [])
    .factory('PaymentsRequest', function () {

        function PaymentsRequest() {
            this.providerTransactionId = '';
            this.paymentDate = '';
            this.providerStatus = '';
            this.userPaymentType = '';
            this.initialAmount = '';
            this.amountLeft = '';
            this.dueDate = '';
        }

        return PaymentsRequest;
    });
})();

(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('PaymentsQueryRequest', function () {

        function PaymentsQueryRequest() {
            this.order = '-paymentDate';
            this.page = 1;
            this.limit = 5;
        }

        return PaymentsQueryRequest;
    });
})();

(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('PaymentInitRequest', function () {

        function PaymentInit() {
            this.productQuantity = '';

            this.price = {
                userPaymentType: 'TYPE_TRANSFER',
                quantity: 0,
                currency: "EUR"
            };

            this.TYPE_TRANSFER = {
                name: 'Przelewy24',
                img: 'pay-przelewy24.png',
                userPaymentType: 'TYPE_TRANSFER',
                maxTokens: 250,
                invoice: true,
                backUrl: '/api/payments/return-from-dotpay'
            };
            this.TYPE_PAY_PAL = {
                name: 'Paypal',
                img: 'pay-paypal.png',
                userPaymentType: 'TYPE_PAY_PAL',
                maxTokens: 250,
                invoice: true,
                backUrl: '/api/payments/return-from-paypal'
            };
            this.TYPE_PAY_PAL_RO = {
                name: 'Paypal.',
                img: 'pay-paypal.png',
                userPaymentType: 'TYPE_PAY_PAL_RO',
                maxTokens: 250,
                invoice: true,
                backUrl: '/api/payments/return-from-paypal'
            };
            this.TYPE_EASY_PAY = {
                name: 'EasyPay',
                img: 'pay-easypay.png',
                userPaymentType: 'TYPE_EASY_PAY',
                maxTokens: 250,
                invoice: true,
                backUrl: '/api/payments/return-from-easypay'
            };
            this.TYPE_KASSA_24 = {
                name: 'Kassa24',
                img: 'pay-kassa24.png',
                userPaymentType: 'TYPE_KASSA_24',
                maxTokens: 50,
                invoice: false,
                backUrl: '/api/payments/return-from-kassa24'
            };
            this.TYPE_KASSA_24_CARD = {
                name: 'Kassa24 Business',
                img: 'pay-kassa24card.png',
                userPaymentType: 'TYPE_KASSA_24_CARD',
                maxTokens: 250,
                invoice: false,
                backUrl: '/api/payments/return-from-kassa24card'
            };
            this.TYPE_SMS = {
                name: 'SMS',
                img: 'pay-smartpay.png',
                userPaymentType: 'TYPE_SMS',
                maxTokens: 20,
                invoice: false,
                backUrl: '/api/payments/return-from-sms',
                smsCode: []
            };
            this.TYPE_MOBILPAY_CARD = {
                name: " Card",
                img: 'pay-mobilpay-card.png',
                userPaymentType: 'TYPE_MOBILPAY_CARD',
                maxTokens: 250,
                invoice: true,
                backUrl: '/api/payments/return-from-mobilpay'
            };
            this.TYPE_MOBILPAY_SMS = {
                name: "SMS",
                img: 'pay-mobilpay.png',
                userPaymentType: 'TYPE_MOBILPAY_SMS',
                maxTokens: 4,
                invoice: false,
                backUrl: '/api/payments/return-from-mobilpay'
            };
            this.TYPE_MILLIKART_CARD = {
                name: 'Millikart',
                img: 'pay-millikart.png',
                userPaymentType: 'TYPE_MILLIKART_CARD',
                maxTokens: 250,
                invoice: false,
                backUrl: '/api/payments/return-from-millikart'
            };
            this.TYPE_YIGIM_AZ = {
                name: 'Yigim.az',
                img: 'pay-yigim.png',
                userPaymentType: 'TYPE_YIGIM_AZ',
                maxTokens: 250,
                invoice: false,
                backUrl: '/api/payments/return-from-provider'
            };
            this.TYPE_UNIBANK_AZ = {
                name: 'Unibank.az',
                img: 'pay-unibank-az.png',
                userPaymentType: 'TYPE_UNIBANK_AZ',
                maxTokens: 250,
                invoice: false,
                backUrl: '/api/payments/return-from-provider'
            };
            this.TYPE_EPAY_BG = {
                name: 'ePay.bg',
                img: 'pay-epay_bg.png',
                userPaymentType: 'TYPE_EPAY_BG',
                maxTokens: 250,
                invoice: false,
                backUrl: '/api/payments/return-from-provider'
            };
            this.TYPE_BLIK = {
                name: 'Blik',
                img: 'pay-blik.png',
                userPaymentType: 'TYPE_BLIK',
                maxTokens: 250,
                invoice: true,
                backUrl: '/api/payments/return-from-blik'
            };
            this.TYPE_MOBILTEK = {
                name: 'SMS',
                img: 'pay-mobiltek.png',
                userPaymentType: 'TYPE_MOBILTEK',
                maxTokens: 20,
                invoice: false,
                backUrl: '/api/payments/return-from-mobiltek'
            };
            this.TYPE_PAYME = {
                name: 'Payme',
                img: 'pay-payme.png',
                userPaymentType: 'TYPE_PAYME',
                maxTokens: 250,
                invoice: false,
                backUrl: '/api/payments/return-from-payme'
            };
            this.TYPE_FORTE_KZ = {
                name: 'Forte.kz',
                img: 'pay-forte-kz.png',
                userPaymentType: 'TYPE_FORTE_KZ',
                maxTokens: 250,
                invoice: false,
                backUrl: '/api/payments/return-from-provider'
            };
            this.TYPE_KASPI_BANK = {
                name: 'Kaspi Bank',
                img: 'pay-kaspi-bank.png',
                userPaymentType: 'TYPE_KASPI_BANK',
                maxTokens: 250,
                invoice: false,
                backUrl: '/api/payments/return-from-provider'
            };

        }

        return PaymentInit;
    });
})();

(function () {
    'use strict';

    angular.module('PaymentFormRequestModel', [])
  .factory('PaymentFormRequest', function () {

      function PaymentForm() {
          this.phase = 'stepTokens';
          this.step1 = true;
          this.step2 = false;
          this.step3 = false;
          this.tokens = 0;
          this.invoiceRequired = '';
          this.isCompany = false;
          this.agreement = false;
          this.invoice = {
              company: '',
              nip: '',
              street: '',
              city: '',
              zip: '',
              phone: '',
              country: '',
              purchaser: ''
          };

          this.paymentMethod = '';
          this.creditCard = {
              name: '',
              cardNo: '',
              dateFrom: '',
              dateTo: '',
              ccv: '',
              country: ''
          };
          this.sms = {
              value: ''
          };
      }

      return PaymentForm;
  });
})();

(function () {
    'use strict';

    angular.module('plagiat2017App')
      .factory('CountryModel', function () {
          function CountryModel() {
              return [
                  "PL",
                  "AF",
                  "AL",
                  "DZ",
                  "AD",
                  "AO",
                  "AI",
                  "AQ",
                  "AG",
                  "SA",
                  "AR",
                  "AM",
                  "AW",
                  "AU",
                  "AT",
                  "AZ",
                  "BS",
                  "BH",
                  "BD",
                  "BB",
                  "BE",
                  "BZ",
                  "BJ",
                  "BM",
                  "BT",
                  "BY",
                  "BO",
                  "BA",
                  "BW",
                  "BR",
                  "BN",
                  "IO",
                  "VG",
                  "BG",
                  "BF",
                  "BI",
                  "CL",
                  "CN",
                  "HR",
                  "CW",
                  "CY",
                  "TD",
                  "ME",
                  "CZ",
                  "UM",
                  "DK",
                  "CD",
                  "DM",
                  "DO",
                  "DJ",
                  "EG",
                  "EC",
                  "EE",
                  "ET",
                  "FK",
                  "FJ",
                  "PH",
                  "FI",
                  "FR",
                  "TF",
                  "GA",
                  "GM",
                  "GH",
                  "GI",
                  "GR",
                  "GD",
                  "GL",
                  "GE",
                  "GU",
                  "GY",
                  "GF",
                  "GP",
                  "GT",
                  "GN",
                  "GW",
                  "GQ",
                  "HT",
                  "ES",
                  "IC",
                  "NL",
                  "HN",
                  "HK",
                  "IN",
                  "ID",
                  "IQ",
                  "IR",
                  "IE",
                  "IS",
                  "IL",
                  "JM",
                  "JP",
                  "YE",
                  "JO",
                  "KY",
                  "KH",
                  "CM",
                  "CA",
                  "QA",
                  "KZ",
                  "KE",
                  "KG",
                  "KI",
                  "CO",
                  "KM",
                  "CG",
                  "KP",
                  "KR",
                  "XK",
                  "CR",
                  "CU",
                  "KW",
                  "LA",
                  "LS",
                  "LB",
                  "LR",
                  "LY",
                  "LI",
                  "LT",
                  "LU",
                  "LV",
                  "MK",
                  "MG",
                  "YT",
                  "MO",
                  "MW",
                  "MV",
                  "MY",
                  "ML",
                  "MT",
                  "MP",
                  "MA",
                  "MQ",
                  "MR",
                  "MU",
                  "MX",
                  "FM",
                  "MM",
                  "MD",
                  "MC",
                  "MN",
                  "MS",
                  "MZ",
                  "NA",
                  "NR",
                  "NP",
                  "BQ",
                  "DE",
                  "NE",
                  "NG",
                  "NI",
                  "NU",
                  "NF",
                  "NO",
                  "NC",
                  "NZ",
                  "OM",
                  "PK",
                  "PW",
                  "PA",
                  "PG",
                  "PY",
                  "PE",
                  "PN",
                  "PF",
                  "PR",
                  "PT",
                  "ZA",
                  "CF",
                  "CV",
                  "RE",
                  "RU",
                  "RO",
                  "RW",
                  "EH",
                  "KN",
                  "LC",
                  "VC",
                  "BL",
                  "MF",
                  "PM",
                  "SV",
                  "WS",
                  "AS",
                  "SM",
                  "SN",
                  "RS",
                  "SC",
                  "SL",
                  "SG",
                  "SX",
                  "SK",
                  "SI",
                  "SO",
                  "LK",
                  "US",
                  "SZ",
                  "SD",
                  "SS",
                  "SR",
                  "SJ",
                  "SY",
                  "CH",
                  "SE",
                  "TJ",
                  "TH",
                  "TW",
                  "TZ",
                  "TG",
                  "TK",
                  "TO",
                  "TT",
                  "TN",
                  "TR",
                  "TM",
                  "TC",
                  "TV",
                  "UG",
                  "UA",
                  "UY",
                  "UZ",
                  "VU",
                  "WF",
                  "VA",
                  "HU",
                  "VE",
                  "GB",
                  "XI",
                  "VN",
                  "IT",
                  "CI",
                  "BV",
                  "CX",
                  "IM",
                  "SH",
                  "CK",
                  "VI",
                  "HM",
                  "CC",
                  "MH",
                  "FO",
                  "SB",
                  "ST",
                  "ZM",
                  "ZW",
                  "AE"
              ];
          }

          return CountryModel;
      });
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('OrganisationalUnitsService', OrganisationalUnitsService);

    OrganisationalUnitsService.$inject = ['$http', '$q'];

    function OrganisationalUnitsService($http, $q) {

        var url = 'api/organisational-units';

        var service = {
            getList: getList,
            getAll: getAll,
            add: add,
            edit: edit,
            getForm: getForm,
            getSimpleById: getSimpleById,
            findByUserId: findByUserId,
            getSimpleForCurrentClient: getSimpleForCurrentClient,
            remove: remove,
            findAllForClient: findAllForClient,
            findAllByClient: findAllByClient
        };

        return service;

        function getList(obj) {
            return $http.post(url + '/list', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getAll(obj) {
            return $http.get(url + '/all', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function add(obj) {
            return $http.put('api/organisational-units', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function edit(obj) {
            return $http.post('api/organisational-units', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getForm(id) {
            return $http.get('api/organisational-units/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getSimpleById(id) {
            return $http.get('api/organisational-units/simple/' + id).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function findByUserId(id) {
            return $http.get('api/organisational-units/by-user-id/' + id).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getSimpleForCurrentClient() {
            return $http.get('api/organisational-units/simple/').then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function remove(obj) {
            return $http.post(url + '/delete', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function findAllForClient(editedDocumentId, editedUserId) {
            var url2 = url;
            if (editedDocumentId) {
                url2 += '?editedDocumentId=' + editedDocumentId;
            } else if (editedUserId) {
                url2 += '?editedUserId=' + editedUserId;
            }

            return $http.get(url2).then(
                function (response) {
                    return response.data;
                }, function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function findAllByClient(clientId) {
            return $http.get(url + "/all-for-client/" + clientId).then(
                function (response) {
                    return response.data;
                }, function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    }

})();

(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('organisationalUnitsSearchRequest', function () {

        function searchRequest() {
            this.pageNumber = 0;
            this.pageSize = 5;
            this.sortTab = '';
            this.search = {};
        }

        return searchRequest;
    });
})();
(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('organisationalUnitsQueryRequest', function () {

        function queryRequest() {
            this.order = '-id';
            this.page = 1;
            this.limit = 5;
            this.search = {};
        }

        return queryRequest;
    });
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('InvoicesService', InvoicesService);
    
    InvoicesService.$inject = ['$http', '$q'];

    function InvoicesService($http, $q) {

        var service = {
            getInvoicesForSuperadmin: getInvoicesForSuperadmin,
            issueInvoice: issueInvoice,
            getInvoiceDetails: getInvoiceDetails,
            generateBulkInvoice: generateBulkInvoice,
            markInvoiceAsIssued: markInvoiceAsIssued,
            markInvoiceAsWaiting: markInvoiceAsWaiting,
            markInvoiceAsIncorrect: markInvoiceAsIncorrect,
            updateIssue: updateIssue,
            createDraftInvoiceFromPayment: createDraftInvoiceFromPayment
        };

        return service;

        function getInvoicesForSuperadmin(obj) {
	        return $http.post('/api/invoice/list-for-superadmin', obj).then(
	        function (response) {
	            return response.data;
	        },
	        function (errResponse) {
	            return $q.reject(errResponse);
	        });
        }

        function issueInvoice(id) {
            return $http.get('/api/invoice/issue/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getInvoiceDetails(id) {
            return $http.get('/api/invoice/details/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function generateBulkInvoice(obj) {
            return $http.post('/api/invoice/issue', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function markInvoiceAsIssued(id) {
            return $http.get('/api/invoice/mark/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function markInvoiceAsWaiting(id) {
            return $http.get('/api/invoice/wait/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function markInvoiceAsIncorrect(id) {
            return $http.get('/api/invoice/incorrect/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function updateIssue(issue) {
            return $http.post('/api/invoice/update', issue).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function createDraftInvoiceFromPayment(providerTransactionId) {
            return $http.get('/api/invoice/create/' + providerTransactionId).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    }
    
})();

(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('InvoicesQueryRequest', function () {

        function InvoicesQueryRequest() {
            this.order = '-id';
            this.page = 1;
            this.limit = 5;
        }

        return InvoicesQueryRequest;
    });
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('DocumentParameterDefinitionsService', DocumentParameterDefinitionsService);

    DocumentParameterDefinitionsService.$inject = ['$http', '$q', '$translate'];

    function DocumentParameterDefinitionsService($http, $q, $translate) {

        var service = {
        	getDocumentParameterDefinitions: getDocumentParameterDefinitions,
            getAllDocumentParameterDefinitionsForClient: getAllDocumentParameterDefinitionsForClient,
        	getDopadeTypes: getDopadeTypes,
        	add: add,
        	edit: edit,
        	getForm: getForm,
        	remove: remove,
        	removeMultiple: removeMultiple
		}

        return service;

        function getDocumentParameterDefinitions(obj) {
        	return $http.post('/api/document-parameter-definitions/list', obj).then(
        			function (response) {
        				return response.data;
        			},
        			function (errResponse) {
        				return $q.reject(errResponse);
        			});
        }

        function getAllDocumentParameterDefinitionsForClient(clientId) {
        	return $http.get('/api/document-parameter-definitions/client/' + clientId).then(
        			function (response) {
        				return response.data;
        			},
        			function (errResponse) {
        				return $q.reject(errResponse);
        			});
        }

        function getDopadeTypes(){
            return [
            	{id:0, label:$translate.instant("document.parameter.definitions.dopade-type.text")},
            	{id:1, label:$translate.instant("document.parameter.definitions.dopade-type.enum")}
            ]
        }

        function add(obj) {
            return $http.put('api/document-parameter-definitions', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function edit(obj) {
            return $http.post('api/document-parameter-definitions', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getForm(parameterId) {
            return $http.get('api/document-parameter-definitions/' + parameterId).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function remove(parameterId) {
            return $http.delete('api/document-parameter-definitions/' + parameterId).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function removeMultiple(obj) {
            return $http.post('/api/document-parameter-definitions/remove-multiple', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }

})();

(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('documentParameterDefinitionsSearchRequest', function () {

        function searchRequest() {
            this.pageNumber = 0;
            this.pageSize = 5;
            this.sortTab = '';
            this.search = {};
        }

        return searchRequest;
    });
})();
(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('documentParameterDefinitionsQueryRequest', function () {

        function queryRequest() {
            this.order = 'dopadeName';
            this.page = 1;
            this.limit = 5;
            this.search = {};
        }

        return queryRequest;
    });
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('ReportDocumentService', ReportDocumentService);

    ReportDocumentService.$inject = ['$http', '$q', '$window', '$translate', '$mdToast'];

    function ReportDocumentService($http, $q, $window, $translate, $mdToast) {

        var service = {
            plainText: plainText,
            getDocumentReport2018: getDocumentReport2018,
            prepareReportName: prepareReportName,
            getReport2017Pdf: getReport2017Pdf,
            getReport2020RedirectionUrl: getReport2020RedirectionUrl
        };

        return service;

        function prepareReportName(docuAuthor, version, reportExtension){
        	var reportPrefix = (version === 'short' ? $translate.instant("document.report.file.name.short") : $translate.instant("document.report.file.name.full"));
        	
        	var reportName = docuAuthor.replace( /[<>:"\/\\|?*]+/g, '' );
        	reportName = reportPrefix + '_' + reportName + reportExtension;
        	
        	return reportName;
        }
        
        function plainText(documentId, version, docuAuthor) {
            return $http({
                url : '/api/document/plainReport/' + documentId + '/' + version,
                method : "GET",
                data : [],
                headers : {
                   'Content-type' : 'application/json'
               },
               responseType : 'arraybuffer'
           })
            .then(
             function(success) {
                var blob = new Blob(
                  [ success.data ],
                  {
                     type: "text/html; encoding=UTF-8"
                 });

                var reportName = prepareReportName(docuAuthor, version, '.html');
                saveAs(blob, reportName);

            }, function(error) {
               $mdToast.show($mdToast.simple().textContent($translate.instant("global.messages.error.label")));
           });
        }
        
        function getDocumentReport2018(documentId, reportType, docuAuthor) {
            return $http({
                url : '/api/document/report/html/' + reportType + '/' + documentId,
                method : "GET",
                data : [],
                headers : {
                   'Content-type' : 'application/json'
               },
               responseType : 'arraybuffer'
           })
            .then(
             function(success) {
                var blob = new Blob(
                  [ success.data ],
                  {
                     type: "text/html; encoding=UTF-8"
                 });

                var reportName = prepareReportName(docuAuthor, reportType, '.html');
                saveAs(blob, reportName);

            }, function() {
               $mdToast.show($mdToast.simple().textContent($translate.instant("global.messages.error.label")));
           });
        }

        /**
         * Generates 2017 type getReport2017Pdf report
         *
         * @param documentId
         * @param reportType ('full' or 'short')
         * @param docAuthor
         * @returns {*}
         */
        function getReport2017Pdf(documentId, reportType, docAuthor) {
            var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            return $http({
                url : '/api/document/report/pdf/2017/' + reportType + '/' + documentId,
                method : "GET",
                params: { timezone: timezone },
                responseType : 'arraybuffer'
            }).then(
                function(success) {
                    onSuccess(success, docAuthor, reportType, '.pdf');
                }, function() {
                    showError();
                }
            );
        }

      function getReport2020RedirectionUrl(documentId) {
        return $http.get('/api/document/report/report-2020/' + documentId + '/redirection-url').then(
          function (response) {
            return response.data.data;
          },
          function (errResponse) {
            return $q.reject(errResponse);
          });
      }

        function onSuccess(success, docAuthor, reportType, reportExtension) {
            var blob = new Blob(
                [ success.data ],
                {
                    type: "text/pdf; encoding=UTF-8"
                });
            var reportName = prepareReportName(docAuthor, reportType, reportExtension);
            saveAs(blob, reportName);
        }

        function showError() {
            $mdToast.show($mdToast.simple().textContent($translate.instant("global.messages.error.label")));
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('OrppdService', OrppdService);

    OrppdService.$inject = ['$http', '$q'];

    function OrppdService($http, $q) {

        var service = {
            sendDocument: sendDocument,
            getOrppdForm: getOrppdForm,
            getAvailablePromotersAndReviewers: getAvailablePromotersAndReviewers,
            savePassword: savePassword,
            getPassword: getPassword,
            getCountriesDictionary: getCountriesDictionary,
            getDocumentTypeDictionary: getDocumentTypeDictionary
        };
        return service;

        function sendDocument(form) {
            return $http.post('api/send-to-orppd/', form).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getOrppdForm(docId) {
            return $http.get('api/orppd/form/' + docId).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getAvailablePromotersAndReviewers(docId) {
            return $http.get('api/orppd/form/' + docId + '/promoters-and-reviewers').then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function savePassword(password) {
            return $http.post('api/orppd/password?password=' + password).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getPassword() {
            return $http.get('api/orppd/password').then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getCountriesDictionary() {
            return $http.get('api/orppd/dictionary/countries').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getDocumentTypeDictionary() {
            return $http.get('api/orppd/dictionary/document-types').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('JsaReportService', JsaReportService);

    JsaReportService.$inject = ['$http', '$q', '$translate', '$mdToast'];

    function JsaReportService($http, $q, $translate, $mdToast) {

        return {
            acceptReport: acceptReport,
            getReport: getReport
        };

        function acceptReport(documentId) {
            return $http.post('/api/jsa/report/accept?documentId=' + documentId).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getReport(documentId, fullReport, docAuthor) {
            return $http({
                url : '/api/jsa/report/download?documentId=' + documentId + "&fullReport=" + fullReport,
                method : "GET",
                responseType : 'arraybuffer'
            }).then(
                function(success) {
                    var reportName = "JSA_";
                    reportName += docAuthor.replace( /[<>:"\/\\|?*]+/g, '' );
                    onSuccess(success, docAuthor, fullReport, '.pdf', reportName);
                }, function() {
                    showError();
                }
            );
        }

        function onSuccess(success, docAuthor, fullReport, reportExtension, reportName) {
            var blob = new Blob(
                [ success.data ],
                {
                    type: "text/pdf; encoding=UTF-8"
                });
            saveAs(blob, reportName + reportExtension);
        }

        function showError() {
            $mdToast.show($mdToast.simple().textContent($translate.instant("global.messages.error.label")));
        }

    }
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('DocumentService', DocumentService);

    DocumentService.$inject = ['$http', '$q', 'AccountService'];

    function DocumentService($http, $q, AccountService) {

        var service = {
            removeMassDocuments:removeMassDocuments,
            indexAddToDatabase:indexAddToDatabase,
            indexRejectFromDatabase:indexRejectFromDatabase,
            searchUser: null,
            uploadFile: uploadFile,
            uploadMultipleFiles: uploadMultipleFiles,
            uploadText: uploadText,
            save: save,
            searchSimilar: searchSimilar,
            check: check,
            addPriority: addPriority,
            addPriorityFromContract: addPriorityFromContract,
            get: get,
            checkDocumentStatuses: checkDocumentStatuses,
            getDocumentFile: getDocumentFile,
            getRoleOperator: get,
            simpleSearch: simpleSearch,
            getTest: getTest,
            getDocument: getDocument,
            getDocumentAvailableExtension: getDocumentAvailableExtension,
            remove: remove,
            getDetails: getDetails,
            getDetailsForOperator: getDetailsForOperator,
            getMetadataForm: getMetadataForm,
            getDocumentHistory: getDocumentHistory,
            checkIfDocumentCreatedByIndividual: checkIfDocumentCreatedByIndividual,
            getCheckId: getCheckId,
            getDocumentStatus: getDocumentStatus,
            getLanguages: getLanguages,
            isWaitingPayment: isWaitingPayment,
            documentDetailsObj: {},
            isUploaded: false,
            document: {
                id: null
            },
            uploadedData: {},
            editDetails: editDetails,
            operator: {
                removeFromDatabase: removeFromDatabase,
                addToDatabase: addToDatabase,
                withdrawFromDatabase:withdrawFromDatabase,
                rejectFromDatabase:rejectFromDatabase,
                restoreFromDatabase:restoreFromDatabase,
                save: operatorSave,
                searchSimilar: operatorSearchSimilar,
                getConfiguration: operatorGetConfiguration,
                getConfigurationOffChecking: operatorGetConfigurationOffChecking,
                uploadFile: uploadFile,
                uploadMultipleFiles: uploadMultipleFiles,
                uploadText: uploadText,
                checkDocument: checkDocument,
                checkDocumentAgain: checkDocumentAgain,
                recheckAiDetection: recheckAiDetection,
                sendReport: sendReport,
                checkDocumentAiLimitReached: checkDocumentAiLimitReached
            },
            student: {
                get: get,
                simpleSearch: simpleSearch
            },
            lecturer: {
                get: get,
                addToDatabase: addToDatabase,
                removeFromDatabase: removeFromDatabase,
                withdrawFromDatabase:withdrawFromDatabase,
                rejectFromDatabase:rejectFromDatabase,
                restoreFromDatabase:restoreFromDatabase,
                save: lecturerSave,
                getConfiguration: operatorGetConfiguration,
                getConfigurationOffChecking: operatorGetConfigurationOffChecking,
                uploadFile: uploadFile,
                uploadMultipleFiles: uploadMultipleFiles,
                uploadText: uploadText
            },
            universal: {
                get: get,
                addToDatabase: addToDatabase,
                removeFromDatabase: removeFromDatabase,
                withdrawFromDatabase:withdrawFromDatabase,
                rejectFromDatabase:rejectFromDatabase,
                restoreFromDatabase:restoreFromDatabase,
                save: universalSave,
                getConfiguration: universalGetFormConfiguration,
                getConfigurationOffChecking: universalGetFormConfigurationOffChecking,
                uploadFile: uploadFile,
                uploadText: uploadText
            },
            admin: {
                adminRemoveDocuments: adminRemoveDocuments
            }
		};

        return service;

        function simpleSearch(obj) {
            return $http.post('/api/documents/search', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function removeMassDocuments(ids, searchRequest, all) {
            if (AccountService.role.isIndividual()) {
                return all ? individualSearchAndRemoveDocuments(searchRequest) : individualRemoveDocuments(ids);
            }
            if (AccountService.role.isAdmin()) {
                return all ? universalSearchAndRemoveDocuments(searchRequest) : adminRemoveDocuments(ids);
            }
            if (AccountService.role.isLecturer()) {
                return individualRemoveDocuments(ids);
            }
        }

        function indexAddToDatabase(ids, searchRequest, all) {
               return all ? searchAndAddToDatabase(searchRequest) : addToDatabase(ids);
        }

        function indexRejectFromDatabase(ids, searchRequest, all) {
               return all ? searchAndRejectFromDatabase(searchRequest) : rejectFromDatabase(ids);
        }

        function restoreFromDatabase(obj) {
            return $http.put('api/universal/document/index/restore', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function rejectFromDatabase(obj) {
            return $http.put('api/universal/document/index/reject', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function searchAndRejectFromDatabase(obj) {
            return $http.put('api/universal/document/search/index/reject', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function addToDatabase(obj) {
            return $http.put('api/universal/document/index/add', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function searchAndAddToDatabase(obj) {
            return $http.put('api/universal/document/search/index/add', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function removeFromDatabase(obj) {
            return $http.put('api/universal/document/index/remove', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function withdrawFromDatabase(obj) {
            return $http.put('api/universal/document/index/withdraw', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function uploadFile(obj, filename) {
            var request = {
                headers: {
                    'Content-Type': undefined,
                    'Charset': 'UTF-8'
                }
            };
            filename = encodeURIComponent(filename);
            return $http.post('api/document/upload-file?filename=' + filename, obj, request).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function universalGetFormConfigurationOffChecking(){
            return $http.get('/api/universal/document/upload-fields-information-for-adding-without-checking').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function operatorGetConfigurationOffChecking(){
            return $http.get('/api/operator/document/upload-fields-information-for-adding-without-checking').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getDocumentFile(documentId){
            return $http.get('/api/document/file/' + documentId).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function universalGetFormConfiguration(){
            return $http.get('/api/universal/document/upload-fields-information').then(
                function (response) {
                	initDocumentSkipAddresses(response.data);
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function operatorGetConfiguration(documentId){
        	var url = '/api/operator/document/upload-fields-information';
        	if(documentId){
        		url += '?documentId=' + documentId;
        	}
            return $http.get(url).then(
                function (response) {
                	initDocumentSkipAddresses(response.data);
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function initDocumentSkipAddresses(responseData){
        	 if(responseData && responseData.data && responseData.data.documentSkipAddresses==null){
        		 responseData.data.documentSkipAddresses = [];
             }
        }

        function lecturerSave(obj){
            return $http.post('api/lecturer/document/save', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function operatorSave(obj) {
            return $http.post('api/operator/document/save', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function operatorSearchSimilar(obj) {
            return $http.post('api/operator/document/similiar/search', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function uploadFile(obj, filename) {
            var request = {
                headers: {
                    'Content-Type': undefined,
                    'Charset': 'UTF-8'
                }
            };
            filename = encodeURIComponent(filename);
            return $http.post('api/document/upload-file?filename=' + filename, obj, request).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function uploadMultipleFiles(obj, filename) {
            var request = {
                headers: {
                    'Content-Type': undefined,
                    'Charset': 'UTF-8'
                }
            };
            return $http.post('api/document/upload-multiple-files?filename=' + filename, obj, request).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function uploadText(obj) {
            return $http.post('api/document/upload-text', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function save(obj) {
            return $http.post('api/document/save', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function searchSimilar(obj) {
            return $http.post('api/document/searchForSimilar', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function universalSave(obj) {
            return $http.post('api/universal/document/save', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function editDetails(obj) {
            return $http.post('api/document', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function check(obj) {
            return $http.post('api/document/check', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function addPriority(documentId) {
            return $http.post('api/document/' + documentId + '/add-priority').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function addPriorityFromContract(documentId) {
            return $http.post('api/document/' + documentId + '/add-priority-from-contract').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function get(obj) {
            return $http.post('/api/documents', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function checkDocumentStatuses(obj) {
            return $http.post('/api/documents/statuses', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getDetails(id) {
            return $http.get('/api/document/details/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getDetailsForOperator(id) {
            return $http.get('/api/operator/document/details/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getMetadataForm(id) {
            return $http.get('/api/operator/document/metadata-form/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getDocument(id) {
            return $http.get('/api/document?documentId=' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getDocumentAvailableExtension() {
            return $http.get('api/document/available-upload-file-extensions').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getTest(obj) {
            return $http.get('/api/documentsTest').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function remove(obj) {
            return $http.delete('/api/document/' + obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function individualRemoveDocuments(obj) {
            return $http.post('/api/documents/remove', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function individualSearchAndRemoveDocuments(obj) {
            return $http.post('/api/documents/search/remove', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function universalSearchAndRemoveDocuments(obj) {
            return $http.post('/api/universal/documents/search/remove', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function adminRemoveDocuments(obj) {
            return $http.post('/api/admin/documents/remove', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        var success =  function (response) {
            return response.data;
        }

        function getDocumentHistory(documentId) {
            return $http.get('/api/document-history?documentId=' + documentId).then(
                    function (response) {
                        return response.data;
                    },
                    function (errResponse) {
                        return $q.reject(errResponse);
                    });
        }

        function checkIfDocumentCreatedByIndividual(documentId) {
            return $http.get('api/document/created-by-individual/' + documentId).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getCheckId(documentId, currency) {
            return $http.get('api/document/check-id?documentId=' + documentId + "&currency=" + currency).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getDocumentStatus(documentId) {
            return $http.get('api/document/' + documentId + '/status').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function checkDocument(documentId, codeId) {
            var url = 'api/operator/document/check/' + documentId;
            if (codeId) {
                url = url + '?codeId=' + codeId;
            }
            return $http.post(url).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function checkDocumentAgain(documentId) {
            return $http.post('api/operator/document/check-again/' + documentId).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function recheckAiDetection(documentId) {
            return $http.post('api/operator/document/recheck-ai-detection/' + documentId).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function sendReport(documentId) {
            return $http.post('api/operator/document/send-report/' + documentId).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getLanguages() {
            return $http.get('api/dictionaries/language/uploadDocument').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function isWaitingPayment(documentId) {
            return $http.get('api/document/' + documentId + '/isWaitingPayment').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function checkDocumentAiLimitReached(docuAuthor) {
            return $http.get('/api/document/aiLimitReached?docuAuthor=' + docuAuthor).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('DocumentIndividualService', DocumentIndividualService);

    DocumentIndividualService.$inject = ['$http', '$q'];

    function DocumentIndividualService($http, $q) {

        var service = {
            getForm: getForm,
            editDetails: editDetails
		};
        
        return service;

        function getForm(id) {
            return $http.get('/api/individual/document/form/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
        
        function editDetails(obj) {
            return $http.post('api/individual/document', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }

})();

(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('tableSettingsRequest', function () {

        function tableSettingsRequest() {
            this.rowSelection = true;
            this.multiSelect = true;
            this.autoSelect = true;
            this.decapitate = false;
            this.largeEditDialog = false;
            this.boundaryLinks = false;
            this.limitSelect = false;
            this.pageSelect = true;
        }

        return tableSettingsRequest;
    });
})();
(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('searchRequest', function () {

        function searchRequest() {
            this.pageNumber = 0;
            this.pageSize = 5;
            this.sortTab = '';
            this.showOnlyForUser = true;
            this.search = {};
        }

        return searchRequest;
    });
})();
(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('queryRequest', function () {

        function queryRequest() {
            this.order = '-docuSubmitDate';
            this.page = 1;
            this.limit = 5;
            this.fixedHeader = 30;
            this.search = {};
        }

        return queryRequest;
    });
})();

(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('documentsSearchIndividualRequest', function () {

        function documentsSearchIndividualRequest() {
            this.simpleSearch = '';
            this.docuTitle = '';
            this.docuStatus = '';
            this.docuSimilarityFactorFrom = '';
            this.docuSimilarityFactorTo = '';
            this.docuSimilarityFactorExtFrom = '';
            this.docuSimilarityFactorExtTo = '';
            this.author = '';
            this.alert = '';
            this.docuSubmitDateFrom = null;
            this.docuSubmitDateTo = null;
        }

        return documentsSearchIndividualRequest;
    });
})();

(function () {
    'use strict';

    angular.module('DocumentsRequestModel', [])
    .factory('DocumentsRequest', function () {

        function DocumentsRequest() {
            this.documentId = '',
            this.docuTitle = '';
            this.tokensNeeded = '';
            this.docuAuthor = '';
            this.docuSubmitDate = '';
            this.docuSimilarityFactor = '';
            this.docuSimilarityFactorExt = '';
            this.docuStatus = '';
        }

        return DocumentsRequest;
    });
})();

(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('DocumentSearchRequestModel', function () {

        function DocumentSearchRequestModel() {
            this.docuTitle = null;
            this.docuStatus = null;
            this.showOnlyForUser = false;
            this.docuCoordinator = null;
            this.docuKind = null;
            this.docuExtraOptions = null;
            this.simpleSearch = '';
            this.searchUser = null;
            this.organisationalUnit = null;
            this.role = null;
            this.docuStatus = '';
            this.docuSimilarityFactorFrom = '';
            this.docuSimilarityFactorTo = '';
            this.docuSimilarityFactorExtFrom = '';
            this.docuSimilarityFactorExtTo = '';
            this.aiType = null;
            this.author = '';
            this.alert = '';
            this.docuSubmitDateFrom = null;
            this.docuSubmitDateTo = null;
            this.orppdStatus = null;
            this.checkingType = null;
            this.assignmentId = null;
        }

        return DocumentSearchRequestModel;
    });
})();

(function () {
    'use strict';

    angular.module('DocumentRequestModel', [])
    .factory('DocumentRequest', function () {

        function DocumentRequest() {
            this.fileId = '';
            this.title = '';
            this.author = '';
        
        }

        return DocumentRequest;
    });
})();

(function() {
    'use strict';

    angular
            .module('plagiat2017App')
            .factory('DocumentErrors', DocumentErrors);

    DocumentErrors.$inject = ['$translate'];

    function DocumentErrors($translate) {

        var documentsArr = [];
        documentsArr['wrongpassword'] = $translate.instant("global.messages.error.wrongpassword");
        documentsArr['wrongtype'] = $translate.instant("global.messages.error.wrongtype");
        documentsArr['maxSize'] = $translate.instant("global.messages.error.max-size");
        documentsArr['emptydocument'] = $translate.instant("global.messages.error.emptydocument");
        documentsArr['converterConnectionRefused'] = $translate.instant("global.messages.error.converter-connection-refused");

        var models = {
            document: documentsArr
        };
        return models;

    }


})();

// (function () {
//     'use strict';

//     angular.module('plagiat2017App')
//     .service('DocumentErrors', function () {

//         function DocumentErrors($translate) {
//             this.document = [];
//             this.document['wrongtype'] = $translate.instant("global.messages.error.wrongtype");
// 			this.document['maxSize'] = $translate.instant("global.messages.error.max-size");
// 	        this.document['emptydocument'] = $translate.instant("global.messages.error.emptydocument");
// 	        this.document['converterConnectionRefused'] = $translate.instant("global.messages.error.converter-connection-refused");
//
//         }

//         return DocumentErrors;
//     });
// })();


(function () {
    'use strict';

    angular.module('documentDetailsRequestModel', [])
    .factory('documentDetailsRequest', function () {

        function documentDetailsRequest() {
            this.simpleSearch = '';
            this.docuTitle = '';
            this.docuStatus = '';
        }

        return documentDetailsRequest;
    });
})();

(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('DocumentClientModel', function () {

        function DocumentClientModelRequest() {
            this.title = '';
            this.authors = [
                { firstName: '', lastName: '', index: ''  }
                ];
            this.promoter = {
                title: 'Tytuł promotora',
                firstname: 'Imię promotora',
                surname: 'Nazwisko promotora'
            };
            this.documentKindId = 'Rodzaj dokumentu';
            this.orgUnitId = 'Jednostka organizacyjna';
            this.documentParameters = [
                { name: 'Kierunek', value: ['Zarządzanie', 'Ekonomia', 'Prawo'] },
                { name: 'Pole do wpisania', value: 'Wpisz coś' }
                ];
        }

        return DocumentClientModelRequest;
    });
})();
(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('DatabaseExchangeProgramMembersSearchRequest', function () {

        function DatabaseExchangeProgramMembersSearchRequest() {
            this.clieName = '';
            this.id = '';
            this.type = '';
            this.status = '';
        }

        return DatabaseExchangeProgramMembersSearchRequest;
    });
})();
(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('DatabaseExchangeProgramMembersQueryRequest', function () {

        function DatabaseExchangeProgramMembersQueryRequest() {
            this.order = 'clieName';
            this.page = 1;
            this.limit = 5;
        }

        return DatabaseExchangeProgramMembersQueryRequest;
    });
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('SearchService', SearchService);

    SearchService.$inject = ['$http', '$q'];

    function SearchService($http, $q) {


        var service = {
        	sort: sort,
        	getSomething: 7
        };

        return service;

        function sort(queryRequest) {
            var reverse = queryRequest.order.slice(0, 1);
            var _length = queryRequest.order.length;
            var predicate;
            if (reverse === '-') {
                predicate = queryRequest.order.slice(1, _length);
                reverse = false;
            } else {
                predicate = queryRequest.order;
                reverse = true;
            }
            var result = [predicate + ',' + (reverse ? 'asc' : 'desc')];
            if (predicate !== 'id') {
                result.push('id');
            }
            return result;
         }

    }


})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('ScrollService', ScrollService);

    ScrollService.$inject = ['$location', '$anchorScroll'];

    function ScrollService($location, $anchorScroll) {


        var service = {
        	scrollTo: scrollTo
        };

        return service;

        function scrollTo(id) {
           $location.hash(id);
           $anchorScroll();
        }

    }


})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('PlagiatValidationService', PlagiatValidationService);

    PlagiatValidationService.$inject = ['$log', 'PLAGIAT_VALIDATIONS_CODES', '$translate', '_', '$mdDialog', '$state'];

    function PlagiatValidationService($log, PLAGIAT_VALIDATIONS_CODES, $translate, _, $mdDialog, $state) {
        var vm = this;
        var service = {
            getModalError: getModalError,
            getTextError: getTextError,
            getTranslationKeyError: getTranslationKeyError,
            getError: getError,
            getModalErrorDefault: getModalErrorDefault
        };

        return service;

        function lowercase(string) {
            return angular.isString(string) ? string.toLowerCase() : string;
        }

        function getModalError(response, optionalTitle, optionalRedirectionLink, multiple){
            vm.translationKey = 'global.messages.error.error';
            if( response && response.code !== '' ) {
                vm.code = _.filter(PLAGIAT_VALIDATIONS_CODES, function(o) { return lowercase(o.code).indexOf(lowercase(response.code)) !== -1; });
                vm.translationKey = ( vm.code.length > 0 && angular.isDefined(vm.code[0].translationCode) && vm.code[0].translationCode !== '' ) ? vm.code[0].translationCode : 'global.messages.error.error';
            }
            vm.data = '';
            if (response.data){
            	vm.data = '</br>' + formatResponseData(response.data);
            }

            if(!multiple) {
                multiple = false;
            }
            
            vm.title = (optionalTitle || optionalTitle == '') ? optionalTitle : $translate.instant("global.messages.error.label");

            $mdDialog.show(
                $mdDialog.alert()
                    .multiple(multiple)
                    .ok('OK')
                    .clickOutsideToClose(true)
                    .title(vm.title)
                    .htmlContent($translate.instant(vm.translationKey) + vm.data)
                    .ariaLabel('ok')
            ).then(function () {
                if (optionalRedirectionLink) {
                    $state.go(optionalRedirectionLink);
                }
            }, function () {
                if (optionalRedirectionLink) {
                    $state.go(optionalRedirectionLink);
                }
            });
        }

        function formatResponseData(responseData) {
            try {
                return JSON.stringify(responseData);
            } catch (e) {
                return responseData;
            }
        }

        function getTextError(code){
            vm.translationKey = 'global.messages.error.error';
            if( code !== '' ) {
                vm.code = _.filter(PLAGIAT_VALIDATIONS_CODES, function(o) { return lowercase(o.code).indexOf(lowercase(code)) !== -1; });
                vm.translationKey = ( vm.code.length > 0 && angular.isDefined(vm.code[0].translationCode) && vm.code[0].translationCode !== '' ) ? vm.code[0].translationCode : 'global.messages.error.error';
            }
            $log.error($translate.instant(vm.translationKey));
            return $translate.instant(vm.translationKey);
        }
        
        function getTranslationKeyError(code){
            vm.translationKey = 'global.messages.error.error';
            if( code !== '' ) {
                vm.code = _.filter(PLAGIAT_VALIDATIONS_CODES, function(o) { return lowercase(o.code).indexOf(lowercase(code)) !== -1; });
                vm.translationKey = ( vm.code.length > 0 && angular.isDefined(vm.code[0].translationCode) && vm.code[0].translationCode !== '' ) ? vm.code[0].translationCode : 'global.messages.error.error';
            }
            return vm.translationKey;
        }

        function getError(){
            $log.error($translate.instant("global.messages.error.error"));
            return $translate.instant("global.messages.error.error");
        }
        
        function getModalErrorDefault() {
            $mdDialog.show(
                $mdDialog.alert()
                .clickOutsideToClose(true)
                .title($translate.instant("global.messages.error.label"))
                .textContent($translate.instant("global.messages.error.label"))
                .ariaLabel('ok')
                .ok('OK')
                );
        }

    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('LandingService', LandingService);

    LandingService.$inject = ['$http', '$q'];

    function LandingService($http, $q) {


        var service = {
            registerAndLogin: registerAndLogin,
            addDocumentFromLanding: addDocumentFromLanding,
            uploadFile: uploadFile,
            getTokenPriceList: getTokenPriceList,
            getSingleTokenPrince: getSingleTokenPrince,
            getAvailableFileExtensions: getAvailableFileExtensions
        };

        return service;

        function registerAndLogin(obj) {
            return $http.post('api/landing-page/register-and-login-user', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getTokenPriceList() {
            return $http.get('api/landing-page/tokens-pricelist').then(
              function (response) {
                  return response.data;
              },
              function (errResponse) {
                  return $q.reject(errResponse);
              });
        }

        function getSingleTokenPrince(currency, paymentType) {
            return $http.get('api/landing-page/single-token-price?currency=' + currency + '&paymentType=' + paymentType).then(
              function (response) {
                  return response.data;
              },
              function (errResponse) {
                  return $q.reject(errResponse);
              });
        }

        function getAvailableFileExtensions() {
            return $http.get('api/landing-page/available-file-extensions').then(
              function (response) {
                  return response.data;
              },
              function (errResponse) {
                  return $q.reject(errResponse);
              });
        }

        function addDocumentFromLanding(fileId, extraOptions, currency, paymentType, autoTranslation, invoiceData) {
            var url = 'api/landing-page/add-document/?fileId=' + fileId + '&extraOptions=' + extraOptions + '&currency=' + currency + '&paymentType=' + paymentType;
            if (autoTranslation !== null && autoTranslation.chosen) {
                url = url + '&autoTranslationTo=' + autoTranslation.autoTranslationsToLang;
            }
            if (invoiceData) {
                return $http.post(url, invoiceData)
                    .then(
                        function (response) {
                            return response.data;
                        },
                        function (errResponse) {
                            return $q.reject(errResponse);
                        });
            } else {
                return $http.post(url)
                    .then(
                        function (response) {
                            return response.data;
                        },
                        function (errResponse) {
                            return $q.reject(errResponse);
                        });
            }
        }

        function uploadFile(obj, fileName) {
            fileName = encodeURIComponent(fileName);
            var request = {
                method: 'POST',
                url: 'api/landing-page/upload-file?fileName=' + fileName,
                data: obj,
                headers: {
                    'Content-Type': undefined,
                    'Charset': 'UTF-8'
                }
            };
            return $http(request).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('InfoService', InfoService);

    InfoService.$inject = ['$http', '$q', '$log'];

    function InfoService($http, $q, $log) {


        var service = {
            sendForm: sendForm,
            getAdmins: getAdmins,
            dontAccept: dontAcceptIodoDataProcessing,
            getIodoCompanies:getIodoCompanies,
            operator: {
                sendForm: operatorSendForm
            }
        };

        return service;

        function dontAcceptIodoDataProcessing(obj){
            var request = {
                method: 'POST',
                url: 'api/iodo/dont-accept',
                data: obj,
                headers: {
                    'Content-Type': undefined,
                    'Charset': 'UTF-8'
                }
            };
            return $http(request).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getAdmins(){
            return $http.get('/api/account-admins').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getIodoCompanies(lang){
            return $http.get('/api/iodo/companies/' + lang).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function operatorSendForm(obj){
            var request = {
                method: 'POST',
                url: 'api/operator/contact-form',
                data: obj,
                headers: {
                    'Content-Type': undefined,
                    'Charset': 'UTF-8'
                }
            };
            return $http(request).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function sendForm(obj) {
            var request = {
                method: 'POST',
                url: 'api/contact-form',
                data: obj,
                headers: {
                    'Content-Type': undefined,
                    'Charset': 'UTF-8'
                }
            };
            return $http(request).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }



})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('GoogleAdWordsService', GoogleAdWordsService);

    GoogleAdWordsService.$inject = ['$http', '$q', '$log'];

    function GoogleAdWordsService($http, $q, $log) {

        return {
            sendRegisterCustomerConversion: function () {
                // Trigger register-customer conversion 
                googleTrackConversion('register-customer');
            },
            sendBookOrderConversion: function () {
                  // Trigger book-order conversion 
                googleTrackConversion('book-order');
            },
            loadJavaScript: loadJavaScript
        };

        // Conversion labels 
        var google_conversion_label = {
            'register-customer': "12abCDef3gH5Klm6789",
            'book-order': "9876mlK5Hg3feDCba21"
        };
       // Basic settings for AdWords Conversion
        var googleTrackConversion = function (conversion_label) {
            $window.google_trackConversion({

            });
        };

        function loadJavaScript(filePath)
        {
            var headElement = document.getElementsByTagName("head")[0];
            var newScriptElement = document.createElement("script");
            newScriptElement.type = "text/javascript";
            newScriptElement.src = filePath;
            headElement.appendChild(newScriptElement);
        }
        
        


    }



})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('DuplicatesDialogService', DuplicatesDialogService);

    DuplicatesDialogService.$inject = ['DocumentService', 'JsaService', 'ContractService', 'PlagiatValidationService',
                                       '$q', '$translate', '$mdDialog', '$mdToast', '$rootScope'];


    function DuplicatesDialogService(DocumentService, JsaService, ContractService, PlagiatValidationService,
                                     $q, $translate, $mdDialog, $mdToast, $rootScope) {
        var vm = this;
        var service = {
            saveDocumentWithPopUp: saveDocumentWithPopUp,
            saveJSADocumentWithPopUp: saveJSADocumentWithPopUp,
        };

        return service;

        function saveDocumentWithPopUp(obj,ev, callbackFunction) {
            return DocumentService.operator.save(obj).then(function (responseData) {
                var deferred = $q.defer();
                $mdDialog.hide();
                $mdDialog.show(
                    $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .title('')
                        .textContent($translate.instant("global.messages.info.actionsuccess"))
                        .ariaLabel('')
                        .ok('Ok')
                        .targetEvent(ev)
                );
                ContractService.broadcast();
                $rootScope.$broadcast('on-get-documents');
                if (callbackFunction) {
                    callbackFunction(responseData.data);
                }
                var documentId = responseData.data;
                deferred.resolve(documentId);
                return deferred.promise;
            }, function (errResponse) {
                return $q.reject(errResponse.data);
            }).catch(function (response) {
                vm.isLoading = false;
                PlagiatValidationService.getModalError(response.data);
            });
        }

        function saveJSADocumentWithPopUp(obj, alert) {
            JsaService.saveDocumentJSA(obj).then(function () {
                $mdDialog.hide(alert);
                $mdDialog.show(
                    $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .title('')
                        .textContent($translate.instant("global.messages.info.actionsuccess"))
                        .ok('Ok')
                );
                ContractService.broadcast();
                $rootScope.$broadcast('on-get-documents');
            }).catch(function (response) {
                $rootScope.$broadcast('on-get-documents');
                $mdDialog.hide(alert);
                vm.isLoading = false;
                PlagiatValidationService.getModalError(response.data);
            });
        }
    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('DateService', DateService);

    DateService.$inject = [];

    function DateService() {


        var service = {
        	fixDate: fixDate,
            fixDateDcouments: fixDateDcouments
        };

        return service;

        function fixDate(input, fieldName, vm) {
            if( input ){
                vm.onSearchRequest.search[fieldName] = moment(input.setDate(input.getDate())).format('YYYY-MM-DD');
            }
        }

        function fixDateDcouments(input, fieldName, vm) {
            if( input ){
                vm.documentsSearchRequest[fieldName] = moment(input.setDate(input.getDate())).format('YYYY-MM-DD');
            }
        }

    }


})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('BrowserService', BrowserService);

    BrowserService.$inject = [];

    function BrowserService() {


        var service = {
            isIeLowerThen12: isIeLowerThen12
        };

        return service;

        function isIeLowerThen12(){
        	var browserVersion = detectIE();
        	if (browserVersion === false) {
                return false;
            } else if (browserVersion >= 12) {
            	return false;
            } else {
                return true;
            }
        }

        function detectIE() {
		    var ua = window.navigator.userAgent;

		  // Test values; Uncomment to check result …

		  // IE 10
		  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
		  
		  // IE 11
		  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
		  
		  // Edge 12 (Spartan)
		  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
		  
		  // Edge 13
		  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

		    var msie = ua.indexOf('MSIE ');
		    if (msie > 0) {
		    // IE 10 or older => return version number
		        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
		    }

		    var trident = ua.indexOf('Trident/');
		    if (trident > 0) {
		    // IE 11 => return version number
		        var rv = ua.indexOf('rv:');
		        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
		    }

		    var edge = ua.indexOf('Edge/');
		    if (edge > 0) {
		    // Edge (IE 12+) => return version number
		        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
		    }

		  // other browser
		    return false;
		}


    }



})();

(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('TableSelectOptions', function () {

        function TableSelectOptions() {
            this.selectedNo = 0;
            this.selectedHelper = [];
            this.selectedAll = false;
            this.ids = [];
        }

        return TableSelectOptions;
    });
})();
(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('SearchRequest', function () {

        function SearchRequest() {
            this.pageNumber = 0;
            this.pageSize = 5;
            this.sortTab = [];
            this.showOnlyForUser = true;
            this.simpleSearch = '';
            this.search = {};
        }

        return SearchRequest;
    });
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/user/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', '$rootScope', '$sessionStorage', '$window', 'Account', 'AuthServerProvider', '$log', 'AccountService', 'ShowPopupService'];

    function Principal ($q, $rootScope, $sessionStorage, $window, Account, AuthServerProvider, $log, AccountService, ShowPopupService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            hasNotAuthority: hasNotAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        /**
         * Check if user HAS NOT given authority
         * @param authority
         * @returns {boolean}
         */
        function hasNotAuthority (authority) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            return _identity.authorities && _identity.authorities.indexOf(authority) === -1;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                $sessionStorage.role = account;
                $rootScope.$broadcast('userRoleIsSet');
                var authStateChanged = !AccountService.account || (AccountService.account.id !== account.data.id);
                AccountService.account = account.data;
                if (authStateChanged) {
                    ShowPopupService.action();
                }
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset-password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset-password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('isIndividual', isIndividual);

    isIndividual.$inject = ['Principal'];

    function isIndividual(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('isIndividual', isIndividual);

    isIndividual.$inject = ['Principal'];

    function isIndividual(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$q', '$localStorage', '$sessionStorage'];

    function AuthServerProvider ($http, $q, $localStorage, $sessionStorage) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            loginWithToken: loginWithToken,
            logout: logout,
            redirect: redirect
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function loginWithToken(jwt) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt) {
                $sessionStorage.authenticationToken = jwt;
        }

        function redirect (credentials, url) {
             $.redirect('https://' + url + '/api/redirect', {
                 j_username: credentials.username,
                 j_password: credentials.password,
                 'remember-me': credentials.rememberMe
             }, "POST");
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
            '&j_password=' + encodeURIComponent(credentials.password) +
            '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function (response) {
                return response;
            });
        }

        function logout () {
            // logout from the server
            $http.post('logout').then(function (response) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.role;
                // to get a new csrf token call the api
                $http.get('api/account');
                return {message:'Success'};
            },
            function (errResponse) {
                return $q.reject(errResponse);
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider',
        'Account', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'AccountService', '$log',
        'ActivateUserCreated', '$localStorage'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, Register,
                   Activate, Password, PasswordResetInit, PasswordResetFinish, AccountService, $log, ActivateUserCreated,
                   $localStorage) {
        var service = {
            activateAccount: activateAccount,
            activateAccountForCreatedUser: activateAccountForCreatedUser,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            loginWithToken:loginWithToken,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            getPasswordPattern: getPasswordPattern,
            redirect: redirect
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.post(key,
                function (response) {
                    return cb(response);
                }).$promise;
        }

        function activateAccountForCreatedUser(key, callback) {
            var cb = callback || angular.noop;

            return ActivateUserCreated.post(key,
                function (response) {
                    return cb(response);
                }).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                if ($rootScope.toState.parent === 'landing') {
                    if (($rootScope.toStateParams.key === 'facebook' || $rootScope.toStateParams.key === 'landing-sso') && $sessionStorage.landingPageFileId) {
                        return;
                    }
                }

                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && ($rootScope.toState.parent === 'landing' || $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'activate' || $rootScope.toState.name === 'activate' || $rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'requestReset' || $rootScope.toState.name === 'finishReset' ))) {
                    var ii = Principal.identity();
                    
                    if (AccountService.clientType && AccountService.clientType.isPap()) {
                        $state.go('portals');
                    } else {
                        $state.go('documents');
                    }
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0
                    && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)
                    && $rootScope.toState.data.authorities[0] !== 'open' && $rootScope.toState.data.authorities[0] !== 'ANY') {
                    if (isAuthenticated) {
                        if(!$localStorage.returnFromUser) {
                            // user is signed in but not authorized for desired state
                            $state.go('accessdenied');
                        } else {
                            $localStorage.returnFromUser = null;
                        }
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);
                        // now, send them to the signin state so they can log in
                        $state.go('login');
                    }
                }
                if ($rootScope.toState.data.authorities
                    && $rootScope.toState.data.authorities.length > 0
                    && $rootScope.toState.data.authorities[0] === 'ANY'
                    && !isAuthenticated) {
                    storePreviousState($rootScope.toState.name, $rootScope.toStateParams);
                    $state.go('login');
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function loginWithToken(jwt) {
            return AuthServerProvider.loginWithToken(jwt);
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
            AccountService.account.userAcceptsRegulations = true;
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }

        function getPasswordPattern(){
        	return new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/);
        }

        function redirect(credentials, url){
            AuthServerProvider.redirect(credentials, url);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ActivateUserCreated', ActivateUserCreated);

    ActivateUserCreated.$inject = ['$resource'];

    function ActivateUserCreated ($resource) {
        var service = $resource('api/user/confirm-registration-for-created-user', {}, {
            'post': { method: 'POST', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/user/confirm-registration', {}, {
            'post': { method: 'POST', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            get: { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response.data;
                    }
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular.module('UserRegisterRequestModel', [])
    .factory('UserRegisterRequest', function () {

        function UserRegisterRequest() {
            this.name = '';
            this.surname = '';
            this.email = '';
            this.password = '';
            this.confirmedPassword = '';
            this.acceptRegulations = false;
        
        }

        return UserRegisterRequest;
    });
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ApiKeysService', ApiKeysService);

    ApiKeysService.$inject = ['$http', '$q', 'ReportXlsService'];

    function ApiKeysService($http, $q, ReportXlsService) {

        var service = {
        	add: add,
            getApiKeys: getApiKeys,
            invalidate: invalidate,
            getDefaultExpiryDate: getDefaultExpiryDate,
            generateExcelFile: generateExcelFile,
            detailsObj: {}
        };

        return service;

        function getApiKeys(params) {
            return $http.post('/api/api-keys', params).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function invalidate(ids) {
            return $http.post('/api/api-keys/delete-multiple', ids).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function add(obj) {
            return $http.put('api/api-keys', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
        
        function getDefaultExpiryDate(params) {
            return $http.get('/api/api-keys/default-expiry-date', params).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function generateExcelFile(pickedId) {
            ReportXlsService.generateExcelFile(pickedId, '/api/api-keys/xls/client-data', 'api_key_client_data_');
        }

    }

})();

(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('apiKeysSearchRequest', function () {

        function searchRequest() {
            this.pageNumber = 0;
            this.pageSize = 5;
            this.sortTab = '';
            this.search = {};
        }

        return searchRequest;
    });
})();
(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('apiKeysQueryRequest', function () {

        function queryRequest() {
            this.order = '-createdAt';
            this.page = 1;
            this.limit = 5;
            this.search = {};
        }

        return queryRequest;
    });
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('AdminConfigurationService', AdminConfigurationService);

    AdminConfigurationService.$inject = ['$http', '$q'];

    function AdminConfigurationService($http, $q) {

        var requestUrl = 'api/client-setting';

        var service = {
            getAdminConfiguration: getAdminConfiguration,
            save: save,
		}

        return service;

        function getAdminConfiguration() {
            return $http.get(requestUrl + '/admin-configuration').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function save(obj) {
            return $http.post(requestUrl + '/save-admin-configuration', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('document-import', {
            parent: 'account',
            url: '/document-import',
            data: {
                authorities: [],
                pageTitle: 'global.menu.document-import'
            },
            views: {
                'content@': {
                    templateUrl: 'app/document-import/document-import.html',
                    controller: 'DocumentImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('document-import');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('DocumentImportService', DocumentImportService);

    DocumentImportService.$inject = ['$http', 'ModalService', '$translate'];

    function DocumentImportService($http, ModalService, $translate) {

        var service = {
            downloadMetadataTemplate: downloadMetadataTemplate,
            uploadMetadataFiles: uploadMetadataFiles,
            deleteFromImport: deleteFromImport,
            uploadDocumentFiles: uploadDocumentFiles,
            addDocuments: addDocuments
		};
        var requestUrl = '/api/document-import';
        return service;

        function uploadMetadataFiles(metadataFiles, importId) {
            var formData = new FormData();
            for (var metadataFileIdx in metadataFiles) {
                formData.append("files", metadataFiles[metadataFileIdx]);
            }
            if (importId) {
                formData.append("importId", importId);
            }
            var request = {
                transformRequest: angular.identity,
                transformResponse: angular.identity,
                headers: {'Content-Type': undefined, 'Accept': 'application/json'}
            };
            return $http.post(requestUrl + '/upload-metadata', formData, request).then(
                function (response) {
                    return JSON.parse(response.data).data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function uploadDocumentFiles(documentFiles, importId) {
            var formData = new FormData();
            for (var documentFileIdx in documentFiles) {
                formData.append("files", documentFiles[documentFileIdx]);
            }
            if (importId) {
                formData.append("importId", importId);
            }
            var request = {
                transformRequest: angular.identity,
                transformResponse: angular.identity,
                headers: {'Content-Type': undefined, 'Accept': 'application/json'}
            };
            return $http.post(requestUrl + '/upload-document-files', formData, request).then(
                function (response) {
                    return JSON.parse(response.data).data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function deleteFromImport(importId, fileName) {
            return $http.post(requestUrl + '/delete-from-import', {importId: importId, fileName: fileName}).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function addDocuments(importId, addWithoutChecking) {
            return $http.post(requestUrl + '/add-documents', {importId: importId, addWithoutChecking: addWithoutChecking}).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function downloadMetadataTemplate() {
            var templateName = $translate.instant('document.import.metadata.file.template.name');
            $http({
                url: requestUrl + '/metadata/template',
                method: "GET",
                responseType: 'arraybuffer'
            }).then(function (success) {
                var blob = new Blob([success.data], {
                    type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                saveAs(blob, templateName + '.xlsx');
            }, function (errorResponse) {
                ModalService.showErrorModal(errorResponse);
            });
        }
    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .controller('DocumentImportController', DocumentImportController);

    DocumentImportController.$inject = ['$q', 'DocumentImportService', 'DocumentKindService', 'OrganisationalUnitsService',
        'AccountService', 'DocumentService', 'ModalService', '$translate', 'PlagiatValidationService', 'LandingService'];

    function DocumentImportController($q, DocumentImportService, DocumentKindService, OrganisationalUnitsService,
                                      AccountService, DocumentService, ModalService, $translate, PlagiatValidationService, LandingService) {
        var vm = this;
        vm.downloadMetadataTemplate = DocumentImportService.downloadMetadataTemplate;
        vm.oldPhdYearColumn = AccountService.account.clientSettings.oldPhdCheckingYearField;
        vm.isSchool = AccountService.clientType.isSchool();
        vm.shouldShowImportedDocumentsList = shouldShowImportedDocumentsList;
        vm.uploadMetadataFiles = uploadMetadataFiles;
        vm.uploadDocumentFiles = uploadDocumentFiles;
        vm.deleteFromImport = deleteFromImport;
        vm.addDocuments = addDocuments;
        vm.getImportedDocumentStatusTooltip = getImportedDocumentStatusTooltip;
        vm.getImportedDocumentState = getImportedDocumentState;
        vm.canAddDocuments = canAddDocuments;

        vm.availableMetadataFileExtensions = '.xls,.xlsx';
        vm.availableDocumentFileExtensions = null;
        vm.documentImportState = {importId: null, importedDocuments: []};
        vm.addWithoutChecking = false;
        vm.documentKindById = {};
        vm.organisationalUnitById = {};
        vm.importedDocumentState = {
            VALIDATION_ERRORS: 'validation-errors',
            READY: 'ready',
            ADDING_ERROR: 'document-adding-error',
            ADDED: 'added'
        };

        this.$onInit = function () {
            DocumentKindService.findAll().then(function (response) {
                    var documentKindList = response.data;
                    for (var documentKindIdx in documentKindList) {
                        var documentKind = documentKindList[documentKindIdx];
                        vm.documentKindById[documentKind.id] = documentKind;
                    }
                }
            );
            OrganisationalUnitsService.getSimpleForCurrentClient().then(function (organisationalUnitList) {
                for (var organisationalUnitIdx in organisationalUnitList) {
                    var organisationalUnit = organisationalUnitList[organisationalUnitIdx];
                    vm.organisationalUnitById[organisationalUnit.id] = organisationalUnit;
                }
            });
            DocumentService.getDocumentAvailableExtension().then(function (result) {
                vm.availableDocumentFileExtensions = '.zip';
                if (result.data.length === 0) {
                    LandingService.getAvailableFileExtensions().then(function (extensions) {
                        vm.availableDocumentFileExtensions += "," + extensions.data;
                    });
                } else {
                    angular.forEach(result.data, function (value) {
                        vm.availableDocumentFileExtensions += ',.' + value;
                    });
                }
            });
        };

        function uploadMetadataFiles(files) {
            if (files.length === 0) {
                return;
            }
            vm.isLoading = true;
            DocumentImportService.uploadMetadataFiles(files, vm.documentImportState.importId)
                .then(function (documentImportState) {
                        vm.documentImportState = documentImportState;
                        vm.isLoading = false;
                    },
                    function (error) {
                        vm.isLoading = false;
                        ModalService.showErrorModal(error);
                    })
        }

        function uploadDocumentFiles(files) {
            if (files.length === 0) {
                return;
            }
            vm.isLoading = true;
            ModalService.showDialogModal('document-import.files.upload.be-patient');
            DocumentImportService.uploadDocumentFiles(files, vm.documentImportState.importId)
                .then(function (documentImportState) {
                        vm.documentImportState = documentImportState;
                        vm.isLoading = false;
                        ModalService.showSuccessModal('document-import.files.upload.complete')
                    },
                    function (error) {
                        vm.isLoading = false;
                        ModalService.showErrorModal(error);
                    });

        }

        function deleteFromImport(filename) {
            ModalService.showConfirmModal('document-import.files.delete.confirm').then(
                function () {
                    vm.isLoading = true;
                    DocumentImportService.deleteFromImport(vm.documentImportState.importId, filename)
                        .then(function (documentImportState) {
                            vm.documentImportState = documentImportState;
                            vm.isLoading = false;
                        });
                },
                function (error) {
                    vm.isLoading = false;
                    ModalService.showErrorModal(error);
                }
            );
        }

        function addDocuments() {
            if (!vm.canAddDocuments()) {
                ModalService.showDialogModal('document-import.add-documents.no-documents-ready-to-be-added');
                return;
            }
            ModalService.showConfirmModal('document-import.add-documents.confirm').then(
                function () {
                    vm.isLoading = true;
                    DocumentImportService.addDocuments(vm.documentImportState.importId, vm.addWithoutChecking)
                        .then(function (documentImportState) {
                            vm.documentImportState = documentImportState;
                            vm.isLoading = false;
                            ModalService.showDialogModal('document-import.add-documents.finished')
                        });
                },
                function (error) {
                    vm.isLoading = false;
                    ModalService.showErrorModal(error);
                }
            );
        }

        function shouldShowImportedDocumentsList() {
            return vm.documentImportState.importedDocuments.length !== 0;
        }

        function getImportedDocumentStatusTooltip(importedDocument) {
            if (getImportedDocumentState(importedDocument) === vm.importedDocumentState.VALIDATION_ERRORS) {
                var result = '';
                for (var validationErrorCodeIndex in importedDocument.validationErrorCodes) {
                    var errorCode = importedDocument.validationErrorCodes[validationErrorCodeIndex];
                    result += $translate.instant(PlagiatValidationService.getTranslationKeyError(errorCode)) + '<br/>';
                }
                return result;
            } else if (getImportedDocumentState(importedDocument) === vm.importedDocumentState.READY) {
                return $translate.instant('document-import.imported-document.ready-to-be-added');
            } else if (getImportedDocumentState(importedDocument) === vm.importedDocumentState.ADDING_ERROR) {
                return $translate.instant(PlagiatValidationService.getTranslationKeyError(importedDocument.addingErrorCode));
            } else {
                return $translate.instant('document-import.imported-document.added');
            }
        }

        function getImportedDocumentState(importedDocument) {
            if (importedDocument.validationErrorCodes.length > 0) {
                return vm.importedDocumentState.VALIDATION_ERRORS;
            } else if (importedDocument.addingErrorCode) {
                return vm.importedDocumentState.ADDING_ERROR;
            } else if (importedDocument.added) {
                return vm.importedDocumentState.ADDED;
            } else
                return vm.importedDocumentState.READY;
        }

        function canAddDocuments() {
            return vm.documentImportState.importedDocuments.findIndex(function (importedDocument) {
                return importedDocument.validationErrorCodes.length > 0 || importedDocument.added;
            }) === -1;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .constant('SSO_LOGIN_DATA', function () {
            var constant = {
                other: {id: 0, title: 'Plagiat.pl ADFS'},
                valencia: {id: 1, title: 'Universitat de València'},
                sdu: {id: 2, title: 'University of Southern Denmark, SDU'},
                tartu: {id: 3, title: 'University of Tartu'},
                tallinn: {id: 4, title: 'Tallinn University'},
                tusofia: {id: 5, title: 'TU Sofia'},
                taltech: {id: 6, title: 'Tallinna Tehnikaülikool'},
                unibit: {id: 7, title: 'unibit.bg'},
                tampere: {id: 8, title: 'Tampere Secondary Education'},
                valladolid: {id: 9, title: 'Universidad de Valladolid'},
                chevron: {id: 10, title: 'Chevron College'},
                ilmenau: {id: 11, title: 'Technische Universität Ilmenau'},
                jaen: {id: 12, title: 'Universidad de Jaén'},
                eah_jena_de: {id: 13, title: 'Ernst Abbe University of Applied Sciences Jena'},
                hochschule: {id: 14, title: 'Hochschule Nordhausen'},
                eesc: {id: 15, title: 'European Economic and Social Committee (EESC)'},
                eesc2: {id: 16, title: 'European Committee of the Regions (CoR)'},
                hepl: {id: 17, title: 'Haute Ecole de la Province de Liège (HEPL)'},
                lviv: {id: 18, title: 'Lviv State University of Life Safety'},
                gottingen: {id: 19, title: 'AcademicID'},
                bfg: {id: 20, title: 'BFG, Bezpieczny Bank'},
                castilla: {id: 21, title: 'Universidad de Castilla-La Mancha'},
                google: {id: 22, title: 'Google SSO'},
                googlelanding: {id: 23, title: 'Google SSO'},
                salta: {id: 24, title: 'Salta Group'},
                saxony: {id: 25, title: 'Duale Hochschule Sachsen'},
            };

            return constant;
        }())
})();

(function () {
    'use strict';

    var restrictingDatabases = [
        {id:0, num: 64, key: 'document.metric.restricting-databases.refbooks'},
        {id:1, num: 128, key: 'document.metric.restricting-databases.local-db'},
        {id:2, num: 256, key: 'document.metric.restricting-databases.dep'},
        {id:3, num: 512, key: 'document.metric.restricting-databases.internet'},
        {id:4, num: 1024, key: 'document.metric.restricting-databases.ukrnti'},
    ];

    angular
        .module('plagiat2017App')
        .constant('RESTRICTING_DATABASES', restrictingDatabases)
})();

(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .constant('PAYMENT_TYPE_CONSTANT', function() {
                var constant = {
                    PAYMENT_TYPE_SMS: {name: 'TYPE_SMS', id: 0, langKey : 'payments.payment.type.sms'},
                    PAYMENT_TYPE_TRANSFER: {name: 'TYPE_TRANSFER', id: 1, langKey : 'payments.payment.type.transfer'},
                    PAYMENT_TYPE_CREDIT_CARD: {name: 'TYPE_CREDIT_CARD', id: 2, langKey : 'payments.payment.type.credit.card'},
                    PAYMENT_TYPE_PAY_PAL: {name: 'TYPE_PAY_PAL', id: 3, langKey : 'payments.payment.type.pay.pal'},
                    PAYMENT_TYPE_MOBILPAY_SMS: {name: 'TYPE_MOBILPAY_SMS', id: 4, langKey : 'payments.payment.type.mobilpay.sms'},
                    PAYMENT_TYPE_MOBILPAY_CARD: {name: 'TYPE_MOBILPAY_CARD', id: 5, langKey : 'payments.payment.type.mobilpay.card'},
                    PAYMENT_TYPE_MILLIKART_CARD: {name: 'TYPE_MILLIKART_CARD', id: 6, langKey : 'payments.payment.type.millikart.card'},
                    PAYMENT_TYPE_EASY_PAY: {name: 'TYPE_EASY_PAY', id: 7, langKey : 'payments.payment.type.easy.pay'},
                    PAYMENT_TYPE_KASSA_24: {name: 'TYPE_KASSA_24', id: 8, langKey : 'payments.payment.type.kassa.24'},
                    PAYMENT_TYPE_BLIK: {name: 'TYPE_BLIK', id: 9, langKey : 'payments.payment.type.blik'},
                    PAYMENT_TYPE_CODE: {name: 'TYPE_CODE', id: 10, langKey : 'payments.payment.type.code'},
                    PAYMENT_TYPE_EASY_PAY_TERMINAL: {name: 'TYPE_EASY_PAY_TERMINAL', id: 11, langKey : 'payments.payment.type.easy.pay.terminal'},
                    PAYMENT_TYPE_KASSA_24_TERMINAL: {name: 'TYPE_KASSA_24_TERMINAL', id: 12, langKey : 'payments.payment.type.kassa.24.pay.terminal'},
                    PAYMENT_TYPE_MOBILTEK: {name: 'TYPE_MOBILTEK', id: 13, langKey : 'payments.payment.type.mobiltek'},
                    PAYMENT_TYPE_PAYME: {name: 'TYPE_PAYME', id: 14, langKey : 'payments.payment.type.payme'},
                    PAYMENT_TYPE_KASSA_24_CARD: {name: 'TYPE_KASSA_24_CARD', id: 15, langKey : 'payments.payment.type.kassa24card'},
                    PAYMENT_TYPE_YIGIM_AZ: {name: 'TYPE_YIGIM_AZ', id: 16, langKey : 'payments.payment.type.yigim'},
                    PAYMENT_TYPE_EPAY_BG: {name: 'TYPE_EPAY_BG', id: 17, langKey : 'payments.payment.type.epay.bg'},
                    PAYMENT_TYPE_PAY_PAL_RO: {name: 'TYPE_PAY_PAL_RO', id: 18, langKey : 'payments.payment.type.pay.pal_ro'},
                    PAYMENT_TYPE_KASPI_BANK: {name: 'TYPE_KASPI_BANK', id: 19, langKey : 'payments.payment.type.kaspi_bank'},
                    PAYMENT_TYPE_FORTE_KZ: {name: 'TYPE_FORTE_KZ', id: 20, langKey : 'payments.payment.type.forte_kz'},
                    PAYMENT_TYPE_UNIBANK_AZ: {name: 'TYPE_UNIBANK_AZ', id: 21, langKey : 'payments.payment.type.unibank_az'},
                    PAYMENT_TYPE_FREE: {name: 'TYPE_FREE', id: 99, langKey : 'payments.payment.type.free'}

                };
                constant.arrayOfValues = [constant.PAYMENT_TYPE_SMS, constant.PAYMENT_TYPE_TRANSFER, constant.PAYMENT_TYPE_CREDIT_CARD,
                    constant.PAYMENT_TYPE_PAY_PAL, constant.PAYMENT_TYPE_MOBILPAY_SMS, constant.PAYMENT_TYPE_MOBILPAY_CARD, constant.PAYMENT_TYPE_MILLIKART_CARD, constant.PAYMENT_TYPE_EASY_PAY,
                    constant.PAYMENT_TYPE_KASSA_24, constant.PAYMENT_TYPE_BLIK, constant.PAYMENT_TYPE_CODE, constant.PAYMENT_TYPE_EASY_PAY_TERMINAL, constant.PAYMENT_TYPE_KASSA_24_TERMINAL,
                    constant.PAYMENT_TYPE_MOBILTEK, constant.PAYMENT_TYPE_PAYME, constant.PAYMENT_TYPE_KASSA_24_CARD, constant.PAYMENT_TYPE_YIGIM_AZ, constant.PAYMENT_TYPE_EPAY_BG,
                    constant.PAYMENT_TYPE_PAY_PAL_RO, constant.PAYMENT_TYPE_KASPI_BANK, constant.PAYMENT_TYPE_FORTE_KZ, constant.PAYMENT_TYPE_UNIBANK_AZ, constant.PAYMENT_TYPE_FREE];
                return constant;
            }()
        )

        .constant('PAYMENT_STATUS_CONSTANT', function () {
                var constant = {
                    PAYMENT_STATUS_SENT_TO_ALLPAY: {name: 'SENT_TO_ALLPAY', id: '-1', langKey : 'payments.payment.status.sent.to.allpay', code: 'payment.status.sent.to.allpay'},
                    PAYMENT_STATUS_SUSPENDED: {name: 'SUSPENDED', id: '0', langKey : 'payments.payment.status.suspended', code: 'payment.status.suspended'},
                    PAYMENT_STATUS_NEW: {name: 'NEW', id: '1', langKey : 'payments.payment.status.new', code: 'payment.status.new'},
                    PAYMENT_STATUS_COMPLETED: {name: 'COMPLETED', id: '2', langKey : 'payments.payment.status.success', code: 'payment.status.success'},
                    PAYMENT_STATUS_REJECTED: {name: 'REJECTED', id: '3', langKey : 'payments.payment.status.rejected', code: 'payment.status.rejected'},
                    PAYMENT_STATUS_CANCELLED: {name: 'CANCELLED', id: '4', langKey : 'payments.payment.status.cancelled', code: 'payment.status.cancelled'},
                    PAYMENT_STATUS_RECLAMATION: {name: 'RECLAMATION', id: '5', langKey : 'payments.payment.status.reclamation', code: 'payment.status.reclamation'}
                };
                constant.arrayOfValues = [constant.PAYMENT_STATUS_SENT_TO_ALLPAY, constant.PAYMENT_STATUS_SUSPENDED, constant.PAYMENT_STATUS_NEW, constant.PAYMENT_STATUS_COMPLETED,
                    constant.PAYMENT_STATUS_REJECTED, constant.PAYMENT_STATUS_CANCELLED, constant.PAYMENT_STATUS_RECLAMATION];
                return constant;
            }()
        )

        .constant('REFRESHING_TIME_FOR_LAST_PAYMENT', 10000)
    ;
})();

(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .constant('INVOICE_STATUS_CONSTANT', function() {
                var constant = {
                    INVOICE_STATUS_NEW: {name: 'NEW', id: 0, langKey : 'payments.invoice.status.0'},
                    INVOICE_STATUS_PAID: {name: 'PAID', id: 1, langKey : 'payments.invoice.status.1'},
                    INVOICE_STATUS_ISSUED: {name: 'ISSUED', id: 2, langKey : 'payments.invoice.status.2'},
                    INVOICE_STATUS_WAITING: {name: 'WAITING', id: 3, langKey : 'payments.invoice.status.3'},
                    INVOICE_STATUS_INCORRECT: {name: 'INCORRECT', id: 4, langKey : 'payments.invoice.status.4'}
                };
                constant.arrayOfValues = [constant.INVOICE_STATUS_NEW, constant.INVOICE_STATUS_PAID, constant.INVOICE_STATUS_ISSUED,
                    constant.INVOICE_STATUS_WAITING, constant.INVOICE_STATUS_INCORRECT];
                return constant;
            }()
        )
    ;
})();
(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .constant('CURRENCY_CONSTANT', function () {
            var constant = {
                EUR: "EUR",
                USD: "USD",
                PLN: "PLN",
                AZN: "AZN",
                KZT: "KZT",
                UAH: "UAH",
                RON: "RON"
            };
            constant.list = Object.keys(constant).map(function (key) {
                return constant[key];
            });

            return constant;
        }());
})();

(function () {
    'use strict';

    var countryCodes = {
        INDIVIDUALS: {key: 'country.individuals', id: 1},
        POLAND_COLUMBIA: {key: 'country.poland_columbia', id: 2},
        UKRAINE: {key: 'country.ukraine', id: 4},
        KAZAKHSTAN_KYRGYZSTAN: {key: 'country.kazakhstan_kyrgyzstan', id: 8},
        AZERBAIJAN: {key: 'country.azerbaijan', id: 16},
        ROMANIA: {key: 'country.romania', id: 64, code:'RO'},
        GUTONLANDIA: {key: 'country.gutonlandia', id: 128}
    };

    countryCodes.arrayOfValues = [countryCodes.INDIVIDUALS, countryCodes.POLAND_COLUMBIA, countryCodes.UKRAINE, countryCodes.KAZAKHSTAN_KYRGYZSTAN,
        countryCodes.AZERBAIJAN, countryCodes.ROMANIA, countryCodes.GUTONLANDIA
    ];

    angular
        .module('plagiat2017App')
        .constant('COUNTRYCODECONSTANT', countryCodes)
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .constant('CONTRACTTYPECONSTANT', function() {
            var constant = {
                CONT_TYPE_PER_DOCUMENT: {id: 0, key: 'contract.type.documents'},
                CONT_TYPE_PER_CHARACTER: {id: 1, key: 'contract.type.characters'},
                CONT_TYPE_PER_USER: {id: 2, key: 'contract.type.users'},
                CONT_TYPE_PER_AUTHOR: {id: 3, key: 'contract.type.authors'}
            };
            constant.arrayOfValues = [constant.CONT_TYPE_PER_DOCUMENT, constant.CONT_TYPE_PER_CHARACTER, constant.CONT_TYPE_PER_USER, constant.CONT_TYPE_PER_AUTHOR];
            return constant;
            }()
        )
        .constant('ASAP_CONTRACT_INSTALLATION_CONSTANT', function () {
            var constant = {
                INSTALL_TYPE_BASIC: {id: 0, key: 'contract.asap.install.basic'},
                INSTALL_TYPE_STANDARD: {id: 1, key: 'contract.asap.install.standard'}
            };
            constant.arrayOfValues = [constant.INSTALL_TYPE_BASIC, constant.INSTALL_TYPE_STANDARD];
            return constant;
            }()
        )
        .constant('ASAP_CONTRACT_INTEGRATION_CONSTANT', function () {
                var constant = {
                    INTEGRATION_AUTHORIAL: {id: 0, key: 'contract.asap.integration.authorial'},
                    INTEGRATION_EORDO: {id: 1, key: 'contract.asap.integration.eordo'},
                    INTEGRATION_EHMS: {id: 2, key: 'contract.asap.integration.ehms'},
                    INTEGRATION_PROAKADEMIA: {id: 3, key: 'contract.asap.integration.proakademia'},
                    INTEGRATION_AZURE: {id: 4, key: 'contract.asap.integration.azure'}
                };
                constant.arrayOfValues = [constant.INTEGRATION_AUTHORIAL, constant.INTEGRATION_EORDO, constant.INTEGRATION_EHMS, constant.INTEGRATION_PROAKADEMIA, constant.INTEGRATION_AZURE];
                return constant;
            }()
        )
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .constant('CLIENTTYPECONSTANT', function () {
            var constant = {
                CLIE_TYPE_NORMAL: {id: 0, key: 'client.type.standard'},
                CLIE_TYPE_PUBLISHER: {id: 1, key: 'client.type.publisher'},
                CLIE_TYPE_PORTAL: {id: 2, key: 'client.type.portal'},
                CLIE_TYPE_KA: {id: 3, key: 'client.type.pka'},
                CLIE_TYPE_SCHOOL_STANDART: {id: 4, key: 'client.type.school_standard'},
                CLIE_TYPE_SCHOOL_ACADEMY: {id: 5, key: 'client.type.school_academy'},
                CLIE_TYPE_SCHOOL_UEK: {id: 6, key: 'client.type.uek'},
                CLIE_TYPE_ACADEMY_IHUW: {id: 7, key: 'client.type.ihuw'},
                CLIE_TYPE_SCHOOL_BEDNARSKA: {id: 8, key: 'client.type.bednarska'},
                CLIE_TYPE_SUBADMIN: {id: 9, key: 'client.type.subadmin'},
                CLIE_TYPE_SECONDARY_SCHOOL: {id: 10, key: 'client.type.secondary_school'},
                CLIE_TYPE_ALLLOCAL: {id: 11, key: 'client.type.all_local'},
                CLIE_TYPE_ASAP: {id: 12, key: 'client.type.asap'},
                CLIE_TYPE_MINSW: {id: 13, key: 'client.type.minsw'},
                CLIE_TYPE_PUBLISHING_HOUSE: {id: 14, key: 'client.type.publishing_house'},
                SCHOOL: {id: 15, key: 'client.type.school'},
                INDIVIDUAL: {id: 16, key: 'client.type.invidual'},
                CODE_ACCOUNT: {id: 17, key: 'client.type.code-account'},
                COLLEGE: {id: 18, key: 'client.type.college'}
            };
            constant.arrayOfValues = [
                constant.CLIE_TYPE_NORMAL, constant.CLIE_TYPE_PUBLISHER, constant.CLIE_TYPE_PORTAL,
                constant.CLIE_TYPE_KA, constant.CLIE_TYPE_SCHOOL_STANDART, constant.CLIE_TYPE_SCHOOL_ACADEMY,
                constant.CLIE_TYPE_SCHOOL_UEK, constant.CLIE_TYPE_ACADEMY_IHUW, constant.CLIE_TYPE_SCHOOL_BEDNARSKA,
                constant.CLIE_TYPE_SECONDARY_SCHOOL, constant.CLIE_TYPE_ASAP,constant.CLIE_TYPE_MINSW,
                constant.CLIE_TYPE_PUBLISHING_HOUSE, constant.SCHOOL, constant.CODE_ACCOUNT,
                constant.COLLEGE
            ];
            constant.listForClientSearch = [
                constant.CLIE_TYPE_NORMAL, constant.CLIE_TYPE_PORTAL,
                constant.CLIE_TYPE_KA, 
                constant.CLIE_TYPE_SCHOOL_UEK, constant.CLIE_TYPE_ASAP,
                constant.CLIE_TYPE_PUBLISHING_HOUSE, constant.SCHOOL, constant.CODE_ACCOUNT,
                constant.COLLEGE
            ];
            constant.listForEditClient = [
                constant.CLIE_TYPE_NORMAL, constant.CLIE_TYPE_ASAP, constant.CODE_ACCOUNT, constant.CLIE_TYPE_PUBLISHING_HOUSE, 
                constant.SCHOOL, constant.COLLEGE
            ];
            constant.listForResellers = [
                constant.CLIE_TYPE_NORMAL, constant.CODE_ACCOUNT, constant.CLIE_TYPE_PUBLISHING_HOUSE, 
                constant.SCHOOL, constant.COLLEGE
            ];
            constant.listForMinistry = [
                constant.CLIE_TYPE_NORMAL, constant.CODE_ACCOUNT, constant.CLIE_TYPE_PUBLISHING_HOUSE, 
                constant.SCHOOL, constant.COLLEGE
            ];
            return constant;
        }())
})();

(function() {
    'use strict';
    angular.module('plagiat2017App').factory('Utils', Utils);
    Utils.$inject = ['CharCode', '$translate'];

    function Utils(CharCode) {
		var service = {
				sortAutoTranslationsLanguages : sortAutoTranslationsLanguages,
                sortCountries : sortCountries,
				removeDiacritics : removeDiacritics,
				removeSpecialChars: removeSpecialChars,
				removeSpaces: removeSpaces,
				removeSpecialCharsForFileName : removeSpecialCharsForFileName,
				isAllowedCharForDigit: isAllowedCharForDigit,
				isAllowedCharForDate: isAllowedCharForDate,
				isAllowedCharForIntegerPositive: isAllowedCharForIntegerPositive,
				validateForm: validateForm
		};
		return service;

        function removeDiacritics(str) {
        	if (typeof str === 'string') {
                return str.replace(/ą/g, 'a').replace(/Ą/g, 'A')
                .replace(/ć/g, 'c').replace(/Ć/g, 'C')
                .replace(/ę/g, 'e').replace(/Ę/g, 'E')
                .replace(/ł/g, 'l').replace(/Ł/g, 'L')
                .replace(/ń/g, 'n').replace(/Ń/g, 'N')
                .replace(/ó/g, 'o').replace(/Ó/g, 'O')
                .replace(/ś/g, 's').replace(/Ś/g, 'S')
                .replace(/ż/g, 'z').replace(/Ż/g, 'Z')
                .replace(/ź/g, 'z').replace(/Ź/g, 'Z');
        	} else {
        		return '';
        	}
        }

        function removeSpaces(str) {
        	if (typeof str === 'string') {
                return str.replace(/ +(?= )/g,'');
        	} else {
        		return '';
        	}
        }

        function removeSpecialChars(str) {
        	if (typeof str === 'string') {
        		return str.replace(/(?:[\u0022\u0023\u0025\u0026\u002a\u002f\u003a\u003b\u003c\u003e\u003f\u007c\u00b2\u00b3\u2211\u222b\u221e\u03c0])+/g, '');
        	} else {
        		return '';
        	}
        }

        function removeSpecialCharsForFileName(str) {
        	return service.removeSpaces(service.removeSpecialChars(service.removeDiacritics(str)));
        }
        
        function isAllowedCharForDigit(e) {
        	return (e.charCode == CharCode.NULL || e.charCode == CharCode.COMMA || e.charCode == CharCode.DOT || e.charCode == CharCode.ENTER || (e.charCode >= CharCode.CHAR_0 && e.charCode <= CharCode.CHAR_9));
        }
        
        function isAllowedCharForIntegerPositive(e) {
        	return (e.charCode == CharCode.NULL || e.charCode == CharCode.ENTER || (e.charCode >= CharCode.CHAR_0 && e.charCode <= CharCode.CHAR_9));
        }
        
        function isAllowedCharForDate(e) {
        	return (e.charCode == CharCode.NULL || e.charCode == CharCode.DASH || e.charCode == CharCode.ENTER || (e.charCode >= CharCode.CHAR_0 && e.charCode <= CharCode.CHAR_9));
        }

		/**
		 * Checks if given form is valid. Also it triggers error messages on fields that are invalid.
		 */
		function validateForm(form) {
			for (var i = 0; i < form.$$controls.length; i++) {
				form.$$controls[i].$touched = true;
			}
			return !form.$invalid;
		}
		
		function sortAutoTranslationsLanguages(langs, t) {
			var sorted = [];
			angular.forEach(langs, function (value) {
				sorted.push({code: value, translated: t.instant('document.report.similarity.language.' + value.toLowerCase())});
			});
			sorted.sort(function(a, b) {
				return a.translated.localeCompare(b.translated, undefined, {sensitivity: 'base'});
			});
			return sorted;
		}

		function sortCountries(tab, t) {
			var sorted = [];
			angular.forEach(tab, function (value) {
                value.translated = t.instant(value.translationKey);
                sorted.push(value);
			});
			sorted.sort(function(a, b) {
				return a.translated.localeCompare(b.translated, undefined, {sensitivity: 'base'});
			});
			return sorted;
		}
	}

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('UrlUtils', UrlUtils);

    UrlUtils.$inject = [];

    function UrlUtils() {

        var service = {
            prepareUrlParam: prepareUrlParam
        };

        return service;

        function prepareUrlParam(param) {
        	return param.replace('+', '%2B');
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .filter('translateExists', translateExists);

    function translateExists($translate) {

        function translateExistsFilter (input) {

            var translation = $translate.instant(input);
            return translation !== input && translation !== "#";
        }
        translateExistsFilter.$stateful = true;
        return translateExistsFilter;
    }
})();
(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('plagiat2017App')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat,
            getDateTimeForFileName: getDateTimeForFileName
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                var utcOffset = moment(date).utcOffset();
                var adjustedDate = new Date(moment(date).add(utcOffset, 'm'));
                return $filter('date')(adjustedDate, dateformat());
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
        
        function getDateTimeForFileName(date) {
            if (date) {
                return $filter('date')(date, 'yyyyMMdd_HHmm');
            } else {
                return null;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function () {
    'use strict';
    angular.module('plagiat2017App').factory('UserReportXlsService',
        UserReportXlsService);

    UserReportXlsService.$inject = ['$http', '$q', 'FileSaver', 'PlagiatValidationService', '$mdDialog', '$translate'];

    function UserReportXlsService($http, $q, FileSaver, PlagiatValidationService, $mdDialog, $translate) {
        var service = {
            generateReportXls: generateReportXls,
            generateReportSendXls: generateReportSendXls
        };
        return service;

        function generateReportXls(response, selected, searchRequest){
            var sendingEmailInfo = $translate.instant("users.report.xls.sending.email.info");

            var confirm = $mdDialog.confirm()
                .title($translate.instant("global.confirm.action"))
                .htmlContent(sendingEmailInfo)
                .ariaLabel($translate.instant("client.areyousure"))
                .ok($translate.instant("global.report.export.xls"))
                .cancel($translate.instant("global.button.cancel"))
                .openFrom('#left');

            $mdDialog.show(confirm).then(function () {
                service.generateReportSendXls({ids: selected}, searchRequest, response.selectedAll).then(function() {
                    var generatingXlsMsg = $translate.instant("users.report.xls.report.generating.with.email.info1");
                    generatingXlsMsg += '<br/>';
                    generatingXlsMsg += $translate.instant("users.report.xls.report.generating.with.email.info2");
                    $mdDialog.show(
                        $mdDialog.confirm()
                            .clickOutsideToClose(true)
                            .title('')
                            .htmlContent(generatingXlsMsg)
                            .ariaLabel('ok')
                            .ok('OK')
                    );

                }, function(response) {
                    PlagiatValidationService.getModalError(response.data);
                });
            });
        }

        function generateReportSendXls(ids, searchRequest, selectedAll) {
            var url = selectedAll ? 'api/user/report/xls/search/send-xls': 'api/user/report/xls/selected/send-xls';
            var data = selectedAll ? searchRequest:ids;

            return $http({
                url : url,
                method : "POST",
                data : data,
                headers : {
                    'Content-type' : 'application/json'
                }
            })
        }

    }

})();

(function () {
    'use strict';

    function UploadFileController($translate, $mdDialog) {
        var vm = this;
        vm.isLoading = false;
        vm.getTheFiles = getTheFiles;

        function getTheFiles($files, $invalidFiles) {
            vm.files = $files;
            vm.errFiles = [];
            vm.errMessage = null;
            vm.onGetTheFiles($files, $invalidFiles);
            angular.forEach($invalidFiles, function (value, key) {
                if (value.$error) {
                    vm.errMessage = value.$error;
                }
                vm.errFiles[vm.errFiles.length] = value.name.substring(value.name.lastIndexOf(".") + 1);
            });

            if (vm.errMessage && vm.errMessage !== 'pattern') {
                vm.errorContent = $translate.instant('document-import.files.' + vm.errMessage);
            } else {
                vm.errorContent = $translate.instant("document-import.files.invalid-extension", { wrongExtension: vm.errFiles.join(", "), validExtensions: vm.onAvailableExtensions });
            }
            
            if (vm.errFiles.length > 0) {
                $mdDialog.show(
                  $mdDialog.confirm()
                  .clickOutsideToClose(true)
                  .title($translate.instant("global.messages.error.label"))
                  .textContent(vm.errorContent)
                  .ariaLabel('ok')
                  .ok('OK')
                  );
            }
        }

    }

    angular.module('fileUpload', ['ngFileUpload'])
    .component('uploadFile', {
        templateUrl: 'app/components/upload-file/upload-file.template.html',
        controller: UploadFileController,
        bindings: {
            documentFormFile: '<',
            onGetTheFiles: '<',
            onAvailableExtensions: '<',
            files: '=',
            isLoading: '=',
            allowMultipleFiles: '<',
            isDisabled: '<',
            maxSize: '<'
        }
    });

})();

(function() {
    'use strict';

    function TokenController($scope, TokenService, $mdToast, $state, $log) {
        var vm = this;
        vm.getTokensInfo = getTokensInfo;
        vm.buyTokens = buyTokens;

        getTokensInfo();
        $scope.$on("availableTokens",function () {
            getTokensInfo();
        } );

        function getTokensInfo() {
            TokenService.getInfo().then(function(responseData) {
                vm.tokens = responseData.data;
            });
        }

        function buyTokens(){
            TokenService.buyTokens = true;
            $state.go('payments');
        }

    }

    angular.module('token', [])
  .component('token', {
      templateUrl: 'app/components/token/token.template.html',
      controller: TokenController,
      bindings: {}
  });

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('PlagiatThemeService', PlagiatThemeService);

    PlagiatThemeService.$inject = ['$q', '$translate', 'THEMES'];

    function PlagiatThemeService($q, $translate, THEMES) {
        var service = {
            getAll: getAll
        };

        return service;

        function getAll() {
            var deferred = $q.defer();
            deferred.resolve(THEMES);
            return deferred.promise;
        }
    
        // function getCurrent() {
        //     var deferred = $q.defer();
        //     var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

        //     deferred.resolve(language);

        //     return deferred.promise;
        // }
    
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('PlagiatThemeController', PlagiatThemeController);

    PlagiatThemeController.$inject = ['PlagiatThemeService', '$location', '$cookies', '$window', '$translate', 
    'tmhDynamicLocale', '$timeout', 'DetectInstanceService', '$log', 'BrowserService'];

    function PlagiatThemeController (PlagiatThemeService, $location, $cookies, $window, $translate, 
        tmhDynamicLocale, $timeout, DetectInstanceService, $log, BrowserService) {
        var vm = this;
        vm.changeTheme = changeTheme;
        vm.host = $location.host();
        BrowserService.isIeLowerThen12()
        vm.inProduction = true;
        if( vm.host === 'localhost' || vm.host === 'st.plagiat.pl' ){
          vm.inProduction = false;
        }
        
        PlagiatThemeService.getAll().then(function (themes) {
            vm.themes = themes;
        });

        vm.isIeLowerThen12 = BrowserService.isIeLowerThen12() ? true : false;

        getTheme();
                
        function changeTheme(theme) {
            setTheme(theme);
            $translate.use(theme);
            tmhDynamicLocale.set(theme);
            $timeout(function () {
                $window.location.reload();
            }, 300);
        }
        
        function getTheme(){
            vm.theme = $cookies.get('plagiat-theme');
            if(vm.theme === 'en'){
                vm.theme = undefined;
            }
           if( angular.isUndefined(vm.theme) ){
            setTheme(DetectInstanceService.instance())
           }
           vm.ico = 'content/favicon/favicon_' + vm.theme;
           vm.domain = DetectInstanceService.getUAConfig();
           vm.pixel = DetectInstanceService.getPixelEnabled();
           vm.conversionDomain = DetectInstanceService.getConversionAllowance();
        }

        function setTheme(theme){
            $cookies.put('plagiat-theme', theme);
            vm.theme = theme;
            vm.ico = 'content/favicon/favicon_'+theme+'.ico';
        }

    }
})();



(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .constant('THEMES', [ 'aka', 'pl', 'ro', 'en' ]);
})();

(function() {
    'use strict';

    function SessionCountdownController ($scope, $log, $http, $interval, $state, Auth, $mdDialog) {
        var vm = this;
        vm.countdownSettings = {
            minutes: 30,
            seconds: 60
        };

        function clearTimer(){
            $interval.cancel(vm.timerInterval);
        }

        function startTimer(duration) {
            var timer = duration, minutes, seconds;
            vm.timerInterval = $interval(function () {
                minutes = parseInt(timer / 60, 10);
                seconds = parseInt(timer % 60, 10);

                minutes = minutes < 10 ? "0" + minutes : minutes;
                seconds = seconds < 10 ? "0" + seconds : seconds;

                vm.timer = minutes + ":" + seconds;

                if (--timer < 0) {
                    clearTimer();
                    $mdDialog.hide();
                    Auth.logout();
                    $state.go('login');
                    $mdDialog.hide();
                }
            }, 1000);
        }

        startTimer(vm.countdownSettings.seconds * vm.countdownSettings.minutes);

        $scope.$watch(function() {
            if( $http.pendingRequests.length > 0 ) {
                clearTimer();
                startTimer(vm.countdownSettings.seconds * vm.countdownSettings.minutes);
            }
        });

    }

    angular.module('plagiat2017App')
    .component('sessionCountdown', {
        templateUrl: 'app/components/session-countdown/session-countdown.template.html',
        controller: SessionCountdownController
    });

})();

(function () {
    angular
        .module('plagiat2017App')
        .directive('selectPageSize', function () {
            return {
                restrict: 'E',
                scope: {
                    queryRequest: '=',
                    onValueChosen: '&'
                },
                templateUrl: 'app/components/select-page-size/select-page-size.template.html'
            }
        })
})();

(function () {
  'use strict';

  function SelectLanguageController($scope, $rootScope, $mdDialog,
                                    JhiLanguageService, InstanceService, AccountService, 
                                    findLanguageFromKeyFilter, tmhDynamicLocale, USERSCHOOLTYPE) {
    var vm = this;
    vm.isIndividual = AccountService.role.isIndividual();
    vm.account = AccountService.account;
    
    function showSelectLanguageOnStart(){
    	$mdDialog.show({
	        templateUrl: 'app/components/select-language/select-language.template.html',
	        clickOutsideToClose: false,
	        escapeToClose: false,
            multiple: true,
	        controller: DialogController
    	});
    }

    if (vm.account.userFirstLoginDate 
            && vm.account.userLastLoginDate 
            && vm.account.userFirstLoginDate == vm.account.userLastLoginDate 
            && vm.account.accountType == USERSCHOOLTYPE.USER_SCHOOL_TYPE_TEACHER.value){
        showSelectLanguageOnStart();
    }
    
    function DialogController($scope, $mdDialog) {
        $scope.closeDialog = function() {
          $mdDialog.hide();
        };
        
        JhiLanguageService.getAll().then(function (allLanguages) {
            $scope.availableLanguages =  allLanguages.data.availableLanguages;
        });

        $scope.changeLanguage = function(languageKey) {
            vm.pickedLanguage = findLanguageFromKeyFilter(languageKey);
            tmhDynamicLocale.set(languageKey).then(function(){
                $translate.use(languageKey).then(function(){
                    $translate.fallbackLanguage('en');
                    $translate.preferredLanguage(languageKey);
                    $rootScope.$broadcast("langChanged");
                })
            });
        }

        $scope.setLang = function(languageKey){
            AccountService.setLang(languageKey);
        }
        
        $scope.langChangedOnStartBroadcast = function(){
        	$rootScope.$broadcast("langChangedOnStart");
        }
    }

  }

  angular.module('plagiat2017App')
  .component('selectLanguage', {
    templateUrl: 'app/components/select-language/select-language.template.html',
    controller: SelectLanguageController
  });

})();

(function() {
	'use strict';

	function ProfileFormOperatorController($scope, $mdDialog, $translatePartialLoader, $log,
										   AccountService, OrganisationalUnitsService, ModalService) {
		var vm = this;
		vm.closeDialog = closeDialog;
		vm.user = {};
		vm.saveDataDetails = saveDataDetails;
		vm.allUsersCanDeleteAccounts = AccountService.getClientSettings() && AccountService.getClientSettings().allUsersCanDeleteAccounts;
		vm.deleteAccountButtonClicked = deleteAccountButtonClicked;

		function deleteAccountButtonClicked() {
			$mdDialog.hide();
			AccountService.sendAccountDeletionConfirmationEmail();
			ModalService.showDialogModal("delete-account.dialog.email-sent");
		}

		function initForm() {
			AccountService.getLoggedUserDetails().then(function(success) {
				vm.user = success.data;
			})
		}

		initForm();

		function closeDialog() {
			$mdDialog.hide();
		}
		
		OrganisationalUnitsService.findAllForClient().then(function(response) {
			vm.organisationalUnits = response.data;
		});

		function saveDataDetails() {
			AccountService
					.setDataDetails(vm.user)
					.then(
							function(responseData) {

								$mdDialog.hide();
								AccountService.account.firstName = vm.user.userName;
								AccountService.account.lastName = vm.user.userSurname;
								AccountService.account.userWantsNotifications = vm.user.userWantsNotifications;
							});
		}
		$translatePartialLoader.addPart('delete-account');

	}

	angular
			.module('plagiat2017App')
			.component(
					'profileFormOperator',
					{
						templateUrl : 'app/components/profile/profile-form-operator/profile-form-operator.template.html',
						controller : ProfileFormOperatorController
					});

})();

(function () {
    'use strict';

    function ProfileFormController($scope, $mdDialog, AccountService, $log, ModalService, PlagiatValidationService,
                                   $translatePartialLoader, $translate, $localStorage) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.deleteAccountButtonClicked = deleteAccountButtonClicked;
        vm.saveData = saveData;

        vm.logoutToRootInfo = $localStorage.logoutToRootInfo;
        vm.user = { changeEmail: false };
        vm.account = AccountService.account;
        vm.user.userName = vm.account.firstName;
        vm.user.userSurname = vm.account.lastName;
        vm.user.userEmail = vm.account.email;
        vm.user.userWantsNotifications = vm.account.userWantsNotifications;
        vm.allUsersCanDeleteAccounts = AccountService.getClientSettings() && AccountService.getClientSettings().allUsersCanDeleteAccounts;
        vm.canNotChangeNotificationSetting = (
            AccountService.role.isStudent()
            && AccountService.clientType.isSchool() 
            && AccountService.getClientSettings() 
            && !AccountService.getClientSettings().sendAlertToStudent
        );
        vm.isIndividual = AccountService.role.isIndividual();
        vm.isStudent = AccountService.role.isStudent();
        vm.errorMessage = undefined;

        function closeDialog() {
            $mdDialog.hide();
        }

        function deleteAccountButtonClicked() {
            $mdDialog.hide();
            AccountService.sendAccountDeletionConfirmationEmail();
            ModalService.showDialogModal("delete-account.dialog.email-sent");
        }

        function saveData() {
            AccountService.setData(vm.user).then(function () {
            	vm.errorMessage = undefined;
                $mdDialog.hide();
                AccountService.account.firstName = vm.user.userName;
                AccountService.account.lastName = vm.user.userSurname;
                AccountService.account.userWantsNotifications = vm.user.userWantsNotifications;
                if(vm.user.changeEmail) {
                    ModalService.showSuccessModal("global.email.changed");
                }
            }, function(errResponse){
            	vm.errorMessage = PlagiatValidationService.getTextError(errResponse.data.code);
        	});
        }
        $translatePartialLoader.addPart('delete-account');
        $translate.refresh();
    }

    angular.module('plagiat2017App')
    .component('profileForm', {
        templateUrl: 'app/components/profile/profile-form/profile-form.template.html',
        controller: ProfileFormController
    });

})();

(function () {
    'use strict';

    function ProfileController($state, $mdDialog, $translatePartialLoader, $localStorage, $attrs, $window,
                               Auth, AccountService, ModalService, UserService) {
        var vm = this;
        vm.showEditForm = showEditForm;
        vm.showChangePasswordForm = showChangePasswordForm;
        vm.logout = logout;
        vm.logoutToRoot = logoutToRoot;
        vm.deleteAccountButtonClicked = deleteAccountButtonClicked;

        vm.isOperator = AccountService.role.isOperator();
        vm.isLecturer = AccountService.role.isLecturer();
        vm.isIndividual = AccountService.role.isIndividual();
        vm.showLogoutToRootBtn = $localStorage.showLogoutToRootBtn;


    
        if ($attrs.$attr.showXs && AccountService.forceChangePassword()) {// sprawdzam czy jest ten atrybut showXs komponentu  
            showChangePasswordForm();
        }
        
        function showEditForm() {
        	if(vm.isOperator || vm.isLecturer){
                $mdDialog.show({
                    templateUrl: 'app/components/profile/profile-form-operator/profile-form-operator.dialog.html',
                    clickOutsideToClose: false
                });
        	}else{
	            $mdDialog.show({
	                templateUrl: 'app/components/profile/profile-form.tmpl.html',
	                clickOutsideToClose: false
	            });
        	}
        }

        function showChangePasswordForm() {
            $mdDialog.show({
                templateUrl: 'app/components/profile/change-password.tmpl.html',
                multiple: true,
                clickOutsideToClose: false
            });
        }

        function deleteAccountButtonClicked() {
            $mdDialog.hide();
            AccountService.sendAccountDeletionConfirmationEmail();
            ModalService.showDialogModal("delete-account.dialog.email-sent");
        }

        function logout(ev) {
        	if(vm.showLogoutToRootBtn){
        		logoutToRoot(ev);
        	}else{
        		$localStorage.showLogoutToRootBtn = false;
        		$localStorage.logoutToRootInfo = undefined;
            	Auth.logout();
            	$state.go('login');
        	}
        }
        
        function logoutToRoot(ev){
        	UserService.logoutToRoot().then(function(){
        		$localStorage.showLogoutToRootBtn = false;
        		$localStorage.logoutToRootInfo = undefined;
        		$localStorage.returnFromUser = true;
                $window.location.href = '/#/users';
                $window.location.reload();
        	},
        	function(){
        		ModalService.showSuccessModal("global.operation.failed", ev);
        	});
        }
        $translatePartialLoader.addPart('delete-account');

    }

    angular.module('plagiat2017App')
    .component('profile', {
        templateUrl: 'app/components/profile/profile.template.html',
        controller: ProfileController
    });

})();

(function () {
    'use strict';

    function ChangePasswordController($scope, $mdDialog, $translate, 
                                      AccountService, ModalService, DocumentErrors, PlagiatValidationService, Auth) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.user = {};
        vm.saveData = saveData;
        vm.doNotMatch = false;
        vm.enforcePasswordChange = AccountService.forceChangePassword();
        vm.tooglePasswordVisibility = tooglePasswordVisibility;
        vm.user.password = '';
        vm.showPassword = false;
        vm.typeInput = 'password';
        vm.passwordPattern = Auth.getPasswordPattern();

        function tooglePasswordVisibility(){
            vm.typeInput = vm.showPassword ? 'text' : 'password';
        }

        function closeDialog() {
            $mdDialog.hide();
        }
        
        function saveData() {
            if (vm.user.newPassword !== vm.user.confirmedPassword) {
                vm.doNotMatch = true;
            } else {
                
                if (vm.user.newPassword == vm.user.password) {
                    ModalService.showErrorModal({data: {code: 111}}, true);
                } else {
                    AccountService.setNewPassword(vm.user)
                        .then(function () {
                            closeDialog();
                            vm.doNotMatch = false;
                            ModalService.showSuccessModal("global.messages.info.passwordchanged");
                        }, function (errorResponse) {
                            ModalService.showErrorModal(errorResponse, true);
                        });
                }
            }
        }

    }

    angular.module('plagiat2017App')
    .component('changePassword', {
        templateUrl: 'app/components/profile/change-password/change-password.template.html',
        controller: ChangePasswordController
    });

})();

(function () {
    'use strict';

    angular.module('plagiat2017App').component('plagiatNgMessages', {
        templateUrl: 'app/components/plagiat-ng-messages/plagiat-ng-messages.template.html',
        controllerAs: 'vm',
        bindings: {
            formElement: '=',
            translateValues: '='
        }
    });

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'tmhDynamicLocale', 'LANGUAGES'];

    function JhiLanguageService($q, $http, $translate, tmhDynamicLocale, LANGUAGES) {
        var service = {
            getAll: getAll,
            getAllWithAdditional: getAllWithAdditional,
            setLanguage:setLanguage,
            getCurrent: getCurrent
        };

        return service;

        function setLanguage(languageKey){
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }

        function getAll() {
            return $http.get('api/languages/available').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getAllWithAdditional() {
            return $http.get('api/languages/available-with-additional').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getCurrent() {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'az': 'Azərbaycan dili',
                'bg': 'Български',
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ka': 'ქართული',
                'ko': '한국어',
                'kk': 'Қазақ тілі',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português (Portugal)',
                'pt': 'Português (Portugal)',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'uk': 'Українська',
                'uz': 'Ozbek',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文',
                'plain': 'Plain'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$scope', '$rootScope', '$translate', '$stateParams', 'JhiLanguageService', 'tmhDynamicLocale', 'findLanguageFromKeyFilter', 'AccountService', '$timeout', 'InstanceService'];

    function JhiLanguageController ($scope, $rootScope, $translate, $stateParams, JhiLanguageService, tmhDynamicLocale, findLanguageFromKeyFilter, AccountService, $timeout, InstanceService) {
        var vm = this;

        vm.isIndividual = AccountService.role.isIndividual();
        vm.isOperator = AccountService.role.isOperator();
        vm.isLecturer = AccountService.role.isLecturer();
        vm.pickedLanguage = findLanguageFromKeyFilter(AccountService.account.langKey);
        vm.pickedLanguageKey = AccountService.account.langKey;

        vm.changeLanguage = changeLanguage;
        vm.instanceLang = InstanceService.instance().lang;
        vm.setLang = setLang;
        vm.availableLanguages = null;

        JhiLanguageService.getAll().then(function (allLanguages) {
            vm.availableLanguages = allLanguages.data.availableLanguages;
        });

        function changeLanguage (languageKey) {
            vm.pickedLanguage = findLanguageFromKeyFilter(languageKey);
            AccountService.account.pickedLang = languageKey;
            
            tmhDynamicLocale.set(languageKey).then(function(){
                $translate.use(languageKey).then(function(){
                    $translate.fallbackLanguage(languageKey);
                    $translate.preferredLanguage(languageKey);
                    $rootScope.$broadcast("langChanged");
                })
            });
        }

        function setLang(languageKey){
            AccountService.setLang(languageKey);
            AccountService.account.langKey = languageKey;
        }
        
        $scope.$on("langChangedOnStart",function () {
        	vm.pickedLanguage = findLanguageFromKeyFilter(AccountService.account.langKey);
        } );

    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'pl',
            'es',
            'az',
            'de',
            'fr',
            'ka',
            'kk',
            'ro',
            'ru',
            'tr',
            'uk',
            'bg',
            'pt-pt',
            'pt-br',
            'it',
            'nl',
            'uz'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ])
        .constant('AUTO_TRANSLATIONS_LANGS', [
            'ar_EG',
            'hy_AM',
            'az_AZ',
            'eu_ES',
            'be_BY',
            'bs_BA',
            'bg_BG',
            'ca_ES',
            'zh-Hans_CN',
            'hr_HR',
            'cs_CZ',
            'da_DK',
            'en_GB',
            'et_EE',
            'fi_FI',
            'fr_FR',
            'fy_NL',
            'ka_GE',
            'de_DE',
            'el_GR',
            'he_IL',
            'hi_IN',
            'hu_HU',
            'is_IS',
            'id_ID',
            'ga_IE',
            'it_IT',
            'ja_JP',
            'kk_KZ',
            'ko_KR',
            'ky_KG',
            'la_VAT',
            'lv_LV',
            'lt_LT',
            'ms_MY',
            'mt_MT',
            'mn_MN',
            'no_NO',
            'fa_IR',
            'pl_PL',
            'pt_PT',
            'pa_PK',
            'ro_RO',
            'ru_RU',
            'sk_SK',
            'es_ES',
            'sv_SE',
            'tg_TJ',
            'ta_IN',
            'tr_TR',
            'uk_UA',
            'ur_PK',
            'uz_UZ',
            'vi_VN',
            'nl_NL'
        ])
    ;
})();

(function() {
    'use strict';

    function LangSelectController (AccountService, InstanceService, findLanguageFromKeyFilter, $scope, $rootScope, tmhDynamicLocale, 
        $stateParams, $translate, JhiLanguageService) {
    	var vm = this;

    	vm.isIndividual = AccountService.role.isIndividual();
        vm.isOperator = AccountService.role.isOperator();
        vm.isLecturer = AccountService.role.isLecturer();

        vm.changeLanguage = changeLanguage;
        vm.instanceLang = InstanceService.instance().lang;
        vm.setLang = setLang;
        vm.availableLanguages = null;
        vm.pickedLanguage = '';

        JhiLanguageService.getAll().then(function (allLanguages) {
            vm.availableLanguages = allLanguages.data.availableLanguages;
        });

        function changeLanguage (languageKey) {
            vm.pickedLanguage = findLanguageFromKeyFilter(languageKey);
            tmhDynamicLocale.set(languageKey).then(function(){
                $translate.use(languageKey).then(function(){
                    $translate.fallbackLanguage(languageKey);
                    $translate.preferredLanguage(languageKey);
                    $rootScope.$broadcast("langChanged");
                })
            });
        }

        function setLang() {
            if ($stateParams.lang) {
                $translate.use($stateParams.lang);
                tmhDynamicLocale.set($stateParams.lang);
            }
        }

        setLang();

    }

    angular.module('plagiat2017App')
    .component('langSelect', {
        templateUrl: 'app/components/lang-select/lang-select.template.html',
        controller: LangSelectController
    });

})();

(function () {
  'use strict';

  angular
    .module('plagiat2017App')
    .directive('threeStateRadio', threeStateRadio);

  function threeStateRadio() {
    return {
      restrict: 'E',
      require: 'ngModel',
      templateUrl: 'app/components/form/three-state-radio/three-state-ratio.template.html',
      link: function ($scope, element, attrs, controller) {
        controller.$validators.threeStateRadioUnset = function (value) {
          return value === true || value === false;
        }

        $scope.modifyValue = function (newValue) {
          if ($scope.nowdisabled) {
            return;
          }
          if (!$scope.immutable) {
            this.inputValue = newValue;
          }
        }

        $scope.$watch(function () {
          if ($scope.onValueChange) {
            $scope.onValueChange();
          }
          return controller.$touched;
        }, function(newValueOfTouched) {
          if ($scope.onValueChange) {
            $scope.onValueChange();
          }
          if (newValueOfTouched) {
            element.addClass('ng-touched');
          }
        });
      },
      scope: {
        inputValue: '=ngModel',
        label: '@',
        onValueChange: '&',
        immutable: '<',
        nowdisabled: '<'
      },
    };
  }
})();

(function() {
	'use strict';
	angular.module('plagiat2017App').directive('stopccp', function() {
		return {
			scope : {},
			link : function(scope, element) {
				element.on('cut copy paste', function(event) {
					event.preventDefault();
				});
			}
		};
	});

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .constant('paginationConstants', {
            'itemsPerPage': 5
        });
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('inputNumber', inputNumber);

    function inputNumber(Utils) {
    	return {
    	    restrict: 'A',
    	    link: function ($scope, element, attrs, ngModel) {
    	        element.bind('keypress', function (e, inputs) {
    	            if(!Utils.isAllowedCharForDigit(e)) {
    	            	e.preventDefault();
    	            }
    	        })
    	    }
    	  };
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('inputDate', inputDate);

    function inputDate(Utils) {
    	return {
    	    restrict: 'A',
    	    link: function ($scope, element, attrs, ngModel) {
    	        element.bind('keypress', function (e, inputs) {
    	            if(!Utils.isAllowedCharForDate(e)) {
    	            	e.preventDefault();
    	            }
    	        })
    	    }
    	  };
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('formDisabled', formDisabled);

    function formDisabled() {
        return {
            restrict: 'A',
            require: 'form',
            link: linkFunc,
            scope: {
                formDisabled: '<'
            }
        };

        function linkFunc(scope, element) {
            scope.$watch('formDisabled', function (newValue) {
                element.find(":input").attr('disabled', newValue);
            });
        }
    }
})();

(function() {
	'use strict';

	function FbPixelPlController($cookies) {
		var vm = this;
		vm.theme = $cookies.get('plagiat-theme');

		if (vm.theme === 'pl'){
			!function(f,b,e,v,n,t,s)
			{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window,document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
			fbq('init', '2793300560737963');
			fbq('track', 'PageView');
		}
	}

	angular.module('plagiat2017App')
	.component('fbPixelPl', {
		templateUrl: 'app/components/fb-pixel/fb-pixel.template.html',
		controller: FbPixelPlController
	});

})();

(function() {
	'use strict';
	angular.module('plagiat2017App').factory(
			'DocumentParameterDefinitionService',
			DocumentParameterDefinitionService);

	DocumentParameterDefinitionService.$inject = [ '$http', '$q', '$translate' ];

	function DocumentParameterDefinitionService($http, $q, $translate) {
		var service = {
			findOneByName : findOneByName,
		};
		return service;

		function findOneByName(dopadeName) {
			return $http.get(
					'api/document-parameter-definitions?dopadeName='
							+ dopadeName).then(function(response) {
				return response.data;
			}, function(errResponse) {
				return $q.reject(errResponse);
			});
		}

	}

})();

(function() {
	'use strict';
	angular.module('plagiat2017App').factory('DocumentKindService',
			DocumentKindService);

	DocumentKindService.$inject = [ '$http', '$q' ];

	function DocumentKindService($http, $q) {
		var service = {
			findAll : findAll
		};
		return service;

		function findAll(editedDocumentId) {
			var url = 'api/document-kinds';
			if(editedDocumentId){
				url += '?editedDocumentId=' + editedDocumentId;
			}
			return $http.get(url).then(
					function(response) {
						return response.data;
					}, function(errResponse) {
						return $q.reject(errResponse);
					});
		}

	}

})();

(function () {
    'use strict';
    angular.module('plagiat2017App')
        .factory('DOCUMENT_KINDS', function () {
            var documentKinds = {
                PHD: {id: 1, label: 'Praca doktorska'},
                MASTER: {id: 2, label: 'Praca magisterska'},
                BACHELOR: {id: 3, label: 'Praca licencjacka'},
                ENGINEERING: {id: 9, label: 'Praca inżynierska'},
                OTHER: {id: 29, label: 'Inne'}
            };
            documentKinds.jsaDocumentKinds = [documentKinds.BACHELOR, documentKinds.MASTER, documentKinds.ENGINEERING, documentKinds.PHD];
            return documentKinds;
        });

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('SendToOrppdController', SendToOrppdController);

    SendToOrppdController.$inject = [
        '$scope', '$mdDialog', 'AccountService',
        'DocumentService', '$localStorage', '$log', 'OrganisationalUnitsService',
        'DocumentKindService', 'DocumentParameterDefinitionService', '$q', '_', '$timeout',
        '$stateParams', 'OrppdService', 'form', 'PlagiatValidationService', 'ScrollService', '$rootScope', 'ModalService',
        'DateUtils'
    ];

    function SendToOrppdController(
        $scope, $mdDialog, AccountService,
        DocumentService, $localStorage, $log, OrganisationalUnitsService,
        DocumentKindService, DocumentParameterDefinitionService, $q, _, $timeout, $stateParams,
        OrppdService, form, PlagiatValidationService, ScrollService, $rootScope, ModalService, DateUtils
    ) {
        var vm = this;

        vm.form = form;
        if (form.orppdErrorCode) {
            vm.orppdErrorMessage = PlagiatValidationService.getTextError(form.orppdErrorCode);
            if (form.orppdErrorMessage){
                vm.orppdErrorMessage += ': ' + form.orppdErrorMessage;
            }
        }

        vm.formOfStudies = ["stacjonarne", "niestacjonarne"];
        vm.professionalTitles = ["INZ", "LIC", "MGR", "MGRINZ", "INZARCH", "INZARCHKR", "INZPOZ", "LEK", "LEKDEN",
            "LEKWET", "LICPIEL", "LICPOL", "MGRFAR", "MGRINZARCH", "MGRINZARCHKR", "MGRPOZ", "MGRINZPOZ", "MGRPIEL", "MGRPOL", "MGRSZT", "OD"];
        vm.addSupervisorMode = false;
        vm.addReviewerMode = false;
        vm.searchSupervisorText = null;
        vm.availablePromotersAndReviewers = [];

        OrppdService.getAvailablePromotersAndReviewers(vm.form.documentId).then(
            function (response) {
                vm.availablePromotersAndReviewers = response;
            }
         );

        vm.supervisorsAndReviewerSearch = supervisorsAndReviewerSearch;

        function lowercase(string) {
            return angular.isString(string) ? string.toLowerCase() : string;
        }

        function supervisorsAndReviewerSearch(query) {
            var list = vm.availablePromotersAndReviewers;
            return query ? _.filter(list, function (o) {
                return lowercase(o.firstName).indexOf(lowercase(query)) !== -1 || lowercase(o.lastName).indexOf(lowercase(query)) !== -1;
            }) : list;
        }

        vm.onSupervisorChanged = onSupervisorChanged;
        function onSupervisorChanged(item) {
            if (!item) return;
            if (!vm.form.supervisors) {
                vm.form.supervisors = [];
            }
            vm.form.supervisors.push({
                polonEmployeeId: item.polonEmployeeId,
                firstName: item.firstName,
                lastName: item.lastName,
                pesel: item.pesel,
                documentCountry: item.documentCountry,
                documentType: item.documentType,
                documentNumber: item.documentNumber
            });
            vm.addSupervisorMode = false;
            vm.searchSupervisorText = null;
        }

        vm.onReviewerChanged = onReviewerChanged;
        function onReviewerChanged(item) {
            if (!item) return;
            if (!vm.form.reviewers) {
                vm.form.reviewers = [];
            }
            vm.form.reviewers.push({
                polonEmployeeId: item.polonEmployeeId,
                firstName: item.firstName,
                lastName: item.lastName,
                pesel: item.pesel,
                documentCountry: item.documentCountry,
                documentType: item.documentType,
                documentNumber: item.documentNumber
            });
            vm.searchReviewerText = null;
            vm.addReviewerMode = false;
        }

        vm.addAuthor = addAuthor;
        function addAuthor() {
            vm.form.authors.push({
                firstName: "",
                lastName: "",
                defenceDate: null,
                interterIndividualStudiesCourseId: null,
                interfacultyFieldOfStudyCode: null,
                formOfStudy: null,
                professionalTitle: null,
                dateVersionData: null
            });
        }

        vm.removeAuthor = removeAuthor;
        function removeAuthor(index) {
            vm.form.authors.splice(index, 1);
        }

        vm.onClickRemoveSupervisor  = onClickRemoveSupervisor;
        function onClickRemoveSupervisor(index) {
            vm.form.supervisors.splice(index, 1);
        }

        vm.onClickRemoveReviewer  = onClickRemoveReviewer;
        function onClickRemoveReviewer(index) {
            vm.form.reviewers.splice(index, 1);
        }

        vm.closeDialog = closeDialog;
        function closeDialog() {
            $mdDialog.cancel();
            $rootScope.$broadcast('on-get-documents');
        }

        function correctDatesInForm() {
            for (var authorIdx in vm.form.authors) {
                var author = vm.form.authors[authorIdx];
                author.defenceDate = DateUtils.convertLocalDateToServer(author.defenceDate);
                author.dateVersionData = DateUtils.convertLocalDateToServer(author.dateVersionData);
            }
        }

        vm.send = send;
        function send() {
            vm.isSending = true;
            correctDatesInForm();
            OrppdService
                .sendDocument(vm.form)
                .then(
                    function () {
                        vm.isSending = false;
                        $mdDialog.hide();
                        ModalService.showSuccessModal("document.orppd.send.success");
                        $rootScope.$broadcast('on-get-documents');
                    }, function (errorResponse) {
                        vm.isSending = false;
                        vm.orppdErrorMessage = PlagiatValidationService.getTextError(errorResponse.data.code);
                        if (errorResponse.data.data){
                            vm.orppdErrorMessage += ': ' + errorResponse.data.data;
                        }
                        ScrollService.scrollTo('orppdErrorsCard');
                    }
                );
        }

    }

})();

(function () {
    'use strict';

    IdentificationDataController.$inject = ['OrppdService'];

    function IdentificationDataController(OrppdService) {

        var vm = this;
        vm.peselDisabled = peselDisabled;
        vm.documentDataDisabled = documentDataDisabled;
        vm.isPesel = false;
        vm.countriesDictionary = [];
        vm.documentTypesDictionary = [];

        OrppdService.getCountriesDictionary().then(
            function (countriesDictionaryResult) {
                vm.countriesDictionary = countriesDictionaryResult.filter(function (dictValue) {
                    return dictValue.code !== '00';
                });
            }
        )

        OrppdService.getDocumentTypeDictionary().then(
            function (documentTypesDictionaryResult) {
                vm.documentTypesDictionary = documentTypesDictionaryResult.filter(function (dictValue) {
                    return dictValue.code !== 'PESEL';
                });
            }
        )

        function peselDisabled() {
            return vm.identificationDataForm.documentCountry || vm.identificationDataForm.documentType || vm.identificationDataForm.documentNumber;
        }

        function documentDataDisabled() {
            return vm.identificationDataForm.pesel;
        }
    }

    angular.module('plagiat2017App')
        .component('identificationData', {
            templateUrl: 'app/components/document/send-to-orppd/identification-data.component.html',
            controller: IdentificationDataController,
            controllerAs: 'vm',
            bindings: {
                identificationDataForm: '<',
            }
        });

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('SendToJSAController', SendToJSAController);

    function SendToJSAController(
        $scope, $mdDialog, $translate, $localStorage, $log,
        docId,
        TRANSLATION_KEYS, DOCUMENT_KINDS,
        AccountService, SearchService, DocumentService, JsaService, OrganisationalUnitsService, DictionaryService,
        DocumentKindService, DocumentParameterDefinitionService, PlagiatValidationService,
        JsaDocumentFormService, $rootScope
    ) {
        var vm = this;
        vm.idDocument = docId;
        vm.isLoading = true;
        vm.sendWithoutUid = false;
        vm.searchValuePromoter = null;
        vm.onUploadObj = {};
        vm.selectedItem = [];
        vm.querySearchForLanguage;
        vm.querySearchForOrganisationalUnit;
        vm.formatAuthor = JsaDocumentFormService.formatAuthor;
        vm.searchLanguages = DictionaryService.getLanguagesJsaAutocompleteItems;
        vm.typeOfDocuments = DOCUMENT_KINDS.jsaDocumentKinds;
        vm.isSuperAdmin = AccountService.role.isSuperAdmin();

        this.$onInit = function () {
            DocumentService.getMetadataForm(vm.idDocument).then(function (responseData) {
                vm.document = responseData.data;
                vm.clientId = vm.document.clientId;
                vm.userId = vm.document.userId;
                DocumentService.operator.getConfiguration().then(function (response) {
                    vm.onUploadObj = Object.assign(response.data, vm.onUploadObj);
                    vm.onUploadObj.title = vm.document.docuTitle;
                    vm.onUploadObj.documentKindId = vm.document.documentKindId;
                    vm.isLoading = false;
                });
            });
        };

        vm.searchAuthors = function (searchText) {
            return JsaService.getAuthorsAutocompleteItems(searchText, vm.onUploadObj.authors, vm.document.clientId)
        };

        vm.searchPromoters = function(searchText) {
            return JsaService.getPromotersAutocompleteItems(searchText, vm.document.clientId);
        };

        vm.selectPromoter = function (promoter) {
            vm.onUploadObj.promoter = (promoter && promoter.name) ? promoter : null;
        };

        vm.selectedOrganisationalUnitChange = function (organisationalUnit) {
            vm.onUploadObj.organisationalUnit = (organisationalUnit && organisationalUnit.id) ? organisationalUnit : null;
        };

        vm.selectLanguage = function (language) {
            vm.onUploadObj.language = (language && language.code) ? language : null;
        };

        vm.getLanguageItemText = function (item) {
            return $translate.instant(TRANSLATION_KEYS.dictionaryLanguage + item.code);
        };

        vm.selectedAuthorChanged = function (item, index) {
            JsaDocumentFormService.handleSelectedAuthorChange(item, index, vm);
        };

        vm.selectedStudyChanged = function selectedStudyChanged() {
            JsaDocumentFormService.refreshAvailableUnits(vm);
        };

        vm.addAuthor = function () {
            if (!vm.onUploadObj.authors) {
                vm.onUploadObj.authors = [];
            }
            vm.onUploadObj.authors.push({});
        };

        vm.removeAuthor = function (event, index) {
            vm.onUploadObj.authors.splice(index, 1);
        };

        vm.closeDialog = function () {
            $mdDialog.hide();
        };

        vm.saveData = function () {
            vm.isLoading = true;
            JsaDocumentFormService.inferOrganisationalUnitId(vm).then(
                function (organisationalUnitId) {
                    vm.onUploadObj.organisationalUnitId = organisationalUnitId;
                }
            ).then(
                function () {
                    JsaService.send(vm.idDocument, vm.onUploadObj, vm.sendWithoutUid).then(function () {
                        $mdDialog.hide();
                        $rootScope.$broadcast('on-get-documents');
                        $state.go("documents");
                    }, function (response) {
                        $rootScope.$broadcast('on-get-documents');
                        $mdDialog.hide();
                        PlagiatValidationService.getModalError(response.data, null, "documents");
                    });
                }
            );
        }
    }
})();

(function() {
	'use strict';

	function JsaDocumentEditControler($scope, $mdDialog, AccountService, $translate, TRANSLATION_KEYS,
		DocumentService, JsaService, $localStorage, $log, OrganisationalUnitsService, DictionaryService,
		DocumentKindService, DocumentParameterDefinitionService, DOCUMENT_KINDS, PlagiatValidationService,
                                      JsaDocumentFormService) {
        var vm = this;
        vm.searchValuePromoter = null;
        vm.closeDialog = closeDialog;
        vm.saveData = saveData;
        vm.selectedItem = [];
        vm.addAuthor = addAuthor;
        vm.removeAuthor = removeAuthor;
        vm.formatAuthor = JsaDocumentFormService.formatAuthor;
        vm.searchAuthors = function(searchText) {return JsaService.getAuthorsAutocompleteItems(searchText, vm.onUploadObj.authors, vm.clientId)};
        vm.selectedAuthorChanged = selectedAuthorChanged;
        vm.selectedStudyChanged = selectedStudyChanged;
        vm.searchPromoters = function(searchText) {return JsaService.getPromotersAutocompleteItems(searchText, vm.clientId)};
        vm.selectPromoter = selectPromoter;
        vm.querySearchForOrganisationalUnit = null;
        vm.selectedOrganisationalUnitChange = selectedOrganisationalUnitChange;
        vm.querySearchForLanguage = null;
        vm.searchLanguages = DictionaryService.getLanguagesJsaAutocompleteItems;
        vm.selectLanguage = selectLanguage;
        vm.getLanguageItemText = getLanguageItemText;
        vm.typeOfDocuments = DOCUMENT_KINDS.jsaDocumentKinds;
        vm.idDocument = DocumentService.document.id;
        vm.onUploadObj = {};
        vm.isLoading = true;
        vm.isSaving = false;

        DocumentService.operator.getConfiguration().then(function (response) {
            vm.onUploadObj = Object.assign(response.data, vm.onUploadObj);
            JsaService.getJsaMetadata(vm.idDocument).then(function (response) {
                vm.onUploadObj = Object.assign(response.data, vm.onUploadObj);
                vm.clientId = vm.onUploadObj.clientId;
                vm.userId = vm.onUploadObj.uploadingUserId;
                vm.jsaExaminationDeprecated = vm.onUploadObj.jsaExaminationDeprecated;
                vm.selectedItem = vm.onUploadObj.authors;
                vm.selectedPromoter = vm.onUploadObj.promoter;
                if (AccountService.account.id === vm.onUploadObj.promoter.userId) {
                    vm.promoterNotEditable = true;
                }
                vm.selectedLanguage = vm.onUploadObj.language;
                vm.selectedOrganisationalUnit = vm.onUploadObj.organisationalUnit;
                vm.selectedDocumentKindId = vm.onUploadObj.documentKindId;
                vm.isLoading = false;
            })
        });

        function selectPromoter(promoter) {
            vm.onUploadObj.promoter = (promoter && promoter.name) ? promoter : null;
        }

        function selectedOrganisationalUnitChange(organisationalUnit) {
            vm.onUploadObj.organisationalUnit = (organisationalUnit && organisationalUnit.id) ? organisationalUnit : null;
        }

        function selectLanguage(language) {
            vm.onUploadObj.language = (language && language.code) ? language : null;
        }

        function getLanguageItemText(item) {
            return $translate.instant(TRANSLATION_KEYS.dictionaryLanguage + item.code);
        }

        function selectedAuthorChanged(item, index) {
            JsaDocumentFormService.handleSelectedAuthorChange(item, index, vm);
        }

        function selectedStudyChanged() {
            JsaDocumentFormService.refreshAvailableUnits(vm);
        }

        function addAuthor() {
            if (!vm.onUploadObj.authors) {
                vm.onUploadObj.authors = [];
            }
            vm.onUploadObj.authors.push({});
        }

        function removeAuthor(event, item) {
            vm.onUploadObj.authors.splice(item, 1);
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function saveData() {
            vm.isSaving = true;
            JsaDocumentFormService.inferOrganisationalUnitId(vm).then(
                function (organisationalUnitId) {
                    vm.onUploadObj.organisationalUnitId = organisationalUnitId;
                }
            ).then(
                function () {
                    JsaService.editJsaMetadata(vm.idDocument, vm.onUploadObj).then(function () {
                        $mdDialog.hide();
                    }, function (response) {
                        vm.isSaving = false;
                        PlagiatValidationService.getModalError(response.data, undefined, undefined, true)
                    });
                }
            );
        }

    }

    angular
        .module('plagiat2017App')
        .component(
            'jsaDocumentEditForm',
            {
                templateUrl: 'app/components/document/jsa-edit-form/jsa-document-edit-form.template.html',
                controller: JsaDocumentEditControler,
                controllerAs: 'vm'
            });

})();

(function () {
  'use strict';

  angular
    .module('plagiat2017App')
    .factory('ExtraOptionsService', ExtraOptionsService);

  ExtraOptionsService.$inject = [];

  function ExtraOptionsService() {

    var service = {
      recalculatePrices: recalculatePrices,
      getCurrentDocumentOptions: getCurrentDocumentOptions,
      isAiDetectionEnabled: isAiDetectionEnabled,
      isOptionDisabled: isOptionDisabled,
      resetForm: resetForm,
    };
    return service;

    function recalculatePrices(documentSize, vm) {
      vm.size = documentSize;
      vm.basePrice = (documentSize <= 500 && vm.freeChecksAvailable) ? 0
        : Math.ceil(documentSize / vm.charactersPerToken);
      vm.totalPrice = vm.basePrice;
      angular.forEach(vm.documentExtraOptions, function (option) {
        option.price =  Math.ceil(documentSize / option.charactersPerToken);
        if (option.id === 32 && (documentSize < 1000 || documentSize >= 999000)) {
          option.chosen = false;
        }
        if (option.chosen) {
          vm.totalPrice += option.price;
        }
        if (option.chosen && option.id == 32 && vm.translation) {
          vm.translation.chosen = false;
        }
      });
    }

    function resetForm(vm) {
      vm.basePrice = null
      vm.totalPrice = null;
      vm.documentExtraOptions = null;
      vm.translation = {};
    }

    function getCurrentDocumentOptions(vm) {
      return vm.documentExtraOptions.reduce(function (sum, option) {
        if (option.chosen) {
          return sum + option.id;
        } else {
          return sum;
        }
      }, 0);
    }

    function isAiDetectionEnabled(vm) {
      vm.aiEnabled = false;
      angular.forEach(vm.documentExtraOptions, function (option) {
        if (option.chosen && option.id == 32) {
          vm.aiEnabled = true;
        }
      });
      return vm.aiEnabled;
    }

    function isOptionEnabled(vm, id) {
      var result = false;
      angular.forEach(vm.documentExtraOptions, function (option) {
        if (option.chosen && option.id === id) {
          result = true;
        }
      });
      return result;
    }

    function isOptionDisabled(vm, documentSize, option) {
      if (option.id === 32) { // 32  => ai id
        // do not allow AI detection for very small and very big documents
        return documentSize < 1000 || documentSize >= 999000;
      }
      if (option.id === 4) { // 4  => ukrint id
        var priorityEnabled = isOptionEnabled(vm, 1); // 1 => priority id
        if (priorityEnabled === true) {
          option.chosen = false;
          recalculatePrices(documentSize, vm);
        }
        return priorityEnabled;
      }
      return false;
    }

  }
})();

(function() {
	'use strict';

    ExtraOptionsController.$inject = ['$scope', '$mdDialog', '$state', '$translate', 'AUTO_TRANSLATIONS_LANGS', 'Utils',
        'documentSize', 'documentId', 'onSuccess',
        'TokenService', 'DetectInstanceService', 'ExtraOptionsService'];

    function ExtraOptionsController($scope, $mdDialog, $state, $translate, AUTO_TRANSLATIONS_LANGS, Utils,
                                    documentSize, documentId, onSuccess,
                                    TokenService, DetectInstanceService, ExtraOptionsService) {
		var vm = this;
		vm.pending = true;
		vm.initializing = true;
		vm.checkDisabled = false;
		vm.instance = DetectInstanceService.instance();
        vm.autoTranslationLangs = Utils.sortAutoTranslationsLanguages(AUTO_TRANSLATIONS_LANGS, $translate);

		vm.tokenInfo = {};
		vm.freeChecksAvailable = true;
		vm.availableTokens = 0;
		vm.basePrice = 0;
		vm.size = 0;
		vm.totalPrice = 0;
		vm.closeDialog = closeDialog;
		vm.buyTokens = buyTokens;
		vm.checkDocument = checkDocument;
		vm.checkboxChange = checkboxChange;
		vm.translationsValidated = translationsValidated;
		vm.isAiDetectionEnabled = isAiDetectionEnabled;
		vm.isOptionDisabled = isOptionDisabled;

		init();

		function init() {
		    vm.pending = true;
		    vm.initializing = true;
            TokenService.getTokenPriceList({
                documentId: documentId,
                documentSize: documentSize
            }).then(function (responseData) {
                vm.charactersPerToken = responseData.data.charactersPerToken;
                vm.documentExtraOptions = responseData.data.extraOptions;
                vm.freeChecksAvailable = responseData.data.freeChecksAvailable;
                vm.translation = {};
                vm.translation.chosen = responseData.data.autoTranslations;
                vm.translation.autoTranslationsToLang = responseData.data.autoTranslationsToLang;
                // console.log('tr=' + JSON.stringify(vm.translation));
                recalculatePrices();
                TokenService.getInfo().then(function (responseData) {
                    vm.tokenInfo = responseData.data;
                    vm.availableTokens = responseData.data.availableTokens;
                    vm.pending = false;
                    vm.initializing = false;
                });
            });
        }

        function buyTokens() {
            TokenService.buyTokens = true;
            TokenService.tokensNedded = vm.totalPrice - vm.availableTokens;
            $mdDialog.hide();
            $state.go('payments', {documentId: documentId});
        }

        function checkDocument() {
            $mdDialog.hide();
            onSuccess(getCurrentDocumentOptions(), vm.totalPrice, vm.availableTokens);
        }

        function checkboxChange() {
            recalculatePrices();
        }

        function getCurrentDocumentOptions() {
          return ExtraOptionsService.getCurrentDocumentOptions(vm);
        }

        function isAiDetectionEnabled() {
		    return ExtraOptionsService.isAiDetectionEnabled(vm);
        }

        function isOptionDisabled(option) {
		    return ExtraOptionsService.isOptionDisabled(vm, vm.size, option);
        }

		function recalculatePrices() {
            return ExtraOptionsService.recalculatePrices(documentSize, vm);
		}

		function closeDialog() {
			$mdDialog.hide();
		}
		
		function translationsValidated() {
            if (vm.translation.chosen) {
                if (!vm.translation.autoTranslationsToLang) {
                    return false;
                }
            }
		    return true;
        }

	}

	angular
        .module('plagiat2017App')
        .controller('ExtraOptionsController', ExtraOptionsController);

})();

(function () {
  'use strict';

  AddPriorityController.$inject = ['$scope', '$rootScope', '$mdDialog', '$state', '$translate',
    'documentSize', 'documentId', 'onReloadDocuments', 'TokenService', 'ExtraOptionsService', 'DocumentService', 'PlagiatValidationService'];

  function AddPriorityController($scope, $rootScope, $mdDialog, $state, $translate, documentSize, documentId, onReloadDocuments,
                                 TokenService, ExtraOptionsService, DocumentService, PlagiatValidationService) {
    var vm = this;
    vm.pending = false;
    vm.initializing = true;
    vm.addPriority = addPriority;
    vm.buyTokensAndAddPriority = buyTokensAndAddPriority;
    vm.closeDialog = closeDialog;
    init();

    function init() {
      TokenService.getTokenPriceList({
        documentId: documentId,
        documentSize: documentSize
      }).then(function (responseData) {
        vm.charactersPerToken = responseData.data.charactersPerToken;
        vm.documentExtraOptions = responseData.data.extraOptions;
        recalculatePrices();
        TokenService.getInfo().then(function (responseData) {
          var availableTokens = responseData.data.availableTokens;
          var priorityOption = vm.documentExtraOptions.find(function (option) {
            return option.code === 'OPTION_PRIORITY'
          });
          vm.tokensNeeded = priorityOption.price;
          vm.tokensNeededToBuy = vm.tokensNeeded > availableTokens ? (vm.tokensNeeded - availableTokens) : 0;
          vm.initializing = false;
        });
      });
    }

    function buyTokensAndAddPriority() {
      TokenService.buyTokens = true;
      TokenService.buyPriority = true;
      TokenService.tokensNedded = vm.tokensNeededToBuy;
      $state.go('payments', {documentId: documentId});
      $mdDialog.hide();
    }

    function addPriority() {
      vm.pending = true;
      DocumentService.addPriority(documentId)
        .then(function () {
          $rootScope.$broadcast("availableTokens");
          onReloadDocuments();
          $mdDialog.hide();
        })
        .catch(function (response) {
          PlagiatValidationService.getModalError(response.data);
          $mdDialog.hide();
      });
    }

    function recalculatePrices() {
      return ExtraOptionsService.recalculatePrices(documentSize, vm);
    }

    function closeDialog() {
      $mdDialog.hide();
    }

  }

  angular
    .module('plagiat2017App')
    .controller('AddPriorityController', AddPriorityController);

})();

(function() {
	'use strict';
	angular.module('plagiat2017App').factory('DocumentReportXlsService',
			DocumentReportXlsService);

	DocumentReportXlsService.$inject = [ '$http', '$q', 'FileSaver', 'PlagiatValidationService', '$mdDialog', '$translate'];

	function DocumentReportXlsService($http, $q, FileSaver, PlagiatValidationService, $mdDialog, $translate) {
		var service = {
			generateReportXls: generateReportXls,
			generateReportSendXls : generateReportSendXls
		};
		return service;

		function generateReportXls(response, selected, searchRequest){
			var sendingEmailInfo = $translate.instant("document.report.xls.sending.email.info");

			var confirm = $mdDialog.confirm()
			.title($translate.instant("global.confirm.action"))
			.htmlContent(sendingEmailInfo)
			.ariaLabel($translate.instant("document.areyousure"))
			.ok($translate.instant("document.generate-report"))
			.cancel($translate.instant("global.button.cancel"))
			.openFrom('#left');

			$mdDialog.show(confirm).then(function () {
					service.generateReportSendXls({ids: selected}, searchRequest, response.selectedAll).then(function() {
						var generatingXlsMsg = $translate.instant("document.report.xls.report.generating.with.email.info1");
						generatingXlsMsg += '<br/>';
						generatingXlsMsg += $translate.instant("document.report.xls.report.generating.with.email.info2");
						$mdDialog.show(
								$mdDialog.confirm()
								.clickOutsideToClose(true)
								.title('')
								.htmlContent(generatingXlsMsg)
								.ariaLabel('ok')
								.ok('OK')
								);

					}, function(response) {
						PlagiatValidationService.getModalError(response.data);
					});
			});

		}

		function generateReportSendXls(ids, searchRequest, selectedAll) {
			var url = selectedAll ? 'api/document/report/xls/search/send-xls': 'api/document/report/xls/selected/send-xls';
			var data = selectedAll ? searchRequest:ids;

			return $http({
				url : url,
				method : "POST",
				data : data,
				headers : {
					'Content-type' : 'application/json'
				}
			})
		}

	}

})();

(function() {
	'use strict';

	function DocumentOperatorDetailsController($scope, $log, DOCUMENT_STATUS, AccountService) {
		var vm = this;
		vm.DOCUMENT_STATUS = DOCUMENT_STATUS;
		vm.addPriorityFromContractEnabled = AccountService.getClientSettings().addPriorityFromContractEnabled;
	}

	angular
	.module('plagiat2017App')
	.component(
		'documentOperatorDetails',
		{
			templateUrl : 'app/components/document/document-operator-details/document-operator-details.template.html',
			controller : DocumentOperatorDetailsController,
			bindings: {
				onDocument: '<',
				onDocumentDetails: '<',
                onIsSuperadmin: '<',

			}
		});

})();

(function() {
	'use strict';

	function DocumentHistoryController($scope, $mdDialog, DocumentService, $log) {
		var vm = this;
		vm.closeDialog = closeDialog;
		vm.idDocument = DocumentService.document.id;
		vm.getDocumentHistory = getDocumentHistory;

		function closeDialog() {
			$mdDialog.hide();
		}

		function getDocumentHistory() {
			DocumentService.getDocumentHistory(vm.idDocument).then(function(response) {
				vm.documentHistoryList = response.data;
			});
		}

		if (vm.idDocument !== null) {
			getDocumentHistory();
		}

	}

	angular
			.module('plagiat2017App')
			.component(
					'documentHistory',
					{
						templateUrl : 'app/components/document/document-history/document-history.template.html',
						controller : DocumentHistoryController
					});

})();

(function() {
	'use strict';

	function DocumentFormIndividualController($scope, $mdDialog,
			DocumentService, DocumentIndividualService, $localStorage, $log, $q, _, $timeout) {
		var vm = this;
		vm.closeDialog = closeDialog;
		vm.saveData = saveData;
		vm.idDocument = DocumentService.document.id;

		function getForm(idDocument) {
			DocumentIndividualService.getForm(idDocument).then(
				function(responseData) {
					vm.form = responseData.data;
			});
		}

		function closeDialog() {
			$mdDialog.hide();
		}

		function saveData(form) {
			DocumentIndividualService.editDetails(form).then(function(responseData) {
				$mdDialog.hide();
			});
		}

		if (vm.idDocument !== null) {
			getForm(vm.idDocument);
		}

	}

	angular
	.module('plagiat2017App')
	.component(
		'documentFormIndividual',
		{
			templateUrl : 'app/components/document/document-form-individual/document-form-individual.template.html',
			controller : DocumentFormIndividualController
		});

})();

(function() {
	'use strict';

	function DocumentFormController($scope, $mdDialog, AccountService,
		DocumentService, $localStorage, $log, OrganisationalUnitsService,
		DocumentKindService, DocumentParameterDefinitionService, $q, _, $timeout, PERMISSIONS) {
		var vm = this;
		vm.closeDialog = closeDialog;
		vm.saveData = saveData;
		vm.idDocument = DocumentService.document.id;
		vm.findOrganisationalUnits = findOrganisationalUnits;
		vm.findDocumentKinds = findDocumentKinds;
		vm.addAuthor = addAuthor;
		vm.removeAuthor = removeAuthor;
		vm.selectedItemChange = selectedItemChange;
		vm.setCoordinatorId = setCoordinatorId;
		vm.querySearch = querySearch;
		vm.getDocumentSkipAddress = getDocumentSkipAddress;
		vm.authorsSimplifiedFields = AccountService.account.clientSettings.authorsSimplifiedFields;
		vm.canChangeOrganisationUnit = AccountService.getPermision(PERMISSIONS.PERM_USER_CAN_CHANGE_ORG_UNIT_DURING_ADD_DOCUMENT) || AccountService.role.isAdmin();
		vm.clientTypePublishingHouse = AccountService.clientType.isPublishingHouse();
		vm.clientTypeSchool = AccountService.clientType.isSchool();
		vm.isLecturer = AccountService.role.isLecturer();
		vm.coordinatorLabel = vm.clientTypeSchool ? 'document.metric.client-type.school.teacher' : 'document.model.docu-coordinator';
		vm.canEditPromoter = canEditPromoter;

		//to refactor functionality => adding and updating document form should be in one component
		function selectedItemChange(item) {
			vm.form.coordinatorId = angular.isUndefined(item) ? null : item.value.coordinatorId;
			vm.form.docuCoordinator = angular.isUndefined(item) ? null : item.label;
		}

		function setCoordinatorId() {
			vm.form.coordinatorId = vm.uploadObj.coordinatorInfo.selectItems[0].value.coordinatorId;
		}

		function canEditPromoter() {
			return (vm.isLecturer && AccountService.getClientSettings().userTeacherCanChangePromoterDuringAddDocument)
				|| AccountService.role.isAdmin() || AccountService.role.isOperator() || AccountService.role.isSuperAdmin();
		}

		function lowercase(string) {
			return angular.isString(string) ? string.toLowerCase() : string;
		}

	    function querySearch (query) {
	        vm.promoters = vm.uploadObj.coordinatorInfo.selectItems;
	        var results = query ? _.filter(vm.promoters, function(o) { return lowercase(o.label).indexOf(lowercase(query)) !== -1; }) : vm.promoters;
	        var deferred = $q.defer();
	        $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
	        return deferred.promise;
	    }
		function getUploadFormConfiguration(obj){
            var deferred = $q.defer();
            DocumentService.operator.getConfiguration(vm.idDocument).then(function(response){
                vm.uploadObj = Object.assign( response.data, obj);
            });
            deferred.resolve(vm.uploadObj);
            return deferred.promise;
        }

		function addAuthor() {
			if (!vm.form) {
				vm.form = {};
			}
			if (!vm.form.documentAuthors) {
				vm.form.documentAuthors = {};
			}
			var authorForm = {
				documentId : vm.idDocument,
				status : 0
			};
			vm.form.documentAuthors.push(authorForm);
		}

		function removeAuthor(index) {
			if (vm.form && vm.form.documentAuthors) {
				vm.form.documentAuthors.splice(index, 1);
			}
			// $(event.target).parent().parent().remove();
		}

		function getMetadataForm(idDocument) {
			DocumentService.getMetadataForm(idDocument).then(
				function(responseData) {
					vm.form = responseData.data;
					if(vm.form.documentSkipAddresses == null){
						vm.form.documentSkipAddresses = [];
					}

					vm.selectedItem = vm.form.docuCoordinator;
					getUploadFormConfiguration(responseData.data).then(function(response){
	                    vm.uploadObj = response;
	                });
				});
		}

		function getDocumentSkipAddress(chip) {
		      return {
		        address: chip
		      };
		};

		function closeDialog() {
			$mdDialog.hide();
		}

		function saveData(form) {
			DocumentService.editDetails(form).then(function(responseData) {
				$mdDialog.hide();
			});
		}

		function findOrganisationalUnits() {
			OrganisationalUnitsService.findAllForClient(vm.idDocument).then(function(response) {
				vm.organisationalUnits = response.data;
			});
		}

		function findDocumentKinds() {
			DocumentKindService.findAll(vm.idDocument).then(function(response) {
				vm.docuKinds = response.data;
			});
		}

		function findSpecializations() {
			var dopadeName = "kierunek";
			DocumentParameterDefinitionService.findOneByName(dopadeName).then(
				function(data) {
					vm.specialization = data;
				});
		}

		if (vm.idDocument !== null) {
			getMetadataForm(vm.idDocument);
		}

		findSpecializations();
		findDocumentKinds();
		findOrganisationalUnits();
	}

	angular
	.module('plagiat2017App')
	.component(
		'documentForm',
		{
			templateUrl : 'app/components/document/document-form/document-form.template.html',
			controller : DocumentFormController
		});

})();

(function() {
	'use strict';

	function DocumentDetailsController($scope, $log) {    
	}

	angular
			.module('plagiat2017App')
			.component(
					'documentDetails',
					{
						templateUrl : 'app/components/document/document-details/document-details.template.html',
						controller : DocumentDetailsController,
						bindings: {
							onDocument: '<',
                    		onDocumentDetails: '<'
                }
					});

})();


(function() {
    'use strict';

    function detectTabsController(Auth, $state, $scope) {


            // window.onbeforeunload = function (e) {
            //    //Auth.logout();
            //    // Firefox || IE
            //     e = e || window.event;

            //     var y = e.pageY || e.clientY;

            //     if(y < 0)  {
            //         
            //         //return "fdgfhgjkghfg";
            //     }
            //     else {
            //         
            //         return "fdgfhgjkghfg";
            //     }



            //     return "fdgfhgjkghfg";
            // }


            // var myEvent = window.attachEvent || window.addEventListener;
            // var chkevent = window.attachEvent ? 'onbeforeunload' : 'beforeunload'; /// make IE7, IE8 compitable

            // myEvent(chkevent, function(e) { // For >=IE7, Chrome, Firefox
            //     var confirmationMessage = 'Are you sure to leave the page?';  // a space
            //     (e || window.event).returnValue = confirmationMessage;
            //     return confirmationMessage;
            // });


            // window.addEventListener('onbeforeunload',function(e) {
            //   var dialogText = 'onbeforeunload';
            //   e.returnValue = dialogText;
            //   return dialogText;
            // })
            // window.addEventListener('beforeunload',function(e) {
            //   var dialogText = 'beforeunload';
            //   e.returnValue = dialogText;
            //   return dialogText;
            // })


    }

    angular.module('detectTabs', [])
        .component('detectTabs', {
            templateUrl: 'app/components/detect-tabs/detect-tabs.template.html',
            controller: detectTabsController
        });

})();

// (function () {
//     'use strict';

//     angular
//     .module('plagiat2017App')
//     .factory('BeforeUnload', BeforeUnload)
    

// })();

(function () {
	'use strict';

	function DetectLandingController($state, $log, $location, $window) {
		var vm = this;
		vm.host = $location.host();
		vm.path = $location.path();

		vm.params = '';
		vm.gclid = location.search.split('gclid=')[1];
		vm.gclidUrl = '';

		if( Object.keys($location.search()).length > 0 ){
			vm.params += '?';
			angular.forEach($location.search(), function (value, key) {
				vm.params += key +'='+value+'&';
			});
		}

		if( angular.isDefined(vm.gclid) ){
			vm.gclidUrl = '/?gclid='+vm.gclid;
		}
		if( vm.gclid === 'undefined'){
			vm.gclidUrl = '';
		}

		if( vm.host === 'sprawdz-prace.plagiat.pl' || vm.host === 'sprawdz.plagiat.pl' ) {
			if( vm.path === '/sprawdz' || vm.path === '/' || vm.path === ''){
				$window.location.href = vm.gclidUrl+'#/sprawdz'+vm.params;
			}
			if( vm.path === '/documents'){
				$window.location.href = vm.gclidUrl+'#/documents'+vm.params;
			}
		}
		if( vm.host === 'check-paper.strikeplagiarism.com'
            || vm.host === 'check-paper-for-plagiarism.strikeplagiarism.com'
            || vm.host === 'plagiat-tekseru-antiplagiat.strikeplagiarism.com'
            || vm.host === 'prover-rabotu-antiplagiat.strikeplagiarism.com'
            || vm.host === 'antiplagiat.strikeplagiarism.com'
            || vm.host === 'perevirka-na-plagiat-antiplagiat.strikeplagiarism.com'
            || vm.host === 'plagiata-yoxlamaq-antiplagiat.strikeplagiarism.com'
            || vm.host === 'plagiatni-tekshiring-antiplagiat.strikeplagiarism.com'
			|| vm.host === 'dokument-auf-plagiat-prufen.strikeplagiarism.com'
			|| vm.host === 'sheamotsmet-dokumenti-plagiatis-shesakheb.strikeplagiarism.com'
			|| vm.host === 'proverete-dokumenta-za-plagiat-stvo.strikeplagiarism.com'
			|| vm.host === 'intihal-ile-ilgili-belgeyi-kontrol-et.strikeplagiarism.com'
			|| vm.host === 'comprobar-documento-sobre-plagio.strikeplagiarism.com'
			|| vm.host === 'verifique-o-artigo-quanto-a-plagio.strikeplagiarism.com'
			|| vm.host === 'verification-du-plagiat.strikeplagiarism.com'
			|| vm.host === 'verifica-del-plagio.strikeplagiarism.com'
        ) {
			if( vm.path === '/check' || vm.path === '/' || vm.path === ''){
				$window.location.href = vm.gclidUrl+'#/check'+vm.params;
			}
			if( vm.path === '/documents'){
				$window.location.href = vm.gclidUrl+'#/documents'+vm.params;
			}
		}
		if( vm.host === 'verifica-textul.sistemantiplagiat.ro') {
			if( vm.path === '/verifica' || vm.path === '/' || vm.path === ''){
				$window.location.href = vm.gclidUrl+'#/verifica'+vm.params;
			}
			if( vm.path === '/documents'){
				$window.location.href = vm.gclidUrl+'#/documents'+vm.params;
			}
		}
		// if( vm.host === 'localhost') {
		// 	if( vm.path === '/sprawdz' || vm.path === '/' || vm.path === ''){
		// 		$window.location.href = vm.gclidUrl+'#/sprawdz'+vm.params;
		// 	}
		// 	if( vm.path === '/documents'){
		// 		$window.location.href = vm.gclidUrl+'#/documents'+vm.params;
		// 	}
		// }


	}

	angular.module('plagiat2017App')
	.component('detectLanding', {
		controller: DetectLandingController
	});

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .constant('INSTANCES', [
                {
                    instance: 'pl', settings: {
                        lang: 'pl',
                        domain: 'plagiat.pl',
                        landingLink: 'https://plagiat.pl',
                        domainGTM: 'GTM-MQMNQ4VK',
                        domainUa: 'G-Z7RZ9JE8CD',
                        domainAw: 'AW-861372621',
                        domainAwCode: 'AW-861372621/4aAECJH_vW8QzYHemgM',
                        helpSettings: [
                            {
                                lang: 'pl',
                                emails: [{name: 'pomoc@antyplagiat.pl', email: 'pomoc@antyplagiat.pl'}]},
                            {
                                lang: 'ro',
                                emails: [{name: 'contact@sistemantiplagiat.ro', email: 'contact@sistemantiplagiat.ro'}]
                            },
                            {
                                lang: 'default',
                                emails: [{name: 'help@strikeplagiarism.com', email: 'help@strikeplagiarism.com'}]
                            }
                        ],
                        currencies: {
                            default: 'PLN',
                            list: ['PLN', 'EUR', 'USD', 'UAH', 'KZT'],
                            settings: [
                                {name: 'PLN', methodsOfPayment: ["TYPE_TRANSFER", "TYPE_BLIK", "TYPE_PAY_PAL"], invoice: true},
                                {name: 'EUR', methodsOfPayment: ["TYPE_TRANSFER", "TYPE_PAY_PAL"], invoice: true},
                                {name: 'USD', methodsOfPayment: ["TYPE_TRANSFER", "TYPE_PAY_PAL"], invoice: true},
                                {name: 'UAH', methodsOfPayment: ["TYPE_EASY_PAY"], invoice: false},
                                {name: 'KZT', methodsOfPayment: ["TYPE_KASSA_24_CARD"], invoice: false}
                            ],
                            langSettings: [
                                {lang: 'pl', currency: 'PLN'},
                                {lang: 'en', currency: 'EUR'},
                                {lang: 'de', currency: 'EUR'},
                                {lang: 'es', currency: 'EUR'},
                                {lang: 'ro', currency: 'EUR'},
                                {lang: 'ru', currency: 'USD'},
                                {lang: 'az', currency: 'USD'},
                                {lang: 'ka', currency: 'USD'},
                                {lang: 'uk', currency: 'UAH'},
                                {lang: 'kk', currency: 'USD'},
                                {lang: 'tr', currency: 'USD'}
                            ],
                            landingCurrencies: [
                                {lang: 'pl', defaultCurrency: 'PLN', currencyList: ['PLN', 'EUR', 'USD']},
                                {lang: 'en', defaultCurrency: 'PLN', currencyList: ['PLN', 'EUR', 'USD']}
                            ]
                        },
                        timezone: '',
                        timezoneDocuments: '',
                        timezonePayments: '',
                        timezones: [
                            {
                                subdomain: 'st',
                                timezone: 'Europe/Warsaw',
                                documents: 'Europe/Warsaw',
                                payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'test',
                                timezone: 'Europe/Warsaw',
                                documents: 'Europe/Warsaw',
                                payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'sprawdz',
                                timezone: 'Europe/Warsaw',
                                documents: 'Europe/Warsaw',
                                payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'sprawdz-prace',
                                timezone: 'Europe/Warsaw',
                                documents: 'Europe/Warsaw',
                                payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'preprod',
                                timezone: 'Europe/Warsaw',
                                documents: 'Europe/Warsaw',
                                payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'panel',
                                timezone: 'Europe/Warsaw',
                                documents: 'Europe/Warsaw',
                                payments: 'Europe/Warsaw'
                            }
                        ],
                        timeFormat: 'yyyy-MM-dd HH:mm'
                    }
                },
                {
                    instance: 'aka', settings: {
                        lang: 'pl',
                        domain: 'akambiko.pl',
                        landingLink: 'https://akambiko.pl',
                        domainGTM: 'GTM-MQMNQ4VK',
                        domainUa: 'G-Z7RZ9JE8CD',
                        domainAw: 'AW-861372621',
                        domainAwCode: 'AW-861372621/4aAECJH_vW8QzYHemgM',
                        helpSettings: [
                            {
                                lang: 'pl',
                                emails: [{name: 'pomoc@antyplagiat.pl', email: 'pomoc@antyplagiat.pl'}]},
                            {
                                lang: 'ro',
                                emails: [{name: 'contact@sistemantiplagiat.ro', email: 'contact@sistemantiplagiat.ro'}]
                            },
                            {
                                lang: 'default',
                                emails: [{name: 'help@strikeplagiarism.com', email: 'help@strikeplagiarism.com'}]
                            }
                        ],
                        currencies: {
                            default: 'PLN',
                            list: ['PLN', 'EUR', 'USD', 'UAH', 'KZT', 'AZN'],
                            settings: [
                                {name: 'PLN', methodsOfPayment: ["TYPE_TRANSFER", "TYPE_PAY_PAL", "TYPE_BLIK"]},
                                {name: 'EUR', methodsOfPayment: ["TYPE_TRANSFER", "TYPE_PAY_PAL"]}
                            ],
                            langSettings: [
                                {lang: 'pl', currency: 'PLN'},
                                {lang: 'en', currency: 'EUR'}
                            ],
                            landingCurrencies: [
                                {lang: 'pl', defaultCurrency: 'PLN'}
                            ]
                        },
                        timezone: '',
                        timezoneDocuments: '',
                        timezonePayments: '',
                        timezones: [
                            {
                                subdomain: 'st',
                                timezone: 'Europe/Warsaw',
                                documents: 'Europe/Warsaw',
                                payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'sprawdz',
                                timezone: 'Europe/Warsaw',
                                documents: 'Europe/Warsaw',
                                payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'sprawdz-prace',
                                timezone: 'Europe/Warsaw',
                                documents: 'Europe/Warsaw',
                                payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'preprod',
                                timezone: 'Europe/Warsaw',
                                documents: 'Europe/Warsaw',
                                payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'panel',
                                timezone: 'Europe/Warsaw',
                                documents: 'Europe/Warsaw',
                                payments: 'Europe/Warsaw'
                            }
                        ],
                        timeFormat: 'yyyy-MM-dd HH:mm'
                    }
                },
                {
                    instance: 'int', settings: {
                        lang: 'en',
                        domain: 'strikeplagiarism.com',
                        landingLink: 'https://strikeplagiarism.com',
                        domainGTM: 'GTM-0000000000',
                        domainUa: 'G-D23R1YN241',
                        domainAw: 'AW-11429142773',
                        domainAwCode: 'AW-11429142773/_KQcCLKX0_sYEPXB68kq',
                        helpSettings: [
                            {
                                lang: 'pl',
                                emails: [{name: 'pomoc@antyplagiat.pl', email: 'pomoc@antyplagiat.pl'}]},
                            {
                                lang: 'ro',
                                emails: [{name: 'contact@sistemantiplagiat.ro', email: 'contact@sistemantiplagiat.ro'}]
                            },
                            {
                                lang: 'default',
                                emails: [{name: 'help@strikeplagiarism.com', email: 'help@strikeplagiarism.com'}]
                            },
                            {
                                lang: 'uk',
                                emails: [{name: 'ukraine@strikeplagiarism.com', email: 'ukraine@strikeplagiarism.com'}]
                            }
                        ],
                        currencies: {
                            default: 'EUR',
                            list: ['EUR', 'PLN', 'USD', 'UAH', 'KZT', 'AZN', 'UZS'],
                            settings: [
                                {name: 'PLN', methodsOfPayment: ["TYPE_PAY_PAL"], invoice: true},
                                {name: 'EUR', methodsOfPayment: ["TYPE_PAY_PAL"], invoice: true},
                                {name: 'USD', methodsOfPayment: ["TYPE_PAY_PAL"], invoice: true},
                                {name: 'UAH', methodsOfPayment: ["TYPE_EASY_PAY"], invoice: false},
                                {name: 'KZT', methodsOfPayment: ["TYPE_KASPI_BANK", "TYPE_FORTE_KZ", "TYPE_KASSA_24_CARD"], invoice: false},
                                {name: 'AZN', methodsOfPayment: ["TYPE_YIGIM_AZ"], invoice: false}, //TYPE_UNIBANK_AZ
                                {name: 'UZS', methodsOfPayment: ["TYPE_PAYME"], invoice: false},
                                // {name: 'BGN', methodsOfPayment: ["TYPE_EPAY_BG"], invoice: false}
                            ],
                            langSettings: [
                                {lang: 'pl', currency: 'PLN'},
                                {lang: 'en', currency: 'EUR'},
                                {lang: 'de', currency: 'EUR'},
                                {lang: 'es', currency: 'EUR'},
                                {lang: 'ro', currency: 'EUR'},
                                {lang: 'ru', currency: 'KZT'}, //tenge takze dla rosyjskiego
                                {lang: 'az', currency: 'AZN'}, //manat dla azerbejdzanu
                                {lang: 'ka', currency: 'USD'},
                                {lang: 'uk', currency: 'UAH'}, // grywny dla ukraincow
                                {lang: 'kk', currency: 'KZT'}, // tenge dla kazachow
                                {lang: 'bg', currency: 'EUR'}, // euro dla bułgarskiego
                                {lang: 'fr', currency: 'EUR'}, // euro dla francuskiego
                                {lang: 'it', currency: 'EUR'}  // euro dla włoskiego
                            ],
                            landingCurrencies: [
                                {lang: 'pl', defaultCurrency: 'PLN'},
                                {lang: 'en', defaultCurrency: 'EUR', currencyList: ['EUR', 'USD', 'AZN', 'KZT', 'UAH', 'UZS']},
                                {lang: 'ru', defaultCurrency: 'USD', currencyList: ['EUR', 'USD', 'AZN', 'KZT', 'UAH', 'UZS']},
                                {lang: 'az', defaultCurrency: 'AZN'},
                                {lang: 'kk', defaultCurrency: 'KZT'}, //kazach
                                {lang: 'uk', defaultCurrency: 'UAH'},
                                {lang: 'ka', defaultCurrency: 'USD'}, //georgian
                                {lang: 'de', defaultCurrency: 'EUR'},
                                {lang: 'es', defaultCurrency: 'EUR'},
                                {lang: 'bg', defaultCurrency: 'EUR'},
                                {lang: 'fr', defaultCurrency: 'EUR'},
                                {lang: 'it', defaultCurrency: 'EUR'},
                                {lang: 'tr', defaultCurrency: 'EUR', currencyList: ['EUR', 'USD']},
                                {lang: 'uz', defaultCurrency: 'UZS', currencyList: ['UZS', 'USD']},
                            ]
                        },
                        timezone: '',
                        timezoneDocuments: '',
                        timezonePayments: '',
                        timezones: [
                            {
                                subdomain: 'st',
                                timezone: 'Europe/Warsaw',
                                documents: 'Europe/Warsaw',
                                payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'check-paper',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'check-paper-for-plagiarism',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'plagiat-tekseru-antiplagiat',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'prover-rabotu-antiplagiat',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'antiplagiat',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'perevirka-na-plagiat-antiplagiat',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'plagiata-yoxlamaq-antiplagiat',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'plagiatni-tekshiring-antiplagiat',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'dokument-auf-plagiat-prufen',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'sheamotsmet-dokumenti-plagiatis-shesakheb',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'proverete-dokumenta-za-plagiat-stvo',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'intihal-ile-ilgili-belgeyi-kontrol-et',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'comprobar-documento-sobre-plagio',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'verifique-o-artigo-quanto-a-plagio',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'verification-du-plagiat',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'verifica-del-plagio',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'preprod',
                                timezone: 'Europe/Warsaw', documents: 'Europe/Warsaw', payments: 'Europe/Warsaw'
                            },
                            {
                                subdomain: 'panel',
                                timezone: 'Europe/Warsaw',
                                documents: 'Europe/Warsaw',
                                payments: 'Europe/Warsaw'
                            }
                        ],
                        timeFormat: 'yyyy-MM-dd HH:mm'
                    }
                },
                {
                    instance: 'ro', settings: {
                        lang: 'ro',
                        domain: 'sistemantiplagiat.ro',
                        landingLink: 'https://sistemantiplagiat.ro',
                        domainGTM: 'GTM-0000000000',
                        domainUa: 'G-H13XM1CF6S',
                        domainAw: 'AW-874812094',
                        domainAwCode: 'AW-874812094/Jk2hCN7Ho4oBEL6lkqED',
                        helpSettings: [
                            {
                                lang: 'default',
                                emails: [{name: 'contact@sistemantiplagiat.ro', email: 'contact@sistemantiplagiat.ro'}]
                            }
                        ],
                        currencies: {
                            default: 'RON',
                            list: ['RON', 'EUR', 'USD'],
                            settings: [
                                {name: 'RON', methodsOfPayment: ["TYPE_MOBILPAY_CARD"], invoice: true},
                                {name: 'EUR', methodsOfPayment: ["TYPE_PAY_PAL_RO"], invoice: true},
                                {name: 'USD', methodsOfPayment: ["TYPE_PAY_PAL_RO"], invoice: true}
                            ],
                            langSettings: [
                                {lang: 'pl', currency: 'EUR'},
                                {lang: 'en', currency: 'EUR'},
                                {lang: 'de', currency: 'EUR'},
                                {lang: 'es', currency: 'EUR'},
                                {lang: 'ro', currency: 'RON'},
                                {lang: 'ru', currency: 'EUR'},
                                {lang: 'az', currency: 'EUR'},
                                {lang: 'ka', currency: 'EUR'},
                                {lang: 'uk', currency: 'EUR'},
                                {lang: 'kk', currency: 'EUR'},
                                {lang: 'tr', currency: 'EUR'}
                            ],
                            landingCurrencies: [
                                {lang: 'ro', defaultCurrency: 'RON'}
                            ]
                        },
                        timezone: '',
                        timezoneDocuments: '',
                        timezonePayments: '',
                        timezones: [
                            {
                                subdomain: 'st',
                                timezone: 'Europe/Bucharest',
                                documents: 'Europe/Bucharest',
                                payments: 'Europe/Bucharest'
                            },
                            {
                                subdomain: 'test',
                                timezone: 'Europe/Bucharest',
                                documents: 'Europe/Bucharest',
                                payments: 'Europe/Bucharest'
                            },
                            {
                                subdomain: 'verifica-textul',
                                timezone: 'Europe/Bucharest',
                                documents: 'Europe/Bucharest',
                                payments: 'Europe/Bucharest'
                            },
                            {
                                subdomain: 'preprod',
                                timezone: 'Europe/Bucharest',
                                documents: 'Europe/Bucharest',
                                payments: 'Europe/Bucharest'
                            },
                            {
                                subdomain: 'panel',
                                timezone: 'Europe/Bucharest',
                                documents: 'Europe/Bucharest',
                                payments: 'Europe/Warsaw'
                            }
                        ],
                        timeFormat: 'yyyy-MM-dd HH:mm'
                    }
                }
            ]
        );
})();

(function () {
    'use strict';
    /*
    domain
    instance: pl | ro - rumunian | int - international
    pixel - fb-pixel enabled
    ua - google analytics active/not active
    conversion - adwords conversion
    */
    angular
    .module('plagiat2017App')
    .constant('DOMAINS', [
        { domain: 'localhost',                instance: 'pl', lang : 'en', pixel: false, ua: true, conversion: false, fb: true, disableRegister:false, redirect: false, landingLang: 'en', oauth: ['sdu', 'google'], saml: ['other','saml3', 'valencia']  },
        { domain: '127.0.0.1',                instance: 'pl', lang : 'en', pixel: false, ua: true, conversion: false, fb: true, disableRegister:false, redirect: false, landingLang: 'en', oauth: ['sdu'], saml: ['other','saml3', 'valencia']  },
        { domain: 'st.plagiat.pl',            instance: 'pl', lang : 'pl', pixel: true,  ua: false, conversion: false, fb: true, disableRegister:false, redirect: true, landingLang: 'pl', oauth: ['sdu'], saml: ['other', 'valencia'] },
        { domain: 'preprod.plagiat.pl',       instance: 'pl', lang : 'pl', pixel: true,  ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'pl' },
        { domain: 'test.plagiat.pl',          instance: 'pl', lang : 'pl', pixel: true,  ua: true, conversion: true, fb: true, disableRegister:false, redirect: true },
        { domain: 'panel.plagiat.pl',         instance: 'pl', lang : 'pl', pixel: true,  ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'pl', saml: ['bfg']},
        { domain: 'sprawdz-prace.plagiat.pl', instance: 'pl', lang : 'pl', pixel: true,  ua: true, conversion: true, fb: false, disableRegister:true, redirect: true, landingLang: 'pl'},
        { domain: 'sprawdz.plagiat.pl',       instance: 'pl', lang : 'pl', pixel: true,  ua: true, conversion: true, fb: false, disableRegister:true, redirect: true, landingLang: 'pl'},

        { domain: 'st.akambiko.pl',      instance: 'aka', lang : 'pl', pixel: false, ua: false, conversion: false, fb: false, disableRegister:true, redirect: true },
        { domain: 'preprod.akambiko.pl', instance: 'aka', lang : 'pl', pixel: false, ua: false, conversion: false, fb: false, disableRegister:true, redirect: true },
        { domain: 'panel.akambiko.pl',   instance: 'aka', lang : 'pl', pixel: false, ua: false, conversion: false, fb: false, disableRegister:true, redirect: true },
        
        { domain: 'st.sistemantiplagiat.ro',              instance: 'ro', lang : 'ro', pixel: false, ua: false, conversion: false, fb: true, disableRegister:false, redirect: false, landingLang: 'ro' },
        { domain: 'test.sistemantiplagiat.ro',            instance: 'ro', lang : 'ro', pixel: false, ua: false, conversion: false, fb: true, disableRegister:false, redirect: false },
        { domain: 'preprod.sistemantiplagiat.ro',         instance: 'ro', lang : 'ro', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'ro' },
        { domain: 'panel.sistemantiplagiat.ro',           instance: 'ro', lang : 'ro', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'ro' },
        { domain: 'verifica-textul.sistemantiplagiat.ro', instance: 'ro', lang : 'ro', pixel: false, ua: true, conversion: true, fb: false, disableRegister:true, redirect: true, landingLang: 'ro' },
        
        { domain: 'st.strikeplagiarism.com',          instance: 'int', lang : 'en', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'en', oauth: ['google'], saml: ['other','saml3', 'valencia', 'sts1'] },
        { domain: 'test.strikeplagiarism.com',        instance: 'int', lang : 'en', pixel: false, ua: false, conversion: false, fb: true, disableRegister:false, redirect: true, landingLang: 'en' },
        { domain:                      'check-paper.strikeplagiarism.com', instance: 'int', lang : 'en', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'en' },
        { domain:       'check-paper-for-plagiarism.strikeplagiarism.com', instance: 'int', lang : 'en', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'en' },
        { domain:      'plagiat-tekseru-antiplagiat.strikeplagiarism.com', instance: 'int', lang : 'kk', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'kk' },
        { domain:        'prover-rabotu-antiplagiat.strikeplagiarism.com', instance: 'int', lang : 'ru', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'ru' },
        { domain:                      'antiplagiat.strikeplagiarism.com', instance: 'int', lang : 'ru', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'ru' },
        { domain: 'perevirka-na-plagiat-antiplagiat.strikeplagiarism.com', instance: 'int', lang : 'uk', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'uk' },
        { domain:    'plagiata-yoxlamaq-antiplagiat.strikeplagiarism.com', instance: 'int', lang : 'az', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'az' },
        
        { domain:          'plagiatni-tekshiring-antiplagiat.strikeplagiarism.com', instance: 'int', lang : 'uz', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'uz' },
        { domain:               'dokument-auf-plagiat-prufen.strikeplagiarism.com', instance: 'int', lang : 'de', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'de' },
        { domain: 'sheamotsmet-dokumenti-plagiatis-shesakheb.strikeplagiarism.com', instance: 'int', lang : 'ka', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'ka' },
        { domain:       'proverete-dokumenta-za-plagiat-stvo.strikeplagiarism.com', instance: 'int', lang : 'bg', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'bg' },
        { domain:     'intihal-ile-ilgili-belgeyi-kontrol-et.strikeplagiarism.com', instance: 'int', lang : 'tr', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'tr' },
        { domain:          'comprobar-documento-sobre-plagio.strikeplagiarism.com', instance: 'int', lang : 'es', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'es' },
        { domain:        'verifique-o-artigo-quanto-a-plagio.strikeplagiarism.com', instance: 'int', lang : 'pt-pt', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'pt' },
        { domain:                   'verification-du-plagiat.strikeplagiarism.com', instance: 'int', lang : 'fr', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'fr' },
        { domain:                       'verifica-del-plagio.strikeplagiarism.com', instance: 'int', lang : 'it', pixel: false, ua: true, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'it' },

        { domain: 'preprod.strikeplagiarism.com',     instance: 'int', lang : 'en', pixel: false, ua: false, conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'en' },
        { domain: 'panel.strikeplagiarism.com',       instance: 'int', lang : 'en', pixel: false, ua: true,  conversion: true, fb: true, disableRegister:false, redirect: true, landingLang: 'en', oauth: ['sdu', 'satbayev', 'salta'], saml: ['valencia', 'valladolid', 'jaen', 'tartu', 'tallinn', 'taltech', 'unibit', 'tampere', 'chevron', 'ilmenau', 'eah_jena_de', 'hochschule', 'eesc', 'eesc2', 'hepl', 'lviv', 'gottingen', 'castilla', 'saxony' ] }
        ]);
})();

(function() {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('DetectInstanceService', DetectInstanceService);

    DetectInstanceService.$inject = ['$http', '$q', '$location', '$log', 'DOMAINS', 'INSTANCES'];

    function DetectInstanceService($http, $q, $location, $log, DOMAINS, INSTANCES) {
        var instanceLang, landingLang, uaConfig = {}, conversion, fb, register, domain;
        var host = $location.host();

        var service = {
            instance : getInstance,
            getLandingLang : getLandingLang,
            getAll: getAll,
            getUAConfig: getUAConfig,
            getPixelEnabled: getPixelEnabled,
            getConversionAllowance: getConversionAllowance,
            samlLoginButtons: samlLoginButtons,
            oauthLoginButtons: oauthLoginButtons,
            getFbLoginForm: getFbLoginForm,
            getAllowRegister: getAllowRegister,
            getInstanceDomain: getInstanceDomain,
            isRedirectEnabled: isRedirectEnabled
        };

        return service;

    function getInstance() {
        angular.forEach(DOMAINS, function(value) {
            if( host === value.domain ) {
                instanceLang = value.instance;
            }
        });
        return instanceLang;
    }

    function getLandingLang() {
        angular.forEach(DOMAINS, function(value) {
            if( host === value.domain ) {
                landingLang = value.landingLang;
            }
        });
        return landingLang;
    }

    function getInstanceDomain(instance) {

        if(host === 'localhost'){
            return 'localhost';
        }

        var subDomain = host.split('.')[0] + '.';

        angular.forEach(DOMAINS, function(value) {
            if( instance === value.instance && value.domain.startsWith(subDomain) ) {
                domain = value.domain;
            }
        });
        return domain;
    }

    function getUAConfig() {
        angular.forEach(DOMAINS, function(value) {
            if( host === value.domain ) {
                uaConfig = value.ua;
            }
        });
        return uaConfig;
    }

    function getPixelEnabled() {
        var ret = false;
        angular.forEach(DOMAINS, function(value) {
            if (host === value.domain) {
                ret = value.pixel;
            }
        });
        return ret;
    }

    function getConversionAllowance() {
        angular.forEach(DOMAINS, function(value) {
            if( host === value.domain ) {
                conversion = value.conversion;
            }
        });
        return conversion;
    }

    function getFbLoginForm() {
        angular.forEach(DOMAINS, function(value) {
            if( host === value.domain ) {
                fb = value.fb;
            }
        });
        return fb;
    }

    function getAllowRegister() {
        angular.forEach(DOMAINS, function(value) {
            if( host === value.domain ) {
                register = !value.disableRegister;
            }
        });
        return register;
    }

    function samlLoginButtons() {
        angular.forEach(DOMAINS, function(value) {
            if( host === value.domain ) {
                register = value.saml;
            }
        });
        return register;
    }

    function oauthLoginButtons() {
        angular.forEach(DOMAINS, function(value) {
            if( host === value.domain ) {
                register = value.oauth;
            }
        });
        return register;
    }

        function isRedirectEnabled() {
            angular.forEach(DOMAINS, function(value) {
                if( host === value.domain ) {
                    register = value.redirect;
                }
            });
            return register;
        }

    function getAll() {
        var deferred = $q.defer();
        deferred.resolve(INSTANCES);
        return deferred.promise;
    }
}
})();

(function () {
    'use strict';

    function DetectInstanceController($scope, $log, DetectInstanceService) {
        // var vm = this;

    //$log.error( 'DetectInstanceController',DetectInstanceService.instance());

    }

    angular.module('plagiat2017App')
  .component('detectInstance', {
      controller: DetectInstanceController
  });

})();

(function () {
	'use strict';

	function DetectBrowserController() {
		var vm = this;

	}

	angular.module('plagiat2017App')
	.component('detectBrowser', {
		templateUrl: 'app/components/detect-browser/detect-browser.template.html',
		controller: DetectBrowserController
	});

})();

(function() {
	'use strict';

	function ConversionTrackingPriceController($stateParams, DetectInstanceService, InstanceService, PaymentsService,
		$log, $cookies, $window, GoogleAdWordsService) {

		var vm = this;
		vm.conversionDomain = DetectInstanceService.getConversionAllowance();
		vm.domainAw = InstanceService.instance().domainAw;
		vm.domainAwCode = InstanceService.instance().domainAwCode;

		vm.success = false;
		if (vm.conversionDomain) {

            PaymentsService.getStatusForLastPayment().then(function (responseData) {
                vm.lastPayment = responseData.data;
                if (vm.lastPayment.providerStatus === 'payment.status.success') {
                    vm.price = vm.lastPayment.price;
                    vm.currency = vm.lastPayment.currency;
                    vm.success = true;
                    trackGoogleAdsConversion();
                    trackFbPixelConversion();
                } else{
                    vm.success = false;
                    $log.info('no-ads-cnv');
                }
            });
		}
        
        function trackFbPixelConversion() {
            if ($window.fbq) {
                $window.fbq('track', 'Purchase', {currency: vm.currency, value: vm.price});
                console.log('Purchase tracked! value=' + vm.price);
            }
        }
        
        function trackGoogleAdsConversion() {
            $log.info('ads conversion OK. price: ', vm.price, 'currency: ', vm.currency);
            /* <![CDATA[ */
            GoogleAdWordsService.loadJavaScript('https://www.googletagmanager.com/gtag/js?id=' + vm.domainAw);
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
    
            gtag('config', vm.domainAw);
            gtag('event', 'conversion', {
                'send_to': vm.domainAwCode,
                'value': vm.price,
                'currency': vm.currency,
                'transaction_id': ''
            });
            /* ]]> */
    
        }
        
    }

	angular.module('plagiat2017App')
	.component('conversionTrackingPrice', {
		templateUrl: 'app/components/conversion-tracking-price/conversion-tracking-price.template.html',
		controller: ConversionTrackingPriceController
	});

})();

(function() {
  'use strict';

  function ContractController($scope, ContractService, AccountService) {
    var vm = this;
    vm.getContractInfo = getContractInfo;
    vm.getContractDate = getContractDate;
    vm.contractInfo = false;
    vm.showContract = false;
    vm.isReseller = AccountService.role.isReseller(); 
    vm.isMinistry = AccountService.role.isMinistry(); 

    
    $scope.$on("refreshContract",function () {
      getContractInfo();
    } );

    function getContractInfo() {
      ContractService.getInfo().then(function(responseData) {
        vm.contract = responseData.data;
        ContractService.inactive = !responseData.data.isContractActive;
        vm.showContract = true;
      });
    }

    function getContractDate() {
      var date = new Date(vm.contract.contractDateToAsLocalDate);
      if (date) {
        return date;
      } else {
        return moment(vm.contract.contractDateTo).format('LL');
      }
    }

    (function () {
      getContractInfo();
    })();

  }

  angular.module('plagiat2017App')
  .component('contract', {
    templateUrl: 'app/components/contract/contract.template.html',
    controller: ContractController,
    bindings: {
      onIsAdmin: '<',
      onShowReports: '<'
    }
  });

})();

(function () {
  'use strict';

  function ConfirmTermsController($scope, InstanceService, $rootScope, $state, $timeout, $log, $translate, AccountService, $mdDialog, Principal, Auth, $localStorage) {
    var vm = this;
    vm.acceptTerms = true;
    vm.instance = InstanceService.instance().lang;
    vm.logoutToRootInfo = $localStorage.logoutToRootInfo;

    function verifyAcceptTerms() {
      Principal.identity().then(function () {
        vm.acceptTerms = AccountService.account.userAcceptsRegulations;
        vm.clientId = AccountService.account.clientId;
        if (!vm.acceptTerms &&
          (AccountService.role.isIndividual() || AccountService.getClientSettings().regulationsUrl)
          && vm.logoutToRootInfo === undefined) {
          showAcceptTermsModal();
        }
      });
    }

    function showAcceptTermsModal() {
      var templateUrlForClient = null;
      if (AccountService.role.isIndividual()) {
        templateUrlForClient = 'app/components/confirm-terms/confirm-terms-individual.dialog.html';
      } else {
        templateUrlForClient = 'app/components/confirm-terms/confirm-terms-non-individual.dialog.html';
      }
      $mdDialog.show({
        templateUrl: templateUrlForClient,
        clickOutsideToClose: false,
        escapeToClose: false,
        controllerAs: 'vm',
        controller: function DialogController($scope, $mdDialog, AccountService, InstanceService) {
          var vm = this;
          vm.closeDialog = closeDialog;
          vm.saveAcceptTerms = saveAcceptTerms;
          vm.postprocessKey = postprocessKey;
          vm.obj = {};
          vm.instance = InstanceService.instance().lang;
          vm.regulationsUrl = AccountService.getClientSettings().regulationsUrl;
          function closeDialog() {
            AccountService.account = {};
            AccountService.account.userAcceptsRegulations = true;
            $mdDialog.hide();
            $timeout(function () {
              Auth.logout();
              $state.go('login');
            }, 1);

          }

          function postprocessKey(translationKey) {
            return (vm.instance === 'ro') ? (translationKey + '_instance_ro') : translationKey;
          }

          function saveAcceptTerms() {
            $mdDialog.hide();
            AccountService.acceptTerms(vm.obj).then(function (responseData) {
              $mdDialog.hide();
              AccountService.account.userAcceptsRegulations = true;
            });
          }
        }
      }).finally(
        function onModalClose() {
          //verifyAcceptTerms();
        });
    }

    $rootScope.$on('$stateChangeStart',
      function (event, toState, toParams, fromState) {
        if (fromState && !fromState.abstract) {
          verifyAcceptTerms();
        }
    });
    verifyAcceptTerms();
  }

  angular.module('plagiat2017App')
  .component('confirmTerms', {
    templateUrl: 'app/components/confirm-terms/confirm-terms.template.html',
    controller: ConfirmTermsController,
    bindings: {
      onConfirmTerms: '<'
    }
  });

})();

(function () {
    'use strict';

    function CodeInfoController($scope, CodeService) {
        var vm = this;
        vm.lessCharacter = '<';
        vm.availableCodesInfo = {};
        $scope.$on("refreshContract", function () {
            getAvailableCodesInfo();
        });

        function getAvailableCodesInfo() {
            CodeService.getAvailableCodeInfo().then(function (availableCodesResponse) {
                vm.availableCodesInfo = availableCodesResponse.data.availableCodes;
            });
        }

        getAvailableCodesInfo();
    }

    angular.module('plagiat2017App')
        .component('codeInfo', {
            templateUrl: 'app/components/code-info/code-info.template.html',
            controller: CodeInfoController,
            controllerAs: 'vm',
            bindings: {
                onIsCollapsed: '<'
            }
        });

})();

(function() {
	'use strict';
	angular.module('plagiat2017App').factory('ClientReportXlsService',
			ClientReportXlsService);

	ClientReportXlsService.$inject = [ '$http', '$q', 'FileSaver', 'PlagiatValidationService', '$mdDialog', '$translate'];

	function ClientReportXlsService($http, $q, FileSaver, PlagiatValidationService, $mdDialog, $translate) {
		var service = {
			generateReportXls: generateReportXls,
			generateReportSendXls : generateReportSendXls
		};
		return service;

		function generateReportXls(response, selected, searchRequest){
			var sendingEmailInfo = $translate.instant("client.report.xls.sending.email.info");

			var confirm = $mdDialog.confirm()
			.title($translate.instant("global.confirm.action"))
			.htmlContent(sendingEmailInfo)
			.ariaLabel($translate.instant("client.areyousure"))
			.ok($translate.instant("global.report.export.xls"))
			.cancel($translate.instant("global.button.cancel"))
			.openFrom('#left');

			$mdDialog.show(confirm).then(function () {
					service.generateReportSendXls({ids: selected}, searchRequest, response.selectedAll).then(function() {
						var generatingXlsMsg = $translate.instant("client.report.xls.report.generating.with.email.info1");
						generatingXlsMsg += '<br/>';
						generatingXlsMsg += $translate.instant("client.report.xls.report.generating.with.email.info2");
						$mdDialog.show(
								$mdDialog.confirm()
								.clickOutsideToClose(true)
								.title('')
								.htmlContent(generatingXlsMsg)
								.ariaLabel('ok')
								.ok('OK')
								);

					}, function(response) {
						PlagiatValidationService.getModalError(response.data);
					});
			});
		}

		function generateReportSendXls(ids, searchRequest, selectedAll) {
			var url = selectedAll ? 'api/client/report/xls/search/send-xls': 'api/client/report/xls/selected/send-xls';
			var data = selectedAll ? searchRequest:ids;

			return $http({
				url : url,
				method : "POST",
				data : data,
				headers : {
					'Content-type' : 'application/json'
				}
			})
		}

	}

})();

(function () {
    angular
        .module('plagiat2017App')
        .directive('autoFocus', function () {
            return {
                link: function (scope, elem) {
                    elem.focus();
                }
            }
        })
})();

(function() {
	'use strict';

	function AnalyticsGa4Controller($cookies, $log, $rootScope, $window, $location, DetectInstanceService, InstanceService) {
		var vm = this;
		vm.activateGtm = activateGtm;
		vm.allowAnalytics = DetectInstanceService.getUAConfig();
		vm.domainAw = InstanceService.instance().domainUa;
		vm.googleTagManagerId = InstanceService.instance().domainGTM;
		vm.theme = $cookies.get('plagiat-theme');

		if (vm.allowAnalytics) {
			// Setting dataLayer & gtag to window because I'm using a custom code text field in a tag management system
			window.dataLayer = window.dataLayer || [];

			vm.activateGtm(window,document,'script','dataLayer', vm.googleTagManagerId);

			window.gtag =
				window.gtag ||
				function() {
					window.dataLayer.push(arguments);
				};
			window.gtag("js", new Date());
			window.gtag("config", vm.domainAw);

			// Set initial gtag/js?id=<first ID> script to <head>
			var script = document.createElement("script");
			script.type = "text/javascript";
			script.async = true;
			script.src = "//www.googletagmanager.com/gtag/js?id=" + vm.domainAw;
			document.getElementsByTagName("head")[0].appendChild(script);

			$rootScope.$on('$stateChangeSuccess', function (event) {
				$window.gtag('config', vm.domainAw, {'page_path': $location.path()});
				$window.gtag('event', 'page_view', {'page_location': $location.absUrl()});
			});

		}

		function activateGtm(w,d,s,l,i){
			w[l]=w[l]||[];
			w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
			var f=d.getElementsByTagName(s)[0],
				j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
			j.async=true;
			j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
			f.parentNode.insertBefore(j,f);
		}

	}

	angular.module('plagiat2017App')
	.component('analyticsGa4', {
		templateUrl: 'app/components/analytics/analytics.template.html',
		controller: AnalyticsGa4Controller,
		bindings: {
			onSetCall: '='
		}
	});

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('plagiat2017App')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('plagiat2017App.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('plagiat2017App.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('plagiat2017App')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ToastService', ToastService);

    ToastService.$inject = ['PLAGIAT_VALIDATIONS_CODES', '$translate', '_', '$mdToast'];

    function ToastService(PLAGIAT_VALIDATIONS_CODES, $translate, _, $mdToast) {
        var service = {
            showSuccessToast: showSuccessToast,
            showErrorToast: showErrorToast
        };

        function showSuccessToast(textContent) {
            var key = textContent ? textContent : 'global.messages.info.actionsuccess';
            var toast = $mdToast.simple()
                .textContent($translate.instant(key))
                .position("top right")
                .hideDelay(5000);
            $mdToast.show(toast);
        }

        function lowercase(string) {
            return angular.isString(string) ? string.toLowerCase() : string;
        }

        function showErrorToast(response) {
            vm.translationKey = 'global.messages.error.error';
            if( response.code !== '' ) {
                vm.code = _.filter(PLAGIAT_VALIDATIONS_CODES, function(o) { return lowercase(o.code).indexOf(lowercase(response.code)) !== -1; });
                vm.translationKey = ( vm.code.length > 0 && angular.isDefined(vm.code[0].translationCode) && vm.code[0].translationCode !== '' ) ? vm.code[0].translationCode : 'global.messages.error.error';
            }
            vm.data = '';
            if (response.data){
                vm.data = '</br>' + response.data;
            }

            var toast = $mdToast.simple()
                .textContent($translate.instant(vm.translationKey) + vm.data)
                .position("top right")
                .hideDelay(5000);

            $mdToast.show(toast);
        }

        return service;
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ReportXlsService', ReportXlsService);

    ReportXlsService.$inject = ['$http', '$mdDialog', '$translate', 'DateUtils', 'PlagiatValidationService'];

    function ReportXlsService($http, $mdDialog, $translate, DateUtils, PlagiatValidationService) {
        var service = {
            generateExcelFile: generateExcelFile
        };

        function generateExcelFile(obj, url, fileName) {
            var alert = $mdDialog.alert()
                .clickOutsideToClose(false)
                .escapeToClose(false)
                .textContent($translate.instant("global.report.xls.exporting-in-progress"))
                .ok("OK");
            $mdDialog.show(alert);

            $http({
                url: url,
                method: "POST",
                data: obj,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).then(function (success) {
                $mdDialog.hide();
                var blob = new Blob([success.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                saveAs(blob, fileName + DateUtils.getDateTimeForFileName(new Date()) + '.xlsx');
                return 'OK';
            }, function (error) {
                $mdDialog.hide();
                PlagiatValidationService.getModalError(error);
                return $q.reject(error);
            });
        }

        return service;
    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('ModalService', ModalService);

    ModalService.$inject = ['$translate', '$mdDialog', 'PlagiatValidationService'];

    function ModalService($translate, $mdDialog, PlagiatValidationService) {
        var service = {
            showConfirmModal: showConfirmModal,
            showSuccessModal: showSuccessModal,
            showErrorModal: showErrorModal,
            showDialogModal: showDialogModal,
            showPleaseWaitDialog: showPleaseWaitDialog
        };

        function showConfirmModal(translationKey, params) {
            var key = translationKey ? translationKey : 'global';
            var customCancelButton = params && params.customCancelButton;
            var customTitle = params && params.customTitle;
            var customWarning = params && params.customWarning;

            return $mdDialog.show(
                $mdDialog.confirm()
                    .title($translate.instant(key + '.confirm'))
                    .textContent(
                        (customWarning ? customWarning + ". " : '')
                        + $translate.instant(customTitle ? customTitle : (key + '.areyousure')))
                    .ariaLabel($translate.instant(key + '.areyousure'))
                    .ok($translate.instant(key + '.button.confirm'))
                    .cancel($translate.instant(customCancelButton ? key + '.button.cancel' : 'global.button.cancel'))
            );
        }

        function showSuccessModal(textConent) {
            var key = textConent ? textConent : 'global.messages.info.actionsuccess';
        	return $mdDialog.show(
                    $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('')
                    .textContent($translate.instant(key))
                    .ariaLabel('msgSuccess')
                    .ok('Ok')
                    );
        }

        function showPleaseWaitDialog(isMultiple) {
            var dialog = $mdDialog.alert()
                .clickOutsideToClose(false)
                .title('')
                .multiple(isMultiple === true ? true : false)
                .textContent($translate.instant('global.please-wait'))
                .ariaLabel('please-wait')
                .ok('');
            $mdDialog.show(dialog);
            return dialog;
        }

        function showDialogModal(textContent, additionalContent) {
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('')
                    .textContent($translate.instant(textContent, additionalContent || {}))
                    .ariaLabel('ok')
                    .ok('Ok')
            );
        }

        function showErrorModal(error, multiple) {
        	PlagiatValidationService.getModalError(error.data, null, null, multiple);
        }

        return service;
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('CurrencyService', CurrencyService);

    CurrencyService.$inject = ['JhiLanguageService', 'InstanceService'];

    function CurrencyService(JhiLanguageService, InstanceService) {
        var service = {
            getDefaultCurrency: getDefaultCurrency
        };

        function getDefaultCurrency() {
            return JhiLanguageService.getCurrent().then(function (currentLanguage) {
                return InstanceService.instance().currencies.langSettings.find(function (value) {
                    if (currentLanguage === value.lang) {
                        return value.currency;
                    }
                }).currency;
            });
        }

        return service;
    }

})();

(function () {
    'use strict';

    function CodesSearchController(
        OrganisationalUnitsService, CodeSearchModel, AccountService, CodeService, SearchService, ClientService,
        ClientQueryRequest, SearchRequest,
        USERROLES, SIMPLE_SEARCH_DELAY, PAYMENT_TYPE_CONSTANT
    ) {
        var vm = this;

        vm.clientSearch = clientSearch;
        vm.selectedClientChange = selectedClientChange;

        vm.organisationalUnits;
        vm.userRoles;
        vm.codeTypes;
        vm.statuses;
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.paymentTypes = PAYMENT_TYPE_CONSTANT;
        vm.clientQueryRequest = new ClientQueryRequest();

        this.$onInit = function () {
            vm.isAdmin = AccountService.role.isAdmin();
            vm.isSuperAdmin = AccountService.role.isSuperAdmin();

            vm.searchRequest = vm.requestPayload.search;
            vm.simpleSearch = vm.requestPayload.simpleSearch.length === 0 ? true : false;

            findOrganisationalUnits();
            findCodeTypes();
            findUserRoles();
            findStatuses();
        };

        function selectedClientChange(item) {
            if (angular.isDefined(item)) {
                if (vm.requestPayload.search.clientId !== item.id) {
                    vm.requestPayload.search.clientId = item.id;
                    vm.search();
                }
            } else {
                vm.requestPayload.search.clientId = null;
                vm.search();
            }
        }

        function clientSearch(query) {
            vm.searchRequest = new SearchRequest();
            vm.searchRequest.pageNumber = 0;
            vm.searchRequest.pageSize = 20;
            vm.searchRequest.sortTab = SearchService.sort(vm.clientQueryRequest);
            vm.searchRequest.search = query;
            vm.searchRequest.simpleSearch = query;

            return ClientService.searchClients(vm.searchRequest).then(function(response) {
                return response.content;
            })
        }

        function findOrganisationalUnits() {
            OrganisationalUnitsService.findAllForClient().then(function(response) {
                vm.organisationalUnits = response.data;
            });
        }

        function findCodeTypes() {
            CodeService.findAllCodeTypesForCurrentClient().then(
                function (response) {
                    vm.codeTypes = response.data;
                }
            );
        }

        function findUserRoles() {
            vm.userRoles = USERROLES.getRolesForCurrentClient(AccountService);
        }

        function findStatuses() {
            vm.statuses = [
                {id: -1, translateKey: 'codes.status.unfinished'},
                {id: 0, translateKey: 'codes.status.available'},
                {id: 1, translateKey: 'codes.status.used'}
            ];
        }

        vm.toggleSearch = function () {
            vm.requestPayload.simpleSearch = '';
            vm.simpleSearch = !vm.simpleSearch;
        };

        vm.clear = function () {
            vm.requestPayload.simpleSearch = '';
            vm.requestPayload.search = new CodeSearchModel();
            vm.onSearch();
        };

        vm.search = function () {
            vm.onSearch();
        }
    }

    angular.module('plagiat2017App')
        .component('codesSearch', {
            templateUrl: 'app/codes/codes-search.template.html',
            controller: CodesSearchController,
            controllerAs: 'vm',
            bindings: {
                onSearch: '<',
                requestPayload: '<',
                pagingModel: '<',
            }
        });

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('CodesController', CodesController);

    CodesController.$inject = [
        'CodeService', 'AccountService', 'SearchRequest', 'ClientSearchRequest',
        'SearchService', '$mdBottomSheet', 'USERROLES', '$localStorage', 'CodeSearchModel', 'ModalService'
    ];

    function CodesController(
        CodeService, AccountService, SearchRequest, ClientSearchRequest,
        SearchService, $mdBottomSheet, USERROLES, $localStorage, CodeSearchModel, ModalService
    ) {
        var vm = this;

        vm.codes;
        vm.selectedRows = [];
        vm.pagingModel = {order: '-id', page: 1, limit: 10};
        vm.requestPayload = {
            pageNumber: null,
            pageSize: null,
            sortTab: [],
            simpleSearch: '',
            search: new CodeSearchModel()
        };
        vm.isSuperAdmin = AccountService.role.isSuperAdmin();

        this.$onInit = function () {
            vm.findAll();
            userRoleIdTranslationMapEngine()
        };

        function userRoleIdTranslationMapEngine() {
            vm.userRoleIdTranslationMap = {};
            var roles = USERROLES.getRolesForCurrentClient(AccountService);
            for (var key in roles) {
                vm.userRoleIdTranslationMap[roles[key].type.id] = roles[key].translationKey;
            }
        }

        vm.pagingAction = function (page) {
            vm.pagingModel.page = page;
            vm.findAll();
        };

        vm.search = function () {
            vm.pagingModel.page = 1;
            vm.findAll();
        };

        vm.findAll = function () {
            vm.pending = true;

            vm.requestPayload.pageNumber = vm.pagingModel.page - 1;
            vm.requestPayload.pageSize = vm.pagingModel.limit;
            vm.requestPayload.sortTab = SearchService.sort(vm.pagingModel);

            CodeService.findAllCodes(vm.requestPayload).then(
                function (response) {
                    vm.pending = false;
                    vm.items = response.data.content;
                    vm.totalItems = response.data.totalElements;
                    vm.queryRequest.page = response.data.number + 1;

                }, function (errorResponse) {
                    vm.pending = false;
                    ModalService.showErrorModal(errorResponse);
                }
            );
        };

    }

})();

(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .constant('CODE_STATUS', function () {
                var statuses = {
                    STATUS_SENT_TO_ALLPAY: {id: -1, key: 'codes.model.status.sent-to-allpay'},
                    CODE_STATUS_AVAILABLE: {id: 0, key: 'codes.model.status.available'},
                    CODE_STATUS_USED: {id: 1, key: 'codes.model.status.used'}
                };

                var keysById = {};
                var keys = Object.keys(statuses);
                for (var key in keys) {
                    var codeStatus = statuses[keys[key]];
                    keysById[codeStatus.id] = codeStatus.key;
                }
                statuses.keysById = keysById;

                return statuses;
            }()
        );
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('CodeSearchModel', function () {
            function model() {
                this.organizationUnitId; //Integer
                this.userEmailAddress; //String
                this.userFirstName; //String
                this.userLastName; //String
                this.userRole; //Integer
                this.control; //String
                this.codeTypeId; //Integer
                this.transactionType; //Integer
                this.clientId; //Integer
                this.status; //Integer
            }

            return model;
        });
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('codes', {
            parent: 'app',
            url: '/codes',
            data: {
                authorities: [],
                pageTitle: 'global.menu.codes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/codes/codes.template.html',
                    controller: 'CodesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('codes');
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('payments');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('CodeService', CodeService);

    CodeService.$inject = ['$http', '$q'];

    function CodeService($http, $q) {

        var requestUrl = 'api/codes';

        var service = {
            findAllCodes: findAllCodes,
            findAllCodeTypesForCurrentClient: findAllCodeTypesForCurrentClient,
            findCodeByTransactionId: findCodeByTransactionId,
            findIdOfCodeTypeRequiredForDocument: findIdOfCodeTypeRequiredForDocument,
            findCodeForDocumentChecking: findCodeForDocumentChecking,
            getAvailableCodeInfo: getAvailableCodeInfo,
            getCurrencyForTerminalPayment: getCurrencyForTerminalPayment
        };
        return service;

        function findAllCodes(searchRequest) {
            return $http.post(requestUrl, searchRequest).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function findAllCodeTypesForCurrentClient() {
            return $http.get(requestUrl + '/code-types').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function findCodeByTransactionId(transactionId, documentId) {
            return $http.get(requestUrl + '/transaction-id/' + transactionId + '?documentId=' + documentId).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function findIdOfCodeTypeRequiredForDocument(documentId) {
            return $http.get(requestUrl + '/code-type/required-for-document/' + documentId).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function findCodeForDocumentChecking(documentId, priority) {
            return $http.get(requestUrl + '/for-document-checking/' + documentId +'?priority=' + priority).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getAvailableCodeInfo() {
            return $http.get(requestUrl + '/available').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getCurrencyForTerminalPayment() {
            return $http.get(requestUrl + '/currency-for-terminal-payment').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('CodeModel', function () {
            function model() {
                this.transactionNumber; // String
                this.userId; // Integer
                this.organizationId; // Integer
                this.clientId; // Integer
                this.userFirstName; // String
                this.userLastName; // String
                this.userRole; // Integer
                this.userEmailAddress; // String
                this.codeType; // String
                this.paymentSystem; // String
                this.paymentDate; // Date
                this.dateOfUse; // Date
                this.status; // Integer
            }

            return model;
        });
})();

(function () {
    'use strict';

    angular.module('plagiat2017App')
        .factory('CodePaymentsRequestModel', function () {

            function PaymentInit() {
                this.productQuantity = '';

                this.price = {
                    userPaymentType: 'TYPE_TRANSFER',
                    quantity: 0,
                    currency: "EUR"
                };

                this.TYPE_TRANSFER = {
                    name: 'Przelewy24',
                    img: 'pay-przelewy24.png',
                    userPaymentType: 'TYPE_TRANSFER',
                    invoice: true,
                    backUrl: '/api/payments/code-return'
                };
                this.TYPE_PAY_PAL = {
                    name: 'Paypal',
                    img: 'pay-paypal.png',
                    userPaymentType: 'TYPE_PAY_PAL',
                    invoice: true,
                    backUrl: '/api/payments/code-return'
                };
                this.TYPE_PAY_PAL_RO = {
                    name: 'Paypal.',
                    img: 'pay-paypal.png',
                    userPaymentType: 'TYPE_PAY_PAL_RO',
                    invoice: true,
                    backUrl: '/api/payments/code-return'
                };
                this.TYPE_EASY_PAY = {
                    name: 'EasyPay',
                    img: 'pay-easypay.png',
                    userPaymentType: 'TYPE_EASY_PAY',
                    invoice: false,
                    backUrl: '/api/payments/code-return'
                };
                this.TYPE_KASSA_24 = {
                    name: 'Kassa24',
                    img: 'pay-kassa24.png',
                    userPaymentType: 'TYPE_KASSA_24',
                    invoice: true,
                    backUrl: '/api/payments/code-return'
                };
                this.TYPE_KASSA_24_CARD = {
                    name: 'Kassa24 Business',
                    img: 'pay-kassa24card.png',
                    userPaymentType: 'TYPE_KASSA_24_CARD',
                    invoice: true,
                    backUrl: '/api/payments/code-return'
                };
                this.TYPE_MOBILPAY_CARD = {
                    name: " Card",
                    img: 'pay-mobilpay-card.png',
                    userPaymentType: 'TYPE_MOBILPAY_CARD',
                    invoice: true,
                    backUrl: '/api/payments/code-return'
                };
                this.TYPE_MILLIKART_CARD = {
                    name: 'Millikart',
                    img: 'pay-millikart.png',
                    userPaymentType: 'TYPE_MILLIKART_CARD',
                    invoice: true,
                    backUrl: '/api/payments/code-return'
                };
                this.TYPE_YIGIM_AZ = {
                    name: 'Yigim.az',
                    img: 'pay-yigim.png',
                    userPaymentType: 'TYPE_YIGIM_AZ',
                    invoice: true,
                    backUrl: '/api/payments/code-return'
                };
                this.TYPE_EPAY_BG = {
                    name: 'ePay.bg',
                    img: 'pay-epay_bg.png',
                    userPaymentType: 'TYPE_EPAY_BG',
                    invoice: true,
                    backUrl: '/api/payments/code-return'
                };
                this.TYPE_BLIK = {
                    name: 'Blik',
                    img: 'pay-blik.png',
                    userPaymentType: 'TYPE_BLIK',
                    invoice: false,
                    backUrl: '/api/payments/code-return'
                };
                this.TYPE_PAYME = {
                    name: 'Payme',
                    img: 'pay-payme.png',
                    userPaymentType: 'TYPE_PAYME',
                    invoice: false,
                    backUrl: '/api/payments/code-return'
                };
                this.TYPE_FORTE_KZ = {
                    name: 'Forte.kz',
                    img: 'pay-forte-kz.png',
                    userPaymentType: 'TYPE_FORTE_KZ',
                    invoice: false,
                    backUrl: '/api/payments/code-return'
                };

            }

            return PaymentInit;
        });
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('code-payments', {
            parent: 'app',
            url: '/code-payments?key&documentId&priorityCode',
            data: {
                pageTitle: 'global.menu.code-payments'
            },
            views: {
                'content@': {
                    templateUrl: 'app/code-payments/code-payments.html',
                    controller: 'CodePaymentsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'paymentDate,desc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('payments');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('CodePaymentsService', CodePaymentsService);

    CodePaymentsService.$inject = ['$http', '$q'];

    function CodePaymentsService($http, $q) {

        var requestUrl = 'api/code-payment';

        var service = {
            getAvailableCodes: getAvailableCodes,
        };
        return service;

        function getAvailableCodes() {
            return $http.get(requestUrl + '/availableCodes').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .controller('CodePaymentsController', CodePaymentsController);

    CodePaymentsController.$inject = [
        '$http',
        '$rootScope',
        '$scope',
        'CodePaymentsService',
        'CodePaymentsRequestModel',
        'PaymentsService',
        'pagingParams',
        'paginationConstants',
        '$stateParams',
        '$mdDialog',
        '$translate',
        '$timeout',
        '$location',
        'JhiLanguageService',
        'InstanceService',
        'DetectInstanceService',
        'CodeService',
        'ContractService'
    ];

    function CodePaymentsController(
        $http,
        $rootScope,
        $scope,
        CodePaymentsService,
        CodePaymentsRequestModel,
        PaymentsService,
        pagingParams,
        paginationConstants,
        $stateParams,
        $mdDialog,
        $translate,
        $timeout,
        $location,
        JhiLanguageService,
        InstanceService,
        DetectInstanceService,
        CodeService,
        ContractService
    ) {

        var vm = this;

        vm.key = $stateParams.key;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = pagingParams.page;
        vm.isPriorityCode = $stateParams.priorityCode && ($stateParams.priorityCode === 'true');
        vm.paymentForm = {priorityCode: vm.isPriorityCode, codes: 1, invoice: {}, isCompany: false};
        vm.priorityCodeMandatory = vm.isPriorityCode;
        vm.request = {};
        vm.code = true;
        vm.codeExpiryDate = moment().add(6, 'months').format('YYYY-MM-DD');
        vm.documentId = $stateParams.documentId;
        vm.protocol = $location.protocol();
        vm.host = $location.host();
        vm.port = $location.port();
        vm.domain = vm.protocol + '://' + vm.host;
        vm.instance = DetectInstanceService.instance();
        vm.isRomania = DetectInstanceService.instance() === 'ro';
        vm.paymentInit = new CodePaymentsRequestModel();
        vm.romanianCounties = [];
        vm.romanianCities = [];

        vm.filterAvailablePayments = filterAvailablePayments;
        vm.paymentMethodChanged = paymentMethodChanged;
        vm.getSingleCodePriceForCurrency = getSingleCodePriceForCurrency;
        vm.getTotalCodePriceForCurrency = getTotalCodePriceForCurrency;
        vm.getCodes = getCodes;
        vm.buyCode = buyCode;
        vm.setDefaultCurrency = setDefaultCurrency;
        vm.transitionToStep2 = transitionToStep2;

        if (vm.key === 'success') {
            ContractService.broadcast();
            var confirm = $mdDialog.confirm()
                .title('')
                .clickOutsideToClose(true)
                .htmlContent($translate.instant("payments.payment-code-ok"))
                .ariaLabel('')
                .ok('Ok')
                .openFrom('#left');
            $mdDialog.show(confirm).then(function () {
            });

        }

        this.$onInit = function () {
            vm.getCodes().then(function () {
                if (vm.documentId) {
                    CodeService.findIdOfCodeTypeRequiredForDocument(vm.documentId).then(
                        function (requiredCodeTypeIdResponse) {
                            vm.paymentForm.selectedCode = vm.codes.find(function (availableCode) {
                                return availableCode.id === requiredCodeTypeIdResponse.data;
                            });
                            vm.disableChoosingCodeType = vm.paymentForm.selectedCode
                        }
                    );
                }
            });
            vm.phase = 'step-1';

            if (vm.isRomania) {
                $http.get('/assets/ro-counties-cities.json').then(function (response) {
                    vm.romanianCounties = response.data.counties;
                });
            }

            vm.onRoCountyChange = function () {
                vm.paymentForm.invoice.city = '';
                vm.paymentForm.invoice.country = 'RO';
                getCities();
            };

            function getCities() {
                if (vm.paymentForm.invoice.county) {
                    const selectedCounty = vm.romanianCounties.find(function (c) {
                        return c.name === vm.paymentForm.invoice.county;
                    });
                    vm.romanianCities = selectedCounty ? selectedCounty.cities : [];
                }
            }
        };

        function transitionToStep2(form) {
            if (form.$invalid || form.$pending) {
                for (var i = 0; i < form.$$controls.length; i++) {
                    form.$$controls[i].$touched = true;
                }
                return;
            }
            if (vm.codeError) {
                return;
            }
            vm.phase = 'step-2'
        }

        $scope.$on("langChanged",function () {
            vm.setDefaultCurrency();
        } );

        function setDefaultCurrency(){
            JhiLanguageService.getCurrent().then(function(response){
                angular.forEach(InstanceService.instance().currencies.langSettings, function(value) {
                    if( response === value.lang ) {
                        vm.paymentForm.payment = vm.availablePayments.find(function(price) {
                            return price.currency === value.currency;
                        });
                        if (!vm.paymentForm.payment && vm.availablePayments) {
                            vm.paymentForm.payment = vm.availablePayments[0];
                        }
                    }
                });
            });
        }

        function getTotalCodePriceForCurrency() {
            vm.codeError = (!(vm.paymentForm.codes > 0 && vm.paymentForm.codes <= 50));

            if (vm.paymentForm.codes) {
                const price = getSingleCodePriceForCurrency();

                return price * vm.paymentForm.codes;
            } else {
                return 0;
            }

        }

        function getSingleCodePriceForCurrency() {
            if( vm.paymentForm.selectedCode && vm.paymentForm.payment) {
                const price = vm.paymentForm.selectedCode.prices.find(function(price) {
                    return price.currency === vm.paymentForm.payment.currency;
                });
                return vm.paymentForm.priorityCode ? price.priorityAmount : price.amount;
            } else {
                return 0;
            }
        }

        function getCodes() {
            return CodePaymentsService.getAvailableCodes().then(
                function (response) {
                    vm.pending = false;
                    vm.availablePayments = response.data.availablePayments;
                    vm.codes = response.data.codes;
                    vm.setDefaultCurrency();
                }, function (errorResponse) {
                    vm.pending = false;
                    ModalService.showErrorModal(errorResponse);
                });
        }

        function buyCode() {
            vm.request.invoiceRequired = vm.paymentForm.invoiceRequired;
            vm.request.invoice = vm.paymentForm.invoice;
            vm.request.userPaymentType = vm.paymentForm.paymentMethod;
            vm.request.currency = vm.paymentForm.payment.currency;
            vm.request.codeId = vm.paymentForm.selectedCode.id;
            vm.request.priorityCode = vm.paymentForm.priorityCode;
            vm.request.productQuantity = vm.paymentForm.codes;
            vm.request.documentId = vm.documentId;
            vm.request.backUrl = vm.domain + (vm.port ? (':' + vm.port) : '') + vm.paymentInit[vm.paymentForm.paymentMethod].backUrl;
            vm.request.browserInfo = getBrowserInfo();

            PaymentsService.pay(vm.request).then(function (responseData) {
                if (responseData.data.paymentRedirectionParams !== null) {
                    paymentRedirect(responseData.data);
                }else {
                    paymentComplete(responseData.data);
                }
            }, function (responseError) {
                if (responseError.status === 400) {
                    $mdDialog.show(
                        $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .textContent(responseError.data.message)
                        .ariaLabel('ok')
                        .ok('OK')
                    );
                }
            });
        }
        
        function getBrowserInfo() {
            const browserInfoModel = {};
            browserInfoModel.colorDepth = window.screen.colorDepth.toString();
            browserInfoModel.screenHeight = window.screen.height.toString();
            browserInfoModel.screenWidth = window.screen.width.toString();
            browserInfoModel.language = window.navigator.language;
            browserInfoModel.javaEnabled = window.navigator.javaEnabled();
            browserInfoModel.timeZone = (new Date()).getTimezoneOffset().toString();
            return browserInfoModel;
        }

        function paymentComplete(response) {
            if (response.userPaymentType === 'TYPE_BLIK') {
                if (response.blikOK === null) {
                    confirm = $mdDialog.confirm()
                        .title('')
                        .textContent($translate.instant("payments.paymentbliknotok"))
                        .ariaLabel('')
                        .ok('Ok')
                        .openFrom('#left');
                    $mdDialog.show(confirm);
                }
            }
        }

        function paymentRedirect(paymentResponse) {
            $mdDialog.show(
                $mdDialog.alert()
                .parent(angular.element(document.querySelector('#popupContainer')))
                .clickOutsideToClose(false)
                .title($translate.instant("global.messages.info.redirect"))
                .textContent($translate.instant("global.messages.info.redirect"))
                .ariaLabel($translate.instant("global.messages.info.redirect"))
                .ok($translate.instant("global.button.cancel"))
            );

            if(paymentResponse.userPaymentType==='TYPE_KASSA_24'){
                window.location = paymentResponse.formAction;
                return;
            }

            if(paymentResponse.userPaymentType==='TYPE_KASSA_24_CARD'){
                window.location = paymentResponse.formAction;
                return;
            }

            if (paymentResponse.userPaymentType === 'TYPE_FORTE_KZ') {
                window.location = paymentResponse.formAction;
                return;
            }

            vm.paymentParams = paymentResponse.paymentRedirectionParams;
            var $redirectFormContainer = angular.element('#paymentForm');
            var $redirectForm = $redirectFormContainer.find('form');

            $redirectForm.attr('method', paymentResponse.formMethod);
            $redirectForm.attr('action', paymentResponse.formAction);

            $timeout(function () {
                $redirectForm.submit();
            }, 100);

        }

        function filterAvailablePayments(payment) {
            return vm.paymentInit[payment];
        }

        function paymentMethodChanged(){
            if (vm.isRomania) {
                vm.paymentForm.invoiceRequired = true;
                vm.paymentForm.invoice.country = 'RO';
            } else {
                if (!vm.paymentForm.paymentMethod.invoice) {
                    vm.paymentForm.invoiceRequired = false;
                } else {
                    vm.paymentForm.invoiceRequired = true;
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('FinderService', FinderService);

    FinderService.$inject = ['$http', '$q'];

    function FinderService($http, $q) {

        var service = {
            getAllAvailableForClientType: getAllAvailableForClientType,
        };

        return service;

        function getAllAvailableForClientType(clientTypeId, countryId, isTestClient) {
            const testClient = isTestClient ? true : false;
            return $http.get('/api/finder/available?clientTypeId=' + clientTypeId + "&countryId=" + countryId + "&isTestClient=" + testClient).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ClientService', ClientService);

    ClientService.$inject = ['$http', '$q'];

    function ClientService($http, $q) {

        var service = {
            searchClients: searchClients,
            getClients: getClients,
            getClient: getClient,
            getClientForEditing: getClientForEditing,
            getClientProtocols: getClientProtocols,
            addClientProtocol: addClientProtocol,
            removeClientProtocol: removeClientProtocol,
            getClientDocumentKinds: getClientDocumentKinds,
            updateClientDocumentKinds: updateClientDocumentKinds,
            getClientGroups: getClientGroups,
            getClientRegions: getClientRegions,
            getClientCountries: getClientCountries,
            clientDetailsObj: {},
            client: null,
            clientTypes: getClientTypes(),
            listDatabaseExchangeProgramMembers: listDatabaseExchangeProgramMembers,
            isDatabaseExchangeProgramMember: isDatabaseExchangeProgramMember,
            addTestClient: addTestClient,
            save: save,
            update: update,
            remove: remove,
            freeze: freeze,
            unfreeze: unfreeze,
            searchObject: null,
            queryRequest: null
	    };
      
        return service;

        function getClientTypes(){
            return {
                'other': {
                    'suffix' : ''
                },
                'notIndividual': {
                    'suffix': '_notindividual'
                },
                'individual': {
                    'suffix': '.individual'
                },
                'publisher': {
                    'suffix': '.publisher'
                },
                'school': {
                    'suffix': '.school'
                },
                'codeAccount': {
                    'suffix': '.code-account'
                }
            };
        }

        function getClient(id) {
            return $http.get('/api/client/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getClientForEditing(id) {
            return $http.get('/api/client/for-editing/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function getClientProtocols(id) {
            return $http.get('/api/client/protocols/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
        
        function removeClientProtocol(clientId, protocolId) {
            return $http.delete('/api/client/protocols/remove/' + clientId + '/' + protocolId).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }
    
        function addClientProtocol(clientId, protocolId) {
            return $http.post('/api/client/protocols/add/' + clientId + '/' + protocolId).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }
    
        function getClientDocumentKinds(id) {
            return $http.get('/api/client/document-kinds/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function updateClientDocumentKinds(obj) {
            return $http.post('/api/client/update-document-kinds', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }
  
        function getClientGroups() {
            return $http.get('/api/client/client-groups/').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
  
        function getClientRegions() {
            return $http.get('/api/client/client-regions/').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
  
        function getClientCountries() {
            return $http.get('/api/client/client-countries/').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
  
      function searchClients(obj) {
            return $http.post('/api/client/search', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getClients(obj) {
            return $http.post('/api/client/list', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function listDatabaseExchangeProgramMembers(obj) {
            return $http.post('/api/client/list-database-exchange-program-members', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function isDatabaseExchangeProgramMember() {
            return $http.get('/api/client/is-database-exchange-program-member').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function save(obj) {
            return $http.post('/api/client', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }

        function addTestClient(obj) {
            return $http.post('/api/client/add-test-client', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }

        function update(obj) {
            return $http.put('/api/client', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }

        function remove(id) {
            return $http.delete('/api/client/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }
    
        function freeze(id) {
            return $http.get('/api/client/freeze/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }
    
        function unfreeze(id) {
            return $http.get('/api/client/unfreeze/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }
    
    }

})();

(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('ClientSearchRequest', function () {

        function ClientSearchRequest() {
            this.name = '';
            this.id = '';
            this.type = '';
            this.status = '';
        }

        return ClientSearchRequest;
    });
})();

(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('ClientQueryRequest', function () {

        function ClientQueryRequest() {
            this.order = 'clieName';
            this.page = 1;
            this.limit = 5;
        }

        return ClientQueryRequest;
    });
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ClientEditRequestModel', function () {

        function ClientEditRequestModel() {
            this.addToDatabaseAutomatically = "automatically";
            this.addToDatabaseDelayed = "delayed";
            this.addToDatabaseManually = "manually";
            this.addToDatabaseWithout = "without";

            this.basicData = {
                id: null,
                name: null,
                adminFirstName: null,
                adminLastName: null,
                adminEmail: null,
                countryId: null,
                clientType: {},
                instance: null,
                clieTestClient: null,
                clieLang: null
            };
            this.codeAccount = {
                currencies: [],
                payments: {},
                codeTypePrices: []
            };
            this.isDatabaseExchangeProgramMember = false;
            this.clientIsHidden = false;
            this.findersConfiguration = {};
            this.asapContract = {
                id: null,
                    dateFrom: null,
                    dateTo: null,
                    installationType: null,
                    integrationType: null
            };
            this.contract = {
                id: null,
                contType: null,
                contDateFrom: null,
                contDateTo: null,
                contNumOfPlagReports: null,
                contNumOfPlagReportsLeft: null,
                contMaxDocPlagSize: null,
            };
            this.configuration = {
                reportSettings: {
                    ignoringBibliography: false,
                    ignoringCitations: false,
                    smartmarksDisabled: false,
                    showReversedSimilarityFactor: false,
                    showSelfCitationFactor: false,
                    addToDatabaseDays: 0,
                    hideMetadata: true,
                    engineMode2026: false,
                    originalReportEnabled: 0
                },
                addToDatabase: this.addToDatabaseManually,
                jsaOrppdSettings: {
                    jsaIntegration: false,
                    orppdIntegration: false
                },
                userSettings: {
                    allowEditDocument: false,
                    permUserCantSeeTheDocumentsOfOthers: false,
                    permUserCanChangeOrganisationalUnit: false,
                    userTeacherCanChangePromoter: false,
                    permUsersCanDownloadOriginalFile: false,
                },
                userGroupsSettings: {
                    allowCreateStudents: false
                },
                documentFieldSettings: {
                    indexNumberPresent: false,
                    indexNumberRequired: false,
                },
                addToDatabaseSettings: {
                    teacherCantDeleteFromDatabase: true,    
                },
                otherSettings: {
                    permUserDocumentVerification: false,
                    permUserCheckDocumentMetricSimilarityBeforeAdd: false,
                    permUserDownloadPdfReport: false,
                    reservedEmails: false,
                    reservedEmailsDomainList: [],
                    acceptRegulationsEnabled: false,
                    regulationsUrl: null,
                    passwordChange: false,
                    passwordChangePeriod: null,
                    sendAlertToPromoter: false,
                    sendAlertToStudent: false,
                    permUserDoNotUseCopyPaste: false,
                    permUserUploadSupport: false,
                    authorsSimplifiedFields: true,
                    protocolsEnabled: false,
                    documentImportEnabled: false,
                    documentComparision: false,
                    assignmentsEnabled: false,
                    assignmentsPaidCorrectionsEnabled: false,
                    noDocumentUploadForStudents: false,
                    disableSkipSitesUrl: true
                },
                uploadPermissions: {
                    txtSupport: false,
                    pdfSupport: false,
                    docSupport: false,
                    docxSupport: false,
                    odtSupport: false,
                    rtfSupport: false,
                    pptSupport: false,
                    pptxSupport: false,
                    postscriptSupport: false,
                    wordperfectSupport: false,
                    htmlSupport: false
                },
                similarityReportSettings: {
                    
                },
                grammarCheckSettings: {
                    forStudent: 'alwaysEnabled',
                    forOperator: 'defaultEnabled',
                    forLecturer: 'defaultEnabled',
                    forAdmin: 'defaultEnabled',
                    forApi: 'defaultEnabled',
                },
                aiDetectionSettings: {
                    forStudent: 'alwaysDisabled',
                    forOperator: 'alwaysDisabled',
                    forLecturer: 'alwaysDisabled',
                    forAdmin: 'alwaysDisabled',
                    forApi: 'defaultEnabled',
                    aiDetectionHideSlider: false,
                    aiDetectionShowOnlyProbability: false,
                    aiDetectionThreshold: 0.80,
                    aiDetectionShowFirstScore: false,
                    aiDetectionExcludeFragments: false
                }
            };

            this.parseAllDates = function () {
                if(this.contract) {
                    this.contract.contDateFrom = new Date(
                        this.contract.contDateFrom);
                    this.contract.contDateTo = new Date(
                        this.contract.contDateTo);
                }
                if(this.forthcomingContract) {
                    this.forthcomingContract.contDateFrom = new Date(this.forthcomingContract.contDateFrom);
                    this.forthcomingContract.contDateTo = new Date(this.forthcomingContract.contDateTo);
                }
                if (this.asapContract) {
                    this.asapContract.dateFrom = new Date(this.asapContract.dateFrom);
                    this.asapContract.dateTo = new Date(this.asapContract.dateTo);
                }
            }
        }
        return ClientEditRequestModel;
    });

})();

(function () {
    'use strict';

    const clientStatus = {
      ACTIVE: {'id': 0, 'label': 'global.status.active' },
      FORTHCOMING: {'id': 1, 'label': 'global.status.forthcoming' },
      REMOVAL_IN_PROGRESS: {'id': 252, 'label': 'client.status.removal-in-progress' },
      REMOVAL_ERROR: {'id': 253, 'label': 'client.status.removal-error' },
      FROZEN: {'id': 254, 'label': 'client.status.frozen' },
      INACTIVE: {'id': 255, 'label': 'global.status.inactive' },
    }
    angular
    .module('plagiat2017App')
    .constant('CLIENTSTATUSES', [
       clientStatus.ACTIVE,
       clientStatus.FORTHCOMING,
       clientStatus.INACTIVE
       ])
    .constant('CLIENT_STATUS', clientStatus);
})();

(function () {
    'use strict';

    function ClientsSearchController(
        $scope, $localStorage, $q, _, $timeout, $translate,
        ClientSearchRequest, ClientQueryRequest, ClientService, SearchService, DateService, AccountService, Utils,
        CLIENTSTATUSES, INSTANCES, SIMPLE_SEARCH_DELAY, CLIENTTYPECONSTANT, CONTRACTTYPECONSTANT) {

        var vm = this;
        vm.getClients = getClients;
        vm.organisationalUnits = [];
        vm.clientGroups = [];
        vm.clientRegions = [];
        vm.contractTypes = [];
        vm.countries = [];
        vm.statuses = CLIENTSTATUSES;
        vm.fixDate = DateService.fixDate;
        vm.toggleSearch = toggleSearch;
        vm.clear = clear;
        vm.searchRequest = new ClientSearchRequest();
        vm.clientQueryRequest = new ClientQueryRequest();
        vm.selectedItemChange = selectedItemChange;
        vm.querySearch = querySearch;
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.isReseller = AccountService.role.isReseller();
        vm.isMinistry = AccountService.role.isMinistry();
        vm.isSuperAdmin = AccountService.role.isSuperAdmin();
        vm.clientTypesForSearch = (vm.isReseller || vm.isMinistry) ? CLIENTTYPECONSTANT.listForResellers : CLIENTTYPECONSTANT.listForClientSearch;
        vm.clientInstances = INSTANCES.map(function (instanceConstant) {
            return instanceConstant.instance;
        });
    
        this.$onInit = function () {
            if (!vm.isReseller && !vm.isMinistry) {
                ClientService.getClientGroups().then(
                    function (success) {
                        vm.clientGroups = success.data;
                    });

                ClientService.getClientRegions().then(
                    function (success) {
                        vm.clientRegions = success.data;
                    });

                ClientService.getClientCountries().then(
                    function (success) {
                        vm.countries_ = success.data;
                        vm.countries = Utils.sortCountries(vm.countries_, $translate);
                    });
                vm.contractTypes = CONTRACTTYPECONSTANT.arrayOfValues;
            }
        };

        function toggleSearch() {
            vm.onSearchRequest.simpleSearch = '';
            vm.simpleSearch = !vm.simpleSearch;
            $localStorage.clientSimpleSearchEnabled = vm.simpleSearch;
        }

        function clear() {
            vm.onClear();
        }

        function getClients() {
            $localStorage.clientListlimit = vm.onQueryRequest.limit;
            $localStorage.clientSimpleSearchValue = vm.onSearchRequest.simpleSearch;
            prepareSearchObject();
            vm.onSearchRequest.simpleSearch.length === 0 ? vm.onGetClients() : '';
            vm.onSearchRequest.simpleSearch.length > 2 ? vm.onGetClients() : '';
        }

        function selectedItemChange(item) {
            if (angular.isDefined(item)) {
                vm.onSearchRequest.search.clientId = item.id;
            } else {
                vm.onSearchRequest.search.clientId = null;
            }
        }

        function querySearch(query) {
            if (query.length > 2) {
                vm.searchRequest.pageNumber = 0;
                vm.searchRequest.pageSize = 20;
                vm.searchRequest.sortTab = SearchService.sort(vm.clientQueryRequest);
                vm.searchRequest.search = query;
                vm.searchRequest.simpleSearch = query;

                return ClientService.searchClients(vm.searchRequest).then(function (response) {
                    return response.content;
                })
            } else {
                var deferred = $q.defer();
                $timeout(function () {
                    deferred.resolve([]);
                }, 1200, false);
                return deferred.promise;
            }
        }

        function prepareSearchObject() {
            if (angular.isDefined(vm.onSearchRequest.search.databaseExchangeProgram)) {
                vm.onSearchRequest.search.contractStatus = 0;
            }
        }
    }

    angular.module('plagiat2017App')
        .component('clientsSearch', {
            templateUrl: 'app/client/client-search/client-search.template.html',
            controller: ClientsSearchController,
            bindings: {
                onGetClients: '<',
                onQueryRequest: '<',
                onSearchRequest: '<',
                onClear: '<',
                simpleSearch: '<',
            }
        });

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ClientProtocolsController', ClientProtocolsController);
    
    function ClientProtocolsController(
        ClientService, ModalService, JhiLanguageService, PlagiatValidationService,
        $q, $stateParams
    ) {
        var vm = this;
        vm.pending = false;
        vm.protocols = [];
        vm.clientId = $stateParams.clientId;
        
        vm.remove = remove;
        vm.loadData = loadData;

        this.$onInit = function () {
            loadData();
        };
        
        function loadData() {
            vm.pending = true;
            ClientService.getClientProtocols(vm.clientId).then(function (result) {
                vm.pending = false;
                vm.protocols = result.data;
            });
        }
    
        function remove(obj) {
            ClientService
                .removeClientProtocol(vm.clientId, obj.id)
                .then(function () {
                    ModalService.showSuccessModal("global.messages.success.label");
                    loadData();
                }, function (errorResponse) {
                    ModalService.showErrorModal(errorResponse);
                });
        }
    }

})();

(function() {
    'use strict';
    
    angular
        .module('plagiat2017App')
        .controller('ClientProtocolAddController', ClientProtocolAddController);
    
    function ClientProtocolAddController(
        ProtocolsService, ClientService, ModalService, JhiLanguageService, PlagiatValidationService,
        QueryRequest, SearchRequest,
        $q, $stateParams, $localStorage, $state
    ) {
        var vm = this;
        vm.pending = false;
        vm.protocols = [];
        vm.clientId = $stateParams.clientId;
        vm.addToClient = addToClient;
        vm.loadData = loadData;
        vm.loadPage = loadPage;
        vm.clear = clear;
        
        vm.keyCodeEnter = KeyCode.KEY_RETURN;
        vm.queryRequest = new QueryRequest();
        vm.queryRequest.order = 'id';
        vm.searchRequest = new SearchRequest();
        vm.protocols = [];
        vm.protocolPage = {};
        vm.simpleSearchText;
    
        this.$onInit = function () {
            loadData();
        };
        
        function loadData() {
            if (vm.protocolPage.number) {
                vm.loadPage(vm.protocolPage.number);
            } else {
                vm.loadPage(1);
            }
        }
    
        function loadPage(pageNumber) {
            vm.searchRequest.pageNumber = pageNumber - 1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.simpleSearch = vm.simpleSearchText;
            $localStorage.protocolLimit = vm.queryRequest.limit;
            vm.pending = true;
            ProtocolsService.search(vm.searchRequest).then(function (protocolPage) {
                vm.pending = false;
                vm.protocolPage = protocolPage;
                vm.protocols = protocolPage.content;
                vm.protocolPage.number++;
                vm.queryRequest.page = vm.protocolPage.number;
            });
        }
    
        function addToClient(obj) {
            vm.pending = true;
            ClientService.addClientProtocol(vm.clientId, obj.id).then(function () {
                vm.pending = false;
                ModalService.showSuccessModal().then(
                    function () {
                        $state.go("client-protocols");
                    }, function () {
                        $state.go("client-protocols");
                    });
            }, function (errResponse) {
                PlagiatValidationService.getModalError(errResponse);
            });
        }

        function clear() {
            vm.simpleSearchText = undefined;
            loadData();
        }
        
    }
    
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ClientDocumentKindsController', ClientDocumentKindsController);
    
    function ClientDocumentKindsController(
        ClientService, ModalService, JhiLanguageService, PlagiatValidationService,
        $q, $stateParams, $state
    ) {
        var vm = this;
        vm.documentKinds = [];
        vm.availableLanguages = [];
        vm.clientId = $stateParams.clientId;
        vm.save = save;

        this.$onInit = function () {
            vm.isLoaderActive = true;
            JhiLanguageService.getAll().then(function (allLanguages) {
                vm.availableLanguages = allLanguages.data.availableLanguages;
            });
            ClientService.getClientDocumentKinds(vm.clientId).then(function (result) {
                vm.isLoaderActive = false;
                vm.documentKinds = result.data;
            });
        };
    
        function save() {
            vm.isLoaderActive = true;
    
            var rows = [];
            angular.forEach(vm.documentKinds, function(row) {
                var item = {};
                item.documentKindId = row.documentKindId;
                item.enabled = row.enabled;
                item.label = row.label;
                rows.push(item);
            });
    
            ClientService.updateClientDocumentKinds({'clientId':vm.clientId, 'dtos': rows}).then(function () {
                vm.isLoaderActive = false;
                ModalService.showSuccessModal().then(
                    function () {
                        $state.go("client");
                    }, function () {
                        $state.go("client");
                    });
            }, function (errResponse) {
                PlagiatValidationService.getModalError(errResponse);
            });
        }

    }

})();

(function() {
	'use strict';

	function ClientDetailsController(
	    UserService, ClientService, UserSearchRequest, $state, USERSCHOOLTYPE
    ) {
		var vm = this;

		vm.showAdmins = showAdmins;

        /**
         * Fill user search object and redirect to user page
         */
		function showAdmins(){
            //for user-search client autocomplete preselection
			ClientService.client = vm.client;

			UserService.searchObject = new UserSearchRequest();
            UserService.searchObject.clientId = vm.client.id;
            UserService.searchObject.role = USERSCHOOLTYPE.USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR.id;
			$state.go('users');
		}
	}

	angular
        .module('plagiat2017App')
        .component(
            'clientDetails',
            {
                templateUrl : 'app/client/client-detail/client-detail.template.html',
                controller : ClientDetailsController,
                bindings: {
                    client: '<'
                }
            }
        );

})();

(function() {
    'use strict';

    function ClientContractController(CONTRACTTYPECONSTANT) {
        var vm = this;

        vm.contractType = CONTRACTTYPECONSTANT;
        vm.toggleEdit = false;
        vm.createForthcomingContract = createForthcomingContract;
        vm.countPercentOfPlagReportsUsed = countPercentOfPlagReportsUsed;
        vm.countPercentOfAiDetectionUsed = countPercentOfAiDetectionUsed;
        vm.forthcomingContractFromDateChange = forthcomingContractFromDateChange;
        vm.contractToDateChange = contractToDateChange;
        vm.today = new Date();
        vm.disableForthcoming = disableForthcoming;
        this.$onInit = onInit;

        function onInit() {
            contractToDateChange();
            if(vm.client.forthcomingContract) {
                forthcomingContractFromDateChange();
            }
        }

        function disableForthcoming() {
            vm.client.forthcomingContract = undefined;
            vm.contractMaxDate = null;
            onInit();
        }

        function createForthcomingContract(){
            vm.client.forthcomingContract = {};
            if(vm.client.contract) {
                vm.client.forthcomingContract.contDateFrom = new Date(
                    addDays(vm.client.contract.contDateTo, 1));
                vm.client.forthcomingContract.contDateTo = new Date(
                    addDays(vm.client.forthcomingContract.contDateFrom, 365));
                vm.client.forthcomingContract.contNumOfPlagReports = vm.client.contract.contNumOfPlagReports;
                vm.client.forthcomingContract.contMaxDocPlagSize = vm.client.contract.contMaxDocPlagSize;
                vm.client.forthcomingContract.contType = vm.client.contract.contType;
                vm.contractToDateChange();
                vm.forthcomingContractFromDateChange();
            }
        }

        function contractToDateChange() {
            if (vm.client.contract) {
                vm.forthcomingContractFromMinDate = new Date(addDays(vm.client.contract.contDateTo, 1));
            } else {
                vm.forthcomingContractFromMinDate = null;
            }
        }

        function forthcomingContractFromDateChange() {
            vm.contractMaxDate = new Date(addDays(vm.client.forthcomingContract.contDateFrom, -1));
        }

        function addDays(date, days){
            var dateToChange = new Date(date);
            return dateToChange.setDate(dateToChange.getDate() + days);
        }

        function countPercentOfPlagReportsUsed(contract) {
            return (contract.contNumOfPlagReportsLeft && contract.contNumOfPlagReports) ? getFlooredFixed((((contract.contNumOfPlagReports - contract.contNumOfPlagReportsLeft) / contract.contNumOfPlagReports)) * 100, 2) + ' %' : '';
        }

        function countPercentOfAiDetectionUsed(contract) {
            return (contract.contNumOfAiDetectionLeft && contract.contNumOfAiDetection) ? getFlooredFixed((((contract.contNumOfAiDetection - contract.contNumOfAiDetectionLeft) / contract.contNumOfAiDetection)) * 100, 2) + ' %' : '';
        }

        function getFlooredFixed(v, d) {
            return (Math.floor(v * Math.pow(10, d)) / Math.pow(10, d)).toFixed(d);
        }

    }

    angular
    .module('plagiat2017App')
    .component(
        'clientContract',
        {
            templateUrl : 'app/client/client-add/steps/components/contract/contract.template.html',
            controller : ClientContractController,
            controllerAs: 'vm',
            bindings: {
                client: '=',
                onIsEdit: '='
            }
        }
    );
})();

(function () {
    'use strict';

    function ClientCreateStepCodeAccountController(InstanceService, PaymentInitRequest) {
        var vm = this;
        vm.isEverythingValidEngine = isEverythingValidEngine;

        this.$onInit = function () {
            vm.isEverythingValid = true;
            vm.paymentInit = new PaymentInitRequest();
            vm.instance = vm.client.basicData.clientInstance;
            if (!vm.client.codeAccount.codeTypePrices || vm.client.codeAccount.codeTypePrices.length === 0) {
                vm.addCodeTypePrices();
            }
            vm.availableCurrencies = InstanceService.findInstanceByBrand(vm.instance).currencies.list;
            vm.availablePayments = {};
            InstanceService.findInstanceByBrand(vm.instance).currencies.settings.forEach(function (currencySetting) {
                vm.availablePayments[currencySetting.name] = currencySetting.methodsOfPayment;
            });
            isEverythingValidEngine();
        };

        function isEverythingValidEngine() {
            var currencyValid = vm.client.codeAccount.currencies.length > 0;
            var codeTypesValid = vm.client.codeAccount.codeTypePrices && vm.client.codeAccount.codeTypePrices.length > 0;
            var paymentsValid = true;
            for (var currency in vm.client.codeAccount.payments) {
                if (vm.client.codeAccount.payments[currency].length === 0) {
                    paymentsValid = false;
                    break;
                }
            }
            vm.isEverythingValid = paymentsValid && currencyValid && codeTypesValid;
        }

        vm.onClickNext = function () {
            isEverythingValidEngine();
            if (vm.isEverythingValid) {
                vm.stepCodeAccountCompleted();
            }
        }

        vm.onClickCurrency = function (currency) {
            var index = vm.client.codeAccount.currencies.indexOf(currency);
            if (index > -1) {
                vm.client.codeAccount.currencies.splice(index, 1);
                delete vm.client.codeAccount.payments[currency];
            } else {
                vm.client.codeAccount.currencies.push(currency);
            }
            isEverythingValidEngine();
        };

        vm.onClickPayment = function (currency, paymentMethod) {
            if (!vm.client.codeAccount.payments[currency]) {
                vm.client.codeAccount.payments[currency] = [];
            }
            var index = vm.client.codeAccount.payments[currency].indexOf(paymentMethod);
            if (index > -1) {
                vm.client.codeAccount.payments[currency].splice(index, 1);
            } else {
                vm.client.codeAccount.payments[currency].push(paymentMethod);
            }
            isEverythingValidEngine();
        };

        vm.addCodeTypePrices = function () {
            vm.client.codeAccount.codeTypePrices.push({name: "", size: 0, currencies: {}});
            isEverythingValidEngine();
        };

        vm.deleteCodeTypePrices = function (index) {
            vm.client.codeAccount.codeTypePrices.splice(index, 1);
            isEverythingValidEngine();
        };
    }

    angular
        .module('plagiat2017App')
        .component('clientCreateStepCodeAccount', {
            templateUrl: 'app/client/client-add/steps/client-create-step-code-account.html',
            controller: ClientCreateStepCodeAccountController,
            controllerAs: 'vm',
            bindings: {
                client: '=',
                availableCurrencies: '=',
                availablePayments: '=',
                isSaving: '=',
                isEdit: '=',
                previousStep: '&',
                saveOrUpdate: '&',
                stepCodeAccountCompleted: '&'
            }
        });
})();

(function () {
    'use strict';

    function ClientConfigurationController(COUNTRYCODECONSTANT, CLIENTTYPECONSTANT) {
        var vm = this;

        vm.configuration = {
            reportSettings: [
                {label: 'ignoring-bibliography', model: 'ignoringBibliography'},
                {label: 'ignoring-citations', model: 'ignoringCitations'},
                {label: 'excluding-citations', model: 'excludingCitations'},
                {label: 'smartmarks-disabled', model: 'smartmarksDisabled'},
                {label: 'hide-docu-similarity-factor', model: 'hideDocuSimilarityFactor'},
                {label: 'hide-docu-similarity-factor-ext', model: 'hideDocuSimilarityFactorExt'},
                {label: 'show-reversed-similarity-factor', model: 'showReversedSimilarityFactor'},
                {label: 'show-self-citation-factor', model: 'showSelfCitationFactor'},
                {label: 'report-2020-disabled', model: 'report2020Disabled'},
                {label: 'report-2020-operator-can-edit', model: 'report2020OperatorCanEdit'},
                {label: 'report-2020-no-submit-button', model: 'report2020NoSubmitButton'},
                {label: 'report-2020-view-only-in-email', model: 'report2020ViewOnlyInEmail'},
                {label: 'warning-thresholds', model: 'warningThresholds'},
                {label: 'report-2020-preview-source-plagiat', model: 'report2020PreviewSourcePlagiat'},
                {label: 'grading-enabled', model: 'gradingEnabled'},
                {label: 'rubric-enabled', model: 'rubricEnabled'},
                {label: 'hide-metadata', model: 'hideMetadata'},
                {label: 'qr-code', model: 'qrCode'},
                {label: 'engine-mode-parallel', model: 'engineMode2026'},
            ],
            addToDatabase: [
                {value: 'without'},
                {value: 'manually'},
                {value: 'automatically'},
                {value: 'delayed'}
            ],
            jsaOrppdSettings: [
                {label: 'jsa-integration', model: 'jsaIntegration'},
                {label: 'jsa-run-ai-detection', model: 'jsaRunAiDetection'},
                {label: 'orppd-integration', model: 'orppdIntegration'}
            ],
            addToDatabaseSettings: [
                {label: 'teacher-cant-delete-from-database', model: 'teacherCantDeleteFromDatabase'},
                {label: 'hide-add-without-checking', model: 'hideAddWithoutChecking'},
                {label: 'only-admin-can-add', model: 'onlyAdminCanAddToDatabase'},
            ],
            otherSettings: [
                {label: 'author-name-field-required', model: 'fieldRequiredAuthorName'},
                {label: 'send-alert-to-promoter', model: 'sendAlertToPromoter'},
                {label: 'send-alert-to-student', model: 'sendAlertToStudent'},
                {label: 'protocols-enabled', model: 'protocolsEnabled'},
                {label: 'document-import-enabled', model: 'documentImportEnabled'},
                {label: 'assignments-enabled', model: 'assignmentsEnabled'},
                {label: 'assignments-paid-corrections-enabled', model: 'assignmentsPaidCorrectionsEnabled'},
                {label: 'add-priority-from-contract-enabled', model: 'addPriorityFromContractEnabled'},
                {label: 'auto-translations-enabled', model: 'autoTranslationsEnabled'},
                {label: 'auto-translations-lang-selection', model: 'autoTranslationsLangSelection'},
                {label: 'tags-enabled', model: 'tagsEnabled'},
                {label: 'peer-review-enabled', model: 'peerReviewEnabled'},
                {label: 'disable-skip-sites-url', model: 'disableSkipSitesUrl'}
            ],
            rareSettings: [
                {label: 'all-users-can-delete-documents', model: 'allUsersCanDeleteDocuments'},
                {label: 'all-users-can-delete-accounts', model: 'allUsersCanDeleteAccounts'},
                {label: 'hide-user-history', model: 'hideUserHistory'},
                {label: 'authors-simplified-fields', model: 'authorsSimplifiedFields'},
                {label: 'authors-from-users-list', model: 'authorFromUsersList'},
                {label: 'perm-user-do-not-use-copy-paste', model: 'permUserDoNotUseCopyPaste'},
                {label: 'perm-user-check-document-metric-similarity-before-add', model: 'permUserCheckDocumentMetricSimilarityBeforeAdd'},
                {label: 'perm-user-download-pdf-report', model: 'permUserDownloadPdfReport'},
                {label: 'perm-user-document-verification', model: 'permUserDocumentVerification'},
                {label: 'document-comparision', model: 'documentComparision'},
                {label: 'no-document-upload-for-students', model: 'noDocumentUploadForStudents'},
                {label: 'db-exchange-program-list-hidden', model: 'dbExchangeProgramListHidden'},
                {label: 'document-kind-due-date', model: 'documentKindDueDate'},
                {label: 'coordinator-not-required-by-default', model: 'coordinatorNotRequiredByDefault'},
                {label: 'old-phd-checking-year-field', model: 'oldPhdCheckingYearField'},
                {label: 'perm-user-upload-support', model: 'permUserUploadSupport'},
                {label: 'restricting-databases', model: 'restrictingDatabases'},
                {label: 'gclassroom-and-msteams-integration', model: 'googleClassroomIntegration'},
                {label: 'reserved-emails', model: 'reservedEmails'},//+ edition of the domain list
                {label: 'accept-regulations-enabled', model: 'acceptRegulationsEnabled'},//+ edition of the regulations url
                {label: 'password-change', model: 'passwordChange'}, //+ edition of the passwordChangePeriod
            ],
            aiDetectionSettings: [
                {label: 'ai-detection-hide-slider', model: 'aiDetectionHideSlider'},
                {label: 'ai-detection-only-two-pages', model: 'aiDetectionOnlyTwoPages'},
                {label: 'ai-detection-not-for-long-text', model: 'aiDetectionNotForLongText'},
                {label: 'ai-detection-show-only-probability', model: 'aiDetectionShowOnlyProbability'},
                {label: 'ai-detection-show-first-score', model: 'aiDetectionShowFirstScore'},
                {label: 'ai-detection-exclude-fragments', model: 'aiDetectionExcludeFragments'},
            ],
            grammarCheckSettings: [
                {label: 'grammar-check', model: 'enabled'},
            ],
            userSettings: [
                {label: 'allow-edit-document', model: 'allowEditDocument'},
                {label: 'perm-user-cant-see-the-documents-of-others', model: 'permUserCantSeeTheDocumentsOfOthers'},
                {label: 'perm-user-can-change-organisational-unit', model: 'permUserCanChangeOrganisationalUnit'},
                {label: 'user-teacher-can-change-promoter', model: 'userTeacherCanChangePromoter'},
                {label: 'perm-users-can-download-original-file', model: 'permUsersCanDownloadOriginalFile'}
            ],
            userGroupsSettings: [
                {label: 'allow-create-students', model: 'allowCreateStudents'},
            ],
            documentFieldSettings: [
                {label: 'index-number-present', model: 'indexNumberPresent'},
                {label: 'index-number-required', model: 'indexNumberRequired'},
            ],
            uploadPermissions: [
                {label: 'txt-support', model: 'txtSupport'},
                {label: 'pdf-support', model: 'pdfSupport'},
                {label: 'doc-support', model: 'docSupport'},
                {label: 'docx-support', model: 'docxSupport'},
                {label: 'odt-support', model: 'odtSupport'},
                {label: 'rtf-support', model: 'rtfSupport'},
                {label: 'ppt-support', model: 'pptSupport'},
                {label: 'pptx-support', model: 'pptxSupport'},
                {label: 'html-support', model: 'htmlSupport'},
                {label: 'postscript-support', model: 'postscriptSupport'},
                {label: 'wordperfect-support', model: 'wordperfectSupport'}
            ]
        };

        vm.aiDetectionRoles = [
            'forStudent',
            'forOperator',
            'forLecturer',
            'forAdmin',
            'forApi'
        ]
        vm.aiDetectionOptions = [
            'alwaysDisabled',
            'defaultDisabled',
            'defaultEnabled',
            'alwaysEnabled'
        ];

        vm.available = function(model) {
            switch (model) {
                // case 'autoTranslationsEnabled':
                //     return vm.client.basicData.clientInstance === 'int';
                case 'oldPhdCheckingYearField':
                    return vm.client.basicData.clientInstance === 'ro';
                case 'permUserDocumentVerification':
                case 'documentFieldCard':
                    return !isClientTypePublishingHouse() && !isClientTypeSchool();
                case 'sendAlertToPromoter':
                    return !isClientTypePublishingHouse();
                case 'sendAlertToStudent':
                    return isClientTypeSchool();
                case 'assignmentsPaidCorrectionsEnabled':
                    return isClientTypeCollege() || isClientTypeCodeAccount();
                case 'userGroupsCard':
                    return isClientTypeCodeAccount() || isClientTypeStandardUniversity() || isClientTypeCollege();
                case 'userSettingsCard':
                case 'allowEditDocument':
                    return !isClientTypeSchool();
                case 'jsaOrppdCard':
                case 'jsaRunAiDetection':
                    return isOrppdAndJsaIntegrationAvailable()
                        || (isClientTypeAsap() && vm.client.basicData.countryId === COUNTRYCODECONSTANT.POLAND_COLUMBIA.id);
                case 'jsaIntegration':
                case 'orppdIntegration':
                    return isOrppdAndJsaIntegrationAvailable();
                case 'authorsSimplifiedFields':
                case 'userTeacherCanChangePromoter':
                    return isClientTypeStandardUniversity() || isClientTypeCodeAccount();
                case 'permUserCantSeeTheDocumentsOfOthers':
                    return isClientTypeStandardUniversity() || isClientTypeCodeAccount() || isClientTypePublishingHouse();
                default: return true;
            }
        };

        function isOrppdAndJsaIntegrationAvailable() {
            return vm.client.basicData.countryId === COUNTRYCODECONSTANT.POLAND_COLUMBIA.id && isClientTypeStandardUniversity();
        }

        function isClientTypeStandardUniversity() {
            return vm.client.basicData.clientType.id === CLIENTTYPECONSTANT.CLIE_TYPE_NORMAL.id;
        }

        function isClientTypeAsap() {
            return vm.client.basicData.clientType.id === CLIENTTYPECONSTANT.CLIE_TYPE_NORMAL.id;
        }

        function isClientTypePublishingHouse() {
            return vm.client.basicData.clientType.id === CLIENTTYPECONSTANT.CLIE_TYPE_PUBLISHING_HOUSE.id;
        }

        function isClientTypeCodeAccount() {
            return vm.client.basicData.clientType.id === CLIENTTYPECONSTANT.CODE_ACCOUNT.id;
        }

        function isClientTypeSchool() {
            return vm.client.basicData.clientType.id === CLIENTTYPECONSTANT.SCHOOL.id;
        }

        function isClientTypeCollege() {
            return vm.client.basicData.clientType.id === CLIENTTYPECONSTANT.COLLEGE.id;
        }

    }

    angular
        .module('plagiat2017App')
        .component('clientConfiguration', {
            templateUrl: 'app/client/client-add/steps/client-configuration.html',
            controller: ClientConfigurationController,
            controllerAs: 'vm',
            bindings: {
                client: '=',
                isSaving: '=',
                isEdit: '=',
                previousStep: '&',
                saveOrUpdate: '&',
            }
        });
})();

(function () {
    'use strict';

    function ContractDetailController(CONTRACTTYPECONSTANT, ASAP_CONTRACT_INSTALLATION_CONSTANT, ASAP_CONTRACT_INTEGRATION_CONSTANT) {
        var vm = this;
        this.$onInit = function () {
            vm.contract = this.contract;
            if (vm.contract.isAsap) {
                var installationType = ASAP_CONTRACT_INSTALLATION_CONSTANT.arrayOfValues.find(function (installation) {
                    return installation.id === vm.contract.installationType;
                });
                vm.installationTypeKey = installationType ? installationType.key : '---';
                var integrationType = ASAP_CONTRACT_INTEGRATION_CONSTANT.arrayOfValues.find(function (integration) {
                    return integration.id === vm.contract.integrationType;
                });
                vm.integrationTypeKey = integrationType ? integrationType.key : '---';
            } else {
                var contractType = CONTRACTTYPECONSTANT.arrayOfValues.find(function (contType) {
                    return contType.id === vm.contract.contType;
                });
                vm.contractTypeKey = contractType ? contractType.key : '---';
            }
        }
    }

    angular
        .module('plagiat2017App')
        .component('contractDetails',
            {
                templateUrl: 'app/client/client-add/contract-details/contract-details.template.html',
                controller: ContractDetailController,
                bindings: {
                    contract: '<',
                }
            }
        );

})();

(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .controller('ClientAddTestController', ClientAddTestController);

    ClientAddTestController.$inject = [
        'ClientService', 'ClientEditRequestModel', '$state',
        'ModalService', 'JhiLanguageService', 'FinderService'
    ];

    function ClientAddTestController(
        ClientService, ClientEditRequestModel, $state,
        ModalService, JhiLanguageService, FinderService
    ) {
        var vm = this;

        this.$onInit = function () {
            onInit();
        };

        // general
        vm.client;

        vm.availableLanguages = [];
        vm.availableFinders = [];
        vm.findersSelection = {};
        vm.toggleFinderSelection = toggleFinderSelection;
        vm.save = save;

        function onInit() {
            JhiLanguageService.getAll().then(function (allLanguages) {
                vm.availableLanguages = allLanguages.data.availableLanguages;
            });
            
            //tworzenie klienta
            vm.client = new ClientEditRequestModel();
            vm.client.basicData.clientType.id = 0;
            JhiLanguageService.getCurrent().then(function (language) {
                vm.client.basicData.clieLang = language;
            });
            initializeFindersSelection();
        }

        function initializeFindersSelection() {
            FinderService.getAllAvailableForClientType(vm.client.basicData.clientType.id, vm.client.basicData.countryId, true)
                .then(function (success) {
                    vm.availableFinders = success.data;
                    vm.availableFinders.forEach(function (entry) {
                        if (entry.defaultQueriesPerKilo > 0) {
                            if ((entry.description !== 'finder.database.shukalka') && (entry.description !== 'finder.database.whitedocs')) {
                                vm.findersSelection[entry.id] = true;
                                vm.toggleFinderSelection(entry.id);
                            }
                        }
                    });
                });
        }

        function toggleFinderSelection(finderId) {
            if (vm.findersSelection[finderId]) {
                if (!vm.client.findersConfiguration[finderId]) {
                    vm.client.findersConfiguration[finderId] = {id: null, queriesPerKilo: 0, visible: true};
                }
                vm.client.findersConfiguration[finderId].queriesPerKilo = vm.availableFinders.find(function (finder) {
                    return finder.id === finderId;
                }).defaultQueriesPerKilo;
                vm.client.findersConfiguration[finderId].visible = true;
                //teraz sprawdzam, czy nie trzeba wylaczyc innego findera intenetowego (0 lub 18)
                var currentFinder = vm.availableFinders.find(function (finder) {
                    return finder.id === finderId;
                });

                if (currentFinder && (currentFinder.finderType === 0 || currentFinder.finderType === 18)) {
                    var otherWebFinder = vm.availableFinders.find(function (finder) {
                        return finder.id !== finderId && (finder.finderType === 0 || finder.finderType === 18);
                    });
                    if (otherWebFinder) {
                        vm.findersSelection[otherWebFinder.id] = false;
                        if(!vm.client.findersConfiguration[otherWebFinder.id]) {
                            vm.client.findersConfiguration[otherWebFinder.id] = {}
                        }
                        vm.client.findersConfiguration[otherWebFinder.id].queriesPerKilo = 0;
                        vm.client.findersConfiguration[otherWebFinder.id].visible = false;
                    }
                }
            } else {
                vm.client.findersConfiguration[finderId].queriesPerKilo = 0;
                vm.client.findersConfiguration[finderId].visible = false;
            }
        }

        function save() {
            vm.isSaving = true;
            
            ClientService.addTestClient(vm.client).then(
                function () {
                    vm.isSaving = false;
                    ModalService.showSuccessModal();
                    $state.go("client");
                },
                function (response) {
                    vm.isSaving = false;
                    ModalService.showErrorModal(response);
                }
            );
            
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .controller('ClientAddController', ClientAddController);

    ClientAddController.$inject = [
        '$stateParams', '$state', '$translate',
        'ClientEditRequestModel',
        'CONTRACTTYPECONSTANT', 'ASAP_CONTRACT_INSTALLATION_CONSTANT', 'ASAP_CONTRACT_INTEGRATION_CONSTANT', 'COUNTRYCODECONSTANT', 'CLIENTTYPECONSTANT', 'INSTANCES',
        'FinderService', 'ClientService', 'UserService', 'ModalService', 'ContractService', 'JhiLanguageService', 'InstanceService', 'AccountService', 'Utils'
    ];

    function ClientAddController(
        $stateParams, $state, $translate,
        ClientEditRequestModel,
        CONTRACTTYPECONSTANT, ASAP_CONTRACT_INSTALLATION_CONSTANT, ASAP_CONTRACT_INTEGRATION_CONSTANT, COUNTRYCODECONSTANT, CLIENTTYPECONSTANT, INSTANCES,
        FinderService, ClientService, UserService, ModalService, ContractService, JhiLanguageService, InstanceService, AccountService, Utils
    ) {
        var vm = this;

        this.$onInit = function () {
            onInit();
        };

        // general
        vm.client;

        vm.isReseller = AccountService.role.isReseller();
        vm.isMinistry = AccountService.role.isMinistry();

        vm.clientType = CLIENTTYPECONSTANT;
        vm.clientTypes = vm.isReseller ? CLIENTTYPECONSTANT.listForResellers : CLIENTTYPECONSTANT.listForEditClient;
        vm.clientInstances = INSTANCES.map(function (instanceConstant) {
            return instanceConstant.instance;
        });
        vm.availableLanguages = [];
        vm.clientGroups = [];
        vm.clientRegions = [];
        vm.countries = [];

        vm.basicDataStepId = 0;
        vm.stepIdCodeAccount = 1;
        vm.contractStepId = 2;
        vm.configurationStepId = 3;

        vm.saveOrUpdate = saveOrUpdate;
        vm.isEdit = isEdit;

        function onInit() {
            vm.clientId = $stateParams.id;
            JhiLanguageService.getAll().then(function (allLanguages) {
                vm.availableLanguages = allLanguages.data.availableLanguages;
            });
            if (vm.clientId) {
                //edycja klienta
                switch ($stateParams.step) {
                    case "basic-data":
                        vm.selectedStep = vm.basicDataStepId;
                        vm.basicDataStep = {completed: false, disabled: false};
                        vm.stepCodeAccount = {completed: true, disabled: true};
                        vm.contractStep = {completed: true, disabled: true};
                        vm.configurationStep = {completed: true, disabled: true};
                        break;
                    case "code-account":
                        vm.selectedStep = vm.stepIdCodeAccount;
                        vm.basicDataStep = {completed: true, disabled: true};
                        vm.stepCodeAccount = {completed: false, disabled: false};
                        vm.contractStep = {completed: true, disabled: true};
                        vm.configurationStep = {completed: true, disabled: true};
                        break;
                    case "contract":
                        vm.selectedStep = vm.contractStepId;
                        vm.basicDataStep = {completed: true, disabled: true};
                        vm.stepCodeAccount = {completed: true, disabled: true};
                        vm.contractStep = {completed: false, disabled: false};
                        vm.configurationStep = {completed: true, disabled: true};
                        break;
                    case "configuration":
                        vm.selectedStep = vm.configurationStepId;
                        vm.basicDataStep = {completed: true, disabled: true};
                        vm.stepCodeAccount = {completed: true, disabled: true};
                        vm.contractStep = {completed: true, disabled: true};
                        vm.configurationStep = {completed: false, disabled: false};
                        break;
                    default:
                        $state.go("client");
                }
                vm.isLoading = true;
                vm.loadClientGroupsAndRegions();
                ClientService.getClientForEditing(vm.clientId).then(
                    function (success) {
                        vm.client = new ClientEditRequestModel();
                        vm.client.basicData = success.data.basicData;
                        vm.client.codeAccount = success.data.codeAccount;
                        vm.client.isDatabaseExchangeProgramMember = success.data.isDatabaseExchangeProgramMember;
                        vm.client.databaseExchangeSourcesVisible = success.data.databaseExchangeSourcesVisible;
                        vm.client.clientIsHidden = success.data.clientIsHidden;
                        vm.client.contract = success.data.contract;
                        vm.client.forthcomingContract = success.data.forthcomingContract;
                        vm.client.configuration = success.data.configuration;
                        vm.client.asapContract = success.data.asapContract;
                        vm.client.findersConfiguration = success.data.findersConfiguration;
                        vm.client.parseAllDates();
                        for (var finderConfiguration in vm.client.findersConfiguration) {
                            vm.findersSelection[finderConfiguration] = true;
                        }
                        vm.isLoading = false;
                    }, function (response) {
                        ModalService.showErrorModal(response);
                        vm.isLoading = false;
                    }
                ).then(function () {
                    if (vm.selectedStep === vm.contractStepId) {
                        initializeFindersSelection();
                    }
                });
                ContractService.getHistory(vm.clientId).then(function (response) {
                    vm.contractHistory = response.data;
                    if (angular.isArray(vm.contractHistory)) {
                        vm.contractHistoryPageNumber = 1;
                        vm.contractHistoryPageSize = 5;
                        vm.contractHistoryPage = vm.contractHistory.slice(0, vm.contractHistoryPageSize);
                        vm.contractHistoryTotalNumOfRecords = vm.contractHistory.length;
                    }
                });
            } else {
                //tworzenie klienta
                vm.client = new ClientEditRequestModel();
                vm.selectedStep = vm.basicDataStepId;
                JhiLanguageService.getCurrent().then(function (language) {
                    vm.client.basicData.clieLang = language;
                });
                vm.loadClientGroupsAndRegions();

                vm.basicDataStep = {completed: false, disabled: false};
                vm.stepCodeAccount = {completed: false, disabled: true};
                vm.contractStep = {completed: false, disabled: true};
                vm.configurationStep = {completed: false, disabled: true};
            }
        }

        function saveOrUpdate() {
            vm.isSaving = true;
            if (isEdit()) {
                ClientService.update(vm.client).then(
                    function () {
                        vm.isSaving = false;
                        ModalService.showSuccessModal();
                        $state.go("client");
                    },
                    function (response) {
                        vm.isSaving = false;
                        ModalService.showErrorModal(response);
                        $mdToast.show($mdToast.simple().textContent($translate.instant("global.messages.error.label")));
                    }
                );
            } else {
                ClientService.save(vm.client).then(
                    function () {
                        vm.isSaving = false;
                        ModalService.showSuccessModal();
                        $state.go("client");
                    },
                    function (response) {
                        vm.isSaving = false;
                        ModalService.showErrorModal(response);
                    }
                );
            }
        }

        function isEdit() {
            return vm.clientId;
        }

        vm.previousStep = function () {
            /** fix jak step codeAccount jest disabled to "vm.selectedStep--;" nie przekierowuje do tylu, mimo tego "vm.selectedStep++;" przeskakuje do przodu */
            if (vm.selectedStep == vm.contractStepId 
                && vm.client.basicData.clientType.id != vm.clientType.CODE_ACCOUNT.id
                && vm.client.basicData.clientType.id != vm.clientType.COLLEGE.id) {
                vm.selectedStep = vm.basicDataStepId;
            } else {
                vm.selectedStep--;
            }
        };

        // end general

        // basic data
        vm.onStepBasicDataCompleted = function () {
            if (!isEdit()) {
                UserService.isEmailUsed(vm.client.basicData.adminEmail).then(function (response) {
                    if (response.data) {
                        ModalService.showDialogModal("client.user.email.exists");
                    } else {
                        basicDataCompleted();
                    }
                });
            } else {
                basicDataCompleted();
            }
        };

        function basicDataCompleted() {
            vm.basicDataStep.completed = true;
            if (vm.client.basicData.clientType.id === vm.clientType.CODE_ACCOUNT.id
                || vm.client.basicData.clientType.id === vm.clientType.COLLEGE.id ) {
                vm.stepCodeAccount.disabled = false;
            } else {
                vm.stepCodeAccount.disabled = true;
                vm.stepCodeAccount.completed = false;
                vm.contractStep.disabled = false;
                initializeFindersSelection();
            }
            vm.selectedStep++;

            setExchangeProgramDefaultValues();
        }

        vm.stepCodeAccountCompleted = function () {
            vm.stepCodeAccount.completed = true;
            vm.contractStep.disabled = false;
            vm.selectedStep++;
            initializeFindersSelection();
        };

        // end basic data

        // contract related functions and variables
        vm.contractType = CONTRACTTYPECONSTANT;
        vm.asapContractInstallation = ASAP_CONTRACT_INSTALLATION_CONSTANT;
        vm.asapContractIntegrationTypes = ASAP_CONTRACT_INTEGRATION_CONSTANT.arrayOfValues;

        vm.stepContractCompleted = stepContractCompleted;
        vm.findersSelection = {};
        vm.toggleFinderSelection = toggleFinderSelection;
        vm.shouldShowAsapSection = shouldShowAsapSection;
        vm.expandedContractHistoryItems = [];
        vm.chooseContractHistoryPage = chooseContractHistoryPage;
        vm.contractHistoryPageOffset = contractHistoryPageOffset;

        function chooseContractHistoryPage(pageNum) {
            vm.contractHistoryPage = vm.contractHistory.slice((pageNum - 1) * vm.contractHistoryPageSize, pageNum * vm.contractHistoryPageSize);
        }

        function contractHistoryPageOffset() {
            return (vm.contractHistoryPageNumber - 1) * vm.contractHistoryPageSize;
        }

        function toggleFinderSelection(finderId) {
            if (vm.findersSelection[finderId]) {
                if (!vm.client.findersConfiguration[finderId]) {
                    vm.client.findersConfiguration[finderId] = {id: null, queriesPerKilo: 0, visible: true};
                }
                vm.client.findersConfiguration[finderId].queriesPerKilo = vm.availableFinders.find(function (finder) {
                    return finder.id === finderId;
                }).defaultQueriesPerKilo;
                vm.client.findersConfiguration[finderId].visible = true;
                //teraz sprawdzam, czy nie trzeba wylaczyc innego findera intenetowego (0 lub 18)
                var currentFinder = vm.availableFinders.find(function (finder) {
                    return finder.id === finderId;
                });
    
                if (currentFinder && (currentFinder.finderType === 0 || currentFinder.finderType === 18)) {
                    var otherWebFinder = vm.availableFinders.find(function (finder) {
                        return finder.id !== finderId && (finder.finderType === 0 || finder.finderType === 18);
                    });
                    if (otherWebFinder) {
                        vm.findersSelection[otherWebFinder.id] = false;
                        if(!vm.client.findersConfiguration[otherWebFinder.id]) {
                            vm.client.findersConfiguration[otherWebFinder.id] = {}
                        }
                        vm.client.findersConfiguration[otherWebFinder.id].queriesPerKilo = 0;
                        vm.client.findersConfiguration[otherWebFinder.id].visible = false;
                    }
                }
            } else {
                vm.client.findersConfiguration[finderId].queriesPerKilo = 0;
                vm.client.findersConfiguration[finderId].visible = false;
            }
        }

        function shouldShowAsapSection() {
            return vm.client.basicData.clientType.id === vm.clientType.CLIE_TYPE_ASAP.id;
        }

        function stepContractCompleted() {
            vm.contractStep.completed = true;
            vm.configurationStep.disabled = false;
            vm.selectedStep++;
            setClientConfigurationDefaultValues();
        }

        function setClientConfigurationDefaultValues() {
            if (vm.client.basicData.clientType.id !== CLIENTTYPECONSTANT.CLIE_TYPE_PUBLISHING_HOUSE.id) {
                vm.client.configuration.otherSettings.permUserCheckDocumentMetricSimilarityBeforeAdd = true;
                vm.client.configuration.otherSettings.sendAlertToPromoter = true;
                vm.client.configuration.otherSettings.assignmentsEnabled = true;
                vm.client.configuration.otherSettings.assignmentsPaidCorrectionsEnabled = true;
                vm.client.configuration.otherSettings.maxAssignmentCorrections = 3;
            } else {
                vm.client.configuration.reportSettings.report2020OperatorCanEdit = true;
            }
            if (vm.client.basicData.countryId === COUNTRYCODECONSTANT.POLAND_COLUMBIA.id) {
                vm.client.configuration.userSettings.allowEditDocument = true;
                vm.client.configuration.aiDetectionSettings.forStudent = 'alwaysEnabled';
                vm.client.configuration.aiDetectionSettings.forOperator = 'defaultEnabled';
                vm.client.configuration.aiDetectionSettings.forLecturer = 'defaultEnabled';
                vm.client.configuration.aiDetectionSettings.forAdmin =    'defaultEnabled';
                vm.client.configuration.aiDetectionSettings.forApi =      'defaultEnabled';
            }
            if (vm.client.basicData.countryId === COUNTRYCODECONSTANT.POLAND_COLUMBIA.id
                && vm.client.basicData.clientType.id === CLIENTTYPECONSTANT.CLIE_TYPE_NORMAL.id) {
                vm.client.configuration.documentFieldSettings.indexNumberPresent = true;
            }
            if (vm.client.basicData.clientType.id !== CLIENTTYPECONSTANT.SCHOOL.id) {
                vm.client.configuration.otherSettings.sendAlertToPromoter = true;
            } else {
                vm.client.configuration.otherSettings.documentImportEnabled = true;
            }
            if (vm.client.basicData.clientInstance === 'int') {
                vm.client.configuration.otherSettings.addPriorityFromContractEnabled = true;
                vm.client.configuration.otherSettings.dbExchangeProgramListHidden = true;
                vm.client.configuration.otherSettings.tagsEnabled = true;
                vm.client.configuration.otherSettings.peerReviewEnabled = true;
                vm.client.configuration.otherSettings.restrictingDatabases = true;
                vm.client.configuration.otherSettings.protocolsEnabled = true;
                vm.client.configuration.otherSettings.fieldRequiredAuthorName = parseInt(vm.client.contract.contType) === CONTRACTTYPECONSTANT.CONT_TYPE_PER_AUTHOR.id;
                vm.client.configuration.reportSettings.report2020PreviewSourcePlagiat = true;
                vm.client.configuration.aiDetectionSettings.forAdmin =    'defaultEnabled';
                vm.client.configuration.similarityReportSettings.warningThreshold1 = 30;
                vm.client.configuration.similarityReportSettings.warningThreshold2 = 5;
            }
            if (vm.client.basicData.clientType.id === CLIENTTYPECONSTANT.COLLEGE.id) {
                vm.client.configuration.reportSettings.report2020OperatorCanEdit = true;
                // vm.client.configuration.reportSettings.warningThresholds = true;
                // vm.client.configuration.similarityReportSettings.warningThreshold1 = 30;
                // vm.client.configuration.similarityReportSettings.warningThreshold2 = 5;
                vm.client.configuration.userSettings.permUserCanChangeOrganisationalUnit = true;
                vm.client.configuration.userGroupsSettings.allowCreateStudents = true;
                vm.client.configuration.otherSettings.permUserDownloadPdfReport = true;
                vm.client.configuration.otherSettings.permUserCheckDocumentMetricSimilarityBeforeAdd = false;
                vm.client.configuration.otherSettings.maxAssignmentCorrections = 2;
            }


            if (vm.client.basicData.clientInstance === 'int') {

                vm.client.configuration.reportSettings.hideDocuSimilarityFactorExt = true;
                vm.client.configuration.reportSettings.ignoringCitations = true;
                vm.client.configuration.reportSettings.excludingCitations = true;
                vm.client.configuration.reportSettings.report2020OperatorCanEdit = true;

                vm.client.configuration.addToDatabase = 'delayed';
                vm.client.configuration.addToDatabaseDays = 10;

                vm.client.configuration.userGroupsSettings.allowCreateStudents = true;

                vm.client.configuration.otherSettings.permUserCheckDocumentMetricSimilarityBeforeAdd = false;
                vm.client.configuration.otherSettings.addPriorityFromContractEnabled = false;

                if (vm.client.basicData.clieTestClient) {
                    vm.client.configuration.reportSettings.warningThresholds = true;
                    vm.client.configuration.similarityReportSettings.warningThreshold1 = 30;
                    vm.client.configuration.similarityReportSettings.warningThreshold2 = 5;

                    vm.client.configuration.otherSettings.autoTranslationsEnabled = true;
                    vm.client.configuration.grammarCheckSettings.enabled = true;
                } else {
                    vm.client.configuration.userSettings.userTeacherCanChangePromoter = true;
                    vm.client.configuration.userSettings.allowEditDocument = true;
                }

            }

            vm.client.configuration.reportSettings.report2020Disabled = false;
            vm.client.configuration.otherSettings.authorsSimplifiedFields = parseInt(vm.client.contract.contType) !== CONTRACTTYPECONSTANT.CONT_TYPE_PER_AUTHOR.id;

            vm.client.configuration.otherSettings.disableSkipSitesUrl = false;
        }

        function setExchangeProgramDefaultValues() {
            if (!vm.client.id) {
                vm.client.isDatabaseExchangeProgramMember = true;

                if (vm.client.basicData.clieTestClient) {
                    vm.client.clientIsHidden = true;
                }

                if (vm.client.basicData.clientType.id === CLIENTTYPECONSTANT.COLLEGE.id) {
                    vm.client.databaseExchangeSourcesVisible = true;
                }

                if (vm.client.basicData.clientInstance === 'int') {
                    vm.client.databaseExchangeSourcesVisible = true;
                }
            }
        }

        function initializeFindersSelection() {
            FinderService.getAllAvailableForClientType(vm.client.basicData.clientType.id, vm.client.basicData.countryId, vm.client.basicData.clieTestClient)
                .then(function (success) {
                    vm.availableFinders = success.data;
                    if (!isEdit()) {
                        vm.availableFinders.forEach(function (entry) {
                            if (entry.defaultQueriesPerKilo > 0) {
                                vm.findersSelection[entry.id] = true;
                                vm.toggleFinderSelection(entry.id);
                            }
                        });
                    }
                });
        }

        vm.onClientInstanceChanged = function() {
            vm.client.basicData.clieLang = null;
            vm.client.codeAccount.currencies = [];
            vm.client.codeAccount.payments = {};
            vm.instance = vm.client.basicData.clientInstance;
            vm.availableCurrencies = InstanceService.findInstanceByBrand(vm.instance).currencies.list;
            vm.availablePayments = {};
            InstanceService.findInstanceByBrand(vm.instance).currencies.settings.forEach(function (currencySetting) {
                vm.availablePayments[currencySetting.name] = currencySetting.methodsOfPayment;
            });
            initializeDefaultCodesSettings();
        };

        function initializeDefaultCodesSettings() {
            if (vm.client.id) {
                return;
            }
            if (vm.client.basicData.clientType.id === CLIENTTYPECONSTANT.COLLEGE.id) {

                if (vm.client.basicData.countryId === COUNTRYCODECONSTANT.UKRAINE.id) {
                    vm.client.codeAccount.currencies.push('UAH');
                    vm.client.codeAccount.payments.UAH = [];
                    vm.client.codeAccount.payments['UAH'].push('TYPE_EASY_PAY');

                    vm.client.codeAccount.codeTypePrices = [];
                    vm.client.codeAccount.codeTypePrices.push({name: "L",  size: 100000, currencyPrices: {UAH: 150}});
                    vm.client.codeAccount.codeTypePrices.push({name: "XL", size: 200000, currencyPrices: {UAH: 300}});
                } else if (vm.client.basicData.countryId === COUNTRYCODECONSTANT.KAZAKHSTAN_KYRGYZSTAN.id) {
                    vm.client.codeAccount.currencies.push('KZT');
                    vm.client.codeAccount.payments.KZT = [];
                    vm.client.codeAccount.payments['KZT'].push('TYPE_KASSA_24_CARD');
                    
                    vm.client.codeAccount.codeTypePrices = [];
                    vm.client.codeAccount.codeTypePrices.push({name: "L",  size: 100000, currencyPrices: {KZT: 2500}});
                    vm.client.codeAccount.codeTypePrices.push({name: "XL", size: 200000, currencyPrices: {KZT: 5000}});
                } else if (vm.client.basicData.countryId === COUNTRYCODECONSTANT.AZERBAIJAN.id) {
                    vm.client.codeAccount.currencies.push('AZN');
                    vm.client.codeAccount.payments.AZN = [];
                    vm.client.codeAccount.payments['AZN'].push('TYPE_YIGIM_AZ');

                    vm.client.codeAccount.codeTypePrices = [];
                    vm.client.codeAccount.codeTypePrices.push({name: "L",  size: 100000, currencyPrices: {AZN: 20}});
                    vm.client.codeAccount.codeTypePrices.push({name: "XL", size: 200000, currencyPrices: {AZN: 40}});
                }
            }
        }

        vm.loadClientGroupsAndRegions = function() {
            
            ClientService.getClientRegions().then(
                function (success) {
                    vm.clientRegions = success.data;
                });
            
            ClientService.getClientCountries().then(
                function (success) {
                    vm.countries_ = success.data;
                    vm.countries = Utils.sortCountries(vm.countries_, $translate);

                });
            
            ClientService.getClientGroups().then(
                function (success) {
                    vm.clientGroups = success.data;
                });

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('client', {
            parent: 'app',
            url: '/client',
            data: {
                authorities: ['PERM_USER_SUPERADMIN', 'PERM_USER_RESELLER', 'PERM_USER_MINISTRY'],
                pageTitle: 'global.menu.clients'
            },
            views: {
                'content@': {
                    templateUrl: 'app/client/client.html',
                    controller: 'ClientController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'userName,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('client');
                    $translatePartialLoader.addPart('contract');
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('client-add', {
            parent: 'client',
            url: '/add',
            data: {
                authorities: ['PERM_USER_SUPERADMIN'],
                pageTitle: 'client.add.header'
            },
            views: {
                'content@': {
                    templateUrl: 'app/client/client-add/client-add.html',
                    controller: 'ClientAddController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('client');
                    $translatePartialLoader.addPart('contract');
                    $translatePartialLoader.addPart('finder');
                    $translatePartialLoader.addPart('validation');
                    return $translate.refresh();
                }]
            }
        })
        .state('client-add-test', {
            parent: 'client',
            url: '/add-test',
            data: {
                authorities: ['PERM_USER_RESELLER'],
                pageTitle: 'client.header.add-test'
            },
            views: {
                'content@': {
                    templateUrl: 'app/client/client-add/client-add-test.html',
                    controller: 'ClientAddTestController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('client');
                    $translatePartialLoader.addPart('validation');
                    return $translate.refresh();
                }]
            }
        })
        .state('client-edit', {
            parent: 'client',
            url: '/:id/:step/edit',
            data: {
                authorities: ['PERM_USER_SUPERADMIN', 'PERM_USER_RESELLER'],
                pageTitle: 'client.edit.header'
            },
            views: {
                'content@': {
                    templateUrl: 'app/client/client-add/client-add.html',
                    controller: 'ClientAddController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('client');
                    $translatePartialLoader.addPart('contract');
                    $translatePartialLoader.addPart('finder');
                    $translatePartialLoader.addPart('validation');
                    return $translate.refresh();
                }]
            }
        })
        .state('client-document-kinds', {
            parent: 'client',
            url: '/:clientId/client-document-kinds',
            data: {
                authorities: ['PERM_USER_SUPERADMIN', 'PERM_USER_RESELLER'],
                pageTitle: 'client.edit.header'
            },
            views: {
                'content@': {
                    templateUrl: 'app/client/client-document-kinds/client-document-kinds.html',
                    controller: 'ClientDocumentKindsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('client');
                    return $translate.refresh();
                }]
            }
        })
        .state('client-protocols', {
            parent: 'client',
            url: '/:clientId/client-protocols',
            data: {
                authorities: ['PERM_USER_SUPERADMIN', 'PERM_USER_RESELLER'],
                pageTitle: 'client.edit.header'
            },
            views: {
                'content@': {
                    templateUrl: 'app/client/client-protocols/client-protocols.html',
                    controller: 'ClientProtocolsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('client');
                    $translatePartialLoader.addPart('protocol');
                    return $translate.refresh();
                }]
            }
        })
        .state('client-protocol-add', {
            parent: 'client-protocols',
            url: '/:clientId/client-protocol-add',
            data: {
                authorities: ['PERM_USER_SUPERADMIN', 'PERM_USER_RESELLER'],
                pageTitle: 'client.edit.header'
            },
            views: {
                'content@': {
                    templateUrl: 'app/client/client-protocols/client-protocol-add.html',
                    controller: 'ClientProtocolAddController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('client');
                    $translatePartialLoader.addPart('protocol');
                    return $translate.refresh();
                }]
            }
        })
        ;
    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ClientController', ClientController);

    ClientController.$inject = ['ClientService', 'ClientQueryRequest', 'SearchRequest', 'ClientSearchRequest',
    'SearchService', '$mdBottomSheet', 'TableSelectOptions', '$localStorage', 'tableSettingsRequest', 'ModalService',
    'ClientReportXlsService', '$q', 'AccountService', 'CLIENTTYPECONSTANT', 'CLIENT_STATUS', '$translate'];

    function ClientController(
        ClientService, ClientQueryRequest, SearchRequest, ClientSearchRequest,
        SearchService, $mdBottomSheet, TableSelectOptions, $localStorage, tableSettingsRequest, ModalService,
        ClientReportXlsService, $q, AccountService, CLIENTTYPECONSTANT, CLIENT_STATUS, $translate
    ) {
        var vm = this;

        vm.queryRequest = new ClientQueryRequest();
        vm.queryRequest.limit = $localStorage.clientListlimit ? $localStorage.clientListlimit : vm.queryRequest.limit;
        vm.searchRequest = new SearchRequest();
        vm.clientSearchRequest = new ClientSearchRequest();
        vm.options = new tableSettingsRequest();
        vm.selected = [];
        vm.pagingAction = pagingAction;
        vm.getClients = getClients;
        vm.getDetails = getDetails;
        vm.pickedClient = false;
        vm.showDetailsBlock = false;
        vm.clear = clear;
        vm.searchClients = searchClients;
        vm.tableSelectOptions = new TableSelectOptions();
        vm.selected = [];
        vm.deSelectRow = deSelectRow;
        vm.selectRow = selectRow;
        vm.toggleSelection = toggleSelection;
        vm.selectRows = selectRows;
        vm.openBottomSheet = openBottomSheet;
        vm.closeBottomSheet = closeBottomSheet;
        vm.generateReportXls = generateReportXls;
        vm.unfreezeClient = unfreezeClient;
        vm.freezeClient = freezeClient;
        vm.removeClient = removeClient;
        vm.getStatusDescription = getStatusDescription;
        vm.clientSettings = AccountService.getClientSettings();
        vm.clientTypeConstant = CLIENTTYPECONSTANT;
        vm.clientStatus = CLIENT_STATUS;
        vm.simpleSearch = true;
        vm.isReseller = AccountService.role.isReseller();
        vm.isMinistry = AccountService.role.isMinistry();
        vm.isSuperAdmin = AccountService.role.isSuperAdmin();

        this.$onInit = function () {
            if ($localStorage.clientSimpleSearchEnabled == true && $localStorage.clientSimpleSearchValue && $localStorage.clientSimpleSearchValue.length > 0) {
                vm.searchRequest.simpleSearch = $localStorage.clientSimpleSearchValue;
            }
            if ($localStorage.clientSearchRequest && $localStorage.clientSimpleSearchEnabled != true) {
                vm.simpleSearch = false;
                vm.clientSearchRequest = $localStorage.clientSearchRequest;
            }
            if ($localStorage.queryRequest) {
                vm.queryRequest = $localStorage.queryRequest;
            }

            getClients();
        };

        function prepareMassActions() {
            vm.deferred = $q.defer();
            vm.tableSelectOptions.ids.length = 0;
            vm.tableSelectOptions.selectedNo = vm.tableSelectOptions.selectedAll ? vm.tableSelectOptions.selectedNo : vm.selected.length;
            angular.forEach(vm.tableSelectOptions.selectedHelper, function (value) {
                vm.tableSelectOptions.ids.push(value.id);
            });
            vm.deferred.resolve(vm.tableSelectOptions);
            return vm.deferred.promise;
        }

        function toggleSelection(total) {
            if(!vm.tableSelectOptions.selectedAll) {
                selectRows(vm.users);
            }
            vm.tableSelectOptions.selectedAll = !vm.tableSelectOptions.selectedAll;
            vm.tableSelectOptions.selectedNo = total;
            if( !vm.tableSelectOptions.selectedAll ) {
                closeBottomSheet();
            }
        }

        function deSelectRow() {
            if( vm.selected.length === 0) {
                closeBottomSheet();
            }
        }

        function selectRow(pickedId) {
            if( vm.selected.length === 1) {
                openBottomSheet();
            }
            angular.forEach(vm.users, function (value) {
                if (value.id === pickedId) {
                    if (vm.tableSelectOptions.selectedHelper.indexOf(pickedId) === -1) {
                        vm.tableSelectOptions.selectedHelper.push(value);
                    }
                }
            });
        }

        function selectRows(obj) {
            angular.forEach(obj, function (value) {
                if (vm.selected.indexOf(value.id) === -1) {
                    vm.selected.push(value.id);
                }
            })
        }

        function resetSelection() {
            if(vm.tableSelectOptions.selectedAll) {
                vm.selected.length = 0;
                vm.tableSelectOptions = new TableSelectOptions();
                $mdBottomSheet.hide();
            }
        }

        function closeBottomSheet() {
                vm.selected.length = 0;
                vm.tableSelectOptions = new TableSelectOptions();
                $mdBottomSheet.hide();
        }

        function openBottomSheet() {
            $mdBottomSheet.show({
                templateUrl: 'app/client/bottom-sheet-grid-template.html',
                controllerAs: 'bootomSheet',
                parent: angular.element(document.getElementById('clients')),
                controller: function GridBottomSheetCtrl(){
                    var bootomSheet = this;
                    bootomSheet.checked = true;
                    bootomSheet.closeBottomSheet = vm.closeBottomSheet;
                    bootomSheet.selected = vm.selected;
                    bootomSheet.tableSelectOptions = vm.tableSelectOptions;
                    bootomSheet.total = vm.totalClients;
                    bootomSheet.toggleSelection = vm.toggleSelection;
                    bootomSheet.generateReportXls = vm.generateReportXls;
            },
            isLockedOpen: true,
            disableParentScroll: false,
            disableBackdrop: true
          });
        }

        function getClients(){
            vm.showDetailsBlock = false;
            vm.searchRequest.pageNumber = vm.queryRequest.page-1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.sortTab = SearchService.sort(vm.queryRequest);
            vm.searchRequest.search = vm.clientSearchRequest;

            $localStorage.clientSearchRequest = vm.clientSearchRequest;
            $localStorage.queryRequest = vm.queryRequest;

            vm.getOrSearch = vm.searchRequest.simpleSearch.length > 0 ? function (s) {
                return ClientService.searchClients(s);
            } : function (s) {
                return ClientService.getClients(s);
            };

            vm.isLoaderActive = true;
            vm.getOrSearch(vm.searchRequest).then(function (responseData) {
                vm.responseObj = responseData.content;
                vm.clients = vm.responseObj;
                vm.totalClients = responseData.totalElements;
                vm.isLoaderActive = false;
                vm.queryRequest.page = vm.searchRequest.pageNumber + 1;
            });
        }

        function searchClients() {
            vm.queryRequest.page = 1;
            getClients();
        }

        function pagingAction(page) {
            resetSelection();
        	vm.isLoaderActive = true;
            vm.queryRequest.page = page;
            getClients();
        }

        function getDetails(client) {
            vm.showDetailsBlock = false;
            vm.isLoaderActive = true;
            if (client.id !== ClientService.clientDetailsObj.id) {
                vm.pickedClient = client.id;
                ClientService.clientDetailsObj = client;
                ClientService.getClient(client.id).then(function (result) {
                    vm.showDetailsBlock = true;
                    vm.isLoaderActive = false;
                    vm.details = result.data;
                });
            } else {
                vm.isLoaderActive = false;
                ClientService.clientDetailsObj = {};
            }
        }

        function clear() {
            vm.clientSearchRequest = new ClientSearchRequest();
            getClients();
        }

        function generateReportXls(){
        	prepareMassActions().then(function(response){
        		ClientReportXlsService.generateReportXls(response, vm.selected, vm.searchRequest);
        	});
        }
    
        function removeClient(id) {
            var TRANSLATION_REMOVE_PREFIX = 'client.remove';
            ModalService.showConfirmModal(TRANSLATION_REMOVE_PREFIX).then( function (){
                ClientService.remove(id).then(function() {
                    getClients();
                    ModalService.showSuccessModal();
                });
            });
        }
    
        function freezeClient(id) {
            ModalService.showConfirmModal().then(function (){
                ClientService.freeze(id).then(function() {
                    getClients();
                    ModalService.showSuccessModal();
                });
            });
        }
    
        function unfreezeClient(id) {
            ModalService.showConfirmModal().then(function (){
                ClientService.unfreeze(id).then(function() {
                    getClients();
                    ModalService.showSuccessModal();
                });
            });
        }

        function getStatusDescription(client) {
            switch (client.clieStatus) {
                case vm.clientStatus.FROZEN.id:
                    return $translate.instant('client.status.frozen');
                case vm.clientStatus.REMOVAL_IN_PROGRESS.id:
                    return $translate.instant('client.status.removal-in-progress');
                case vm.clientStatus.REMOVAL_ERROR.id:
                    return $translate.instant('client.status.removal-error');
                default:
                    return '';
            }
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope', '$injector', '$log'];

    function errorHandlerInterceptor ($q, $rootScope, $injector, $log) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if ((!response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('plagiat2017App.httpError', response);
                var $state = $injector.get('$state');
                $state.go('login');
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$location', '$q', '$injector', '$log'];

    function authExpiredInterceptor($rootScope, $location, $q, $injector, $log) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            //$log.error('authExpiredInterceptor', response)
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                var prevState = Auth.getPreviousState();
                var $state = $injector.get('$state');
                if( $rootScope.toState.name === 'landing-page-int' || $rootScope.toState.name === 'landing-page-ro' || $rootScope.toState.name === 'landing-page' || $rootScope.toState.name === 'activate' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'finishReset' || $rootScope.toState.name === 'requestReset' ){
                    Auth.storePreviousState(to.name, params);
                } else{
                    Auth.logout();
                    ($location.host() === 'sprawdz-prace.plagiat.pl' 
                        || $location.host() === 'sprawdz.plagiat.pl'
                        || $location.host() === 'verifica-textul.sistemantiplagiat.ro'
                        || $location.host() === 'check-paper.strikeplagiarism.com'
                        || $location.host() === 'check-paper-for-plagiarism.strikeplagiarism.com'
                        || $location.host() === 'plagiat-tekseru-antiplagiat.strikeplagiarism.com'
                        || $location.host() === 'prover-rabotu-antiplagiat.strikeplagiarism.com'
                        || $location.host() === 'antiplagiat.strikeplagiarism.com'
                        || $location.host() === 'perevirka-na-plagiat-antiplagiat.strikeplagiarism.com'
                        || $location.host() === 'plagiata-yoxlamaq-antiplagiat.strikeplagiarism.com'
                        || $location.host() === 'plagiatni-tekshiring-antiplagiat.strikeplagiarism.com'
                        || $location.host() === 'dokument-auf-plagiat-prufen.strikeplagiarism.com'
                        || $location.host() === 'sheamotsmet-dokumenti-plagiatis-shesakheb.strikeplagiarism.com'
                        || $location.host() === 'proverete-dokumenta-za-plagiat-stvo.strikeplagiarism.com'
                        || $location.host() === 'intihal-ile-ilgili-belgeyi-kontrol-et.strikeplagiarism.com'
                        || $location.host() === 'comprobar-documento-sobre-plagio.strikeplagiarism.com'
                        || $location.host() === 'verifique-o-artigo-quanto-a-plagio.strikeplagiarism.com'
                        || $location.host() === 'verification-du-plagiat.strikeplagiarism.com'
                        || $location.host() === 'verifica-del-plagio.strikeplagiarism.com'
                    )
                        ? $state.go('landing-page') 
                        : window.location.href = './'; 
                }
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION', '$log'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION, $log) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;
                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;
                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App');
        // .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App');
        // .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();


(function() {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$q','$cookies', '$log', 'LANGUAGES', '$location', 'DOMAINS'];

    function translationStorageProvider($q, $cookies, $log, LANGUAGES, $location,  DOMAINS) {

        var host = $location.host();
        var instanceLang;
        
        return {
            get: get,
            put: put
        };

        function getInstance(){
            var deferred = $q.defer();
            var lang;
            angular.forEach(DOMAINS, function(value, key) {
                if( host === value.domain ) {
                    lang = value.lang;
                }
            });

            deferred.resolve(lang);
            return lang;
        }

        function get(name) {
            var retObj = getInstance();

            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language ');
                $cookies.putObject(name, retObj);
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
    .module('plagiat2017App')
    .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];


    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '/api/i18n/{lang}/{part}'
        });
        
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');
        $translateProvider.useLoaderCache(false);

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

moment.updateLocale('ro', {
    longDateFormat : {
        LT: "HH:mm",
        LTS: "h:mm:ss A",
        L: "MM/DD/YYYY",
        l: "M/D/YYYY",
        LL: "YYYY-MM-DD",
        ll: "MMM D YYYY",
        LLL: "MMMM Do YYYY LT",
        lll: "MMM D YYYY LT",
        LLLL: "dddd, MMMM Do YYYY LT",
        llll: "ddd, MMM D YYYY LT"
    }
});
moment.updateLocale('pl', {
    longDateFormat : {
        LT: "HH:mm",
        LTS: "h:mm:ss A",
        L: "MM/DD/YYYY",
        l: "M/D/YYYY",
        LL: "YYYY-MM-DD",
        ll: "MMM D YYYY",
        LLL: "MMMM Do YYYY LT",
        lll: "MMM D YYYY LT",
        LLLL: "dddd, MMMM Do YYYY LT",
        llll: "ddd, MMM D YYYY LT"
    }
});
moment.updateLocale('en', {
    longDateFormat : {
        LT: "HH:mm",
        LTS: "h:mm:ss A",
        L: "MM/DD/YYYY",
        l: "M/D/YYYY",
        LL: "YYYY-MM-DD",
        ll: "MMM D YYYY",
        LLL: "MMMM Do YYYY LT",
        lll: "MMM D YYYY LT",
        LLLL: "dddd, MMMM Do YYYY LT",
        llll: "ddd, MMM D YYYY LT"
    }
});
(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App');

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .constant('TRANSLATION_KEYS', {
                dictionaryLanguage: 'dictionary.language.'
            }
        );
})();

(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .constant('SIMPLE_SEARCH_DELAY', 1000);
})();

(function () {
    'use strict';

angular
    .module('plagiat2017App')
    .config(html5ModeConfig)
    .config(stateConfig)
    .config(mdDateLocaleProvider)
    .config(['$qProvider', function ($qProvider) {
        $qProvider.errorOnUnhandledRejections(false);
    }])
    .constant('_', window._);

    html5ModeConfig.$inject = ['$locationProvider'];
    stateConfig.$inject = ['$stateProvider'];
    beforeUnload.$inject = ['$rootScope', '$window'];

    function beforeUnload($rootScope, $window) {
        $window.onbeforeunload = function (e) {
            var confirmation = {};
            var event = $rootScope.$broadcast('onBeforeUnload', confirmation);
            if (event.defaultPrevented) {
                return confirmation.message;
            }
        };

        $window.onunload = function () {
            $rootScope.$broadcast('onUnload');
        };
        return {};
    }


    function html5ModeConfig($locationProvider) {
        $locationProvider.hashPrefix('');
        $locationProvider.html5Mode({enabled: false, requireBase: false});
    }


    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }


    function mdDateLocaleProvider($mdDateLocaleProvider){
        $mdDateLocaleProvider.formatDate = function(date) {
            return date ? moment(date).format('YYYY-MM-DD') : '';
        };
        $mdDateLocaleProvider.parseDate = function(dateString) {
          var m = moment(dateString, 'YYYY-MM-DD', true);
          return m.isValid() ? m.toDate() : new Date(NaN);
        };
    } 

})();

(function () {
    'use strict';
    angular
    .module('plagiat2017App')
    .constant('PLAGIAT_VALIDATIONS_CODES', [
        { code: '001', translationCode: '' },
        { code: '002', translationCode: 'reset.request.messages.notfound' },
        { code: '003', translationCode: 'global.messages.error.mailnotsent' },
        { code: '004', translationCode: '' },
        { code: '005', translationCode: 'global.registration.email.reserved' },
        { code: '006', translationCode: '' },
        { code: '007', translationCode: '' },
        { code: '008', translationCode: '' },
        { code: '009', translationCode: 'global.messages.error.wrongpassword' },
        { code: '010', translationCode: '' },
        { code: '011', translationCode: '' },
        { code: '012', translationCode: '' },
        { code: '013', translationCode: 'global.messages.error.docu-size-exceeded' },
        { code: '014', translationCode: '' },
        { code: '015', translationCode: 'global.messages.error.converter-connection-refused' },
        { code: '016', translationCode: 'global.messages.error.document-file-null' },
        { code: '017', translationCode: 'global.messages.error.inactive-contract' },
        { code: '018', translationCode: 'global.messages.error.docu-count-exceeded' },
        { code: '019', translationCode: 'global.messages.error.docu-character-count-exceeded' },
        { code: '020', translationCode: 'global.messages.error.contract-error' },
        { code: '021', translationCode: 'global.messages.error.user-query-limit-exceeded' },
        { code: '022', translationCode: '' },
        { code: '023', translationCode: 'global.messages.error.max-size-with-value' },
        { code: '024', translationCode: 'global.messages.error.max-size-with-value' },
        { code: '025', translationCode: 'global.messages.error.wrongtype' },
        { code: '026', translationCode: 'global.messages.error.notenough' },
        { code: '027', translationCode: 'global.messages.error.emptydocument' },
        { code: '028', translationCode: '' },
        { code: '029', translationCode: 'global.messages.error.wronguser' },
        { code: '030', translationCode: 'global.messages.error.document-title-length-exceeded' },
        { code: '031', translationCode: '' },
        { code: '032', translationCode: '' },
        { code: '033', translationCode: '' },
        { code: '034', translationCode: '' },
        { code: '035', translationCode: '' },
        { code: '036', translationCode: '' },
        { code: '037', translationCode: '' },
        { code: '038', translationCode: '' },
        { code: '039', translationCode: '' },
        { code: '040', translationCode: '' },
        { code: '041', translationCode: '' },
        { code: '042', translationCode: '' },
        { code: '043', translationCode: '' },
        { code: '044', translationCode: 'global.messages.error.authentication' },
        { code: '045', translationCode: 'login.messages.error.activation'},
        { code: '046', translationCode: 'global.messages.error.organisational-unit-already-exists' },
        { code: '047', translationCode: 'global.messages.error.document-parameter-definition-already-exists' },
        { code: '048', translationCode: 'organisational.units.deleting.assigned-to-user' },
        { code: '051', translationCode: 'organisational.units.deleting-multiple.assigned-to-user' },
        { code: '052', translationCode: 'global.invalid.numeric.value' },
        { code: '053', translationCode: 'global.invalid.email.format' },
        { code: '054', translationCode: 'global.messages.error.user.nothibernated' },
        { code: '055', translationCode: 'global.messages.error.user.already.removed' },
        { code: '056', translationCode: 'global.messages.error.user.permission' },
        { code: '057', translationCode: '' },
        { code: '058', translationCode: '' },
        { code: '059', translationCode: 'global.messages.error.user-query-limit-exceeded' },
        { code: '068', translationCode: 'global.messages.error.number.of.users.limit.exceeded' },
        { code: '069', translationCode: 'global.messages.error.could-not-retrieve-polon-units-for-current-client' },
        { code: '070', translationCode: 'global.messages.error.could-not-send-the-document-to-jsa' },
        { code: '071', translationCode: 'global.messages.error.could-not-save-jsa-access-data' },
        { code: '072', translationCode: 'global.messages.error.could-not-send-the-document-to-jsa-bad-request' },
        { code: '073', translationCode: 'global.messages.error.wrong-credentials' },
        { code: '075', translationCode: 'global.messages.error.could-not-send-the-document-to-jsa-institution-code-required' },
        { code: '078', translationCode: 'global.messages.error.could-not-edit-jsa-metadata' },
        { code: '080', translationCode: 'global.mail.reserved' },
        { code: '087', translationCode: 'global.messages.error.invalid-orppd-password' },
        { code: '088', translationCode: 'global.messages.error.document-backup-file-not-found' },
        { code: '089', translationCode: 'global.messages.error.could-not-send-document-to-orppd' },
        { code: '090', translationCode: 'global.messages.error.orppd-is-unavailable' },
        { code: '091', translationCode: 'global.messages.error.orppd-no-access-data' },
        { code: '092', translationCode: 'global.messages.error.jsa-study-not-on-unit' },
        { code: '093', translationCode: 'global.messages.error.jsa-wrong-institution-of-promoter' },
        { code: '094', translationCode: 'global.messages.error.could-not-add-polon-employee' },
        { code: '095', translationCode: 'global.messages.error.jsa-could-not-find-polon-employees-polon-unavailable' },
        { code: '096', translationCode: 'global.messages.error.main-admin-could-not-change-his-email' },
        { code: '097', translationCode: 'global.messages.error.client-setting-code-not-found' },
        { code: '009', translationCode: 'global.messages.error.wrongpassword' },
        { code: '100', translationCode: 'global.messages.error.text-retrieval-error' },
        { code: '101', translationCode: 'global.messages.error.document-import.metadata-incomplete' },
        { code: '103', translationCode: 'global.messages.error.invalid-confirmation-code' },
        { code: '104', translationCode: 'global.messages.error.document-has-no-check-id' },
        { code: '105', translationCode: 'global.messages.error.code-expired' },
        { code: '106', translationCode: 'global.messages.error.code-size-too-small' },
        { code: '107', translationCode: 'global.messages.error.code-has-wrong-status' },
        { code: '108', translationCode: 'translations.messages.error.column-not-found' },
        { code: '109', translationCode: 'translations.messages.error.file-format-error' },
        { code: '110', translationCode: 'statistics.messages.error.date-to-before-date-from' }, 
        { code: '111', translationCode: 'global.messages.error.samepassword' },
        { code: '112', translationCode: 'payments.messages.error.fakturownia' },
        { code: '113', translationCode: 'users.messages.error.can-not-add-admin' },
        { code: '114', translationCode: 'payments.messages.error.bulk.invoice.validation' },
        { code: '118', translationCode: 'global.messages.error.organisational-unit-does-not-belong-to-user' },
        { code: '119', translationCode: 'global.messages.error.cannot-add-priority-by-using-tokens' },
        { code: '121', translationCode: 'global.messages.error.unexpected-zip-content' },
        { code: '122', translationCode: 'reports.messages.error.too-many-rows' },
        { code: '123', translationCode: 'reports.messages.error.too-many-rows-for-zip' },
        { code: '124', translationCode: 'reports.messages.error.no-data' },
        { code: '125', translationCode: 'client.messages.error.wrong-country' },
        { code: '126', translationCode: 'assignment.messages.error.check-unique' },
        { code: '127', translationCode: 'assignment.messages.error.already-added' },
        { code: '128', translationCode: 'assignment.messages.error.assignment-closed' },
        { code: '129', translationCode: 'client.messages.error.region-issue' },
        { code: '136', translationCode: 'global.messages.error.invoice-not-ready' },

        { code: '999', translationCode: 'global.error.unknown' } //please leave it last, so you wont have to move the semicolon every time
        ]
        );
})();

(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .constant('PERMISSIONS', {
            PERM_USER_CAN_CHANGE_ORG_UNIT_DURING_ADD_DOCUMENT: 'PERM_USER_CAN_CHANGE_ORG_UNIT_DURING_ADD_DOCUMENT'
        });
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('plagiat2017App')
        .constant('VERSION', "2.3.00")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function () {
    'use strict';
    angular
    .module('plagiat2017App')
    .constant('CharCode', {
    	'NULL': '0',
    	'ENTER': '13',
    	'COMMA': '44',
    	'DASH': '45',
        'DOT': '46',
        'SLASH': '47',
        'CHAR_0': '48',
        'CHAR_1': '49',
        'CHAR_2': '50',
        'CHAR_3': '51',
        'CHAR_4': '52',
        'CHAR_5': '53',
        'CHAR_6': '54',
        'CHAR_7': '55',
        'CHAR_8': '56',
        'CHAR_9': '57'
    }
        );
})();

(function () {
    'use strict';

    function UsersSearchontroller(
        $scope, $state, $log, $localStorage, $q, _, $timeout,
        DateService, SearchService, SearchRequest, ClientQueryRequest, ClientService, OrganisationalUnitsService, AccountService,
        SIMPLE_SEARCH_DELAY, CLIENTTYPECONSTANT, USERSTATUSES, USERSTATUSES_SUPERADMIN, USERROLES
    ) {
        var vm = this;
        vm.simpleSearch = true;
        vm.getUsers = getUsers;
        vm.addUser = addUser;
        vm.roles = USERROLES.getRolesForCurrentClient(AccountService);
        vm.isReseller = AccountService.role.isReseller();
        vm.isMinistry = AccountService.role.isMinistry();
        vm.isSuperAdmin = AccountService.role.isSuperAdmin();
        vm.canFilterOrganisationalUnits = !AccountService.role.isOrgUnitAdmin();
        vm.statuses = vm.isSuperAdmin ? USERSTATUSES_SUPERADMIN : USERSTATUSES;
        vm.toogleSearch = toogleSearch;
        vm.clear = clear;
        vm.changeHasntLogged = changeHasntLogged;
        vm.fixDate = DateService.fixDate;
        vm.searchRequest = new SearchRequest();
        vm.clientQueryRequest = new ClientQueryRequest();
        vm.selectedClientChange = selectedClientChange;
        vm.clientSearch = clientSearch;
        vm.jsaIntegration = AccountService.getClientSettings().jsaIntegration;
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.clientTypesForSearch = CLIENTTYPECONSTANT.listForClientSearch;
        vm.countries = [];
        vm.organisationalUnits = [];
        vm.regions = [];

        this.$onInit = function () {
            onInit();
        };

        function onInit() {
            if (vm.isSuperAdmin) {
                ClientService.getClientRegions().then(
                    function (success) {
                        vm.regions = success.data;
                    });

                ClientService.getClientCountries().then(
                    function (success) {
                        vm.countries = success.data;
                    });

            }

            if (ClientService.client) {
                vm.selectedClient = ClientService.client;
                ClientService.client = null;
            } else if (vm.onSearchRequest.search.clientId) {
                vm.clientSearch(vm.onSearchRequest.search.clientId).then(function (clients) {
                    if (clients.length === 1) {
                        vm.selectedClient = clients[0];
                    }
                });
            }
            vm.simpleSearch = vm.onSimpleSearch;
            findOrganisationalUnits();
        }

        function changeHasntLogged(){
            if( vm.onSearchRequest.search.hasntLogged ){
                vm.onSearchRequest.search.userLastLoginDateFrom = '';
                vm.onSearchRequest.search.userLastLoginDateTo = '';
            }
            vm.getUsers();
        }
        
        function toogleSearch() {
            vm.onSearchRequest.simpleSearch = '';
            vm.simpleSearch = !vm.simpleSearch;
        }
        
        function clear() {
            vm.selectedClient = undefined;
            vm.onClear();
        }
        
        function addUser(){
            $state.go('userAdd');
        }

        function getUsers() {
            $localStorage.usersListlimit = vm.onQueryRequest.limit;
            vm.onSearchRequest.simpleSearch.length === 0 ? vm.onGetUsers() : '';
            vm.onSearchRequest.simpleSearch.length > 2 ? vm.onGetUsers() : '';
        }
           
        function findOrganisationalUnits() {
            OrganisationalUnitsService.findAllForClient().then(function(response) {
                vm.organisationalUnits = response.data;
            });
        }

        function selectedClientChange(item) {
            if (angular.isDefined(item)) {
                if(vm.onSearchRequest.search.clientId !== item.id) {
                    vm.onSearchRequest.search.clientId = item.id;
                    getUsers();
                }
            } else {
                vm.onSearchRequest.search.clientId = null;
                getUsers();
            }
        }

        function clientSearch(query) {
            vm.searchRequest.pageNumber = 0;
            vm.searchRequest.pageSize = 20;
            vm.searchRequest.sortTab = SearchService.sort(vm.clientQueryRequest);
            vm.searchRequest.search = query;
            vm.searchRequest.simpleSearch = query;

            return ClientService.searchClients(vm.searchRequest).then(function(response) {
                return response.content;
            })
        }

        vm.querySearchOrganizations = function () {
            return vm.searchOrganizationText ? vm.organisationalUnits.filter(function (org) {
                return org.orguniLabel.toLowerCase().includes(vm.searchOrganizationText.toLowerCase());
            }) : vm.organisationalUnits;
        };

        vm.selectedOrganizationChange = function (item) {
            if (item) {
                vm.onSearchRequest.search.organisationalUnitId = item.id;
            } else {
                vm.onSearchRequest.search.organisationalUnitId = null;
            }
            vm.getUsers();
        };

    }

    angular.module('plagiat2017App')
        .component('usersSearch', {
            templateUrl: 'app/account/users/users-search/users-search.template.html',
            controller: UsersSearchontroller,
            bindings: {
                onGetUsers: '<',
                onQueryRequest: '<',
                onSearchRequest: '<',
                onClear: '<',
                onIsSuperadmin: '<',
                onSimpleSearch: '<'
            }
        });

})();

(function () {
    'use strict';

    function UsersMenuController(AccountService) {
        var vm = this;

        vm.isReseller = AccountService.role.isReseller();
        vm.isMinistry = AccountService.role.isMinistry();
        
	}

    angular.module('plagiat2017App')
    .component('usersMenu', {
        templateUrl: 'app/account/users/users-menu/users-menu.template.html',
        controller: UsersMenuController,
        bindings: {
        	activeTab: '<',
            onIsSuperadmin: '<'
        }
    });

})();

(function() {
	'use strict';
	function UsersButtonsController($state, $translate, $log, $mdDialog, $window, $localStorage,
									UserService, ModalService, Auth, PlagiatValidationService, AccountService) {

		var vm = this;
		vm.arrIdis = [];
		vm.hibernateUser = hibernateUser;
		vm.activateUser = activateUser;
		vm.removeUser = removeUser;
		vm.remindPassword = remindPassword;
		vm.grantMainAdminRights = grantMainAdminRights;
		vm.revokeMainAdminRights = revokeMainAdminRights;
		vm.loginAs = loginAs;
        vm.showHistory = showHistory;
        vm.showAddFreeTokensForm = showAddFreeTokensForm;
        vm.onUserAdmin = onUserAdmin;
        vm.canEditRegions = canEditRegions;
		vm.hideUserHistory = AccountService.account.clientSettings.hideUserHistory;
		vm.isReseller = AccountService.role.isReseller();
		vm.isMinistry = AccountService.role.isMinistry();

        vm.editUser = function() {
			$state.go('userEdit', {
				user : {
					id: vm.onUser.id,
					userEmail: vm.onUser.userEmail,
					userName: vm.onUser.userName,
					role: vm.onUser.userSchoolType,
					userSurname: vm.onUser.userSurname,
					academicTitle: vm.onUser.academicTitle,
					organisationalUnitId: vm.onUser.organisationalUnitId,
                    userQueryCounter: vm.onUser.userQueryCounter,
                    userQueryCounterType: vm.onUser.userQueryCounterType,
					userPhone: vm.onUser.userPhone,
                    polonEmployeeId: vm.onUser.polonEmployeeId,
                    userClientType: vm.onUser.userClientType
				},
				canEditMail: !vm.onUser.mainAdmin || vm.onLoggedUserIsSuperAdmin
			});
		};
        
        function canEditRegions() {
        	return vm.onUser.userSchoolTypeEnum == 'USER_SCHOOL_TYPE_SUPERADMIN'
				|| vm.onUser.userSchoolTypeEnum == 'USER_SCHOOL_TYPE_RESELLER'
				|| vm.onUser.userSchoolTypeEnum == 'USER_SCHOOL_TYPE_MINISTRY';
		}

		function hibernateUser(ev){
			$mdDialog.show($mdDialog.confirm()
				.title($translate.instant("global.confirm.action"))
				.targetEvent(ev)
				.ok($translate.instant("global.button.confirm"))
				.cancel($translate.instant("global.button.cancel"))
				).then(function () {
					UserService.verifyHibernateUsers({ids: [vm.onUser.id]}, {}, false).then(function () {
						vm.onGetUsers();
					});
				});
		}

		function activateUser(ev){
			$mdDialog.show($mdDialog.confirm()
				.title($translate.instant("global.confirm.action"))
				.targetEvent(ev)
				.ok($translate.instant("global.button.confirm"))
				.cancel($translate.instant("global.button.cancel"))
				).then(function () {
					UserService.activateUsers({ids: [vm.onUser.id]}).then(function () {
						vm.onGetUsers();
					});
				});
		}

		function removeUser(ev){
			$mdDialog.show($mdDialog.confirm()
				.title($translate.instant("global.confirm.action"))
				.targetEvent(ev)
				.ok($translate.instant("global.button.remove"))
				.cancel($translate.instant("global.button.cancel"))
				).then(function () {
					UserService.verifyRemoveUsers({ids: [vm.onUser.id]}, {}, false).then(function(){
						ModalService.showSuccessModal("users.message.removed", ev);
						vm.onGetUsers();
					});
				});

		}

		function onUserAdmin() {
			return AccountService.userRole.isUserAnAdmin(vm.onUser);
		}

		function remindPassword(ev){
            Auth.resetPasswordInit({email:vm.onUser.userEmail}).then(
            		function () {
            			ModalService.showSuccessModal("users.reset.request.success", ev);
            		},
            		function (response) {
            			PlagiatValidationService.getModalError(response.data);
            		}
            );
		}
		
        function grantMainAdminRights(userId, ev){
        	UserService.grantMainAdminRights(userId).then(
            		function () {
            			vm.onGetUsers();
            			ModalService.showSuccessModal("users.grant.main.admin.rights.success", ev);
            		},
            		function (response) {
            			PlagiatValidationService.getModalError(response.data);
            		}
            );
        }
        
        function revokeMainAdminRights(userId, ev){
        	UserService.revokeMainAdminRights(userId).then(
            		function () {
            			vm.onGetUsers();
                        $mdDialog.show(
                                $mdDialog.confirm()
                                .clickOutsideToClose(true)
                                .title('')
                                .textContent($translate.instant("users.revoke.main.admin.rights.success"))
                                .ariaLabel('msgSuccess')
                                .ok('Ok')
                                .targetEvent(ev)
                                );
            		},
            		function (response) {
            			PlagiatValidationService.getModalError(response.data);
            		}
            );
        }

        function loginAs(username, ev){
        	UserService.loginAs(username).then(function(){
        		loginCallback();
        	},
        	function(){
                ModalService.showSuccessModal("global.operation.failed", ev);
        	});
        }
        
        var loginCallback = function(){
    		$localStorage.showLogoutToRootBtn = true;
    		$localStorage.logoutToRootInfo = AccountService.account.login;
    		$localStorage.backUrlSuperAdmin = $state.href();
            $localStorage.userSearchRequest = angular.copy(vm.onSearchRequest);
            window.location.replace("/");
        };
        
        function showHistory(ev) {
            UserService.user.id = vm.onUser.id;
            $mdDialog.show({
                templateUrl: 'app/account/users/user-history/user-history.dialog.html',
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function () {
                vm.onGetUsers();
            });
        }
        
        function showAddFreeTokensForm(ev) {
            UserService.user.id = vm.onUser.id;
            $mdDialog.show({
                templateUrl: 'app/account/users/add-free-tokens/add-free-tokens.dialog.html',
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function () {
            	ModalService.showSuccessModal("users.add.free.tokens.success", ev);
                vm.onGetUsers();
            });
        }

	}

    angular.module('usersButtons', [])
    .component('usersButtons', {
        templateUrl: 'app/account/users/users-list/users-buttons/users-buttons.template.html',
        controller: UsersButtonsController,
        bindings: {
        	onUser: '=',
        	onGetUsers: '<',
        	onLoggedUserIsSuperAdmin: '<',
        	onLoggedUserIsMainSuperAdmin: '<',
        	onLoggedUserIsMainAdmin: '<',
        	onLoggedUserIsOrgUnitAdmin: '<',
        	onLoggedUserIsAdmin: '<',
            onSearchRequest: '<'
        }
    });

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('UsersAddController', UsersAddController);

    UsersAddController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate', 'USERROLES', 'USER_QUERY_COUNTER_TYPES', 'UserService',
    	'InstanceService', '$state', '$cookies', '$stateParams', 'OrganisationalUnitsService', '$mdDialog', 'PlagiatValidationService', 'JsaService', 'AccountService'];

    function UsersAddController (Principal, Auth, JhiLanguageService, $translate, USERROLES, USER_QUERY_COUNTER_TYPES, UserService,
    		InstanceService, $state, $cookies, $stateParams, OrganisationalUnitsService, $mdDialog, PlagiatValidationService, JsaService, AccountService) {
        var vm = this;

        vm.instance = InstanceService.instance().lang;
        vm.theme = $cookies.get('plagiat-theme');
        vm.timezone = InstanceService.instance().timezoneDocuments;
        moment.locale(vm.instance);
        vm.key = $stateParams.key;
        vm.selected = [];
        vm.saveUser = saveUser;
        vm.isSchool = AccountService.clientType.isSchool();
        vm.backToUserList = backToUserList;
        vm.jsaIntegration = AccountService.getClientSettings().jsaIntegration;
        vm.loggedUserIsOrgUnitAdmin = AccountService.role.isOrgUnitAdmin();
        vm.academicTitleVisible = !AccountService.clientType.isPublishingHouse() && !AccountService.clientType.isSchool()  && !AccountService.clientType.isPap();
        vm.testPoolVisible = !AccountService.clientType.isPap();
        vm.roles = USERROLES.getRolesForCurrentClient(AccountService);
        vm.userQueryCounterTypes = USER_QUERY_COUNTER_TYPES;
        vm.userQueryCountersKeyPress = userQueryCountersKeyPress;
        vm.userQueryCountersKeyUp = userQueryCountersKeyUp;
		vm.form = {
			userQueryCounterType: USER_QUERY_COUNTER_TYPES[0].id,
      userQueryCounter: 1000
		};
		vm.canEditMail = true;
        findOrganisationalUnits();
        if(vm.jsaIntegration) {
            getPolonUsers();
        }

        function getPolonUsers() {
            JsaService.getPolonEmployeesAddUser().then(function(response) {
                vm.polonEmployees = response;
            });
        }

		function findOrganisationalUnits() {
			if (vm.loggedUserIsOrgUnitAdmin) {
                vm.form.organisationalUnitId = AccountService.account.organisationalUnitId;
            }
            OrganisationalUnitsService.findAllForClient().then(function(response) {
                vm.organisationalUnits = response.data;
                vm.selectedOrganization = vm.organisationalUnits.find(function (element) {
                    return element.id === vm.form.organisationalUnitId;
                });
            });
		}

        function backToUserList(){
        	$state.go('users');
        }

        function saveUser(form, ev){
        	UserService.addUser(form).then(function(){
        		backToUserList();

                $mdDialog.show(
                        $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .title('')
                        .textContent($translate.instant("users.form.new.user.msg"))
                        .ariaLabel('msgSuccess')
                        .ok('Ok')
                        .targetEvent(ev)
                        );
        	}, function(response){
        		PlagiatValidationService.getModalError(response.data);
        	})
        }
        
        function userQueryCountersKeyPress(event){
        	if (event.target.value.length >= event.target.maxLength || !(event.charCode == 0 || (event.charCode >= 48 && event.charCode <= 57))){
        		event.preventDefault();
        	}
        }
        
        function userQueryCountersKeyUp(event){
        	if (event.target.value.length >= event.target.maxLength){
        		event.preventDefault();
        		event.target.value = event.target.value.slice(0, event.target.maxLength);        		
        		vm.form.userQueryCounter = event.target.value;
        	}
        }

        vm.querySearchOrganizations = function () {
            return vm.searchOrganizationText ? vm.organisationalUnits.filter(function (org) {
                return org.orguniLabel.toLowerCase().includes(vm.searchOrganizationText.toLowerCase());
            }) : vm.organisationalUnits;
        };

        vm.selectedOrganizationChange = function (item) {
            if (item) {
                vm.form.organisationalUnitId = item.id;
            } else {
                vm.form.organisationalUnitId = null;
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('userAdd', {
            parent: 'account',
            url: '/userAdd',
            data: {
                authorities: ['PERM_USER_ADMIN', 'PERM_USER_ORG_UNIT_ADMIN', 'PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/users/users-form/users-form.html',
                    controller: 'UsersAddController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'userName,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('UsersEditController', UsersEditController);

    UsersEditController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate', 'USERROLES', 'USERSCHOOLTYPE', 'USER_QUERY_COUNTER_TYPES', 'UserService',
    	'InstanceService', '$state', '$cookies', '$stateParams', 'OrganisationalUnitsService', 'ModalService', 'AccountService', 'JsaService'];

    function UsersEditController (Principal, Auth, JhiLanguageService, $translate, USERROLES, USERSCHOOLTYPE, USER_QUERY_COUNTER_TYPES, UserService,
    		InstanceService, $state, $cookies, $stateParams, OrganisationalUnitsService, ModalService, AccountService, JsaService) {
        var vm = this;

        redirectIfFromDirectUrl();

        vm.instance = InstanceService.instance().lang;
        vm.theme = $cookies.get('plagiat-theme');
        vm.timezone = InstanceService.instance().timezoneDocuments;
        moment.locale(vm.instance);
        vm.key = $stateParams.key;
        vm.selected = [];
        vm.saveUser = saveUser;
        vm.isSchool = AccountService.clientType.isSchool();
        vm.loggedUserIsOrgUnitAdmin = AccountService.role.isOrgUnitAdmin();
        vm.backToUserList = backToUserList;
        vm.roles = USERROLES.getRolesForCurrentClient(AccountService);
        vm.userQueryCounterTypes = USER_QUERY_COUNTER_TYPES;
        vm.userQueryCountersKeyPress = userQueryCountersKeyPress;
        vm.userQueryCountersKeyUp = userQueryCountersKeyUp;
        vm.loggedUserIsSuperAdmin = AccountService.role.isSuperAdmin();
        vm.jsaIntegration = AccountService.getClientSettings().jsaIntegration;
        vm.academicTitleVisible = !AccountService.clientType.isPublishingHouse() && !AccountService.clientType.isSchool()  && !AccountService.clientType.isPap();
        vm.testPoolVisible = !AccountService.clientType.isPap();
        vm.USERSCHOOLTYPE = USERSCHOOLTYPE;
        
        findOrganisationalUnits();
        if(vm.jsaIntegration) {
            getPolonUsers();
        }

        function getPolonUsers() {
            JsaService.getPolonEmployeesEditUser(vm.form.id).then(function(response) {
                vm.polonEmployees = response;
            });
        }

		function findOrganisationalUnits() {
			var editedUserId = undefined;
			if(vm.loggedUserIsSuperAdmin && $stateParams.user){
				editedUserId = $stateParams.user.id;
			}
			OrganisationalUnitsService.findAllForClient(undefined, editedUserId).then(function(response) {
				vm.organisationalUnits = response.data;
                vm.selectedOrganization = vm.organisationalUnits.find(function (element) {
                    return element.id === vm.form.organisationalUnitId;
                });
			});
		}

        function backToUserList(){
        	$state.go('users');
        }

        function redirectIfFromDirectUrl(){
        	vm.user = $stateParams.user;
        	vm.canEditMail = $stateParams.canEditMail;
        	if(vm.user) {
            	vm.form = vm.user;
            } else {
            	backToUserList();
            }
        }

        function saveUser(form, ev){
        	UserService.editUser(form, form.id).then(function(){
        		backToUserList();
        		ModalService.showSuccessModal("users.form.edit.user.msg", ev);
        	}, function(errResponse){
        		ModalService.showErrorModal(errResponse);
        	})
        }
        
        function userQueryCountersKeyPress(event){
        	if (event.target.value.length >= event.target.maxLength || !(event.charCode == 0 || (event.charCode >= 48 && event.charCode <= 57))){
        		event.preventDefault();
        	}
        }
        
        function userQueryCountersKeyUp(event){
        	if (event.target.value.length >= event.target.maxLength){
        		event.preventDefault();
        		event.target.value = event.target.value.slice(0, event.target.maxLength);        		
        		vm.form.userQueryCounter = event.target.value;
        	}
        }

        vm.querySearchOrganizations = function () {
            return vm.searchOrganizationText ? vm.organisationalUnits.filter(function (org) {
                return org.orguniLabel.toLowerCase().includes(vm.searchOrganizationText.toLowerCase());
            }) : vm.organisationalUnits;
        };

        vm.selectedOrganizationChange = function (item) {
            if (item) {
                vm.form.organisationalUnitId = item.id;
            } else {
                vm.form.organisationalUnitId = null;
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('userEdit', {
            parent: 'account',
            url: '/userEdit',
            data: {
                authorities: ['PERM_USER_ADMIN', 'PERM_USER_ORG_UNIT_ADMIN', 'PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/users/users-form/users-form.html',
                    controller: 'UsersEditController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'userName,asc',
                    squash: true
                },
                user: null,
                canEditMail: true
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('userAdd');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('users', {
            parent: 'app',
            url: '/users',
            data: {
                authorities: ['PERM_USER_ADMIN', 'PERM_USER_ORG_UNIT_ADMIN', 'PERM_USER_SUPERADMIN', 'PERM_USER_RESELLER', 'PERM_USER_MINISTRY'],
                pageTitle: 'global.menu.users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/users/users.html',
                    controller: 'UsersController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'userName,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('client');
                    return $translate.refresh();
                }]
            }
        })
        .state("userLoginHistory", {
            url: "/:userId/login-history",
            parent: "users",
            data: {
                authorities: ['PERM_USER_SUPERADMIN'],
                pageTitle: 'users.user-login-history.title'
            },
            onEnter: [
                "$mdDialog", "$state", '$stateParams',
                function ($mdDialog, $state, $stateParams) {
                    $mdDialog.show({
                        controller: 'UserLoginHistoryController',
                        controllerAs: 'vm',
                        templateUrl: 'app/account/users/user-login-history/user-login-history.template.html',
                        clickOutsideToClose: true,
                        locals: {
                            userId : $stateParams.userId
                        },
                    }).then(function () {
                        $state.go("users");
                    }, function () {
                        $state.go("users");
                    });
                }
            ]
        })
        .state("userRegions", {
            url: "/:userId/user-regions",
            parent: "users",
            data: {
                authorities: ['PERM_USER_SUPERADMIN'],
                pageTitle: 'users.table.menu.edit-client-regions'
            },
            onEnter: [
                "$mdDialog", "$state", '$stateParams',
                function ($mdDialog, $state, $stateParams) {
                    $mdDialog.show({
                        controller: 'UserRegionsController',
                        controllerAs: 'vm',
                        templateUrl: 'app/account/users/user-regions/user-regions.template.html',
                        clickOutsideToClose: true,
                        locals: {
                            userId : $stateParams.userId
                        },
                    }).then(function () {
                        $state.go("users");
                    }, function () {
                        $state.go("users");
                    });
                }
            ]
        });
    }

})();

(function() {
    'use strict';

    angular
    .module('plagiat2017App')
    .controller('UsersController', UsersController);

    UsersController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate', 'UserService',
    'QueryRequest', 'SearchRequest', 'UserSearchRequest', 'tableSettingsRequest',
    'InstanceService', 'DetectInstanceService', '$cookies', '$stateParams', '$log', 'SearchService', 'PlagiatValidationService',
    '$mdBottomSheet', '$mdToast', 'TableSelectOptions', '$q', '$mdDialog', '$localStorage', 'UserReportXlsService', 'AccountService', 'USERROLES', 'USERSCHOOLTYPE'];

    function UsersController (Principal, Auth, JhiLanguageService, $translate, UserService,
      QueryRequest, SearchRequest, UserSearchRequest, tableSettingsRequest,
      InstanceService, DetectInstanceService, $cookies, $stateParams, $log, SearchService, PlagiatValidationService,
      $mdBottomSheet, $mdToast, TableSelectOptions, $q, $mdDialog, $localStorage, UserReportXlsService, AccountService, USERROLES, USERSCHOOLTYPE
    ) {

        var vm = this;
        vm.showUserImport = false;
        vm.simpleSearch = true;
        vm.activeTab='users';
        vm.instance = InstanceService.instance().lang;
        vm.conversionDomain = DetectInstanceService.getConversionAllowance();
        vm.testPoolVisible = !AccountService.clientType.isPap();
        vm.theme = $cookies.get('plagiat-theme');
        vm.timezone = InstanceService.instance().timezoneDocuments;
        moment.locale(vm.instance);
        vm.key = $stateParams.key;
        vm.queryRequest = new QueryRequest();
        vm.queryRequest.limit = $localStorage.usersListlimit ? $localStorage.usersListlimit : vm.queryRequest.limit;
        vm.searchRequest = new SearchRequest();
        vm.userSearchRequest = new UserSearchRequest();
        vm.options = new tableSettingsRequest();
        vm.selected = [];
        vm.userQueryCounters = [];
        vm.pickedUser = false;
        vm.showDetailsBlock = false;

        vm.pagingAction = pagingAction;
        vm.getUsers = getUsers;
        vm.getDetails = getDetails;
        vm.editUserQueryCounter = editUserQueryCounter;
        vm.clickOnThePageListener = clickOnThePageListener;
        vm.cancelEditUserQueryCounter = cancelEditUserQueryCounter;
        vm.saveUserQueryCounter = saveUserQueryCounter;
        vm.clear = clear;
        vm.searchUsers = searchUsers;
        vm.userQueryCountersKeyPress = userQueryCountersKeyPress;
        vm.userQueryCountersKeyUp = userQueryCountersKeyUp;
        vm.tableSelectOptions = new TableSelectOptions();
        vm.selected = [];
        vm.deSelectRow = deSelectRow;
        vm.selectRow = selectRow;
        vm.toggleSelection = toggleSelection;
        vm.selectRows = selectRows;
        vm.openBottomSheet = openBottomSheet;
        vm.closeBottomSheet = closeBottomSheet;
        vm.hibernateUsers = hibernateUsers;
        vm.massRemindPassword = massRemindPassword;
        vm.setCounters = setCounters;
        vm.setCountersCallback = setCountersCallback;
        vm.generateReportXls = generateReportXls;
        vm.removeUsers = removeUsers;
        vm.getUserRole = getUserRole;
        vm.USERSCHOOLTYPES = USERSCHOOLTYPE;

        this.$onInit = function () {
            vm.showUserImport = !AccountService.clientType.isPap();
            vm.loggedUserIsMainAdmin = AccountService.role.isMainAdmin();
            vm.loggedUserIsOrgUnitAdmin = AccountService.role.isOrgUnitAdmin();
            vm.loggedUserIsAdmin = AccountService.role.isAdmin();
            vm.isReseller = AccountService.role.isReseller();
            vm.isMinistry = AccountService.role.isMinistry();
            vm.loggedUserIsSuperAdmin = AccountService.role.isSuperAdmin();
            vm.loggedUserIsMainSuperAdmin = AccountService.role.isMainSuperAdmin();
            vm.jsaIntegration = AccountService.getClientSettings().jsaIntegration;
            if (UserService.searchObject) {
                vm.searchRequest.search = UserService.searchObject;
                vm.simpleSearch = vm.searchRequest.simpleSearch.length > 0;
                vm.userSearchRequest = vm.searchRequest.search;
                UserService.searchObject = null;
            } else if($localStorage.userSearchRequest){
                vm.searchRequest = $localStorage.userSearchRequest;
                vm.simpleSearch = vm.searchRequest.simpleSearch.length > 0;
                vm.userSearchRequest = vm.searchRequest.search;
            }
            getUsers();
        };
        
        function getUserRole(user) {
            const userRole = angular.copy(USERROLES.getAllUserRoles()
                .find(function (role) {
                    return role.type.id === user.userSchoolType;
                }));
            if (user.userSchoolType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR.id && user.mainAdmin) {
                userRole.translationKey = 'users.model.role.main.admin';
            }
            return userRole;
        }

        function prepareMassActions() {
            vm.deferred = $q.defer();
            vm.tableSelectOptions.ids.length = 0;
            vm.tableSelectOptions.selectedNo = vm.tableSelectOptions.selectedAll ? vm.tableSelectOptions.selectedNo : vm.selected.length;
            angular.forEach(vm.tableSelectOptions.selectedHelper, function (value) {
                if( value.userStatusEnum === 'PRESENT' ){
                    vm.tableSelectOptions.ids.push(value.id);
                }
            });
            vm.deferred.resolve(vm.tableSelectOptions);
            return vm.deferred.promise;
        }

        function prepareMassActionsForRemindPassword() {
            vm.deferred = $q.defer();
            vm.tableSelectOptions.ids.length = 0;
            vm.tableSelectOptions.selectedNo = vm.tableSelectOptions.selectedAll ? vm.tableSelectOptions.selectedNo : vm.selected.length;
            angular.forEach(vm.tableSelectOptions.selectedHelper, function (value) {
                if( value.userStatusEnum === 'PRESENT' || value.userStatusEnum === 'INACTIVE_NOT_HIBERNATE' ){
                    vm.tableSelectOptions.ids.push(value.id);
                }
            });
            vm.deferred.resolve(vm.tableSelectOptions);
            return vm.deferred.promise;
        }

        function prepareMassActionsForSetCounters() {
            vm.deferred = $q.defer();
            vm.tableSelectOptions.ids.length = 0;
            vm.tableSelectOptions.selectedNo = vm.tableSelectOptions.selectedAll ? vm.tableSelectOptions.selectedNo : vm.selected.length;
            angular.forEach(vm.tableSelectOptions.selectedHelper, function (value) {
                vm.tableSelectOptions.ids.push(value.id);
            });
            vm.deferred.resolve(vm.tableSelectOptions);
            return vm.deferred.promise;
        }

        function removeUsers() {
            prepareMassActions().then(function(response){
                var confirm = $mdDialog.confirm()
                .title($translate.instant("global.confirm.action"))
                .htmlContent($translate.instant("global.selected") + response.selectedNo)
                .ariaLabel($translate.instant("document.areyousure"))
                .ok($translate.instant("global.button.remove"))
                .cancel($translate.instant("global.button.cancel"))
                .openFrom('#left');
                $mdDialog.show(confirm).then(function () {
                    vm.isLoaderActive = true;
                    UserService.verifyRemoveUsers({ids: vm.selected}, vm.searchRequest, response.selectedAll).then(function () {
                        vm.isLoaderActive = false;
                        closeBottomSheet();
                        getUsers();
                    }).catch(function (response) {
                        PlagiatValidationService.getModalError(response.data);
                    });
                });
            });
        }

        function hibernateUsers() {
            prepareMassActions().then(function(response) {
                vm.infoText = response.selectedAll
                    ? $translate.instant("users.info.selected") + vm.selected.length +'<br /><br />'+ $translate.instant("users.info.hibernate.all")
                    : $translate.instant("users.info.selected") + vm.selected.length +'<br />'+ $translate.instant("users.info.to.hibernate") + response.ids.length + '<br /><br />' + $translate.instant("users.info.cant.hibernate");
                var confirm = $mdDialog.confirm()
                .title($translate.instant("global.confirm.action"))
                .htmlContent(vm.infoText)
                .ariaLabel($translate.instant("user.areyousure"))
                .ok($translate.instant("global.button.hibernate"))
                .cancel($translate.instant("global.button.cancel"))
                .openFrom('#left');
                $mdDialog.show(confirm).then(function () {
                    if( vm.tableSelectOptions.ids.length > 0 || response.selectedAll ){
                        vm.isLoaderActive = true;
                        UserService.verifyHibernateUsers({ids:response.ids}, vm.searchRequest, response.selectedAll).then(function () {
                            vm.isLoaderActive = false;
                            closeBottomSheet();
                            getUsers();
                        }, function () {
                         PlagiatValidationService.getModalError(response.data);
                     });
                    }
                });
            });
        }

        function DialogController($scope, $mdDialog, items) {
            $scope.items = items;
        }

        function setCountersCallback(value, contractType) {
            $mdDialog.hide();

            prepareMassActionsForSetCounters().then(function(response) {
                vm.infoText = response.selectedAll
                    ? $translate.instant("users.info.set.counters.all") +'<br /><br />'
                    : $translate.instant("users.info.selected") + vm.selected.length +'<br />'+ $translate.instant("users.info.set.counters.confirmation") + '<br />';
                var confirm = $mdDialog.confirm()
                    .title($translate.instant("global.confirm.action"))
                    .htmlContent(vm.infoText)
                    .ariaLabel($translate.instant("user.areyousure"))
                    .ok($translate.instant("users.set.counters"))
                    .cancel($translate.instant("global.button.cancel"))
                    .openFrom('#left');
                $mdDialog.show(confirm).then(function () {
                    if( vm.tableSelectOptions.ids.length > 0 || response.selectedAll ){
                        vm.isLoaderActive = true;
                        UserService.setCounters({ids:response.ids}, vm.searchRequest, response.selectedAll, value, contractType).then(function () {
                            vm.isLoaderActive = false;
                            closeBottomSheet();
                            getUsers();
                        }, function () {
                            PlagiatValidationService.getModalError(response.data);
                        });
                    }
                });
            });
        }

        function setCounters() {
            $mdDialog.show({
                templateUrl: 'app/account/users/set-counters/set-counters.dialog.html',
                clickOutsideToClose: true,
                locals: {
                    items: {
                        setCountersCallback: setCountersCallback
                    }
                },
                controllerAs: 'vm',
                controller: DialogController
            });
        }

        function massRemindPassword() {
            prepareMassActionsForRemindPassword().then(function(response) {
                vm.infoText = response.selectedAll
                    ? $translate.instant("users.info.selected") + vm.users.length
                    : $translate.instant("users.info.selected") + vm.selected.length +'<br />'+ $translate.instant("users.info.to.remind.password") + response.ids.length + '<br /><br />' + $translate.instant("users.info.cant.remind.password");
                var confirm = $mdDialog.confirm()
                    .title($translate.instant("global.confirm.action"))
                    .htmlContent(vm.infoText)
                    .ariaLabel($translate.instant("user.areyousure"))
                    .ok($translate.instant("users.remind.password"))
                    .cancel($translate.instant("global.button.cancel"))
                    .openFrom('#left');
                $mdDialog.show(confirm).then(function () {
                    if( vm.tableSelectOptions.ids.length > 0 || response.selectedAll ){
                        vm.isLoaderActive = true;
                        UserService.verifyMassRemindPassword({ids:response.ids}, vm.searchRequest, response.selectedAll).then(function () {
                            vm.isLoaderActive = false;
                            closeBottomSheet();
                            getUsers();
                        }, function () {
                            PlagiatValidationService.getModalError(response.data);
                        });
                    }
                });
            });
        }

        function toggleSelection(total) {
            if(!vm.tableSelectOptions.selectedAll) {
                selectRows(vm.users);
            }
            vm.tableSelectOptions.selectedAll = !vm.tableSelectOptions.selectedAll;
            vm.tableSelectOptions.selectedNo = total;
            if( !vm.tableSelectOptions.selectedAll ) {
                closeBottomSheet();
            }
        }

        function deSelectRow() {
            if( vm.selected.length === 0) {
                closeBottomSheet();
            }
        }

        function selectRow(pickedId) {
            if( vm.selected.length === 1) {
                openBottomSheet();
            }
            angular.forEach(vm.users, function (value) {
                if (value.id === pickedId) {
                    if (vm.tableSelectOptions.selectedHelper.indexOf(pickedId) === -1) {
                        vm.tableSelectOptions.selectedHelper.push(value);
                    }
                }
            });
        }

        function selectRows(obj) {
            angular.forEach(obj, function (value) {
                if (vm.selected.indexOf(value.id) === -1) {
                    vm.selected.push(value.id);
                }
            })
        }

        function resetSelection() {
            if(vm.tableSelectOptions.selectedAll) {
                vm.selected.length = 0;
                vm.tableSelectOptions = new TableSelectOptions();
                $mdBottomSheet.hide();
            }
        }

        function closeBottomSheet() {
                vm.selected.length = 0;
                vm.tableSelectOptions = new TableSelectOptions();
                $mdBottomSheet.hide();
        }

        function openBottomSheet() {
            $mdBottomSheet.show({
              templateUrl: 'app/account/users/bottom-sheet-grid-template.html',
              controllerAs: 'bootomSheet',
              parent: angular.element(document.getElementById('users')),
              controller: function GridBottomSheetCtrl(){
                var bootomSheet = this;
                bootomSheet.checked = true;
                bootomSheet.closeBottomSheet = vm.closeBottomSheet;
                bootomSheet.selected = vm.selected;
                bootomSheet.tableSelectOptions = vm.tableSelectOptions;
                bootomSheet.total = vm.totalUsers;
                bootomSheet.toggleSelection = vm.toggleSelection;
                bootomSheet.hibernate = vm.hibernateUsers;
                bootomSheet.remove = vm.removeUsers;
                bootomSheet.remindPasswords = vm.massRemindPassword;
                bootomSheet.setCounters = vm.setCounters;
                bootomSheet.generateReportXls = vm.generateReportXls;
                bootomSheet.isReseller = vm.isReseller;
                bootomSheet.isMinistry = vm.isMinistry;
                bootomSheet.isSuperAdmin = vm.loggedUserIsSuperAdmin;
            },
            isLockedOpen: true,
            disableParentScroll: false,
            disableBackdrop: true
          });
        }

        function clickOnThePageListener(event){
            vm.clickedElement = event.target;
            if (!vm.clickedElement) return;

            var elementClasses = vm.clickedElement.classList;
            var clickedInsideOfUserQueryCounter = elementClasses.contains('user-query-counter-input') || elementClasses.contains('user-query-counter-block')
                || elementClasses.contains('icon-save') || elementClasses.contains('icon-cancel') || elementClasses.contains('icon-edit');
            if(!clickedInsideOfUserQueryCounter){
                vm.userQueryCounterId = undefined;
                resetUserQueryCounters();
            }
        }
        
        function getUsers(){
            vm.showDetailsBlock = false;
            vm.searchRequest.pageNumber = vm.queryRequest.page-1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.sortTab = SearchService.sort(vm.queryRequest);
            vm.searchRequest.search = vm.userSearchRequest;
            vm.getOrSearch = vm.searchRequest.simpleSearch.length > 0 ? function (s) {
                return UserService.searchUsers(s);
            } : function (s) {
                return UserService.getUsers(s);
            };
            vm.isLoaderActive = true;
            vm.getOrSearch(vm.searchRequest).then(function (responseData) {
                vm.responseObj = responseData.content;
                vm.users = vm.responseObj;
                vm.totalUsers = responseData.totalElements;
                vm.isLoaderActive = false;
                UserService.searchObject = null;
            });

        }

        function searchUsers(){
            vm.queryRequest.page = 1;
            getUsers(); 
        }
        
        function pagingAction(page) {
            resetSelection();
        	vm.isLoaderActive = true;
            vm.queryRequest.page = page;
            getUsers();
        }

        function getDetails(user) {
        	vm.showDetailsBlock = false;
        	
        	if (user.id !== UserService.userDetailsObj.id) {
	            vm.pickedUser = user.id;
	            UserService.userDetailsObj = user;
	            UserService.getDetails(user.id).then(function (result) {
	                vm.showDetailsBlock = true;
	                vm.details = result.data;
	            }); 
        	} else {
        		UserService.userDetailsObj = {};
        	}
        }
        
        function resetUserQueryCounters(){
        	if(vm.users){
        		angular.forEach(vm.users, function(user, index){
        			vm.userQueryCounters[index] = user.userQueryCounter;    
        		})
        	}
        }

        function editUserQueryCounter(user, index, event) {
            if (vm.isMinistry) {
                return;
            }
        	vm.clickedElement = event.target;
            if (!vm.clickedElement) return;
            var elementClasses = vm.clickedElement.classList;
            vm.clickedCancelOrSave = elementClasses.contains('icon-save') || elementClasses.contains('icon-cancel');
            if (vm.clickedCancelOrSave){
            	return;
            }
            vm.userQueryCounterId = user.id;
        }

        function cancelEditUserQueryCounter(){
        	vm.userQueryCounterId = undefined;
        	resetUserQueryCounters();
        }
        
        function saveUserQueryCounter(user, index){
        	vm.userQueryCounterSaving = true;
        	vm.form = {
            	id: vm.userQueryCounterId,
            	userQueryCounterStr: vm.userQueryCounters[index]
            };
        	UserService.updateUserQueryCounter(vm.form).then(function(){
        		vm.userQueryCounterId = undefined;
        		vm.userQueryCounterSaving = false;
        		vm.users[index].userQueryCounter = vm.userQueryCounters[index];
        	}, function(response){
        		vm.userQueryCounterId = undefined;
        		vm.userQueryCounterSaving = false;
        		resetUserQueryCounters();
        		PlagiatValidationService.getModalError(response.data);
        	})
        }

        function clear() {
            vm.userSearchRequest = new UserSearchRequest();
            getUsers();
        }
        
        function userQueryCountersKeyPress(event){
        	if (event.target.value.length >= event.target.maxLength || !(event.charCode == 0 || (event.charCode >= 48 && event.charCode <= 57))){
        		event.preventDefault();
        	}
        }
        
        function userQueryCountersKeyUp(event){
        	if (event.target.value.length >= event.target.maxLength){
        		event.target.value = event.target.value.slice(0, event.target.maxLength);
        	}
        }

        function generateReportXls(){
        	prepareMassActions().then(function(response){
        		UserReportXlsService.generateReportXls(response, vm.selected, vm.searchRequest);
        	});
        }
   }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .constant('USERSTATUSES', [
       {'id': 0, 'status': 'users.model.status.active' },
       {'id': -3, 'status': 'users.model.status.inactive' },
       {'id': -1, 'status': 'users.model.status.hibernated' }  ])
    .constant('USERSTATUSES_SUPERADMIN', [
       {'id': 0, 'status': 'users.model.status.active' },
       {'id': -2, 'status': 'users.model.status.blocked' },
       {'id': -3, 'status': 'users.model.status.inactive' },
       {'id': -1, 'status': 'users.model.status.hibernated' }  ])
    ;
})();

(function () {
    'use strict';


    var userSchoolTypes = {
        USER_SCHOOL_TYPE_TEACHER: {id: 0, value: 'USER_SCHOOL_TYPE_TEACHER_SCHOOL'},
        USER_SCHOOL_TYPE_STUDENT: {id: 1, value: 'USER_SCHOOL_TYPE_STUDENT_SCHOOL'},
        USER_SCHOOL_TYPE_DEANERY: {id: 2, value: 'USER_SCHOOL_TYPE_DEANERY'},
        USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR: {id: 4, value: 'USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR'},
        USER_SCHOOL_TYPE_SUPERADMIN: {id: 5, value: 'USER_SCHOOL_TYPE_SUPERADMIN'},
        USER_SCHOOL_TYPE_ORG_UNIT_ADMIN: {id: 6, value: 'USER_SCHOOL_TYPE_ORG_UNIT_ADMIN'},
        USER_SCHOOL_TYPE_RESELLER: {id: 7, value: 'USER_SCHOOL_TYPE_RESELLER'},
        USER_SCHOOL_TYPE_MINISTRY: {id: 8, value: 'USER_SCHOOL_TYPE_MINISTRY'},
        USER_SCHOOL_TYPE_INDIVIDUAL: {id: 100, value: 'USER_SCHOOL_TYPE_INDIVIDUAL'}
    };

    angular
        .module('plagiat2017App')
        .constant('USERSCHOOLTYPE', userSchoolTypes)
        .constant('USERROLES', function () {
            var userRoles = {
                INDIVIDUAL: [
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_INDIVIDUAL,
                        translationKey: 'users.model.role.individual',
                        icons: ['monetization_on']
                    }],
                CLIENT_TYPE_STANDARD: [
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_TEACHER,
                        translationKey: 'users.model.role.teacher',
                        icons: ['school']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_DEANERY,
                        translationKey: 'users.model.role.deanery',
                        icons: ['account_balance']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR,
                        translationKey: 'users.model.role.deanery_admin',
                        icons: ['brightness_auto', 'account_balance']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_ORG_UNIT_ADMIN,
                        translationKey: 'users.model.role.org_unit_admin',
                        icons: ['turned_in_not', 'account_balance']
                    },
                    {
                        settingDependence: 'userSchoolTypeStudent',
                        type: userSchoolTypes.USER_SCHOOL_TYPE_STUDENT,
                        translationKey: 'users.model.role.student.code-account',
                        icons: ['edit']
                    }],
                CLIENT_TYPE_ASAP: [
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_TEACHER,
                        translationKey: 'users.model.role.teacher',
                        icons: ['school']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_DEANERY,
                        translationKey: 'users.model.role.deanery',
                        icons: ['account_balance']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR,
                        translationKey: 'users.model.role.deanery_admin',
                        icons: ['brightness_auto', 'account_balance']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_ORG_UNIT_ADMIN,
                        translationKey: 'users.model.role.org_unit_admin',
                        icons: ['turned_in_not', 'account_balance']
                    }],
                CODE_ACCOUNT: [
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_TEACHER,
                        translationKey: 'users.model.role.teacher',
                        icons: ['school']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_DEANERY,
                        translationKey: 'users.model.role.deanery',
                        icons: ['account_balance']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR,
                        translationKey: 'users.model.role.deanery_admin',
                        icons: ['brightness_auto', 'account_balance']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_ORG_UNIT_ADMIN,
                        translationKey: 'users.model.role.org_unit_admin',
                        icons: ['turned_in_not', 'account_balance']
                    },
                    {
                        settingDependence: 'userSchoolTypeStudent',
                        type: userSchoolTypes.USER_SCHOOL_TYPE_STUDENT,
                        translationKey: 'users.model.role.student.code-account',
                        icons: ['edit']
                    }],
                COLLEGE: [
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_TEACHER,
                        translationKey: 'users.model.role.teacher',
                        icons: ['school']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_DEANERY,
                        translationKey: 'users.model.role.deanery',
                        icons: ['account_balance']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR,
                        translationKey: 'users.model.role.deanery_admin',
                        icons: ['brightness_auto', 'account_balance']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_ORG_UNIT_ADMIN,
                        translationKey: 'users.model.role.org_unit_admin',
                        icons: ['turned_in_not', 'account_balance']
                    },
                    {
                        settingDependence: 'userSchoolTypeStudent',
                        type: userSchoolTypes.USER_SCHOOL_TYPE_STUDENT,
                        translationKey: 'users.model.role.student.code-account',
                        icons: ['edit']
                    }],
                PUBLISHING_HOUSE: [
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_DEANERY,
                        translationKey: 'users.model.role.user',
                        icons: ['person']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR,
                        translationKey: 'users.model.role.admin',
                        icons: ['brightness_auto']
                    }],
                CLIENT_TYPE_PORTAL: [
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_DEANERY,
                        translationKey: 'users.model.role.operator',
                        icons: ['person']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR,
                        translationKey: 'users.model.role.admin',
                        icons: ['brightness_auto']
                    }],
                SCHOOL: [
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_STUDENT,
                        translationKey: 'users.model.role.student.school',
                        icons: ['edit']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_TEACHER,
                        translationKey: 'users.model.role.teacher.school',
                        icons: ['school']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR,
                        translationKey: 'users.model.role.admin',
                        icons: ['brightness_auto']
                    }],
                RESELLER: [
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_STUDENT,
                        translationKey: 'users.model.role.student.school',
                        icons: ['edit']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_TEACHER,
                        translationKey: 'users.model.role.lecturer.or.teacher',
                        icons: ['school']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_DEANERY,
                        translationKey: 'users.model.role.deanery',
                        icons: ['account_balance']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR,
                        translationKey: 'users.model.role.deanery_admin',
                        icons: ['brightness_auto', 'account_balance']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_ORG_UNIT_ADMIN,
                        translationKey: 'users.model.role.org_unit_admin',
                        icons: ['turned_in_not', 'account_balance']
                    }
                    ],
                SUPERADMIN: [
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_STUDENT,
                        translationKey: 'users.model.role.student.school',
                        icons: ['edit']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_TEACHER,
                        translationKey: 'users.model.role.lecturer.or.teacher',
                        icons: ['school']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_DEANERY,
                        translationKey: 'users.model.role.deanery',
                        icons: ['account_balance']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR,
                        translationKey: 'users.model.role.deanery_admin',
                        icons: ['brightness_auto', 'account_balance']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_ORG_UNIT_ADMIN,
                        translationKey: 'users.model.role.org_unit_admin',
                        icons: ['turned_in_not', 'account_balance']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_SUPERADMIN,
                        translationKey: 'users.model.role.superadmin',
                        icons: ['stars']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_RESELLER,
                        translationKey: 'users.model.role.reseller',
                        icons: ['fingerprint']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_MINISTRY,
                        translationKey: 'users.model.role.ministry',
                        icons: ['dataset']
                    },
                    {
                        type: userSchoolTypes.USER_SCHOOL_TYPE_INDIVIDUAL,
                        translationKey: 'users.model.role.individual',
                        icons: ['monetization_on']
                    }]
            };
            userRoles.DEFAULT = userRoles.CLIENT_TYPE_STANDARD;

            userRoles.getAllUserRoles = function() {
                return userRoles.SUPERADMIN;
            };
            
            userRoles.getRolesForUser = function (user) {
                if (user.userSchoolType === userSchoolTypes.USER_SCHOOL_TYPE_SUPERADMIN.id) {
                    return userRoles.SUPERADMIN;
                }
                if (user.userSchoolType === userSchoolTypes.USER_SCHOOL_TYPE_RESELLER.id) {
                    return userRoles.RESELLER;
                }
                return  userRoles[user.userClientType] ? userRoles[user.userClientType] : userRoles.DEFAULT;
            };

            userRoles.getRolesForCurrentClient = function (AccountService) {
                if (AccountService.role.isSuperAdmin()) {
                    return userRoles.SUPERADMIN;
                }
                if (AccountService.role.isReseller() || AccountService.role.isMinistry()) {
                    return userRoles.DEFAULT;
                }
                var rolesForClientType = userRoles[AccountService.getClientType()] ? userRoles[AccountService.getClientType()] : userRoles.DEFAULT;
                if (AccountService.getClientSettings()) {
                    return rolesForClientType.filter(function (role) {
                        return !role.settingDependence || AccountService.getClientSettings()[role.settingDependence] === true;
                    });
                } else {
                    return rolesForClientType;
                }
            };

            return userRoles;
        }());
})();

(function() {
	'use strict';

	angular
		.module('plagiat2017App')
		.controller('UserRegionsController', UserRegionsController);

	function UserRegionsController($scope, $mdDialog, UserService, ModalService, ClientService, userId) {
		var vm = this;
		vm.cancelDialog = cancelDialog;
		vm.saveUserRegions = saveUserRegions;

		vm.clientRegions = [];
		vm.allRegions = false;

		this.$onInit = function () {
			UserService.getUserRegions(userId).then(
				function (success) {
					vm.clientRegions = success.data.userRegions;
					vm.allRegions = success.data.allRegions;
				});
		};
		
		function cancelDialog() {
			$mdDialog.cancel();
		}

		function saveUserRegions() {
	        UserService.saveUserRegions({userId: userId, allRegions: vm.allRegions, userRegions: vm.clientRegions}).then(
	        	function() {
	        		$mdDialog.cancel();
	        	}, function(response) {
	        		$mdDialog.cancel().then(function() {
	        			ModalService.showErrorModal(response);
	        		});
	        	});
		}

	}

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .constant('USER_QUERY_COUNTER_TYPES', [
       {'id': 0, 'type': 'users.model.usertests.type.docs' },
       {'id': 1, 'type': 'users.model.usertests.type.chars' }  ]);
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('UserLoginHistoryService', UserLoginHistoryService);

    UserLoginHistoryService.$inject = ['$http', '$q'];

    function UserLoginHistoryService($http, $q) {

        var requestUrl = 'api/user-login-history';

        var service = {
            findAllByUser: findAllByUser,
        };
        return service;

        function findAllByUser(searchRequest) {
            return $http.post(requestUrl, searchRequest).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('UserLoginHistoryController', UserLoginHistoryController);

    UserLoginHistoryController.$inject = [
        '$mdDialog', '$q',
        'userId', '$rootScope', 'ModalService',
        'SearchRequest', 'UserLoginHistoryService'
    ];

    function UserLoginHistoryController(
        $mdDialog, $q, userId, $rootScope, ModalService,
        SearchRequest, UserLoginHistoryService
    ) {
        var vm = this;

        vm.page;
        vm.searchRequest;
        vm.pageOfTranslations = {};

        this.$onInit = function () {
            vm.find(1);
        };

        vm.find = function (pageNumber) {
            vm.pending = true;
            vm.searchRequest = new SearchRequest();
            vm.searchRequest.userId = userId;
            vm.searchRequest.pageNumber = pageNumber - 1;
            vm.searchRequest.pageSize = 20;
            vm.searchRequest.sortTab = ['loginTimestamp,desc'];

            UserLoginHistoryService.findAllByUser(vm.searchRequest).then(
                function (response) {
                    vm.pending = false;
                    vm.page = response.data;
                    vm.page.number++;
                }, function (errorResponse) {
                    vm.pending = false;
                    $mdDialog.cancel();
                    ModalService.showErrorModal(errorResponse);
                }
            );
        };

        vm.closeDialog = function () {
            $mdDialog.cancel();
            $rootScope.$broadcast('on-close-modal-translation-edit');
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('user-import', {
            parent: 'account',
            url: '/user-import',
            data: {
            	authorities: ['PERM_USER_ADMIN', 'PERM_USER_ORG_UNIT_ADMIN', 'PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/users/user-import/user-import.html',
                    controller: 'UserImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('user.import');
                    $translatePartialLoader.addPart('document');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('UserImportController', UserImportController);

    UserImportController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate',
    	'InstanceService', '$state', '$cookies', '$stateParams', '$mdDialog', '$http', 'UserImportService', 'Utils',
        'AccountService', '$sce', 'DetectInstanceService'];

    function UserImportController (Principal, Auth, JhiLanguageService, $translate,
    		InstanceService, $state, $cookies, $stateParams,  $mdDialog, $http, UserImportService, Utils,
                                   AccountService, $sce, DetectInstanceService) {
        var vm = this;
        vm.activeTab='userImport';
        vm.instance = InstanceService.instance().lang;
        vm.formData = null;
        vm.fileName = null;
        vm.dontActivate = !AccountService.account.clientSettings.authorFromUsersList;
        vm.theme = $cookies.get('plagiat-theme');
        vm.timezone = InstanceService.instance().timezoneDocuments;
        moment.locale(vm.instance);
        vm.importUsersFromXls = UserImportService.importUsersFromXls;
        vm.availableExtension = UserImportService.getAvailableExtensions();
        vm.isLoaderActive = false;
        vm.fileReportName = $translate.instant("user.import.file-report-name");
        vm.userImportSuccess = false;
        vm.userImportError = false;
        vm.importSuccessMsg = $translate.instant("user.import.success.info1") + '<br/>' + $translate.instant("user.import.success.info2");
        vm.importErrorMsg = $translate.instant("user.import.error.info1");
        vm.clientTypePublishingHouse = AccountService.clientType.isPublishingHouse();
        vm.instance = DetectInstanceService.instance();

        vm.downloadTemplate = downloadTemplate;
        vm.uploadUserImportFile = uploadUserImportFile;
        vm.cancelUploadUsers = cancelUploadUsers;
        vm.uploadFile = uploadFile;
        vm.getTheFiles = getTheFiles;
        vm.trustSrc = trustSrc;

        function downloadTemplate(){
        	UserImportService.downloadTemplate(vm.fileReportName);
        }

        function trustSrc(src) {
            return $sce.trustAsResourceUrl(src);
        }

        switch(vm.instance) {
            case 'int':
              vm.instanceType = '_int';
              break;
            case 'ro':
              vm.instanceType = '_ro';
              break;
            case 'pl':
              vm.instanceType = '_pl';
              break;
            case 'aka':
              vm.instanceType = '_aka';
              break;
            default:
              vm.instanceType = '_pl';
        }

        function getTheFiles($files, $invalidFiles) {
            if ($files === null) {
                vm.files = null;
            } else {
                if ($invalidFiles.length === 0) {
                    var formData = new FormData();
                    vm.files = $files;
                    var i = 0;
                    angular.forEach(vm.files, function (value, key) {
                        vm.fileName = Utils.removeSpecialCharsForFileName(value.name);
                        formData.append(key, value);
                        i++;
                    });
                    if (i > 0) {
                        vm.userImportPending = true;
                        vm.userImportSuccess = false;
                        vm.userImportError = false;
                        vm.formData = formData;
                    }
                }
            }
        }

		function cancelUploadUsers() {
            vm.userImportPending = false;
            vm.formData = null;
            vm.fileName = null;
		}

		function uploadUserImportFile() {
            vm.uploadFile(vm.formData, vm.fileName, vm.dontActivate);
		}

		function uploadFile(obj, filename, activate) {
			var request = {
                headers: {
                    'Content-Type': undefined,
                    'Charset': 'UTF-8'
                },
                responseType : 'arraybuffer'
            };
			vm.isLoaderActive = true;
        	vm.userImportSuccess = false;
			vm.userImportError = false;

			 return $http.post('api/user/upload-file?dontActivate=' + activate + '&filename=' + filename, obj, request).then(
                function (response) {
					var blob = new Blob(
							[ response.data ],
							{
                                type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
							});
					saveAs(blob, vm.fileReportName + getExtension(filename));
					vm.isLoaderActive = false;
					vm.userImportError = false;
					vm.userImportPending = false;
					vm.userImportSuccess = true;

		            $mdDialog.show(
		                    $mdDialog.confirm()
		                    .clickOutsideToClose(true)
		                    .title('')
		                    .htmlContent(vm.importSuccessMsg)
		                    .ariaLabel('ok')
		                    .ok('OK')
		                    );
                },
                function (errResponse) {
                	vm.isLoaderActive = false;
                	vm.userImportSuccess = false;
                	vm.userImportPending = false;
					vm.userImportError = true;

		            $mdDialog.show(
		                    $mdDialog.confirm()
		                    .clickOutsideToClose(true)
		                    .title('')
		                    .textContent(vm.importErrorMsg)
		                    .ariaLabel('ok')
		                    .ok('OK')
		                    );

                    return $q.reject(errResponse);
                });
        }
        
        function getExtension(filename) {
            if (filename) {
                var a = filename.lastIndexOf('.xlsx');
                if (a > 0) {
                    return '.xlsx';
                }
                var b = filename.lastIndexOf('.xls');
                if (b > 0) {
                    return '.xls';
                }
            }
            return '.xlsx';
        }

    }
})();

(function() {
	'use strict';

	function UserHistoryController($scope, $mdDialog, UserService) {
		var vm = this;
		vm.closeDialog = closeDialog;
		vm.userId = UserService.user.id;
		vm.getUserHistory = getUserHistory;

		function closeDialog() {
			$mdDialog.hide();
		}

		function getUserHistory() {
			UserService.getUserHistory(vm.userId).then(function(response) {
				vm.userHistoryList = response.data;
			});
		}

		if (vm.userId !== null) {
			getUserHistory();
		}

	}

	angular
			.module('plagiat2017App')
			.component(
					'userHistory',
					{
						templateUrl : 'app/account/users/user-history/user-history.template.html',
						controller : UserHistoryController
					});

})();

(function() {
	'use strict';

	function UserDetailsController($log, $state, DocumentService, AccountService) {
		var vm = this;

		vm.hideUserHistory = AccountService.account.clientSettings.hideUserHistory;
		
		vm.getDocuments = getDocuments;

		function getDocuments(user){
			DocumentService.searchUser = user;
			$state.go('documents');
		}

	}

	angular
	.module('plagiat2017App')
	.component('userDetails', {
			templateUrl : 'app/account/users/user-details/user-details.template.html',
			controller : UserDetailsController,
			bindings: {
				onUser: '<',
				onUserDetails: '<',
            	onIsSuperadmin: '<',
				onGetUserRole: '<'
			}
		});

})();

(function() {
	'use strict';

	function SetCountersController($scope, $mdDialog) {
		var vm = this;
		vm.cancelDialog = cancelDialog;

		vm.value = null;
		vm.contractType = null;

		function cancelDialog() {
			$mdDialog.cancel();
		}

	}

	angular
		.module('plagiat2017App')
		.component(
			'setCounters',
			{
				templateUrl : 'app/account/users/set-counters/set-counters.template.html',
				controllerAs: 'vm',
				bindings: {
					setCountersCallback: "="
				},
				controller : SetCountersController
			});

})();

(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .constant('ADDFREETOKENSMIN', 1)
        .constant('ADDFREETOKENSMAX', 100);
})();

(function() {
	'use strict';

	function AddFreeTokensController($scope, $mdDialog, UserService, ModalService, ADDFREETOKENSMIN, ADDFREETOKENSMAX) {
		var vm = this;
		vm.cancelDialog = cancelDialog;
		vm.addFreeTokens = addFreeTokens;
		vm.addFreeTokensMin = ADDFREETOKENSMIN;
		vm.addFreeTokensMax = ADDFREETOKENSMAX;
		
		vm.form = {
			userId: UserService.user.id,
			tokens: undefined
		};

		function cancelDialog() {
			$mdDialog.cancel();
		}

		function addFreeTokens(form) {
	        UserService.addFreeTokens(form).then(function(){
	        	$mdDialog.hide();
	        }, function(response){
	        	$mdDialog.cancel().then(function(){
	        		ModalService.showErrorModal(response);
	        	})
	        });
		}

	}

	angular
			.module('plagiat2017App')
			.component(
					'addFreeTokens',
					{
						templateUrl : 'app/account/users/add-free-tokens/add-free-tokens.template.html',
						controller : AddFreeTokensController
					});

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('translations', {
            parent: 'app',
            url: '/translations',
            data: {
                authorities: ['PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.account.translations'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/translations/translations.html',
                    controller: 'TranslationsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'userName,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil',
                    function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate(
                                $stateParams.sort),
                            ascending: PaginationUtil.parseAscending(
                                $stateParams.sort)
                        };
                    }],
                translatePartialLoader: ['$translate',
                    '$translatePartialLoader',
                    function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('translations');
                        $translatePartialLoader.addPart('document');
                        return $translate.refresh();
                    }]
            }
        })
        .state("translations-edit", {
            url: "/:code/edit",
            parent: "translations",
            data: {
                authorities: ['PERM_USER_SUPERADMIN'],
                pageTitle: 'translations.edit.update-title'
            },
            onEnter: [
                "$mdDialog", "$state", '$stateParams',
                function ($mdDialog, $state, $stateParams) {
                    $mdDialog.show({
                        controller: 'TranslationEditController',
                        controllerAs: 'vm',
                        templateUrl: 'app/account/translations/translation-edit.html',
                        clickOutsideToClose: false,
                        locals: {
                            code: $stateParams.code
                        },
                    }).then(function () {
                        $state.go("translations");
                    }, function () {
                        $state.go("translations");
                    });
                }
            ]
        })
        .state("translationHistory", {
            url: "/history?code&lang",
            parent: "translations",
            data: {
                pageTitle: 'translations.history.title'
            },
            onEnter: [
                "$mdDialog", "$state", '$stateParams',
                function ($mdDialog, $state, $stateParams) {
                    $mdDialog.show({
                        controller: 'TranslationHistoryController',
                        controllerAs: 'vm',
                        templateUrl: 'app/account/translations/translation.history.template.html',
                        clickOutsideToClose: true,
                        locals: {
                            code: $stateParams.code,
                            lang: $stateParams.lang
                        }
                    }).then(function () {
                        $state.go("translations");
                    }, function () {
                        $state.go("translations");
                    });
                }
            ]
        })
        .state("translations-create", {
            url: "/create",
            parent: "translations",
            data: {
                authorities: ['PERM_USER_SUPERADMIN'],
                pageTitle: 'translations.edit.create-title'
            },
            onEnter: [
                "$mdDialog", "$state",
                function ($mdDialog, $state) {
                    $mdDialog.show({
                        controller: 'TranslationEditController',
                        controllerAs: 'vm',
                        templateUrl: 'app/account/translations/translation-edit.html',
                        clickOutsideToClose: false,
                        locals: {
                            code: null
                        },
                    }).then(function () {
                        $state.go("translations");
                    }, function () {
                        $state.go("translations");
                    });
                }
            ]
        })
        .state("translations-import", {
            url: "/import",
            parent: "translations",
            data: {
                authorities: ['PERM_USER_SUPERADMIN'],
                pageTitle: 'translations.import.import-title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/translations/translation-import.html',
                    controller: 'TranslationImportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate',
                    '$translatePartialLoader',
                    function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('translations');
                        $translatePartialLoader.addPart('document');
                        return $translate.refresh();
                    }]
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('TranslationsService', TranslationsService);

    TranslationsService.$inject = ['$http', '$q', 'ReportXlsService'];

    function TranslationsService($http, $q, ReportXlsService) {

        var service = {
            search: search,
            save: save,
            findOne: findOne,
            hasConflictingExternalTranslationCodes: hasConflictingExternalTranslationCodes,
            findHistory: findHistory,
            saveOrUpdate: saveOrUpdate,
            removeTranslations: removeTranslations,
            generateReportXls: generateReportXls,
            uploadTranslationsFile: uploadTranslationsFile,
            saveImportedTranslations: saveImportedTranslations
        };
        var requestUrl = 'api/translations';
        return service;

        function search(pageableFilter) {
            return $http.post(requestUrl + '/search', pageableFilter).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function save(code, lang, translatedText) {
            return $http.post(requestUrl + '/save', {code: code, lang: lang, translatedText: translatedText}).then(
                function () {
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function saveOrUpdate(obj) {
            return $http.post(requestUrl + '/save-or-update', obj).then(
                function () {
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function findOne(code) {
            return $http.get(requestUrl + '?code=' + code).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function hasConflictingExternalTranslationCodes(code) {
            return $http.get(requestUrl + '/has-conflicting-external-translation-codes?code=' + code).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function findHistory(code) {
            return $http.get(requestUrl + '/history?code=' + code).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function removeTranslations(obj) {
            return $http.post(requestUrl + '/remove-multiple', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function generateReportXls(response, selected, searchRequest, languageSelection) {

            var url = response.selectedAll ? 'api/translations/report/xls/search/return-xls'
                : 'api/translations/report/xls/selected/return-xls';
            var data = response.selectedAll
                ? {langs:languageSelection, filter:searchRequest}
                : {langs:languageSelection, ids:{ids:selected}};

            ReportXlsService.generateExcelFile(data, url, 'translations_');
        }

        function uploadTranslationsFile(obj, filename) {
            var request = {
                headers: {
                    'Content-Type': undefined,
                    'Charset': 'UTF-8'
                }
            };

            return $http.post(requestUrl + '/upload-file?filename=' + filename, obj, request).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function saveImportedTranslations(obj) {
            return $http.post(requestUrl + '/save-imported', obj).then(
                function () {
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('TranslationsController', TranslationsController);

    TranslationsController.$inject = [
        'JhiLanguageService', 'TranslationsService', 'tableSettingsRequest', 'TableSelectOptions', '$localStorage', 'ModalService',
        '$mdBottomSheet', '$q', '$mdDialog', '$translate', 'PlagiatValidationService', 'QueryRequest', 'SearchRequest', 'TRANSLATION_TYPES', '$scope'
    ];

    function TranslationsController(
        JhiLanguageService, TranslationsService, tableSettingsRequest, TableSelectOptions, $localStorage, ModalService,
        $mdBottomSheet, $q, $mdDialog, $translate, PlagiatValidationService, QueryRequest, SearchRequest, TRANSLATION_TYPES, $scope
    ) {
        var vm = this;

        vm.loadData = loadData;
        vm.loadPageOfTranslations = loadPageOfTranslations;
        vm.onLanguageSelected = onLanguageSelected;
        vm.shouldShowColumnForLanguage = shouldShowColumnForLanguage;
        vm.onMouseEnter = onMouseEnter;
        vm.isMouseOver = isMouseOver;
        vm.editCell = editCell;
        vm.isCellEdited = isCellEdited;
        vm.cancelEdition = cancelEdition;
        vm.saveTranslation = saveTranslation;
        vm.deSelectRow = deSelectRow;
        vm.selectRow = selectRow;
        vm.toggleSelection = toggleSelection;
        vm.selectRows = selectRows;
        vm.openBottomSheet = openBottomSheet;
        vm.closeBottomSheet = closeBottomSheet;
        vm.removeTranslations = removeTranslations;
        vm.generateReportXls = generateReportXls;
        vm.toggleSearch = toggleSearch;
        vm.clear = clear;

        vm.translationTypes = TRANSLATION_TYPES;
        vm.pageOfTranslations = {};
        vm.selected = [];
        vm.tableSelectOptions = new TableSelectOptions();
        vm.tableSettings = new tableSettingsRequest();
        vm.keyCodeEnter = KeyCode.KEY_RETURN;
        vm.queryRequest = new QueryRequest();
        vm.searchRequest = new SearchRequest();
        vm.cellWithMouseOver = null;
        vm.editedCell = null;
        vm.editedValue = null;

        vm.codeMouseEnterMap = {};
        vm.simpleSearch = true;
        vm.simpleSearchText;

        this.$onInit = function () {
            JhiLanguageService.getAllWithAdditional().then(function (allLanguages) {
                vm.availableLanguages = allLanguages.data.availableLanguages;
            });
            vm.queryRequest.limit = $localStorage.translationsLimit ? $localStorage.translationsLimit : vm.queryRequest.limit;
            vm.searchRequest.search.type = 0;
            loadPageOfTranslations(1);
            vm.languageSelection = $localStorage.translationsPageLanguageSelection ? $localStorage.translationsPageLanguageSelection : {};
        };

        $scope.$on('on-close-modal-translation-edit', function () {
            vm.loadData();
        });

        vm.onSimpleSearchTextChange = function () {
            vm.loadPageOfTranslations(1);
        };

        function toggleSearch() {
            vm.simpleSearchText = '';
            vm.simpleSearch = !vm.simpleSearch;
            $localStorage.translationSimpleSearchEnabled = vm.simpleSearch;
        }

        function clear() {
            vm.searchRequest = new SearchRequest();
            loadData();
        }

        function shouldShowColumnForLanguage(languageCode) {
            return vm.languageSelection[languageCode];
        }

        function onLanguageSelected() {
            $localStorage.translationsPageLanguageSelection = vm.languageSelection;
        }

        function loadPageOfTranslations(pageNumber) {
            vm.searchRequest.pageNumber = pageNumber - 1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.simpleSearch = vm.simpleSearchText;
            $localStorage.translationsLimit = vm.queryRequest.limit;
            vm.pending = true;
            TranslationsService.search(vm.searchRequest).then(function (translationsPage) {
                vm.pending = false;
                vm.pageOfTranslations = translationsPage;
                vm.totalTranslations = translationsPage.totalElements;
                vm.translations = translationsPage.content;
                vm.pageOfTranslations.number++;
            });
        }

        function loadData() {
            if( vm.selected.length > 0) {
                vm.tableSelectOptions = new TableSelectOptions();
                closeBottomSheet();
            }

            if (vm.pageOfTranslations.number) {
                vm.loadPageOfTranslations(vm.pageOfTranslations.number);
            } else {
                vm.loadPageOfTranslations(1);
            }
        }

        function onMouseEnter(translationRow, lang) {
            vm.cellWithMouseOver = new TranslationCellIndex(translationRow.code, lang);
        }

        function isMouseOver(translationRow, lang) {
            return vm.cellWithMouseOver && vm.cellWithMouseOver.code === translationRow.code && vm.cellWithMouseOver.lang === lang;
        }

        function isCellEdited(translationRow, lang) {
            return vm.editedCell && vm.editedCell.code === translationRow.code && vm.editedCell.lang === lang;
        }

        function editCell(translationRow, lang) {
            vm.editedCell = new TranslationCellIndex(translationRow.code, lang);
            vm.editedValue = translationRow[lang];
        }

        function cancelEdition() {
            vm.editedCell = null;
        }

        function saveTranslation(translationRow, lang) {
            TranslationsService.save(translationRow.code, lang, vm.editedValue).then(function () {
                vm.editedCell = null;
                translationRow[lang] = vm.editedValue;
            }, function (errResponse) {
                PlagiatValidationService.getModalError(errResponse);
            });
        }

        function TranslationCellIndex(code, lang) {
            return {
                code: code,
                lang: lang
            };
        }

        function toggleSelection(total) {
            if(!vm.tableSelectOptions.selectedAll) {
                selectRows(vm.translations);
            }
            vm.tableSelectOptions.selectedAll = !vm.tableSelectOptions.selectedAll;
            vm.tableSelectOptions.selectedNo = total;
            if( !vm.tableSelectOptions.selectedAll ) {
                closeBottomSheet();
            }
        }

        function deSelectRow() {
            if( vm.selected.length === 0) {
                closeBottomSheet();
            }
        }

        function selectRow(pickedId) {
            if( vm.selected.length === 1) {
                openBottomSheet();
            }
            angular.forEach(vm.translations, function (value) {
                if (value.id === pickedId) {
                    if (vm.tableSelectOptions.selectedHelper.indexOf(pickedId) === -1) {
                        vm.tableSelectOptions.selectedHelper.push(value);
                    }
                }
            });
        }

        function selectRows(obj) {
            angular.forEach(obj, function (value) {
                if (vm.selected.indexOf(value.id) === -1) {
                    vm.selected.push(value.id);
                }
            })
        }

        function closeBottomSheet() {
            vm.selected.length = 0;
            vm.tableSelectOptions = new TableSelectOptions();
            $mdBottomSheet.hide();
        }

        function openBottomSheet() {
            $mdBottomSheet.show({
                templateUrl: 'app/account/translations/translations-bottom-sheet.html',
                controllerAs: 'bottomSheet',
                parent: angular.element(document.getElementById('translations')),
                controller: function GridBottomSheetCtrl(){
                    var bottomSheet = this;
                    bottomSheet.checked = true;
                    bottomSheet.closeBottomSheet = vm.closeBottomSheet;
                    bottomSheet.selected = vm.selected;
                    bottomSheet.tableSelectOptions = vm.tableSelectOptions;
                    bottomSheet.total = vm.totalTranslations;
                    bottomSheet.toggleSelection = vm.toggleSelection;
                    bottomSheet.remove = vm.removeTranslations;
                    bottomSheet.generateReportXls = vm.generateReportXls;
                },
                isLockedOpen: true,
                disableParentScroll: false,
                disableBackdrop: true
            });
        }

        function prepareMassActions() {
            vm.deferred = $q.defer();
            vm.tableSelectOptions.ids.length = 0;
            vm.tableSelectOptions.selectedNo = vm.tableSelectOptions.selectedAll ? vm.tableSelectOptions.selectedNo : vm.selected.length;
            angular.forEach(vm.tableSelectOptions.selectedHelper, function (value) {
                vm.tableSelectOptions.ids.push(value.id);
            });

            vm.deferred.resolve(vm.tableSelectOptions);
            return vm.deferred.promise;
        }

        function removeTranslations(){
            prepareMassActions().then(function(){
                var TRANSLATION_REMOVE_PREFIX = 'translations.remove';
                ModalService.showConfirmModal(TRANSLATION_REMOVE_PREFIX).then( function (){
                    vm.isLoaderActive = true;
                    TranslationsService.removeTranslations(vm.selected).then(function () {
                        vm.isLoaderActive = false;
                        closeBottomSheet();
                        loadData();
                        ModalService.showSuccessModal();
                    }).catch(function (response) {
                        PlagiatValidationService.getModalError(response.data);
                    });
                });
            });
        }

        function generateReportXls(){
            prepareMassActions().then(function(response){
                TranslationsService.generateReportXls(response, vm.selected, vm.searchRequest, vm.languageSelection);
            });
        }
    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .constant('TRANSLATION_TYPES', [
        {'id': 0, 'key': 'translations.search.type.2017' },
        {'id': 2, 'key': 'translations.search.type.new'  },
        {'id': 3, 'key': 'translations.search.type.asap3' }
    ]).constant('TRANSLATION_TYPES_ADD', [
        {'id': 0, 'key': 'translations.search.type.2017' },
        {'id': 3, 'key': 'translations.search.type.asap3' }
    ])
    ;
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .controller('TranslationImportController', TranslationImportController);

    TranslationImportController.$inject = ['JhiLanguageService', 'Utils',
        'TranslationsService', 'ModalService',
        '$state'];

    function TranslationImportController(JhiLanguageService, Utils,
        TranslationsService, ModalService,
        $state
    ) {
        var vm = this;

        vm.availableLanguages;
        vm.availableExtensions = '.xls,.xlsx';
        vm.files = null;
        vm.data = null;
        vm.duplicates = null;
        vm.conflictingExternalTranslationCodes = null;
        vm.isLoaderActive = false;
        vm.isLoading = false;
        vm.getTheFiles = getTheFiles;
        vm.uploadFile = uploadFile;
        vm.removeTranslationRow = removeTranslationRow;
        vm.saveImportedTranslations = saveImportedTranslations;

        this.$onInit = function () {
            initAvailableLanguages();
        };

        function getTheFiles($files, $invalidFiles) {
            if ($files === null) {
                vm.files = null;
            } else {
                if ($invalidFiles.length === 0) {
                    var formData = new FormData();
                    vm.files = $files;
                    angular.forEach(vm.files, function (value, key) {
                        vm.fileName = Utils.removeSpecialCharsForFileName(
                            value.name);
                        formData.append(key, value);
                    });
                    if (vm.files.length > 0) {
                        vm.uploadFile(formData, vm.fileName);
                    }
                }
            }
        }

        function uploadFile(obj, filename) {
            vm.isLoaderActive = true;

            TranslationsService.uploadTranslationsFile(obj, filename).then(
                function (responseData) {
                    vm.isLoaderActive = false;
                    vm.data = responseData.data;
                    vm.availableLanguages = vm.data.langs;
                    vm.duplicates = vm.data.duplicates;
                    vm.conflictingExternalTranslationCodes = vm.data.conflictingExternalTranslationCodes;
                }, function (errorResponse) {
                    vm.isLoaderActive = false;
                    ModalService.showErrorModal(errorResponse);
                });
        }

        function removeTranslationRow(row) {
            var filteredAry = vm.data.data.filter(function (e) {
                return e !== row
            });
            vm.data.data = filteredAry;
        }

        function saveImportedTranslations() {
            vm.isLoaderActive = true;

            TranslationsService.saveImportedTranslations(vm.data).then(
                function () {
                    vm.isLoaderActive = false;
                    vm.data = null;
                    vm.availableLanguages = ["en"];
                    vm.duplicates = null

                    ModalService.showSuccessModal().then(
                        function () {
                            $state.go("translations");
                        }, function () {
                            $state.go("translations");
                        });
                }, function (errorResponse) {
                    vm.isLoaderActive = false;
                    ModalService.showErrorModal(errorResponse);
                });
        }

        function initAvailableLanguages() {
            JhiLanguageService.getAll().then(function (allLanguages) {
                vm.availableLanguages = allLanguages.data.availableLanguages;
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('TranslationEditController', TranslationEditController);

    function TranslationEditController(
        $mdDialog, JhiLanguageService, DocumentKindService, $q,
        $stateParams, OrppdService, code, $rootScope, ModalService,
        TranslationModel, TranslationsService, TRANSLATION_TYPES, TRANSLATION_TYPES_ADD
    ) {
        var vm = this;

        vm.code = code;
        vm.translationTypes = TRANSLATION_TYPES;
        vm.obj;
        vm.availableLanguages;

        this.$onInit = function () {
            if (code) {
                find();
            } else {
                vm.obj = new TranslationModel();
                vm.obj.type = 0;
                vm.translationTypes = TRANSLATION_TYPES_ADD;
            }
            initAvailableLanguages();
        };

        function find() {
            vm.pending = true;
            TranslationsService.findOne(code).then(
                function (response) {
                    vm.pending = false;
                    vm.obj = response.data;
                    vm.initialCode = vm.obj.code;
                    vm.isAtLeastOneTranslationFilledEngine();
                }, function (errorResponse) {
                    vm.pending = false;
                    $mdDialog.cancel();
                    ModalService.showErrorModal(errorResponse);
                }
            );
        }

        function initAvailableLanguages() {
            JhiLanguageService.getAllWithAdditional().then(function (allLanguages) {
                vm.availableLanguages = allLanguages.data.availableLanguages;
            });
        }

        vm.closeDialog = function () {
            $mdDialog.cancel();
            $rootScope.$broadcast('on-close-modal-translation-edit');
        };

        /**
         * calculates if at least one translation is filled
         */
        vm.isAtLeastOneTranslationFilledEngine = function () {
            for (var i = 0; i < vm.availableLanguages.length; i++) {
                var lang = vm.availableLanguages[i];
                if (vm.obj[lang]) {
                    vm.isAtLeastOneTranslationFilled = true;
                    return;
                }
            }
            vm.isAtLeastOneTranslationFilled = false;
        };

        vm.saveOrUpdate = function (form) {
            if (form.$invalid || form.$pending) {
                for (var i = 0; i < form.$$controls.length; i++) {
                    form.$$controls[i].$touched = true;
                }
                return;
            }
            vm.pending = true;
            TranslationsService
                .saveOrUpdate(vm.obj)
                .then(function () {
                        vm.pending = false;
                        $mdDialog.hide();
                        ModalService.showSuccessModal("global.messages.success.label");
                        $rootScope.$broadcast('on-close-modal-translation-edit');
                    }, function (errorResponse) {
                        vm.pending = false;
                        ModalService.showErrorModal(errorResponse);
                    }
                );
        };
    }

})();

angular.module('plagiat2017App').directive('translationCodeValidator', function ($http, $q, $timeout, TranslationsService) {
    return {
        restrict: "A",
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
            ngModel.$asyncValidators.translationCodeExist = function (modelValue, viewValue) {
                var initialValue = scope.$eval(attrs.translationCodeValidator);
                if (viewValue == initialValue) {
                    return $q.resolve();
                }

                return TranslationsService.findOne(viewValue).then(
                    function (response) {
                        if (response.data && response.data.id) {
                            return $q.reject();
                        } else {
                            return $q.resolve();
                        }
                    }
                );
            };
            ngModel.$asyncValidators.conflictingExternalTranslationCode = function (modelValue, viewValue) {
                if (viewValue === scope.$eval(attrs.translationCodeValidator)) {
                    return $q.resolve();
                }
                return TranslationsService.hasConflictingExternalTranslationCodes(viewValue).then(
                    function (response) {
                        if (response.data) {
                            return $q.reject();
                        } else {
                            return $q.resolve();
                        }
                    }
                );
            };
        }
    };
});

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('TranslationModel', TranslationModel);
    TranslationModel.$inject = ['JhiLanguageService'];

    function TranslationModel(JhiLanguageService) {
        function Model() {
            this.id = null;
            this.code = null;
            generateTranslations(this);
        }

        function generateTranslations(model) {
            JhiLanguageService.getAll().then(function (allLanguages) {
                allLanguages.data.availableLanguages.forEach(function (lang) {
                    model[lang] = null;
                });
            });
        }

        return Model;
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('TranslationHistoryController', TranslationHistoryController);

    function TranslationHistoryController(
        code, lang, $mdDialog, JhiLanguageService, DocumentKindService, $q,
        $stateParams, OrppdService, $rootScope, ModalService,
        TranslationModel, TranslationsService
    ) {
        var vm = this;

        vm.code = code;
        vm.lang = lang;
        vm.obj;
        vm.selectedStepIndex;
        vm.availableLanguages;
        vm.order = {};

        this.$onInit = function () {
            find();
            initAvailableLanguages();
        };

        function find() {
            vm.pending = true;
            TranslationsService.findHistory(code).then(
                function (response) {
                    vm.pending = false;
                    vm.obj = response.data;
                }, function (errorResponse) {
                    vm.pending = false;
                    $mdDialog.cancel();
                    ModalService.showErrorModal(errorResponse);
                }
            );
        }

        function initAvailableLanguages() {
            JhiLanguageService.getAll().then(function (allLanguages) {
                vm.availableLanguages = allLanguages.data.availableLanguages;
                vm.selectedStepIndex = vm.availableLanguages.indexOf(vm.lang);
                for (var i = 0; i < vm.availableLanguages.length; i++) {
                    vm.order[vm.availableLanguages[i]] = '-createDate';
                }
            });
        }

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('socialLoginButton', socialLoginButton);

    socialLoginButton.$inject = ['$translatePartialLoader', '$translate', '$filter', '$timeout', 'SSO_LOGIN_DATA'];

    function socialLoginButton($translatePartialLoader, $translate, $filter, $timeout, SSO_LOGIN_DATA) {
        var directive = {
            restrict: 'E',
            scope: {
                provider: '@ngProvider',
                disabled: '=ngDisabled',
                title: '@ngTitle',
                onButtonClick: '&'
            },
            templateUrl: 'app/account/social/social-login-button/social-login-button.html',
            link: linkFunc
        };

        return directive;

        /* private helper methods */

        function linkFunc(scope) {

            $translate.refresh();

            scope.click = function() {
                scope.onButtonClick()(scope.provider);
            };

            scope.titles = SSO_LOGIN_DATA;

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('landingSocialLogin', landingSocialLogin);

    landingSocialLogin.$inject = ['$translatePartialLoader', '$translate'];

    function landingSocialLogin($translatePartialLoader, $translate) {
        var directive = {
            restrict: 'E',
            scope: {
                provider: '@ngProvider',
                disabled: '=ngDisabled',
                onButtonClick: '&'
            },
            templateUrl: 'app/account/social/landing-social-login/landing-social-login.html',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope) {

            $translate.refresh();

            scope.click = function() {
                scope.onButtonClick()(scope.provider);
            };
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('TagsListController', TagsListController);
    
    TagsListController.$inject = ['TagsService', 'ModalService', 'SearchRequest', 'QueryRequest',
        'SIMPLE_SEARCH_DELAY', '$localStorage'];

    function TagsListController(TagsService, ModalService, SearchRequest, QueryRequest,
                                    SIMPLE_SEARCH_DELAY, $localStorage) {
        var vm = this;
        vm.activeTab = 'tags';
        vm.pending = false;
    
        vm.loadData = loadData;
        vm.loadPage = loadPage;
        vm.transformTagChip = transformTagChip;
        vm.onChangeChip = onChangeChip;
        vm.onRemoveChip = onRemoveChip;
        vm.saveTags = saveTags;

        vm.keyCodeEnter = KeyCode.KEY_RETURN;
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.queryRequest = new QueryRequest();
        vm.searchRequest = new SearchRequest();
        vm.tags = [];
        vm.tagsPage = {};
    
        this.$onInit = function () {
            vm.queryRequest.limit = $localStorage.tagsLimit ? $localStorage.tagsLimit : vm.queryRequest.limit;
            vm.searchRequest.sortTab = ['id,desc'];
            vm.loadData();
        };

        function saveTags(tagGroup) {
            vm.pending = true;
            TagsService
                .saveOrUpdateTags(tagGroup)
                .then(function (result) {
                    vm.pending = false;
                    ModalService.showSuccessModal("global.messages.success.label");
                    tagGroup.changesMade = false;
                    tagGroup.tags = result.data.tags;
                }, function (errorResponse) {
                    vm.pending = false;
                    ModalService.showErrorModal(errorResponse);
                });
        }

        function transformTagChip(chip, row) {

            if (row.tags) {
                row.tags = row.tags.slice(0); // workaround na bug w md-chips
            }

            const chipObj = {name: chip};
            if (row.tags.indexOf(chipObj) < 0) {
                row.tags.push(chipObj);
                row.changesMade = true;
            }

            return null;
        }

        function onChangeChip(row) {
            row.changesMade = true;
        }

        function onRemoveChip(chip, row) {
            row.changesMade = true;
        }

        function loadData() {
            if (vm.tagsPage.number) {
                vm.loadPage(vm.tagsPage.number);
            } else {
                vm.loadPage(1);
            }
        }

        function loadPage(pageNumber) {
            vm.searchRequest.pageNumber = pageNumber - 1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            $localStorage.tagsLimit = vm.queryRequest.limit;
            vm.pending = true;
            TagsService.searchTagGroups(vm.searchRequest).then(function (tagsPage) {
                vm.pending = false;
                vm.tagsPage = tagsPage;
                vm.tags = tagsPage.content;
                vm.tagsPage.number++;
                vm.queryRequest.page = vm.tagsPage.number;
            });
        }
    
    }
})();

(function () {
    'use strict';
    
    angular
        .module('plagiat2017App')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider'];
    
    function stateConfig($stateProvider) {
        $stateProvider
            .state('tags-list', {
                parent: 'account',
                url: '/tags-list',
                data: {
                    authorities: ['PERM_USER_ADMIN'],
                    pageTitle: 'tags.edit.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/settings/tags/tags-list.template.html',
                        controller: 'TagsListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('users');
                        $translatePartialLoader.addPart('tags');
                        return $translate.refresh();
                    }]
                }
            })
            .state("tag-group-add", {
                parent: "tags-list",
                url: "/add-edit/:id",
                data: {
                    authorities: ['PERM_USER_ADMIN'],
                    pageTitle: 'tags.edit.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/settings/tags/tag-group-add.template.html',
                        controller: 'TagGroupAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('users');
                        $translatePartialLoader.addPart('tags');
                        return $translate.refresh();
                    }]
                }
            })
        ;
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('TagsService', TagsService);
    
    TagsService.$inject = ['$http', '$q'];

    function TagsService($http, $q) {

        var service = {
            searchTagGroups: searchTagGroups,
            getTagGroupForEditing: getTagGroupForEditing,
            saveOrUpdateTagGroup: saveOrUpdateTagGroup,
            saveOrUpdateTags: saveOrUpdateTags
        };
        var requestUrl = 'api/tags';
        return service;

        function getTagGroupForEditing(id) {
            return $http.get(requestUrl + '/tag-group/for-editing/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function saveOrUpdateTagGroup(obj) {
            return $http.post(requestUrl + '/tag-group/save-or-update', obj).then(
                function () {},
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function saveOrUpdateTags(obj) {
            return $http.post(requestUrl + '/tag/save-or-update', obj).then(
                function () {},
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function searchTagGroups(searchRequest) {
            return $http.post(requestUrl + '/tag-group/search', searchRequest).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('TagGroupAddController', TagGroupAddController);
    
    TagGroupAddController.$inject = ['TagsService', 'ModalService',
        '$localStorage', '$state', '$stateParams'];

    function TagGroupAddController(TagsService, ModalService,
        $localStorage, $state, $stateParams) {
        var vm = this;
        vm.pending = false;
        vm.activeTab = 'tags';
        
        vm.obj = {};
        vm.saveOrUpdate = saveOrUpdate;

        this.$onInit = function () {
            vm.pending = true;

            if ($stateParams.id) {
                TagsService.getTagGroupForEditing($stateParams.id).then(function (obj) {
                    vm.obj = obj.data;
                });
            }
            vm.pending = false;
        };
    
        function saveOrUpdate() {
            TagsService
                .saveOrUpdateTagGroup(vm.obj)
                .then(function () {
                    vm.obj = null;
                    ModalService.showSuccessModal("global.messages.success.label");
                    $state.go('tags-list');
                    $stateParams.id = null;
                }, function (errorResponse) {
                    ModalService.showErrorModal(errorResponse);
                });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('system-administration', {
            parent: 'account',
            url: '/system-administration',
            data: {
                pageTitle: 'global.menu.settings.system-administration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/system-administration/system-administration.html',
                    controller: 'SystemAdministrationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('system-administration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('SystemAdministrationController', SystemAdministrationController);

    SystemAdministrationController.$inject = ['JsaService', 'ModalService', 'DetectInstanceService'];

    function SystemAdministrationController(JsaService, ModalService, DetectInstanceService) {
        var vm = this;

        vm.synchronizePolonUnitsButtonDisabled = false;
        vm.activeTab = 'systemAdministration';
        vm.jsaCardEnabled = DetectInstanceService.instance() === 'pl';

        vm.synchronizePolonUnits = function () {
            ModalService.showConfirmModal('system-administration.jsa.synchronize-polon-institutions.confirm').then(
                function () {
                    JsaService.synchronizeInstitutions().then(function () {
                        ModalService.showSuccessModal('system-administration.jsa.synchronize-polon-institutions.in-progress');
                        vm.synchronizePolonUnitsButtonDisabled = true;
                    });
                }
            )
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('similarity-report-settings', {
            parent: 'account',
            url: '/similarity-report-settings',
            data: {
                authorities: ['PERM_USER_ADMIN'],
                pageTitle: 'global.menu.account.similarity.report.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/similarity-report-settings/similarity-report-settings.html',
                    controller: 'SimilarityReportSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('similarity');
                    $translatePartialLoader.addPart('users');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('SimilarityReportSettingsController', SimilarityReportSettingsController);

    SimilarityReportSettingsController.$inject = ['SimilarityReportSettingsService', 'PlagiatValidationService', '$mdDialog', 'AccountService', '$translate'];

    function SimilarityReportSettingsController (SimilarityReportSettingsService, PlagiatValidationService, $mdDialog, AccountService, $translate) {
        var vm = this;
        vm.activeTab = 'similarityReportSettings';
        vm.editing = false;
        vm.editState = editState;
        vm.cancelSaving = cancelSaving;
        vm.getForm = getForm;
        vm.save = save;
        vm.clientId = AccountService.account.clientId;
        getForm(vm.clientId);
        
        function editState(){
        	vm.editing = true;
        }
        
        function cancelSaving(){
        	vm.editing = false;
        	getForm(vm.clientId);
        }
        
        function getForm(clientId){
        	SimilarityReportSettingsService.getForm(clientId).then(function(response){
        		vm.form = response.data;
        	})
        }
        
        function save(form, ev){
        	SimilarityReportSettingsService.edit(form).then(function(){
        		vm.editing = false;

                $mdDialog.show(
                        $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .title('')
                        .textContent($translate.instant("similarity.report.settings.edit.msg"))
                        .ariaLabel('msgSuccess')
                        .ok('Ok')
                        .targetEvent(ev)
                        );
        	}, function(response){
        		PlagiatValidationService.getModalError(response.data);
        	})
        }
    }
})();

(function () {
    'use strict';

    SettingsMenuController.$inject = ['AccountService'];

    function SettingsMenuController(AccountService) {
        var vm = this;
        vm.isAdmin = AccountService.role.isAdmin();
        vm.isSuperAdmin = AccountService.role.isSuperAdmin();
        vm.jsa = AccountService.getClientSettings().jsaIntegration;
        vm.tagsEnabled = AccountService.getClientSettings().tagsEnabled;
        vm.orppdIntegration = AccountService.getClientSettings().orppdIntegration;
    }

    angular.module('plagiat2017App')
    .component('settingsMenu', {
        templateUrl: 'app/account/settings/settings-menu/settings-menu.template.html',
        controller: SettingsMenuController,
        bindings: {
        	activeTab: '<'
        }
    });

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['PERM_USER_ADMIN', 'PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function () {
    'use strict';
    
    angular
        .module('plagiat2017App')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider'];
    
    function stateConfig($stateProvider) {
        $stateProvider
            .state('protocol-list', {
                parent: 'account',
                url: '/protocol-list',
                data: {
                    authorities: ['PERM_USER_SUPERADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/settings/protocols/protocol-list.template.html',
                        controller: 'ProtocolListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('users');
                        $translatePartialLoader.addPart('protocol');
                        return $translate.refresh();
                    }]
                }
            })
            .state("protocol-add", {
                parent: "protocol-list",
                url: "/add-edit/:id",
                data: {
                    authorities: ['PERM_USER_SUPERADMIN'],
                    pageTitle: 'protocol.edit.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/settings/protocols/protocol-add.template.html',
                        controller: 'ProtocolAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('users');
                        $translatePartialLoader.addPart('protocol');
                        return $translate.refresh();
                    }]
                }
            })
        ;
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ProtocolsService', ProtocolsService);
    
    ProtocolsService.$inject = ['$http', '$q'];

    function ProtocolsService($http, $q) {

        var service = {
            search: search,
            getProtocolForEditing: getProtocolForEditing,
            getProtocolParameters: getProtocolParameters,
            remove: remove,
            duplicate: duplicate,
            saveOrUpdate: saveOrUpdate
        };
        var requestUrl = 'api/protocols';
        return service;

        function getProtocolForEditing(id) {
            return $http.get(requestUrl + '/for-editing/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function getProtocolParameters() {
            return $http.get(requestUrl + '/parameters').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function saveOrUpdate(obj) {
            return $http.post(requestUrl + '/save-or-update', obj).then(
                function () {},
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function search(searchRequest) {
            return $http.post(requestUrl + '/search', searchRequest).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function remove(id) {
            return $http.get(requestUrl + '/remove?id=' + id).then(
                function () {},
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function duplicate(id) {
            return $http.get(requestUrl + '/duplicate?id=' + id).then(
                function () {},
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ProtocolListController', ProtocolListController);
    
    ProtocolListController.$inject = ['ProtocolsService', 'ModalService', 'SearchRequest', 'QueryRequest',
        'SIMPLE_SEARCH_DELAY', '$localStorage'];

    function ProtocolListController(ProtocolsService, ModalService, SearchRequest, QueryRequest,
                                    SIMPLE_SEARCH_DELAY, $localStorage) {
        var vm = this;
        vm.activeTab = 'protocolList';
        vm.pending = false;
    
        vm.loadData = loadData;
        vm.loadPage = loadPage;
        vm.remove = remove;
        vm.duplicate = duplicate;
        
        vm.keyCodeEnter = KeyCode.KEY_RETURN;
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.queryRequest = new QueryRequest();
        vm.searchRequest = new SearchRequest();
        vm.protocols = [];
        vm.protocolPage = {};
    
        this.$onInit = function () {
            vm.queryRequest.limit = $localStorage.protocolLimit ? $localStorage.protocolLimit : vm.queryRequest.limit;
            vm.searchRequest.sortTab = ['id,desc'];
            vm.loadData();
        };

        function loadData() {
            if (vm.protocolPage.number) {
                vm.loadPage(vm.protocolPage.number);
            } else {
                vm.loadPage(1);
            }
        }

        function loadPage(pageNumber) {
            vm.searchRequest.pageNumber = pageNumber - 1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            $localStorage.protocolLimit = vm.queryRequest.limit;
            vm.pending = true;
            ProtocolsService.search(vm.searchRequest).then(function (protocolPage) {
                vm.pending = false;
                vm.protocolPage = protocolPage;
                vm.protocols = protocolPage.content;
                vm.protocolPage.number++;
                vm.queryRequest.page = vm.protocolPage.number;
            });
        }
    
        function remove(obj) {
            ProtocolsService
                .remove(obj.id)
                .then(function () {
                    vm.obj = null;
                    ModalService.showSuccessModal("global.messages.success.label");
                    loadData();
                }, function (errorResponse) {
                    ModalService.showErrorModal(errorResponse);
                });
        }
    
        function duplicate(obj) {
            ProtocolsService
                .duplicate(obj.id)
                .then(function () {
                    vm.obj = null;
                    ModalService.showSuccessModal("global.messages.success.label");
                    loadData();
                }, function (errorResponse) {
                    ModalService.showErrorModal(errorResponse);
                });
        }
    
    
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ProtocolAddController', ProtocolAddController);
    
    ProtocolAddController.$inject = ['ProtocolsService', 'ModalService',
        '$localStorage', '$state', '$stateParams', 'ClientService', 'DocumentParameterDefinitionsService'];

    function ProtocolAddController(ProtocolsService, ModalService,
        $localStorage, $state, $stateParams, ClientService, DocumentParameterDefinitionsService) {
        var vm = this;
        vm.pending = false;
        vm.activeTab = 'protocolList';
        vm.availableDocumentParameterDefinitions = [];
        vm.selectedDocumentParameterDefinitionId = null;

        vm.obj = {};
        vm.parameters = [];
        vm.methods = [];
        vm.insertSimpleParam = insertSimpleParam;
        vm.insertConditionalParam = insertConditionalParam;
        vm.insertDocumentParameter = insertDocumentParameter;
        vm.saveOrUpdate = saveOrUpdate;
        vm.clientSearch = clientSearch;
        vm.selectedClientChange = selectedClientChange;

        vm.tinymceOptions = {
            plugins: 'link image code fullpage',
            menubar: false,
            height: 400,
            fullpage_default_doctype: '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">',
            doctype : '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">',
            image_list: [
                {title: 'Client Logo', value: 'content/images/client-logo.png'}
            ],
            image_class_list: [
                {title: 'Client Logo - right', value: 'client-logo-right'},
                {title: 'None', value: ''}
            ],
            content_style: '.left { text-align: left; } ' +
                'img.left { float: left; } ' +
                'table.left { float: left; } ' +
                '.right { text-align: right; } ' +
                'img.right { float: right; } ' +
                'table.right { float: right; } ' +
                '.center { text-align: center; } ' +
                'img.center { display: block; margin: 0 auto; } ' +
                'table.center { display: block; margin: 0 auto; } ' +
                '.full { text-align: justify; } ' +
                'img.full { display: block; margin: 0 auto; } ' +
                'table.full { display: block; margin: 0 auto; } ' +
                '.bold { font-weight: bold; } ' +
                '.italic { font-style: italic; } ' +
                '.underline { text-decoration: underline; } ' +
                '.client-logo-right {float: right;} ' +
                '.tablerow1 { background-color: #D3D3D3; }'
            ,
            toolbar: 'undo redo | formatselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | image | removeformat | help | code | fullpage'
        };
        
        this.$onInit = function () {
            vm.pending = true;
            ProtocolsService.getProtocolParameters().then(function (obj) {
                vm.parameters = obj.data.parameters;
                vm.methods = obj.data.methods;
            });
    
            if ($stateParams.id) {
                ProtocolsService.getProtocolForEditing($stateParams.id).then(function (obj) {
                    vm.obj = obj.data;
                });
            }
            vm.pending = false;
        };
    
        function insertSimpleParam() {
            tinymce.activeEditor.execCommand('mceInsertContent', false, 
                "${" + vm.simpleParam + "}"
            );
        }
    
        function insertConditionalParam() {
            tinymce.activeEditor.execCommand('mceInsertContent', false, 
                "{boxSelectedIf " + vm.conditionalParam + " " + vm.conditionalParamMethod + " " + vm.conditionalParamValue + "}"
            );
        }

        function insertDocumentParameter() {
            tinymce.activeEditor.execCommand('mceInsertContent', false,
                "${document.parameter." + vm.selectedDocumentParameterDefinitionId + "}"
            );
        }
    
        function saveOrUpdate() {
            if (vm.obj && vm.obj.htmlTemplate) {
                vm.obj.htmlTemplate = vm.obj.htmlTemplate.replace('class="client-logo-right"', 'style="float:right;"');
            }
            ProtocolsService
                .saveOrUpdate(vm.obj)
                .then(function () {
                    vm.obj = null;
                    ModalService.showSuccessModal("global.messages.success.label");
                    $state.go('protocol-list');
                    $stateParams.id = null;
                }, function (errorResponse) {
                    ModalService.showErrorModal(errorResponse);
                });
        }

        function clientSearch(query) {
            return ClientService.searchClients({pageSize: 10, simpleSearch: query}).then(function(response) {
                return response.content;
            })
        }

        function selectedClientChange(client) {
            if (!client) {
                vm.availableDocumentParameterDefinitions = [];
                vm.selectedDocumentParameterDefinitionId = null;
            }
            DocumentParameterDefinitionsService.getAllDocumentParameterDefinitionsForClient(client.id).then(function (response) {
                vm.availableDocumentParameterDefinitions = response;
            })
        }
    
    }
})();

(function() {
    'use strict';
    
    function PopupDetailsController(
        PopupAdministrationService, $state, USERROLES, POPUP_OPTIONS
    ) {
        var vm = this;
        vm.roles = USERROLES.SUPERADMIN;
        vm.options = POPUP_OPTIONS;
    }
    
    angular
        .module('plagiat2017App')
        .component(
            'popupDetails',
            {
                templateUrl : 'app/account/settings/popup/popup-detail/popup-detail.template.html',
                controller : PopupDetailsController,
                bindings: {
                    popup: '<'
                }
            }
        );
    
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('PopupAdministrationAddController', PopupAdministrationAddController);

    PopupAdministrationAddController.$inject = ['PopupAdministrationService', 'ModalService', 'SearchRequest', 'QueryRequest',
        'USERROLES', 'POPUP_OPTIONS', '$localStorage', '$state', '$stateParams'];

    function PopupAdministrationAddController(PopupAdministrationService, ModalService, SearchRequest, QueryRequest, 
        USERROLES, POPUP_OPTIONS, $localStorage, $state, $stateParams) {
        var vm = this;
        vm.activeTab = 'popupAdministration';
        
        vm.obj = {};
        vm.roles = USERROLES.SUPERADMIN;
        vm.options = POPUP_OPTIONS;
        vm.saveOrUpdate = saveOrUpdate;
        
        this.$onInit = function () {
            if ($stateParams.id) {
                PopupAdministrationService.getPopupForEditing($stateParams.id).then(function (obj) {
                    vm.obj = obj.data;
                    if (vm.obj.dateFrom) {
                        vm.obj.dateFrom = new Date(vm.obj.dateFrom);
                    }
                    if (vm.obj.dateTo) {
                        vm.obj.dateTo = new Date(vm.obj.dateTo);
                    }
                });
            } else {
                vm.obj.dateFrom = new Date();
            }
        };

        function saveOrUpdate() {
            PopupAdministrationService
                .saveOrUpdate(vm.obj)
                .then(function () {
                    vm.obj = null;
                    ModalService.showSuccessModal("global.messages.success.label");
                    $state.go('popup-administration');
                    $stateParams.id = null;
                }, function (errorResponse) {
                    ModalService.showErrorModal(errorResponse);
                });
        }
    
    }
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('popup-administration', {
            parent: 'account',
            url: '/popup-administration',
            data: {
                authorities: ['PERM_USER_SUPERADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/popup/popup-administration.template.html',
                    controller: 'PopupAdministrationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('popup');
                    return $translate.refresh();
                }]
            }
        })
        .state("popup-administration-add", {
            parent: "popup-administration",
            url: "/add-edit/:id",
            data: {
                authorities: ['PERM_USER_SUPERADMIN'],
                pageTitle: 'popup.popup-administration.add.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/popup/popup-administration-add.template.html',
                    controller: 'PopupAdministrationAddController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('popup');
                    return $translate.refresh();
                }]
            }
        })
        ;
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('PopupAdministrationService', PopupAdministrationService);

    PopupAdministrationService.$inject = ['$http', '$q'];

    function PopupAdministrationService($http, $q) {

        var service = {
            orderContactByRegularPopup: orderContactByRegularPopup,
            search: search,
            findAllToShowForCurrentUser: findAllToShowForCurrentUser,
            remove: remove,
            switchOff: switchOff,
            copy: copy,
            getPopupForEditing: getPopupForEditing,
            saveOrUpdate: saveOrUpdate
        };
        var requestUrl = 'api/popup';
        return service;

        function orderContactByRegularPopup(id, telephone) {
            return $http.post(requestUrl + '/order-contact', {id: id, telephone: telephone}).then(
                function () {},
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getPopupForEditing(id) {
            return $http.get(requestUrl + '/for-editing/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function remove(id) {
            return $http.get(requestUrl + '/remove?id=' + id).then(
                function () {},
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function switchOff(id) {
            return $http.get(requestUrl + '/switch-off?id=' + id).then(
                function () {},
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function copy(id) {
            return $http.get(requestUrl + '/copy?id=' + id).then(
                function () {},
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function saveOrUpdate(obj) {
            return $http.post(requestUrl + '/save-or-update', obj).then(
                function () {},
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function search(searchRequest) {
            return $http.post(requestUrl + '/search', searchRequest).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function findAllToShowForCurrentUser() {
            return $http.post(requestUrl + '/all-to-show-for-current-user').then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('PopupAdministrationController', PopupAdministrationController);

    PopupAdministrationController.$inject = ['PopupAdministrationService', 'ModalService', 'SearchRequest', 'QueryRequest',
        '$localStorage'];

    function PopupAdministrationController(PopupAdministrationService, ModalService, SearchRequest, QueryRequest, $localStorage) {
        var vm = this;
        vm.activeTab = 'popupAdministration';
        vm.remove = remove;
        vm.switchOff = switchOff;
        vm.copy = copy;
        vm.getDetails = getDetails;
    
        vm.keyCodeEnter = KeyCode.KEY_RETURN;
        vm.queryRequest = new QueryRequest();
        vm.searchRequest = new SearchRequest();
        vm.pending = false;
        vm.popups = [];
        vm.popupPage = {};
        vm.expandedRow = null;
    
        vm.loadData = loadData;
        vm.loadPage = loadPage;
    
        this.$onInit = function () {
            vm.queryRequest.limit = $localStorage.popupLimit ? $localStorage.popupLimit : vm.queryRequest.limit;
            vm.searchRequest.sortTab = ['id,desc'];
            vm.loadData();
        };

        function loadData() {
            if (vm.popupPage.number) {
                vm.loadPage(vm.popupPage.number);
            } else {
                vm.loadPage(1);
            }
        }

        function loadPage(pageNumber) {
            vm.searchRequest.pageNumber = pageNumber - 1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            $localStorage.popupLimit = vm.queryRequest.limit;
            vm.pending = true;
            PopupAdministrationService.search(vm.searchRequest).then(function (popupPage) {
                vm.pending = false;
                vm.expandedRow = null;
                vm.popupPage = popupPage;
                vm.popups = popupPage.content;
                vm.popupPage.number++;
            });
        }
    
        function getDetails(popup) {
            vm.expandedRow = null;
            PopupAdministrationService.getPopupForEditing(popup.id).then(function (result) {
                vm.details = result.data;
                vm.expandedRow = popup.id;
            });
        }

        function remove(obj) {
            PopupAdministrationService
                .remove(obj.id)
                .then(function () {
                    vm.obj = null;
                    ModalService.showSuccessModal("global.messages.success.label");
                    loadData();
                }, function (errorResponse) {
                    ModalService.showErrorModal(errorResponse);
                });
        }
    
        function switchOff(obj) {
            PopupAdministrationService
                .switchOff(obj.id)
                .then(function () {
                    vm.obj = null;
                    ModalService.showSuccessModal("global.messages.success.label");
                    loadData();
                }, function (errorResponse) {
                    ModalService.showErrorModal(errorResponse);
                });
        }
    
        function copy(obj) {
            PopupAdministrationService
                .copy(obj.id)
                .then(function () {
                    vm.obj = null;
                    ModalService.showSuccessModal("global.messages.success.label");
                    loadData();
                }, function (errorResponse) {
                    ModalService.showErrorModal(errorResponse);
                });
        }
    
    }
})();

(function () {
    'use strict';
    
    angular
        .module('plagiat2017App')
        .constant('POPUP_OPTIONS', [
            {'id': 1, 'key': 'popup.option.dont-show-again'},
            {'id': 2, 'key': 'popup.option.ask-contact'},
            {'id': 4, 'key': 'popup.option.ask-contact-with-tel'}
            ]);
})();
(function () {
    'use strict';

    function OrganisationalUnitsSearchController($scope, $rootScope, $state, $translate, $mdDialog, $log,
    		OrganisationalUnitsService, organisationalUnitsQueryRequest, organisationalUnitsSearchRequest, $localStorage) {
        var vm = this;
        vm.simpleSearch = true;
        vm.getData = getData;
        vm.clear = clear;
        vm.goToAddPage = goToAddPage;
        
        function goToAddPage(){
        	$state.go('organisationalUnitsAddEdit');
        }
        
        function getData(){
            $localStorage.organisationalListLimit = vm.onQueryRequest.limit;
        	vm.onGetData(vm.organisationalUnitsSearchRequest);
		}
        
        function clear() {
            vm.organisationalUnitsSearchRequest = new organisationalUnitsSearchRequest();
            getData();
        }

    }

    angular.module('plagiat2017App')
            .component('organisationalUnitsSearch', {
                templateUrl: 'app/account/settings/organisational-units/organisational-units-search/organisational-units-search.template.html',
                controller: OrganisationalUnitsSearchController,
                bindings: {
                    onGetData: '<',
                    onQueryRequest: '=',
                    onSearchData: '='
                }
            });

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('organisational-units', {
            parent: 'account',
            url: '/organisational-units',
            data: {
                authorities: ['PERM_USER_ADMIN'],
                pageTitle: 'global.menu.account.organisational.units'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/organisational-units/organisational-units-list/organisational-units.html',
                    controller: 'OrganisationalUnitsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('organisational.units');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('OrganisationalUnitsController', OrganisationalUnitsController);

    OrganisationalUnitsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate',
    	'organisationalUnitsQueryRequest', 'organisationalUnitsSearchRequest', 'tableSettingsRequest',
    	'OrganisationalUnitsService', 'SearchService', '$mdDialog', 'PlagiatValidationService', '$localStorage',
        'AccountService'];

    function OrganisationalUnitsController (Principal, Auth, JhiLanguageService, $translate,
    		organisationalUnitsQueryRequest, organisationalUnitsSearchRequest, tableSettingsRequest,
    		OrganisationalUnitsService, SearchService, $mdDialog, PlagiatValidationService, $localStorage,
                                            AccountService) {
        var vm = this;
        vm.activeTab='organisationalUnits';
        vm.queryRequest = new organisationalUnitsQueryRequest();
        vm.doesClientHaveJsaIntegration = AccountService.getClientSettings().jsaIntegration;
        vm.queryRequest.limit = $localStorage.organisationalListLimit ? $localStorage.organisationalListLimit : vm.queryRequest.limit;
        vm.searchRequest = new organisationalUnitsSearchRequest();
        vm.options = new tableSettingsRequest();
        vm.selected = [];
        vm.pickedIds = [];
        vm.startPaging = startPaging;
        vm.prepareMapping = prepareMapping;
        vm.getData = getData;
        vm.removeItems = removeItems;
        prepareMapping();

        function prepareMapping(){
        	getData(vm.organisationalUnitsSearchRequest);
        }

        function getData(organisationalUnitsSearchRequest){
            vm.selected.length = 0;
            vm.showDetailsBlock = false;
            vm.organisationalUnitsSearchRequest = organisationalUnitsSearchRequest;
            vm.searchRequest.pageNumber = (vm.queryRequest.page - 1);
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.sortTab = SearchService.sort(vm.queryRequest);

            vm.isLoadingData = true;
            OrganisationalUnitsService.getList(vm.searchRequest).then(function (responseData) {

                vm.organisationalUnits = responseData.content;
                vm.totalElements = responseData.totalElements;

                vm.isLoadingData = false;
            });
        }

        function startPaging(page) {
         	vm.isLoadingData = true;
             vm.queryRequest.page = page;
             prepareMapping();
         }

        function transformSelectedObj() {
            vm.pickedIds.length = 0;
            angular.forEach(vm.selected, function (value) {
                vm.pickedIds.push(value.id);
            });
        }

        function removeItems(ev) {
            var confirm = $mdDialog.confirm()
            .title($translate.instant("global.confirmremove"))
            .textContent($translate.instant("global.areyousure"))
            .ariaLabel($translate.instant("global.areyousure"))
            .ok($translate.instant("global.button.remove"))
            .cancel($translate.instant("global.button.cancel"))
            .openFrom('#left');
            $mdDialog.show(confirm).then(function () {
                transformSelectedObj();
                OrganisationalUnitsService.remove(vm.pickedIds).then(function () {
                    vm.selected.length = 0;
                    prepareMapping();

            		$mdDialog.show(
                            $mdDialog.confirm()
                            .clickOutsideToClose(true)
                            .title('')
                            .textContent($translate.instant("global.table.delete-multiple.msg.success"))
                            .ariaLabel('msgSuccess')
                            .ok('Ok')
                            .targetEvent(ev)
                            );
                }, function (response) {
                	PlagiatValidationService.getModalError(response.data, $translate.instant("global.messages.warning.label"));
                });
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('organisationalUnitsAddEdit', {
            parent: 'account',
            url: '/organisational-units-add-edit/:organisationalUnitId',
            data: {
            	authorities: ['PERM_USER_ADMIN', 'PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.organisational.units'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/organisational-units/organisational-units-form/organisational-units-form.html',
                    controller: 'OrganisationalUnitsAddEditController',
                    controllerAs: 'vm'
                }
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('OrganisationalUnitsAddEditController', OrganisationalUnitsAddEditController);

    OrganisationalUnitsAddEditController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate', 'OrganisationalUnitsService',
    	'InstanceService', '$state', '$cookies', '$stateParams', '$mdDialog', 'PlagiatValidationService', 'AccountService',
        'PolonStudyService'];

    function OrganisationalUnitsAddEditController (Principal, Auth, JhiLanguageService, $translate, OrganisationalUnitsService,
    		InstanceService, $state, $cookies, $stateParams,  $mdDialog, PlagiatValidationService, AccountService,
                                                PolonStudyService) {
        var vm = this;
        vm.instance = InstanceService.instance().lang;
        vm.theme = $cookies.get('plagiat-theme');
        vm.timezone = InstanceService.instance().timezoneDocuments;
        moment.locale(vm.instance);
        vm.key = $stateParams.key;
        vm.save = save;
        vm.backToMainList = backToMainList;
        vm.getMatchingPolonStudies = getMatchingPolonStudies;
        vm.associatePolonStudy = associatePolonStudy;
        vm.formatPolonStudy = formatPolonStudy;
        vm.unassociatedPolonStudies = unassociatedPolonStudies;
        vm.disassociatePolonStudy = disassociatePolonStudy;
        vm.form = {
            id: $stateParams.organisationalUnitId,
            polonStudies: []
        };
        vm.doesClientHaveJsaIntegration = AccountService.getClientSettings().jsaIntegration;

        if ($stateParams.organisationalUnitId) {
            getForm($stateParams.organisationalUnitId).then(function () {
                if (vm.doesClientHaveJsaIntegration) {
                    fetchPolonStudiesEligibleToAssociate();
                }
            });
        } else {
            fetchPolonStudiesEligibleToAssociate();
        }

        function fetchPolonStudiesEligibleToAssociate() {
            PolonStudyService.getAllNotAssignedToOrganisationalUnit().then(
                function (polonStudies) {
                    vm.polonStudies = polonStudies;
                },
                function (response) {
                    PlagiatValidationService.getModalError(response.data);
                }
            )
        }

        function getMatchingPolonStudies(polonStudiesSearchText) {
            return !polonStudiesSearchText ? vm.unassociatedPolonStudies()
                : vm.unassociatedPolonStudies().filter(function (polonUnit) {
                    return polonUnit.name.toLowerCase().indexOf(polonStudiesSearchText.toLowerCase()) !== -1;
                });
        }

        function unassociatedPolonStudies() {
            return vm.polonStudies.filter(function (polonStudy) {
                return !vm.form.polonStudies.find(function (associatedPolonStudy) {
                    return associatedPolonStudy.id === polonStudy.id;
                });
            });
        }

        function associatePolonStudy(polonStudy) {
            if (polonStudy) {
                vm.form.polonStudies.push(polonStudy);
                vm.selectedPolonStudy = null;
            }
        }

        function formatPolonStudy(polonStudy) {
            return ('<b>' + polonStudy.name + '</b>, ' +
                (polonStudy.title ? $translate.instant('document.jsa.title.' + polonStudy.title) + ', ' : '') +
                (polonStudy.form ? polonStudy.form + ', ' : '') +
                'UUID: ' + polonStudy.uid);
        }

        function disassociatePolonStudy(polonStudy) {
            var indexOfStudyToDelete = vm.form.polonStudies.findIndex(function (associatedPolonStudy) {
                return associatedPolonStudy.id === polonStudy.id;
            });
            vm.form.polonStudies.splice(indexOfStudyToDelete, 1);
        }

        function backToMainList(){
        	$state.go('organisational-units');
        }
        
        function getForm(id){
        	return OrganisationalUnitsService.getForm(id).then(function(response){
        		vm.form = response.data;
        	});
        }
        
        function save(form, ev){
            var savePromise = form.id ? OrganisationalUnitsService.edit(form) : OrganisationalUnitsService.add(form);
            savePromise.then(function(){
        		backToMainList();
        		
                $mdDialog.show(
                        $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .title('')
                        .textContent($translate.instant(form.id ? "organisational.units.form.edit.msg":
                            "organisational.units.form.new.msg"))
                        .ariaLabel('msgSuccess')
                        .ok('Ok')
                        .targetEvent(ev)
                        );
        	}, function(response){
        		PlagiatValidationService.getModalError(response.data);
        	})
        }
         
    }
})();

(function () {
    'use strict';
    function OrganisationalUnitsButtonsController($state, $mdDialog, $mdToast, $translate, OrganisationalUnitsService, PlagiatValidationService) {
        var vm = this;
        vm.arrIdis = [];

        vm.edit = function(organisationalUnitId){
        	$state.go('organisationalUnitsAddEdit', {organisationalUnitId : organisationalUnitId});
        }
        
        vm.remove = function(id, ev) {
            var confirm = $mdDialog.confirm()
            .title($translate.instant("global.confirmremove"))
            .textContent($translate.instant("global.areyousure"))
            .ariaLabel($translate.instant("global.areyousure"))
            .ok($translate.instant("global.button.remove"))
            .cancel($translate.instant("global.button.cancel"))
            .openFrom('#left');
            $mdDialog.show(confirm).then(function () {
            	OrganisationalUnitsService.remove([id]).then(function () {
                    vm.getData();
            		$mdDialog.show(
                            $mdDialog.confirm()
                            .clickOutsideToClose(true)
                            .title('')
                            .textContent($translate.instant("global.table.delete.msg.success"))
                            .ariaLabel('msgSuccess')
                            .ok('Ok')
                            .targetEvent(ev)
                            );
                }, function (response) {
                	PlagiatValidationService.getModalError(response.data);
                });
            });
        }
    }

    angular.module('organisationalUnitsButtons', [])
    .component('organisationalUnitsButtons', {
        templateUrl: 'app/account/settings/organisational-units/organisational-units-buttons/organisational-units-buttons.template.html',
        controller: OrganisationalUnitsButtonsController,
        bindings: {
        	organisationalUnitId: '<',
        	getData: '<',
        	buttonLp: '<'
        }
    });

})();

(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .constant('POLON_SYNCHRONIZATION_STATUS', {
            NOT_STARTED: {value: "NOT_STARTED", translationKey: "polon.synchronization.status.not-started"},
            IN_PROGRESS: {value: "IN_PROGRESS", translationKey: "polon.synchronization.status.in-progress"},
            SUCCESS: {value: "SUCCESS", translationKey: "polon.synchronization.status.success"},
            FAILURE: {value: "FAILURE", translationKey: "polon.synchronization.status.failure"}
        })
        .constant('POLON_SYNCHRONIZATION_TYPE', {
            FILE: {value: "FILE", translationKey: "polon.synchronization.type.file"},
            POLON: {value: "POLON", translationKey: "polon.synchronization.status.polon"},
            POLON_UNITS_AND_STUDIES: {value: "POLON_UNITS_AND_STUDIES", translationKey: "polon.synchronization.type.polon-units-and-studies"},
        });
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jsa', {
            parent: 'account',
            url: '/jsa',
            data: {
                // authorities: ['PERM_USER_ADMIN', 'PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.settings.jsa.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/jsa/jsa.html',
                    controller: 'JsaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('jsa');
                    $translatePartialLoader.addPart('polon');
                    $translatePartialLoader.addPart('orppd');
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('document');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('JsaService', JsaService);

    JsaService.$inject = ['$http', '$q'];

    function JsaService($http, $q) {

        var service = {
            upload: upload,
            getSynchronizationInfo: getSynchronizationInfo,
            synchronize: synchronize,
            synchronizeUnitsAndStudies: synchronizeUnitsAndStudies,
            synchronizeInstitutions: synchronizeInstitutions,
            saveAccessData: saveAccessData,
            getAccessData: getAccessData,
            getEmployingPolonInstitutions: getEmployingPolonInstitutions,
            getEmployeeSummaryByInstitution: getEmployeeSummaryByInstitution,
            getPolonEmployeesEditUser: getPolonEmployeesEditUser,
            getPolonEmployeesAddUser: getPolonEmployeesAddUser,
            getAuthorsAutocompleteItems: getAuthorsAutocompleteItems,
            getPromoterByUserId: getPromoterByUserId,
            getPromotersAutocompleteItems: getPromotersAutocompleteItems,
            saveDocumentJSA: saveDocumentJSA,
            getJsaMetadata: getJsaMetadata,
            editJsaMetadata: editJsaMetadata,
            send: send,
            addPolonEmployee: addPolonEmployee,
            getDegreesAndTitles: getDegreesAndTitles,
            sendOpiEmail: sendOpiEmail
        };

        var requestUrl = 'api/jsa';
        return service;

        function upload(file) {
            var request = {
                transformRequest: angular.identity,
                transformResponse: angular.identity,
                headers: {
                    'Content-Type': undefined,
                }
            };
            return $http.post(requestUrl + '/import-file', file, request).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function synchronize(login, password, polonCode) {
            var synchronizationData = {
                login: login,
                password: password,
                polonCode: polonCode
            };
            return $http.post(requestUrl + '/synchronize', synchronizationData).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function synchronizeUnitsAndStudies() {
            return $http.post(requestUrl + '/synchronize-units-and-studies').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function synchronizeInstitutions() {
            return $http.post(requestUrl + '/synchronize-institutions').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getSynchronizationInfo() {
            return $http.get(requestUrl + '/synchronization-info').then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function saveAccessData(accessData) {
            return $http.post(requestUrl + '/access-data', accessData).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getDegreesAndTitles() {
            return $http.get(requestUrl + '/degrees-and-titles').then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function addPolonEmployee(polonEmployee) {
            return $http.post(requestUrl + '/add-polon-employee', polonEmployee).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function sendOpiEmail(polonEmployee) {
            return $http.post(requestUrl + '/send-email-opi', polonEmployee).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getAccessData() {
            return $http.get(requestUrl + '/access-data').then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getEmployingPolonInstitutions() {
            return $http.get('api/polon/institution/employing').then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getEmployeeSummaryByInstitution(institutionUid) {
            return $http.get('api/polon/employees/summary/institution/' + institutionUid).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getPolonEmployeesEditUser(uid) {
            return $http.get('api/polon/employees/edit-user/' + uid).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getPolonEmployeesAddUser() {
            return $http.get('api/polon/employees/add-user/').then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getAuthorsAutocompleteItems(autocompleteQuery, authors, clientId) {
            var params = {params: {searchValue: autocompleteQuery, 'clientId': clientId}};
            if (authors && authors[0]) {
                if (authors[0].uid) {
                    params.params.includePhdStudents = false;
                } else {
                    params.params.includeStudents = false;
                }
            }
            return $http.get(requestUrl + '/authors',  params).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getPromoterByUserId(userId) {
            return $http.get(requestUrl + '/promoter?userId=' + userId).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getPromotersAutocompleteItems(searchValue, clientId) {
            return $http.get(requestUrl + '/promoters', {params: {searchValue: searchValue, 'clientId': clientId}}).then(
                function (response) {
                    return response.data.data.content;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function saveDocumentJSA(obj) {
            return $http.post(requestUrl + '/add-document', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function editJsaMetadata(documentId, jsaDocument) {
            return $http.post(requestUrl + '/edit-metadata?documentId=' + documentId, jsaDocument).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        /**
         * Send already created document to JSA
         */
        function send(documentId, jsaDocument, sendWithoutUid) {
            return $http.post(requestUrl + '/send?documentId=' + documentId + '&sendWithoutUid=' + sendWithoutUid, jsaDocument).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getJsaMetadata(documentId) {
            return $http.get(requestUrl + '/get-metadata?documentId=' + documentId).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('JsaController', JsaController);

    JsaController.$inject = ['JsaService', 'ModalService', 'PlagiatValidationService', '$translate', 'POLON_SYNCHRONIZATION_STATUS',
        'POLON_SYNCHRONIZATION_TYPE', 'OrppdService', 'AccountService', '$q'];

    function JsaController(JsaService, ModalService, PlagiatValidationService, $translate, POLON_SYNCHRONIZATION_STATUS,
                           POLON_SYNCHRONIZATION_TYPE, OrppdService, AccountService, $q) {
        var vm = this;
        vm.importFile = importFile;
        vm.keyReturn = KeyCode.KEY_RETURN;
        vm.synchronize = synchronize;
        vm.saveAccessData = saveAccessData;
        vm.jsaTokenModel = saveAccessData;
        vm.isSynchronizationEnabled = isSynchronizationEnabled;
        vm.toggleShouldUpdateJsaToken = toggleShouldUpdateJsaToken;
        vm.shouldShowJsaTokenInput = shouldShowJsaTokenInput;
        vm.synchronizeOnlyUnitsAndStudies = false;
        vm.addPolonEmployee = addPolonEmployee;
        vm.searchPolonInstitutions = searchPolonInstitutions;
        vm.searchPolonEmployees = searchPolonEmployees;
        vm.selectedPolonInstitutionChange = selectedPolonInstitutionChange;
        vm.selectedPolonEmployeeChange = selectedPolonEmployeeChange;
        vm.getPolonEmployeeSummaryFormatted = getPolonEmployeeSummaryFormatted;
        vm.addPolonEmployeeFromOtherInstitution = addPolonEmployeeFromOtherInstitution;
        vm.sendOpiEmail = sendOpiEmail;
        vm.availableExtensions = '.xml,.xls,.xlsx';

        vm.orppdIntegration = AccountService.getClientSettings().orppdIntegration;

        vm.activeTab = 'jsaSynchronization';
        vm.activeSubTabPolonEmployee = 'search';
        vm.polonSynchronizationStatus = POLON_SYNCHRONIZATION_STATUS;
        vm.polonSynchronizationType = POLON_SYNCHRONIZATION_TYPE;
        vm.files = [];

        vm.jsaAccessData = {};
        vm.polonEmployee = {};
        vm.selectedPolonInstitution = null;
        vm.selectedEmployeeCustomTitle = null;
        vm.polonInstitutions = [];
        vm.polonEmployeesInInstitution = [];
        vm.showJsaToken = true;
        vm.showOrppdPassword = true;
        vm.degreesAndTitles = {};
        vm.changeTab = function(){};


        onInit();

        function onInit() {
            vm.isLoading = true;
            JsaService.getSynchronizationInfo().then(
                function (responseData) {
                    vm.isLoading = false;
                    vm.synchronizationStatus = responseData.synchronizationStatus;
                    vm.synchronizationType = responseData.synchronizationType;
                    vm.activeSubTab = responseData.synchronizationType;
                    vm.synchronizationStartDate = !!responseData.synchronizationStartDate ?
                        moment(responseData.synchronizationStartDate).format("DD-MM-YYYY HH:mm") : null;
                },
                function (response) {
                    vm.isLoading = false;
                    ModalService.showErrorModal(response);
                }).catch(function (response) {
                vm.isLoading = false;
                ModalService.showErrorModal(response);
            });
            JsaService.getAccessData().then(function (jsaAccessData) {
                vm.jsaAccessData = jsaAccessData;
                vm.showJsaToken = !jsaAccessData.jsaToken;
                vm.jsaTokenLastSaveDateFormatted = !!jsaAccessData.tokenLastSaveDate
                    ? moment(jsaAccessData.tokenLastSaveDate).format("DD-MM-YYYY HH:mm") : null;
            });
            JsaService.getDegreesAndTitles().then(function (responseData) {
                vm.degreesAndTitles = responseData;
            });
            OrppdService.getPassword().then(function (orppdPassword) {
                vm.orppdPassword = orppdPassword.password;
                vm.showOrppdPassword = !vm.orppdPassword;
                vm.passwordLastSaveDateFormatted = !!orppdPassword.passwordLastSaveDate
                    ? moment(orppdPassword.passwordLastSaveDate).format("DD-MM-YYYY HH:mm") : null;
            });
        }

        function searchPolonInstitutions(searchText) {
           if (!vm.polonInstitutions || (angular.isArray(vm.polonInstitutions) && vm.polonInstitutions.length === 0)) {
               return JsaService.getEmployingPolonInstitutions().then(
                   function (polonInstitutions) {
                       vm.polonInstitutions = polonInstitutions;
                       return filterPolonInstitutionsByName(searchText);
                   }
               )
           } else {
               return filterPolonInstitutionsByName(searchText);
           }
        }

        function filterPolonInstitutionsByName(name) {
            return vm.polonInstitutions.filter(
                function (polonInstitution) {
                    return polonInstitution.name.toLowerCase().indexOf(name.toLowerCase()) >= 0;
                }
            )
        }

        function selectedPolonInstitutionChange() {
            if (vm.selectedPolonInstitution) {
                vm.showLoader = true;
                JsaService.getEmployeeSummaryByInstitution(vm.selectedPolonInstitution.uuid).then(
                    function (employeeSummaryForInstitution) {
                        vm.showLoader = false;
                        vm.polonEmployeesInInstitution = employeeSummaryForInstitution;
                    }, function (response) {
                        vm.showLoader = false;
                        PlagiatValidationService.getModalError(response.data);
                        vm.selectedPolonInstitution = vm.polonInstitutionsSearchText = null;
                        vm.polonEmployeesInInstitution = [];
                    }
                )
            } else {
                vm.polonEmployeesInInstitution = [];
            }
            vm.selectedPolonEmployee = vm.polonEmployeeSearchText = null;
        }

        function selectedPolonEmployeeChange() {
            vm.selectedEmployeeCustomTitle = null;
        }

        function searchPolonEmployees(searchText) {
            var tokens = searchText.split(/\s/);
            return vm.polonEmployeesInInstitution.filter(
                function (polonEmployee) {
                    for (var tokenIdx in tokens) {
                        var token = tokens[tokenIdx];
                        var isMatching = (polonEmployee.name && polonEmployee.name.toLowerCase().indexOf(token.toLowerCase()) >= 0) ||
                          (polonEmployee.surname && polonEmployee.surname.toLowerCase().indexOf(token.toLowerCase()) >= 0) ||
                            polonEmployee.uid.indexOf(token) >= 0;
                        if (!isMatching) {
                            return false;
                        }
                    }
                    return true;
                });
        }

        function getPolonEmployeeSummaryFormatted(polonEmployeeSummary) {
            return (polonEmployeeSummary.title == null ? '' :  polonEmployeeSummary.title)
                + ' ' + polonEmployeeSummary.name + ' ' + polonEmployeeSummary.surname + ' ' + polonEmployeeSummary.uid;
        }

        function importFile($files, $invalidFiles) {
            var formData;
            if ($files === null) {
                vm.files = null;
                vm.fileName = null;
            } else {
                if ($invalidFiles.length === 0) {
                    formData = new FormData();
                    vm.files = $files;
                    angular.forEach(vm.files, function (value) {
                        formData.append("file", value);
                        vm.fileName = value.name;
                    });
                }
                if (formData) {
                    JsaService.upload(formData).then(
                        function () {
                            vm.isLoading = false;
                            ModalService.showSuccessModal(vm.fileName + $translate.instant("jsa.file.import.success"))
                                .then(function () {
                                    refreshStateAfterTriggeringSynchronization(POLON_SYNCHRONIZATION_TYPE.FILE.value);
                                });
                        },
                        function (response) {
                            vm.isLoading = false;
                            ModalService.showErrorModal(response);
                        }).catch(function (response) {
                        vm.isLoading = false;
                        ModalService.showErrorModal(response);
                    });
                }
            }
        }

        function refreshStateAfterTriggeringSynchronization(synchronizationType) {
            vm.synchronizationStatus = POLON_SYNCHRONIZATION_STATUS.IN_PROGRESS.value;
            vm.synchronizationStartDate = moment(new Date()).format("DD-MM-YYYY HH:mm");
            vm.synchronizationType = synchronizationType;
        }

        function toggleShouldUpdateJsaToken() {
            vm.jsaAccessData.jsaToken = null;
        }

        function synchronize() {
            if (vm.synchronizeOnlyUnitsAndStudies) {
                synchronizeUnitsAndStudiesFromPolon();
            } else {
                synchronizeAllDataFromPolon();
            }
        }

        function synchronizeAllDataFromPolon() {
            vm.isLoading = true;
            JsaService.synchronize(vm.login, vm.password, vm.jsaAccessData.polonCode).then(
                function () {
                    vm.isLoading = false;
                    ModalService.showSuccessModal("polon.synchronization.success").then(function () {
                        refreshStateAfterTriggeringSynchronization(POLON_SYNCHRONIZATION_TYPE.POLON.value);
                    });
                },
                function (response) {
                    vm.isLoading = false;
                    ModalService.showErrorModal(response);
                }).catch(function (response) {
                    vm.isLoading = false;
                    ModalService.showErrorModal(response);
                });
        }

        function synchronizeUnitsAndStudiesFromPolon() {
            vm.isLoading = true;
            JsaService.synchronizeUnitsAndStudies().then(
                function () {
                    vm.isLoading = false;
                    ModalService.showSuccessModal("polon.synchronization.units-and-studies.success").then(
                        function () {
                            refreshStateAfterTriggeringSynchronization(POLON_SYNCHRONIZATION_TYPE.POLON_UNITS_AND_STUDIES.value);
                        });
                },
                function (response) {
                    vm.isLoading = false;
                    ModalService.showErrorModal(response);
                }).catch(function (response) {
                    vm.isLoading = false;
                    ModalService.showErrorModal(response);
                });
        }

        function isSynchronizationEnabled() {
            return POLON_SYNCHRONIZATION_STATUS.IN_PROGRESS.value !== vm.synchronizationStatus;
        }

        function shouldShowJsaTokenInput() {
            return !vm.jsaAccessData.tokenLastSaveDate || vm.shouldUpdateJsaToken;
        }

        function addPolonEmployee() {
            vm.isLoading = true;
            JsaService.addPolonEmployee(vm.polonEmployee).then(function () {
                vm.polonEmployee = {};
                vm.isLoading = false;
                successSaveDataModalClosure("jsa.add-polon-employee.success")();
            },function (response) {
                vm.isLoading = false;
                PlagiatValidationService.getModalError(response.data);
                return $q.reject()
            });
        }

        function addPolonEmployeeFromOtherInstitution() {
            vm.isLoading = true;
            vm.selectedPolonEmployee.mainInstitutionUid = vm.selectedPolonInstitution.uuid;
            if (!vm.selectedPolonEmployee.title) {
                vm.selectedPolonEmployee.title = vm.selectedEmployeeCustomTitle;
            }
            JsaService.addPolonEmployee(vm.selectedPolonEmployee).then(function () {
                vm.polonEmployee = {};
                vm.isLoading = false;
                successSaveDataModalClosure("jsa.search-polon-employee.add.success")();
            }, function (response) {
                vm.isLoading = false;
                PlagiatValidationService.getModalError(response.data);
                return $q.reject()
            });
        }

        function sendOpiEmail() {
            vm.isLoading = true;
            JsaService.sendOpiEmail(vm.polonEmployee).then(function () {
                vm.polonEmployee = {};
                successSaveDataModalClosure("jsa.send-opi-mail.success")();
            },function (response) {
                vm.isLoading = false;
                PlagiatValidationService.getModalError(response.data);
                return $q.reject()
            });
        }

        function saveAccessData() {
            vm.isLoading = true;
            var savingDataPromise = JsaService.saveAccessData(vm.jsaAccessData).then(function () {
                if (!vm.orppdIntegration) {
                    successSaveDataModalClosure("jsa.save-access-data.success")();
                }
            },function (response) {
                vm.isLoading = false;
                PlagiatValidationService.getModalError(response.data);
                return $q.reject()
            });
            if(vm.orppdIntegration) {
                savingDataPromise.then(saveOrppdAccessData);
            }
        }

        function saveOrppdAccessData() {
            OrppdService.savePassword(vm.orppdPassword).then(successSaveDataModalClosure("orppd.password.save.success"),
                function (response) {
                    vm.isLoading = false;
                    PlagiatValidationService.getModalError(response.data);
                });
        }

        function successSaveDataModalClosure(successMessage) {
            return function() {
                vm.isLoading = false;
                ModalService.showSuccessModal(successMessage)
                    .then(function () {
                        onInit();
                    });
            };
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('iodo', {
            parent: 'account',
            url: '/iodo',
            data: {
                authorities: ['PERM_USER_ADMIN'],
                pageTitle: 'global.menu.iodo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/iodo/iodo.html',
                    controller: 'IodoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'userName,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';

    angular
    .module('plagiat2017App')
    .controller('IodoController', IodoController);

    IodoController.$inject = ['AccountService', 'InstanceService', '$mdDialog', '$translate', 'InfoService', 
    'ModalService', 'PlagiatValidationService', '$cookies', '$scope'];

    function IodoController (AccountService, InstanceService, $mdDialog, $translate, InfoService, 
        ModalService, PlagiatValidationService, $cookies, $scope) {

        var vm = this;
        vm.activeTab = 'iodo';
        vm.acceptRodo = angular.isUndefined(AccountService.account.acceptRodo) || AccountService.account.acceptRodo == null ? true : AccountService.account.acceptRodo;
        vm.accept = vm.acceptRodo;
        vm.verifyAcceptTerms = verifyAcceptTerms;

        if (AccountService.account.clientRegionId == 8) {
            // dla klientów z bulgarskiego ministerstwa wyświetlamy rumuńskie napisy
            vm.instance = '_ro';
        } else {
            vm.instance = InstanceService.instance().lang === 'en' ? '_int' : '_' + InstanceService.instance().lang;
        }

        vm.acceptTitleHtml = '<h2 data-translate="global.iodo.confirm.title">Potwierdź brak akcpetacji podpowierzania danych</h2>';
        vm.acceptInfoHtml = '<span class="dialog-info">' + $translate.instant("global.iodo.confirm.info" + vm.instance)  + '</span>';

        $scope.$on('langChanged', function () {
          getIodoCompanies();
        });

        function getIodoCompanies(){
          InfoService.getIodoCompanies($cookies.getObject('NG_TRANSLATE_LANG_KEY')).then(function(response){
            vm.companies = response['iodo.companies.content' + vm.instance];
          });
        }


        function verifyAcceptTerms() {

            if (!vm.accept) {
                $mdDialog.show({
                  template:
                  '<md-dialog aria-label="List dialog">' +
                  '  <md-toolbar>' +
                  '  <div class="md-toolbar-tools">' +
                      vm.acceptTitleHtml +
                  '  </div>' +
                  '  </md-toolbar>' +
                  '  <form name="form" ng-cloak>' +
                  '  <md-dialog-content>' +
                  '   <div class="md-dialog-content rodo-md-dialog-content">' +
                        vm.acceptInfoHtml +
                  '    <md-input-container class="md-block">' +
                  '     <input placeholder="{{\'global.iodo.confirm.client-id\' | translate}}" ng-model="_dialog.account.clientId" disabled>' +
                  '    </md-input-container>' +
                  '    <md-input-container class="md-block">' +
                  '     <input placeholder="{{\'global.iodo.confirm.reporting-person\' | translate}}" ng-model="_dialog.person" disabled>' +
                  '    </md-input-container>' +
                  '    </md-input-container>' +
                  '    <md-input-container class="md-block">' +
                  '     <textarea placeholder="{{\'global.iodo.confirm.reason\' | translate}}" ng-model="_dialog.reason" rows="4" md-autofocus></textarea>' +
                  '    </md-input-container>' +
                  '   </div>' +
                  '  </md-dialog-content>' +
                  '  <md-dialog-actions>' +
                  '    <md-button ng-click="_dialog.closeDialog()">' + $translate.instant("global.button.cancel") +
                  '    </md-button>' +
                  '    <md-button ng-click="_dialog.dontAccept()" ng-disabled="form.$invalid" class="md-primary">' + $translate.instant("global.button.confirm") +
                  '    </md-button>' +
                  '  </md-dialog-actions>' +
                  '  </form>' +
                  '</md-dialog>',
                  clickOutsideToClose: false,
                  escapeToClose: false,
                  parent: angular.element(document.getElementById('mainContent')),
                  controllerAs: '_dialog',
                  controller: function DialogController($scope, $mdDialog) {
                    var _dialog = this;
                    _dialog.closeDialog = closeDialog;
                    _dialog.dontAccept = dontAccept;
                    _dialog.formData = new FormData();
                    _dialog.account = AccountService.account;
                    _dialog.person = _dialog.account.firstName + ' ' + _dialog.account.lastName;
                    function closeDialog() {
                      $mdDialog.hide();
                      vm.accept = true;
                    }
                    function dontAccept() {
                        _dialog.formData.append('message', _dialog.reason);
                        InfoService.dontAccept(_dialog.formData).then(function() {
                            $mdDialog.hide();
                            ModalService.showSuccessModal($translate.instant("global.iodo.confirm.success"));
                        }).catch(function (response) {
                            PlagiatValidationService.getModalError(response.data);
                        });
                    }
                  }
                });
            } 
        }

        getIodoCompanies();

   }

})();

(function () {
    'use strict';

    function DocumentParameterDefinitionsSearchController($scope, $rootScope, $state, $translate, $mdDialog, $log,
    		DocumentParameterDefinitionsService, documentParameterDefinitionsQueryRequest, documentParameterDefinitionsSearchRequest) {
        var vm = this;
        vm.simpleSearch = true;
        vm.getData = getData;
        vm.clear = clear;
        vm.goToAddPage = goToAddPage;
        
        function goToAddPage(){
        	$state.go('documentParameterDefinitionsAdd');
        }
        
        function getData(){
            $localStorage.documentParameterDefinitionListLimit = vm.onQueryRequest.limit;
        	vm.onGetData(vm.documentParameterDefinitionsSearchRequest);
		}
        
        function clear() {
            vm.documentParameterDefinitionsSearchRequest = new documentParameterDefinitionsSearchRequest();
            getData();
        }

    }

    angular.module('plagiat2017App')
            .component('documentParameterDefinitionsSearch', {
                templateUrl: 'app/account/settings/document-parameter-definitions/document-parameter-definitions-search/document-parameter-definitions-search.template.html',
                controller: DocumentParameterDefinitionsSearchController,
                bindings: {
                    onGetData: '<',
                    onQueryRequest: '=',
                    onSearchData: '='
                }
            });

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('document-parameter-definitions', {
            parent: 'account',
            url: '/document-parameter-definitions',
            data: {
                authorities: ['PERM_USER_ADMIN', 'PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.account.document-parameter-definitions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/document-parameter-definitions/document-parameter-definitions-list/document-parameter-definitions.html',
                    controller: 'DocumentParameterDefinitionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('document-parameter-definitions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('DocumentParameterDefinitionsController', DocumentParameterDefinitionsController);

    DocumentParameterDefinitionsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate',
    	'documentParameterDefinitionsQueryRequest', 'documentParameterDefinitionsSearchRequest', 'tableSettingsRequest',
    	'DocumentParameterDefinitionsService', 'SearchService', '$mdDialog', '$mdToast', 'PlagiatValidationService',
        '$localStorage', '$scope'];

    function DocumentParameterDefinitionsController (Principal, Auth, JhiLanguageService, $translate,
    		documentParameterDefinitionsQueryRequest, documentParameterDefinitionsSearchRequest, tableSettingsRequest,
    		DocumentParameterDefinitionsService, SearchService, $mdDialog, $mdToast, PlagiatValidationService,
            $localStorage) {

        var vm = this;
        vm.activeTab='documentParameterDefinitions';
        vm.queryRequest = new documentParameterDefinitionsQueryRequest();
        vm.queryRequest.limit = $localStorage.documentParameterDefinitionListLimit;
        vm.searchRequest = new documentParameterDefinitionsSearchRequest();
        vm.options = new tableSettingsRequest();
        vm.selected = [];
        vm.startPaging = startPaging;
        vm.prepareMapping = prepareMapping;
        vm.getData = getData;
        vm.removeParameters = removeParameters;
        vm.pickedIds = [];

        prepareMapping();

        function prepareMapping(){
        	getData(vm.documentParameterDefinitionsSearchRequest);
        }

        function getData(documentParameterDefinitionsSearchRequest){
            vm.selected.length = 0;
            vm.showDetailsBlock = false;
            vm.documentParameterDefinitionsSearchRequest = documentParameterDefinitionsSearchRequest;
            vm.searchRequest.pageNumber = (vm.queryRequest.page - 1);
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.sortTab = SearchService.sort(vm.queryRequest);

            vm.isLoadingData = true;
            DocumentParameterDefinitionsService.getDocumentParameterDefinitions(vm.searchRequest).then(function (responseData) {
                var responseObj = responseData.content;

                vm.documentParameterDefinitions = responseObj;
                vm.totalElements = responseData.totalElements;

                vm.isLoadingData = false;
            });
        }

        function startPaging(page) {
         	vm.isLoadingData = true;
             vm.queryRequest.page = page;
             prepareMapping();
         }

        function transformSelectedObj() {
            vm.pickedIds.length = 0;
            angular.forEach(vm.selected, function (value) {
                vm.pickedIds.push(value.id);
            });
        }

        function removeParameters(ev) {
            var confirm = $mdDialog.confirm()
            .title($translate.instant("global.confirmremove"))
            .textContent($translate.instant("global.areyousure"))
            .ariaLabel($translate.instant("global.areyousure"))
            .ok($translate.instant("global.button.remove"))
            .cancel($translate.instant("global.button.cancel"))
            .openFrom('#left');
            $mdDialog.show(confirm).then(function () {
                transformSelectedObj();
                DocumentParameterDefinitionsService.removeMultiple(vm.pickedIds).then(function () {
                    vm.selected.length = 0;
                    prepareMapping();

            		$mdDialog.show(
                            $mdDialog.confirm()
                            .clickOutsideToClose(true)
                            .title('')
                            .textContent($translate.instant("global.table.delete-multiple.msg.success"))
                            .ariaLabel('msgSuccess')
                            .ok('Ok')
                            .targetEvent(ev)
                            );
                }, function () {
                	PlagiatValidationService.getModalError(response.data);
                });
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('documentParameterDefinitionsEdit', {
            parent: 'account',
            url: '/document-parameter-definitions-edit/:parameterId',
            data: {
            	authorities: ['PERM_USER_ADMIN', 'PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.document.parameter.definitions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/document-parameter-definitions/document-parameter-definitions-form/document-parameter-definitions-form.html',
                    controller: 'DocumentParameterDefinitionsEditController',
                    controllerAs: 'vm'
                }
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('DocumentParameterDefinitionsEditController', DocumentParameterDefinitionsEditController);

    DocumentParameterDefinitionsEditController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate', 'DocumentParameterDefinitionsService',
    	'InstanceService', '$state', '$cookies', '$stateParams', '$mdDialog', 'PlagiatValidationService'];

    function DocumentParameterDefinitionsEditController (Principal, Auth, JhiLanguageService, $translate, DocumentParameterDefinitionsService,
    		InstanceService, $state, $cookies, $stateParams,  $mdDialog, PlagiatValidationService) {
        var vm = this;
        vm.instance = InstanceService.instance().lang;
        vm.theme = $cookies.get('plagiat-theme');
        vm.timezone = InstanceService.instance().timezoneDocuments;
        moment.locale(vm.instance);
        vm.key = $stateParams.key;
        vm.selected = [];
        vm.save = save;
        vm.backToMainList = backToMainList;
        vm.form = {
        		id: $stateParams.parameterId
        }
        
        vm.dopadeTypes = DocumentParameterDefinitionsService.getDopadeTypes();
        
        getForm($stateParams.parameterId);
        
        function backToMainList(){
        	$state.go('document-parameter-definitions');
        }
        
        function getForm(parameterId){
        	DocumentParameterDefinitionsService.getForm(parameterId).then(function(response){
        		vm.form = response.data;
        	});
        }
        
        function save(form, ev){
        	DocumentParameterDefinitionsService.edit(form).then(function(){
        		backToMainList();
        		
        		$mdDialog.show(
                        $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .title('')
                        .textContent($translate.instant("document.parameter.definition.form.edit.msg"))
                        .ariaLabel('msgSuccess')
                        .ok('Ok')
                        .targetEvent(ev)
                        );
        	}, function(response){
        		PlagiatValidationService.getModalError(response.data);
        	})
        }
         
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('documentParameterDefinitionsAdd', {
            parent: 'account',
            url: '/document-parameter-definitions-add',
            data: {
            	authorities: ['PERM_USER_ADMIN', 'PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.document.parameter.definitions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/document-parameter-definitions/document-parameter-definitions-form/document-parameter-definitions-form.html',
                    controller: 'DocumentParameterDefinitionsAddController',
                    controllerAs: 'vm'
                }
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('DocumentParameterDefinitionsAddController', DocumentParameterDefinitionsAddController);

    DocumentParameterDefinitionsAddController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate', 'DocumentParameterDefinitionsService',
    	'InstanceService', '$state', '$cookies', '$stateParams', '$mdDialog', 'PlagiatValidationService'];

    function DocumentParameterDefinitionsAddController (Principal, Auth, JhiLanguageService, $translate, DocumentParameterDefinitionsService,
    		InstanceService, $state, $cookies, $stateParams,  $mdDialog, PlagiatValidationService) {
        var vm = this;
        
        vm.instance = InstanceService.instance().lang;
        vm.theme = $cookies.get('plagiat-theme');
        vm.timezone = InstanceService.instance().timezoneDocuments;
        moment.locale(vm.instance);
        vm.key = $stateParams.key;
        vm.selected = [];
        vm.save = save;
        vm.backToMainList = backToMainList;
        vm.dopadeTypeListener = dopadeTypeListener;
        vm.form = {
        		dopadeType: 0,
        		dopadeIsMandatoryBoolean: false,
        		comboBoxValues: []
        }
        
        vm.dopadeTypes = DocumentParameterDefinitionsService.getDopadeTypes();
        
        function backToMainList(){
        	$state.go('document-parameter-definitions');
        }
        
        function save(form, ev){
        	DocumentParameterDefinitionsService.add(form).then(function(){
        		backToMainList();
        		
        		$mdDialog.show(
                        $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .title('')
                        .textContent($translate.instant("document.parameter.definition.form.new.msg"))
                        .ariaLabel('msgSuccess')
                        .ok('Ok')
                        .targetEvent(ev)
                        );
        	}, function(response){
        		PlagiatValidationService.getModalError(response.data);
        	})
        }

		function dopadeTypeListener(){
			if(vm.form){
				vm.form.dopadeDefault = undefined; 
			}
		}

    }
})();

(function () {
    'use strict';
    function DocumentParameterDefinitionsButtonsController($state, $mdDialog, $mdToast, $translate, DocumentParameterDefinitionsService) {
        var vm = this;
        vm.arrIdis = [];

        vm.edit = function(parameterId){
        	$state.go('documentParameterDefinitionsEdit', {parameterId : parameterId});
        }
        
        vm.remove = function(parameterId, ev) {
            var confirm = $mdDialog.confirm()
            .title($translate.instant("global.confirmremove"))
            .textContent($translate.instant("global.areyousure"))
            .ariaLabel($translate.instant("global.areyousure"))
            .ok($translate.instant("global.button.remove"))
            .cancel($translate.instant("global.button.cancel"))
            .openFrom('#left');
            $mdDialog.show(confirm).then(function () {
            	DocumentParameterDefinitionsService.remove(parameterId).then(function () {
                    vm.getData();
                    
            		$mdDialog.show(
                            $mdDialog.confirm()
                            .clickOutsideToClose(true)
                            .title('')
                            .textContent($translate.instant("global.table.delete.msg.success"))
                            .ariaLabel('msgSuccess')
                            .ok('Ok')
                            .targetEvent(ev)
                            );
                }, function () {
                    $mdToast.show($mdToast.simple().textContent($translate.instant("global.table.delete.msg.error")));
                });
            });
        }
    }

    angular.module('documentParameterDefinitionsButtons', [])
    .component('documentParameterDefinitionsButtons', {
        templateUrl: 'app/account/settings/document-parameter-definitions/document-parameter-definitions-buttons/document-parameter-definitions-buttons.template.html',
        controller: DocumentParameterDefinitionsButtonsController,
        bindings: {
        	parameterId: '<',
        	getData: '<',
        	buttonLp: '<'
        }
    });

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('EditThresholdsController', EditThresholdsController);

    EditThresholdsController.$inject = ['DocumentKindsService', 'PlagiatValidationService', 'ModalService',
    	'$state', '$stateParams'];

    function EditThresholdsController (DocumentKindsService, PlagiatValidationService, ModalService,
    		$state, $stateParams) {
        var vm = this;
        vm.key = $stateParams.key;
        vm.save = save;
        vm.backToMainList = backToMainList;

        if ($stateParams.documentKindId) {
            vm.pending = true;
            getForm($stateParams.documentKindId).then(function () {
                vm.pending = false;
            });
        }

        function backToMainList() {
        	$state.go('document-kinds');
        }
        
        function getForm(id) {
        	return DocumentKindsService.getThresholdsForEdit(id).then(function(response) {
        		vm.form = response;
        	});
        }
        
        function save(form){
            DocumentKindsService.saveThresholds(form).then(function(){
        		backToMainList();

                ModalService.showSuccessModal();
        	}, function(response){
        		PlagiatValidationService.getModalError(response.data);
        	})
        }
         
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('DocumentKindsListController', DocumentKindsListController);
    
    DocumentKindsListController.$inject = ['DocumentKindsService', 'AccountService', 'ModalService', '$state'];

    function DocumentKindsListController(DocumentKindsService, AccountService, ModalService, $state) {
        var vm = this;
        vm.activeTab = 'documentKinds';
        vm.pending = false;
        vm.clientId = AccountService.account.clientId;
        vm.warningThresholdsEnabled = AccountService.account.clientSettings.warningThresholds;
        vm.dueDateEnabled = AccountService.account.clientSettings.documentKindDueDate;
        vm.warningThreshold1 = AccountService.account.clientSettings.warningThreshold1;
        vm.warningThreshold2 = AccountService.account.clientSettings.warningThreshold2;
    
        vm.loadData = loadData;
        vm.save = save;
        vm.editThresholds = editThresholds;

        vm.warningsKeyPress = warningsKeyPress;
        vm.warningsKeyUp = warningsKeyUp;
        vm.editWarnings = editWarnings;
        vm.cancelEditWarnings = cancelEditWarnings;
        vm.saveWarnings = saveWarnings;

        vm.editDueDates = editDueDates;
        vm.cancelEditDueDates = cancelEditDueDates;
        vm.saveDueDates = saveDueDates;

        vm.kinds = [];
        vm.warnings1 = [];
        vm.warnings2 = [];
        vm.warningId = undefined;

        vm.dueDates = [];
        vm.dueDateId = undefined;

        this.$onInit = function () {
            vm.loadData();
        };

        function loadData() {
            vm.pending = true;
            DocumentKindsService.load(vm.searchRequest).then(function (data) {
                vm.pending = false;
                for (var i = 0; i < data.length; i++) {
                    var dueDate = data[i].dueDate;
                    if (dueDate) {
                        data[i].dueDate = new Date(dueDate);
                    }
                    vm.dueDates[i] = data[i].dueDate;
                }
                vm.kinds = data;
            });
        }
    
        function save() {
            vm.isLoaderActive = true;
        
            var rows = [];
            angular.forEach(vm.kinds, function(row) {
                var item = {};
                item.documentKindId = row.documentKindId;
                item.enabled = row.enabled;
                item.label = row.label;
                rows.push(item);
            });
    
            DocumentKindsService.updateDocumentKinds({'clientId':vm.clientId, 'dtos': rows}).then(function () {
                vm.isLoaderActive = false;
                ModalService.showSuccessModal().then(
                    function () {
                        vm.loadData();
                    }, function () {
                        vm.loadData();
                    });
            }, function (errResponse) {
                PlagiatValidationService.getModalError(errResponse);
            });
        }
        
        function editThresholds(row) {
            $state.go('edit-thresholds', {documentKindId : row.documentKindId});
        }
        
        function warningsKeyPress(event){
            if (event.target.value.length >= event.target.maxLength || !(event.charCode == 0 || (event.charCode >= 48 && event.charCode <= 57))){
                event.preventDefault();
            }
        }

        function warningsKeyUp(event){
            if (event.target.value.length >= event.target.maxLength){
                event.target.value = event.target.value.slice(0, event.target.maxLength);
            }
        }

        function resetWarnings() {
            if (vm.kinds){
                angular.forEach(vm.kinds, function(kind, index) {
                    vm.warnings1[index] = kind.warning1;
                    vm.warnings2[index] = kind.warning2;
                });
            }
        }

        function editWarnings(row, index, event) {
            vm.clickedElement = event.target;
            if (!vm.clickedElement) return;
            var elementClasses = vm.clickedElement.classList;
            vm.clickedCancelOrSave = elementClasses.contains('icon-save') || elementClasses.contains('icon-cancel');
            if (vm.clickedCancelOrSave){
                return;
            }
            vm.warningId = row.documentKindId;
        }

        function cancelEditWarnings(){
            vm.warningId = undefined;
            resetWarnings();
        }

        function saveWarnings(user, index){
            vm.warningsSaving = true;
            vm.form = {
                documentKindId: vm.warningId,
                warning1: vm.warnings1[index],
                warning2: vm.warnings2[index]
            };
            DocumentKindsService.saveThresholds(vm.form).then(function() {
                vm.warningId = undefined;
                vm.warningsSaving = false;
                vm.kinds[index].warning1 = vm.warnings1[index];
                vm.kinds[index].warning2 = vm.warnings2[index];
                vm.kinds[index].enabled = true;
            }, function(response){
                vm.warningId = undefined;
                vm.warningsSaving = false;
                resetWarnings();
                PlagiatValidationService.getModalError(response.data);
            })
        }

        function resetDueDates() {
            if (vm.kinds){
                angular.forEach(vm.kinds, function(kind, index) {
                    vm.dueDates[index] = kind.dueDate;
                });
            }
        }

        function editDueDates(row, index, event) {
            vm.clickedElement = event.target;
            if (!vm.clickedElement) return;
            var elementClasses = vm.clickedElement.classList;
            vm.clickedCancelOrSave = elementClasses.contains('icon-save') || elementClasses.contains('icon-cancel');
            if (vm.clickedCancelOrSave){
                return;
            }
            vm.dueDateId = row.documentKindId;
        }

        function cancelEditDueDates(){
            vm.dueDateId = undefined;
            resetDueDates();
        }

        function saveDueDates(user, index){
            vm.dueDatesSaving = true;
            var form = {
                documentKindId: vm.dueDateId,
                dueDate: vm.dueDates[index]
            };
            DocumentKindsService.saveDueDate(form).then(function() {
                vm.dueDateId = undefined;
                vm.dueDatesSaving = false;
                vm.kinds[index].dueDate = vm.dueDates[index];
                vm.kinds[index].enabled = true;
            }, function(response){
                vm.dueDateId = undefined;
                vm.dueDatesSaving = false;
                resetDueDates();
                PlagiatValidationService.getModalError(response.data);
            })
        }


    }
})();

(function () {
    'use strict';
    
    angular
        .module('plagiat2017App')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider'];
    
    function stateConfig($stateProvider) {
        $stateProvider
            .state('document-kinds', {
                parent: 'account',
                url: '/document-kinds',
                data: {
                    authorities: ['PERM_USER_ADMIN'],
                    pageTitle: 'global.menu.document-kinds'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/settings/document-kinds/document-kinds-list.template.html',
                        controller: 'DocumentKindsListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('users');
                        $translatePartialLoader.addPart('client');
                        return $translate.refresh();
                    }]
                }
            })
            .state('edit-thresholds', {
                parent: 'document-kinds',
                url: '/:documentKindId/edit-thresholds',
                data: {
                    authorities: ['PERM_USER_ADMIN'],
                    pageTitle: 'global.menu.document-kinds'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/settings/document-kinds/edit-thresholds/edit-thresholds.html',
                        controller: 'EditThresholdsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('users');
                        $translatePartialLoader.addPart('client');
                        return $translate.refresh();
                    }]
                }
            })

        ;
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('DocumentKindsService', DocumentKindsService);
    
    DocumentKindsService.$inject = ['$http', '$q'];

    function DocumentKindsService($http, $q) {

        var service = {
            load: load,
            updateDocumentKinds: updateDocumentKinds,
            getThresholdsForEdit: getThresholdsForEdit,
            saveThresholds: saveThresholds,
            saveDueDate: saveDueDate,
        };
        return service;

        function load() {
            return $http.get('api/client/admin-document-kinds').then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function updateDocumentKinds(obj) {
            return $http.post('/api/client/admin-update-document-kinds', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }
        
        function getThresholdsForEdit(id) {
            return $http.get('/api/client/admin-document-kinds/get-thresholds-for-edit/' + id).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function saveThresholds(obj) {
            return $http.post('/api/client/admin-update-document-kind-thresholds', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }

        function saveDueDate(obj) {
            return $http.put('/api/client/admin-update-document-kind/due-date', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                }
            );
        }
    
    }
})();

(function () {
    'use strict';

    function DatabaseExchangeProgramMembersSearchController($localStorage, SIMPLE_SEARCH_DELAY) {

        var vm = this;
        vm.simpleSearch = true;
        vm.getClients = getClients;
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;

        function getClients() {
            $localStorage.clientListlimit = vm.onQueryRequest.limit;
            vm.onSearchRequest.simpleSearch.length === 0 ? vm.onGetClients() : '';
            vm.onSearchRequest.simpleSearch.length > 2 ? vm.onGetClients() : '';
        }

    }

    angular.module('plagiat2017App')
        .component('databaseExchangeProgramMembersSearch', {
            templateUrl: 'app/account/settings/database-exchange-program-members/database-exchange-program-members-search/database-exchange-program-members-search.template.html',
            controller: DatabaseExchangeProgramMembersSearchController,
            bindings: {
                onGetClients: '<',
                onQueryRequest: '<',
                onSearchRequest: '<',
                onClear: '<'
            }
        });

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('database-exchange-program-members', {
            parent: 'account',
            url: '/database-exchange-program-members',
            data: {
                authorities: ['PERM_USER_ADMIN', 'PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.account.database.exchange.program.members'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/database-exchange-program-members/database-exchange-program-members-list/database-exchange-program-members.html',
                    controller: 'DatabaseExchangeProgramMembersListController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('users');
                	$translatePartialLoader.addPart('client');
                	$translatePartialLoader.addPart('database');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('DatabaseExchangeProgramMembersListController', DatabaseExchangeProgramMembersListController);

    DatabaseExchangeProgramMembersListController.$inject = ['ClientService', 'AccountService', 'SearchRequest', 'DatabaseExchangeProgramMembersSearchRequest', 'DatabaseExchangeProgramMembersQueryRequest', 'tableSettingsRequest', '$localStorage', 'SearchService', 'TableSelectOptions'];

    function DatabaseExchangeProgramMembersListController (ClientService, AccountService, SearchRequest, DatabaseExchangeProgramMembersSearchRequest, DatabaseExchangeProgramMembersQueryRequest, tableSettingsRequest, $localStorage, SearchService, TableSelectOptions) {
        var vm = this;
        vm.activeTab = 'databaseExchangeProgramMembers';
        vm.queryRequest = new DatabaseExchangeProgramMembersQueryRequest();
        vm.queryRequest.limit = $localStorage.clientListlimit ? $localStorage.clientListlimit : vm.queryRequest.limit;
        vm.searchRequest = new SearchRequest();
        vm.DatabaseExchangeProgramMembersSearchRequest = new DatabaseExchangeProgramMembersSearchRequest();
        vm.options = new tableSettingsRequest();
        vm.tableSelectOptions = new TableSelectOptions();
        vm.pagingAction = pagingAction;
        vm.getClients = getClients;
        vm.isDatabaseExchangeProgramMember = undefined;
        vm.showDbExchangeProgramList = !AccountService.getClientSettings().dbExchangeProgramListHidden;
        
        function getClients(){
            vm.searchRequest.pageNumber = vm.queryRequest.page-1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.sortTab = SearchService.sort(vm.queryRequest);
            vm.searchRequest.search = vm.DatabaseExchangeProgramMembersSearchRequest;

            vm.isLoadingData = false;
            vm.isLoaderActive = true;
            ClientService.listDatabaseExchangeProgramMembers(vm.searchRequest).then(function (responseData) {
                vm.responseObj = responseData.content;
                vm.clients = vm.responseObj;
                vm.totalClients = responseData.totalElements;
                vm.isLoaderActive = false;
                vm.isLoadingData = false;
            });
        }
        
        function pagingAction(page) {
            vm.queryRequest.page = page;
            vm.getClients();
        }
        
        if (vm.showDbExchangeProgramList) {
            vm.getClients();
        }
        
        function isDatabaseExchangeProgramMember(){
            ClientService.isDatabaseExchangeProgramMember().then(function (responseData) {
                vm.isDatabaseExchangeProgramMember = responseData.data;
            });
        }
        
        isDatabaseExchangeProgramMember();
        
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('client-logo', {
            parent: 'settings',
            url: '/logo',
            data: {
                authorities: ['PERM_USER_ADMIN'],
                pageTitle: 'global.menu.settings.client-logo.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/client-logo/client-logo.html',
                    controller: 'ClientLogoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('client-logo');
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ClientLogoService', ClientLogoService);

    ClientLogoService.$inject = ['$http', '$q'];

    function ClientLogoService($http, $q) {

        var service = {
            createOrUpdate: createOrUpdate,
            get: get,
            remove: remove
        };

        var requestUrl = '/api/settings/client-logo';
        return service;

        function createOrUpdate(formData) {
            var request = {
                transformRequest: angular.identity,
                transformResponse: angular.identity,
                headers: {
                    'Content-Type': undefined,
                }
            };
            return $http.post(requestUrl, formData, request).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function get() {
            return $http.get(requestUrl).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function remove() {
            return $http.delete(requestUrl).then(
                function () {
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ClientLogoController', ClientLogoController);

    ClientLogoController.$inject = ['ClientLogoService', 'ModalService'];

    function ClientLogoController(ClientLogoService, ModalService) {
        var vm = this;
        vm.activeTab = 'clientLogo';

        vm.clientLogo;

        this.$onInit = function () {
            vm.getClientLogo();
        };

        vm.addFile = function (files) {
            vm.isLoading = true;
            var formData = new FormData();
            formData.append("file", files[0]);
            formData.append("fileName", files[0].name);

            ClientLogoService.createOrUpdate(formData).then(function () {
                vm.isLoading = false;
                vm.getClientLogo();
            }).catch(function (response) {
                vm.isLoading = false;
                ModalService.showErrorModal(response);
            });
        };

        vm.getClientLogo = function () {
            vm.isLoading = true;
            ClientLogoService.get().then(function (response) {
                vm.clientLogo = response;
                vm.isLoading = false;
            });
        };

        vm.removeClientLogo = function () {
            vm.isLoading = true;
            ClientLogoService.remove().then(function () {
                vm.clientLogo = null;
                vm.isLoading = false;
            }, function (response) {
                ModalService.showErrorModal(response);
                vm.isLoading = false;
            });
        };
    }
})();

(function () {
    'use strict';
    
    angular
        .module('plagiat2017App')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider'];
    
    function stateConfig($stateProvider) {
        $stateProvider
            .state('client-group-list', {
                parent: 'account',
                url: '/client-group-list',
                data: {
                    authorities: ['PERM_USER_SUPERADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/settings/client-groups/client-group-list.template.html',
                        controller: 'ClientGroupListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('users');
                        $translatePartialLoader.addPart('client');
                        return $translate.refresh();
                    }]
                }
            })
            .state("client-group-add", {
                parent: "client-group-list",
                url: "/add-edit/:id",
                data: {
                    authorities: ['PERM_USER_SUPERADMIN'],
                    pageTitle: 'client-group.edit.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/settings/client-groups/client-group-add.template.html',
                        controller: 'ClientGroupAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('users');
                        $translatePartialLoader.addPart('client');
                        return $translate.refresh();
                    }]
                }
            })
        ;
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ClientGroupsService', ClientGroupsService);
    
    ClientGroupsService.$inject = ['$http', '$q'];

    function ClientGroupsService($http, $q) {

        var service = {
            search: search,
            getClientGroupForEditing: getClientGroupForEditing,
            saveOrUpdate: saveOrUpdate
        };
        var requestUrl = 'api/client-groups';
        return service;

        function getClientGroupForEditing(id) {
            return $http.get(requestUrl + '/for-editing/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function saveOrUpdate(obj) {
            return $http.post(requestUrl + '/save-or-update', obj).then(
                function () {},
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function search(searchRequest) {
            return $http.post(requestUrl + '/search', searchRequest).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ClientGroupListController', ClientGroupListController);
    
    ClientGroupListController.$inject = ['ClientGroupsService', 'ModalService', 'SearchRequest', 'QueryRequest',
        'SIMPLE_SEARCH_DELAY', '$localStorage'];

    function ClientGroupListController(ClientGroupsService, ModalService, SearchRequest, QueryRequest,
                                    SIMPLE_SEARCH_DELAY, $localStorage) {
        var vm = this;
        vm.activeTab = 'clientGroups';
        vm.pending = false;
    
        vm.loadData = loadData;
        vm.loadPage = loadPage;
        
        vm.keyCodeEnter = KeyCode.KEY_RETURN;
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.queryRequest = new QueryRequest();
        vm.searchRequest = new SearchRequest();
        vm.clientGroups = [];
        vm.clientGroupPage = {};
    
        this.$onInit = function () {
            vm.queryRequest.limit = $localStorage.clientGroupLimit ? $localStorage.clientGroupLimit : vm.queryRequest.limit;
            vm.searchRequest.sortTab = ['id,desc'];
            vm.loadData();
        };

        function loadData() {
            if (vm.clientGroupPage.number) {
                vm.loadPage(vm.clientGroupPage.number);
            } else {
                vm.loadPage(1);
            }
        }

        function loadPage(pageNumber) {
            vm.searchRequest.pageNumber = pageNumber - 1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            $localStorage.clientGroupLimit = vm.queryRequest.limit;
            vm.pending = true;
            ClientGroupsService.search(vm.searchRequest).then(function (clientGroupPage) {
                vm.pending = false;
                vm.clientGroupPage = clientGroupPage;
                vm.clientGroups = clientGroupPage.content;
                vm.clientGroupPage.number++;
                vm.queryRequest.page = vm.clientGroupPage.number;
            });
        }
    
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ClientGroupAddController', ClientGroupAddController);
    
    ClientGroupAddController.$inject = ['ClientGroupsService', 'ModalService',
        '$localStorage', '$state', '$stateParams'];

    function ClientGroupAddController(ClientGroupsService, ModalService,
        $localStorage, $state, $stateParams) {
        var vm = this;
        vm.pending = false;
        vm.activeTab = 'clientGroupList';
        
        vm.obj = {};
        vm.saveOrUpdate = saveOrUpdate;

        this.$onInit = function () {
            vm.pending = true;

            if ($stateParams.id) {
                ClientGroupsService.getClientGroupForEditing($stateParams.id).then(function (obj) {
                    vm.obj = obj.data;
                });
            }
            vm.pending = false;
        };
    
        function saveOrUpdate() {
            ClientGroupsService
                .saveOrUpdate(vm.obj)
                .then(function () {
                    vm.obj = null;
                    ModalService.showSuccessModal("global.messages.success.label");
                    $state.go('client-group-list');
                    $stateParams.id = null;
                }, function (errorResponse) {
                    ModalService.showErrorModal(errorResponse);
                });
        }

    }
})();

(function () {
    'use strict';

    function ApiKeysSearchController($scope, $rootScope, $state, $translate, $mdDialog, $log,
    		apiKeysQueryRequest, apiKeysSearchRequest, $localStorage, SIMPLE_SEARCH_DELAY,
    		ClientService, SearchRequest, QueryRequest, SearchService, ClientQueryRequest, UserService, $q, $timeout,
    		CLIENTSTATUSES) {
        var vm = this;
        vm.simpleSearch = true;
        vm.getData = getData;
        vm.clear = clear;
        vm.goToAddPage = goToAddPage;
        vm.toggleSearch = toggleSearch;
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.querySearchClients = querySearchClients;
        vm.selectedClientChange = selectedClientChange;
        vm.searchRequest = new apiKeysSearchRequest();
        vm.queryRequest = new apiKeysQueryRequest();
        vm.clientQueryRequest = new ClientQueryRequest();
        vm.userQueryRequest = new QueryRequest();
        vm.selectedUserChange = selectedUserChange;
        vm.querySearchUsers = querySearchUsers;
        vm.statuses = CLIENTSTATUSES;
        vm.countries = [];

        this.$onInit = function () {
            onInit();
        };

        function onInit() {
            ClientService.getClientCountries().then(
                function (success) {
                    vm.countries = success.data;
                });
        }


        function goToAddPage() {
            $state.go('apiKeysAdd');
        }
        
        function getData() {
            $localStorage.apiKeysListLimit = vm.onQueryRequest.limit;
            vm.onGetData(vm.onSearchRequest);
        }
        
        function clear() {
            vm.selectedClient = undefined;
            vm.selectedUser = undefined;
            vm.onClear();
        }
        
        function toggleSearch() {
            vm.onSearchRequest.simpleSearch = '';
            vm.simpleSearch = !vm.simpleSearch;
            $localStorage.apiKeysSimpleSearchEnabled = vm.simpleSearch;
        }

        function selectedClientChange(item) {
            if(angular.isDefined(item)) {
                vm.onSearchRequest.search.clientId = item.id;
            } else {
                vm.onSearchRequest.search.clientId = null;
            }
            vm.getData();
        }
        
        function querySearchClients(query) {
            vm.searchRequest.pageNumber = 0;
            vm.searchRequest.pageSize = 20;
            vm.searchRequest.sortTab = SearchService.sort(vm.clientQueryRequest);
            vm.searchRequest.search = query;
            vm.searchRequest.simpleSearch = query;
            
            return ClientService.searchClients(vm.searchRequest).then(function(response) {
                return response.content;
            });
        }
        
        function selectedUserChange(item) {
            if(angular.isDefined(item)) {
                vm.onSearchRequest.search.userId = item.id;
            } else {
                vm.onSearchRequest.search.userId = null;
            }
            vm.getData();
        }
        
        function querySearchUsers(query) {
            if(query.length > 2) {
	            vm.searchRequest.pageNumber = 0;
	            vm.searchRequest.pageSize = 20;
	            vm.searchRequest.sortTab = SearchService.sort(vm.userQueryRequest);
	            vm.searchRequest.search = query;
	            vm.searchRequest.simpleSearch = query;
	            
	            return UserService.searchUsers(vm.searchRequest).then(function(responseData) {
	                 return responseData.content;
	            })
            } else {
            	var deferred = $q.defer();
            	deferred.resolve([]);
            	return deferred.promise;
            }
        }

        
    }

    angular.module('plagiat2017App')
            .component('apKeysSearch', {
                templateUrl: 'app/account/settings/ap-keys/ap-keys-search/ap-keys-search.template.html',
                controller: ApiKeysSearchController,
                bindings: {
                    onGetData: '<',
                    onQueryRequest: '<',
                    onSearchRequest: '<',
                    onClear: '<',
                    simpleSearch: '<',
                }
            });

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('ap-keys', {
            parent: 'account',
            url: '/ap-keys',
            data: {
                authorities: ['PERM_USER_ADMIN', 'PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.settings.api.keys'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/ap-keys/ap-keys-list/ap-keys.html',
                    controller: 'ApiKeysController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('api.keys');
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('client');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ApiKeysController', ApiKeysController);

    ApiKeysController.$inject = ['$translate',
    	'apiKeysQueryRequest', 'apiKeysSearchRequest', 'tableSettingsRequest',
    	'ApiKeysService', 'SearchService', '$mdDialog', 'PlagiatValidationService', '$localStorage',
        'ModalService'];

    function ApiKeysController ($translate,
    		apiKeysQueryRequest, apiKeysSearchRequest, tableSettingsRequest,
    		ApiKeysService, SearchService, $mdDialog, PlagiatValidationService, $localStorage, ModalService) {
        var vm = this;
        vm.activeTab='apiKeys';
        vm.queryRequest = new apiKeysQueryRequest();
        vm.queryRequest.limit = $localStorage.apiKeysListLimit ? $localStorage.apiKeysListLimit : vm.queryRequest.limit;
        vm.searchRequest = new apiKeysSearchRequest();
        vm.options = new tableSettingsRequest();
        vm.selected = [];
        vm.pickedIds = [];
        vm.startPaging = startPaging;
        vm.prepareMapping = prepareMapping;
        vm.getData = getData;
        vm.removeItems = removeItems;
        vm.getDetails = getDetails;
        vm.isApikeyActive = isApikeyActive;
        vm.generateExcelFile = generateExcelFile;
        prepareMapping();
        vm.simpleSearch = true;
        vm.clear = clear;
        
        function clear() {
        	vm.searchRequest = new apiKeysSearchRequest();
        	getData(vm.searchRequest);
        }
        
        function prepareMapping(){
        	getData(vm.searchRequest);
        }
        
        function getData(){
            vm.selected.length = 0;
            vm.showDetailsBlock = false;
            vm.searchRequest.pageNumber = (vm.queryRequest.page - 1);
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.sortTab = SearchService.sort(vm.queryRequest);

            vm.isLoadingData = true;
            ApiKeysService.getApiKeys(vm.searchRequest).then(function (responseData) {

                vm.apiKeys = responseData.content;
                vm.totalElements = responseData.totalElements;
                vm.isLoadingData = false;
            }, function (errResponse) {
                vm.isLoadingData = false;
                PlagiatValidationService.getModalError(errResponse);
            });
        }
        
        function startPaging(page) {
         	vm.isLoadingData = true;
             vm.queryRequest.page = page;
             prepareMapping();
         }
         
        function transformSelectedObj() {
            vm.pickedIds.length = 0;
            angular.forEach(vm.selected, function (value) {
                vm.pickedIds.push(value.id);
            });
        }
        
        function removeItems() {
            ModalService.showConfirmModal('global.confirmremove').then(function(){
                transformSelectedObj();
                ApiKeysService.remove(vm.pickedIds).then(function () {
                    vm.selected.length = 0;
                    prepareMapping();
                }, function (response) {
                	PlagiatValidationService.getModalError(response.data, $translate.instant("global.messages.warning.label"));
                });
            });
        }

        function generateExcelFile() {
            ModalService.showConfirmModal().then(function(){
                transformSelectedObj();
                ApiKeysService.generateExcelFile(vm.pickedIds);
            });
        }
        
        function getDetails(row) {
            vm.showDetailsBlock = false;
            vm.isLoaderActive = true;
            if (row.id !== ApiKeysService.detailsObj.id) {
                vm.pickedElement = row.id;
                ApiKeysService.detailsObj = row;
                vm.showDetailsBlock = true;
                vm.isLoaderActive = false;
                vm.details = row;
            } else {
                vm.isLoaderActive = false;
                ApiKeysService.detailsObj = {};
            }
        }
        
        function isApikeyActive(row) {
            return (row.contractAntyplagiat && row.contractAntyplagiat.status == 0) 
                && (!row.expiryDate || new Date() < row.expiryDate);
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('ap-keys-add', {
            parent: 'account',
            url: '/ap-keys-add',
            data: {
            	authorities: [],
                pageTitle: 'global.menu.api.keys'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/ap-keys/ap-keys-form/ap-keys-form.html',
                    controller: 'ApiKeysAddController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('api.keys');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ApiKeysAddController', ApiKeysAddController);

    ApiKeysAddController.$inject = ['$state', '$mdDialog', 'ApiKeysService', 'PlagiatValidationService', 'ClientService',
    	'SearchRequest', 'QueryRequest', 'SearchService', 'UserService', 'ClientQueryRequest', '$q', '$timeout', 'SIMPLE_SEARCH_DELAY'];

    function ApiKeysAddController ($state, $mdDialog, ApiKeysService, PlagiatValidationService, ClientService,
    		SearchRequest, QueryRequest, SearchService, UserService, ClientQueryRequest, $q, $timeout, SIMPLE_SEARCH_DELAY) {
        var vm = this;
        
        vm.save = save;
        vm.backToMainList = backToMainList;
        vm.querySearchClients = querySearchClients;
        vm.querySearchUsers = querySearchUsers;
        vm.searchRequest = new SearchRequest();
        vm.queryRequest = new QueryRequest();
        vm.clientQueryRequest = new ClientQueryRequest();
        vm.selectedClientChange = selectedClientChange;
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.form = {
            withoutUser: false
        };
        
        ApiKeysService.getDefaultExpiryDate().then(function(response){
        	vm.form.expiryDate = new Date(response.data);
        });

        function backToMainList(){
        	$state.go('ap-keys');
        }
        
        function save(form, ev){
        	var params = {
        			userId: (form.withoutUser ? null : form.selectedUser.id),
        			clientId: form.selectedClient.id,
        			expiryDate: form.expiryDate
        			}
        	ApiKeysService.add(params).then(function(){
        		backToMainList();

                $mdDialog.show(
                        $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .title('')
                        .textContent($translate.instant("api.keys.form.new.msg"))
                        .ariaLabel('msgSuccess')
                        .ok('Ok')
                        .targetEvent(ev)
                        );
        	}, function(response){
        		PlagiatValidationService.getModalError(response.data);
        	})
        }
        
        function querySearchClients(query) {
            vm.searchRequest.pageNumber = 0;
            vm.searchRequest.pageSize = 20;
            vm.searchRequest.sortTab = SearchService.sort(vm.clientQueryRequest);
            vm.searchRequest.search = query;
            vm.searchRequest.simpleSearch = query;
            
            return ClientService.searchClients(vm.searchRequest).then(function(response) {
                return response.content;
            });
        }
        
        function selectedClientChange(item) {
            if(angular.isDefined(item)){
                vm.clientId = item.id;
                vm.form.selectedUser = null;
            } else {
            	vm.clientId = null;
            }
        }

        function querySearchUsers(query) {
            if (query.length > 2){
	        	vm.searchRequest.pageNumber = 0;
	            vm.searchRequest.pageSize = 20;
	            vm.searchRequest.sortTab = SearchService.sort(vm.queryRequest);
	            vm.searchRequest.search = query;
	            vm.searchRequest.simpleSearch = query;
	            vm.searchRequest.clientId =  vm.clientId;
	            
	            return UserService.searchUsersForClient(vm.searchRequest).then(function(responseData) {
	                 return responseData.content;
	            })
            } else {
            	var deferred = $q.defer();
            	deferred.resolve([]);
            	return deferred.promise;
            }
        }

         
    }
})();

(function() {
	'use strict';

	function ApiKeyDetailsController() {

	}

	angular
        .module('plagiat2017App')
        .component(
            'apKeyDetails',
            {
                templateUrl : 'app/account/settings/ap-keys/ap-keys-details/ap-keys-details.template.html',
                controller : ApiKeyDetailsController,
                controllerAs: 'vm',
                bindings: {
                	details: '<'
                }
            }
        );

})();

(function () {
    'use strict';
    function ApiKeysButtonsController($translate, ApiKeysService, PlagiatValidationService, ModalService) {
        var vm = this;
        vm.arrIdis = [];
        vm.invalidate = invalidate;

        function invalidate(ev, id) {
        	var ids = [];
        	ids.push(id);
        	
            ModalService.showConfirmModal('global.confirmremove').then(function(){
                ApiKeysService.invalidate(ids).then(function () {
                    vm.onGetData();
                    
                }, function (response) {
                	PlagiatValidationService.getModalError(response.data, $translate.instant("global.messages.warning.label"));
                });
            });
        }
    }

    angular.module('apKeysButtons', [])
    .component('apKeysButtons', {
        templateUrl: 'app/account/settings/ap-keys/ap-keys-buttons/ap-keys-buttons.template.html',
        controller: ApiKeysButtonsController,
        controllerAs: 'vm',
        bindings: {
        	onGetData: '<',
        	onId: '<'
        }
    });

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin-configuration', {
            parent: 'account',
            url: '/admin-configuration',
            data: {
                authorities: ['PERM_USER_ADMIN'],
                pageTitle: 'global.menu.account.admin.configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/admin-configuration/admin-configuration.html',
                    controller: 'AdminConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('client');
                    $translatePartialLoader.addPart('users');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('AdminConfigurationController', AdminConfigurationController);

    AdminConfigurationController.$inject = [
        'AdminConfigurationService', 'CLIENTTYPECONSTANT', 'COUNTRYCODECONSTANT', 'ClientService',
        'PlagiatValidationService', '$mdDialog', 'AccountService',
        'ModalService', '$translate', 'DetectInstanceService'];

    function AdminConfigurationController (
        AdminConfigurationService, CLIENTTYPECONSTANT, COUNTRYCODECONSTANT, ClientService,
        PlagiatValidationService, $mdDialog, AccountService,
        ModalService, $translate, DetectInstanceService) {

        var vm = this;
        vm.activeTab = 'adminConfiguration';
        vm.clientTypeConstant = CLIENTTYPECONSTANT;

        this.$onInit = function () {
            vm.instance = DetectInstanceService.instance();
            onInit();
        };
        vm.model = {};
        vm.save = save;

        vm.configuration = {
            reportSettings: [
                {label: 'ignoring-bibliography', model: 'ignoringBibliography'},
                {label: 'ignoring-citations', model: 'ignoringCitations'},
                {label: 'warning-thresholds', model: 'warningThresholds'},
                {label: 'report-2020-operator-can-edit', model: 'report2020OperatorCanEdit'},
                {label: 'excluding-citations', model: 'excludingCitations'},
                {label: 'hide-docu-similarity-factor-ext', model: 'hideDocuSimilarityFactorExt'},
                {label: 'show-self-citation-factor', model: 'showSelfCitationFactor'},
                {label: 'show-reversed-similarity-factor', model: 'showReversedSimilarityFactor'},
                {label: 'report-2020-no-submit-button', model: 'report2020NoSubmitButton'},
                {label: 'hide-metadata', model: 'hideMetadata'},
                {label: 'qr-code', model: 'qrCode'},
            ],
            aiDetectionSettings: [
                {label: 'ai-detection-exclude-fragments', model: 'aiDetectionExcludeFragments'},
            ],
            addToDatabase: [
                {value: 'without'},
                {value: 'manually'},
                {value: 'automatically'},
                {value: 'delayed'}
            ],
            otherSettings: [
                {label: 'perm-user-document-verification', model: 'permUserDocumentVerification'},
                {label: 'perm-user-check-document-metric-similarity-before-add', model: 'permUserCheckDocumentMetricSimilarityBeforeAdd'},
                {label: 'send-alert-to-promoter', model: 'sendAlertToPromoter'},
                {label: 'send-alert-to-student', model: 'sendAlertToStudent'},
                {label: 'perm-user-do-not-use-copy-paste', model: 'permUserDoNotUseCopyPaste'},
                {label: 'perm-user-upload-support', model: 'permUserUploadSupport'},
                {label: 'no-document-upload-for-students', model: 'noDocumentUploadForStudents'},
                {label: 'restricting-databases', model: 'restrictingDatabases'},
                {label: 'accept-regulations-enabled', model: 'acceptRegulationsEnabled'},//+ edition of the regulations url
                {label: 'auto-translations-lang-selection', model: 'autoTranslationsLangSelection'},
                {label: 'disable-skip-sites-url', model: 'disableSkipSitesUrl'}
            ],
            jsaOrppdSettings: [
                {label: 'jsa-run-ai-detection', model: 'jsaRunAiDetection'},
            ],
            userSettings: [
                {label: 'allow-edit-document', model: 'allowEditDocument'},
                {label: 'perm-user-cant-see-the-documents-of-others', model: 'permUserCantSeeTheDocumentsOfOthers'},
                {label: 'user-teacher-can-change-promoter', model: 'userTeacherCanChangePromoter'},
                {label: 'perm-user-can-change-organisational-unit', model: 'permUserCanChangeOrganisationalUnit'},
                {label: 'perm-users-can-download-original-file', model: 'permUsersCanDownloadOriginalFile'}
            ],
            uploadPermissions: [
                {label: 'txt-support', model: 'txtSupport'},
                {label: 'pdf-support', model: 'pdfSupport'},
                {label: 'doc-support', model: 'docSupport'},
                {label: 'docx-support', model: 'docxSupport'},
                {label: 'odt-support', model: 'odtSupport'},
                {label: 'rtf-support', model: 'rtfSupport'},
                {label: 'ppt-support', model: 'pptSupport'},
                {label: 'pptx-support', model: 'pptxSupport'},
                {label: 'html-support', model: 'htmlSupport'},
                {label: 'postscript-support', model: 'postscriptSupport'},
                {label: 'wordperfect-support', model: 'wordperfectSupport'}
            ],
            addToDatabaseSettings: [
                {label: 'teacher-cant-delete-from-database', model: 'teacherCantDeleteFromDatabase'},
                {label: 'hide-add-without-checking', model: 'hideAddWithoutChecking'},
                {label: 'only-admin-can-add', model: 'onlyAdminCanAddToDatabase'},
            ],
            rareSettings: [
                {label: 'all-users-can-delete-documents', model: 'allUsersCanDeleteDocuments'},
                {label: 'all-users-can-delete-accounts', model: 'allUsersCanDeleteAccounts'},
                {label: 'hide-user-history', model: 'hideUserHistory'},
                {label: 'no-document-upload-for-students', model: 'noDocumentUploadForStudents'},
                {label: 'document-kind-due-date', model: 'documentKindDueDate'},
                {label: 'coordinator-not-required-by-default', model: 'coordinatorNotRequiredByDefault'}
            ]
        };

        vm.available = function(model) {
            switch (model) {
                case 'userSettingsCard':
                    return isAnyUniversity() || AccountService.clientType.isPublishingHouse();

                    // otherSettings
                case 'permUserDocumentVerification':
                    return isAnyUniversity();
                case 'acceptRegulationsEnabled':
                    return isAnyUniversity();
                case 'permUserCheckDocumentMetricSimilarityBeforeAdd':
                    return isAnyUniversity() || AccountService.clientType.isPublishingHouse() || AccountService.clientType.isSchool();
                case 'noDocumentUploadForStudents':
                    return AccountService.clientType.isSchool();
                case 'sendAlertToPromoter':
                    return isAnyUniversity() || AccountService.clientType.isSchool();
                case 'sendAlertToStudent':
                    return AccountService.clientType.isSchool();
                case 'permUserDoNotUseCopyPaste':
                    return isAnyUniversity() || AccountService.clientType.isPublishingHouse() || AccountService.clientType.isSchool();
                case 'permUserUploadSupport':
                    return isAnyUniversity() || AccountService.clientType.isPublishingHouse() || AccountService.clientType.isSchool();
                case 'autoTranslationsLangSelection':
                    return isAnyUniversity() || AccountService.clientType.isSchool();
                case 'disableSkipSitesUrl':
                    return true;
                    // user settings
                case 'allowEditDocument':
                    return true;
                case 'permUserCantSeeTheDocumentsOfOthers':
                    return isAnyUniversity() || AccountService.clientType.isPublishingHouse();
                case 'userTeacherCanChangePromoter':
                    return isAnyUniversity();
                case 'permUserCanChangeOrganisationalUnit':
                    return isAnyUniversity() || AccountService.clientType.isSchool();
                case 'permUsersCanDownloadOriginalFile':
                    return isAnyUniversity() || AccountService.clientType.isSchool();
                    // jsaOrppdSettings
                case 'jsaOrppdCard':
                    return AccountService.account.clientSettings.jsaIntegration
                        || (AccountService.clientType.isClientTypeUnivAsap() && AccountService.clientCountryId === COUNTRYCODECONSTANT.POLAND_COLUMBIA.id);
                default:
                    return false;
            }
        };

        vm.availableInstance = function(model) {
            switch (model) {
                case 'showSelfCitationFactor':
                    return (vm.instance === 'int');
                default:
                    return true;
            }
        };

        function isAnyUniversity() {
            return AccountService.clientType.isClientTypeUnivStandard() || AccountService.clientType.isCodeAccount() || AccountService.clientType.isClientTypeUnivAsap() ;
        }

        function onInit() {
            vm.isLoading = true;
            AdminConfigurationService.getAdminConfiguration().then(function (success) {
                vm.model = success.data;
                vm.isLoading = false;
            }, function (response) {
                ModalService.showErrorModal(response);
                vm.isLoading = false;
            });
        }
        function save() {
            vm.isSaving = true;

            AdminConfigurationService.save(vm.model.configuration).then(
                function () {
                    vm.isSaving = false;
                    ModalService.showSuccessModal();
                },
                function (response) {
                    vm.isSaving = false;
                    ModalService.showErrorModal(response);
                    $mdToast.show($mdToast.simple().textContent($translate.instant("global.messages.error.label")));
                }
            );
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', 'PlagiatValidationService'];

    function RequestResetController ($timeout, Auth, PlagiatValidationService) {
        var vm = this;

        vm.error = null;
        vm.errorKey = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit({email: vm.resetAccount.email}).then(
            		function () {
            			vm.success = true;
            			vm.error = false;
            		},
            		function (errResponse) {
            			vm.error = true;
            			vm.success = false;
            			vm.errorKey = PlagiatValidationService.getTranslationKeyError(errResponse.data.code);
            		}
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth'];

    function ResetFinishController ($stateParams, $timeout, Auth) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.toggleShowPassword = toggleShowPassword;
        vm.resetAccount = {};
        vm.success = null;
        vm.showPassword = false;
        vm.passwordPattern = Auth.getPasswordPattern();
        
        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.resetAccount.confirmedPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, password: vm.resetAccount.password, newPassword: vm.resetAccount.confirmedPassword}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        function toggleShowPassword() {
            vm.showPassword = !vm.showPassword;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register?lang',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('RegisterController', RegisterController);

    RegisterController.$inject = ['$translate', '$log', '$timeout', '$localStorage',
        'DetectInstanceService', 'Auth', 'UserRegisterRequest', 'UserService'];

    function RegisterController ($translate, $log, $timeout, $localStorage,
                                 DetectInstanceService, Auth, UserRegisterRequest, UserService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.registerObj = new UserRegisterRequest();
        vm.success = null;
        vm.pending = false;
        vm.instance = DetectInstanceService.instance();
        vm.allowFbLogin = DetectInstanceService.getFbLoginForm();
        vm.allowRegister = DetectInstanceService.getAllowRegister();
        vm.passwordPattern = Auth.getPasswordPattern();
        vm.showPassword = false;
        vm.isCapsLockOn = null;
        vm.emailInputHaveWrongDomain = false;
        vm.wrongEmails = ["gmaill.com", "gmall.com", "gmial.com", "gmail.ocm", "gamil.com", "gmail.cojm", "gmal.com",
            "gmal.com", "gnail.com", "gmail.coim", "gmail.pl", "ineria.pl", "02.pl"];

        vm.loginOauth2 = loginOauth2;
        vm.toggleShowPassword = toggleShowPassword;
        vm.register = register;
        vm.regulationsAcceptanceInfo = regulationsAcceptanceInfo;

        $timeout(function (){angular.element('#login').focus();});

        function resetDisplays(){
            vm.success = null;
            vm.error = false;
            vm.errorUserExists = null;
            vm.errorEmailExists = null;
            vm.isReserved = null;
            vm.doNotMatch = null;
        }

        function register(form) {
            for (var i = 0; i < form.$$controls.length; i++) {
                form.$$controls[i].$touched = true;
            }
            if (form.$invalid) {
                return;
            }

            vm.pending = true;
            resetDisplays();
            if (vm.registerObj.password !== vm.registerObj.confirmedPassword) {
                vm.doNotMatch = true;
                vm.error = true;
                vm.pending = false;
            } else {
                vm.registerObj.langKey = $translate.use();
                Auth.createAccount(vm.registerObj).then(function () {
                    vm.success = true;
                    vm.error = false;
                    vm.pending = false;
                }).catch(function (response) {
                    vm.error = true;
                    vm.success = false;
                    vm.pending = false;
                    if (response.data.status === "fail") {
                        if( response.data.code === '004' ) vm.otherError = true;
                        if( response.data.code === '005' ) vm.isReserved = true;
                        if( response.data.code === '006' ) vm.errorEmailExists = true;
                    } else {
                        vm.otherError = true;
                    }
                });
            }
        }
    
        function toggleShowPassword() {
            vm.showPassword = !vm.showPassword;
        }

        function regulationsAcceptanceInfo() {
            var regulationsKey = 'info.instructions.instruction3.url_' + vm.instance;
            var regulationsTranslation = $translate.instant(regulationsKey);
            var companyNameKey = vm.instance === 'ro' ? 'global.company.name.ro' : 'global.company.name';
            var companyNameTranslation = $translate.instant(companyNameKey);
            
            var result = $translate.instant('global.social.regulations-acceptance-info');
            result = result.replace('{regulationsUrl}', regulationsTranslation);
            result = result.replace('{companyName}', companyNameTranslation);
            result =  '<span>' + result + '</span>';
            return result;
        }

        vm.checkCapsLockKey = function (event) {
            vm.isCapsLockOn = event.originalEvent.getModifierState('CapsLock');
        };

        vm.checkEmailDomain = function () {
            vm.emailInputHaveWrongDomain = false;
            if (vm.registerObj.email.match(".") && vm.registerObj.email.match("@")) {
                var emailArray = vm.registerObj.email.split('@');
                if (emailArray.size > 2) {
                    vm.emailInputHaveWrongDomain = true;
                } else {
                    for (var i = 0; i < vm.wrongEmails.length; i++) {
                        if (emailArray[1].toUpperCase().match(vm.wrongEmails[i].toUpperCase())) {
                            vm.emailInputHaveWrongDomain = true;
                        }
                    }
                }
            }
        };

        function loginOauth2(partner) {
            $localStorage.lastSsoPartner = partner;

            UserService.oauth2RedirectionUrl(partner).then(function(data) {
                $.redirect(data.data.url, "GET");
            });

        }

    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ShowPopupService', ShowPopupService);

    ShowPopupService.$inject = [
        '$http', '$q', '$mdDialog', '$localStorage', '$translatePartialLoader', '$translate',
        'AccountService', 'DetectInstanceService', 'PopupAdministrationService'
    ];

    function ShowPopupService(
        $http, $q, $mdDialog, $localStorage, $translatePartialLoader, $translate,
        AccountService, DetectInstanceService, PopupAdministrationService
    ) {
        var openPopups = [];

        var service = {
            action: action
        };
        return service;

        function action() {
            $translatePartialLoader.addPart('popup');
            $translate.refresh();

            PopupAdministrationService.findAllToShowForCurrentUser().then(function (res) {

                var popups = res;
                openPopups = [];
                for (var i = 0; i < popups.length; i++) {
                    if (shouldShowPopup(popups[i].id)) {
                        openPopups.push({ modal: showModal(popups[i]), popupId: popups[i].id });
                    }
                }
            });
        }

        function close(popupId) {
            var popupIdToRemove = -1;
            for ( var i=0; i< openPopups.length; i++) {
                if (openPopups[i].popupId === popupId) {
                    $mdDialog.cancel(openPopups[i].modal);
                    popupIdToRemove = i;
                    break;
                }
            }
            if (popupIdToRemove >= 0) {
                openPopups.slice(popupIdToRemove, 1);
            }
        }

        function showModal(popup) {
            return $mdDialog.show({
                controller: 'PopupController',
                controllerAs: 'vm',
                templateUrl: 'app/account/popup/popup.template.html',
                clickOutsideToClose: true,
                locals: {
                    popup: popup,
                    closeCallback: close
                },
                multiple: true
            });
        }

        function shouldShowPopup(popupId) {
            var hidePopup = checkLocalStorage(popupId);
            return !hidePopup;
        }

        function checkLocalStorage(popupId) {
            if (!$localStorage.dontShowPopupMap) {
                $localStorage.dontShowPopupMap = {};
            }
            return $localStorage.dontShowPopupMap[popupId];
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('PopupCallMeWithTelController', PopupCallMeWithTelController);

    function PopupCallMeWithTelController($mdDialog, ModalService, PopupAdministrationService, popup, closeCallback) {
        var vm = this;
        vm.popup = popup;
        vm.tel = '';
        vm.gdpr = false;

        this.callMeWithTelEnd = function() {
            close();
            closeCallback(vm.tel);
        }

        this.close = function() {
            $mdDialog.hide();
        }

        this.buttonDisabled = function () {
            return (vm.tel === null) || (vm.tel === undefined) || (vm.tel === '') || (!vm.gdpr);
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('PopupController', PopupController);

    function PopupController($mdDialog, ModalService, PopupAdministrationService, popup, $localStorage, closeCallback) {
        var vm = this;
        vm.popup = popup;
        vm.closePopup = closeCallback;

        vm.close = function () {
            vm.closePopup(popup.id);
        };

        vm.dontShowAgain = function () {
            if (!$localStorage.dontShowPopupMap) {
                $localStorage.dontShowPopupMap = {};
            }
            $localStorage.dontShowPopupMap[vm.popup.id] = true;
            vm.close();
        };

        vm.callMe = function () {
            closeCallMeWithTel('');
        };

        function closeCallMeWithTel(telephone) {
            vm.pending = true;
            PopupAdministrationService.orderContactByRegularPopup(vm.popup.id, telephone).then(function () {
                    vm.pending = false;
                    vm.dontShowAgain();
                    ModalService.showSuccessModal("popup.order-contact.success");
                }, function () {
                    vm.pending = false;
                    vm.close();
                }
            );
        }

        vm.callMeWithTel = function () {

            $mdDialog.show({
                controller: 'PopupCallMeWithTelController',
                controllerAs: 'vm',
                templateUrl: 'app/account/popup/popup-call-me-with-tel.template.html',
                clickOutsideToClose: true,
                locals: {
                    popup: popup,
                    closeCallback: closeCallMeWithTel
                },
                multiple: true
            });

        };
    }

})();

(function () {
    'use strict';

    function PaymentsSuperadminSearchController($scope, $localStorage, SearchService, DateService,
        PaymentsRequest, PaymentsQueryRequest, $q, _, $timeout, PaymentsService, 
                                                SIMPLE_SEARCH_DELAY, PAYMENT_TYPE_CONSTANT, PAYMENT_STATUS_CONSTANT) {

        var vm = this;
        vm.getPayments = getPayments;
        vm.fixDate = DateService.fixDate;
        vm.toggleSearch = toggleSearch;
        vm.clear = clear;
        vm.searchRequest = new PaymentsRequest();
        vm.queryRequest = new PaymentsQueryRequest();
        vm.querySearch = querySearch;
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.paymentTypes = PAYMENT_TYPE_CONSTANT;
        vm.paymentStatuses = PAYMENT_STATUS_CONSTANT;

        function toggleSearch() {
            vm.onSearchRequest.simpleSearch = '';
            vm.simpleSearch = !vm.simpleSearch;
            $localStorage.paymentsSimpleSearchEnabled = vm.simpleSearch;
        }

        function clear() {
            vm.onClear();
        }

        function getPayments() {
            $localStorage.paymentsListlimit = vm.onQueryRequest.limit;
            vm.onGetPayments();
        }

        function querySearch(query) {
            if (query.length > 2) {
                vm.searchRequest.pageNumber = 0;
                vm.searchRequest.pageSize = 20;
                vm.searchRequest.sortTab = SearchService.sort(vm.queryRequest);
                vm.searchRequest.search = query;
                vm.searchRequest.simpleSearch = query;

                return PaymentsService.searchPayments(vm.searchRequest).then(function (response) {
                    return response.content;
                })
            } else {
                var deferred = $q.defer();
                $timeout(function () {
                    deferred.resolve([]);
                }, 1200, false);
                return deferred.promise;
            }
        }

    }

    angular.module('plagiat2017App')
        .component('paymentsSuperadminSearch', {
            templateUrl: 'app/account/payments/payments-superadmin-search/payments-superadmin-search.template.html',
            controller: PaymentsSuperadminSearchController,
            bindings: {
                onGetPayments: '<',
                onQueryRequest: '<',
                onSearchRequest: '<',
                onClear: '<',
                simpleSearch: '<',
            }
        });

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('payments-superadmin', {
            parent: 'app',
            url: '/payments-superadmin',
            data: {
                authorities: ['PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.payments'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/payments/payments-superadmin/payments-superadmin.html',
                    controller: 'PaymentsSuperadminController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'paymentDate,desc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('payments');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
	'use strict';

	angular.module('plagiat2017App').controller('PaymentsSuperadminController',
			PaymentsSuperadminController);

	PaymentsSuperadminController.$inject = [ '$localStorage', 'PaymentsQueryRequest', 'tableSettingsRequest',
		'PaymentsRequest', 'SearchService', 'PaymentsService', 'PlagiatValidationService', 'ModalService', 'InvoicesService',
        'PAYMENT_STATUS_CONSTANT', 'INVOICE_STATUS_CONSTANT'];

	function PaymentsSuperadminController($localStorage, PaymentsQueryRequest, tableSettingsRequest,
			PaymentsRequest, SearchService, PaymentsService, PlagiatValidationService, ModalService, InvoicesService,
                                          PAYMENT_STATUS_CONSTANT, INVOICE_STATUS_CONSTANT) {
		var vm = this;
        vm.activeTab = 'paymentsSuperadmin';

		vm.queryRequest = new PaymentsQueryRequest();
        vm.queryRequest.limit = $localStorage.paymentsListlimit ? $localStorage.paymentsListlimit : vm.queryRequest.limit;
        vm.searchRequest = new PaymentsRequest();
        vm.options = new tableSettingsRequest();
        vm.downloadInvoice = downloadInvoice;
        vm.markAsCanceled = markAsCanceled;
		vm.getPayments = getPayments;
		vm.searchPayments = searchPayments;
		vm.pagingAction = pagingAction;
        vm.createDraftInvoiceFromPayment = createDraftInvoiceFromPayment;
		vm.clear = clear;
		vm.simpleSearch = false;
        vm.paymentStatuses = PAYMENT_STATUS_CONSTANT;
        vm.invoiceStatuses = INVOICE_STATUS_CONSTANT;

        this.$onInit = function () {
            if ($localStorage.paymentsSuperadminSearch) {
                vm.searchRequest.search = $localStorage.paymentsSuperadminSearch;
            }
            if ($localStorage.paymentsSuperadminSimpleSearch) {
                vm.simpleSearch = $localStorage.paymentsSuperadminSimpleSearch;
            }

        }

        function searchPayments(){
            vm.queryRequest.page = 1;
            getPayments(); 
        }

        function getPayments(){
            vm.showDetailsBlock = false;
            vm.searchRequest.pageNumber = vm.queryRequest.page-1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.sortTab = SearchService.sort(vm.queryRequest);
            vm.isLoaderActive = true;

            $localStorage.paymentsSuperadminSimpleSearch = vm.simpleSearch;
            $localStorage.paymentsSuperadminSearch = vm.searchRequest.search;

            PaymentsService.getPaymentsForSuperadmin(vm.searchRequest).then(function (responseData) {
                vm.responseObj = responseData.content;
                vm.payments = vm.responseObj;
                vm.totalPayments = responseData.totalElements;
                vm.isLoaderActive = false;
            });
        }

        function pagingAction(page) {
        	vm.isLoaderActive = true;
            vm.queryRequest.page = page;
            vm.getPayments();
        }
		
        function searchPayments() {
            vm.queryRequest.page = 1;
            vm.getPayments();
        }

        function clear() {
        	vm.searchRequest = new PaymentsRequest();
            vm.getPayments();
        }
        
        function downloadInvoice(invoiceNumber) {
            PaymentsService.downloadInvoice(invoiceNumber).then(
                function () {},
                function (response) {
                    PlagiatValidationService.getModalError(response.data);
                });
        }

        function createDraftInvoiceFromPayment(payment) {
            ModalService.showConfirmModal().then(function () {
                vm.isLoaderActive = true;
                InvoicesService.createDraftInvoiceFromPayment(payment.providerTransactionId).then(
                    function () {
                        vm.getPayments();
                        ModalService.showSuccessModal();
                    },
                    function (response) {
                        PlagiatValidationService.getModalError(response.data);
                        vm.isLoaderActive = false;
                    });
            });

        }

        function markAsCanceled(payment) {
            ModalService.showConfirmModal().then(function () {
                vm.isLoaderActive = true;
                PaymentsService.markAsCanceled(payment.providerTransactionId).then(
                    function () {
                        vm.getPayments();
                        ModalService.showSuccessModal();
                    },
                    function (response) {
                        PlagiatValidationService.getModalError(response.data);
                        vm.isLoaderActive = false;
                    });
            });
            
        }
        
        vm.getPayments();

	}
})();

(function () {
    'use strict';
    
    PaymentsMenuController.$inject = ['AccountService'];

    function PaymentsMenuController(AccountService) {
        var vm = this;
        vm.isSuperAdmin = AccountService.role.isSuperAdmin();
    }

    angular.module('plagiat2017App')
    .component('paymentsMenu', {
        templateUrl: 'app/account/payments/payments-menu/payments-menu.template.html',
        controller: PaymentsMenuController,
        bindings: {
        	activeTab: '<'
        }
    });

})();

(function () {
    'use strict';

    function PaymentsListController($localStorage, $translate,
                                    ModalService, PaymentsService) {
        var vm = this;
        vm.documentRequest = {};
        vm.searchRequest = {};
        vm.showPayments = vm.onGetKey;
        vm.tooglePayments = tooglePayments;
        vm.clear = clear;
        vm.getPayments = getPayments;
        vm.downloadInvoice = downloadInvoice;
        vm.selected = [];
        vm.promise;
        vm.dateNow = new Date();
        vm.dateFormat = 'YYYY-MM-DD HH:mm';

        vm.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: false,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: false,
            limitSelect: true,
            pageSelect: false
        };


        vm.query = {
            order: '-paymentDate',
            limit: $localStorage.paymentListLimit ? $localStorage.paymentListLimit : 5,
            page: 1,
            search: vm.searchRequest
        };

        vm.startPaging = startPaging;
        vm.goTo = goTo;
        vm.changeLimit = changeLimit;
        vm.onGetPayments = onGetPayments;

        vm.tableProperties = {};

        this.$onInit = function () {
            vm.showPayments = vm.onGetKey;
            if (vm.showPayments) {
                vm.getPayments();
            }
        };

        function goTo() {
            vm.getPayments();
        }

        function startPaging(page) {
            vm.query.page = page;
            vm.getPayments();
        }

        function changeLimit(n) {
            vm.query.limit = n;
            vm.getPayments();
        }
        
        function downloadInvoice(payment) {

            if (payment.invoiceStatus === 2) {
                PaymentsService.downloadInvoice(payment.invoiceNumber).then(
                    function () {},
                    function (response) {
                        PlagiatValidationService.getModalError(response.data);
                    });
            } else {
                ModalService.showErrorModal({data: {code: 136}});
            }

        }

        function getPayments() {
            $localStorage.paymentListLimit = vm.query.limit;
            var reverse = vm.query.order.slice(0, 1);
            if (reverse === '-') {
                var _length = vm.query.order.length;
                vm.tableProperties.sort = {
                    predicate: vm.query.order.slice(1, _length),
                    reverse: false
                };
            } else {
                vm.tableProperties.sort = {
                    predicate: vm.query.order,
                    reverse: true
                };
            }
            vm.tableProperties.paging = {
                page: vm.query.page,
                limit: vm.query.limit
            };

            vm.tableProperties.search = vm.searchRequest;

            vm.onGetPayments(vm.tableProperties);
        }

        function clear() {
            vm.searchRequest = {};
            getPayments();
        }

        function tooglePayments() {
            !(vm.showPayments) ? getPayments() : '';
            vm.showPayments = !vm.showPayments;
        }

        function onGetPayments(obj) {
            vm.predicate = obj.sort.predicate;
            vm.reverse = obj.sort.reverse;
            vm.page = obj.paging.page;
            vm.itemsPerPage = obj.paging.limit;
            vm.search = obj.search;
            PaymentsService.get({
                pageNumber: (vm.page - 1),
                pageSize: vm.itemsPerPage,
                sortTab: sort(),
                search: vm.search
            }, onSuccess, onError).then(function (responseData) {
                var responseObj = responseData.content;
                angular.forEach(responseObj, function (value, key) {
                    value.providerStatusId = value.providerStatus;
                    value.providerStatusTooltipKey = value.providerStatus.replace('payment.status', 'payments.status.tooltip');
                    value.providerStatus = $translate.instant("payments." + value.providerStatus);
                    value.userPaymentType = $translate.instant("payments." + value.userPaymentType);
                    value.paymentDate = value.paymentDate ? moment(value.paymentDate).format(vm.dateFormat) : value.paymentDate;
                    value.codeExpiryDate = value.codeExpiryDate ? moment(value.codeExpiryDate).format('YYYY-MM-DD') : value.codeExpiryDate;
                    value.codeUseDate = value.codeUseDate ? moment(value.codeUseDate).format(vm.dateFormat) : value.codeUseDate;
                });
                vm.payments = responseObj;
                vm.totalPayments = responseData.totalElements;
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.payments = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

    }

    angular.module('paymentsList', [])
    .component('paymentsList', {
        templateUrl: 'app/account/payments/payments-list/payments-list.template.html',
        controller: PaymentsListController,
        controllerAs: 'vm',
        bindings: {
            onGetKey: '=',
            onCodePayments: '='
        }
    });

})();

(function () {
  'use strict';

	function PaymentsInvoicesDetailsController(DetectInstanceService) {
		var vm = this;
    vm.detectedInstance = DetectInstanceService.instance();
    vm.isRomania = vm.detectedInstance === 'ro';
	}

  angular
    .module('plagiat2017App')
    .component('paymentsInvoicesDetails', {
      templateUrl: 'app/account/payments/payments-invoices-details/payments-invoices-details.template.html',
			controller : PaymentsInvoicesDetailsController,
      bindings: {
        onInvoice: '<',
        onInvoiceDetails: '<'
      }
    });
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('payments-invoices', {
            parent: 'app',
            url: '/payments-invoices',
            data: {
                authorities: ['PERM_USER_SUPERADMIN'],
                pageTitle: 'global.menu.payments'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/payments/payments-invoices/payments-invoices.html',
                    controller: 'PaymentsInvoicesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('payments');
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('users');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('plagiat2017App').controller('PaymentsInvoicesController',
        PaymentsInvoicesController);

    PaymentsInvoicesController.$inject = ['$localStorage', 'InvoicesQueryRequest', 'tableSettingsRequest',
        'SearchRequest', 'SearchService', 'InvoicesService', 'ModalService', 'PaymentsService', 'DetectInstanceService',
        'PlagiatValidationService', 'INVOICE_STATUS_CONSTANT', '$translate', '$mdDialog', 'CountryModel', 'PAYMENT_TYPE_CONSTANT',
        'COUNTRYCODECONSTANT', 'DateService'];

    function PaymentsInvoicesController($localStorage, InvoicesQueryRequest, tableSettingsRequest,
                                        SearchRequest, SearchService, InvoicesService, ModalService, PaymentsService, DetectInstanceService,
                                        PlagiatValidationService, INVOICE_STATUS_CONSTANT, $translate, $mdDialog, CountryModel,
                                        PAYMENT_TYPE_CONSTANT, COUNTRYCODECONSTANT, DateService) {
        var vm = this;
        vm.activeTab = 'paymentsInvoices';

        vm.queryRequest = new InvoicesQueryRequest();
        vm.queryRequest.limit = $localStorage.invoicesListlimit ? $localStorage.invoicesListlimit : vm.queryRequest.limit;
        vm.searchRequest = new SearchRequest();
        vm.searchRequest.search.status = 1;
        vm.searchRequest.search.romanian = DetectInstanceService.instance() === 'ro';
        vm.options = new tableSettingsRequest();
        vm.selected = [];
        vm.pickedIds = [];
        vm.selectedIdsContainAnInvalidEmail = false;
        vm.pickedInvoice = false;
        vm.showDetailsBlock = false;
        vm.details = {};
        vm.invoiceDetailsObj = {};
        vm.simpleSearch = true;
        vm.invoiceStatuses = INVOICE_STATUS_CONSTANT;
        vm.paymentTypes = PAYMENT_TYPE_CONSTANT;
        vm.fixDate = DateService.fixDate;

        vm.getInvoices = getInvoices;
        vm.processIssueInvoice = processIssueInvoice;
        vm.downloadInvoice = downloadInvoice;
        vm.markInvoiceAsIssued = markInvoiceAsIssued;
        vm.markInvoiceAsWaiting = markInvoiceAsWaiting;
        vm.markInvoiceAsIncorrect = markInvoiceAsIncorrect;
        vm.processGenerateBulkInvoice = processGenerateBulkInvoice;
        vm.selectInvoice = selectInvoice;
        vm.pagingAction = pagingAction;
        vm.clear = clear;
        vm.getInvoiceDetails = getInvoiceDetails;
        vm.editCompletedInvoice = editCompletedInvoice;
        vm.updateIssue = updateIssue;

        function getInvoices() {
            clearSelection();
            vm.showDetailsBlock = false;
            vm.searchRequest.pageNumber = vm.queryRequest.page - 1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.sortTab = SearchService.sort(vm.queryRequest);
            vm.isLoaderActive = true;
            InvoicesService.getInvoicesForSuperadmin(vm.searchRequest).then(function (responseData) {
                vm.responseObj = responseData.content;
                vm.invoices = vm.responseObj;
                vm.totalInvoices = responseData.totalElements;
                vm.isLoaderActive = false;
            });
        }

        function getInvoiceDetails(row) {
            vm.showDetailsBlock = false;

            if (row.id !== vm.invoiceDetailsObj.id) {
                vm.pickedInvoice = row.id;
                vm.invoiceDetailsObj = row;
                InvoicesService.getInvoiceDetails(row.id).then(function (result) {
                    vm.showDetailsBlock = true;
                    vm.details = result.data;
                });
            } else {
                vm.invoiceDetailsObj = {};
            }
        }

        function pagingAction(page) {
            vm.isLoaderActive = true;
            vm.queryRequest.page = page;
            vm.getInvoices();
        }

        function clear() {
            vm.searchRequest = new SearchRequest();
            vm.getInvoices();
        }

        function markInvoiceAsIssued(invoice) {
            ModalService.showConfirmModal().then(function () {
                vm.isLoaderActive = true;
                InvoicesService.markInvoiceAsIssued(invoice.id).then(
                    function () {
                        vm.getInvoices();
                        ModalService.showSuccessModal();
                    },
                    function (response) {
                        PlagiatValidationService.getModalError(response.data);
                        vm.isLoaderActive = false;
                    });
            });
        }
    
        function markInvoiceAsWaiting(invoice) {
            ModalService.showConfirmModal().then(function () {
                vm.isLoaderActive = true;
                InvoicesService.markInvoiceAsWaiting(invoice.id).then(
                    function () {
                        vm.getInvoices();
                        ModalService.showSuccessModal();
                    },
                    function (response) {
                        PlagiatValidationService.getModalError(response.data);
                        vm.isLoaderActive = false;
                    });
            });
        }

        function markInvoiceAsIncorrect(invoice) {
            ModalService.showConfirmModal().then(function () {
                vm.isLoaderActive = true;
                InvoicesService.markInvoiceAsIncorrect(invoice.id).then(
                    function () {
                        vm.getInvoices();
                        ModalService.showSuccessModal();
                    },
                    function (response) {
                        PlagiatValidationService.getModalError(response.data);
                        vm.isLoaderActive = false;
                    });
            });
        }

        function processGenerateBulkInvoice() {
            transformSelectedObj();
            generateBulkInvoice();
        }
    
        function generateBulkInvoice() {
            ModalService.showConfirmModal(null,
                vm.selectedIdsContainAnInvalidEmail ? {customWarning: $translate.instant("payments.invoice.warning.user.deleted")} : null)
                .then(function() {
                vm.isLoaderActive = true;
                InvoicesService.generateBulkInvoice(vm.pickedIds).then(
                    function () {
                        clearSelection();
                        vm.getInvoices();
                        ModalService.showSuccessModal();
                    },
                    function (response) {
                        PlagiatValidationService.getModalError(response.data);
                        vm.isLoaderActive = false;
                    });
            });
        }

        function processIssueInvoice(invoice) {
            InvoicesService.getInvoiceDetails(invoice.id).then(function (invoiceData) {
                issueInvoice(invoice, getCustomWarning(invoice, invoiceData));
            })
        }
    
        function issueInvoice(invoice, warnings) {
            ModalService.showConfirmModal(null, {customWarning: warnings})
                .then(function () {
                vm.isLoaderActive = true;
                InvoicesService.issueInvoice(invoice.id).then(
                    function () {
                        vm.getInvoices();
                        ModalService.showSuccessModal();
                    },
                    function (response) {
                        PlagiatValidationService.getModalError(response.data);
                        vm.isLoaderActive = false;
                    });
            });
        }

        function updateIssue(invoice) {
            ModalService.showConfirmModal().then(function () {
                    vm.isLoaderActive = true;
                    InvoicesService.updateIssue(invoice).then(
                        function () {
                            vm.getInvoices();
                            ModalService.showSuccessModal();
                        },
                        function (response) {
                            PlagiatValidationService.getModalError(response.data);
                            vm.isLoaderActive = false;
                        });
                });
        }
    
        function downloadInvoice(invoiceNumber) {
            PaymentsService.downloadInvoice(invoiceNumber).then(
                function () {},
                function (response) {
                    PlagiatValidationService.getModalError(response.data);
                });
        }
    
        function transformSelectedObj() {
            vm.pickedIds.length = 0;
            vm.selectedIdsContainAnInvalidEmail = false;
            angular.forEach(vm.selected, function (value) {
                if(!value.email.includes("@")){
                    vm.selectedIdsContainAnInvalidEmail = true;
                }
                vm.pickedIds.push(value.id);
            });
        }
    
        function selectInvoice(invoice) {
            if (invoice.status !== vm.invoiceStatuses.INVOICE_STATUS_WAITING.id
            && invoice.status !== vm.invoiceStatuses.INVOICE_STATUS_PAID.id) { // pozwalamy na zaznaczanie tylko ze statusem 3 oraz 0
                vm.selected = vm.selected.filter(function(el) {
                    return el.id !== invoice.id;
                });
            }
        }

        function editCompletedInvoice(invoice) {
            InvoicesService.getInvoiceDetails(invoice.id).then(function (result) {
                vm.invoice = result.data;
                $mdDialog.show({
                    templateUrl: 'app/account/payments/payments-invoices/payments-invoice.template.html',
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    controllerAs: 'vm',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payments');
                            $translatePartialLoader.addPart('country');
                            return $translate.refresh();
                        }]
                    },
                    locals: {
                        data: result.data
                    },
                    controller: function ($mdDialog, data) {
                        this.invoice = data;
                        this.isCompany = !!data.nip;
                        this.invoice.company = data.purchaser;
                        this.isRomania = vm.instanceLang === 'ro';
                        this.isPoland = vm.instanceLang === 'pl';
                        this.countries = new CountryModel();
                        if(this.isRomania){
                            this.invoice.country = COUNTRYCODECONSTANT.ROMANIA.code;
                        }
                        this.saveInvoice = function () {
                            if (!this.isCompany) {
                                this.invoice.nip = null;
                            }
                            vm.updateIssue(this.invoice)
                        }
                        this.closeDialog = function () {
                            $mdDialog.hide();
                        }
                    }
                })
            });
        }

        function getCustomWarning(invoice, invoiceData) {
            var warnings = '';

            if (!invoice.email.includes("@")) {
                warnings += $translate.instant("payments.invoice.warning.user.deleted");
            }

            if (!invoiceData.data.purchaser.length > 1) {
                if (warnings !== '') {
                    warnings += '. ';
                }
                warnings += $translate.instant("payments.payme.error.wrong-amount") + ': ' + $translate.instant("payments.table.invoice.purchaser");
            }
            if (!invoiceData.data.street) {
                if (warnings !== '') {
                    warnings += '. ';
                }
                warnings += $translate.instant("global.validation.required") + ': ' + $translate.instant("payments.metric.address.street");
            }
            if (!invoiceData.data.country && !invoiceData.data.county) {
                if (warnings !== '') {
                    warnings += '. ';
                }
                warnings += $translate.instant("global.validation.required") + ': ' + $translate.instant("payments.metric.address.invoice-country");
            }
            if (!invoiceData.data.city) {
                if (warnings !== '') {
                    warnings += '. ';
                }
                warnings += $translate.instant("global.validation.required") + ': ' + $translate.instant("payments.metric.address.city");
            }
            return warnings;
        }

        function clearSelection() {
            vm.selected = [];
            vm.pickedIds = [];
            vm.selectedIdsContainAnInvalidEmail = false;
        }

        vm.getInvoices();

    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('payments', {
            parent: 'app',
            url: '/payments?key&documentId',
            data: {
                authorities: ['PERM_USER_ALL_PAYMENTS', 'PERM_USER_PAYMENT'],
                pageTitle: 'global.menu.payments'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/payments/payments.html',
                    controller: 'PaymentsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'paymentDate,desc',
                    squash: true
                }
            },
            onEnter: ['$state', '$stateParams', 'AccountService', function ($state, $stateParams,  AccountService) {
                if (AccountService.clientType.isCodeAccount()) {
                    $state.go('code-payments', $stateParams);
                }
            }],
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('payments');
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('users');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .controller('PaymentsController', PaymentsController);

    PaymentsController.$inject = ['$rootScope', '$stateParams', '$state', '$timeout', '$translate', '$window',
        'PaymentsService', '$mdDialog', 'pagingParams', 'paginationConstants', 'AlertService', 'TokenService', '$log', 'InstanceService'];

    function PaymentsController($rootScope, $stateParams, $state, $timeout, $translate, $window, 
                                PaymentsService, $mdDialog, pagingParams, paginationConstants, AlertService, TokenService, $log, InstanceService) {
        var vm = this;

        vm.key = $stateParams.key;
        vm.documentId = $stateParams.documentId;
        moment.locale(InstanceService.instance().lang);

        vm.timezone = InstanceService.instance().timezonePayments;

        vm.pending = false;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.success = null;
        vm.uploadIsActive = false;
        vm.uploadObj = {};
        vm.smsStatuses = { statuses: {}, codesNotValid: [] };
        vm.notValidSms = { codes: []};
        vm.formdata = new FormData();
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = pagingParams.page;
        vm.search = {};
        vm.paymentRedirectionFormContainerId = 'paymentRedirectionFormContainer';
        vm.paymentParams = null;
        vm.price = 0;
        vm.tokenPrice = {
            price: 0,
            quantity: 0
        };
        vm.invoiceInfo = {};

        vm.initPayment = initPayment;
        vm.paymentRedirect = paymentRedirect;
        vm.getPaymentParams = getPaymentParams;
        vm.submitMe = submitMe;
        vm.getPrice = getPrice;
        vm.getLastInvoiceInfo = getLastInvoiceInfo;
        vm.getPaymentMethods = getPaymentMethods;

        function getPaymentMethods() {
            PaymentsService.getPaymentMethods().then(function (responseData) {
                vm.paymentMethods = responseData.data.methodsOfPayment;
            });
        }

        function afterPayment() {
            
            if (vm.key === 'success' || vm.key === 'error') {
                var dialogContent = (vm.key === 'error') ? "payments.paymenterror" : "payments.paymentok";
                $rootScope.$broadcast("availableTokens");
                var confirm = $mdDialog.confirm()
                .title('')
                .clickOutsideToClose(true)
                .htmlContent($translate.instant(dialogContent))
                .ariaLabel('')
                .ok('Ok')
                .openFrom('#left');
                $mdDialog.show(confirm).then(function (result) {
                });
            }
        }

        function getLastInvoiceInfo() {
            vm.pending = true;
            PaymentsService.getLastInvoiceInfo().then(function (responseData) {
                vm.invoiceInfo = responseData.data;
                vm.pending = false;
            });
        }

        function getPrice(obj) {
          PaymentsService.getPrice(obj).then(function (responseData) {
            if (responseData.data.price === null) {
                vm.price = 0;
                vm.tokenPrice = {
                    price: 0
                };
            } else {
                vm.price = responseData.data.price;
                vm.tokenPrice = responseData.data;
                vm.tokenPrice.singlePrice = (responseData.data.price/responseData.data.quantity).toFixed(2);
            }
          });
        }

        function trackFbPixel(paymentObj) {
            if ($window.fbq) {
                $window.fbq('track', 'InitiateCheckout', {currency: paymentObj.currency, value: vm.price});
                // console.log('InitiateCheckout tracked! value=' + vm.price);
            }
        }

      function initPayment(paymentObj) {
        trackFbPixel(paymentObj);
        PaymentsService.pay(paymentObj).then(function (responseData) {
            if (responseData.data.paymentRedirectionParams !== null) {
                paymentRedirect(responseData.data);
            } else {
                paymentComplete(responseData.data);
            }
        }, function (responseError) {
            if (responseError.status === 400) {
                        $mdDialog.show(
                            $mdDialog.confirm()
                            .clickOutsideToClose(true)
                            .textContent(responseError.data.message)
                            .ariaLabel('ok')
                            .ok('OK')
                            );
            }
        });
    }

    function paymentRedirect(paymentResponse) {
            
      $mdDialog.show(
        $mdDialog.alert()
        .parent(angular.element(document.querySelector('#popupContainer')))
        .clickOutsideToClose(false)
        .title($translate.instant("global.messages.info.redirect"))
        .textContent($translate.instant("global.messages.info.redirect"))
        .ariaLabel($translate.instant("global.messages.info.redirect"))
        .ok($translate.instant("global.button.cancel"))
        );

      if(paymentResponse.userPaymentType==='TYPE_KASSA_24'){
       	 window.location = paymentResponse.formAction;
       	 return;
      }

      if(paymentResponse.userPaymentType==='TYPE_KASSA_24_CARD'){
       	 window.location = paymentResponse.formAction;
       	 return;
      }

      if (paymentResponse.userPaymentType === 'TYPE_FORTE_KZ') {
       	 window.location = paymentResponse.formAction;
       	 return;
      }

      vm.paymentParams = paymentResponse.paymentRedirectionParams;
      var $redirectFormContainer = angular.element('#paymentForm');
      var $redirectForm = $redirectFormContainer.find('form');

      $redirectForm.attr('method', paymentResponse.formMethod);
      $redirectForm.attr('action', paymentResponse.formAction);

      $timeout(function () {
    	$redirectForm.submit();
      });

    }

    function paymentComplete(response) {
	  if(response.userPaymentType === 'TYPE_BLIK'){
		    if (response.blikOK === null) {
		        confirm = $mdDialog.confirm()
		        .title('')
		        .textContent($translate.instant("payments.paymentbliknotok"))
		        .ariaLabel('')
		        .ok('Ok')
		        .openFrom('#left');
		        $mdDialog.show(confirm);
		    }
	  } else {
            vm.smsStatuses.statuses = angular.extend(vm.smsStatuses.statuses, response.smsStatuses);
            vm.smsStatuses.codesNotValid = vm.smsStatuses.codesNotValid.concat(response.notValidSms);
            var allValid = true;
            var anyValid = false;
            angular.forEach(vm.smsStatuses.statuses, function (value) {
                if(value !== 'valid'){
                    allValid = false;
                } else if(value !== 'valid'){
                    anyValid = true;
                }
            });
            var confirm;
			if (allValid) {
			    confirm = $mdDialog.confirm()
			    .title('')
			    .textContent($translate.instant("payments.paymentsmsok"))
			    .ariaLabel('')
			    .ok('Ok')
			    .openFrom('#left');
			    $mdDialog.show(confirm);
			    TokenService.broadcastTokens();
			    $state.reload();
			}
			if (!allValid) {
			    confirm = $mdDialog.confirm()
			    .title('')
			    .textContent($translate.instant(anyValid ? "payments.paymentsmssomeok" : "payments.paymentsmsnotok"))
			    .ariaLabel('')
			    .ok('Ok')
			    .openFrom('#left');
			    $mdDialog.show(confirm);
                TokenService.broadcastTokens();
			}
	  }
    }

    function getPaymentParams(paymentParams) {
        return vm.paymentParams;
    }

    function submitMe(t) {
        var $redirectFormContainer = angular.element('#paymentForm');
        var $redirectForm = $redirectFormContainer.find('form');
        $redirectForm.submit();
    }


    afterPayment();
    getLastInvoiceInfo();

  }
})();

(function() {
	'use strict';

	function PaymentStatusController(PaymentsService, $interval, $window, REFRESHING_TIME_FOR_LAST_PAYMENT, ContractService, $rootScope) {
		var vm = this;

		this.$onInit = function () {
			vm.checkingPromise = $interval(getStatusForLastPayment, REFRESHING_TIME_FOR_LAST_PAYMENT);
			getStatusForLastPayment();
		};

		function getStatusForLastPayment() {
			PaymentsService.getStatusForLastPayment().then(function (responseData) {
				vm.lastPayment = responseData.data;
				if(vm.lastPayment.providerStatus === 'payment.status.success') {
					$rootScope.$broadcast("availableTokens");
                    ContractService.broadcast();
					$interval.cancel(vm.checkingPromise);
				}
			});
		}
	}

	angular
			.module('plagiat2017App')
			.component(
					'paymentStatus',
					{
						templateUrl : 'app/account/payments/payment-status/payment-status.template.html',
						controller : PaymentStatusController,
						controllerAs: 'vm',
						bindings: {
							onIsCode: '='
						}
					});

})();

(function () {
    'use strict';

    function PaymentMetricController($http, $scope, $location, $document, PaymentFormRequest, CountryModel, $mdDialog, $log, $translate, $timeout,
                                     PaymentInitRequest, TokenService, InstanceService, DetectInstanceService,
                                     JhiLanguageService, AccountService, PaymentsService, CurrencyService) {
        var vm = this;
        vm.protocol = $location.protocol();
        vm.paymentForm = new PaymentFormRequest();
        vm.paymentInit = new PaymentInitRequest();
        vm.countries = new CountryModel();
        vm.host = $location.host();
        vm.port = $location.port();
        vm.domain = vm.protocol + '://' + vm.host;
        vm.request = {};
        vm.currencies = [];
        vm.currency = '';
        vm.invoiceAllowed = true;
        vm.maxTokensNum  = 250;
        vm.instance = InstanceService.instance().lang;
        vm.detectedInstance = DetectInstanceService.instance();
        vm.isRomania = vm.detectedInstance === 'ro';
        vm.paymentForm.invoiceRequired = vm.isRomania;
        vm.romanianCounties = [];
        vm.romanianCities = [];

        vm.getStatusSms = getStatusSms;
        vm.isSmsNotValid = isSmsNotValid;
        vm.isPaymentDisabled = isPaymentDisabled;
        vm.showPaymentsMethods = showPaymentsMethods;
        vm.setCurrency = setCurrency;
        vm.setTypeMethod = setTypeMethod;
        vm.getCurrencies = getCurrencies;
        vm.resetSteps = resetSteps;
        vm.goStep = goStep;
        vm.buyTokens = buyTokens;
        vm.getPrice = getPrice;

        $scope.$on("langChanged",function () {
            setDefaultCurrency();
            getPrice();
        } );

        if (vm.isRomania) {
            $http.get('/assets/ro-counties-cities.json').then(function (response) {
                vm.romanianCounties = response.data.counties;
            });
        }

        vm.onRoCountyChange = function () {
            vm.paymentForm.invoice.city = '';
            vm.paymentForm.invoice.country = 'RO';
            getCities();
        };

        function getCities() {
            if (vm.paymentForm.invoice.county) {
                const selectedCounty = vm.romanianCounties.find(function (c) {
                    return c.name === vm.paymentForm.invoice.county;
                });
                vm.romanianCities = selectedCounty ? selectedCounty.cities : [];
            }
        }

        function isPaymentDisabled(paymentMethod){
            return vm.paymentForm.tokens > vm.paymentInit[paymentMethod].maxTokens || (paymentMethod !== 'TYPE_SMS' && anyValidStatusSMS());
        }

        function isSmsNotValid(value) {
            if(value){
                return vm.onSmsStatuses.codesNotValid.includes(value);
            } else {
                return false;
            }
        }

        function getStatusSms(code) {
            return vm.onSmsStatuses.statuses[code.name];
        }

        function anyValidStatusSMS() {
            var anyValid = false;
            angular.forEach(vm.onSmsStatuses.statuses, function (value, key) {
                if(value === 'valid'){
                    anyValid = true;
                }
            });
            return anyValid;
        }

        function showPaymentsMethods(){
            vm.paymentsMethodsList = '';
            angular.forEach(InstanceService.instance().currencies.settings, function(value, key) {
                vm.paymentsMethodsList += '<span class="payments-methods-list">';
                vm.paymentsMethodsList += '<span class="payment-method payment-method-currency">'+value.name+'</span>';
                angular.forEach(value.methodsOfPayment, function(paymentType, key) {
                	if(paymentType === 'TYPE_MOBILPAY_SMS' && vm.instance === 'ro'){
                		paymentType += '_RO';
                	}
                	vm.paymentsMethodsList += '<span class="payment-method '+paymentType+'"></span>';
                });
            vm.paymentsMethodsList += '</span>';
            });
            $mdDialog.show(
                  $mdDialog.confirm()
                  .clickOutsideToClose(true)
                  .htmlContent($translate.instant("payments.metric.paymentsmethodslist")+vm.paymentsMethodsList)
                  .ariaLabel('ok')
                  .ok('OK')
                  );
        }

        function setDefaultCurrency(){
            CurrencyService.getDefaultCurrency().then(
                function (defaultCurrency) {
                    vm.currency = defaultCurrency;
                    setPaymentMethod(vm.currency);
                    getPrice();
                    getPaymentMethods(vm.currency);
                }
            );
        }

        function setCurrency(currency){
            vm.currency = currency;
            getPaymentMethods(currency);
            vm.paymentForm.paymentMethod = '';
            setPaymentMethod(currency);
            getPrice();
        }

        function getCurrencies(){
            vm.currencies = InstanceService.instance().currencies.list;
            setDefaultCurrency();
        }

        function setPaymentMethod(currency){
            angular.forEach(InstanceService.instance().currencies.settings, function(value, key) {
                if( currency === value.name ) {
                    vm.paymentMethod = value.methodsOfPayment[0];
                }
            });
            vm.paymentForm.paymentMethod = vm.paymentMethod;
        }

        function getPaymentMethods(currency) {
            vm.paymentForm.paymentMethod = '';
            angular.forEach(InstanceService.instance().currencies.settings, function(value, key) {
                if( vm.currency === value.name ) {
                    vm.paymentsMethod = value.methodsOfPayment;
                    vm.invoice = value.invoice;
                }
            });
            removePaymentKassa24ByAvailableUsers(vm.paymentsMethod);
            setPaymentMethod(vm.currency);
        }

        //for testing payment purposes only
        function removePaymentEasyPayByAvailableUsers(paymentMethods){
        	var methods = [];

        	var loggedUserId = AccountService.account.id;
		    PaymentsService.getEasyPayAvailableForUsers().then(function(responseData){
		    	var ids = responseData.data;
		    	var easyPayAvailable = false;
		    	angular.forEach(responseData.data, function (value, key) {
		    		if(loggedUserId===value){
		    			easyPayAvailable = true;
		    		}
		    	});

		    	angular.forEach(paymentMethods, function (method, key) {
		    		if(method === 'TYPE_EASY_PAY'){
		    			if(easyPayAvailable){
		    				methods.push(method);
		    			}
		    		}else{
		    			methods.push(method);
		    		}
		    	});

		    });

		    vm.paymentsMethod = methods;
        }

        function removePaymentKassa24ByAvailableUsers(paymentMethods){
        	var methods = [];

        	var loggedUserId = AccountService.account.id;
		    PaymentsService.getKassa24AvailableForUsers().then(function(responseData){
		    	var ids = responseData.data;
		    	var paymentAvailable = false;

		    	if(ids){
			    	angular.forEach(responseData.data, function (value, key) {
			    		if(loggedUserId===value){
			    			paymentAvailable = true;
			    		}
			    	});
		    	}else{
		    		paymentAvailable = true;
		    	}

		    	angular.forEach(paymentMethods, function (method, key) {
		    		if(method === 'TYPE_KASSA_24'){
		    			if(paymentAvailable){
		    				methods.push(method);
		    			}
		    		}else{
		    			methods.push(method);
		    		}
		    	});

		    });

		    vm.paymentsMethod = methods;
        }

        function disableInputNumberDefaultBehavior() {
            var input = $document[0].getElementById("tokensNumber");
            input.addEventListener("wheel", function (event) {
                event.preventDefault();
            });
        }

        function setTypeMethod() {
            vm.invoiceAllowed = vm.paymentInit[vm.paymentForm.paymentMethod].invoice;
            if (!vm.invoiceAllowed) {
                vm.paymentForm.invoiceRequired = false;
            }
            vm.paymentMethod = vm.paymentForm.paymentMethod;
            getPrice();
        }

        function resetSteps() {
            vm.stepsActiveObj = {
                stepTokens: true,
                stepInvoice: false,
                stepPaymentMethod: false,
            };
        }

        function getTokensInfo() {
            TokenService.getInfo().then(function (responseData) {
                vm.availableTokens = responseData.data.availableTokens;
                vm.tokensNeeded = responseData.data.tokensNeeded;

                if (TokenService.buyTokens) {
                    if (TokenService.tokensNedded) {
                        vm.paymentForm.tokens = TokenService.tokensNedded;
                        vm.paymentForm.paymentForPriority = TokenService.buyPriority;
                        TokenService.buyTokens = false;
                        TokenService.buyPriority = false;
                        TokenService.tokensNedded = false;
                    } else {
                        vm.paymentForm.tokens = 1;
                        if (vm.tokensNeeded > vm.availableTokens) {
                            vm.paymentForm.tokens = Math.max(1, Math.min((vm.tokensNeeded - vm.availableTokens), vm.maxTokensNum));
                            TokenService.buyTokens = false;
                        }
                    }
                } else {
                    if (vm.tokensNeeded > vm.availableTokens) {
                        vm.paymentForm.tokens = Math.max(1, Math.min((vm.tokensNeeded - vm.availableTokens), vm.maxTokensNum));
                    } else {
                        vm.paymentForm.tokens = 3;
                    }
                }
                getPrice();
            });
        }

        function goStep(step) {
            resetSteps();
            vm.paymentForm.phase = step;
            if (step === 'tokens') {
                vm.stepsActiveObj.stepTokens = true;
            }
            if (step === 'invoice') {
                getPaymentMethods();
                getInvoiceInfo();
                vm.stepsActiveObj.stepInvoice = true;
            }
            if (step === 'paymentMethod') {
                vm.stepsActiveObj.stepPaymentMethod = true;
            }
        }

        function validatePaymentRequest(request){
            if (vm.isRomania) {
                var foundCounty;
                if (vm.request && vm.request.invoice && vm.request.invoice.county) {
                    foundCounty = vm.romanianCounties.find(function (element) {
                        return element.name === vm.request.invoice.county;
                    });
                    if (!foundCounty) {
                        vm.request.invoice.county = null;
                        return false;
                    }
                }
                if (foundCounty && vm.request && vm.request.invoice && vm.request.invoice.city) {
                    const foundCity = foundCounty.cities.find(function (element) {
                        return element === vm.request.invoice.city;
                    });
                    if (!foundCity) {
                        vm.request.invoice.city = null;
                        return false;
                    }
                }
            }

            if( request.productQuantity > vm.paymentInit[vm.paymentForm.paymentMethod].maxTokens ) {
                $mdDialog.show(
                  $mdDialog.confirm()
                  .clickOutsideToClose(true)
                  .textContent($translate.instant("payments.metric.paymentmaxtokensinfo"))
                  .ariaLabel('ok')
                  .ok('OK')
                  );
                return false;
            } else{
                return true;
            }

        }

        function buyTokens() {
            paymentMethodResponse();
            vm.request.productQuantity = vm.paymentForm.tokens;
            vm.request.invoiceRequired = vm.paymentForm.invoiceRequired;
            vm.request.paymentMethod = vm.paymentForm.paymentMethod;
            if (!vm.paymentForm.isCompany) {
                vm.paymentForm.invoice.nip = null;
            }
            vm.request.invoice = vm.paymentForm.invoice;
            vm.request.paymentForPriority = vm.paymentForm.paymentForPriority;
            vm.request.currency = vm.currency;
            vm.request.documentId = vm.onDocumentId;
            vm.request.browserInfo = getBrowserInfo();
            if( validatePaymentRequest(vm.request) ) {
                vm.onInitPayment(vm.request);
            }
        }

        function getBrowserInfo() {
            const browserInfoModel = {};
            browserInfoModel.colorDepth = window.screen.colorDepth.toString();
            browserInfoModel.screenHeight = window.screen.height.toString();
            browserInfoModel.screenWidth = window.screen.width.toString();
            browserInfoModel.language = window.navigator.language;
            browserInfoModel.javaEnabled = window.navigator.javaEnabled();
            browserInfoModel.timeZone = (new Date()).getTimezoneOffset().toString();
            return browserInfoModel;
        }

        function paymentMethodResponse() {
            vm.request.userPaymentType = vm.paymentInit[vm.paymentForm.paymentMethod].userPaymentType;
            vm.request.backUrl = vm.domain + (vm.port ? (':' + vm.port) : '') + vm.paymentInit[vm.paymentForm.paymentMethod].backUrl;

            if (vm.paymentForm.paymentMethod === 'TYPE_SMS') {
                vm.request.smsCodes = [];
                angular.forEach(vm.paymentForm.smsCodes, function (value, key) {
                    if(vm.onSmsStatuses.statuses[value.name] !== 'valid' && !isSmsNotValid(value.code) ) {
                        vm.request.smsCodes.push(value);
                    }
                });
            } else if (vm.paymentForm.paymentMethod === 'TYPE_BLIK') {
                vm.request.blikCode = vm.paymentForm.blikCode;
            }
        }

        function preparePayment(){
            getCurrencies();
            getTokensInfo();
            resetSteps();
        }

        function getPrice() {
            var request = vm.paymentInit.price;
            request.quantity = vm.paymentForm.tokens;
            vm.tokenError = (!(vm.paymentForm.tokens > 0 && vm.paymentForm.tokens <= vm.maxTokensNum));

            if (angular.isUndefined(vm.paymentForm.tokens) || vm.paymentForm.tokens === '0' || vm.paymentForm.tokens === '') {
                request.quantity = 1;
            }

            request.userPaymentType = vm.paymentMethod;
            request.currency = vm.currency;

            if( vm.paymentForm.tokens !== '' || angular.isUndefined(vm.paymentForm.tokens)) {
                vm.onGetPrice(request);
            }
            vm.tokensArr = Array(parseFloat(request.quantity)).fill().map(function (e, i) {
                return i;
            });
     }

     function getInvoiceInfo() {
        vm.paymentForm.invoice = vm.onInvoiceInfo;
        getCities();
    }

    vm.nextStep = function() {
        if (vm.paymentForm.phase === 'stepTokens') {
            if (vm.invoice) {
                goStep('invoice');
                return;
            } else {
                goStep('paymentMethod');
                return;
            }
        }
        if (vm.paymentForm.phase === 'invoice') {
            goStep('paymentMethod')
        }
    }

    vm.goBack = function () {
        if (vm.paymentForm.phase === 'paymentMethod') {
            if (vm.invoice) {
              vm.goStep('invoice');
              return;
            } else {
              vm.goStep('stepTokens');
              return;
            }
        }
        if (vm.paymentForm.phase === 'invoice') {
            vm.goStep('stepTokens');
        }
    }

    preparePayment();
    disableInputNumberDefaultBehavior();
}

angular.module('plagiat2017App')
.component('paymentMetric', {
  templateUrl: 'app/account/payments/payment-metric/payment-metric.template.html',
  controller: PaymentMetricController,
  bindings: {
      onInitPayment: '<',
      onGetPrice: '<',
      onTokenPrice: '<',
      onInvoiceInfo: '<',
      onGetPaymentMethods: '<',
      onPaymentMethods: '<',
      onDocumentId: '<',
      onSmsStatuses: '=',
      onSmsNotValid: '='
  }
});

})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('suspect-reports', {
            parent: 'app',
            url: '/suspect-reports/d/:documentId',
            data: {
                authorities: [],
                pageTitle: 'global.menu.account.reports'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/pap/suspect-reports/suspect-reports.html',
                    controller: 'SuspectReportsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'docuSubmitDate,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil',
                    function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate(
                                $stateParams.sort),
                            ascending: PaginationUtil.parseAscending(
                                $stateParams.sort)
                        };
                    }],
                translatePartialLoader: ['$translate',
                    '$translatePartialLoader',
                    function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('document');
                        return $translate.refresh();
                    }]
            }
        })
            .state('suspect-reports-s', {
                parent: 'app',
                url: '/suspect-reports/s/:suspectId',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.account.reports'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/pap/suspect-reports/suspect-reports.html',
                        controller: 'SuspectReportsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '0',
                        squash: true
                    },
                    sort: {
                        value: 'docuSubmitDate,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil',
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort)
                            };
                        }],
                    translatePartialLoader: ['$translate',
                        '$translatePartialLoader',
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('reports');
                            $translatePartialLoader.addPart('document');
                            return $translate.refresh();
                        }]
                }
            })
        ;
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('SuspectReportsService', SuspectReportsService);
    
    SuspectReportsService.$inject = ['$http', '$q'];

    function SuspectReportsService($http, $q) {

        var service = {
            downloadReport: downloadReport,
            search: search
        };
        var requestUrl = 'api/suspect-reports';
        return service;

        function downloadReport(inforSuspectId) {
            // const id = 1;
            return $http({
                url : '/api/suspect-reports/download',
                method: "POST",
                data: inforSuspectId,
                headers: {
                    'Content-type': 'application/json',
                    'Accept': 'application/pdf, application/json'
                },
                responseType: 'arraybuffer'
            }).then(
                function(success) {
                    var blob = new Blob(
                        [ success.data ],
                        {
                            type: "text/pdf; encoding=UTF-8"
                        });
                    
                    // var fileName = 'rep-' + id.replace( /[<>:"\/\\|?*]+/g, '-' ) + ".pdf";
                    var fileName = 'report' + ".pdf"; // TODO
                    saveAs(blob, fileName);
                }, function(errResponse) {
                    return $q.reject(errResponse);
                }
            );
            
        }
        
        function search(searchRequest) {
            return $http.post(requestUrl + '/search', searchRequest).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('SuspectReportsController', SuspectReportsController);

    SuspectReportsController.$inject = [
        'SuspectReportsService', 'ModalService', 'PlagiatValidationService', 'DocumentService', 'DateService', 'ReportsService',
        '$q', '$mdDialog', '$translate', '$scope', '$localStorage', '$stateParams', '$state',
        'QueryRequest', 'SearchRequest', 'tableSettingsRequest', 'SIMPLE_SEARCH_DELAY'
    ];

    function SuspectReportsController(
        SuspectReportsService, ModalService, PlagiatValidationService, DocumentService, DateService, ReportsService,
        $q, $mdDialog, $translate, $scope, $localStorage, $stateParams, $state,
        QueryRequest, SearchRequest, tableSettingsRequest, SIMPLE_SEARCH_DELAY
    ) {
        var vm = this;

        vm.fixDate = DateService.fixDate;
        vm.loadData = loadData;
        vm.loadPageOfData = loadPageOfData;
        vm.clear = clear;
        vm.showBothReports = showBothReports;
        vm.goBack = goBack;

        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.keyCodeEnter = KeyCode.KEY_RETURN;
        vm.pageOfData = {};
        vm.queryRequest = new QueryRequest();
        vm.queryRequest.order = '-reportCoeReverted';
        vm.searchRequest = new SearchRequest();
        vm.searchRequest.search.status = 1;

        this.$onInit = function () {
            vm.queryRequest.limit = $localStorage.suspectReportsLimit ? $localStorage.suspectReportsLimit : vm.queryRequest.limit;
            
            vm.documentId = $stateParams.documentId;
            vm.suspectId = $stateParams.suspectId;

            if (vm.documentId) {
                vm.searchRequest.search.documentId = vm.documentId;
                vm.searchRequest.search.suspectId = undefined;
            } else if (vm.suspectId) {
                if ($localStorage.suspectReportsSearch) {
                    vm.searchRequest.search = $localStorage.suspectReportsSearch;
                }
                vm.searchRequest.search.documentId = undefined;
                vm.searchRequest.search.suspectId = vm.suspectId;
                if ($localStorage.portalsSearch) {
                    if ($localStorage.portalsSearch.portalDateFrom) {
                        vm.searchRequest.search.dateFrom = $localStorage.portalsSearch.portalDateFrom;
                    }
                    if ($localStorage.portalsSearch.portalDateTo) {
                        vm.searchRequest.search.dateTo = $localStorage.portalsSearch.portalDateTo;
                    }
                }
            } else {
                vm.searchRequest.search.documentId = -1;
                vm.searchRequest.search.suspectId = undefined;
            }
            
            loadPageOfData(1);
            if (vm.documentId) {
                ReportsService.getDetails(vm.documentId).then(function (result) {
                    vm.details = result.data;
                });
            }
        };
        
        function goBack() {
            if (vm.documentId) {
                $state.go("reports");
            } else {
                $state.go("portals");
            }
        }

        function clear() {
            vm.searchRequest = new SearchRequest();
            loadData();
        }

        function loadPageOfData(pageNumber) {
            vm.pending = true;
            
            vm.searchRequest.pageNumber = pageNumber - 1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.sortTab = sort();
            $localStorage.suspectReportsLimit = vm.queryRequest.limit;
            if (vm.suspectId) {
                $localStorage.suspectReportsSearch = vm.searchRequest.search;
            }
            SuspectReportsService.search(vm.searchRequest).then(function (page) {
                vm.pending = false;
                vm.pageOfData = page;
                vm.pageOfData.number++;
                if (vm.suspectId) {
                    vm.suspectDomain = vm.pageOfData.content[0].urlDomain;
                }
            });
        }

        function loadData() {
            vm.loadPageOfData(1);
        }

        function sort() {
            var reverse = vm.queryRequest.order.slice(0, 1);
            var _length = vm.queryRequest.order.length;
            var predicate;
            if (reverse === '-') {
                predicate = vm.queryRequest.order.slice(1, _length);
                reverse = false;
            } else {
                predicate = vm.queryRequest.order;
                reverse = true;
            }
            var result = [predicate + ',' + (reverse ? 'asc' : 'desc')];
            return result;
        }

        vm.convertToDate = function (date){
            return new Date(date);
        }
        
        function showBothReports(row) {
            SuspectReportsService.downloadReport(row.id).then(
                function () {},
                function (response) {
                    PlagiatValidationService.getModalError(response.data);
                });
        }

    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('reports', {
            parent: 'app',
            url: '/reports',
            data: {
                authorities: [],
                pageTitle: 'global.menu.account.reports'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/pap/reports/reports.html',
                    controller: 'ReportsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'docuSubmitDate,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil',
                    function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate(
                                $stateParams.sort),
                            ascending: PaginationUtil.parseAscending(
                                $stateParams.sort)
                        };
                    }],
                translatePartialLoader: ['$translate',
                    '$translatePartialLoader',
                    function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        $translatePartialLoader.addPart('document');
                        return $translate.refresh();
                    }]
            }
        })
        
        ;
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ReportsService', ReportsService);
    
    ReportsService.$inject = ['$http', '$q', 'FileSaver', 'PlagiatValidationService', '$mdDialog', '$translate', 'DateUtils'];

    function ReportsService($http, $q, FileSaver, PlagiatValidationService, $mdDialog, $translate, DateUtils) {

        var service = {
            generateReportXls: generateReportXls,
            sendReportXls: sendReportXls,
            getDetails: getDetails,
            search: search
        };
        var requestUrl = 'api/reports';
        return service;

        function search(searchRequest) {
            return $http.post(requestUrl + '/search', searchRequest).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function getDetails(id) {
            return $http.get('/api/reports/document/details/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function sendReportXls(response, selected, searchRequest) {
            var confirm = $mdDialog.confirm()
                .clickOutsideToClose(true)
                .escapeToClose(true)
                .textContent($translate.instant("reports.xls.report.generating.info"))
                .ok("OK");
            $mdDialog.show(confirm);

            var url = response.selectedAll ? 'api/suspect-reports/xls/search/xls-send'
                : 'api/suspect-reports/xls/selected/xls-send';
            var data = response.selectedAll
                ? {filter:searchRequest}
                : {ids:{ids:selected}};
            
            return $http.post(url, data).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function generateReportXls(response, selected, searchRequest) {
            var alert = $mdDialog.alert()
                .clickOutsideToClose(false)
                .escapeToClose(false)
                .textContent($translate.instant("global.report.xls.exporting-in-progress"))
                .ok("OK");
            $mdDialog.show(alert);

            var url = response.selectedAll ? 'api/suspect-reports/xls/search/return-xls'
                : 'api/suspect-reports/xls/selected/return-xls';
            var data = response.selectedAll
                ? {filter:searchRequest}
                : {ids:{ids:selected}};

            function jsonBufferToObject (data, headersGetter, status) {
                var type = headersGetter("Content-Type");
                if (!type.startsWith("application/json")) {
                    return data;
                };
                var decoder = new TextDecoder("utf-8");
                var domString = decoder.decode(data);
                var json = JSON.parse(domString);
                return json;
            };
            
            return $http({
                url: url,
                method: "POST",
                data: data,
                headers: {
                    'Content-type': 'application/json',
                    'Accept': 'application/vnd.ms-excel, vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/json'
                },
                responseType: 'arraybuffer',
                transformResponse: jsonBufferToObject
            }).then(function (success) {
                $mdDialog.hide();
                var blob = new Blob([success.data], {
                    type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                saveAs(blob, 'report_' + DateUtils.getDateTimeForFileName(new Date()) + '.xlsx');
                return 'OK';
            }, function (errResponse) {
                $mdDialog.hide();
                return $q.reject(errResponse);
            });
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ReportsController', ReportsController);

    ReportsController.$inject = [
        'ReportsService', 'ModalService', 'PlagiatValidationService', 'DocumentService', 'DateService',
        '$q', '$mdDialog', '$translate', '$scope', '$localStorage', '$state', '$mdBottomSheet',
        'QueryRequest', 'SearchRequest', 'tableSettingsRequest', 'TableSelectOptions', 'SIMPLE_SEARCH_DELAY', 'DOCUMENT_STATUS', 'DOCUMENT_PAP_STATUSES'
    ];

    function ReportsController(
        ReportsService, ModalService, PlagiatValidationService, DocumentService, DateService,
        $q, $mdDialog, $translate, $scope, $localStorage, $state, $mdBottomSheet,
        QueryRequest, SearchRequest, tableSettingsRequest, TableSelectOptions, SIMPLE_SEARCH_DELAY, DOCUMENT_STATUS, DOCUMENT_PAP_STATUSES
    ) {
        var vm = this;

        vm.loadData = loadData;
        vm.loadPageOfData = loadPageOfData;
        vm.clear = clear;
        vm.deSelectRow = deSelectRow;
        vm.selectRow = selectRow;
        vm.generateReportXls = generateReportXls;
        vm.sendReportXls = sendReportXls;
        vm.showText = showText;
        vm.getDetails = getDetails;
        vm.showSuspectReports = showSuspectReports;
        vm.closeBottomSheet = closeBottomSheet;
        vm.toggleSelection = toggleSelection;
        vm.isBottomSheetOpen = isBottomSheetOpen;

        vm.fixDate = DateService.fixDate;
        vm.documentStatus = DOCUMENT_STATUS;
        vm.documentPapStatuses = DOCUMENT_PAP_STATUSES;
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.keyCodeEnter = KeyCode.KEY_RETURN;
        vm.pageOfData = {};
        vm.queryRequest = new QueryRequest();
        vm.queryRequest.order = '-docuSubmitDate';
        vm.searchRequest = new SearchRequest();
        vm.options = new tableSettingsRequest();
        vm.tableSelectOptions = new TableSelectOptions();
        vm.selected = [];

        vm.showDetailsBlock = false;
        vm.pickedDocument = false;
        vm.details = {};

        this.$onInit = function () {
            vm.queryRequest.limit = $localStorage.reportsLimit ? $localStorage.reportsLimit : vm.queryRequest.limit;
            if ($localStorage.reportsSearch) {
                vm.searchRequest.search = $localStorage.reportsSearch;
            }
            vm.searchRequest.search.status = 1;
            loadPageOfData(1);
        };

        function showSuspectReports(row) {
            $state.go('suspect-reports', {documentId : row.documentId});
        }

        function getDetails(item) {
            vm.showDetailsBlock = false;
            vm.pickedDocument = item.documentId;
            if (item.documentId !== DocumentService.documentDetailsObj.documentId) {
                DocumentService.documentDetailsObj = item;
                vm.isLoaderActive = true;

                ReportsService.getDetails(item.documentId).then(function (result) {
                    vm.details = result.data;
                    vm.isLoaderActive = false;
                    vm.showDetailsBlock = true;
                    vm.details.docuSubmitDate = moment(vm.details.docuSubmitDate).format('LL LT');
                    if (vm.details.docuReportDate !== null){
                        vm.details.docuReportDate =  moment(vm.details.docuReportDate).format('LL LT');
                    }
                });
                
            } else {
                DocumentService.documentDetailsObj = {};
            }
        }

        function showText(ev, row) {
            DocumentService.document.id = row.documentId;
            $mdDialog.show({
                templateUrl: 'app/account/documents/document-text/view-text.tmpl.html',
                targetEvent: ev,
                clickOutsideToClose: true,
                multiple: true
            });
        }

        function clear() {
            vm.searchRequest = new SearchRequest();
            loadData();
        }

        function loadPageOfData(pageNumber) {
            vm.pending = true;
            
            vm.searchRequest.pageNumber = pageNumber - 1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.sortTab = sort();
            $localStorage.reportsLimit = vm.queryRequest.limit;
            $localStorage.reportsSearch = vm.searchRequest.search;
            ReportsService.search(vm.searchRequest).then(function (page) {
                vm.pending = false;
                vm.pageOfData = page;
                vm.totalRows = page.totalElements;
                vm.pageOfData.number++;
            });
        }

        function loadData() {
            closeBottomSheet();
            vm.loadPageOfData(1);
        }

        function sort() {
            var reverse = vm.queryRequest.order.slice(0, 1);
            var _length = vm.queryRequest.order.length;
            var predicate;
            if (reverse === '-') {
                predicate = vm.queryRequest.order.slice(1, _length);
                reverse = false;
            } else {
                predicate = vm.queryRequest.order;
                reverse = true;
            }
            var result = [predicate + ',' + (reverse ? 'asc' : 'desc')];
            return result;
        }

        vm.convertToDate = function (date){
            return new Date(date);
        }

        function deSelectRow() {
            if (vm.selected.length === 0) {
                closeBottomSheet();
            }
        }

        function selectRow(pickedId) {
            if (vm.selected.length === 1) {
                openBottomSheet();
            }
            angular.forEach(vm.users, function (value) {
                if (value.id === pickedId) {
                    if (vm.tableSelectOptions.selectedHelper.indexOf(pickedId) === -1) {
                        vm.tableSelectOptions.selectedHelper.push(value);
                    }
                }
            });
        }

        function selectRows(obj) {
            angular.forEach(obj, function (value) {
                if (vm.selected.indexOf(value.id) === -1) {
                    vm.selected.push(value.id);
                }
            })
        }

        function toggleSelection(total) {
            if (!vm.tableSelectOptions.selectedAll) {
                selectRows(vm.pageOfData.content);
            }
            vm.tableSelectOptions.selectedAll = !vm.tableSelectOptions.selectedAll;
            vm.tableSelectOptions.selectedNo = total;
            if (!vm.tableSelectOptions.selectedAll) {
                closeBottomSheet();
            }
        }

        function closeBottomSheet() {
            vm.selected.length = 0;
            vm.tableSelectOptions = new TableSelectOptions();
            $mdBottomSheet.hide();
        }

        function isBottomSheetOpen() {
            return vm.selected && vm.selected.length > 0;
        }

        function openBottomSheet() {
            $mdBottomSheet.show({
                templateUrl: 'app/account/pap/reports/reports-bottom-sheet.html',
                controllerAs: 'bootomSheet',
                parent: angular.element(document.getElementById('reports')),
                controller: function GridBottomSheetCtrl(){
                    var bootomSheet = this;
                    bootomSheet.checked = true;
                    bootomSheet.closeBottomSheet = vm.closeBottomSheet;
                    bootomSheet.selected = vm.selected;
                    bootomSheet.tableSelectOptions = vm.tableSelectOptions;
                    bootomSheet.total = vm.totalRows;
                    bootomSheet.toggleSelection = vm.toggleSelection;
                    bootomSheet.generateReportXls = vm.generateReportXls;
                    bootomSheet.sendReportXls = vm.sendReportXls;
                },
                isLockedOpen: true,
                disableParentScroll: false,
                disableBackdrop: true
            });
        }

        function generateReportXls() {
            prepareMassActions().then(function(response) {
                ReportsService.generateReportXls(response, vm.selected, vm.searchRequest).then(
                    function (ok) {
                        closeBottomSheet();
                    }, function (errorResponse) {
                        PlagiatValidationService.getModalError(errorResponse.data);
                    }
                );
            });
        }

        function sendReportXls() {
            prepareMassActions().then(function(response) {
                ReportsService.sendReportXls(response, vm.selected, vm.searchRequest).then(function (ok) {
                    closeBottomSheet();
                }, function (errResponse) {
                    // nothing?
                });
            });
        }

        function prepareMassActions() {
            vm.deferred = $q.defer();
            vm.tableSelectOptions.ids.length = 0;
            vm.tableSelectOptions.selectedNo = vm.tableSelectOptions.selectedAll ? vm.tableSelectOptions.selectedNo : vm.selected.length;
            angular.forEach(vm.tableSelectOptions.selectedHelper, function (value) {
                vm.tableSelectOptions.ids.push(value.id);
            });
            vm.deferred.resolve(vm.tableSelectOptions);
            return vm.deferred.promise;
        }

    }

})();

(function() {
	'use strict';

	function DocumentDetailsReportsController($scope, $log, DOCUMENT_STATUS) {
		var vm = this;
		vm.DOCUMENT_STATUS = DOCUMENT_STATUS;
	}

	angular
	.module('plagiat2017App')
	.component(
		'documentDetailsReports',
		{
			templateUrl : 'app/account/pap/reports/document-details-reports/document-details-reports.template.html',
			controller : DocumentDetailsReportsController,
			bindings: {
				onDocument: '<',
				onDocumentDetails: '<',
			}
		});

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('PortalOfClientAddEditController', PortalOfClientAddEditController);
    
    PortalOfClientAddEditController.$inject = ['PortalOfClientService', 'ModalService',
        '$localStorage', '$state', '$stateParams', 'PORTAL_OF_CLIENT_TYPES'];

    function PortalOfClientAddEditController(PortalOfClientService, ModalService,
        $localStorage, $state, $stateParams, PORTAL_OF_CLIENT_TYPES) {
        var vm = this;
        vm.pending = false;

        vm.obj = {};
        vm.id = $stateParams.id;
        vm.portalOfClientTypes = PORTAL_OF_CLIENT_TYPES;
        vm.saveOrUpdate = saveOrUpdate;
        
        this.$onInit = function () {
            vm.pending = true;
    
            if ($stateParams.id) {
                PortalOfClientService.getForEditing($stateParams.id).then(function (obj) {
                    vm.obj = obj.data;
                });
            }
            vm.pending = false;
        };
    
        function saveOrUpdate() {
            PortalOfClientService
                .saveOrUpdate(vm.obj)
                .then(function () {
                    vm.obj = null;
                    ModalService.showSuccessModal("global.messages.success.label");
                    $state.go('portal-of-client');
                    $stateParams.id = null;
                }, function (errorResponse) {
                    ModalService.showErrorModal(errorResponse);
                });
        }
    
    }
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('portal-of-client', {
                parent: 'app',
                url: '/portal-of-client',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.account.portal-of-client'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/pap/portal-of-client/portal-of-client.html',
                        controller: 'PortalOfClientController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '0',
                        squash: true
                    },
                    sort: {
                        value: 'userName,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil',
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort)
                            };
                        }],
                    translatePartialLoader: ['$translate',
                        '$translatePartialLoader',
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('reports');
                            return $translate.refresh();
                        }]
                }
            })
            .state('portal-of-client-edit', {
                parent: 'portal-of-client',
                url: '/:id/edit',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.account.portal-of-client'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/pap/portal-of-client/portal-of-client-add-edit.html',
                        controller: 'PortalOfClientAddEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        return $translate.refresh();
                    }]
                }
            })
            .state('portal-of-client-add', {
                parent: 'portal-of-client',
                url: '/add',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.account.portal-of-client'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/pap/portal-of-client/portal-of-client-add-edit.html',
                        controller: 'PortalOfClientAddEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reports');
                        return $translate.refresh();
                    }]
                }
            })
        ;
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('PortalOfClientService', PortalOfClientService);
    
    PortalOfClientService.$inject = ['$http', '$q'];

    function PortalOfClientService($http, $q) {

        var service = {
            addToClientPortals: addToClientPortals,
            search: search,
            getForEditing: getForEditing,
            remove: remove,
            saveOrUpdate: saveOrUpdate
        };
        var requestUrl = 'api/portal-of-client';
        return service;

        function addToClientPortals(obj) {
            return $http.post(requestUrl + '/add-to-client-portals', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getForEditing(id) {
            return $http.get(requestUrl + '/for-editing/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function saveOrUpdate(obj) {
            return $http.post(requestUrl + '/save-or-update', obj).then(
                function () {},
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function search(searchRequest) {
            return $http.post(requestUrl + '/search', searchRequest).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
        function remove(id) {
            return $http.get(requestUrl + '/remove?id=' + id).then(
                function () {},
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    
    
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('PortalOfClientController', PortalOfClientController);

    PortalOfClientController.$inject = [
        'PortalOfClientService', 'ModalService', 'PlagiatValidationService',
        '$q', '$mdDialog', '$translate', '$scope', '$localStorage',
        'QueryRequest', 'SearchRequest', 'PORTAL_OF_CLIENT_TYPES', 'SIMPLE_SEARCH_DELAY',
    ];

    function PortalOfClientController(
        PortalOfClientService, ModalService, PlagiatValidationService,
        $q, $mdDialog, $translate, $scope, $localStorage,
        QueryRequest, SearchRequest, PORTAL_OF_CLIENT_TYPES, SIMPLE_SEARCH_DELAY
    ) {
        var vm = this;

        vm.loadData = loadData;
        vm.loadPageOfData = loadPageOfData;
        vm.remove = remove;
        vm.clear = clear;

        vm.portalOfClientTypes = PORTAL_OF_CLIENT_TYPES;
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.keyCodeEnter = KeyCode.KEY_RETURN;
        vm.pageOfData = {};
        vm.queryRequest = new QueryRequest();
        vm.searchRequest = new SearchRequest();

        this.$onInit = function () {
            vm.queryRequest.limit = $localStorage.portalOfClientLimit ? $localStorage.portalOfClientLimit : vm.queryRequest.limit;
            if ($localStorage.portalOfClientSearch) {
                vm.searchRequest.search = $localStorage.portalOfClientSearch;
            }
            loadPageOfData(1);
        };

        function clear() {
            vm.searchRequest = new SearchRequest();
            loadData();
        }

        function loadPageOfData(pageNumber) {
            vm.pending = true;
            
            vm.searchRequest.pageNumber = pageNumber - 1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            $localStorage.portalOfClientLimit = vm.queryRequest.limit;
            $localStorage.portalOfClientSearch = vm.searchRequest.search;
            PortalOfClientService.search(vm.searchRequest).then(function (page) {
                vm.pending = false;
                vm.pageOfData = page;
                vm.totalTranslations = page.totalElements;
                vm.pageOfData.number++;
            });
        }

        function loadData() {
            vm.loadPageOfData(1);
        }

        function remove(id) {
            var REMOVE_PREFIX = 'portal-of-client.remove';
            ModalService.showConfirmModal(REMOVE_PREFIX).then( function (){
                vm.isLoaderActive = true;
                PortalOfClientService.remove(id).then(function () {
                    vm.isLoaderActive = false;
                    loadData();
                    ModalService.showSuccessModal();
                }).catch(function (response) {
                    PlagiatValidationService.getModalError(response.data);
                });
            });

        }

    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .constant('PORTAL_OF_CLIENT_TYPES', [
        {'id': 1, 'key': 'reports.portal-of-client.type.native' },
        {'id': 2, 'key': 'reports.portal-of-client.type.client' }
        ])
    .constant('SUSPECT_TYPES', [
        {'id': 1, 'key': 'reports.portal-of-client.type.client' },
        {'id': 2, 'key': 'reports.portal-of-client.type.illegal' },
        {'id': 3, 'key': 'reports.portal-of-client.type.native' }
        ])
    ;
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('portals', {
                parent: 'app',
                url: '/portals',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.account.portals'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/pap/infor-suspect-portal/infor-suspect-portal.html',
                        controller: 'PortalsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '0',
                        squash: true
                    },
                    sort: {
                        value: 'userName,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil',
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort)
                            };
                        }],
                    translatePartialLoader: ['$translate',
                        '$translatePartialLoader',
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('reports');
                            return $translate.refresh();
                        }]
                }
            })
            
        ;
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('PortalsService', PortalsService);

    PortalsService.$inject = ['$http', '$q', 'FileSaver', 'PlagiatValidationService', '$mdDialog', '$translate', 'DateUtils'];

    function PortalsService($http, $q, FileSaver, PlagiatValidationService, $mdDialog, $translate, DateUtils) {

        var service = {
            generateReportXls: generateReportXls,
            downloadZip: downloadZip,
            search: search,
        };
        var requestUrl = 'api/portals';
        return service;

        function search(searchRequest) {
            return $http.post(requestUrl + '/search', searchRequest).then(
                function (response) {
                    return response.data.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
        
        function generateReportXls(response, selected, searchRequest) {
            var alert = $mdDialog.alert()
                .clickOutsideToClose(false)
                .escapeToClose(false)
                .textContent($translate.instant("global.report.xls.exporting-in-progress"))
                .ok("OK");
            $mdDialog.show(alert);

            var url = 'api/portals/xls/return-xls';
            var data = response.selectedAll
                ? {filter:searchRequest}
                : {filter:searchRequest, ids:{ids:selected}};

            return $http({
                url: url,
                method: "POST",
                data: data,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).then(function (success) {
                $mdDialog.hide();
                var blob = new Blob([success.data], {
                    type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                saveAs(blob, 'portals_' + DateUtils.getDateTimeForFileName(new Date()) + '.xlsx');
                return 'OK';
            }, function (errResponse) {
                $mdDialog.hide();
                PlagiatValidationService.getModalError(error);
                return $q.reject(errResponse);
            });
        }
        
        function downloadZip(response, selected, searchRequest) {
            var alert = $mdDialog.alert()
                .clickOutsideToClose(false)
                .escapeToClose(false)
                .textContent($translate.instant("global.report.xls.exporting-in-progress"))
                .ok("OK");
            $mdDialog.show(alert);

            var url = 'api/portals/reports-zip';
            var data = response.selectedAll
                ? {filter:searchRequest}
                : {filter:searchRequest, ids:{ids:selected}};

            function jsonBufferToObject (data, headersGetter, status) {
                var type = headersGetter("Content-Type");
                if (!type.startsWith("application/json")) {
                    return data;
                };
                var decoder = new TextDecoder("utf-8");
                var domString = decoder.decode(data);
                var json = JSON.parse(domString);
                return json;
            };
            
            return $http({
                url: url,
                method: "POST",
                data: data,
                headers: {
                    'Content-type': 'application/json',
                    'Accept': 'application/pdf, application/json'
                },
                responseType: 'arraybuffer',
                transformResponse: jsonBufferToObject
            }).then(function (success) {
                $mdDialog.hide();
                var blob = new Blob([success.data], {
                    type: "application/zip"
                });
                saveAs(blob, 'reports_' + DateUtils.getDateTimeForFileName(new Date()) + '.zip');
                return 'OK';
            }, function (errResponse) {
                $mdDialog.hide();
                return $q.reject(errResponse);
            });
        }
        
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('PortalsController', PortalsController);

    PortalsController.$inject = [
        'PortalsService', 'ModalService', 'PlagiatValidationService', 'DateService', 'PortalOfClientService',
        '$q', '$mdDialog', '$translate', '$scope', '$localStorage', '$mdBottomSheet', '$state',
        'QueryRequest', 'SearchRequest', 'tableSettingsRequest', 'TableSelectOptions', 'SIMPLE_SEARCH_DELAY', 'SUSPECT_TYPES'
    ];

    function PortalsController(
        PortalsService, ModalService, PlagiatValidationService, DateService, PortalOfClientService,
        $q, $mdDialog, $translate, $scope, $localStorage, $mdBottomSheet, $state,
        QueryRequest, SearchRequest, tableSettingsRequest, TableSelectOptions, SIMPLE_SEARCH_DELAY, SUSPECT_TYPES
    ) {
        var vm = this;

        vm.loadData = loadData;
        vm.loadPageOfData = loadPageOfData;
        vm.clear = clear;
        vm.deSelectRow = deSelectRow;
        vm.selectRow = selectRow;
        vm.generateReportXls = generateReportXls;
        vm.downloadZip = downloadZip;
        vm.addToClientPortals = addToClientPortals;
        vm.closeBottomSheet = closeBottomSheet;
        vm.toggleSelection = toggleSelection;
        vm.isBottomSheetOpen = isBottomSheetOpen;
        vm.showSuspectReports = showSuspectReports;

        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.suspectTypes = SUSPECT_TYPES;
        vm.keyCodeEnter = KeyCode.KEY_RETURN;
        vm.fixDate = DateService.fixDate;
        vm.pageOfData = {};
        vm.queryRequest = new QueryRequest();
        vm.queryRequest.order = '-counter';
        vm.searchRequest = new SearchRequest();
        vm.onSearchRequest = vm.searchRequest;
        vm.options = new tableSettingsRequest();
        vm.tableSelectOptions = new TableSelectOptions();
        vm.selected = [];

        this.$onInit = function () {
            vm.queryRequest.limit = $localStorage.portalsLimit ? $localStorage.portalsLimit : vm.queryRequest.limit;
            if ($localStorage.portalsSearch) {
                vm.searchRequest.search = $localStorage.portalsSearch;
            }
            if (!vm.searchRequest.search.portalDateFrom) {
                var dateToChange = new Date();
                dateToChange.setTime(dateToChange.getTime() - (7 * 24 * 60 * 60 * 1000)); // 7 days
                vm.searchRequest.search.portalDateFrom = dateToChange;
            }
            loadPageOfData(1);
        };

        function showSuspectReports(row) {
            $state.go('suspect-reports-s', {suspectId : row.minId});
        }

        function clear() {
            vm.searchRequest = new SearchRequest();
            loadData();
        }

        function loadPageOfData(pageNumber) {
            vm.pending = true;
            
            vm.searchRequest.pageNumber = pageNumber - 1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.sortTab = sort();
            $localStorage.portalsLimit = vm.queryRequest.limit;
            $localStorage.portalsSearch = vm.searchRequest.search;
            PortalsService.search(vm.searchRequest).then(function (page) {
                vm.pending = false;
                vm.pageOfData = page;
                vm.totalRows = page.totalElements;
                vm.pageOfData.number++;
            });
        }

        function sort() {
            var reverse = vm.queryRequest.order.slice(0, 1);
            var _length = vm.queryRequest.order.length;
            var predicate;
            if (reverse === '-') {
                predicate = vm.queryRequest.order.slice(1, _length);
                reverse = false;
            } else {
                predicate = vm.queryRequest.order;
                reverse = true;
            }
            var result = [predicate + ',' + (reverse ? 'asc' : 'desc')];
            return result;
        }

        function loadData() {
            closeBottomSheet();
            vm.loadPageOfData(1);
        }
        
        function deSelectRow() {
            if( vm.selected.length === 0) {
                closeBottomSheet();
            }
        }
        
        function isBottomSheetOpen() {
            return vm.selected && vm.selected.length > 0;
        }

        function selectRow(pickedId) {
            if (vm.selected.length === 1) {
                openBottomSheet();
            }
            angular.forEach(vm.users, function (value) {
                if (value.id === pickedId) {
                    if (vm.tableSelectOptions.selectedHelper.indexOf(pickedId) === -1) {
                        vm.tableSelectOptions.selectedHelper.push(value);
                    }
                }
            });
        }

        function selectRows(obj) {
            angular.forEach(obj, function (value) {
                if (vm.selected.indexOf(value.portalName) === -1) {
                    vm.selected.push(value.portalName);
                }
            })
        }

        function toggleSelection(total) {
            if (!vm.tableSelectOptions.selectedAll) {
                selectRows(vm.pageOfData.content);
            }
            vm.tableSelectOptions.selectedAll = !vm.tableSelectOptions.selectedAll;
            vm.tableSelectOptions.selectedNo = total;
            if (!vm.tableSelectOptions.selectedAll) {
                closeBottomSheet();
            }
        }

        function closeBottomSheet() {
            vm.selected.length = 0;
            vm.tableSelectOptions = new TableSelectOptions();
            $mdBottomSheet.hide();
        }

        function openBottomSheet() {
            $mdBottomSheet.show({
                templateUrl: 'app/account/pap/infor-suspect-portal/infor-suspect-portal-bottom-sheet.html',
                controllerAs: 'bootomSheet',
                parent: angular.element(document.getElementById('portals')),
                controller: function GridBottomSheetCtrl(){
                    var bootomSheet = this;
                    bootomSheet.checked = true;
                    bootomSheet.closeBottomSheet = vm.closeBottomSheet;
                    bootomSheet.selected = vm.selected;
                    bootomSheet.tableSelectOptions = vm.tableSelectOptions;
                    bootomSheet.total = vm.totalRows;
                    bootomSheet.toggleSelection = vm.toggleSelection;
                    bootomSheet.generateReportXls = vm.generateReportXls;
                    bootomSheet.downloadZip = vm.downloadZip;
                    bootomSheet.addToClientPortals = vm.addToClientPortals;
                },
                isLockedOpen: true,
                disableParentScroll: false,
                disableBackdrop: true
            });
        }

        function addToClientPortals() {
            vm.rowsToAdd = [];
            angular.forEach(vm.selected, function (value) {
                vm.rowsToAdd.push({portal: value});
            });
            
            $mdDialog.show({
                templateUrl: 'app/account/pap/infor-suspect-portal/add-to-client-portals.dialog.html',
                controllerAs: 'vm',
                escapeToClose: true,
                clickOutsideToClose: true,
                locals: {
                    data: vm.rowsToAdd
                },
                controller: function ($mdDialog, data) {
                    this.data = data;
                    this.deleteRow = function(row) {
                        var filteredAry = this.data.filter(function (e) {
                            return e !== row
                        });
                        this.data = filteredAry;
                    }
                    this.closeDialog = function() {
                        $mdDialog.hide();
                    }
                    this.addThem = function() {
                        $mdDialog.hide();
                        vm.isLoaderActive = true;
                        PortalOfClientService.addToClientPortals(this.data).then(
                            function () {
                                closeBottomSheet();
                                ModalService.showSuccessModal();
                                vm.isLoaderActive = false;
                            },
                            function (response) {
                                PlagiatValidationService.getModalError(response.data);
                                vm.isLoaderActive = false;
                            });
                        
                    }
                }
            });
        }

        function generateReportXls() {
            prepareMassActions().then(function(response){
                PortalsService.generateReportXls(response, vm.selected, vm.searchRequest).then(
                    function (okResponse) {
                        closeBottomSheet();
                    }, function (errorResponse) {
                        PlagiatValidationService.getModalError(errorResponse.data);
                    });
            });
        }

        function downloadZip(){
            prepareMassActions().then(function(response){
                PortalsService.downloadZip(response, vm.selected, vm.searchRequest).then(
                    function (okResponse) {
                        closeBottomSheet();
                    }, function (errorResponse) {
                        PlagiatValidationService.getModalError(errorResponse.data);
                    }
                );
            });
        }

        function prepareMassActions() {
            vm.deferred = $q.defer();
            vm.tableSelectOptions.ids.length = 0;
            vm.tableSelectOptions.selectedNo = vm.tableSelectOptions.selectedAll ? vm.tableSelectOptions.selectedNo : vm.selected.length;
            angular.forEach(vm.tableSelectOptions.selectedHelper, function (value) {
                vm.tableSelectOptions.ids.push(value.id);
            });
            vm.deferred.resolve(vm.tableSelectOptions);
            return vm.deferred.promise;
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .directive('samlLogin', samlLogin);

    samlLogin.$inject = ['$translatePartialLoader', '$translate', 'SSO_LOGIN_DATA'];

    function samlLogin($translatePartialLoader, $translate, SSO_LOGIN_DATA) {
        var directive = {
            restrict: 'E',
            scope: {
                partner: '@ngPartner',
                disabled: '=ngDisabled',
                onButtonClick: '&'
            },
            templateUrl: 'app/account/login/saml/saml-login.html',
            link: linkFunc
        };

        return directive;

        /* private helper methods */

        function linkFunc(scope) {

            $translate.refresh();

            scope.click = function() {
                scope.onButtonClick()(scope.partner);
            };

            scope.titles = SSO_LOGIN_DATA;

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'account',
            url: '/?lang&error',
            data: {
                authorities: [],
                pageTitle: 'login.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('info');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
            .module('plagiat2017App')
            .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$scope', '$state', 'DetectInstanceService', '$timeout', 'Auth', '$stateParams',
    'tmhDynamicLocale', '$translate', 'BrowserService', '$localStorage', 'UserService', 'InstanceService', '$window'];

    function LoginController($rootScope, $scope, $state, DetectInstanceService, $timeout, Auth, $stateParams, 
        tmhDynamicLocale, $translate, BrowserService, $localStorage, UserService, InstanceService, $window) {

        var vm = this;

        vm.authenticationError = false;
        vm.credentials = {};
        vm.password = null;
        vm.rememberMe = true;
        vm.username = null;
        vm.pending = false;
        vm.loginPossible = true;
        vm.showPassword = false;
        vm.response = null;
        vm.isCapsLockOn = null;

        vm.login = login;
        vm.register = register;
        vm.loginSaml = loginSaml;
        vm.loginOauth2 = loginOauth2;
        vm.requestResetPassword = requestResetPassword;
        vm.goToHomePage = goToHomePage;
        vm.toggleShowPassword = toggleShowPassword;
        vm.regulationsAcceptanceInfo = regulationsAcceptanceInfo;
        vm.toggleInstitutions = toggleInstitutions;

        vm.allowFbLogin = DetectInstanceService.getFbLoginForm();
        vm.allowRegister = DetectInstanceService.getAllowRegister();
        vm.samlPartners = DetectInstanceService.samlLoginButtons();
        vm.oauthPartners = DetectInstanceService.oauthLoginButtons();
        vm.showInstitutions = (vm.samlPartners && vm.samlPartners.length > 0) || (vm.oauthPartners && vm.oauthPartners.length > 0);
        vm.institutionsExpanded = false;
        vm.homepage = InstanceService.instance().domain;
        vm.instance = DetectInstanceService.instance();
        vm.lastSsoPartner = null;

        $timeout(function () {
            angular.element('#username').focus();
        });

        $scope.$on('authenticationSuccess', function () {
            vm.loginPossible = false;
        });

        this.$onInit = function () {
            vm.key = $stateParams.error;
            if (vm.key === 'saml') {
                vm.authenticationError = true;
                vm.responseMessage = 'login.messages.saml.error.authentication';
            }
            if (vm.key === 'oauth') {
                vm.authenticationError = true;
                vm.responseMessage = 'login.messages.oauth.error.authentication';
            }
            if (vm.key === 'hibernated') {
                vm.authenticationError = true;
                vm.responseMessage = 'login.messages.error.hibernate';
            }
            vm.lastSsoPartner = $localStorage.lastSsoPartner;
        }

        function login(event) {
            event.preventDefault();
            var credentials = {
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            };
            UserService.getUserInstance(vm.username, DetectInstanceService.isRedirectEnabled()).then(function(data) {
                if (data.data === "" || DetectInstanceService.instance() === data.data) {
                    $localStorage.showLogoutToRootBtn = false;
                    $localStorage.logoutToRootInfo = undefined;
                    Auth.login(credentials)
                        .then(function (response) {
                            vm.authenticationError = false;
                            $rootScope.$broadcast('authenticationSuccess');
                            // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                            // since login is successful, go to stored previousState and clear previousState
                            if (Auth.getPreviousState()) {
                                var previousState = Auth.getPreviousState();
                                Auth.resetPreviousState();
                                $state.go(previousState.name, previousState.params);
                            } else if ($state.current.name === 'login') {
                                $state.go('documents');
                            }
                        }).catch(function (response) {
                        vm.authenticationError = true;
                        if (response.status === 401) {
                            vm.authenticationError = true;
                            vm.responseMessage = 'login.messages.error.authentication';
                            //Wyszukanie komunikatu wysłanego z backendu
                            for (var prop in response) {
                                vm.response = response[prop];
                                if (vm.response.message !== 'undefined') {
                                    // Znaleziono komunikat - do przetłumaczenia i18 na stronie
                                    vm.responseMessage = vm.response.message;
                                    break;
                                }
                            }
                        }
                    });
                } else {
                    Auth.redirect(credentials, DetectInstanceService.getInstanceDomain(data.data));
                }
            });
        }

        function register() {
            $state.go('register');
        }

        function requestResetPassword() {
            $state.go('requestReset');
        }

        function goToHomePage(){
            $window.open('https://' + vm.homepage, "_self");
        }

        function toggleShowPassword() {
            vm.showPassword = !vm.showPassword;
        }

        function toggleInstitutions() {
            vm.institutionsExpanded = !vm.institutionsExpanded;
        }

        function regulationsAcceptanceInfo() {
            var regulationsKey = 'info.instructions.instruction3.url_' + vm.instance;
            var regulationsTranslation = $translate.instant(regulationsKey);
            var result = $translate.instant('global.social.regulations-acceptance-info');
            result = result.replace('{regulationsUrl}', regulationsTranslation);
            result =  '<span>' + result + '</span>';
            return result;
        }

        function loginSaml(samlPartner) {
            $localStorage.lastSsoPartner = samlPartner;

            UserService.samlRedirectionUrl(samlPartner).then(function(data) {
                $.redirect(data.data.url, "GET");
            });

        }

        function loginOauth2(partner) {
            $localStorage.lastSsoPartner = partner;

            UserService.oauth2RedirectionUrl(partner).then(function(data) {
                $.redirect(data.data.url, "GET");
            });

        }

        vm.checkCapsLockKey = function (event) {
            if (event.originalEvent && isFunction(event.originalEvent.getModifierState)) {
                vm.isCapsLockOn = event.originalEvent.getModifierState('CapsLock');
            }
        };

        function isFunction(x) {
            return Object.prototype.toString.call(x) == '[object Function]';
        }
        
    }
})();

(function () {
    'use strict';
    angular
    .module('plagiat2017App')
    .directive('enterDirective', function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.enterDirective);
                    });
                    event.preventDefault();
                }
            });
        };
    });
})();

angular
    .module('plagiat2017App').directive('autoFillSync', function($timeout) {
        return {
            require: 'ngModel',
            link: function(scope, elem, attrs, ngModel) {
                var origVal = elem.val();
                $timeout(function () {
                    var newVal = elem.val();
                    if(ngModel.$pristine && origVal !== newVal) {
                        ngModel.$setViewValue(newVal);
                    }
                }, 500);
            }
        };
    });

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('info', {
            parent: 'account',
            url: '/info',
            data: {
                pageTitle: 'global.menu.info'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/info/info.html',
                    controller: 'InfoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'docuSubmitDate,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('info');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .controller('InfoController', InfoController);

    InfoController.$inject = ['$rootScope', 'AccountService', '_', '$translate', 'tmhDynamicLocale', 'ContactFormModelRequest',
        'ContactAddresatsModelRequest', 'emailFilter', 'InfoService', '$mdDialog', '$document', 'InstanceService', '$log',
        'DetectInstanceService', 'ClientService', 'USERSCHOOLTYPE', '$sce'];

    function InfoController($rootScope, AccountService, _, $translate, tmhDynamicLocale, ContactFormModelRequest,
                            ContactAddresatsModelRequest, emailFilter, InfoService, $mdDialog, $document, InstanceService, $log,
                            DetectInstanceService, ClientService, USERSCHOOLTYPE, $sce) {
        var vm = this;

        vm.isIndividual = AccountService.role.isIndividual();
        vm.isOperator = AccountService.role.isOperator();
        vm.isLecturer = AccountService.role.isLecturer();
        vm.isAdmin = AccountService.role.isAdmin();
        vm.isReseller = AccountService.role.isReseller();
        vm.clientType = AccountService.getClientType();
        vm.isAcceptRegulationsEnabled = AccountService.account.clientSettings.acceptRegulationsEnabled;
        vm.regulationsUrl = AccountService.account.clientSettings.regulationsUrl;

        vm.showProcedures = (AccountService.account.clientRegionId == 8) && AccountService.role.isAdmin();

        vm.instance = DetectInstanceService.instance();

        vm.numbers = [1, 2, 3, 4, 5, 6];

        if (vm.instance === 'ro') {
            vm.instanceStr = '_instance_ro';
        } else if (vm.instance === 'int') {
            vm.instanceStr = '_instance_int';
        } else {
            vm.instanceStr = '';
        }

        vm.accountType = AccountService.account.accountType;
        vm.accountTypeSuffix = '';
        vm.userRole = getAccountTypeSuffix(vm.accountType);
        vm.userRoleYoutube = getAccountTypeYoutubeSuffix(vm.accountType);
        vm.trustSrc = trustSrc;
        vm.translateStr = translateStr;
        vm.clearForm = clearForm;
        vm.sendForm = sendForm;

        vm.contactFormModel = new ContactFormModelRequest();
        vm.adresatsRequest = [];
        vm.contactForm = vm.contactFormModel.contactForm;
        vm.messages = vm.contactFormModel.messages;
        var formData = new FormData();
        vm.isSending = false;

        vm.ul = $document[0].getElementById("faq");
        vm.ul.addEventListener('click', handleClick);

        vm.adresatsArr = [];

        switch(vm.instance) {
            case 'int':
                vm.instanceType = '_int';
                break;
            case 'ro':
                vm.instanceType = '_ro';
                break;
            case 'pl':
                vm.instanceType = '_pl';
                break;
            case 'aka':
                vm.instanceType = '_aka';
                break;
            default:
                vm.instanceType = '_pl';
        }

        switch(vm.clientType) {
	        case 'CLIENT_TYPE_STANDARD':
	        case 'CLIENT_TYPE_ASAP':
	        	vm.clientTypeAdmin = ClientService.clientTypes.other.suffix;
	        	vm.clientTypeSuffix = ClientService.clientTypes.notIndividual.suffix;
	          break;
            case 'CODE_ACCOUNT':
                vm.clientTypeAdmin = ClientService.clientTypes.codeAccount.suffix;
                vm.clientTypeSuffix = ClientService.clientTypes.codeAccount.suffix;
                break;
            case 'PUBLISHING_HOUSE':
	        	vm.clientTypeAdmin = ClientService.clientTypes.publisher.suffix;
	        	vm.clientTypeSuffix = ClientService.clientTypes.publisher.suffix;
	          break;
	        case 'SCHOOL':
	        	vm.clientTypeAdmin = ClientService.clientTypes.school.suffix;
	        	vm.clientTypeSuffix = ClientService.clientTypes.school.suffix;
	        	vm.accountTypeSuffix = getAccountTypeSuffix(vm.accountType);
	          break;
	        default:
                vm.clientTypeAdmin = ClientService.clientTypes.other.suffix;
                vm.clientTypeSuffix = ClientService.clientTypes.notIndividual.suffix;
        }

        function getAccountTypeSuffix(accountType){
        	switch(accountType) {
        		case USERSCHOOLTYPE.USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR.value:
                    return '.admin';
        		case USERSCHOOLTYPE.USER_SCHOOL_TYPE_ORG_UNIT_ADMIN.value:
        			return '.unitadmin';
        		case USERSCHOOLTYPE.USER_SCHOOL_TYPE_TEACHER.value:
        			return '.teacher';
        		case USERSCHOOLTYPE.USER_SCHOOL_TYPE_STUDENT.value:
        			return '.student';
        	}
        }

        function getAccountTypeYoutubeSuffix(accountType){
            switch(accountType) {
                case USERSCHOOLTYPE.USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR.value:
                    return '.admin';
                case USERSCHOOLTYPE.USER_SCHOOL_TYPE_ORG_UNIT_ADMIN.value:
                    return '.unitadmin';
                case USERSCHOOLTYPE.USER_SCHOOL_TYPE_DEANERY.value:
                    return '.deanery';
                case USERSCHOOLTYPE.USER_SCHOOL_TYPE_TEACHER.value:
                    return '.teacher';
                case USERSCHOOLTYPE.USER_SCHOOL_TYPE_STUDENT.value:
                    return '.student';
            }
        }

        getAdressats();

        function getAdressats(){
            if (vm.isIndividual) {
                return;
            }
            vm.adresats = [];

            InfoService.getAdmins().then(function (response) {
                angular.forEach(response, function (key) {
                    if (emailFilter(key.clieAdminEmail)) {
                        vm.adresats.push({name: $translate.instant("info.contact-form.administrator") + ' (' + key.clieAdminClientName +
                                ') - ' + key.clieAdminName + ' ' + key.clieAdminSurname, email: key.clieAdminEmail});
                    }
                });

                var helpdeskEmail = AccountService.getClientRegionHelpdeskEmail();
                var officeEmail = AccountService.getClientRegionOfficeEmail();

                vm.adresats.push({
                    name: $translate.instant("info.contact-form.helpdesk"),
                    email: helpdeskEmail
                });

                vm.adresats.push({
                    name: $translate.instant("info.contact-form.account-manager"),
                    email: officeEmail
                });

            });

            vm.contactForm.adresat = null;
        }

        function handleClick(event) {
            vm.header = event.target;
            vm.next = vm.header.nextElementSibling;
            if( vm.next !== null ){
                if (vm.next.style.display === 'block') {
                    vm.header.style.border = '1px solid #ddd';
                    vm.next.style.display = 'none';
                } else {
                    vm.header.style.border = 'none';
                    vm.next.style.display = 'block';
                }
            }

        }

        function resetMessages() {
            vm.contactFormModel = new ContactFormModelRequest();
            vm.messages = vm.contactFormModel.messages;
        }

      function trustSrc(src) {
        return $sce.trustAsResourceUrl(src);
      }

      function translateStr(val) {
            return $translate.instant(val);
      }

        function clearForm() {
            resetMessages();
            vm.adresat = vm.contactFormModel.adresat;
            vm.contactForm = vm.contactFormModel.contactForm;
            formData = new FormData();
            vm.isSending = false;
        }

        function sendForm() {
            vm.isSending = true;
            angular.forEach(vm.contactForm, function (element, key) {
                formData.append(key, element);
            });

            vm.sendFn = vm.isIndividual ? InfoService.sendForm(formData) : InfoService.operator.sendForm(formData);
            vm.sendFn.then(function (response) {
                clearForm();
                vm.isSending = false;
                vm.messages.success = true;
                vm.fileName = false;
            }).catch(function (error) {
                vm.messages.error = true;
            });


        }
    }
})();

angular.module('plagiat2017App').filter('email', function () {
    var validateEmail = function (email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };
    return function (input) {
        return validateEmail(input);
    };
});

angular.module('plagiat2017App')
.component('selfEnrollmentModal', {
    templateUrl: 'app/account/documents/self-enrollment/self-enrollment.template.html',
    controller: SelfEnrollmentController,
    controllerAs: 'vm'
});

SelfEnrollmentController.$inject = ['ModalService', 'AssignmentsService',
                                    '$mdDialog', 'items'];

function SelfEnrollmentController(ModalService, AssignmentsService,
                                  $mdDialog, items) {
    var vm = this;

    vm.findAssignment = findAssignment;
    vm.joinAssignment = joinAssignment;
    vm.cancel = cancel;
    
    vm.assignment = null;
    vm.found = true;
    vm.isLoading = false;

    this.$onInit = function () {
        vm.isLoading = true;
        vm.isLoading = false;
    };
    
    function joinAssignment() {
        vm.isLoading = true;
        AssignmentsService
            .joinAssignment({shortcode: vm.shortcode, assignmentId: vm.assignment.id})
            .then(function (resp) {
                vm.isLoading = false;
                vm.cancel();
                items.onJoin();
                ModalService.showSuccessModal("assignments.self-enrollment.success");
            }, function (errorResponse) {
                ModalService.showErrorModal(errorResponse);
                vm.isLoading = false;
            });
    }
    
    function findAssignment() {
        if (!vm.shortcode) {
            return;
        }
        vm.isLoading = true;
        AssignmentsService
            .findAssignment(vm.shortcode)
            .then(function (resp) {
                vm.assignment = resp.data;
                if (vm.assignment) {
                    vm.found = true;
                } else {
                    vm.found = false;
                }
                vm.isLoading = false;
            }, function (errorResponse) {
                ModalService.showErrorModal(errorResponse);
                vm.isLoading = false;
            });
    }
    
    function cancel() {
        return $mdDialog.hide();
    }

}

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .filter('percentage', percentage);

    percentage.$inject = ['$filter'];

    function percentage($filter) {
        return function (input, decimals) {
            return $filter('number')(input * 100, decimals) + '%';
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .filter('numberOfPages', getNumberOfPages);

    getNumberOfPages.$inject = ['AccountService'];

    function getNumberOfPages(AccountService) {
        return getNumberOfPagesFilter;

        function getNumberOfPagesFilter(size) {
            return pagesToString(getRandomPages(size,AccountService.account.numberOfRandomPages,AccountService.account.avgSizeOfLettersPerPage));
        }
    }

    function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function pagesToString(bucket) {
        var numberOfPagesString = "";
        bucket.sort().forEach(function (pageNumber) {
            numberOfPagesString = numberOfPagesString + pageNumber + ",";
        });
        numberOfPagesString = numberOfPagesString.slice(0, -1);

        return numberOfPagesString + ".";
    }

    function getRandomPages(size, numberOfRandomPages, avgSizeOfLettersPerPage) {
        var numOfpages = Math.ceil(size / avgSizeOfLettersPerPage);
        var bucket = [];

        if (numberOfRandomPages >= numOfpages) {
            for (var i = 1; i <= numOfpages; i++) {
                bucket.push(i);
            }
            return bucket;
        }
        for (var i = 0; i < numberOfRandomPages; i++) {
            var min, max;
            if (numOfpages <= 4 + numberOfRandomPages) {
                min = 1;
                max = numOfpages;
            } else if (numOfpages > 4 + numberOfRandomPages && numOfpages <= 10 + numberOfRandomPages) {
                min = 3;
                max = numOfpages - 2;
            } else if (numOfpages > 10 + numberOfRandomPages) {
                min = 5;
                max = numOfpages - 5;
            }
            var getPage;
            while (getPage = getRandomInt(min, max)) {
                if (!bucket.includes(getPage)) {
                    bucket.push(getPage);
                    break;
                }
            }
        }
        return bucket.sort();
    }

})();

(function () {
    'use strict';

    function DocumentsUniversalRoleController(DocumentSearchRequestModel, AccountService, $log, $q, _, $localStorage, $timeout,
        UserService, QueryRequest, DocumentService, DateService, SearchService, SearchRequest, $document, ClientService,
                                              ClientQueryRequest, SIMPLE_SEARCH_DELAY, JSA_ORDER_STATUS, ORPPD_STATUS) {
        var vm = this;
        vm.documentsSearchRequest = new DocumentSearchRequestModel();
        if (DocumentService.searchObject) {
            vm.documentsSearchRequest = DocumentService.searchObject;
            DocumentService.searchObject = null;
        } else {
            vm.documentsSearchRequest.docuSubmitDateFrom = getDateAYearAgo();
        }
        vm.fixDateDcouments = DateService.fixDateDcouments;
        vm.simpleSearch = true;
        vm.userCantSeeTheDocumentsOfOthers = AccountService.getPermision('PERM_USER_CANT_SEE_THE_DOCUMENTS_OF_OTHERS');
        setShowOnlyForUser(angular.isUndefined($localStorage.showOnlyForUser) ? true : $localStorage.showOnlyForUser);
        vm.searchRequest = new SearchRequest();
        vm.queryRequest = new QueryRequest();
        vm.clientQueryRequest = new ClientQueryRequest();
        vm.queryRequest.limit = $localStorage.documentsListLimit ? $localStorage.documentsListLimit : vm.queryRequest.limit;
        vm.jsa = AccountService.getClientSettings().jsaIntegration;
        vm.orppdIntegration = AccountService.getClientSettings().orppdIntegration;
        vm.clientSettings = AccountService.getClientSettings();
        vm.ORPPD_STATUS = ORPPD_STATUS;
        vm.clientTypePublishingHouse = AccountService.clientType.isPublishingHouse();
        vm.clientTypeCodeAccount = AccountService.clientType.isCodeAccount();
        vm.isReseller = AccountService.role.isReseller();
        vm.isMinistry = AccountService.role.isMinistry();
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.shouldShowAuthor = !vm.onIsStudent;
        vm.docuCoordinatorTranslationKey = AccountService.clientType.isSchool() ? 'document.metric.client-type.school.teacher' : 'document.model.docu-coordinator';
        vm.isLoggedUserOrgUnitAdmin = AccountService.role.isOrgUnitAdmin();
        vm.JSA_ORDER_STATUS = JSA_ORDER_STATUS;
        vm.clientRegions = [];

        vm.toogleSearch = toogleSearch;
        vm.getDocuments = getDocuments;
        vm.setUserSearchSetting = setUserSearchSetting;
        vm.clear = clear;
        vm.searchTextChange = searchTextChange;
        vm.selectedUserChange = selectedUserChange;
        vm.selectedClientChange = selectedClientChange;
        vm.querySearch = querySearch;
        vm.isCoordinatorVisible = isCoordinatorVisible;
        vm.canUserSearchCoordinator = canUserSearchCoordinator;
        vm.querySearchClients = querySearchClients;

        this.$onInit = function () {
            if (vm.onIsSuperAdmin) {
                ClientService.getClientRegions().then(
                    function (success) {
                        vm.clientRegions = success.data;
                    });

                ClientService.getClientCountries().then(
                    function (success) {
                        vm.countries = success.data;
                    });
            }

        };

        function querySearchClients(query) {
                vm.searchRequest.pageNumber = 0;
                vm.searchRequest.pageSize = 20;
                vm.searchRequest.sortTab = SearchService.sort(vm.clientQueryRequest);
                vm.searchRequest.search = query;
                vm.searchRequest.simpleSearch = query;

                return ClientService.searchClients(vm.searchRequest).then(function(response) {
                    return response.content;
                });
        }

        function prepareGetDocumentsMapping(){
            vm.onGetDocuments(vm.documentsSearchRequest);
        }

        function simpleSearch(){
            vm.onGetDocumentsSimpleSearch(vm.documentsSearchRequest);
        }

        function verifyOrganisationaUnitId(){
            setShowOnlyForUser((AccountService.account.organisationalUnitId === 0) ? true : vm.documentsSearchRequest.showOnlyForUser);
        }

        function getDocuments(){
            $localStorage.documentsListLimit = vm.onQueryRequest.limit;
            if( DocumentService.searchUser ) {
              vm.simpleSearch = false;
              vm.selectedUser = DocumentService.searchUser;
            }
            if( DocumentService.searchClient ) {
                vm.simpleSearch = false;
                vm.selectedClient = DocumentService.searchClient;
            }
            vm.documentsSearchRequest.simpleSearch.length === 0 ? prepareGetDocumentsMapping() : '';
            vm.documentsSearchRequest.simpleSearch.length > 2 ? simpleSearch() : '';
        }

        function setUserSearchSetting(){
            vm.onResetSelection();
            $localStorage.showOnlyForUser = vm.documentsSearchRequest.showOnlyForUser;
            if( vm.documentsSearchRequest.showOnlyForUser ){
                vm.documentsSearchRequest.searchUser = null;
            }
            verifyOrganisationaUnitId();
            getDocuments();
        }

        function toogleSearch() {
            vm.onResetSelection();
            vm.simpleSearch ? vm.documentsSearchRequest.simpleSearch = '' : '';
            vm.simpleSearch = !vm.simpleSearch;
            if (!vm.simpleSearch) {
                var dateToChange = new Date();
                dateToChange.setFullYear(dateToChange.getFullYear() - 1);
                vm.documentsSearchRequest.docuSubmitDateFrom = dateToChange;
            }
        }

        function clear() {
            vm.documentsSearchRequest = new DocumentSearchRequestModel();
            vm.selectedClient = undefined;
            vm.selectedUser = undefined;
            getDocuments();
        }

        function searchTextChange(query){

        }

        function selectedClientChange(item) {
            if (item) {
                setShowOnlyForUser(false);
                vm.documentsSearchRequest.searchClient = item.id;
            } else {
                vm.documentsSearchRequest.searchClient = null;
            }
            vm.getDocuments();
        }

        vm.querySearchOrganizations = function () {
            return vm.searchOrganizationText ? vm.onSearchData.orgUnitInfo.filter(function (org) {
                return org.orguniLabel.toLowerCase().includes(vm.searchOrganizationText.toLowerCase());
            }) : vm.onSearchData.orgUnitInfo;
        };

        vm.selectedOrganizationChange = function (item) {
            if (item) {
                vm.documentsSearchRequest.organisationalUnit = item.id;
            } else {
                vm.documentsSearchRequest.organisationalUnit = null;
            }
            vm.getDocuments();
        };

        function selectedUserChange(item) {
            if( angular.isDefined(item) ){
                setShowOnlyForUser(false);
                vm.documentsSearchRequest.searchUser = item.id;
            }
            else{
                vm.documentsSearchRequest.searchUser = null;
            }
            vm.getDocuments();
        }

        function lowercase(string) {
            return angular.isString(string) ? string.toLowerCase() : string;
        }

        function querySearch(query) {
            var results = {};

            if(query.length > 2){
	        	vm.searchRequest.pageNumber = 0;
	            vm.searchRequest.pageSize = 20;
	            vm.searchRequest.sortTab = SearchService.sort(vm.queryRequest);
	            vm.searchRequest.search = query;
	            vm.searchRequest.simpleSearch = query;

	            return UserService.searchUsers(vm.searchRequest).then(function(responseData) {
	            	vm.users = responseData.content;
	            	results = _.filter(vm.users, function(o) { return (lowercase(o.userName).indexOf(lowercase(query)) && lowercase(o.userSurname).indexOf(lowercase(query)) && lowercase(o.userEmail).indexOf(lowercase(query)) ) !== -1 ; });
	                return results;
	            })
            }else {
            	var deferred = $q.defer();
            	$timeout(function(){
            		deferred.resolve([]);
            	}, 1200, false);
            	return deferred.promise;
            }
        }

        $timeout(function() {
            verifyOrganisationaUnitId();
            getDocuments();
        }, 1);

        function setShowOnlyForUser(value){
            if(vm.userCantSeeTheDocumentsOfOthers && vm.onIsOperator){
            	//vm.documentsSearchRequest.showOnlyForUser = true;
            	//$localStorage.showOnlyForUser = true;
            	vm.hideShowOnlyForUserOption = true;
            }else if(vm.onIsSuperAdmin) {
            	vm.documentsSearchRequest.showOnlyForUser = false;
            	$localStorage.showOnlyForUser = false;
            	vm.hideShowOnlyForUserOption = false;
            }else{
            	vm.documentsSearchRequest.showOnlyForUser = value;
            	$localStorage.showOnlyForUser = value;
            }
        }

        function disableInputNumberDefaultBehavior() {
        	var inputs = Array.from(document.querySelectorAll("#wp1FromInput, #wp1ToInput, #wp2FromInput, #wp2ToInput"));
        	inputs.forEach(function(input) {
        		input.addEventListener("wheel", function (event) {
        			event.preventDefault();
        		});
        	});
        }
        disableInputNumberDefaultBehavior();

        function isCoordinatorVisible() {
            return !vm.clientTypePublishingHouse;
        }

        function canUserSearchCoordinator() {
            if(vm.onIsLecturer) {
                return AccountService.getClientSettings().userTeacherCanChangePromoterDuringAddDocument;
            } else {
                return true;
            }
        }

        function getDateAYearAgo(){
            var dateToChange = new Date();
            dateToChange.setMonth(dateToChange.getMonth() - 12);
            return dateToChange;
        }

    }

    angular.module('plagiat2017App')
    .component('documentsSearchUniversal', {
        templateUrl: 'app/account/documents/documents-search/documents-search.template.html',
        controller: DocumentsUniversalRoleController,
        bindings: {
            onGetDocuments: '<',
            onGetDocumentsSimpleSearch: '<',
            onQueryRequest: '=',
            onIsStudent: '<',
            onIsLecturer: '<',
            onIsOperator: '<',
            onIsIndividual: '<',
            onIsAdmin: '<',
            onIsSuperAdmin: '<',
            onSearchData: '=',
            onGetUserDocuments: '<',
            onResetSelection: '<'
        }
    });
})();

(function () {
    'use strict';

    function DocumentsSearchIndividualController(documentsSearchIndividualRequest, $log, $timeout, DateService,
                                                 $localStorage, SIMPLE_SEARCH_DELAY, AccountService) {
        var vm = this;
        vm.documentsSearchRequest = new documentsSearchIndividualRequest();
        vm.getDocuments = getDocuments;
        vm.fixDateDcouments = DateService.fixDateDcouments;
        vm.simpleSearch = true;
        vm.toogleSearch = toogleSearch;
        vm.clear = clear;
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.clientSettings = AccountService.getClientSettings();
        vm.isLoggedUserOrgUnitAdmin = AccountService.role.isOrgUnitAdmin();
        vm.clientTypeCodeAccount = false;
        vm.clientRegions = [];

        function getDocuments(){
            $localStorage.documentsListLimit = vm.onQueryRequest.limit;
            vm.documentsSearchRequest.simpleSearch.length === 0 ? vm.onGetDocuments(vm.documentsSearchRequest) : '';
            vm.documentsSearchRequest.simpleSearch.length > 2 ? vm.onGetDocumentsSimpleSearch(vm.documentsSearchRequest) : '';
        }

        function toogleSearch() {
            vm.onResetSelection();
            vm.simpleSearch ? vm.documentsSearchRequest.simpleSearch = '' : '';
            vm.simpleSearch = !vm.simpleSearch;
        }

        function clear() {
            vm.documentsSearchRequest = new documentsSearchIndividualRequest();
            getDocuments();
        }


        $timeout(function() {
            getDocuments();
        }, 1);

    }

    angular.module('plagiat2017App')
    .component('documentsSearchIndividual', {
        templateUrl: 'app/account/documents/documents-search/documents-search.template.html',
        controller: DocumentsSearchIndividualController,
        bindings: {
            onGetDocuments: '<',
            onQueryRequest: '=',
            onIsLecturer: '<',
            onIsOperator: '<',
            onIsIndividual: '<',
            onSearchData: '=',
            onResetSelection: '<',
            onGetDocumentsSimpleSearch: '<',
        }
    });

})();

(function() {
	'use strict';
	angular.module('plagiat2017App')
        .factory('DocumentProtocolService', DocumentProtocolService);

	DocumentProtocolService.$inject = [ '$http', '$q', 'FileSaver', 'PlagiatValidationService', 'AccountService'];

	function DocumentProtocolService($http, $q, FileSaver, PlagiatValidationService, AccountService) {
		var service = {
            generateProtocolForDocuments: generateProtocolForDocuments
		};
		return service;

		function generateProtocolForDocuments(documentId, protocolForDocumentId, fileName) {
			var url = 'api/protocols/protocol-for-document/generate/' + documentId + ',' + protocolForDocumentId
			+ ',' + AccountService.account.langKey;
			return $http({
				url : url,
				method : "GET",
				responseType : 'arraybuffer'
			}).then(
			    function(success) {
                    onSuccess(success, fileName, '.pdf');
                },
                function(error) {
                    PlagiatValidationService.getModalError(error);
                }
            );
		}

        function onSuccess(success, fileName, reportExtension) {
            var blob = new Blob(
                [ success.data ],
                {
                    type: "text/pdf; encoding=UTF-8"
                }
            );
            saveAs(blob, fileName + reportExtension);
        }
	}

})();

(function () {
    'use strict';

    function DocumentProtocolController($translate, DocumentProtocolService, AccountService) {
        var vm = this;
        vm.getProtocolForDocument = getProtocolForDocument;

        function getProtocolForDocument(protocolForDocument) {
            var fileName = protocolForDocument.fileName + "_" + vm.document.docuTitle;
            DocumentProtocolService.generateProtocolForDocuments(
                vm.document.documentId,
                protocolForDocument.id,
                fileName,
                AccountService.account.pickedLang
            );
        }
    }

    angular.module('documentProtocol', [])
    .component('documentProtocol', {
        templateUrl: 'app/account/documents/documents-list/document-protocol/document-protocol.template.html',
        controller: DocumentProtocolController,
        bindings: {
            document: '<',
            protocolForDocuments: '<'
        }
    });

})();

(function () {
    'use strict';

    function DocumentButtonsReportController($rootScope, $state, $translate, PaymentsService,
        ReportDocumentService, $mdDialog, $window, $mdToast, TokenService, $log, DocumentService, 
        ContractService, PlagiatValidationService, JsaReportService, JSA_ORDER_STATUS, AccountService, ModalService, DOCUMENT_STATUS) {
        var vm = this;
        vm.getDocumentReport = getDocumentReport;
        vm.getDocumentReport2018 = getDocumentReport2018;
        vm.checkTokens = checkTokens;
        vm.checkTokensWithExtraOptions = checkTokensWithExtraOptions;
        vm.canAddPriority = canAddPriority;
        vm.showAddPriorityDialog = showAddPriorityDialog;
        vm.canAddPriorityFromContract = canAddPriorityFromContract;
        vm.canSubmitAssignment = canSubmitAssignment;
        vm.canSubmitAssignmentCorrection = canSubmitAssignmentCorrection;
        vm.canSubmitAssignmentPaidCorrection = canSubmitAssignmentPaidCorrection;
        vm.addPriorityFromContract = addPriorityFromContract;
        vm.checkDocument = checkDocument;
        vm.checkDocumentCodeAccount = checkDocumentCodeAccount;
        vm.getFullJsaReport = getFullJsaReport;
        vm.jsaOrderStatus = JSA_ORDER_STATUS;
        vm.checkDisabled = false;
        vm.DOCUMENT_STATUS = DOCUMENT_STATUS;


        vm.isCodeAccount = AccountService.clientType.isCodeAccount();
        vm.assignmentsPaidCorrectionsEnabled = AccountService.getClientSettings().assignmentsPaidCorrectionsEnabled;
        vm.shouldShowCodeAccountCheckModal = AccountService.clientType.isCodeAccount() && !AccountService.role.isAdmin();
        vm.maxAssignmentCorrections = AccountService.getClientSettings().maxAssignmentCorrections;
        vm.report2020Disabled = AccountService.getClientSettings().report2020Disabled;
        vm.isIndividual = AccountService.role.isIndividual();
        vm.isSuperAdmin = AccountService.role.isSuperAdmin();
        vm.userId = AccountService.account.id;

        function checkDocument(docId, codeId) {
            $mdDialog.show($mdDialog.confirm()
                .title($translate.instant("document.messages.checknow"))
                .textContent(vm.checkInfo)
                .ariaLabel(vm.checkInfo)
                .ok('Ok')
                .cancel($translate.instant("global.button.cancel"))
            ).then(function () {
                vm.checkDisabled = true;
                ModalService.showPleaseWaitDialog();
                DocumentService.operator.checkDocument(docId, codeId)
                    .then(function () {
                        ModalService.showSuccessModal("global.messages.info.actionsuccess");
                        vm.onReloadDocuments();
                        ContractService.broadcast();
                    }).catch(function (response) {
                        vm.checkDisabled = false;
                        PlagiatValidationService.getModalError(response.data);
                    });
            });
        }

        function checkTokens(docId, ev) {
            vm.checkDisabled = true;
    
            DocumentService.isWaitingPayment(docId).then(function (responseData) {
                vm.checkDisabled = false;
                var onDocumentWaitingPayment = responseData.data;
                
                if (onDocumentWaitingPayment) {
                    $mdDialog.show($mdDialog.confirm()
                        .title($translate.instant('document.messages.waiting-payment.title'))
                        .textContent($translate.instant('document.messages.waiting-payment'))
                        .ariaLabel('checkInfo')
                        .targetEvent(ev)
                        .ok($translate.instant('document.messages.waiting-payment.continue'))
                        .cancel($translate.instant('document.messages.waiting-payment.cancel'))
                    ).then(function () {
                        showExtraOptionsDialog();
                    });
                } else {
                    showExtraOptionsDialog();
                }
        
            });
        }
        
        function showExtraOptionsDialog() {   
            $mdDialog.show({
                controller: 'ExtraOptionsController',
                templateUrl: 'app/components/document/extra-options/extra-options.dialog.html',
                clickOutsideToClose: true,
                controllerAs: 'vm',
                multiple: true,
                locals: {
                    onSuccess: vm.checkTokensWithExtraOptions,
                    documentId: vm.onDocumentId,
                    documentSize: vm.onDocumentSize
                }
            });
        }

        function showAddPriorityDialog() {
            $mdDialog.show({
                controller: 'AddPriorityController',
                templateUrl: 'app/components/document/extra-options/add-priority.dialog.html',
                clickOutsideToClose: false,
                controllerAs: 'vm',
                multiple: true,
                locals: {
                    documentId: vm.onDocumentId,
                    documentSize: vm.onDocumentSize,
                    onReloadDocuments:  vm.onReloadDocuments
                }
            });
        }

        function canAddPriority() {
            var notTooLate = vm.onDocumentReleaseDate && (vm.onDocumentReleaseDate > new Date().getTime());
            return vm.onDocumentStatus == 0 && vm.isIndividual && notTooLate;
        }


        function addPriorityFromContract() {
            ModalService.showConfirmModal("document.add-priority-from-contract.dialog").then(
              function () {
                  DocumentService.addPriorityFromContract(vm.onDocumentId)
                    .then(function () {
                        ContractService.broadcast();
                        vm.onReloadDocuments();
                    })
                    .catch(function (response) {
                        PlagiatValidationService.getModalError(response.data);
                    });
              }
            )
        }

        function canAddPriorityFromContract() {
            return vm.onDocumentStatus === 0 && !vm.onDocumentPriorityAddedFromContract &&
              AccountService.role.isAdmin() &&
              AccountService.getClientSettings().addPriorityFromContractEnabled;
        }
    
        function checkTokensWithExtraOptions(newExtraOptions, totalPrice, availableTokens) {
            ModalService.showPleaseWaitDialog(true);
        
            var useTokenRequestDto = {
                documentId: vm.onDocumentId,
                documentExtraOptions: newExtraOptions
            };
            PaymentsService.useTokens(useTokenRequestDto).then(function (responseData) {
                TokenService.broadcastTokens();
                if (responseData.data.used === false) {
                    $mdDialog.hide(); //close please wait
                
                    var confirm = $mdDialog.confirm()
                        .title($translate.instant('global.confirm'))
                        .textContent($translate.instant('global.messages.error.notenough'))
                        .ariaLabel('global.messages.error.notenough')
                        .ok($translate.instant('document.buytokens'))
                        .multiple(true)
                        .cancel($translate.instant('document.metric.check-later'));
                    $mdDialog.show(confirm).then(function (result) {
                        buyTokens(totalPrice - availableTokens);
                    });
                    vm.pending = false;
                } else {
                    ModalService.showSuccessModal("global.messages.info.systemstart").then(function () {
                        vm.onReloadDocuments();
                    });
                }
            
            });
        }
    
        function buyTokens(tokensNeeded) {
            TokenService.buyTokens = true;
            TokenService.tokensNedded = tokensNeeded;
            $mdDialog.hide();
            $state.go('payments', {documentId: vm.onDocumentId});
        }
    
        function checkDocumentCodeAccount(documentId, size, isAssignment) {
            var checkDocumentCallback = function(codeDialogParameters) {
                var codeId = codeDialogParameters.codeId;
                return vm.checkDocument(documentId, codeId);
            };
            $mdDialog.show({
                templateUrl: 'app/account/documents/document-code-check/document-check-code.dialog.html',
                clickOutsideToClose: false,
                locals: {
                    items: {
                        documentId: documentId,
                        checkDocumentCallback: checkDocumentCallback,
                        isAssignment: vm.onDocument.assignmentId,
                        priorityCode: false,
                        size: size
                    }
                },
                controllerAs: 'vm',
                controller: DialogController
            });
            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
            }
        }

        function getDocumentReport() {
            if (vm.isSuperAdmin) {
                if (!vm.onReport2020Disabled) {
                    openDocumentReport2020();
                } else {
                    getDocumentReport2018();
                }
            } else if (!vm.report2020Disabled) {
                openDocumentReport2020();
            } else {
                getDocumentReport2018();
            }
        }

        function openDocumentReport2020() {
            vm.onIsLoaderActive = true;
            ReportDocumentService.getReport2020RedirectionUrl(vm.onDocumentId).then(function(redirectionUrl){
                window.open(redirectionUrl, "_blank");
                vm.onIsLoaderActive = false;
            });
        }

        function getDocumentReport2018() {
            vm.onIsLoaderActive = true;
            ReportDocumentService.getDocumentReport2018(vm.onDocumentId, 'full', vm.onDocuAuthor).then(function(){
                vm.onIsLoaderActive = false;
            });
        }

        function getFullJsaReport() {
            vm.onIsLoaderActive = true;
            JsaReportService.getReport(vm.onDocumentId, true, vm.onDocuAuthor).then(function(){
                vm.onIsLoaderActive = false;
            }).catch(function(){
                vm.onIsLoaderActive = false;
            });
        }

        function canSubmitAssignment() {
            return vm.onDocument.assignmentId 
                && vm.onDocument.userId === vm.userId 
                && (vm.onDocumentStatus === DOCUMENT_STATUS.DRAFT.id);
        }

        // pokazujemy gdy w statusie DO POPRAWY i nie zostal jeszcze zaladowany poprawiony dokument, 
        // ale mozna jeszcze dodac bezplatny dokument
        function canSubmitAssignmentCorrection() {
            return vm.onDocument.assignmentId 
                && (vm.onDocument.userId === vm.userId)
                && (vm.onDocumentStatus === DOCUMENT_STATUS.EDITION_REQUIRED.id)
                && !(vm.onDocument.docuNextDocumentID)
                && (vm.onDocument.docuVersion && (vm.onDocument.docuVersion < vm.maxAssignmentCorrections) || (!vm.onDocument.docuVersion && (vm.maxAssignmentCorrections > 1)));
        }

        // pokazujemy gdy w statusie DO POPRAWY i nie zostal jeszcze zaladowany poprawiony dokument
        // nie mozna juz dodac bezplatnego dokumentu, ale mozna dodac platny
        function canSubmitAssignmentPaidCorrection() { //pokazujemy gdy w statusie DO POPRAWY i nie zostal jeszcze zaladowany poprawiony dokument
            return vm.onDocument.assignmentId 
                && (vm.onDocument.userId === vm.userId)
                && (vm.onDocumentStatus === DOCUMENT_STATUS.EDITION_REQUIRED.id)
                && !(vm.onDocument.docuNextDocumentID)
                && (vm.onDocument.docuVersion && (vm.onDocument.docuVersion >= vm.maxAssignmentCorrections) || (!vm.onDocument.docuVersion && (vm.maxAssignmentCorrections <= 1)))
                && vm.isCodeAccount
                && vm.assignmentsPaidCorrectionsEnabled;
        }

    }

    angular.module('documentButtonsReport', [])
        .component('documentButtonsReport', {
            templateUrl: 'app/account/documents/documents-list/document-buttons-report/document-buttons-report.template.html',
            controller: DocumentButtonsReportController,
            bindings: {
                onDocumentId: '<',
                onDocumentSize: '<',
                onDocumentReleaseDate: '<',
                onDocumentStatus: '=',
                onDocumentHasReport: '=',
                onReloadDocuments: '<',
                onIsLoaderActive: '=',
                onHasAlert: '<',
                onReport2020Disabled: '=',
                onDocuAuthor: '=',
                onDocumentHasJsaReport: "<",
                onDocumentJsaStatus: "<",
                onDocumentPriorityAddedFromContract: "<",
                onDocument: "<",
                onAvailableExtensions: "<",
                onSubmitAssignment: "<",
                onSubmitAssignmentCorrection: "<",
                onSubmitAssignmentPaidCorrection: "<",
            }
        });

})();

(function () {
    'use strict';

    function DocumentButtonsController($rootScope, $state, $translate, DocumentService, PaymentsService,
        ReportDocumentService, $mdDialog, $window, $mdToast, TokenService, $log, JsaReportService, PlagiatValidationService,
        JSA_ORDER_STATUS, DOCUMENT_STATUS, ModalService, OrppdService, ORPPD_STATUS, AccountService, PERMISSIONS, ContractService,
        Principal
    ) {
        var vm = this;
        vm.getDocumentReport = getDocumentReport;
        vm.getShortDocumentReport = getShortDocumentReport;
        vm.onClickReportSimilarity2017Pdf = onClickReportSimilarity2017Pdf;
        vm.getDocumentReport2018 = getDocumentReport2018;
        vm.removeDocument = removeDocument;
        vm.showText = showText;
        vm.useTokens = useTokens;
        vm.getDocuments = vm.onDocuments;
        vm.editDocument = editDocument;
        vm.editDocumentForIndividual = editDocumentForIndividual;
        vm.editDocumentBySuperAdmin = editDocumentBySuperAdmin;
        vm.showHistory = showHistory;
        vm.recheckAiDetection = recheckAiDetection;
        vm.checkDocumentAgain = checkDocumentAgain;
        vm.checkDocumentAgain = checkDocumentAgain;
        vm.sendReport = sendReport;
        vm.addToDatabase = addToDatabase;
        vm.removeFromDatabase = removeFromDatabase;
        vm.withdrawFromDatabase = withdrawFromDatabase;
        vm.rejectFromDatabase = rejectFromDatabase;
        vm.restoreFromDatabase = restoreFromDatabase;
        vm.acceptJsaReport = acceptJsaReport;
        vm.getShortJsaReport = getShortJsaReport;
        vm.canEditDocument = canEditDocument;
        vm.resendJsaDocument = resendJsaDocument;
        vm.canRestoreDocument = canRestoreDocument;
        vm.canRejectDocument = canRejectDocument;
        vm.canAddDocumentToDatabase = canAddDocumentToDatabase;
        vm.canWithdrawDocumentFromDatabase = canWithdrawDocumentFromDatabase;
        vm.canShowDocumentHistory = canShowDocumentHistory;
        vm.canShowDownloadOriginalFile = canShowDownloadOriginalFile;
        vm.canShowRecheckAiDetection = canShowRecheckAiDetection;
        vm.canSendDocumentToOrppd = canSendDocumentToOrppd;
        vm.JSA_ORDER_STATUS = JSA_ORDER_STATUS;
        vm.DOCUMENT_STATUS = DOCUMENT_STATUS;
        vm.arrIdis = [];
        vm.jsa = AccountService.getClientSettings().jsaIntegration;
        vm.teacherCantDeleteFromDatabase = AccountService.getClientSettings().teacherCantDeleteFromDatabase && AccountService.role.isLecturer();
        vm.report2020Disabled = AccountService.getClientSettings().report2020Disabled;
        vm.allUsersCanDeleteDocuments = AccountService.getClientSettings().allUsersCanDeleteDocuments;
        vm.isSuperAdmin = AccountService.role.isSuperAdmin();
        vm.isMinistry = AccountService.role.isMinistry();
        vm.isJsaDocument = isJsaDocument;
        vm.getDocumentFile = getDocumentFile;
        vm.isReport2020 = isReport2020;
        vm.canDownloadPdfReport = canDownloadPdfReport;

        function resendJsaDocument(ev) {
            editJsaDocument(ev, true);
        }

        function restoreFromDatabase(id){
            vm.onIsLoaderActive = true;
            vm.arrIdis.push(id);
            DocumentService.operator.restoreFromDatabase({ids: vm.arrIdis}).then(function(){
                vm.onDocuments();
                vm.onSelectedRows();
            }).catch(function(){
        		vm.onIsLoaderActive = false;
            });
        }

        function rejectFromDatabase(id){
            vm.onIsLoaderActive = true;
            vm.arrIdis.push(id);
            DocumentService.operator.rejectFromDatabase({ids: vm.arrIdis}).then(function(){
                vm.onDocuments();
                vm.onSelectedRows();
            }).catch(function(){
        		vm.onIsLoaderActive = false;
            });
        }

        function withdrawFromDatabase(id){
            ModalService.showConfirmModal('document.withdraw').then(function(){
                vm.onIsLoaderActive = true;
                vm.arrIdis.push(id);
                DocumentService.operator.withdrawFromDatabase({ids: vm.arrIdis}).then(
                    function() {
                        ModalService.showSuccessModal();
                        vm.onDocuments();
                        vm.onSelectedRows();
                    },
                    function(response) {
                        ModalService.showErrorModal(response);
                        vm.onIsLoaderActive = false;
                    }
                ).catch(function(response){
                    ModalService.showErrorModal(response);
                    vm.onIsLoaderActive = false;
                });
            });
        }

        function addToDatabase(id){
            vm.onIsLoaderActive = true;
            vm.arrIdis.push(''+id+'');
            DocumentService.operator.addToDatabase({ids: vm.arrIdis}).then(function(){
                vm.onDocuments();
                vm.onSelectedRows();
            }).catch(function(){
        		vm.onIsLoaderActive = false;
            });
        }

        function removeFromDatabase(id){
            vm.onIsLoaderActive = true;
            vm.arrIdis.push(''+id+'');
            DocumentService.operator.removeFromDatabase({ids: vm.arrIdis}).then(function(){
                vm.onDocuments();
                vm.onSelectedRows();
            }).catch(function(){
                $log.error('errResponse', errResponse)
            });
        }

        function acceptJsaReport(documentId){
            JsaReportService.acceptReport(documentId).then(function(){
                vm.onDocuments();
            }).catch(function(response){
                PlagiatValidationService.getModalError(response.data);
            });
        }

        function getShortJsaReport() {
            vm.onIsLoaderActive = true;
            JsaReportService.getReport(vm.onDocumentId, false, vm.onDocuAuthor).then(function(){
                vm.onIsLoaderActive = false;
            }).catch(function(){
                vm.onIsLoaderActive = false;
            });
        }

        function getShortDocumentReport() {
            vm.onIsLoaderActive = true;
            ReportDocumentService.plainText(vm.onDocumentId, 'short', vm.onDocuAuthor).then(function(){
                vm.onIsLoaderActive = false;
            }).catch(function(){
            	vm.onIsLoaderActive = false;
            });
        }

        function getDocumentReport(reportType) {
            if (isReport2020()) {
                openDocumentReport2020();
            } else {
                getDocumentReport2018(reportType);
            }
        }

        function isReport2020() {
            return (vm.isSuperAdmin && !vm.onReport2020Disabled) || !vm.report2020Disabled;
        }

        function getDocumentReport2018(reportType) {
            vm.onIsLoaderActive = true;
            ReportDocumentService.getDocumentReport2018(vm.onDocumentId, reportType, vm.onDocuAuthor).then(function(){
                vm.onIsLoaderActive = false;
            });
        }

        function openDocumentReport2020() {
            vm.onIsLoaderActive = true;
            ReportDocumentService.getReport2020RedirectionUrl(vm.onDocumentId).then(function(redirectionUrl){
                window.open(redirectionUrl, "_blank");
                vm.onIsLoaderActive = false;
            });
        }

        function onClickReportSimilarity2017Pdf(type) {
        	vm.onIsLoaderActive = true;
        	ReportDocumentService.getReport2017Pdf(vm.onDocumentId, type, vm.onDocuAuthor).then(function(){
        		vm.onIsLoaderActive = false;
        	}).catch(function(){
        		vm.onIsLoaderActive = false;
            });
        }

        function removeDocument() {
            var confirm = $mdDialog.confirm()
            .title($translate.instant("document.confirmremove"))
            .textContent($translate.instant("document.areyousure"))
            .ariaLabel($translate.instant("document.areyousure"))
            .ok($translate.instant("global.button.remove"))
            .cancel($translate.instant("global.button.cancel"))
            .openFrom('#left');
            $mdDialog.show(confirm).then(function () {
                vm.onIsLoaderActive = true;
                vm.removeService = vm.onIsIndividual ? DocumentService.remove(vm.onDocumentId) : DocumentService.removeMassDocuments({ids: [vm.onDocumentId]});
                vm.removeService.then(function () {
                    TokenService.broadcastTokens();
                    vm.onDocuments();
                    vm.onSelectedRows();
                }, function (error) {
                	vm.onIsLoaderActive = false;
                    $mdToast.show($mdToast.simple().textContent($translate.instant("global.messages.error.label")));
                });
            });
        }

        function showText(ev) {
        	DocumentService.document.id = vm.onDocumentId;
        	$mdDialog.show({
        		templateUrl: 'app/account/documents/document-text/view-text.tmpl.html',
        		targetEvent: ev,
        		clickOutsideToClose: true,
                multiple: true
        	});
        }

        function canEditDocument() {
            var docIsEditable = (vm.onDocumentStatus >= -2 && vm.onJsaOrderStatus !== JSA_ORDER_STATUS.ACCEPTED);
            if (vm.onIsAdmin) {
                return docIsEditable;
            } else {
                return docIsEditable && !vm.onIsStudent && !vm.isMinistry && vm.clientHasPermToEditDocument;
            }
        }

        function canRestoreDocument() {
            if (!vm.onDocumentHasReport) {
                return false;
            }
            return ((vm.onDocumentStatus === DOCUMENT_STATUS.DISALLOWED_TO_ADD_TO_DATABASE.id || vm.onDocumentStatus === DOCUMENT_STATUS.EDITION_REQUIRED.id)
                && !vm.onIsIndividual && !vm.onIsStudent && !vm.isMinistry);
        }

        function canRejectDocument() {
            return (vm.onDocumentStatus === DOCUMENT_STATUS.PLAGIARISM_CHECKED.id && !vm.onIsIndividual && !vm.onIsStudent  && !vm.isMinistry && !vm.document.orppdActive);
        }

        function canAddDocumentToDatabase() {
            const basicConditions = vm.onDocumentStatus === DOCUMENT_STATUS.PLAGIARISM_CHECKED.id && !vm.onIsIndividual && !vm.onIsStudent && !vm.isMinistry && userDatabaseAddingEnabled();
            const basicConditionsForAdmin = (vm.onDocumentStatus === DOCUMENT_STATUS.REPORT_ACCEPTED.id) && vm.onIsAdmin && userDatabaseAddingEnabled();
            if (AccountService.getClientSettings().onlyAdminCanAddToDatabase) {
                return (basicConditions && vm.onIsAdmin) || (vm.onIsAdmin && (vm.onDocumentStatus === DOCUMENT_STATUS.REPORT_ACCEPTED.id) && userDatabaseAddingEnabled());
            }
            return basicConditions || basicConditionsForAdmin;
        }

        function canSendDocumentToOrppd() {
            return !vm.onIsIndividual && !vm.onIsStudent && vm.document.orppdActive;
        }

        vm.sendDocumentToOrppd = sendDocumentToOrppd;
        function sendDocumentToOrppd() {
            ModalService.showConfirmModal('document.table.menu.send-document-to-orppd').then(function(){
                vm.onIsLoaderActive = true;
                OrppdService.sendDocument(vm.onDocumentId).then(
                    function(){
                        ModalService.showSuccessModal();
                        vm.onDocuments();
                        vm.onSelectedRows();
                    },
                    function(response){
                        ModalService.showErrorModal(response);
                        vm.onIsLoaderActive = false;
                    }).catch(function(response){
                    ModalService.showErrorModal(response);
                    vm.onIsLoaderActive = false;
                });
            });
        }

        vm.getOrppdActionTranslationKey = getOrppdActionTranslationKey;
        function getOrppdActionTranslationKey() {
            return vm.document.orppdStatus === ORPPD_STATUS.SENT.id ? 'document.table.menu.resend-document-to-orppd' :
                'document.table.menu.send-document-to-orppd';
        }

        function canWithdrawDocumentFromDatabase() {
            return ((vm.onDocumentStatus === DOCUMENT_STATUS.MARKED_FOR_DATABASE.id || vm.onDocumentStatus === DOCUMENT_STATUS.ADDED_TO_DATABASE.id)
                && !vm.onIsIndividual
                && !vm.onIsStudent
                && !vm.isMinistry
                && !vm.teacherCantDeleteFromDatabase
                && userDatabaseAddingEnabled());
        }

        function userDatabaseAddingEnabled() {
            return vm.onIsSuperAdmin
                || AccountService.getClientSettings().addingToDatabase === 'automatically'
                || AccountService.getClientSettings().addingToDatabase === 'delayed'
                || AccountService.getClientSettings().addingToDatabase === 'manually';
        }

        function canShowDocumentHistory() {
            return vm.onDocumentStatus >= DOCUMENT_STATUS.WAITING_FOR_PAYMENT.id;
        }

        function canShowDownloadOriginalFile() {
            return vm.onDocumentStatus != DOCUMENT_STATUS.DRAFT.id;
        }

        function canShowRecheckAiDetection() {
            // return vm.document.aiDetection && vm.onIsSuperAdmin;
            return vm.onIsSuperAdmin;
        }

        function editDocument(ev) {
            if (vm.onIsSuperAdmin) {
                editDocumentBySuperAdmin(ev);
            } else if (vm.onIsIndividual) {
                editDocumentForIndividual(ev);
            } else if (isJsaDocument()) {
                editJsaDocument(ev);
            } else {
                editStandardDocument(ev);
            }
        }

        function editStandardDocument(ev) {
            DocumentService.document.id = vm.onDocumentId;
            $mdDialog.show({
                templateUrl: 'app/components/document/document-form/document-form.dialog.html',
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function () {
                vm.onDocuments();
                vm.onSelectedRows();
            });
        }

        function editJsaDocument(ev, refreshContract) {
            DocumentService.document.id = vm.onDocumentId;
            $mdDialog.show({
                templateUrl: 'app/components/document/jsa-edit-form/jsa-document-form.dialog.html',
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function () {
                vm.onDocuments();
                vm.onSelectedRows();
                if(refreshContract){
                    ContractService.broadcast();
                }
            });
        }

        function editDocumentForIndividual(ev) {
            DocumentService.document.id = vm.onDocumentId;
            $mdDialog.show({
                templateUrl: 'app/components/document/document-form-individual/document-form-individual.dialog.html',
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function (result) {
                vm.onDocuments();
                vm.onSelectedRows();
            });
        }

        function editDocumentBySuperAdmin(ev) {
        	DocumentService.checkIfDocumentCreatedByIndividual(vm.onDocumentId).then(function (data) {
                var documentByIndividual = data.data;
                if (documentByIndividual) {
                    editDocumentForIndividual(ev);
                } else if (isJsaDocument()) {
                    editJsaDocument(ev);
                } else {
                    editStandardDocument(ev);
                }
            });
        }

        function isJsaDocument() {
            return angular.isDefined(vm.onJsaOrderStatus) && vm.onJsaOrderStatus != null || vm.onDocumentStatus === DOCUMENT_STATUS.JSA_ERROR.id;
        }

        function showHistory(ev) {
            DocumentService.document.id = vm.onDocumentId;
            $mdDialog.show({
                templateUrl: 'app/components/document/document-history/document-history.dialog.html',
                targetEvent: ev,
                clickOutsideToClose: false
            });
        }

        function recheckAiDetection(docId, ev) {
            $mdDialog.show($mdDialog.confirm()
                .title($translate.instant("document.messages.recheck-ai-detection"))
                .textContent(vm.checkInfo)
                .ariaLabel(vm.checkInfo)
                .targetEvent(ev)
                .ok('Ok')
                .cancel($translate.instant("global.button.cancel"))
            ).then(function () {
                DocumentService.operator.recheckAiDetection(docId)
                    .then(function () {
                        $mdDialog.show(
                            $mdDialog.confirm()
                                .clickOutsideToClose(true)
                                .title('')
                                .textContent($translate.instant("global.messages.info.actionsuccess"))
                                .ariaLabel('')
                                .ok('Ok')
                                .targetEvent(ev)
                        );
                        vm.onDocuments();
                    }).catch(function (response) {
                    PlagiatValidationService.getModalError(response.data);
                });
            });
        }

        function useTokens() {
            vm.onUseTokens;
        }

        function checkDocumentAgain(docId, ev) {
            $mdDialog.show($mdDialog.confirm()
                .title($translate.instant("document.messages.checknow.again"))
                .textContent(vm.checkInfo)
                .ariaLabel(vm.checkInfo)
                .targetEvent(ev)
                .ok('Ok')
                .cancel($translate.instant("global.button.cancel"))
            ).then(function () {
                DocumentService.operator.checkDocumentAgain(docId)
                    .then(function () {
                        $mdDialog.show(
                            $mdDialog.confirm()
                                .clickOutsideToClose(true)
                                .title('')
                                .textContent($translate.instant("global.messages.info.actionsuccess"))
                                .ariaLabel('')
                                .ok('Ok')
                                .targetEvent(ev)
                        );
                        vm.onDocuments();
                    }).catch(function (response) {
                        PlagiatValidationService.getModalError(response.data);
                    });
            });
        }

        function sendReport(docId, ev) {
            DocumentService.operator.sendReport(docId)
            .then(function () {
                $mdDialog.show(
                    $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .title('')
                        .textContent($translate.instant("global.messages.info.actionsuccess"))
                        .ariaLabel('')
                        .ok('Ok')
                        .targetEvent(ev)
                );
                vm.onDocuments();
            }).catch(function (response) {
                PlagiatValidationService.getModalError(response.data);
            });
        }

        function getDocumentFile() {
            DocumentService.getDocumentFile(vm.onDocumentId).then(function (result) {
                var binary_string = window.atob(result.data.uploadFile);
                var len = binary_string.length;
                var bytes = new Uint8Array(len);
                for (var i = 0; i < len; i++) {
                    bytes[i] = binary_string.charCodeAt(i);
                }

                var blob = new Blob([ bytes.buffer]);
                saveAs(blob, result.data.docuTitle);
            }).catch(function (response) {
                PlagiatValidationService.getModalError(response.data);
            });
        }

        function canDownloadPdfReport() {
            return Principal.hasAnyAuthority(['PERM_DOWNLOAD_PDF_REPORT', 'PERM_USER_SUPERADMIN']) || isReport2020();
        }

    }

    angular.module('documentButtons', [])
    .component('documentButtons', {
        templateUrl: 'app/account/documents/documents-list/document-buttons/document-buttons.template.html',
        controller: DocumentButtonsController,
        controllerAs: 'vm',
        bindings: {
            onTokensNeeded: '<',
            onDocumentId: '<',
            onDocumentSize: '<',
            onUseTokens: '=',
            onCheckTokens: '=',
            onDocumentStatus: '=',
            onDocumentHasReport: '=',
            onReport2020Disabled: '=',
            onDocuments: '<',
            onIsLecturer: '<',
            onIsStudent: '<',
            onIsOperator: '<',
            onIsIndividual: '<',
            onIsAdmin: '<',
            onIsSuperAdmin: '<',
            onClientId: '<',
            onDocuAuthor: '<',
            onIsLoaderActive: '=',
            onSelectedRows: '<',
            onCanAcceptJsaReport: '<',
            onDocumentHasJsaReport: '<',
            onJsaOrderStatus: '<',
            document: '=',
            clientHasPermToEditDocument: '='
        }
    });

})();

(function () {
    'use strict';

    function ViewTextController($rootScope, $mdDialog, DocumentService) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.textToUpload = '';
        vm.uploadTextFlag = false;
        vm.documentId = DocumentService.document.id;

        function closeDialog() {
            $mdDialog.hide();
        }

        if( vm.documentId !== null ){
            getText(vm.documentId);
        }

        function getText(id) {
            DocumentService.getDocument(id).then(function (responseData) {
                vm.textToUpload = responseData.data.text;
                angular.element(function () {
                    vm.rendered = true;
                });
            });
        }

    }

    angular.module('plagiat2017App')
    .component('viewText', {
        templateUrl: 'app/account/documents/document-text/view-text/view-text.template.html',
        controller: ViewTextController,
        bindings: {
            onUploadIsActive: '=',
            onUploadObj: '='
        }
    });

})();

(function () {
    'use strict';

    function DocumentTextController($rootScope, $mdDialog, DocumentService, $translate) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.textToUpload = '';
        vm.uploadTextFlag = false;
        vm.sendUploadedText = sendUploadedText;
        vm.documentId = DocumentService.document.id;

        function closeDialog() {
            $mdDialog.hide();
        }

        if( vm.documentId !== null ){
            getText(vm.documentId);
        }

        function getText(id) {
            DocumentService.getDocument(id).then(function (responseData) {
                vm.hideButton = true;
                vm.textToUpload = responseData.data.text;
            });
        }


        function sendUploadedText() {
            DocumentService.uploadText({text: vm.textToUpload}).then(function (responseData) {
                $mdDialog.hide();
                DocumentService.isUploaded = true;
                DocumentService.uploadedData = responseData.data;
                $rootScope.$broadcast('uploadActive');
            }, function (error) {
                PlagiatValidationService.getModalError(error.data);
            });
        }

    }

    angular.module('plagiat2017App')
    .component('documentText', {
        templateUrl: 'app/account/documents/document-text/document-text.template.html',
        bindings: {
            onUploadIsActive: '=',
            onUploadObj: '='
        }
    });

})();

(function () {
    'use strict';

    function AddTextController($rootScope, $mdDialog, Principal, DocumentService, $translate, $log, PlagiatValidationService) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.textToUpload = '';
        vm.uploadTextFlag = false;
        vm.sendUploadedText = sendUploadedText;
        vm.documentId = DocumentService.document.id;

        Principal.hasAuthority('PERM_USER_PAYMENT').then(function(response){
            vm.authorities = {
                PERM_USER_PAYMENT: response
            }
        });

        function closeDialog() {
            $mdDialog.hide();
        }

        function sendUploadedText() {
            vm.upTextFn = vm.authorities.PERM_USER_PAYMENT ? DocumentService.uploadText({text: vm.textToUpload}) : DocumentService.operator.uploadText({text: vm.textToUpload});
            vm.upTextFn.then(function (responseData) {
                $mdDialog.hide();
                DocumentService.isUploaded = true;
                DocumentService.uploadedData = responseData.data;
                $rootScope.$broadcast('uploadActive');
            }, function (error) {
                PlagiatValidationService.getModalError(error.data);
            });
        }

    }

    angular.module('plagiat2017App')
    .component('addText', {
        templateUrl: 'app/account/documents/document-text/add-text/add-text.template.html',
        controller: AddTextController,
        bindings: {
            onUploadIsActive: '=',
            onUploadObj: '='
        }
    });

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .constant('DOCUMENT_STATUS', {
        // Document statuses as they are defined on back-end (pl.plagiat.datatypes.db.Document.java).
        PROCESSING_ERROR: {id: -7},
        WAITING: {id: -6},
        DRAFT: {id: -11},
        WAITING_FOR_PAYMENT: {id: -2},
        JSA_PENDING: {id: -10},
        JSA_ERROR: {id: -9},
        PROCESSING: {id: 0},
        PLAGIARISM_CHECKED: {id: 1},// sprawdzony
        MARKED_FOR_DATABASE: {id: 2},// zaznaczony do zaindeksowania
        ADDED_TO_DATABASE: {id: 3},// dodany do bazy
        CHECK_AGAIN: {id: 4},
        DISALLOWED_TO_ADD_TO_DATABASE: {id: 5}, // odrzucony
        EDITION_REQUIRED: {id: 6},
        REPORT_ACCEPTED: {id: 7},
        REMOVED: {id: 255}
    })
    .constant('DOCUMENT_PAP_STATUSES', [
       {'id': -6, 'status': 'waiting' },
       {'id': 1,  'status': 'paid' } ])
    .constant('DOCUSTATUSES', [
       {'id': -2, 'status': 'awaiting' },
       {'id': 0, 'status': 'processing' },
       {'id': 1, 'status': 'paid' } ])
    .constant('OPDOCUSTATUSES', [
       {'id': 0, 'status': 'processing' },
       {'id': 1, 'status': 'paid' },
       {'id': 2, 'status': 'picked' },
       {'id': 3, 'status': 'added' },
       {'id': 5, 'status': 'rejected' },
       {'id': 6, 'status': 'edition-required' },
       {'id': 7, 'status': 'report-accepted' },
    ])
    .constant('JSA_ORDER_STATUS', {
        NEW: 'New',
        IN_PROGRESS: 'In progress',
        COMPLETE: 'Complete',
        ERROR: 'Error',
        ACCEPTED: 'Accepted'
    }).constant('ORPPD_STATUS', {
        NOT_SENT: {id: 0, key: "document.model.orppd.status.not-sent"},
        SENT: {id: 1, key: "document.model.orppd.status.sent"},
        NOT_TO_SEND: {id: 2, key: "document.model.orppd.status.not-to-send"},
        ERROR: {id: 3, key: "document.model.orppd.status.error"}
    })
})();

angular.module('plagiat2017App')
.component('documentCheckCodeModal', {
    templateUrl: 'app/account/documents/document-code-check/document-check-code.template.html',
    controller: DocumentCheckCodeController,
    controllerAs: 'vm',
    bindings: {
        onDocumentId: "<",
        onFileId: "<",
        onSize: "<",
        onPriorityCode: "<",
        onIsAssignment: "<",
        onAddDocumentCallback: "=",
        onCheckDocumentCallback: "="
    }
});

    DocumentCheckCodeController.$inject = ['ModalService', 'AccountService', 'DocumentService', 'CurrencyService', 'CodeService', 'ContractService',
    'DOCUMENT_STATUS', 
    '$mdDialog', '$state', '$translate', '$q', '$rootScope'];


function DocumentCheckCodeController(ModalService, AccountService, DocumentService, CurrencyService, CodeService, ContractService,
                                     DOCUMENT_STATUS, 
                                     $mdDialog, $state, $translate, $q, $rootScope) {

    var vm = this;

    vm.useContract = useContract;
    vm.usePurchasedCode = usePurchasedCode;
    vm.buyNewCode = buyNewCode;
    vm.isUseCodeByTransactionIdAvailable = isUseCodeByTransactionIdAvailable;
    vm.useCodeByTransactionId = useCodeByTransactionId;
    vm.isCheckLaterAvailable = isCheckLaterAvailable;
    vm.isCheckWithCheckIdAvailable = isCheckWithCheckIdAvailable;
    vm.checkLater = checkLater;
    vm.checkWithCheckId = checkWithCheckId;
    vm.cancel = cancel;

    vm.isUseContractDisabled = true;
    vm.isUsePurchasedCodeDisabled = true;
    vm.isBuyCodeDisabled = false;
    vm.currencyForTerminalPayment = null;
    vm.availableCodesInfo = [];
    vm.areTerminalsAvailableInRegion = false;
    vm.isLoading = false;

    vm.alreadyPurchasedCode = '';
    vm.codeToBuy = '';

    this.$onInit = function () {
        vm.isLoading = true;
        vm.isStudent = AccountService.role.isStudent();
        ContractService.getInfo().then(function (contractResponse) {
            checkTheContract(contractResponse.data);
            CodeService.getAvailableCodeInfo().then(function (availableCodesResponse) {
                vm.availableCodesInfo = availableCodesResponse.data.availableCodes;
                checkIfThereIsValidCode(availableCodesResponse.data);
                vm.isLoading = false;
                vm.isBuyCodeDisabled = false;
                findSmallestFittingCode(availableCodesResponse.data);
            });
        });

        CodeService.getCurrencyForTerminalPayment().then(function (currencyForTerminalPaymentResponse) {
            vm.currencyForTerminalPayment = currencyForTerminalPaymentResponse.data;
        });
    };
    
    function checkTheContract(d) {
        // console.log('checkTheContract ' + JSON.stringify(d));
        if (vm.onIsAssignment && AccountService.role.isStudent()) {
            // gdy jest Assignment, to dla studentów zawsze ukryta opcja "Z kontraktu"
            return;
        }
        
        if (d.isContractActive) {
            if (d.contractType === 2 || d.contractType === 3) {
                // dla kontraktow na userow i na autorow zawsze pokazujemy przycisk 'z kontraktu'
                vm.isUseContractDisabled = false;
            } else {
                if (AccountService.role.isStudent()) {
                    if (d.userQueryCounterType === 0 && d.userQueryCounter > 0) {
                        vm.isUseContractDisabled = false;
                    }
                    if (d.userQueryCounterType === 1 && d.userQueryCounter >= vm.onSize) {
                        vm.isUseContractDisabled = false;
                    }
                } else {
                    if (d.contractType === 0 && d.contNumOfPlagReportsLeft > 0) {
                        vm.isUseContractDisabled = false;
                    }
                    if (d.contractType === 1 && d.contNumOfPlagReportsLeft >= vm.onSize) {
                        vm.isUseContractDisabled = false;
                    }
                }
            }
        }
    }

    function checkIfThereIsValidCode(d) {
        angular.forEach(d.availableCodes, function (aCode) {

            if (aCode.size >= vm.onSize) {
                if (!vm.alreadyPurchasedCode) {
                    vm.alreadyPurchasedCode = '(' + aCode.name + ')';
                }
                vm.isUsePurchasedCodeDisabled = false;
            }
        })
    }

    function findSmallestFittingCode(d) {
        var smallest;
        angular.forEach(d.configuredCodes, function (aCode) {
            if (aCode.size >= vm.onSize) {
                if (!smallest || aCode.size < smallest.size) {
                    smallest = aCode;
                }
            }
        });
        if (smallest) {
            vm.codeToBuy = '(' + smallest.name + ')';
        }
    }

    function useContract(){
        if(vm.onAddDocumentCallback){
            vm.onAddDocumentCallback();
        } else {
            vm.onCheckDocumentCallback(vm.onDocumentId);
        }
    }

    function goToCodePayments(documentId){
        $state.go('code-payments', {documentId: documentId, priorityCode: vm.onPriorityCode});
    }

    function buyNewCode() {

        cancel();
        
        var  documentIdPromise = null;
        if (vm.onDocumentId) {
            documentIdPromise = $q.when(vm.onDocumentId);

            documentIdPromise.then(
                function (documentId) {
                    $state.go('code-payments', {documentId: documentId});
                }
            );
        } else {
            vm.onAddDocumentCallback({checkLater: true}, goToCodePayments);
        }

    }

    function usePurchasedCode() {
        var documentIdPromise = null;
        if (vm.onDocumentId) {
            documentIdPromise = $q.when(vm.onDocumentId);
        } else {
            documentIdPromise = vm.onAddDocumentCallback({checkLater: true});
        }
        documentIdPromise.then(
            function (documentId) {
                CodeService.findCodeForDocumentChecking(documentId, vm.onPriorityCode).then(
                    function (codeForDocumentCheckingResponse) {
                        var codeForDocumentChecking = codeForDocumentCheckingResponse.data;
                        if (codeForDocumentChecking && codeForDocumentChecking.codeName === codeForDocumentChecking.minimalRequiredCodeName) {
                            vm.onCheckDocumentCallback({documentId: documentId, codeId: codeForDocumentChecking.codeId});
                        } else if (codeForDocumentChecking && codeForDocumentChecking.codeName !== codeForDocumentChecking.minimalRequiredCodeName) {
                            $mdDialog.show(
                                $mdDialog.confirm()
                                    .textContent(
                                        $translate.instant('document.code.smaller-codes-exist.buy-proposal',
                                            {
                                                foundCodeName: codeForDocumentChecking.codeName,
                                                cheaperCodeName: codeForDocumentChecking.minimalRequiredCodeName
                                            }))
                                    .ok($translate.instant('document.code.smaller-codes-exist.buy-proposal.agree'))
                                    .cancel($translate.instant("document.code.smaller-codes-exist.buy-proposal.refuse")))
                                .then(
                                    function () {
                                        $state.go('code-payments', {documentId: documentId});
                                    },
                                    function () {
                                        vm.onCheckDocumentCallback({documentId: documentId,
                                            codeId: codeForDocumentChecking.codeId});
                                    }
                                )
                        } else {
                            ModalService.showConfirmModal("document.code.no-fitting-code.buy-proposal",
                                {customCancelButton: true}).then(
                                function () {
                                    $state.go('code-payments', {documentId: documentId, priorityCode: vm.onPriorityCode});
                                }
                            )
                        }
                    }
                )
            }
        );
    }

    function cancel() {
        return $mdDialog.hide();
    }

    function useCodeByTransactionId() {
        var documentIdPromise = null;
        var documentIdToCheck = null;
        if (vm.onDocumentId) {
            documentIdPromise = $q.when(vm.onDocumentId);
        } else {
            documentIdPromise = vm.onAddDocumentCallback({checkLater: true});
        }
        documentIdPromise.then(function (documentId) {
            documentIdToCheck = documentId;
            return findCodeByTransactionId(documentId);
        }).then(function (codeId) {
                vm.onCheckDocumentCallback({documentId: documentIdToCheck, codeId: codeId})
            }
        );
    }

    function isUseCodeByTransactionIdAvailable() {
        return vm.currencyForTerminalPayment && AccountService.role.isOperator();
    }

    function findCodeByTransactionId(documentId) {
        return $mdDialog.show({
            templateUrl: 'app/account/documents/document-code-check/find-code-by-transaction-id.dialog.html',
            controllerAs: 'vm',
            controller: function ($mdDialog, CodeService, CODE_STATUS) {
                var vm = this;
                vm.transactionId = null;
                vm.shouldShowCodeNotFoundMessage = false;
                vm.shouldShowCodeNotValidMessage = false;
                vm.shouldShowCodeNotAdequateForDocumentMessage = false;
                vm.code = null;
                vm.codeStatuses = CODE_STATUS;
                vm.keyReturn = KeyCode.KEY_RETURN;

                this.findCodeByTransactionId = function () {
                    CodeService.findCodeByTransactionId(vm.transactionId, documentId).then(function (result) {
                        vm.shouldShowCodeNotValidMessage = false;
                        vm.shouldShowCodeNotAdequateForDocumentMessage = false;
                        var code = result.data;
                        if (!code) {
                            vm.code = null;
                            vm.shouldShowCodeNotFoundMessage = true;
                            return;
                        }
                        vm.shouldShowCodeNotFoundMessage = false;
                        code.paymentDate = new Date(code.paymentDate);
                        vm.code = code;
                    });
                };

                this.useCode = function () {
                    if (vm.code === null) {
                        vm.shouldShowCodeNotFoundMessage = true;
                        return;
                    }
                    if (vm.code.status !== vm.codeStatuses.CODE_STATUS_AVAILABLE.id) {
                        vm.shouldShowCodeNotValidMessage = true;
                        return;
                    }
                    if (!vm.code.adequateForDocument) {
                        vm.shouldShowCodeNotAdequateForDocumentMessage = true;
                        return;
                    }
                    $mdDialog.hide(vm.code.id);
                };
                this.cancel = function () {
                    $mdDialog.cancel();
                }
            }
        });
    }

    function isCheckLaterAvailable() {
        return !vm.onDocumentId;
    }

    function isCheckWithCheckIdAvailable() {
        return vm.currencyForTerminalPayment && !vm.onDocumentId && AccountService.role.isOperator();
    }

    function checkWithCheckId() {
        vm.onAddDocumentCallback({generateCheckId: true}).then(function (documentId) {
            return DocumentService.getCheckId(documentId, vm.currencyForTerminalPayment);
        }).then(function (checkIdData) {
            $mdDialog.show({
                templateUrl: 'app/account/documents/document-code-check/document-check-code-check-id.dialog.html',
                controllerAs: 'vm',
                escapeToClose: false,
                locals: {
                    data: checkIdData.data
                },
                controller: function ($mdDialog, data) {
                    this.data = data;
                    this.closeDialog = function () {
                        $rootScope.$broadcast('on-get-documents');
                        $mdDialog.hide();
                    }
                }
            });
        }).catch(function (error) {
            ModalService.showErrorModal(error);
        });
    }

    function checkLater() {
        vm.onAddDocumentCallback({checkLater: true});
    }

}

(function () {
    'use strict';

    function checkLaterController($scope, $rootScope, $state, $translate, $mdDialog, DocumentRequest, DocumentService, TokenService, $log) {
        var vm = this;
        vm.getDocuments = getDocuments;
        vm.resetUploadForm = resetUploadForm;
        vm.checkLater = checkLater;
        vm.documentRequest = new DocumentRequest();
        vm.check = check;
        vm.missingTokens;
        vm.tokens;
        vm.uploadText = uploadText;

        getTokensInfo();

        function uploadText() {
            vm.onUploadText();
        }

        function broadcastTokensInfo() {
            $rootScope.$broadcast("availableTokens");
        }

        function getTokensInfo() {
            TokenService.getInfo().then(function (responseData) {
                vm.availableTokens = responseData.availableTokens;
            });
        }

        function getDocuments() {
            vm.onReloadDocuments();
        }

        function resetUploadForm() {
            vm.onUploadIsActive = false;
            vm.onUploadTextFlag = false;
            vm.documentRequest = new DocumentRequest();
            vm.onGetTheFiles(null, {});
        }

        function checkLater(obj, ev) {
            vm.onUploadTextFlag = false;
            vm.documentRequest.fileId = obj.fileId;
            vm.documentRequest.title = obj.docuTitle;
            vm.documentRequest.author = obj.authorFirstName + ' ' + obj.authorLastName;

            $mdDialog.show(
                $mdDialog.confirm()
                .title($translate.instant("document.messages.checklater"))
                .textContent($translate.instant("document.messages.clickinfo"))
                .ariaLabel($translate.instant("document.messages.clickinfo"))
                .targetEvent(ev)
                .ok('Ok')
                .cancel($translate.instant("global.button.cancel"))

                ).then(function () {
                    DocumentService.save(vm.documentRequest).then(function (responseData) {
                        vm.onUploadIsActive = false;
                        getDocuments();
                        getTokensInfo();
                        broadcastTokensInfo();
                        $mdDialog.show(
                            $mdDialog.confirm()
                            .clickOutsideToClose(true)
                            .title($translate.instant("document.messages.checkconfirm"))
                            .textContent($translate.instant("document.messages.checkconfirm"))
                            .ariaLabel($translate.instant("document.messages.checkconfirm"))
                            .ok('Ok')
                            .targetEvent(ev)
                            );
                    });
                }, function () {

                });
        }

        function check(obj, ev) {
            vm.onUploadTextFlag = false;
            vm.documentRequest.fileId = obj.fileId;
            vm.documentRequest.title = obj.docuTitle;
            vm.documentRequest.author = obj.authorFirstName + ' ' + obj.authorLastName;

            vm.checkInfo = (vm.onUploadObj.tokensNeeded > 0) ? $translate.instant("document.messages.checknowinfo") : $translate.instant("document.messages.checknowinfonotokens");

            $mdDialog.show($mdDialog.confirm()
                    .title($translate.instant("document.messages.checknow"))
                    .textContent(vm.checkInfo)
                    .ariaLabel(vm.checkInfo)
                    .targetEvent(ev)
                    .ok('Ok')
                    .cancel($translate.instant("global.button.cancel"))
                    ).then(function () {
                        vm.isLoading = true;
                        DocumentService.check(vm.documentRequest).then(function (responseData) {
                            vm.isLoading = false;
                            vm.onUploadIsActive = false;
                            if (responseData.used === false) {
                                var confirm = $mdDialog.confirm()
                                .title('')
                                .textContent($translate.instant("global.messages.error.notenough"))
                                .ariaLabel('')
                                .ok($translate.instant("document.buytokens"))
                                .cancel('Ok')
                                .openFrom('#left');
                                $mdDialog.show(confirm).then(function (result) {
                                    $state.go('payments');
                                });
                            } else {
                                $mdDialog.show(
                                  $mdDialog.confirm()
                                  .clickOutsideToClose(true)
                                  .title('')
                                  .textContent($translate.instant("global.messages.info.actionsuccess"))
                                  .ariaLabel('')
                                  .ok('Ok')
                                  .targetEvent(ev)
                                  );
                                getDocuments();
                                broadcastTokensInfo();
                            }
                        }).catch(function (response) {
                            vm.isLoading = false;
                            if (response.status === 400) {
                                $mdDialog.show(
                                  $mdDialog.confirm()
                                  .clickOutsideToClose(true)
                                  .title($translate.instant("global.messages.error.unknown"))
                                  .textContent($translate.instant("global.messages.error.unknown"))
                                  .ariaLabel($translate.instant("global.messages.error.unknown"))
                                  .ok('OK')
                                  );
                            }
                        });
                    });
        }

    }

    angular.module('plagiat2017App')
            .component('checkLater', {
                templateUrl: 'app/account/documents/document-metric/document-metric.template.html',
                controller: checkLaterController,
                bindings: {
                    onUploadIsActive: '=',
                    onUploadTextFlag: '=',
                    onUploadObj: '<',
                    onReloadDocuments: '<',
                    onDocuments: '<',
                    onGetTheFiles: '<',
                    onUploadText: '<',
                    isLoading: '='
                }
            });

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('JsaDocumentFormService', JsaDocumentFormService);

    JsaDocumentFormService.$inject = ['$http', 'PolonUnitService', '$mdDialog', 'ModalService', 'AccountService',
        'OrganisationalUnitsService', '$translate', 'DOCUMENT_KINDS', 'PolonStudyService'];

    function JsaDocumentFormService($http, PolonUnitService, $mdDialog, ModalService, AccountService,
                                    OrganisationalUnitsService, $translate, DOCUMENT_KINDS, PolonStudyService) {

        var service = {
            inferOrganisationalUnitId: inferOrganisationalUnitId,
            handleSelectedAuthorChange: handleSelectedAuthorChange,
            refreshAvailableUnits: refreshAvailableUnits,
            formatAuthor: formatAuthor
        };
        return service;

        function inferOrganisationalUnitId(documentFormScope) {
            if (isPhdThesis(documentFormScope)) {
                return getOrganisationalUnitIdForUser(documentFormScope.userId);
            }
            var polonStudyId = documentFormScope.onUploadObj.authors[0].selectedStudy.id;
            return PolonStudyService.getOrganisationalUnitId(polonStudyId).then(function (polonStudyOrganisationalUnit) {
                if (polonStudyOrganisationalUnit) {
                    return polonStudyOrganisationalUnit;
                }
                return getOrganisationalUnitIdForUser(documentFormScope.userId);
            })
        }

        function getOrganisationalUnitIdForUser(userId) {
            var currentUserOrgUnitId = AccountService.account.organisationalUnitId;
            if (AccountService.role.isSuperAdmin()) {
                return OrganisationalUnitsService.findByUserId(userId).then(function (organisationalUnit) {
                    currentUserOrgUnitId = organisationalUnit.id;
                    return useCurrentUserOrgUnitIdAndNotifyUser(currentUserOrgUnitId);
                });
            } else {
                return useCurrentUserOrgUnitIdAndNotifyUser(currentUserOrgUnitId);
            }
        }

        function useCurrentUserOrgUnitIdAndNotifyUser(currentUserOrgUnitId) {
            return OrganisationalUnitsService.getSimpleById(currentUserOrgUnitId).then(function (organisationalUnit) {
                return ModalService.showConfirmModal(null,
                    {customTitle: $translate.instant('global.messages.jsa.no-matching-organisational-unit', {unitName: organisationalUnit.orguniLabel})}
                    ).then(function () {
                        return currentUserOrgUnitId;
                    })
                }
            );
        }

        function handleSelectedAuthorChange(selectedAuthor, index, documentFormScope) {
            if (!documentFormScope.onUploadObj.authors) {
                documentFormScope.onUploadObj.authors = [];
            }
            if (selectedAuthor && selectedAuthor.id) {
                documentFormScope.onUploadObj.authors[index] = selectedAuthor;
                if (isPhdStudent(selectedAuthor)) {
                    documentFormScope.isPhdThesis = true;
                    documentFormScope.onUploadObj.documentKindId = DOCUMENT_KINDS.PHD.id;
                } else {
                    documentFormScope.isPhdThesis = false;
                    documentFormScope.onUploadObj.authors[index].selectedStudy = selectedAuthor.studies[0];
                }
            } else {
                documentFormScope.onUploadObj.authors[index] = null;
                documentFormScope.onUploadObj.documentKindId = null;
                if (index === 0) {
                    documentFormScope.isPhdThesis = false;
                }
            }
            if (index === 0) {
                refreshAvailableUnits(documentFormScope);
            }
        }

        function refreshAvailableUnits(documentFormScope) {
            documentFormScope.availableUnits = [];
            if (!documentFormScope.onUploadObj
                || !documentFormScope.onUploadObj.authors
                || !documentFormScope.onUploadObj.authors[0]) {
                return;
            }
            var mainAuthor = documentFormScope.onUploadObj.authors[0];
            if (isPhdStudent(mainAuthor)) {
                if (AccountService.role.isSuperAdmin()) {
                    PolonUnitService.getAllForClient(documentFormScope.clientId).then(function (result) {
                            documentFormScope.availableUnits = result;
                    })
                } else {
                    PolonUnitService.getAllForCurrentClient().then(function (result) {
                            documentFormScope.availableUnits = result;
                        }
                    );
                }
                return;
            } else {
                documentFormScope.onUploadObj.polonUnitId = null;
            }
            if (!mainAuthor.selectedStudy) {
                return;
            }
            PolonUnitService.getAllByStudyId(mainAuthor.selectedStudy.id).then(function (result) {
                documentFormScope.availableUnits = result;
                    if (angular.isArray(documentFormScope.availableUnits) && documentFormScope.availableUnits.length > 0) {
                        documentFormScope.onUploadObj.polonUnitId = documentFormScope.availableUnits[0].id;
                    } else {
                        ModalService.showDialogModal("jsa.document.no-polon-unit-for-study-do-synchronization");
                    }
                }
            )
        }

        function formatAuthor(author) {
            var result = author.firstName;
            if (author.middleNames) {
                result += ' ' + author.middleNames;
            }
            result += ' ' + author.lastName;
            if (isPhdStudent(author)) {
                result += ' ' + $translate.instant('document.author.phd-student');
            } else {
                result += ', UID: ' + author.uid
            }
            if (author.lastDigitsIdentificator) {
                result += ', ' + $translate.instant('document.author.last.digits')+': ' + author.lastDigitsIdentificator;
            }
            return result;
        }

        function isPhdStudent(author) {
            return !author.uid;
        }

        function isPhdThesis(documentFormScope) {
            var mainAuthor = documentFormScope.onUploadObj.authors[0];
            return isPhdStudent(mainAuthor);
        }

    }
})();

(function () {
    'use strict';

    function JsaDocumentFormUniversalController(
        $scope, $q, _, $rootScope, $state, $translate, $mdDialog, DocumentClientModel, DocumentService, JsaService,
        ContractService, $log, $timeout, AccountService, PlagiatValidationService, DuplicatesDialogService, DictionaryService,
        TRANSLATION_KEYS, DOCUMENT_KINDS, OrganisationalUnitsService, JsaDocumentFormService
    ) {
        var vm = this;
        vm.getDocuments = getDocuments;
        vm.resetUploadForm = resetUploadForm;
        vm.uploadText = uploadText;
        vm.getDocumentSkipAddress = getDocumentSkipAddress;
        vm.showDocumentVerification = showDocumentVerification;
        vm.addDocumentJsa = addDocumentJsa;
        vm.getLanguageItemText = getLanguageItemText;
        vm.getLanguageItemTextByCode = getLanguageItemTextByCode;
        vm.aiDetectionPoolExhausted = aiDetectionPoolExhausted;
        vm.aiDetectionDisabled = aiDetectionDisabled;

        vm.selectedItem = [];
        vm.searchText = [];
        vm.authorsSimplifiedFields = AccountService.account.clientSettings.authorsSimplifiedFields;
        vm.jsa = AccountService.getClientSettings().jsaIntegration;
        vm.account = AccountService.account;
        vm.userId = vm.account.id;
        vm.availableUnits = [];

        vm.typeOfDocuments = DOCUMENT_KINDS.jsaDocumentKinds;

        vm.addAuthor = addAuthor;
        vm.removeAuthor = removeAuthor;
        vm.searchAuthors = function(searchText) {return JsaService.getAuthorsAutocompleteItems(searchText, vm.onUploadObj.authors)};
        vm.selectedAuthorChanged = selectedAuthorChanged;
        vm.selectedStudyChanged = selectedStudyChanged;
        vm.shouldRequireIndexNumber = shouldRequireIndexNumber;
        vm.formatAuthor = JsaDocumentFormService.formatAuthor;

        vm.searchValuePromoter;
        vm.searchPromoters = JsaService.getPromotersAutocompleteItems;
        vm.selectPromoter = selectPromoter;

        vm.querySearchForLanguage;
        vm.searchLanguages = DictionaryService.getLanguagesJsaAutocompleteItems;
        vm.selectLanguage = selectLanguage;

        if (AccountService.role.isLecturer()) {
            JsaService.getPromoterByUserId(vm.account.id).then(function (response) {
                if (response.data) {
                    vm.selectedPromoter = response.data;
                    vm.promoterNotEditable = true;
                }
            });
        }

        function showDocumentVerification() {
            return AccountService.account.authorities.includes("PERM_USER_DOCUMENT_VERIFICATION");
        }

        function getLanguageItemText(item) {
            return $translate.instant(TRANSLATION_KEYS.dictionaryLanguage + item.code);
        }

        function shouldRequireIndexNumber() {
            return vm.onUploadObj.documentKindId !== DOCUMENT_KINDS.PHD.id;
        }

        function selectedAuthorChanged(item, index) {
            JsaDocumentFormService.handleSelectedAuthorChange(item, index, vm);
        }

        function selectedStudyChanged() {
            JsaDocumentFormService.refreshAvailableUnits(vm);
        }

        function getLanguageItemTextByCode(code) {
            return $translate.instant(code);
        }

        function selectPromoter(promoter) {
            if (promoter && promoter.name) {
                vm.onUploadObj.promoter = promoter;
            } else {
                vm.onUploadObj.promoter = null;
            }
        }

        function selectLanguage(language) {
            if (language && language.code) {
                vm.onUploadObj.language = language;
            } else {
                vm.onUploadObj.language = null;
            }
        }

        function setCoordinatorId() {
            vm.onUploadObj.coordinatorId = vm.onUploadObj.promoter;
        }

        function addAuthor() {
            if (!vm.onUploadObj.authors) {
                vm.onUploadObj.authors = [];
            }
            vm.onUploadObj.authors.push({});
        }

        function removeAuthor(event, item) {
            vm.onUploadObj.authors.splice(item, 1);
        }

        function aiDetectionDisabled() {
            return (vm.onUploadObj && vm.onUploadObj.aiDetectionInfo && vm.onUploadObj.aiDetectionInfo.defaultValue === 'alwaysEnabled')
                || vm.aiDetectionPoolExhausted() || vm.onUploadObj.size <= 300;
        }

        function aiDetectionPoolExhausted() {

            if (AccountService.account.contractAiDetectionEnabled) {
                if (vm.onUploadObj && vm.onUploadObj.aiDetectionPoolInfo && vm.onUploadObj.aiDetectionPoolInfo.aiDetectionPoolEnabled) {
                    if (vm.onUploadObj.size > vm.onUploadObj.aiDetectionPoolInfo.contNumOfAiDetectionLeft) {
                        vm.onUploadObj.aiDetection = false;
                        return true;
                    }
                }
            }
            return false;
        }


        function uploadText() {
            vm.onUploadText();
        }

        function getDocuments() {
            vm.onReloadDocuments();
        }

        function resetUploadForm() {
            vm.onUploadObj = {
                documentSkipAddresses: []
            };
            vm.onUploadIsActive = false;
            vm.onUploadTextFlag = false;
            vm.isLoading = false;
            vm.onGetTheFiles(null, {});
            vm.selectedItem = [];
            vm.searchText = [];
        }

        function addDocument(obj) {
            if (vm.selectedPromoter) {
                vm.selectPromoter(vm.selectedPromoter);
            }
            //check if coordinator's fields are simplified
            if (vm.onIsLecturer) {
                vm.onIsLecturer ? setCoordinatorId() : '';
            } else if (angular.isDefined(obj.coordinatorDTO)) {
                obj.coordinatorDTO.lastName = vm.authorsSimplifiedFields ? '' : obj.coordinatorDTO.lastName;
            }
            vm.onUploadTextFlag = false;
            vm.isLoading = true;

            $mdDialog.show($mdDialog.confirm()
                .title($translate.instant("document.messages.checknow"))
                .textContent(vm.checkInfo)
                .ariaLabel(vm.checkInfo)
                .ok($translate.instant("global.msg.ok"))
                .cancel($translate.instant("global.button.cancel"))
            ).then(function () {
                resetUploadForm();
                var alert = $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#popupContainer')))
                    .clickOutsideToClose(false)
                    .escapeToClose(false)
                    .title($translate.instant("global.messages.jsa.uploading"))
                    .textContent($translate.instant("global.messages.jsa.uploading.content"));

                $mdDialog.show(alert);

                DuplicatesDialogService.saveJSADocumentWithPopUp(obj, alert);
            });
        }

        function addDocumentJsa(obj, form) {
            for (var i = 0; i < form.$$controls.length; i++) {
                form.$$controls[i].$touched = true;
            }
            if (form.$invalid) {
                return;
            }
            JsaDocumentFormService.inferOrganisationalUnitId(vm).then(function (organisationalUnitId) {
                obj.organisationalUnitId = organisationalUnitId;
            }).then(function () {
                addDocument(obj);
            });
        }

        function getDocumentSkipAddress(chip) {
            return {
                address: chip
            };
        }
    }

    angular.module('plagiat2017App')
        .component('jsaDocumentForm', {
            templateUrl: 'app/account/documents/document/document-form/jsa-document-form/jsa-document-form.template.html',
            controller: JsaDocumentFormUniversalController,
            controllerAs: 'vm',
            bindings: {
                onUploadIsActive: '=',
                onUploadTextFlag: '=',
                onUploadObj: '<',
                onReloadDocuments: '<',
                onGetTheFiles: '<',
                onUploadText: '<',
                isLoading: '=',
                onGetConfiguration: '<',
                onGetConfigurationOffChecking: '<',
                onIsLecturer: '<',
                onIsOperator: '<',
                isJsaDisabled: '<'
            }
        });

})();

(function () {
    'use strict';

    function DocumentFormUniversalController(
        $scope, $q, _, $rootScope, $state, $translate, $mdDialog, $log, $timeout,
        DocumentClientModel, Utils,
        DocumentService, ContractService, AccountService, PlagiatValidationService, CodeService, ModalService, DocumentFormService, DuplicatesDialogService,
        PERMISSIONS, AUTO_TRANSLATIONS_LANGS, RESTRICTING_DATABASES, USERSCHOOLTYPE, CONTRACTTYPECONSTANT
    ) {
        var vm = this;

        vm.addAuthor = addAuthor;
        vm.removeAuthor = removeAuthor;
        vm.getDocuments = getDocuments;
        vm.resetUploadForm = resetUploadForm;
        vm.uploadText = uploadText;
        vm.isCoordinatorVisible = isCoordinatorVisible;
        vm.canUserChangeCoordinator = canUserChangeCoordinator;
        vm.coordinatorAutocompleteAvailable = coordinatorAutocompleteAvailable;
        vm.aiDetectionPoolExhausted = aiDetectionPoolExhausted;
        vm.aiDetectionDisabled = aiDetectionDisabled;
        vm.grammarCheckDisabled = grammarCheckDisabled;
        vm.addWithoutChecking = addWithoutChecking;
        vm.addDocumentUniversal = addDocumentUniversal;
        vm.checkDocumentCodeAccountProcess = checkDocumentCodeAccountProcess;
        vm.checkDocumentCodeAccount = checkDocumentCodeAccount;
        vm.authorsQuerySearch = authorsQuerySearch;
        vm.authorsSelectedItemChange = authorsSelectedItemChange;
        vm.querySearch = querySearch;
        vm.getConfiguration = getConfiguration;
        vm.getConfigurationOffChecking = getConfigurationOffChecking;
        vm.setOnUploadObj = setOnUploadObj;
        vm.verifyAiDetectionVsAutoTranslation = verifyAiDetectionVsAutoTranslation;
        vm.selectedItemChange = selectedItemChange;
        vm.getDocumentSkipAddress = getDocumentSkipAddress;
        vm.showDocumentVerification = showDocumentVerification;
        vm.showSkipUrl = showSkipUrl;

        vm.missingTokens;
        vm.autoTranslationLangs = Utils.sortAutoTranslationsLanguages(AUTO_TRANSLATIONS_LANGS, $translate);
        vm.restrictingDatabasesOptions = RESTRICTING_DATABASES;

        vm.account = AccountService.account;
        vm.authorsArr = [];
        vm.authorIndex = 0;
        vm.authorSelectedItem  = null;
        vm.selectedItem  = null;
        vm.searchText    = null;
        vm.students = [];
        vm.contract = {};
        vm.priorityCode = undefined;

        vm.coordinatorNotApplicable = AccountService.account.clientSettings.coordinatorNotRequiredByDefault;
        vm.orgUnitId = !angular.isUndefined(AccountService.account.organisationalUnitId) ? AccountService.account.organisationalUnitId : 0;
        vm.authorsSimplifiedFields = AccountService.account.clientSettings.authorsSimplifiedFields;
        vm.autoTranslationsLangSelection = AccountService.account.clientSettings.autoTranslationsLangSelection;
        vm.jsa = AccountService.getClientSettings().jsaIntegration ;
        vm.canChangeOrganisationUnit = AccountService.getPermision(PERMISSIONS.PERM_USER_CAN_CHANGE_ORG_UNIT_DURING_ADD_DOCUMENT) || AccountService.role.isAdmin();
        vm.clientTypePublishingHouse = AccountService.clientType.isPublishingHouse();
        vm.clientTypeSchool = AccountService.clientType.isSchool();
        vm.shouldShowCodeAccountCheckModal = AccountService.clientType.isCodeAccount() && !AccountService.role.isAdmin();
        vm.hideAddWithoutChecking = AccountService.account.clientSettings.hideAddWithoutChecking;
        vm.authorFromUsersList = AccountService.account.clientSettings.authorFromUsersList && !AccountService.role.isStudent();
        vm.isStudent = AccountService.role.isStudent();

        this.$onInit = function () {
            populateOrganisationUnit();
            ContractService.getInfo().then(function (contract){
                vm.contract = contract.data;
                if ((CONTRACTTYPECONSTANT.CONT_TYPE_PER_USER.id === contract.data.contractType) && AccountService.account.accountType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_STUDENT.value) {
                    DocumentService.operator.checkDocumentAiLimitReached(vm.account.firstName.trim() + ' ' + vm.account.lastName.trim()).then(function (limit) {
                        vm.isAiLimitReached = limit;
                    })
                }
                if ((CONTRACTTYPECONSTANT.CONT_TYPE_PER_CHARACTER.id === vm.contract.userQueryCounterType)
                    && AccountService.account.accountType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_STUDENT.value
                    && vm.onUploadObj.size > vm.account.userQueryCounter) {
                    vm.isCharacterLimit = true;
                }
            });
        };

        function showDocumentVerification(){
            return AccountService.account.authorities.includes("PERM_USER_DOCUMENT_VERIFICATION");
        }

        function setOnUploadObj(){
            vm.onUploadObj.addWithoutChecking ? getConfigurationOffChecking() : getConfiguration();
        }

        function verifyAiDetectionVsAutoTranslation(val) {
            if ('aiDetection' === val) {
                vm.onUploadObj.autoTranslations = 0;
                vm.onUploadObj.addWithoutChecking = 0;
            }
            if ('grammarCheck' === val) {
                vm.onUploadObj.autoTranslations = 0;
                vm.onUploadObj.addWithoutChecking = 0;
            }
            if ('autoTranslation' === val) {
                vm.onUploadObj.aiDetection = 0;
                vm.onUploadObj.grammarCheck = 0;
                vm.onUploadObj.addWithoutChecking = 0;
            }
            if ('addWithoutChecking' === val) {
                vm.onUploadObj.autoTranslations = 0;
                vm.onUploadObj.aiDetection = 0;
                vm.onUploadObj.grammarCheck = 0;
                vm.setOnUploadObj();
            }
        }

        function getConfiguration(){
            vm.onGetConfiguration(vm.onUploadObj);
        }

        function getConfigurationOffChecking(){
            vm.onGetConfigurationOffChecking(vm.onUploadObj);
        }

        function selectedItemChange(item) {
            vm.onUploadObj.coordinatorId = angular.isUndefined(item) ? null : item.value.coordinatorId;
            vm.onUploadObj.coordinatorDTO = {};
        }

        function lowercase(string) {
            return angular.isString(string) ? string.toLowerCase() : string;
        }

        function querySearch(query) {
            vm.promoters = vm.onUploadObj.coordinatorInfo.selectItems;
            var results = query ? _.filter(vm.promoters, function (o) {
                return lowercase(o.label).indexOf(lowercase(query)) !== -1;
            }) : vm.promoters;
            var deferred = $q.defer();
            $timeout(function () {
                deferred.resolve(results);
            }, Math.random() * 1000, false);
            return deferred.promise;
        }

        function authorsQuerySearch(query) {
            vm.students = vm.onUploadObj.docuAuthorInfo.selectItems;
            var results = query ? _.filter(vm.students, function (o) {
                return lowercase(o.label).indexOf(lowercase(query)) !== -1;
            }) : vm.students;
            var deferred = $q.defer();
            $timeout(function () {
                deferred.resolve(results);
            }, Math.random() * 1000, false);
            return deferred.promise;
        }

        function authorsSelectedItemChange(item) {
            if (!vm.onUploadObj.authors) {
                vm.onUploadObj.authors = {};
            }
            vm.onUploadObj.authors.idx0 = {};
            vm.onUploadObj.authors.idx0.firstName = angular.isUndefined(item) ? null : item.label;
        }

        function addAuthor(){
            vm.authorIndex++;
            vm.authorsArr.push(vm.authorIndex);
        }

        function removeAuthor(event, item){
            $(event.target).parent().parent().remove();
            if(angular.isDefined(vm.onUploadObj.authors) && angular.isDefined(vm.onUploadObj.authors[item])){
                delete vm.onUploadObj.authors[item];
            }
        }

        function uploadText() {
            vm.onUploadText();
        }

        function getDocuments() {
            vm.onReloadDocuments();
        }

        function resetUploadForm() {
            vm.onUploadObj = {
                documentSkipAddresses: []
            };
            vm.onUploadIsActive = false;
            vm.onUploadTextFlag = false;
            vm.isLoading = false;
            vm.onGetTheFiles(null, {});
            vm.authorIndex = 0;
            vm.authorsArr.length = 0;
            vm.selectedItem  = null;
            vm.searchText    = null;
        }

        function addWithoutChecking(obj, ev, form) {
            for (var i = 0; i < form.$$controls.length; i++) {
                form.$$controls[i].$touched = true;
            }
            if (form.$invalid) {
                return;
            }
            //check if coordinator's fields are simplified
            if (angular.isDefined(obj.coordinatorDTO)) {
                obj.coordinatorDTO.lastName = vm.authorsSimplifiedFields ? '' : obj.coordinatorDTO.lastName;
            }
            obj.title = obj.docuTitle;
            vm.onUploadTextFlag = false;

            $mdDialog.show($mdDialog.confirm()
                .title($translate.instant("document.messages.adwithoutchecking"))
                .textContent($translate.instant("document.messages.adwithoutcheckinginfo"))
                .ariaLabel($translate.instant("document.messages.adwithoutcheckinginfo"))
                .targetEvent(ev)
                .ok('Ok')
                .cancel($translate.instant("global.button.cancel"))
                ).then(function () {
                    vm.isLoading = true;
                    DocumentService.operator.save(obj).then(function (responseData) {
                        resetUploadForm();
                        $mdDialog.show(
                          $mdDialog.confirm()
                          .clickOutsideToClose(true)
                          .title('')
                          .textContent($translate.instant("global.messages.info.actionsuccess"))
                          .ariaLabel('')
                          .ok('Ok')
                          .targetEvent(ev)
                          );
                        getDocuments();
                        ContractService.broadcast();
                    }).catch(function (response) {
                        vm.isLoading = false;
                        PlagiatValidationService.getModalError(response.data);
                    });
                });
        }

        function checkDocumentCodeAccountProcess(obj, ev, form) {
            var textContent = vm.checkInfo;
            if (vm.isCharacterLimit) {
                textContent = $translate.instant("document.metric.limit.pool.exhausted:" + vm.account.clientId);
                if (textContent === "document.metric.limit.pool.exhausted:" + vm.account.clientId){
                     textContent = vm.checkInfo;
                }

                $mdDialog.show($mdDialog.confirm()
                    .title($translate.instant("document.messages.checknow"))
                    .htmlContent(textContent)
                    .ariaLabel(vm.checkInfo)
                    .targetEvent(ev)
                    .ok($translate.instant("global.msg.ok"))
                    .cancel($translate.instant("global.button.cancel"))
                ).then(function () {
                    checkDocumentCodeAccount(obj, ev, form);
                });
            } else {
                checkDocumentCodeAccount(obj, ev, form);
            }

        }

        function checkDocumentCodeAccount(obj, ev, form) {
            if (!isFormValid(form)) {
                return;
            }
            // if (vm.priorityCode) {
            //     checkDocumentByPriorityCode(obj, ev, form);
            //     return;
            // }
            var addDocumentCallback;
            if(!vm.onUploadObj.addWithoutChecking){
                addDocumentCallback = function(codeDialogParameters, callbackFunction) {
                    if (codeDialogParameters && codeDialogParameters.generateCheckId) {
                        obj.generateCheckId = true;
                    }
                    if (codeDialogParameters && codeDialogParameters.codeId) {
                        obj.codeId = codeDialogParameters.codeId;
                    }
                    if (codeDialogParameters && codeDialogParameters.checkLater) {
                        obj.checkLater = true;
                    }
                    return vm.addDocumentUniversal(obj, ev, form, callbackFunction);
                };
                var checkDocumentCallback = function(codeDialogParameters) {

                    var documentId = codeDialogParameters.documentId;
                    var codeId = null;
                    if (codeDialogParameters && codeDialogParameters.codeId) {
                        codeId = codeDialogParameters.codeId;
                    }
                    DocumentService.operator.checkDocument(documentId, codeId).then(function () {
                        getDocuments();
                        ContractService.broadcast();
                    });



                };
                $mdDialog.show({
                    templateUrl: 'app/account/documents/document-code-check/document-check-code.dialog.html',
                    clickOutsideToClose: false,
                    locals: {
                        items: {
                            addDocumentCallback: addDocumentCallback,
                            checkDocumentCallback: checkDocumentCallback,
                            fileId: vm.onUploadObj.fileId,
                            priorityCode: vm.priorityCode,
                            size: vm.onUploadObj.size
                        }
                    },
                    controllerAs: 'vm',
                    controller: DialogController
                });
            } else {
                addWithoutChecking(obj, ev, form)
            }
        }

        function checkDocumentByPriorityCode(uploadObj, event, form) {
            uploadObj.checkLater = true;
            vm.addDocumentUniversal(uploadObj, event, form).then(function (documentId) {
                CodeService.findCodeForDocumentChecking(documentId, true).then(
                  function (codeForDocumentCheckingResponse) {
                      var codeForDocumentChecking = codeForDocumentCheckingResponse.data;
                      if (codeForDocumentChecking) {
                          DocumentService.operator.checkDocument(documentId, codeForDocumentChecking.codeId).then(function () {
                              getDocuments();
                              ContractService.broadcast();
                          });
                      } else {
                          ModalService.showConfirmModal("document.code.no-fitting-code.buy-proposal",
                            {customCancelButton: true}).then(
                            function () {
                                $state.go('code-payments', {documentId: documentId, priorityCode: true});
                            }
                          )
                      }
                  }
                )
            });
        }

        function DialogController($scope, $mdDialog, items) {
            $scope.items = items;
        }

        function isFormValid(form) {
            for (var i = 0; i < form.$$controls.length; i++) {
                form.$$controls[i].$touched = true;
            }
            return !form.$invalid;
        }

        function addDocumentUniversal(obj, ev, form, callbackFunction) {
            if (!isFormValid(form)) {
                return;
            }
            //check if coordinator's fields are simplified
            if (angular.isDefined(obj.coordinatorDTO)) {
                obj.coordinatorDTO.lastName = vm.authorsSimplifiedFields ? '' : obj.coordinatorDTO.lastName;
            }
            obj.title = obj.docuTitle;
            vm.onUploadTextFlag = false;
            vm.isLoading = true;

            if ((CONTRACTTYPECONSTANT.CONT_TYPE_PER_USER.id === vm.contract.contractType) && AccountService.account.accountType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_TEACHER.value && vm.onUploadObj.aiDetection) {
                DocumentService.operator.checkDocumentAiLimitReached(obj.authors ? obj.authors.idx0.firstName : null)
                  .then(function (limit) {
                      vm.isAiLimitReached = limit.data;
                      return showAddDocumentDialog(obj, ev, callbackFunction);
                  })
            } else {
                vm.isAiLimitReached = false;
                return showAddDocumentDialog(obj, ev, callbackFunction);
            }
        }

        function showAddDocumentDialog(obj, ev, callbackFunction) {
            return $mdDialog.show($mdDialog.confirm()
                .title($translate.instant("document.messages.checknow"))
                .textContent(vm.isAiLimitReached && vm.onUploadObj.aiDetection ? $translate.instant(" document.metric.ai-detection.pool.exhausted") : vm.checkInfo)
                .ariaLabel(vm.checkInfo)
                .targetEvent(ev)
                .ok($translate.instant("global.msg.ok"))
                .cancel($translate.instant("global.button.cancel"))
            ).then(function () {
                if (vm.isAiLimitReached) {
                    vm.onUploadObj.aiDetection = false
                }
                if (vm.account.authorities.includes('PERM_USER_CHECK_DOCUMENT_METRIC_SIMILARITY_BEFORE_ADD')) {
                    return DocumentService.operator.searchSimilar(obj).then(function (responseData) {
                        if (typeof responseData.data !== "undefined" && responseData.data.length != 0) {

                            resetUploadForm();
                            return $mdDialog.show(
                                $mdDialog.confirm(
                                    {
                                        onComplete: function afterShowAnimation() {
                                            var $dialog = angular.element(document.querySelector('md-dialog'));

                                            var $actionsSection = $dialog.find('md-dialog-actions');
                                            angular.element($actionsSection).addClass('md-dialog-action-section-similar-documents');

                                            var $actionsContent = $dialog.find('md-dialog-content');
                                            angular.element($actionsContent).addClass('md-dialog-content-section-similar-documents');

                                            var wishToProceedLine = angular.element('<span>' + $translate.instant("document.messages.metric.similarity.wish.to.proceed") + '</span>');
                                            angular.element(wishToProceedLine).addClass('md-title md-dialog-content-section-similar-documents-proceed');
                                            angular.element($actionsSection).prepend(wishToProceedLine);
                                        }
                                    }
                                ).title($translate.instant("document.messages.metric.similarity.before.adding"))
                                    .htmlContent(formatSimilarDocumentsList($translate, responseData))
                                    .ariaLabel('')
                                    .targetEvent(ev)
                                    .ok($translate.instant("global.msg.ok"))
                                    .cancel($translate.instant("global.button.cancel"))
                            ).then(function () {
                                resetUploadForm();
                                return DuplicatesDialogService.saveDocumentWithPopUp(obj, ev, callbackFunction);
                            }, function () {
                                // console.log("Operation of adding document has been aborted");
                            });
                        } else {
                            resetUploadForm();
                            return DuplicatesDialogService.saveDocumentWithPopUp(obj, ev, callbackFunction);
                        }

                    }).catch(function (response) {
                        vm.isLoading = false;
                        PlagiatValidationService.getModalError(response.data);
                    });
                } else {
                    resetUploadForm();

                    DocumentService.operator.save(obj).then(function (responseData) {
                        if (callbackFunction) {
                            callbackFunction(responseData.data);
                        }
                        getDocuments();
                        ContractService.broadcast();
                        return responseData.data;
                    }, function (response) {
                        vm.isLoading = false;
                        PlagiatValidationService.getModalError(response.data);
                    });
                }
            }, function () {
                vm.isLoading = false;
            });
        }

        function getDocumentSkipAddress(chip) {
            return DocumentFormService.documentSkipAddress(chip, vm);
        }

        function isCoordinatorVisible() {
            if (vm.clientTypePublishingHouse) {
                return false;
            }
            return vm.onUploadObj
                && vm.onUploadObj.coordinatorInfo
                && vm.onUploadObj.coordinatorInfo.isPresent
                && vm.onUploadObj.coordinatorInfo.selectItems.length === 0;
        }

        function canUserChangeCoordinator() {
            if (vm.onIsLecturer) {
                return AccountService.getClientSettings().userTeacherCanChangePromoterDuringAddDocument;
            } else {
                return true;
            }
        }

        function coordinatorAutocompleteAvailable() {
            return vm.onUploadObj && vm.onUploadObj.coordinatorInfo && vm.onUploadObj.coordinatorInfo.isPresent
                && vm.onUploadObj.coordinatorInfo.selectItems.length > 0 && vm.canUserChangeCoordinator();
        }

        function aiDetectionDisabled() {
            if (vm.onUploadObj.size <= 300) {
                vm.onUploadObj.aiDetection = false;
            }
            return (vm.onUploadObj && vm.onUploadObj.aiDetectionInfo && vm.onUploadObj.aiDetectionInfo.defaultValue === 'alwaysEnabled')
                || vm.aiDetectionPoolExhausted() || vm.onUploadObj.size <= 300;
        }

        function aiDetectionPoolExhausted() {

            if (AccountService.account.contractAiDetectionEnabled) {
                if (vm.onUploadObj && vm.onUploadObj.aiDetectionPoolInfo && vm.onUploadObj.aiDetectionPoolInfo.aiDetectionPoolEnabled) {
                    if (vm.onUploadObj.size > vm.onUploadObj.aiDetectionPoolInfo.contNumOfAiDetectionLeft) {
                        vm.onUploadObj.aiDetection = false;
                        return true;
                    }
                } else if (vm.onUploadObj && vm.onUploadObj.aiPerUserDetectionLimitInfo && vm.onUploadObj.aiPerUserDetectionLimitInfo.aiPerUserDetectionLimitEnabled) {
                    if ((CONTRACTTYPECONSTANT.CONT_TYPE_PER_USER.id === vm.contract.contractType) && AccountService.account.accountType === USERSCHOOLTYPE.USER_SCHOOL_TYPE_STUDENT.value && vm.isAiLimitReached) {
                        vm.onUploadObj.aiDetection = false;
                        return true;
                    }
                }
            }
            return false;
        }

        function grammarCheckDisabled() {
            return (vm.onUploadObj && vm.onUploadObj.grammarCheckInfo && vm.onUploadObj.grammarCheckInfo.defaultValue === 'alwaysEnabled');
        }

        function showSkipUrl() {
            return !(vm.onIsStudent && vm.clientTypeSchool)
        }

        vm.querySearchOrganizations = function () {
            return vm.searchOrganizationText ? vm.onUploadObj.orgUnitInfo.selectItems.filter(function (org) {
                return org.label.toLowerCase().includes(vm.searchOrganizationText.toLowerCase());
            }) : vm.onUploadObj.orgUnitInfo.selectItems;
        };

        function populateOrganisationUnit() {
            vm.selectedOrganization = vm.onUploadObj.orgUnitInfo.selectItems.find(function (org) {
                return org.value === vm.orgUnitId;
            });
            vm.selectedOrganizationChange(vm.selectedOrganization);
        }

        vm.selectedOrganizationChange = function (item) {
            if (item) {
                vm.onUploadObj.orgUnitId = item.value;
            } else {
                vm.onUploadObj.orgUnitId = null;
            }
        };
    }

    function formatSimilarDocumentsList($translate, responseData) {
        var similarDocumentsList="";
        responseData.data.forEach(function (data) {
            similarDocumentsList = similarDocumentsList + "<br>" +
                $translate.instant('document.report.similarity.title') + ":<b><i>&nbsp;" + data.docuTitle + "&nbsp;</i></b>";
            var lastName = data.authors.author.lastName ? " " + data.authors.author.lastName : "";
            similarDocumentsList = similarDocumentsList + "(" + data.authors.author.firstName + lastName + ")";
            similarDocumentsList = similarDocumentsList + " " + $translate.instant("document.model.size") +":"+data.docuSize +' ' + $translate.instant('document.table.characters');
            similarDocumentsList = similarDocumentsList + "&nbsp;" + $translate.instant("document.model.status") + ": " + $translate.instant('document.table.statuses.' + data.docuStatus) + "<br>";
        });
        similarDocumentsList=similarDocumentsList+"<br>";
        return similarDocumentsList
    }

    angular.module('plagiat2017App')
    .component('documentFormUniversal', {
        templateUrl: 'app/account/documents/document/document-form/document-form-universal.template.html',
        controller: DocumentFormUniversalController,
        bindings: {
            onUploadIsActive: '=',
            onUploadTextFlag: '=',
            onUploadObj: '<',
            onReloadDocuments: '<',
            onGetTheFiles: '<',
            onUploadText: '<',
            isLoading: '=',
            onGetConfiguration: '<',
            onGetConfigurationOffChecking: '<',
            onIsLecturer: '<',
            onIsStudent: '<',
            onIsOperator: '<'
        }
    });

})();

(function () {
    'use strict';

    function DocumentMetricController($scope, $rootScope, $state, $translate, $mdDialog, AUTO_TRANSLATIONS_LANGS, 
                                      DocumentRequest, DocumentService, JhiLanguageService,
                                      TokenService, DocumentFormService, Utils, ExtraOptionsService, DetectInstanceService) {
        var vm = this;
        vm.getDocuments = getDocuments;
        vm.resetUploadForm = resetUploadForm;
        vm.checkLater = checkLater;
        vm.check = check;
        vm.uploadText = uploadText;
        vm.getDocumentSkipAddress = getDocumentSkipAddress;
        vm.goToExtraOptions = goToExtraOptions;
        vm.recalculatePrices = recalculatePrices;
        vm.isAiDetectionEnabled = isAiDetectionEnabled;
        vm.isOptionDisabled = isOptionDisabled;

        vm.documentRequest = new DocumentRequest();
        vm.step = 1;
        vm.autoTranslationLangs = Utils.sortAutoTranslationsLanguages(AUTO_TRANSLATIONS_LANGS, $translate);
        vm.translation = {};
        vm.isBg = false;
        JhiLanguageService.getCurrent().then(function (language) {
            vm.isBg = language === 'bg';
        });

        function uploadText() {
            vm.onUploadText();
        }

        function broadcastTokensInfo() {
            $rootScope.$broadcast("availableTokens");
        }

        function getDocuments() {
            resetUploadForm();
            vm.onReloadDocuments();
        }

        function resetUploadForm() {
            vm.onUploadIsActive = false;
            vm.onUploadTextFlag = false;
            vm.documentRequest = new DocumentRequest();
            vm.translation = {};
            ExtraOptionsService.resetForm(vm);
            vm.onGetTheFiles(null, {});
            vm.step = 1;
        }

        function checkLater(form, ev) {
            if (!Utils.validateForm(form)) {
                return;
            }
            fillDocumentRequest();
            $mdDialog.show(
                $mdDialog.confirm()
                .title($translate.instant("document.messages.checklater"))
                .textContent($translate.instant("document.messages.clickinfo"))
                .ariaLabel($translate.instant("document.messages.clickinfo"))
                .targetEvent(ev)
                .ok('Ok')
                .cancel($translate.instant("global.button.cancel"))

                ).then(function () {
                    DocumentService.save(vm.documentRequest).then(function (responseData) {
                        vm.onUploadIsActive = false;
                        getDocuments();
                        getTokensInfo();
                        broadcastTokensInfo();
                        $mdDialog.show(
                            $mdDialog.confirm()
                            .clickOutsideToClose(true)
                            .textContent($translate.instant("document.messages.checkconfirm"))
                            .ariaLabel($translate.instant("document.messages.checkconfirm"))
                            .ok('Ok')
                            .targetEvent(ev)
                            );
                    });
                }, function () {

                });
        }

        function fillDocumentRequest() {
            vm.onUploadTextFlag = false;
            vm.documentRequest.fileId = vm.onUploadObj.fileId;
            vm.documentRequest.title = vm.onUploadObj.docuTitle;
            vm.documentRequest.author = vm.onUploadObj.authorFirstName + ' ' + vm.onUploadObj.authorLastName;
            vm.documentRequest.documentSkipAddresses = vm.onUploadObj.documentSkipAddresses;
            vm.documentRequest.paperFormValidityFlag = vm.onUploadObj.paperFormValidityFlag;
            vm.documentRequest.extraOptions = ExtraOptionsService.getCurrentDocumentOptions(vm);
            vm.documentRequest.autoTranslations = vm.translation.chosen;
            vm.documentRequest.autoTranslationsToLang = vm.translation.autoTranslationsToLang;
        }

        function check(form) {
            if (!Utils.validateForm(form)) {
                return;
            }
            fillDocumentRequest();
            vm.isLoading = true;

            DocumentService.check(vm.documentRequest).then(function (responseData) {
                vm.isLoading = false;
                vm.onUploadIsActive = false;
                if (responseData.data.used === false) {
                    var confirm = $mdDialog.confirm()
                    .title('')
                    .textContent($translate.instant("global.messages.error.notenough"))
                    .ariaLabel('notenough')
                    .ok($translate.instant("document.buytokens"))
                    .cancel($translate.instant("document.metric.check-later"))
                    .openFrom('#left');
                    $mdDialog.show(confirm).then(function (result) {
                        TokenService.buyTokens = true;
                        TokenService.tokensNedded = vm.totalPrice - vm.availableTokens;

                        $state.go('payments', {documentId : responseData.data.documentId});
                    },function (result) {
                        getDocuments();
                        broadcastTokensInfo();
                        $mdDialog.hide();
                    });
                } else {
                    $mdDialog.show(
                      $mdDialog.confirm()
                      .clickOutsideToClose(true)
                      .title('')
                      .textContent($translate.instant("global.messages.info.actionsuccess"))
                      .ariaLabel('actionsuccess')
                      .ok('Ok')
                      );
                    getDocuments();
                    broadcastTokensInfo();
                }
            }).catch(function (response) {
                vm.isLoading = false;
                if (response.status === 400) {
                    $mdDialog.show(
                      $mdDialog.confirm()
                      .clickOutsideToClose(true)
                      .title($translate.instant("global.messages.error.unknown"))
                      .textContent($translate.instant("global.messages.error.unknown"))
                      .ariaLabel($translate.instant("global.messages.error.unknown"))
                      .ok('OK')
                      );
                }
            });
                    
        }
    
        function getDocumentSkipAddress(chip) {
            return DocumentFormService.documentSkipAddress(chip, vm);
        }

        function goToExtraOptions(form) {
            if (!Utils.validateForm(form)) {
                return;
            }
            if (!vm.documentExtraOptions) {
                vm.isLoading = true;
                TokenService.getTokenPriceList({
                    documentId: null,
                    documentSize: vm.onUploadObj.size
                }).then(function (responseData) {
                    vm.charactersPerToken = responseData.data.charactersPerToken;
                    vm.documentExtraOptions = responseData.data.extraOptions;
                    if (vm.instance === 'int') {
                        for (var i in vm.documentExtraOptions) {
                            vm.documentExtraOptions[i].chosen = null;
                        }
                    }
                    vm.freeChecksAvailable = responseData.data.freeChecksAvailable;
                    recalculatePrices();
                    TokenService.getInfo().then(function (responseData) {
                        vm.tokenInfo = responseData.data;
                        vm.availableTokens = responseData.data.availableTokens;
                        vm.isLoading = false;
                        vm.step = 2;
                    });
                });
            } else {
                vm.step = 2;
            }

        }

        function recalculatePrices() {
            return ExtraOptionsService.recalculatePrices(vm.onUploadObj.size, vm);
        }

        function isAiDetectionEnabled() {
            return ExtraOptionsService.isAiDetectionEnabled(vm);
        }

        function isOptionDisabled(option) {
            return ExtraOptionsService.isOptionDisabled(vm, vm.onUploadObj.size, option);
        }

    }

    angular.module('documentMetric', [])
            .component('documentMetric', {
                templateUrl: 'app/account/documents/document/document-form/document-form-individual/document-metric-individual.template.html',
                controller: DocumentMetricController,
                bindings: {
                    onUploadIsActive: '=',
                    onUploadTextFlag: '=',
                    onUploadObj: '<',
                    onReloadDocuments: '<',
                    onGetTheFiles: '<',
                    onUploadText: '<',
                    isLoading: '='
                }
            });

})();

(function () {
    'use strict';

    function DocumentFormAssignmentController($scope, $q, _, AccountService, AssignmentsService, PlagiatValidationService, Utils) {
        var vm = this;
        vm.loading = false;
        vm.submitAssignment = submitAssignment;
        vm.resetUploadForm = resetUploadForm;
        vm.clientTypeSchool = AccountService.clientType.isSchool();
        
        function submitAssignment(form) {
            if (!Utils.validateForm(form)) {
                return;
            }
            vm.loading = true;
            AssignmentsService.submitAssignment(vm.onAssignmentSubmitForm)
                .then(function (responseData) {
                    vm.resetUploadForm();
                    vm.onReloadDocuments();
                    vm.loading = false;
            }).catch(function (response) {
                vm.loading = false;
                PlagiatValidationService.getModalError(response.data);
            });
        }

        function resetUploadForm() {
            vm.onUploadObj = {
                documentSkipAddresses: []
            };
            vm.onUploadIsActive = false;
            vm.onUploadTextFlag = false;
            vm.isLoading = false;
            vm.onGetTheFiles(null, {});
            vm.authorIndex = 0;
            vm.selectedItem  = null;
            vm.searchText    = null;
        }

    }

    angular.module('plagiat2017App')
    .component('documentFormAssignment', {
        templateUrl: 'app/account/documents/document/document-form/document-form-assignment.template.html',
        controller: DocumentFormAssignmentController,
        bindings: {
            onUploadIsActive: '=',
            onUploadTextFlag: '=',
            onUploadObj: '<',
            onReloadDocuments: '<',
            onGetTheFiles: '<',
            onUploadText: '<',
            isLoading: '=',
            onAssignmentSubmitForm: '<',
        }
    });

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('DocumentFormService', DocumentFormService);

    DocumentFormService.$inject = [];

    function DocumentFormService() {

        var service = {
            documentSkipAddress: documentSkipAddress
        }

        return service;

        function documentSkipAddress(chips, vm) {

            if (vm.onUploadObj.documentSkipAddresses) {
                vm.onUploadObj.documentSkipAddresses = vm.onUploadObj.documentSkipAddresses.slice(0); // workaround na bug w md-chips
            }

            vm.skipAddressesInvalidError = false;
            vm.skipAddressesInvalidUrl = null;

            var chipsArray = chips.split(/[\n\s,]+/);
            angular.forEach(chipsArray, function(chip) {
                if (chip.startsWith("http")) {
                    if (!isValidUrl(chip)) {
                        vm.skipAddressesInvalidError = true;
                        vm.skipAddressesInvalidUrl = chip;
                    } else {
                        const chipObj = {address: chip};
                        if (vm.onUploadObj.documentSkipAddresses.indexOf(chipObj) < 0) {
                            vm.onUploadObj.documentSkipAddresses.push(chipObj);
                        }
                    }
                }
            });

            return null;    
        }
        
        function isValidUrl(string) {
            try {
                new URL(string);
            } catch (_) {
                return false;
            }
            return true;
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('documents', {
            parent: 'account',
            url: '/documents?key&price&currency',
            data: {
                authorities: [],
                pageTitle: 'global.menu.documents'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/documents/document.html',
                    controller: 'DocumentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'docuSubmitDate,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('codes');
                    $translatePartialLoader.addPart('dictionary');
                    $translatePartialLoader.addPart('clientType');
                    $translatePartialLoader.addPart('validation');
                    $translatePartialLoader.addPart('assignment');
                    $translatePartialLoader.addPart('delete-account');
                    return $translate.refresh();
                }]
            }
        })
        .state("send-to-orppd", {
            url: "/:docId/send-to-orppd",
            parent: "documents",
            data: {
                pageTitle: 'client.orppd'
            },
            onEnter: [
                "$mdDialog", "$state", '$stateParams', 'OrppdService',
                function ($mdDialog, $state, $stateParams, OrppdService) {
                    OrppdService.getOrppdForm($stateParams.docId).then(
                        function (response) {
                            $mdDialog.show({
                                controller: 'SendToOrppdController',
                                controllerAs: 'vm',
                                templateUrl: 'app/components/document/send-to-orppd/send-to-orppd.modal.html',
                                clickOutsideToClose: false,
                                locals: {
                                    form: response
                                },
                            }).then(function () {
                                $state.go("documents");
                            }, function () {
                                $state.go("documents");
                            });
                        }, function () {
                            $state.go("documents");
                        }
                    );
                }
            ]
        })
        .state("documentSendToJsa", {
            url: "/:docId/send-to-jsa",
            parent: "documents",
            data: {
                pageTitle: 'global.menu.documents.send-to-jsa'
            },
            onEnter: [
                "$mdDialog", "$state", '$stateParams', 'DocumentService',
                function ($mdDialog, $state, $stateParams, DocumentService) {
                    DocumentService.document.id = $stateParams.docId;
                    $mdDialog.show({
                        controller: 'SendToJSAController',
                        controllerAs: 'vm',
                        templateUrl: 'app/components/document/send-to-jsa/send-to-jsa.template.html',
                        clickOutsideToClose: false,
                        locals: {
                            docId: $stateParams.docId
                        }
                    }).then(function () {
                        $state.go("documents");
                    });
                }
            ]
        }).state("report2020Redirection", {
            url: "/:documentId/report",
            parent: "documents",
            data: {
                pageTitle: 'global.menu.documents.report2020-redirect'
            },
            onEnter: [
                "ModalService", "$state", '$window', '$stateParams', 'ReportDocumentService', '$mdDialog',
                function (ModalService, $state, $window, $stateParams, ReportDocumentService, $mdDialog) {
                    var dialog = ModalService.showPleaseWaitDialog();
                    ReportDocumentService.getReport2020RedirectionUrl($stateParams.documentId).then(function(redirectionUrl) {
                        $window.location.href = redirectionUrl;
                    }, function () {
                        $mdDialog.hide(dialog);
                        $state.go('accessdenied');
                    });
                }
            ]
        })
        ;
    }

})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .controller('DocumentController', DocumentController);

    DocumentController.$inject = [
        '$scope', '$q', '$rootScope', '$localStorage', 'queryRequest', 'searchRequest', 'tableSettingsRequest', '$interval',
        'AccountService', '$timeout', '$state', '$stateParams', '$translate', '$mdToast', 'DocumentService', '$mdDialog', 'TokenService', '$mdBottomSheet',
        '$log', 'InstanceService', 'DetectInstanceService', 'DOCUSTATUSES', 'OPDOCUSTATUSES', 'DocumentReportXlsService', 'ContractService',
        '$cookies', 'PlagiatValidationService', 'ScrollService', 'OrganisationalUnitsService', 'Utils', 'TableSelectOptions',
        'JSA_ORDER_STATUS', 'ProtocolForDocumentService', 'JsaService', 'ModalService', 'Principal', 'ORPPD_STATUS', 'DOCUMENT_STATUS', 'PERMISSIONS',
        'ClientSettingService', 'AssignmentsService'
    ];

    function DocumentController(
        $scope, $q, $rootScope, $localStorage, queryRequest, searchRequest, tableSettingsRequest, $interval,
        AccountService, $timeout, $state, $stateParams, $translate, $mdToast, DocumentService, $mdDialog, TokenService, $mdBottomSheet,
        $log, InstanceService, DetectInstanceService, DOCUSTATUSES, OPDOCUSTATUSES, DocumentReportXlsService, ContractService,
        $cookies, PlagiatValidationService, ScrollService, OrganisationalUnitsService, Utils, TableSelectOptions,
        JSA_ORDER_STATUS, ProtocolForDocumentService, JsaService, ModalService, Principal, ORPPD_STATUS, DOCUMENT_STATUS, PERMISSIONS,
        ClientSettingService, AssignmentsService
    ) {
        var vm = this;

        vm.jsaOrderStatus = JSA_ORDER_STATUS;

        vm.instance = InstanceService.instance().lang;
        vm.conversionDomain = DetectInstanceService.getConversionAllowance();
        vm.theme = $cookies.get('plagiat-theme');
        vm.timezone = InstanceService.instance().timezoneDocuments;
        moment.locale(vm.instance);
        vm.convertToDate = convertToDate;

        vm.jsa = AccountService.getClientSettings().jsaIntegration;
        vm.assignmentsEnabled = AccountService.getClientSettings().assignmentsEnabled;
        vm.documentImportEnabled = AccountService.getClientSettings().documentImportEnabled && !AccountService.role.isStudent();
        vm.selfEnrollmentEnabled = AccountService.getClientSettings().assignmentsEnabled && AccountService.role.isStudent();

        vm.key = $stateParams.key;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.success = null;
        vm.isLoading = false;
        vm.uploadIsActive = false;
        vm.uploadTextFlag = false;
        vm.uploadObj = {};
        vm.searchData = {};
        vm.files = null;
        vm.availableExtension = '';
        vm.formdata = new FormData();
        vm.queryRequest = new queryRequest();
        vm.queryRequest.limit = $localStorage.documentsListLimit ? $localStorage.documentsListLimit : vm.queryRequest.limit;
        vm.searchRequest = new searchRequest();
        vm.options = new tableSettingsRequest();
        vm.showDetailsBlock = false;
        vm.pickedDocument = false;
        vm.details = {};
        vm.statuses = [];
        vm.documentsToRefresh = [];
        vm.documentsToRefreshPromise;
        vm.isJsaDisabled = true;
        vm.selected = [];
        vm.tableSelectOptions = new TableSelectOptions();
        vm.ORPPD_STATUS = ORPPD_STATUS;
        vm.documentStatus = DOCUMENT_STATUS;
        vm.isUploadTextVisible = false;
        vm.isSuperAdmin = AccountService.role.isSuperAdmin();
        vm.isAdmin = AccountService.role.isAdmin();
        vm.isReseller = AccountService.role.isReseller();
        vm.isMinistry = AccountService.role.isMinistry();
        vm.isStudent = AccountService.role.isStudent();
        vm.isIndividual = AccountService.role.isIndividual();
        vm.clientTypePublishingHouse = AccountService.clientType.isPublishingHouse();
        vm.clientTypeSchool = AccountService.clientType.isSchool();
        vm.clientSettings = AccountService.getClientSettings();
        vm.report2020Disabled = vm.clientSettings.report2020Disabled;
        vm.multipleSimilarityFactorsAreDisplayed = !vm.clientSettings.hideDocuSimilarityFactor && !vm.clientSettings.hideDocuSimilarityFactorExt && vm.clientSettings.showReversedSimilarityFactor;
        vm.showReversedSimilarityFactor = vm.clientSettings.showReversedSimilarityFactor;
        vm.showSelfCitationFactor = vm.clientSettings.showSelfCitationFactor;
        vm.authorsSimplifiedFields = vm.clientSettings.authorsSimplifiedFields;

        vm.uploadFile = uploadFile;
        vm.uploadText = uploadText;
        vm.getTheFiles = getTheFiles;
        vm.submitAssignment = submitAssignment;
        vm.submitAssignmentCorrection = submitAssignmentCorrection;
        vm.submitAssignmentPaidCorrection = submitAssignmentPaidCorrection;
        vm.getDocuments = getDocuments;
        vm.getDocumentsSimpleSearch = documentsSimpleSearch;
        vm.reloadDocuments = reloadDocuments;
        vm.getAvailableExtensions = getAvailableExtensions;
        vm.startPaging = startPaging;
        vm.goTo = goTo;
        vm.changeLimit = changeLimit;
        vm.getDetails = getDetails;
        vm.getDocumentStatusTooltipKey = getDocumentStatusTooltipKey;
        vm.getUploadFormConfiguration = getUploadFormConfiguration;
        vm.getUploadFormOffCheckingConfiguration = getUploadFormOffCheckingConfiguration;
        vm.generateReportXls = generateReportXls;
        vm.deSelectRow = deSelectRow;
        vm.selectRow = selectRow;
        vm.toggleSelection = toggleSelection;
        vm.resetSelection = resetSelection;
        vm.closeBottomSheet = closeBottomSheet;
        vm.removeDocuments = removeDocuments;
        vm.rejectDocuments = rejectDocuments;
        vm.addDocuments = addDocuments;
        vm.showWarningOnFactor1 = showWarningOnFactor1;
        vm.showWarningOnFactor2 = showWarningOnFactor2;
        vm.canAcceptJsaReport = canAcceptJsaReport;
        vm.shouldShowDocumentFormTabs = shouldShowDocumentFormTabs;
        vm.shouldShowOnlyUniversalDocumentForm = shouldShowOnlyUniversalDocumentForm;
        vm.shouldShowDocumentAssignmentForm = shouldShowDocumentAssignmentForm;
        vm.assignmentAfterDueDate = assignmentAfterDueDate;
        vm.isUploadFileVisible = isUploadFileVisible;
        vm.selfEnrollment = selfEnrollment;
        vm.isCoordinatorVisible = isCoordinatorVisible;

        checkJsaAccessData();
        if (vm.clientSettings.protocolsEnabled) {
            findAllProtocolForDocuments();
        }

        this.$onInit = function () {
            if (AccountService.clientType.isPap()) {
                $state.go('reports');
            }
            vm.isUploadTextVisible = isUploadTextVisible();
            vm.clientHasPermToEditDocument = vm.clientSettings.clientConfigurationAllowUserEditDocument;
            if (vm.isSuperAdmin) {
                vm.searchRequest.simpleSearch = false;
            }
        };

        $scope.$on('$destroy', function() {
            cancelDocumentsToRefreshInterval();
        });
        
        $scope.$on('on-get-documents', function () {
            reloadDocuments();
        });

        function reloadDocuments() {
            vm.documentsSearchRequest.simpleSearch.length > 0 ? documentsSimpleSearch(vm.documentsSearchRequest) : getDocuments(vm.documentsSearchRequest);
        }

        function checkJsaAccessData() {
            if (vm.jsa) {
                JsaService.getAccessData().then(function (response) {
                    if (response.tokenLastSaveDate !== null && response.polonCode !== null) {
                        vm.isJsaDisabled = false;
                    }
                })
            }
        }

        function resetSelection() {
            if(vm.tableSelectOptions.selectedAll) {
                vm.selected.length = 0;
                vm.tableSelectOptions = new TableSelectOptions();
                $mdBottomSheet.hide();
            }
        }

        function canAcceptJsaReport(document){
            return document.jsaOrderStatus === JSA_ORDER_STATUS.COMPLETE;
        }

        function shouldShowDocumentFormTabs(){
            return vm.uploadIsActive && vm.jsa && !vm.assignmentSubmitForm;
        }

        function shouldShowOnlyUniversalDocumentForm(){
            return vm.uploadIsActive && !vm.jsa && !vm.assignmentSubmitForm;
        }

        function shouldShowDocumentAssignmentForm(){
            return vm.uploadIsActive && vm.assignmentSubmitForm;
        }

        function showWarningOnFactor1(val, clientWarningThreshold1) {
            if (vm.clientSettings.warningThresholds) {
                if (clientWarningThreshold1) {
                    return 100 * val > clientWarningThreshold1;
                } else {
                    return 100 * val > vm.clientSettings.warningThreshold1;
                }
            }
            return false;
        }
        
        function showWarningOnFactor2(val, clientWarningThreshold2) {
            if (vm.clientSettings.warningThresholds) {
                if (clientWarningThreshold2) {
                    return 100 * val > clientWarningThreshold2;
                } else {
                    return 100 * val > vm.clientSettings.warningThreshold2;
                }
            }
            return false;
        }
        
        function closeBottomSheet() {
            vm.selected.length = 0;
            vm.tableSelectOptions = new TableSelectOptions();
            $mdBottomSheet.hide();
        }

        function openBottomSheet() {
            $mdBottomSheet.show({
              templateUrl: 'app/account/documents/bottom-sheet.template.html',
              controllerAs: 'bootomSheet',
              parent: angular.element(document.getElementById('documents')),
              controller: function GridBottomSheetCtrl(){
                var bootomSheet = this;
                bootomSheet.checked = true;
                bootomSheet.closeBottomSheet = vm.closeBottomSheet;
                bootomSheet.selected = vm.selected;
                bootomSheet.tableSelectOptions = vm.tableSelectOptions;
                bootomSheet.total = vm.totalDocuments;
                bootomSheet.toggleSelection = vm.toggleSelection;
                bootomSheet.closeBottomSheet = vm.closeBottomSheet;

                bootomSheet.isIndividual = vm.isIndividual;
                bootomSheet.isStudent = vm.isStudent;
                bootomSheet.isAdmin = vm.isAdmin;
                bootomSheet.isMinistry = vm.isMinistry;
                bootomSheet.generateReportXls = vm.generateReportXls;
                bootomSheet.removeDocuments = vm.removeDocuments;
                bootomSheet.rejectDocuments = vm.rejectDocuments;
                bootomSheet.addDocuments = vm.addDocuments;
                bootomSheet.userDatabaseAddingEnabled = userDatabaseAddingEnabled();
            },
            isLockedOpen: true,
            disableParentScroll: false,
            disableBackdrop: true
          });
        }

        function selectRow(pickedId) {
            if( vm.selected.length === 1) {
                openBottomSheet();
            }
            angular.forEach(vm.documents, function (value) {
                if (value.documentId === pickedId) {
                    if (vm.tableSelectOptions.selectedHelper.indexOf(pickedId) === -1) {
                        vm.tableSelectOptions.selectedHelper.push(value);
                    }
                }
            });
        }

        function selectRows(obj) {
            angular.forEach(obj, function (value) {
                if (vm.selected.indexOf(value.documentId) === -1) {
                    vm.selected.push(value.documentId);
                }
            })
        }

        function toggleSelection(total) {
            if(!vm.tableSelectOptions.selectedAll) {
                selectRows(vm.documents);
            }
            vm.tableSelectOptions.selectedAll = !vm.tableSelectOptions.selectedAll;
            vm.tableSelectOptions.selectedNo = total;
            if( !vm.tableSelectOptions.selectedAll ) {
                closeBottomSheet();
            }
        }

        function deSelectRow(pickedId) {
            if( vm.selected.length === 0) {
                closeBottomSheet();
            }
            vm.tableSelectOptions.selectedAll = false;
            angular.forEach(vm.documents, function (value) {
                if (value.documentId === pickedId) {
                    vm.tableSelectOptions.selectedHelper.splice(vm.tableSelectOptions.selectedHelper.indexOf(value), 1);
                }
            });
        }

        if(vm.clientSettings && vm.clientSettings.clieForeignAlphabetAlertLimit == 0){
        	vm.clientSettings.clieForeignAlphabetAlertLimit = 1;
        }

        $scope.$on('uploadActive', function () {
            vm.uploadIsActive = true;
            getUploadFormConfiguration(DocumentService.uploadedData).then(function(response){
                vm.uploadObj = response;
                vm.uploadObj.documentSkipAddresses = [];
            });
        });

        function shouldShowSynchronizationValidationWindow() {
            if (vm.jsa) {
                JsaService.getAccessData().then(function (response) {
                    if (response.tokenLastSaveDate === null || response.polonCode === null) {
                        ModalService.showDialogModal("document.messages.jsa.synchronization.error");
                    } else {
                        vm.isJsaDisabled = false;
                    }
                })
            }
        }

        function setRoles(){
            vm.isIndividual = AccountService.role.isIndividual();
            vm.isOperator = AccountService.role.isOperator();
            vm.isStudent = AccountService.role.isStudent();
            vm.isLecturer = AccountService.role.isLecturer();
            vm.isAdmin = AccountService.role.isAdmin();
            vm.isSuperAdmin = AccountService.role.isSuperAdmin();
        }

        function verifyContract(){

        	vm.uploadObj.addWithoutCheckingError = false;
        	vm.uploadObj.addWithoutCheckingDisabled = false;
        	vm.uploadObj.addWithoutChecking = false;

            ContractService.getInfo().then(function(response){
                if (AccountService.clientType.isCodeAccount()) {
                    // Code Accounts are not depending on contract only. Code clients can check document using purchased codes.
                    return;
                }
            	if(response.data.contractType === 0 && !response.data.isContractActive ){
                    setErrorWithoutCheckingText('global.messages.error.docu-count-exceeded');
                } else if(response.data.contractType === 1 && response.data.contNumOfPlagReportsLeft < vm.uploadObj.size){
                	 setErrorWithoutCheckingText('global.messages.error.docu-character-count-exceeded');
                } else if(response.data.userQueryCounter <= 0 && response.data.userQueryCounterType === 0){
                	setErrorWithoutCheckingText('global.messages.error.user-query-limit-exceeded');
                } else if(response.data.userQueryCounter < vm.uploadObj.size && response.data.userQueryCounterType === 1 ){
                	setErrorWithoutCheckingText('global.messages.error.user-query-limit-exceeded');
                } else if(response.data.contMaxDocPlagSize < vm.uploadObj.size){
                	setErrorWithoutCheckingText('global.messages.error.docu-size-exceeded');
                }
            });
        }

        function setErrorWithoutCheckingText(translationKey){
        	vm.uploadObj.addWithoutCheckingError = true;
        	vm.uploadObj.addWithoutCheckingDisabled = true;
        	if (vm.isStudent && AccountService.clientType.isSchool()) { // ITDPANEL17-1836 dla uczniów nie pokazujemy guzika <Dodaj bez sprawdzania>
                vm.uploadObj.addWithoutChecking = false;
            } else {
                vm.uploadObj.addWithoutChecking = true;
            }
        	vm.uploadObj.addWithoutCheckingErrorText = translationKey;
        }

        function getUploadFormOffCheckingConfiguration(obj){
            var deferred = $q.defer();
            if(!vm.isIndividual){
                DocumentService.operator.getConfigurationOffChecking().then(function(response){
                    vm.uploadObj = Object.assign( response.data, obj);
                });
            }
            else {
                vm.uploadObj = obj;
            }
            deferred.resolve(vm.uploadObj);
            return deferred.promise;
        }

        function getUploadFormConfiguration(obj){
            var deferred = $q.defer();
            if (!vm.isIndividual){
                DocumentService.operator.getConfiguration().then(function(response){
                    vm.uploadObj = Object.assign( response.data, obj);
                    populateAiDetection();
                    populateGrammarCheck();
                    verifyContract();
                    populateAuthor();
                });
            } else {
                vm.uploadObj = obj;
                vm.uploadObj.documentSkipAddresses = [];
            }
            deferred.resolve(vm.uploadObj);
            return deferred.promise;
        }

        function afterUploadLandingPage() {
            if (vm.key === 'error') {
                var confirm = $mdDialog.confirm()
                .title('')
                .clickOutsideToClose(true)
                .htmlContent($translate.instant("global.messages.error.error"))
                .ariaLabel('')
                .ok('Ok')
                .openFrom('#left');
                $mdDialog.show(confirm).then(function (result) {

                });
            }
            if (vm.key === 'success') {
                var confirm = $mdDialog.confirm()
                .title('')
                .clickOutsideToClose(true)
                .htmlContent($translate.instant("global.messages.success.afterpayment"))
                .ariaLabel('')
                .ok('Ok')
                .openFrom('#left');
                $mdDialog.show(confirm).then(function (result) {

                });
            }
        }

        function prepareSearchRequest(){
            if(!vm.isIndividual){
                DocumentService.operator.getConfiguration().then(function(response){
                    vm.searchData.docuKindInfo = response.data.docuKindInfo.selectItems;
                    OrganisationalUnitsService.getAll().then(function(response){
                        vm.searchData.orgUnitInfo = response.data;
                    });
                    vm.searchData.documentParameterDefinitions = response.data.documentParameterDefinitions;
                });
            }
        }

        function prepareDocuStatuses(){
            vm.searchData.statuses = vm.isIndividual ? DOCUSTATUSES : OPDOCUSTATUSES;
            if (vm.jsa || vm.isSuperAdmin) {
                vm.searchData.statuses.push({'id': -9, 'status': 'jsa-error' });
            }
            if (vm.isSuperAdmin || vm.assignmentsEnabled) {
                vm.searchData.statuses.push({'id': -11, 'status': 'draft' });
            }
        }

        function prepareMassActions() {
            vm.deferred = $q.defer();
            vm.tableSelectOptions.ids.length = 0;
            vm.tableSelectOptions.selectedNo = vm.tableSelectOptions.selectedAll ? vm.tableSelectOptions.selectedNo : vm.selected.length;
            angular.forEach(vm.tableSelectOptions.selectedHelper, function (value) {
                if( value.docuStatus === 1 ){
                    vm.tableSelectOptions.ids.push(value.documentId);
                }
            });
            vm.deferred.resolve(vm.tableSelectOptions);
            return vm.deferred.promise;
        }

        function removeDocuments() {
            prepareMassActions().then(function(response){
                var confirm = $mdDialog.confirm()
                .title($translate.instant("document.confirmremovemany"))
                .htmlContent($translate.instant("document.marked-docs") + ' ' + response.selectedNo)
                .ariaLabel($translate.instant("document.areyousure"))
                .ok($translate.instant("global.button.remove"))
                .cancel($translate.instant("global.button.cancel"))
                .openFrom('#left');
                $mdDialog.show(confirm).then(function () {
                    vm.isLoaderActive = true;
                    DocumentService.removeMassDocuments({ids: vm.selected}, vm.searchRequest, response.selectedAll).then(function () {
                        vm.isLoaderActive = false;
                        TokenService.broadcastTokens();
                        closeBottomSheet();
                        reloadDocuments();
                    }).catch(function (response) {
                        PlagiatValidationService.getModalError(response.data);
                    });
                });
            });
        }

        function rejectDocuments() {
            prepareMassActions().then(function(response) {
                vm.rejectIndexFromDbText = response.selectedAll ? $translate.instant("document.marked-docs") + ' ' + response.selectedNo +'<br /><br />'+ $translate.instant("document.messages.index.reject.mass") : $translate.instant("document.marked-docs") + vm.selected.length +'<br />'+ $translate.instant("document.rejectfromdatabaseno") + response.ids.length + '<br /><br />' + $translate.instant("document.cantrejectothers");
                var confirm = $mdDialog.confirm()
                .title($translate.instant("global.confirm.action"))
                .htmlContent(vm.rejectIndexFromDbText)
                .ariaLabel($translate.instant("document.areyousure"))
                .ok($translate.instant("global.button.reject"))
                .cancel($translate.instant("global.button.cancel"))
                .openFrom('#left');
                $mdDialog.show(confirm).then(function () {
                    if( vm.tableSelectOptions.ids.length > 0 || response.selectedAll ){
                        vm.isLoaderActive = true;
                        DocumentService.indexRejectFromDatabase({ids:response.ids}, vm.searchRequest, response.selectedAll).then(function () {
                            vm.isLoaderActive = false;
                            closeBottomSheet();
                            reloadDocuments();
                        }, function (error) {
                         PlagiatValidationService.getModalError(error.data);
                     });
                    }
                });
            });
        }

        function addDocuments() {
            prepareMassActions().then(function(response) {
                vm.addToIndexText = response.selectedAll ? $translate.instant("document.marked-docs") + ' ' + response.selectedNo +'<br /><br />'+ $translate.instant("document.messages.index.add.mass") : $translate.instant("document.marked-docs") + vm.selected.length +'<br />'+ $translate.instant("document.addtodatabaseno") + response.ids.length + '<br /><br />' + $translate.instant("document.cantaddothers");
                var confirm = $mdDialog.confirm()
                .title($translate.instant("global.confirm.action"))
                .htmlContent(vm.addToIndexText)
                .ariaLabel($translate.instant("document.areyousure"))
                .ok($translate.instant("global.button.add"))
                .cancel($translate.instant("global.button.cancel"))
                .openFrom('#left');
                $mdDialog.show(confirm).then(function () {
                    if( vm.tableSelectOptions.ids.length > 0 || response.selectedAll){
                        vm.isLoaderActive = true;
                        DocumentService.indexAddToDatabase({ids:response.ids}, vm.searchRequest, response.selectedAll).then(function () {
                            vm.isLoaderActive = false;
                            closeBottomSheet();
                            reloadDocuments();
                        }, function (error) {
                            PlagiatValidationService.getModalError(error.data);
                        });
                    }
                });
            });
        }

        function getDetails(item) {
            vm.showDetailsBlock = false;
            vm.pickedDocument = item.documentId;
            if (item.documentId !== DocumentService.documentDetailsObj.documentId) {
                DocumentService.documentDetailsObj = item;
                vm.isLoaderActive = true;

                if(!vm.isIndividual){
                    DocumentService.getDetailsForOperator(item.documentId).then(function (result) {
                        vm.isLoaderActive = false;
                        vm.showDetailsBlock = true;
                        vm.details = result.data;
                        vm.details.docuSubmitDate = moment(vm.details.docuSubmitDate).format('LL LT');
                        if (vm.details.docuReportDate){
                            vm.details.docuReportDate =  moment(vm.details.docuReportDate).format('LL LT');
                        }

                    });
                } else {
                    DocumentService.getDetails(item.documentId).then(function (result) {
                        vm.isLoaderActive = false;
                        vm.showDetailsBlock = true;
                        vm.details = result.data;
                        vm.details.docuSubmitDate = moment(vm.details.docuSubmitDate).format('LL LT');
                        if (vm.details.docuReportDate){
                            vm.details.docuReportDate =  moment(vm.details.docuReportDate).format('LL LT');
                        }
                    });
                }
            } else {
                DocumentService.documentDetailsObj = {};
            }
        }

        function getAvailableExtensions() {
            DocumentService.getDocumentAvailableExtension().then(function (result) {
                angular.forEach(result.data, function (value) {
                    vm.availableExtension += '.' + value + ',';
                });
            });
        }

        function uploadText(ev) {
            $mdDialog.show({
                templateUrl: 'app/account/documents/document-text/add-text.tmpl.html',
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(shouldShowSynchronizationValidationWindow);
        }

        function getTheFiles($files, $invalidFiles) {
            preprocessFile($files, $invalidFiles).then(
                function (formData) {
                    vm.uploadFile(formData, vm.fileName);
                }, function (error) {
                    // console.error('getTheFiles error ' + error);
                });
        }
        
        function submitAssignmentPaidCorrection(documentId, $files, $invalidFiles) {
            vm.isLoaderActive = true;
            
            preprocessFile($files, $invalidFiles).then(function (formData) {
                vm.isLoading = true;
                
                DocumentService.operator.uploadFile(formData, vm.fileName)
                    .then(function (responseData) {
                        var submitForm = {};
                        submitForm.documentId = documentId;
                        submitForm.fileId = responseData.data.fileId;
                        
                        var size = responseData.data.size;

                        AssignmentsService.submitAssignmentPaidCorrection(submitForm).then(function (submitResponse) {
                            reloadDocuments();
                            var submitedDocumentId = submitResponse.documentId;
                            
                            var checkDocumentCallback = function(codeDialogParameters) {
                                var codeId = codeDialogParameters.codeId;

                                ModalService.showPleaseWaitDialog();
                                DocumentService.operator.checkDocument(submitedDocumentId, codeId)
                                    .then(function () {
                                        ModalService.showSuccessModal("global.messages.info.actionsuccess");
                                        reloadDocuments();
                                        ContractService.broadcast();
                                    }).catch(function (response) {
                                        PlagiatValidationService.getModalError(response.data);
                                    });
                            };

                            $mdDialog.show({
                                templateUrl: 'app/account/documents/document-code-check/document-check-code.dialog.html',
                                clickOutsideToClose: false,
                                locals: {
                                    items: {
                                        documentId: submitedDocumentId,
                                        checkDocumentCallback: checkDocumentCallback,
                                        isAssignment: true,
                                        priorityCode: false,
                                        size: size
                                    }
                                },
                                controllerAs: 'vm',
                                controller: DialogController
                            });

                        });
                        
                    }).catch(function (response) {
                        vm.isLoading = false;
                        PlagiatValidationService.getModalError(response.data);
                });
            });
        }

        function submitAssignmentCorrection(documentId, $files, $invalidFiles) {
            preprocessFile($files, $invalidFiles).then(function (formData) {
                vm.isLoading = true;
                DocumentService.operator.uploadFile(formData, vm.fileName)
                    .then(function (responseData) {
                        var submitForm = {};
                        submitForm.documentId = documentId;
                        submitForm.fileId = responseData.data.fileId;
                        
                        AssignmentsService.submitAssignmentCorrection(submitForm).then(function (submitResponse) {
                            vm.isLoading = false;
                            //vm.uploadIsActive = true;
                            vm.files = null;
                            vm.formdata = new FormData();

                            ModalService.showSuccessModal("assignment.upload.success");
                            reloadDocuments();
                        });

                    }).catch(function (response) {
                        vm.isLoading = false;
                        PlagiatValidationService.getModalError(response.data);
                    });
            })
        }

        function submitAssignment(documentId, $files, $invalidFiles) {
            preprocessFile($files, $invalidFiles).then(function (formData) {
                vm.isLoading = true;
                DocumentService.operator.uploadFile(formData, vm.fileName)
                  .then(function (responseData) {
                      AssignmentsService.getSubmitForm(documentId).then(function (submitFormResponse) {
                          vm.assignmentSubmitForm = submitFormResponse.data;
                          vm.uploadObj = responseData.data;
                          vm.assignmentSubmitForm.fileId = vm.uploadObj.fileId;
                          vm.isLoading = false;
                          vm.uploadIsActive = true;
                          vm.files = null;
                          vm.formdata = new FormData();
                      });

                }).catch(function (response) {
                    vm.isLoading = false;
                    PlagiatValidationService.getModalError(response.data);
                });
            })
        }

        function preprocessFile($files, $invalidFiles) {
            if ($files === null) {
                vm.files = null;
                return Promise.reject();
            } else {
                if ($invalidFiles.length === 0) {
                    var formData = new FormData();
                    vm.files = $files;
                    var i = 0;
                    angular.forEach(vm.files, function (value, key) {
                        vm.fileName = Utils.removeSpecialCharsForFileName(value.name);
                        formData.append(key, value);
                        i++;
                    });
                    if (i > 0) {
                        return Promise.resolve(formData);
                    }
                    return Promise.reject();
                }
            }
        }

        function uploadFile(obj, name) {
            vm.isLoading = true;
            vm.assignmentSubmitForm = null;
            vm.upfileFn = vm.isIndividual ? DocumentService.uploadFile(obj, name) : DocumentService.operator.uploadFile(obj, name);
            vm.upfileFn.then(function (responseData) {
                getUploadFormConfiguration(responseData.data).then(function(response){
                    vm.isLoading = false;
                    vm.uploadIsActive = true;
                    vm.uploadObj = response;
                    vm.files = null;
                    vm.formdata = new FormData();
                    shouldShowSynchronizationValidationWindow();
                });
            }).catch(function (response) {
                vm.isLoading = false;
                PlagiatValidationService.getModalError(response.data);
            });
        }

        function documentsSimpleSearch(documentsSearchRequest){
            vm.showDetailsBlock = false;
            vm.documentsSearchRequest = documentsSearchRequest;
            vm.searchRequest.pageNumber = (vm.queryRequest.page - 1);
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.sortTab = sort();
            vm.searchRequest.showOnlyForUser = documentsSearchRequest.showOnlyForUser;
            vm.searchRequest.search = documentsSearchRequest.simpleSearch;

            if( DocumentService.searchUser){
                vm.searchRequest.showOnlyForUser = false;
                vm.searchRequest.search.showOnlyForUser = false;
                vm.searchRequest.search.searchUser = DocumentService.searchUser.id;
                ScrollService.scrollTo('table-anchor');
            }

            vm.isLoaderActive = true;

            DocumentService.simpleSearch(vm.searchRequest, onSuccess, onError).then(function (responseData) {
                var responseObj = responseData.content;
                angular.forEach(responseObj, function (value) {
                    value.docuSubmitDateTimestamp = value.docuSubmitDate;
                    value.docuSubmitDate = moment(value.docuSubmitDate).format('LL LT');
                });
                vm.documents = responseObj;
                vm.totalDocuments = responseData.totalElements;

                vm.isLoaderActive = false;
                DocumentService.searchUser = null;
            });
        }

        function getDocuments(documentsSearchRequest) {
            vm.showDetailsBlock = false;
            vm.documentsSearchRequest = documentsSearchRequest;
            vm.searchRequest.pageNumber = (vm.queryRequest.page - 1);
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.sortTab = sort();
            vm.searchRequest.showOnlyForUser = documentsSearchRequest.showOnlyForUser;
            vm.searchRequest.search = documentsSearchRequest;

            if (DocumentService.searchUser) {
                vm.searchRequest.showOnlyForUser = false;
                vm.searchRequest.search.showOnlyForUser = false;
                vm.searchRequest.search.searchUser = DocumentService.searchUser.id;
                ScrollService.scrollTo('table-anchor');
            }

            vm.isLoaderActive = true;

            DocumentService.get(vm.searchRequest, onSuccess, onError).then(function (responseData) {
                var responseObj = responseData.content;
                angular.forEach(responseObj, function (value) {
                    value.docuSubmitDateTimestamp = value.docuSubmitDate;
                    value.docuSubmitDate = moment(value.docuSubmitDate).format('LL LT');
                });
                vm.documents = responseObj;
                vm.totalDocuments = responseData.totalElements;

                vm.isLoaderActive = false;
                DocumentService.searchUser = null;
                
                checkIfNeedToRefreshProcessingDocuments();
            });
        }

        function goTo() {
            getDocuments();
        }

        function startPaging(page) {
            resetSelection();
        	vm.isLoaderActive = true;
            vm.queryRequest.page = page;
            vm.documentsSearchRequest.simpleSearch.length > 0 ? documentsSimpleSearch(vm.documentsSearchRequest) : getDocuments(vm.documentsSearchRequest);
        }

        function changeLimit(n) {
            vm.queryRequest.limit = n;
            getDocuments();
        }

        function onSuccess(data, headers) {
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.searchRequestCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.documents = data;
        }

        function onError(error) {
            $mdDialog.show(
                $mdDialog.confirm()
                .clickOutsideToClose(true)
                .title($translate.instant("global.messages.error.label"))
                .textContent($translate.instant("global.messages.error.label"))
                .ariaLabel('ok')
                .ok('OK')
                );
        }

        function sort() {
            var reverse = vm.queryRequest.order.slice(0, 1);
            var _length = vm.queryRequest.order.length;
            var predicate;
            if (reverse === '-') {
                predicate = vm.queryRequest.order.slice(1, _length);
                reverse = false;
            } else {
                predicate = vm.queryRequest.order;
                reverse = true;
            }
            var result = [predicate + ',' + (reverse ? 'asc' : 'desc')];
            //zakomentowane, w przypadku superadmina dodatkowe sortowanie bardzo spowalnia zapytanie o dokumenty
//            if (predicate !== 'id') {
//                result.push('id');
//            }
            return result;
        }

        function generateReportXls(){
        	prepareMassActions().then(function(response){
        		DocumentReportXlsService.generateReportXls(response, vm.selected, vm.searchRequest);
        	});
        }

        (function () {
            setRoles();
            getAvailableExtensions();
            afterUploadLandingPage();
            prepareDocuStatuses();
            prepareSearchRequest();
        })();

        function showEditForm() {
            $mdDialog.show({
                templateUrl: 'app/components/document/document-form.tmpl.html',
                clickOutsideToClose: false
            });
        }

        function findAllProtocolForDocuments() {
            ProtocolForDocumentService
                .getAllForCurrentClient()
                .then(function (responseData) {
                    vm.protocolForDocuments = responseData;
                });
        }

        //visibilities
        function isCoordinatorVisible() {
            return !vm.isIndividual && !vm.clientTypePublishingHouse && !vm.isSuperAdmin;
        }
        function isUploadTextVisible() {
            return !vm.isSuperAdmin && !vm.isReseller && !vm.isMinistry && Principal.hasNotAuthority('PERM_USER_DO_NOT_USE_COPY_PASTE') && !(vm.isStudent && vm.clientSettings.noDocumentUploadForStudents);
        }

        function isUploadFileVisible() {
            return !vm.isSuperAdmin && !vm.isReseller && !vm.isMinistry && !(vm.isStudent && vm.clientSettings.noDocumentUploadForStudents);
        }

        function isStudent() {
            return vm.isStudent;
        }

        function populateAiDetection() {
            if (vm.uploadObj.aiDetectionInfo) {
                const info = vm.uploadObj.aiDetectionInfo;
                if (info.isPresent) {
                    if ('defaultDisabled' === info.defaultValue) {
                        vm.uploadObj.aiDetection = false;
                    }
                    if (('defaultEnabled' === info.defaultValue) || ('alwaysEnabled' === info.defaultValue)) {
                        vm.uploadObj.aiDetection = true;
                    }
                }
            }
        }

        function populateGrammarCheck() {
            if (vm.uploadObj.grammarCheckInfo) {
                const info = vm.uploadObj.grammarCheckInfo;
                if (info.isPresent) {
                    if ('defaultDisabled' === info.defaultValue) {
                        vm.uploadObj.grammarCheck = false;
                    }
                    if (('defaultEnabled' === info.defaultValue) || ('alwaysEnabled' === info.defaultValue)) {
                        vm.uploadObj.grammarCheck = true;
                    }
                }
            }
        }

        function populateAuthor() {
            if (!isStudent())
                return;

            vm.uploadObj.authors = {};
            vm.uploadObj.authors.idx0 = {};
            if (vm.authorsSimplifiedFields) {
                vm.uploadObj.authors.idx0.firstName = vm.uploadObj.authorFirstName + ' ' + vm.uploadObj.authorLastName;
            } else {
                vm.uploadObj.authors.idx0.firstName = vm.uploadObj.authorFirstName;
                vm.uploadObj.authors.idx0.lastName = vm.uploadObj.authorLastName;
            }
        }

        function convertToDate(date){
            return new Date(date);
        }

        function assignmentAfterDueDate(document){
            return document.assignmentEndDate && (document.docuSubmitDateTimestamp > document.assignmentEndDate);
        }

        function userDatabaseAddingEnabled() {
            return AccountService.getClientSettings().addingToDatabase === 'automatically'
                || AccountService.getClientSettings().addingToDatabase === 'delayed'
                || AccountService.getClientSettings().addingToDatabase === 'manually';
        }

        function getDocumentStatusTooltipKey(document) {
            if (document.docuStatus === DOCUMENT_STATUS.MARKED_FOR_DATABASE.id) {
                if (document.orppdStatus === ORPPD_STATUS.SENT.id) {
                    return 'document.table.statuses.picked.orppd-sent';
                }
                if (!vm.report2020Disabled) {
                    return 'document.table.statuses.picked.report-accepted';
                }
                return 'document.table.statuses.picked';
            }
            if (document.docuStatus === DOCUMENT_STATUS.ADDED_TO_DATABASE.id) {
                if (document.orppdStatus === ORPPD_STATUS.SENT.id) {
                    return 'document.table.statuses.added.orppd-sent';
                }
                if (!vm.report2020Disabled) {
                    return 'document.table.statuses.added.report-accepted';
                }
                return 'document.table.statuses.added';
            }
            return '';
        }

        function checkIfNeedToRefreshProcessingDocuments() {
            if (vm.isSuperAdmin || vm.isReseller) {
                return; // nie robimy tego dla superadmina i resellera
            }
            vm.documentsToRefresh = [];
            cancelDocumentsToRefreshInterval();
            angular.forEach(vm.documents, function (doc) {
                if (doc.docuStatus == 0) {
                    vm.documentsToRefresh.push(doc.documentId);
                }
            });
            if (vm.documentsToRefresh.length > 0) {
                vm.documentsToRefreshPromise = $interval(doRefreshProcessingDocuments, 60000);
            }
        }
        
        function doRefreshProcessingDocuments() {
            DocumentService.checkDocumentStatuses(vm.documentsToRefresh).then(function (responseData) {
                vm.newStatuses = responseData.data;
                if (!angular.equals(vm.newStatuses, {})) {
                    cancelDocumentsToRefreshInterval();
                    reloadDocuments();
                }
            }, function () {
                cancelDocumentsToRefreshInterval();
            });
        }
        
        function cancelDocumentsToRefreshInterval() {
            $interval.cancel(vm.documentsToRefreshPromise);
        }
        
        function DialogController($scope, $mdDialog, items) {
            $scope.items = items;
        }
        
        function selfEnrollment() {
            $mdDialog.show({
                clickOutsideToClose: true,
                templateUrl: 'app/account/documents/self-enrollment/self-enrollment.template.html',
                controller: SelfEnrollmentController,
                multiple:true,
                controllerAs: 'vm',
                locals: {
                    items: {
                        onJoin: vm.reloadDocuments
                    }
                }
            });
            
        }


    }

})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('confirm-email', {
            parent: 'account',
            url: '/confirm-email?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/confirm-email/confirm-email.html',
                    controller: 'ConfirmEmailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('confirm');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ConfirmEmailController', ConfirmEmailController);

    ConfirmEmailController.$inject = ['$stateParams', 'UserService', 'Auth', 'Principal'];

    function ConfirmEmailController ($stateParams, UserService, Auth, Principal) {
        var vm = this;
        vm.key = $stateParams.key;
        
        if(Principal.isAuthenticated()){
        	Auth.logout();
        }
        
        function confirmEmail(key){
        	UserService.confirmEmail({key: key}).then(function () {
                vm.error = null;
                vm.success = 'OK';
            }).catch(function () {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
        
        confirmEmail(vm.key);
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('confirm-account-deletion', {
            parent: 'account',
            data: {
                authorities: ['open']
            },
            url: '/delete-account/confirm?key',
            views: {
                'content@': {
                    templateUrl: 'app/account/confirm-account-deletion/confirm-account-deletion.html',
                    controller: 'AccountDeletionConfirmationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('delete-account');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .controller('AccountDeletionConfirmationController', AccountDeletionConfirmationController);

    AccountDeletionConfirmationController.$inject = ['$stateParams', 'Auth', 'Principal', 'AccountService', 'ModalService'];

    function AccountDeletionConfirmationController($stateParams, Auth, Principal, AccountService, ModalService) {
        var vm = this;
        vm.key = $stateParams.key;
        vm.removalComplete = false;
        if (Principal.isAuthenticated()) {
            Auth.logout();
        }
        AccountService.confirmAccountDeletion(vm.key).then(
            function () {
                vm.removalComplete = true;
            }, function (errorResponse) {
                ModalService.showErrorModal(errorResponse);
            }
        )
    }
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('comparision', {
            parent: 'app',
            url: '/comparision',
            data: {
                authorities: ['PERM_USER_ADMIN', 'PERM_USER_ORG_UNIT_ADMIN', 'PERM_USER_SUPERADMIN', 'PERM_USER_OPERATOR'],
                pageTitle: 'global.menu.account.comparision'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/comparision/comparision.html',
                    controller: 'ComparisionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                }
            },
            resolve: {
                translatePartialLoader: ['$translate',
                    '$translatePartialLoader',
                    function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('comparision');
                        $translatePartialLoader.addPart('document');
                        return $translate.refresh();
                    }]
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('ComparisionService', ComparisionService);

    ComparisionService.$inject = ['$http', 'FileSaver', 'PlagiatValidationService', '$mdDialog', '$translate', 'DateUtils', '$q'];

    function ComparisionService($http, FileSaver, PlagiatValidationService, $mdDialog, $translate, DateUtils, $q) {

        var service = {
            downloadComparisionReport: downloadComparisionReport,
            convertFile: convertFile
        };
        var requestUrl = 'api/comparision';
        return service;

        function downloadComparisionReport(obj, fileName) {
            var url = requestUrl + '/pdf';

            return $http({
                url : url,
                method: "POST",
                data: obj,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).then(
                function(success) {
                    onSuccess(success, fileName, '.pdf');
                },
                function(error) {
                    PlagiatValidationService.getModalError(error);
                }
            );
        }

        function onSuccess(success, fileName, reportExtension) {

            $mdDialog.hide();
            var blob = new Blob(
                [ success.data ],
                {
                    type: "text/pdf; encoding=UTF-8"
                }
            );
            saveAs(blob, fileName + reportExtension);
        }

        function convertFile(obj) {
            var request = {
                method: 'POST',
                url: requestUrl + '/convert-file-to-text',
                data: obj,
                headers: {
                    'Content-Type': undefined,
                    'Charset': 'UTF-8'
                },
                responseType: 'text'
            };
            return $http(request).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ComparisionController', ComparisionController);

    ComparisionController.$inject = ['ComparisionService', 'ModalService', '$mdDialog'];

    function ComparisionController(ComparisionService, ModalService, $mdDialog) {
        var vm = this;
        vm.obj = {};
        vm.pending = false;
        vm.filesBase = [];
        vm.filesCompared = [];
        vm.filesBaseError = false;
        vm.filesComparedError = false;
        var formData = new FormData();
        vm.getBaseFiles = getBaseFiles;
        vm.getComparedFiles = getComparedFiles;

        vm.downloadComparisionReport = function () {
            vm.pending = true;
            ModalService.showPleaseWaitDialog(false);
            ComparisionService.downloadComparisionReport(vm.obj, 'report').then(
                function () {
                    vm.pending = false;
                }, function () {
                    $mdDialog.hide();
                    vm.pending = false;
                });
        }

        function getBaseFiles($files, $invalidFiles) {
            formData = new FormData();
            vm.filesBaseError = false;
            if ($files.length === 0) {
                vm.filesBase = null;
                return;
            }
            if ($invalidFiles.length === 0) {
                vm.filesBase = $files;
                angular.forEach(vm.filesBase, function (value, key) {
                    vm.fileName = value.name;
                    formData.append(key, value);
                });
                ComparisionService.convertFile(formData).then(function (response) {
                    vm.obj.title1 = vm.filesBase[0].name;
                    vm.obj.content1 = response.data;
                }, function () {
                    vm.filesBaseError = true;
                });
            } else {
                vm.filesBaseError = true;
            }
        }

        function getComparedFiles($files, $invalidFiles) {
            formData = new FormData();
            vm.filesComparedError = false;
            if ($files.length === 0) {
                vm.filesCompared = null;
                return;
            }
            if ($invalidFiles.length === 0) {
                vm.filesCompared = $files;
                angular.forEach(vm.filesCompared, function (value, key) {
                    vm.fileName = value.name;
                    formData.append(key, value);
                });
                ComparisionService.convertFile(formData).then(function (response) {
                    vm.obj.title2 = vm.filesCompared[0].name;
                    vm.obj.content2 = response.data;
                }, function () {
                    vm.filesComparedError = true;
                });
            } else {
                vm.filesComparedError = true;
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('PeerReviewScoringController', PeerReviewScoringController);
    
    PeerReviewScoringController.$inject = ['PeerReviewService', 'PeerReviewFeedbackService', '$state', '$stateParams'];

    function PeerReviewScoringController(PeerReviewService, PeerReviewFeedbackService, $state, $stateParams) {

        const vm = this;
        vm.loadingValues = true;
        vm.pending = false;
        vm.obj = {};
        vm.expandedReviewers = {};
        vm.editScoreMode = {};

        this.$onInit = function () {
            if ($stateParams.id) {
                PeerReviewService.findOne($stateParams.id).then(function (obj) {
                    vm.obj = obj.data;
                    vm.loadingValues = false;
                });
            }
        };
        vm.expandReviews = function(reviewerId) {
            vm.expandedReviewers[reviewerId] = !vm.expandedReviewers[reviewerId];
        };

        vm.editScores = function(reviewerId) {
            vm.editScoreMode[reviewerId] = !vm.editScoreMode[reviewerId];
        };

        vm.cancelEditScores = function(reviewerId) {
            vm.editScoreMode[reviewerId] = !vm.editScoreMode[reviewerId];
        };

        vm.saveScores = function(reviewer) {
            PeerReviewFeedbackService.saveGrades(reviewer).then(function () {
                vm.editScoreMode[reviewer.id] = !vm.editScoreMode[reviewer.id];
            })
        };

        vm.onChangeScore = function (reviewer) {
            reviewer.sumScore = calcSumScores(reviewer);
            reviewer.averageScore = Math.round(reviewer.sumScore / reviewer.feedbacks.length);
            reviewer.scorePercentage = Math.round(((reviewer.sumScore / reviewer.feedbacks.length) / reviewer.maxScore) * 100);
        }

        var calcSumScores = function (reviewer) {
            var sum = 0;
            for (var i = 0; i < reviewer.feedbacks.length; i++) {
                if (reviewer.feedbacks[i].score) {
                    sum += reviewer.feedbacks[i].score;
                }
            }
            return sum;
        };

        vm.readReview = function(feedbackId) {
            $state.go('view-feedback', {id: feedbackId});
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('plagiat2017App')
    .factory('PeerReviewLibraryService', PeerReviewLibraryService);

  PeerReviewLibraryService.$inject = ['$http', '$q'];

  function PeerReviewLibraryService($http, $q) {

    var requestUrl = 'api/peer/libraries';

    var service = {
      create: create,
      update: update,
      delete: deleteLibrary,
      deleteLibraryQuestion: deleteLibraryQuestion,
      loadAll: loadAll,
      addQuestions: addQuestions,
      loadAllWithQuestions: loadAllWithQuestions,
    };
    return service;

    function addQuestions(obj) {
      return $http.post(requestUrl + '/add-questions', obj).then(
        function (response) {
          return response.data;
        },
        function (errResponse) {
          return $q.reject(errResponse);
        });
    }

    function loadAllWithQuestions() {
      return $http.get(requestUrl + '/with-questions').then(
        function (response) {
          return response.data;
        },
        function (errResponse) {
          return $q.reject(errResponse);
        });
    }

    function loadAll() {
      return $http.get(requestUrl).then(
        function (response) {
          return response.data;
        },
        function (errResponse) {
          return $q.reject(errResponse);
        });
    }

    function create(obj) {
      return $http.post(requestUrl, obj).then(
        function (response) {
          return response.data;
        },
        function (errResponse) {
          return $q.reject(errResponse);
        });
    }

    function update(obj) {
      return $http.put(requestUrl, obj).then(
        function () {
        },
        function (errResponse) {
          return $q.reject(errResponse);
        });
    }

    function deleteLibrary(id) {
      return $http.delete(requestUrl + '/' + id).then(
        function () {
        },
        function (errResponse) {
          return $q.reject(errResponse);
        });
    }

    function deleteLibraryQuestion(id) {
      return $http.delete(requestUrl + '/questions/' + id).then(
        function () {
        },
        function (errResponse) {
          return $q.reject(errResponse);
        });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('plagiat2017App')
    .config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider
      .state("peer-review-scoring", {
        parent: 'app',
        url: "/peer-review/:id/scoring",
        data: {
          pageTitle: "peer-review.scoring.title"
        },
        views: {
          'content@': {
            templateUrl: 'app/account/assignments/peer-review/scoring.component.html',
            controller: 'PeerReviewScoringController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
            $translatePartialLoader.addPart('peer-review');
            $translatePartialLoader.addPart('feedback');
            return $translate.refresh();
          }]
        }
      })
  }

})();

(function () {
  'use strict';

  angular
    .module('plagiat2017App')
    .factory('PeerReviewService', PeerReviewService);

  PeerReviewService.$inject = ['$http', '$q'];

  function PeerReviewService($http, $q) {

    var requestUrl = 'api/peer-review';

    var service = {
      getList: getList,
      findOne: findOne,
    };
    return service;

    function getList(pageableFilter) {
      return $http.post(requestUrl, pageableFilter).then(
        function (response) {
          return response.data;
        },
        function (errResponse) {
          return $q.reject(errResponse);
        });
    }

    function findOne(id) {
      return $http.get(requestUrl + '/' + id).then(
        function (response) {
          return response.data;
        },
        function (errResponse) {
          return $q.reject(errResponse);
        });
    }

  }
})();

angular.module('plagiat2017App')
    .component('addReviewerManuallyModal', {
        templateUrl: 'app/account/assignments/peer-review/manual-assigment/add-reviewer.controller.html',
        controller: AddReviewerManuallyController,
        controllerAs: 'vm'
    });

AddReviewerManuallyController.$inject = ['$mdDialog', 'items'];

function AddReviewerManuallyController($mdDialog, items) {
    var vm = this;

    vm.docOwnerEmail = items.email;
    vm.docOwnerFullName = items.fullName;
    vm.reviewers = items.reviewers;
    vm.manuallyAssigned = items.manuallyAssigned;
    vm.max = items.max;
    vm.disabled = items.disabled;
    vm.checked = {};

    this.$onInit = function () {
        for (var i = 0; i < vm.manuallyAssigned.length; i++) {
            const assign = vm.manuallyAssigned[i];
            for (var j = 0; j < vm.reviewers.length; j++) {
                if (vm.reviewers[j].email === assign.email) {
                    vm.checked[j] = true;
                    break;
                }
            }
        }
    };

    vm.getSelected = function() {
        const selected = [];
        for (var i = 0; i < vm.reviewers.length; i++) {
            if (vm.checked[i]) {
                selected.push(vm.reviewers[i]);
            }
        }
        return selected;
    };

    vm.confirm = function() {
        $mdDialog.hide(vm.getSelected());
    }

    vm.cancel = function() {
        return $mdDialog.hide();
    }

}

angular.module('plagiat2017App')
  .component('selfEnrollmentModal', {
    templateUrl: 'app/account/assignments/peer-review/library/create-library.template.html',
    controller: CreateLibraryController,
    controllerAs: 'vm'
  });

CreateLibraryController.$inject = ['ModalService', 'PeerReviewLibraryService', '$mdDialog'];

function CreateLibraryController(ModalService, PeerReviewLibraryService, $mdDialog) {
  var vm = this;

  vm.cancel = cancel;

  vm.isLoading = false;
  vm.newLibraryName = '';

  vm.addNewLibrary = function() {
    vm.isLoading = true;
    PeerReviewLibraryService.create({name: vm.newLibraryName}).then(function(response) {
      vm.isLoading = false;
      $mdDialog.hide(response.data);
    }, function (errorResponse) {
      vm.isLoading = false;
      ModalService.showErrorModal(errorResponse);
    })
  }

  function cancel() {
    return $mdDialog.hide();
  }

}

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ViewFeedbackController', ViewFeedbackController);
    
    ViewFeedbackController.$inject = ['PeerReviewFeedbackService', 'AccountService', '$stateParams', '$scope', '$window'];

    function ViewFeedbackController(PeerReviewFeedbackService, AccountService, $stateParams, $scope, $window) {

        const vm = this;
        vm.loadingValues = true;
        vm.pending = false;
        vm.isAdmin = false;
        vm.isLecturer = false;

        vm.obj = {};

        this.$onInit = function () {
            if ($stateParams.id) {
                PeerReviewFeedbackService.findOne($stateParams.id).then(function (obj) {
                    vm.obj = obj.data;
                    vm.loadingValues = false;
                });
            }
            vm.isAdmin = AccountService.role.isAdmin();
            vm.isLecturer = AccountService.role.isLecturer();
        };

        $scope.generateRange = function(start, end) {
            var arr = [];
            for (var i = start; i <= end; i++) {
                arr.push(i);
            }
            return arr;
        };

        $scope.goBack = function () {
            $window.history.back();
        }

        $scope.saveGrade = function () {
            PeerReviewFeedbackService.saveGrade(vm.obj).then(function (obj) {
                $window.history.back();
            })
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('plagiat2017App')
    .config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider
      .state('feedbacks', {
        parent: 'app',
        url: '/feedbacks',
        data: {
          pageTitle: 'global.menu.account.feedbacks'
        },
        views: {
          'content@': {
            templateUrl: 'app/account/assignments/peer-review/feedback/feedback-list.html',
            controller: 'FeedbackListController',
            controllerAs: 'vm'
          }
        },
        params: {
          page: {
            value: '0',
            squash: true
          },
          sort: {
            value: 'id,desc',
            squash: true
          }
        },
        resolve: {
          pagingParams: ['$stateParams', 'PaginationUtil',
            function ($stateParams, PaginationUtil) {
              return {
                page: PaginationUtil.parsePage($stateParams.page),
                sort: $stateParams.sort,
                predicate: PaginationUtil.parsePredicate(
                  $stateParams.sort),
                ascending: PaginationUtil.parseAscending(
                  $stateParams.sort)
              };
            }],
          translatePartialLoader: ['$translate',
            '$translatePartialLoader',
            function ($translate, $translatePartialLoader) {
              $translatePartialLoader.addPart('feedback');
              $translatePartialLoader.addPart('assignment');
              $translatePartialLoader.addPart('document');
              $translatePartialLoader.addPart('peer-review');
              return $translate.refresh();
            }]
        }
      })
      .state("add-feedback", {
        parent: "feedbacks",
        url: "/:id",
        data: {
          pageTitle: "feedback.review.title"
        },
        views: {
          'content@': {
            templateUrl: 'app/account/assignments/peer-review/feedback/add-feedback.html',
            controller: 'AddFeedbackController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
            $translatePartialLoader.addPart('peer-review');
            $translatePartialLoader.addPart('assignment');
            $translatePartialLoader.addPart('global');
            return $translate.refresh();
          }]
        }
      }).state("view-feedback", {
        parent: "feedbacks",
        url: "/:id/view",
        data: {
          pageTitle: "feedback.view.title"
        },
        views: {
          'content@': {
            templateUrl: 'app/account/assignments/peer-review/feedback/view-feedback.html',
            controller: 'ViewFeedbackController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
            $translatePartialLoader.addPart('assignment');
            $translatePartialLoader.addPart('global');
            return $translate.refresh();
          }]
        }
      });
  }

})();

(function () {
    'use strict';
    
    angular.module('plagiat2017App')
        .factory('FeedbackRequest', function () {
    
            function FeedbackRequest() {
                this.pageNumber = 0;
                this.pageSize = 5;
                this.sortTab = [];
                this.simpleSearch = '';
                this.search = {};
            }
    
            return FeedbackRequest;
        });
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .controller('FeedbackListController', FeedbackListController);

    FeedbackListController.$inject = [
        '$rootScope', '$scope', '$stateParams', '$translate', '$state', 'SIMPLE_SEARCH_DELAY',
        'FeedbackRequest', 'QueryRequest', 'AccountService', 'DocumentService', 'ModalService',
        'DocumentSearchRequestModel', 'SearchService', 'PlagiatValidationService',
        'PeerReviewService', 'PeerReviewFeedbackService'
    ];

    function FeedbackListController(
        $rootScope, $scope, $stateParams, $translate, $state, SIMPLE_SEARCH_DELAY,
        FeedbackRequest, QueryRequest, AccountService, DocumentService, ModalService,
        DocumentSearchRequestModel, SearchService, PlagiatValidationService,
        PeerReviewService, PeerReviewFeedbackService
    ) {
        var vm = this;
        var feedbacks = [];
        var pending = true;
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.getPeerReviews = getPeerReviews;
        vm.getPeerReviewsPage = getPeerReviewsPage;
        vm.submitReview = submitReview;
        vm.clear = clear;
        vm.toggleSearch = toggleSearch;
        
        vm.searchRequest = new FeedbackRequest();
        vm.queryRequest = new QueryRequest();
        vm.queryRequest.limit = 10;
        vm.queryRequest.order = '-id';
        vm.simpleSearch = true;
        vm.statuses = [
            {id: 0, translateKey: 'peer-review.status.in-progress'},
            {id: 1, translateKey: 'peer-review.status.filled'}
        ];
        vm.isAdmin = AccountService.role.isAdmin();
        vm.peerReviews = [];
        vm.expandedFeedbacksToReview = {};
        vm.expandedReceivedReviews = {};
        vm.expandedSelfSelectReviews = {};

        vm.getPeerReviews();

        function getPeerReviews() {
            vm.pending = true;
            vm.searchRequest.pageNumber = vm.queryRequest.page - 1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.sortTab = SearchService.sort(vm.queryRequest);
            
            PeerReviewService.getList(vm.searchRequest).then(
                function (response) {
                    vm.pending = false;
                    vm.peerReviews = response.content;
                    // vm.totalFeedbacks = response.totalElements;
                }, function (error) {
                  vm.pending = false;
                  PlagiatValidationService.getModalError(error.data);
                }
            );
        }
        
        function getPeerReviewsPage(page) {
            vm.queryRequest.page = page;
            vm.getPeerReviews();
        }
        
        function toggleSearch() {
            vm.searchRequest.simpleSearch = '';
            vm.searchRequest.search = {};
            vm.simpleSearch = !vm.simpleSearch;
        }

        function clear() {
            vm.searchRequest.simpleSearch = '';
            vm.searchRequest.search = {};
            getPeerReviews();
        }

        function submitReview(row) {
            $state.go('add-feedback', {id: row.id});
        }

        $scope.readReview = function(row) {
            $state.go('view-feedback', {id: row.id});
        };

        $scope.onClickExpandFeedbacksToReview = function(peerReviewId) {
            vm.expandedReceivedReviews[peerReviewId] = false;
            vm.expandedSelfSelectReviews[peerReviewId] = false;
            vm.expandedFeedbacksToReview[peerReviewId] = !vm.expandedFeedbacksToReview[peerReviewId];
        }

        $scope.onClickExpandReceivedReviews = function(peerReviewId) {
            vm.expandedFeedbacksToReview[peerReviewId] = false;
            vm.expandedSelfSelectReviews[peerReviewId] = false;
            vm.expandedReceivedReviews[peerReviewId] = !vm.expandedReceivedReviews[peerReviewId];
        }

        $scope.onClickSelfSelect = function(peerReviewId) {
            vm.expandedReceivedReviews[peerReviewId] = false;
            vm.expandedFeedbacksToReview[peerReviewId] = false;
            vm.expandedSelfSelectReviews[peerReviewId] = !vm.expandedSelfSelectReviews[peerReviewId];
        }

        $scope.onClickSelfSelectReview = function (feedback) {
            ModalService.showConfirmModal('peer-review.feedbacks.self-select').then(function () {
                vm.pending = true;
                PeerReviewFeedbackService.createBySelfSelect(feedback).then(
                    function (response) {
                        vm.pending = false;
                        $state.go('add-feedback', {id: response.data.id});
                    }, function (error) {
                        vm.pending = false;
                        PlagiatValidationService.getModalError(error.data);
                    }
                );
            });
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('plagiat2017App')
    .factory('PeerReviewFeedbackService', PeerReviewFeedbackService);

  PeerReviewFeedbackService.$inject = ['$http', '$q'];

  function PeerReviewFeedbackService($http, $q) {

    var requestUrl = 'api/feedbacks';

    var service = {
      getList: getList,
      findOne: findOne,
      update: update,
      submit: submit,
      saveGrade: saveGrade,
      saveGrades: saveGrades,
      createBySelfSelect: createBySelfSelect,
    };
    return service;

    function getList(pageableFilter) {
      return $http.post(requestUrl + '/list', pageableFilter).then(
        function (response) {
          return response.data;
        },
        function (errResponse) {
          return $q.reject(errResponse);
        });
    }

    function findOne(id) {
      return $http.get(requestUrl + '/' + id).then(
        function (response) {
          return response.data;
        },
        function (errResponse) {
          return $q.reject(errResponse);
        });
    }

    function update(obj) {
      return $http.put(requestUrl, obj).then(
        function () {},
        function (errResponse) {
          return $q.reject(errResponse);
        });
    }

    function submit(obj) {
      return $http.put(requestUrl + '/submit', obj).then(
        function () {},
        function (errResponse) {
          return $q.reject(errResponse);
        });
    }

    function saveGrade(obj) {
      return $http.put(requestUrl + '/grade', obj).then(
        function () {},
        function (errResponse) {
          return $q.reject(errResponse);
        });
    }

    function saveGrades(reviewer) {
      return $http.put(requestUrl + '/grades', reviewer).then(
        function () {},
        function (errResponse) {
          return $q.reject(errResponse);
        });
    }

    function createBySelfSelect(feedback) {
      return $http.post(requestUrl + '/self-select', feedback).then(
        function (response) {
          return response.data;
        },
        function (errResponse) {
          return $q.reject(errResponse);
        });
    }

  }
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('AddFeedbackController', AddFeedbackController);
    
    AddFeedbackController.$inject = ['PeerReviewFeedbackService', 'ModalService', 'AccountService', 'UserService', 'Utils',
        '$localStorage', '$state', '$stateParams', '$mdDialog', '$scope'];

    function AddFeedbackController(PeerReviewFeedbackService, ModalService, AccountService, UserService, Utils,
                                   $localStorage, $state, $stateParams, $mdDialog, $scope) {

        const vm = this;
        vm.loadingValues = true;
        vm.pending = false;

        vm.obj = {};

        vm.save = save;
        vm.submit = submit;
        vm.validateWordCount = validateWordCount;

        this.$onInit = function () {
            if ($stateParams.id) {
                PeerReviewFeedbackService.findOne($stateParams.id).then(function (obj) {
                    vm.obj = obj.data;
                    vm.loadingValues = false;
                    validateAllAnswers();
                });
            }
        };
        function validateAllAnswers() {
            vm.obj.answers.forEach(function(answer, index) {
                if (answer.questionType === 'text') {
                    validateWordCount(answer, index);
                }
            });
        }

        function validateWordCount(answer, index) {
            answer.currentWordCount = answer.contentText ? answer.contentText.trim().split(/\s+/).length : 0;
            const valid = answer.currentWordCount >= answer.questionTextMinWords;
            if ($scope.form1 && $scope.form1['answer' + index]) {
                const field = $scope.form1['answer' + index];
                field.$setValidity('textMinWords', valid);
                field.$setTouched();
                $scope.form1.$setValidity('textMinWords', valid);
            }
        }

        function save() {
            vm.pending = true;
            PeerReviewFeedbackService.update(vm.obj)
                .then(function () {
                    ModalService.showSuccessModal("global.messages.success.label");
                    $state.go('feedbacks');
                    $stateParams.id = null;
                }, function (errorResponse) {
                    ModalService.showErrorModal(errorResponse);
                    vm.pending = false;
                });
        }

        function submit(form){
            if (!Utils.validateForm(form)) {
                return;
            }
            vm.pending = true;
            PeerReviewFeedbackService.submit(vm.obj)
              .then(function () {
                  ModalService.showSuccessModal("global.messages.success.label");
                  $state.go('feedbacks');
                  $stateParams.id = null;
              }, function (errorResponse) {
                  ModalService.showErrorModal(errorResponse);
                  vm.pending = false;
              });
        }

        $scope.generateRange = function(start, end) {
            var arr = [];
            for (var i = start; i <= end; i++) {
                arr.push(i);
            }
            return arr;
        };
    }
})();

angular.module('plagiat2017App')
  .component('selfEnrollmentModal', {
    templateUrl: 'app/account/assignments/peer-review/add-to-library.template.html',
    controller: AddToLibraryController,
    controllerAs: 'vm'
  });

AddToLibraryController.$inject = ['ModalService', 'PeerReviewLibraryService', '$mdDialog', 'items'];

function AddToLibraryController(ModalService, PeerReviewLibraryService, $mdDialog, items) {
  var vm = this;

  vm.cancel = cancel;
  vm.addToLibrary = addToLibrary;
  vm.isLoading = false;
  vm.questions = [];
  vm.library = items.library;
  vm.checkedQuestions = {};

  this.$onInit = function () {
    vm.questions = items.questions;
    vm.selectAllQuestions();
  };

  vm.selectAllQuestions = function () {
    for (var i = 0; i < items.questions.length; i++) {
      vm.checkedQuestions[i] = true; // Pre-select the checkbox
    }
  };

  vm.deselectAllQuestions = function () {
    for (var i = 0; i < items.questions.length; i++) {
      vm.checkedQuestions[i] = false; // Pre-select the checkbox
    }
  };


  function addToLibrary(library) {
    vm.isLoading = true;
    const selectedQuestions = vm.getSelectedQuestions();
    PeerReviewLibraryService.addQuestions({id: library.id, name: library.name, questions: selectedQuestions}).then(function () {
      vm.isLoading = false;
      $mdDialog.hide(selectedQuestions);
    }, function (errorResponse) {
      vm.isLoading = false;
      ModalService.showErrorModal(errorResponse);
    });
  }

  vm.getSelectedQuestions = function() {
    var selectedQuestions = [];
    for (var i = 0; i < vm.questions.length; i++) {
      if (vm.checkedQuestions[i]) {
        selectedQuestions.push(vm.questions[i]);
      }
    }
    return selectedQuestions;
  };

  function cancel() {
    return $mdDialog.hide();
  }

}

angular.module('plagiat2017App')
.component('selfEnrollmentModal', {
    templateUrl: 'app/account/assignments/peer-review/add-question.template.html',
    controller: AddQuestionController,
    controllerAs: 'vm'
});

AddQuestionController.$inject = ['$mdDialog', 'items'];

function AddQuestionController($mdDialog, items) {
    var vm = this;

    vm.addQuestionOk = addQuestionOk;
    vm.cancel = cancel;
    
    vm.title = null;
    vm.type = 'TEXT';
    vm.isLoading = false;
    vm.editMode = false;

    this.$onInit = function () {
        vm.isLoading = true;
        vm.isLoading = false;
        vm.editMode = !!items.question;
        if (vm.editMode) {
            vm.title = items.question.title;
            vm.type = items.question.type;
            vm.textMinWords = items.question.textMinWords;
            vm.scaleSize = items.question.scaleSize;
            vm.scaleLowestValueName = items.question.scaleLowestValueName;
            vm.scaleHighestValueName = items.question.scaleHighestValueName;
        }
    };
    
    function addQuestionOk(form) {
        if (form.$invalid) {
            for (var i = 0; i < form.$$controls.length; i++) {
                form.$$controls[i].$touched = true;
            }
            return;
        }
        
        vm.isLoading = true;
        var question = items.question ? items.question : {};
        question.title = vm.title;
        question.type = vm.type;
        question.textMinWords = vm.textMinWords;
        question.scaleSize = vm.scaleSize;
        question.scaleLowestValueName = vm.scaleLowestValueName;
        question.scaleHighestValueName = vm.scaleHighestValueName;
        if (vm.editMode) {
            items.question = question;
            items.onEditQuestion(items.index, items.question);
        } else {
            items.onAddQuestion(question);
        }
        $mdDialog.hide();
    }

    function cancel() {
        return $mdDialog.hide();
    }

}

angular.module('plagiat2017App')
.component('selfEnrollmentModal', {
    templateUrl: 'app/account/assignments/peer-review/add-from-library.template.html',
    controller: AddFromLibraryController,
    controllerAs: 'vm'
});

AddFromLibraryController.$inject = ['ModalService', 'PeerReviewLibraryService', '$mdDialog', 'items'];

function AddFromLibraryController(ModalService, PeerReviewLibraryService, $mdDialog, items) {
    var vm = this;

    vm.cancel = cancel;
    vm.addSelectedQuestionsFromLibrary = addSelectedQuestionsFromLibrary;

    vm.library = items.library;
    vm.questions = [];
    vm.checkedQuestions = {};

    this.$onInit = function () {
        if (vm.library.questions) {
            vm.questions = vm.library.questions;
        }
        vm.selectAllQuestions();
    };

    function addSelectedQuestionsFromLibrary() {
        items.onAddFromLibrary(vm.getSelectedQuestions());
        cancel();
    }

    vm.deleteQuestion = function (index, questionId) {
        vm.isLoading = true;
        PeerReviewLibraryService.deleteLibraryQuestion(questionId).then(function () {
            vm.questions.splice(index, 1);
            vm.isLoading = false;
            vm.checkedQuestions.splice(index, 1);
        })
    }

    vm.selectAllQuestions = function () {
        for (var i = 0; i < vm.questions.length; i++) {
            vm.checkedQuestions[i] = true;
        }
    };

    vm.deselectAllQuestions = function () {
        for (var i = 0; i < vm.questions.length; i++) {
            vm.checkedQuestions[i] = false;
        }
    };

    vm.getSelectedQuestions = function() {
        var selectedQuestions = [];
        for (var i = 0; i < vm.questions.length; i++) {
            if (vm.checkedQuestions[i]) {
                selectedQuestions.push(vm.questions[i]);
            }
        }
        return selectedQuestions;
    };

    function cancel() {
        return $mdDialog.hide();
    }

}

(function () {
    'use strict';
    
    angular.module('plagiat2017App')
        .factory('AssignmentsRequest', function () {
    
            function AssignmentsRequest() {
                this.pageNumber = 0;
                this.pageSize = 5;
                this.sortTab = [];
                this.simpleSearch = '';
                this.search = {};
            }
    
            return AssignmentsRequest;
        });
})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('AssignmentsSubmitController', AssignmentsSubmitController);

    AssignmentsSubmitController.$inject = ['PlagiatValidationService', 'ModalService', 'DocumentService', 'AssignmentsService', 'LandingService', 'Utils',
                                           '$localStorage', '$state', '$stateParams', '$mdDialog', '$translate'];

    function AssignmentsSubmitController(PlagiatValidationService, ModalService, DocumentService, AssignmentsService, LandingService, Utils,
                                         $localStorage, $state, $stateParams, $mdDialog, $translate) {
        var vm = this;
        vm.submits = [];
        vm.pending = false;
        vm.activeTab = 'assignments';
        vm.getTheFiles = getTheFiles;
        vm.uploadFile = uploadFile;
        vm.backToList = backToList;
        vm.save = save;
        vm.remove = remove;
        vm.assignment = {};
        vm.errorFilenames = '';

        this.$onInit = function () {
            vm.pending = true;
            if ($stateParams.id) {
                AssignmentsService.getAssignmentForEditing($stateParams.id).then(function (obj) {
                    vm.assignment = obj.data;
                });
            } else {
                $state.go('assignments');
            }
            DocumentService.getDocumentAvailableExtension().then(function (result) {
                vm.availableExtension = '.zip,';

                if (result.data.length === 0) {
                    LandingService.getAvailableFileExtensions().then(function (extensions) {
                        vm.availableExtension += extensions.data;
                        vm.pending = false;
                    });
                } else {
                    angular.forEach(result.data, function (value) {
                        vm.availableExtension += '.' + value + ',';
                    });
                    vm.pending = false;
                }
            });
        }

        function getTheFiles($files, $invalidFiles) {
            preprocessFile($files, $invalidFiles).then(function (formData) {
                //TODO refactor
            }, function (error) {
                console.error('getTheFiles error ' + error);
            })
        }

        function preprocessFile($files, $invalidFiles) {
            if ($files === null) {
                vm.files = null;
                return Promise.reject();
            } else {
                if ($invalidFiles.length === 0) {
                    var i = 0;
                    var formData = null;
                    vm.files = $files;
                    angular.forEach(vm.files, function (value, key) {
                        formData = new FormData();
                        formData.append(key, value);
                        vm.fileName = Utils.removeSpecialCharsForFileName(value.name);
                        vm.uploadFile(formData, vm.fileName);
                        i++;
                    });
                    if (i > 0) {
                        return Promise.resolve(formData);
                    }
                    return Promise.reject();
                }
            }
        }

        function uploadFile(obj, name) {
            vm.pending = true;
            DocumentService.operator.uploadMultipleFiles(obj, name).then(function (responseData) {
                var arr = responseData.data;
                var errorFiles = false;
                angular.forEach(arr, function (d) {
                    if (!d.errorCode) {
                        vm.submits.push({
                            fileId: d.fileId,
                            filename: d.docuTitle,
                            size: d.size,
                            title: vm.assignment.title
                        });
                    } else {
                        errorFiles = true;
                        if (vm.errorFilenames.length == 0) {
                            vm.errorFilenames = d.docuTitle;
                        } else if (vm.errorFilenames.length < 200) {
                            vm.errorFilenames += '<br/>' + d.docuTitle;
                        } else if (!vm.errorFilenames.endsWith('(...)')) {
                            vm.errorFilenames += '<br/>(...)';
                        }
                    }
                });
                vm.pending = false;
                if (errorFiles) { //jesli byly jakies nieobslugiwane pliki, to poakzuje komunikat
                    $mdDialog.show(
                        $mdDialog.confirm()
                            .multiple(false)
                            .clickOutsideToClose(true)
                            .title($translate.instant('global.messages.warning.label'))
                            .htmlContent($translate.instant('global.messages.error.unexpected-zip-content') + '<br /><br />' + vm.errorFilenames)
                            .ariaLabel('ok')
                            .ok('OK')
                    ).then(function () {
                        vm.errorFilenames = '';
                    }, function () {
                        //do nothing
                    });
                }
            }).catch(function (response) {
                vm.pending = false;
                PlagiatValidationService.getModalError(response.data);
            });
        }

        function backToList() {
            $state.go('assignments');
        }
        
        function remove(sub) {
            var filteredAry = vm.submits.filter(function (e) {
                return e !== sub
            });
            vm.submits = filteredAry;
        }

        function save() {
            vm.pending = true;
            AssignmentsService.submitMultipleAssignments(vm.submits, vm.assignment.id).then(function (responseData) {
                ModalService.showSuccessModal("assignments.upload.success").then(function () {
                    $state.go('assignments');
                });
                
            }, function (errorResponse) {
                vm.pending = false;
                ModalService.showErrorModal(errorResponse);
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('AssignmentsAddController', AssignmentsAddController);

    AssignmentsAddController.$inject = ['AssignmentsService', 'ModalService', 'AccountService', 'UserService', 'Utils',
        'PeerReviewFeedbackService', 'PeerReviewLibraryService', '$localStorage', '$state', '$stateParams', '$mdDialog', '$scope'];

    function AssignmentsAddController(AssignmentsService, ModalService, AccountService, UserService, Utils,
                                      PeerReviewFeedbackService, PeerReviewLibraryService, $localStorage, $state, $stateParams, $mdDialog, $scope) {

        var vm = this;
        vm.pending = false;
        vm.editMode = false;
        vm.activeTab = 'assignments';

        vm.obj = {};
        vm.obj.emailAddresses = [];
        vm.obj.peerReview = {};
        vm.obj.peerReview.feedbackUploadedDocCount = 0;
        vm.obj.peerReview.questions = [];
        vm.docuKinds = [];
        vm.emailAddressesInvalid = null;
        vm.emailAddressesNotRegistered = null;
        vm.emailAddressesNotStudent = null;
        vm.debounceDelay = 2000;
        vm.grammarCheckEnabled = AccountService.account.contractGrammarCheckEnabled
            && (!AccountService.role.isLecturer() || (AccountService.account.clientSettings.grammarCheckForLecturer && AccountService.account.clientSettings.grammarCheckForLecturer !== 'alwaysDisabled'))
            && (!AccountService.role.isAdmin() || (AccountService.account.clientSettings.grammarCheckForAdmin && AccountService.account.clientSettings.grammarCheckForAdmin !== 'alwaysDisabled'))
        ;

        vm.aiDetectionEnabled = AccountService.account.contractAiDetectionEnabled
            && (!AccountService.role.isLecturer() || (AccountService.account.clientSettings.aiDetectionForLecturer && AccountService.account.clientSettings.aiDetectionForLecturer !== 'alwaysDisabled'))
            && (!AccountService.role.isAdmin() || (AccountService.account.clientSettings.aiDetectionForAdmin && AccountService.account.clientSettings.aiDetectionForAdmin !== 'alwaysDisabled'))
        ;
        
        vm.clientSettingPeerReviewEnabled = AccountService.account.clientSettings.peerReviewEnabled;
        vm.obj.peerReviewEnabled = null;

        vm.saveOrUpdate = saveOrUpdate;
        vm.transformEmailAddress = transformEmailAddress;
        vm.generate = generate;
        vm.validateShortcode = validateShortcode;
        vm.addQuestionDialog = addQuestionDialog;
        vm.addQuestion = addQuestion;
        vm.addFromLibraryDialog = addFromLibraryDialog;
        vm.addFromLibrary = addFromLibrary;
        vm.removeQuestion = removeQuestion;
        vm.addToLibrary = addToLibrary;
        vm.moveQuestionUp = moveQuestionUp;
        vm.moveQuestionDown = moveQuestionDown;
        vm.editQuestion = editQuestion;
        vm.onEditQuestion = onEditQuestion;

        vm.selectedLibrary = null;
        vm.loadingLibraries = false;
        vm.libraries = [];

        this.$onInit = function () {
            vm.pending = true;
            AssignmentsService.getAvailableDocuKinds().then(function (ret) {
                vm.docuKinds = ret.data;

                if ($stateParams.id) {
                    vm.editMode = true;
                    if ($state.current.name === 'assignment-duplicate') {
                        AssignmentsService.duplicateAssignment($stateParams.id).then(function (obj) {
                            vm.obj = obj.data;
                            if (vm.obj.peerReview) {
                                vm.obj.peerReview.questions.sort(function (a, b) {
                                    return a.sequence - b.sequence;
                                });
                            }
                            vm.pending = false;
                        });
                    } else {
                        AssignmentsService.getAssignmentForEditing($stateParams.id).then(function (obj) {
                            vm.obj = obj.data;
                            if (vm.obj.startDate) {
                                vm.obj.startDate = new Date(vm.obj.startDate);
                                // vm.obj.startTime = new Date(vm.obj.startDate);
                            }
                            if (vm.obj.endDate) {
                                vm.obj.endDate = new Date(vm.obj.endDate);
                                vm.obj.endTime = new Date(vm.obj.endDate);
                            }
                            if (vm.obj.peerReview) {
                                if (vm.obj.peerReview.studentsCanReviewFrom) {
                                    vm.obj.peerReview.studentsCanReviewFrom = new Date(vm.obj.peerReview.studentsCanReviewFrom);
                                }
                                if (vm.obj.peerReview.studentsCanReviewUntil) {
                                    vm.obj.peerReview.studentsCanReviewUntil = new Date(vm.obj.peerReview.studentsCanReviewUntil);
                                }
                                if (vm.obj.peerReview.feedbackAvailableFrom) {
                                    vm.obj.peerReview.feedbackAvailableFrom = new Date(vm.obj.peerReview.feedbackAvailableFrom);
                                }
                                vm.obj.peerReview.questions.sort(function (a, b) {
                                    return a.sequence - b.sequence;
                                });
                            }
                            vm.pending = false;
                        });
                    }
                } else {
                    vm.obj.startDate = new Date();
                    // vm.obj.startTime = new Date();
                    // vm.obj.startTime.setHours(0, 0, 0, 0);
                    vm.obj.endTime = new Date();
                    vm.obj.endTime.setHours(23, 59, 0, 0);
                    vm.obj.emailAddresses = [];
                    vm.pending = false;
                }
            });
            loadLibraries();
        };

        function setTimeInDates() {
            // if (vm.obj.startDate && vm.obj.startTime) {
            //     vm.obj.startDate.setHours(vm.obj.startTime.getHours(), vm.obj.startTime.getMinutes())
            // }
            if (vm.obj.endDate && vm.obj.endTime) {
                vm.obj.endDate.setHours(vm.obj.endTime.getHours(), vm.obj.endTime.getMinutes())
            }
        }

        function generate() {
            vm.obj.shortcode = getRandomChars(6);
            checkUnique($stateParams.id, vm.obj.shortcode);
        }

        function validateShortcode() {
            checkUnique($stateParams.id, vm.obj.shortcode);
        }

        function checkUnique(id, shortcode) {
            if (!id) {
                id = null;
            }
            AssignmentsService
                .checkUnique(id, shortcode)
                .then(function (resp) {
                    if (!resp.data) {
                        ModalService.showErrorModal({data: {code: 126}});
                    }
                    vm.pending = false;
                }, function (errorResponse) {
                    ModalService.showErrorModal(errorResponse);
                    vm.pending = false;
                });
        }

        function getRandomChars(length) {
            var result = '';
            var characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        }

        function saveOrUpdate(form) {
            if (!Utils.validateForm(form)) {
                return;
            }
            vm.pending = true;
            setTimeInDates();
            AssignmentsService
                .saveOrUpdate(vm.obj)
                .then(function () {
                    vm.obj = null;
                    ModalService.showSuccessModal("global.messages.success.label");
                    $state.go('assignments');
                    $stateParams.id = null;
                }, function (errorResponse) {
                    ModalService.showErrorModal(errorResponse);
                    vm.pending = false;
                });
        }

        function transformEmailAddress(chips) {
            if (vm.obj.emailAddresses) {
                vm.obj.emailAddresses = vm.obj.emailAddresses.slice(0); // workaround na bug w md-chips
            }

            vm.emailAddressesInvalidError = false;
            vm.emailAddressesInvalid = null;
            vm.emailAddressesNotStudent = null;
            vm.emailAddressesNotRegistered = null;

            var chipsArray = chips.split(/[\n\s,]+/);
            UserService.getAvailableStudentEmails(chipsArray).then(function (result) {
                const registeredEmailsResult = result.data.first;
                const notStudentEmailsResult = result.data.second;

                const registeredEmails = [];
                angular.forEach(registeredEmailsResult, function (user) {
                    registeredEmails.push(user.userEmail);
                })

                const notStudentEmails = [];
                angular.forEach(notStudentEmailsResult, function (user) {
                    notStudentEmails.push(user.userEmail);
                })

                angular.forEach(chipsArray, function (chip, i) {
                    if (validateEmailAddress(chip, registeredEmails, notStudentEmails)) {
                        if (vm.obj.emailAddresses.indexOf(chip) < 0) {
                            vm.obj.emailAddresses.push(chip);
                            addEmailToPeerReviewFeedbackSettings(registeredEmailsResult[i].userEmail, registeredEmailsResult[i].fullName);
                            resetManualReviewers();
                        }
                    }
                });
            })

            return null;
        }

        function validateEmailAddress(email, registeredEmails, notStudentEmails) {
            var validationRegexp = /\S+@\S+\.\S+/;
            if (!validationRegexp.test(email)) {
                vm.emailAddressesInvalid = (vm.emailAddressesInvalid ? (vm.emailAddressesInvalid + ', ') : '') + email;
                return null;
            }
            if (registeredEmails.indexOf(email) < 0) {
                if (notStudentEmails.indexOf(email) < 0) {
                    vm.emailAddressesNotRegistered = (vm.emailAddressesNotRegistered ? (vm.emailAddressesNotRegistered + ', ') : '') + email;
                } else {
                    vm.emailAddressesNotStudent = (vm.emailAddressesNotStudent ? (vm.emailAddressesNotStudent + ', ') : '') + email;
                }
                return null;
            }
            return true;
        }

        vm.onClickRemoveEmail = function (email) {
            angular.forEach(vm.obj.peerReview.manuallyAssignedReviewers, function (value, i) {
                if (value.email === email) {
                    vm.obj.peerReview.manuallyAssignedReviewers.splice(i, 1);
                }
            })
            resetManualReviewers();
        }

        // PEER REVIEW ////////////////////////////////////////////////////////////

        function addQuestionDialog() {
            $mdDialog.show({
                templateUrl: 'app/account/assignments/peer-review/add-question.template.html',
                controller: AddQuestionController,
                controllerAs: 'vm',
                locals: {
                    items: {
                        onAddQuestion: vm.addQuestion
                    }
                }
            });
        }

        function editQuestion(question, index) {
            $mdDialog.show({
                templateUrl: 'app/account/assignments/peer-review/add-question.template.html',
                controller: AddQuestionController,
                controllerAs: 'vm',
                locals: {
                    items: {
                        index: index,
                        question: question,
                        onEditQuestion: vm.onEditQuestion
                    }
                }
            });
        }

        function addQuestion(question) {
            const questionLength = vm.obj.peerReview.questions.length;
            const sequence = questionLength > 0 ? vm.obj.peerReview.questions[questionLength - 1].sequence + 1 : 0;
            question.sequence = sequence;
            vm.obj.peerReview.questions.push(question);
        }

        function loadLibraries() {
            vm.loadingLibraries = true;
            PeerReviewLibraryService.loadAllWithQuestions().then(function (obj) {
                vm.libraries = obj.data;
                if (vm.libraries.length > 0) {
                    vm.selectedLibrary = vm.libraries[vm.libraries.length - 1];
                }
                vm.loadingLibraries = false;
            }, function (errorResponse) {
                vm.loadingLibraries = false;
                ModalService.showErrorModal(errorResponse);
            });
        }

        function addFromLibrary(questions) {
            vm.obj.peerReview.questions = vm.obj.peerReview.questions.concat(questions);
            vm.obj.peerReview.questions.forEach(function (question, index) {
                question.id = null;
                question.libraryId = null;
                question.sequence = index + 1;
            });
        }

        function addFromLibraryDialog() {
            $mdDialog.show({
                templateUrl: 'app/account/assignments/peer-review/add-from-library.template.html',
                controller: AddFromLibraryController,
                controllerAs: 'vm',
                locals: {
                    items: {
                        library: vm.selectedLibrary,
                        onAddFromLibrary: vm.addFromLibrary
                    }
                }
            });
        }

        function removeQuestion(question, index) {
            if (index > -1 && vm.obj && vm.obj.peerReview.questions) {
                vm.obj.peerReview.questions.splice(index, 1);
            }
        }

        function addToLibrary() {
            $mdDialog.show({
                templateUrl: 'app/account/assignments/peer-review/add-to-library.template.html',
                controller: AddToLibraryController,
                controllerAs: 'vm',
                locals: {
                    items: {
                        library: vm.selectedLibrary,
                        questions: vm.obj.peerReview.questions,
                    }
                }
            }).then(function (selectedQuestions) {
                if (selectedQuestions) {
                    if (!this.selectedLibrary.questions) {
                        this.selectedLibrary.questions = [];
                    }
                    for (var i = selectedQuestions.length - 1; i >= 0; i--) {
                        this.selectedLibrary.questions.push(selectedQuestions[i]);
                    }
                }
            }.bind(this));
        }

        vm.onClickCreateLibrary = function () {
            $mdDialog.show({
                templateUrl: 'app/account/assignments/peer-review/library/create-library.template.html',
                controller: CreateLibraryController,
                controllerAs: 'vm'
            }).then(function (library) {
                if (library) {
                    this.selectedLibrary = library;
                    this.libraries.push(library);
                }
            }.bind(this));
        }

        vm.onClickDeleteLibrary = function () {
            ModalService.showConfirmModal('peer-review.library.delete.question').then(function () {
                vm.loadingLibraries = true;
                PeerReviewLibraryService.delete(vm.selectedLibrary.id).then(function () {
                    vm.selectedLibrary = null;
                    loadLibraries();
                    vm.loadingLibraries = false;
                });
            });
        }

        function moveQuestionUp(question, index) {
            if (index > 0) {
                const sequence1 = vm.obj.peerReview.questions[index].sequence;
                const sequence2 = vm.obj.peerReview.questions[index - 1].sequence;
                // Swap the questions
                vm.obj.peerReview.questions[index] = vm.obj.peerReview.questions[index - 1];
                vm.obj.peerReview.questions[index - 1] = question;

                vm.obj.peerReview.questions[index].sequence = sequence1;
                vm.obj.peerReview.questions[index - 1].sequence = sequence2;
            }
        }

        function moveQuestionDown(question, index) {
            if (index < vm.obj.peerReview.questions.length - 1) {
                const sequence1 = vm.obj.peerReview.questions[index].sequence;
                const sequence2 = vm.obj.peerReview.questions[index + 1].sequence;
                // Swap the questions
                vm.obj.peerReview.questions[index] = vm.obj.peerReview.questions[index + 1];
                vm.obj.peerReview.questions[index + 1] = question;

                vm.obj.peerReview.questions[index].sequence = sequence1;
                vm.obj.peerReview.questions[index + 1].sequence = sequence2;
            }
        }

        function onEditQuestion(index, question) {
            vm.obj.peerReview.questions[index] = question;
        }

        function addEmailToPeerReviewFeedbackSettings(email, fullName) {
            if (!vm.obj.peerReview.manuallyAssignedReviewers) {
                vm.obj.peerReview.manuallyAssignedReviewers = [];
            }
            vm.obj.peerReview.manuallyAssignedReviewers.push({email: email, fullName: fullName, manuallyAssigned: []});
        }

        vm.onClickShowDetailsManualReviewer = function (i) {
            const possibleReviewers = vm.obj.peerReview.manuallyAssignedReviewers.slice(); // .slice() does copy of array
            const docOwnerFullName = vm.obj.peerReview.manuallyAssignedReviewers[i].fullName;
            const docOwnerEmail = vm.obj.peerReview.manuallyAssignedReviewers[i].email;
            possibleReviewers.splice(i, 1);
            const mappedPossibleReviewers = [];
            angular.forEach(possibleReviewers, function (reviewer) {
                mappedPossibleReviewers.push({email: reviewer.email, fullName: reviewer.fullName});
            })
            $mdDialog.show({
                clickOutsideToClose: false,
                templateUrl: 'app/account/assignments/peer-review/manual-assigment/add-reviewer.controller.html',
                controller: AddReviewerManuallyController,
                controllerAs: 'vm',
                locals: {
                    items: {
                        email: docOwnerEmail,
                        fullName: docOwnerFullName,
                        reviewers: mappedPossibleReviewers,
                        manuallyAssigned: vm.obj.peerReview.manuallyAssignedReviewers[i].manuallyAssigned,
                        max: vm.obj.peerReview.pairCount,
                        disabled: vm.obj.peerReview.documentsExist,
                    }
                }
            }).then(function (selectedReviewers) {
                if (selectedReviewers) {
                    vm.obj.peerReview.manuallyAssignedReviewers[i].manuallyAssigned = selectedReviewers;
                }
            }.bind(this));
        }

        vm.onClickRemoveManualReviewer = function (index) {
            ModalService.showConfirmModal('peer-review.reviewer.delete.question').then(function () {
                var email = vm.obj.peerReview.manuallyAssignedReviewers[index].email;
                vm.obj.peerReview.manuallyAssignedReviewers.splice(index, 1);
                resetManualReviewers();
                angular.forEach(vm.obj.emailAddresses, function (email) {
                    if (vm.obj.emailAddresses[i] === email) {
                        vm.obj.emailAddresses.splice(i, 1);
                    }
                })
            });
        }

        function resetManualReviewers() {
            if (vm.obj.peerReview) {
                angular.forEach(vm.obj.peerReview.manuallyAssignedReviewers, function (value) {
                    value.manuallyAssigned = [];
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
          .state('assignments', {
            parent: 'app',
            url: '/assignments',
            data: {
                pageTitle: 'global.menu.account.assignments'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/assignments/assignments.html',
                    controller: 'AssignmentsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '0',
                    squash: true
                },
                sort: {
                    value: 'shortcode,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil',
                    function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate(
                                $stateParams.sort),
                            ascending: PaginationUtil.parseAscending(
                                $stateParams.sort)
                        };
                    }],
                translatePartialLoader: ['$translate',
                    '$translatePartialLoader',
                    function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('assignment');
                        $translatePartialLoader.addPart('document');
                        return $translate.refresh();
                    }]
            }
        })
          .state("assignment-add", {
            parent: "assignments",
            url: "/add-edit/:id",
            data: {
                pageTitle: 'assignment.edit.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/assignments/assignments-add.template.html',
                    controller: 'AssignmentsAddController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assignment');
                    $translatePartialLoader.addPart('peer-review');
                    $translatePartialLoader.addPart('document');
                    return $translate.refresh();
                }]
            }
        })
        .state("assignment-submit", {
            parent: "assignments",
            url: "/submit/:id",
            data: {
                pageTitle: 'assignment.submit.page.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/assignments/assignments-submit.html',
                    controller: 'AssignmentsSubmitController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assignment');
                    $translatePartialLoader.addPart('document');
                    return $translate.refresh();
                }]
            }
        })
        .state("assignment-duplicate", {
            parent: "assignments",
            url: "/duplicate/:id",
            data: {
                pageTitle: 'assignment.edit.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/assignments/assignments-add.template.html',
                    controller: 'AssignmentsAddController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assignment');
                    $translatePartialLoader.addPart('peer-review');
                    $translatePartialLoader.addPart('document');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('AssignmentsService', AssignmentsService);

    AssignmentsService.$inject = ['$http', '$q'];

    function AssignmentsService($http, $q) {

        var requestUrl = 'api/assignment';
        var peerReviewUrl = 'api/peer';

        var service = {
            getList: getList,
            getAssignmentForEditing: getAssignmentForEditing,
            getAvailableDocuKinds: getAvailableDocuKinds,
            saveOrUpdate: saveOrUpdate,
            getSubmitForm: getSubmitForm,
            submitAssignment: submitAssignment,
            submitAssignmentCorrection: submitAssignmentCorrection,
            submitAssignmentPaidCorrection: submitAssignmentPaidCorrection,
            submitMultipleAssignments: submitMultipleAssignments,
            changeAssignmentStatus: changeAssignmentStatus,
            checkUnique: checkUnique,
            findAssignment: findAssignment,
            joinAssignment: joinAssignment,
            duplicateAssignment: duplicateAssignment,
        };
        return service;

        function getList(pageableFilter) {
            return $http.post(requestUrl + '/list', pageableFilter).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function findAssignment(obj) {
            return $http.post(requestUrl + '/find-assignment', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function joinAssignment(obj) {
            return $http.post(requestUrl + '/self-enrollment', obj).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getAssignmentForEditing(id) {
            return $http.get(requestUrl + '/for-editing/' + id).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function changeAssignmentStatus(id, status) {
            return $http.get(requestUrl + '/change-status/' + id + '/' + status).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function checkUnique(id, shortcode) {
            return $http.get(requestUrl + '/check-unique/' + id + '/' + shortcode).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function getSubmitForm(documentId) {
            return $http.get(requestUrl + '/submit-form/' + documentId).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function submitAssignment(obj) {
            return $http.post(requestUrl + '/submit', obj).then(
              function (response) {
                  return response.data.data;
              },
              function (errResponse) {
                  return $q.reject(errResponse);
              });
        }

        function submitAssignmentCorrection(obj) {
            return $http.post(requestUrl + '/submit-correction', obj).then(
              function (response) {
                  return response.data.data;
              },
              function (errResponse) {
                  return $q.reject(errResponse);
              });
        }

        function submitAssignmentPaidCorrection(obj) {
            return $http.post(requestUrl + '/submit-correction-paid', obj).then(
              function (response) {
                  return response.data.data;
              },
              function (errResponse) {
                  return $q.reject(errResponse);
              });
        }

        function submitMultipleAssignments(obj, id) {
            return $http.post(requestUrl + '/submit-multiple/' + id, obj).then(
              function (response) {
                  return response.data.data;
              },
              function (errResponse) {
                  return $q.reject(errResponse);
              });
        }

        function getAvailableDocuKinds() {
            return $http.get(requestUrl + '/available-docu-kinds').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function saveOrUpdate(obj) {
            return $http.post(requestUrl + '/save-or-update', obj).then(
                function () {},
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

        function duplicateAssignment(assignmentId) {
            return $http.post(requestUrl + '/duplicate/' + assignmentId, null).then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }
})();

(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .controller('AssignmentsController', AssignmentsController);
    
    AssignmentsController.$inject = [
        '$rootScope', '$scope', '$stateParams', '$translate', '$state', 'SIMPLE_SEARCH_DELAY',
        'AssignmentsService', 'AssignmentsRequest', 'QueryRequest', 'AccountService', 'DocumentService', 'ModalService',
        'DocumentSearchRequestModel', 'SearchService', 'PlagiatValidationService'
    ];

    function AssignmentsController(
        $rootScope, $scope, $stateParams, $translate, $state, SIMPLE_SEARCH_DELAY,
        AssignmentsService, AssignmentsRequest, QueryRequest, AccountService, DocumentService, ModalService,
        DocumentSearchRequestModel, SearchService, PlagiatValidationService
    ) {
        var vm = this;
        var assignments = [];
        var pending = true;
        vm.simpleSearchDelay = SIMPLE_SEARCH_DELAY;
        vm.getAssignments = getAssignments;
        vm.getAssignmentsPage = getAssignmentsPage;
        vm.onClickDuplicate = onClickDuplicate;
        vm.closeAssignment = closeAssignment;
        vm.reopenAssignment = reopenAssignment;
        vm.onOpenScoringClick = onOpenScoringClick;
        vm.clear = clear;
        vm.toggleSearch = toggleSearch;
        vm.showSubmissions = showSubmissions;
        vm.submitToAssignment = submitToAssignment;

        vm.searchRequest = new AssignmentsRequest();
        vm.queryRequest = new QueryRequest();
        vm.queryRequest.limit = 10;
        vm.queryRequest.order = '-id';
        vm.simpleSearch = true;
        vm.statuses = [
            {id: 0, translateKey: 'assignment.table.status.in-progress'},
            {id: 1, translateKey: 'assignment.table.status.terminated'},
            {id: 2, translateKey: 'assignment.table.status.ended'}
        ];
        vm.types = [
            {id: 'PEER_REVIEW', translateKey: 'assignment.type.peer_review'},
            {id: 'STANDARD', translateKey: 'assignment.type.standard'}
        ];
        vm.canAddAssignment = AccountService.role.isLecturer() || AccountService.role.isAdmin() || AccountService.role.isOperator();
        vm.canSubmitToAssignment = AccountService.role.isLecturer() || AccountService.role.isAdmin() || AccountService.role.isOperator();
        vm.isAdmin = AccountService.role.isAdmin();

        vm.getAssignments();
        
        function closeAssignment(row) {
            AssignmentsService.changeAssignmentStatus(row.id, 2).then(
                function (response) {
                    vm.pending = false;
                    ModalService.showSuccessModal("global.messages.info.actionsuccess");
                    vm.getAssignments();
                }, function (errorResponse) {
                    vm.pending = false;
                    ModalService.showErrorModal(errorResponse);
                });
        }

        function onClickDuplicate(assignment) {
            $state.go('assignment-duplicate', {id: assignment.id});
        }
        
        function reopenAssignment(row) {
            AssignmentsService.changeAssignmentStatus(row.id, 0).then(
                function (response) {
                    vm.pending = false;
                    ModalService.showSuccessModal("global.messages.info.actionsuccess");
                    vm.getAssignments();
                }, function (errorResponse) {
                    vm.pending = false;
                    ModalService.showErrorModal(errorResponse);
                });
        }
        
        function submitToAssignment(row) {
            $state.go('assignment-submit', {id: row.id});
        }

        function onOpenScoringClick(row) {
            $state.go('peer-review-scoring', {id: row.peerReviewId});
        }
        
        function getAssignments() {
            vm.pending = true;
            vm.searchRequest.pageNumber = vm.queryRequest.page - 1;
            vm.searchRequest.pageSize = vm.queryRequest.limit;
            vm.searchRequest.sortTab = SearchService.sort(vm.queryRequest);
            
            return AssignmentsService.getList(vm.searchRequest).then(
                function (response) {
                    vm.pending = false;
                    vm.assignments = response.content;
                    vm.totalAssignments = response.totalElements;
                }, function (error) {
                    vm.pending = false;
                    PlagiatValidationService.getModalError(error.data);
                });
        }
        
        function getAssignmentsPage(page) {
            vm.queryRequest.page = page;
            vm.getAssignments();
        }
        
        function toggleSearch() {
            vm.searchRequest.simpleSearch = '';
            vm.searchRequest.search = {};
            vm.simpleSearch = !vm.simpleSearch;
        }

        function showSubmissions(assignment) {
            DocumentService.searchObject = new DocumentSearchRequestModel();
            DocumentService.searchObject.assignmentId = assignment.id;
            $state.go('documents');
        }
        
        function clear() {
            vm.searchRequest.simpleSearch = '';
            vm.searchRequest.search = {};
            getAssignments();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate-set-password', {
            parent: 'account',
            url: '/activate-set-password?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate-set-password/activate-set-password.html',
                    controller: 'ActivateSetPasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ActivateSetPasswordController', ActivateSetPasswordController);

    ActivateSetPasswordController.$inject = ['$stateParams', 'Auth', '$cookies', 'DetectInstanceService', 'AccountService'];

    function ActivateSetPasswordController ($stateParams, Auth, $cookies, DetectInstanceService, AccountService) {
        var vm = this;
        vm.conversionDomain = DetectInstanceService.getConversionAllowance();
        vm.theme = $cookies.get('plagiat-theme');
        vm.setPassword = setPassword;
        vm.toggleShowPassword = toggleShowPassword;
        vm.showPassword = false;
        vm.uniqueKeyValid = true;
        vm.passwordPattern = Auth.getPasswordPattern();
        
        Auth.activateAccountForCreatedUser({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function (response) {
            if(response.data.code == 58){
            	vm.alreadyActivated = true;
            	vm.error = null;
                vm.success = 'OK';
                vm.passwordSetSuccess = false;
            }else if(response.data.code == 57){
            	vm.uniqueKeyValid = false;
            }else{
            	vm.success = null;
            	vm.error = 'ERROR';
            }
        });
        
        function setPassword() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.resetAccount.confirmedPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, password: vm.resetAccount.password, newPassword: vm.resetAccount.confirmedPassword}).then(function () {
                    vm.success = 'OK';
                    vm.passwordSetError=false;
                    vm.passwordSetSuccess=true;
                }).catch(function (response) {
                    vm.success = null;
                    vm.passwordSetSuccess=false;
                    vm.passwordSetError=true;
                    vm.error = 'ERROR';
                });
            }
        }

        function toggleShowPassword() {
            vm.showPassword = !vm.showPassword;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('login');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', '$cookies', 'DetectInstanceService'];

    function ActivationController ($stateParams, Auth, $cookies, DetectInstanceService) {
        var vm = this;
        vm.conversionDomain = DetectInstanceService.getConversionAllowance();
        vm.theme = $cookies.get('plagiat-theme');

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }

})();
(function(){angular.module('plagiat2017App').run(['$templateCache', function($templateCache) {$templateCache.put('app/client/bottom-sheet-grid-template.html','<md-bottom-sheet layout="column"><div ng-cloak><div layout="row" layout-xs="column" layout-align="start start"><span layout-align="start start" layout-padding layout-xs="column"><span ng-click="bootomSheet.closeBottomSheet()" data-translate="global.undo">Cofnij</span> </span><span layout-align="start start" layout-padding layout-xs="row" flex><span><md-checkbox ng-model="bootomSheet.checked" aria-label="Checkbox 1" ng-click="bootomSheet.closeBottomSheet()"><span data-translate="global.selected"></span></md-checkbox></span><span class="md-mini" layout-align="center start" aria-label="{{bootomSheet.selected.length}}" ng-if="!bootomSheet.tableSelectOptions.selectedAll">{{bootomSheet.selected.length}} / {{bootomSheet.total}} </span><span class="md-mini" aria-label="{{bootomSheet.selected.length}}" ng-if="bootomSheet.tableSelectOptions.selectedAll">{{bootomSheet.tableSelectOptions.selectedNo}} / {{bootomSheet.total}} </span><span aria-label="select all" ng-click="bootomSheet.toggleSelection(bootomSheet.total)" ng-if="!bootomSheet.tableSelectOptions.selectedAll" data-translate="global.button.select.all"></span> <span aria-label="select all" ng-click="bootomSheet.toggleSelection(bootomSheet.totalUsers)" ng-if="bootomSheet.tableSelectOptions.selectedAll" data-translate="global.button.clear.selection"></span> </span><span layout-align="start start" layout-padding layout-xs="row" flex flex-offset-gt-sm="10"><span layout-align="center start" ng-click="bootomSheet.generateReportXls()"><i class="material-icons">vertical_align_bottom</i> <span data-translate="global.bottomsheet.getreport"></span></span></span></div></div></md-bottom-sheet>');
$templateCache.put('app/client/client-actions.html','<div flex layout="row" layout-align="end center"><md-menu-bar flex layout="row"><md-menu><md-button aria-label="open" class="md-icon-button" ng-click="$mdMenu.open()"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item ng-if="!vm.isMinistry"><md-button aria-label="editClientBasicData" data-translate="client.edit.basic-data" ui-sref="client-edit({id: client.id, step: \'basic-data\'})"></md-button></md-menu-item><md-menu-item ng-if="!vm.isMinistry && ((client.clientType.id == vm.clientTypeConstant.CODE_ACCOUNT.id) || (client.clientType.id == vm.clientTypeConstant.COLLEGE.id))"><md-button aria-label="editClientBasicData" data-translate="client.edit.code-account" ui-sref="client-edit({id: client.id, step: \'code-account\'})"></md-button></md-menu-item><md-menu-item ng-if="!vm.isReseller && !vm.isMinistry"><md-button aria-label="editClientContract" data-translate="client.edit.contract" ui-sref="client-edit({id: client.id, step: \'contract\'})"></md-button></md-menu-item><md-menu-item ng-if="!vm.isReseller && !vm.isMinistry"><md-button aria-label="editClientConfiguration" data-translate="client.edit.configuration" ui-sref="client-edit({id: client.id, step: \'configuration\'})"></md-button></md-menu-item><md-menu-item ng-if="!vm.isMinistry"><md-button aria-label="editClientDocumentKinds" data-translate="client.edit.document-kinds" ui-sref="client-document-kinds({clientId: client.id})"></md-button></md-menu-item><md-menu-item ng-if="!vm.isMinistry"><md-button aria-label="editClientProtocols" data-translate="client.edit.protocols" ui-sref="client-protocols({clientId: client.id})"></md-button></md-menu-item><md-divider><md-menu-item ng-if="client.clieStatus == 0 && client.clientType.label != \'INDIVIDUAL\'"><md-button aria-label="freeze client" data-translate="client.action.freeze" ng-click="vm.freezeClient(client.id)"></md-button></md-menu-item><md-menu-item ng-if="client.clieStatus == vm.clientStatus.FROZEN.id"><md-button aria-label="unfreeze client" data-translate="client.action.unfreeze" ng-click="vm.unfreezeClient(client.id)"></md-button></md-menu-item><div ng-if="(client.clieStatus != vm.clientStatus.REMOVAL_IN_PROGRESS.id) && !vm.isReseller && !vm.isMinistry && (client.clientType.label != \'INDIVIDUAL\') "><md-divider><md-menu-item><md-button aria-label="removeClient" data-translate="global.button.remove" ng-click="vm.removeClient(client.id)"></md-button></md-menu-item></div></md-menu-content></md-menu></md-menu-bar></div>');
$templateCache.put('app/client/client.html','<div class="site-container" id="clients" layout="column"><div class="table-container" flex><md-content class="clients-header" flex-xs="100" layout="row"><div layout-align="center center"><header class="header"><h5 data-translate="client.title"></h5></header></div></md-content><md-content layout="row" layout-margin><md-card aria-hidden="false" flex><div flex layout="row" layout-align="end center"><md-button aria-label="client add" class="md-raised md-primary button-waiting" data-translate="client.button.add" id="addClient" ui-sref="client-add" ng-if="!vm.isReseller && !vm.isMinistry"></md-button><md-button aria-label="client add test" class="md-raised md-primary button-waiting" data-translate="client.button.add-test" id="addTestClient" ui-sref="client-add-test" ng-if="vm.isReseller"></md-button></div><clients-search on-clear="vm.clear" on-get-clients="vm.searchClients" on-query-request="vm.queryRequest" on-search-request="vm.searchRequest" simple-search="vm.simpleSearch"></clients-search><md-table-container><table md-table md-row-select="vm.options.rowSelection" multiple="{{vm.options.multiSelect}}" ng-model="vm.selected" md-progress="vm.promise" id="tableClients"><thead md-head md-order="vm.queryRequest.order" md-on-reorder="vm.getClients"><tr md-row><th md-column><span>#</span></th><th md-column md-order-by="clieName"><span data-translate="client.model.name"></span></th><th md-column md-order-by="id"><span data-translate="client.model.id"></span></th><th md-column md-order-by="contracts.contStatus"><span data-translate="client.model.status"></span></th><th md-column><span></span></th><th md-column md-order-by="clieType"><span data-translate="client.model.type"></span></th><th md-column ng-if="vm.isSuperAdmin"><span data-translate="global.model.region"></span></th><th md-column ng-if="vm.isSuperAdmin"><span data-translate="client.model.country"></span></th><th md-column class="table-actions"><span data-translate="global.table.actions"></span></th></tr></thead><tbody md-body><tr md-on-deselect="vm.deSelectRow" md-on-select="vm.selectRow" md-row md-select="client.id" ng-repeat-start="client in vm.clients track by $index" ng-class="{\'disabled-row\': (client.clieStatus == vm.clientStatus.FROZEN.id || client.clieStatus == vm.clientStatus.REMOVAL_IN_PROGRESS.id)}"><td md-cell ng-click="vm.getDetails(client)">{{($index + 1) + ((vm.queryRequest.page - 1) * vm.queryRequest.limit)}}</td><td md-cell ng-click="vm.getDetails(client)">{{client.clieName}}</td><td md-cell ng-click="vm.getDetails(client)">{{client.id}}</td><td md-cell ng-click="vm.getDetails(client)"><md-tooltip md-delay="100" md-direction="top">{{client.contractAntyplagiat.status == 0 ? client.contractAntyplagiat.forthcomingContract ? \'global.status.forthcoming\' : \'global.status.active\' : \'global.status.inactive\'| translate}}</md-tooltip><i class="material-icons {{client.contractAntyplagiat.status == 0 ? client.contractAntyplagiat.forthcomingContract ? \'icon-picked\' : \'icon-paid\': \'icon-rejected\'}}">{{client.contractAntyplagiat.status == 0 ? \'done\' : \'error\'}}</i></td><td md-cell ng-click="vm.getDetails(client)">{{vm.getStatusDescription(client)}}</td><td md-cell ng-click="vm.getDetails(client)"><span ng-if="client.clientType.langKey">{{client.clientType.langKey | translate }}</span></td><td md-cell ng-click="vm.getDetails(client)">{{client.clientRegionName}}</td><td md-cell ng-click="vm.getDetails(client)" ng-if="vm.isSuperAdmin">{{client.clientCountryName}}</td><td md-cell ng-include src="\'app/client/client-actions.html\'"></td></tr><tr ng-if="vm.showDetailsBlock && vm.pickedClient == client.id" ng-repeat-end><td colspan="99"><client-details client="vm.details"></client-details></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoaderActive"></md-progress-circular></div></md-table-container><div flex><div layout="row" layout-align="end center" layout-wrap><paging page="vm.queryRequest.page" page-size="vm.queryRequest.limit" paging-action="vm.pagingAction(page)" show-first-last="true" show-prev-next="true" total="vm.totalClients"></paging><div layout="row" class="go-to" flex-xs="100" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to next page" ng-model="vm.queryRequest.page" type="number" ng-keyup="vm.getClients()" ng-change="vm.getClients()"></md-input-container></div></div></div></md-card></md-content></div></div>');
$templateCache.put('app/code-payments/code-payments.html','<div layout="column" class="code-payments site-container"><md-content class="code-payments-content" layout="column"><header class="header"><h5 data-translate="payments.code.title"></h5></header></md-content><payment-status on-is-code="true" ng-if="vm.key === \'success\'"></payment-status><md-content layout="row" class="payment-metric"><div layout-margin layout="row" flex class="payment-metric-container"><div flex="60" flex-md="100" flex-sm="100" flex-xs="100"><md-card><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><h2 flex data-translate="payments.code.metric.title">Zakup token\xF3w</h2></div></md-toolbar><md-card-title><md-card-title-text><div class="payment-box box-with-shadow active-step1" ng-class="{ \'active-step2\': vm.phase === \'step-2\', \'active-step3\': vm.phase === \'step-3\'}"><div class="payment-top-wrapper"><div class="payment-line"></div><div class="payment-steps" layout-wrap><div class="step steps-step-1" flex-xs="100"><div class="step-counter"><div class="step-counter-number">1</div><i class="material-icons step-counter-done">done</i></div><div class="step-name" data-translate="payments.metric.code-number">Liczba kod\xF3w</div></div><div class="step steps-step-2" flex-xs="100"><div class="step-counter"><div class="step-counter-number">2</div><i class="material-icons step-counter-done">done</i></div><div class="step-name" data-translate="payments.metric.paymentsmethod"></div></div><div class="step steps-step-3" flex-xs="100" ng-if="vm.paymentForm.invoiceRequired"><div class="step-counter"><div class="step-counter-number">3</div><i class="material-icons step-counter-done">done</i></div><div class="step-name" data-translate="payments.metric.invoice" ng-if="vm.paymentForm.invoiceRequired">Faktura</div></div></div></div></div></md-card-title-text></md-card-title><md-card-content><div layout="column" flex><div class="payment-content payment-content-step1" ng-class="{ \'hide\': vm.phase !== \'step-1\'}"><form class="formCode" name="codeForm" autocomplete="off"><div class="input-field" layout="column" layout-wrap><md-input-container class="md-block"><label data-translate="payments.metric.code-type"></label><md-select ng-disabled="vm.disableChoosingCodeType" ng-model="vm.paymentForm.selectedCode" required><md-option ng-repeat="value in vm.codes" ng-value="value">{{value.name}} &nbsp; {{\'payments.code.metric.code-size.prefix\' | translate }} {{value.size}} {{\'payments.code.metric.code-size.suffix\' | translate}}</md-option></md-select></md-input-container><div class="input-field tokens-count"><md-input-container class="md-block"><input placeholder="{{\'payments.metric.codessno\' | translate }}" id="codesNumber" aria-label="codes number" ng-model="vm.paymentForm.codes" type="text" onkeypress="return (event.charCode == 0 || (event.charCode >= 48 && event.charCode <= 57))" ng-pattern="/^[1-9][0-9]*$/" name="codesNumber" placeholder="{{\'payments.metric.inputno\'| translate}}" autocomplete="off" required><div class="md-input-messages-info ng-active" ng-class="{\'md-input-messages-error\': vm.codeError && $ctrl.paymentForm.codes != \'\' }"><div data-translate="payments.metric.max-codes-info"></div></div></md-input-container></div><div layout="row" layout-margin layout-align="start center" class="ml-2"><three-state-radio ng-model="vm.paymentForm.priorityCode" data-label="{{\'payments.metric.code.priority\' | translate}}" data-immutable="vm.priorityCodeMandatory"></three-state-radio><span><i class="material-icons cursor-pointer">info</i><md-tooltip ng-bind-html="\'payments.metric.code.priority.tooltip\' | translate"></md-tooltip></span></div></div><div class="summary"><div class="summary-line"><div class="summary-name" data-translate="payments.metric.code.currency" layout-align="center center">currency</div><div class="summary-value"><md-input-container><md-select id="currencySelect" aria-label="set query limit" ng-model="vm.paymentForm.payment" layout-align="center center" required><md-option id="idOptionCurrencySelect{{payment.currency}}" ng-value="payment" ng-repeat="payment in vm.availablePayments"><em>{{payment.currency}}</em></md-option></md-select></md-input-container></div></div><div class="hr"></div><div class="summary-line"><div class="summary-name" data-translate="payments.metric.to-pay"></div><div class="summary-value summary-value-big" flex layout="row"><span layout-align="center center">{{vm.getTotalCodePriceForCurrency() | currency:vm.paymentForm.payment.currency}}</span></div></div><div class="hr"></div><div class="summary-line"><div class="summary-name" data-translate="payments.metric.code.expiry-date"></div><div class="summary-value summary-value-big" flex layout="row"><span layout-align="center center">{{ vm.codeExpiryDate }}</span></div></div></div></form><div class="hr-payment hr"></div></div></div><div class="payment-content payment-content-step2" ng-class="{ \'hide\': vm.phase !== \'step-2\'}"><div class="payment-checkbox" ng-if="!vm.isRomania && vm.paymentInit[vm.paymentForm.paymentMethod].invoice"><md-checkbox class="md-block" ng-model="vm.paymentForm.invoiceRequired" aria-label="Checkbox 1"><span data-translate="payments.metric.invoiceissue"></span></md-checkbox></div><div class="payment-mode-header" data-translate="payments.metric.paymentsmethod"></div><form class="formPaymentMethod" name="providerForm" autocomplete="off"><md-radio-group name="paymentMethod" ng-model="vm.paymentForm.paymentMethod" ng-change="vm.paymentMethodChanged()" required><div class="payment-mode"><div class="payment-mode-line" layout-align="center center" ng-repeat="paymentMethod in vm.paymentForm.payment.providers | filter: vm.filterAvailablePayments"><md-radio-button value="{{paymentMethod}}" class="md-primary"><img ng-src="{{\'content/images/\' + vm.paymentInit[paymentMethod].img}}"> {{vm.instance === \'int\' ? \'\' : vm.paymentInit[paymentMethod].name}}</md-radio-button></div><div class="payment-line-collapsible" ng-if="vm.paymentForm.paymentMethod == \'TYPE_BLIK\'"><div class="collapsible-header"></div><div class="collapsible-body"><div layout="row" layout-wrap><md-input-container class="md-block blik-block" flex="25"><input ng-pattern="/^[0-9]{6}$/" onkeypress="return (event.charCode == 0 || (event.charCode >= 48 && event.charCode <= 57))" name="blikCode" ng-model="vm.paymentForm.blikCode" placeholder="{{\'payments.metric.blik.enter-code\' | translate}}"> <span ng-show="formPaymentMethod.blikCode.$error.pattern" class="error-description" data-translate="payments.payment.blik.validation.6digit"></span></md-input-container></div></div></div></div></md-radio-group><div class="payment-checkbox"><md-checkbox class="md-block" ng-model="vm.paymentForm.cedeRegulations" aria-label="Checkbox 2" required name="accepRegulations"><span data-translate="{{\'payments.metric.codes.regulations_\' + vm.instance}}"></span></md-checkbox></div></form><div class="hr"></div></div><div class="payment-content payment-content-step3" ng-class="{ \'hide\': vm.phase !== \'step-3\'}"><form class="form" name="invoiceForm" flex><div layout="row" layout-xs="column"><md-radio-group ng-model="vm.paymentForm.isCompany" layout="row" layout-padding><md-radio-button ng-value="true"><span data-translate="payments.metric.address.placeholder.business"></span></md-radio-button><md-radio-button ng-value="false"><span data-translate="payments.metric.address.placeholder.private-person"></span></md-radio-button></md-radio-group></div><div layout="row" layout-xs="column"><md-input-container class="md-block" flex="50" flex-xs="100"><input ng-model="vm.paymentForm.invoice.company" placeholder="{{!vm.paymentForm.invoice.company ? \'payments.metric.address.placeholder.first-and-last-name\' : \'payments.metric.address.company\' | translate}}" required></md-input-container><md-input-container class="md-block" flex="50" flex-xs="100" ng-if="vm.paymentForm.isCompany"><input ng-model="vm.paymentForm.invoice.nip" placeholder="{{!vm.paymentForm.invoice.nip ? \'payments.metric.address.placeholder.nip\' : \'payments.metric.address.nip\' | translate}}" md-maxlength="16"></md-input-container></div><div layout="row" layout-xs="column"><md-input-container class="md-block" flex="100"><input ng-model="vm.paymentForm.invoice.street" placeholder="{{!vm.paymentForm.invoice.street ? \'payments.metric.address.placeholder.street\' : \'payments.metric.address.street\' | translate}}" required></md-input-container></div><div layout="row" layout-xs="column" ng-if="!vm.isRomania"><md-input-container class="md-block" flex="50" flex-xs="100"><input ng-model="vm.paymentForm.invoice.city" placeholder="{{vm.paymentForm.invoice.city ? \'payments.metric.address.placeholder.city\' : \'payments.metric.address.city\' | translate}}" required></md-input-container><md-input-container class="md-block" flex="50" flex-xs="100"><input ng-model="vm.paymentForm.invoice.zip" placeholder="{{!vm.paymentForm.invoice.zip ? \'payments.metric.address.placeholder.post-code\' : \'payments.metric.address.post-code\' | translate}}" md-maxlength="10" required></md-input-container></div><div layout="row" layout-xs="column" ng-if="vm.isRomania"><md-input-container class="md-block" flex="50" flex-xs="100"><label data-translate="payments.metric.address.county"></label><md-select ng-model="vm.paymentForm.invoice.county" ng-change="vm.onRoCountyChange()" required><md-option ng-repeat="county in vm.romanianCounties" ng-value="county.name">{{ county.name }}</md-option></md-select></md-input-container><md-input-container class="md-block" flex="50" flex-xs="100"><md-autocomplete class="white-background" md-floating-label="{{\'payments.metric.address.city\' | translate}}" md-selected-item="vm.paymentForm.invoice.city" md-search-text="searchText" md-items="city in vm.romanianCities | filter:searchText" md-item-text="city" ng-disabled="!vm.paymentForm.invoice.county" md-min-length="0" md-require-match="true" md-delay="100" md-select-on-match="true" md-clear-button="true" md-no-cache="true" required><md-item-template><span md-highlight-text="searchText">{{ city }}</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{searchText}}"</md-not-found></md-autocomplete></md-input-container></div><div layout="row" layout-xs="column"><md-input-container class="md-block" flex="100"><input ng-model="vm.paymentForm.invoice.phone" placeholder="{{!vm.paymentForm.invoice.phone ? \'payments.metric.address.placeholder.phone\' : \'payments.metric.address.phone\' | translate}}"></md-input-container></div></form><div class="hr"></div></div></md-card-content><md-card-actions layout="row" layout-align="end center"><md-button class="md-raised md-primary button-forward" ng-if="vm.phase === \'step-1\'" ng-click="vm.transitionToStep2(codeForm)" data-translate="payments.metric.buttons.forward" id="goToPaymentMethodButton">Dalej</md-button><md-button ng-if="vm.phase === \'step-2\'" ng-click="vm.phase = \'step-1\'" data-translate="payments.metric.buttons.back">Cofnij</md-button><md-button ng-if="vm.phase === \'step-3\'" ng-click="vm.phase= \'step-2\'" data-translate="payments.metric.buttons.back">Cofnij</md-button><md-button class="md-raised md-primary" ng-if="vm.phase === \'step-2\' && vm.paymentForm.invoiceRequired" ng-click="vm.phase = \'step-3\'" ng-disabled="codeForm.$invalid || providerForm.$invalid || providerForm.paymentMethod.$invalid || providerForm.blikCode.$error.pattern || (vm.paymentForm.paymentMethod == \'TYPE_BLIK\' && !providerForm.blikCode.$viewValue)" data-translate="payments.metric.buttons.forward">Dalej</md-button><md-button class="md-raised md-primary button-waiting" ng-disabled="codeForm.$invalid || providerForm.$invalid || formPaymentMethod.blikCode.$error.pattern || (vm.paymentForm.paymentMethod == \'TYPE_BLIK\' && !providerForm.blikCode.$viewValue)" ng-if="vm.phase === \'step-2\' && !vm.paymentForm.invoiceRequired" ng-click="vm.buyCode()" data-translate="payments.metric.code.buttons.buy" id="buyTokensButton">Kup kody</md-button><md-button class="md-raised md-primary button-waiting" ng-disabled="codeForm.$invalid || providerForm.$invalid || invoiceForm.$invalid || providerForm.blikCode.$error.pattern || (vm.paymentForm.paymentMethod == \'TYPE_BLIK\' && !providerForm.blikCode.$viewValue)" ng-if="vm.phase === \'step-3\' && vm.paymentForm.invoiceRequired" ng-click="vm.buyCode()" data-translate="payments.code.metric.title">Kup kody</md-button></md-card-actions></md-card></div></div></md-content><payments-list on-get-key="vm.key" on-code-payments="true"></payments-list><div id="paymentForm" style="display:none"><form><ul><li ng-repeat="(key, value) in vm.paymentParams"><input type="text" name="{{key}}" value="{{value}}"></li></ul><md-button class="md-raised md-primary" ng-click="vm.submitMe()">Submit</md-button></form></div></div>');
$templateCache.put('app/codes/codes-search.template.html','<form name="form" layout-padding><div layout="row" layout-xs="column"><select-page-size query-request="vm.pagingModel" on-value-chosen="vm.search()" layout="row" flex="30" flex-xs="100" layout-align="start center"></select-page-size><div flex="70" flex-xs="100" layout="row" layout-align="end center"><md-input-container flex="70" flex-xs="100" ng-if="vm.simpleSearch"><label data-translate="global.search.title"></label><input ng-change="vm.search()" ng-model="vm.requestPayload.simpleSearch" ng-model-options="{ debounce: vm.simpleSearchDelay }"></md-input-container><div flex="30" flex-xs="100" layout="column" layout-align="end center"><md-button aria-label="toggleSearch" ng-if="vm.simpleSearch" data-translate="global.button.search.advanced" ng-click="vm.toggleSearch()"></md-button><md-button ng-if="!vm.simpleSearch" aria-label="toggleSearch" data-translate="global.button.search.simple" ng-click="vm.toggleSearch()"></md-button></div></div></div><div layout="row" layout-xs="column" ng-if="!vm.simpleSearch" layout-wrap><md-input-container flex="33" flex-xs="100" flex-gt-md="25" class="mt-3 md-block" ng-if="vm.isSuperAdmin"><md-autocomplete id="search-client-for-codes" md-clear-button="true" class="white-background" md-floating-label="{{\'users.model.clientname\'| translate}}" md-input-minlength="1" md-item-text="item.id + \' \' + item.clieName" md-items="item in vm.clientSearch(vm.clientSearchText)" md-search-text="vm.clientSearchText" md-selected-item-change="vm.selectedClientChange(item)" md-require-match="true" md-delay="500" md-select-on-match="true"><md-item-template><span md-highlight-text="vm.clientSearchText" md-highlight-flags="^i">{{item.clieName}} [{{item.id}}]</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{vm.clientSearchText}}"</md-not-found></md-autocomplete></md-input-container><md-input-container flex="33" flex-xs="100" flex-gt-md="25" class="mt-3" ng-if="vm.isAdmin && !vm.isSuperAdmin"><label data-translate="codes.model.organization-unit"></label><md-select ng-change="vm.search()" ng-model="vm.searchRequest.organizationUnitId"><md-option ng-if="vm.searchRequest.organizationUnitId" ng-value="">{{\'global.button.clear\'| translate}}: {{\'codes.model.organization-unit\' | translate}}</md-option><md-option ng-repeat="value in vm.organisationalUnits" ng-value="value.id">{{value.orguniLabel}}</md-option></md-select></md-input-container><md-input-container flex="33" flex-xs="100" flex-gt-md="25" class="mt-3"><label data-translate="codes.model.user-email-address"></label><input ng-model="vm.searchRequest.userEmailAddress"></md-input-container><md-input-container flex="33" flex-xs="100" flex-gt-md="25" class="mt-3"><label data-translate="codes.model.user-firstname"></label><input ng-model="vm.searchRequest.userFirstName"></md-input-container><md-input-container flex="33" flex-xs="100" flex-gt-md="25" class="mt-3"><label data-translate="codes.model.user-lastname"></label><input ng-model="vm.searchRequest.userLastName"></md-input-container><md-input-container flex="33" flex-xs="100" flex-gt-md="25" class="mt-3"><label data-translate="codes.model.user-role"></label><md-select ng-change="vm.search()" ng-model="vm.searchRequest.userRole"><md-option ng-if="vm.searchRequest.userRole" ng-value="">{{\'global.button.clear\'| translate}}: {{\'codes.model.user-role\' | translate}}</md-option><md-option ng-repeat="value in vm.userRoles" ng-value="value.type.id">{{value.translationKey | translate}}</md-option></md-select></md-input-container><md-input-container flex="33" flex-xs="100" flex-gt-md="25" class="mt-3"><label data-translate="codes.model.control"></label><input ng-model="vm.searchRequest.control"></md-input-container><md-input-container flex="33" flex-xs="100" flex-gt-md="25" class="mt-3"><label data-translate="codes.model.code-type"></label><md-select ng-change="vm.search()" ng-model="vm.searchRequest.codeTypeId"><md-option ng-if="vm.searchRequest.codeTypeId" ng-value="">{{\'global.button.clear\'| translate}}: {{\'codes.model.code-type\' | translate}}</md-option><md-option ng-repeat="value in vm.codeTypes" ng-value="value.id">{{value.codeName}}</md-option></md-select></md-input-container><md-input-container md-no-float flex="33" flex-xs="100" flex-gt-md="25" class="mt-3"><label data-translate="codes.model.status">Status</label><md-select ng-change="vm.search()" ng-model="vm.searchRequest.status"><md-option ng-value="" ng-if="vm.searchRequest.status">{{\'global.button.clear\'| translate}}: {{\'codes.model.status\' | translate}}</md-option><md-option ng-value="value.id" ng-repeat="value in vm.statuses">{{ value.translateKey | translate }}</md-option></md-select></md-input-container><md-input-container md-no-float flex="33" flex-xs="100" flex-gt-md="25" class="mt-3"><label data-translate="codes.model.priority"></label><md-select ng-change="vm.search()" ng-model="vm.searchRequest.priority"><md-option ng-value="null" data-translate="global.button.clear"></md-option><md-option ng-value="true" data-translate="global.search.yes"></md-option><md-option ng-value="false" data-translate="global.search.no"></md-option></md-select></md-input-container><md-input-container md-no-float flex="33" flex-xs="100" flex-gt-md="25" class="mt-3" ng-if="vm.isSuperAdmin"><label data-translate="payments.table.payment.type"></label><md-select ng-change="vm.search()" placeholder="{{\'payments.table.payment.type\' | translate}}" ng-model="vm.searchRequest.transactionType" layout-align="center center"><md-option ng-value="" ng-if="vm.searchRequest.transactionType"><em>{{\'global.button.clear\'| translate}}: {{\'payments.table.payment.type\' | translate}}</em></md-option><md-option ng-value="val.id" ng-repeat="val in vm.paymentTypes.arrayOfValues"><em>{{val.langKey | translate}}</em></md-option></md-select></md-input-container></div><div layout="row" ng-if="!vm.simpleSearch"><md-button aria-label="clear" class="md-raised" data-translate="global.button.clear.search" ng-click="vm.clear()"></md-button><md-button aria-label="search" class="md-raised md-primary" data-translate="global.button.search" ng-click="vm.search()" type="submit"></md-button></div></form>');
$templateCache.put('app/codes/codes.template.html','<div class="site-container"><div class="table-container"><header class="header"><h5><span data-translate="global.menu.codes"></span></h5></header><md-content layout="row" layout-margin><md-card flex><codes-search on-search="vm.search" request-payload="vm.requestPayload" paging-model="vm.pagingModel"></codes-search><md-progress-linear md-mode="indeterminate" ng-show="vm.pending"></md-progress-linear><md-table-container><table md-table md-row-select="true" multiple="true" ng-model="vm.selectedRows" md-progress="vm.pending"><thead md-head md-order="vm.pagingModel.order" md-on-reorder="vm.findAll"><tr md-row><th md-column md-order-by="control"><span data-translate="codes.model.transaction-number"></span></th><th md-column md-order-by="user.userEmail"><span data-translate="codes.model.user-email-address"></span></th><th md-column md-order-by="user.userSchoolType"><span data-translate="codes.model.user-role"></span></th><th md-column md-order-by="codeAccountCodeType.codeName"><span data-translate="codes.model.code-type"></span></th><th md-column><span data-translate="codes.model.priority"></span></th><th md-column md-order-by="paymentSystem"><span data-translate="codes.model.payment-system"></span></th><th md-column ng-if="vm.isSuperAdmin"><span data-translate="codes.model.provider-status"></span></th><th md-column md-order-by="paymentDate"><span data-translate="codes.model.payment-date"></span></th><th md-column md-order-by="useCodeDate"><span data-translate="codes.model.date-of-use"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="item in vm.items" md-select="item.id"><td md-cell class="word-break-all">{{item.transactionNumber}}</td><td md-cell>{{item.userEmailAddress}}</td><td md-cell>{{vm.userRoleIdTranslationMap[item.userRole] | translate}}</td><td md-cell>{{item.codeType}}</td><td md-cell><i ng-if="item.priority" class="material-icons text-success">check</i> <i ng-if="!item.priority" class="material-icons text-danger">clear</i></td><td md-cell>{{item.paymentSystem}}</td><td md-cell ng-if="vm.isSuperAdmin">{{item.providerStatus}}</td><td md-cell>{{item.paymentDate | date: \'yyyy-MM-dd HH:mm\'}}</td><td md-cell>{{item.dateOfUse | date: \'yyyy-MM-dd HH:mm\'}}</td></tr></tbody></table></md-table-container><paging page="vm.queryRequest.page" page-size="vm.requestPayload.pageSize" paging-action="vm.pagingAction(page)" show-first-last="true" show-prev-next="true" total="vm.totalItems"></paging></md-card></md-content></div></div>');
$templateCache.put('app/document-import/document-import.html','<div class="site-container"><div class="document-import" layout="column"><md-content class="users" layout="row"><header class="header"><h5 data-translate="document-import.header"></h5></header></md-content><md-progress-linear ng-if="vm.isLoading" md-mode="indeterminate"></md-progress-linear><md-content layout="row" flex="100" layout-wrap><md-card flex="49" flex-xs="100" flex-sm="100" layout-padding layout-align="space-between"><md-card-header layout="column" layout-align="center center" layout-xs="column"><span class="md-headline" data-translate="document-import.metadata.header"></span><p data-translate="document-import.metadata.instructions"></p></md-card-header><md-card-content><div layout="row" layout-align="end center"><md-button aria-label="metadata" ng-click="vm.downloadMetadataTemplate()" data-translate="document-import.metadata.file.template"></md-button></div><form class="dragbox has-advanced-upload" name="document-metadata-upload-form" role="form" novalidate><upload-file on-get-the-files="vm.uploadMetadataFiles" allow-multiple-files="true" files="vm.metadataFiles" is-disabled="vm.isLoading" is-loading="vm.isLoading" on-available-extensions="vm.availableMetadataFileExtensions"></upload-file></form></md-card-content></md-card><md-card flex="49" flex-xs="100" flex-sm="100" layout-padding layout-align="space-between"><md-card-header layout="column" layout-align="center center" layout-xs="column"><span class="md-headline" data-translate="document-import.files.header"></span><p data-translate="document-import.files.instructions"></p></md-card-header><md-card-content><form class="dragbox has-advanced-upload" name="document-files-upload-form" role="form" novalidate><upload-file on-get-the-files="vm.uploadDocumentFiles" allow-multiple-files="true" files="vm.documentFiles" max-size="\'100MB\'" is-loading="vm.isLoading" is-disabled="vm.isLoading" on-available-extensions="vm.availableDocumentFileExtensions"></upload-file></form></md-card-content></md-card></md-content><div class="table-container"><md-content layout="row" flex="100" ng-if="vm.shouldShowImportedDocumentsList()"><md-card flex><md-table-container flex layout-padding><table md-table><thead md-head><tr md-row><th md-column><span data-translate="document-import.metadata.table.header.status"></span></th><th md-column><span data-translate="document-import.metadata.table.header.file-name"></span></th><th md-column><span data-translate="document-import.metadata.table.header.title"></span></th><th md-column><span data-translate="document-import.metadata.table.header.author"></span></th><th md-column ng-if="vm.isSchool"><span data-translate="document.model.docu-coordinator.school"></span></th><th md-column ng-if="!vm.isSchool"><span data-translate="document-import.metadata.table.header.coordinator"></span></th><th md-column><span data-translate="document-import.metadata.table.header.document-kind"></span></th><th md-column><span data-translate="document-import.metadata.table.header.organisational-unit"></span></th><th md-column ng-if="vm.oldPhdYearColumn"><span data-translate="document.metric.old-phd-year"></span></th><th md-column ng-if="vm.isSchool"><span data-translate="document-import.metadata.table.header.subject"></span></th><th md-column><span data-translate="document-import.metadata.table.header.actions"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="importedDocument in vm.documentImportState.importedDocuments" ng-class="{\'row-with-added-document\': importedDocument.added,\n                                 \'row-with-validation-error\': importedDocument.validationErrorCodes.length > 0}"><td md-cell><span><md-tooltip md-delay="100" md-direction="top" class="tooltip-with-long-text" ng-bind-html="::vm.getImportedDocumentStatusTooltip(importedDocument)"></md-tooltip><i ng-if="::vm.getImportedDocumentState(importedDocument) === vm.importedDocumentState.VALIDATION_ERRORS" class="material-icons imported-document-validation-errors">warning</i> <i ng-if="::vm.getImportedDocumentState(importedDocument) === vm.importedDocumentState.READY" class="material-icons imported-document-ready">where_to_vote</i> <i ng-if="::vm.getImportedDocumentState(importedDocument) === vm.importedDocumentState.ADDING_ERROR" class="material-icons imported-document-adding-error">error</i> <i ng-if="::vm.getImportedDocumentState(importedDocument) === vm.importedDocumentState.ADDED" class="material-icons imported-document-added">check</i></span></td><td md-cell><span>{{importedDocument.fileName}}</span></td><td md-cell>{{importedDocument.title}}</td><td md-cell>{{importedDocument.author}}</td><td md-cell>{{importedDocument.coordinator}}</td><td md-cell>{{vm.documentKindById[importedDocument.documentKindId].labelTranslated}}</td><td md-cell>{{vm.organisationalUnitById[importedDocument.organisationalUnitId].orguniLabel}}</td><td md-cell ng-if="vm.oldPhdYearColumn">{{importedDocument.oldPhdYear}}</td><td md-cell ng-if="vm.isSchool">{{importedDocument.subject}}</td><td md-cell><md-button class="md-icon-button" ng-if="!importedDocument.added" ng-click="vm.deleteFromImport(importedDocument.fileName)"><md-tooltip md-delay="100" md-direction="top">{{ \'document-import.delete-from-import.tooltip\' | translate}}</md-tooltip><i class="material-icons">delete_forever</i></md-button></td></tr></tbody></table></md-table-container><div flex layout="row" layout-align="end center" layout-wrap><md-input-container><md-switch class="md-primary" aria-label="without" ng-model="vm.addWithoutChecking"><span data-translate="document-import.add-without-checking"></span></md-switch></md-input-container><md-button class="md-raised md-primary mr-5" aria-label="add" ng-disabled="vm.isLoading" ng-click="vm.addDocuments()" data-translate="document-import.add-documents.button"></md-button></div></md-card></md-content></div></div></div>');
$templateCache.put('app/online-order/online-order.html','<div class="landing landing-image online-order" layout="row" ng-if="vm.plagiatPlMode" ng-include src="\'app/online-order/plagiat-pl-mode.html\'"></div><div class="landing landing-image online-order" layout="row" ng-if="!vm.plagiatPlMode"><div class="landing-header" layout="row" flex-xs="100" flex-gt-xs="80" flex-offset-gt-xs="10" flex-sm="80" flex-gt-md="70" flex-offset-gt-md="15"><div flex flex-xs="20" layout-align="start center" class="pl-2"><div class="landing-header-logo-bg"><div class="landing-header-logo"></div></div></div><div flex flex-xs="80"><md-menu layout="row" class="menu-lang" ng-controller="JhiLanguageController as languageVm" layout-align="end end"><md-button aria-label="open" ng-click="$mdMenu.open()" data-translate="global.menu.language" translate-values="{lang: \'{{languageVm.pickedLanguage}}\'}"></md-button><md-menu-content width="3"><md-menu-item ng-repeat="language in languageVm.availableLanguages"><md-button type="button" aria-label="change Language" ng-click="languageVm.changeLanguage(language);">{{language | findLanguageFromKey}}</md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div class="online-order" layout="row" flex-xs="100" flex="100" ng-if="!vm.plagiatPlMode"><form name="form" class="mt-1 mb-5" ng-if="!vm.success"><div class="opacity-9" layout="row" layout-wrap flex-xs="100" flex-gt-xs="80" flex-offset-gt-xs="10" flex-sm="80" flex-gt-md="70" flex-offset-gt-md="15"><div flex="100" flex-xs="100" ng-include src="\'app/online-order/slider.html\'"></div><div flex="33" flex-xs="100"><md-card class="h-100"><md-card-title><md-card-title-text><span class="md-headline text-center" data-translate="online-order.company.header"></span></md-card-title-text></md-card-title><md-card-content><div layout-margin layout-align="center center"><md-input-container class="md-block"><label data-translate="online-order.company.name"></label><input name="companyName" ng-model="vm.uplObj.company.name" required type="text"><plagiat-ng-messages form-element="form.companyName"></plagiat-ng-messages></md-input-container><md-input-container class="md-block"><label data-translate="online-order.company.nip"></label><input name="nip" ng-model="vm.uplObj.company.nip" ng-pattern="/^(\\d-?){10}$/" required type="text"><plagiat-ng-messages form-element="form.nip" translate-values="{pattern: \'online-order.company.nip.errors.pattern\'}"></plagiat-ng-messages></md-input-container><md-input-container class="md-block"><label data-translate="online-order.company.street"></label><input name="companyStreet" ng-model="vm.uplObj.company.street" required type="text"><plagiat-ng-messages form-element="form.companyStreet"></plagiat-ng-messages></md-input-container><md-input-container class="md-block"><label data-translate="online-order.company.city"></label><input name="companyCity" ng-model="vm.uplObj.company.city" required type="text"><plagiat-ng-messages form-element="form.companyCity"></plagiat-ng-messages></md-input-container></div></md-card-content></md-card></div><div flex="33" flex-xs="100"><md-card class="h-100"><md-card-title><md-card-title-text><span class="md-headline text-center" data-translate="online-order.contact-person.header"></span></md-card-title-text></md-card-title><md-card-content><div layout-margin layout-align="center center"><md-input-container class="md-block"><label data-translate="register.form.firstname"></label><input name="firstname" ng-model="vm.uplObj.person.name" required type="text"><plagiat-ng-messages form-element="form.firstname"></plagiat-ng-messages></md-input-container><md-input-container class="md-block"><label data-translate="register.form.surname"></label><input name="surname" ng-model="vm.uplObj.person.surname" required type="text"><plagiat-ng-messages form-element="form.surname"></plagiat-ng-messages></md-input-container><md-input-container class="md-block"><label data-translate="register.form.email"></label><input name="email" ng-model="vm.uplObj.person.email" ng-pattern="/^.+@.+\\..+$/" required type="email"><plagiat-ng-messages form-element="form.email" translate-values="{pattern: \'global.form.email.pattern\'}"></plagiat-ng-messages></md-input-container><md-input-container class="md-block"><label data-translate="online-order.person.phone"></label><input name="phone" ng-model="vm.uplObj.person.phone" required type="text"><plagiat-ng-messages form-element="form.phone"></plagiat-ng-messages></md-input-container></div></md-card-content></md-card></div><div flex="33" flex-xs="100"><md-card class="h-100"><md-card-content><div layout-align="center center" layout-margin><md-input-container><md-checkbox aria-label="accept regulations" class="m-0 accept-data-processing" name="accepRegulations" ng-model="vm.uplObj.acceptRegulations" required><span data-translate="online-order.accept-terms.terms"></span><plagiat-ng-messages form-element="form.accepRegulations"></plagiat-ng-messages></md-input-container></div></md-card-content><md-card-actions layout="column" layout-align="center center"><div><h3 data-translate="online-order.number-of-characters.amount-to-pay" translate-values="{amount: \'{{vm.uplObj.totalPrice | number: 2}}\', currency: \'{{vm.currency}}\' }">SUMA:</h3></div><md-button type="button" id="submit Form" aria-label="next" class="md-raised md-primary pb-2" data-translate="online-order.button.next" ng-click="vm.submitForm(form)" ng-disabled="vm.pending"></md-button></md-card-actions><md-progress-linear ng-if="vm.pending" md-mode="indeterminate"></md-progress-linear></md-card></div></div></form><div ng-if="vm.success" class="opacity-9" flex layout="row" layout-align="center center"><div><md-card><md-card-title><md-card-title-text><span class="md-headline text-center" data-translate="online-order.message.success"></span></md-card-title-text></md-card-title><md-card-actions layout="row" layout-align="center center"><md-button aria-label="proforma invoice" class="md-raised md-primary" data-translate="online-order.get-proforma-invoice" ng-click="vm.getProformaInvoiceClick()" ng-disabled="vm.pending"></md-button></md-card-actions><md-progress-linear ng-if="vm.pending" md-mode="indeterminate"></md-progress-linear></md-card></div></div></div>');
$templateCache.put('app/online-order/plagiat-pl-mode.html','<div ng-include src="\'app/online-order/slider.html\'"></div><div class="text-center"><md-button ng-if="vm.plagiatPlMode" class="md-raised md-primary" data-translate="online-order.button.go-to-order" ng-click="vm.redirectFromMainPage()"></md-button></div>');
$templateCache.put('app/online-order/slider.html','<md-card><md-card-content><div><span><p style="text-align: justify" class="m-0" data-translate="online-order.top-text">System antyplagiatowy dla klient\xF3w biznesowych...</p></span></div><md-card-title><md-card-title-text><span class="md-headline text-center" data-translate="online-order.choose-unit"></span></md-card-title-text></md-card-title><md-radio-group ng-model="vm.uplObj.unit" layout="row" layout-xs="column" layout-align="center center" class="md-primary" ng-change="vm.refreshSlider()"><md-radio-button ng-repeat="unit in vm.units" ng-value="unit.value" aria-label="unit.value" class="w-100 m-0"><span data-translate="{{unit.dataTranslate}}"></span></md-radio-button></md-radio-group><rzslider id="slider" rz-slider-model="vm.uplObj.charactersQuantity" rz-slider-options="vm.slider.options"></rzslider><div class="text-center"><h3 class="text-center" data-translate="online-order.number-of-characters.amount-discounted" translate-values="{amount: \'{{vm.uplObj.amountDiscounted | number: 2}}\', currency: \'{{vm.currency}}\' }"></h3></div><div><span data-translate="online-order.under-price">Dodatkowy tekt pod cen\u0105 i rabatem</span></div><div class="mt-3" layout="row" layout-xs="column"><div flex="33" flex-xs="100" class="pr-3" ng-if="vm.brand !== \'int\'"><md-tooltip class="tooltip-with-long-text" md-delay="100" md-direction="top">{{\'online-order.ai-detection.tooltip\'| translate}}</md-tooltip><md-checkbox ng-model="vm.uplObj.aiDetection" aria-label="ai-detection" ng-change="vm.calculatePrice()"><span data-translate="online-order.ai-detection" class="add-without-checking-switch-text" translate-values="{amount: \'{{vm.aiDetectionPrice | number: 0}}\', currency: \'{{vm.currency}}\' }">Zamawiam ai-detection. Koszt 2500 pln netto.</span></md-checkbox></div><div flex="33" flex-xs="100" class="pr-3" ng-if="vm.brand !== \'int\'"><md-tooltip class="tooltip-with-long-text" md-delay="100" md-direction="top">{{\'online-order.grammar-check.tooltip\'| translate}}</md-tooltip><md-checkbox ng-model="vm.uplObj.grammarCheck" aria-label="grammar-check" ng-change="vm.calculatePrice()"><span data-translate="online-order.grammar-check" class="add-without-checking-switch-text" translate-values="{amount: \'{{vm.grammarCheckPrice | number: 0}}\', currency: \'{{vm.currency}}\' }">Zamawiam grammarCheck. Koszt 1500 pln netto.</span></md-checkbox></div><div flex="33" flex-xs="100" class="pr-3" ng-if="vm.brand !== \'int\'"><md-tooltip class="tooltip-with-long-text" md-delay="100" md-direction="top">{{\'online-order.integration.tooltip\'| translate}}</md-tooltip><md-checkbox ng-model="vm.uplObj.integration" aria-label="integration" ng-change="vm.calculatePrice()"><span data-translate="online-order.integration" class="add-without-checking-switch-text" translate-values="{amount: \'{{vm.integrationPrice | number: 0}}\', currency: \'{{vm.currency}}\' }">Zamawiam integration. Koszt 1500 pln netto.</span></md-checkbox></div></div><div class="mt-3" layout="row" layout-xs="column" ng-if="vm.uplObj.integration"><md-radio-group ng-model="vm.uplObj.integrationType" flex layout="row" layout-margin layout-align="center center" required><div flex="20" data-translate="online-order.integration-type"></div><md-radio-button flex="20" ng-click="vm.radioChange(n)" ng-repeat="n in [\'Editorial\', \'OJS\', \'Moodle\', \'online-order.integration-type-other\']" ng-value="n" aria-label="integration-type {{n}}" class="md-primary">{{ n | translate }}</md-radio-button></md-radio-group></div><div class="mt-3" layout="row" layout-xs="column"><div flex="33" flex-xs="100" class="pr-3"><md-tooltip class="tooltip-with-long-text" md-delay="100" md-direction="top">{{\'online-order.training1.tooltip\'| translate}}</md-tooltip><md-checkbox ng-model="vm.uplObj.training1" aria-label="training1" ng-change="vm.toggleTraining1()"><span data-translate="online-order.training1" class="add-without-checking-switch-text" translate-values="{amount: \'{{vm.pricelist.training1 | number: 0}}\', currency: \'{{vm.currency}}\' }">Zamawiam szkolenie zdalne. Koszt 840 pln netto.</span></md-checkbox></div><div flex="33" flex-xs="100" class="pr-3" ng-if="vm.brand !== \'int\'"><md-tooltip class="tooltip-with-long-text" md-delay="100" md-direction="top">{{\'online-order.training2.tooltip\'| translate}}</md-tooltip><md-checkbox ng-model="vm.uplObj.training2" aria-label="training2" ng-change="vm.toggleTraining2()"><span data-translate="online-order.training2" class="add-without-checking-switch-text" translate-values="{amount: \'{{vm.pricelist.training2 | number: 0}}\', currency: \'{{vm.currency}}\' }">Zamawiam szkolenie stacjonarne. Koszt 2500 pln netto.</span></md-checkbox></div><div flex="33" flex-xs="100" class="pr-3" ng-if="vm.brand !== \'int\'"><md-tooltip class="tooltip-with-long-text" md-delay="100" md-direction="top">{{\'online-order.ai-detection-training.tooltip\'| translate}}</md-tooltip><md-checkbox ng-model="vm.uplObj.aiDetectionTraining" aria-label="ai-detection-training" ng-change="vm.calculatePrice()" ng-disabled="!(vm.uplObj.training1 || vm.uplObj.training2)"><span data-translate="online-order.ai-detection-training" class="add-without-checking-switch-text" translate-values="{amount: \'{{vm.pricelist.aiDetectionTraining | number: 0}}\', currency: \'{{vm.currency}}\' }">Zamawiam ai-detection-training. Koszt 2500 pln netto.</span></md-checkbox></div></div><div class="mt-3"><span data-translate="online-order.under-options">Dodatkowy tekt pod opcjami</span></div></md-card-content></md-card>');
$templateCache.put('app/statistics/statistics.html','<div class="site-container" id="statistics"><statistics-submenu active-tab="vm.activeTab" ng-if="vm.isSuperAdmin"></statistics-submenu><header class="header"><h5 data-translate="statistics.title"></h5></header><md-content layout="row"><md-card flex="34" flex-xs="100"><header class="header"><h5 data-translate="statistics.choose"></h5></header><form name="form"><md-card-content ng-if="vm.isSuperAdmin || vm.isMinistry"><div layout="row" layout-wrap><md-input-container layout="row" flex="100"><md-autocomplete class="white-background" md-input-minlength="2" md-selected-item="vm.selectedClient" md-search-text="vm.searchClient" md-items="client in vm.querySearchClients(vm.searchClient)" md-selected-item-change="vm.clientChange()" md-item-text="client.clieName + \' [\' + client.id + \']\'" md-min-length="0" md-floating-label="{{\'global.model.clientname\'| translate}}" md-clear-button="true" ng-required="vm.option.id !== 5" md-require-match="true" md-select-on-match="true" ng-model-options="{ debounce: vm.simpleSearchDelay }"><md-item-template><span md-highlight-text="vm.searchClient" md-highlight-flags="^i">{{client.clieName}} [{{client.id}}]</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{vm.searchClient}}"</md-not-found></md-autocomplete></md-input-container></div></md-card-content><md-card-content><md-radio-group ng-model="vm.option" ng-change="vm.change()"><md-radio-button ng-value="vm.options.DOCUMENTS" class="md-primary">{{vm.options.DOCUMENTS.translationKey | translate}}</md-radio-button><md-radio-button ng-value="vm.options.AI_DETECTION" class="md-primary" ng-if="vm.aiDetectionEnabled">{{vm.options.AI_DETECTION.translationKey | translate}}</md-radio-button><md-radio-button ng-value="vm.options.UNIT_CONTRACT" class="md-primary" ng-if="!vm.isMinistry">{{vm.options.UNIT_CONTRACT.translationKey | translate}}</md-radio-button><md-radio-button ng-value="vm.options.USER_CONTRACT" class="md-primary" ng-if="!vm.isMinistry">{{vm.options.USER_CONTRACT.translationKey | translate}}</md-radio-button><md-radio-button ng-value="vm.options.DOCUMENTS_CHECKED" class="md-primary" ng-if="!vm.isMinistry"><div>{{vm.options.DOCUMENTS_CHECKED.translationKey | translate}}</div><div class="radio-info">{{\'statistics.documents.checked.info\' | translate}}</div></md-radio-button><md-radio-button ng-if="!vm.noCoefficients" ng-value="vm.options.COEFFICIENT_DISTRIBUTION" class="md-primary">{{vm.options.COEFFICIENT_DISTRIBUTION.translationKey | translate}}</md-radio-button><md-radio-button ng-value="vm.options.NUMBER_OF_USERS" class="md-primary">{{vm.options.NUMBER_OF_USERS.translationKey | translate}}</md-radio-button><md-radio-button ng-value="vm.options.NUMBER_OF_AUTHORS" class="md-primary">{{vm.options.NUMBER_OF_AUTHORS.translationKey | translate}}</md-radio-button></md-radio-group></md-card-content><div ng-if="vm.option.id == 4" layout-padding ng-include src="\'app/statistics/views/coefficient-distribution-options.html\'"></div><div ng-if="vm.option.id !== 5" layout-xl="row" layout-lg="column" layout-padding><md-input-container flex class="mb-3"><label data-translate="{{\'statistics.model.datefrom\'| translate}}">Data od</label><md-datepicker ng-model="vm.dateFrom" input-date></md-datepicker></md-input-container><md-input-container flex><label data-translate="{{\'statistics.model.dateto\'| translate}}">Data do</label><md-datepicker ng-model="vm.dateTo" input-date></md-datepicker></md-input-container></div><div layout="row" layout-align="center center"><md-button type="submit" aria-label="generate" class="md-raised md-primary" ng-click="vm.generate()" ng-disabled="form.$invalid" data-translate="statistics.generate"></md-button></div></form></md-card><md-card flex="65" flex-xs="100"><header class="header"><h5 data-translate="{{vm.option.translationKey}}"></h5></header><div class="loader relative" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-if="vm.loading"></md-progress-circular></div><div ng-if="!vm.loading && vm.data"><div class="content" ng-switch="vm.option.id"><div ng-switch-when="0"><div ng-include src="\'app/statistics/views/documents-statistics-table.html\'"></div></div><div ng-switch-when="1"><div ng-include src="\'app/statistics/views/units-statistics-table.html\'"></div></div><div ng-switch-when="2"><div ng-include src="\'app/statistics/views/users-statistics-table.html\'"></div></div><div ng-switch-when="3"><div ng-include src="\'app/statistics/views/checks-statistics-table.html\'"></div></div><div ng-switch-when="4"><div ng-include src="\'app/statistics/views/coefficient-distribution-table.html\'"></div></div><div ng-switch-when="5"><div ng-include src="\'app/statistics/views/number-of-users-statistics-table.html\'"></div></div><div ng-switch-when="6"><div ng-include src="\'app/statistics/views/ai-detection-statistics-table.html\'"></div></div><div ng-switch-when="7"><div ng-include src="\'app/statistics/views/number-of-authors-statistics-table.html\'"></div></div></div><md-button type="submit" aria-label="generate" class="md-raised md-primary search-buttons" ng-click="vm.generateExcelFile()" data-translate="statistics.xls.generate"></md-button></div><div class="loader relative" layout="row" layout-align="space-around" ng-if="!vm.loading && !vm.data"><span data-translate="statistics.data.generate"></span></div></md-card></md-content></div>');
$templateCache.put('app/account/activate/activate.html','<div layout="column" flex class="unlogged login"><md-content layout="row"><form novalidate class="form" name="form"><div layout="row" layout-xs="column"><div class="login-logo" layout-xs="row" flex="50" flex-xs="100" layout-align="end start" layout-align-xs="center center" flex-gt-sm></div><div layout-xs="row" flex-xs="100" flex="50" layout-align="end start" layout-align-xs="center center" layout-padding class="choose-lang" flex-gt-sm><lang-select></lang-select></div></div><div flex="100" layout="column"><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch><md-card-title><md-card-title-text layout="row" layout-xs="column" layout-align="center center"><span class="md-headline login-header" data-translate="activate.title"></span></md-card-title-text></md-card-title><md-card-content class="md-padding"><div layout-margin layout-align="center center" ng-show="vm.success"><div data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong></div></div><div layout-margin layout-align="center center" ng-show="vm.error"><div data-translate="activate.messages.error" translate-compile>> <strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div><div class="md-padding"><md-button aria-label="register" layout="column" layout-fill class="md-raised md-primary" ng-href="#/register" data-translate="register.form.button"></md-button></div></div></md-card-content></md-card></div></form></md-content></div>');
$templateCache.put('app/account/activate-set-password/activate-set-password.html','<div layout="column" flex class="unlogged login"><md-content layout="row"><form novalidate class="form" name="form" autocomplete="off"><div layout="row" layout-xs="column"><div class="login-logo" layout-xs="row" flex="50" flex-xs="100" layout-align="end start" layout-align-xs="center center" flex-gt-sm></div><div layout-xs="row" flex-xs="100" flex="50" layout-align="end start" layout-align-xs="center center" layout-padding class="choose-lang" flex-gt-sm><lang-select></lang-select></div></div><div flex="100" layout="column"><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}"><md-card-title><md-card-title-text layout="row" layout-xs="column" layout-align="center center"><span class="md-headline login-header" data-translate="activate.title"></span></md-card-title-text></md-card-title><md-card-content class="md-padding" md-theme-watch><div ng-show="!vm.uniqueKeyValid"><strong><span data-translate="activate.activation.link.incorrect"></span></strong><div class="md-padding"><md-button aria-label="login" layout="column" layout-fill class="md-raised md-primary" ng-href="#/login" data-translate="activate.go.to.login.page"></md-button></div></div><div ng-show="vm.uniqueKeyValid"><div ng-show="vm.passwordSetError"><strong><span data-translate="activate.messages.password.set.error"></span></strong></div><div ng-show="vm.passwordSetError" data-translate="activate.messages.error.user.already.activated" translate-compile></div><div ng-show="vm.passwordSetSuccess"><strong><span data-translate="activate.messages.password.has.been.set"></span></strong></div><div ng-show="vm.passwordSetSuccess || vm.passwordSetError"><div class="md-padding"><md-button aria-label="login" layout="column" layout-fill class="md-raised md-primary" ng-href="#/login" data-translate="activate.go.to.login.page"></md-button></div></div><div layout-margin layout-align="center center" ng-show="vm.success && !vm.alreadyActivated && !vm.passwordSetSuccess"><strong><div data-translate="activate.messages.success.for.created.user" translate-compile></div></strong></div><div ng-show="vm.success && !vm.passwordSetSuccess" layout-margin layout-align="center center"><div data-translate="activate.messages.success.password.info"></div><md-input-container class="md-block"><label data-translate="reset.finish.form.password"></label><input ng-model="vm.resetAccount.password" name="password" ng-attr-type="{{ vm.showPassword ? \'text\' : \'password\' }}" ng-minlength="8" ng-pattern="vm.passwordPattern" placeholder="{{\'global.form.password.placeholder\' | translate}}" autocomplete="off" required> <span class="password-eye" ng-click="vm.toggleShowPassword()"><i class="material-icons" ng-class="{\'visibility\': !vm.showPassword, \'visibility_off\': vm.showPassword}">{{vm.showPassword ? \'visibility\' : \'visibility_off\'}}</i></span><div ng-show="form.password.$error.required" class="md-input-messages-animation ng-active" data-translate="global.form.password.required"></div><div ng-show="form.password.$error.pattern" class="md-input-messages-animation ng-active" data-translate="global.form.password.pattern"></div><div ng-show="form.password.$error.minlength" class="md-input-messages-animation ng-active" data-translate="global.form.password.minlength"></div></md-input-container><md-input-container class="md-block"><label data-translate="reset.finish.form.retype-password"></label><input ng-model="vm.resetAccount.confirmedPassword" name="confirmedPassword" ng-minlength="8" ng-attr-type="{{ vm.showPassword ? \'text\' : \'password\' }}" ng-pattern="vm.passwordPattern" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" required ng-disabled="!vm.resetAccount.password"> <span class="password-eye" ng-click="vm.toggleShowPassword()"><i class="material-icons" ng-class="{\'visibility\': !vm.showPassword, \'visibility_off\': vm.showPassword}">{{vm.showPassword ? \'visibility\' : \'visibility_off\'}}</i></span><div ng-show="form.confirmedPassword.$error.required" class="md-input-messages-animation ng-active" data-translate="global.form.confirmed-password.required"></div><div ng-show="form.confirmedPassword.$error.pattern" class="md-input-messages-animation ng-active" data-translate="global.form.password.pattern"></div><div ng-show="form.confirmedPassword.$error.minlength" class="md-input-messages-animation ng-active" data-translate="global.form.password.minlength"></div></md-input-container></div><div class="md-padding" ng-show="vm.success && !vm.passwordSetSuccess"><md-button layout="column" layout-fill class="md-raised md-primary" ng-disabled="form.$invalid" ng-click="vm.setPassword()" data-translate="activate.save.password"></md-button></div></div></md-card-content></md-card></div></form></md-content></div>');
$templateCache.put('app/account/assignments/assignments-add.template.html','<div layout="column" class="site-container"><md-content class="users" layout="row"><div layout-align="center center"><header class="header"><h5 data-translate="assignment.edit.title"></h5></header></div></md-content><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div><md-content layout="row"><form name="form" flex><md-card flex><div layout="column" layout-xs="column" flex flex-xs="100" layout-padding><div layout="row" class="md-block p-0"><md-input-container class="md-block" flex flex-xs="100"><input name="assignmentShortcode" ng-model="vm.obj.shortcode" ng-required="true" placeholder="{{\'assignment.model.shortcode\' | translate}}" ng-change="vm.validateShortcode()" ng-model-options="{ debounce: vm.debounceDelay }"><plagiat-ng-messages form-element="form.assignmentShortcode"></plagiat-ng-messages></md-input-container><div><span><i class="material-icons cursor-pointer">info</i><md-tooltip class="tooltip-with-long-text" ng-bind-html="\'assignment.form.generate-shortcode-tooltip\' | translate"></md-tooltip></span><md-button id="generateButton" ng-click="vm.generate()" aria-label="generate assignment id" class="md-raised md-primary button-waiting" ng-disabled="vm.pending"><span data-translate="assignment.button.generate"></span></md-button></div></div><div layout="row" class="md-block p-0"><md-input-container flex flex-xs="100"><input name="assignmentTitle" ng-model="vm.obj.title" ng-required="true" placeholder="{{\'assignment.model.title\' | translate}}"><plagiat-ng-messages form-element="form.assignmentTitle"></plagiat-ng-messages></md-input-container><div layout="row" layout-margin flex="25" flex-xs="100" layout-align="end center" class="ml-2"><span><i class="material-icons cursor-pointer" ng-if="vm.obj.fixedTitle === undefined">info</i> <i class="material-icons cursor-pointer" ng-if="vm.obj.fixedTitle === true">edit_off</i> <i class="material-icons cursor-pointer" ng-if="vm.obj.fixedTitle === false">edit</i><md-tooltip class="tooltip-with-long-text" ng-bind-html="\'assignment.form.fixed-title-tooltip\' | translate"></md-tooltip></span><three-state-radio ng-model="vm.obj.fixedTitle" data-label="{{\'assignment.form.fixed-title\' | translate}}"></three-state-radio></div></div><md-input-container class="md-block" flex="50" flex-xs="100"><textarea name="assignmentDescription" ng-model="vm.obj.description" placeholder="{{\'assignment.model.description\' | translate}}" rows="3" md-select-on-focus></textarea></md-input-container><!--\n                    <div layout="row">\n                        <md-input-container flex="40" flex-md="100" flex-sm="100" flex-xs="100">\n                            <label data-translate="{{\'assignment.model.start-date\'| translate}}">Data startu</label>\n                            <md-datepicker ng-model="vm.obj.startDate" input-date ng-required="true" md-max-date="vm.obj.endDate"></md-datepicker>\n                        </md-input-container>\n                        <md-input-container flex="20" flex-sm="100" flex-xs="100">\n                            <label data-translate="{{\'assignment.model.start-time\'| translate}}">Czas startu</label>\n                            <input type="time" ng-disabled="!vm.obj.startDate" ng-model="vm.obj.startTime" ng-required="true">\n                        </md-input-container>\n                    </div>\n                    --><div flex layout="row" layout-align="space-between center"><div flex layout="row" layout-margin><md-input-container><label data-translate="{{\'assignment.model.end-date\'| translate}}">Data zako\u0144czenia</label><md-datepicker ng-model="vm.obj.endDate" input-date md-min-date="vm.obj.startDate"></md-datepicker></md-input-container><md-input-container><label data-translate="{{\'assignment.model.end-time\'| translate}}">Czas zako\u0144czenia</label><input type="time" ng-disabled="!vm.obj.endDate" ng-model="vm.obj.endTime"></md-input-container></div><div><div flex layout="row" ng-if="vm.aiDetectionEnabled"><i class="material-icons cursor-pointer pr-2">info</i><md-tooltip class="tooltip-with-long-text" ng-bind-html="\'assignment.form.ai-detection-tooltip\' | translate"></md-tooltip><three-state-radio ng-model="vm.obj.aiDetection" data-label="{{\'assignment.form.ai-detection\' | translate}}"></three-state-radio></div><div flex layout="row" ng-if="vm.grammarCheckEnabled" class="mt-1"><i class="material-icons cursor-pointer pr-2">info</i><md-tooltip class="tooltip-with-long-text" ng-bind-html="\'assignment.form.grammar-check-tooltip\' | translate"></md-tooltip><three-state-radio ng-model="vm.obj.grammarCheck" data-label="{{\'assignment.form.grammar-check\' | translate}}"></three-state-radio></div></div></div><md-input-container flex="50" flex-xs="100"><label data-translate="document.metric.client.promoter.type">Rodzaj dokumentu</label><md-select id="documentKindSelect1" name="documentKindSelect" aria-label="docu kinds" ng-model="vm.obj.documentKindId" ng-required="true"><md-option id="idOptionDocuKind{{$index}}" ng-value="val.value" ng-repeat="val in vm.docuKinds">{{val.label | translate}}</md-option></md-select><plagiat-ng-messages form-element="form.documentKindSelect"></plagiat-ng-messages></md-input-container><md-chips flex="100" aria-label="email address" name="documentAddresses" ng-if="vm.obj.peerReviewEnabled" ng-model="vm.obj.emailAddresses" md-transform-chip="vm.transformEmailAddress($chip)" md-add-on-blur="true" md-on-remove="vm.onClickRemoveEmail($chip)" md-removable="vm.obj.peerReview.feedbackUploadedDocCount === 0 || vm.obj.peerReview.feedbackUploadedDocCount === undefined" placeholder="{{\'assignment.form.email-adresses-placeholder\' | translate}}" readonly="vm.obj.peerReview.feedbackUploadedDocCount > 0"></md-chips><md-chips flex="100" flex-xs="100" aria-label="email address" name="documentAddresses" ng-if="!vm.obj.peerReviewEnabled" ng-model="vm.obj.emailAddresses" readonly="false" md-removable="true" placeholder="{{\'assignment.form.email-adresses-placeholder\' | translate}}" md-transform-chip="vm.transformEmailAddress($chip)" md-add-on-blur="true"><md-chip-template>{{$chip}}</md-chip-template></md-chips><div layout="row" class="errors" layout-wrap layout-margin ng-if="vm.emailAddressesInvalid || vm.emailAddressesNotRegistered || vm.emailAddressesNotStudent"><div ng-if="vm.emailAddressesInvalid"><span data-translate="assignment.form.email.invalid"></span> : {{vm.emailAddressesInvalid}}</div><div ng-if="vm.emailAddressesNotRegistered"><span data-translate="assignment.form.email.not-registered"></span> : {{vm.emailAddressesNotRegistered}}</div><div ng-if="vm.emailAddressesNotStudent"><span data-translate="assignment.form.email.not-student"></span> : {{vm.emailAddressesNotStudent}}</div></div></div><div flex layout="column" ng-if="vm.clientSettingPeerReviewEnabled" ng-include src="\'app/account/assignments/peer-review/peer-review.html\'"></div></md-card><div layout="row" flex layout-align="end center"><md-button id="cancelButton" aria-label="assignment-add-cancel" ui-sref="assignments" data-translate="global.form.button.cancel"></md-button><md-button id="saveButton" ng-click="vm.saveOrUpdate(form)" aria-label="save assignment" class="md-raised md-primary button-waiting" ng-disabled="vm.pending"><span data-translate="global.form.button.save"></span></md-button></div></form></md-content></div>');
$templateCache.put('app/account/assignments/assignments-submit.html','<div class="site-container"><div class="table-container"><header class="header"><h5 data-translate="assignment.submit.page.title"></h5><span class="header-description" data-translate="assignment.submit.page.header.info">opis</span></header><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div><md-content layout="row" flex="100" layout-wrap><md-card flex="49" flex-xs="100" flex-sm="100" layout-padding layout-align="space-between"><md-card-content><div layout="row"><form class="dragbox has-advanced-upload" name="form" role="form" novalidate><upload-file on-get-the-files="vm.getTheFiles" allow-multiple-files="true" files="vm.files" is-disabled="vm.pending" is-loading="vm.pending" on-available-extensions="vm.availableExtension"></upload-file></form></div><form name="form2"><div ng-repeat="sub in vm.submits track by $index" layout="column"><div flex="100" flex-xs="100" layout-align="start center"><span>{{$index +1}}: </span><span data-translate="assignment.model.filename">filename:</span> <span>{{sub.filename}}</span></div><div layout="row"><md-input-container class="md-block" flex="45" flex-xs="100"><input name="author" ng-model="sub.title" ng-required="true" placeholder="{{\'assignment.model.title\' | translate}}"></md-input-container><md-input-container class="md-block" flex="45" flex-xs="100"><input name="author" ng-model="sub.author" ng-required="true" placeholder="{{\'document.model.author\' | translate}}"></md-input-container><div ng-click="vm.remove(sub)"><i class="material-icons icon-red cursor-pointer">delete_forever</i></div></div></div><div layout="row" layout-align="end center" layout-padding><md-button aria-label="can" id="cancelButton" ng-click="vm.backToList()" data-translate="global.form.button.cancel"></md-button><md-button aria-label="sav" id="saveButton" ng-click="vm.save()" class="md-raised md-primary button-waiting" ng-disabled="form2.$invalid || vm.submits.length == 0 || vm.pending"><span data-translate="global.form.button.save"></span></md-button></div></form></md-card-content></md-card></md-content></div></div>');
$templateCache.put('app/account/assignments/assignments.html','<div class="site-container"><div class="table-container"><header class="header"><h5 data-translate="global.menu.account.assignments"></h5><span class="header-description" data-translate="assignment.page.header.info">opis</span></header><md-content layout="row" layout-margin><md-card aria-hidden="false" flex><form name="formSearchAssignments"><div layout-margin layout-wrap><div layout="row" layout-align="end center" ng-if="vm.canAddAssignment"><md-button id="addAssignmentButton" aria-label="assignment-add" ui-sref="assignment-add" class="md-raised md-primary button-waiting" data-translate="global.button.add"></md-button></div><div layout="row" layout-padding layout-wrap><select-page-size flex="25" layout="row" layout-align="start center" query-request="vm.queryRequest" on-value-chosen="vm.getAssignmentsPage(1)"></select-page-size><div flex="75" flex-sm="75" flex-xs="100" layout="row" layout-align="end center" layout-sm="column"><md-input-container class="md-block" flex="70" flex-xs="100" layout-align="end center" md-no-float ng-if="vm.simpleSearch"><input ng-change="vm.getAssignments()" ng-model="vm.searchRequest.simpleSearch" ng-model-options="{ debounce: vm.simpleSearchDelay }" placeholder="{{\'global.search.title\'| translate}}"></md-input-container><div flex="40" flex-xs="100" layout="row" layout-align="end center"><md-button ng-if="vm.simpleSearch" data-translate="global.button.search.advanced" aria-label="advanced" ng-click="vm.toggleSearch()"></md-button><md-button ng-if="!vm.simpleSearch" data-translate="global.button.search.simple" aria-label="simple" ng-click="vm.toggleSearch()"></md-button></div></div></div><div layout="row" layout-xs="column" ng-if="!vm.simpleSearch" layout-wrap><div layout="row" layout-margin layout-wrap flex="100"><md-input-container flex="30" flex-xs="100" class="mt-3"><label data-translate="assignment.model.shortcode"></label><input ng-model="vm.searchRequest.search.shortcode"></md-input-container><md-input-container flex="30" flex-xs="100" class="mt-3"><label data-translate="assignment.model.type"></label><md-select ng-change="vm.getAssignments()" ng-model="vm.searchRequest.search.type"><md-option ng-value="" ng-if="vm.searchRequest.search.type">{{\'global.button.clear\'| translate}}: {{\'assignment.model.type\' | translate}}</md-option><md-option ng-value="value.id" ng-repeat="value in vm.types">{{ value.translateKey | translate }}</md-option></md-select></md-input-container><md-input-container flex="30" flex-xs="100" class="mt-3"><label data-translate="assignment.model.title"></label><input ng-model="vm.searchRequest.search.title"></md-input-container><md-input-container md-no-float flex="30" flex-xs="100" class="mt-3"><label data-translate="document.model.status">Status</label><md-select ng-change="vm.getAssignments()" ng-model="vm.searchRequest.search.status"><md-option ng-value="" ng-if="vm.searchRequest.search.status">{{\'global.button.clear\'| translate}}: {{\'document.model.status\' | translate}}</md-option><md-option ng-value="value.id" ng-repeat="value in vm.statuses">{{ value.translateKey | translate }}</md-option></md-select></md-input-container></div></div><div layout="row" layout-xs="column" ng-if="!vm.simpleSearch" layout-wrap><div layout="row" layout-margin layout-wrap flex="100"><md-input-container flex="22" flex-sm="100" flex-xs="100"><label data-translate="{{\'assignment.model.start-date-from\'| translate}}">Data startu od</label><md-datepicker ng-change="vm.getAssignments()" ng-model="vm.searchRequest.search.startDateFrom" input-date></md-datepicker></md-input-container><md-input-container flex="22" flex-sm="100" flex-xs="100"><label data-translate="{{\'assignment.model.start-date-to\'| translate}}">Data startu do</label><md-datepicker ng-change="vm.getAssignments()" ng-model="vm.searchRequest.search.startDateTo" input-date></md-datepicker></md-input-container><md-input-container flex="22" flex-sm="100" flex-xs="100"><label data-translate="{{\'assignment.model.end-date-from\'| translate}}">Data zako\u0144czenia od</label><md-datepicker ng-change="vm.getAssignments()" ng-model="vm.searchRequest.search.endDateFrom" input-date></md-datepicker></md-input-container><md-input-container flex="22" flex-sm="100" flex-xs="100"><label data-translate="{{\'assignment.model.end-date-to\'| translate}}">Data zako\u0144czenia do</label><md-datepicker ng-change="vm.getAssignments()" ng-model="vm.searchRequest.search.endDateTo" input-date></md-datepicker></md-input-container></div></div><div layout="row" ng-if="!vm.simpleSearch"><md-button aria-label="clear" class="md-raised" data-translate="global.button.clear.search" ng-click="vm.clear()"></md-button><md-button aria-label="search" class="md-raised md-primary" data-translate="global.button.search" ng-click="vm.getAssignments()" type="submit"></md-button></div></div></form><md-table-container><table id="tableAssignments" md-table md-progress="vm.promise"><thead md-head md-order="vm.queryRequest.order" md-on-reorder="vm.getAssignments"><tr md-row><th md-column><span>#</span></th><th md-column ng-if="vm.isAdmin"><span data-translate="assignment.model.owner"></span></th><th md-column md-order-by="shortcode"><span data-translate="assignment.model.shortcode"></span></th><th md-column md-order-by="type"><span data-translate="assignment.model.type"></span></th><th md-column md-order-by="title"><span data-translate="assignment.model.title"></span></th><th md-column md-order-by="startDate"><span data-translate="assignment.model.start-date"></span></th><th md-column md-order-by="endDate"><span data-translate="assignment.model.end-date"></span></th><th md-column><span data-translate="assignment.model.peer-review.due-date"></span></th><th md-column><span data-translate="assignment.model.peer-review.post-date"></span></th><th md-column><span data-translate="document.model.status"></span></th><th md-column><span data-translate="assignment.model.avg-sc1"></span></th><th md-column><span data-translate="assignment.model.submissions"></span></th><th md-column ng-if="vm.canSubmitToAssignment"></th><th md-column class="table-actions"><span data-translate="global.table.actions"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="row in vm.assignments"><td md-cell ng-click="vm.getDetails(row)"><span ng-show="!vm.isLoadingData">{{($index + 1) + ((vm.queryRequest.page - 1) * vm.queryRequest.limit)}}</span></td><td md-cell ng-click="vm.getDetails(row)" ng-if="vm.isAdmin">{{row.owner}}</td><td md-cell ng-click="vm.getDetails(row)">{{row.shortcode}}</td><td md-cell ng-click="vm.getDetails(row)"><span>{{\'assignment.type.\' + row.type | translate}}</span></td><td md-cell ng-click="vm.getDetails(row)">{{row.title}}</td><td md-cell ng-click="vm.getDetails(row)">{{row.startDate | date: \'yyyy-MM-dd\'}}</td><td md-cell ng-click="vm.getDetails(row)">{{row.endDate | date: \'yyyy-MM-dd HH:mm\'}}</td><td md-cell ng-click="vm.getDetails(row)">{{row.peerReviewDueDate | date: \'yyyy-MM-dd\'}}</td><td md-cell ng-click="vm.getDetails(row)">{{row.peerReviewPostDate | date: \'yyyy-MM-dd\'}}</td><td md-cell ng-click="vm.getDetails(row)"><span ng-if="row.status == 0"><md-tooltip md-delay="100" md-direction="top">{{\'assignment.table.status.in-progress\'| translate}}</md-tooltip><i class="material-icons icon-primary">pending_actions</i> </span><span ng-if="row.status == 1"><md-tooltip md-delay="100" md-direction="top">{{\'assignment.table.status.terminated\'| translate}}</md-tooltip><i class="material-icons icon-picked">flaky</i> </span><span ng-if="row.status == 2"><md-tooltip md-delay="100" md-direction="top">{{\'assignment.table.status.ended\'| translate}}</md-tooltip><i class="material-icons icon-success">check_circle_outline</i></span></td><td md-cell ng-click="vm.getDetails(row)">{{row.avgSc1| percentage:2}}</td><td md-cell ng-click="vm.getDetails(row)"><span ng-if="row.draftCount > 0">{{row.submissionCount}} / {{row.draftCount + row.submissionCount}}</span> <span ng-if="row.draftCount == 0">{{row.submissionCount}}</span><md-button aria-label="open" class="md-icon-button" ng-click="vm.showSubmissions(row)"><i class="material-icons-outlined">format_list_bulleted</i><md-tooltip md-delay="100" md-direction="top">{{\'assignment.table.show-submissions.button.tooltip\'| translate}}</md-tooltip></md-button></td><td md-cell ng-if="vm.canSubmitToAssignment"><div class="d-inline-flex documents-buttons-report"><md-button aria-label="submit-to-assignment" class="md-raised md-button priority-check" ng-click="vm.submitToAssignment(row)" ng-if="row.status != 2"><span data-translate="document.table.submit-assignment.button.label"></span><md-tooltip md-delay="100" md-direction="top">{{\'document.table.submit-assignment.button.tooltip\'| translate}}</md-tooltip></md-button></div></td><td md-cell><div flex layout="row" layout-align="end center"><md-menu-bar flex layout="row"><md-menu><md-button aria-label="open" class="md-icon-button" ng-click="$mdMenu.open()"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item ng-if="row.status != 2"><md-button id="tableOptionEdit{{$index}}" aria-label="edit assignment" ui-sref="assignment-add({id: row.id})" data-translate="global.table.menu.edit"></md-button></md-menu-item><md-menu-item><md-button id="tableOptionDuplicate{{$index}}" aria-label="duplicate" ng-click="vm.onClickDuplicate(row)" data-translate="global.table.menu.duplicate"></md-button></md-menu-item><md-menu-item ng-if="row.status != 2"><md-button id="tableOptionClose{{$index}}" aria-label="close assignment" ng-click="vm.closeAssignment(row)" data-translate="global.table.menu.close"></md-button></md-menu-item><md-menu-item ng-if="row.status == 2"><md-button id="tableOptionReopen{{$index}}" aria-label="reopen assignment" ng-click="vm.reopenAssignment(row)" data-translate="global.table.menu.reopen"></md-button></md-menu-item><md-menu-item ng-if="row.type === \'peer_review\'"><md-button id="tableOptionPeerReviewScoring{{$index}}" aria-label="peer review scoring" ng-click="vm.onOpenScoringClick(row)" data-translate="global.table.menu.scoring"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div></md-table-container><div flex><div layout="row" layout-align="end center" layout-wrap><paging page="vm.queryRequest.page" page-size="vm.queryRequest.limit" paging-action="vm.getAssignmentsPage(page)" show-first-last="true" show-prev-next="true" total="vm.totalAssignments"></paging><div layout="row" class="go-to" flex-xs="100" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to next page" ng-model="vm.queryRequest.page" type="number" ng-keyup="vm.getAssignments()" ng-change="vm.getAssignments()"></md-input-container></div></div></div></md-card></md-content></div></div>');
$templateCache.put('app/account/confirm-account-deletion/confirm-account-deletion.html','<div layout="column" flex class="unlogged"><md-content layout="row"><form novalidate class="form" name="form"><div layout="row" layout-xs="column"><div class="login-logo" layout-xs="row" flex="50" flex-xs="100" layout-align="end start" layout-align-xs="center center" flex-gt-sm></div><div layout-xs="row" flex-xs="100" flex="50" layout-align="end start" layout-align-xs="center center" layout-padding class="choose-lang" flex-gt-sm><lang-select></lang-select></div></div><div ng-if="vm.removalComplete"><md-card><md-card-title><md-card-title-text layout-align="center center"><span class="md-headline mt-3 mb-3">{{ \'delete-account.complete\' | translate }}</span></md-card-title-text></md-card-title></md-card></div></form></md-content></div>');
$templateCache.put('app/account/confirm-email/confirm-email.html','<div layout="column" flex class="unlogged login"><md-content layout="row"><form novalidate class="form" name="form"><div layout="row" layout-xs="column"><div class="login-logo" layout-xs="row" flex="50" flex-xs="100" layout-align="end start" layout-align-xs="center center" flex-gt-sm></div><div layout-xs="row" flex-xs="100" flex="50" layout-align="end start" layout-align-xs="center center" layout-padding class="choose-lang" flex-gt-sm><lang-select></lang-select></div></div><div flex="100" layout="column"><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch><md-card-title><md-card-title-text layout="row" layout-xs="column" layout-align="center center"><span class="md-headline login-header" data-translate="confirm.email.title"></span></md-card-title-text></md-card-title><md-card-content class="md-padding"><div layout-margin layout-align="center center" ng-show="vm.success"><div data-translate="confirm.email.success" translate-compile></div></div><div layout-margin layout-align="center center" ng-show="vm.error"><div data-translate="confirm.email.error" translate-compile></div></div></md-card-content><div class="md-padding" layout-margin><md-button aria-label="Login" layout="column" layout-fill class="md-raised" ui-sref="login" data-translate="global.button.login"></md-button></div></md-card></div></form></md-content></div>');
$templateCache.put('app/account/comparision/comparision.html','<div layout="column" class="site-container"><md-content layout="row"><md-card flex layout-margin><md-card-title><md-card-title-text layout="row" layout-align="start"><span class="md-headline" data-translate="comparision.page-title"></span></md-card-title-text></md-card-title><md-card-content><form name="form" ng-cloak><div layout="row" layout-padding="5px"><div flex="50"><div class="dragbox dragbox-big has-advanced-upload"><div class="button dragbox-input" ngf-max-size="100MB" ngf-select="vm.getBaseFiles($files,$invalidFiles)" ngf-drop="vm.getBaseFiles($files,$invalidFiles)"><div class="dragbox-icon-cloud"><i class="material-icons">backup</i></div><label class="overflow-hidden"><strong ng-if="vm.filesBaseError" data-translate="global.messages.error.text-retrieval-error">Import</strong> <strong data-translate="document-import.add-documents.button">Import</strong> <span class="dragbox-dragndrop" data-translate="document.toupload"></span></label></div></div><span data-translate="comparision.label1">label1</span><md-input-container flex="100" layout-align="start center" md-no-float class="md-block"><input ng-model="vm.obj.title1" placeholder="{{\'comparision.title1\'| translate}}" aria-label="t1" required></md-input-container><md-input-container class="md-block"><textarea ng-model="vm.obj.content1" placeholder="{{\'comparision.content1\'| translate}}" aria-label="c1" style="min-height: 290px" required></textarea></md-input-container></div><div flex="50"><div class="dragbox dragbox-big has-advanced-upload"><div class="button dragbox-input" name="files" ngf-max-size="100MB" ngf-select="vm.getComparedFiles($files,$invalidFiles)" ngf-drop="vm.getComparedFiles($files,$invalidFiles)"><div class="dragbox-icon-cloud"><i class="material-icons">backup</i></div><label class="overflow-hidden"><strong ng-if="vm.filesComparedError" data-translate="global.messages.error.text-retrieval-error">Import</strong> <strong data-translate="document-import.add-documents.button">Import</strong> <span class="dragbox-dragndrop" data-translate="document.toupload"></span></label></div></div><span data-translate="comparision.label2">label2</span><md-input-container flex="100" layout-align="start center" md-no-float class="md-block"><input ng-model="vm.obj.title2" placeholder="{{\'comparision.title2\'| translate}}" aria-label="t2" required></md-input-container><md-input-container class="md-block"><textarea ng-model="vm.obj.content2" placeholder="{{\'comparision.content2\'| translate}}" aria-label="c2" style="min-height: 290px" required></textarea></md-input-container></div></div><md-button class="md-raised md-primary" aria-label="b1" data-translate="comparision.get-report-button" ng-click="vm.downloadComparisionReport()" ng-disabled="vm.pending || form.$invalid"></md-button></form></md-card-content></md-card></md-content></div>');
$templateCache.put('app/account/info/info.html','<div layout="column" class="info site-container" id="info"><md-content class="info-header" layout="column"><div layout-align="center center"><header class="header"><h5 data-translate="info.title"></h5></header></div></md-content><div class="info-container"><div layout="row"><h5 data-translate="info.instructions.title"></h5></div><div ng-if="vm.isIndividual"><div class="instructions-list" layout="row" layout-wrap><div layout="row" flex="30" flex-md="50" flex-sm="100" flex-xs="100" data-translate="info.instructions.instruction1.title" translate-values="{url: \'{{ \'info.instructions.instruction1.url\'+vm.instanceType+\'\' | translate}}\'}"></div><div layout="row" flex="40" flex-md="50" flex-sm="100" flex-xs="100" data-translate="info.instructions.instruction2.title" translate-values="{url: \'{{ \'info.instructions.instruction2.url\'+vm.instanceType+\'\' | translate}}\'}"></div><div layout="row" flex="30" flex-md="50" flex-sm="100" flex-xs="100" layout-align="start start" data-translate="info.instructions.instruction3.title" translate-values="{url: \'{{ \'info.instructions.instruction3.url\'+vm.instanceType+\'\' | translate}}\'}"></div></div></div><div ng-if="!vm.isIndividual && vm.clientType!=\'SCHOOL\'"><div class="instructions-list" layout="row" layout-wrap><div layout="row" flex="50" flex-md="50" flex-sm="100" flex-xs="100" data-translate="info.instructions.instruction1_notindividual.title" translate-values="{url: \'{{ \'info.instructions.instruction1\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.url\'+vm.instanceType+\'\' | translate}}\'}"></div><div layout="row" flex="50" flex-md="50" flex-sm="100" flex-xs="100" data-translate="info.instructions.instruction2_notindividual.title" translate-values="{url: \'{{ \'info.instructions.instruction2\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.url\'+vm.instanceType+\'\' | translate}}\'}"></div><div ng-if="vm.isAdmin || vm.isReseller" layout="row" flex="50" flex-md="50" flex-sm="100" flex-xs="100" data-translate="info.instructions.instruction.admin1.title" translate-values="{url: \'{{ \'info.instructions.instruction\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.admin1.url\'+vm.instanceType+\'\' | translate}}\'}"></div><div ng-if="vm.isReseller" layout="row" flex="50" flex-md="50" flex-sm="100" flex-xs="100" data-translate="info.instructions.instruction.reseller.title" translate-values="{url: \'{{ \'info.instructions.instruction.reseller.url\' | translate}}\'}"></div><div ng-if="vm.regulationsUrl" layout="row" flex="50" flex-md="50" flex-sm="100" flex-xs="100"><a href="{{vm.regulationsUrl}}" target="_blank"><i class="material-icons">description</i><span data-translate="global.accept-terms.non-individual.regulations-url-label">Link do procedury antyplagiatowej</span></a></div></div></div><div ng-if="vm.clientType==\'SCHOOL\'"><div class="instructions-list" layout="row" layout-wrap><div ng-if="!vm.isAdmin" layout="row" flex="50" flex-md="50" flex-sm="100" flex-xs="100" data-translate="{{\'info.instructions.instruction1\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'}}" translate-values="{url: \'{{ \'info.instructions.instruction1\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.url\'+vm.instanceType+\'\' | translate}}\'}"></div><div ng-if="!vm.isAdmin" layout="row" flex="50" flex-md="50" flex-sm="100" flex-xs="100" data-translate="{{\'info.instructions.instruction2\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'}}" translate-values="{url: \'{{ \'info.instructions.instruction2\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.url\'+vm.instanceType+\'\' | translate}}\'}"></div><div ng-if="vm.isAdmin" layout="row" flex="30" flex-md="50" flex-sm="100" flex-xs="100" data-translate="{{\'info.instructions.instruction\'+vm.clientTypeSuffix+\'.admin.title\'}}" translate-values="{url: \'{{ \'info.instructions.instruction\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.url\'+vm.instanceType+\'\' | translate}}\'}"></div><!-- dodatkowe instrukcje admina SCHOOL --><div ng-if="vm.isAdmin" layout="row" flex="30" flex-md="50" flex-sm="100" flex-xs="100" data-translate="info.instructions.instruction1.school.teacher.title" translate-values="{url: \'{{ \'info.instructions.instruction1.school.teacher.url\'+vm.instanceType+\'\' | translate}}\'}"></div><div ng-if="vm.isAdmin" layout="row" flex="30" flex-md="50" flex-sm="100" flex-xs="100" data-translate="info.instructions.instruction2.school.teacher.title" translate-values="{url: \'{{ \'info.instructions.instruction2.school.teacher.url\'+vm.instanceType+\'\' | translate}}\'}"></div><div ng-if="vm.isAdmin" layout="row" flex="30" flex-md="50" flex-sm="100" flex-xs="100" data-translate="info.instructions.instruction1.school.student.title" translate-values="{url: \'{{ \'info.instructions.instruction1.school.student.url\'+vm.instanceType+\'\' | translate}}\'}"></div><div ng-if="vm.isAdmin" layout="row" flex="30" flex-md="50" flex-sm="100" flex-xs="100" data-translate="info.instructions.instruction2.school.student.title" translate-values="{url: \'{{ \'info.instructions.instruction2.school.student.url\'+vm.instanceType+\'\' | translate}}\'}"></div></div></div><div class="info-container" ng-if="vm.showProcedures"><div layout="row" flex="100"><h5 data-translate="info.procedures.title"></h5></div><div class="instructions-list" layout="row" layout-wrap><div layout="row" flex="50" flex-md="50" flex-sm="100" flex-xs="100"><a href="{{\'info.procedures.procedure1.url\' | translate}}" target="_blank"><i class="material-icons">description</i><span data-translate="info.procedures.procedure1.title">Procedure 1</span></a></div><div layout="row" flex="50" flex-md="50" flex-sm="100" flex-xs="100"><a href="{{\'info.procedures.procedure2.url\' | translate}}" target="_blank"><i class="material-icons">description</i><span data-translate="info.procedures.procedure2.title">Procedure 2</span></a></div></div></div><div layout="row" class="faq-row flex-wrap"><div layout="row" flex="100"><h5 data-translate="info.faq.title"></h5></div><div layout="row flex-wrap" flex="100" class="flex-wrap"><div ng-if="\'info.instructions.youtube\'+vm.clientTypeSuffix+vm.userRoleYoutube+\'.\'+vm.instanceType+\'_1\' | translateExists" flex-gt-md="35" flex-md="100" flex="100" class="mb-3" layout="column"><div ng-repeat="number in vm.numbers" layout="column" flex="100" class="youtube-holder-1" ng-if="\'info.instructions.youtube\'+vm.clientTypeSuffix+vm.userRoleYoutube+\'.\'+vm.instanceType+\'_\'+number | translateExists"><div class="youtube-holder-2"><iframe ng-src="{{vm.trustSrc(\'info.instructions.youtube\'+vm.clientTypeSuffix+vm.userRoleYoutube+\'.\'+vm.instanceType+\'_\'+number | translate)}}" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div></div></div><div layout="row" flex-md="100" flex-sm="100" flex-xs="100" flex><div flex="100" class="faq-list"><ul id="faq"><li ng-if="vm.isIndividual"><span class="collapsible-header">{{\'info.faq.faq1.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq1.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isIndividual"><span class="collapsible-header">{{\'info.faq.faq2.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq2.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isIndividual"><span class="collapsible-header">{{\'info.faq.faq3.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body" data-ng-bind-html="vm.translateStr(\'info.faq.faq3.body\' + vm.instanceStr + \'\')"></span></li><li ng-if="vm.isIndividual"><span class="collapsible-header">{{\'info.faq.faq4.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body" data-ng-bind-html="vm.translateStr(\'info.faq.faq4.body\' + vm.instanceStr + \'\')"></span></li><li ng-if="vm.isIndividual"><span class="collapsible-header">{{\'info.faq.faq5.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body" data-ng-bind-html="vm.translateStr(\'info.faq.faq5.body\' + vm.instanceStr + \'\')"></span></li><li ng-if="vm.isIndividual"><span class="collapsible-header">{{\'info.faq.faq6.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq6.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isIndividual"><span class="collapsible-header">{{\'info.faq.faq7.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq7.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isIndividual"><span class="collapsible-header">{{\'info.faq.faq8.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body" data-ng-bind-html="vm.translateStr(\'info.faq.faq8.body\' + vm.instanceStr + \'\')"></span></li><li ng-if="vm.isIndividual"><span class="collapsible-header">{{\'info.faq.faq9.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq9.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isIndividual"><span class="collapsible-header">{{\'info.faq.faq10.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq10.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isIndividual && (vm.instance !== \'pl\') && (vm.instance !== \'int\')"><span class="collapsible-header">{{\'info.faq.faq11.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq11.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isIndividual && (vm.instance !== \'pl\') && (vm.instance !== \'int\')"><span class="collapsible-header">{{\'info.faq.faq12.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq12.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isIndividual"><span class="collapsible-header">{{\'info.faq.faq13.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq13.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="!vm.isIndividual && !vm.isAdmin && !vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq1\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq1\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="!vm.isIndividual && !vm.isAdmin && !vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq2\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq2\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="!vm.isIndividual && !vm.isAdmin && !vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq3\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq3\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="!vm.isIndividual && !vm.isAdmin && !vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq4\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq4\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="!vm.isIndividual && !vm.isAdmin && !vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq5\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq5\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="!vm.isIndividual && !vm.isAdmin && !vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq6\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq6\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="!vm.isIndividual && !vm.isAdmin && !vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq7\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq7\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="!vm.isIndividual && !vm.isAdmin && !vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq8\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq8\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="!vm.isIndividual && !vm.isAdmin && !vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq9\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq9\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="!vm.isIndividual && !vm.isAdmin && !vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq10\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq10\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="!vm.isIndividual && !vm.isAdmin && !vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq11\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq11\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="!vm.isIndividual && !vm.isAdmin && !vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq12\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq12\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="!vm.isIndividual && !vm.isAdmin && !vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq13\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq13\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="!vm.isIndividual && !vm.isAdmin && !vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq14\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq14\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="!vm.isIndividual && !vm.isAdmin && !vm.isReseller && vm.clientType==\'SCHOOL\'"><span class="collapsible-header">{{\'info.faq.faq15\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq15\'+vm.clientTypeSuffix+vm.accountTypeSuffix+\'.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isAdmin || vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq1\'+vm.clientTypeAdmin+\'.admin.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq1\'+vm.clientTypeAdmin+\'.admin.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isAdmin || vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq2\'+vm.clientTypeAdmin+\'.admin.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq2\'+vm.clientTypeAdmin+\'.admin.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isAdmin || vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq3\'+vm.clientTypeAdmin+\'.admin.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq3\'+vm.clientTypeAdmin+\'.admin.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isAdmin || vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq4\'+vm.clientTypeAdmin+\'.admin.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq4\'+vm.clientTypeAdmin+\'.admin.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isAdmin || vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq5\'+vm.clientTypeAdmin+\'.admin.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq5\'+vm.clientTypeAdmin+\'.admin.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isAdmin || vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq6\'+vm.clientTypeAdmin+\'.admin.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq6\'+vm.clientTypeAdmin+\'.admin.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isAdmin || vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq7\'+vm.clientTypeAdmin+\'.admin.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq7\'+vm.clientTypeAdmin+\'.admin.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isAdmin || vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq8\'+vm.clientTypeAdmin+\'.admin.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq8\'+vm.clientTypeAdmin+\'.admin.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isAdmin || vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq9\'+vm.clientTypeAdmin+\'.admin.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq9\'+vm.clientTypeAdmin+\'.admin.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isAdmin || vm.isReseller"><span class="collapsible-header">{{\'info.faq.faq10\'+vm.clientTypeAdmin+\'.admin.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq10\'+vm.clientTypeAdmin+\'.admin.body\'+vm.instanceStr+\'\'| translate}}</span></li><li ng-if="vm.isAdmin && vm.clientType==\'SCHOOL\'"><span class="collapsible-header">{{\'info.faq.faq11\'+vm.clientTypeAdmin+\'.admin.title\'+vm.instanceStr+\'\'| translate}}</span> <span class="collapsible-body">{{\'info.faq.faq11\'+vm.clientTypeAdmin+\'.admin.body\'+vm.instanceStr+\'\'| translate}}</span></li></ul></div></div></div></div><div layout="column"><div class="contact-form row contact-form-title"><span data-translate="info.contact-form.title"></span></div><div class="contact-form"><div class="contact-form" flex ng-if="vm.messages.success" data-translate="info.contact-form.success"></div><div class="contact-form" flex ng-if="vm.messages.error" data-translate="info.contact-form.error"></div><div layout="row" flex="100" flex-xs="100" layout-padding><md-input-container flex ng-if="vm.isIndividual"><input ng-model="vm.contactForm.adresat" type="hidden" name="password" ng-init="vm.contactForm.adresat = null"></md-input-container><md-input-container flex ng-if="!vm.isIndividual"><label data-translate="info.contact-form.form.adresat"></label><md-select required ng-model="vm.contactForm.adresat" placeholder="{{\'info.contact-form.form.send-to\' | translate}}"><md-option ng-value="adresat.email" ng-repeat="adresat in vm.adresats">{{adresat.name}}</md-option></md-select></md-input-container></div><div layout="row" flex="100" flex-xs="100" layout-padding><form novalidate name="form" accept-charset="utf-8"><div layout="row" flex="100" flex-md="100" flex-sm="100" flex-xs="100" class="message"><md-input-container flex><textarea ng-model="vm.contactForm.message" placeholder="{{!vm.contactForm.message ? \'info.contact-form.form.message-text.placeholder\' : \'info.contact-form.form.message-text.title\' | translate}}" rows="1" required></textarea></md-input-container></div><div layout="row" layout-xs="column" flex="100" flex-md="100" flex-sm="100" flex-xs="100" layout-align="end start"><md-button aria-label="clear" ng-click="vm.clearForm()" data-translate="info.contact-form.form.buttons.clear"></md-button><md-button aria-label="submit" ng-click="vm.sendForm()" class="button-send" data-translate="info.contact-form.form.buttons.send-form" ng-disabled="form.$invalid || vm.isSending"></md-button></div></form></div></div></div></div></div>');
$templateCache.put('app/account/documents/bottom-sheet.template.html','<md-bottom-sheet layout="column"><div ng-cloak><div layout="row" layout-xs="column" layout-align="start start"><span layout-align="start start" layout-padding layout-xs="column"><span ng-click="bootomSheet.closeBottomSheet()" data-translate="global.undo">Cofnij</span> </span><span layout-align="start start" layout-padding layout-xs="row" flex><span><md-checkbox ng-model="bootomSheet.checked" aria-label="Checkbox 1" ng-click="bootomSheet.closeBottomSheet()"><span data-translate="global.selected"></span></md-checkbox></span><span class="md-mini" layout-align="center start" aria-label="{{bootomSheet.selected.length}}" ng-if="!bootomSheet.tableSelectOptions.selectedAll">{{bootomSheet.selected.length}} / {{bootomSheet.total}} </span><span class="md-mini" aria-label="{{bootomSheet.selected.length}}" ng-if="bootomSheet.tableSelectOptions.selectedAll">{{bootomSheet.tableSelectOptions.selectedNo}} / {{bootomSheet.total}} </span><span aria-label="select all" ng-click="bootomSheet.toggleSelection(bootomSheet.total)" ng-if="!bootomSheet.tableSelectOptions.selectedAll" data-translate="global.button.select.all"></span> <span aria-label="select all" ng-click="bootomSheet.toggleSelection(bootomSheet.total)" ng-if="bootomSheet.tableSelectOptions.selectedAll" data-translate="global.button.clear.selection"></span> </span><span layout-align="start start" layout-padding layout-xs="row" flex flex-offset-gt-sm="15"><span layout-align="center start" ng-if="!bootomSheet.isIndividual && !bootomSheet.isStudent && !bootomSheet.isMinistry && bootomSheet.userDatabaseAddingEnabled" ng-click="bootomSheet.addDocuments()" ng-disabled="bootomSheet.selected.length == 0"><i class="material-icons">add</i> <span data-translate="global.bottomsheet.addtodatabse"></span> </span><span layout-align="center start" ng-if="!bootomSheet.isIndividual && !bootomSheet.isStudent && !bootomSheet.isMinistry && bootomSheet.userDatabaseAddingEnabled" ng-click="bootomSheet.rejectDocuments()" ng-disabled="bootomSheet.selected.length == 0"><i class="material-icons">remove</i> <span data-translate="global.bottomsheet.reject"></span> </span><span layout-align="center start" ng-click="bootomSheet.generateReportXls()" ng-disabled="bootomSheet.selected.length == 0" ng-if="!bootomSheet.isIndividual"><i class="material-icons">vertical_align_bottom</i> <span data-translate="global.bottomsheet.getreport"></span> </span><span layout-align="center start" ng-click="bootomSheet.removeDocuments()" ng-disabled="bootomSheet.selected.length == 0" ng-if="bootomSheet.isIndividual || bootomSheet.isAdmin"><i class="material-icons">close</i> <span data-translate="global.bottomsheet.delete"></span></span></span></div></div></md-bottom-sheet>');
$templateCache.put('app/account/documents/document.html','<div layout="column" class="site-container" id="documents"><md-content class="documents" flex-xs="100" layout="row" ng-class="{\'superadmin-docs\': !vm.isUploadFileVisible(), \'hide\': vm.uploadIsActive}"><div layout-align="center center"><header class="header"><div layout="row" layout-align="space-between center"><h5 data-translate="document.title"></h5><!--TODO ITDPANEL17-1920 Place the button in the better place?--><md-button id="import-documents-button" aria-label="import-documents-button" ng-if="vm.documentImportEnabled" class="md-raised md-primary mr-4" data-translate="document.import.button" ui-sref="document-import"></md-button><md-button id="self-enrollment-button" aria-label="self-enrollment-button" ng-if="vm.selfEnrollmentEnabled" class="md-raised md-primary mr-4" data-translate="document.self.enrollment.button" ng-click="vm.selfEnrollment()"><md-tooltip class="tooltip-with-long-text" md-delay="100" md-direction="top">{{\'document.self.enrollment.button-tooltip\'| translate}}</md-tooltip></md-button></div><form class="dragbox dragbox-big has-advanced-upload" ng-if="vm.isUploadFileVisible()" ng-show="!vm.success" name="form" role="form" novalidate show-validation><upload-file on-get-the-files="vm.getTheFiles" files="vm.files" is-loading="vm.isLoading" on-available-extensions="vm.availableExtension"></upload-file></form><div class="grey-link-wrapper" ng-if="vm.isUploadTextVisible"><a class="modal-trigger grey-link" href="" ng-click="vm.uploadText()" data-translate="document.docstext"></a></div></header></div></md-content><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoading"></md-progress-circular></div><document-metric on-upload-is-active="vm.uploadIsActive" on-upload-text-flag="vm.uploadTextFlag" on-upload-obj="vm.uploadObj" on-reload-documents="vm.reloadDocuments" on-get-the-files="vm.getTheFiles" on-upload-text="vm.uploadText" is-loading="vm.isLoading" ng-if="vm.isIndividual"></document-metric><md-content ng-if="!vm.isIndividual"><md-tabs md-dynamic-height="" md-border-bottom="" ng-if="vm.shouldShowDocumentFormTabs()"><md-tab label="{{\'document.tabs.jsa.title\' | translate}}"><md-content class="md-padding"><jsa-document-form on-upload-is-active="vm.uploadIsActive" on-upload-text-flag="vm.uploadTextFlag" on-upload-obj="vm.uploadObj" on-reload-documents="vm.reloadDocuments" on-get-the-files="vm.getTheFiles" on-upload-text="vm.uploadText" is-loading="vm.isLoading" on-get-configuration="vm.getUploadFormConfiguration" on-get-configuration-off-checking="vm.getUploadFormOffCheckingConfiguration" on-is-lecturer="vm.isLecturer" on-is-operator="vm.isOperator" is-jsa-disabled="vm.isJsaDisabled"></jsa-document-form></md-content></md-tab><md-tab label="{{\'document.tabs.plagiat.title\' | translate}}"><md-content class="md-padding"><document-form-universal ng-if=" vm.uploadObj.docuTitleInfo" on-upload-is-active="vm.uploadIsActive" on-upload-text-flag="vm.uploadTextFlag" on-upload-obj="vm.uploadObj" on-reload-documents="vm.reloadDocuments" on-get-the-files="vm.getTheFiles" on-upload-text="vm.uploadText" is-loading="vm.isLoading" on-get-configuration="vm.getUploadFormConfiguration" on-get-configuration-off-checking="vm.getUploadFormOffCheckingConfiguration" on-is-lecturer="vm.isLecturer" on-is-operator="vm.isOperator" on-is-student="vm.isStudent"></document-form-universal></md-content></md-tab></md-tabs><document-form-universal ng-if="vm.shouldShowOnlyUniversalDocumentForm() && vm.uploadObj.docuTitleInfo" on-upload-is-active="vm.uploadIsActive" on-upload-text-flag="vm.uploadTextFlag" on-upload-obj="vm.uploadObj" on-reload-documents="vm.reloadDocuments" on-get-the-files="vm.getTheFiles" on-upload-text="vm.uploadText" is-loading="vm.isLoading" on-get-configuration="vm.getUploadFormConfiguration" on-get-configuration-off-checking="vm.getUploadFormOffCheckingConfiguration" on-is-lecturer="vm.isLecturer" on-is-operator="vm.isOperator" on-is-student="vm.isStudent"></document-form-universal><document-form-assignment ng-if="vm.shouldShowDocumentAssignmentForm()" on-upload-is-active="vm.uploadIsActive" on-upload-text-flag="vm.uploadTextFlag" on-upload-obj="vm.uploadObj" on-reload-documents="vm.reloadDocuments" on-get-the-files="vm.getTheFiles" on-upload-text="vm.uploadText" is-loading="vm.isLoading" on-assignment-submit-form="vm.assignmentSubmitForm"></document-form-assignment></md-content><div ng-hide="vm.uploadIsActive" class="table-container" flex id="table-anchor"><md-content layout="row" layout-margin><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch aria-hidden="false" flex><documents-search-individual ng-if="vm.isIndividual" on-search-data="vm.searchData" on-query-request="vm.queryRequest" on-is-individual="vm.isIndividual" on-is-lecturer="vm.isLecturer" on-is-operator="vm.isOperator" on-get-documents="vm.getDocuments" on-get-documents-simple-search="vm.getDocumentsSimpleSearch" on-reset-selection="vm.resetSelection"></documents-search-individual><documents-search-universal ng-if="!vm.isIndividual" on-search-data="vm.searchData" on-query-request="vm.queryRequest" on-is-individual="vm.isIndividual" on-is-student="vm.isStudent" on-is-lecturer="vm.isLecturer" on-is-operator="vm.isOperator" on-is-admin="vm.isAdmin" on-is-super-admin="vm.isSuperAdmin" on-get-documents="vm.getDocuments" on-get-documents-simple-search="vm.getDocumentsSimpleSearch" on-reset-selection="vm.resetSelection"></documents-search-universal><md-table-container><table md-table md-row-select="vm.options.rowSelection" multiple="{{vm.options.multiSelect}}" ng-model="vm.selected" md-progress="vm.promise" id="tableDocuments"><thead md-head md-order="vm.queryRequest.order" md-on-reorder="vm.reloadDocuments"><tr md-row><th md-column><span>#</span></th><th md-column md-order-by="client" class="table-td-30" ng-if="vm.isSuperAdmin || vm.isReseller || vm.isMinistry"><span data-translate="global.model.client"></span></th><th md-column md-order-by="docuTitle" class="docuTitle table-td-30"><span data-translate="document.model.title"></span></th><th md-column md-numeric md-order-by="tokensNeeded" ng-if="vm.isIndividual"><span data-translate="document.model.tokens"></span></th><th md-column md-order-by="docuAuthor"><span data-translate="document.model.author"></span></th><th md-column md-order-by="docuCoordinator" ng-if="::vm.isCoordinatorVisible()"><span data-translate="{{vm.clientTypeSchool ? \'document.metric.client-type.school.teacher\' : \'document.model.docu-coordinator\'}}"></span></th><th md-column md-order-by="docuSubmitDate"><span data-translate="document.model.date"></span></th><th md-column class="documents-wp" ng-if="::vm.multipleSimilarityFactorsAreDisplayed"><span class="align-vertical" data-translate="document.model.wp"></span></th><th md-column class="documents-wp" ng-if="::!vm.clientSettings.hideDocuSimilarityFactor"><span class="align-vertical">{{ vm.multipleSimilarityFactorsAreDisplayed ? 1 : (\'document.model.wp1\' | translate) }}</span></th><th md-column class="documents-wp" ng-if="::!vm.clientSettings.hideDocuSimilarityFactorExt"><span class="align-vertical">{{ vm.multipleSimilarityFactorsAreDisplayed ? 2 : (\'document.model.wp2\' | translate) }}</span></th><th md-column class="documents-wp" ng-if="::vm.showReversedSimilarityFactor"><span class="align-vertical" data-translate="document.model.wpr"></span></th><th md-column class="documents-wp" ng-if="vm.clientSettings.showWhiteDocs || vm.isSuperAdmin"><span class="align-vertical" data-translate="document.table.column.wp-bap"></span></th><th md-column md-numeric class="documents-wp" ng-if="vm.clientSettings.ignoringCitations || vm.isSuperAdmin"><span class="align-vertical" data-translate="document.table.column.wp-cit"></span></th><th md-column md-numeric class="documents-wp" ng-if="vm.showSelfCitationFactor"><span class="align-vertical" data-translate="document.table.column.csc"></span></th><th md-column md-numeric class="documents-wp" ng-if="vm.isSuperAdmin || vm.isAdmin"><span class="align-vertical" data-translate="document.table.column.wp-ai"></span></th><th md-column class="documents-status" md-order-by="docuStatus"><md-icon ng-if="vm.instance == \'ro\'"></md-icon><span class="label-document-status" data-translate="document.model.status"></span></th><th md-column class="table-actions"><span data-translate="document.table.report"></span></th><th md-column class="table-actions" ng-if="(vm.protocolForDocuments.length > 0) || vm.isSuperAdmin"><span data-translate="document.table.protocols"></span></th><th md-column class="table-actions"><span data-translate="global.table.actions"></span></th></tr></thead><tbody md-body><tr md-row md-select="document.documentId" md-on-select="vm.selectRow" md-on-deselect="vm.deSelectRow" ng-repeat-start="document in vm.documents track by $index" ng-disabled="document.docuStatus == vm.documentStatus.PROCESSING.id"><td md-cell><span ng-show="!vm.isLoaderActive" ng-click="vm.getDetails(document)">{{($index + 1) + ((vm.queryRequest.page - 1) * vm.queryRequest.limit)}}</span></td><td md-cell ng-click="vm.getDetails(document)" ng-if="vm.isSuperAdmin || vm.isReseller || vm.isMinistry"><div flex class="docu-title-ellipsis"><md-truncate flex>[{{document.clientId}}] {{document.clientName}}</md-truncate></div></td><td md-cell class="docuTitle" ng-click="vm.getDetails(document)"><div layout="row" layout-align="start center"><md-tooltip md-delay="100" md-direction="right">{{document.docuTitle}}</md-tooltip><div ng-if="document.services && (document.clientId != 873)" class="pr-1"><i class="material-icons-outlined">translate</i></div><div flex class="docu-title-ellipsis" layout-align="start center"><md-truncate flex>{{document.docuTitle}}</md-truncate></div></div></td><td md-cell class="main-color" ng-click="vm.getDetails(document)" ng-if="vm.isIndividual">{{document.tokensNeeded}}</td><td md-cell ng-click="vm.getDetails(document)">{{document.docuAuthor}}</td><td md-cell ng-click="vm.getDetails(document)" ng-if="::vm.isCoordinatorVisible()">{{document.docuCoordinator ? document.docuCoordinator : \'\'}}</td><td md-cell ng-click="vm.getDetails(document)">{{vm.convertToDate(document.docuSubmitDate) | date:\'yyyy-MM-dd\'}}</td><td md-cell ng-click="vm.getDetails(document)" ng-if="vm.multipleSimilarityFactorsAreDisplayed"></td><td class="documents-wp" md-cell ng-click="vm.getDetails(document)" ng-if="!vm.clientSettings.hideDocuSimilarityFactor"><span class="align-vertical" ng-if="document.docuStatus > vm.documentStatus.PROCESSING.id && document.hasReport" ng-class="{\'warning-color\': vm.showWarningOnFactor1(document.docuSimilarityFactor, document.clientWarningThreshold1) }"><span ng-if="!vm.showSelfCitationFactor">{{document.docuSimilarityFactor| percentage:2}} </span><span ng-if="vm.showSelfCitationFactor">{{(document.docuSimilarityFactor - document.selfCitationFactor)| percentage:2}}</span></span></td><td class="documents-wp" md-cell ng-click="vm.getDetails(document)" ng-if="!vm.clientSettings.hideDocuSimilarityFactorExt"><span class="align-vertical" ng-if="document.docuStatus > vm.documentStatus.PROCESSING.id && document.hasReport" ng-class="{\'warning-color\': vm.showWarningOnFactor2(document.docuSimilarityFactorExt, document.clientWarningThreshold2) }">{{document.docuSimilarityFactorExt| percentage:2}}</span></td><td class="documents-wp" md-cell ng-click="vm.getDetails(document)" ng-if="::vm.clientSettings.showReversedSimilarityFactor"><span class="align-vertical" ng-if="document.docuStatus > vm.documentStatus.PROCESSING.id && document.hasReport">{{document.docuSimilarityFactorReversed| percentage:2}}</span></td><td class="documents-wp" md-cell ng-click="vm.getDetails(document)" ng-if="vm.clientSettings.showWhiteDocs || vm.isSuperAdmin"><span class="align-vertical" ng-if="document.docuStatus > vm.documentStatus.PROCESSING.id && document.hasReport">{{document.docuWhiteOnlySimilarityFactor| percentage:2}}</span></td><td class="documents-wp" md-cell ng-click="vm.getDetails(document)" ng-if="vm.clientSettings.ignoringCitations || vm.isSuperAdmin"><span class="align-vertical" ng-if="document.docuStatus > vm.documentStatus.PROCESSING.id && document.hasReport && document.docuQuotationsCoeficient">{{document.docuQuotationsCoeficient| percentage:2}}</span></td><td class="documents-wp" md-cell ng-click="vm.getDetails(document)" ng-if="vm.showSelfCitationFactor"><span class="align-vertical" ng-if="document.docuStatus > vm.documentStatus.PROCESSING.id && document.hasReport && document.selfCitationFactor">{{document.selfCitationFactor | percentage:2}}</span></td><td class="documents-wp" md-cell ng-click="vm.getDetails(document)" ng-if="vm.isSuperAdmin || vm.isAdmin"><span class="align-vertical" ng-if="document.docuStatus > vm.documentStatus.PROCESSING.id && document.hasReport && document.docuAiScore">{{ ((\'-\' === document.docuAiScore) ? \'-\' : (document.docuAiScore | percentage:0)) }}</span></td><td md-cell ng-click="vm.getDetails(document)" class="documents-status"><span ng-if="document.assignmentId && !document.releaseDate"><span ng-if="document.docuStatus == vm.documentStatus.DRAFT.id"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.draft\'| translate}}</md-tooltip><i class="material-icons icon-secondary">pending_actions</i> </span><span ng-if="(document.docuStatus != vm.documentStatus.DRAFT.id) && vm.assignmentAfterDueDate(document)"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.after-due-date\'| translate}}</md-tooltip><i class="material-icons icon-error">hourglass_bottom</i> </span><span ng-if="(document.docuStatus != vm.documentStatus.DRAFT.id) && !vm.assignmentAfterDueDate(document)"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.turned-in\'| translate}}</md-tooltip><i class="material-icons icon-success">assignment_turned_in</i> </span></span><span ng-if="document.docuStatus == vm.documentStatus.WAITING_FOR_PAYMENT.id && vm.isIndividual"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.awaiting-tokens\'| translate}}</md-tooltip><i class="material-icons icon-awaiting">payment</i> </span><span ng-if="document.docuStatus == vm.documentStatus.WAITING_FOR_PAYMENT.id && !vm.isIndividual"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.awaiting\'| translate}}</md-tooltip><i class="material-icons icon-awaiting">payment</i> </span><span ng-if="document.docuStatus == vm.documentStatus.JSA_ERROR.id"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.jsa-send-error\'| translate}}</md-tooltip><i class="material-icons">warning</i> </span><span ng-if="document.docuStatus == vm.documentStatus.PROCESSING.id  ||\n                                                 (document.docuStatus == vm.documentStatus.PROCESSING_ERROR.id && !vm.isSuperAdmin) ||\n                                                 document.docuStatus == vm.documentStatus.JSA_PENDING.id"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.processing\'| translate}}</md-tooltip><div class="out-circle" ng-class="{\'out-circle\': true, \'assignment-checking\': document.assignmentId}"><div class="rotate anim1"><div class="counterrotate"><i class="inner material-icons">search</i></div></div></div></span><span ng-if="document.docuStatus == vm.documentStatus.PROCESSING_ERROR.id && vm.isSuperAdmin"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.processing-error\'| translate}}</md-tooltip><i class="material-icons icon-unpaid">report_problem</i> </span><span ng-if="document.docuStatus == vm.documentStatus.PLAGIARISM_CHECKED.id && document.orppdStatus !== vm.ORPPD_STATUS.ERROR.id"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.paid\'| translate}}</md-tooltip><i class="material-icons icon-paid">verified_user</i> </span><span ng-if="document.docuStatus == vm.documentStatus.PLAGIARISM_CHECKED.id && document.orppdStatus === vm.ORPPD_STATUS.ERROR.id"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.orrpd.error\'| translate}}</md-tooltip><i class="material-icons icon-error">cloud_download</i> </span><span ng-if="document.docuStatus == vm.documentStatus.MARKED_FOR_DATABASE.id"><md-tooltip md-delay="100" md-direction="top">{{ vm.getDocumentStatusTooltipKey(document) | translate }}</md-tooltip><i class="material-icons icon-picked">backup</i> </span><span ng-if="document.docuStatus == vm.documentStatus.ADDED_TO_DATABASE.id"><md-tooltip md-delay="100" md-direction="top">{{ vm.getDocumentStatusTooltipKey(document) | translate }}</md-tooltip><i class="material-icons icon-added">cloud_download</i> </span><span ng-if="document.docuStatus == vm.documentStatus.DISALLOWED_TO_ADD_TO_DATABASE.id"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.rejected\'| translate}}</md-tooltip><i class="material-icons icon-rejected">error</i> </span><span ng-if="document.docuStatus == vm.documentStatus.EDITION_REQUIRED.id"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.edition-required\'| translate}}</md-tooltip><i class="material-icons icon-edition-required">health_and_safety</i> </span><span ng-if="document.docuStatus == vm.documentStatus.REMOVED.id"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.unpaid\'| translate}}</md-tooltip><i class="material-icons icon-unpaid">error</i> </span><span ng-if="document.docuStatus == vm.documentStatus.REPORT_ACCEPTED.id"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.report-accepted\' | translate}}</md-tooltip><i class="material-icons icon-success">verified</i></span></td><td md-cell class="documents-report"><document-buttons-report on-document-id="document.documentId" on-document-status="document.docuStatus" on-document-has-report="document.hasReport" on-report-2020-disabled="document.report2020Disabled" on-document-size="document.docuSize" on-document-release-date="document.releaseDate" on-reload-documents="vm.reloadDocuments" on-is-loader-active="vm.isLoaderActive" on-docu-author="document.docuAuthor" on-has-alert="document.hasAlert" on-document-priority-added-from-contract="document.priorityAddedFromContract" on-document-has-jsa-report="document.hasJsaReport" on-document-jsa-status="document.jsaOrderStatus" on-document="document" on-available-extensions="vm.availableExtension" on-submit-assignment="vm.submitAssignment" on-submit-assignment-correction="vm.submitAssignmentCorrection" on-submit-assignment-paid-correction="vm.submitAssignmentPaidCorrection"></document-buttons-report></td><td md-cell class="documents-downloads" ng-if="(vm.protocolForDocuments.length > 0) || vm.isSuperAdmin"><document-protocol document="document" protocol-for-documents="vm.protocolForDocuments"></document-protocol></td><td md-cell class="documents-actions"><document-buttons on-document-id="document.documentId" on-document-status="document.docuStatus" on-document-has-report="document.hasReport" on-report-2020-disabled="document.report2020Disabled" on-document-size="document.docuSize" on-use-tokens="vm.useTokens(document.tokensNeeded)" on-delete="vm.delete(document.tokensNeeded)" on-documents="vm.reloadDocuments" on-is-student="vm.isStudent" on-is-lecturer="vm.isLecturer" on-is-operator="vm.isOperator" on-is-individual="vm.isIndividual" on-is-admin="vm.isAdmin" on-is-super-admin="vm.isSuperAdmin" on-tokens-needed="document.tokensNeeded" on-client-id="document.clientId" on-docu-author="document.docuAuthor" on-is-loader-active="vm.isLoaderActive" on-selected-rows="vm.closeBottomSheet" on-jsa-order-status="document.jsaOrderStatus" on-can-accept-jsa-report="vm.canAcceptJsaReport(document)" on-document-has-jsa-report="document.hasJsaReport" document="document" client-has-perm-to-edit-document="vm.clientHasPermToEditDocument"></document-buttons></td></tr><tr ng-repeat-end ng-if="vm.showDetailsBlock && vm.pickedDocument == document.documentId" class="document-details"><td colspan="16"><document-details on-document="document" on-document-details="vm.details" ng-if="vm.isIndividual"></document-details><document-operator-details on-document="document" on-document-details="vm.details" on-is-superadmin="vm.isSuperAdmin" ng-if="!vm.isIndividual"></document-operator-details></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoaderActive"></md-progress-circular></div></md-table-container><!-- END TABLE --><div flex><div layout="row" layout-align="end center" layout-wrap><paging page="vm.queryRequest.page" page-size="vm.queryRequest.limit" total="vm.totalDocuments" show-prev-next="true" show-first-last="true" paging-action="vm.startPaging(page)"></paging><div layout="row" class="go-to" flex-xs="100" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to next page" ng-model="vm.queryRequest.page" type="number" ng-keyup="vm.reloadDocuments()" ng-change="vm.reloadDocuments()"></md-input-container></div></div></div></md-card></md-content></div></div>');
$templateCache.put('app/account/login/login.html','<div layout="column" flex class="unlogged login" ng-if="vm.loginPossible"><md-content layout="row"><form novalidate class="form" name="form" autocomplete="on"><div layout="row" layout-xs="column"><div class="login-logo" ng-click="vm.goToHomePage()" layout-xs="row" flex="50" flex-xs="100" layout-align="end start" layout-align-xs="center center" flex-gt-sm></div><div layout-xs="row" flex-xs="100" flex="50" layout-align="end start" layout-align-xs="center center" layout-padding class="choose-lang" flex-gt-sm><lang-select></lang-select></div></div><div flex="100" layout="column"><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch><md-card-title><md-card-title-text layout="row" layout-xs="column" layout-align="center center"><span class="md-headline login-header" data-translate="login.title"></span></md-card-title-text></md-card-title><md-card-content><div layout-margin layout-align="center center" ng-if="vm.authenticationError"><md-list flex><md-subheader data-translate="{{vm.responseMessage}}"></md-subheader></md-list></div><div layout-margin layout-align="center center"><md-input-container layout="row" class="md-block username" flex-gt-sm><label data-translate="global.form.username"></label><input ng-model="vm.username" name="username" id="username" ng-keyup="form.$valid && $event.keyCode == 13 && vm.login($event)" type="text" placeholder="{{\'global.form.username.placeholder\' | translate}}" autocomplete="on" required></md-input-container><md-input-container class="md-block" layout="row"><label data-translate="login.form.password"></label><input ng-model="vm.password" name="password" ng-attr-type="{{ vm.showPassword ? \'text\' : \'password\' }}" placeholder="{{\'global.form.password.placeholder\' | translate}}" ng-keyup="form.$valid && $event.keyCode == 13 && vm.login($event); vm.checkCapsLockKey($event)" autocomplete="off" required> <span class="password-eye" ng-click="vm.toggleShowPassword()"><i class="material-icons" ng-class="{\'visibility\': !vm.showPassword, \'visibility_off\': vm.showPassword}">{{vm.showPassword ? \'visibility\' : \'visibility_off\'}}</i></span></md-input-container><label data-translate="login.form.capslock.alert" class="capslock-alert" ng-show="vm.isCapsLockOn"></label></div><div class="md-padding"><md-button aria-label="Login" type="submit" ng-disabled="form.$invalid" layout-fill class="md-raised md-primary" ng-click="vm.login($event)" ng-keypress="vm.login($event)" data-translate="login.form.button"></md-button></div><div class="login-with" data-translate="global.social.btnlabel" ng-if="vm.allowFbLogin">Zaloguj si\u0119 przez</div><div layout="row" class="md-padding" layout-align="space-between center"><social-login-button ng-provider="facebook" ng-title="Facebook" ng-if="vm.allowFbLogin" on-button-click="vm.loginOauth2"></social-login-button><social-login-button ng-provider="google" ng-title="Google" ng-if="vm.allowFbLogin" on-button-click="vm.loginOauth2"></social-login-button><social-login-button ng-provider="microsoft" ng-title="Microsoft" ng-if="vm.allowFbLogin" on-button-click="vm.loginOauth2"></social-login-button></div><div ng-if="vm.lastSsoPartner"><saml-login ng-repeat="partner in vm.oauthPartners" ng-partner="{{ partner }}" ng-disabled="false" on-button-click="vm.loginOauth2" ng-if="partner == vm.lastSsoPartner"></saml-login><saml-login ng-repeat="partner in vm.samlPartners" ng-partner="{{ partner }}" ng-disabled="false" on-button-click="vm.loginSaml" ng-if="partner == vm.lastSsoPartner"></saml-login></div><div class="md-padding login-with-btn" ng-if="vm.showInstitutions"><md-button aria-label="showInstitutions" layout-fill class="jh-btn-social jh-btn-institutions" ng-click="vm.toggleInstitutions()" ng-class="vm.institutionsExpanded ? \'md-primary\' : \'\'"><div layout="row" layout-align="center center"><span data-translate="login.institutions"></span> <span class="drop-down-icon2"><i class="material-icons">arrow_drop_down</i></span></div></md-button></div><div ng-if="vm.institutionsExpanded"><saml-login ng-repeat="partner in vm.oauthPartners" ng-partner="{{ partner }}" ng-disabled="false" on-button-click="vm.loginOauth2"></saml-login><saml-login ng-repeat="partner in vm.samlPartners" ng-partner="{{ partner }}" ng-disabled="false" on-button-click="vm.loginSaml"></saml-login></div><div ng-if="vm.allowFbLogin"><span layout="column" layout-align="center center" flex="90" class="register-regulations-acceptance-info" data-ng-bind-html="vm.regulationsAcceptanceInfo()"></span></div><div><a layout="column" layout-align="center center" class="register-forgot-password" ui-sref="requestReset" data-translate="login.form.forgetpassword"></a></div></md-card-content><md-divider ng-if="vm.allowRegister"></md-divider><md-card-content class="md-padding" ng-if="vm.allowRegister"><p layout="column" layout-align="center center" class="register-label" data-translate="login.form.dont-have-account"></p><div class="md-padding"><md-button aria-label="Register" layout="column" layout-fill class="md-raised" ng-href="#/register" data-translate="global.button.register"></md-button></div></md-card-content></md-card></div></form></md-content></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/popup/popup-call-me-with-tel.template.html','<md-dialog class="m-1"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="popup.content.telephone"></h2></div><md-progress-linear ng-if="vm.pending" md-mode="indeterminate"></md-progress-linear></md-toolbar><md-dialog-content><div class="md-dialog-content"><md-content layout="column" layout-padding><md-input-container><input ng-model="vm.tel" name="tel" type="text" ng-required="true" placeholder="{{\'popup.content.telephone\'| translate}}"></md-input-container><md-input-container layout="column"><!--                    <md-tooltip class="tooltip-with-long-text" md-delay="100" md-direction="top">{{\'popup.gdpr-tooltip\'| translate}}</md-tooltip>--><md-checkbox ng-model="vm.gdpr" aria-label="check1"><span data-translate="popup.gdpr">Akceptuj\u0119 warunki GDPR</span></md-checkbox></md-input-container></md-content></div></md-dialog-content><md-dialog-actions layout="row" layout-xs="column"><md-button data-translate="popup.close" aria-label="popupClose" ng-click="vm.close()"></md-button><md-button aria-label="orderContactWithTel" type="submit" data-translate="popup.order-contact-with-tel" ng-click="vm.callMeWithTelEnd()" ng-disabled="vm.buttonDisabled()" md-autofocus></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/account/popup/popup.template.html','<md-dialog class="m-1"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="{{vm.popup.title}}"></h2></div><md-progress-linear ng-if="vm.pending" md-mode="indeterminate"></md-progress-linear></md-toolbar><md-dialog-content><div class="md-dialog-content"><md-content><p data-translate="{{vm.popup.content}}"></p></md-content></div></md-dialog-content><md-dialog-actions layout="row" layout-xs="column"><md-button ng-if="vm.popup.options[1]" aria-label="dontShowAgain" id="popup-dont-show-again" data-translate="popup.dont-show-again" ng-click="vm.dontShowAgain()"></md-button><md-button ng-if="vm.popup.options[2]" aria-label="orderContact" type="submit" data-translate="popup.order-contact" ng-click="vm.callMe()" ng-disabled="vm.pending" md-autofocus></md-button><md-button ng-if="vm.popup.options[4]" aria-label="orderContactWithTel" type="submit" data-translate="popup.order-contact-with-tel" ng-click="vm.callMeWithTel()" ng-disabled="vm.pending" md-autofocus></md-button><md-button data-translate="popup.close" aria-label="popupClose" ng-click="vm.close()"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/account/payments/payments.html','<div layout="column" class="payments site-container"><md-content class="payments-content" layout="column"><header class="header"><h5 data-translate="payments.title"></h5></header><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div></md-content><payment-status ng-if="vm.key === \'success\'"></payment-status><payment-metric ng-if="vm.key !== \'success\'" on-init-payment="vm.initPayment" on-sms-statuses="vm.smsStatuses" on-sms-not-valid="vm.notValidSms" on-get-price="vm.getPrice" on-token-price="vm.tokenPrice" on-invoice-info="vm.invoiceInfo" on-get-payment-methods="vm.getPaymentMethods" on-payment-methods="vm.paymentMethods" on-document-id="vm.documentId"></payment-metric><div id="paymentForm" style="display:none"><form><ul><li ng-repeat="(key, value) in vm.paymentParams"><input type="text" name="{{key}}" value="{{value}}"></li></ul><md-button class="md-raised md-primary" ng-click="vm.submitMe()">Submit</md-button></form></div><payments-list on-get-key="vm.key"></payments-list></div>');
$templateCache.put('app/account/register/register.html','<div layout="column" flex class="unlogged register"><md-content layout="row" ng-class="{ \'success\' : vm.success }"><form class="form" name="form"><div layout="row" layout-xs="column"><div class="login-logo" layout-xs="row" flex="50" flex-xs="100" layout-align="end start" layout-align-xs="center center" flex-gt-sm></div><div layout-xs="row" flex-xs="100" flex="50" layout-align="end start" layout-align-xs="center center" layout-padding class="choose-lang" flex-gt-sm><lang-select></lang-select></div></div><div flex="100" layout="column"><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch><md-card-title><md-card-title-text layout="row" layout-xs="column" layout-align="center center"><span class="md-headline text-center register-header" data-translate="register.title"></span></md-card-title-text></md-card-title><md-card-content class="padding-horizontal"><div layout-margin layout-align="center center" ng-if="vm.error"><md-list flex><md-subheader ng-if="vm.errorUserExists" data-translate="register.messages.error.emailexists"></md-subheader><md-subheader ng-if="vm.errorEmailExists" data-translate="register.messages.error.emailexists"></md-subheader><md-subheader ng-if="vm.otherError" data-translate="register.messages.error.othererror"></md-subheader><md-subheader ng-if="vm.isReserved" data-translate="register.messages.error.isreserved"></md-subheader><md-subheader ng-if="vm.doNotMatch" data-translate="register.messages.error.donotmatch"></md-subheader></md-list></div><div layout-margin layout-align="center center" ng-if="vm.success"><md-list flex><md-subheader class="subheader-success" data-translate="register.messages.success"></md-subheader></md-list></div><div layout-margin layout-align="center center" ng-if="vm.success"><md-list flex><md-subheader class="subheader-success" data-translate="{{\'register.messages.facebook.like_\' + vm.instance| translate}}"></md-subheader></md-list></div><div layout-margin layout-align="center center" ng-if="!vm.success"><md-input-container class="md-block" flex-gt-sm><label data-translate="register.form.firstname"></label><input ng-model="vm.registerObj.name" name="firstname" type="text" placeholder="{{\'register.form.placeholder.firstname\' | translate}}" required><plagiat-ng-messages form-element="form.firstname"></plagiat-ng-messages></md-input-container><md-input-container class="md-block" flex-gt-sm><label data-translate="register.form.surname"></label><input ng-model="vm.registerObj.surname" name="surname" type="text" placeholder="{{\'register.form.placeholder.surname\' | translate}}" required><plagiat-ng-messages form-element="form.surname"></plagiat-ng-messages></md-input-container><md-input-container class="md-block" flex-gt-sm><label data-translate="register.form.email"></label><input id="email" name="email" ng-model="vm.registerObj.email" type="email" required ng-pattern="/^.+@.+\\..+$/" ng-keyup="vm.checkEmailDomain()" placeholder="{{\'register.form.placeholder.email\' | translate}}"><plagiat-ng-messages form-element="form.email" translate-values="{pattern: \'global.form.email.pattern\'}"></plagiat-ng-messages></md-input-container><label data-translate="register.form.email.domain.alert" class="email-alert" ng-show="vm.emailInputHaveWrongDomain"></label><md-input-container ng-if="vm.instance === \'int\'"><small data-translate="global.form.password.pattern.hint"></small></md-input-container><md-input-container class="md-block mt-1"><label data-translate="register.form.password"></label><input ng-model="vm.registerObj.password" name="password" ng-attr-type="{{ vm.showPassword ? \'text\' : \'password\' }}" ng-minlength="8" ng-pattern="vm.passwordPattern" placeholder="{{\'global.form.password.placeholder\' | translate}}" required ng-keyup="vm.checkCapsLockKey($event)"> <span class="password-eye" ng-click="vm.toggleShowPassword()"><i class="material-icons" ng-class="{\'visibility\': !vm.showPassword, \'visibility_off\': vm.showPassword}">{{vm.showPassword ? \'visibility\' : \'visibility_off\'}}</i></span><plagiat-ng-messages form-element="form.password" translate-values="{minlength: \'global.form.password.minlength\', pattern: \'global.form.password.pattern\'}"></plagiat-ng-messages></md-input-container><md-input-container class="md-block"><label data-translate="register.form.retype-password"></label><input ng-model="vm.registerObj.confirmedPassword" name="confirmedPassword" ng-attr-type="{{ vm.showPassword ? \'text\' : \'password\' }}" ng-minlength="8" ng-pattern="vm.passwordPattern" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" required ng-disabled="!vm.registerObj.password" ng-keyup="vm.checkCapsLockKey($event)"> <span class="password-eye" ng-click="vm.toggleShowPassword()"><i class="material-icons" ng-class="{\'visibility\': !vm.showPassword, \'visibility_off\': vm.showPassword}">{{vm.showPassword ? \'visibility\' : \'visibility_off\'}}</i></span><plagiat-ng-messages form-element="form.password" translate-values="{minlength: \'global.form.password.minlength\'}"></plagiat-ng-messages></md-input-container><label data-translate="login.form.capslock.alert" class="capslock-alert" ng-show="vm.isCapsLockOn"></label><md-input-container><md-checkbox name="accepRegulations" ng-model="vm.registerObj.acceptRegulations" aria-label="Checkbox 1" required><span data-translate="global.accept-terms.terms" ng-if="vm.instance != \'ro\'"></span> <span data-translate="global.accept-terms.terms_instance_ro" ng-if="vm.instance == \'ro\'"></span></md-checkbox><plagiat-ng-messages form-element="form.accepRegulations"></plagiat-ng-messages></md-input-container><md-input-container><md-checkbox name="acceptDataProcessing" class="accept-data-processing" ng-model="vm.registerObj.acceptDataProcesing" aria-label="Checkbox 2" required><span class="tooltip"><span data-translate="global.dataprocessing.title" ng-if="vm.instance != \'ro\'"></span> <span data-translate="global.dataprocessing.title_instance_ro" ng-if="vm.instance == \'ro\'"></span> <span class="tooltiptext" data-translate="global.dataprocessing.info" ng-if="vm.instance != \'ro\'"></span> <span class="tooltiptext" data-translate="global.dataprocessing.info_instance_ro" ng-if="vm.instance == \'ro\'"></span></span></md-checkbox><plagiat-ng-messages form-element="form.acceptDataProcessing"></plagiat-ng-messages></md-input-container></div><div class="padding-horizontal" ng-if="!vm.success && vm.allowRegister"><md-button aria-label="Register" ng-disabled="vm.pending" layout="column" layout-fill class="md-raised md-primary" ng-click="vm.register(form)" data-translate="register.form.button"></md-button></div><md-progress-linear ng-if="vm.pending" md-mode="indeterminate"></md-progress-linear><div class="md-padding login-with" data-translate="global.social.btnlabel" ng-if="!vm.success && vm.allowFbLogin">Zaloguj si\u0119 przez</div><div layout="row" class="md-padding" layout-align="space-between center"><social-login-button ng-provider="facebook" ng-title="Facebook" ng-if="vm.allowFbLogin" on-button-click="vm.loginOauth2"></social-login-button><social-login-button ng-provider="google" ng-title="Google" ng-if="vm.allowFbLogin" on-button-click="vm.loginOauth2"></social-login-button><social-login-button ng-provider="microsoft" ng-title="Microsoft" ng-if="vm.allowFbLogin" on-button-click="vm.loginOauth2"></social-login-button></div><div ng-if="!vm.success"><span ng-show="vm.allowFbLogin" layout="column" layout-align="center center" flex="90" class="register-regulations-acceptance-info info-on-register-screen" data-ng-bind-html="vm.regulationsAcceptanceInfo()"></span></div></md-card-content><md-divider></md-divider><md-card-content><p layout="column" layout-align="center center" data-translate="register.form.have-account"></p><div class="padding-horizontal" layout-margin><md-button aria-label="Login" layout="column" layout-fill class="md-raised" ui-sref="login" data-translate="global.button.login"></md-button></div></md-card-content></md-card></div></form></md-content></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2 data-translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="sessions.table.ipaddress">IP Address</th><th data-translate="sessions.table.useragent">User agent</th><th data-translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" data-translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.availableLanguages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/translations/translation-edit.html','<md-dialog flex-gt-lg="65" flex-lg="70" flex-md="85" flex-xs="95"><md-toolbar><div class="md-toolbar-tools"><h2 ng-if="vm.code" data-translate="translations.edit.update-title"></h2><h2 ng-if="!vm.code" data-translate="translations.edit.create-title"></h2></div><md-progress-linear ng-if="vm.pending" md-mode="indeterminate"></md-progress-linear></md-toolbar><form name="form"><md-dialog-content layout="row" layout-wrap layout-padding class="mt-3"><div flex="100" layout="row" layout-xs="column"><md-input-container flex="70"><label data-translate="translations.edit.code.label"></label><textarea name="translationCode" ng-model="vm.obj.code" translation-code-validator="vm.initialCode" ng-model-options="{ updateOn: \'default blur\', debounce: {\'default\': 500, \'blur\': 0} }" required></textarea><plagiat-ng-messages form-element="form.translationCode"></plagiat-ng-messages></md-input-container><md-input-container md-no-float flex="30" flex-xs="100"><md-select aria-label="type" placeholder="{{\'translations.edit.type.label\' | translate}}" ng-model="vm.obj.type" layout-align="center center"><md-option ng-value="translationType.id" ng-repeat="translationType in vm.translationTypes"><em>{{translationType.key | translate}}</em></md-option></md-select></md-input-container></div><div flex="100" layout="row" ng-repeat="lang in vm.availableLanguages"><div class="text-center" flex="5">{{lang | uppercase}}</div><div flex="95" layout="row"><md-input-container flex><label data-translate="translations.edit.translated-text.label"></label><textarea type="text" name="translationText{{lang}}" ng-model="vm.obj[lang]" ng-change="vm.isAtLeastOneTranslationFilledEngine()" ng-model-options="{ updateOn: \'default blur\', debounce: {\'default\': 500, \'blur\': 0} }" ng-required="!vm.isAtLeastOneTranslationFilled"></textarea><plagiat-ng-messages form-element="form[\'translationText\' + lang]"></plagiat-ng-messages></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row"><md-button data-translate="global.button.cancel" ng-click="vm.closeDialog()" aria-label="close button"></md-button><md-button class="md-raised md-primary" aria-label="save translation" data-translate="global.button.save" ng-click="vm.saveOrUpdate(form)" ng-disabled="vm.pending" type="submit"></md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/account/translations/translation-import.html','<div layout="row" class="site-container translations" ng-click="vm.clickOnThePageListener($event)" id="translations-import"><div class="table-container" flex><md-content layout="row" layout-margin><md-card flex="100" flex-xs="100" flex><div class="loader loader-user-import" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoaderActive"></md-progress-circular></div><form class="dragbox dragbox-big has-advanced-upload" ng-show="!vm.success" name="form1" role="form2" novalidate show-validation><upload-file on-get-the-files="vm.getTheFiles" files="vm.files" is-loading="vm.isLoading" on-available-extensions="vm.availableExtension"></upload-file></form><div class="import-info-success md-padding" ng-show="vm.duplicates != null"><md-whiteframe class="md-whiteframe-1dp md-padding" layout layout-align="center center"><span><b><span data-translate="translations.import.error.duplicates"></span></b><br><span ng-repeat="duplicate in vm.duplicates">{{duplicate}}<br></span></span></md-whiteframe></div><div class="import-info-success md-padding" ng-show="vm.conflictingExternalTranslationCodes && vm.conflictingExternalTranslationCodes.length > 0"><md-whiteframe class="md-whiteframe-1dp md-padding" layout layout-align="center center"><span><b><span data-translate="translations.import.error.invalid-external-translation-codes"></span></b><br><span ng-repeat="code in vm.conflictingExternalTranslationCodes">{{code}}<br></span></span></md-whiteframe></div><md-table-container ng-show="vm.duplicates == null && (!vm.conflictingExternalTranslationCodes || vm.conflictingExternalTranslationCodes.length === 0)"><table md-table class="translations-import-table"><thead md-head><th md-column>#</th><th md-column></th><th md-column><span data-translate="translations.table.header.translation-key"></span></th><th md-column ng-repeat="lang in vm.availableLanguages" class="lang"><span>{{ lang.toUpperCase() }}</span></th></thead><tbody md-body><tr md-row ng-repeat="row in vm.data.data track by $index"><td md-cell>{{($index + 1)}}</td><td md-cell ng-click="vm.removeTranslationRow(row)"><i class="material-icons">delete_forever</i></td><td md-cell>{{row.code}}</td><td ng-repeat="lang in vm.availableLanguages" md-cell layout-padding class="word-break-all md-cell {{row.items[lang].status}}"><div ng-if="\'changed\' == row.items[lang].status"><span class="translation-text previous">{{row.items[lang].orgText}}</span></div><div><span class="translation-text">{{row.items[lang].text}}</span></div></td></tr></tbody></table></md-table-container></md-card></md-content></div><div layout="row" layout-align="end center"><md-button ng-disabled="vm.data == null" aria-label="save translations" data-translate="translations.button.import-save" ng-click="vm.saveImportedTranslations()" class="md-raised md-primary"></md-button><md-button aria-label="global close" data-translate="global.button.close" ui-sref="translations" class="md-raised md-primary"></md-button></div></div>');
$templateCache.put('app/account/translations/translation.history.template.html','<md-dialog flex-gt-lg="80" flex-lg="85" flex-md="90" flex-xs="95" class="translation-history"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="translations.history.title"></h2></div><md-progress-linear ng-if="vm.pending" md-mode="indeterminate"></md-progress-linear></md-toolbar><md-dialog-content class="p-2"><md-steppers md-stretch-steppers="always" md-selected="vm.selectedStepIndex" class="vh-80"><md-step class="step-no-numbers" ng-repeat="lang in vm.availableLanguages" label="{{lang | uppercase}}"><md-content><md-table-container><table md-table><thead md-head md-order="vm.order[lang]"><th class="createDate" md-column md-order-by="createDate"><span data-translate="translations.history.date"></span></th><th md-column md-order-by="translatedText"><span data-translate="translations.history.translated-text"></span></th><th class="userEmail" md-column md-order-by="userEmail"><span data-translate="translations.history.user"></span></th><th class="status" md-column md-order-by="status"><span data-translate="translations.history.status"></span></th></thead><tbody md-body><tr md-row ng-repeat="row in vm.obj.translations[lang] | orderBy: vm.order[lang]"><td md-cell>{{row.createDate | date:\'yyyy-MM-dd HH:mm\' }}</td><td md-cell>{{row.translatedText}}</td><td md-cell>{{row.userEmail}}</td><td md-cell><span ng-if="row.status == 0"><md-tooltip md-delay="100" md-direction="top">{{\'translations.history.status.active\'| translate}}</md-tooltip><i class="material-icons icon-success">check</i> </span><span ng-if="row.status != 0"><md-tooltip md-delay="100" md-direction="top">{{\'translations.history.status.hibernated\'| translate}}</md-tooltip><i class="material-icons icon-primary">ac_unit</i></span></td></tr></tbody></table></md-table-container></md-content></md-step></md-steppers></md-dialog-content><md-dialog-actions layout="row"><md-button data-translate="global.button.cancel" ng-click="vm.closeDialog()"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/account/translations/translations-bottom-sheet.html','<md-bottom-sheet><div layout="row" layout-padding layout-wrap><span flex="10" flex-xs="33" data-translate="global.undo" ng-click="bottomSheet.closeBottomSheet()"></span><md-checkbox flex="15" flex-xs="33" aria-label="Checkbox 1" ng-click="bottomSheet.closeBottomSheet()" ng-model="bottomSheet.checked"><span data-translate="global.selected"></span></md-checkbox><span flex="15" flex-xs="33" layout-align="center center" aria-label="{{bottomSheet.selected.length}}" ng-if="!bottomSheet.tableSelectOptions.selectedAll">{{bottomSheet.selected.length}} / {{bottomSheet.total}} </span><span flex="15" flex-xs="33" aria-label="{{bottomSheet.selected.length}}" ng-if="bottomSheet.tableSelectOptions.selectedAll">{{bottomSheet.tableSelectOptions.selectedNo}} / {{bottomSheet.total}} </span><span flex="15" flex-xs="33" aria-label="select all" data-translate="global.button.select.all" ng-click="bottomSheet.toggleSelection(bottomSheet.total)" ng-if="!bottomSheet.tableSelectOptions.selectedAll"></span> <span flex="15" flex-xs="33" aria-label="select all" data-translate="global.button.clear.selection" ng-click="bottomSheet.toggleSelection(bottomSheet.totalTranslations)" ng-if="bottomSheet.tableSelectOptions.selectedAll"></span> <span flex></span> <span flex="10" flex-xs="33" ng-click="bottomSheet.remove()"><i class="material-icons">close</i> <span data-translate="global.bottomsheet.delete"></span> </span><span flex="10" flex-xs="33" ng-click="bottomSheet.generateReportXls()"><i class="material-icons">vertical_align_bottom</i> <span data-translate="global.bottomsheet.getreport"></span></span></div></md-bottom-sheet>');
$templateCache.put('app/account/translations/translations.html','<div layout="column" class="site-container translations" ng-click="vm.clickOnThePageListener($event)" id="translations"><div class="table-container"><md-progress-linear ng-if="vm.pending" md-mode="indeterminate"></md-progress-linear><md-content layout="row" flex layout-margin><md-card flex layout-padding><div layout="row" layout-padding layout-wrap><select-page-size flex="25" flex-xs="100" layout="row" layout-align="start center" query-request="vm.queryRequest" on-value-chosen="vm.loadData()"></select-page-size><md-input-container flex="35" flex-xs="100" layout-align="end center" md-no-float class="md-block"><input ng-model="vm.simpleSearchText" ng-model-options="{ debounce: 500 }" placeholder="{{\'translations.search.code\'| translate}}" ng-change="vm.onSimpleSearchTextChange()" ng-class="{ \'hide\': !vm.simpleSearch}"></md-input-container><div flex="20" flex-xs="100" layout="column" layout-align="end center"><md-button id="advancedSearchBtn" class="search-buttons" aria-label="open" data-translate="{{vm.simpleSearch ? \'global.button.search.advanced\' : \'global.button.search.simple\'}}" ng-click="vm.toggleSearch()"></md-button></div><div flex="10" flex-xs="100" layout="row" layout-align="end center"><md-button class="md-raised md-primary" aria-label="translations-import" ui-sref="translations-import" data-translate="translations.button.import"></md-button></div><div flex="10" flex-xs="100" layout="row" layout-align="end center"><md-button class="md-raised md-primary button-waiting" aria-label="translations-create" ui-sref="translations-create" data-translate="global.button.add"></md-button></div></div><div ng-class="{ \'hide\': vm.simpleSearch}"><form name="formSearchTranslations"><div layout="row" layout-xs="column"><md-input-container class="md-block" flex="33" flex-xs="100"><input ng-model="vm.searchRequest.search.code" placeholder="{{\'translations.search.code\'| translate}}"></md-input-container><md-input-container class="md-block" flex="33" flex-xs="100"><input ng-model="vm.searchRequest.search.translatedText" placeholder="{{\'translations.search.translated-text\'| translate}}"></md-input-container><md-input-container md-no-float class="md-block" flex="33" flex-xs="100"><label data-translate="translations.search.type">Panel 10/17</label><md-select aria-label="panels" placeholder="{{\'translations.search.type\' | translate}}" ng-model="vm.searchRequest.search.type" layout-align="center center"><md-option ng-value="" ng-if="vm.searchRequest.search.type || vm.searchRequest.search.type === 0"><em>{{\'global.button.clear\'| translate}}: {{\'translations.search.type\' | translate}}</em></md-option><md-option ng-value="translationType.id" ng-repeat="translationType in vm.translationTypes"><em>{{translationType.key | translate}}</em></md-option></md-select></md-input-container></div><div layout="row" class="text-center" layout-padding layout-wrap layout-align="center center"><p flex="100" flex-xs="100" class="md-headline p-0 m-0" data-translate="translations.search.empty-in-language.choose"></p><md-checkbox flex="5" flex-xs="10" ng-repeat="lang in vm.availableLanguages" ng-model="vm.searchRequest.search.langs[lang]">{{ lang.toUpperCase() }}</md-checkbox></div><div layout="row" layout-align="start" layout-padding layout-xs="column"><md-button aria-label="clear" class="md-raised search-buttons" data-translate="global.button.clear.search" ng-click="vm.clear()"></md-button><md-button aria-label="search" class="md-raised md-primary search-buttons" data-translate="global.button.search" ng-click="vm.loadData()" type="submit"></md-button></div></form></div><div layout="row" class="text-center" layout-padding layout-wrap layout-align="center center"><p flex="100" flex-xs="100" class="md-headline p-0 m-0" data-translate="translations.language.choose"></p><md-checkbox flex="5" flex-xs="10" ng-repeat="lang in vm.availableLanguages" ng-model="vm.languageSelection[lang]" ng-click="vm.onLanguageSelected()">{{ lang.toUpperCase() }}</md-checkbox></div><md-table-container><table md-table class="translations-table" ng-model="vm.selected" md-row-select="vm.tableSettings.rowSelection" multiple="{{vm.options.multiSelect}}"><thead md-head><th md-column>#</th><th md-column><span data-translate="translations.table.header.translation-key"></span></th><th md-column class="translationType"><span data-translate="translations.table.header.translation-type"></span></th><th md-column ng-repeat="lang in vm.availableLanguages" ng-if="vm.shouldShowColumnForLanguage(lang)"><span>{{ lang.toUpperCase() }}</span></th></thead><tbody md-body><tr md-row ng-repeat="row in vm.pageOfTranslations.content track by $index" md-select="row.id" md-on-deselect="vm.deSelectRow" md-on-select="vm.selectRow"><td md-cell>{{($index + 1) + ((vm.pageOfTranslations.number - 1) * vm.pageOfTranslations.size)}}</td><td md-cell class="word-break-all" ng-mouseenter="vm.codeMouseEnterMap[row.code] = true" ng-mouseleave="vm.codeMouseEnterMap[row.code] = false">{{row.code}}<md-icon ng-if="vm.codeMouseEnterMap[row.code]" ui-sref="translations-edit({code: row.code})" ng-bind="\'create\'"></md-icon></td><td md-cell><span ng-if="row.type==\'0\'">{{\'translations.search.type.2017\'| translate}}</span> <span ng-if="row.type==\'1\'">{{\'translations.search.type.2010\'| translate}}</span> <span ng-if="row.type==\'2\'">{{\'translations.search.type.new\'| translate}}</span> <span ng-if="row.type==\'3\'">{{\'translations.search.type.asap3\'| translate}}</span></td><td ng-repeat="lang in vm.availableLanguages" ng-if="vm.shouldShowColumnForLanguage(lang)" ng-mouseenter="vm.onMouseEnter(row, lang)" ng-mouseleave="vm.cellWithMouseOver = null" md-cell layout-padding><span class="translation-text" ng-if="!vm.isCellEdited(row, lang)">{{row[lang]}}<md-icon class="icon-edit" ng-show="vm.isMouseOver(row, lang)" ng-click="vm.editCell(row, lang)" ng-bind="\'create\'"></md-icon><md-icon class="icon-edit" ng-show="vm.isMouseOver(row, lang)" ui-sref="translationHistory({code: row.code, \'lang\': lang})" ng-bind="\'history\'"></md-icon></span><md-input-container md-no-float ng-if="vm.isCellEdited(row, lang)"><textarea aria-label="enter translation" ng-model="vm.editedValue" auto-focus placeholder="{{ \'translations.table.translation.placeholder\' | translate }}"></textarea><div layout-align="end" layout="row"><md-icon flex="15" class="icon-save" ng-click="vm.saveTranslation(row, lang)" ng-bind="\'check\'" ng-show="vm.isCellEdited(row, lang)"></md-icon><md-icon flex="15" class="icon-cancel" ng-click="vm.cancelEdition()" ng-bind="\'close\'" ng-show="vm.isCellEdited(row, lang)"></md-icon></div></md-input-container></td></tr></tbody></table></md-table-container><div flex layout="row" layout-align="end center" layout-wrap><paging page="vm.pageOfTranslations.number" page-size="vm.pageOfTranslations.size" paging-action="vm.loadPageOfTranslations(page)" show-first-last="true" show-prev-next="true" total="vm.pageOfTranslations.totalElements"></paging><div class="go-to" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to page" ng-model="goToPageInputModel" min="1" max="vm.pageOfTranslations.totalPages" type="number" ng-keyup="$event.keyCode === vm.keyCodeEnter && vm.loadPageOfTranslations(goToPageInputModel)"></md-input-container></div></div></md-card></md-content></div></div>');
$templateCache.put('app/account/users/bottom-sheet-grid-template.html','<md-bottom-sheet layout="column"><div ng-cloak><div layout="row" layout-xs="column" layout-align="start start"><span layout-align="start start" layout-padding layout-xs="column"><span ng-click="bootomSheet.closeBottomSheet()" data-translate="global.undo">Cofnij</span> </span><span layout-align="start start" layout-padding layout-xs="row" flex><span><md-checkbox ng-model="bootomSheet.checked" aria-label="Checkbox 1" ng-click="bootomSheet.closeBottomSheet()"><span data-translate="global.selected"></span></md-checkbox></span><span class="md-mini" layout-align="center start" aria-label="{{bootomSheet.selected.length}}" ng-if="!bootomSheet.tableSelectOptions.selectedAll">{{bootomSheet.selected.length}} / {{bootomSheet.total}} </span><span class="md-mini" aria-label="{{bootomSheet.selected.length}}" ng-if="bootomSheet.tableSelectOptions.selectedAll">{{bootomSheet.tableSelectOptions.selectedNo}} / {{bootomSheet.total}} </span><span aria-label="select all" ng-click="bootomSheet.toggleSelection(bootomSheet.total)" ng-if="!bootomSheet.tableSelectOptions.selectedAll" data-translate="global.button.select.all"></span> <span aria-label="select all" ng-click="bootomSheet.toggleSelection(bootomSheet.totalUsers)" ng-if="bootomSheet.tableSelectOptions.selectedAll" data-translate="global.button.clear.selection"></span> </span><span layout-align="start start" layout-padding layout-xs="row" flex flex-offset-gt-sm="10"><span layout-align="center start" ng-if="!bootomSheet.isReseller && !bootomSheet.isMinistry" ng-click="bootomSheet.hibernate()"><i class="material-icons">ac_unit</i> <span data-translate="global.bottomsheet.hibernate"></span> </span><span layout-align="center start" ng-if="bootomSheet.isSuperAdmin" ng-click="bootomSheet.remindPasswords()"><i class="material-icons">back_hand</i> <span data-translate="users.remind.password"></span> </span><span layout-align="center start" ng-if="!bootomSheet.isReseller && !bootomSheet.isMinistry" ng-click="bootomSheet.setCounters()"><i class="material-icons">exposure</i> <span data-translate="users.set.counters"></span> </span><span layout-align="center start" ng-click="bootomSheet.generateReportXls()"><i class="material-icons">vertical_align_bottom</i> <span data-translate="global.bottomsheet.getreport"></span> </span><span layout-align="center start" ng-if="!bootomSheet.isReseller && !bootomSheet.isMinistry" ng-click="bootomSheet.remove()"><i class="material-icons">close</i> <span data-translate="global.bottomsheet.delete"></span></span></span></div></div></md-bottom-sheet>');
$templateCache.put('app/account/users/users.html','<div layout="column" class="site-container" ng-click="vm.clickOnThePageListener($event)" id="users"><users-menu active-tab="vm.activeTab" on-is-superadmin="vm.loggedUserIsSuperAdmin" ng-if="vm.showUserImport && !vm.isReseller && !vm.isMinistry"></users-menu><div class="table-container" flex><md-content layout="row" layout-margin><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch aria-hidden="false" flex><users-search on-clear="vm.clear" on-get-users="vm.searchUsers" on-is-superadmin="vm.loggedUserIsSuperAdmin" on-query-request="vm.queryRequest" on-search-request="vm.searchRequest" on-simple-search="vm.simpleSearch"></users-search><md-table-container><table md-table md-row-select="vm.options.rowSelection" multiple="{{vm.options.multiSelect}}" ng-model="vm.selected" md-progress="vm.promise" id="tableUsers"><thead md-head md-order="vm.queryRequest.order" md-on-reorder="vm.getUsers"><tr md-row><th md-column><span>#</span></th><th md-column md-order-by="clientId" ng-if="vm.loggedUserIsSuperAdmin || vm.isReseller || vm.isMinistry"><span data-translate="users.model.clientname"></span></th><th md-column md-order-by="userName"><span data-translate="users.model.firstname"></span></th><th md-column md-order-by="userSurname"><span data-translate="users.model.lastname"></span></th><th md-column md-order-by="userEmail" ng-if="!vm.loggedUserIsSuperAdmin"><span data-translate="users.model.email"></span></th><th md-column md-order-by="userEmail" ng-if="vm.loggedUserIsSuperAdmin"><span data-translate="users.model.userid"></span></th><th md-column md-order-by="organisationalunitLabel" ng-if="!vm.loggedUserIsSuperAdmin"><span data-translate="users.model.organisationalunit"></span></th><th md-column md-order-by="userStatus"><span data-translate="users.model.status"></span></th><th md-column ng-if="vm.jsaIntegration"><span data-translate="users.model.jsa"></span></th><th md-column ng-if="vm.testPoolVisible" md-order-by="userQueryCounter" class="user-query-counter-list-column"><span data-translate="users.model.usertests"></span></th><th md-column ng-if="vm.testPoolVisible"><span data-translate="users.model.usertests.type"></span></th><th md-column class="table-actions"><span data-translate="global.table.actions"></span></th></tr></thead><tbody md-body><tr md-row md-select="user.id" md-on-deselect="vm.deSelectRow" md-on-select="vm.selectRow" ng-repeat-start="user in vm.users"><td md-cell ng-click="vm.getDetails(user)"><span ng-show="!vm.isLoaderActive">{{($index + 1) + ((vm.queryRequest.page - 1) * vm.queryRequest.limit)}}</span></td><td md-cell ng-click="vm.getDetails(user)" ng-if="vm.loggedUserIsSuperAdmin || vm.isReseller || vm.isMinistry">{{user.userClientName}} [{{user.clientId}}]</td><td md-cell ng-click="vm.getDetails(user)"><div layout="row" layout-align="start center"><span layout="column" layout-align="center center"><md-tooltip md-delay="100" md-direction="top">{{vm.getUserRole(user).translationKey| translate}}</md-tooltip><i ng-repeat="iconName in vm.getUserRole(user).icons" class="material-icons">{{iconName}}</i> </span><span class="span-firstname">{{user.userName}}</span></div></td><td md-cell ng-click="vm.getDetails(user)">{{user.userSurname}}</td><td md-cell ng-click="vm.getDetails(user)" ng-if="!vm.loggedUserIsSuperAdmin">{{user.userEmail}}</td><td md-cell ng-click="vm.getDetails(user)" ng-if="vm.loggedUserIsSuperAdmin">{{user.userEmail}} [{{user.id}}]</td><td md-cell ng-click="vm.getDetails(user)" ng-if="!vm.loggedUserIsSuperAdmin">{{user.organisationalUnit}}</td><td md-cell ng-click="vm.getDetails(user)"><span ng-if="user.userStatusEnum==\'PRESENT\'"><md-tooltip md-delay="100" md-direction="top">{{\'users.list.user-status.active\'| translate}}</md-tooltip><i class="material-icons icon-success">check</i> </span><span ng-if="user.userStatusEnum==\'ACTIVE_HIBERNATE\' || user.userStatusEnum==\'INACTIVE_HIBERNATE\'"><md-tooltip md-delay="100" md-direction="top">{{\'users.model.status.hibernated\'| translate}}</md-tooltip><i class="material-icons icon-primary">ac_unit</i> </span><span ng-if="user.userStatusEnum==\'INACTIVE_NOT_HIBERNATE\'"><md-tooltip md-delay="100" md-direction="top">{{\'users.model.status.inactive\'| translate}}</md-tooltip><i class="material-icons">cancel</i> </span><span ng-if="user.userStatusEnum==\'BLOCKED\'"><md-tooltip md-delay="100" md-direction="top">{{\'users.model.status.blocked\'| translate}}</md-tooltip><i class="material-icons">cancel_presentation</i> </span><span ng-if="user.userStatusEnum==\'REMOVED\'"><md-tooltip md-delay="100" md-direction="top">{{\'users.model.status.removed\'| translate}}</md-tooltip><i class="material-icons">remove_circle_outline</i></span></td><td ng-if="vm.jsaIntegration" md-cell ng-click="vm.getDetails(user)"><span ng-if="user.polonEmployeeId"><md-tooltip md-delay="100" md-direction="top">{{\'users.list.jsa.active\'| translate}}</md-tooltip><i class="material-icons icon-success">check</i> </span><span ng-if="!user.polonEmployeeId"><md-tooltip md-delay="100" md-direction="top">{{\'users.model.jsa.disabled\'| translate}}</md-tooltip><i class="material-icons">cancel</i></span></td><td md-cell ng-if="vm.testPoolVisible && user.userSchoolType!=vm.USERSCHOOLTYPES.USER_SCHOOL_TYPE_INDIVIDUAL.id"><div class="text" ng-class="{\'editing\': user.id==vm.userQueryCounterId, \'reading\': user.id!=vm.userQueryCounterId, \'user-query-counter-block\': !vm.isMinistry}" ng-click="vm.editUserQueryCounter(user, $index, $event)"><span class="text-block with-content" ng-show="user.userQueryCounter">{{user.userQueryCounter}}</span> <input class="user-query-counter-input text-block no-content" ng-show="!user.userQueryCounter" type="text" ng-if="!vm.isMinistry" placeholder="" ng-readonly="true"><md-input-container md-no-float class="md-block input-block" ng-if="!vm.isMinistry"><input aria-label="{{\'users.model.usertests\'| translate}}" class="user-query-counter-input editable" ng-init="vm.userQueryCounters[$index]=user.userQueryCounter" ng-model="vm.userQueryCounters[$index]" type="number" min="0" max="999999999" ng-pattern="/^[0-9]+$/" ng-keyup="vm.userQueryCountersKeyUp($event)" ng-keypress="vm.userQueryCountersKeyPress($event)" maxlength="9" placeholder="" ng-readonly="user.id!=vm.userQueryCounterId" ng-if="!vm.isMinistry"><md-icon class="icon-edit" ng-bind="\'create\'" ng-show="user.id!==vm.userQueryCounterId && !vm.isMinistry"></md-icon><md-icon class="icon-save" ng-click="vm.saveUserQueryCounter(user, $index)" ng-bind="\'check\'" ng-show="user.id==vm.userQueryCounterId"></md-icon><md-icon ng-click="vm.cancelEditUserQueryCounter()" class="icon-cancel" ng-bind="\'close\'" ng-show="user.id==vm.userQueryCounterId"></md-icon></md-input-container><md-progress-circular class="user-query-counter-progress md-hue-2" md-diameter="20px" ng-show="user.id == vm.userQueryCounterId && vm.userQueryCounterSaving" md-mode="small"></md-progress-circular></div></td><td md-cell ng-click="vm.getDetails(user)" ng-if="vm.testPoolVisible && user.userSchoolType==vm.USERSCHOOLTYPES.USER_SCHOOL_TYPE_INDIVIDUAL.id">{{user.userTokens}} {{\'users.model.tokens\'| translate}}</td><td md-cell ng-click="vm.getDetails(user)" ng-if="vm.testPoolVisible && user.userSchoolType!=vm.USERSCHOOLTYPES.USER_SCHOOL_TYPE_INDIVIDUAL.id"><span ng-if="user.userQueryCounterTypeEnum==\'USER_QUERY_COUNTER_TYPE_DOCS\'">{{\'users.model.usertests.type.docs\'| translate}}</span> <span ng-if="user.userQueryCounterTypeEnum==\'USER_QUERY_COUNTER_TYPE_CHARS\'">{{\'users.model.usertests.type.chars\'| translate}}</span></td><td md-cell ng-click="vm.getDetails(user)" ng-if="vm.testPoolVisible && user.userSchoolType==vm.USERSCHOOLTYPES.USER_SCHOOL_TYPE_INDIVIDUAL.id"><span>-</span></td><td md-cell><users-buttons on-user="user" on-get-users="vm.searchUsers" on-logged-user-is-super-admin="vm.loggedUserIsSuperAdmin" on-logged-user-is-main-super-admin="vm.loggedUserIsMainSuperAdmin" on-logged-user-is-main-admin="vm.loggedUserIsMainAdmin" on-logged-user-is-org-unit-admin="vm.loggedUserIsOrgUnitAdmin" on-logged-user-is-admin="vm.loggedUserIsAdmin" on-search-request="vm.searchRequest"></users-buttons></td></tr><tr ng-class="{ \'table-details\': (vm.showDetailsBlock && vm.pickedUser == user.id), \'table-details-sadmin\' : vm.loggedUserIsSuperAdmin }" ng-repeat-end ng-if="vm.showDetailsBlock && vm.pickedUser == user.id"><td colspan="99"><user-details on-user="user" on-get-user-role="vm.getUserRole" on-user-details="vm.details" on-is-superadmin="vm.loggedUserIsSuperAdmin"></user-details></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoaderActive"></md-progress-circular></div></md-table-container><div flex><div layout="row" layout-align="end center" layout-wrap><paging page="vm.queryRequest.page" page-size="vm.queryRequest.limit" total="vm.totalUsers" show-prev-next="true" show-first-last="true" paging-action="vm.pagingAction(page)"></paging><div layout="row" class="go-to" flex-xs="100" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to next page" ng-model="vm.queryRequest.page" type="number" ng-keyup="vm.getUsers()" ng-change="vm.getUsers()"></md-input-container></div></div></div></md-card></md-content></div></div>');
$templateCache.put('app/client/client-add/client-add-test.html','<div class="site-container"><md-card><md-card-title><md-card-title-text><h2 class="mb-0" data-translate="client.header.add-test"></h2></md-card-title-text></md-card-title><md-progress-linear ng-if="vm.isLoading" md-mode="indeterminate"></md-progress-linear><md-card-content><form name="form" style="width: 99%"><div layout="row" layout-xs="column" layout-padding><md-input-container flex><input name="clientName" ng-model="vm.client.basicData.name" ng-required="true" placeholder="{{\'client.model.name\' | translate}}"><plagiat-ng-messages form-element="form.clientName"></plagiat-ng-messages></md-input-container><md-input-container flex="33"><label data-translate="client.model.language"></label><md-select name="clientLanguage" ng-model="vm.client.basicData.clieLang" ng-required="true"><md-option ng-repeat="value in vm.availableLanguages" ng-value="value" ng-selected="vm.client.basicData.clieLang === value">{{value | findLanguageFromKey}}</md-option></md-select><plagiat-ng-messages form-element="form.clientLanguage"></plagiat-ng-messages></md-input-container></div><div layout="row" layout-xs="column" layout-padding ng-if="!vm.isEdit()"><md-input-container flex><input placeholder="{{\'client.model.admin-first-name\' | translate}}" name="adminFirstName" ng-model="vm.client.basicData.adminFirstName" ng-required="true"><plagiat-ng-messages form-element="form.adminFirstName"></plagiat-ng-messages></md-input-container><md-input-container flex><input name="adminLastName" placeholder="{{\'client.model.admin-last-name\' | translate}}" ng-model="vm.client.basicData.adminLastName" ng-required="true"><plagiat-ng-messages form-element="form.adminLastName"></plagiat-ng-messages></md-input-container><md-input-container flex><input name="adminEmail" type="email" ng-pattern="/^.+@.+\\..+$/" placeholder="{{\'client.model.admin-email\' | translate}}" ng-model="vm.client.basicData.adminEmail" ng-required="true"><plagiat-ng-messages form-element="form.adminEmail"></plagiat-ng-messages></md-input-container></div><div layout="row" layout-align="end center"><md-button name="cancelButton" aria-label="cancelButton" class="md-raised md-primary" data-translate="global.button.cancel" ui-sref="client"></md-button><md-button name="save" aria-label="save" class="md-raised md-primary" data-translate="client.edit.button.update-client.submit" ng-click="vm.save()" ng-disabled="form.$invalid || vm.isSaving"></md-button></div></form></md-card-content></md-card><md-progress-linear ng-if="vm.isSaving" md-mode="indeterminate"></md-progress-linear></div>');
$templateCache.put('app/client/client-add/client-add.html','<div class="site-container"><md-card><md-card-title><md-card-title-text><h2 class="mb-0" data-translate="{{!vm.isEdit() ? \'client.edit.new.header\' : \'client.edit.update.header\'}}"></h2><h3 class="mt-1" ng-if="vm.isEdit()">{{vm.client.basicData.name}}</h3></md-card-title-text></md-card-title><md-progress-linear ng-if="vm.isLoading" md-mode="indeterminate"></md-progress-linear><md-card-content><md-steppers md-selected="vm.selectedStep" md-stretch-steppers="always" class="md-dynamic-height" ng-if="vm.client"><md-step label="{{\'client.edit.stepper.basic-data-step.header\' | translate}}" md-complete="vm.basicDataStep.completed" ng-disabled="vm.basicDataStep.disabled"><md-content ng-include src="\'app/client/client-add/steps/basic-data.html\'"></md-content></md-step><md-step label="{{\'client.edit.stepper.code-account.header\' | translate}}" md-complete="vm.stepCodeAccount.completed" ng-disabled="vm.stepCodeAccount.disabled"><md-content><client-create-step-code-account client="vm.client" available-currencies="vm.availableCurrencies" available-payments="vm.availablePayments" is-saving="vm.isSaving" is-edit="vm.isEdit" previous-step="vm.previousStep()" save-or-update="vm.saveOrUpdate()" step-code-account-completed="vm.stepCodeAccountCompleted()"></client-create-step-code-account></md-content></md-step><md-step label="{{\'client.edit.stepper.contract-step.header\' | translate}}" md-complete="vm.contractStep.completed" ng-disabled="vm.contractStep.disabled"><md-content ng-include src="\'app/client/client-add/steps/contract.html\'"></md-content></md-step><md-step label="{{\'client.edit.stepper.configuration-step.header\' | translate}}" md-complete="vm.configurationStep.completed" ng-disabled="vm.configurationStep.disabled"><md-content><client-configuration client="vm.client" is-saving="vm.isSaving" is-edit="vm.isEdit" previous-step="vm.previousStep()" save-or-update="vm.saveOrUpdate()"></client-configuration></md-content></md-step></md-steppers></md-card-content></md-card><md-progress-linear ng-if="vm.isSaving" md-mode="indeterminate"></md-progress-linear></div>');
$templateCache.put('app/client/client-detail/client-detail.template.html','<div class="border-top" layout="row" layout-padding><div layout="row" flex="40"><div layout="column" flex="50"><div layout="column" flex ng-if="$ctrl.client.contractAntyplagiat"><small class="text-muted" data-translate="client.model.contract.antyplagiat"></small></div><div layout="column" flex ng-if="$ctrl.client.contractAsap"><small class="text-muted" data-translate="client.model.contract.asap"></small></div></div><div layout="column" flex="50"><div layout="row" flex ng-if="$ctrl.client.contractAntyplagiat"><small>{{$ctrl.client.contractAntyplagiat.dateFrom | date: \'dd-MM-yyyy\'}} </small><small class="mx-2">\u2014</small> <small>{{$ctrl.client.contractAntyplagiat.dateTo | date: \'dd-MM-yyyy\'}}</small></div><div layout="row" flex ng-if="$ctrl.client.contractAsap"><small>{{$ctrl.client.contractAsap.dateFrom | date: \'dd-MM-yyyy\'}} </small><small class="mx-2">\u2014</small> <small>{{$ctrl.client.contractAsap.dateTo | date: \'dd-MM-yyyy\'}}</small></div></div></div><div layout="row" flex="40"><div layout="column" flex="50"><div flex layout="column" ng-if="$ctrl.client.contractAntyplagiat.contractType !== null"><small class="text-muted">{{($ctrl.client.contractAntyplagiat.contractType === 0 ? \'global.menu.contract.type.documents\' : \'\') | translate}} {{($ctrl.client.contractAntyplagiat.contractType === 1 ? \'global.menu.contract.type.chars\' : \'\') | translate}} {{($ctrl.client.contractAntyplagiat.contractType === 2 ? \'global.menu.contract.type.users\' : \'\') | translate}} {{($ctrl.client.contractAntyplagiat.contractType === 3 ? \'global.menu.contract.type.authors\' : \'\') | translate}}</small></div><div flex layout="column" ng-if="$ctrl.client.contractAntyplagiat.contAiDetectionEnabled"><small class="text-muted" data-translate="client.edit.contract.ai.detection.enabled"></small></div><div flex layout="column" ng-if="$ctrl.client.contractAntyplagiat.contAiDetectionPool"><small class="text-muted" data-translate="client.edit.contract.ai.detection.pool"></small></div><div flex layout="column" ng-if="$ctrl.client.contractAntyplagiat.contGrammarCheckEnabled"><small class="text-muted" data-translate="client.edit.configuration.grammar-check.grammar-check"></small></div><div flex layout="column" ng-if="$ctrl.client.contractAsap"><small class="text-muted" data-translate="client.model.installation-type"></small></div></div><div layout="column" flex="50"><div flex layout="row" ng-if="$ctrl.client.contractAntyplagiat.contNumOfPlagReportsLeft !== null"><small>{{$ctrl.client.contractAntyplagiat.contNumOfPlagReportsLeft | number}} /{{$ctrl.client.contractAntyplagiat.contNumOfPlagReports | number}} [{{$ctrl.client.contractAntyplagiat.percentUsed}}%]</small></div><div flex layout="row" ng-if="$ctrl.client.contractAntyplagiat.contAiDetectionEnabled"><small>{{ $ctrl.client.contractAntyplagiat.contAiDetectionEnabled }}</small></div><div flex layout="row" ng-if="$ctrl.client.contractAntyplagiat.contAiDetectionPool"><small>{{$ctrl.client.contractAntyplagiat.contNumOfAiDetectionLeft | number}} /{{$ctrl.client.contractAntyplagiat.contNumOfAiDetection | number}} [{{$ctrl.client.contractAntyplagiat.percentUsedAi}}%]</small></div><div flex layout="row" ng-if="$ctrl.client.contractAntyplagiat.contGrammarCheckEnabled"><small>{{ $ctrl.client.contractAntyplagiat.contGrammarCheckEnabled }}</small></div><div flex layout="row" ng-if="$ctrl.client.contractAsap"><small>{{$ctrl.client.contractAsap.installationTypeLangKey | translate}}</small></div></div></div><div flex="20" layout="row"><md-button class="w-100" data-translate="global.button.showadmins" ng-click="$ctrl.showAdmins()" aria-label="showAdmins"></md-button></div></div>');
$templateCache.put('app/client/client-document-kinds/client-document-kinds.html','<form name="form"><md-card><md-card-content><md-card-title-text><h3 data-translate="client.edit.document-kinds.header"></h3></md-card-title-text><md-table-container><table id="tableClientDocumentKinds" md-table><thead md-head><tr md-row><th md-column><span>#</span></th><th md-column><span data-translate="client.edit.document-kinds.enabled"></span></th><th md-column><span data-translate="client.edit.document-kinds.label"></span></th><th md-column ng-repeat="lang in vm.availableLanguages"><span>{{ lang.toUpperCase() }}</span></th></tr></thead><tbody md-body><tr md-row ng-repeat="row in vm.documentKinds" ng-class="{\'disabled-row\': row.standard}"><td md-cell><span>{{ ($index + 1) }}</span></td><td md-cell><md-checkbox name="{{\'docu_kind_\'+ row.id}}" class="md-primary" aria-label="{{\'docu_kind_\'+ row.id}}" ng-model="row.enabled"></td><td md-cell>{{row.label}}</td><td md-cell ng-repeat="lang in vm.availableLanguages">{{row.translations[lang]}}</td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoaderActive"></md-progress-circular></div></md-table-container></md-card-content></md-card><div layout="row" layout-align="end center" layout-padding><md-button id="cancelButton" aria-label="cancelButton" class="md-raised md-primary" data-translate="global.button.cancel" ui-sref="client"></md-button><md-button id="save" aria-label="saveButton" class="md-raised md-primary" data-translate="global.button.save" ng-click="vm.save()"></md-button></div></form>');
$templateCache.put('app/client/client-protocols/client-protocol-add.html','<div layout="column" class="site-container"><md-content class="users" layout="row"><div layout-align="center center"><header class="header"><h5 data-translate="client.edit.protocols"></h5></header></div></md-content><div class="table-container" flex><md-content layout="row" layout-margin><md-card flex><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div><div layout="row" layout-padding layout-wrap><select-page-size flex="25" layout="row" layout-align="start center" query-request="vm.queryRequest" on-value-chosen="vm.loadData()"></select-page-size></div><div layout-padding><div layout="row" layout-xs="column"><md-input-container layout="row" layout-xs="column" flex="33" flex-xs="100"><input ng-model="vm.simpleSearchText" placeholder="{{\'protocol.table.header.protocol.name\'| translate}} / {{\'protocol.table.header.protocol.filename\'| translate}}"></md-input-container></div></div><div layout="row" layout-padding layout-xs="column" layout-align="start"><md-button aria-label="clear" class="md-raised search-buttons" ng-click="vm.clear()" data-translate="global.button.clear.search"></md-button><md-button type="submit" aria-label="search" id="searchBtn" class="md-raised md-primary search-buttons" ng-click="vm.loadData()" data-translate="global.button.search">Szukaj</md-button></div><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span>#</span></th><th md-column></th><th md-column><span data-translate="protocol.table.header.protocol.name"></span></th><th md-column><span data-translate="protocol.table.header.protocol.filename"></span></th><th md-column><span data-translate="global.table.actions"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="row in vm.protocols track by $index"><td md-cell>{{($index + 1) + ((vm.queryRequest.page - 1) * vm.queryRequest.limit)}}</td><td md-cell>{{row.id}}</td><td md-cell>{{row.name}}</td><td md-cell>{{row.fileName}}</td><td md-cell><md-button id="tableOptionAdd{{$index}}" aria-label="add protocol to client" ng-click="vm.addToClient(row)" class="md-raised md-primary" data-translate="global.button.add"></md-button></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div></md-table-container><div flex layout="row" layout-align="end center" layout-wrap><paging page="vm.protocolPage.number" page-size="vm.protocolPage.size" paging-action="vm.loadPage(page)" show-first-last="true" show-prev-next="true" total="vm.protocolPage.totalElements"></paging><div class="go-to" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to page" ng-model="goToPageInputModel" min="1" max="vm.protocolPage.totalPages" type="number" ng-keyup="$event.keyCode === vm.keyCodeEnter && vm.loadPage(goToPageInputModel)"></md-input-container></div></div></md-card></md-content></div><div layout="row" flex layout-align="end center"><md-button id="closeButton" aria-label="protocol-add-close" ui-sref="client-protocols" data-translate="global.button.close"></md-button></div></div>');
$templateCache.put('app/client/client-protocols/client-protocols.html','<form name="form"><div layout-margin layout-wrap><div layout="row" flex layout-align="end center"><md-button id="addClientProtocolButton" aria-label="client-protocol-add" ui-sref="client-protocol-add" class="md-raised md-primary button-waiting" data-translate="global.button.add"></md-button></div></div><md-card><md-card-content><md-card-title-text><h3 data-translate="client.edit.protocols"></h3></md-card-title-text><md-table-container><table id="tableClientProtocols" md-table><thead md-head><tr md-row><th md-column><span>#</span></th><th md-column></th><th md-column><span data-translate="protocol.table.header.protocol.name"></span></th><th md-column><span data-translate="protocol.table.header.protocol.filename"></span></th><th md-column><span data-translate="global.table.actions"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="row in vm.protocols track by $index"><td md-cell>{{$index + 1}}</td><td md-cell>{{row.id}}</td><td md-cell>{{row.name}}</td><td md-cell>{{row.fileName}}</td><td md-cell><md-menu-bar flex layout="row"><md-menu><md-button aria-label="open" class="md-icon-button" ng-click="$mdMenu.open(); $event.stopPropagation();"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item><md-button id="tableOptionDelete{{$index}}" aria-label="remove protocol" ng-click="vm.remove(row)" data-translate="global.table.menu.delete"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div></md-table-container></md-card-content></md-card><div layout="row" layout-align="end center" layout-padding><md-button id="cancelButton" aria-label="cancelButton" class="md-raised md-primary" data-translate="global.button.cancel" ui-sref="client"></md-button></div></form>');
$templateCache.put('app/client/client-search/client-search.template.html','<form name="formSearchClients"><div layout-padding><div layout="row" layout-xs="column"><select-page-size query-request="$ctrl.onQueryRequest" on-value-chosen="$ctrl.getClients()" flex="30" flex-xs="100" layout="row" layout-align="start center"></select-page-size><div flex="70" flex-sm="70" flex-xs="100" layout="row" layout-align="end center" layout-sm="column"><md-input-container flex="70" flex-xs="100" layout-align="end center" md-no-float ng-if="$ctrl.simpleSearch"><input ng-change="$ctrl.getClients()" ng-model="$ctrl.onSearchRequest.simpleSearch" ng-model-options="{ debounce: $ctrl.simpleSearchDelay }" placeholder="{{\'global.search.title\'| translate}}"></md-input-container><div flex="30" flex-xs="100" layout="column" layout-align="end center"><md-button aria-label="open" class="search-buttons" data-translate="global.button.search.advanced" id="advancedSearchBtn" ng-class="{ \'hide\': !$ctrl.simpleSearch}" ng-click="$ctrl.toggleSearch()"></md-button><md-button aria-label="hide" class="search-buttons" data-translate="global.button.search.simple" ng-class="{ \'hide\': $ctrl.simpleSearch}" ng-click="$ctrl.toggleSearch()"></md-button></div></div></div><div layout="row" layout-xs="column" ng-hide="$ctrl.simpleSearch" layout-wrap><md-input-container flex="33" class="mt-3"><input ng-model="$ctrl.onSearchRequest.search.name" placeholder="{{\'client.model.name\'| translate}}"></md-input-container><md-input-container flex="33" class="mt-3"><input ng-model="$ctrl.onSearchRequest.search.id" placeholder="{{\'client.model.id\'| translate}}"></md-input-container><md-input-container flex="33" class="mt-3"><label data-translate="client.model.is-client-test">Test client</label><md-select aria-label="is-client-test" layout-align="center center" ng-change="$ctrl.getClients()" ng-model="$ctrl.onSearchRequest.search.clieIsTest" placeholder="{{\'client.model.clie-is-test\' | translate }}"><md-option ng-if="$ctrl.onSearchRequest.search.clieIsTest != null" ng-value="">{{\'global.button.clear\'| translate}}: {{\'client.model.clie-is-test\' | translate}}</md-option><md-option data-translate="global.msg.yes" ng-value="true">TAK</md-option><md-option data-translate="global.msg.no" ng-value="false">NIE</md-option></md-select></md-input-container><md-input-container flex="33" class="mt-3"><label data-translate="client.model.type"></label><md-select ng-change="$ctrl.getClients()" ng-model="$ctrl.onSearchRequest.search.clientTypeId"><md-option ng-if="$ctrl.onSearchRequest.search.clientTypeId != null" ng-value="">{{\'global.button.clear\'| translate}}: {{\'client.model.type\' | translate}}</md-option><md-option ng-repeat="clientType in $ctrl.clientTypesForSearch" ng-value="clientType.id">{{clientType.key | translate}}</md-option></md-select></md-input-container><md-input-container flex="33" class="mt-3"><label data-translate="client.model.status">Status</label><md-select aria-label="clients statuses" layout-align="center center" ng-change="$ctrl.getClients()" ng-model="$ctrl.onSearchRequest.search.contractStatus" placeholder="{{\'client.model.status\' | translate }}"><md-option ng-if="$ctrl.onSearchRequest.search.contractStatus || $ctrl.onSearchRequest.search.contractStatus === 0 " ng-value="">{{\'global.button.clear\'| translate}}: {{\'client.model.status\' | translate}}</md-option><md-option ng-repeat="status in $ctrl.statuses" ng-value="status.id">{{status.label| translate}}</md-option></md-select></md-input-container><md-input-container flex="33" class="mt-3"><label data-translate="client.model.databaseexchange"></label><md-select ng-change="$ctrl.getClients()" ng-model="$ctrl.onSearchRequest.search.databaseExchangeProgram"><md-option ng-if="$ctrl.onSearchRequest.search.databaseExchangeProgram != null" ng-value="">{{\'global.button.clear\'| translate}}: {{\'client.model.databaseexchange\' | translate}}</md-option><md-option data-translate="global.msg.yes" ng-value="true">TAK</md-option><md-option data-translate="global.msg.no" ng-value="false">NIE</md-option></md-select></md-input-container><md-input-container flex="33" class="mt-3"><label data-translate="client.model.contract.date-from"></label><md-datepicker input-date name="contractDateFrom" ng-change="$ctrl.fixDate($ctrl.onSearchRequest.search.contractDateFrom, \'contractDateFrom\', $ctrl)" ng-model="$ctrl.onSearchRequest.search.contractDateFrom"></md-datepicker><md-tooltip md-delay="100" md-direction="top">{{\'global.messages.info.dateformat\'| translate}}</md-tooltip></md-input-container><md-input-container flex="33" class="mt-3"><label data-translate="client.model.contract.date-to"></label><md-datepicker input-date name="contractDateTo" ng-change="$ctrl.fixDate($ctrl.onSearchRequest.search.contractDateTo, \'contractDateTo\', $ctrl)" ng-model="$ctrl.onSearchRequest.search.contractDateTo"></md-datepicker><md-tooltip md-delay="100" md-direction="top">{{\'global.messages.info.dateformat\'| translate}}</md-tooltip></md-input-container><md-input-container flex="33" class="mt-3" ng-if="!$ctrl.isReseller && !$ctrl.isMinistry"><label data-translate="client.instance"></label><md-select name="clientInstance" aria-label="instance" ng-model="$ctrl.onSearchRequest.search.instance" ng-change="$ctrl.getClients()" placeholder="{{\'client.instance\' | translate }}"><md-option ng-if="$ctrl.onSearchRequest.search.instance != null" ng-value="">{{\'global.button.clear\'| translate}}: {{\'client.instance\' | translate}}</md-option><md-option ng-repeat="value in $ctrl.clientInstances" ng-value="value">{{value}}</md-option></md-select></md-input-container><md-input-container flex="33" class="mt-3" ng-if="!$ctrl.isReseller && !$ctrl.isMinistry"><label data-translate="client.client-group"></label><md-select name="clientGroupId" aria-label="clientGroupId" ng-model="$ctrl.onSearchRequest.search.clientGroupId" ng-change="$ctrl.getClients()" placeholder="{{\'client.client-group\' | translate }}"><md-option ng-if="$ctrl.onSearchRequest.search.clientGroupId != null" ng-value="">{{\'global.button.clear\'| translate}}: {{\'client.client-group\' | translate}}</md-option><md-option ng-repeat="value in $ctrl.clientGroups" ng-value="value.id">{{value.name}}</md-option></md-select></md-input-container><md-input-container flex="33" class="mt-3" ng-if="!$ctrl.isReseller && !$ctrl.isMinistry"><label data-translate="global.model.region"></label><md-select name="clientRegionId" aria-label="clientRegionId" ng-model="$ctrl.onSearchRequest.search.clientRegionId" ng-change="$ctrl.getClients()" placeholder="{{\'global.model.region\' | translate }}"><md-option ng-if="$ctrl.onSearchRequest.search.clientRegionId != null" ng-value="">{{\'global.button.clear\'| translate}}: {{\'global.model.region\' | translate}}</md-option><md-option ng-repeat="value in $ctrl.clientRegions" ng-value="value.id">{{value.name}}</md-option></md-select></md-input-container><md-input-container flex="33" class="mt-3" ng-if="!$ctrl.isReseller && !$ctrl.isMinistry"><label data-translate="client.model.country"></label><md-select ng-change="$ctrl.getClients()" ng-model="$ctrl.onSearchRequest.search.countryCodeId"><md-option ng-if="$ctrl.onSearchRequest.search.countryCodeId != null" ng-value="">{{\'global.button.clear\'| translate}}: {{\'client.model.country\' | translate}}</md-option><md-option ng-repeat="country in $ctrl.countries" ng-value="country.id">{{ country.translated }}</md-option></md-select></md-input-container><md-input-container flex="33" class="mt-3" ng-if="!$ctrl.isReseller && !$ctrl.isMinistry"><label data-translate="client.model.aiDetectionEnabled"></label><md-select ng-change="$ctrl.getClients()" ng-model="$ctrl.onSearchRequest.search.aiDetectionEnabled"><md-option ng-if="$ctrl.onSearchRequest.search.aiDetectionEnabled != null" ng-value="">{{\'global.button.clear\'| translate}}: {{\'client.model.aiDetectionEnabled\' | translate}}</md-option><md-option data-translate="global.msg.yes" ng-value="true">TAK</md-option><md-option data-translate="global.msg.no" ng-value="false">NIE</md-option></md-select></md-input-container><md-input-container flex="33" class="mt-3" ng-if="!$ctrl.isReseller && !$ctrl.isMinistry"><label data-translate="client.edit.configuration.grammar-check.grammar-check"></label><md-select ng-change="$ctrl.getClients()" ng-model="$ctrl.onSearchRequest.search.grammarCheckEnabled"><md-option ng-if="$ctrl.onSearchRequest.search.grammarCheckEnabled != null" ng-value="">{{\'global.button.clear\'| translate}}: {{\'client.edit.configuration.grammar-check.grammar-check\' | translate}}</md-option><md-option data-translate="global.msg.yes" ng-value="true">TAK</md-option><md-option data-translate="global.msg.no" ng-value="false">NIE</md-option></md-select></md-input-container><md-input-container flex="33" class="mt-3" ng-if="$ctrl.isSuperAdmin"><label data-translate="global.menu.contract.type"></label><md-select ng-change="$ctrl.getClients()" ng-model="$ctrl.onSearchRequest.search.contractType"><md-option ng-if="$ctrl.onSearchRequest.search.contractType != null" ng-value="">{{\'global.button.clear\'| translate}}: {{\'global.menu.contract.type\' | translate}}</md-option><md-option ng-repeat="type in $ctrl.contractTypes" ng-value="type.id">{{type.key | translate}}</md-option></md-select></md-input-container></div><div layout="row" layout-align="start" layout-padding layout-xs="column" ng-class="{ \'hide\': $ctrl.simpleSearch}"><md-button aria-label="clear" class="md-raised search-buttons" data-translate="global.button.clear.search" ng-click="$ctrl.clear()"></md-button><md-button aria-label="search" class="md-raised md-primary search-buttons" data-translate="global.button.search" ng-click="$ctrl.getClients()" type="submit"></md-button></div></div></form>');
$templateCache.put('app/components/analytics/analytics.template.html','');
$templateCache.put('app/components/code-info/code-info.template.html','<div id="codeInfo" ng-if="!vm.onIsCollapsed" layout="column" layout-padding class="contract"><h3 data-translate="global.menu.code-info" class="h3-m5"></h3><div class="contract-group"><div layout="row" ng-repeat="codeAmount in vm.availableCodesInfo" layout-align="start center"><div layout="column" flex="75" class="pool-label"><div>{{codeAmount.name}}</div><div><span>{{vm.lessCharacter}} {{codeAmount.size}} </span><span data-translate="global.code.metric.code-size.suffix">characters</span></div></div><div flex="25" layout-align="end end" class="contract-value">{{codeAmount.amount}}</div></div><div layout="row" ng-if="vm.availableCodesInfo.length === 0" layout-align="start center"><div flex="100" layout-align="end end" class="contract-value">---</div></div></div></div>');
$templateCache.put('app/components/confirm-terms/confirm-terms-individual.dialog.html','<md-dialog aria-label="List dialog"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="global.accept-terms.title"></h2></div></md-toolbar><form name="form" ng-cloak><md-dialog-content><div class="md-dialog-content" layout-margin><md-input-container class="md-block accept-terms-content"><span data-translate="{{vm.postprocessKey(\'global.accept-terms.content\')}}"></span></md-input-container><md-input-container class="md-block"><md-checkbox name="accepRegulations" ng-model="vm.obj.userAcceptsRegulations" aria-label="Checkbox 1" required><span data-translate="{{vm.postprocessKey(\'global.accept-terms.terms\')}}"></span></md-checkbox></md-input-container><md-input-container class="md-block accept-terms-content"><md-checkbox name="acceptDataProcessing" ng-model="vm.obj.acceptDataProcessing" aria-label="Checkbox 1" required><div class="tooltip"><div data-translate="{{vm.postprocessKey(\'global.dataprocessing.title\')}}"></div><div class="tooltiptext" data-translate="{{vm.postprocessKey(\'global.dataprocessing.info\')}}"></div></div></md-checkbox></md-input-container></div></md-dialog-content><md-dialog-actions><md-button ng-click="vm.closeDialog()" class="md-primary" data-translate="global.menu.account.logout"></md-button><md-button ng-click="vm.saveAcceptTerms()" ng-disabled="form.$invalid" class="md-primary" data-translate="global.button.accept"></md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/confirm-terms/confirm-terms-non-individual.dialog.html','<md-dialog><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="global.accept-terms.title"></h2></div></md-toolbar><form name="form" ng-cloak><md-dialog-content><div class="md-dialog-content" layout-margin><md-input-container class="md-block accept-terms-content"><span data-translate="global.accept-terms.non-individual.content"></span></md-input-container><md-input-container class="md-block"><md-checkbox name="acceptRegulations" ng-model="vm.obj.userAcceptsRegulations" aria-label="Checkbox 1" required><span>{{\'global.accept-terms.non-individual.accept\' | translate }} (<a class="terms-link" href="{{vm.regulationsUrl}}" target="_blank" ng-click="$event.stopPropagation()" data-translate="global.accept-terms.non-individual.regulations-url-label"> </a>)</span></md-checkbox></md-input-container></div></md-dialog-content><md-dialog-actions><md-button ng-click="vm.closeDialog()" class="md-primary" data-translate="global.menu.account.logout"></md-button><md-button ng-click="vm.saveAcceptTerms()" ng-disabled="form.$invalid" class="md-primary" data-translate="global.button.accept"></md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/confirm-terms/confirm-terms.template.html','<form name="form" ng-cloak><md-dialog-content><div class="md-dialog-content" layout-margin><md-input-container><md-checkbox name="accepRegulations" ng-model="vm.registerObj.accepRegulations" aria-label="Checkbox 1" required><span data-translate="register.form.terms" translate-values="{pdf: \'{{ \'register.form.terms-pdf\' | translate}}\'}"></span></md-checkbox></md-input-container><md-input-container><md-checkbox name="acceptDataProcesing" ng-model="vm.registerObj.acceptDataProcesing" aria-label="Checkbox 2" required><span class="tooltip"><span data-translate="global.data-procesing.title"></span> <span class="tooltiptext" data-translate="global.data-procesing.info" ng-if="vm.instance != \'ro\'"></span> <span class="tooltiptext" data-translate="global.data-p rocesing.info_instance_ro" ng-if="vm.instance == \'ro\'"></span></span></md-checkbox></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="closeDialog()" data-translate="global.button.cancel">Anuluj</md-button><md-button ng-click="$ctrl.acceptTerms($ctrl.user)" ng-disabled="form.$invalid" class="md-raised" data-translate="global.button.save">Zapisz</md-button></md-dialog-actions></form>');
$templateCache.put('app/components/contract/contract.template.html','<md-divider></md-divider><div id="contractInfo" layout="column" layout-padding class="contract" ng-show="$ctrl.showContract" ng-if="!$ctrl.onShowReports"><h3 data-translate="global.menu.yourcontract" class="h3-m5" ng-if="!$ctrl.isReseller && !$ctrl.isMinistry"></h3><div class="contract-group" ng-if="!$ctrl.isReseller && !$ctrl.isMinistry"><div layout="row" layout-align="start center"><div flex="51" ng-if="!$ctrl.collapsed" class="pool-label" data-translate="global.menu.pooloftests">Test pool</div><div flex="49" ng-if="!$ctrl.collapsed" layout-align="end end" class="contract-value">{{$ctrl.contract.userQueryCounter | number}}</div></div><div layout="row" layout-align="start center"><div flex="51" ng-if="!$ctrl.collapsed" class="pool-label" data-translate="global.menu.userquerycounter.type">Test pool type</div><div flex="49" ng-if="!$ctrl.collapsed" layout-align="end end" class="contract-value">{{($ctrl.contract.userQueryCounterType === 0 ? \'global.menu.userquerycounter.type.documents\' : \'global.menu.userquerycounter.type.chars\') | translate}}</div></div></div></div><div id="clientContractInfo" layout="column" layout-padding class="contract" ng-show="$ctrl.onIsAdmin || $ctrl.onShowReports"><h3 data-translate="global.menu.clientcontract" class="h3-m5"></h3><div class="contract-group"><div layout="row" layout-align="start center" ng-if="$ctrl.contract.isContractActive"><div flex="51" ng-if="!$ctrl.collapsed" class="pool-label" data-translate="global.menu.dateto">Data wa\u017Cno\u015Bci:</div><div id="contractDateTo" flex="49" layout="row" layout-align="end end" class="contract-value">{{$ctrl.getContractDate() | date:\'dd.MM.yyyy\' }}</div></div></div><div class="contract-group" ng-if="!$ctrl.onShowReports"><div layout="row" layout-align="start center" ng-if="$ctrl.contract.isContractActive"><div flex="49" ng-if="!$ctrl.collapsed" class="pool-label" data-translate="global.menu.contract.limit">Contract Limit:</div><div id="contractLeft" flex="51" layout-align="end end" class="contract-value"><span class="contract-limit">{{$ctrl.contract.contNumOfPlagReports | number}}</span></div></div><div layout="row" layout-align="start center" ng-if="$ctrl.contract.isContractActive"><div flex="20" ng-if="!$ctrl.collapsed" class="pool-label" data-translate="global.menu.contract.reportsleft">Reports left:</div><div id="contractLimit" flex="80" layout-align="end end" class="contract-value"><span class="contract-limit">{{$ctrl.contract.contNumOfPlagReportsLeft | number}}</span></div></div><div layout="row" layout-align="start center" ng-if="$ctrl.contract.isContractActive"><div flex="49" ng-if="!$ctrl.collapsed" class="pool-label" data-translate="global.menu.contract.type">Contract type</div><div id="contractLimitType" flex="51" layout-align="end end" class="contract-value"><span class="contract-limit">{{($ctrl.contract.contractType === 0 ? \'global.menu.contract.type.documents\' : \'\') | translate}} {{($ctrl.contract.contractType === 1 ? \'global.menu.contract.type.chars\' : \'\') | translate}} {{($ctrl.contract.contractType === 2 ? \'global.menu.contract.type.users\' : \'\') | translate}} {{($ctrl.contract.contractType === 3 ? \'global.menu.contract.type.authors\' : \'\') | translate}}</span></div></div><div layout="row" layout-align="start center" ng-if="$ctrl.contract.isContractActive && !$ctrl.onShowReports"><div flex="49" ng-if="!$ctrl.collapsed" class="pool-label" data-translate="global.menu.usage">Wykorzystano:</div><div id="contractUsage" flex="51" layout-align="end end" class="contract-value">{{$ctrl.contract.percentUsed}}%</div></div><div layout="row" layout-align="start center" ng-if="$ctrl.contract.isContractActive && !$ctrl.onShowReports"><md-progress-linear class="progress-bar-usage" md-mode="determinate" value="{{$ctrl.contract.percentUsed}}"></md-progress-linear></div></div><div class="contract-group" ng-if="$ctrl.contract.isContractActive && !$ctrl.onShowReports && $ctrl.contract.contAiDetectionPool"><hr><div layout="row" layout-align="start center" ng-if="$ctrl.contract.isContractActive && $ctrl.contract.contAiDetectionPool"><div flex="49" ng-if="!$ctrl.collapsed" class="pool-label" data-translate="global.menu.contract.ai.limit">AI Limit:</div><div id="contractLeftAi" flex="51" layout-align="end end" class="contract-value"><span class="contract-limit">{{$ctrl.contract.contNumOfAiDetection | number}}</span></div></div><div layout="row" layout-align="start center" ng-if="$ctrl.contract.isContractActive && $ctrl.contract.contAiDetectionPool"><div flex="49" ng-if="!$ctrl.collapsed" class="pool-label" data-translate="global.menu.contract.reportsleft">AI left:</div><div id="contractLimitAi" flex="51" layout-align="end end" class="contract-value"><span class="contract-limit">{{$ctrl.contract.contNumOfAiDetectionLeft | number}}</span></div></div><div layout="row" layout-align="start center" ng-if="$ctrl.contract.isContractActive && $ctrl.contract.contAiDetectionPool"><div flex="49" ng-if="!$ctrl.collapsed" class="pool-label" data-translate="global.menu.contract.type">Contract type</div><div id="contractLimitAiType" flex="51" layout-align="end end" class="contract-value"><span class="contract-limit">{{\'global.menu.contract.type.chars\' | translate}}</span></div></div><div layout="row" layout-align="start center" ng-if="$ctrl.contract.isContractActive && !$ctrl.onShowReports"><div flex="49" ng-if="!$ctrl.collapsed" class="pool-label" data-translate="global.menu.usage">Wykorzystano:</div><div id="contractUsageAi" flex="51" layout-align="end end" class="contract-value">{{$ctrl.contract.percentUsedAi}}%</div></div><div layout="row" layout-align="start center" ng-if="$ctrl.contract.isContractActive && !$ctrl.onShowReports"><md-progress-linear class="progress-bar-usage" md-mode="determinate" value="{{$ctrl.contract.percentUsedAi}}"></md-progress-linear></div></div></div><div id="clientContract" layout="column" layout-padding class="contract" ng-if="$ctrl.showContract && !$ctrl.contract.isContractActive && !$ctrl.onShowReports"><div class="contract-group"><div id="contractExpired" layout="row" layout-align="start center" class="contract-info" data-translate="global.menu.contract-used" ng-if="!$ctrl.contract.isContractActive"></div></div></div>');
$templateCache.put('app/components/conversion-tracking-price/conversion-tracking-price.template.html','');
$templateCache.put('app/components/detect-browser/detect-browser.template.html','<div layout="column" layout-align="center center" class="unlogged"><md-content><form novalidate class="form" name="form" autocomplete="on"><div layout="row" layout-xs="column"><div class="login-logo" layout-xs="row" flex="50" flex-xs="100" layout-align="end start" layout-align-xs="center center" flex-gt-sm></div><div layout-xs="row" flex-xs="100" flex="50" layout-align="end start" layout-align-xs="center center" layout-padding class="choose-lang" flex-gt-sm><lang-select on-obj-lang=""></lang-select></div></div><div flex="100" layout="column"><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch><md-card-content><div layout="row" layout-margin layout-align="center center" class="md-padding"><h4 class="login-info" data-translate="global.messages.info.ie"></h4></div></md-card-content></md-card></div></form></md-content></div>');
$templateCache.put('app/components/detect-landing/detect-landing.template.html','');
$templateCache.put('app/components/detect-tabs/detect-tabs.template.html','');
$templateCache.put('app/components/fb-pixel/fb-pixel.template.html','');
$templateCache.put('app/components/lang-select/lang-select.template.html','<md-menu layout="row" layout-align="end end"><md-button aria-label="open" ng-click="$mdMenu.open()" data-translate="global.menu.language" translate-values="{lang: \'{{$ctrl.pickedLanguage}}\'}"></md-button><md-menu-content width="3"><md-menu-item ng-repeat="language in $ctrl.availableLanguages"><md-button aria-label="change Language" ng-click="$ctrl.changeLanguage(language);$ctrl.setLang();">{{language | findLanguageFromKey}}</md-button></md-menu-item></md-menu-content></md-menu>');
$templateCache.put('app/components/plagiat-ng-messages/plagiat-ng-messages.template.html','<div ng-messages="vm.formElement.$error" multiple="multiple" role="alert"><div ng-message="required" data-translate="{{vm.translateValues.required ? vm.translateValues.required : \'global.validation.required\'}}"></div><div ng-message="pattern" data-translate="{{vm.translateValues.pattern ? vm.translateValues.pattern : \'global.validation.pattern\'}}"></div><div ng-message="min" data-translate="{{vm.translateValues.min ? vm.translateValues.min : \'global.validation.min\'}}"></div><div ng-message="max" data-translate="{{vm.translateValues.max ? vm.translateValues.max : \'global.validation.max\'}}"></div><div ng-message="minlength" data-translate="{{vm.translateValues.minlength ? vm.translateValues.minlength : \'global.validation.minlength\'}}"></div><div ng-message="maxlength" data-translate="{{vm.translateValues.maxlength ? vm.translateValues.maxlength : \'global.validation.maxlength\'}}"></div><!--CUSTOM--><div ng-message="translationCodeExist" data-translate="translations.validation.code.exist"></div><div ng-message="conflictingExternalTranslationCode" data-translate="translations.validation.conflicting-external-translation-code"></div></div>');
$templateCache.put('app/components/select-language/select-language.template.html','<form name="form" ng-cloak><md-toolbar><div class="md-toolbar-tools"><h2>{{\'global.select.language.title\' | translate}}</h2></div></md-toolbar><md-dialog-content><div class="md-dialog-content" layout-margin><md-radio-group ng-model="languageVm.pickedLanguageKey" ng-controller="JhiLanguageController as languageVm"><md-radio-button ng-value="language" ng-repeat="language in languageVm.availableLanguages" ng-click="languageVm.changeLanguage(language); languageVm.setLang(language); langChangedOnStartBroadcast()">{{language | findLanguageFromKey}}</md-radio-button></md-radio-group></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button aria-label="global ok" ng-click="closeDialog()" data-translate="global.button.ok"></md-button></md-dialog-actions></form>');
$templateCache.put('app/components/select-page-size/select-page-size.template.html','<div class="box-limit"><span data-translate="global.table.search.show"></span><md-input-container><md-select class="show-limit" aria-label="select records per page" ng-model="queryRequest.limit" ng-change="onValueChosen()" layout-align="center center"><md-option ng-value="5"><em>5</em></md-option><md-option ng-value="10"><em>10</em></md-option><md-option ng-value="20"><em>20</em></md-option><md-option ng-value="30"><em>30</em></md-option></md-select></md-input-container><span data-translate="global.table.search.records"></span></div>');
$templateCache.put('app/components/profile/change-password.tmpl.html','<md-dialog aria-label="" class="change-password"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="global.form.change-password.title"></h2></div></md-toolbar><change-password></change-password></md-dialog>');
$templateCache.put('app/components/profile/profile-form.tmpl.html','<md-dialog aria-label="" class="upload-text"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="global.form.edit.title"></h2></div></md-toolbar><profile-form></profile-form></md-dialog>');
$templateCache.put('app/components/profile/profile.template.html','<md-menu-item hide-xs><md-button aria-label="logout" layout="row" ng-click="$ctrl.showEditForm()" data-translate="global.menu.account.edit" layout-align="center center"></md-button></md-menu-item><md-menu-item hide-xs><md-button aria-label="changePassword" layout="row" ng-click="$ctrl.showChangePasswordForm()" data-translate="global.menu.account.change-password" layout-align="center center"></md-button></md-menu-item><md-menu-item hide-xs ng-if="$ctrl.isIndividual"><md-button aria-label="deleteAccount" layout="row" ng-click="$ctrl.deleteAccountButtonClicked()" data-translate="global.menu.account.delete-account.button" layout-align="center center"></md-button></md-menu-item><md-menu-divider hide-xs></md-menu-divider><md-menu-item hide-xs><md-button aria-label="logout" layout="row" ng-click="$ctrl.logout($event)" layout-align="center center"><span data-translate="global.menu.account.logout"></span> <span ng-if="$ctrl.showLogoutToRootBtn" data-translate="global.menu.account.logout.to.root"></span></md-button></md-menu-item><span class="sidenav-lang" show-xs hide-gt-xs><md-menu ng-controller="JhiLanguageController as languageVm"><a class="md-button" layout="row" layout-align="center center" ng-click="$mdMenu.open()"><md-tooltip md-delay="100" md-direction="right" ng-if="$ctrl.collapsed">{{\'global.menu.language\' | translate}}</md-tooltip><i class="material-icons">language</i></a><md-menu-content width="3"><md-menu-item ng-repeat="language in languageVm.availableLanguages"><md-button aria-label="change Language" ng-click="languageVm.changeLanguage(language); languageVm.setLang(language);">{{language | findLanguageFromKey}}</md-button></md-menu-item></md-menu-content></md-menu></span><span class="sidenav-profile" show-xs hide-gt-xs><li><a ng-click="$ctrl.showEditForm()" class="md-button" layout="row" layout-align="center center"><md-tooltip md-delay="100" md-direction="right" ng-if="$ctrl.collapsed">{{\'global.menu.account.edit\' | translate}}</md-tooltip><i class="material-icons">settings_applications</i></a></li><li><a ng-click="$ctrl.showChangePasswordForm()" class="md-button" layout="row" layout-align="center center"><md-tooltip md-delay="100" md-direction="right" ng-if="$ctrl.collapsed">{{\'global.menu.account.change-password\' | translate}}</md-tooltip><i class="material-icons">security</i></a></li><li><a ng-click="$ctrl.logout($event)" class="md-button" layout="row" layout-align="center center"><i class="material-icons">power_settings_new</i></a></li></span>');
$templateCache.put('app/components/session-countdown/session-countdown.template.html','<md-tooltip md-delay="100" md-direction="bottom" class="session-tooltip">{{ \'global.messages.info.session\'| translate }}</md-tooltip><span data-translate="global.sessioncountdown" class="session-label"></span> <span>: {{$ctrl.timer}} <i class="material-icons">info</i></span>');
$templateCache.put('app/components/token/token.template.html','<md-divider></md-divider><div layout="column" class="tokens" layout-padding><div layout="row" layout-align="start center"><h3 layout-padding data-translate="global.menu.yourcontract"></h3></div><div layout="row" layout-align="start center"><div flex="60" ng-if="!$ctrl.collapsed" data-translate="global.menu.tokens">Liczba token\xF3w:</div><div flex="40" layout="row" layout-align="end end" id="tokensAvailable" class="tokens-info" layout-padding>{{$ctrl.tokens.availableTokens}} T</div></div><div layout="row" layout-align="start center"><div flex="60" ng-if="!$ctrl.collapsed" data-translate="global.menu.tokensneeded">:</div><div flex="40" layout="row" layout-align="end end" class="tokens-info" layout-padding>{{$ctrl.tokens.tokensNeeded}} T</div></div><div layout="row" layout-align="start center"><md-button aria-label="Buy tokens" layout-fill class="md-raised md-primary button-info" ng-click="$ctrl.buyTokens()" data-translate="global.button.buy-tokens"></md-button></div></div>');
$templateCache.put('app/components/upload-file/upload-file.template.html','<div class="dragbox-input"><div class="button dragbox-input" name="files" ngf-max-size="$ctrl.maxSize ? $ctrl.maxSize : \'100MB\'" ngf-min-height="100" ng-disabled="$ctrl.isDisabled" ng-class="{\'dragbox-disabled\': $ctrl.isDisabled}" ngf-accept="$ctrl.onAvailableExtensions" ngf-resize="{width: 100, height: 100}" ngf-pattern="$ctrl.onAvailableExtensions" accept="{{$ctrl.onAvailableExtensions}}" ngf-multiple="$ctrl.allowMultipleFiles" ngf-select="$ctrl.getTheFiles($files,$invalidFiles)" ngf-drop="$ctrl.getTheFiles($files,$invalidFiles)"><div class="dragbox-icon-cloud"><i class="material-icons">backup</i></div><label class="overflow-hidden"><strong data-translate="document.click">Kliknij</strong> <span class="dragbox-dragndrop" data-translate="document.toupload"></span></label></div></div>');
$templateCache.put('app/landing/landing-page/landing-page-invoice.template.html','<md-dialog aria-label="landing invoice" class="landing-page-invoice"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="landing.loader.title" ng-if="!(vm.isRomania || vm.isPoland)"></h2><h2 data-translate="landing.invoice.enter-invoice-data" ng-if="vm.isRomania || vm.isPoland"></h2></div></md-toolbar><form name="formInvoice" ng-cloak><md-dialog-content style="min-width: 650px"><div class="md-dialog-content" layout-margin ng-if="!(vm.isRomania || vm.isPoland)"><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div><md-input-container class="md-block"><span data-translate="landing.loader.content"></span></div><div class="md-dialog-content" layout-margin ng-if="vm.isRomania || vm.isPoland"><div class="loader" layout="row" layout-sm="column" layout-align="space-around" ng-if="vm.isLoading"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div><md-radio-group ng-model="vm.isCompany" layout="row" layout-padding><md-radio-button ng-value="true"><span data-translate="payments.metric.address.placeholder.business"></span></md-radio-button><md-radio-button ng-value="false"><span data-translate="payments.metric.address.placeholder.private-person"></span></md-radio-button></md-radio-group><div layout="row" layout-xs="column" ng-show="!vm.isCompany"><md-input-container ng-if="!vm.isCompany" class="md-block" flex="100"><input ng-model="vm.invoice.company" placeholder="{{!vm.invoice.company ? \'payments.metric.address.placeholder.first-and-last-name\' : \'payments.metric.address.first-and-last-name\' | translate}}" required></md-input-container></div><div layout="row" layout-xs="column" ng-show="vm.isCompany"><md-input-container ng-if="vm.isCompany" class="md-block" flex="50" flex-xs="100"><input ng-model="vm.invoice.company" placeholder="{{ \'payments.metric.address.company\' | translate}}" required></md-input-container><md-input-container ng-if="vm.isCompany" class="md-block" flex="50" flex-xs="100"><input ng-model="vm.invoice.nip" placeholder="{{ \'payments.metric.address.nip\' | translate}}" md-maxlength="16" required></md-input-container></div><div layout="row" layout-xs="column"><md-input-container class="md-block" flex="50" flex-xs="100"><input ng-model="vm.invoice.street" placeholder="{{ \'payments.metric.address.street\' | translate}}" required></md-input-container><md-input-container class="md-block" flex="50" flex-xs="100" ng-if="vm.isRomania"><label data-translate="payments.metric.address.county"></label><md-select ng-model="vm.invoice.county" ng-change="vm.onRoCountyChange()" required><md-option ng-repeat="county in vm.romanianCounties" ng-value="county.name">{{ county.name }}</md-option></md-select></md-input-container><md-input-container class="md-block" flex="100" ng-if="!vm.isRomania"><label data-translate="payments.metric.address.invoice-country"></label><md-select placeholder="{{\'payments.metric.address.invoice-country\' | translate}}" ng-model="vm.invoice.country" required><md-option ng-value="code" ng-repeat="code in vm.countries">{{(\'country.\' + code.toLowerCase()) | translate}}</md-option></md-select></md-input-container><md-input-container class="md-block" flex="100" ng-if="vm.isRomania"><label data-translate="payments.metric.address.invoice-country"></label><md-select placeholder="{{\'payments.metric.address.invoice-country\' | translate}}" ng-model="vm.invoice.country" required><md-option ng-value="vm.invoice.country" selected="vm.invoice.country" ng-disabled="true">{{(\'country.\' + vm.invoice.country.toLowerCase()) | translate}}</md-option></md-select></md-input-container></div><div layout="row" layout-xs="column"><md-input-container class="md-block" flex="50" flex-xs="100" ng-if="vm.isRomania"><md-autocomplete class="white-background" md-floating-label="{{\'payments.metric.address.city\' | translate}}" md-selected-item="vm.invoice.city" md-search-text="searchText" md-items="city in vm.romanianCities | filter:searchText" md-item-text="city" ng-disabled="!vm.invoice.county" md-min-length="0" md-require-match="true" md-delay="100" md-select-on-match="true" md-clear-button="true" md-no-cache="true" required><md-item-template><span md-highlight-text="searchText">{{ city }}</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{searchText}}"</md-not-found></md-autocomplete></md-input-container><md-input-container ng-if="vm.isPoland" class="md-block" flex="50" flex-xs="100"><input ng-model="vm.invoice.city" placeholder="{{!$ctrl.paymentForm.invoice.city ? \'payments.metric.address.placeholder.city\' : \'payments.metric.address.city\' | translate}}" required></md-input-container><md-input-container class="md-block" flex="50" flex-xs="100"><input ng-model="vm.invoice.zip" placeholder="{{ \'payments.metric.address.post-code\' | translate}}" md-maxlength="10"></md-input-container></div><div class="mt-3"><md-checkbox class="md-block" ng-model="vm.agreement" aria-label="Data Correct Agreement" required><span data-translate="payments.metric.agreement"></span></md-checkbox></div><div layout="row" layout-xs="column" layout-align="end end"><md-button class="md-raised md-primary button-forward" ng-disabled="(formInvoice.$invalid || !vm.agreement)" ng-click="vm.goUpload()" data-translate="payments.metric.buttons.forward" id="goToPaymentMethodButton">Dalej</md-button></div></div></md-dialog-content></form></md-dialog>');
$templateCache.put('app/landing/landing-page/landing-page.html','<div class="landing landing-image" layout-align="center start" layout-fill ng-if="!vm.pending"><div class="landing-header" layout="row"><div flex-gt-sm="30" flex-offset-gt-sm="5" flex-sm="50" flex-xs="50" layout-align="start center"><div class="landing-header-logo-bg"><a href="{{ vm.landingLink }}"><div class="landing-header-logo"></div></a></div></div><div flex-gt-sm="30" hide-xs hide-sm></div><div flex-gt-sm="30" flex-sm="50" flex-xs="50" layout-align="end center"><div layout="row" layout-align="end center"><md-button href="{{ vm.loginLink }}" class="md-raised md-primary mr-sm-0" data-translate="global.button.login" ng-if="!vm.isAuthenticated()"></md-button></div></div></div><div layout="row" layout-xs="column"><div flex-gt-sm="30" flex-offset-gt-sm="5" flex-sm="50" flex-xs="100" class="landing-content"><h3 data-translate="landing.content.title" class="landing-title pb-0"></h3><span data-translate="landing.content.leader" class="landing-leader" ng-if="vm.instance != \'ro\'"></span> <span data-translate="landing.content.leader_instancero" class="landing-leader" ng-if="vm.instance == \'ro\'"></span> <span data-translate="landing.content.checkout" class="landing-checkout"></span> <span data-translate="landing.content.list" class="landing-list"></span> <span layout="row" layout-align="center center"><span class="landing-red-mark"><span data-translate="landing.content.slogan"></span></span></span></div><div flex-gt-sm="60" flex-sm="50" flex-xs="100" class="landing-form"><div layout="row" layout-wrap><div flex-gt-sm="50" flex-sm="100" flex-xs="100"><md-content layout-align="center start" layout-padding class="h-100 p-0 landing-middle"><div layout="row"><div flex="100"><md-content layout-align="start center" layout-padding class="h-100"><div layout="row" layout-align="center center" class="landing-title pb-0 pt-3"><h4 class="pb-0 m-0 landing-header-text" data-translate="landing.form.verify"></h4><!-- <span class="landing-content pl-5 pt-0" data-translate="landing.form.fulfill"></span> --></div></md-content></div></div><div layout="column" layout-align="center center"><div layout="row" layout-align="center center" class="landing-file-name"><md-button aria-label="file name" class="file-name" ng-if="vm.fileName">{{vm.fileName}}</md-button><md-button ng-click="vm.clearFiles()" aria-label="file name" class="delete-button" ng-if="vm.fileName && !vm.isLoading && !vm.isCalculatingPrice"><i class="material-icons" ng-if="vm.fileName">clear</i></md-button></div><form ng-if="!vm.fileName" class="dragbox dragbox-big has-advanced-upload" ng-show="!vm.success" name="upload-file-form" role="form" novalidate show-validation><upload-file on-get-the-files="vm.getTheFiles" files="vm.files" is-loading="vm.isLoading || vm.isCalculatingPrice" on-available-extensions="vm.availableExtensions"></upload-file></form><form name="form2" role="form" novalidate show-validation><div layout="row" ng-if="!vm.fileName" class="landing-content"><span translate="landing.price.explore"></span></div><ng-include ng-if="vm.documentSize" src="\'app/components/document/extra-options/extra-options-form.template.html\'"></ng-include><div layout-padding layout="row" class="pt-0 pb-0" ng-if="vm.totalPrice && vm.fileName && (vm.totalPrice > 0) && vm.availableCurrencies && (vm.availableCurrencies.length > 1)"><md-button ng-repeat="value in vm.availableCurrencies" aria-label="currency1" class="md-raised currency-button" ng-class="{\'md-primary\': vm.currencyChosen(value)}" ng-click="vm.chooseCurrency(value)" layout="column">{{value}}</md-button></div><div layout-padding layout="row" ng-if="vm.fileName"><span class="landing-total-price" ng-if="vm.totalPrice && vm.fileName && vm.totalPrice > 0 && !vm.isLoading" translate="landing.price-currency" translate-values="{ price: vm.getPriceInCurrency(), currency: \'{{vm.currency}}\' }"></span> <span class="landing-total-price" ng-if="vm.fileName && vm.totalPrice === 0" translate="landing.free-check"></span></div><md-progress-linear flex layout="row" md-mode="indeterminate" ng-if="vm.isCalculatingPrice"></md-progress-linear></form></div><div class="landing-input-container landing-radio-box" layout-margin ng-if="vm.fileName && vm.isPoland"><md-radio-group class="landing-radio-box" ng-model="vm.isInvoice" layout="column" required><md-radio-button ng-value="false" required><span data-translate="payments.metric.no-invoiceissue"></span></md-radio-button><md-radio-button ng-value="true"><span data-translate="payments.metric.invoiceissue"></span></md-radio-button></md-radio-group><div ng-show="vm.validated && vm.isInvoice == null" class="landing-alert-div"><span class="landing-alert" data-translate="global.validation.required">required</span></div></div></md-content></div><div flex-gt-sm="50" flex-sm="100" flex-xs="100"><md-content layout-align="center center" layout-padding class="h-100"><form novalidate class="form" name="form" autocomplete="on"><div layout-margin layout-padding layout-align="center center" ng-if="vm.error"><md-list flex><md-subheader ng-if="vm.errorUserExists" data-translate="register.messages.error.emailexists"></md-subheader><md-subheader ng-if="vm.errorEmailExists" data-translate="register.messages.error.emailexists"></md-subheader><md-subheader ng-if="vm.otherError" data-translate="register.messages.error.othererror"></md-subheader><md-subheader ng-if="vm.isReserved" data-translate="register.messages.error.isreserved"></md-subheader><md-subheader ng-if="vm.doNotMatch" data-translate="register.messages.error.donotmatch"></md-subheader></md-list></div><div layout-margin layout-align="center center" ng-if="vm.success"><md-list flex><md-subheader class="subheader-success" data-translate="register.messages.success"></md-subheader></md-list></div><div layout-margin layout-align="center center" ng-if="!vm.success" class="landing-inputs"><md-input-container class="landing-input-container"><md-checkbox name="acceptRegulations" ng-model="vm.user.acceptRegulations" aria-label="acceptRegulations" required><span class="landing-checkbox" data-translate="global.accept-terms.terms" ng-if="vm.instance != \'ro\'"></span> <span class="landing-checkbox" data-translate="global.accept-terms.terms_instance_ro" ng-if="vm.instance == \'ro\'"></span></md-checkbox><div ng-show="vm.validated && !vm.user.acceptRegulations" class="landing-alert-div"><span class="landing-alert" data-translate="global.validation.required">required</span></div></md-input-container><md-input-container class="landing-input-container"><md-checkbox name="acceptDataProcessing" class="accept-data-processing" ng-model="vm.user.acceptDataProcesing" aria-label="acceptDataProcessing" required><md-tooltip ng-if="vm.instance != \'ro\'" class="accept-data-processing-tooltip" md-direction="top">{{ \'global.dataprocessing.info\' | translate}}</md-tooltip><span class="landing-checkbox" data-translate="global.dataprocessing.title" ng-if="vm.instance != \'ro\'"></span><md-tooltip ng-if="vm.instance === \'ro\'" md-direction="top">{{ \'global.dataprocessing.info_instance_ro\' | translate}}</md-tooltip><span class="landing-checkbox" data-translate="global.dataprocessing.title_instance_ro" ng-if="vm.instance == \'ro\'"></span></md-checkbox><div ng-show="vm.validated && !vm.user.acceptDataProcesing" class="landing-alert-div"><span class="landing-alert" data-translate="global.validation.required">required</span></div></md-input-container><landing-social-login class="mt-3" ng-provider="googlelanding" ng-params="landingPage=true" ng-disabled="vm.fbButtonDisabled()" on-button-click="vm.loginOauth2"></landing-social-login><landing-social-login class="mt-3" ng-provider="facebooklanding" ng-params="landingPage=true" ng-disabled="vm.fbButtonDisabled()" on-button-click="vm.loginOauth2"></landing-social-login><md-input-container class="md-block mt-4" flex-gt-sm><label data-translate="register.form.email"></label><input id="email" type="email" name="email" ng-model="vm.user.email" autocomplete="off" required ng-pattern="/^.+@.+\\..+$/" placeholder="{{\'register.form.placeholder.email\' | translate}}" auto-fill-sync ng-keyup="vm.checkEmailDomain()"><div ng-show="form.email.$error.pattern" class="md-input-messages-animation ng-active" data-translate="global.form.email.pattern"></div></md-input-container><label data-translate="register.form.email.domain.alert" class="md-input-messages-error ng-active" ng-show="vm.emailInputHaveWrongDomain"></label><md-input-container class="md-block mt-4" flex-gt-sm ng-if="vm.isRomania || vm.isPoland"><label data-translate="register.form.email"></label><input ng-if="vm.isRomania" id="email2RO" type="email" name="email2" ng-model="vm.user.email2" autocomplete="off" required ng-pattern="/^.+@.+\\..+$/" placeholder="{{\'register.form.placeholder.repeat-email\' | translate}}" auto-fill-sync> <input ng-if="vm.isPoland" id="email2PL" type="email" name="email2" ng-model="vm.user.email2" autocomplete="off" required ng-pattern="/^.+@.+\\..+$/" placeholder="{{\'register.form.placeholder.repeat-email\' | translate}}" auto-fill-sync onpaste="return false;"><div ng-show="form.email2.$error.pattern" class="md-input-messages-animation ng-active" data-translate="global.form.email.pattern"></div><div ng-show="vm.user.email && vm.user.email2 && (vm.user.email !== vm.user.email2)" class="md-input-messages-animation ng-active" data-translate="global.form.email.doesnt-match"></div></md-input-container><md-input-container class="md-block mt-4"><label data-translate="register.form.password"></label><input ng-model="vm.user.password" name="password" autocomplete="off" ng-attr-type="{{ vm.showPassword ? \'text\' : \'password\' }}" ng-minlength="8" ng-pattern="vm.passwordPattern" placeholder="{{\'global.form.password.placeholder\' | translate}}" auto-fill-sync required ng-keyup="vm.checkCapsLockKey($event)"> <span class="password-eye" ng-click="vm.toggleShowPassword()"><i class="material-icons" ng-class="{\'visibility\': !vm.showPassword, \'visibility_off\': vm.showPassword}">{{vm.showPassword ? \'visibility\' : \'visibility_off\'}}</i></span><div ng-show="form.password.$error.pattern" class="md-input-messages-animation ng-active" data-translate="global.form.password.pattern"></div><div ng-show="form.password.$error.minlength" class="md-input-messages-animation ng-active" data-translate="global.form.password.minlength"></div></md-input-container><label data-translate="landing.form.capslock.alert" class="md-input-messages-error ng-active" ng-show="vm.isCapsLockOn"></label><md-input-container class="md-block mt-4" flex-gt-sm><label data-translate="register.form.firstname"></label><input ng-model="vm.user.name" name="firstname" type="text" placeholder="{{\'register.form.placeholder.firstname\' | translate}}" required></md-input-container><md-input-container class="md-block mt-4" flex-gt-sm><label data-translate="register.form.surname"></label><input ng-model="vm.user.surname" name="surname" type="text" placeholder="{{\'register.form.placeholder.surname\' | translate}}" required></md-input-container></div></form></md-content></div></div><div layout="row" layout-wrap><md-content flex="100" layout="column" layout-align="center-center"><div layout="row"><div class="md-padding py-1 flex-50" flex-offset="25" ng-if="!vm.success"><md-button aria-label="Register" class="md-raised md-primary" data-translate="landing.button.upload" layout="column" layout-fill ng-click="vm.registerAndUpload(form, form2)" ng-disabled="vm.uploadButtonDisabled()"></md-button></div></div><div layout="row"><md-progress-linear class="md-padding py-1 flex-50 pb-5" flex-offset="25" ng-show="vm.isLoading" md-mode="indeterminate"></md-progress-linear></div><div class="pb-5" layout="row"></div></md-content></div></div></div><div class="landing-info" layout="column" layout-align="center center" flex-gt-sm="90" flex-offset-gt-sm="5" flex-sm="100" flex-xs="100"><div layout="row" data-translate="landing.content.works"></div><div layout="row" data-translate="landing.content.price" ng-if="vm.instance != \'ro\'"></div><div layout="row" data-translate="landing.content.price_instancero" ng-if="vm.instance == \'ro\'"></div><div layout="row" data-translate="landing.content.more" ng-if="vm.instance != \'ro\'"></div><div layout="row" data-translate="landing.content.more_instancero" ng-if="vm.instance == \'ro\'"></div></div><div class="landing-footer" layout="column" layout-align="center center"><div class="landing-footer-logo" layout="row"></div><div class="landing-footer-text" layout="row" data-translate="landing.footer.text"></div></div></div><div id="paymentForm" style="display:none"><form><ul><li ng-repeat="(key, value) in vm.paymentParams"><input type="text" name="{{key}}" value="{{value}}"></li></ul><md-button class="md-raised md-primary" ng-click="vm.submitMe()">Submit</md-button></form></div>');
$templateCache.put('app/layouts/dialog/confirm-terms.tmpl.html','<confirm-terms on-confirm-terms="false"></confirm-terms>');
$templateCache.put('app/layouts/dialog/landing-redirect.tmpl.html','<md-dialog aria-label="redirect"><md-dialog-content><div class="md-dialog-content" layout="row" layout-align="center center"><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div><span data-translate="landing.loader"></span></div></md-dialog-content><md-dialog-actions><md-button ng-click="_dialog.closeDialog()" class="md-primary"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/layouts/dialog/redirect-cancel.tmpl.html','<md-dialog aria-label="redirect"><md-dialog-content><div class="md-dialog-content" layout="row" layout-align="center center"><h3 data-translate="global.messages.info.redirect"></h3></div></md-dialog-content><md-dialog-actions><md-button ng-click="_dialog.closeDialog()" class="md-primary"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/layouts/dialog/redirect.tmpl.html','<md-dialog aria-label="redirect"><md-dialog-content><div class="md-dialog-content" layout="row" layout-align="center center"><h3 data-translate="global.messages.info.redirect"></h3></div></md-dialog-content></md-dialog>');
$templateCache.put('app/layouts/error/accessdenied.html','<div layout="column" class="site-container"><md-content class="documents" flex-xs="100" layout="row"><div layout-align="center center"><header class="header"><h5 data-translate="error.title"></h5><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></header></div></md-content><div class="table-container"><md-content layout="row" layout-margin><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch aria-hidden="false" flex flex-xs="100"></md-card></md-content></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/footer/footer.template.html','<div class="footer">footer</div>');
$templateCache.put('app/layouts/navbar/navbar.html','<select-language style="display: none" ng-if="vm.isAuthenticated() && vm.show" on-select-language="vm.account.userFirstLoginDate"></select-language><md-toolbar ng-if="vm.isAuthenticated() && vm.show" class="navbar" id="navbar" ng-controller="NavbarController as navbarVm"><div layout="row" flex class="navbar-container"><md-toolbar-filler layout="row" layout-align="center center" flex="20" flex-sm="30" flex-md="30" flex-xs="30" flex-gt-lg="15"><span class="navbar-logo" layout-align="start center"></span></md-toolbar-filler><div layout="row" class="md-caption" layout-align="start center" hide-xs hide-sm flex="70"><span class="navbar-version" layout="row" layout-align="center center"><session-countdown layout="row" class="session-countdown"></session-countdown></span><span ng-if="vm.account.showAppVersion"><span class="navbar-version" layout="row" layout-align="center center">VERSION: <a class="version-link" href="https://jira.plagiat.pl/browse/{{ vm.account.appVersion }}" target="_blank" rel="noopener noreferrer">{{ vm.account.appVersion }}</a></span></span></div><div layout="row" layout-align="end center" flex="100"><div flex="20" layout="row" layout-align="end center" layout-margin show-xs hide-gt-xs><i class="material-icons" ng-click="vm.toggleMenu(\'left\')">menu</i></div><div layout-align="end center" hide-xs><md-menu ng-controller="JhiLanguageController as languageVm"><md-button aria-label="open" ng-click="$mdMenu.open()" data-translate="global.menu.language" translate-values="{lang: \'{{languageVm.pickedLanguage}}\'}"></md-button><md-menu-content width="3"><md-menu-item ng-repeat="language in languageVm.availableLanguages"><md-button aria-label="change Language" ng-click="languageVm.changeLanguage(language); languageVm.setLang(language);">{{language | findLanguageFromKey}}</md-button></md-menu-item></md-menu-content></md-menu><md-menu><md-button aria-label="open" ng-click="$mdMenu.open()" ng-class="{\'logoutToRootInfoBtn\': vm.logoutToRootInfo}"><span ng-if="!vm.logoutToRootInfo" data-translate="global.menu.profile.email" translate-values="{username: \'{{navbarVm.account.login}}\'}"></span> <span ng-if="vm.logoutToRootInfo">{{vm.logoutToRootInfo}} <span class="logoutToRootInfo"><br>{{\'global.menu.profile.logged.as\' | translate}}:<span data-translate="global.menu.profile.email" translate-values="{username: \'{{navbarVm.account.login}}\'}"></span></span></span></md-button><md-menu-content width="3"><profile hide-xs></profile></md-menu-content></md-menu></div></div></div></md-toolbar>');
$templateCache.put('app/layouts/side-nav/side-nav.template.html','<md-sidenav ng-if="vm.isAuthenticated() && vm.show" class="md-sidenav-left" md-component-id="left" md-is-locked-open="$mdMedia(\'gt-xs\')" md-whiteframe="1" layout-fill layout="column" flex-xs="100px" id="sidenav"><md-content ng-if="vm.showAuthoritiesMenu"><div layout="row" layout-align="center center" class="sidenav-header" flex hide-xs><span flex="0" ng-hide="vm.collapsed" layout-padding data-translate="global.menu.title">Menu</span><div ng-hide="vm.collapsed" layout="row" flex="100" layout-align="end center" layout-padding><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.showmenu\' | translate}}</md-tooltip><md-tooltip md-delay="100" md-direction="right" ng-if="!vm.collapsed">{{\'global.menu.collapsemenu\' | translate}}</md-tooltip><i class="material-icons" ng-click="vm.toggleMenu()">menu</i></div><div ng-show="vm.collapsed" layout="row" flex="100" layout-align="center center" layout-padding><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.showmenu\' | translate}}</md-tooltip><md-tooltip md-delay="100" md-direction="right" ng-if="!vm.collapsed">{{\'global.menu.collapsemenu\' | translate}}</md-tooltip><i class="material-icons" ng-click="vm.toggleMenu()">menu</i></div></div><!--<ul class="sidenav-menu" ng-if="vm.isAuthenticated">--><ul class="sidenav-menu"><li ng-if="vm.isSuperAdmin || vm.isReseller || vm.isMinistry"><a class="md-button" ng-class="{ \'collapsed\': vm.collapsed}" ui-sref="client" ui-sref-active="active"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.account.clients\' | translate}}</md-tooltip><i class="material-icons">assignment_ind</i> <span ng-if="!vm.collapsed" data-translate="global.menu.account.clients"></span></a></li><li ng-if="vm.showDocuments"><a ui-sref="documents" ui-sref-active="active" class="md-button" ng-class="{ \'collapsed\': vm.collapsed}"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.account.documents\' | translate}}</md-tooltip><i class="material-icons">folder_open</i> <span ng-if="!vm.collapsed" data-translate="global.menu.account.documents"></span></a></li><li ng-if="vm.showAssignments"><a ui-sref="assignments" ui-sref-active="active" class="md-button" ng-class="{ \'collapsed\': vm.collapsed}"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.account.assignments\' | translate}}</md-tooltip><i class="material-icons-outlined">format_list_bulleted</i> <span ng-if="!vm.collapsed" data-translate="global.menu.account.assignments"></span></a></li><li ng-if="vm.showFeedbacks"><a ui-sref="feedbacks" ui-sref-active="active" class="md-button" ng-class="{ \'collapsed\': vm.collapsed}"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.account.feedbacks\' | translate}}</md-tooltip><i class="material-icons-outlined">format_list_bulleted</i> <span ng-if="!vm.collapsed" data-translate="global.menu.account.feedbacks"></span></a></li><li ng-if="vm.isOrgUnitAdmin || vm.isAdmin || vm.isSuperAdmin || vm.isReseller || vm.isMinistry"><a ui-sref="users" ui-sref-active="active" class="md-button" ng-class="{ \'collapsed\': vm.collapsed}"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.account.users\' | translate}}</md-tooltip><i class="material-icons">people</i> <span ng-if="!vm.collapsed" data-translate="global.menu.account.users"></span></a></li><li ng-if="vm.isSuperAdmin"><a ui-sref="payments-superadmin" ui-sref-active="active" class="md-button" ng-class="{ \'collapsed\': vm.collapsed}"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.account.payments\' | translate}}</md-tooltip><i class="material-icons">credit_card</i> <span ng-if="!vm.collapsed" data-translate="global.menu.account.payments"></span></a></li><li ng-if="vm.isIndividual"><a ui-sref="payments" ui-sref-active="active" class="md-button" ng-class="{ \'collapsed\': vm.collapsed}"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.account.payments\' | translate}}</md-tooltip><i class="material-icons">credit_card</i> <span ng-if="!vm.collapsed" data-translate="global.menu.account.payments"></span></a></li><li ng-if="vm.isCodeAccount && !vm.isAdmin"><a ui-sref="code-payments" ui-sref-active="active" class="md-button" ng-class="{ \'collapsed\': vm.collapsed}"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.account.code-payments\' | translate}}</md-tooltip><i class="material-icons">credit_card</i> <span ng-if="!vm.collapsed" data-translate="global.menu.account.code-payments"></span></a></li><li ng-if="vm.isAdmin && !vm.showReports"><a ui-sref="{{ vm.isSuperAdmin?  \'database-exchange-program-members\' : \'document-parameter-definitions\' }}" ui-sref-active="active" class="md-button" ng-class="{ \'collapsed\': vm.collapsed}"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.account.settings\' | translate}}</md-tooltip><i class="material-icons">settings</i> <span ng-if="!vm.collapsed" data-translate="global.menu.account.settings"></span></a></li><li ng-if="vm.isSuperAdmin"><a ui-sref="translations" ui-sref-active="active" class="md-button" ng-class="{ \'collapsed\': vm.collapsed}"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.account.translations\' | translate}}</md-tooltip><i class="material-icons">translate</i> <span ng-if="!vm.collapsed" data-translate="global.menu.account.translations"></span></a></li><li ng-if="(vm.isAdmin || vm.isMinistry) && !vm.showReports "><a ui-sref="statistics" ui-sref-active="active" class="md-button" ng-class="{ \'collapsed\': vm.collapsed}"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.account.statistics\' | translate}}</md-tooltip><i class="material-icons">equalizer</i> <span ng-if="!vm.collapsed" data-translate="global.menu.account.statistics"></span></a></li><li ng-if="vm.isSuperAdmin || (vm.isCodeAccount && !vm.isStudent && !vm.isIndividual)"><a class="md-button" ng-class="{\'collapsed\': vm.collapsed}" ui-sref="codes" ui-sref-active="active"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.codes\' | translate}}</md-tooltip><i class="material-icons">assignment_ind</i> <span ng-if="!vm.collapsed" data-translate="global.menu.codes"></span></a></li><li ng-if="!vm.isSuperAdmin && !vm.showReports && !vm.isMinistry"><a id="a-info" ui-sref="info" ui-sref-active="active" class="md-button" ng-class="{ \'collapsed\': vm.collapsed}"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.account.info\' | translate}}</md-tooltip><i class="material-icons">help_outline</i> <span ng-if="!vm.collapsed" data-translate="global.menu.account.info"></span></a></li><li ng-if="vm.showReports"><a id="inforSuspectPortals" ui-sref="portals" ui-sref-active="active" class="md-button" ng-class="{ \'collapsed\': vm.collapsed}"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.account.portals\' | translate}}</md-tooltip><i class="material-icons">analytics</i> <span ng-if="!vm.collapsed" data-translate="global.menu.account.portals"></span></a></li><li ng-if="vm.showReports"><a id="clientPortals" ui-sref="portal-of-client" ui-sref-active="active" class="md-button" ng-class="{ \'collapsed\': vm.collapsed}"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.account.portal-of-client\' | translate}}</md-tooltip><i class="material-icons">manage_accounts</i> <span ng-if="!vm.collapsed" data-translate="global.menu.account.portal-of-client"></span></a></li><li ng-if="vm.showReports"><a ui-sref="reports" ui-sref-active="active" class="md-button" ng-class="{ \'collapsed\': vm.collapsed}"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.account.reports\' | translate}}</md-tooltip><i class="material-icons">folder_open</i> <span ng-if="!vm.collapsed" data-translate="global.menu.account.reports"></span></a></li><li ng-if="vm.showComparison"><a class="md-button" ng-class="{ \'collapsed\': vm.collapsed}" ui-sref="comparision" ui-sref-active="active"><md-tooltip md-delay="100" md-direction="right" ng-if="vm.collapsed">{{\'global.menu.account.comparision\' | translate}}</md-tooltip><i class="material-icons">compare_arrows</i> <span ng-if="!vm.collapsed" data-translate="global.menu.account.comparision"></span></a></li><profile show-xs hide-gt-xs></profile></ul><md-divider ng-if="!vm.collapsed"></md-divider><token ng-if="!vm.collapsed && vm.isIndividual"></token><contract ng-if="!vm.collapsed && !vm.isIndividual" on-show-reports="vm.showReports" on-is-admin="vm.isAdmin"></contract><code-info ng-if="vm.isCodeAccount && !vm.isAdmin" on-is-collapsed="vm.collapsed"></code-info></md-content></md-sidenav>');
$templateCache.put('app/statistics/invoices-data/invoices-data.template.html','<div layout="column" class="site-container"><statistics-submenu active-tab="vm.activeTab"></statistics-submenu><div class="table-container" flex><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div><md-content layout="row" layout-margin><md-card flex><form name="form"><div layout="row" layout-padding><md-input-container flex="30"><label data-translate="statistics.model.datefrom">Data od</label><md-datepicker ng-model="vm.obj.dateFrom" input-date ng-required="true"></md-input-container><md-input-container flex="30"><label data-translate="statistics.model.dateto">Data do</label><md-datepicker ng-model="vm.obj.dateTo" input-date ng-required="true"></md-input-container></div><div layout="row" layout-align="left center"><md-button aria-label="executeInvoicesData" data-translate="statistics.generate" ng-click="vm.executeInvoicesData()" ng-disabled="form.$invalid || vm.pending" class="md-raised md-primary"></md-button><!--\n                        <md-button\n                                aria-label="generateInvoicesDataXls"\n                                data-translate="global.bottomsheet.getreport"\n                                ng-click="vm.generateInvoicesDataXls()"\n                                ng-disabled="form.$invalid"\n                                class="md-raised md-primary"></md-button>\n                                --></div></form><div><div><h3 data-translate="statistics.results"></h3></div><div class="table-container" flex><md-table-container><table id="tableFullStats" md-table><thead md-head><tr md-row><th md-column><span>#</span></th><th md-column ng-repeat="col in vm.columns track by $index"><span>{{col}}</span></th></tr></thead><tbody md-body><tr md-row ng-repeat="row in vm.result.rows track by $index"><td md-cell><span>{{ ($index + 1) }}</span></td><td md-cell ng-repeat="cell in row track by $index"><span>{{cell}}</span></td></tr></tbody></table></md-table-container></div></div></md-card></md-content></div></div>');
$templateCache.put('app/statistics/full-stats/full-stats.template.html','<div layout="column" class="site-container"><statistics-submenu active-tab="vm.activeTab"></statistics-submenu><div class="table-container" flex><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div><md-content layout="row" layout-margin><md-card flex><form name="form"><div layout="row" layout-padding><md-input-container flex="30" flex-xs="100"><label data-translate="statistics.choose">Statystyka</label><md-select ng-model="vm.obj.option" ng-required="true"><md-option ng-value="val" ng-repeat="val in vm.availableStats">{{val.name | translate}}</md-option></md-select></md-input-container></div><div layout="row" layout-padding><md-input-container flex="30" ng-hide="!vm.displayField(\'dateFrom\')"><label data-translate="statistics.model.datefrom">Data od</label><md-datepicker ng-model="vm.obj.dateFrom" input-date ng-required="vm.displayField(\'dateFrom\')"></md-input-container><md-input-container flex="30" ng-hide="!vm.displayField(\'dateTo\')"><label data-translate="statistics.model.dateto">Data do</label><md-datepicker ng-model="vm.obj.dateTo" input-date ng-required="vm.displayField(\'dateTo\')"></md-input-container></div><div layout="row" layout-padding ng-if="vm.displayField(\'clientIds\')"><md-input-container flex="50" ng-hide="!vm.displayField(\'clientIds\')"><input ng-model="vm.obj.clientIds" ng-pattern="/^[0-9, ]+$/" placeholder="{{\'statistics.model.client-ids\'| translate}}" ng-required="vm.displayField(\'clientIds\')" ng-keyup="$event.keyCode === vm.keyCodeEnter && vm.executeFullStats()"></md-input-container></div><div layout="row" layout-padding ng-if="vm.displayField(\'paymentType\')"><md-input-container flex="50" ng-hide="!vm.displayField(\'paymentType\')"><input ng-model="vm.obj.paymentType" ng-pattern="/^[0-9, ]+$/" placeholder="{{\'statistics.model.payment-type-ids\'| translate}}" ng-required="vm.displayField(\'paymentType\')" ng-keyup="$event.keyCode === vm.keyCodeEnter && vm.executeFullStats()"></md-input-container></div><div layout="row" layout-padding ng-if="vm.displayField(\'clientSetting\')"><md-input-container flex="50" ng-hide="!vm.displayField(\'clientSetting\')"><input ng-model="vm.obj.clientSetting" placeholder="{{\'statistics.model.client-setting\'| translate}}" ng-required="vm.displayField(\'clientSetting\')" ng-keyup="$event.keyCode === vm.keyCodeEnter && vm.executeFullStats()"></md-input-container></div><div layout="row" layout-align="left center"><md-button aria-label="execute fullstats" data-translate="statistics.generate" ng-click="vm.executeFullStats()" ng-disabled="form.$invalid" class="md-raised md-primary"></md-button><md-button aria-label="execute fullstats xls" data-translate="global.bottomsheet.getreport" ng-click="vm.generateFullStatsXls()" ng-disabled="form.$invalid" class="md-raised md-primary"></md-button></div></form><div><div><h3 data-translate="statistics.results"></h3></div><div class="table-container" flex><md-table-container><table id="tableFullStats" md-table><thead md-head><tr md-row><th md-column><span>#</span></th><th md-column ng-repeat="col in vm.result.executeDTO.option.columns track by $index"><span>{{col}}</span></th></tr></thead><tbody md-body><tr md-row ng-repeat="row in vm.result.rows track by $index"><td md-cell><span>{{ ($index + 1) }}</span></td><td md-cell ng-repeat="cell in row track by $index"><span>{{cell}}</span></td></tr><tr ng-repeat-end md-row><td md-cell class="disabled-row"><span>--</span></td><td md-cell class="disabled-row" ng-repeat="val in vm.result.summary track by $index"><span>{{val}}</span></td></tr></tbody></table></md-table-container></div></div></md-card></md-content></div></div>');
$templateCache.put('app/statistics/statistics-submenu/statistics-submenu.template.html','<md-content class="users settings-menu" layout="row" ng-if="$ctrl.isSuperAdmin"><md-nav-bar md-no-ink-bar="disableInkBar" md-selected-nav-item="$ctrl.activeTab" nav-bar-aria-label="navigation links"><md-nav-item class="tabs-menu-li-elipsis" name="statistics" md-nav-sref="statistics">{{\'global.menu.account.statistics\' | translate}}</md-nav-item><md-nav-item name="fullStats" md-nav-sref="full-stats" ng-if="$ctrl.isSuperAdmin">{{\'statistics.menu.full-stats\' | translate}}</md-nav-item><md-nav-item name="invoicesData" md-nav-sref="invoices-data" ng-if="$ctrl.isSuperAdmin && $ctrl.showInvoicesData">Invoices</md-nav-item></md-nav-bar></md-content>');
$templateCache.put('app/statistics/views/ai-detection-statistics-table.html','<md-card-content><div><span data-translate="statistics.units.all.characters"></span> {{vm.data.charactersSum | number}}</div><div><span data-translate="statistics.units.all.documents"></span> {{vm.data.documentsSum | number}}</div></md-card-content>');
$templateCache.put('app/statistics/views/checks-statistics-table.html','<md-card-content layout="row" flex="20" flex-sm="40" flex-xs="100" layout-align="start center" class="box-limit"><span data-translate="global.table.search.show"></span><md-input-container><md-select class="show-limit" aria-label="select records per page" ng-model="vm.size" ng-change="vm.generate()" layout-align="center center"><md-option ng-value="5"><em>5</em></md-option><md-option ng-value="10"><em>10</em></md-option><md-option ng-value="20"><em>20</em></md-option><md-option ng-value="30"><em>30</em></md-option></md-select></md-input-container><span data-translate="global.table.search.records"></span></md-card-content><div class="table-container"><md-content layout="row" class="auto-height" layout-margin><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch aria-hidden="false" flex><md-table-container><table md-table md-row-select><thead md-head><tr md-row><th md-column><span data-translate="statistics.checks.table.title"></span></th><th md-column><span data-translate="statistics.checks.table.author"></span></th><th md-column><span data-translate="statistics.checks.table.amount"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="document in vm.data.content"><td md-cell>{{document.title}}</td><td md-cell>{{document.author}}</td><td md-cell>{{document.amount | number}}</td></tr></tbody></table></md-table-container><div flex><div layout="row" layout-align="end center" layout-wrap><paging page="vm.page" page-size="vm.queryRequest.limit" total="vm.data.totalPages" show-prev-next="true" show-first-last="true" paging-action="vm.pageChange(page)"></paging><div layout="row" class="go-to" flex-xs="100" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to next page" ng-model="vm.page" type="number" ng-change="vm.generate()"></md-input-container></div></div></div></md-card></md-content></div>');
$templateCache.put('app/statistics/views/coefficient-distribution-options.html','<div layout="row"><md-input-container flex><label data-translate="statistics.coefficient-distribution.organisational-unit.label"></label><md-select ng-model="vm.coefficientDistributionOptions.organisationalUnitId" ng-disabled="vm.isSuperAdmin && !vm.selectedClient"><md-option ng-value="" ng-if="vm.coefficientDistributionOptions.organisationalUnitId">{{\'global.button.clear\'| translate}}: {{\'statistics.coefficient-distribution.organisational-unit.label\' | translate}}</md-option><md-option ng-repeat="option in vm.organisationalUnits" ng-value="option.id">{{option.orguniLabel}}</md-option></md-select></md-input-container></div><div layout="row"><md-input-container flex><label data-translate="statistics.coefficient-distribution.similarity-factor.label"></label><md-select ng-model="vm.coefficientDistributionOptions.similarityFactor"><md-option ng-value="1" data-translate="statistics.coefficient-distribution.similarity-factor.similarity-factor" ng-if="!vm.clientSettings.hideDocuSimilarityFactor"></md-option><md-option ng-value="2" data-translate="statistics.coefficient-distribution.similarity-factor.similarity-factor-ext" ng-if="!vm.clientSettings.hideDocuSimilarityFactorExt"></md-option><md-option ng-value="3" data-translate="statistics.coefficient-distribution.similarity-factor.similarity-factor-reversed" ng-if="vm.clientSettings.showReversedSimilarityFactor"></md-option></md-select></md-input-container><md-input-container flex><label data-translate="document.model.status">Status</label><md-select ng-model="vm.coefficientDistributionOptions.docStatus"><md-option ng-value="" ng-if="vm.coefficientDistributionOptions.docStatus || vm.coefficientDistributionOptions.docStatus === 0 ">{{\'global.button.clear\'| translate}}: {{\'document.model.status\' | translate}}</md-option><md-option ng-value="status.id" ng-repeat="status in vm.docStatuses">{{\'document.table.statuses.\' + status.status | translate}}</md-option></md-select></md-input-container></div><div layout="row"><md-input-container flex><label data-translate="statistics.coefficient-distribution.similarity-factor-range.from"></label><input type="number" min="0" max="100" ng-model="vm.coefficientDistributionOptions.similarityFrom"></md-input-container><md-input-container flex><label data-translate="statistics.coefficient-distribution.similarity-factor-range.to"></label><input type="number" min="0" max="100" ng-model="vm.coefficientDistributionOptions.similarityTo"></md-input-container><md-input-container flex><label data-translate="statistics.coefficient-distribution.step.label"></label><input type="number" min="1" max="100" ng-model="vm.coefficientDistributionOptions.step"></md-input-container></div><div layout="row"><md-radio-group ng-model="vm.coefficientDistributionOptions.alerts" layout="row"><md-radio-button ng-value="-1">{{\'statistics.coefficient-distribution.alerts.all\' | translate}}</md-radio-button><md-radio-button ng-value="1">{{\'statistics.coefficient-distribution.alerts.with-alerts\' | translate}}</md-radio-button><md-radio-button ng-value="0">{{\'statistics.coefficient-distribution.alerts.without-alerts\' | translate}}</md-radio-button></md-radio-group></div>');
$templateCache.put('app/statistics/views/coefficient-distribution-table.html','<div class="table-container"><md-content layout="row"><md-card flex><md-table-container><table md-table><thead md-head><th md-column><span data-translate="statistics.coefficient-distribution.table.row-index"></span></th><th md-column><span data-translate="statistics.coefficient-distribution.table.sim-factor-range"></span></th><th md-column><span data-translate="statistics.coefficient-distribution.table.documents-quantity"></span></th><th md-column><span data-translate="statistics.coefficient-distribution.table.documents-percentage"></span></th></thead><tbody md-body><tr md-row ng-repeat="row in vm.data"><td md-cell>{{row.rowNumber}}</td><td md-cell>{{row.rangeFrom}}% - {{row.rangeTo}}%</td><td md-cell>{{row.docsNumber | number}}</td><td md-cell>{{row.docsPercent}}%</td></tr></tbody></table></md-table-container></md-card></md-content></div>');
$templateCache.put('app/statistics/views/documents-statistics-table.html','<div class="table-container"><md-content layout="row" class="auto-height" layout-margin><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch aria-hidden="false" flex><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span data-translate="statistics.documents.table.type.name"></span></th><th md-column><span data-translate="statistics.documents.table.checked.name"></span></th><th md-column><span data-translate="statistics.documents.table.database.name"></span></th><th md-column><span data-translate="statistics.documents.table.removed.name"></span></th><th md-column><span data-translate="statistics.documents.table.rejected.name"></span></th><th md-column><span data-translate="statistics.documents.table.all.name"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="statistic in vm.data.statistics"><td md-cell><span data-translate="{{ \'statistics.documents.row.name.\' + statistic.name }}"></span></td><td md-cell>{{statistic.checked}}</td><td md-cell>{{statistic.checkedAndAddedToDatabase | number}}</td><td md-cell>{{statistic.checkedAndRemoved | number}}</td><td md-cell>{{statistic.checkedAndRejected | number}}</td><td md-cell>{{statistic.sum | number}}</td></tr></tbody></table></md-table-container></md-card></md-content></div>');
$templateCache.put('app/statistics/views/number-of-authors-statistics-table.html','<div class="table-container"><md-content layout="row" class="auto-height" layout-margin><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch aria-hidden="false" flex><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span></span></th><th md-column><span data-translate="statistics.option.number-of-authors"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="statistic in vm.data.statistics"><td md-cell><span>{{ statistic.name }}</span></td><td md-cell>{{statistic.sum | number}}</td></tr></tbody></table></md-table-container></md-card></md-content></div>');
$templateCache.put('app/statistics/views/number-of-users-statistics-table.html','<div class="table-container"><md-content layout="row" class="auto-height" layout-margin><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch aria-hidden="false" flex><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span data-translate="statistics.option.number-of-users"></span></th><th md-column><span data-translate="users.model.role.external"></span></th><th md-column><span data-translate="users.model.role.student"></span></th><th md-column><span data-translate="users.model.role.lecturer.or.teacher"></span></th><th md-column><span data-translate="users.model.role.deanery"></span></th><th md-column><span data-translate="users.model.role.deanery_admin"></span></th><th md-column><span data-translate="users.model.status.removed"></span></th><th md-column><span data-translate="statistics.documents.table.all.name"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="statistic in vm.data.statistics"><td md-cell><span>{{ statistic.name }}</span></td><td md-cell>{{statistic.external}}</td><td md-cell>{{statistic.students}}</td><td md-cell>{{statistic.teachers | number}}</td><td md-cell>{{statistic.deanerys | number}}</td><td md-cell>{{statistic.admins | number}}</td><td md-cell>{{statistic.removed | number}}</td><td md-cell>{{statistic.sum | number}}</td></tr></tbody></table></md-table-container></md-card></md-content></div>');
$templateCache.put('app/statistics/views/units-statistics-table.html','<md-card-content><div><span data-translate="statistics.units.all.characters"></span> {{vm.data.charactersSum + vm.data.charactersPrioritySum | number}}</div><div><span data-translate="statistics.units.all.documents"></span> {{vm.data.documentsSum | number}}</div></md-card-content><md-card-content layout="row" flex="20" flex-sm="40" flex-xs="100" layout-align="start center" class="box-limit"><span data-translate="global.table.search.show"></span><md-input-container><md-select class="show-limit" aria-label="select records per page" ng-model="vm.size" ng-change="vm.generate()" layout-align="center center"><md-option ng-value="5"><em>5</em></md-option><md-option ng-value="10"><em>10</em></md-option><md-option ng-value="20"><em>20</em></md-option><md-option ng-value="30"><em>30</em></md-option></md-select></md-input-container><span data-translate="global.table.search.records"></span></md-card-content><div class="table-container"><md-content layout="row" class="auto-height" layout-margin><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch aria-hidden="false" flex><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span data-translate="statistics.units.table.unit.name"></span></th><th md-column><span data-translate="statistics.units.table.documents.count.name"></span></th><th md-column><span data-translate="statistics.units.table.characters.count"></span></th><th md-column ng-if="vm.showStatisticPriorityColumn"><span data-translate="statistics.users.table.priority.characters.used.name"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="unit in vm.data.units.content"><td md-cell>{{ unit.unitName ? unit.unitName : (\'statistics.unit.table.undefined-unit\' | translate)}}</td><td md-cell>{{unit.documentCount | number}}</td><td md-cell>{{unit.characterCount | number}}</td><td md-cell ng-if="vm.showStatisticPriorityColumn">{{unit.characterPriorityCount | number}}</td></tr></tbody></table></md-table-container><div flex><div layout="row" layout-align="end center" layout-wrap><paging page="vm.page" page-size="vm.queryRequest.limit" total="vm.data.units.totalPages" show-prev-next="true" show-first-last="true" paging-action="vm.pageChange(page)"></paging><div layout="row" class="go-to" flex-xs="100" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to next page" ng-model="vm.page" type="number" ng-change="vm.generate()"></md-input-container></div></div></div></md-card></md-content></div>');
$templateCache.put('app/statistics/views/users-statistics-table.html','<md-card-content layout="row" flex="20" flex-sm="40" flex-xs="100" layout-align="start center" class="box-limit"><span data-translate="global.table.search.show"></span><md-input-container><md-select class="show-limit" aria-label="select records per page" ng-model="vm.size" ng-change="vm.generate()" layout-align="center center"><md-option ng-value="5"><em>5</em></md-option><md-option ng-value="10"><em>10</em></md-option><md-option ng-value="20"><em>20</em></md-option><md-option ng-value="30"><em>30</em></md-option></md-select></md-input-container><span data-translate="global.table.search.records"></span></md-card-content><div class="table-container"><md-content layout="row" class="auto-height" layout-margin><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch aria-hidden="false" flex><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span data-translate="statistics.users.table.user.name"></span></th><th md-column><span data-translate="statistics.users.table.units.name"></span></th><th md-column><span data-translate="statistics.users.table.documents.name"></span></th><th md-column><span data-translate="statistics.users.table.characters.name"></span></th><th md-column><span data-translate="statistics.users.table.documents.sum.name"></span></th><th md-column><span data-translate="statistics.users.table.characters.sum.name"></span></th><th md-column><span data-translate="statistics.users.table.priority.characters.used.name"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="user in vm.data.users.content"><td md-cell>{{user.email}}</td><td md-cell nowrap="nowrap"><table md-table><tr md-row ng-repeat="unit in user.units"><td md-cell nowrap="nowrap">{{unit.unitName}}</td></tr></table></td><td md-cell><table md-table><tr md-row ng-repeat="unit in user.units"><td md-cell>{{unit.documentCount | number}}</td></tr></table></td><td md-cell><table md-table><tr md-row ng-repeat="unit in user.units"><td md-cell>{{unit.characterCount | number}}</td></tr></table></td><td md-cell>{{vm.sumDocuments(user.units) | number}}</td><td md-cell>{{vm.sumCharacters(user.units) | number}}</td><td md-cell>{{vm.sumPriorityCharacters(user.units) | number}}</td></tr></tbody></table></md-table-container><div flex><div layout="row" layout-align="end center" layout-wrap><paging page="vm.page" page-size="vm.queryRequest.limit" total="vm.data.users.totalPages" show-prev-next="true" show-first-last="true" paging-action="vm.pageChange(page)"></paging><div layout="row" class="go-to" flex-xs="100" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to next page" ng-model="vm.page" type="number" ng-change="vm.generate()"></md-input-container></div></div></div></md-card></md-content></div>');
$templateCache.put('app/account/assignments/peer-review/add-from-library.template.html','<md-dialog aria-label="" class="peer-review-add-question-dialog"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="peer-review.add-from-library.title"></h2>: {{vm.library.name}}</div></md-toolbar><md-dialog-content layout-padding><div layout="row" layout-align="space-between" ng-repeat="question in vm.questions track by $index"><div layout="row" layout-align="start start"><md-checkbox name="{{\'peer-review\' + question.title}}" class="md-primary" aria-label="{{\'peer-review-question\'+ question.title}}" ng-model="vm.checkedQuestions[$index]"></md-checkbox><div layout="column"><div><span>{{question.title}}</span></div><div><span class="bold" data-translate="peer-review.question-type"></span>: <span data-translate="{{\'peer-review.question-type.\' + question.type}}"></span></div><div ng-if="question.type === \'text\'"><span class="bold" data-translate="peer-review.text-min-words"></span>: {{question.textMinWords}}</div><div ng-if="question.type === \'scale\'"><div><span class="bold" data-translate="peer-review.scale-size"></span>: {{question.scaleSize}}</div><div><span class="bold" data-translate="peer-review.scale-lowest-value-name"></span>: {{question.scaleLowestValueName}}</div><div><span class="bold" data-translate="peer-review.scale-highest-value-name"></span>: {{question.scaleHighestValueName}}</div></div></div></div><md-button ng-click="vm.deleteQuestion($index, question.id)" class="md-icon-button" ng-disabled="vm.obj.peerReview.answersExist"><md-tooltip md-direction="top"><span data-translate="global.table.menu.delete"></span></md-tooltip><i class="material-icons">delete_forever</i></md-button></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><md-button md-no-ink aria-label="select-all" data-translate="global.button.select-all" ng-click="vm.selectAllQuestions()"></md-button><md-button md-no-ink aria-label="deselect-all" data-translate="global.button.deselect-all" ng-click="vm.deselectAllQuestions()"></md-button><div class="loader" layout="row" layout-sm="column" layout-align="space-around" ng-if="vm.isLoading"><md-progress-circular md-mode="small" ng-show="vm.isLoading"></md-progress-circular></div><md-button ng-click="vm.cancel()" data-translate="global.button.cancel" aria-label="cancel"></md-button><md-button aria-label="add" class="md-raised md-primary" data-translate="peer-review.add-question.from-library-button" ng-click="vm.addSelectedQuestionsFromLibrary(library)" ng-disabled="vm.getSelectedQuestions().length === 0"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/account/assignments/peer-review/add-question.template.html','<form name="form3"><md-dialog aria-label="" class="peer-review-add-question-dialog"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="peer-review.add-question.title"></h2></div></md-toolbar><md-dialog-content layout-padding layout="column"><div layout="column"><md-input-container><input ng-model="vm.title" placeholder="{{\'peer-review.question.title\' | translate}}" required></md-input-container><md-input-container flex="17" flex-xs="100"><label data-translate="peer-review.question.type"></label><md-select placeholder="{{\'peer-review.question.type\' | translate }}" ng-model="vm.type" required><md-option ng-value="\'text\'" data-translate="peer-review.question.type-text"></md-option><md-option ng-value="\'scale\'" data-translate="peer-review.question.type-scale"></md-option></md-select></md-input-container><md-input-container ng-if="vm.type === \'text\'"><label for="textMinWords" data-translate="peer-review.question.text-min-words"></label><input id="textMinWords" type="number" min="0" ng-model="vm.textMinWords" placeholder="{{\'peer-review.question.text-min-words\' | translate}}" required></md-input-container><md-input-container ng-if="vm.type === \'scale\'"><input type="number" ng-model="vm.scaleSize" placeholder="{{\'peer-review.question.scale-size\' | translate}}" min="1" max="10" required></md-input-container><md-input-container ng-if="vm.type === \'scale\'"><input type="text" ng-model="vm.scaleLowestValueName" placeholder="{{\'peer-review.question.scale-lowest-value-name\' | translate}}"></md-input-container><md-input-container ng-if="vm.type === \'scale\'"><input type="text" ng-model="vm.scaleHighestValueName" placeholder="{{\'peer-review.question.scale-highest-value-name\' | translate}}"></md-input-container></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div class="loader" layout="row" layout-sm="column" layout-align="space-around" ng-if="vm.isLoading"><md-progress-circular md-mode="small" ng-show="vm.isLoading"></md-progress-circular></div><md-button ng-click="vm.cancel()" data-translate="global.button.cancel" aria-label="cancel"></md-button><md-button ng-click="vm.addQuestionOk(form3)" data-translate="global.button.save" aria-label="save" class="md-raised md-primary" ng-disabled="vm.isLoading || form3.$invalid "></md-button></md-dialog-actions></md-dialog></form>');
$templateCache.put('app/account/assignments/peer-review/add-to-library.template.html','<md-dialog aria-label="" class="peer-review-add-question-dialog"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="peer-review.add-to-library.title"></h2>:&nbsp;<span>{{vm.library.name}}</span></div></md-toolbar><md-dialog-content layout-padding><div layout="row" layout-align="start start" ng-repeat="question in vm.questions track by $index"><md-checkbox name="{{\'peer-review\' + question.title}}" class="md-primary" aria-label="{{\'peer-review-question\'+ question.title}}" ng-model="vm.checkedQuestions[$index]"></md-checkbox><div><div><span>{{question.title}}</span></div><div><span class="bold" data-translate="peer-review.question-type"></span>: <span data-translate="{{\'peer-review.question-type.\' + question.type}}"></span></div><div ng-if="question.type === \'text\'"><span class="bold" data-translate="peer-review.text-min-words"></span>: {{question.textMinWords}}</div><div ng-if="question.type === \'scale\'"><div><span class="bold" data-translate="peer-review.scale-size"></span>: {{question.scaleSize}}</div><div><span class="bold" data-translate="peer-review.scale-lowest-value-name"></span>: {{question.scaleLowestValueName}}</div><div><span class="bold" data-translate="peer-review.scale-highest-value-name"></span>: {{question.scaleHighestValueName}}</div></div></div></div><div><md-divider></md-divider></div><h5>Library questions</h5><div layout="row" layout-align="start start" ng-repeat="question in vm.library.questions"><div layout="column"><div><span>{{question.title}}</span></div><div><span class="bold" data-translate="peer-review.question-type"></span>: <span data-translate="{{\'peer-review.question-type.\' + question.type}}"></span></div><div ng-if="question.type === \'text\'"><span class="bold" data-translate="peer-review.text-min-words"></span>: {{question.textMinWords}}</div><div ng-if="question.type === \'scale\'"><div><span class="bold" data-translate="peer-review.scale-size"></span>: {{question.scaleSize}}</div><div><span class="bold" data-translate="peer-review.scale-lowest-value-name"></span>: {{question.scaleLowestValueName}}</div><div><span class="bold" data-translate="peer-review.scale-highest-value-name"></span>: {{question.scaleHighestValueName}}</div></div></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><md-button md-no-ink aria-label="select-all" data-translate="global.button.select-all" ng-click="vm.selectAllQuestions()"></md-button><md-button md-no-ink aria-label="deselect-all" data-translate="global.button.deselect-all" ng-click="vm.deselectAllQuestions()"></md-button><div class="loader" layout="row" layout-sm="column" layout-align="space-around" ng-if="vm.isLoading"><md-progress-circular md-mode="small" ng-show="vm.isLoading"></md-progress-circular></div><md-button ng-click="vm.cancel()" data-translate="global.button.cancel" aria-label="cancel"></md-button><div><md-button class="md-raised md-primary" aria-label="add" data-translate="peer-review.add-to-library-button" ng-click="vm.addToLibrary(vm.library)" ng-disabled="vm.isLoading || vm.getSelectedQuestions().length === 0"></md-button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/account/assignments/peer-review/peer-review.html','<md-divider></md-divider><div layout="row" flex="25" flex-xs="100" layout-align="start center"><span class="p-2"><i class="material-icons cursor-pointer">info</i><md-tooltip class="tooltip-with-long-text" ng-bind-html="\'assignment.form.peer-review-switch-tooltip\' | translate"></md-tooltip></span><three-state-radio ng-model="vm.obj.peerReviewEnabled" data-label="{{\'assignment.form.peer-review-switch\' | translate}}" nowdisabled="vm.editMode || vm.pending"></three-state-radio><span class="p-2" ng-if="vm.obj.peerReview.documentsExist"><i class="material-icons cursor-pointer">info</i><md-tooltip md-direction="top"><span data-translate="peer-review.errors.documents-exist"></span></md-tooltip></span></div><md-card aria-hidden="false" flex ng-if="vm.obj.peerReviewEnabled"><md-card-title-text class="m-3"><h3 data-translate="peer-review.form.settings.header"></h3></md-card-title-text><md-card-content layout="row" layout-xs="column" layout-wrap><div flex="50" flex-xs="100" layout="column"><md-input-container><input name="maxPoints" ng-required="true" type="number" ng-model="vm.obj.peerReview.maxPoints" placeholder="{{\'peer-review.form.max-points\' | translate}}"><plagiat-ng-messages form-element="form.peerReview.maxPoints"></plagiat-ng-messages></md-input-container><md-input-container><input name="pairCount" ng-required="true" type="number" ng-model="vm.obj.peerReview.pairCount" placeholder="{{\'peer-review.form.pair-count\' | translate}}"><plagiat-ng-messages form-element="form.peerReview.pairCount"></plagiat-ng-messages></md-input-container><md-input-container><label for="selfSelect" data-translate="peer-review.form.self-select"></label><input id="selfSelect" name="selfSelect" type="number" ng-model="vm.obj.peerReview.selfSelect"><plagiat-ng-messages form-element="form.peerReview.selfSelect"></plagiat-ng-messages></md-input-container></div><div flex="50" flex-xs="100" layout="column"><md-input-container><label data-translate="{{\'peer-review.form.students-can-review-from\'| translate}}">students-can-review-from</label><md-datepicker ng-model="vm.obj.peerReview.studentsCanReviewFrom" input-date md-placeholder="{{\'global.datepicker.placeholder\' | translate}}"></md-datepicker></md-input-container><md-input-container><label data-translate="{{\'peer-review.form.students-can-review-until\'| translate}}">students-can-review-until</label><md-datepicker ng-model="vm.obj.peerReview.studentsCanReviewUntil" input-date md-placeholder="{{\'global.datepicker.placeholder\' | translate}}"></md-datepicker></md-input-container><md-input-container><label data-translate="{{\'peer-review.form.feedback-available-from\'| translate}}">feedbackAvailableFrom</label><md-datepicker ng-model="vm.obj.peerReview.feedbackAvailableFrom" input-date md-placeholder="{{\'global.datepicker.placeholder\' | translate}}"></md-datepicker></md-input-container></div><div flex="100" layout="column"><md-input-container class="md-block"><md-switch class="md-primary" aria-label="names visible" ng-model="vm.obj.peerReview.peerNameVisible"><span data-translate="peer-review.form.peer-name-visible"></span></md-switch></md-input-container><md-input-container class="md-block"><md-switch class="md-primary" aria-label="names visible" ng-model="vm.obj.peerReview.allowReviewWithoutSubmission"><span data-translate="peer-review.form.allow-review-without-submission"></span></md-switch></md-input-container><md-input-container class="md-block"><md-switch class="md-primary" aria-label="names visible" ng-model="vm.obj.peerReview.forceSelfReview" ng-disabled="vm.obj.peerReview.feedbackUploadedDocCount > 0"><span data-translate="peer-review.form.force-self-review"></span></md-switch></md-input-container></div></md-card-content></md-card><md-card aria-hidden="false" flex ng-if="vm.obj.peerReviewEnabled"><md-card-content><md-card-title-text><h3 data-translate="peer-review.form.questions.header"></h3></md-card-title-text><md-button ng-click="vm.addQuestionDialog()" aria-label="add question" class="md-raised md-primary button-waiting" ng-disabled="vm.pending || vm.obj.peerReview.answersExist"><i class="material-icons">add</i> <span data-translate="peer-review.form.button.add-question"></span></md-button><md-input-container flex="33"><label data-translate="peer-review.form.library.select">Library</label><md-select ng-model="vm.selectedLibrary"><md-option ng-repeat="library in vm.libraries" ng-value="library">{{library.name}}</md-option></md-select></md-input-container><md-button ng-click="vm.addFromLibraryDialog()" aria-label="add from library" class="md-raised md-primary button-waiting" ng-disabled="vm.pending || vm.obj.peerReview.answersExist || !vm.selectedLibrary"><i class="material-icons">library_books</i> <span data-translate="peer-review.form.button.add-from-library"></span></md-button><md-button ng-click="vm.addToLibrary()" aria-label="add to library" class="md-raised md-primary button-waiting" ng-disabled="vm.obj.questions.length == 0 || vm.obj.peerReview.questions.length === 0 || !vm.selectedLibrary"><i class="material-icons">library_add</i> <span data-translate="peer-review.form.button.add-to-library"></span></md-button><md-button ng-click="vm.onClickCreateLibrary()" aria-label="create-library" class="md-raised md-primary button-waiting"><i class="material-icons">library_add</i> <span data-translate="peer-review.form.button.create-library"></span></md-button><md-button ng-click="vm.onClickDeleteLibrary()" aria-label="add to library" class="md-raised md-primary button-waiting" ng-disabled="!vm.selectedLibrary || vm.selectedLibrary.questions.length > 0"><i class="material-icons">delete_forever</i> <span data-translate="peer-review.form.button.delete-library"></span></md-button><div ng-repeat="question in vm.obj.peerReview.questions track by $index"><div class="peer-review-question-div" layout="row"><div class="m-1 buttons"><md-button aria-label="remove question" class="md-icon-button m-0" ng-click="vm.removeQuestion(question, $index)" ng-disabled="vm.obj.peerReview.answersExist"><md-tooltip md-delay="100" md-direction="top">{{\'peer-review.form.button.remove-question\'| translate}}</md-tooltip><i class="material-icons">delete_forever</i></md-button><md-button aria-label="move Question Up" class="md-icon-button m-0" ng-click="vm.moveQuestionUp(question, $index)" ng-disabled="vm.obj.peerReview.answersExist"><md-tooltip md-delay="100" md-direction="top">{{\'peer-review.form.button.move-question-up\'| translate}}</md-tooltip><i class="material-icons">arrow_upward</i></md-button><md-button aria-label="move Question Down" class="md-icon-button m-0" ng-click="vm.moveQuestionDown(question, $index)" ng-disabled="vm.obj.peerReview.answersExist"><md-tooltip md-delay="100" md-direction="top">{{\'peer-review.form.button.move-question-down\'| translate}}</md-tooltip><i class="material-icons">arrow_downward</i></md-button><md-button aria-label="edit Question" class="md-icon-button m-0" ng-click="vm.editQuestion(question, $index)" ng-disabled="vm.obj.peerReview.answersExist"><md-tooltip md-delay="100" md-direction="top">{{\'peer-review.form.button.edit-question\'| translate}}</md-tooltip><i class="material-icons">edit_note</i></md-button></div><div layout="column"><div><span>{{question.title}}</span></div><div><span class="bold" data-translate="peer-review.question-type"></span>: <span data-translate="{{\'peer-review.question-type.\' + question.type}}"></span></div><div ng-if="question.type === \'text\'"><span class="bold" data-translate="peer-review.text-min-words"></span>: {{question.textMinWords}}</div><div ng-if="question.type === \'scale\'"><div><span class="bold" data-translate="peer-review.scale-size"></span>: {{question.scaleSize}}</div><div><span class="bold" data-translate="peer-review.scale-lowest-value-name"></span>: {{question.scaleLowestValueName}}</div><div><span class="bold" data-translate="peer-review.scale-highest-value-name"></span>: {{question.scaleHighestValueName}}</div></div></div></div><md-divider></md-divider></div></md-card-content></md-card><md-card ng-if="vm.obj.peerReviewEnabled"><md-card-content><md-card-title-text><h3 data-translate="peer-review.form.manual-pair.header"></h3></md-card-title-text></md-card-content><md-table-container><table md-table><thead md-head><tr md-row><th md-column colspan="3"><span data-translate="peer-review.feedbacks.table.doc-author"></span></th></tr></thead><tbody md-body ng-repeat="row in vm.obj.peerReview.manuallyAssignedReviewers track by $index" style="{{vm.feedbackSettingsEnabled[$index] ? \'background-color: #faf8f8\' : \'\'}}"><tr md-row><td md-cell><b>{{row.fullName}}</b><br><small>{{row.email}}</small></td><td md-cell>(<span data-translate="peer-review.form.manual-pair.forced"></span>: {{row.manuallyAssigned.length}}, <span data-translate="peer-review.form.manual-pair.system-assigned"></span>: {{vm.obj.peerReview.pairCount - row.manuallyAssigned.length}})</td><td md-cell><md-button md-no-ink ng-click="vm.onClickShowDetailsManualReviewer($index)"><md-tooltip md-direction="top"><span data-translate="peer-review.form.manual-pair.button.show-details.tooltip"></span></md-tooltip><span data-translate="peer-review.form.manual-pair.button.show-details.header"></span></md-button></td><td md-cell><md-button ng-click="vm.onClickRemoveManualReviewer($index)" class="md-icon-button" ng-disabled="vm.obj.peerReview.documentsExist"><md-tooltip md-direction="top"><span ng-if="!vm.obj.peerReview.documentsExist" data-translate="peer-review.form.manual-pair.button.remove-student"></span> <span ng-if="vm.obj.peerReview.documentsExist" data-translate="peer-review.errors.documents-exist"></span></md-tooltip><i class="material-icons">delete_forever</i></md-button></td></tr></tbody></table></md-table-container></md-card>');
$templateCache.put('app/account/assignments/peer-review/scoring.component.html','<md-card aria-hidden="false" flex><md-card-content><md-card-title-text><h3 data-translate="peer-review.form.feedbacks.header"></h3></md-card-title-text></md-card-content><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span data-translate="peer-review.feedbacks.table.reviewer"></span></th><th md-column><span data-translate="peer-review.feedbacks.table.submitted"></span></th><th md-column><span data-translate="peer-review.feedbacks.table.grade"></span></th><th md-column><span data-translate="peer-review.feedbacks.table.actions"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat-start="reviewer in vm.obj.reviewers track by $index" class="{{vm.expandedReviewers[reviewer.id] ? \'bg-primary\' : \'\'}}"><td style="width: 25%" md-cell>{{reviewer.fullName}}</td><td style="width: 25%" md-cell><span>{{reviewer.submittedFeedbacks}}/{{reviewer.countAllFeedbacks}}</span> <span data-translate="peer-review.feedbacks.table.submitted.reviews"></span></td><td style="width: 25%" md-cell><span ng-if="!reviewer.averageScore">--</span> <span ng-if="reviewer.averageScore">{{reviewer.averageScore}}</span> <span>/ {{reviewer.maxScore}}</span> <span>({{reviewer.scorePercentage}}%)</span></td><td style="width: 25%" md-cell><md-button md-no-ink ng-if="!vm.expandedReviewers[reviewer.id]" ng-click="vm.expandReviews(reviewer.id)" aria-label="expand reviews" class="md-primary"><span data-translate="peer-review.feedbacks.table.button.show-details"></span></md-button><md-button md-no-ink ng-if="vm.expandedReviewers[reviewer.id]" ng-click="vm.expandReviews(reviewer.id)" aria-label="expand reviews" class="md-primary"><span data-translate="peer-review.feedbacks.table.button.hide-details"></span></md-button></td></tr><tr md-row ng-if="vm.expandedReviewers[reviewer.id]" ng-repeat="feedback in reviewer.feedbacks"><td md-cell><div flex layout="row" layout-align="start start"><div>{{feedback.author}}<br><small class="text-black-50">{{feedback.docTitle}}</small></div><div class="ms-2"><span ng-if="feedback.selfSelect"><md-tooltip md-delay="100" md-direction="top">{{\'feedback.button.self-select\'| translate}}</md-tooltip><i class="material-icons icon-secondary ml-1">info</i> </span><span ng-if="feedback.selfReview"><md-tooltip md-delay="100" md-direction="top">{{\'peer-review.form.force-self-review\' | translate}}</md-tooltip><i class="material-icons icon-secondary ml-1">info</i></span></div></div></td><td md-cell><div ng-if="feedback.status === 1"><span ng-if="!vm.editScoreMode[reviewer.id]">{{feedback.score}}</span><!--                        <label ng-if="vm.editScoreMode[reviewer.id]" for="score{{feedback.id}}" class="text-black-50"--><!--                               data-translate="peer-review.feedbacks.table.score"></label>--><md-input-container class="fix-md-input-container" flex="20" ng-if="vm.editScoreMode[reviewer.id]"><input id="score{{feedback.id}}" name="score{{feedback.id}}" type="number" min="0" max="{{feedback.maxScore}}" ng-model="feedback.score" ng-change="vm.onChangeScore(reviewer)"></md-input-container><span><md-tooltip md-delay="100" md-direction="bottom"><span data-translate="peer-review.feedbacks.max-grade.tooltip"></span></md-tooltip>/ {{feedback.maxScore}}</span></div><span ng-if="feedback.status === 0">--</span></td><td md-cell><md-button ng-if="feedback.status === 1" md-no-ink ng-click="vm.readReview(feedback.id)" aria-label="expand reviews" class="md-primary"><span data-translate="peer-review.feedbacks.table.button.read-review"></span></md-button></td><td md-cell></td></tr><tr md-row ng-repeat-end ng-if="vm.expandedReviewers[reviewer.id] && reviewer.submittedFeedbacks > 0"><td md-cell></td><td md-cell><span data-translate="peer-review.feedbacks.table.total"></span>: <span>{{reviewer.sumScore}}/{{reviewer.sumMaxScore}}</span><md-button ng-if="!vm.editScoreMode[reviewer.id]" aria-label="expand reviews" class="md-primary" md-no-ink ng-click="vm.editScores(reviewer.id)"><span data-translate="peer-review.feedbacks.table.button.edit-scores"></span></md-button><md-button ng-if="vm.editScoreMode[reviewer.id]" aria-label="expand reviews" class="md-primary" md-no-ink ng-click="vm.cancelEditScores(reviewer.id)"><span data-translate="global.button.cancel"></span></md-button><md-button ng-if="vm.editScoreMode[reviewer.id]" aria-label="expand reviews" class="md-primary" md-no-ink ng-click="vm.saveScores(reviewer)"><span data-translate="peer-review.feedbacks.table.button.save-scores"></span></md-button></td><td md-cell></td><td md-cell></td></tr></tbody></table></md-table-container></md-card>');
$templateCache.put('app/account/documents/document-code-check/document-check-code-check-id.dialog.html','<md-dialog><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="document.code.check.check-later.check-id.header"></h2></div></md-toolbar><md-dialog-content layout-padding layout="column"><table class="document-check-later-price-table"><tbody><tr><td data-translate="document.code.check-later.code-name"></td><td class="font-weight-bold">{{ vm.data.codeName }}</td></tr><tr><td data-translate="document.code.check-later.code-price"></td><td class="font-weight-bold">{{ vm.data.codePrice + \' \' + vm.data.codeCurrency }}</td></tr></tbody></table><label>{{ \'document.code.check-later.check-id\' | translate }}</label><span class="check-id">{{vm.data.checkId}}</span><p>{{ \'document.code.check-later.check-id.instruction\' | translate }}</p></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog()" data-translate="global.button.ok">Ok</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/account/documents/document-code-check/document-check-code.dialog.html','<md-dialog aria-label="" class="document-code-check-dialog"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="document.code.check"></h2></div></md-toolbar><document-check-code-modal on-document-id="items.documentId" on-file-id="items.fileId" on-size="items.size" on-priority-code="items.priorityCode" on-add-document-callback="items.addDocumentCallback" on-is-assignment="items.isAssignment" on-check-document-callback="items.checkDocumentCallback"></document-check-code-modal></md-dialog>');
$templateCache.put('app/account/documents/document-code-check/document-check-code.template.html','<md-dialog-content layout-padding layout="column"><div class="loader" layout="row" layout-sm="column" layout-align="space-around" ng-if="vm.isLoading"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoading"></md-progress-circular></div><div layout="column"><md-button class="md-raised md-primary" ng-if="vm.isStudent" ng-disabled="vm.isUseContractDisabled" ng-click="vm.useContract()" data-translate="document.check.using-test-counter" aria-label="1"></md-button><md-button class="md-raised md-primary" ng-if="!vm.isStudent" ng-disabled="vm.isUseContractDisabled" ng-click="vm.useContract()" data-translate="document.check.contract" aria-label="11"></md-button><md-button class="md-raised md-primary" ng-disabled="vm.isUsePurchasedCodeDisabled" ng-click="vm.usePurchasedCode()" data-translate="document.check.code.use-already-purchased" translate-values="{code: \'{{vm.alreadyPurchasedCode}}\'}" aria-label="2"></md-button><md-button class="md-raised md-primary" ng-disabled="vm.isBuyCodeDisabled" ng-click="vm.buyNewCode()" data-translate="document.check.code.buy-new-code" translate-values="{code: \'{{vm.codeToBuy}}\'}" aria-label="22"></md-button><md-button class="md-raised md-primary" ng-if="vm.isUseCodeByTransactionIdAvailable()" ng-click="vm.useCodeByTransactionId()" data-translate="document.check.code.by-transaction-id" aria-label="3"></md-button><md-button class="md-raised md-primary" ng-if="vm.isCheckWithCheckIdAvailable()" ng-click="vm.checkWithCheckId()" data-translate="document.check.check-id" aria-label="4"></md-button><md-button class="md-raised md-primary" ng-if="vm.isCheckLaterAvailable()" ng-click="vm.checkLater()" data-translate="document.check.later" aria-label="5"></md-button><md-button ng-click="vm.cancel()" data-translate="global.button.cancel" aria-label="6"></md-button></div></md-dialog-content>');
$templateCache.put('app/account/documents/document-code-check/find-code-by-transaction-id.dialog.html','<md-dialog><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="document.code.find-by-transaction-id.header"></h2></div></md-toolbar><md-dialog-content layout-padding layout="column"><div layout="row"><md-input-container flex="70"><input ng-model="vm.transactionId" placeholder="{{\'document.code.find-by-transaction-id.input\' | translate}}" ng-keyup="$event.keyCode == vm.keyReturn && vm.findCodeByTransactionId()"></md-input-container><md-button flex="30" type="submit" class="md-raised md-primary" data-translate="document.code.find-by-transaction-id.find" ng-click="vm.findCodeByTransactionId()"></md-button></div><div class="md-input-messages-error" ng-if="vm.shouldShowCodeNotFoundMessage" data-translate="global.search.notfound"></div><div ng-if="vm.code" layout="row" flex class="mt-3"><div layout="column" flex><small flex class="text-muted" data-translate="codes.model.code-type"></small> <small flex class="text-muted" data-translate="codes.model.status"></small> <small flex class="text-muted" data-translate="codes.model.payment-date"></small></div><div layout="column" flex><small flex>{{vm.code.type}}</small> <small flex>{{vm.codeStatuses.keysById[vm.code.status] | translate}}</small> <small flex>{{vm.code.paymentDate | date: \'yyyy-MM-dd HH:mm\'}}</small></div></div><div class="md-input-messages-error" ng-if="vm.shouldShowCodeNotValidMessage" data-translate="document.code.find-by-transaction-id.code.invalid"></div><div class="md-input-messages-error" ng-if="vm.shouldShowCodeNotAdequateForDocumentMessage" data-translate="document.code.find-by-transaction-id.code.not-adequate" data-translate-values="{ requiredCodeName: vm.code.requiredCodeName }"></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><md-button ng-click="vm.cancel()" data-translate="global.button.cancel-code">Cancel</md-button><md-button ng-click="vm.useCode()" data-translate="document.code.find-by-transaction-id.use-code">Use code</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/account/documents/document-text/add-text.tmpl.html','<md-dialog aria-label="addtext" class="upload-text"><add-text></add-text></md-dialog>');
$templateCache.put('app/account/documents/document-text/document-text.template.html','<form name="form" ng-cloak><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="document.upload-text.title" ng-if="!$ctrl.hideButton"></h2><h2 data-translate="document.upload-text.title1" ng-if="$ctrl.hideButton"></h2></div></md-toolbar><md-dialog-content><div class="md-dialog-content" layout-margin><md-input-container class="md-block"><textarea ng-if="!$ctrl.hideButton" ng-model="$ctrl.textToUpload" placeholder="{{!$ctrl.textToUpload ? \'document.upload-text.placeholder\' : \'document.upload-text.title\' | translate}}" rows="7" md-select-on-focus required></textarea><textarea ng-if="$ctrl.hideButton" ng-model="$ctrl.textToUpload" placeholder="{{!$ctrl.textToUpload ? \'document.upload-text.placeholder1\' : \'document.upload-text.title1\' | translate}}" rows="7" md-select-on-focus required></textarea><div class="md-input-messages-info ng-active" ng-class="{\'md-input-messages-error\': $ctrl.textToUpload.length < 30 }"><div data-translate="document.upload-text.minlength" ng-show="$ctrl.textToUpload.length < 30" translate-values="{n: \'{{$ctrl.textToUpload.length}}\'}"></div><div data-translate="document.upload-text.wordsno" ng-show="$ctrl.textToUpload.length >= 30" translate-values="{n: \'{{$ctrl.textToUpload.length}}\'}"></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="$ctrl.closeDialog()" ng-if="$ctrl.hideButton" data-translate="global.button.close">Zamknij</md-button><md-button ng-click="$ctrl.closeDialog()" ng-if="!$ctrl.hideButton" data-translate="global.button.cancel">Anuluj</md-button><md-button ng-click="$ctrl.sendUploadedText()" ng-disabled="form.$invalid || $ctrl.textToUpload.length < 30" class="md-raised md-primary" ng-if="!$ctrl.hideButton" data-translate="global.button.send">Wy\u015Blij</md-button></md-dialog-actions></form>');
$templateCache.put('app/account/documents/document-text/view-text.tmpl.html','<md-dialog aria-label="viewtext" class="upload-text"><view-text></view-text></md-dialog>');
$templateCache.put('app/account/documents/documents-search/documents-search.template.html','<form name="formSearchDocuments"><div layout-padding><div layout="row" layout-xs="column"><select-page-size query-request="$ctrl.onQueryRequest" on-value-chosen="$ctrl.getDocuments()" layout="row" flex="40" flex-sm="40" flex-xs="100" layout-align="start center"></select-page-size><div layout="row" flex="20" flex-sm="50" flex-xs="100" layout-align="start center" class="box-limit"><md-input-container ng-show="$ctrl.onIsLecturer || $ctrl.onIsOperator || $ctrl.onIsAdmin"><md-switch aria-label="{{\'document.model.onlymine\'| translate}}" ng-show="!$ctrl.hideShowOnlyForUserOption && !$ctrl.onIsSuperAdmin" class="md-primary" name="notify" ng-model="$ctrl.documentsSearchRequest.showOnlyForUser" ng-change="$ctrl.setUserSearchSetting()"><span data-translate="document.model.onlymine"></span></md-switch></md-input-container></div><div layout="row" layout-sm="column" flex="55" flex-sm="60" flex-xs="100" layout-align="end center"><md-input-container md-no-float class="md-block" flex="70" flex-sm="50" layout-xs="column" flex-xs="100" layout-align="end center" ng-if="$ctrl.simpleSearch"><input ng-model="$ctrl.documentsSearchRequest.simpleSearch" placeholder="{{\'global.search.title\'| translate}}" ng-change="$ctrl.getDocuments()" ng-model-options="{ debounce: $ctrl.simpleSearchDelay }"></md-input-container><div layout="column" flex="35" flex-xs="100" flex-sm="50" layout-xs="column" layout-align="end center"><md-button aria-label="{{\'global.button.search.advanced\'| translate}}" ng-click="$ctrl.toogleSearch()" class="search-buttons" ng-class="{ \'hide\': !$ctrl.simpleSearch}" data-translate="global.button.search.advanced"></md-button><md-button aria-label="{{\'global.button.search.simple\'| translate}}" class="search-buttons" ng-click="$ctrl.toogleSearch()" ng-class="{ \'hide\': $ctrl.simpleSearch}" data-translate="global.button.search.simple"></md-button></div></div></div><div class="document-metric-users" layout="row" layout-xs="column" ng-class="{ \'hide\': $ctrl.simpleSearch}" ng-if="$ctrl.onIsAdmin || $ctrl.onIsSuperAdmin || $ctrl.isLoggedUserOrgUnitAdmin || $ctrl.isReseller || $ctrl.isMinistry"><md-input-container flex="33" flex-xs="100" ng-if="$ctrl.onIsSuperAdmin || $ctrl.isReseller || $ctrl.isMinistry"><md-autocomplete id="search-clients" md-input-minlength="2" ng-disabled="$ctrl.isDisabled" md-no-cache="$ctrl.noCache" md-selected-item="$ctrl.selectedClient" md-search-text="$ctrl.searchClient" md-selected-item-change="$ctrl.selectedClientChange(client)" md-items="client in $ctrl.querySearchClients($ctrl.searchClient)" md-item-text="client.id+\' \'+client.clieName" md-min-length="0" md-floating-label="{{\'global.model.clientname\'| translate}}" md-clear-button="true" md-require-match="true" md-select-on-match="true"><md-item-template><span md-highlight-text="$ctrl.searchClient" md-highlight-flags="^i">{{client.clieName}} [{{client.id}}]</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{$ctrl.searchClient}}"</md-not-found></md-autocomplete></md-input-container><md-input-container layout="row" layout-xs="column" flex="33" flex-xs="100" ng-show="$ctrl.onIsAdmin || $ctrl.isLoggedUserOrgUnitAdmin"><md-autocomplete id="search-users" md-input-minlength="2" ng-disabled="$ctrl.isDisabled" md-no-cache="$ctrl.noCache" md-selected-item="$ctrl.selectedUser" md-search-text-change="$ctrl.searchTextChange($ctrl.searchText)" md-search-text="$ctrl.searchText" md-selected-item-change="$ctrl.selectedUserChange(user)" md-items="user in $ctrl.querySearch($ctrl.searchText)" md-item-text="user.userName+\' \'+user.userSurname+\' \'+user.userEmail" md-min-length="0" md-floating-label="{{\'document.metric.placeholder.users\'| translate}}" md-require-match="true" md-select-on-match="true"><md-item-template><span md-highlight-text="ctrl.searchText" md-highlight-flags="^i">{{user.userName}} {{user.userSurname}} {{user.userEmail}}</span></md-item-template></md-autocomplete></md-input-container><md-input-container flex="16" flex-xs="100" ng-if="$ctrl.onIsSuperAdmin || $ctrl.onIsAdmin"><input ng-model="$ctrl.documentsSearchRequest.documentId" placeholder="{{\'document.table.details.id\'| translate}}"></md-input-container><md-input-container flex="17" flex-xs="100"><label data-translate="document.model.has.report"></label><md-select ng-change="$ctrl.getDocuments()" placeholder="{{\'document.model.has.report\' | translate }}" ng-model="$ctrl.documentsSearchRequest.hasReport"><md-option ng-value="" ng-if="$ctrl.documentsSearchRequest.hasReport || $ctrl.documentsSearchRequest.hasReport === false "><em>{{\'global.button.clear\'| translate}}: {{\'document.model.has.report\' | translate}}</em></md-option><md-option ng-value="true" data-translate="document.search.yes"></md-option><md-option ng-value="false" data-translate="document.search.no"></md-option></md-select></md-input-container><md-input-container flex="17" flex-xs="100" ng-show="$ctrl.clientTypeCodeAccount || $ctrl.onIsSuperAdmin"><label data-translate="document.model.checking-type"></label><md-select ng-change="$ctrl.getDocuments()" placeholder="{{\'document.model.checking-type\' | translate }}" ng-model="$ctrl.documentsSearchRequest.checkingType"><md-option ng-value="" ng-if="$ctrl.documentsSearchRequest.checkingType"><em>{{\'global.button.clear\'| translate}}: {{\'document.model.checking-type\' | translate}}</em></md-option><md-option ng-value="\'code\'" data-translate="document.search.checking-type-code"></md-option><md-option ng-value="\'contract\'" data-translate="document.search.checking-type-contract"></md-option></md-select></md-input-container></div><div layout="row" layout-xs="column" ng-class="{ \'hide\': $ctrl.simpleSearch}"><md-input-container class="md-block" flex="{{$ctrl.shouldShowAuthor ? 33 : 66}}" flex-xs="100"><input ng-model="$ctrl.documentsSearchRequest.docuTitle" placeholder="{{\'document.model.title\'| translate}}"></md-input-container><md-input-container class="md-block" flex="33" flex-xs="100" ng-show="$ctrl.shouldShowAuthor"><input ng-model="$ctrl.documentsSearchRequest.author" placeholder="{{\'document.model.author\'| translate}}"></md-input-container><md-input-container class="md-block" flex="33" flex-xs="100"><label data-translate="document.model.status">Status</label><md-select ng-change="$ctrl.getDocuments()" placeholder="{{\'document.model.status\' | translate }}" aria-label="docu statuses" ng-model="$ctrl.documentsSearchRequest.docuStatus" layout-align="center center"><md-option ng-value="" ng-if="$ctrl.documentsSearchRequest.docuStatus || $ctrl.documentsSearchRequest.docuStatus === 0 "><em>{{\'global.button.clear\'| translate}}: {{\'document.model.status\' | translate}}</em></md-option><md-option ng-value="status.id" ng-repeat="status in $ctrl.onSearchData.statuses"><em>{{\'document.table.statuses.\'+status.status+\'\'| translate}}</em></md-option></md-select></md-input-container><md-input-container flex="33" ng-if="$ctrl.onIsSuperAdmin"><label data-translate="global.model.region"></label><md-select name="clientRegionId" aria-label="clientRegionId" ng-model="$ctrl.documentsSearchRequest.clientRegionId" ng-change="$ctrl.getDocuments()" placeholder="{{\'global.model.region\' | translate }}"><md-option ng-if="$ctrl.documentsSearchRequest.clientRegionId != null" ng-value="">{{\'global.button.clear\'| translate}}: {{\'global.model.region\' | translate}}</md-option><md-option ng-repeat="value in $ctrl.clientRegions" ng-value="value.id">{{value.name}}</md-option></md-select></md-input-container></div><div layout="row" layout-xs="column" ng-class="{ \'hide\': $ctrl.simpleSearch}" ng-show="!$ctrl.onIsIndividual"><md-input-container class="md-block" flex ng-if="::$ctrl.isCoordinatorVisible() && $ctrl.canUserSearchCoordinator()"><input ng-model="$ctrl.documentsSearchRequest.docuCoordinator" placeholder="{{$ctrl.docuCoordinatorTranslationKey | translate}}"></md-input-container><md-input-container flex><label data-translate="document.metric.client.promoter.type">docuKind</label><md-select ng-change="$ctrl.getDocuments()" placeholder="{{\'document.metric.client.promoter.type\' | translate }}" aria-label="docu kind" ng-model="$ctrl.documentsSearchRequest.docuKind" layout-align="center center"><md-option ng-value="" ng-if="$ctrl.documentsSearchRequest.docuKind"><em>{{\'global.button.clear\'| translate}}: {{\'document.metric.client.promoter.type\' | translate}}</em></md-option><md-option ng-value="docu.value" ng-repeat="docu in $ctrl.onSearchData.docuKindInfo"><em>{{docu.label}}</em></md-option></md-select></md-input-container><md-input-container flex flex-xs="100" ng-if="!$ctrl.isLoggedUserOrgUnitAdmin"><md-autocomplete id="organization-autocomplete" class="white-background" md-selected-item="$ctrl.selectedOrganization" md-search-text="$ctrl.searchOrganizationText" md-items="organization in $ctrl.querySearchOrganizations()" md-selected-item-change="$ctrl.selectedOrganizationChange(organization)" md-item-text="organization.orguniLabel" md-min-length="0" md-floating-label="{{\'document.metric.client.promoter.unit\'| translate}}" md-no-cache="true" md-clear-button="true" md-require-match="true" md-select-on-match="true" ng-disabled="false"><md-item-template><span md-highlight-text="$ctrl.searchOrganizationText" md-highlight-flags="^i">{{organization.orguniLabel}}</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{$ctrl.searchOrganizationText}}"</md-not-found></md-autocomplete></md-input-container></div><div layout="row" layout-padding layout-sm="column" layout-xs="column" ng-class="{ \'hide\': $ctrl.simpleSearch}" layout-wrap><div layout="row" flex="33" flex-sm="100" flex-xs="100" layout-wrap><md-input-container class="md-block" flex="25" flex-xs="50" flex-sm="25" ng-if="!$ctrl.clientSettings.hideDocuSimilarityFactor"><input id="wp1FromInput" input-number ng-model="$ctrl.documentsSearchRequest.docuSimilarityFactorFrom" placeholder="{{\'document.model.wp1from\'| translate}}"></md-input-container><md-input-container class="md-block" flex="25" flex-xs="50" flex-sm="25" ng-if="!$ctrl.clientSettings.hideDocuSimilarityFactor"><input id="wp1ToInput" input-number ng-model="$ctrl.documentsSearchRequest.docuSimilarityFactorTo" placeholder="{{\'document.model.wp1to\'| translate}}"></md-input-container><md-input-container class="md-block" flex="25" flex-xs="50" flex-sm="25" ng-if="!$ctrl.clientSettings.hideDocuSimilarityFactorExt"><input id="wp2FromInput" input-number ng-model="$ctrl.documentsSearchRequest.docuSimilarityFactorExtFrom" placeholder="{{\'document.model.wp2from\'| translate}}"></md-input-container><md-input-container class="md-block" flex="25" flex-xs="50" flex-sm="25" ng-if="!$ctrl.clientSettings.hideDocuSimilarityFactorExt"><input id="wp2ToInput" input-number ng-model="$ctrl.documentsSearchRequest.docuSimilarityFactorExtTo" placeholder="{{\'document.model.wp2to\'| translate}}"></md-input-container></div><div layout="row" flex="66" flex-xs="100" layout-wrap><md-input-container flex="33" flex-sm="100" flex-xs="100"><label data-translate="{{\'document.model.datefrom\'| translate}}">Data od</label><md-datepicker ng-change="$ctrl.fixDateDcouments($ctrl.documentsSearchRequest.docuSubmitDateFrom, \'docuSubmitDateFrom\', $ctrl)" ng-model="$ctrl.documentsSearchRequest.docuSubmitDateFrom" input-date></md-datepicker></md-input-container><md-input-container flex="33" flex-sm="100" flex-xs="100"><label data-translate="{{\'document.model.dateto\'| translate}}">Data do</label><md-datepicker ng-change="$ctrl.fixDateDcouments($ctrl.documentsSearchRequest.docuSubmitDateTo, \'docuSubmitDateTo\', $ctrl)" ng-model="$ctrl.documentsSearchRequest.docuSubmitDateTo" input-date></md-datepicker></md-input-container><md-input-container flex="20" flex-sm="100" flex-xs="100" ng-if="!$ctrl.onIsSuperAdmin"><label data-translate="document.model.alert">Alert</label><md-select ng-change="$ctrl.getDocuments()" placeholder="{{\'document.model.alert\' | translate }}" ng-model="$ctrl.documentsSearchRequest.alert"><md-option ng-value="" ng-if="$ctrl.documentsSearchRequest.alert || $ctrl.documentsSearchRequest.alert === false "><em>{{\'global.button.clear\'| translate}}: {{\'document.model.alert\' | translate}}</em></md-option><md-option ng-value="true" data-translate="document.search.yes">TAK</md-option><md-option ng-value="false" data-translate="document.search.no">NIE</md-option></md-select></md-input-container><md-input-container flex="20" flex-xs="100" ng-if="$ctrl.onIsSuperAdmin"><label data-translate="document.table.details.extra-options">Extra Opcje</label><md-select aria-label="extra-options" layout-align="center center" ng-change="$ctrl.getDocuments()" ng-model="$ctrl.documentsSearchRequest.docuExtraOptions" placeholder="{{\'document.table.details.extra-options\' | translate }}"><md-option ng-if="$ctrl.documentsSearchRequest.docuExtraOptions != null" ng-value="">{{\'global.button.clear\'| translate}}: {{\'document.table.details.extra-options\' | translate}}</md-option><md-option data-translate="global.msg.yes" ng-value="true">TAK</md-option><md-option data-translate="global.msg.no" ng-value="false">NIE</md-option></md-select></md-input-container></div></div><div layout="row" layout-xs="column" ng-class="{ \'hide\': $ctrl.simpleSearch}" ng-show="!$ctrl.onIsIndividual" ng-if="$ctrl.onIsSuperAdmin || $ctrl.onIsAdmin"><md-input-container class="md-block" flex="15" flex-xs="50" flex-sm="25"><input id="aiFromInput" input-number ng-model="$ctrl.documentsSearchRequest.docuAiScoreFrom" placeholder="{{\'document.model.aiScoreFrom\'| translate}}"></md-input-container><md-input-container class="md-block" flex="15" flex-xs="50" flex-sm="25"><input id="aiToInput" input-number ng-model="$ctrl.documentsSearchRequest.docuAiScoreTo" placeholder="{{\'document.model.aiScoreTo\'| translate}}"></md-input-container><md-input-container flex="20" flex-xs="100"><label data-translate="document.report.similarity.ai-detection">AI Detection</label><md-select aria-label="ai detection" layout-align="center center" ng-change="$ctrl.getDocuments()" ng-model="$ctrl.documentsSearchRequest.aiDetection" placeholder="{{\'document.report.similarity.ai-detection\' | translate }}"><md-option ng-if="$ctrl.documentsSearchRequest.aiDetection != null" ng-value="">{{\'global.button.clear\'| translate}}: {{\'document.report.similarity.ai-detection\' | translate}}</md-option><md-option data-translate="global.msg.yes" ng-value="true">TAK</md-option><md-option data-translate="global.msg.no" ng-value="false">NIE</md-option></md-select></md-input-container><md-input-container flex="20" flex-xs="100"><label data-translate="document.table.details.grammar-check">Grammar Check</label><md-select aria-label="Grammar Check" layout-align="center center" ng-change="$ctrl.getDocuments()" ng-model="$ctrl.documentsSearchRequest.grammarCheck" placeholder="{{\'document.metric.grammar-check.label\' | translate }}"><md-option ng-if="$ctrl.documentsSearchRequest.grammarCheck != null" ng-value="">{{\'global.button.clear\'| translate}}: {{\'document.metric.grammar-check.label\' | translate}}</md-option><md-option data-translate="global.msg.yes" ng-value="true">TAK</md-option><md-option data-translate="global.msg.no" ng-value="false">NIE</md-option></md-select></md-input-container><md-input-container flex="20" flex-xs="100" ng-if="$ctrl.onIsSuperAdmin"><label data-translate="document.table.details.ai-type">Ai Type</label><md-select aria-label="Ai Type" layout-align="center center" ng-change="$ctrl.getDocuments()" ng-model="$ctrl.documentsSearchRequest.aiType" placeholder="{{\'document.metric.ai-type.label\' | translate }}"><md-option ng-if="$ctrl.documentsSearchRequest.aiType != null" ng-value="">{{\'global.button.clear\'| translate}}: {{\'document.metric.ai-type.label\' | translate}}</md-option><md-option ng-value="\'win\'">ai type w</md-option><md-option ng-value="\'ori\'">ai type o</md-option></md-select></md-input-container><div flex="40" flex-xs="100"></div></div><div layout="row" layout-xs="column" ng-class="{ \'hide\': $ctrl.simpleSearch}" ng-show="!$ctrl.onIsIndividual"><div flex layout="row" layout-xs="column" ng-if="$ctrl.jsa || $ctrl.orppdIntegration || $ctrl.documentsSearchRequest.jsa"><md-input-container flex ng-if="$ctrl.jsa"><label data-translate="document.model.jsa">Jsa</label><md-select ng-change="$ctrl.getDocuments()" placeholder="{{\'document.model.jsa\' | translate }}" ng-model="$ctrl.documentsSearchRequest.jsa"><md-option ng-value="" ng-if="$ctrl.documentsSearchRequest.jsa"><em>{{\'global.button.clear\'| translate}}: {{\'document.model.jsa\' | translate}}</em></md-option><md-option ng-value="true" data-translate="document.search.yes">TAK</md-option><md-option ng-value="false" data-translate="document.search.no">NIE</md-option></md-select></md-input-container><md-input-container flex ng-if="$ctrl.documentsSearchRequest.jsa"><label data-translate="document.model.jsa.status">Jsa</label><md-select ng-change="$ctrl.getDocuments()" placeholder="{{\'document.model.jsa.status\' | translate }}" ng-model="$ctrl.documentsSearchRequest.jsaOrderStatus"><md-option ng-value="" ng-if="$ctrl.documentsSearchRequest.jsaOrderStatus"><em>{{\'global.button.clear\'| translate}}: {{\'document.model.jsa\' | translate}}</em></md-option><md-option ng-value="$ctrl.JSA_ORDER_STATUS.NEW" data-translate="document.search.jsa.new"></md-option><md-option ng-value="$ctrl.JSA_ORDER_STATUS.COMPLETE" data-translate="document.search.jsa.complete"></md-option><md-option ng-value="$ctrl.JSA_ORDER_STATUS.ACCEPTED" data-translate="document.search.jsa.accepted"></md-option></md-select></md-input-container><md-input-container flex ng-if="$ctrl.orppdIntegration"><label data-translate="document.model.orppd.status">OrppdStatus</label><md-select ng-change="$ctrl.getDocuments()" placeholder="{{\'document.model.orppd.status\' | translate }}" ng-model="$ctrl.documentsSearchRequest.orppdStatus"><md-option ng-value="null" ng-if="$ctrl.documentsSearchRequest.orppdStatus!==null"><em>{{\'global.button.clear\'| translate}}: {{\'document.model.orppd.status\' | translate}}</em></md-option><md-option ng-value="$ctrl.ORPPD_STATUS.NOT_SENT.id" data-translate="{{$ctrl.ORPPD_STATUS.NOT_SENT.key}}"></md-option><md-option ng-value="$ctrl.ORPPD_STATUS.SENT.id" data-translate="{{$ctrl.ORPPD_STATUS.SENT.key}}"></md-option><md-option ng-value="$ctrl.ORPPD_STATUS.ERROR.id" data-translate="{{$ctrl.ORPPD_STATUS.ERROR.key}}"></md-option></md-select></md-input-container></div><div layout="row" layout-xs="column" flex="25" flex-xs="50" ng-repeat="p in $ctrl.onSearchData.documentParameterDefinitions" ng-show="$ctrl.onIsLecturer || $ctrl.onIsOperator || $ctrl.onIsAdmin"><md-input-container class="md-block" flex ng-if="p.comboBoxValues.length == 0"><input ng-model="$ctrl.documentsSearchRequest.documentParameters[p.id]" placeholder="{{p.dopadeName}}"></md-input-container><md-input-container class="md-block" flex ng-if="p.comboBoxValues.length > 0"><label for="{{p.id}}">{{p.dopadeName}}</label><md-select ng-change="$ctrl.getDocuments()" aria-label="docu statuses" ng-model="$ctrl.documentsSearchRequest.documentParameters[p.id]" layout-align="center center"><md-option ng-value="" ng-if="$ctrl.documentsSearchRequest.documentParameters[p.id]"><em>{{\'global.button.clear\'| translate}}: {{p.dopadeName}}</em></md-option><md-option ng-value="val" ng-repeat="val in p.comboBoxValues"><em>{{val}}</em></md-option></md-select></md-input-container></div></div><div layout="row" layout-padding layout-xs="column" layout-align="start" ng-class="{ \'hide\': $ctrl.simpleSearch}"><md-button aria-label="clear" class="md-raised search-buttons" ng-click="$ctrl.clear()" data-translate="global.button.clear.search"></md-button><md-button type="submit" aria-label="search" id="searchBtn" class="md-raised md-primary search-buttons" ng-click="$ctrl.getDocuments()" data-translate="global.button.search">Szukaj</md-button></div></div></form>');
$templateCache.put('app/account/documents/self-enrollment/self-enrollment.template.html','<md-dialog aria-label="" class="self-enrollment-dialog"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="assignment.self-enrollment.title"></h2></div></md-toolbar><md-dialog-content layout-padding layout="column"><div layout="row"><md-input-container flex="70"><input ng-model="vm.shortcode" placeholder="{{\'assignment.self-enrollment.shortcode.input\' | translate}}" ng-keyup="$event.keyCode == vm.keyReturn && vm.findAssignment()"></md-input-container><md-button flex="30" class="md-raised md-primary" ng-disabled="vm.isLoading" ng-click="vm.findAssignment()" data-translate="assignment.self-enrollment.find" aria-label="5"></md-button></div><div layout="row"><div flex="70"><span data-translate="assignment.self-enrollment.do-search" ng-if="!vm.assignment && vm.found"></span> <span data-translate="assignment.self-enrollment.not-found" ng-if="!vm.assignment && !vm.found"></span><div ng-if="vm.assignment" layout="column"><span class="add-without-checking-switch-text">{{vm.assignment.title}}</span> <span>{{vm.assignment.description}}</span> <span>{{vm.assignment.owner}}</span> <span>{{vm.assignment.endDate | date: \'yyyy-MM-dd\'}}</span></div></div><md-button flex="30" class="md-raised md-primary button-waiting" ng-disabled="vm.isLoading || !vm.assignment" ng-click="vm.joinAssignment()" data-translate="assignment.self-enrollment.join" aria-label="5"></md-button></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div class="loader" layout="row" layout-sm="column" layout-align="space-around" ng-if="vm.isLoading"><md-progress-circular md-mode="small" ng-show="vm.isLoading"></md-progress-circular></div><md-button ng-click="vm.cancel()" data-translate="global.button.cancel" aria-label="6"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/account/login/saml/saml-login.html','<div class="md-padding login-with-btn"><md-button aria-label="Login" type="submit" ng-disabled="{{ disabled }}" layout-fill class="jh-btn-social jh-btn-{{ partner }}" ng-click="click()"><div layout="row" layout-align="center center"><div class="{{\'login-\' + partner}} social-icon"></div><div><span>{{ titles[partner] ? titles[partner].title : ((\'global.login.\' + partner) | translate) }}</span></div></div></md-button></div>');
$templateCache.put('app/account/pap/infor-suspect-portal/add-to-client-portals.dialog.html','<md-dialog><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="reports.add-to-client-portals.header"></h2></div></md-toolbar><md-dialog-content layout-padding layout="column"><div layout="row"><span data-translate="reports.add-to-client-list.selected-counter"></span>&nbsp;<span>{{\' \' + vm.data.length}}</span></div><table md-table><thead md-head><th md-column>#</th><th md-column><span data-translate="reports.table.header.portal-of-client.portal-name"></span></th><th md-column><span data-translate="reports.table.header.portal-of-client.skip-domain-for-searching"></span></th><th md-column><span data-translate="global.button.remove"></span></th></thead><tbody md-body><tr md-row ng-repeat="row in vm.data track by $index"><td md-cell>{{($index + 1)}}</td><td md-cell class="word-break-all">{{row.portal}}</td><td md-cell><div layout-align="center center"><md-checkbox ng-model="row.skipDomainForSearching" aria-label="m"></md-checkbox></div></td><td md-cell ng-click="vm.deleteRow(row)"><i class="material-icons">delete_forever</i></td></tr></tbody></table></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog()" class="md-raised" data-translate="global.button.cancel" aria-label="cancel"></md-button><md-button ng-click="vm.addThem()" class="md-raised md-primary" data-translate="global.button.ok" aria-label="o">Ok</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/account/pap/infor-suspect-portal/infor-suspect-portal-bottom-sheet.html','<md-bottom-sheet layout="column"><div ng-cloak><div layout="row" layout-xs="column" layout-align="start start"><span layout-align="start start" layout-padding layout-xs="column"><span ng-click="bootomSheet.closeBottomSheet()" data-translate="global.undo">Cofnij</span> </span><span layout-align="start start" layout-padding layout-xs="row" flex><!--\n        <span>\n          <md-checkbox ng-model="bootomSheet.checked" aria-label="Checkbox 1" ng-click="bootomSheet.closeBottomSheet()">\n          --> <span data-translate="global.selected"></span><!--\n          </md-checkbox>\n        </span>\n        --> <span class="md-mini" layout-align="center start" aria-label="{{bootomSheet.selected.length}}" ng-if="!bootomSheet.tableSelectOptions.selectedAll">{{bootomSheet.selected.length}} / {{bootomSheet.total}} </span><span class="md-mini" aria-label="{{bootomSheet.selected.length}}" ng-if="bootomSheet.tableSelectOptions.selectedAll">{{bootomSheet.tableSelectOptions.selectedNo}} / {{bootomSheet.total}} </span><span aria-label="select all" ng-click="bootomSheet.toggleSelection(bootomSheet.total)" ng-if="!bootomSheet.tableSelectOptions.selectedAll" data-translate="global.button.select.all"></span> <span aria-label="select all" ng-click="bootomSheet.toggleSelection(bootomSheet.totalUsers)" ng-if="bootomSheet.tableSelectOptions.selectedAll" data-translate="global.button.clear.selection"></span> </span><span layout-align="start start" layout-padding layout-xs="row" flex flex-offset-gt-sm="10"><span layout-align="center start" ng-click="bootomSheet.generateReportXls()"><i class="material-icons">vertical_align_bottom</i> <span data-translate="global.bottomsheet.getreport"></span> </span><span layout-align="center start"><span ng-click="bootomSheet.downloadZip()"><i class="material-icons">folder_zip</i> {{\'reports.bottomsheet.getzip\'| translate}} </span></span><span layout-align="center start"><span ng-click="bootomSheet.addToClientPortals()"><i class="material-icons">playlist_add</i> {{\'reports.bottomsheet.add-to-client-portals\'| translate}}</span></span></span></div></div></md-bottom-sheet>');
$templateCache.put('app/account/pap/infor-suspect-portal/infor-suspect-portal.html','<div layout="column" class="site-container portals"><div class="table-container" id="portals"><md-progress-linear ng-if="vm.pending" md-mode="indeterminate"></md-progress-linear><md-content layout="row" flex layout-margin><md-card flex layout-padding><div><form name="formSearchPortals"><div layout="row" layout-xs="column"><md-input-container class="md-block" flex="33" flex-xs="100"><input ng-change="vm.loadData()" ng-model="vm.searchRequest.search.portalName" placeholder="{{\'\treports.table.header.portal-of-client.portal-name\'| translate}}" ng-model-options="{ debounce: vm.simpleSearchDelay }"></md-input-container><!-- ukrywam na razie\n                            <md-input-container class="md-block" flex="33" flex-xs="100">\n                                <input ng-change="vm.loadData()" ng-model="vm.searchRequest.search.documentId" placeholder="{{\'reports.table.header.portals.document-id\'| translate}}"\n                                       ng-model-options=\'{ debounce: vm.simpleSearchDelay }\'>\n                            </md-input-container>\n                            --><md-input-container md-no-float class="md-block" flex="33" flex-xs="100"><label data-translate="reports.table.header.portal-of-client.type"></label><md-select ng-model="vm.searchRequest.search.type" ng-change="vm.loadData()" aria-label="skip" placeholder="{{\'reports.table.header.portal-of-client.type\' | translate}}"><md-option ng-value="" ng-if="vm.searchRequest.search.type"><em>{{\'global.button.clear\'| translate}}: {{\'reports.table.header.portal-of-client.type\' | translate}}</em></md-option><md-option ng-value="suspect.id" ng-repeat="suspect in vm.suspectTypes"><em>{{suspect.key | translate}}</em></md-option></md-select></md-input-container></div><div layout="row" layout-xs="column"><md-input-container flex="33"><label data-translate="reports.table.search.date-range-from"></label><md-datepicker input-date aria-label="from" name="portalDateFrom" ng-change="vm.fixDate(vm.searchRequest.search.portalDateFrom, \'portalDateFrom\', vm)" ng-model="vm.searchRequest.search.portalDateFrom"></md-datepicker><md-tooltip md-delay="100" md-direction="top">{{\'global.messages.info.dateformat\'| translate}}</md-tooltip></md-input-container><md-input-container flex="33"><label data-translate="reports.table.search.date-range-to"></label><md-datepicker input-date aria-label="to" name="portalDateTo" ng-change="vm.fixDate(vm.searchRequest.search.portalDateTo, \'portalDateTo\', vm)" ng-model="vm.searchRequest.search.portalDateTo"></md-datepicker><md-tooltip md-delay="100" md-direction="top">{{\'global.messages.info.dateformat\'| translate}}</md-tooltip></md-input-container></div><div layout="row" layout-align="start" layout-padding layout-xs="column"><md-button aria-label="clear" class="md-raised search-buttons" data-translate="global.button.clear.search" ng-click="vm.clear()"></md-button><md-button aria-label="search" class="md-raised md-primary search-buttons" data-translate="global.button.search" ng-click="vm.loadData()" type="submit"></md-button></div></form></div><md-table-container><table md-table class="portals-table" md-row-select="vm.options.rowSelection" multiple="{{vm.options.multiSelect}}" ng-model="vm.selected"><thead md-head md-order="vm.queryRequest.order" md-on-reorder="vm.loadData"><th md-column>#</th><th md-column md-order-by="urlDomain"><span data-translate="reports.table.header.portal-of-client.portal-name"></span></th><th md-column md-order-by="counter"><span data-translate="reports.table.header.portals.counter"></span></th><th md-column><span data-translate="global.menu.account.similarity.report.settings"></span></th></thead><tbody md-body><tr md-row ng-repeat="row in vm.pageOfData.content track by $index" md-select="row.portalName" md-on-deselect="vm.deSelectRow" md-on-select="vm.selectRow"><td md-cell ng-click="vm.showSuspectReports(row)">{{($index + 1) + ((vm.pageOfData.number - 1) * vm.pageOfData.size)}}</td><td md-cell class="word-break-all"><a href="http://{{row.portalName}}" target="_blank">{{row.portalName}}</a></td><td md-cell ng-click="vm.showSuspectReports(row)">{{row.counter}}</td><td md-cell><div layout="row" layout-align="start center"><md-button aria-label="get report" class="md-icon-button m-0" ng-click="vm.showSuspectReports(row)"><md-tooltip md-delay="100" md-direction="top">{{\'reports.table.menu.show-suspect-reports\'| translate}}</md-tooltip><i class="material-icons">topic</i></md-button></div></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoaderActive"></md-progress-circular></div></md-table-container><div flex layout="row" layout-align="end center" layout-wrap><select-page-size flex="25" flex-xs="100" layout="row" layout-align="start center" query-request="vm.queryRequest" on-value-chosen="vm.loadData()"></select-page-size><div flex></div><paging page="vm.pageOfData.number" page-size="vm.pageOfData.size" paging-action="vm.loadPageOfData(page)" show-first-last="true" show-prev-next="true" total="vm.pageOfData.totalElements"></paging><div class="go-to" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to page" ng-model="vm.goToPageInputModel" min="1" max="vm.pageOfData.totalPages" type="number" ng-keyup="$event.keyCode === vm.keyCodeEnter && vm.loadPageOfData(vm.goToPageInputModel)"></md-input-container></div></div><div class="white-div" ng-show="vm.isBottomSheetOpen()">.</div></md-card></md-content></div></div>');
$templateCache.put('app/account/pap/portal-of-client/portal-of-client-add-edit.html','<div layout="column" class="site-container"><md-content class="users" layout="row"><div layout-align="center center"><header class="header"><h5 ng-if="vm.id" data-translate="reports.portal-of-client.edit.title"></h5><h5 ng-if="!vm.id" data-translate="reports.portal-of-client.add.title"></h5></header></div><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div></md-content><md-content layout="row" layout-padding><form name="form" flex><md-card flex layout-padding><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="50" flex-xs="100"><input name="protocolName" ng-model="vm.obj.portal" ng-required="true" placeholder="{{\'reports.table.header.portal-of-client.portal-name\' | translate}}"></md-input-container></div><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="50" flex-xs="100"><label data-translate="reports.table.header.portal-of-client.type"></label><md-select ng-model="vm.obj.type" aria-label="portal type" ng-required="true" placeholder="{{\'reports.table.header.portal-of-client.type\'| translate}}"><md-option ng-value="portalOfClientType.id" ng-repeat="portalOfClientType in vm.portalOfClientTypes">{{portalOfClientType.key | translate}}</md-option></md-select></md-input-container></div><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="50" flex-xs="100"><label data-translate="reports.table.header.portal-of-client.skip-domain-for-searching"></label><md-select ng-model="vm.obj.skipDomainForSearching" aria-label="portal skipDomainForSearching" ng-required="true" placeholder="{{\'reports.table.header.portal-of-client.skip-domain-for-searching\'| translate}}"><md-option data-translate="global.msg.yes" ng-value="true">TAK</md-option><md-option data-translate="global.msg.no" ng-value="false">NIE</md-option></md-select></md-input-container></div></md-card><div layout="row" flex layout-align="end center"><md-button id="cancelButton" aria-label="portal-add-cancel" ui-sref="portal-of-client" data-translate="global.form.button.cancel"></md-button><md-button id="saveButton" ng-click="vm.saveOrUpdate(vm.obj)" aria-label="save portal" class="md-raised md-primary button-waiting" ng-disabled="form.$invalid"><span data-translate="global.form.button.save"></span></md-button></div></form></md-content></div>');
$templateCache.put('app/account/pap/portal-of-client/portal-of-client.html','<div layout="column" class="site-container reports" id="reports"><div class="table-container"><md-progress-linear ng-if="vm.pending" md-mode="indeterminate"></md-progress-linear><md-content layout="row" flex layout-margin><md-card flex layout-padding><div layout="row" layout-padding layout-wrap layout-align="end center"><div layout="row" layout-align="end center"><md-button class="md-raised md-primary button-waiting" aria-label="portal-of-client-add" ui-sref="portal-of-client-add" data-translate="global.button.add"></md-button></div></div><div><form name="formSearchReports"><div layout="row" layout-xs="column"><md-input-container class="md-block" flex="33" flex-xs="100"><input ng-change="vm.loadData()" ng-model="vm.searchRequest.search.portal" placeholder="{{\'reports.table.header.portal-of-client.portal-name\'| translate}}" ng-model-options="{ debounce: vm.simpleSearchDelay }"></md-input-container><md-input-container md-no-float class="md-block" flex="33" flex-xs="100"><label data-translate="reports.table.header.portal-of-client.type">typ</label><md-select ng-change="vm.loadData()" aria-label="panels" placeholder="{{\'reports.table.header.portal-of-client.type\' | translate}}" ng-model="vm.searchRequest.search.type" layout-align="center center"><md-option ng-value="" ng-if="vm.searchRequest.search.type"><em>{{\'global.button.clear\'| translate}}: {{\'reports.table.header.portal-of-client.type\' | translate}}</em></md-option><md-option ng-value="portalOfClientType.id" ng-repeat="portalOfClientType in vm.portalOfClientTypes"><em>{{portalOfClientType.key | translate}}</em></md-option></md-select></md-input-container><md-input-container md-no-float class="md-block" flex="33" flex-xs="100"><label data-translate="reports.table.header.portal-of-client.skip-domain-for-searching"></label><md-select ng-model="vm.searchRequest.search.skipDomainForSearching" ng-change="vm.loadData()" aria-label="skip" placeholder="{{\'reports.table.header.portal-of-client.skip-domain-for-searching\' | translate}}"><md-option ng-if="vm.searchRequest.search.skipDomainForSearching" ng-value="">{{\'global.button.clear\'| translate}}: {{\'reports.table.header.portal-of-client.skip-domain-for-searching\' | translate}}</md-option><md-option data-translate="global.msg.yes" ng-value="true">TAK</md-option><md-option data-translate="global.msg.no" ng-value="false">NIE</md-option></md-select></md-input-container></div><div layout="row" layout-align="start" layout-padding layout-xs="column"><md-button aria-label="clear" class="md-raised search-buttons" data-translate="global.button.clear.search" ng-click="vm.clear()"></md-button><md-button aria-label="search" class="md-raised md-primary search-buttons" data-translate="global.button.search" ng-click="vm.loadData()" type="submit"></md-button></div></form></div><md-table-container><table md-table class="portal-of-client-table"><thead md-head><th md-column>#</th><th md-column><span data-translate="reports.table.header.portal-of-client.portal-name"></span></th><th md-column><span data-translate="reports.table.header.portal-of-client.type"></span></th><th md-column><span data-translate="reports.table.header.portal-of-client.skip-domain-for-searching"></span></th><th md-column class="table-actions"><span data-translate="global.table.actions"></span></th></thead><tbody md-body><tr ng-repeat="row in vm.pageOfData.content track by $index" md-row md-select="user.id" md-on-deselect="vm.deSelectRow" md-on-select="vm.selectRow"><td md-cell>{{($index + 1) + ((vm.pageOfData.number - 1) * vm.pageOfData.size)}}</td><td md-cell class="word-break-all"><a href="{{row.portal}}" target="_blank">{{row.portal}}</a></td><td md-cell><span ng-if="row.type==\'0\'">{{\'reports.portal-of-client.type.illegal\'| translate}}</span> <span ng-if="row.type==\'1\'">{{\'reports.portal-of-client.type.native\'| translate}}</span> <span ng-if="row.type==\'2\'">{{\'reports.portal-of-client.type.client\'| translate}}</span></td><td md-cell><span ng-if="row.skipDomainForSearching === true">{{\'global.msg.yes\'| translate}}</span> <span ng-if="row.skipDomainForSearching === false">{{\'global.msg.no\'| translate}}</span></td><td md-cell><div flex layout="row" layout-align="end center"><md-menu-bar flex layout="row"><md-menu><md-button aria-label="open" class="md-icon-button" ng-click="$mdMenu.open()"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item><md-button id="tableOptionEdit{{$index}}" aria-label="edit portal of client" ui-sref="portal-of-client-edit({id: row.id})" data-translate="global.table.menu.edit"></md-button></md-menu-item><md-menu-item><md-button aria-label="Remove" ng-click="vm.remove(row.id)" data-translate="global.button.remove"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></td></tr></tbody></table></md-table-container><div flex layout="row" layout-align="end center" layout-wrap><select-page-size flex="25" flex-xs="100" layout="row" layout-align="start center" query-request="vm.queryRequest" on-value-chosen="vm.loadData()"></select-page-size><div flex></div><paging page="vm.pageOfData.number" page-size="vm.pageOfData.size" paging-action="vm.loadPageOfData(page)" show-first-last="true" show-prev-next="true" total="vm.pageOfData.totalElements"></paging><div class="go-to" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to page" ng-model="vm.goToPageInputModel" min="1" max="vm.pageOfData.totalPages" type="number" ng-keyup="$event.keyCode === vm.keyCodeEnter && vm.loadPageOfData(vm.goToPageInputModel)"></md-input-container></div></div></md-card></md-content></div></div>');
$templateCache.put('app/account/pap/suspect-reports/suspect-reports.html','<div layout="column" class="site-container suspect-reports" id="suspect-reports"><div class="table-container"><md-progress-linear ng-if="vm.pending" md-mode="indeterminate"></md-progress-linear><md-content layout="row" flex layout-margin><md-card flex layout-padding><div ng-if="vm.details" layout="column"><div><span data-translate="document.model.title"></span> <span class="add-without-checking-switch-text">{{vm.details.docuTitle}}</span></div><div><span data-translate="reports.table.header.reports.similarity-factor"></span> <span class="add-without-checking-switch-text">{{vm.details.docuSimilarityFactor| percentage:2}}</span></div></div><div ng-if="vm.suspectDomain" layout="column"><div><span data-translate="reports.table.header.portal-of-client.portal-name"></span> <span class="add-without-checking-switch-text">{{vm.suspectDomain}}</span></div></div><form name="formSearchReports"><div layout="row" layout-xs="column"><div layout="row" flex="33" flex-xs="100" layout-wrap><md-input-container class="md-block" flex="100"><input ng-change="vm.loadData()" ng-model="vm.searchRequest.search.pageUrl" placeholder="{{\'reports.suspect-report.page-url\'| translate}}" ng-model-options="{ debounce: vm.simpleSearchDelay }"></md-input-container></div><div layout="row" flex="33" flex-xs="100" layout-wrap><md-input-container class="md-block" flex="50" flex-xs="50" flex-sm="50"><input id="ac1FromInput" input-number ng-model="vm.searchRequest.search.sc2From" placeholder="{{\'reports.suspect-report.sc-in-2-from\'| translate}}"></md-input-container><md-input-container class="md-block" flex="50" flex-xs="50" flex-sm="50"><input id="ac1ToInput" input-number ng-model="vm.searchRequest.search.sc2To" placeholder="{{\'reports.suspect-report.sc-in-2-to\'| translate}}"></md-input-container></div><div layout="row" flex="33" flex-xs="100" layout-wrap><md-input-container class="md-block" flex="50" flex-xs="50" flex-sm="50"><input id="lc1FromInput" input-number ng-model="vm.searchRequest.search.sc1From" placeholder="{{\'reports.suspect-report.sc-in-1-from\'| translate}}"></md-input-container><md-input-container class="md-block" flex="50" flex-xs="50" flex-sm="50"><input id="lc1ToInput" input-number ng-model="vm.searchRequest.search.sc1To" placeholder="{{\'reports.suspect-report.sc-in-1-to\'| translate}}"></md-input-container></div></div><div layout="row" layout-xs="column"><md-input-container flex="33"><label data-translate="reports.table.search.date-range-from"></label><md-datepicker input-date aria-label="from" name="dateFrom" ng-change="vm.fixDate(vm.searchRequest.search.dateFrom, \'dateFrom\', vm)" ng-model="vm.searchRequest.search.dateFrom"></md-datepicker><md-tooltip md-delay="100" md-direction="top">{{\'global.messages.info.dateformat\'| translate}}</md-tooltip></md-input-container><md-input-container flex="33"><label data-translate="reports.table.search.date-range-to"></label><md-datepicker input-date aria-label="to" name="dateTo" ng-change="vm.fixDate(vm.searchRequest.search.dateTo, \'dateTo\', vm)" ng-model="vm.searchRequest.search.dateTo"></md-datepicker><md-tooltip md-delay="100" md-direction="top">{{\'global.messages.info.dateformat\'| translate}}</md-tooltip></md-input-container></div><div layout="row" layout-padding layout-sm="column" layout-xs="column" layout-wrap><div layout="row" layout-align="start" layout-padding layout-xs="column"><md-button class="search-buttons md-raised" aria-label="back" ng-click="vm.goBack()"><i class="material-icons">keyboard_backspace</i> {{\'global.button.back\'| translate}}</md-button><md-button aria-label="clear" class="md-raised search-buttons" data-translate="global.button.clear.search" ng-click="vm.clear()"></md-button><md-button aria-label="search" class="md-raised md-primary search-buttons" type="submit" data-translate="global.button.search" ng-click="vm.loadData()"></md-button></div></div></form><md-table-container><table md-table class="reports-table"><thead md-head md-order="vm.queryRequest.order" md-on-reorder="vm.loadData"><th md-column>#</th><th md-column md-order-by="url"><span data-translate="reports.suspect-report.page-url"></span></th><th md-column md-order-by="type"><span data-translate="reports.table.header.portal-of-client.type"></span></th><th md-column md-order-by="checkTime"><span data-translate="reports.table.header.reports.date"></span></th><th md-column md-order-by="reportCoe"><md-tooltip md-delay="100" md-direction="top">{{\'reports.suspect-report.sc-in-2-tooltip\'| translate}}</md-tooltip><span data-translate="reports.suspect-report.sc-in-2"></span></th><th md-column md-order-by="reportCoeReverted"><md-tooltip md-delay="100" md-direction="top">{{\'reports.suspect-report.sc-in-1-tooltip\'| translate}}</md-tooltip><span data-translate="reports.suspect-report.sc-in-1"></span></th><th md-column><md-tooltip md-delay="100" md-direction="top">{{\'reports.suspect-report.tooltip.show-both-reports\'| translate}}</md-tooltip><span data-translate="reports.suspect-report.both-reports"></span></th></thead><tbody md-body><tr ng-repeat="row in vm.pageOfData.content track by $index" md-row><td md-cell>{{($index + 1) + ((vm.pageOfData.number - 1) * vm.pageOfData.size)}}</td><td md-cell class="word-break-all"><a href="{{row.url}}" target="_blank">{{row.url}}</a></td><td md-cell><span ng-if="row.type == 1"><md-tooltip md-delay="100" md-direction="top">{{\'reports.portal-of-client.type.legal\'| translate}}</md-tooltip><i class="material-icons icon-paid">thumb_up</i> </span><span ng-if="row.type == 2"><md-tooltip md-delay="100" md-direction="top">{{\'reports.portal-of-client.type.illegal\'| translate}}</md-tooltip><i class="inner material-icons icon-error">thumb_down</i> </span><span ng-if="row.type == 3"><md-tooltip md-delay="100" md-direction="top">{{\'reports.portal-of-client.type.client\'| translate}}</md-tooltip><i class="inner material-icons icon-added">home</i></span></td><td md-cell>{{vm.convertToDate(row.checkTime) | date:\'yyyy-MM-dd\'}}</td><td md-cell>{{row.reportCoe}}</td><td md-cell>{{row.reportCoeReverted}}</td><td md-cell><md-button aria-label="get report" class="md-icon-button m-0" ng-click="vm.showBothReports(row)" ng-if="(row.reportCoe !== null) && (row.reportCoeReverted !== null)"><md-tooltip md-delay="100" md-direction="top">{{\'reports.suspect-report.tooltip.show-both-reports\'| translate}}</md-tooltip><i class="material-icons">sticky_note_2</i></md-button></td></tr></tbody></table></md-table-container><div layout="row" layout-padding layout-wrap></div><div flex layout="row" layout-align="end center" layout-wrap><select-page-size flex="25" flex-xs="100" layout="row" layout-align="start center" query-request="vm.queryRequest" on-value-chosen="vm.loadData()"></select-page-size><div flex></div><paging page="vm.pageOfData.number" page-size="vm.pageOfData.size" paging-action="vm.loadPageOfData(page)" show-first-last="true" show-prev-next="true" total="vm.pageOfData.totalElements"></paging><div class="go-to" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to page" ng-model="vm.goToPageInputModel" min="1" max="vm.pageOfData.totalPages" type="number" ng-keyup="$event.keyCode === vm.keyCodeEnter && vm.loadPageOfData(vm.goToPageInputModel)"></md-input-container></div></div></md-card></md-content></div></div>');
$templateCache.put('app/account/pap/reports/reports-bottom-sheet.html','<md-bottom-sheet layout="column"><div ng-cloak><div layout="row" layout-xs="column" layout-align="start start"><span layout-align="start start" layout-padding layout-xs="column"><span ng-click="bootomSheet.closeBottomSheet()" data-translate="global.undo">Cofnij</span> </span><span layout-align="start start" layout-padding layout-xs="row" flex><!--\n        <span>\n          <md-checkbox ng-model="bootomSheet.checked" aria-label="Checkbox 1" ng-click="bootomSheet.closeBottomSheet()">\n          --> <span data-translate="global.selected"></span><!--\n          </md-checkbox>\n        </span>\n        --> <span class="md-mini" layout-align="center start" aria-label="{{bootomSheet.selected.length}}" ng-if="!bootomSheet.tableSelectOptions.selectedAll">{{bootomSheet.selected.length}} / {{bootomSheet.total}} </span><span class="md-mini" aria-label="{{bootomSheet.selected.length}}" ng-if="bootomSheet.tableSelectOptions.selectedAll">{{bootomSheet.tableSelectOptions.selectedNo}} / {{bootomSheet.total}} </span><span aria-label="select all" ng-click="bootomSheet.toggleSelection(bootomSheet.total)" ng-if="!bootomSheet.tableSelectOptions.selectedAll" data-translate="global.button.select.all"></span> <span aria-label="select all" ng-click="bootomSheet.toggleSelection(bootomSheet.totalUsers)" ng-if="bootomSheet.tableSelectOptions.selectedAll" data-translate="global.button.clear.selection"></span> </span><span layout-align="start start" layout-padding layout-xs="row" flex flex-offset-gt-sm="10"><span layout-align="center start" ng-show="bootomSheet.tableSelectOptions.selectedNo < 1000" ng-click="bootomSheet.generateReportXls()"><i class="material-icons">vertical_align_bottom</i> <span data-translate="global.bottomsheet.getreport"></span> </span><span layout-align="center start"><span ng-click="bootomSheet.sendReportXls()"><i class="material-icons">attach_email</i> {{\'reports.bottomsheet.send-report\' | translate}}</span></span></span></div></div></md-bottom-sheet>');
$templateCache.put('app/account/pap/reports/reports.html','<div layout="column" class="site-container reports" id="reports"><div class="table-container"><md-progress-linear ng-if="vm.pending" md-mode="indeterminate"></md-progress-linear><md-content layout="row" flex layout-margin><md-card flex layout-padding><div><form name="formSearchReports"><div layout="row" layout-xs="column"><md-input-container class="md-block" flex="25" flex-xs="100"><input ng-change="vm.loadData()" ng-model="vm.searchRequest.search.title" placeholder="{{\'document.model.title\'| translate}}" ng-model-options="{ debounce: vm.simpleSearchDelay }"></md-input-container><md-input-container class="md-block" flex="25" flex-xs="100"><input ng-change="vm.loadData()" ng-model="vm.searchRequest.search.author" placeholder="{{\'document.model.author\'| translate}}" ng-model-options="{ debounce: vm.simpleSearchDelay }"></md-input-container><md-input-container class="md-block" flex="25" flex-xs="100"><input ng-change="vm.loadData()" ng-model="vm.searchRequest.search.docuExternalId" placeholder="{{\'reports.details.external-id\'| translate}}" ng-model-options="{ debounce: vm.simpleSearchDelay }"></md-input-container><md-input-container md-no-float class="md-block" flex="25" flex-xs="100"><label data-translate="document.model.status">typ</label><md-select ng-change="vm.loadData()" aria-label="status" layout-align="center center" placeholder="{{\'document.model.status\' | translate}}" ng-model="vm.searchRequest.search.status"><md-option ng-value="" ng-if="vm.searchRequest.search.status"><em>{{\'global.button.clear\'| translate}}: {{\'document.model.status\' | translate}}</em></md-option><md-option ng-value="val.id" ng-repeat="val in vm.documentPapStatuses"><em>{{\'document.table.statuses.\' + val.status | translate}}</em></md-option></md-select></md-input-container></div><div layout="row" layout-xs="column"><md-input-container class="md-block" flex="25" flex-xs="100"><input ng-change="vm.loadData()" ng-model="vm.searchRequest.search.keywords" placeholder="{{\'reports.details.keywords\'| translate}}" ng-model-options="{ debounce: vm.simpleSearchDelay }"></md-input-container><md-input-container class="md-block" flex="25" flex-xs="100"><input ng-change="vm.loadData()" ng-model="vm.searchRequest.search.department" placeholder="{{\'reports.details.department\'| translate}}" ng-model-options="{ debounce: vm.simpleSearchDelay }"></md-input-container><md-input-container class="md-block" flex="25" flex-xs="100"><input ng-change="vm.loadData()" ng-model="vm.searchRequest.search.services" placeholder="{{\'reports.details.services\'| translate}}" ng-model-options="{ debounce: vm.simpleSearchDelay }"></md-input-container><md-input-container class="md-block" flex="25" flex-xs="100"><input ng-change="vm.loadData()" ng-model="vm.searchRequest.search.categories" placeholder="{{\'reports.details.categories\'| translate}}" ng-model-options="{ debounce: vm.simpleSearchDelay }"></md-input-container></div><div layout="row" layout-xs="column"><div layout="row" flex="25" flex-xs="100" layout-wrap><md-input-container class="md-block" flex="50" flex-xs="50" flex-sm="50"><input id="wp1FromInput" input-number ng-model="vm.searchRequest.search.scFrom" placeholder="{{\'reports.table.header.reports.similarity-factor-from\'| translate}}"></md-input-container><md-input-container class="md-block" flex="50" flex-xs="50" flex-sm="50"><input id="wp1ToInput" input-number ng-model="vm.searchRequest.search.scTo" placeholder="{{\'reports.table.header.reports.similarity-factor-to\'| translate}}"></md-input-container></div><div layout="row" flex="25" flex-xs="100" layout-wrap><md-input-container class="md-block" flex="50" flex-xs="50" flex-sm="50"><input id="ac1FromInput" input-number ng-model="vm.searchRequest.search.allCopiesFrom" placeholder="{{\'reports.table.header.reports.all-copies-from\'| translate}}"></md-input-container><md-input-container class="md-block" flex="50" flex-xs="50" flex-sm="50"><input id="ac1ToInput" input-number ng-model="vm.searchRequest.search.allCopiesTo" placeholder="{{\'reports.table.header.reports.all-copies-to\'| translate}}"></md-input-container></div><div layout="row" flex="25" flex-xs="100" layout-wrap><md-input-container class="md-block" flex="50" flex-xs="50" flex-sm="50"><input id="lc1FromInput" input-number ng-model="vm.searchRequest.search.legalCopiesFrom" placeholder="{{\'reports.table.header.reports.legal-copies-from\'| translate}}"></md-input-container><md-input-container class="md-block" flex="50" flex-xs="50" flex-sm="50"><input id="lc1ToInput" input-number ng-model="vm.searchRequest.search.legalCopiesTo" placeholder="{{\'reports.table.header.reports.legal-copies-to\'| translate}}"></md-input-container></div><div layout="row" flex="25" flex-xs="100" layout-wrap><md-input-container class="md-block" flex="50" flex-xs="50" flex-sm="50"><input id="ic1FromInput" input-number ng-model="vm.searchRequest.search.illegalCopiesFrom" placeholder="{{\'reports.table.header.reports.illegal-copies-from\'| translate}}"></md-input-container><md-input-container class="md-block" flex="50" flex-xs="50" flex-sm="50"><input id="ic1ToInput" input-number ng-model="vm.searchRequest.search.illegalCopiesTo" placeholder="{{\'reports.table.header.reports.illegal-copies-to\'| translate}}"></md-input-container></div></div><div layout="row" layout-xs="column"><md-input-container flex="25"><label data-translate="reports.table.search.date-range-from"></label><md-datepicker input-date aria-label="from" name="portalDateFrom" ng-change="vm.fixDate(vm.searchRequest.search.portalDateFrom, \'portalDateFrom\', vm)" ng-model="vm.searchRequest.search.dateFrom"></md-datepicker><md-tooltip md-delay="100" md-direction="top">{{\'global.messages.info.dateformat\'| translate}}</md-tooltip></md-input-container><md-input-container flex="25"><label data-translate="reports.table.search.date-range-to"></label><md-datepicker input-date aria-label="to" name="portalDateTo" ng-change="vm.fixDate(vm.searchRequest.search.portalDateTo, \'portalDateTo\', vm)" ng-model="vm.searchRequest.search.dateTo"></md-datepicker><md-tooltip md-delay="100" md-direction="top">{{\'global.messages.info.dateformat\'| translate}}</md-tooltip></md-input-container></div><div layout="row" layout-padding layout-sm="column" layout-xs="column" layout-wrap><div layout="row" layout-align="start" layout-padding layout-xs="column"><md-button aria-label="clear" class="md-raised search-buttons" data-translate="global.button.clear.search" ng-click="vm.clear()"></md-button><md-button aria-label="search" class="md-raised md-primary search-buttons" type="submit" data-translate="global.button.search" ng-click="vm.loadData()"></md-button></div></div></form></div><md-table-container><table md-table class="reports-table" md-row-select="vm.options.rowSelection" multiple="{{vm.options.multiSelect}}" ng-model="vm.selected"><thead md-head md-order="vm.queryRequest.order" md-on-reorder="vm.loadData"><th md-column>#</th><th md-column md-order-by="docuTitle"><span data-translate="document.model.title"></span></th><th md-column md-order-by="docuAuthor"><span data-translate="document.model.author"></span></th><th md-column md-order-by="docuSubmitDate"><span data-translate="reports.table.header.reports.date"></span></th><th md-column md-order-by="docuSimilarityFactor"><span data-translate="reports.table.header.reports.similarity-factor"></span></th><th md-column md-order-by="docuStatus"><span data-translate="document.model.status"></span></th><th md-column><md-tooltip md-delay="100" md-direction="top" ng-bind-html="\'reports.table.reports-tooltip\' | translate" class="tooltip-with-long-text"></md-tooltip><span data-translate="global.menu.account.similarity.report.settings"></span></th><!--<th md-column><span data-translate="document.table.report"></span></th>--><th md-column class="table-actions"><span data-translate="global.table.actions"></span></th></thead><tbody md-body><tr ng-repeat-start="row in vm.pageOfData.content track by $index" md-row md-select="row.documentId" md-on-deselect="vm.deSelectRow" md-on-select="vm.selectRow"><td md-cell ng-click="vm.getDetails(row)">{{($index + 1) + ((vm.pageOfData.number - 1) * vm.pageOfData.size)}}</td><td md-cell ng-click="vm.getDetails(row)" class="word-break-all">{{row.docuTitle}}</td><td md-cell ng-click="vm.getDetails(row)" class="word-break-all">{{row.docuAuthor}}</td><td md-cell ng-click="vm.getDetails(row)">{{vm.convertToDate(row.docuSubmitDate) | date:\'yyyy-MM-dd\'}}</td><td md-cell ng-click="vm.getDetails(row)">{{row.docuSimilarityFactor| percentage:2}}</td><td md-cell ng-click="vm.getDetails(row)"><span ng-if="row.docuStatus == vm.documentStatus.PLAGIARISM_CHECKED.id"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.paid\'| translate}}</md-tooltip><i class="material-icons icon-paid">verified_user</i> </span><span ng-if="row.docuStatus == vm.documentStatus.WAITING.id || row.docuStatus == vm.documentStatus.PROCESSING.id"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.waiting\'| translate}}</md-tooltip><i class="inner material-icons">hourglass_bottom</i></span></td><td md-cell ng-click="vm.getDetails(row)"><div layout="row" layout-align="center center"><div><md-tooltip md-delay="100" md-direction="top" ng-bind-html="\'reports.table.reports-tooltip\' | translate" class="tooltip-with-long-text"></md-tooltip><span>{{row.suspectReportQuantity >= 0 ? row.suspectReportQuantity : \'\'}}</span> <span class="icon-blue">{{row.nativeSuspectReportQuantity >= 0 ? row.nativeSuspectReportQuantity : \'\'}}</span> <span class="icon-green">{{row.legalSuspectReportQuantity >= 0 ? row.legalSuspectReportQuantity : \'\'}}</span> <span class="icon-red">{{row.illegalSuspectReportQuantity >= 0 ? row.illegalSuspectReportQuantity : \'\'}}</span></div><div class="d-inline-flex documents-buttons-report"><md-button aria-label="get report" class="md-icon-button m-0" ng-click="vm.showSuspectReports(row)" ng-if="row.hasReport"><md-tooltip md-delay="100" md-direction="top">{{\'reports.table.menu.show-suspect-reports\'| translate}}</md-tooltip><i class="material-icons">topic</i></md-button></div></div></td><td md-cell><div flex layout="row" layout-align="end center"><md-menu-bar flex layout="row"><md-menu><md-button aria-label="open" class="md-icon-button" ng-click="$mdMenu.open()"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item><md-button aria-label="show text" ng-click="vm.showText($event, row)" data-translate="document.table.menu.showtext"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></td></tr><tr ng-repeat-end ng-if="vm.showDetailsBlock && vm.pickedDocument == row.documentId" class="document-details"><td colspan="10"><document-details-reports on-document="row" on-document-details="vm.details"></document-details-reports></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoaderActive"></md-progress-circular></div></md-table-container><div flex layout="row" layout-align="end center" layout-wrap><select-page-size flex="25" flex-xs="100" layout="row" layout-align="start center" query-request="vm.queryRequest" on-value-chosen="vm.loadData()"></select-page-size><div flex></div><paging page="vm.pageOfData.number" page-size="vm.pageOfData.size" paging-action="vm.loadPageOfData(page)" show-first-last="true" show-prev-next="true" total="vm.pageOfData.totalElements"></paging><div class="go-to" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to page" ng-model="vm.goToPageInputModel" min="1" max="vm.pageOfData.totalPages" type="number" ng-keyup="$event.keyCode === vm.keyCodeEnter && vm.loadPageOfData(vm.goToPageInputModel)"></md-input-container></div></div><div class="white-div" ng-show="vm.isBottomSheetOpen()">.</div></md-card></md-content></div></div>');
$templateCache.put('app/account/payments/payment-metric/payment-metric.template.html','<md-content layout="row" class="payment-metric"><div layout-margin layout="row" flex class="payment-metric-container"><div flex="60" flex-md="100" flex-sm="100" flex-xs="100"><md-card><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><h2 flex data-translate="payments.metric.title">Zakup token\xF3w</h2></div></md-toolbar><md-card-title><md-card-title-text><div class="payment-box box-with-shadow active-step1" ng-class="{\n                                \'active-step2\': $ctrl.stepsActiveObj.stepInvoice,\n                                \'active-step3\': $ctrl.stepsActiveObj.stepPaymentMethod\n                            }"><div class="payment-top-wrapper"><div class="payment-line"></div><div class="payment-steps" layout-wrap><div class="step steps-step-1" flex-xs="100"><div class="step-counter"><div class="step-counter-number">1</div><i class="material-icons step-counter-done">done</i></div><div class="step-name" data-translate="payments.metric.token-number">Liczba token\xF3w</div></div><div class="step steps-step-2" flex-xs="100" ng-show="$ctrl.invoice === true"><div class="step-counter"><div class="step-counter-number">2</div><i class="material-icons step-counter-done">done</i></div><div class="step-name" data-translate="payments.metric.invoice">Faktura</div></div><div class="step steps-step-3" flex-xs="100"><div class="step-counter"><div class="step-counter-number"><span ng-show="$ctrl.invoice">3</span> <span ng-show="!$ctrl.invoice">2</span></div><i class="material-icons step-counter-done">done</i></div><div class="step-name" data-translate="payments.metric.paymentsmethod"></div></div></div></div></div></md-card-title-text></md-card-title><md-card-content><div layout="column" flex><div class="payment-content payment-content-step1"><form class="formToken" name="formToken" autocomplete="off"><div class="input-field tokens-count" ng-class="{ \'hide\': $ctrl.paymentForm.phase !== \'stepTokens\'}"><md-input-container class="md-block"><input placeholder="{{\'payments.metric.tokensno\' | translate }}" id="tokensNumber" aria-label="tokens number" ng-model="$ctrl.paymentForm.tokens" type="text" onkeypress="return (event.charCode == 0 || (event.charCode >= 48 && event.charCode <= 57))" ng-pattern="/^[0-9]+$/" ng-keyup="$ctrl.getPrice()" name="tokensNumber" placeholder="{{\'payments.metric.inputno\'| translate}}" autocomplete="off" required><div class="md-input-messages-info ng-active" ng-class="{\'md-input-messages-error\': $ctrl.tokenError && $ctrl.paymentForm.tokens != \'\' }"><div data-translate="payments.metric.max-tokens-info"></div></div></md-input-container></div><div class="summary" ng-class="{ \'hide\': $ctrl.paymentForm.phase === \'invoice\'}"><div class="summary-line" ng-class="{ \'hide\': $ctrl.paymentForm.phase !== \'stepTokens\'}"><div class="summary-name" data-translate="payments.metric.currency" ng-click="$ctrl.showPaymentsMethods()" layout-align="center center">currency</div><div class="summary-value"><md-select aria-label="set query limit" ng-model="$ctrl.currency" layout-align="center center"><md-option ng-value="currency" ng-click="$ctrl.setCurrency(currency)" ng-repeat="currency in $ctrl.currencies"><em>{{currency}}</em></md-option></md-select></div></div><div class="summary-line"><div class="summary-name" data-translate="payments.metric.tokensno">:</div><div class="summary-value">{{$ctrl.paymentForm.tokens}}</div></div><div class="summary-line"><div class="summary-name" data-translate="payments.metric.price"></div><div class="summary-value">x {{$ctrl.onTokenPrice.price > 0 ? $ctrl.onTokenPrice.singlePrice : 0 | currency:$ctrl.currency}}</div></div><div class="hr"></div><div class="summary-line"><div class="summary-name" data-translate="payments.metric.topay"></div><div class="summary-value summary-value-big" flex layout="row"><span layout-align="center center">{{$ctrl.onTokenPrice.price | currency:$ctrl.currency}}</span></div></div></div></form><div class="hr-payment hr"></div></div><div class="payment-content payment-content-step2" ng-class="{ \'hide\': $ctrl.paymentForm.phase !== \'paymentMethod\'}"><div class="payment-mode-header" data-translate="payments.metric.paymentsmethod"></div><form class="formPaymentMethod" name="formPaymentMethod" autocomplete="off"><md-radio-group name="paymentMethod" ng-model="$ctrl.paymentForm.paymentMethod" ng-change="$ctrl.setTypeMethod()" required><div class="payment-mode"><div class="payment-mode-line" layout-align="center center" ng-repeat="paymentMethod in $ctrl.paymentsMethod"><md-radio-button value="{{paymentMethod}}" class="md-primary row md-block" ng-disabled="$ctrl.isPaymentDisabled(paymentMethod)" aria-label="{{paymentMethod}}"><img ng-src="{{$ctrl.instance ==\'ro\' && paymentMethod==\'TYPE_MOBILPAY_SMS\'?\'content/images/pay-mobilpay-ro.png\':(\'content/images/\'+$ctrl.paymentInit[paymentMethod].img)}}"> {{$ctrl.instance == \'en\' ? \'\' : $ctrl.paymentInit[paymentMethod].name}} <span ng-if="$ctrl.paymentForm.tokens > $ctrl.paymentInit[paymentMethod].maxTokens" data-translate="payments.metric.max-tokens" translate-values="{max: \'{{$ctrl.paymentInit[paymentMethod].maxTokens}}\'}">mo\u017Cna kupi\u0107 max {{$ctrl.paymentInit[paymentMethod].maxTokens}} token\xF3w</span></md-radio-button><div class="payment-line-collapsible" ng-if="$ctrl.paymentForm.paymentMethod == \'TYPE_MOBILTEK\' && paymentMethod === \'TYPE_MOBILTEK\'"><ul class="collapsible" data-collapsible="accordion"><li><div class="collapsible-header sms-account"></div><div class="collapsible-body"><span class="sms-info-text" data-translate="payments.metric.mobiltek.desc"></span></div></li></ul></div><div class="payment-line-collapsible" ng-if="$ctrl.paymentForm.paymentMethod == \'TYPE_SMS\' && paymentMethod === \'TYPE_SMS\'"><ul class="collapsible" data-collapsible="accordion"><li><div class="collapsible-header sms-account"></div><div class="collapsible-body"><div class="sms-info-text" data-translate="payments.metric.sms.desc"></div><div layout="row" layout-wrap><md-input-container class="md-block sms-input" flex="25" ng-repeat="n in $ctrl.tokensArr"><input ng-disabled="$ctrl.getStatusSms($ctrl.paymentForm.smsCodes[n]) === \'valid\'" ng-model="$ctrl.paymentForm.smsCodes[n].code" placeholder="{{!$ctrl.paymentForm.smsCodes[n].code ? \'payments.metric.sms.enter-cod\' : \'payments.metric.sms.provide-cod\'| translate}}" ng-init="$ctrl.paymentForm.smsCodes[n].name = \'name-\' + n"> <span ng-show="$ctrl.isSmsNotValid($ctrl.paymentForm.smsCodes[n].code) === true" class="error-description" data-translate="payments.metric.sms.notValid"></span> <span ng-show="$ctrl.getStatusSms($ctrl.paymentForm.smsCodes[n]) === \'valid\'" class="" data-translate="payments.metric.sms.valid"></span> <span ng-show="$ctrl.getStatusSms($ctrl.paymentForm.smsCodes[n]) === \'error\'" class="" data-translate="payments.metric.sms.again"></span></md-input-container></div></div></li></ul></div><div class="row" flex ng-if="$ctrl.paymentForm.paymentMethod == \'TYPE_BLIK\' && paymentMethod === \'TYPE_BLIK\'"><md-input-container flex="25" class="md-block"><input ng-pattern="/^[0-9]{6}$/" onkeypress="return (event.charCode == 0 || (event.charCode >= 48 && event.charCode <= 57))" name="blikCode" ng-model="$ctrl.paymentForm.blikCode" placeholder="{{\'payments.metric.blik.enter-code\' | translate}}"> <span ng-show="formPaymentMethod.blikCode.$error.pattern" class="error-description" data-translate="payments.payment.blik.validation.6digit"></span></md-input-container></div></div></div></md-radio-group></form><div class="hr"></div></div><div class="payment-content payment-content-step3" ng-show="$ctrl.paymentForm.phase === \'invoice\'"><md-radio-group ng-if="!$ctrl.isRomania && $ctrl.invoice" ng-model="$ctrl.paymentForm.invoiceRequired" layout="column"><md-radio-button ng-value="false"><span data-translate="payments.metric.no-invoiceissue"></span></md-radio-button><md-radio-button ng-value="true"><span data-translate="payments.metric.invoiceissue"></span></md-radio-button></md-radio-group><hr ng-if="$ctrl.paymentForm.invoiceRequired && !$ctrl.isRomania"><form class="form" name="form" flex ng-show="$ctrl.paymentForm.invoiceRequired"><md-radio-group ng-model="$ctrl.paymentForm.isCompany" layout="row" layout-padding><md-radio-button ng-value="true"><span data-translate="payments.metric.address.placeholder.business"></span></md-radio-button><md-radio-button ng-value="false"><span data-translate="payments.metric.address.placeholder.private-person"></span></md-radio-button></md-radio-group><div layout="row" layout-xs="column"><md-input-container ng-show="$ctrl.paymentForm.isCompany" class="md-block" flex="50" flex-xs="100"><input ng-model="$ctrl.paymentForm.invoice.company" placeholder="{{!$ctrl.paymentForm.invoice.company ? \'payments.metric.address.placeholder.company\' : \'payments.metric.address.company\' | translate}}" required></md-input-container><md-input-container ng-show="!$ctrl.paymentForm.isCompany" class="md-block" flex="100"><input ng-model="$ctrl.paymentForm.invoice.company" placeholder="{{!$ctrl.paymentForm.invoice.company ? \'payments.metric.address.placeholder.first-and-last-name\' : \'payments.metric.address.first-and-last-name\' | translate}}" required></md-input-container><md-input-container ng-show="$ctrl.paymentForm.isCompany" class="md-block" flex="50" flex-xs="100"><input ng-model="$ctrl.paymentForm.invoice.nip" placeholder="{{!$ctrl.paymentForm.invoice.nip ? \'payments.metric.address.placeholder.nip\' : \'payments.metric.address.nip\' | translate}}" md-maxlength="16" ng-required="$ctrl.paymentForm.isCompany"></md-input-container></div><div layout="row" layout-xs="column"><md-input-container class="md-block" flex="100"><input ng-model="$ctrl.paymentForm.invoice.street" placeholder="{{!$ctrl.paymentForm.invoice.street ? \'payments.metric.address.placeholder.street\' : \'payments.metric.address.street\' | translate}}" required></md-input-container></div><div layout="row" layout-xs="column" ng-if="!$ctrl.isRomania"><md-input-container class="md-block" flex="50" flex-xs="100"><input ng-model="$ctrl.paymentForm.invoice.city" placeholder="{{!$ctrl.paymentForm.invoice.city ? \'payments.metric.address.placeholder.city\' : \'payments.metric.address.city\' | translate}}" required></md-input-container><md-input-container class="md-block" flex="50" flex-xs="100"><input ng-model="$ctrl.paymentForm.invoice.zip" placeholder="{{!$ctrl.paymentForm.invoice.zip ? \'payments.metric.address.placeholder.post-code\' : \'payments.metric.address.post-code\' | translate}}" md-maxlength="10" required></md-input-container><md-input-container class="md-block" flex="100"><label data-translate="users.model.country"></label><md-select placeholder="{{\'users.model.country\' | translate}}" ng-model="$ctrl.paymentForm.invoice.country" required><md-option ng-value="code" ng-repeat="code in $ctrl.countries">{{(\'country.\' + code.toLowerCase()) | translate}}</md-option></md-select></md-input-container></div><div layout="row" layout-xs="column" ng-if="$ctrl.isRomania"><md-input-container class="md-block" flex="50" flex-xs="100"><label data-translate="payments.metric.address.county"></label><md-select ng-model="$ctrl.paymentForm.invoice.county" ng-change="$ctrl.onRoCountyChange()" required><md-option ng-repeat="county in $ctrl.romanianCounties" ng-value="county.name">{{ county.name }}</md-option></md-select></md-input-container><md-input-container class="md-block" flex="50" flex-xs="100"><md-autocomplete class="white-background" md-floating-label="{{\'payments.metric.address.city\' | translate}}" md-selected-item="$ctrl.paymentForm.invoice.city" md-search-text="searchText" md-items="city in $ctrl.romanianCities | filter:searchText" md-item-text="city" ng-disabled="!$ctrl.paymentForm.invoice.county" md-min-length="0" md-require-match="true" md-delay="100" md-select-on-match="true" md-clear-button="true" md-no-cache="true" required><md-item-template><span md-highlight-text="searchText">{{ city }}</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{searchText}}"</md-not-found></md-autocomplete></md-input-container></div><div class="pt-3"><md-checkbox class="top-checkbox md-block" ng-model="$ctrl.paymentForm.agreement" aria-label="Data Correct Agreement" required><span data-translate="payments.metric.agreement"></span></md-checkbox></div></form><div class="hr"></div></div></div></md-card-content><md-card-actions layout="row" layout-align="end center"><md-button ng-if="$ctrl.paymentForm.phase === \'paymentMethod\' || $ctrl.paymentForm.phase === \'invoice\'" ng-click="$ctrl.goBack()" data-translate="payments.metric.buttons.back">Cofnij</md-button><md-button class="md-raised md-primary button-forward" ng-disabled="formToken.tokensNumber.$invalid || $ctrl.tokenError" ng-if="$ctrl.paymentForm.phase === \'stepTokens\'" ng-click="$ctrl.nextStep()" data-translate="payments.metric.buttons.forward" id="goToPaymentMethodButton">Dalej</md-button><md-button class="md-raised md-primary" ng-if="$ctrl.paymentForm.phase === \'invoice\'" ng-click="$ctrl.nextStep()" ng-disabled="$ctrl.paymentForm.invoiceRequired && form.$invalid" data-translate="payments.metric.buttons.forward">Dalej</md-button><md-button class="md-raised md-primary button-waiting" ng-if="$ctrl.paymentForm.phase === \'paymentMethod\'" ng-disabled="formToken.tokensNumber.$invalid ||\n                                    ($ctrl.paymentForm.invoiceRequired && form.$invalid) ||\n                                    formPaymentMethod.paymentMethod.$invalid ||\n                                    formPaymentMethod.blikCode.$error.pattern ||\n                                    ($ctrl.paymentForm.paymentMethod == \'TYPE_BLIK\' && !formPaymentMethod.blikCode.$viewValue)" ng-click="$ctrl.buyTokens()" data-translate="payments.metric.buttons.buy">Kup tokeny</md-button></md-card-actions></md-card></div><div flex="40" flex-md="100" flex-sm="100" flex-xs="100" layout="column" layout-align="center start"><div layout-padding><div layout-padding class="payment-col-label" data-translate="payments.info" ng-if="$ctrl.tokensNeeded">* Informacja:</div><div layout-padding class="payment-text" data-translate="payments.longinfo" ng-if="$ctrl.tokensNeeded">Masz w bazie dokumenty czekaj\u0105ce na sprwadzenie.<br>Dokup tokeny aby m\xF3c sprawdzi\u0107 wgrane pliki w systemie<br>Plagiat.</div><md-divider></md-divider></div><div layout-padding><div layout-padding class="payment-col-label" data-translate="payments.whatistokens">Czym s\u0105 tokeny?</div><div layout-padding class="payment-text" data-translate="payments.tokensinfo_instance_ro" ng-if="$ctrl.instance == \'ro\'"></div><div layout-padding class="payment-text" data-translate="payments.tokensinfo" ng-if="$ctrl.instance != \'ro\'"></div></div></div></div></md-content>');
$templateCache.put('app/account/payments/payment-status/payment-status.template.html','<conversion-tracking-price ng-if="vm.lastPayment.providerStatus===\'payment.status.success\' || vm.lastPayment.providerStatus===\'payment.status.completed\'"></conversion-tracking-price><md-content layout="row" class="payment-metric last-payment-status"><div layout-margin layout="row" flex><div flex="60" flex-md="100" flex-sm="100" flex-xs="100"><md-card><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><h2 flex data-translate="payments.last.payment"></h2></div></md-toolbar><md-card-title><md-card-title-text><table class="last-payment-info"><tr><th colspan="100%"><div class="payment-done" ng-if="vm.lastPayment.providerStatus===\'payment.status.success\' || vm.lastPayment.providerStatus===\'payment.status.completed\'"><span ng-if="!vm.onIsCode" class="label">{{\'payments.tokens.added\' | translate}}</span> <span ng-if="vm.onIsCode" class="label">{{\'payments.codes.added\' | translate}}</span> <i class="material-icons">done</i></div><div class="payment-rejected" ng-if="vm.lastPayment.providerStatus===\'payment.status.rejected\'"><span class="label">{{\'payments.payment.rejected\' | translate}}</span> <i class="material-icons">remove_shopping_cart</i></div><div class="payment-cancelled" ng-if="vm.lastPayment.providerStatus===\'payment.status.cancelled\'"><span class="label">{{\'payments.payment.cancelled\' | translate}}</span> <i class="material-icons">highlight_off</i></div><div class="payment-reclamation" ng-if="vm.lastPayment.providerStatus===\'payment.status.reclamation\'"><span class="label">{{\'payments.payment.reclamation\' | translate}}</span> <i class="material-icons">record_voice_over</i></div><div ng-if="vm.lastPayment.providerStatus===\'payment.status.sent.to.allpay\' || vm.lastPayment.providerStatus===\'payment.status.suspended\' || vm.lastPayment.providerStatus===\'payment.status.new\'"><span class="label">{{\'payments.waiting.for.finishing.transaction\' | translate}}</span><div layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular class="md-hue-2" md-diameter="20px"></md-progress-circular></div></div></th></tr><tr ng-if="!vm.onIsCode"><td>{{\'payments.payment.tokens.number\' | translate}}</td><td>{{vm.lastPayment.initialAmount}}</td></tr><tr ng-if="vm.onIsCode"><td>{{\'payments.payment.code.name\' | translate}}</td><td>{{vm.lastPayment.codeName}}</td></tr><tr><td>{{\'payments.payment.date\' | translate}}</td><td>{{vm.lastPayment.paymentDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr><tr><td>{{\'payments.payment.type\' | translate}}</td><td>{{\'payments.\'+vm.lastPayment.userPaymentType| translate}}</td></tr><tr><td>{{\'payments.payment.status\' | translate}}</td><td>{{\'payments.\'+vm.lastPayment.providerStatus | translate}}</td></tr><tr><td>{{\'payments.payment.transaction.id\' | translate}}</td><td>{{vm.lastPayment.providerTransactionId}}</td></tr></table></md-card-title-text></md-card-title></md-card></div></div></md-content>');
$templateCache.put('app/account/payments/payments-invoices/payments-invoice.template.html','<md-dialog aria-label="payment invoice" class="landing-page-invoice"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="payments.metric.invoice"></h2></div></md-toolbar><form name="formInvoice" ng-cloak><md-dialog-content style="min-width: 650px"><div class="md-dialog-content" layout-margin><div class="loader" layout="row" layout-sm="column" layout-align="space-around" ng-if="vm.isLoading"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div><md-radio-group ng-model="vm.isCompany" layout="row" layout-padding><md-radio-button ng-value="true"><span data-translate="payments.metric.address.placeholder.business"></span></md-radio-button><md-radio-button ng-value="false"><span data-translate="payments.metric.address.placeholder.private-person"></span></md-radio-button></md-radio-group><div layout="row" layout-xs="column" ng-show="!vm.isCompany"><md-input-container ng-if="!vm.isCompany" class="md-block" flex="100"><input ng-model="vm.invoice.purchaser" placeholder="{{\'payments.metric.address.first-and-last-name\' | translate}}" required></md-input-container></div><div layout="row" layout-xs="column" ng-show="vm.isCompany"><md-input-container ng-if="vm.isCompany" class="md-block" flex="50" flex-xs="100"><input ng-model="vm.invoice.purchaser" placeholder="{{ \'payments.metric.address.company\' | translate}}" required></md-input-container><md-input-container ng-if="vm.isCompany && !vm.isPoland" class="md-block" flex="50" flex-xs="100"><input ng-model="vm.invoice.nip" placeholder="{{ \'payments.metric.address.nip\' | translate}}" md-maxlength="16"></md-input-container><md-input-container ng-if="vm.isCompany && vm.isPoland" class="md-block" flex="50" flex-xs="100"><input ng-model="vm.invoice.nip" placeholder="{{ \'payments.metric.address.nip\' | translate}}" md-maxlength="16" required></md-input-container></div><div layout="row" layout-xs="column"><md-input-container class="md-block" flex="50" flex-xs="100"><input ng-model="vm.invoice.street" placeholder="{{ \'payments.metric.address.street\' | translate}}" required></md-input-container><md-input-container class="md-block" flex="50" flex-xs="100" ng-if="vm.isRomania"><input ng-model="vm.invoice.county" placeholder="{{ \'payments.metric.address.county\' | translate}}" required></md-input-container><md-input-container class="md-block" flex="100" ng-if="!vm.isRomania"><label data-translate="payments.metric.address.invoice-country"></label><md-select placeholder="{{\'payments.metric.address.invoice-country\' | translate}}" ng-model="vm.invoice.country" required><md-option ng-value="code" ng-repeat="code in vm.countries">{{(\'country.\' + code.toLowerCase()) | translate}}</md-option></md-select></md-input-container><md-input-container class="md-block" flex="100" ng-if="vm.isRomania"><label data-translate="payments.metric.address.invoice-country"></label><md-select placeholder="{{\'payments.metric.address.invoice-country\' | translate}}" ng-model="vm.invoice.country" required><md-option ng-value="vm.invoice.country" selected="vm.invoice.country" ng-disabled="true">{{(\'country.\' + vm.invoice.country.toLowerCase()) | translate}}</md-option></md-select></md-input-container></div><div layout="row" layout-xs="column"><md-input-container class="md-block" flex="50" flex-xs="100"><input ng-model="vm.invoice.city" placeholder="{{!$ctrl.paymentForm.invoice.city ? \'payments.metric.address.placeholder.city\' : \'payments.metric.address.city\' | translate}}" required></md-input-container><md-input-container class="md-block" flex="50" flex-xs="100"><input ng-model="vm.invoice.zip" placeholder="{{ \'payments.metric.address.post-code\' | translate}}" md-maxlength="10"></md-input-container></div><div layout="row" layout-xs="column" layout-align="end end"><md-button class="md-raised md-primary button-forward" ng-click="vm.saveInvoice()" data-translate="global.button.save" id="saveInvoice">Dalej</md-button></div></div></md-dialog-content></form></md-dialog>');
$templateCache.put('app/account/payments/payments-invoices/payments-invoices.html','<md-content layout="column" class="payments-list site-container"><payments-menu active-tab="vm.activeTab"></payments-menu><md-divider></md-divider><div layout-margin layout-padding layout="row"><md-card flex flex-xs="100"><form name="formSearchInvoices"><div layout="row" layout-xs="column"><select-page-size flex="25" flex-xs="100" layout="row" layout-align="start center" query-request="vm.queryRequest" on-value-chosen="vm.getInvoices()"></select-page-size></div><div layout="row" layout-xs="column" layout-padding><md-input-container class="md-block" flex="33" flex-xs="100"><input ng-model="vm.searchRequest.search.invoiceNumber" placeholder="{{\'payments.table.invoice.number\'| translate}}"></md-input-container><md-input-container class="md-block" flex="33" flex-xs="100"><input ng-model="vm.searchRequest.search.providerTransactionId" placeholder="{{\'payments.table.transact-name\'| translate}}"></md-input-container><md-input-container class="md-block" flex="25" flex-xs="50"><label data-translate="payments.table.status"></label><md-select ng-change="vm.getInvoices()" placeholder="{{\'payments.table.status\' | translate}}" ng-model="vm.searchRequest.search.status" layout-align="center center"><md-option ng-value="" ng-if="vm.searchRequest.search.status"><em>{{\'global.button.clear\'| translate}}: {{\'payments.table.status\' | translate}}</em></md-option><md-option ng-value="val.id" ng-repeat="val in vm.invoiceStatuses.arrayOfValues"><em>{{val.langKey | translate}}</em></md-option></md-select></md-input-container></div><div layout="row" layout-xs="column" layout-padding><md-input-container class="md-block" flex="33" flex-xs="100"><input ng-model="vm.searchRequest.search.purchaser" placeholder="{{\'payments.table.invoice.purchaser\'| translate}}"></md-input-container><md-input-container class="md-block" flex="33" flex-xs="100"><input ng-model="vm.searchRequest.search.userEmail" placeholder="{{\'payments.table.invoice.email\'| translate}}"></md-input-container><md-input-container class="md-block" flex="25" flex-xs="50"><label data-translate="payments.is.romanian"></label><md-select ng-change="vm.getInvoices()" placeholder="{{\'payments.is.romanian\' | translate}}" ng-model="vm.searchRequest.search.romanian" layout-align="center center"><md-option ng-value="" ng-if="vm.searchRequest.search.romanian"><em>{{\'global.button.clear\'| translate}}: {{\'payments.is.romanian\' | translate}}</em></md-option><md-option ng-value="true" data-translate="global.msg.yes">TAK</md-option><md-option ng-value="false" data-translate="global.msg.no">NIE</md-option></md-select></md-input-container></div><div layout="row" layout-xs="column" layout-padding><md-input-container class="md-block" flex="25" flex-xs="50"><label data-translate="payments.table.payment.type"></label><md-select ng-change="vm.getInvoices()" placeholder="{{\'payments.table.payment.type\' | translate}}" ng-model="vm.searchRequest.search.transactionType" layout-align="center center"><md-option ng-value="" ng-if="vm.searchRequest.search.transactionType"><em>{{\'global.button.clear\'| translate}}: {{\'payments.table.payment.type\' | translate}}</em></md-option><md-option ng-value="val.id" ng-repeat="val in vm.paymentTypes.arrayOfValues"><em>{{val.langKey | translate}}</em></md-option></md-select></md-input-container><md-input-container flex="25" flex-sm="50" flex-xs="50" layout-sm="column"><label data-translate="payments.table.transaction.date.from"></label><md-datepicker input-date name="supplyDateFrom" ng-change="vm.fixDate(vm.searchRequest.search.supplyDateFrom, \'supplyDateFrom\', vm)" ng-model="vm.searchRequest.search.supplyDateFrom"></md-datepicker><md-tooltip md-delay="100" md-direction="top">{{\'global.messages.info.dateformat\'| translate}}</md-tooltip></md-input-container><md-input-container flex="25" flex-sm="50" flex-xs="50" layout-sm="column"><label data-translate="payments.table.transaction.date.to"></label><md-datepicker input-date name="supplyDateTo" ng-change="vm.fixDate(vm.searchRequest.search.supplyDateTo, \'supplyDateTo\', vm)" ng-model="vm.searchRequest.search.supplyDateTo"></md-datepicker><md-tooltip md-delay="100" md-direction="top">{{\'global.messages.info.dateformat\'| translate}}</md-tooltip></md-input-container></div><div layout="row" layout-align="start" layout-padding layout-xs="column"><md-button aria-label="clear" class="md-raised search-buttons" data-translate="global.button.clear.search" ng-click="vm.clear()"></md-button><md-button aria-label="search" class="md-raised md-primary search-buttons" data-translate="global.button.search" ng-click="vm.getInvoices()" type="submit"></md-button></div></form><div class="table-container"><md-table-container><table md-table md-progress="vm.promise" md-row-select="vm.options.rowSelection" ng-model="vm.selected" multiple="{{vm.options.multiSelect}}"><thead md-head md-order="vm.queryRequest.order" md-on-reorder="vm.getInvoices"><tr md-row><th md-column><span>#</span></th><th md-column><span data-translate="payments.table.invoice.number"></span></th><th md-column><span data-translate="payments.table.transact-name"></span></th><th md-column md-order-by="id"><span data-translate="payments.table.invoice.date"></span></th><th md-column md-order-by="purchaser"><span data-translate="payments.table.invoice.purchaser"></span></th><th md-column><span data-translate="payments.table.invoice.email"></span></th><th md-column><span data-translate="payments.table.kind-of"></span></th><th md-column><span data-translate="payments.table.bought-token"></span></th><th md-column><span data-translate="payments.table.value"></span></th><th md-column><span data-translate="payments.table.office">Office</span></th><th md-column md-order-by="status"><span data-translate="payments.table.status"></span></th><th md-column></th></tr></thead><tbody md-body><tr md-row ng-repeat-start="invoice in vm.invoices" md-select="invoice" md-on-select="vm.selectInvoice" md-select-id="invoice.id"><td md-cell ng-click="vm.getInvoiceDetails(invoice)">{{ ($index + 1) + ((vm.queryRequest.page - 1) * vm.queryRequest.limit) }}</td><td md-cell ng-click="vm.getInvoiceDetails(invoice)">{{invoice.number}}</td><td md-cell ng-click="vm.getInvoiceDetails(invoice)"><i ng-if="invoice.status == vm.invoiceStatuses.INVOICE_STATUS_ISSUED.id">{{invoice.providerTransactionId}}</i></td><td md-cell ng-click="vm.getInvoiceDetails(invoice)">{{invoice.created | date:\'yyyy-MM-dd HH:mm\'}}</td><td md-cell ng-click="vm.getInvoiceDetails(invoice)">{{invoice.purchaser}}</td><td md-cell ng-click="vm.getInvoiceDetails(invoice)">{{invoice.email}}</td><td md-cell ng-click="vm.getInvoiceDetails(invoice)">{{\'payments.\' + invoice.userPaymentType | translate}}</td><td md-cell ng-click="vm.getInvoiceDetails(invoice)">{{invoice.initialAmount}}</td><td md-cell ng-click="vm.getInvoiceDetails(invoice)">{{invoice.value}}</td><td md-cell ng-click="vm.getInvoiceDetails(invoice)">{{invoice.office}}</td><td md-cell ng-click="vm.getInvoiceDetails(invoice)">{{\'payments.invoice.status.\' + invoice.status | translate}}</td><td md-cell><md-menu-bar flex layout="row" ng-if="invoice.userPaymentTypeId != vm.paymentTypes.PAYMENT_TYPE_MOBILTEK.id  &&\n                                (invoice.status == vm.invoiceStatuses.INVOICE_STATUS_PAID.id || invoice.status == vm.invoiceStatuses.INVOICE_STATUS_WAITING.id || invoice.status == vm.invoiceStatuses.INVOICE_STATUS_INCORRECT.id)"><md-menu><md-button aria-label="open" class="md-icon-button" ng-click="$mdMenu.open(); $event.stopPropagation();"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item ng-if="invoice.status != vm.invoiceStatuses.INVOICE_STATUS_INCORRECT.id"><md-button id="issueInvoice{{$index}}" aria-label="issue invoice action" ng-click="vm.processIssueInvoice(invoice)" data-translate="payments.table.menu.issue.invoice"></md-button></md-menu-item><md-menu-item ng-if="invoice.status === vm.invoiceStatuses.INVOICE_STATUS_PAID.id"><md-button id="editInvoice{{$index}}" aria-label="edit invoice action" ng-click="vm.editCompletedInvoice(invoice)" data-translate="global.table.menu.edit"></md-button></md-menu-item><md-menu-item ng-if="invoice.status != vm.invoiceStatuses.INVOICE_STATUS_INCORRECT.id"><md-button id="markInvoiceAsIssued{{$index}}" aria-label="mark invoice action" ng-click="vm.markInvoiceAsIssued(invoice)" data-translate="payments.table.menu.mark.invoice"></md-button></md-menu-item><md-menu-item ng-if="invoice.status != vm.invoiceStatuses.INVOICE_STATUS_WAITING.id && invoice.status != vm.invoiceStatuses.INVOICE_STATUS_INCORRECT.id"><md-button id="markInvoiceAsWaiting{{$index}}" aria-label="mark invoice as waiting action" ng-click="vm.markInvoiceAsWaiting(invoice)" data-translate="payments.table.menu.wait.invoice"></md-button></md-menu-item><md-menu-item ng-if="invoice.status != vm.invoiceStatuses.INVOICE_STATUS_INCORRECT.id"><md-button id="markInvoiceAsIncorrect{{$index}}" aria-label="mark invoice as incorrect action" ng-click="vm.markInvoiceAsIncorrect(invoice)" data-translate="payments.table.menu.mark.incorrect"></md-button></md-menu-item><md-menu-item ng-if="invoice.status === vm.invoiceStatuses.INVOICE_STATUS_INCORRECT.id"><md-button id="markInvoiceAsIncorrect{{$index}}" aria-label="mark invoice as correct action" ng-click="vm.markInvoiceAsIncorrect(invoice)" data-translate="payments.table.menu.mark.correct"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-button aria-label="download invoice" class="md-icon-button m-0" ng-click="vm.downloadInvoice(invoice.number)" ng-if="invoice.invoiceStatus == 2"><md-tooltip md-delay="100" md-direction="top">{{\'payments.table.download-invoice\'| translate}}</md-tooltip><i class="material-icons">receipt</i></md-button></td></tr><tr ng-repeat-end ng-if="vm.showDetailsBlock && (vm.pickedInvoice == invoice.id)"><td colspan="99"><payments-invoices-details on-invoice="invoice" on-invoice-details="vm.details"></payments-invoices-details></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoaderActive"></md-progress-circular></div></md-table-container><div flex><div layout="row" layout-align="start center"><md-button id="generateBulkInvoice" aria-label="generateBulkInvoice" ng-click="vm.processGenerateBulkInvoice()" ng-disabled="vm.selected.length < 2" data-translate="payments.table.button.generate.bulk.invoice" class="md-raised md-primary search-buttons"></md-button></div><div layout="row" layout-align="end center" layout-wrap><paging page="vm.queryRequest.page" page-size="vm.queryRequest.limit" paging-action="vm.pagingAction(page)" show-first-last="true" show-prev-next="true" total="vm.totalInvoices"></paging><div layout="row" class="go-to" flex-xs="100" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to next page" ng-model="vm.queryRequest.page" type="number" ng-keyup="vm.getInvoices()" ng-change="vm.getInvoices()"></md-input-container></div></div></div></div></md-card></div></md-content>');
$templateCache.put('app/account/payments/payments-invoices-details/payments-invoices-details.template.html','<div class="details-info" hide-xs layout="row" layout-padding><div layout="row" flex="40"><div layout="column" flex="50"><div layout="column" flex><span class="detail-label" data-translate="payments.metric.address.company">company</span></div><div ng-if="$ctrl.onInvoiceDetails.nip" layout="column" flex><span class="detail-label" data-translate="payments.metric.address.nip">NIP</span></div><div layout="column" flex><span class="detail-label" data-translate="payments.metric.address.street">street</span></div><div layout="column" flex><span class="detail-label" data-translate="payments.metric.address.city">city</span></div><div ng-if="$ctrl.isRomania" layout="column" flex><span class="detail-label" data-translate="payments.metric.address.county">County</span></div><div layout="column" flex><span class="detail-label" data-translate="payments.metric.address.post-code">zip</span></div><div ng-if="!$ctrl.isRomania" layout="column" flex><span class="detail-label" data-translate="users.model.country">country</span></div></div><div layout="column" flex="50"><div layout="row" flex><span class="detail-info user-details">{{$ctrl.onInvoiceDetails.purchaser}}</span></div><div ng-if="$ctrl.onInvoiceDetails.nip" layout="row" flex><span class="detail-info user-details">{{$ctrl.onInvoiceDetails.nip}}</span></div><div layout="row" flex><span class="detail-info user-details">{{$ctrl.onInvoiceDetails.street}}</span></div><div layout="row" flex><span class="detail-info user-details">{{$ctrl.onInvoiceDetails.city}}</span></div><div ng-if="$ctrl.isRomania" layout="row" flex><span class="detail-info user-details">{{$ctrl.onInvoiceDetails.county}}</span></div><div layout="row" flex><span class="detail-info user-details">{{$ctrl.onInvoiceDetails.zip}}</span></div><div ng-if="!$ctrl.isRomania" layout="row" flex><span class="detail-info user-details">{{(\'country.\' + $ctrl.onInvoiceDetails.country.toLowerCase()) | translate}}</span></div></div></div></div>');
$templateCache.put('app/account/payments/payments-list/payments-list.template.html','<md-content layout="column" class="payments-list"><md-divider></md-divider><div layout-margin layout-padding layout="row"><md-card flex flex-xs="100"><md-card-title><md-card-title-text flex layout="row" ng-click="vm.tooglePayments()"><span class="md-headline text-left" flex="50">{{(vm.onCodePayments ? \'payments.table.title.codes\' : \'payments.table.title\') | translate }} </span><span class="md-caption text-right" flex="50" layout="row" layout-align="end end"><span ng-class="{ \'hide\': !vm.showPayments}" data-translate="payments.table.collapse">Zwi\u0144 </span><span ng-class="{ \'hide\': vm.showPayments}" data-translate="payments.table.show">Rozwi\u0144</span></span></md-card-title-text></md-card-title><!-- TABLE --><div class="table-container" ng-class="{ \'hide\': !vm.showPayments}"><div flex="20" flex-xs="100" layout="row" layout-align="start center" layout-padding><span data-translate="global.table.search.show"></span><md-input-container><md-select aria-label="set query limit" ng-model="vm.query.limit" ng-change="vm.getPayments()" layout-align="center center"><md-option ng-value="5"><em>5</em></md-option><md-option ng-value="10"><em>10</em></md-option><md-option ng-value="20"><em>20</em></md-option><md-option ng-value="30"><em>30</em></md-option></md-select></md-input-container><span data-translate="global.table.search.records"></span></div><md-table-container><table md-table md-row-select="vm.options.rowSelection" multiple="{{vm.options.multiSelect}}" ng-model="vm.selected" md-progress="vm.promise"><thead md-head md-order="vm.query.order" md-on-reorder="vm.getPayments"><tr md-row><th md-column><span>#</span></th><th md-column md-order-by="providerTransactionId"><span data-translate="payments.table.transact-name"></span></th><th md-column md-order-by="paymentDate"><span data-translate="payments.table.payment-date"></span></th><th md-column md-order-by="providerStatus"><span data-translate="payments.table.status"></span></th><th md-column md-order-by="type"><span data-translate="payments.table.kind-of"></span></th><th ng-if="vm.onCodePayments" md-column md-order-by="initialAmount"><span data-translate="payments.table.bought-codes"></span></th><th ng-if="!vm.onCodePayments" md-column md-order-by="initialAmount"><span data-translate="payments.table.bought-token"></span></th><th ng-if="!vm.onCodePayments" md-column md-order-by="amountLeft"><span data-translate="payments.table.unused-tokens"></span></th><th ng-if="!vm.onCodePayments" md-column md-order-by="dueDate"><span data-translate="payments.table.expiration-date"></span></th><th ng-if="vm.onCodePayments" md-column md-order-by="dueDate"><span data-translate="payments.table.code-name"></span></th><th ng-if="vm.onCodePayments" md-column><span data-translate="payments.table.code-priority"></span></th><th ng-if="vm.onCodePayments" md-column><span data-translate="payments.table.code-use-date"></span></th><th ng-if="vm.onCodePayments" md-column><span data-translate="payments.table.code-expiry-date"></span></th><th md-column><span></span></th></tr></thead><tbody md-body><tr md-row md-select="payment" md-select-id="payment.providerTransactionId" md-auto-select ng-repeat="payment in vm.payments"><td md-cell>{{($index+1)+((vm.query.page-1)*vm.query.limit)}}</td><td md-cell>{{payment.providerTransactionId}}</td><td md-cell>{{payment.paymentDate }}</td><td md-cell>{{payment.providerStatus}} <span><md-tooltip md-direction="top">{{ payment.providerStatusTooltipKey | translate}}</md-tooltip><i class="material-icons">info</i></span></td><td md-cell>{{payment.userPaymentType}}</td><td md-cell>{{payment.initialAmount | number}}</td><td ng-if="!vm.onCodePayments" md-cell>{{ payment.dueDate ? payment.amountLeft : \'-\'}} <span ng-show="payment.amountLeft>0 && payment.dueDate && payment.dueDate<vm.dateNow" class="expiry-date-info" data-translate="payments.history.list.expiry-date-has-passed"></span></td><td ng-if="!vm.onCodePayments" md-cell>{{payment.dueDate | date: \'yyyy-MM-dd\'}}</td><td ng-if="vm.onCodePayments" md-cell>{{payment.codeName}}</td><td ng-if="vm.onCodePayments" md-cell><i ng-if="payment.codePriority" class="material-icons text-success">check</i> <i ng-if="!payment.codePriority" class="material-icons text-danger">clear</i></td><td ng-if="vm.onCodePayments" md-cell>{{payment.codeUseDate }}</td><td ng-if="vm.onCodePayments" md-cell>{{payment.codeExpiryDate }}</td><td md-cell>{{payment.invoiceNumber}}<md-button aria-label="download invoice" class="md-icon-button m-0" ng-click="vm.downloadInvoice(payment)" ng-if="payment.invoiceNumber"><md-tooltip md-delay="100" md-direction="top">{{\'payments.table.download-invoice\'| translate}}</md-tooltip><i class="material-icons">receipt</i></md-button></td></tr></tbody><tfoot md-foot><tr md-row><td md-cell colspan="9"></td></tr></tfoot></table></md-table-container><div layout="row" layout-align="end center" layout-wrap><div layout="row" layout-align="end center" layout-wrap><paging page="vm.query.page" page-size="vm.query.limit" total="vm.totalPayments" show-prev-next="true" show-first-last="true" paging-action="vm.startPaging(page)"></paging></div><div layout="row" class="go-to" flex-xs="100" layout-align="end center" layout-margin><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to next page" ng-model="vm.query.page" type="number" ng-keyup="vm.goTo()" ng-change="vm.goTo()"></md-input-container></div></div></div><!-- TABLE --></md-card></div></md-content>');
$templateCache.put('app/account/payments/payments-menu/payments-menu.template.html','<md-content class="users settings-menu" layout="row"><md-nav-bar md-no-ink-bar="disableInkBar" md-selected-nav-item="$ctrl.activeTab" nav-bar-aria-label="navigation links"><md-nav-item class="tabs-menu-li-elipsis" name="paymentsSuperadmin" md-nav-sref="payments-superadmin">{{\'payments.table.title\' | translate}}</md-nav-item><md-nav-item class="tabs-menu-li-elipsis" name="paymentsInvoices" md-nav-sref="payments-invoices">{{\'payments.invoices\' | translate}}</md-nav-item></md-nav-bar></md-content>');
$templateCache.put('app/account/payments/payments-superadmin/payments-superadmin.html','<md-content layout="column" class="payments-list site-container"><payments-menu active-tab="vm.activeTab"></payments-menu><md-divider></md-divider><div layout-margin layout-padding layout="row"><md-card flex flex-xs="100"><md-card-title><md-card-title-text flex layout="row"><span class="md-headline text-left" flex="50" data-translate="payments.table.title"></span></md-card-title-text></md-card-title><div class="table-container"><payments-superadmin-search on-clear="vm.clear" on-get-payments="vm.searchPayments" on-query-request="vm.queryRequest" on-search-request="vm.searchRequest" simple-search="vm.simpleSearch"></payments-superadmin-search><md-table-container><table md-table md-progress="vm.promise"><thead md-head md-order="vm.queryRequest.order" md-on-reorder="vm.getPayments"><tr md-row><th md-column><span>#</span></th><th md-column md-order-by="user.userName"><span data-translate="payments.table.user"></span></th><th md-column md-order-by="providerTransactionId"><span data-translate="payments.table.transact-name"></span></th><th md-column md-order-by="paymentDate"><span data-translate="payments.table.payment-date"></span></th><th md-column md-order-by="providerStatus"><span data-translate="payments.table.status"></span></th><th md-column md-order-by="type"><span data-translate="payments.table.kind-of"></span></th><th md-column md-order-by="initialAmount" class="narrow"><span data-translate="payments.table.bought-token"></span></th><th md-column md-order-by="amountLeft" class="narrow"><span data-translate="payments.table.unused-tokens"></span></th><th md-column md-order-by="realAmount" class="narrow"><span data-translate="payments.table.value"></span></th><th md-column md-order-by="dueDate"><span data-translate="payments.table.expiration-date"></span></th><th md-column><span data-translate="payments.metric.invoice"></span></th><th md-column><span></span></th><th md-column class="table-actions"><span data-translate="global.table.actions"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="payment in vm.payments"><td md-cell>{{($index + 1) + ((vm.queryRequest.page - 1) * vm.queryRequest.limit)}}</td><td md-cell>{{payment.userNameAndEmail}}</td><td md-cell>{{payment.providerTransactionId}}</td><td md-cell>{{payment.paymentDate | date: \'yyyy-MM-dd HH:mm\' }}</td><td md-cell>{{\'payments.\' + payment.providerStatus | translate}}</td><td md-cell>{{\'payments.\' + payment.userPaymentType | translate}}</td><td md-cell>{{payment.initialAmount | number}}</td><td md-cell>{{payment.amountLeft | number}} <span ng-show="payment.amountLeft > 0 && payment.dueDate < vm.dateNow" class="expiry-date-info" data-translate="payments.history.list.expiry-date-has-passed"></span></td><td md-cell>{{payment.value}}</td><td md-cell>{{payment.dueDate | date: \'yyyy-MM-dd\'}}</td><td md-cell>{{payment.invoiceNumber}}<md-button aria-label="download invoice" class="md-icon-button m-0" ng-click="vm.downloadInvoice(payment.invoiceNumber)" ng-if="payment.invoiceNumber && payment.invoiceStatus == vm.invoiceStatuses.INVOICE_STATUS_ISSUED.id"><md-tooltip md-delay="100" md-direction="top">{{\'payments.table.download-invoice\'| translate}}</md-tooltip><i class="material-icons">receipt</i></md-button></td><td md-cell><md-menu-bar flex layout="row" ng-if="payment.amountLeft > 0 || (!payment.invoiceNumber && payment.providerStatus == vm.paymentStatuses.PAYMENT_STATUS_COMPLETED.code)"><md-menu><md-button aria-label="open" class="md-icon-button" ng-click="$mdMenu.open(); $event.stopPropagation();"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item ng-if="payment.providerStatus == vm.paymentStatuses.PAYMENT_STATUS_COMPLETED.code && !payment.invoiceNumber"><md-button id="createDraftInvoiceFromPayment{{$index}}" aria-label="createDraftInvoiceFromPayment" ng-click="vm.createDraftInvoiceFromPayment(payment)" data-translate="payments.table.menu.create-draft-invoice"></md-button></md-menu-item><md-menu-item ng-if="payment.amountLeft > 0"><md-button id="markAsCanceled{{$index}}" aria-label="markAsCanceled" ng-click="vm.markAsCanceled(payment)" data-translate="payments.table.menu.mark-as-canceled"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoaderActive"></md-progress-circular></div></md-table-container><div flex><div layout="row" layout-align="end center" layout-wrap><paging page="vm.queryRequest.page" page-size="vm.queryRequest.limit" paging-action="vm.pagingAction(page)" show-first-last="true" show-prev-next="true" total="vm.totalPayments"></paging><div layout="row" class="go-to" flex-xs="100" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to next page" ng-model="vm.queryRequest.page" type="number" ng-keyup="vm.getPayments()" ng-change="vm.getPayments()"></md-input-container></div></div></div></div></md-card></div></md-content>');
$templateCache.put('app/account/payments/payments-superadmin-search/payments-superadmin-search.template.html','<form name="formSearchClients"><div layout-padding><div layout="row" layout-xs="column"><select-page-size query-request="$ctrl.onQueryRequest" on-value-chosen="$ctrl.getPayments()" flex="30" flex-xs="100" layout="row" layout-align="start center"></select-page-size><div flex="70" flex-sm="70" flex-xs="100" layout="row" layout-align="end center" layout-sm="column"><md-input-container class="md-block" flex="70" flex-xs="100" layout-align="end center" md-no-float ng-if="$ctrl.simpleSearch"><input ng-change="$ctrl.getPayments()" ng-model="$ctrl.onSearchRequest.simpleSearch" ng-model-options="{ debounce: $ctrl.simpleSearchDelay }" placeholder="{{\'global.search.title\'| translate}}"></md-input-container><div flex="30" flex-xs="100" layout="column" layout-align="end center"><md-button aria-label="open" class="search-buttons" data-translate="global.button.search.advanced" id="advancedSearchBtn" ng-class="{ \'hide\': !$ctrl.simpleSearch}" ng-click="$ctrl.toggleSearch()"></md-button><md-button aria-label="hide" class="search-buttons" data-translate="global.button.search.simple" ng-class="{ \'hide\': $ctrl.simpleSearch}" ng-click="$ctrl.toggleSearch()"></md-button></div></div></div><div layout="row" layout-xs="column" ng-class="{ \'hide\': $ctrl.simpleSearch}"><md-input-container class="md-block" flex="33" flex-xs="100"><input ng-model="$ctrl.onSearchRequest.search.userEmail" placeholder="{{\'payments.table.user.email\'| translate}}"></md-input-container><md-input-container class="md-block" flex="33" flex-xs="100"><input ng-model="$ctrl.onSearchRequest.search.userName" placeholder="{{\'payments.table.user.name\'| translate}}"></md-input-container><md-input-container class="md-block" flex="33" flex-xs="100"><input ng-model="$ctrl.onSearchRequest.search.providerTransactionId" placeholder="{{\'payments.table.transact-name\'| translate}}"></md-input-container></div><div layout="row" layout-xs="column" ng-class="{ \'hide\': $ctrl.simpleSearch}"><md-input-container flex="25" flex-sm="50" flex-xs="50" layout-sm="column"><label data-translate="payments.table.transaction.date.from"></label><md-datepicker input-date name="transactionDateFrom" ng-change="$ctrl.fixDate($ctrl.onSearchRequest.search.transactionDateFrom, \'transactionDateFrom\', $ctrl)" ng-model="$ctrl.onSearchRequest.search.transactionDateFrom"></md-datepicker><md-tooltip md-delay="100" md-direction="top">{{\'global.messages.info.dateformat\'| translate}}</md-tooltip></md-input-container><md-input-container flex="25" flex-sm="50" flex-xs="50" layout-sm="column"><label data-translate="payments.table.transaction.date.to"></label><md-datepicker input-date name="transactionDateTo" ng-change="$ctrl.fixDate($ctrl.onSearchRequest.search.transactionDateTo, \'transactionDateTo\', $ctrl)" ng-model="$ctrl.onSearchRequest.search.transactionDateTo"></md-datepicker><md-tooltip md-delay="100" md-direction="top">{{\'global.messages.info.dateformat\'| translate}}</md-tooltip></md-input-container><md-input-container class="md-block" flex="25" flex-xs="50"><label data-translate="payments.table.status"></label><md-select ng-change="$ctrl.getPayments()" placeholder="{{\'payments.table.status\' | translate}}" ng-model="$ctrl.onSearchRequest.search.providerStatus" layout-align="center center"><md-option ng-value="" ng-if="$ctrl.onSearchRequest.search.providerStatus"><em>{{\'global.button.clear\'| translate}}: {{\'payments.table.status\' | translate}}</em></md-option><md-option ng-value="val.id" ng-repeat="val in $ctrl.paymentStatuses.arrayOfValues"><em>{{val.langKey | translate}}</em></md-option></md-select></md-input-container><md-input-container class="md-block" flex="25" flex-xs="50"><label data-translate="payments.table.payment.type"></label><md-select ng-change="$ctrl.getPayments()" placeholder="{{\'payments.table.payment.type\' | translate}}" ng-model="$ctrl.onSearchRequest.search.transactionType" layout-align="center center"><md-option ng-value="" ng-if="$ctrl.onSearchRequest.search.transactionType"><em>{{\'global.button.clear\'| translate}}: {{\'payments.table.payment.type\' | translate}}</em></md-option><md-option ng-value="val.id" ng-repeat="val in $ctrl.paymentTypes.arrayOfValues"><em>{{val.langKey | translate}}</em></md-option></md-select></md-input-container></div><div layout="row" layout-align="start" layout-padding layout-xs="column" ng-class="{ \'hide\': $ctrl.simpleSearch}"><md-button aria-label="clear" class="md-raised search-buttons" data-translate="global.button.clear.search" ng-click="$ctrl.clear()"></md-button><md-button aria-label="search" class="md-raised md-primary search-buttons" data-translate="global.button.search" ng-click="$ctrl.getPayments()" type="submit"></md-button></div></div></form>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div layout="column" flex class="unlogged login"><md-content layout="row"><form novalidate class="form" name="form" autocomplete="off"><div layout="row" layout-xs="column"><div class="login-logo" layout-xs="row" flex="50" flex-xs="100" layout-align="end start" layout-align-xs="center center" flex-gt-sm></div><div layout-xs="row" flex-xs="100" flex="50" layout-align="end start" layout-align-xs="center center" layout-padding class="choose-lang" flex-gt-sm><lang-select></lang-select></div></div><div flex="100" layout="column"><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch><md-card-title><md-card-title-text layout="row" layout-xs="column" layout-align="center center"><span class="md-headline login-header" data-translate="reset.finish.messages.info"></span></md-card-title-text></md-card-title><md-card-content class="md-padding"><div layout-margin layout-align="center center" ng-show="vm.keyMissing"><div data-translate="reset.finish.messages.keymissing" translate-compile></div></div><div layout-margin layout-align="center center" ng-show="vm.error"><div data-translate="reset.finish.messages.error" translate-compile></div></div><div layout-margin layout-align="center center" ng-show="vm.success"><div data-translate="reset.finish.messages.success" translate-compile></div></div><div layout-margin layout-align="center center" ng-show="vm.doNotMatch"><div data-translate="global.messages.error.dontmatch" translate-compile></div></div><div ng-hide="vm.keyMissing || vm.success" layout-margin layout-align="center center"><md-input-container class="md-block"><input ng-model="vm.resetAccount.password" name="password" ng-attr-type="{{ vm.showPassword ? \'text\' : \'password\' }}" ng-minlength="8" ng-pattern="vm.passwordPattern" placeholder="{{!vm.resetAccount.password ? \'global.form.password.placeholder\' : \'reset.finish.form.password\' | translate}}" autocomplete="off" required> <span class="password-eye" ng-click="vm.toggleShowPassword()"><i class="material-icons" ng-class="{\'visibility\': !vm.showPassword, \'visibility_off\': vm.showPassword}">{{vm.showPassword ? \'visibility\' : \'visibility_off\'}}</i></span><div ng-show="form.password.$error.required" class="md-input-messages-animation ng-active" data-translate="global.form.password.required"></div><div ng-show="form.password.$error.pattern" class="md-input-messages-animation ng-active" data-translate="global.form.password.pattern"></div><div ng-show="form.password.$error.minlength" class="md-input-messages-animation ng-active" data-translate="global.form.password.minlength"></div></md-input-container><md-input-container class="md-block"><label data-translate="reset.finish.form.retype-password"></label><input ng-model="vm.resetAccount.confirmedPassword" name="confirmedPassword" ng-minlength="8" ng-attr-type="{{ vm.showPassword ? \'text\' : \'password\' }}" ng-pattern="vm.passwordPattern" placeholder="{{!vm.resetAccount.confirmedPassword ? \'global.form.confirmpassword.placeholder\' : \'reset.finish.form.retype-password\' | translate}}" required ng-disabled="!vm.resetAccount.password"> <span class="password-eye" ng-click="vm.toggleShowPassword()"><i class="material-icons" ng-class="{\'visibility\': !vm.showPassword, \'visibility_off\': vm.showPassword}">{{vm.showPassword ? \'visibility\' : \'visibility_off\'}}</i></span><div ng-show="form.confirmedPassword.$error.required" class="md-input-messages-animation ng-active" data-translate="global.form.confirmed-password.required"></div><div ng-show="form.confirmedPassword.$error.pattern" class="md-input-messages-animation ng-active" data-translate="global.form.password.pattern"></div><div ng-show="form.confirmedPassword.$error.minlength" class="md-input-messages-animation ng-active" data-translate="global.form.password.minlength"></div></md-input-container></div><div class="md-padding" ng-hide="vm.keyMissing || vm.success"><md-button layout="column" layout-fill class="md-raised md-primary" ng-disabled="form.$invalid" ng-click="vm.finishReset()" data-translate="reset.request.form.button"></md-button></div></md-card-content><md-divider></md-divider><md-card-content><div class="md-padding" layout-margin><md-button layout="column" layout-fill class="md-raised" ui-sref="login" data-translate="global.button.login"></md-button></div></md-card-content></md-card></div></form></md-content></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div layout="column" flex class="unlogged login"><md-content layout="row"><form novalidate class="form" name="form" autocomplete="off"><div layout="row" layout-xs="column"><div class="login-logo" layout-xs="row" flex="50" flex-xs="100" layout-align="end start" layout-align-xs="center center" flex-gt-sm></div><div layout-xs="row" flex-xs="100" flex="50" layout-align="end start" layout-align-xs="center center" layout-padding class="choose-lang" flex-gt-sm><lang-select></lang-select></div></div><div flex="100" layout="column"><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch><md-card-title><md-card-title-text layout="row" layout-xs="column" layout-align="center center"><span class="md-headline login-header" data-translate="reset.request.title"></span></md-card-title-text></md-card-title><md-card-content class="md-padding"><div layout-margin layout-align="center center" ng-show="vm.success"><div data-translate="reset.request.messages.success" translate-compile></div></div><div layout-margin layout-align="center center" ng-show="vm.error"><div data-translate="{{vm.errorKey}}" translate-compile></div></div><div layout-margin layout-align="center center" ng-hide="vm.success"><md-input-container layout="row" class="md-block" flex-gt-sm><label data-translate="global.form.email"></label><input ng-model="vm.resetAccount.email" name="email" id="email" ng-keyup="form.$valid && $event.keyCode == 13 && vm.login($event)" type="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-pattern="/^.+@.+\\..+$/" autocomplete="off" required><div ng-show="form.email.$error.required" class="md-input-messages-animation ng-active" data-translate="global.form.email.required"></div><div ng-show="form.email.$error.pattern" class="md-input-messages-animation ng-active" data-translate="global.form.email.pattern"></div></md-input-container></div><div class="md-padding" ng-hide="vm.success"><md-button layout="column" aria-label="reset" layout-fill class="md-raised md-primary" ng-disabled="form.$invalid" ng-click="vm.requestReset()" data-translate="reset.request.form.button"></md-button></div></md-card-content><md-divider></md-divider><md-card-content><div class="md-padding" layout-margin><md-button aria-label="login" layout="column" layout-fill class="md-raised" ui-sref="login" data-translate="global.button.login"></md-button></div></md-card-content></md-card></div></form></md-content></div>');
$templateCache.put('app/account/settings/admin-configuration/admin-configuration.html','<div layout="column" class="site-container"><settings-menu active-tab="vm.activeTab"></settings-menu><md-content layout="row"><form name="form" flex is-loading="vm.isLoading"><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoading"></md-progress-circular></div><md-card><div layout="row" layout-align="end center" layout-padding><md-button aria-label="save button" id="save" class="md-raised md-primary" data-translate="global.button.save" ng-click="vm.save()" ng-disabled="form.$invalid || vm.isSaving"></md-button></div></md-card><md-card><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.report-settings.header"></h3></md-card-title-text><div layout="row" layout-padding><md-input-container flex="50" flex-xs="100"><input type="number" name="clieSfWordCountExt" min="0" placeholder="{{!vm.model.configuration.similarityReportSettings.clieSfWordCountExt ? \'client.report.settings.form.word-count.placeholder\' : \'client.report.settings.form.word-count\' | translate}}" ng-model="vm.model.configuration.similarityReportSettings.clieSfWordCountExt" ng-required="true"><plagiat-ng-messages form-element="form.clieSfWordCountExt"></plagiat-ng-messages></md-input-container><md-input-container flex="50" flex-xs="100"><input type="number" name="clieForeignAlphabetAlertLimit" min="0" placeholder="{{!vm.model.configuration.similarityReportSettings.clieForeignAlphabetAlertLimit ? \'client.report.settings.form.foreign-alphabet-alert-limit.placeholder\' : \'client.report.settings.form.foreign-alphabet-alert-limit\' | translate}}" ng-model="vm.model.configuration.similarityReportSettings.clieForeignAlphabetAlertLimit" ng-required="true"><plagiat-ng-messages form-element="form.clieForeignAlphabetAlertLimit"></plagiat-ng-messages></md-input-container></div><div layout="row" layout-padding><md-input-container flex="33" flex-xs="100"><!-- pattern accepts from 0 to 1 --> <input name="aiDetectionThreshold" ng-required="false" ng-pattern="/^(0(\\.\\d+)?|1(\\.0+)?)$/" ng-model="vm.model.configuration.aiDetectionSettings.aiDetectionThreshold" placeholder="{{\'client.edit.configuration.ai-detection.ai-detection-threshold\' | translate}}"><plagiat-ng-messages form-element="form.aiDetectionThreshold"></plagiat-ng-messages></md-input-container><md-input-container flex="33" flex-xs="100" class="mt-4"><md-checkbox name="ai-detection-hide-slider" class="md-primary" aria-label="client.edit.configuration.ai-detection.ai-detection-hide-slider" ng-model="vm.model.configuration.aiDetectionSettings.aiDetectionHideSlider"><span data-translate="client.edit.configuration.ai-detection.ai-detection-hide-slider"></span></md-checkbox></md-input-container><md-input-container flex="33" flex-xs="100" class="mt-4"><md-checkbox name="ai-detection-exclude-fragments" class="md-primary" aria-label="client.edit.configuration.ai-detection.ai-detection-exclude-fragments" ng-model="vm.model.configuration.aiDetectionSettings.aiDetectionExcludeFragments"><span data-translate="client.edit.configuration.ai-detection.ai-detection-exclude-fragments"></span></md-checkbox></md-input-container></div><div layout="row" layout-padding layout-wrap><md-input-container flex="33" flex-xs="100" ng-repeat="value in vm.configuration.reportSettings" ng-if="vm.availableInstance(value.model)"><md-checkbox id="{{\'reportSetting-id\' + value.label}}" name="{{\'reportSetting-name\' + value.label}}" class="md-primary" aria-label="{{\'reportSetting-aria-label\' + value.label}}" ng-model="vm.model.configuration.reportSettings[value.model]" ng-disabled="value.disabled"><span data-translate="{{\'client.edit.configuration.report-settings.\' + value.label}}"></span></md-input-container></div><div ng-if="!vm.model.configuration.reportSettings.report2020Disabled" layout="row" layout-padding><md-input-container flex="50" ng-if="!vm.model.configuration.reportSettings.report2020Disabled"><input name="report2020ExpirationHours" ng-required="false" ng-pattern="/^[0-9]+$/" ng-model="vm.model.configuration.reportSettings.report2020ExpirationHours" placeholder="{{\'client.edit.configuration.report-settings.report-2020-expiration-hours\' | translate}}"><plagiat-ng-messages form-element="form.report2020ExpirationHours"></plagiat-ng-messages></md-input-container></div><div ng-if="vm.model.configuration.reportSettings.warningThresholds" layout="row" layout-padding><md-input-container flex="50"><input name="warningThreshold1" ng-required="true" type="number" ng-model="vm.model.configuration.similarityReportSettings.warningThreshold1" placeholder="{{\'client.report.settings.form.warning-threshold-1\' | translate}}"><plagiat-ng-messages form-element="form.warningThreshold1"></plagiat-ng-messages></md-input-container><md-input-container flex="50"><input name="warningThreshold2" ng-required="true" type="number" ng-model="vm.model.configuration.similarityReportSettings.warningThreshold2" placeholder="{{\'client.report.settings.form.warning-threshold-2\' | translate}}"><plagiat-ng-messages form-element="form.warningThreshold2"></plagiat-ng-messages></md-input-container></div></md-card-content></md-card><md-card><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.add-to-database.header"></h3></md-card-title-text><md-radio-group ng-model="vm.model.configuration.addToDatabase" layout="row" layout-padding layout-wrap><md-radio-button flex="20" flex-xs="50" class="md-primary" aria-label="{{\'addToDatabase\' +  obj.value}}" ng-repeat="obj in vm.configuration.addToDatabase" ng-value="obj.value"><span data-translate="{{\'client.edit.configuration.add-to-database.\' + obj.value}}"></span></md-radio-button></md-radio-group><div ng-if="vm.model.configuration.addToDatabase === \'delayed\'" layout="row" layout-padding><md-input-container flex="50" flex-xs="100"><input name="addToDatabaseDays" ng-required="false" ng-pattern="/^[0-9]+$/" ng-model="vm.model.configuration.addToDatabaseDays" placeholder="{{\'client.edit.configuration.add-to-database.days\' | translate}}"><plagiat-ng-messages form-element="form.addToDatabaseDays"></plagiat-ng-messages></md-input-container></div><div layout="row" layout-padding layout-wrap><div flex="33" flex-xs="100" layout="row" ng-repeat="value in vm.configuration.addToDatabaseSettings"><md-input-container flex><md-checkbox id="{{\'addToDatabaseSettings-id\' + value.label}}" name="{{\'addToDatabaseSettings-name\' + value.label}}" class="md-primary" aria-label="{{\'addToDatabaseSettings-aria\'+ value.label}}" ng-model="vm.model.configuration.addToDatabaseSettings[value.model]"><span data-translate="{{\'client.edit.configuration.database-settings.\' + value.label}}"></span></md-input-container></div></div></md-card-content></md-card><md-card ng-if="vm.available(\'userSettingsCard\')"><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.user-settings.header"></h3></md-card-title-text><div layout="row" layout-padding layout-wrap><md-input-container flex="33" flex-xs="100" ng-repeat="value in vm.configuration.userSettings" ng-if="vm.available(value.model)"><md-checkbox name="{{\'user-settings\' + value.label}}" class="md-primary" aria-label="{{\'user-settings\'+ value.label}}" ng-model="vm.model.configuration.userSettings[value.model]"><span data-translate="{{\'client.edit.configuration.user-settings.\' + value.label}}"></span></md-input-container></div></md-card-content></md-card><md-card><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.other-settings.header"></h3></md-card-title-text><div layout="row" layout-padding layout-wrap><div flex="33" flex-xs="100" layout="row" ng-repeat="value in vm.configuration.otherSettings" ng-if="vm.available(value.model)"><md-input-container flex><md-checkbox id="{{\'otherSetting-id\' + value.label}}" name="{{\'otherSetting-name\' + value.label}}" class="md-primary" aria-label="{{\'otherSetting-aria\'+ value.label}}" ng-model="vm.model.configuration.otherSettings[value.model]"><span data-translate="{{\'client.edit.configuration.other-settings.\' + value.label}}"></span></md-input-container><md-input-container flex ng-if="vm.model.configuration.otherSettings[value.model] && value.type == \'checkbox+list\'"><md-select id="documentKindSelect" aria-label="docu kinds" ng-model="vm.model.configuration.otherSettings[value.model+\'Value\']" ng-required="vm.model.configuration.otherSettings[value.model]"><md-option id="idOptionDocuKind{{$index}}" ng-value="val" ng-repeat="val in value.valuesForList">{{val}}</md-option></md-select></md-input-container></div><md-chips flex="100" ng-if="vm.model.configuration.otherSettings.reservedEmails" name="reserved-emails-setting.domain-list" aria-label="reserved-emails-setting.domain-list" placeholder="{{\'client.edit.configuration.other-settings.reserved-emails.domain-list.placeholder\' | translate}}" ng-model="vm.model.configuration.otherSettings.reservedEmailsDomainList" md-removable="true" md-add-on-blur="true"><md-chip-template>{{$chip}}</md-chip-template></md-chips><md-input-container flex="100" ng-if="vm.model.configuration.otherSettings.acceptRegulationsEnabled"><input name="regulationsUrl" ng-model="vm.model.configuration.otherSettings.regulationsUrl" ng-required="true" placeholder="{{\'client.edit.configuration.other-settings.regulations-url\' | translate}}"><plagiat-ng-messages form-element="form.regulationsUrl"></plagiat-ng-messages></md-input-container><md-input-container flex="100" ng-if="vm.model.configuration.otherSettings.assignmentsEnabled"><input name="maxAssignmentCorrections" ng-required="true" ng-pattern="/^[0-9]+$/" ng-model="vm.model.configuration.otherSettings.maxAssignmentCorrections" placeholder="{{\'client.edit.configuration.other-settings.max-assignment-corrections\' | translate}}"><plagiat-ng-messages form-element="form.maxAssignmentCorrections"></plagiat-ng-messages></md-input-container></div></md-card-content></md-card><md-card ng-if="vm.available(\'jsaOrppdCard\')"><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.jsa-orppd-settings.header"></h3></md-card-title-text><div layout="row" layout-padding layout-wrap><div flex="33" flex-xs="100" layout="row" ng-repeat="value in vm.configuration.jsaOrppdSettings"><md-input-container flex><md-checkbox id="{{\'jsaOrppdSettings-id\' + value.label}}" name="{{\'jsaOrppdSettings-name\' + value.label}}" class="md-primary" aria-label="{{\'jsaOrppdSettings-aria\'+ value.label}}" ng-model="vm.model.configuration.jsaOrppdSettings[value.model]"><span data-translate="{{\'client.edit.configuration.jsa-orppd-settings.\' + value.label}}"></span></md-input-container></div></div></md-card-content></md-card><md-card ng-if="vm.model.configuration.otherSettings.permUserUploadSupport"><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.upload-permissions.header"></h3></md-card-title-text><div layout="row" layout-padding layout-wrap><md-input-container flex="33" ng-repeat="value in vm.configuration.uploadPermissions"><md-checkbox id="{{\'uploadPermission-id\' + value.label}}" name="{{\'uploadPermission-name\' + value.label}}" class="md-primary" aria-label="{{\'uploadPermission \'+ value.label}}" ng-model="vm.model.configuration.uploadPermissions[value.model]"><span data-translate="{{\'client.edit.configuration.upload-permission.\' + value.label}}"></span></md-input-container></div></md-card-content></md-card><md-card><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.rare-settings.header"></h3></md-card-title-text><div layout="row" layout-padding layout-wrap><div flex="33" flex-xs="100" layout="row" ng-repeat="value in vm.configuration.rareSettings"><md-input-container flex><md-checkbox id="{{\'rareSetting-id\' + value.label}}" name="{{\'rareSetting-name\' + value.label}}" class="md-primary" aria-label="{{\'rareSetting-aria\'+ value.label}}" ng-model="vm.model.configuration.rareSettings[value.model]"><span data-translate="{{\'client.edit.configuration.other-settings.\' + value.label}}"></span></md-input-container><md-input-container flex ng-if="vm.model.configuration.otherSettings[value.model] && value.type == \'checkbox+list\'"><md-select id="documentKindSelect" aria-label="docu kinds" ng-model="vm.model.configuration.otherSettings[value.model+\'Value\']" ng-required="vm.model.configuration.otherSettings[value.model]"><md-option id="idOptionDocuKind{{$index}}" ng-value="val" ng-repeat="val in value.valuesForList">{{val}}</md-option></md-select></md-input-container></div><md-chips flex="100" ng-if="vm.model.configuration.otherSettings.reservedEmails" name="reserved-emails-setting.domain-list" aria-label="reserved-emails-setting.domain-list" placeholder="{{\'client.edit.configuration.other-settings.reserved-emails.domain-list.placeholder\' | translate}}" ng-model="vm.model.configuration.otherSettings.reservedEmailsDomainList" md-removable="true" md-add-on-blur="true"><md-chip-template>{{$chip}}</md-chip-template></md-chips><md-input-container flex="100" ng-if="vm.model.configuration.otherSettings.acceptRegulationsEnabled"><input name="regulationsUrl" ng-model="vm.model.configuration.otherSettings.regulationsUrl" ng-required="true" placeholder="{{\'client.edit.configuration.other-settings.regulations-url\' | translate}}"><plagiat-ng-messages form-element="form.regulationsUrl"></plagiat-ng-messages></md-input-container><md-input-container flex="100" ng-if="vm.model.configuration.otherSettings.passwordChange"><input name="passwordChangePeriod" ng-model="vm.model.configuration.otherSettings.passwordChangePeriod" ng-required="true" ng-pattern="/^[0-9]+$/" placeholder="{{\'client.edit.configuration.other-settings.password-change-period\' | translate}}"><plagiat-ng-messages form-element="form.passwordChangePeriod"></plagiat-ng-messages></md-input-container></div></md-card-content></md-card><md-card><div layout="row" layout-align="end center" layout-padding><md-button aria-label="save button" id="save" class="md-raised md-primary" data-translate="global.button.save" ng-click="vm.save()" ng-disabled="form.$invalid || vm.isSaving"></md-button></div></md-card></form></md-content></div>');
$templateCache.put('app/account/settings/client-groups/client-group-add.template.html','<div layout="column" class="site-container"><md-content class="users" layout="row"><div layout-align="center center"><header class="header"><h5 data-translate="client.group.edit.title"></h5></header></div><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div></md-content><md-content layout="row" layout-padding><form name="form" flex><md-card flex layout-padding><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="50" flex-xs="100"><input name="clientGroupName" ng-model="vm.obj.name" ng-required="true" placeholder="{{\'client.group.table.header.client-group.name\' | translate}}"></md-input-container></div></md-card><div layout="row" flex layout-align="end center"><md-button id="cancelButton" aria-label="client-group-add-cancel" ui-sref="client-group-list" data-translate="global.form.button.cancel"></md-button><md-button id="saveButton" ng-click="vm.saveOrUpdate(vm.obj)" aria-label="save clientGroup" class="md-raised md-primary button-waiting" ng-disabled="form.$invalid"><span data-translate="global.form.button.save"></span></md-button></div></form></md-content></div>');
$templateCache.put('app/account/settings/client-groups/client-group-list.template.html','<div layout="column" class="site-container"><settings-menu active-tab="vm.activeTab"></settings-menu><div layout-margin layout-wrap><div layout="row" flex layout-align="end center"><md-button id="addClientGroupButton" aria-label="client-group-add" ui-sref="client-group-add" class="md-raised md-primary button-waiting" data-translate="global.button.add"></md-button></div></div><div class="table-container" flex><md-content layout="row" layout-margin><md-card flex><div layout="row" layout-padding layout-wrap><select-page-size flex="25" layout="row" layout-align="start center" query-request="vm.queryRequest" on-value-chosen="vm.loadData()"></select-page-size><div flex="70" flex-sm="70" flex-xs="100" layout="row" layout-align="end center" layout-sm="column"><md-input-container class="md-block" flex="70" flex-xs="100" layout-align="end center" md-no-float><input ng-change="vm.loadData()" ng-model="vm.searchRequest.simpleSearch" ng-model-options="{ debounce: vm.simpleSearchDelay }" placeholder="{{\'global.search.title\'| translate}}"></md-input-container></div></div><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span>#</span></th><th md-column><span data-translate="client.group.table.header.client-group.name"></span></th><th md-column><span data-translate="global.table.actions"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="row in vm.clientGroups track by $index"><td md-cell>{{($index + 1) + ((vm.queryRequest.page - 1) * vm.queryRequest.limit)}}</td><td md-cell>{{row.name}}</td><td md-cell>{{row.fileName}}</td><td md-cell><md-menu-bar flex layout="row"><md-menu><md-button aria-label="open" class="md-icon-button" ng-click="$mdMenu.open(); $event.stopPropagation();"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item><md-button id="tableOptionEdit{{$index}}" aria-label="edit clientGroup" ui-sref="client-group-add({id: row.id})" data-translate="global.table.menu.edit"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div></md-table-container><div flex layout="row" layout-align="end center" layout-wrap><paging page="vm.clientGroupPage.number" page-size="vm.clientGroupPage.size" paging-action="vm.loadPage(page)" show-first-last="true" show-prev-next="true" total="vm.clientGroupPage.totalElements"></paging><div class="go-to" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to page" ng-model="goToPageInputModel" min="1" max="vm.clientGroupPage.totalPages" type="number" ng-keyup="$event.keyCode === vm.keyCodeEnter && vm.loadPage(goToPageInputModel)"></md-input-container></div></div></md-card></md-content></div></div>');
$templateCache.put('app/account/settings/client-logo/client-logo.html','<div class="site-container"><settings-menu active-tab="vm.activeTab"></settings-menu><md-card><md-card-title><md-card-title-text class="text-center"><span class="md-headline" data-translate="client-logo.title"></span></md-card-title-text></md-card-title><md-card-content><div layout="column" flex-gt-lg="50" flex-gt-md="60" flex-offset-gt-lg="25" flex-offset-gt-md="20"><md-progress-linear ng-if="vm.isLoading" md-mode="indeterminate"></md-progress-linear><div layout="row" layout-xs="column" layout-wrap layout-padding><div flex layout="column" layout-align="center center" flex-xs="100" class="text-center"><img src="{{\'data:\' + vm.clientLogo.imageType + \';base64,\' + vm.clientLogo.imageData}}" style="max-height: 10rem" ng-if="vm.clientLogo" alt="client logo"><md-button ng-if="vm.clientLogo" id="remove-client-logo" ng-click="vm.removeClientLogo()" class="md-raised md-primary" data-translate="global.button.remove"></md-button><p ng-if="!vm.clientLogo && !vm.isLoading" class="text text-danger" data-translate="client-logo.no-logo-found"></p></div><div flex flex-xs="100"><form class="dragbox dragbox-big has-advanced-upload w-100 m-0" name="form" novalidate role="form" show-validation><div class="dragbox-input"><div class="button dragbox-input" name="files" ngf-max-size="1MB" ngf-select="vm.addFile($files)" ngf-drop="vm.addFile($files)" ngf-accept="[\'.jpg\', \'.png\', \'.jpeg\']"><div class="dragbox-icon-cloud"><i class="material-icons">backup</i></div><label class="overflow-hidden" data-translate="{{vm.clientLogo ? \'client-logo.change-logo\' : \'client-logo.new-logo\'}}"></label></div></div></form></div></div></div></md-card-content></md-card></div>');
$templateCache.put('app/account/settings/document-kinds/document-kinds-list.template.html','<div layout="column" class="site-container"><settings-menu active-tab="vm.activeTab"></settings-menu><div class="table-container" flex><md-content layout="row" layout-margin><md-card flex><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span>#</span></th><th md-column><span data-translate="client.edit.document-kinds.enabled"></span></th><th md-column><span data-translate="client.edit.document-kinds.label"></span></th><th md-column><span data-translate="client.edit.document-kinds.name"></span></th><th md-column ng-if="vm.dueDateEnabled"><span data-translate="client.edit.document-kinds.due-date"></span></th><th md-column ng-if="vm.warningThresholdsEnabled"><div><span data-translate="client.report.settings.form.warning-threshold-1"></span></div><div><span data-translate="client.edit.document-kinds.warning-threshold-default"></span> <span>{{vm.warningThreshold1}}</span></div></th><th md-column ng-if="vm.warningThresholdsEnabled"><div><span data-translate="client.report.settings.form.warning-threshold-2"></span></div><div><span data-translate="client.edit.document-kinds.warning-threshold-default"></span> <span>{{vm.warningThreshold2}}</span></div></th><th md-column ng-if="vm.warningThresholdsEnabled"><span data-translate="global.table.actions"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="row in vm.kinds track by $index"><td md-cell>{{ ($index + 1) }}</td><td md-cell><md-checkbox name="{{\'docu_kind_\'+ row.documentKindId}}" class="md-primary" aria-label="{{\'docu_kind_\'+ row.documentKindId}}" ng-model="row.enabled"></td><td md-cell>{{row.label}}</td><td md-cell>{{row.labelTranslated}}</td><td md-cell ng-if="vm.dueDateEnabled"><div class="due-date" ng-class="{\'editing\': row.documentKindId==vm.dueDateId, \'reading\': row.documentKindId!=vm.dueDateId}" ng-click="vm.editDueDates(row, $index, $event)"><md-input-container class="md-block input-block"><span class="text-block with-content" ng-show="row.dueDate && row.documentKindId !== vm.dueDateId">{{row.dueDate | date: \'yyyy-MM-dd\'}}</span><md-datepicker input-date aria-label="dueDate{{$index}}" ng-model="vm.dueDates[$index]" ng-show="row.documentKindId === vm.dueDateId"></md-datepicker><md-icon class="icon-edit" ng-bind="\'create\'" ng-show="row.documentKindId !== vm.dueDateId" style="cursor: pointer; left: 70px; top: 2px"></md-icon><md-icon class="icon-save" ng-click="vm.saveDueDates(row, $index)" ng-bind="\'check\'" ng-show="row.documentKindId === vm.dueDateId" style="cursor: pointer; left: 175px; top: 23px"></md-icon><md-icon ng-click="vm.cancelEditDueDates()" class="icon-cancel" ng-bind="\'close\'" ng-show="row.documentKindId === vm.dueDateId" style="cursor: pointer; left: 200px; top: 23px"></md-icon></md-input-container><md-progress-circular class="user-query-counter-progress md-hue-2" md-diameter="20px" ng-show="row.documentKindId == vm.dueDateId && vm.dueDateSaving" md-mode="small"></md-progress-circular></div></td><td md-cell ng-if="vm.warningThresholdsEnabled"><div class="user-query-counter-block text" ng-class="{\'editing\': row.documentKindId==vm.warningId, \'reading\': row.documentKindId!=vm.warningId}" ng-click="vm.editWarnings(row, $index, $event)"><span class="text-block with-content" ng-show="row.warning1">{{row.warning1}}</span> <input class="user-query-counter-input text-block no-content" ng-show="!row.warning1" type="text" placeholder="" ng-readonly="true"><md-input-container md-no-float class="md-block input-block"><input aria-label="{{\'users.model.usertests\'| translate}}" class="user-query-counter-input editable" ng-init="vm.warnings1[$index]=row.warning1" ng-model="vm.warnings1[$index]" type="number" min="0" max="999999999" ng-pattern="/^[0-9]+$/" ng-keyup="vm.warningsKeyUp($event)" ng-keypress="vm.warningsKeyPress($event)" maxlength="9" placeholder="" ng-readonly="row.documentKindId!=vm.warningId"><md-icon class="icon-edit" ng-bind="\'create\'" ng-show="row.documentKindId!==vm.warningId"></md-icon><md-icon class="icon-save" ng-click="vm.saveWarnings(row, $index)" ng-bind="\'check\'" ng-show="row.documentKindId==vm.warningId"></md-icon><md-icon ng-click="vm.cancelEditWarnings()" class="icon-cancel" ng-bind="\'close\'" ng-show="row.documentKindId==vm.warningId"></md-icon></md-input-container><md-progress-circular class="user-query-counter-progress md-hue-2" md-diameter="20px" ng-show="row.documentKindId == vm.warningId && vm.warningsSaving" md-mode="small"></md-progress-circular></div></td><td md-cell ng-if="vm.warningThresholdsEnabled"><div class="user-query-counter-block text" ng-class="{\'editing\': row.documentKindId==vm.warningId, \'reading\': row.documentKindId!=vm.warningId}" ng-click="vm.editWarnings(row, $index, $event)"><span class="text-block with-content" ng-show="row.warning2">{{row.warning2}}</span> <input class="user-query-counter-input text-block no-content" ng-show="!row.warning2" type="text" placeholder="" ng-readonly="true"><md-input-container md-no-float class="md-block input-block"><input aria-label="{{\'users.model.usertests\'| translate}}" class="user-query-counter-input editable" ng-init="vm.warnings2[$index]=row.warning2" ng-model="vm.warnings2[$index]" type="number" min="0" max="999999999" ng-pattern="/^[0-9]+$/" ng-keyup="vm.warningsKeyUp($event)" ng-keypress="vm.warningsKeyPress($event)" maxlength="9" placeholder="" ng-readonly="row.documentKindId!=vm.warningId"><md-icon class="icon-edit" ng-bind="\'create\'" ng-show="row.documentKindId!==vm.warningId"></md-icon><md-icon class="icon-save" ng-click="vm.saveWarnings(row, $index)" ng-bind="\'check\'" ng-show="row.documentKindId==vm.warningId"></md-icon><md-icon ng-click="vm.cancelEditWarnings()" class="icon-cancel" ng-bind="\'close\'" ng-show="row.documentKindId==vm.warningId"></md-icon></md-input-container><md-progress-circular class="user-query-counter-progress md-hue-2" md-diameter="20px" ng-show="row.documentKindId == vm.warningId && vm.warningsSaving" md-mode="small"></md-progress-circular></div></td><td md-cell ng-if="vm.warningThresholdsEnabled"><md-menu-bar flex layout="row"><md-menu><md-button aria-label="open" class="md-icon-button" ng-click="$mdMenu.open(); $event.stopPropagation();"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item><md-button id="editThresholds{{$index}}" aria-label="edit thresholds" ng-click="vm.editThresholds(row)" data-translate="global.table.menu.edit"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div></md-table-container></md-card></md-content></div><div layout-margin layout-wrap><div layout="row" flex layout-align="end center"><md-button id="save" aria-label="saveButton" class="md-raised md-primary" data-translate="global.button.save" ng-click="vm.save()"></md-button></div></div></div>');
$templateCache.put('app/account/settings/iodo/iodo.html','<div layout="column" class="site-container" id="rodo"><settings-menu active-tab="vm.activeTab"></settings-menu><div layout="column" class="payments site-container"><md-content class="payments-content" layout="column"><header class="header"><h5 data-translate="global.iodo.title">Podpowierzanie danych</h5><span>{{\'global.iodo.info\'+vm.instance+\'\'| translate}}</span></header></md-content><md-content layout="row" layout-margin><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch aria-hidden="false" flex><div layout-margin layout-padding layout="row" flex class="payment-metric-container"><div flex="80" flex-md="100" flex-sm="100" flex-xs="100"><span>{{\'global.iodo.companies.subheader\'+vm.instance+\'\'| translate}}</span><h3>{{\'global.iodo.companies.header\'+vm.instance+\'\'| translate}}</h3><div layout-padding ng-bind-html="vm.companies"></div><md-input-container layout="row"><div flex="10" class="rodo-dontaccept-label" data-translate="global.iodo.dontaccept">Brak akceptacji</div><md-switch flex="none" ng-model="vm.accept" ng-change="vm.verifyAcceptTerms()" aria-label="Switch 1" class="md-primary"><span ng-class="{ \'rodo-dontaccept-label\': !vm.accept }" class="rodo-accept-label" data-translate="global.iodo.accept">Akceptuje podpowierzanie danych</span></md-switch></md-input-container></div></div></md-card></md-content></div></div>');
$templateCache.put('app/account/settings/jsa/jsa.html','<div layout="column" class="site-container"><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.showLoader"></md-progress-circular></div><settings-menu active-tab="vm.activeTab"></settings-menu><div layout="row"><form novalidate class="form" name="formAccessData" autocomplete="on" flex-md="100" flex="40"><md-card class="h-100"><md-card-content><md-card-title-text class="pb-5" layout="row" layout-xs="column" layout-align="center center"><span class="md-headline login-header" data-translate="{{vm.orppdIntegration ? \'orppd.access-data.title\' : \'jsa.access-data.title\'}}"></span></md-card-title-text><div layout-margin layout-align="center center"><md-input-container layout="row" class="md-block"><input id="polonCode" type="text" name="polonCode" ng-model="vm.jsaAccessData.polonCode" ng-keyup="formAccessData.$valid && $event.keyCode == vm.keyReturn && vm.saveAccessData($event)" placeholder="{{\'jsa.synchronize.code-polon\' | translate}}" required></md-input-container><input type="text" style="display:none"><md-input-container layout="row" class="md-block"><input id="jsaToken" type="{{vm.showJsaToken ? \'text\' : \'password\'}}" name="accessDataToken" ng-model="vm.jsaAccessData.jsaToken" ng-keyup="formAccessData.$valid && $event.keyCode == vm.keyReturn && vm.saveAccessData($event)" placeholder="{{vm.jsaAccessData.tokenLastSaveDate ? \'jsa.access-data.token.update\' : \'jsa.access-data.token\' | translate}}" required><md-checkbox name="showPassword" ng-model="vm.showJsaToken" aria-label="Poka\u017C token"><span data-translate="jsa.access-data.show.token">Poka\u017C token</span></md-checkbox><p ng-if="!!vm.jsaTokenLastSaveDateFormatted">{{(\'jsa.access-data.token-last-save-date\' | translate) + \': \' + vm.jsaTokenLastSaveDateFormatted}}</p></md-input-container><md-input-container ng-if="vm.orppdIntegration" layout="row" class="md-block"><input id="orppdPassword" type="{{vm.showOrppdPassword ? \'text\' : \'password\'}}" name="orppdPassword" ng-model="vm.orppdPassword" ng-keyup="formAccessData.$valid && $event.keyCode == vm.keyReturn && vm.saveAccessData($event)" placeholder="{{vm.orppdPassword ? \'orppd.password.update\' : \'orppd.password\' | translate}}" required><md-checkbox name="showPassword" ng-model="vm.showOrppdPassword" aria-label="Poka\u017C has\u0142o orppd"><span data-translate="orppd.access-data.show.password">Poka\u017C token</span></md-checkbox><p ng-if="vm.passwordLastSaveDateFormatted">{{(\'orppd.password.last-save-date\' | translate) + \': \' + vm.passwordLastSaveDateFormatted}}</p></md-input-container></div></md-card-content><md-card-footer><md-button type="submit" class="md-raised md-primary" aria-label="accessDataSave" data-translate="jsa.access-data.button" layout-fill ng-click="vm.saveAccessData($event)" ng-keypress="vm.saveAccessData($event)" ng-disabled="formAccessData.$invalid"></md-button></md-card-footer></md-card></form><div flex-md="100" flex="40"><md-card class="h-100"><md-nav-bar md-no-ink-bar="disableInkBar" md-selected-nav-item="vm.activeSubTab" nav-bar-aria-label="navigation links"><md-nav-item md-nav-click="vm.changeTab()" name="{{vm.polonSynchronizationType.POLON.value}}">{{\'jsa.polon\' | translate}}</md-nav-item><md-nav-item md-nav-click="vm.changeTab()" name="{{vm.polonSynchronizationType.FILE.value}}" ng-show="false">{{\'jsa.file\' | translate}}</md-nav-item></md-nav-bar><md-card-content><p>{{(\'polon.synchronization.status\' | translate) + \': \' + (vm.polonSynchronizationStatus[vm.synchronizationStatus].translationKey | translate)}}</p><p ng-if="!!vm.synchronizationStartDate">{{(\'polon.synchronization.start-date\' | translate) + \': \' + vm.synchronizationStartDate}}</p><p ng-if="!!vm.synchronizationType">{{(\'polon.synchronization.type\' | translate) + \': \' + (vm.polonSynchronizationType[vm.synchronizationType].translationKey | translate)}}</p></md-card-content><md-card-content><!--\n                                 <md-card-content ng-if="vm.activeSubTab == vm.polonSynchronizationType.POLON.value">\n                 --><form class="form" form-disabled="!vm.isSynchronizationEnabled()" name="form"><md-card-title-text class="pb-5" layout="row" layout-align="center center" layout-xs="column"><span class="md-headline login-header" data-translate="jsa.synchronize.title"></span></md-card-title-text><div layout-align="center center"><md-input-container class="md-block" layout="row" ng-if="!vm.synchronizeOnlyUnitsAndStudies"><input autocomplete="nope" id="usernameJsa" name="usernameJsa" ng-keyup="form.$valid && $event.keyCode == vm.keyReturn && vm.formData && vm.synchronize($event)" ng-model="vm.login" placeholder="{{\'jsa.synchronize.username\' | translate}}" required type="text"></md-input-container><md-input-container class="md-block" layout="row" ng-if="!vm.synchronizeOnlyUnitsAndStudies"><input autocomplete="new-password" name="passwordJsa" ng-keyup="form.$valid && $event.keyCode == vm.keyReturn && vm.formData &&vm.synchronize($event)" ng-model="vm.password" placeholder="{{\'jsa.synchronize.password\' | translate}}" required type="password"></md-input-container><md-checkbox class="mt-4" aria-label="Synchronizuj tylko wydzialy i kierunki" name="synchronizeOnlyUnitsAndStudies" ng-model="vm.synchronizeOnlyUnitsAndStudies"><span data-translate="jsa.synchronize.only-units-and-studies">Tylko wydzialy i kierunki</span></md-checkbox><md-button aria-label="synchronize" class="md-raised md-primary" data-translate="jsa.synchronize.button" layout-fill ng-click="vm.synchronize($event)" ng-disabled="form.$invalid" ng-keypress="vm.synchronize($event)" type="submit"></md-button></div></form></md-card-content><!--\n                <md-card-content ng-if="vm.activeSubTab == vm.polonSynchronizationType.FILE.value">\n                    <md-card-title-text layout="row" layout-align="center center" layout-xs="column">\n                        <span class="md-headline login-header" data-translate="jsa.file.title"></span>\n                    </md-card-title-text>\n                    <div layout-align="center center">\n                        <form\n                                class="dragbox dragbox-big has-advanced-upload w-100 mb-0"\n                                name="form"\n                                novalidate\n                                role="form"\n                                show-validation>\n                            <upload-file files="vm.files"\n                                         on-available-extensions="vm.availableExtensions"\n                                         is-loading="vm.isLoading"\n                                         ng-if="vm.isSynchronizationEnabled()"\n                                         on-get-the-files="vm.importFile"\n                            ></upload-file>\n                            <div class="dragbox-input" ng-if="!vm.isSynchronizationEnabled()">\n                                <div class="dragbox-icon-cloud">\n                                    <i class="material-icons glyphicon-warning-sign">warning</i>\n                                </div>\n                                <label class="overflow-hidden"\n                                       data-translate="jsa.file.synchronization-already-in-progress"></label>\n                            </div>\n                        </form>\n                    </div>\n                </md-card-content>\n--><md-card-footer><!--\n                    <div ng-if="vm.activeSubTab == vm.polonSynchronizationType.FILE.value">\n                        <p class="md-title mt-0">{{\'jsa.file.text1\' | translate}}</p>\n                        <p class="mb-0">{{\'jsa.file.text2\' | translate}}</p>\n                    </div>\n                    --><div layout="row" layout-align="end center"><md-button ng-href="{{\'jsa.file.instructionbutton.url\' | translate }}" target="_blank">{{\'jsa.file.instructionbutton.label\' | translate}}</md-button></div></md-card-footer></md-card></div><div flex-md="100" flex="40"><md-card class="h-100"><md-nav-bar md-no-ink-bar="disableInkBar" md-selected-nav-item="vm.activeSubTabPolonEmployee" nav-bar-aria-label="navigation links"><md-nav-item md-nav-click="vm.changeTab()" name="search">{{\'jsa.polon-employee.search\' | translate}}</md-nav-item><md-nav-item md-nav-click="vm.changeTab()" name="add">{{\'jsa.polon-employee.add\' | translate}}</md-nav-item></md-nav-bar><md-card-content ng-if="vm.activeSubTabPolonEmployee ==\'search\'"><md-card-title-text class="pb-5" layout="row" layout-align="center center"><span class="md-headline login-header" data-translate="jsa.polon-employee.search.title"></span></md-card-title-text><form novalidate class="form" name="formPolonEmployeeSearch" layout="column"><md-input-container><md-autocomplete class="white-background" md-floating-label="{{\'jsa.polon-employee.search.polon-institution\' | translate}}" md-item-text="item.name" md-items="item in vm.searchPolonInstitutions(vm.polonInstitutionsSearchText)" md-search-text="vm.polonInstitutionsSearchText" md-no-cache md-selected-item="vm.selectedPolonInstitution" md-selected-item-change="vm.selectedPolonInstitutionChange()" md-require-match="true" md-select-on-match="true" md-clear-button="true" md-min-length="3" required><md-item-template><span md-highlight-text="vm.polonInstitutionsSearchText">{{item.name}}</span></md-item-template></md-autocomplete></md-input-container><md-input-container><md-autocomplete ng-if="vm.selectedPolonInstitution" class="white-background" md-floating-label="{{\'jsa.polon-employee.search.polon-employee\' | translate}}" md-item-text="vm.getPolonEmployeeSummaryFormatted(item)" md-items="item in vm.searchPolonEmployees(vm.polonEmployeeSearchText)" md-search-text="vm.polonEmployeeSearchText" md-no-cache md-selected-item="vm.selectedPolonEmployee" md-selected-item-change="vm.selectedPolonEmployeeChange()" md-require-match="true" md-select-on-match="true" md-min-length="2" md-clear-button="true" required><md-item-template><span md-highlight-text="vm.polonEmployeeSearchText">{{vm.getPolonEmployeeSummaryFormatted(item)}}</span></md-item-template></md-autocomplete></md-input-container><md-input-container ng-if="vm.selectedPolonEmployee && !vm.selectedPolonEmployee.title" layout="row" class="md-block"><label data-translate="jsa.add-polon-employee.title"></label><md-select ng-model="vm.selectedEmployeeCustomTitle" placeholder="{{\'jsa.add-polon-employee.title\' | translate}}" required><md-option ng-value="null"><em>{{\'jsa.add-polon-employee.no-title\' | translate}}</em></md-option><md-option ng-value="opt" ng-repeat="opt in vm.degreesAndTitles">{{ opt }}</md-option></md-select></md-input-container><md-button type="submit" ng-click="vm.addPolonEmployeeFromOtherInstitution()" class="md-raised md-primary" aria-label="addPolonEmployeeFromOtherInstitution" data-translate="jsa.search-polon-employee.add" ng-disabled="formPolonEmployeeSearch.$invalid || (!vm.selectedPolonEmployee.title && !vm.selectedEmployeeCustomTitle)">layout-fill</md-button></form></md-card-content><md-card-content ng-if="vm.activeSubTabPolonEmployee ==\'add\'"><form novalidate class="form" name="formPolonEmployeeData"><md-card-title-text class="pb-5" layout="row" layout-xs="column" layout-align="center center"><span class="md-headline login-header" data-translate="jsa.polon-employee-add.title"></span></md-card-title-text><div layout-margin layout-align="center center"><md-input-container layout="row" class="md-block"><input id="polonEmployeeName" type="text" name="polonEmployeeName" ng-model="vm.polonEmployee.name" ng-keyup="formPolonEmployeeData.$valid && $event.keyCode == vm.keyReturn && vm.addPolonEmployee($event)" placeholder="{{\'jsa.add-polon-employee.name\' | translate}}" required></md-input-container><md-input-container layout="row" class="md-block"><input id="polonEmployeeSurname" type="text" name="polonEmployeeSurname" ng-model="vm.polonEmployee.surname" ng-keyup="formPolonEmployeeData.$valid && $event.keyCode == vm.keyReturn && vm.addPolonEmployee($event)" placeholder="{{\'jsa.add-polon-employee.surname\' | translate}}" required></md-input-container><md-input-container layout="row" class="md-block"><label data-translate="jsa.add-polon-employee.title"></label><md-select ng-model="vm.polonEmployee.title" placeholder="{{\'jsa.add-polon-employee.title\' | translate}}" required><md-option ng-value="null"><em>{{\'jsa.add-polon-employee.no-title\' | translate}}</em></md-option><md-option ng-value="opt" ng-repeat="opt in vm.degreesAndTitles">{{ opt }}</md-option></md-select></md-input-container><md-checkbox id="polonEmployeeNoUid" class="mt-4" aria-label="Nie posiadam uid" name="polonEmployeeNoUid" ng-model="vm.polonEmployeeNoUid"><span data-translate="jsa.add-polon-employee.no-uid">Brak numeru uid</span></md-checkbox><md-input-container layout="row" class="md-block" ng-if="!vm.polonEmployeeNoUid"><input id="polonEmployeeUid" type="text" name="polonEmployeeUid" ng-model="vm.polonEmployee.uid" ng-keyup="formPolonEmployeeData.$valid && $event.keyCode == vm.keyReturn && vm.addPolonEmployee($event)" placeholder="{{\'jsa.add-polon-employee.uid\' | translate}}" required></md-input-container></div><md-button type="submit" class="md-raised md-primary" aria-label="addpolonEmployee" data-translate="jsa.add-polon-employee.button" layout-fill ng-click="vm.addPolonEmployee($event)" ng-keypress="vm.addPolonEmployee($event)" ng-disabled="formPolonEmployeeData.$invalid" ng-if="!vm.polonEmployeeNoUid"></md-button><md-button type="submit" class="md-raised md-primary" aria-label="sendopiEmail" data-translate="jsa.send-opi-email.button" layout-fill ng-click="vm.sendOpiEmail($event)" ng-keypress="vm.sendOpiEmail($event)" ng-disabled="formPolonEmployeeData.$invalid" ng-if="vm.polonEmployeeNoUid"></md-button></form></md-card-content></md-card></div></div></div>');
$templateCache.put('app/account/settings/popup/popup-administration-add.template.html','<div layout="column" class="site-container"><md-content class="users" layout="row"><div layout-align="center center"><header class="header"><h5 ng-if="!vm.obj.id" data-translate="popup.popup-administration.add.title"></h5><h5 ng-if="vm.obj.id" data-translate="popup.popup-administration.edit.title"></h5></header></div></md-content><md-content layout="row" layout-padding><form name="form" flex><md-card flex layout-padding><md-card-title-text><h4 data-translate="popup.base-data.header"></h4></md-card-title-text><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="50" flex-xs="100"><input name="popupCodename" ng-model="vm.obj.codename" ng-required="true" placeholder="{{\'popup.form.codename\' | translate}}"></md-input-container></div><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="50" flex-xs="100"><input name="popupTitle" ng-model="vm.obj.title" ng-required="true" placeholder="{{\'popup.form.title.translation-key\' | translate}}"></md-input-container></div><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="50" flex-xs="100"><input name="popupContent" ng-model="vm.obj.content" ng-required="true" placeholder="{{\'popup.form.content.translation-key\' | translate}}"></md-input-container></div></md-card><md-card flex layout-padding><md-card-title-text><h4 data-translate="popup.criteria-data.header"></h4></md-card-title-text><div layout="row" class="mt-3"><md-input-container flex="25"><label data-translate="popup.table.header.date-from">Data od</label><md-datepicker required ng-model="vm.obj.dateFrom" md-max-date="vm.obj.dateTo" input-date md-open-on-focus></md-datepicker></md-input-container><md-input-container flex="25"><label data-translate="popup.table.header.date-to">Data do</label><md-datepicker required ng-model="vm.obj.dateTo" input-date md-min-date="vm.obj.dateFrom" md-open-on-focus></md-datepicker></md-input-container></div><div layout="row" class="mt-3"><md-input-container class="md-block" flex="50" flex-xs="100"><input name="clientIds" placeholder="{{\'popup.form.client-ids\' | translate}}" ng-model="vm.obj.criteria.clientIds" ng-required="false"></md-input-container></div><div layout="row" class="text-left" layout-padding layout-wrap layout-align="center left"><span flex="100" flex-xs="100" class="md-headline p-0 m-0" data-translate="popup.roles.choose"></span><md-checkbox flex="15" flex-xs="15" ng-repeat="role in vm.roles" ng-model="vm.obj.criteria.roles[role.type.id]">{{ role.translationKey | translate }}</md-checkbox></div><div layout="row" class="text-left" layout-padding layout-wrap layout-align="center left"><span flex="100" flex-xs="100" class="md-headline p-0 m-0" data-translate="popup.options.choose"></span><md-switch ng-repeat="option in vm.options" aria-label="option" class="m-0" ng-model="vm.obj.options[option.id]">{{option.key | translate}}</md-switch></div><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="50" flex-xs="100"><input type="email" ng-pattern="/^.+@.+\\..+$/" name="popupemail" ng-model="vm.obj.email" ng-required="vm.obj.options[2]" placeholder="{{\'popup.form.email\' | translate}}"></md-input-container></div></md-card><div layout="row" flex layout-align="end center"><md-button id="cancelButton" aria-label="popup-administration-create-cancel" ui-sref="popup-administration" data-translate="global.form.button.cancel"></md-button><md-button id="saveButton" ng-click="vm.saveOrUpdate(vm.obj)" aria-label="save popup" class="md-raised md-primary button-waiting" ng-disabled="form.$invalid"><span data-translate="global.form.button.save"></span></md-button></div></form></md-content></div>');
$templateCache.put('app/account/settings/popup/popup-administration.template.html','<div layout="column" class="site-container"><settings-menu active-tab="vm.activeTab"></settings-menu><div layout-margin layout-wrap><div layout="row" flex layout-align="end center"><md-button id="addPopupButton" aria-label="popup-administration-add" ui-sref="popup-administration-add" class="md-raised md-primary button-waiting" data-translate="global.button.add"></md-button></div></div><div class="table-container" flex><md-content layout="row" layout-margin><md-card flex><div layout="row" layout-padding layout-wrap><select-page-size flex="25" layout="row" layout-align="start center" query-request="vm.queryRequest" on-value-chosen="vm.loadData()"></select-page-size></div><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span data-translate="popup.table.header.codename"></span></th><th md-column><span data-translate="popup.table.header.title"></span></th><th md-column><span data-translate="popup.table.header.content"></span></th><th md-column><span data-translate="popup.table.header.date-from"></span></th><th md-column><span data-translate="popup.table.header.date-to"></span></th><th md-column><span data-translate="global.table.actions"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat-start="popupRow in vm.popups track by $index" ng-click="vm.getDetails(popupRow);"><td md-cell>{{popupRow.codename}}</td><td md-cell>{{popupRow.title | translate}}</td><td md-cell>{{ (popupRow.content | translate | limitTo:100) + \'...\'}}<md-tooltip class="tooltip-with-long-text" md-direction="bottom" md-delay="100" ng-bind-html="popupRow.content | translate"></md-tooltip></td><td md-cell>{{popupRow.dateFrom | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td md-cell>{{popupRow.dateTo | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td md-cell><md-menu-bar flex layout="row"><md-menu><md-button aria-label="open" class="md-icon-button" ng-click="$mdMenu.open(); $event.stopPropagation();"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item><md-button id="tableOptionEdit{{$index}}" aria-label="edit popup" ui-sref="popup-administration-add({id: popupRow.id})" data-translate="global.table.menu.edit"></md-button></md-menu-item><md-menu-item><md-button id="tableOptionDelete{{$index}}" aria-label="remove popup" ng-click="vm.remove(popupRow)" data-translate="global.table.menu.delete"></md-button></md-menu-item><md-menu-item><md-button id="tableOptionSwitch{{$index}}" aria-label="switch off popup" ng-click="vm.switchOff(popupRow)" data-translate="popup.switch-off.action"></md-button></md-menu-item><md-menu-item><md-button id="tableOptionCopy{{$index}}" aria-label="copy popup" ng-click="vm.copy(popupRow)" data-translate="popup.copy.action"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></td></tr><tr ng-repeat-end><td colspan="6" ng-if="vm.expandedRow === popupRow.id"><popup-details popup="vm.details"></popup-details></td></tr></tbody></table></md-table-container><div flex layout="row" layout-align="end center" layout-wrap><paging page="vm.popupPage.number" page-size="vm.popupPage.size" paging-action="vm.loadPage(page)" show-first-last="true" show-prev-next="true" total="vm.popupPage.totalElements"></paging><div class="go-to" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to page" ng-model="goToPageInputModel" min="1" max="vm.popupPage.totalPages" type="number" ng-keyup="$event.keyCode === vm.keyCodeEnter && vm.loadPage(goToPageInputModel)"></md-input-container></div></div></md-card></md-content></div></div>');
$templateCache.put('app/account/settings/protocols/protocol-add.template.html','<div layout="column" class="site-container"><md-content class="users" layout="row"><div layout-align="center center"><header class="header"><h5 data-translate="protocol.edit.title"></h5></header></div><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div></md-content><md-content layout="row" layout-padding><form name="form" flex><md-card flex layout-padding><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="50" flex-xs="100"><input name="protocolName" ng-model="vm.obj.name" ng-required="true" placeholder="{{\'protocol.table.header.protocol.name\' | translate}}"></md-input-container></div><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="50" flex-xs="100"><input name="protocolFilename" ng-model="vm.obj.fileName" ng-required="true" placeholder="{{\'protocol.table.header.protocol.filename\' | translate}}"></md-input-container></div><div layout="row" layout-xs="column" flex flex-xs="100"><md-select ng-model="vm.conditionalParam" aria-label="conditional p" placeholder="{{\'protocol.parameter.conditional\' | translate}}"><md-option ng-value="param.value" ng-repeat="param in vm.parameters">{{param.label}}</md-option></md-select><md-select ng-model="vm.conditionalParamMethod" aria-label="conditional method"><md-option ng-value="method.value" ng-repeat="method in vm.methods">{{method.label}}</md-option></md-select><md-input-container class="md-block" flex="10"><input name="conditionalParamValue" ng-model="vm.conditionalParamValue" aria-label="conditionalParamValue"></md-input-container><md-button id="insertConditionalButton" ng-click="vm.insertConditionalParam()" ng-disabled="!vm.conditionalParam" aria-label="insert param protocol" class="md-raised md-primary"><span data-translate="global.button.add">insert conditional</span></md-button></div><div layout="row" layout-xs="column" flex flex-xs="100"><md-select ng-model="vm.simpleParam" aria-label="simple p" placeholder="{{\'protocol.parameter.simple\' | translate}}"><md-option ng-value="param.value" ng-repeat="param in vm.parameters">{{param.label}}</md-option></md-select><md-button id="insertSimpleButton" ng-click="vm.insertSimpleParam()" ng-disabled="!vm.simpleParam" aria-label="insert simple param protocol" class="md-raised md-primary"><span data-translate="global.button.add">insert simple</span></md-button></div><div layout="row" class="layout-row" layout-xs="column" flex flex-xs="100"><md-input-container flex="20" flex-sm="100" flex-xs="100" class="md-block"><md-autocomplete id="search-client-for-document-parameter" md-clear-button="true" class="white-background" md-floating-label="{{\'protocol.parameter.document-parameter.client\'| translate}}" md-input-minlength="1" md-item-text="item.id+\' \'+item.clieName" md-items="item in vm.clientSearch(vm.clientSearchText)" md-search-text="vm.clientSearchText" md-selected-item-change="vm.selectedClientChange(item)" md-require-match="true" md-delay="500" md-select-on-match="true"><md-item-template><span md-highlight-text="vm.clientSearchText" md-highlight-flags="^i">{{item.clieName}} [{{item.id}}]</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{vm.clientSearchText}}"</md-not-found></md-autocomplete></md-input-container><md-input-container flex="20" flex-sm="50" flex-xs="50" class="md-block"><md-select ng-model="vm.selectedDocumentParameterDefinitionId" aria-label="document parameter definition" placeholder="{{\'protocol.parameter.document-parameter.chosen-value\'| translate}}"><md-option ng-value="docuParamDef.id" ng-repeat="docuParamDef in vm.availableDocumentParameterDefinitions">{{docuParamDef.dopadeName}}</md-option></md-select></md-input-container><md-button flex="10" flex-sm="50" flex-xs="50" id="insertDocumentParameterButton" ng-click="vm.insertDocumentParameter()" ng-disabled="!vm.selectedDocumentParameterDefinitionId" aria-label="insert document parameter" class="md-raised md-primary"><span data-translate="global.button.add">document parameter</span></md-button></div><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="50" flex-xs="100"><textarea id="protocolHtmlTemplate" ui-tinymce="vm.tinymceOptions" ng-model="vm.obj.htmlTemplate" aria-label="protocol textarea"></textarea></md-input-container></div></md-card><div layout="row" flex layout-align="end center"><md-button id="cancelButton" aria-label="protocol-add-cancel" ui-sref="protocol-list" data-translate="global.form.button.cancel"></md-button><md-button id="saveButton" ng-click="vm.saveOrUpdate(vm.obj)" aria-label="save protocol" class="md-raised md-primary button-waiting" ng-disabled="form.$invalid"><span data-translate="global.form.button.save"></span></md-button></div></form></md-content></div>');
$templateCache.put('app/account/settings/protocols/protocol-list.template.html','<div layout="column" class="site-container"><settings-menu active-tab="vm.activeTab"></settings-menu><div layout-margin layout-wrap><div layout="row" flex layout-align="end center"><md-button id="addProtocolButton" aria-label="protocol-add" ui-sref="protocol-add" class="md-raised md-primary button-waiting" data-translate="global.button.add"></md-button></div></div><div class="table-container" flex><md-content layout="row" layout-margin><md-card flex><div layout="row" layout-padding layout-wrap><select-page-size flex="25" layout="row" layout-align="start center" query-request="vm.queryRequest" on-value-chosen="vm.loadData()"></select-page-size><div flex="70" flex-sm="70" flex-xs="100" layout="row" layout-align="end center" layout-sm="column"><md-input-container class="md-block" flex="70" flex-xs="100" layout-align="end center" md-no-float><input ng-change="vm.loadData()" ng-model="vm.searchRequest.simpleSearch" ng-model-options="{ debounce: vm.simpleSearchDelay }" placeholder="{{\'global.search.title\'| translate}}"></md-input-container></div></div><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span>#</span></th><th md-column><span data-translate="protocol.table.header.protocol.name"></span></th><th md-column><span data-translate="protocol.table.header.protocol.filename"></span></th><th md-column><span data-translate="global.table.actions"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="row in vm.protocols track by $index"><td md-cell>{{($index + 1) + ((vm.queryRequest.page - 1) * vm.queryRequest.limit)}}</td><td md-cell>{{row.name}}</td><td md-cell>{{row.fileName}}</td><td md-cell><md-menu-bar flex layout="row"><md-menu><md-button aria-label="open" class="md-icon-button" ng-click="$mdMenu.open(); $event.stopPropagation();"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item><md-button id="tableOptionEdit{{$index}}" aria-label="edit protocol" ui-sref="protocol-add({id: row.id})" data-translate="global.table.menu.edit"></md-button></md-menu-item><md-menu-item><md-button id="tableOptionDelete{{$index}}" aria-label="remove protocol" ng-click="vm.remove(row)" data-translate="global.table.menu.delete"></md-button></md-menu-item><md-menu-item><md-button id="tableOptionDuplicate{{$index}}" aria-label="duplicate protocol" ng-click="vm.duplicate(row)" data-translate="global.table.menu.duplicate"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div></md-table-container><div flex layout="row" layout-align="end center" layout-wrap><paging page="vm.protocolPage.number" page-size="vm.protocolPage.size" paging-action="vm.loadPage(page)" show-first-last="true" show-prev-next="true" total="vm.protocolPage.totalElements"></paging><div class="go-to" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to page" ng-model="goToPageInputModel" min="1" max="vm.protocolPage.totalPages" type="number" ng-keyup="$event.keyCode === vm.keyCodeEnter && vm.loadPage(goToPageInputModel)"></md-input-container></div></div></md-card></md-content></div></div>');
$templateCache.put('app/account/settings/settings-menu/settings-menu.template.html','<md-content class="users settings-menu" layout="row"><div layout-align="center center"><header class="header"><h5 data-translate="users.settings.title"></h5></header></div><md-nav-bar md-no-ink-bar="disableInkBar" md-selected-nav-item="$ctrl.activeTab" nav-bar-aria-label="navigation links"><md-nav-item name="adminConfiguration" md-nav-sref="admin-configuration" ng-if="$ctrl.isAdmin && !$ctrl.isSuperAdmin">{{\'users.settings.menu.admin-configuration\' | translate}}</md-nav-item><md-nav-item ng-if="!$ctrl.isSuperAdmin" class="tabs-menu-li-elipsis" name="organisationalUnits" md-nav-sref="organisational-units">{{\'users.settings.menu.organisational-units\' | translate}}</md-nav-item><md-nav-item name="jsaSynchronization" md-nav-sref="jsa" ng-if="$ctrl.isAdmin && $ctrl.jsa">{{ ($ctrl.orppdIntegration ? \'global.menu.settings.jsa-orppd.title\' : \'global.menu.settings.jsa.title\') | translate}}</md-nav-item><md-nav-item class="tabs-menu-li-elipsis" name="databaseExchangeProgramMembers" md-nav-sref="database-exchange-program-members">{{\'users.settings.menu.database.exchange.program.members\' | translate}}</md-nav-item><md-nav-item ng-if="!$ctrl.isSuperAdmin" md-selected="true" name="documentParameterDefinitions" md-nav-sref="document-parameter-definitions">{{\'users.settings.menu.document-parameters\' | translate}}<md-tooltip md-delay="100" md-direction="top">{{\'users.settings.menu.document-parameters\' | translate}}</md-tooltip></md-nav-item><md-nav-item ng-if="$ctrl.isSuperAdmin" class="tabs-menu-li-elipsis" name="systemAdministration" md-nav-sref="system-administration">{{\'users.settings.menu.system-administration\' | translate}}</md-nav-item><md-nav-item ng-if="$ctrl.isSuperAdmin" class="tabs-menu-li-elipsis" name="popupAdministration" md-nav-sref="popup-administration">{{\'users.settings.menu.popup-administration\' | translate}}</md-nav-item><md-nav-item ng-if="$ctrl.isAdmin && !$ctrl.isSuperAdmin" class="tabs-menu-li-elipsis" name="iodo" md-nav-sref="iodo">{{\'global.menu.iodo\' | translate}}</md-nav-item><md-nav-item name="apiKeys" md-nav-sref="ap-keys" ng-if="$ctrl.isSuperAdmin">{{\'users.settings.menu.api-keys\' | translate}}</md-nav-item><md-nav-item name="clientLogo" md-nav-sref="client-logo" ng-if="$ctrl.isAdmin && !$ctrl.isSuperAdmin">{{\'users.settings.menu.client-logo\' | translate}}</md-nav-item><md-nav-item ng-if="$ctrl.isAdmin && !$ctrl.isSuperAdmin" class="tabs-menu-li-elipsis" name="documentKinds" md-nav-sref="document-kinds">{{\'global.menu.document-kinds\' | translate}}</md-nav-item><md-nav-item name="protocolList" md-nav-sref="protocol-list" ng-if="$ctrl.isSuperAdmin">{{\'users.settings.menu.protocol-list\' | translate}}</md-nav-item><md-nav-item name="clientGroups" md-nav-sref="client-group-list" ng-if="$ctrl.isSuperAdmin">{{\'users.settings.menu.client-groups\' | translate}}</md-nav-item><md-nav-item name="tags" md-nav-sref="tags-list" ng-if="$ctrl.isAdmin && $ctrl.tagsEnabled">{{\'users.settings.menu.tags\' | translate}}</md-nav-item></md-nav-bar></md-content>');
$templateCache.put('app/account/settings/similarity-report-settings/similarity-report-settings.html','<div layout="column" class="site-container"><settings-menu active-tab="vm.activeTab"></settings-menu><md-content layout="row" layout-padding><form name="form" flex><div layout="column" layout-margin><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="30" flex-xs="100"><input type="number" name="clieSfWordCountExt" placeholder="{{!vm.form.clieSfWordCountExt ? \'similarity.report.settings.form.word-count.placeholder\' : \'similarity.report.settings.form.word-count\' | translate}}" ng-model="vm.form.clieSfWordCountExt" ng-required="true" ng-show="vm.editing"> <span ng-show="!vm.editing"><br>{{vm.form.clieSfWordCountExt}}</span></md-input-container><md-input-container class="md-block" flex="30" flex-xs="100"><input type="number" name="clieForeignAlphabetAlertLimit" placeholder="{{!vm.form.clieForeignAlphabetAlertLimit ? \'similarity.report.settings.form.foreign-alphabet-alert-limit.placeholder\' : \'similarity.report.settings.form.foreign-alphabet-alert-limit\' | translate}}" ng-model="vm.form.clieForeignAlphabetAlertLimit" ng-required="true" ng-show="vm.editing"> <span ng-show="!vm.editing"><br>{{vm.form.clieForeignAlphabetAlertLimit}}</span></md-input-container></div></div><div layout="row" flex layout-align="end center"><md-button id="cancelButton" ng-click="vm.cancelSaving()" data-translate="global.form.button.cancel" ng-show="vm.editing"></md-button><md-button id="editButton" ng-click="vm.editState()" data-translate="global.form.button.edit" ng-show="!vm.editing"></md-button><md-button id="saveButton" ng-click="vm.save(vm.form, $event)" class="md-raised md-primary button-waiting" ng-show="vm.editing" ng-disabled="form.$invalid"><span data-translate="global.form.button.save"></span></md-button></div></form></md-content></div>');
$templateCache.put('app/account/settings/tags/tag-group-add.template.html','<div layout="column" class="site-container"><md-content class="users" layout="row"><div layout-align="center center"><header class="header"><h5 data-translate="tags.tag-group.edit.title"></h5></header></div><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div></md-content><md-content layout="row" layout-padding><form name="form" flex><md-card flex layout-padding><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="50" flex-xs="100"><input name="tagGroupName" ng-model="vm.obj.name" ng-required="true" placeholder="{{\'tags.tag-group.table.header.name\' | translate}}"></md-input-container></div></md-card><div layout="row" flex layout-align="end center"><md-button id="cancelButton" aria-label="tag-group-add-cancel" ui-sref="tags-list" data-translate="global.form.button.cancel"></md-button><md-button id="saveButton" ng-click="vm.saveOrUpdate(vm.obj)" aria-label="save tagGroup" class="md-raised md-primary button-waiting" ng-disabled="form.$invalid"><span data-translate="global.form.button.save"></span></md-button></div></form></md-content></div>');
$templateCache.put('app/account/settings/tags/tags-list.template.html','<div layout="column" class="site-container"><settings-menu active-tab="vm.activeTab"></settings-menu><div layout-margin layout-wrap><div layout="row" flex layout-align="end center"><md-button id="addTagButton" aria-label="tag-group-add" ui-sref="tag-group-add" class="md-raised md-primary button-waiting" data-translate="global.button.add"></md-button></div></div><div class="table-container" flex><md-content layout="row" layout-margin><md-card flex><div layout="row" layout-padding layout-wrap><select-page-size flex="25" layout="row" layout-align="start center" query-request="vm.queryRequest" on-value-chosen="vm.loadData()"></select-page-size><div flex="70" flex-sm="70" flex-xs="100" layout="row" layout-align="end center" layout-sm="column"><md-input-container class="md-block" flex="70" flex-xs="100" layout-align="end center" md-no-float><input ng-change="vm.loadData()" ng-model="vm.searchRequest.simpleSearch" ng-model-options="{ debounce: vm.simpleSearchDelay }" placeholder="{{\'global.search.title\'| translate}}"></md-input-container></div></div><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span>#</span></th><th md-column><span data-translate="tags.group.table.header.tag-group.name"></span></th><th md-column><span data-translate="tags.group.table.header.tags.name"></span></th><th md-column><span data-translate="global.table.actions"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="row in vm.tags track by $index"><td md-cell>{{($index + 1) + ((vm.queryRequest.page - 1) * vm.queryRequest.limit)}}</td><td md-cell>{{row.name}}</td><td md-cell layout="row"><md-button id="saveButton" ng-click="vm.saveTags(row)" aria-label="save tags" class="md-raised md-primary button-waiting" ng-disabled="!row.changesMade || vm.pending"><span data-translate="global.form.button.save"></span></md-button><md-chips flex="100" flex-xs="100" aria-label="tags" name="tags" class="tags-chips" ng-model="row.tags" readonly="false" md-enable-chip-edit="false" md-removable="true" placeholder="{{\'tags.add-tag.name-placeholder\' | translate}}" secondary-placeholder="{{\'tags.add-more-tags.name-placeholder\' | translate}}" md-transform-chip="vm.transformTagChip($chip, row)" md-on-remove="vm.onRemoveChip($chip, row)" md-add-on-blur="false"><md-chip-template>{{$chip.name}}</md-chip-template></md-chips></td><td md-cell><md-menu-bar flex layout="row"><md-menu><md-button aria-label="open" class="md-icon-button" ng-click="$mdMenu.open(); $event.stopPropagation();"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item><md-button id="tableOptionEdit{{$index}}" aria-label="edit tag" ui-sref="tag-group-add({id: row.id})" data-translate="global.table.menu.edit"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div></md-table-container><div flex layout="row" layout-align="end center" layout-wrap><paging page="vm.tagPage.number" page-size="vm.tagPage.size" paging-action="vm.loadPage(page)" show-first-last="true" show-prev-next="true" total="vm.tagPage.totalElements"></paging><div class="go-to" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to page" ng-model="goToPageInputModel" min="1" max="vm.tagPage.totalPages" type="number" ng-keyup="$event.keyCode === vm.keyCodeEnter && vm.loadPage(goToPageInputModel)"></md-input-container></div></div></md-card></md-content></div></div>');
$templateCache.put('app/account/settings/system-administration/system-administration.html','<div layout="column" class="site-container"><settings-menu active-tab="vm.activeTab"></settings-menu><md-content layout="row"><md-card flex layout-margin ng-if="vm.jsaCardEnabled"><md-card-title><md-card-title-text layout="row" layout-align="center"><span class="md-headline" data-translate="system-administration.jsa"></span></md-card-title-text></md-card-title><md-card-content><md-button class="md-raised md-primary" data-translate="system-administration.jsa.synchronize-polon-institutions" ng-click="vm.synchronizePolonUnits()" ng-disabled="vm.synchronizePolonUnitsButtonDisabled"></md-button></md-card-content></md-card></md-content></div>');
$templateCache.put('app/account/social/landing-social-login/landing-social-login.html','<div class="md-padding login-with-btn"><md-button aria-label="Login" ng-disabled="disabled" layout-fill class="jh-btn-social jh-btn-{{ provider }}" ng-click="click()"><div layout="row" layout-align="center center"><div class="{{\'login-\' + provider }} social-icon"></div><div><span>{{ ((\'global.login.\' + provider) | translate) }}</span></div></div></md-button></div>');
$templateCache.put('app/account/social/social-login-button/social-login-button.html','<div class="login-with-btn" flex="33"><md-button aria-label="Login" class="social-button jh-btn-{{ provider }}" ng-click="click()"><div layout="row" layout-align="center center"><div class="{{\'login-\' + provider }} social-icon"></div><div><span>{{ title }}</span></div></div></md-button></div>');
$templateCache.put('app/account/users/add-free-tokens/add-free-tokens.dialog.html','<md-dialog aria-label=""><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="users.add.free.tokens.window.title"></h2></div></md-toolbar><add-free-tokens></add-free-tokens></md-dialog>');
$templateCache.put('app/account/users/add-free-tokens/add-free-tokens.template.html','<form name="form" ng-cloak><md-dialog-content layout-margin><md-input-container class="md-block" flex-gt-sm flex="70"><input type="number" ng-min="$ctrl.addFreeTokensMin" ng-max="$ctrl.addFreeTokensMax" ng-model="$ctrl.form.tokens" name="tokens" type="text" ng-required="true" placeholder="{{\'users.add.free.tokens.form.tokens\'| translate}}"></md-input-container></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="$ctrl.cancelDialog()" data-translate="global.button.cancel"></md-button><md-button ng-click="$ctrl.addFreeTokens($ctrl.form)" data-translate="global.button.save" ng-disabled="form.$invalid"></md-button></md-dialog-actions></form>');
$templateCache.put('app/account/users/set-counters/set-counters.dialog.html','<md-dialog aria-label=""><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="users.set.counters"></h2></div></md-toolbar><set-counters set-counters-callback="items.setCountersCallback"></set-counters></md-dialog>');
$templateCache.put('app/account/users/set-counters/set-counters.template.html','<form name="form" ng-cloak><md-dialog-content layout-margin><md-input-container class="md-block" flex-gt-sm flex="70"><md-radio-group ng-model="vm.contractType" layout="row" layout-padding><md-radio-button ng-value="0"><span data-translate="users.model.usertests.type.docs"></span></md-radio-button><md-radio-button ng-value="1"><span data-translate="users.model.usertests.type.chars"></span></md-radio-button></md-radio-group></md-input-container><md-input-container class="md-block" flex-gt-sm flex="90" layout="row" layout-padding><input type="number" ng-min="0" ng-max="99999999" ng-model="vm.value" name="tokens" type="text" placeholder="{{\'users.field.set.counters\'| translate}}"></md-input-container></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.cancelDialog()" data-translate="global.button.cancel"></md-button><md-button ng-click="vm.setCountersCallback(vm.value, vm.contractType)" data-translate="global.button.save" ng-disabled="vm.value == null && vm.contractType == null"></md-button></md-dialog-actions></form>');
$templateCache.put('app/account/users/user-details/user-details.template.html','<div class="details-info" hide-xs layout="row" layout-padding><div layout="row" flex="40"><div layout="column" flex="50"><div layout="column" flex ng-if="$ctrl.onUser.userSchoolType != 6"><span class="detail-label" data-translate="users.model.phone">Telefon</span></div><div layout="column" flex><span class="detail-label" data-translate="users.model.role">Rola</span></div><div layout="column" flex ng-if="$ctrl.onIsSuperadmin && $ctrl.onUser.userSchoolType != 6"><span class="detail-label" data-translate="users.model.organisationalunit"></span></div></div><div layout="column" flex="50"><div layout="row" flex ng-if="$ctrl.onUser.userSchoolType != 6"><span class="detail-info user-details">{{$ctrl.onUserDetails.phoneNumber}}</span></div><div layout="row" flex><span class="detail-info user-details">{{ $ctrl.onGetUserRole($ctrl.onUser).translationKey | translate }}</span></div><div layout="row" flex ng-if="$ctrl.onIsSuperadmin && $ctrl.onUser.userSchoolType != 6"><span class="detail-info user-details">{{$ctrl.onUser.organisationalUnit}}</span></div></div></div><div layout="row" flex="40"><div layout="column" flex="50"><div layout="column" flex ng-if="!$ctrl.hideUserHistory"><span class="detail-label" data-translate="users.model.lastlogindate">Data ostatniego logowania</span></div><div layout="column" flex ng-if="!$ctrl.hideUserHistory"><span class="detail-label" data-translate="users.model.registerdate">Data utworzenia/span></span></div><div layout="column" flex ng-if="!$ctrl.hideUserHistory"><span class="detail-label" data-translate="users.model.login-counter"></span></div></div><div layout="column" flex="50"><div layout="row" flex ng-if="!$ctrl.hideUserHistory"><span class="detail-info user-details">{{$ctrl.onUserDetails.lastLoginDate| date: \'yyyy-MM-dd HH:mm\'}}</span></div><div layout="row" flex ng-if="!$ctrl.hideUserHistory"><span class="detail-info user-details">{{$ctrl.onUserDetails.registrationDate| date: \'yyyy-MM-dd HH:mm\'}}</span></div><div layout="row" flex ng-if="!$ctrl.hideUserHistory"><span class="detail-info user-details">{{$ctrl.onUserDetails.loginCounter}}</span></div></div></div><div layout="row" flex="20" class="show-docs" ng-click="$ctrl.getDocuments($ctrl.onUser)"><span data-translate="users.button.showdocs">Poka\u017C dokumenty</span> (<span id="documents-no" class="user-details">{{$ctrl.onUserDetails.documentsCount}}</span>)</div></div><div class="details-info" hide-xs layout="row" layout-padding ng-if="$ctrl.onIsSuperadmin"><div layout="row" flex="40"><div layout="column" flex ng-if="$ctrl.onIsSuperadmin"><span class="detail-label" data-translate="global.model.region"></span></div></div><div layout="row" flex="50"><div layout="column" flex ng-if="$ctrl.onIsSuperadmin"><span class="detail-info user-details" ng-if="$ctrl.onUserDetails.clientRegions.allRegions">ALL </span><span class="detail-info user-details" ng-repeat="region in $ctrl.onUserDetails.clientRegions.userRegions" ng-if="region.enabled">{{region.name}}</span></div></div></div>');
$templateCache.put('app/account/users/user-history/user-history.dialog.html','<md-dialog aria-label="" class="upload-text"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="users.history.window.title"></h2></div></md-toolbar><user-history></user-history></md-dialog>');
$templateCache.put('app/account/users/user-history/user-history.template.html','<form name="form" ng-cloak><md-dialog-content><md-table-container flex layout="row" layout-margin class="table-fixed-container"><table md-table md-progress="vm.promise" class="table-fixed"><thead md-head md-order="vm.query.order" md-on-reorder="vm.getUserHistory"><tr md-row><th md-column class="table-td-30"><span data-translate="users.history.changed.field.name"></span></th><th md-column class="table-td-30"><span data-translate="users.history.old.value"></span></th><th md-column class="table-td-30"><span data-translate="users.history.new.value"></span></th><th md-column class="table-td-30"><span data-translate="users.history.user.changing"></span></th><th md-column class="column-datetime"><span data-translate="users.history.change.date"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="row in $ctrl.userHistoryList"><td md-cell>{{row.fieldName}}</td><td md-cell>{{row.fieldValueOld}}</td><td md-cell>{{row.fieldValueNew}}</td><td md-cell>{{row.userChangingEmail}}</td><td md-cell>{{row.changeDate | date:\'yyyy-MM-dd HH:mm\'}}</td></tr></tbody></table></md-table-container></md-dialog-content><md-dialog-actions layout="row"><md-button ng-click="$ctrl.closeDialog()" data-translate="global.button.cancel"></md-button></md-dialog-actions></form>');
$templateCache.put('app/account/users/user-login-history/user-login-history.template.html','<md-dialog flex-gt-lg="65" flex-lg="70" flex-md="85" flex-xs="95"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="users.user-login-history.title"></h2></div></md-toolbar><md-dialog-content><md-table-container layout="row"><table md-table md-progress="vm.pending"><thead md-head><tr md-row><th md-column><span data-translate="users.user-login-history.user-email"></span></th><th md-column><span data-translate="users.user-login-history.status"></span></th><th md-column><span data-translate="users.user-login-history.ip-address"></span></th><th md-column><span data-translate="users.user-login-history.login-time"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="item in vm.page.content"><td md-cell>{{item.userEmail}}</td><td md-cell>{{item.status}}</td><td md-cell>{{item.ipAddress}}</td><td md-cell>{{item.loginTimestamp | date:\'yyyy-MM-dd HH:mm\'}}</td></tr></tbody></table></md-table-container></md-dialog-content><md-dialog-actions layout="row"><paging page="vm.page.number" page-size="vm.page.size" paging-action="vm.find(page)" show-first-last="true" show-prev-next="true" total="vm.page.totalElements"></paging><md-button aria-label="global ok" ng-click="vm.closeDialog()" data-translate="global.button.ok"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/account/users/user-import/user-import.html','<div layout="column" class="site-container"><users-menu active-tab="vm.activeTab"></users-menu><div class="table-container" flex><md-content layout="row" layout-margin><md-card flex="60" md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch aria-hidden="false" flex><div class="md-padding" ng-if="false"><md-button class="md-raised md-primary" ng-click="vm.importUsersFromXls()"><span data-translate="user.import.button-import"></span></md-button></div><div class="loader loader-user-import" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoaderActive"></md-progress-circular></div><form class="dragbox dragbox-big has-advanced-upload" ng-show="!vm.success" name="form" role="form" novalidate show-validation><upload-file on-get-the-files="vm.getTheFiles" files="vm.files" is-loading="vm.isLoading" on-available-extensions="vm.availableExtension"></upload-file></form><div class="import-info-success md-padding" ng-show="vm.userImportPending"><md-whiteframe class="md-whiteframe-1dp md-padding" layout layout-align="center center"><span><span data-translate="user.import.pending.info"></span><br><span>{{vm.filename}}</span></span></md-whiteframe><md-switch class="md-primary" aria-label="activate" ng-model="vm.dontActivate"><span data-translate="user.import.activate"></span></md-switch><div layout="row" layout-align="start center"><md-button class="md-raised md-primary" aria-label="uploadUserImportFile" ng-disabled="vm.isLoaderActive" ng-click="vm.uploadUserImportFile()"><span data-translate="user.import.info.button-upload"></span></md-button><md-button aria-label="cancelUploadUsers" ng-click="vm.cancelUploadUsers()"><span data-translate="global.button.cancel"></span></md-button></div></div><div class="import-info-success md-padding" ng-show="vm.userImportSuccess"><md-whiteframe class="md-whiteframe-1dp md-padding" layout layout-align="center center"><span><span data-translate="user.import.success.info1"></span><br><span data-translate="user.import.success.info2"></span></span></md-whiteframe></div><div class="import-info-success md-padding" ng-show="vm.userImportError"><md-whiteframe class="md-whiteframe-1dp md-padding" layout layout-align="center center"><span><span data-translate="user.import.error.info1"></span></span></md-whiteframe></div><div layout="row" flex-md="100" flex="100" class="mb-3" ng-if="\'user.import.youtube\'+vm.instanceType | translateExists"><div layout="row flex-wrap" flex="100" class="flex-wrap"><div class="youtube-holder-1" flex="100"><div class="youtube-holder-2"><iframe ng-src="{{vm.trustSrc(\'user.import.youtube\'+vm.instanceType | translate)}}" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div></div></div></div></md-card><md-card flex="40" class="md-padding"><strong><span data-translate="user.import.info.header"></span></strong><p><span data-translate="user.import.info.content1"></span> <strong>xls</strong> <span data-translate="user.import.info.content2"></span></p><ul><li ng-show="!vm.clientTypePublishingHouse"><span data-translate="user.import.column.position"></span></li><li><span data-translate="user.import.column.first-name"></span></li><li><span data-translate="user.import.column.last-name"></span></li><li><span data-translate="user.import.column.email-address"></span></li><li><span data-translate="user.import.column.organisational-unit"></span></li><li><span data-translate="user.import.column.phone-number"></span></li><li><span data-translate="user.import.column.user-school-type"></span></li><li><span data-translate="user.import.column.user-query-counter-type-chars"></span> / <span data-translate="user.import.column.user-query-counter-type-docs"></span></li></ul><md-divider></md-divider><div layout="row" layout-align="end center"><md-button class="md-raised md-primary" aria-label="downloadTemplate" ng-click="vm.downloadTemplate()"><span data-translate="user.import.info.button-template"></span></md-button></div><div layout="row" layout-align="end center"><span data-translate="user.import.info.in-case-of-error"></span></div></md-card></md-content></div></div>');
$templateCache.put('app/account/users/user-regions/user-regions.template.html','<md-dialog aria-label=""><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="users.table.menu.edit-client-regions"></h2></div></md-toolbar><form name="form" ng-cloak><md-dialog-content layout-margin><md-input-container class="md-block" layout="row"><div><md-checkbox ng-model="vm.allRegions" class="add-without-checking-switch-text">ALL</md-checkbox></div><div ng-repeat="region in vm.clientRegions"><md-checkbox ng-model="region.enabled" ng-disabled="vm.allRegions">{{ region.name }}</md-checkbox></div></md-input-container></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="vm.cancelDialog()" data-translate="global.button.cancel" aria-label="cancelButton"></md-button><md-button ng-click="vm.saveUserRegions(vm.form)" data-translate="global.button.save" ng-disabled="form.$invalid" aria-label="go"></md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/account/users/users-form/users-form.html','<div layout="column" class="site-container"><md-content class="users" layout="row"><div layout-align="center center"><header class="header"><h5 ng-if="!vm.form.id" data-translate="users.form.title-user-new"></h5><h5 ng-if="vm.form.id" data-translate="users.form.title-user-edit"></h5></header></div></md-content><div class="table-container" flex><md-content layout="row" layout-margin><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch aria-hidden="false" flex><form name="form"><div layout-margin layout-wrap><div layout="row" flex="100" layout-margin layout-wrap><md-input-container flex flex-xs="100"><input name="firstName" placeholder="{{!vm.form.userName ? \'users.model.firstname.placeholder\' : \'users.model.firstname\' | translate}}" ng-model="vm.form.userName" ng-required="true"></md-input-container><md-input-container flex flex-xs="100"><input name="lastName" placeholder="{{!vm.form.userSurname ? \'users.model.lastname.placeholder\' : \'users.model.lastname\' | translate}}" ng-model="vm.form.userSurname" ng-required="true"></md-input-container><md-input-container class="md-block" flex="30" flex-xs="100"><input type="email" name="email" ng-pattern="/^.+@.+\\..+$/" placeholder="{{!vm.form.userEmail ? \'users.model.login.placeholder\' : \'users.model.login\' | translate}}" ng-model="vm.form.userEmail" ng-required="true" ng-disabled="!vm.canEditMail"><div ng-show="form.email.$error.pattern" class="md-input-messages-animation ng-active" data-translate="global.form.email.pattern"></div></md-input-container><md-input-container flex="20" flex-xs="100" class="md-block" ng-if="!vm.user || vm.form.role != 7"><input name="userPhone" placeholder="{{!vm.form.userPhone ? \'users.model.user-phone.placeholder\' : \'users.model.user-phone\' | translate}}" ng-model="vm.form.userPhone"></md-input-container></div><div layout="row" flex="100" layout-margin layout-wrap ng-if="!vm.user || vm.form.role != 7"><md-input-container flex flex-xs="100"><md-autocomplete id="organization-autocomplete" class="white-background" md-selected-item="vm.selectedOrganization" md-search-text="vm.searchOrganizationText" md-items="organization in vm.querySearchOrganizations()" md-selected-item-change="vm.selectedOrganizationChange(organization)" md-item-text="organization.orguniLabel" md-min-length="0" md-floating-label="{{\'users.model.organisationalunit.placeholder\'| translate}}" md-no-cache="true" md-clear-button="!vm.loggedUserIsOrgUnitAdmin" md-require-match="true" md-select-on-match="true" ng-disabled="vm.loggedUserIsOrgUnitAdmin" ng-required="vm.form.role !== vm.USERSCHOOLTYPE.USER_SCHOOL_TYPE_INDIVIDUAL.id"><md-item-template><span md-highlight-text="vm.searchOrganizationText" md-highlight-flags="^i">{{organization.orguniLabel}}</span><md-tooltip md-delay="100" md-direction="top">{{organization.orguniLabel}}</md-tooltip></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{vm.searchOrganizationText}}"</md-not-found></md-autocomplete></md-input-container><md-input-container ng-if="::vm.academicTitleVisible && !vm.isSchool" flex-xs="100"><input name="academicTitle" placeholder="{{!vm.form.academicTitle ? \'users.model.academic.title.placeholder\' : \'users.model.academic.title\' | translate}}" ng-model="vm.form.academicTitle"></md-input-container><md-input-container class="md-block" ng-if="vm.isSchool && vm.form.role == 0" flex-xs="100"><input name="subject" placeholder="{{!vm.form.academicTitle ? \'users.model.subject.title.placeholder\' : \'users.model.subject.title\' | translate}}" ng-model="vm.form.academicTitle"></md-input-container><md-input-container class="md-block" flex flex-xs="100"><label for="selectRole" data-translate="users.model.role"></label><md-select placeholder="{{ \'users.model.role.placeholder\' | translate}}" id="selectRole" aria-label="docu statuses" layout-align="center center" ng-model="vm.form.role" ng-required="true"><md-option ng-value="val.type.id" ng-repeat="val in vm.roles"><em>{{\'\'+val.translationKey+\'\'| translate}}</em></md-option></md-select></md-input-container><md-input-container class="md-block" flex="30" flex-xs="100" ng-if="::vm.testPoolVisible"><input type="number" maxlength="9" min="0" max="999999999" ng-keyup="vm.userQueryCountersKeyUp($event)" ng-keypress="vm.userQueryCountersKeyPress($event)" ng-pattern="/^[0-9]+$/" name="poolOfTests" placeholder="{{ !vm.form.userQueryCounter ? \'users.model.pooloftests.placeholder\' : \'users.model.pooloftests\' | translate}}" ng-model="vm.form.userQueryCounter"></md-input-container><md-input-container class="md-block" flex flex-xs="100" ng-if="::vm.testPoolVisible"><label for="selectUserQueryCounterType" data-translate="users.model.pooloftests.type"></label><md-select placeholder="{{ \'users.model.pooloftests.type.placeholder\' | translate}}" id="selectUserQueryCounterType" aria-label="selectUserQueryCounterType3" ng-model="vm.form.userQueryCounterType" ng-required="true"><md-option ng-value="val.id" ng-repeat="val in vm.userQueryCounterTypes"><em>{{\'\'+val.type+\'\'| translate}}</em></md-option></md-select></md-input-container></div><div layout="row" flex="100" layout-margin><md-input-container class="md-block" flex="33" flex-xs="100" ng-if="vm.jsaIntegration"><label>{{\'users.model.polon-employees\' | translate }}</label><md-select ng-model="vm.form.polonEmployeeId" placeholder="{{\'users.model.polon-employees.placeholder\' | translate }}"><md-option ng-value="item.id" ng-repeat="item in vm.polonEmployees">{{ item.firstName + \', \' + item.lastName + \' \' + item.uid }}</md-option></md-select></md-input-container></div><div layout="row" flex="100" layout-align="end center"><md-button id="cancelButton" ng-click="vm.backToUserList()" data-translate="global.button.cancel"></md-button><md-button id="saveUserButton" ng-click="vm.saveUser(vm.form, $event)" class="md-raised md-primary button-waiting" data-translate="global.button.save" ng-disabled="form.$invalid"></md-button></div></div></form></md-card></md-content></div></div>');
$templateCache.put('app/account/users/users-menu/users-menu.template.html','<md-content class="users settings-menu" layout="row"><md-nav-bar md-no-ink-bar="disableInkBar" md-selected-nav-item="$ctrl.activeTab" nav-bar-aria-label="navigation links"><md-nav-item md-selected="true" name="users" md-nav-sref="users">{{\'users.menu.users\' | translate}}<md-tooltip md-delay="100" md-direction="top">{{\'users.menu.users\' | translate}}</md-tooltip></md-nav-item><md-nav-item class="tabs-menu-li-elipsis" name="userImport" md-nav-sref="user-import" ng-if="!$ctrl.onIsSuperadmin && !$ctrl.isReseller && !$ctrl.isMinistry">{{\'users.menu.import\' | translate}}</md-nav-item></md-nav-bar></md-content>');
$templateCache.put('app/account/users/users-search/users-search.template.html','<form name="formSearchUsers"><div layout-margin layout-wrap><div layout="row" flex layout-align="end center" ng-if="!$ctrl.onIsSuperadmin && !$ctrl.isReseller && !$ctrl.isMinistry"><md-button id="addUserButton" ng-click="$ctrl.addUser()" class="md-raised md-primary button-waiting" data-translate="users.button.add" aria-label="addUserButton"></md-button></div><div layout="row" layout-wrap layout-margin flex><div flex="30" flex-xs="100" layout-align="start center"><select-page-size query-request="$ctrl.onQueryRequest" on-value-chosen="$ctrl.getUsers()"></select-page-size></div><div layout="row" layout-wrap flex flex-xs="100" layout-align="end center"><md-input-container flex ng-if="$ctrl.simpleSearch" md-no-float class="md-block" layout-align="end center"><input ng-model="$ctrl.onSearchRequest.simpleSearch" placeholder="{{\'global.search.title\'| translate}}" ng-change="$ctrl.getUsers()" ng-model-options="{ debounce: $ctrl.simpleSearchDelay }"></md-input-container><md-button flex-lg="20" flex-md="35" flex-xs="100" aria-label="open" ng-click="$ctrl.toogleSearch()" id="advancedSearchBtn" class="search-buttons" ng-class="{ \'hide\': !$ctrl.simpleSearch}" data-translate="global.button.search.advanced"></md-button><md-button flex-lg="20" flex-md="35" flex-xs="100" aria-label="hide" ng-click="$ctrl.toogleSearch()" class="search-buttons" ng-class="{ \'hide\': $ctrl.simpleSearch}" data-translate="global.button.search.simple"></md-button></div></div><div layout="row" layout-margin layout-wrap ng-hide="$ctrl.simpleSearch"><div layout="row" layout-margin layout-wrap flex="100"><md-input-container flex flex-md="100" flex-xs="100" flex-sm="100" ng-show="$ctrl.onIsSuperadmin || $ctrl.isReseller || $ctrl.isMinistry"><md-autocomplete id="search-clients" md-clear-button="true" md-floating-label="{{\'users.model.clientname\'| translate}}" md-input-minlength="1" md-item-text="item.id+\' \'+item.clieName" md-items="item in $ctrl.clientSearch($ctrl.clientSearchText)" md-min-length="0" md-no-cache="$ctrl.noCache" md-search-text="$ctrl.clientSearchText" md-selected-item="$ctrl.selectedClient" md-selected-item-change="$ctrl.selectedClientChange(item)" ng-disabled="$ctrl.isDisabled" md-require-match="true" md-select-on-match="true"><md-item-template><span md-highlight-text="$ctrl.clientSearchText" md-highlight-flags="^i">{{item.clieName}} [{{item.id}}]</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{$ctrl.clientSearchText}}"</md-not-found></md-autocomplete></md-input-container><md-input-container flex flex-xs="100"><input input-number ng-model="$ctrl.onSearchRequest.search.userId" placeholder="{{\'users.model.userid\'| translate}}"></md-input-container><md-input-container class="md-block" flex flex-xs="100"><input ng-model="$ctrl.onSearchRequest.search.userName" placeholder="{{\'users.model.name\'| translate}}"></md-input-container><md-input-container class="md-block" flex flex-xs="100"><input ng-model="$ctrl.onSearchRequest.search.userEmail" placeholder="{{\'users.model.email\'| translate}}"></md-input-container></div><div layout="row" layout-margin layout-wrap flex="100"><md-input-container flex flex-sm="100" flex-xs="100" ng-show="$ctrl.canFilterOrganisationalUnits && !$ctrl.isReseller && !$ctrl.isMinistry"><md-autocomplete id="organization-autocomplete" md-selected-item="$ctrl.selectedOrganization" md-search-text="$ctrl.searchOrganizationText" md-items="organization in $ctrl.querySearchOrganizations()" md-selected-item-change="$ctrl.selectedOrganizationChange(organization)" md-item-text="organization.orguniLabel" md-min-length="0" md-floating-label="{{\'users.model.organisationalunit\'| translate}}" md-no-cache="true" md-clear-button="true" md-require-match="true" md-select-on-match="true" ng-disabled="false"><md-item-template><span md-highlight-text="$ctrl.searchOrganizationText" md-highlight-flags="^i">{{organization.orguniLabel}}</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{$ctrl.searchOrganizationText}}"</md-not-found></md-autocomplete></md-input-container><md-input-container md-no-float class="md-block" flex flex-xs="100"><label data-translate="users.model.status">Status</label><md-select ng-change="$ctrl.getUsers()" aria-label="user statuses" placeholder="{{\'users.model.status\' | translate}}" ng-model="$ctrl.onSearchRequest.search.status" layout-align="center center"><md-option ng-value="" ng-if="$ctrl.onSearchRequest.search.status || $ctrl.onSearchRequest.search.status === 0"><em>{{\'global.button.clear\'| translate}}: {{\'users.model.status\' | translate}}</em></md-option><md-option ng-value="status.id" ng-repeat="status in $ctrl.statuses"><em>{{\'\'+status.status+\'\'| translate}}</em></md-option></md-select></md-input-container><md-input-container class="md-block" flex flex-xs="100"><label data-translate="users.model.role"></label><md-select ng-change="$ctrl.getUsers()" placeholder="{{\'users.model.role\' | translate}}" aria-label="user roles" ng-model="$ctrl.onSearchRequest.search.role" layout-align="center center"><md-option ng-value="" ng-if="$ctrl.onSearchRequest.search.role || $ctrl.onSearchRequest.search.role === 0"><em>{{\'global.button.clear\'| translate}}: {{\'users.model.role\' | translate}}</em></md-option><md-option ng-value="val.type.id" ng-repeat="val in $ctrl.roles"><em>{{\'\'+val.translationKey+\'\'| translate}}</em></md-option></md-select></md-input-container><md-input-container class="md-block" flex flex-xs="100" ng-if="$ctrl.jsaIntegration"><label data-translate="users.model.matched-with-polon-employee"></label><md-select ng-change="$ctrl.getUsers()" placeholder="{{\'users.model.matched-with-polon-employee\' | translate}}" aria-label="matched with polon employee" ng-model="$ctrl.onSearchRequest.search.matchedWithPolonEmployee" layout-align="center center"><md-option ng-value="null" ng-if="$ctrl.onSearchRequest.search.matchedWithPolonEmployee || $ctrl.onSearchRequest.search.matchedWithPolonEmployee == false"><em>{{\'global.button.clear\'| translate}}: {{\'users.model.matched-with-polon-employee\' | translate}}</em></md-option><md-option ng-value="true" data-translate="global.msg.yes">Tak</md-option><md-option ng-value="false" data-translate="global.msg.no">Nie</md-option></md-select></md-input-container><md-input-container class="md-block" flex flex-xs="100" ng-if="$ctrl.onIsSuperadmin"><label data-translate="users.model.country"></label><md-select ng-change="$ctrl.getUsers()" placeholder="{{\'users.model.country\' | translate}}" aria-label="user roles" ng-model="$ctrl.onSearchRequest.search.countryId" layout-align="center center"><md-option ng-value="" ng-if="$ctrl.onSearchRequest.search.countryId || $ctrl.onSearchRequest.search.countryId === 0"><em>{{\'global.button.clear\'| translate}}: {{\'users.model.country\' | translate}}</em></md-option><md-option ng-repeat="country in $ctrl.countries" ng-value="country.id"><em>{{country.translationKey | translate}}</em></md-option></md-select></md-input-container><md-input-container class="md-block" flex flex-xs="100" ng-if="$ctrl.onIsSuperadmin"><label data-translate="global.model.region"></label><md-select ng-change="$ctrl.getUsers()" placeholder="{{\'global.model.region\' | translate}}" aria-label="user roles" ng-model="$ctrl.onSearchRequest.search.regionId" layout-align="center center"><md-option ng-value="" ng-if="$ctrl.onSearchRequest.search.regionId"><em>{{\'global.button.clear\'| translate}}: {{\'global.model.region\' | translate}}</em></md-option><md-option ng-repeat="region in $ctrl.regions" ng-value="region.id"><em>{{region.name}}</em></md-option></md-select></md-input-container><md-input-container class="md-block" flex flex-xs="100" ng-if="$ctrl.onIsSuperadmin"><label data-translate="client.model.type"></label><md-select ng-change="$ctrl.getUsers()" placeholder="{{\'client.model.type\' | translate}}" aria-label="client types" ng-model="$ctrl.onSearchRequest.search.clientTypeId" layout-align="center center"><md-option ng-if="$ctrl.onSearchRequest.search.clientTypeId != null" ng-value="">{{\'global.button.clear\'| translate}}: {{\'client.model.type\' | translate}}</md-option><md-option ng-repeat="clientType in $ctrl.clientTypesForSearch" ng-value="clientType.id">{{clientType.key | translate}}</md-option></md-select></md-input-container><md-input-container flex flex-xs="100"><label data-translate="client.model.is-client-test"></label><md-select ng-change="$ctrl.getUsers()" placeholder="{{\'client.model.is-client-test\' | translate }}" ng-model="$ctrl.onSearchRequest.search.testClient"><md-option ng-value="" ng-if="$ctrl.onSearchRequest.search.testClient || $ctrl.onSearchRequest.search.testClient === false "><em>{{\'global.button.clear\'| translate}}: {{\'client.model.is-client-test\' | translate}}</em></md-option><md-option ng-value="1" data-translate="document.search.yes"></md-option><md-option ng-value="0" data-translate="document.search.no"></md-option></md-select></md-input-container><md-input-container layout="column" flex flex-xs="100" layout-align="end center"><md-switch class="md-primary" name="Hasn\'t logged" ng-model="$ctrl.onSearchRequest.search.hasntLogged" ng-change="$ctrl.changeHasntLogged()" aria-label="Hasn\'t logged"><span data-translate="users.model.hasntlogged"></span></md-switch></md-input-container></div><div layout="row" layout-margin layout-wrap flex><div layout-margin layout-wrap flex flex-xs="100"><md-input-container flex flex-xs="100"><label data-translate="users.model.lastlogindate.from">Data od</label><md-datepicker input-date name="userLastLoginDateFrom" ng-change="$ctrl.fixDate($ctrl.onSearchRequest.search.userLastLoginDateFrom, \'userLastLoginDateFrom\', $ctrl)" ng-model="$ctrl.onSearchRequest.search.userLastLoginDateFrom"></md-datepicker><md-tooltip md-delay="100" md-direction="top">{{\'global.messages.info.dateformat\'| translate}}</md-tooltip></md-input-container><md-input-container flex flex-xs="100"><label data-translate="users.model.lastlogindate.to">Data do</label><md-datepicker input-date id="userLastLoginDateTo" ng-change="$ctrl.fixDate($ctrl.onSearchRequest.search.userLastLoginDateTo, \'userLastLoginDateTo\', $ctrl)" name="userLastLoginDateTo" ng-model="$ctrl.onSearchRequest.search.userLastLoginDateTo"></md-datepicker><md-tooltip md-delay="100" md-direction="top">{{\'global.messages.info.dateformat\'| translate}}</md-tooltip></md-input-container></div><div layout-margin layout-wrap flex flex-xs="100"><md-input-container flex flex-xs="100"><label data-translate="users.model.registerdate.from">Data do</label><md-datepicker input-date ng-change="$ctrl.fixDate($ctrl.onSearchRequest.search.registerDateFrom, \'registerDateFrom\', $ctrl)" ng-model="$ctrl.onSearchRequest.search.registerDateFrom" name="registerDateFrom"></md-datepicker><md-tooltip md-delay="100" md-direction="top">{{\'global.messages.info.dateformat\'| translate}}</md-tooltip></md-input-container><md-input-container flex flex-xs="100"><label data-translate="users.model.registerdate.to">Data do</label><md-datepicker input-date ng-change="$ctrl.fixDate($ctrl.onSearchRequest.search.registerDateTo, \'registerDateTo\', $ctrl)" ng-model="$ctrl.onSearchRequest.search.registerDateTo" name="registerDateTo"></md-datepicker><md-tooltip md-delay="100" md-direction="top">{{\'global.messages.info.dateformat\'| translate}}</md-tooltip></md-input-container></div></div></div><div layout="row" layout-xs="column" layout-padding layout-align="start" ng-hide="$ctrl.simpleSearch"><md-button aria-label="clear" class="md-raised search-buttons" ng-click="$ctrl.clear()" data-translate="global.button.clear.search"></md-button><md-button type="submit" aria-label="search" class="md-raised md-primary search-buttons" ng-click="$ctrl.getUsers()" data-translate="global.button.search">Szukaj</md-button></div></div></form>');
$templateCache.put('app/client/client-add/contract-details/contract-details.template.html','<div class="border-top" hide-xs layout="row" layout-padding><table><tbody><tr><td><small ng-if="!$ctrl.contract.isAsap" data-translate="client.model.contract.cont-num-of-plag-reports"></small></td><td><small ng-if="!$ctrl.contract.isAsap">{{$ctrl.contract.contNumOfPlagReports}}</small></td></tr><tr><td><small ng-if="!$ctrl.contract.isAsap" data-translate="client.model.contract.cont-num-of-plag-reports-left"></small></td><td><small ng-if="!$ctrl.contract.isAsap">{{$ctrl.contract.contNumOfPlagReportsLeft}}</small></td></tr><tr><td><small ng-if="!$ctrl.contract.isAsap" data-translate="client.model.contract.cont-type"></small></td><td><small ng-if="!$ctrl.contract.isAsap">{{$ctrl.contractTypeKey | translate}}</small></td></tr><tr><td><small ng-if="!$ctrl.contract.isAsap" data-translate="client.edit.contract.cont-max-doc-plag-size"></small></td><td><small ng-if="!$ctrl.contract.isAsap">{{$ctrl.contract.contMaxDocPlagSize}}</small></td></tr><tr ng-if="!$ctrl.contract.isAsap && $ctrl.contract.aiDetection"><td><small data-translate="client.edit.contract.ai.detection.pool"></small></td><td ng-if="$ctrl.contract.contAiDetectionPool"><small>{{ \'global.msg.yes\' | translate }}</small></td><td ng-if="!$ctrl.contract.contAiDetectionPool"><small>{{ \'client.edit.contract.ai.detection.unlimited\' | translate }}</small></td></tr><tr ng-if="$ctrl.contract.aiDetection && $ctrl.contract.contAiDetectionPool"><td><small ng-if="!$ctrl.contract.isAsap" data-translate="client.model.contract.cont-num-of-ai-detection"></small></td><td><small ng-if="!$ctrl.contract.isAsap">{{$ctrl.contract.contNumOfAiDetection}}</small></td></tr><tr ng-if="$ctrl.contract.aiDetection && $ctrl.contract.contAiDetectionPool"><td><small ng-if="!$ctrl.contract.isAsap" data-translate="client.model.contract.cont-num-of-ai-detection-left"></small></td><td><small ng-if="!$ctrl.contract.isAsap">{{$ctrl.contract.contNumOfAiDetectionLeft}}</small></td></tr><tr><td><small ng-if="$ctrl.contract.isAsap" data-translate="client.model.contract.asap.installation-type"></small></td><td><small ng-if="$ctrl.contract.isAsap">{{$ctrl.installationTypeKey | translate}}</small></td></tr><tr><td><small ng-if="$ctrl.contract.isAsap" data-translate="client.model.contract.asap.integration"></small></td><td><small ng-if="$ctrl.contract.isAsap">{{$ctrl.integrationTypeKey | translate}}</small></td></tr><tr><td><small data-translate="client.model.contract.notes"></small></td><td><small>{{$ctrl.contract.notes}}</small></td></tr><tr><td><small>Superadmin</small></td><td><small>{{$ctrl.contract.user}}</small></td></tr></tbody></table></div>');
$templateCache.put('app/client/client-add/steps/basic-data.html','<md-card><md-card-content><form name="form" style="width: 99%"><div layout="row" layout-xs="column" layout-padding><md-input-container flex><input name="clientName" ng-model="vm.client.basicData.name" ng-required="true" placeholder="{{\'client.model.name\' | translate}}"><plagiat-ng-messages form-element="form.clientName"></plagiat-ng-messages></md-input-container><md-input-container flex ng-if="!vm.isReseller"><label data-translate="client.model.country"></label><md-select name="country" ng-model="vm.client.basicData.countryId" ng-required="true"><md-option ng-repeat="country in vm.countries" ng-value="country.id">{{ country.translated }}</md-option></md-select><plagiat-ng-messages form-element="form.country"></plagiat-ng-messages></md-input-container><md-input-container flex><label data-translate="client.model.type"></label><md-select name="clientType" ng-model="vm.client.basicData.clientType.id" ng-required="true"><md-option ng-repeat="type in vm.clientTypes" ng-value="type.id">{{type.key | translate}}</md-option></md-select><plagiat-ng-messages form-element="form.clientType"></plagiat-ng-messages></md-input-container></div><div layout="row" layout-xs="column" layout-padding ng-if="!vm.isEdit()"><md-input-container flex><input placeholder="{{\'client.model.admin-first-name\' | translate}}" name="adminFirstName" ng-model="vm.client.basicData.adminFirstName" ng-required="true"><plagiat-ng-messages form-element="form.adminFirstName"></plagiat-ng-messages></md-input-container><md-input-container flex><input name="adminLastName" placeholder="{{\'client.model.admin-last-name\' | translate}}" ng-model="vm.client.basicData.adminLastName" ng-required="true"><plagiat-ng-messages form-element="form.adminLastName"></plagiat-ng-messages></md-input-container><md-input-container flex><input name="adminEmail" type="email" ng-pattern="/^.+@.+\\..+$/" placeholder="{{\'client.model.admin-email\' | translate}}" ng-model="vm.client.basicData.adminEmail" ng-required="true"><plagiat-ng-messages form-element="form.adminEmail"></plagiat-ng-messages></md-input-container></div><div layout="row" layout-xs="column" layout-padding><md-input-container flex="33" ng-if="!vm.isReseller"><label data-translate="client.instance"></label><md-select name="clientInstance" ng-model="vm.client.basicData.clientInstance" ng-change="vm.onClientInstanceChanged()" ng-required="true"><md-option ng-repeat="value in vm.clientInstances" ng-value="value">{{value}}</md-option></md-select><plagiat-ng-messages form-element="form.clientInstance"></plagiat-ng-messages></md-input-container><md-input-container flex="33"><label data-translate="client.model.language"></label><md-select name="clientLanguage" ng-model="vm.client.basicData.clieLang" ng-required="true"><md-option ng-repeat="value in vm.availableLanguages" ng-value="value" ng-selected="vm.client.basicData.clieLang === value">{{value | findLanguageFromKey}}</md-option></md-select><plagiat-ng-messages form-element="form.clientLanguage"></plagiat-ng-messages></md-input-container><md-input-container flex><md-switch ng-model="vm.client.basicData.clieTestClient" aria-label="client is test" class="m-0">{{\'client.model.is-client-test\' | translate}}</md-switch></md-input-container></div><div layout="row" layout-xs="column" layout-padding><md-input-container flex="33"><label data-translate="client.client-group"></label><md-select name="clientGroup" ng-model="vm.client.basicData.clientGroupId" ng-required="false"><md-option ng-value="" ng-if="vm.client.basicData.clientGroupId"><em>{{\'global.button.clear\'| translate}}: {{client.client-group | translate}}</em></md-option><md-option ng-repeat="value in vm.clientGroups" ng-value="value.id">{{value.name}}</md-option></md-select><plagiat-ng-messages form-element="form.clientGroup"></plagiat-ng-messages></md-input-container><md-input-container flex="33" ng-if="!vm.isReseller"><label data-translate="global.model.region"></label><md-select name="clientRegion" ng-model="vm.client.basicData.clientRegionId" ng-required="true"><md-option ng-value="" ng-if="vm.client.basicData.clientRegionId"><em>{{\'global.button.clear\'| translate}}: {{\'global.model.region\' | translate}}</em></md-option><md-option ng-repeat="value in vm.clientRegions" ng-value="value.id">{{value.name}}</md-option></md-select><plagiat-ng-messages form-element="form.clientRegion"></plagiat-ng-messages></md-input-container></div><div layout="row" layout-align="end center"><md-button ng-if="vm.isEdit()" name="cancelButton" aria-label="cancelButton" class="md-raised md-primary" data-translate="global.button.cancel" ui-sref="client"></md-button><md-button ng-if="!vm.isEdit()" name="stepBasicDataCompleted" aria-label="stepBasicDataCompleted" class="md-raised md-primary" data-translate="client.edit.stepper.next" ng-click="vm.onStepBasicDataCompleted()" ng-disabled="form.$invalid"></md-button><md-button ng-if="vm.isEdit()" name="saveOrUpdate" aria-label="saveOrUpdate" class="md-raised md-primary" data-translate="client.edit.button.update-client.submit" ng-click="vm.saveOrUpdate()" ng-disabled="form.$invalid || vm.isSaving"></md-button></div></form></md-card-content></md-card>');
$templateCache.put('app/client/client-add/steps/client-configuration.html','<form name="form"><md-card><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.report-settings.header"></h3></md-card-title-text><div layout="row" layout-padding layout-wrap><md-input-container flex="33" flex-xs="100" ng-repeat="value in vm.configuration.reportSettings"><md-checkbox id="{{\'reportSetting-id\' + value.label}}" name="{{\'reportSetting-name\' + value.label}}" class="md-primary" aria-label="{{\'reportSetting-aria-label\' + value.label}}" ng-model="vm.client.configuration.reportSettings[value.model]" ng-disabled="value.label === \'rubric-enabled\' && !vm.client.configuration.reportSettings.gradingEnabled"><span data-translate="{{\'client.edit.configuration.report-settings.\' + value.label}}"></span></md-input-container></div><div ng-if="vm.client.configuration.reportSettings.warningThresholds" layout="row" layout-padding><md-input-container flex="50"><input name="warningThreshold1" ng-required="true" type="number" ng-model="vm.client.configuration.similarityReportSettings.warningThreshold1" placeholder="{{\'client.report.settings.form.warning-threshold-1\' | translate}}"><plagiat-ng-messages form-element="form.warningThreshold1"></plagiat-ng-messages></md-input-container><md-input-container flex="50"><input name="warningThreshold2" ng-required="true" type="number" ng-model="vm.client.configuration.similarityReportSettings.warningThreshold2" placeholder="{{\'client.report.settings.form.warning-threshold-2\' | translate}}"><plagiat-ng-messages form-element="form.warningThreshold2"></plagiat-ng-messages></md-input-container></div><div layout="row" layout-padding><md-input-container flex="50"><input name="report2020ExpirationHours" ng-required="false" ng-pattern="/^[0-9]+$/" ng-model="vm.client.configuration.reportSettings.report2020ExpirationHours" placeholder="{{\'client.edit.configuration.report-settings.report-2020-expiration-hours\' | translate}}"><plagiat-ng-messages form-element="form.report2020ExpirationHours"></plagiat-ng-messages></md-input-container></div></md-card-content></md-card><md-card><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.original-report-settings.header"></h3></md-card-title-text><md-radio-group ng-model="vm.client.configuration.reportSettings.originalReportEnabled" layout="row" layout-padding layout-wrap><md-radio-button flex="20" flex-xs="50" class="md-primary" ng-value="0" aria-label="old"><span data-translate="client.edit.configuration.original-report-settings.old"></span></md-radio-button><md-radio-button flex="20" flex-xs="50" class="md-primary" ng-value="1" aria-label="switch"><span data-translate="client.edit.configuration.original-report-settings.switch"></span></md-radio-button><md-radio-button flex="20" flex-xs="50" class="md-primary" ng-value="2" aria-label="original"><span data-translate="client.edit.configuration.original-report-settings.original"></span></md-radio-button></md-radio-group></md-card-content></md-card><md-card><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.add-to-database.header"></h3></md-card-title-text><md-radio-group ng-model="vm.client.configuration.addToDatabase" layout="row" layout-padding layout-wrap><md-radio-button flex="20" flex-xs="50" class="md-primary" ng-repeat="obj in vm.configuration.addToDatabase" ng-value="obj.value" aria-label="{{obj.value}}"><span data-translate="{{\'client.edit.configuration.add-to-database.\' + obj.value}}"></span></md-radio-button></md-radio-group><div ng-if="vm.client.configuration.addToDatabase === \'delayed\'" layout="row" layout-padding><md-input-container flex="50" flex-xs="100"><input name="addToDatabaseDays" ng-required="false" ng-pattern="/^[0-9]+$/" ng-model="vm.client.configuration.addToDatabaseDays" placeholder="{{\'client.edit.configuration.add-to-database.days\' | translate}}"><plagiat-ng-messages form-element="form.addToDatabaseDays"></plagiat-ng-messages></md-input-container></div><div layout="row" layout-padding layout-wrap><div flex="33" flex-xs="100" layout="row" ng-repeat="value in vm.configuration.addToDatabaseSettings" ng-if="vm.available(value.model)"><md-input-container flex><md-checkbox id="{{\'addToDatabaseSettings-id\' + value.label}}" name="{{\'addToDatabaseSettings-name\' + value.label}}" class="md-primary" aria-label="{{\'addToDatabaseSettings-aria\'+ value.label}}" ng-model="vm.client.configuration.addToDatabaseSettings[value.model]"><span data-translate="{{\'client.edit.configuration.database-settings.\' + value.label}}"></span></md-input-container></div></div></md-card-content></md-card><md-card ng-if="vm.available(\'userSettingsCard\')"><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.user-settings.header"></h3></md-card-title-text><div layout="row" layout-padding layout-wrap><md-input-container flex="33" flex-xs="100" ng-repeat="value in vm.configuration.userSettings" ng-if="vm.available(value.model)"><md-checkbox name="{{\'user-settings\' + value.label}}" class="md-primary" aria-label="{{\'user-settings\'+ value.label}}" ng-model="vm.client.configuration.userSettings[value.model]"><span data-translate="{{\'client.edit.configuration.user-settings.\' + value.label}}"></span></md-input-container></div></md-card-content></md-card><md-card ng-if="vm.available(\'documentFieldCard\')"><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.document-field-settings.header"></h3></md-card-title-text><div layout="row" layout-padding layout-wrap><md-input-container flex="33" flex-xs="100" ng-repeat="value in vm.configuration.documentFieldSettings" ng-if="vm.available(value.model)"><md-checkbox id="{{\'documentFieldSettings-id\' + value.label}}" name="{{\'documentFieldSettings-name\' + value.label}}" class="md-primary" aria-label="{{\'documentFieldSettings-aria\'+ value.label}}" ng-model="vm.client.configuration.documentFieldSettings[value.model]"><span data-translate="{{\'client.edit.configuration.document-field-settings.\' + value.label}}"></span></md-input-container></div></md-card-content></md-card><md-card ng-if="vm.available(\'userGroupsCard\')"><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.user-groups-settings.header"></h3></md-card-title-text><div layout="row" layout-padding layout-wrap><md-input-container flex="33" flex-xs="100" ng-repeat="value in vm.configuration.userGroupsSettings"><md-checkbox name="{{\'user-groups-settings\' + value.label}}" class="md-primary" aria-label="{{\'user-groups-settings\'+ value.label}}" ng-model="vm.client.configuration.userGroupsSettings[value.model]"><span data-translate="{{\'client.edit.configuration.user-groups-settings.\' + value.label}}"></span></md-input-container></div></md-card-content></md-card><md-card><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.ai-detection-settings.header"></h3></md-card-title-text><div layout="row" layout-padding layout-wrap><md-input-container class="md-block" flex="20" flex-sm="100" ng-repeat="role in vm.aiDetectionRoles"><label>{{role}}</label><md-select placeholder="{{role}}" ng-model="vm.client.configuration.aiDetectionSettings[role]" layout-align="center center"><md-option ng-value="val" ng-repeat="val in vm.aiDetectionOptions"><em>{{val}}</em></md-option></md-select></md-input-container></div><div layout="row" layout-padding layout-wrap><md-input-container flex="33" flex-xs="100" ng-repeat="value in vm.configuration.aiDetectionSettings"><md-checkbox name="{{\'ai-detection\' + value.label}}" class="md-primary" aria-label="{{\'ai-detection\'+ value.label}}" ng-model="vm.client.configuration.aiDetectionSettings[value.model]"><span data-translate="{{\'client.edit.configuration.ai-detection.\' + value.label}}"></span></md-input-container></div><div layout="row" layout-padding layout-wrap><md-input-container flex="50"><input name="aiDetectionThreshold" ng-required="true" ng-pattern="/^(0(\\.\\d+)?|1(\\.0+)?)$/" ng-model="vm.client.configuration.aiDetectionSettings.aiDetectionThreshold" placeholder="{{\'client.edit.configuration.ai-detection.ai-detection-threshold\' | translate}}"><plagiat-ng-messages form-element="form.aiDetectionThreshold"></plagiat-ng-messages></md-input-container></div></md-card-content></md-card><md-card><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.grammar-check-settings.header"></h3></md-card-title-text><div layout="row" layout-padding layout-wrap><md-input-container class="md-block" flex="20" flex-sm="100" ng-repeat="role in vm.aiDetectionRoles"><label>{{role}}</label><md-select placeholder="{{role}}" ng-model="vm.client.configuration.grammarCheckSettings[role]" layout-align="center center"><md-option ng-value="val" ng-repeat="val in vm.aiDetectionOptions"><em>{{val}}</em></md-option></md-select></md-input-container></div></md-card-content></md-card><md-card><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.other-settings.header"></h3></md-card-title-text><div layout="row" layout-padding layout-wrap><div flex="33" flex-xs="100" layout="row" ng-repeat="value in vm.configuration.otherSettings" ng-if="vm.available(value.model)"><md-input-container flex><md-checkbox id="{{\'otherSetting-id\' + value.label}}" name="{{\'otherSetting-name\' + value.label}}" class="md-primary" aria-label="{{\'otherSetting-aria\'+ value.label}}" ng-model="vm.client.configuration.otherSettings[value.model]"><span data-translate="{{\'client.edit.configuration.other-settings.\' + value.label}}"></span></md-input-container><md-input-container flex ng-if="vm.client.configuration.otherSettings[value.model] && value.type == \'checkbox+list\'"><md-select id="documentKindSelect" aria-label="docu kinds" ng-model="vm.client.configuration.otherSettings[value.model+\'Value\']" ng-required="vm.client.configuration.otherSettings[value.model]"><md-option id="idOptionDocuKind{{$index}}" ng-value="val" ng-repeat="val in value.valuesForList">{{val}}</md-option></md-select></md-input-container></div><md-input-container flex="50" ng-if="vm.client.configuration.otherSettings.assignmentsEnabled"><input name="maxAssignmentCorrections" ng-required="true" ng-pattern="/^[0-9]+$/" ng-model="vm.client.configuration.otherSettings.maxAssignmentCorrections" placeholder="{{\'client.edit.configuration.other-settings.max-assignment-corrections\' | translate}}"><plagiat-ng-messages form-element="form.maxAssignmentCorrections"></plagiat-ng-messages></md-input-container></div></md-card-content></md-card><md-card><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.rare-settings.header"></h3></md-card-title-text><div layout="row" layout-padding layout-wrap><div flex="33" flex-xs="100" layout="row" ng-repeat="value in vm.configuration.rareSettings" ng-if="vm.available(value.model)"><md-input-container flex><md-checkbox id="{{\'rareSetting-id\' + value.label}}" name="{{\'rareSetting-name\' + value.label}}" class="md-primary" aria-label="{{\'rareSetting-aria\'+ value.label}}" ng-model="vm.client.configuration.otherSettings[value.model]"><span data-translate="{{\'client.edit.configuration.other-settings.\' + value.label}}"></span></md-input-container><md-input-container flex ng-if="vm.client.configuration.otherSettings[value.model] && value.type == \'checkbox+list\'"><md-select id="documentKindSelect" aria-label="docu kinds" ng-model="vm.client.configuration.otherSettings[value.model+\'Value\']" ng-required="vm.client.configuration.otherSettings[value.model]"><md-option id="idOptionDocuKind{{$index}}" ng-value="val" ng-repeat="val in value.valuesForList">{{val}}</md-option></md-select></md-input-container></div><md-chips flex="100" ng-if="vm.client.configuration.otherSettings.reservedEmails" name="reserved-emails-setting.domain-list" aria-label="reserved-emails-setting.domain-list" placeholder="{{\'client.edit.configuration.other-settings.reserved-emails.domain-list.placeholder\' | translate}}" ng-model="vm.client.configuration.otherSettings.reservedEmailsDomainList" md-removable="true" md-add-on-blur="true"><md-chip-template>{{$chip}}</md-chip-template></md-chips><md-input-container flex="100" ng-if="vm.client.configuration.otherSettings.acceptRegulationsEnabled"><input name="regulationsUrl" ng-model="vm.client.configuration.otherSettings.regulationsUrl" ng-required="true" placeholder="{{\'client.edit.configuration.other-settings.regulations-url\' | translate}}"><plagiat-ng-messages form-element="form.regulationsUrl"></plagiat-ng-messages></md-input-container><md-input-container flex="100" ng-if="vm.client.configuration.otherSettings.passwordChange"><input name="passwordChangePeriod" ng-model="vm.client.configuration.otherSettings.passwordChangePeriod" ng-required="true" ng-pattern="/^[0-9]+$/" placeholder="{{\'client.edit.configuration.other-settings.password-change-period\' | translate}}"><plagiat-ng-messages form-element="form.passwordChangePeriod"></plagiat-ng-messages></md-input-container></div></md-card-content></md-card><md-card ng-if="vm.available(\'jsaOrppdCard\')"><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.jsa-orppd-settings.header"></h3></md-card-title-text><div layout="row" layout-padding layout-wrap><div flex="33" flex-xs="100" layout="row" ng-repeat="value in vm.configuration.jsaOrppdSettings" ng-if="vm.available(value.model)"><md-input-container flex><md-checkbox id="{{\'jsaOrppdSettings-id\' + value.label}}" name="{{\'jsaOrppdSettings-name\' + value.label}}" class="md-primary" aria-label="{{\'jsaOrppdSettings-aria\'+ value.label}}" ng-model="vm.client.configuration.jsaOrppdSettings[value.model]"><span data-translate="{{\'client.edit.configuration.jsa-orppd-settings.\' + value.label}}"></span></md-input-container></div></div></md-card-content></md-card><md-card ng-if="vm.client.configuration.otherSettings.permUserUploadSupport"><md-card-content><md-card-title-text><h3 data-translate="client.edit.configuration.upload-permissions.header"></h3></md-card-title-text><div layout="row" layout-padding layout-wrap><md-input-container flex="33" ng-repeat="value in vm.configuration.uploadPermissions"><md-checkbox id="{{\'uploadPermission-id\' + value.label}}" name="{{\'uploadPermission-name\' + value.label}}" class="md-primary" aria-label="{{\'uploadPermission \'+ value.label}}" ng-model="vm.client.configuration.uploadPermissions[value.model]"><span data-translate="{{\'client.edit.configuration.upload-permission.\' + value.label}}"></span></md-input-container></div></md-card-content></md-card><div layout="row" layout-align="end center" layout-padding><md-button ng-if="vm.isEdit()" id="cancelButton" aria-label="cancel" class="md-raised md-primary" data-translate="global.button.cancel" ui-sref="client"></md-button><md-button ng-if="!vm.isEdit()" id="prevStep" aria-label="prevStep" class="md-raised md-primary" data-translate="client.edit.stepper.previous-step" ng-click="vm.previousStep()"></md-button><md-button id="saveOrUpdate" aria-label="saveOrUpdate" class="md-raised md-primary" data-translate="{{!vm.isEdit() ? \'client.edit.button.create-client.submit\' : \'client.edit.button.update-client.submit\'}}" ng-click="vm.saveOrUpdate()" ng-disabled="form.$invalid || vm.isSaving"></md-button></div></form>');
$templateCache.put('app/client/client-add/steps/client-create-step-code-account.html','<form name="form"><md-card><md-card-title><md-card-title-text><h3 data-translate="client.code-account.currency.header"></h3></md-card-title-text></md-card-title><md-card-content><div layout="row" layout-xs="column" layout-padding layout-wrap><md-input-container flex="20" ng-repeat="currency in vm.availableCurrencies"><md-checkbox name="{{\'currencie-name\' + currency}}" class="md-primary" aria-label="{{\'currencie-aria-label\' + currency}}" ng-checked="vm.client.codeAccount.currencies.indexOf(currency) > -1" ng-click="vm.onClickCurrency(currency)">{{currency}}</md-input-container><p class="text text-danger" flex="100" ng-if="vm.client.codeAccount.currencies.length == 0" data-translate="global.error.no-element-selected"></p></div></md-card-content></md-card><md-card><md-card-title><md-card-title-text><h3 data-translate="client.code-account.payment-option.header"></h3></md-card-title-text></md-card-title><md-card-content><div layout="row" layout-xs="column" layout-padding layout-wrap ng-class="{\'border-bottom\': !$last}" ng-repeat="currency in vm.client.codeAccount.currencies"><h3 flex="5">{{currency}}</h3><md-input-container flex="20" ng-repeat="paymentMethod in vm.availablePayments[currency]"><md-checkbox name="{{\'paymentOption-name\' + paymentMethod}}" class="md-primary" aria-label="{{\'paymentOption-aria-label\' + paymentMethod}}" ng-checked="vm.client.codeAccount.payments[currency].indexOf(paymentMethod) > -1" ng-click="vm.onClickPayment(currency, paymentMethod)"><img ng-src="{{vm.instance == \'ro\' && paymentMethod == \'TYPE_MOBILPAY_SMS\' ? \'content/images/pay-mobilpay-ro.png\' : (\'content/images/\' + vm.paymentInit[paymentMethod].img)}}" style="max-height: 2rem"></md-input-container><p flex="100" class="text text-danger" ng-if="!vm.client.codeAccount.payments[currency] || vm.client.codeAccount.payments[currency].length == 0" data-translate="global.error.no-element-selected"></p></div></md-card-content></md-card><md-card><md-card-title><md-card-title-text><h3 data-translate="client.code-account.code-name-size-currency.header"></h3></md-card-title-text></md-card-title><md-card-content><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span data-translate="client.code-account.document-size-currency.name"></span></th><th md-column><span data-translate="client.code-account.document-size-currency.size"></span></th><th md-column ng-repeat="currency in vm.client.codeAccount.currencies">{{currency}}</th></tr></thead><tbody md-body><tr md-row ng-repeat="value in vm.client.codeAccount.codeTypePrices track by $index"><td md-cell><md-input-container class="w-100"><input name="{{$index}}documentName" aria-label="documentName" ng-model="value.name" ng-change="vm.isEverythingValidEngine()" ng-required="true"><plagiat-ng-messages form-element="form[$index + \'documentName\']"></plagiat-ng-messages></md-input-container></td><td md-cell><md-input-container class="w-100"><input type="number" name="{{$index}}documentSize" aria-label="documentSize" min="0" ng-change="vm.isEverythingValidEngine()" ng-model="value.size" ng-required="true"><plagiat-ng-messages form-element="form[$index + \'documentSize\']"></plagiat-ng-messages></md-input-container></td><td md-cell ng-repeat="currency in vm.client.codeAccount.currencies"><md-input-container class="w-100"><input type="number" name="{{$parent.$index + currency}}currency" aria-label="documentCurrency" ng-model="value.currencyPrices[currency]" ng-change="vm.isEverythingValidEngine()" min="0" ng-required="true"><plagiat-ng-messages form-element="form[$parent.$index + currency + \'currency\']"></plagiat-ng-messages></md-input-container></td><td md-cell><md-button name="deleteButton" aria-label="deleteButton" class="md-raised md-primary" data-translate="global.button.remove" ng-click="vm.deleteCodeTypePrices($index)"></md-button></td></tr></tbody></table></md-table-container><div layout="row" layout-align="begin center"><md-button name="addCodeTypePrices" class="md-raised md-primary" aria-label="addCodeTypePrices" data-translate="global.button.add" ng-click="vm.addCodeTypePrices()"></md-button></div></md-card-content></md-card><div layout="row" layout-align="end center"><md-button ng-if="vm.isEdit()" name="cancelButton" aria-label="cancelButton" class="md-raised md-primary" data-translate="global.button.cancel" ui-sref="client"></md-button><md-button ng-if="!vm.isEdit()" name="prevStep" aria-label="prevStep" class="md-raised md-primary" data-translate="client.edit.stepper.previous-step" ng-click="vm.previousStep()"></md-button><md-button ng-if="!vm.isEdit()" name="stepBasicDataCompleted" aria-label="stepBasicDataCompleted" class="md-raised md-primary" data-translate="client.edit.stepper.next" ng-click="vm.onClickNext()" ng-disabled="form.$invalid"></md-button><md-button ng-if="vm.isEdit()" name="saveOrUpdate" aria-label="saveOrUpdate" class="md-raised md-primary" data-translate="client.edit.button.update-client.submit" ng-click="vm.saveOrUpdate()" ng-disabled="form.$invalid || vm.isSaving || !vm.isEverythingValid"></md-button></div></form>');
$templateCache.put('app/client/client-add/steps/contract.html','<form name="form" class="client-finders-configuration"><div layout="column" flex-gt-lg="100" layout-padding><md-card><md-card-title><md-card-title-text><span class="md-headline">{{ \'client.edit.contract.plagiat\' | translate }}</span></md-card-title-text></md-card-title><md-card-content layout="column" layout-padding><client-contract client="vm.client" on-is-edit="vm.isEdit()"></client-contract><md-divider></md-divider><span class="md-title" data-translate="client.edit.finders-configuration">Liczba zapyta\u0144</span><md-table-container><table md-table class="finders-table"><thead md-head><tr md-row><th md-column class="finder-enabled"><span data-translate="client.edit.finders-configuration.th.enabled"></span></th><th md-column><span data-translate="client.edit.finders-configuration.th.finder-name"></span></th><th md-column class="finder-visible"><span data-translate="client.edit.finders-configuration.th.visible"></span></th><th md-column><span data-translate="client.edit.finders-configuration.th.queries-per-kilo"></span></th></tr></thead><tbody md-body><tr ng-repeat="finder in vm.availableFinders" md-row><td md-cell><md-checkbox ng-model="vm.findersSelection[finder.id]" ng-change="vm.toggleFinderSelection(finder.id)" aria-label="a"></md-checkbox></td><td md-cell>{{finder.description | translate}}</td><td md-cell><md-input-container><md-switch class="md-primary" aria-label="b" ng-disabled="!vm.findersSelection[finder.id]" ng-model="vm.client.findersConfiguration[finder.id].visible"></md-switch></md-input-container></td><td md-cell><md-input-container><input type="number" min="0" ng-model="vm.client.findersConfiguration[finder.id].queriesPerKilo" ng-disabled="!vm.findersSelection[finder.id]" aria-label="queriesPerKilo"></md-input-container></td></tr></tbody></table></md-table-container><div layout="row"><md-input-container flex class="pl-2"><md-checkbox ng-model="vm.client.isDatabaseExchangeProgramMember" ng-change="vm.client.databaseExchangeSourcesVisible = !!vm.client.isDatabaseExchangeProgramMember">{{\'client.model.contract.is-database-exchange-program-member\' | translate}}</md-checkbox></md-input-container><md-input-container flex ng-if="vm.client.isDatabaseExchangeProgramMember == true" class="pl-3"><md-switch class="md-primary m-0" ng-model="vm.client.databaseExchangeSourcesVisible" aria-label="database exchange sources visible">{{\'client.edit.finders-configuration.th.visible\' | translate}}</md-switch></md-input-container><md-input-container flex ng-if="vm.client.isDatabaseExchangeProgramMember == true" class="pl-3"><md-switch ng-model="vm.client.clientIsHidden" aria-label="client is hidden" class="m-0">{{\'client.model.contract.is-client-hidden\' | translate}}</md-switch></md-input-container></div></md-card-content></md-card></div><div class="space-top1"></div><md-divider></md-divider><md-card flex ng-if="vm.shouldShowAsapSection()"><md-card-title><md-card-title-text><span class="md-headline">{{ \'client.edit.contract.asap\' | translate }}</span></md-card-title-text></md-card-title><md-card-content layout="column" layout-padding><div layout="row"><md-input-container flex="66"><md-radio-group ng-model="vm.client.asapContract.installationType" class="md-primary" layout="row" required><md-radio-button value="{{vm.asapContractInstallation.INSTALL_TYPE_BASIC.id}}" flex="50">{{vm.asapContractInstallation.INSTALL_TYPE_BASIC.key | translate}}</md-radio-button><md-radio-button value="{{vm.asapContractInstallation.INSTALL_TYPE_STANDARD.id}}" flex="50">{{vm.asapContractInstallation.INSTALL_TYPE_STANDARD.key | translate}}</md-radio-button></md-radio-group></md-input-container><md-input-container flex="33"><label data-translate="client.model.contract.asap.integration">Integracja</label><md-select ng-model="vm.client.asapContract.integrationType"><md-option ng-repeat="integrationType in vm.asapContractIntegrationTypes" ng-value="integrationType.id">{{integrationType.key | translate}}</md-option></md-select></md-input-container></div><md-divider></md-divider><div layout="row"><md-input-container flex><label data-translate="client.model.contract.date-from">Data od</label><md-datepicker required ng-model="vm.client.asapContract.dateFrom" md-max-date="vm.client.asapContract.dateTo" input-date></md-datepicker></md-input-container><md-input-container flex><label data-translate="client.model.contract.date-to">Data do</label><md-datepicker required ng-model="vm.client.asapContract.dateTo" md-min-date="vm.client.asapContract.dateFrom" input-date></md-datepicker></md-input-container></div></md-card-content></md-card><md-card ng-if="vm.contractHistory"><md-card-title><md-card-title-text><span class="md-headline">{{ \'client.edit.contract.history\' | translate }}</span></md-card-title-text></md-card-title><md-card-content><md-table-container><table md-table><thead md-head><tr md-row><th md-column><span data-translate="client.edit.contract.create-date"></span></th><th md-column><span data-translate="client.edit.contract.disable-date"></span></th><th md-column><span data-translate="client.model.contract.date-from"></span></th><th md-column><span data-translate="client.model.contract.date-to"></span></th><th md-column><span data-translate="client.edit.contract.type"></span></th><th md-column><span data-translate="client.model.contract.percent-of-plag-reports-used"></span></th><th md-column><span data-translate="client.model.contract.ai-detection"></span></th><th md-column><span data-translate="client.edit.configuration.grammar-check.grammar-check"></span></th></tr></thead><tbody md-body><tr ng-repeat-start="contractRevision in vm.contractHistoryPage track by $index" md-row ng-click="vm.expandedContractHistoryItems[$index + vm.contractHistoryPageOffset()] = !vm.expandedContractHistoryItems[$index + vm.contractHistoryPageOffset()]"><td md-cell>{{contractRevision.createDate ? (contractRevision.createDate | date:\'dd.MM.yyyy\') : \'---\'}}</td><td md-cell>{{contractRevision.disableDate ? (contractRevision.disableDate | date:\'dd.MM.yyyy\') : \'---\'}}</td><td md-cell>{{contractRevision.dateFrom ? ( contractRevision.dateFrom | date:\'dd.MM.yyyy\') : \'---\'}}</td><td md-cell>{{contractRevision.dateTo ? ( contractRevision.dateTo | date:\'dd.MM.yyyy\') : \'---\'}}</td><td md-cell>{{(contractRevision.isAsap ? \'client.edit.contract.asap\' : \'client.edit.contract.plagiat\') | translate }}</td><td md-cell>{{contractRevision.percentOfPlagReportsUsed + \'%\'}}</td><td md-cell>{{contractRevision.aiDetection ? (\'global.msg.yes\' | translate) : (\'global.msg.no\' | translate)}}</td><td md-cell>{{contractRevision.grammarCheck ? (\'global.msg.yes\' | translate) : (\'global.msg.no\' | translate)}}</td></tr><tr ng-repeat-end><td colspan="8" ng-if="vm.expandedContractHistoryItems[$index + vm.contractHistoryPageOffset()]"><contract-details contract="vm.contractHistory[$index + vm.contractHistoryPageOffset()]"></contract-details></td></tr></tbody></table></md-table-container><div layout="row"><paging page="vm.contractHistoryPageNumber" page-size="vm.contractHistoryPageSize" total="vm.contractHistoryTotalNumOfRecords" paging-action="vm.chooseContractHistoryPage(page)"></paging></div></md-card-content></md-card><div layout="row" layout-align="end center"><md-button ng-if="vm.isEdit()" id="cancelButton" aria-label="cancelButton" class="md-raised md-primary" data-translate="global.button.cancel" ui-sref="client"></md-button><md-button ng-if="!vm.isEdit()" id="prevStep" aria-label="prevStep" class="md-raised md-primary" data-translate="client.edit.stepper.previous-step" ng-click="vm.previousStep()"></md-button><md-button ng-if="!vm.isEdit()" id="stepContractCompleted" aria-label="stepContractCompleted" class="md-raised md-primary" data-translate="client.edit.stepper.next" ng-click="vm.stepContractCompleted()" ng-disabled="form.$invalid"></md-button><md-button ng-if="vm.isEdit()" id="saveOrUpdate1" aria-label="saveOrUpdate" class="md-raised md-primary" data-translate="client.edit.button.update-client.submit" ng-click="vm.saveOrUpdate()" ng-disabled="form.$invalid || vm.isSaving"></md-button></div></form>');
$templateCache.put('app/components/document/document-details/document-details.template.html','<div class="border-top pl-5" layout="row" layout-padding flex><div layout="row" flex="50"><div layout="column" flex="100"><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="document.table.details.id">ID dokumentu</small> <small flex>{{$ctrl.onDocumentDetails.documentIdShort}}</small></div><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="document.table.details.upload-date">Data wgrania pracy</small> <small flex>{{$ctrl.onDocumentDetails.docuSubmitDate | date: \'yyyy-MM-dd HH:mm\'}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onDocumentDetails.docuReportDate"><small flex class="text-muted" data-translate="document.table.details.report">Raport podobie\u0144stwa</small> <small flex>{{$ctrl.onDocumentDetails.docuReportDate | date: \'yyyy-MM-dd HH:mm\'}}</small></div></div></div><div layout="row" flex="50"><div layout="column" flex="100"><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="document.table.details.format">Format pliku</small> <small flex>{{$ctrl.onDocumentDetails.fileFormat}}</small></div><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="document.table.details.size">Rozmiar</small> <small flex>{{$ctrl.onDocumentDetails.docuSize}}</small></div><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="document.table.details.extra-options">Wybrane opcje</small> <small flex><span ng-repeat="optionKey in $ctrl.onDocumentDetails.docuExtraOptions track by $index">{{$index > 0 ? \', \' : \'\'}}{{optionKey | translate}}</span></small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onDocumentDetails.services"><small flex class="text-muted" data-translate="document.table.details.auto-translations">Automatic translations</small> <small flex ng-if="$ctrl.onDocumentDetails.autoTranslationsFromLang">{{(\'document.report.similarity.language.\' + $ctrl.onDocumentDetails.autoTranslationsFromLang.toLowerCase()) | translate}} > {{(\'document.report.similarity.language.\' + $ctrl.onDocumentDetails.autoTranslationsToLang.toLowerCase()) | translate}}</small> <small flex ng-if="!$ctrl.onDocumentDetails.autoTranslationsFromLang">{{(\'document.report.similarity.language.\' + $ctrl.onDocumentDetails.autoTranslationsToLang.toLowerCase()) | translate}}</small></div></div></div></div>');
$templateCache.put('app/components/document/document-form/document-form.dialog.html','<md-dialog aria-label="upload-text" class="upload-text"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="document.edit-action"></h2></div></md-toolbar><document-form></document-form></md-dialog>');
$templateCache.put('app/components/document/document-form/document-form.template.html','<form name="form" ng-cloak><md-dialog-content><div class="md-dialog-content" layout-margin><md-input-container class="md-block" flex-gt-sm><input ng-model="$ctrl.form.docuTitle" name="title" type="text" placeholder="{{!$ctrl.form.docuTitle ? \'document.metric.placeholder.title\' : \'document.form.title\' | translate}}" required></md-input-container><div layout="row" layout-wrap layout-margin flex ng-if="::$ctrl.isCoordinatorVisible()"><!-- SEPARATE COORDINATOR TITLE, FIRSTNAME AND SURNAME --><md-input-container class="md-block" flex="20" flex-xs="100" ng-if="!$ctrl.authorsSimplifiedFields"><input placeholder="{{$ctrl.clientTypeSchool ? \'document.metric.client.teacher.title\' : \'document.metric.client.promoter.title\' | translate}}" ng-model="$ctrl.onUploadObj.coordinatorDTO.title"></md-input-container><md-input-container class="md-block" flex flex-xs="100" ng-if="!$ctrl.authorsSimplifiedFields"><input name="coordinatorFirstName" placeholder="{{$ctrl.clientTypeSchool ? \'document.metric.client.teacher.first-name\' : \'document.metric.client.promoter.firstname\' | translate}}" ng-model="$ctrl.onUploadObj.coordinatorDTO.firstName" ng-required="$ctrl.onUploadObj.coordinatorInfo.isMandatory && !$ctrl.onIsLecturer"><plagiat-ng-messages form-element="form.coordinatorFirstName"></plagiat-ng-messages></md-input-container><md-input-container class="md-block" flex flex-xs="100" ng-if="!$ctrl.authorsSimplifiedFields"><input name="coordinatorLastName" placeholder="{{$ctrl.clientTypeSchool ? \'document.metric.client.teacher.last-name\' : \'document.metric.client.promoter.surname\' | translate}}" ng-model="$ctrl.onUploadObj.coordinatorDTO.lastName" ng-required="$ctrl.onUploadObj.coordinatorInfo.isMandatory && !$ctrl.onIsLecturer"><plagiat-ng-messages form-element="form.coordinatorLastName"></plagiat-ng-messages></md-input-container><!-- ONLY ONE COORDINATOR FIELD: BOTH TITLE,NAME AND SURNAME COMBINED --><md-input-container class="md-block" flex flex-xs="100" ng-if="$ctrl.authorsSimplifiedFields"><input name="coordinatorSimplifiedFields" placeholder="{{$ctrl.clientTypeSchool ? \'document.metric.client-type.school.teacher\' : \'document.metric.client.promoter.placeholder.fullname\' | translate}}" ng-model="$ctrl.onUploadObj.coordinatorDTO.firstName" ng-required="$ctrl.onUploadObj.coordinatorInfo.isMandatory && !$ctrl.onIsLecturer"><plagiat-ng-messages form-element="form.coordinatorSimplifiedFields"></plagiat-ng-messages></md-input-container></div><md-input-container class="md-block" flex-gt-sm ng-if="$ctrl.uploadObj.coordinatorInfo.isPresent\n            && $ctrl.uploadObj.coordinatorInfo.selectItems.length == 0\n            && !$ctrl.clientTypePublishingHouse\n            && $ctrl.canEditPromoter()"><input name="docuCoordinator" type="text" ng-required="$ctrl.uploadObj.coordinatorInfo.isMandatory && !$ctrl.canEditPromoter()" ng-disabled="!$ctrl.canEditPromoter()" ng-model="$ctrl.form.docuCoordinator" placeholder="{{!$ctrl.form.docuCoordinator ? \'document.metric.placeholder.docu-coordinator\' : \'document.model.docu-coordinator\' | translate}}"></md-input-container><md-input-container layout="row" layout-xs="column" flex flex-xs="100" class="document-metric-authors" ng-if="$ctrl.uploadObj.coordinatorInfo.isPresent\n            && $ctrl.uploadObj.coordinatorInfo.selectItems.length > 0\n            && !$ctrl.clientTypePublishingHouse\n            && $ctrl.canEditPromoter()\n        "><md-autocomplete id="coordinatorId" name="coordinatorId" ng-disabled="!$ctrl.canEditPromoter()" md-no-cache="$ctrl.noCache" md-selected-item="$ctrl.selectedItem" md-search-text-change="$ctrl.searchTextChange(ctrl.searchText)" md-search-text="$ctrl.searchText" md-selected-item-change="$ctrl.selectedItemChange(item)" md-items="item in $ctrl.querySearch($ctrl.searchText)" md-item-text="item.label" md-min-length="0" md-select-on-match="true" md-require-match="true" md-floating-label="{{$ctrl.coordinatorLabel | translate}}" ng-required="$ctrl.uploadObj.coordinatorInfo.isMandatory && !$ctrl.canEditPromoter()"><md-item-template><span md-highlight-text="$ctrl.searchText" md-highlight-flags="^i">{{item.label}}</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{$ctrl.searchText}}"</md-not-found></md-autocomplete></md-input-container><div layout="row" layout-xs="column" flex flex-xs="100">{{vm.clientTypeSchool}}<md-input-container class="md-block" flex="35" flex-xs="100" ng-if="!$ctrl.authorsSimplifiedFields"><input ng-model="$ctrl.form.mainAuthor.firstName" ng-required="true" placeholder="{{$ctrl.form.mainAuthor.firstName ? \'document.metric.placeholder.name\' : \'document.metric.author-first-name\' | translate}}"></md-input-container><md-input-container class="md-block" flex="35" flex-xs="100" ng-if="!$ctrl.authorsSimplifiedFields"><input ng-model="$ctrl.form.mainAuthor.lastName" ng-required="true" placeholder="{{$ctrl.form.mainAuthor.lastName ? \'document.metric.placeholder.surname\' : \'document.metric.author-last-name\'| translate}}"></md-input-container><md-input-container class="md-block" flex="70" flex-xs="100" ng-if="$ctrl.authorsSimplifiedFields"><input ng-model="$ctrl.form.mainAuthor.firstName" ng-required="true" placeholder="{{\'document.metric.authorfullname\' | translate}}"></md-input-container><md-input-container class="md-block plagiat-input-color" flex="30" flex-xs="100" ng-if="$ctrl.uploadObj.indexNumberInfo.isPresent"><input ng-model="$ctrl.form.mainAuthor.indexNo" placeholder="{{$ctrl.form.mainAuthor.indexNo ? \'document.metric.placeholder.index\' : \'document.metric.client.index\'| translate}}" ng-required="$ctrl.uploadObj.indexNumberInfo.isMandatory"></md-input-container></div><div layout="row" layout-xs="column" flex class="document-metric-author"><div flex="50" flex-xs="100" layout="row" layout-xs="column"><md-input-container class="md-block" flex><label data-translate="document.model.document-kind"></label><md-select layout-align="center center" ng-model="$ctrl.form.documentKindId"><md-option ng-repeat="option in $ctrl.docuKinds" ng-value="option.id"><em>{{option.labelTranslated}}</em></md-option></md-select></md-input-container></div><div class="m-top" flex="50" flex-xs="100" layout="row" layout-xs="column"><md-input-container class="md-block" flex><label data-translate="document.model.organisational-unit"></label><md-select ng-disabled="!$ctrl.canChangeOrganisationUnit" layout-align="center center" ng-model="$ctrl.form.organisationalUnitId"><md-option ng-repeat="option in $ctrl.organisationalUnits" ng-value="option.id"><em>{{option.orguniLabel}}</em></md-option></md-select></md-input-container></div></div><div class="mt-3" flex layout="row" ng-if="$ctrl.uploadObj.schoolClassInfo.isPresent"><md-input-container flex="50" flex-xs="100" layout="column"><input id="documentClass" ng-model="$ctrl.form.schoolClass" ng-required="$ctrl.uploadObj.schoolClassInfo.isMandatory" placeholder="{{\'document.metric.school-class.placeholder\' | translate}}"></md-input-container></div><div layout="row" class="document-parameters" layout-xs="column" flex><div layout="row" layout-xs="column" flex="25" flex-xs="100" ng-repeat="p in $ctrl.form.documentParameterDefinitions"><md-input-container class="md-block" flex ng-if="p.comboBoxValues.length == 0"><input ng-model="$ctrl.form.documentParameters[p.id]" placeholder="{{p.dopadeName}}"></md-input-container><md-input-container class="md-block" flex ng-if="p.comboBoxValues.length > 0"><label>{{p.dopadeName}}</label><md-select aria-label="docu statuses" ng-model="$ctrl.form.documentParameters[p.id]" placeholder="{{p.dopadeName}}" layout-align="center center"><md-option ng-value="val" ng-repeat="val in p.comboBoxValues"><em>{{val}}</em></md-option></md-select></md-input-container></div></div><div class="cooauthors-add" layout="row" layout-xs="column" flex="100" flex-xs="100"><md-button ng-click="$ctrl.addAuthor()" class="md-raised md-primary" data-translate="document.metric.client.add-author">Dodaj wsp\xF3\u0142autora</md-button></div><div layout="row" layout-xs="column" flex class="document-metric-authors" ng-repeat="n in $ctrl.form.documentAuthors"><md-input-container class="md-block" flex="30" flex-xs="100" ng-if="!$ctrl.authorsSimplifiedFields"><input placeholder="{{!$ctrl.form.documentAuthors[$index].firstName ? \'document.metric.placeholder.name\' : \'document.metric.author-first-name\' | translate}}" ng-required="true" ng-model="$ctrl.form.documentAuthors[$index].firstName"></md-input-container><md-input-container class="md-block" flex="30" flex-xs="100" ng-if="!$ctrl.authorsSimplifiedFields"><input placeholder="{{!$ctrl.form.documentAuthors[$index].lastName ? \'document.metric.placeholder.surname\' : \'document.metric.author-last-name\' | translate}}" ng-required="true" ng-model="$ctrl.form.documentAuthors[$index].lastName"></md-input-container><md-input-container class="md-block" flex="60" flex-xs="100" ng-if="$ctrl.authorsSimplifiedFields"><input placeholder="{{\'document.metric.placeholder.coauthorfullname\' | translate}}" ng-required="true" ng-model="$ctrl.form.documentAuthors[$index].firstName"></md-input-container><md-input-container class="md-block plagiat-input-color" flex="20" flex-xs="100" ng-if="$ctrl.uploadObj.indexNumberInfo.isPresent"><input placeholder="{{!document.metric.client.index ? \'document.metric.placeholder.index\' : \'document.metric.client.index\' | translate}}" ng-model="$ctrl.form.documentAuthors[$index].indexNo"></md-input-container><md-input-container class="md-block" flex="20" flex-xs="100"><md-button ng-click="$ctrl.removeAuthor($index)" class="md-raised md-primary">X</md-button></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button data-translate="global.button.cancel" ng-click="$ctrl.closeDialog()">Anuluj</md-button><md-button class="md-raised md-primary" data-translate="global.button.save" ng-click="$ctrl.saveData($ctrl.form)" ng-disabled="form.$invalid">Zapisz</md-button></md-dialog-actions></form>');
$templateCache.put('app/components/document/document-form-individual/document-form-individual.dialog.html','<md-dialog aria-label="" class="upload-text"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="document.edit-action"></h2></div></md-toolbar><document-form-individual></document-form-individual></md-dialog>');
$templateCache.put('app/components/document/document-form-individual/document-form-individual.template.html','<form name="form" ng-cloak><md-dialog-content><div class="md-dialog-content" layout-margin><md-input-container class="md-block" flex-gt-sm><input ng-model="$ctrl.form.docuTitle" name="title" type="text" placeholder="{{!$ctrl.form.docuTitle ? \'document.metric.placeholder.title\' : \'document.form.title\' | translate}}" required></md-input-container><md-input-container class="md-block" flex-gt-sm ng-if="$ctrl.uploadObj.coordinatorInfo.isPresent && $ctrl.uploadObj.coordinatorInfo.selectItems.length == 0"><input ng-model="$ctrl.form.docuCoordinator" name="docuCoordinator" type="text" ng-required="true" placeholder="{{!$ctrl.form.docuCoordinator ? \'document.metric.placeholder.docu-coordinator\' : \'document.model.docu-coordinator\' | translate}}"></md-input-container><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="50" flex-xs="100"><input placeholder="{{$ctrl.form.mainAuthor.firstName ? \'document.metric.placeholder.name\' : \'document.metric.author-first-name\' | translate}}" ng-required="true" ng-model="$ctrl.form.mainAuthor.firstName"></md-input-container><md-input-container class="md-block" flex="50" flex-xs="100"><input placeholder="{{$ctrl.form.mainAuthor.lastName ? \'document.metric.placeholder.surname\' : \'document.metric.author-last-name\'| translate}}" ng-required="true" ng-model="$ctrl.form.mainAuthor.lastName"></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="$ctrl.closeDialog()" data-translate="global.button.cancel">Anuluj</md-button><md-button ng-click="$ctrl.saveData($ctrl.form)" ng-disabled="form.$invalid" class="md-raised md-primary" data-translate="global.button.save">Zapisz</md-button></md-dialog-actions></form>');
$templateCache.put('app/components/document/document-history/document-history.dialog.html','<md-dialog aria-label="history" class="upload-text"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="document.history-of-document"></h2></div></md-toolbar><document-history></document-history></md-dialog>');
$templateCache.put('app/components/document/document-history/document-history.template.html','<form name="form" ng-cloak><md-dialog-content><md-table-container flex layout="row" layout-margin class="table-fixed-container"><table md-table md-progress="vm.promise" class="table-fixed"><thead md-head md-order="vm.query.order" md-on-reorder="vm.getDocumentHistory"><tr md-row><th md-column class="table-td-30"><span data-translate="document.history.changed-field-name"></span></th><th md-column class="table-td-30"><span data-translate="document.history.old-value"></span></th><th md-column class="table-td-30"><span data-translate="document.history.new-value"></span></th><th md-column class="table-td-30"><span data-translate="document.table.details.author"></span></th><th md-column class="table-td-30"><span data-translate="document.change-date"></span></th><th md-column class="table-td-30"><span data-translate="document.history.related-with"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat="documentHistory in $ctrl.documentHistoryList"><td md-cell>{{documentHistory.changedFieldName}}</td><td md-cell>{{documentHistory.fieldValueOld}}</td><td md-cell>{{documentHistory.fieldValueNew}}</td><td md-cell>{{documentHistory.changedBy}}</td><td md-cell>{{documentHistory.changeDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td md-cell>{{documentHistory.comments}}</td></tr></tbody></table></md-table-container></md-dialog-content><md-dialog-actions layout="row"><md-button ng-click="$ctrl.closeDialog()" data-translate="global.button.cancel">Anuluj</md-button></md-dialog-actions></form>');
$templateCache.put('app/components/document/document-operator-details/document-operator-details.template.html','<div class="pl-5" layout="row" layout-padding flex ng-if="$ctrl.onDocument.docuStatus === $ctrl.DOCUMENT_STATUS.JSA_ERROR.id"><div layout="column" flex="50" class="pr-5"><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="document.table.jsa-error-message">B\u0142\u0105d jsa</small> <small flex>{{$ctrl.onDocument.jsaErrorMessage}}</small></div></div></div><div class="border-top pl-5" layout="row" layout-padding flex><div layout="row" flex="50" class="pr-5"><div layout="column" flex="100"><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="document.table.details.id">ID dokumentu</small> <small flex>{{$ctrl.onDocumentDetails.documentId}}</small></div><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="document.table.details.author">U\u017Cytkownik</small> <small flex>{{$ctrl.onDocumentDetails.userEmail}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onDocumentDetails.docuSize > 0"><small flex class="text-muted" data-translate="document.table.details.upload-date">Data wgrania pracy</small> <small flex>{{$ctrl.onDocumentDetails.docuSubmitDate | date: \'yyyy-MM-dd HH:mm\'}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onDocumentDetails.docuReportDate"><small flex class="text-muted" data-translate="document.table.details.report">Raport podobie\u0144stwa</small> <small flex>{{$ctrl.onDocumentDetails.docuReportDate | date: \'yyyy-MM-dd HH:mm\'}}</small></div><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="document.metric.client.promoter.unit">Jednostka</small> <small flex>{{$ctrl.onDocumentDetails.orguniLabel}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onDocumentDetails.assignmentDescription"><small flex class="text-muted" data-translate="document.table.details.assignment-description">Assignment description</small> <small flex>{{$ctrl.onDocumentDetails.assignmentDescription}}</small></div></div></div><div layout="row" flex="50"><div layout="column" flex="100"><div layout="row" class="document-row-details" ng-repeat="a in $ctrl.onDocumentDetails.documentAuthors" ng-if="$ctrl.onDocumentDetails.documentAuthors.length > 1 && $index > 0"><small flex class="text-muted" data-translate="document.table.details.coauthor"></small> <small flex>{{a.firstName}} {{a.lastName}}</small></div><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="document.metric.client.promoter.type">rodzaj</small> <small flex>{{$ctrl.onDocumentDetails.docuKindLabel}}</small></div><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="document.table.details.format">format</small> <small flex>{{$ctrl.onDocumentDetails.documentType}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onDocumentDetails.docuSize > 0"><small flex class="text-muted" data-translate="document.table.details.size">Rozmiar</small> <small flex>{{$ctrl.onDocumentDetails.docuSize}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onDocumentDetails.docuReleaseDate"><small flex class="text-muted" data-translate="document.metric.old-phd-year">Old PHD Year</small> <small flex>{{$ctrl.onDocumentDetails.docuReleaseDate | date: \'yyyy\'}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onIsSuperadmin"><small flex ng-if="$ctrl.onIsSuperadmin" data-translate="document.model.docu-coordinator" class="text-muted"></small> <small flex ng-if="$ctrl.onIsSuperadmin">{{$ctrl.onDocument.docuCoordinator}}</small></div><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="document.table.details.orppd.date-sent" ng-if="$ctrl.onDocumentDetails.orppdDateSent">Data wyslania do ORPPD</small> <small flex ng-if="$ctrl.onDocumentDetails.orppdDateSent">{{$ctrl.onDocumentDetails.orppdDateSent | date: \'yyyy-MM-dd HH:mm\'}}</small></div><div layout="row" class="document-row-details"><small flex class="text-muted" ng-if="$ctrl.onDocumentDetails.checkId" data-translate="document.table.details.check-id">Check ID</small> <small flex ng-if="$ctrl.onDocumentDetails.checkId">{{$ctrl.onDocumentDetails.checkId}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onIsSuperadmin"><small flex class="text-muted" data-translate="document.table.details.extra-options">Wybrane opcje</small> <small flex><span ng-repeat="optionKey in $ctrl.onDocumentDetails.docuExtraOptions track by $index">{{$index > 0 ? \', \' : \'\'}}{{optionKey | translate}}</span></small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onIsSuperadmin && $ctrl.onDocumentDetails.externalUserId"><small flex class="text-muted" data-translate="document.table.details.external-user-id">external-user-id</small> <small flex>{{$ctrl.onDocumentDetails.externalUserId}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onIsSuperadmin && $ctrl.onDocumentDetails.externalDocumentId"><small flex class="text-muted" data-translate="document.table.details.external-document-id">external-document-id</small> <small flex>{{$ctrl.onDocumentDetails.externalDocumentId}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onIsSuperadmin"><small flex class="text-muted" data-translate="document.report.similarity.ai-detection">docuAiDetection</small> <small flex>{{$ctrl.onDocumentDetails.docuAiDetection}} {{$ctrl.onDocumentDetails.aiDetectionType}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onIsSuperadmin"><small flex class="text-muted" data-translate="document.metric.grammar-check.label">docuGrammarCheck</small> <small flex>{{$ctrl.onDocumentDetails.docuGrammarCheck}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onDocumentDetails.assignmentTitle"><small flex class="text-muted" data-translate="document.table.details.assignment">Assignment</small> <small flex>{{$ctrl.onDocumentDetails.assignmentTitle}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onDocumentDetails.assignmentDateTo"><small flex class="text-muted" data-translate="document.table.details.assignment-due-date">Assignment Due Date</small> <small flex>{{$ctrl.onDocumentDetails.assignmentDateTo | date: \'yyyy-MM-dd HH:mm\'}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.addPriorityFromContractEnabled"><small flex class="text-muted" data-translate="document.table.details.priority-added-from-contract">priority from contract</small> <small flex>{{$ctrl.onDocument.priorityAddedFromContract ? (\'global.msg.yes\' | translate) : (\'global.msg.no\' | translate)}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onDocumentDetails.services"><small flex class="text-muted" data-translate="document.table.details.auto-translations">Automatic translations</small> <small flex ng-if="$ctrl.onDocumentDetails.autoTranslationsFromLang">{{(\'document.report.similarity.language.\' + $ctrl.onDocumentDetails.autoTranslationsFromLang.toLowerCase()) | translate}} > {{(\'document.report.similarity.language.\' + $ctrl.onDocumentDetails.autoTranslationsToLang.toLowerCase()) | translate}}</small> <small flex ng-if="!$ctrl.onDocumentDetails.autoTranslationsFromLang">{{(\'document.report.similarity.language.\' + $ctrl.onDocumentDetails.autoTranslationsToLang.toLowerCase()) | translate}}</small></div></div></div></div><div class="border-top pl-5" layout="column" layout-padding flex ng-if="$ctrl.onIsSuperadmin || $ctrl.onDocumentDetails.skipUrls"><div layout="row" flex="100" class="pr-5"><small class="text-muted" flex="100" data-translate="document.report.similarity.document-skip-addresses"></small></div><div layout="row" flex="100" class="pr-5"><small flex>{{$ctrl.onDocumentDetails.skipUrls}}</small></div></div><div layout="row" class="pl-5"><span flex="100" data-translate="document.table.parameters" ng-if="$ctrl.onDocumentDetails.parameters.length > 0"></span></div><div class="pl-5" layout="row" layout-padding flex ng-if="$ctrl.onDocumentDetails.parameters.length > 0"><div layout="row" flex="50"><div layout="column" flex="100"><div layout="row" class="document-row-details" ng-repeat="p in $ctrl.onDocumentDetails.parameters" ng-if="$even"><small flex class="text-muted" data-name="{{p.dopadeName}}">{{p.dopadeName}}</small> <small flex>{{p.docparValue}}</small></div></div></div><div layout="row" flex="50"><div layout="column" flex="100"><div layout="row" class="document-row-details" ng-repeat="p in $ctrl.onDocumentDetails.parameters" ng-if="$odd"><small flex class="text-muted" data-name="{{p.dopadeName}}">{{p.dopadeName}}</small> <small flex>{{p.docparValue}}</small></div></div></div></div>');
$templateCache.put('app/components/document/extra-options/add-priority.dialog.html','<md-dialog aria-label="priorityCheck" class="priority-check"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="document.add-priority.dialog.title"></h2></div></md-toolbar><md-dialog-content layout-padding layout="column"><div class="loader" layout="row" layout-sm="column" layout-align="space-around" ng-if="vm.initializing"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div><div ng-if="!vm.initializing" class="p-3"><div class="priority-check-description" data-translate="document.priority-check.dialog.description"></div><div class="priority-check-tokens-needed" data-translate="document.add-priority.dialog.tokens-needed" data-translate-values="{value: vm.tokensNeeded}"></div><div ng-if="vm.tokensNeededToBuy > 0" class="priority-check-tokens-needed-to-buy" data-translate="document.add-priority.dialog.tokens-to-buy" data-translate-values="{value: vm.tokensNeededToBuy}"></div></div><md-progress-linear layout="row" ng-if="vm.pending" md-mode="indeterminate"></md-progress-linear><md-dialog-actions layout-gt-xs="row" layout-xs="column"><md-button flex-order-gt-xs="0" flex-order-xs="1" ng-click="vm.closeDialog()" data-translate="global.button.cancel" ng-disabled="vm.pending">Anuluj</md-button><md-button ng-if="vm.tokensNeededToBuy == 0" ng-click="vm.addPriority()" data-translate="document.add-priority.dialog.add-priority" class="md-raised button-waiting" ng-disabled="vm.pending"></md-button><md-button ng-if="vm.tokensNeededToBuy > 0" ng-click="vm.buyTokensAndAddPriority()" data-translate="document.add-priority.dialog.buy-tokens-and-add-priority" class="md-raised button-waiting" ng-disabled="vm.pending"><md-tooltip md-delay="100" md-autohide="true" md-direction="top">{{\'document.add-priority.dialog.buy-tokens-and-add-priority.tooltip\'| translate}}</md-tooltip></md-button></md-dialog-actions></md-dialog-content></md-dialog>');
$templateCache.put('app/components/document/extra-options/extra-options-form.template.html','<div layout-padding layout="column"><div layout="row"><span ng-if="!vm.landingPage" data-translate="document.form.extra.options.story"></span> <span ng-if="vm.landingPage" data-translate="landing.form.extra.options.story"></span></div><div layout="row"><span data-translate="document.form.extra.options.initial.price" data-translate-values="{value: vm.basePrice, size: vm.size}"></span> <span><md-tooltip md-delay="100" md-direction="top" class="accept-data-processing-tooltip">{{\'document.form.tooltip.extra.options.initial.price\' | translate}}</md-tooltip><i class="material-icons-outlined">info</i></span></div><div layout="column"><div ng-repeat="option in vm.documentExtraOptions"><md-switch ng-model="option.chosen" ng-change="vm.checkboxChange()" ng-disabled="vm.isOptionDisabled(option)" class="m-0 md-primary"><span class="font-weight-bold-zzz">{{(\'document.form.extra.option\' + option.id) | translate}}</span> <span><md-tooltip md-delay="100" md-direction="top" ng-if="!vm.isOptionDisabled(option)" class="accept-data-processing-tooltip">{{(\'document.form.tooltip.extra.option\' + option.id) | translate}}</md-tooltip><md-tooltip md-delay="100" md-direction="top" ng-if="vm.isOptionDisabled(option)" class="accept-data-processing-tooltip">{{(\'document.form.tooltip.extra.disabled.option\' + option.id) | translate}}</md-tooltip><i class="material-icons-outlined options">info</i> </span><span data-translate="document.form.extra.option.price" data-translate-values="{value: option.price}"></span></md-switch></div><div><md-switch ng-model="vm.translation.chosen" ng-change="vm.checkboxChange()" ng-disabled="vm.isAiDetectionEnabled()" class="m-0 md-primary"><span class="font-weight-bold-zzz">{{(\'document.form.extra.option-translation\') | translate}}</span> <span><md-tooltip md-delay="100" md-direction="top" class="accept-data-processing-tooltip" ng-bind-html="\'document.form.tooltip.extra.option-translation\' | translate"></md-tooltip><i class="material-icons-outlined options">info</i></span></md-switch></div><div layout="row" layout-wrap flex="100" ng-if="vm.translation.chosen"><div layout-align="end end" layout="column" class="pr-1"><div><span layout-align="center end" data-translate="document.metric.auto-translations.translate-lang-text"></span></div></div><md-input-container flex flex-xs="100"><label data-translate="document.metric.auto-translations.to-lang-placeholder">J\u0119zyk docelowy</label><md-select id="toLangSelect" name="toLangSelect" aria-label="toLang" layout-align="center center" ng-model="vm.translation.autoTranslationsToLang" ng-required="true" class="mt-0"><md-option id="autoTranslationLangsTo{{val.code}}" ng-value="val.code" ng-repeat="val in vm.autoTranslationLangs">{{val.translated}}</md-option></md-select><plagiat-ng-messages form-element="form.toLangSelect"></plagiat-ng-messages></md-input-container><div></div></div></div><div layout="row"><span data-translate="document.form.extra.options.total.price" data-translate-values="{value: vm.totalPrice}"></span></div></div>');
$templateCache.put('app/components/document/extra-options/extra-options.dialog.html','<md-dialog aria-label="extraOptions" class="extra-options" id="extraOptions"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="document.form.extra.options.title"></h2></div></md-toolbar><form name="form1" ng-cloak><md-dialog-content layout-padding layout="column"><div class="loader" layout="row" layout-sm="column" layout-align="space-around" ng-if="vm.pending"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div><ng-include ng-if="!vm.initializing" src="\'app/components/document/extra-options/extra-options-form.template.html\'"></ng-include><md-dialog-actions layout="row"><md-button ng-click="vm.closeDialog()" data-translate="global.button.cancel">Anuluj</md-button><md-button ng-click="vm.checkDocument()" data-translate="document.metric.check" class="md-raised button-waiting" ng-disabled="vm.pending || !vm.translationsValidated()">Sprawd\u017A</md-button></md-dialog-actions></md-dialog-content></form></md-dialog>');
$templateCache.put('app/components/document/jsa-edit-form/jsa-document-edit-form.template.html','<form name="form" ng-cloak><md-dialog-content><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="$ctrl.isLoading"></md-progress-circular></div><div ng-if="vm.jsaExaminationDeprecated" layout="row" layout-margin class="jsa-examination-deprecated-warning"><i class="material-icons">warning</i><p data-translate="document.edit.jsa.examination-deprecated"></p></div><div ng-include src="\'app/account/documents/document/document-form/jsa-document-form/jsa-document-metadata-form.template.html\'"></div></md-dialog-content><md-dialog-actions layout="row"><md-button ng-click="vm.closeDialog()" data-translate="global.button.cancel">Anuluj</md-button><md-button ng-click="vm.saveData()" ng-disabled="form.$invalid || vm.isSaving" class="md-raised md-primary" data-translate="global.button.save">Zapisz</md-button></md-dialog-actions></form>');
$templateCache.put('app/components/document/jsa-edit-form/jsa-document-form.dialog.html','<md-dialog aria-label="" class="jsa-document-edit-dialog"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="document.edit-action"></h2></div></md-toolbar><jsa-document-edit-form></jsa-document-edit-form></md-dialog>');
$templateCache.put('app/components/document/send-to-jsa/send-to-jsa.template.html','<md-dialog class="jsa-document-edit-dialog"><form name="form" ng-cloak><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="document.send-to-jsa.header"></h2></div></md-toolbar><md-dialog-content><md-progress-linear md-mode="indeterminate" ng-show="vm.isLoading"></md-progress-linear><div ng-include src="\'app/account/documents/document/document-form/jsa-document-form/jsa-document-metadata-form.template.html\'"></div><div layout-align="center center" layout-margin ng-if="vm.isSuperAdmin"><md-input-container><md-checkbox class="m-0" ng-model="vm.sendWithoutUid"><span data-translate="document.jsa.send-without-uid"></span></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><md-button ng-click="vm.closeDialog()" data-translate="global.button.cancel"></md-button><md-button ng-click="vm.saveData()" ng-disabled="form.$invalid || vm.isLoading" class="md-raised md-primary" data-translate="global.button.send"></md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/document/send-to-orppd/identification-data.component.html','<md-input-container flex="25"><input type="text" ng-model="vm.identificationDataForm.pesel" ng-disabled="vm.peselDisabled()" ng-required="!vm.peselDisabled()" placeholder="{{\'document.orppd.identification-data.pesel\' | translate}}"></md-input-container><md-input-container flex="25"><label data-translate="document.orppd.identification-data.document-country"></label><md-select ng-model="vm.identificationDataForm.documentCountry" ng-disabled="vm.documentDataDisabled()" ng-required="!vm.documentDataDisabled()"><md-option ng-value="null"></md-option><md-option ng-repeat="countryDictionaryValue in vm.countriesDictionary" ng-value="countryDictionaryValue.code">{{countryDictionaryValue.label}}</md-option></md-select></md-input-container><md-input-container flex="25"><label data-translate="document.orppd.identification-data.document-type"></label><md-select ng-model="vm.identificationDataForm.documentType" ng-disabled="vm.documentDataDisabled()" ng-required="!vm.documentDataDisabled()"><md-option ng-value="null"></md-option><md-option ng-repeat="documentTypeDictionaryValue in vm.documentTypesDictionary" ng-value="documentTypeDictionaryValue.code">{{documentTypeDictionaryValue.label}}</md-option></md-select></md-input-container><md-input-container flex="25"><input type="text" ng-model="vm.identificationDataForm.documentNumber" ng-disabled="vm.documentDataDisabled()" ng-required="!vm.documentDataDisabled()" placeholder="{{\'document.orppd.identification-data.document-number\' | translate}}"></md-input-container>');
$templateCache.put('app/components/document/send-to-orppd/send-to-orppd.dialog-content.html','<md-card ng-if="vm.orppdErrorMessage" id="orppdErrorsCard"><md-card-title class="pb-0"><md-card-title-text><span class="font-weight-bold">{{ \'document.orppd.send.error\' | translate }}</span></md-card-title-text></md-card-title><div class="space-top1"></div><md-card-content><div layout="column" class="errors"><span>{{vm.orppdErrorMessage}}</span></div></md-card-content></md-card><md-card><md-card-content><div layout="row"><md-input-container flex="100"><md-switch class="md-primary" ng-model="vm.form.orppd2"><span data-translate="document.orppd.is-orppd-2"></span></md-switch></md-input-container></div><div layout="row"><!--document title--><md-input-container flex><input name="title" type="text" ng-model="vm.form.title" placeholder="{{\'document.form.title\' | translate}}" required></md-input-container></div><div layout="row" ng-if="!vm.form.orppd2"><!--defenceInstutution basicOrgUnitCode--><md-input-container flex><input name="basicOrgUnitCode" type="text" ng-model="vm.form.basicOrgUnitCode" placeholder="{{\'document.orppd.defence-institution.basic-org-unit-code\' | translate}}" required></md-input-container></div></md-card-content></md-card><md-card><md-card-title class="pb-0"><md-card-title-text data-translate="document.orppd.authors.title"></md-card-title-text></md-card-title><md-card-content><div layout="row" layout-xs="column" class="border-bottom" ng-repeat="author in vm.form.authors" layout-wrap layout-padding><div flex="100" layout="row" class="pt-0"><p flex="90">{{author.firstName + \' \' + author.lastName}}</p><md-button flex name="removeAuthor" aria-label="remove author" class="md-warn" ng-click="vm.removeAuthor($index)">X</md-button></div><!--author: first name --><md-input-container flex="33" flex-xs="100"><input ng-model="author.firstName" placeholder="{{\'document.metric.author-first-name\' | translate}}" ng-required="true"></md-input-container><!--author: last name --><md-input-container flex="33" flex-xs="100"><input ng-model="author.lastName" placeholder="{{\'document.metric.author-last-name\'| translate}}" ng-required="true"></md-input-container><!-- author: data obrony --><md-input-container flex="33" flex-xs="100"><label data-translate="document.orppd.defence-date"></label><md-datepicker input-date name="defenceDate" aria-label="defence date" ng-model="author.defenceDate" md-open-on-focus ng-required="true"></md-datepicker><!--ng-change="vm.fixDate(vm.form.defenseDate, \'userLastLoginDateFrom\', vm)"--></md-input-container><identification-data ng-if="vm.form.orppd2" flex="100" layout="row" identification-data-form="author"></identification-data><!-- author course: kod studi\xF3w --><md-input-container flex="33" flex-xs="100"><input ng-model="author.fieldOfStudyInstanceCode" placeholder="{{\'document.orppd.polon-course-id\'| translate}}" ng-required="true"></md-input-container><!-- author course: forma studi\xF3w --><md-input-container ng-if="!vm.form.orppd2" flex="33" flex-xs="100"><label data-translate="document.orppd.form-of-study"></label><md-select name="formOfStudy" aria-label="form of study" ng-model="author.formOfStudy" ng-required="true"><md-option ng-repeat="option in vm.formOfStudies" ng-value="option">{{option}}</md-option></md-select></md-input-container><md-input-container flex="33" flex-xs="100" ng-if="vm.form.orppd2"><input ng-model="author.interfacultyFieldOfStudyCode" placeholder="{{\'document.orppd.interfaculty-field-of-study-code\'| translate}}"></md-input-container><!-- author course: Professional title--><md-input-container flex="33" flex-xs="100"><label data-translate="document.orppd.professional-title"></label><md-select name="professionalTitle" aria-label="professional title" ng-model="author.professionalTitle" ng-required="true"><md-option ng-repeat="option in vm.professionalTitles" ng-value="option">{{option}}</md-option></md-select></md-input-container><!--author: interterIndividualStudiesCourseId --><md-input-container ng-if="!vm.form.orppd2" flex="50" flex-xs="100"><input ng-model="author.interterIndividualStudiesCourseId" placeholder="{{\'document.metric.interter-individual-studies-course-id\'| translate}}"></md-input-container><!-- author course: Data wersji danych o kierunku studi\xF3w --><md-input-container ng-if="!vm.form.orppd2" flex="50" flex-xs="100"><label data-translate="document.orppd.date-version-data"></label><md-datepicker input-date name="dateFieldOfStudy" aria-label="date version data " ng-model="author.dateVersionData" md-open-on-focus ng-required="true"></md-datepicker></md-input-container><md-input-container ng-if="vm.form.orppd2" flex="100"><textarea placeholder="{{\'document.note\'| translate}}" ng-model="author.note"></textarea></md-input-container></div><!--additional author button--><div layout="row" layout-xs="column"><md-button ng-click="vm.addAuthor()" class="md-raised md-primary" data-translate="document.metric.client.add-author">Dodaj wsp\xF3\u0142autora</md-button></div></md-card-content></md-card><!--supervisors--><md-card><md-card-title><md-card-title-text data-translate="document.orppd.supervisors.title"></md-card-title-text></md-card-title><md-card-content><div layout="row" layout-xs="column" ng-repeat="supervisor in vm.form.supervisors" layout-wrap><!-- supervisor: first name --><md-input-container flex flex-xs="100"><input ng-model="supervisor.firstName" placeholder="{{\'document.orppd.supervisor.first-name\' | translate}}" ng-required="true"></md-input-container><!-- supervisor: last name --><md-input-container flex flex-xs="100"><input ng-model="supervisor.lastName" placeholder="{{\'document.orppd.supervisor.last-name\'| translate}}" ng-required="true"></md-input-container><md-input-container flex="10" flex-xs="100" layout="row" layout-align="end center"><md-button name="removeSupervisor" aria-label="remove supervisor" class="md-warn" ng-click="vm.onClickRemoveSupervisor($index)">X</md-button></md-input-container><identification-data ng-if="vm.form.orppd2" flex="100" layout="row" identification-data-form="supervisor"></identification-data></div><div layout="row" ng-if="!vm.addSupervisorMode"><md-button name="addSupervisor" aria-label="add supervisor" class="md-raised md-primary" ng-click="vm.addSupervisorMode = !vm.addSupervisorMode" data-translate="document.orppd.supervisor.add"></md-button></div><div layout="row" ng-if="vm.addSupervisorMode"><md-input-container flex><md-autocomplete class="white-background" name="supervisorSearch" md-search-text="vm.searchSupervisorText" md-selected-item-change="vm.onSupervisorChanged(item)" md-items="item in vm.supervisorsAndReviewerSearch(vm.searchSupervisorText)" md-item-text="item.firstName" md-min-length="0" md-select-on-match="true" md-require-match="true" md-floating-label="{{\'document.orppd.supervisor.search\' | translate}}"><md-item-template><span md-highlight-text="ctrl.searchSupervisorText" md-highlight-flags="^i">{{item.firstName + \' \' + item.lastName}} </span>&nbsp;&nbsp; <i>{{\'UUID: \' + item.uuid}}</i></md-item-template></md-autocomplete></md-input-container></div></md-card-content></md-card><!--reviewers--><md-card><md-card-title><md-card-title-text data-translate="document.orppd.reviewers.title"></md-card-title-text></md-card-title><md-card-content><div layout="row" layout-xs="column" ng-repeat="reviewer in vm.form.reviewers" layout-wrap><!-- reviewer: first name --><md-input-container flex flex-xs="100"><input ng-model="reviewer.firstName" placeholder="{{\'document.orppd.reviewer.first-name\' | translate}}" ng-required="true"></md-input-container><!-- reviewer: last name --><md-input-container flex flex-xs="100"><input ng-model="reviewer.lastName" placeholder="{{\'document.orppd.reviewer.last-name\'| translate}}" ng-required="true"></md-input-container><md-input-container flex="10" flex-xs="100" layout="row" layout-align="end center"><md-button name="removeReviewer" aria-label="remove reviewer" class="md-warn" ng-click="vm.onClickRemoveReviewer($index)">X</md-button></md-input-container><identification-data ng-if="vm.form.orppd2" flex="100" layout="row" identification-data-form="reviewer"></identification-data></div><div layout="row" ng-if="!vm.addReviewerMode"><md-button name="addReviewer" aria-label="add reviewer" class="md-raised md-primary" ng-click="vm.addReviewerMode = !vm.addReviewerMode" data-translate="document.orppd.reviewer.add"></md-button></div><div layout="row" ng-if="vm.addReviewerMode"><md-input-container flex><md-autocomplete class="white-background" name="reviewerSearch" md-search-text="vm.searchReviewerText" md-selected-item-change="vm.onReviewerChanged(item)" md-items="item in vm.supervisorsAndReviewerSearch(vm.searchReviewerText)" md-item-text="item.firstName" md-min-length="0" md-select-on-match="true" md-require-match="true" md-floating-label="{{\'document.orppd.reviewer.search\' | translate}}"><md-item-template><span md-highlight-text="ctrl.searchSupervisorText" md-highlight-flags="^i">{{item.firstName + \' \' + item.lastName}} </span>&nbsp;&nbsp; <i>{{\'UUID: \' + item.uuid}}</i></md-item-template></md-autocomplete></md-input-container></div></md-card-content></md-card>');
$templateCache.put('app/components/document/send-to-orppd/send-to-orppd.modal.html','<md-dialog flex-gt-lg="65" flex-lg="70" flex-md="85" flex-xs="95"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="document.table.menu.send-document-to-orppd"></h2></div></md-toolbar><form name="form" ng-cloak><md-dialog-content class="pt-4 px-1" ng-include src="\'app/components/document/send-to-orppd/send-to-orppd.dialog-content.html\'" layout-padding></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button data-translate="global.button.cancel" ng-click="vm.closeDialog()">Anuluj</md-button><md-button type="submit" class="md-raised md-primary" data-translate="global.button.send" ng-disabled="form.$invalid || vm.isSending" ng-click="vm.send(vm.form)">Wyslij</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/form/three-state-radio/three-state-ratio.template.html','<div class="three-state-radio-wrapper" layout="row" ng-class="{\'immutable\': immutable}"><div class="three-state-radio" ng-class="{\'yes-chosen\': inputValue === true}"><label class="no-lbl" ng-class="{\'selected\': inputValue === false}">\u2716 <input type="radio" value="" ng-click="modifyValue(false)" name="no_radio" ng-class="{\'selected\': inputValue === false}" class="no-radio"></label><label class="maybe-lbl" ng-class="{\'selected\': inputValue === null}">&nbsp; <input type="radio" value="" ng-click="modifyValue(true)" name="maybe_radio" class="maybe-radio" checked="checked"></label><label class="yes-lbl" ng-class="{\'selected\': inputValue === true}">\u2713 <input type="radio" value="" ng-click="modifyValue(true)" name="yes_radio" ng-class="{\'selected\': inputValue === true}" class="yes-radio"></label><div class="three-state-toggle"></div></div><label class="custom-label ml-2" ng-class="{\'nowdisabled\': nowdisabled}">{{ label }}*</label></div>');
$templateCache.put('app/components/profile/change-password/change-password.template.html','<form name="form" ng-cloak novalidate autocomplete="off"><md-dialog-content><div class="md-dialog-content" layout="column" flex><div layout-align="center center" ng-if="::$ctrl.enforcePasswordChange"><md-list layout layout-align="center center" flex><span data-translate="global.messages.time-to-change-pass"></span></md-list></div><div layout-align="center center" ng-if="$ctrl.doNotMatch"><md-list layout layout-align="center center" flex><span class="errors" data-translate="global.messages.error.dontmatch"></span></md-list></div><md-input-container flex><input ng-model="$ctrl.user.password" type="{{$ctrl.typeInput}}" data-lpignore="true" name="password" placeholder="{{!$ctrl.user.password ? \'global.form.placeholder.oldpassword\' : \'global.form.oldpassword\' | translate}}" aria-autocomplete="none" ng-model-options="{ allowInvalid: true, debounce: 500 }" required><md-checkbox name="showPassword" ng-model="$ctrl.showPassword" ng-change="$ctrl.tooglePasswordVisibility()" aria-label="Poka\u017C has\u0142o"><span data-translate="global.form.show.password">Poka\u017C has\u0142o</span></md-checkbox></md-input-container><md-input-container flex><input ng-model="$ctrl.user.newPassword" name="newPassword" type="password" ng-minlength="8" placeholder="{{!$ctrl.user.newPassword ? \'global.form.placeholder.newpassword\' : \'global.form.newpassword\' | translate}}" ng-pattern="$ctrl.passwordPattern" ng-disabled="!$ctrl.user.password" required><div flex><div ng-show="form.newPassword.$error.pattern" class="md-input-messages-animation ng-active" data-translate="global.form.password.pattern"></div><div ng-show="form.newPassword.$error.minlength" class="md-input-messages-animation ng-active" data-translate="global.form.password.minlength"></div></div></md-input-container><md-input-container flex><input ng-model="$ctrl.user.confirmedPassword" name="confirmedPassword" ng-minlength="8" type="password" placeholder="{{!$ctrl.user.confirmedPassword ? \'global.form.placeholder.confirmpassword\' : \'global.form.confirmpassword\' | translate}}" ng-pattern="$ctrl.passwordPattern" required ng-disabled="!$ctrl.user.newPassword"><div flex><div ng-show="form.confirmedPassword.$error.pattern" class="md-input-messages-animation ng-active" data-translate="global.form.password.pattern"></div><div ng-show="form.confirmedPassword.$error.minlength" class="md-input-messages-animation ng-active" data-translate="global.form.password.minlength"></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="$ctrl.closeDialog()" data-translate="global.button.cancel">Anuluj</md-button><md-button ng-click="$ctrl.saveData($ctrl.user)" ng-disabled="form.$invalid" class="md-raised md-primary" data-translate="global.button.changepassword">Zapisz</md-button></md-dialog-actions></form>');
$templateCache.put('app/components/profile/profile-form/profile-form.template.html','<form name="form" ng-cloak><md-dialog-content><div class="md-dialog-content" layout-margin><md-input-container class="md-block" flex-gt-sm ng-if="$ctrl.isStudent"><input ng-model="$ctrl.user.userEmail" name="login" type="text" placeholder="{{!$ctrl.user.userEmail ? \'global.form.placeholder.login\' : \'global.form.login\' | translate}}" disabled="disabled"></md-input-container><md-input-container class="md-block" flex-gt-sm><input ng-model="$ctrl.user.userName" name="username" type="text" placeholder="{{!$ctrl.user.userName ? \'global.form.placeholder.firstname\' : \'global.form.firstname\' | translate}}" required></md-input-container><md-input-container class="md-block" flex-gt-sm><input ng-model="$ctrl.user.userSurname" name="surname" type="text" placeholder="{{!$ctrl.user.userSurname ? \'global.form.placeholder.surname\' : \'global.form.surname\' | translate}}" required></md-input-container><md-input-container class="md-block" flex ng-if="!$ctrl.canNotChangeNotificationSetting"><md-switch class="md-primary" name="notify" ng-model="$ctrl.user.userWantsNotifications"><span data-translate="global.form.report-notify">Powiadomienia z raportu prawdopodobienstwa</span></md-switch></md-input-container><md-input-container class="md-block" flex ng-if="$ctrl.isIndividual"><md-switch class="md-primary" name="notify" ng-model="$ctrl.user.changeEmail" ng-disabled="$ctrl.logoutToRootInfo"><span data-translate="global.form.i.want.to.change.email"></span></md-switch></md-input-container><md-input-container class="md-block" flex-gt-sm ng-show="$ctrl.user.changeEmail" ng-if="$ctrl.isIndividual"><input ng-pattern="/^.+@.+\\..+$/" type="email" name="newEmail" ng-model="$ctrl.user.newEmail" placeholder="{{\'global.form.changed.email1\' | translate}}" ng-required="$ctrl.user.changeEmail"><div ng-show="form.newEmail.$error.pattern" class="md-input-messages-animation ng-active" data-translate="global.form.email.pattern"></div></md-input-container><md-input-container class="md-block" flex-gt-sm ng-show="$ctrl.user.changeEmail" ng-if="$ctrl.isIndividual"><input stopccp name="confirmedNewEmail" ng-model="$ctrl.user.confirmedNewEmail" placeholder="{{\'global.form.changed.email2\' | translate}}" ng-required="$ctrl.user.changeEmail"><div ng-show="$ctrl.user.newEmail && $ctrl.user.newEmail!=$ctrl.user.confirmedNewEmail" class="md-input-messages-animation ng-active" data-translate="global.form.email.not.the.same"></div></md-input-container><md-button ng-if="$ctrl.isIndividual || $ctrl.allUsersCanDeleteAccounts" ng-click="$ctrl.deleteAccountButtonClicked()" data-translate="delete-account.button"><md-tooltip md-direction="top" class="tooltip-with-long-text">{{ \'delete-account.button.tooltip\' | translate }}</md-tooltip></md-button><div class="alert alert-danger fade in alert-dismissible" ng-show="$ctrl.errorMessage">{{$ctrl.errorMessage}}</div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="$ctrl.closeDialog()" data-translate="global.button.cancel">Anuluj</md-button><md-button ng-click="$ctrl.saveData($ctrl.user)" ng-disabled="form.$invalid || $ctrl.user.newEmail != $ctrl.user.confirmedNewEmail" class="md-raised md-primary" data-translate="global.button.save">Zapisz</md-button></md-dialog-actions></form>');
$templateCache.put('app/components/profile/profile-form-operator/profile-form-operator.dialog.html','<md-dialog aria-label="" class="upload-text"><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="global.form.profile-form-operator.title-edit"></h2></div></md-toolbar><profile-form-operator></profile-form-operator></md-dialog>');
$templateCache.put('app/components/profile/profile-form-operator/profile-form-operator.template.html','<form name="form" ng-cloak><md-dialog-content><div class="md-dialog-content profile-form" layout-margin><md-input-container class="md-block" flex-gt-sm><input ng-model="$ctrl.user.userEmail" name="login" type="text" placeholder="{{!$ctrl.user.userEmail ? \'global.form.placeholder.login\' : \'global.form.login\' | translate}}" ng-disabled="true"></md-input-container><md-input-container class="md-block" flex-gt-sm><input ng-model="$ctrl.user.userName" name="username" type="text" placeholder="{{!$ctrl.user.userName ? \'global.form.placeholder.firstname\' : \'global.form.firstname\'  | translate}}" ng-disabled="true" required></md-input-container><md-input-container class="md-block" flex-gt-sm><input ng-model="$ctrl.user.userSurname" name="surname" type="text" placeholder="{{!$ctrl.user.userSurname ? \'global.form.placeholder.surname\' : \'global.form.surname\' | translate}}" ng-disabled="true" required></md-input-container><md-input-container class="md-block" flex-gt-sm ng-if="$ctrl.user.userSchoolType == 0 || $ctrl.user.userSchoolType == 2 || $ctrl.user.userSchoolType == 4 || $ctrl.user.userSchoolType == 5"><label data-translate="global.form.organisationalunit"></label><md-select aria-label="org units" ng-model="$ctrl.user.organisationalUnitId" layout-align="center center" ng-disabled="true"><md-option ng-value="val.id" ng-repeat="val in $ctrl.organisationalUnits"><em>{{val.orguniLabel}}</em></md-option></md-select></md-input-container><md-input-container class="md-block" flex-gt-sm><input ng-model="$ctrl.user.userPosition" name="position" type="text" placeholder="{{!$ctrl.user.userPosition ? \'global.form.placeholder.position\' : \'global.form.position\' | translate}}"></md-input-container><md-input-container class="md-block" flex-gt-sm><input ng-model="$ctrl.user.userPhone" name="phone" type="text" placeholder="{{!$ctrl.user.userPhone ? \'global.form.placeholder.phone\' : \'global.form.phone\' | translate}}"></md-input-container><md-input-container class="md-block" flex><md-switch class="md-primary" name="notify" ng-model="$ctrl.user.userWantsNotifications"><span data-translate="global.form.report-notify">Powiadomienia z raportu prawdopodobie\u0144stwa</span></md-switch></md-input-container><md-button ng-if="$ctrl.allUsersCanDeleteAccounts" class="md-raised md-primary" ng-click="$ctrl.deleteAccountButtonClicked()" data-translate="delete-account.button"><md-tooltip md-direction="top" class="tooltip-with-long-text">{{ \'delete-account.button.tooltip\' | translate }}</md-tooltip></md-button></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="$ctrl.closeDialog()" data-translate="global.button.cancel">Anuluj</md-button><md-button ng-click="$ctrl.saveDataDetails($ctrl.user)" ng-disabled="form.$invalid" class="md-raised md-primary" data-translate="global.button.save">Zapisz</md-button></md-dialog-actions></form>');
$templateCache.put('app/account/assignments/peer-review/feedback/add-feedback.html','<div class="loader" layout="row" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending || vm.loadingValues"></md-progress-circular></div><div layout="row" class="h-100"><md-content layout="row" layout-padding flex="50" class="h-100"><div flex layout-padding><md-input-container class="md-block"><textarea flex ng-model="vm.obj.bodyText" md-select-on-focus readonly="readonly" aria-label="bodyText"></textarea></md-input-container></div></md-content><md-content layout="column" layout-padding class="h-100" flex="50"><h3 class="text-center" data-translate="assignment.feedbacks.answers.title"></h3><form name="form1" flex><div layout="column" ng-repeat="answer in vm.obj.answers" ng-if="!vm.loadingValues"><div class="text-center">{{answer.questionTitle}}</div><md-input-container ng-if="answer.questionType === \'text\'" class="md-block"><textarea flex name="answer{{$index}}" ng-model="answer.contentText" maxlength="5000" required ng-change="vm.validateWordCount(answer, $index)"></textarea><div class="text-right" ng-class="{\'text-danger\': answer.currentWordCount < answer.questionTextMinWords}"><span data-translate="peer-review.text-min-words"></span>: <span>{{answer.currentWordCount || 0}}/{{answer.questionTextMinWords}}</span></div></md-input-container><md-radio-group ng-if="answer.questionType === \'scale\'" ng-model="answer.contentScale" flex layout="row" layout-margin layout-align="center center" required><div>{{answer.questionScaleLowestValueName}}</div><md-radio-button flex="10" ng-repeat="n in generateRange(1, answer.questionScaleSize)" ng-value="n" aria-label="Rating {{n}}" class="md-primary" ng-mouseenter="answer.hoverRating = n" ng-mouseleave="answer.hoverRating = 0">{{n}}</md-radio-button><div>{{answer.questionScaleHighestValueName}}</div></md-radio-group></div><div layout="row" layout-padding layout-align="center center"><md-button id="feedbackCancelButton" aria-label="feedback-cancel" data-translate="global.form.button.cancel" ui-sref="feedbacks"></md-button><md-button id="feedbackSaveButton" aria-label="feedback-save" data-translate="peer-review.feedback.button.save-for-the-future" ng-click="vm.save()" ng-disabled="vm.pending"></md-button><md-button id="feedbackSubmitButton" aria-label="feedback-submit" class="md-raised md-primary" data-translate="peer-review.feedback.button.submit" ng-click="vm.submit(form1)" ng-disabled="vm.pending || form1.$invalid"></md-button></div></form></md-content></div>');
$templateCache.put('app/account/assignments/peer-review/feedback/feedback-list.html','<div class="site-container"><header class="header"><h5 data-translate="global.menu.account.feedbacks"></h5><span class="header-description" data-translate="assignment.feedbacks.page.header.info">opis</span></header><md-card><form name="formSearchFeedbacks"><div layout="row" layout-padding><select-page-size flex="25" layout="row" layout-align="start center" query-request="vm.queryRequest" on-value-chosen="vm.getPeerReviewsPage(1)"></select-page-size><div flex="75" flex-sm="75" flex-xs="100" layout="row" layout-align="end center" layout-sm="column"><md-input-container class="md-block" flex="70" flex-xs="100" layout-align="end center" md-no-float ng-if="vm.simpleSearch"><label for="simpleSearch" data-translate="global.search.title"></label><input id="simpleSearch" ng-change="vm.getPeerReviews()" ng-model="vm.searchRequest.simpleSearch" ng-model-options="{ debounce: vm.simpleSearchDelay }"></md-input-container><div flex="40" flex-xs="100" layout="row" layout-align="end center"><md-button ng-if="vm.simpleSearch" data-translate="global.button.search.advanced" aria-label="advanced" ng-click="vm.toggleSearch()"></md-button><md-button ng-if="!vm.simpleSearch" data-translate="global.button.search.simple" aria-label="simple" ng-click="vm.toggleSearch()"></md-button></div></div></div><div layout="row" layout-margin layout-wrap flex ng-if="!vm.simpleSearch"><md-input-container flex="30" flex-xs="100" class="mt-3"><label for="shortcode" data-translate="assignment.model.shortcode"></label><input id="shortcode" ng-model="vm.searchRequest.search.shortcode"></md-input-container><md-input-container flex="30" flex-xs="100" class="mt-3"><label for="search.title" data-translate="assignment.model.title"></label><input id="search.title" ng-model="vm.searchRequest.search.title"></md-input-container><md-input-container md-no-float flex="30" flex-xs="100" class="mt-3"><label data-translate="document.model.status">Status</label><md-select ng-change="vm.getPeerReviews()" ng-model="vm.searchRequest.search.status"><md-option ng-value="" ng-if="vm.searchRequest.search.status">{{\'global.button.clear\'| translate}}: {{\'document.model.status\' | translate}}</md-option><md-option ng-value="value.id" ng-repeat="value in vm.statuses">{{ value.translateKey | translate }}</md-option></md-select></md-input-container></div><div layout="row" layout-margin ng-if="!vm.simpleSearch"><md-button aria-label="clear" class="md-raised" data-translate="global.button.clear.search" ng-click="vm.clear()"></md-button><md-button aria-label="search" class="md-raised md-primary" data-translate="global.button.search" ng-click="vm.getPeerReviews()" type="submit"></md-button></div></form><md-table-container><table id="tableAssignments" md-table md-progress="vm.promise"><thead md-head><tr md-row><th md-column><span data-translate="assignment.model.shortcode"></span></th><th md-column><span data-translate="assignment.model.title"></span></th><th md-column><span data-translate="feedback.start-date"></span></th><th md-column><span data-translate="feedback.end-date"></span></th><th md-column><span data-translate="feedback.post-date"></span></th><th colspan="4"></th></tr></thead><tbody md-body><tr md-row ng-repeat-start="peerReview in vm.peerReviews track by $index"><td md-cell ng-if="vm.isAdmin"></td><!-- shortcode--><td md-cell><span>{{peerReview.shortcode}}</span></td><!-- title--><td md-cell><span>{{peerReview.assignmentTitle}}</span></td><!-- author start-date--><td md-cell><span ng-if="peerReview.studentsCanReviewFrom">{{peerReview.studentsCanReviewFrom | date: \'yyyy-MM-dd\'}} </span><span ng-if="!peerReview.studentsCanReviewFrom">--</span></td><!-- end-date--><td md-cell><span ng-if="peerReview.studentsCanReviewUntil">{{peerReview.studentsCanReviewUntil | date: \'yyyy-MM-dd\'}} </span><span ng-if="!peerReview.studentsCanReviewUntil">--</span></td><!-- post-date--><td md-cell><span ng-if="peerReview.feedbackAvailableFrom">{{peerReview.feedbackAvailableFrom | date: \'yyyy-MM-dd\'}} </span><span ng-if="!peerReview.feedbackAvailableFrom">--</span></td><!-- status--><td md-cell style="width: 10%"><div ng-if="peerReview.pendingReviewsCount > 0" class="text-black-50 text-center" data-translate="feedback.pending-reviews"></div><div class="text-center" ng-if="peerReview.pendingReviewsCount > 0">{{peerReview.pendingReviewsCount}}</div></td><!-- buttons--><td md-cell><md-button md-no-ink aria-label="expand reviews" class="md-primary" ng-disabled="peerReview.feedbacksToReview.length === 0" ng-click="onClickExpandFeedbacksToReview(peerReview.id)"><span ng-if="!vm.expandedFeedbacksToReview[peerReview.id]" data-translate="feedback.button.show-write-reviews"></span> <span ng-if="vm.expandedFeedbacksToReview[peerReview.id]" data-translate="feedback.button.hide-write-reviews"></span></md-button></td><td md-cell><md-button md-no-ink aria-label="expand reviews" class="md-primary" ng-disabled="!peerReview.feedbackAvailable" ng-click="onClickExpandReceivedReviews(peerReview.id)"><span ng-if="!vm.expandedReceivedReviews[peerReview.id]" data-translate="feedback.button.show-read-reviews"></span> <span ng-if="vm.expandedReceivedReviews[peerReview.id]" data-translate="feedback.button.hide-read-reviews"></span></md-button></td><td md-cell><md-button md-no-ink aria-label="expand reviews" class="md-primary" ng-if="peerReview.selfSelect > 0" ng-disabled="!peerReview.selfSelectPossible" ng-click="onClickSelfSelect(peerReview.id)"><span data-translate="feedback.button.self-select"></span> <span ng-if="peerReview.selfSelectLeft > 0">({{peerReview.selfSelectLeft}})</span></md-button></td></tr><tr md-row ng-if="vm.expandedFeedbacksToReview[peerReview.id]" ng-repeat="row in peerReview.feedbacksToReview"><td md-cell ng-if="vm.isAdmin">{{row.owner}}</td><!-- shortcode & title--><td md-cell colspan="2"><span class="text-black-50" data-translate="assignment.model.title"></span><br><span>{{row.docTitle}}</span></td><!-- under start-date & end-date--><td md-cell colspan="2"><span class="text-black-50" data-translate="assignment.model.author"></span><br><span ng-if="row.author">{{row.author}}</span> <span ng-if="!row.author">--</span></td><!-- post-date--><td md-cell></td><td md-cell><span ng-if="row.status == 0 && !row.reviewDateExceeded && !row.reviewDateNotStarted"><md-tooltip md-delay="100" md-direction="top">{{\'peer-review.status.in-progress\'| translate}}</md-tooltip><i class="material-icons icon-primary">edit</i> </span><span ng-if="row.status == 1"><md-tooltip md-delay="100" md-direction="top">{{\'peer-review.status.filled\'| translate}}</md-tooltip><i class="material-icons icon-success">gpp_good</i> </span><span ng-if="row.status == 0 && row.reviewDateExceeded"><md-tooltip md-delay="100" md-direction="top">{{\'peer-review.submit-review.button.tooltip.error.review-dates-exceeded\'| translate}}</md-tooltip><i class="material-icons icon-alphabet-alert-count">remove_circle_outline</i> </span><span ng-if="row.status == 0 && row.reviewDateNotStarted"><md-tooltip md-delay="100" md-direction="top">{{\'peer-review.submit-review.button.tooltip.error.review-date-not-started\'| translate}}</md-tooltip><i class="material-icons icon-secondary">lock_clock_outlined</i> </span><span ng-if="row.selfSelect"><md-tooltip md-delay="100" md-direction="top">{{\'feedback.button.self-select\'| translate}}</md-tooltip><i class="material-icons icon-secondary">info</i> </span><span ng-if="row.selfReview"><md-tooltip md-delay="100" md-direction="top">{{\'peer-review.form.force-self-review\' | translate}}</md-tooltip><i class="material-icons icon-secondary">info</i></span></td><td md-cell><div class="d-inline-flex" ng-if="row.status == 0"><md-button aria-label="submit-review" class="md-raised md-primary" ng-click="vm.submitReview(row)" ng-if="row.status != 2" ng-disabled="!row.reviewerCanReview"><span data-translate="peer-review.submit-review.button.label"></span><md-tooltip md-delay="100" md-direction="top"><span ng-if="row.reviewerCanReview">{{\'peer-review.submit-review.button.tooltip\'| translate}}</span> <span ng-if="false === row.allowReviewWithoutSubmission && false === row.reviewerUploadedDoc">{{\'peer-review.submit-review.button.tooltip.error.reviewer-didnt-uploaded-document\'| translate}}</span></md-tooltip></md-button></div></td><td md-cell></td><td md-cell></td></tr><tr md-row ng-if="vm.expandedReceivedReviews[peerReview.id]" ng-repeat="row in peerReview.feedbacksReceived"><td md-cell ng-if="vm.isAdmin">{{row.owner}}</td><td md-cell colspan="2"><span class="text-black-50" data-translate="assignment.model.title"></span><br><span>{{row.docTitle}}</span></td><td md-cell colspan="2"><span class="text-black-50" data-translate="assignment.model.author"></span><br><span ng-if="row.author">{{row.author}}</span> <span ng-if="!row.author">--</span></td><td md-cell><span class="text-black-50" data-translate="peer-review.feedbacks.table.grade"></span><br><span ng-if="!row.score">--</span> <span ng-if="row.score">{{row.score}}</span> <span>/ {{row.maxScore}}</span> <span>({{row.scorePercentage}}%)</span></td><td md-cell><span ng-if="row.status == 1"><md-tooltip md-delay="100" md-direction="top">{{\'peer-review.status.filled\'| translate}}</md-tooltip><i class="material-icons icon-success">gpp_good</i></span></td><!-- buttons--><td md-cell></td><td md-cell><md-button aria-label="read-review" class="md-raised md-primary" ng-click="readReview(row)"><span data-translate="peer-review.feedbacks.table.button.read-review"></span></md-button></td><td md-cell></td></tr><tr ng-repeat-end md-row ng-if="vm.expandedSelfSelectReviews[peerReview.id]" ng-repeat="row in peerReview.feedbacksToSelfSelect"><td md-cell ng-if="vm.isAdmin"></td><!-- shortcode & title--><td md-cell colspan="2"><span class="text-black-50" data-translate="assignment.model.title"></span><br><span>{{row.docTitle}}</span></td><!-- under start-date & end-date--><td md-cell colspan="2"><span class="text-black-50" data-translate="assignment.model.author"></span><br><span ng-if="row.author">{{row.author}}</span> <span ng-if="!row.author">--</span></td><!-- post-date--><td md-cell></td><!-- status--><td md-cell></td><!-- buttons--><td md-cell></td><td md-cell></td><td md-cell><md-button md-no-ink aria-label="submit-review" class="md-primary" ng-click="onClickSelfSelectReview(row)"><span data-translate="peer-review.submit-review.button.label"></span></md-button></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending"></md-progress-circular></div></md-table-container><div flex layout="row" layout-align="end center" layout-wrap><paging page="vm.queryRequest.page" page-size="vm.queryRequest.limit" paging-action="vm.getPeerReviewsPage(page)" show-first-last="true" show-prev-next="true" total="vm.totalAssignments"></paging><div layout="row" class="go-to" flex layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to next page" ng-model="vm.queryRequest.page" type="number" ng-keyup="vm.getPeerReviews()" ng-change="vm.getPeerReviews()"></md-input-container></div></div></md-card></div>');
$templateCache.put('app/account/assignments/peer-review/feedback/view-feedback.html','<div class="loader" layout="row" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.pending || vm.loadingValues"></md-progress-circular></div><div layout="row" class="h-100"><md-content layout="row" layout-padding flex="50" class="h-100"><md-input-container class="md-block w-100"><textarea flex ng-model="vm.obj.bodyText" md-select-on-focus readonly="readonly" aria-label="bodyText"></textarea></md-input-container></md-content><md-content layout="column" class="h-100" flex="50"><h3 class="text-center" data-translate="assignment.feedbacks.answers.title"></h3><div layout="column" layout-padding ng-repeat="answer in vm.obj.answers" ng-if="!vm.loadingValues"><div class="text-center">{{answer.questionTitle}}</div><md-input-container ng-if="answer.questionType === \'text\'" class="md-block"><textarea flex ng-model="answer.contentText" md-select-on-focus readonly="readonly"></textarea></md-input-container><md-radio-group ng-if="answer.questionType === \'scale\'" ng-model="answer.contentScale" layout="row" layout-margin layout-align="center center"><div>{{answer.questionScaleLowestValueName}}</div><md-radio-button flex="10" ng-repeat="n in generateRange(1, answer.questionScaleSize)" ng-value="n" aria-label="Rating {{n}}" class="md-primary" ng-disabled="true">{{n}}</md-radio-button><div>{{answer.questionScaleHighestValueName}}</div></md-radio-group></div><div layout="row" layout-padding layout-align="center center"><md-button id="feedbackCancelButton" aria-label="feedback-cancel" data-translate="global.button.cancel" ng-click="goBack()"></md-button></div><form novalidate class="form" name="form" ng-if="vm.isLecturer || vm.isAdmin"><div layout="row" layout-align="center center"><md-input-container class="fix-md-input-container" flex="10"><label for="grade" data-translate="peer-review.feedbacks.table.grade"></label><input id="grade" name="grade" type="number" min="0" max="{{vm.obj.maxScore}}" ng-model="vm.obj.score"></md-input-container><span class="ml-1">/</span> <span class="ml-1"><md-tooltip md-delay="100" md-direction="bottom"><span data-translate="peer-review.feedbacks.max-grade.tooltip"></span></md-tooltip>{{vm.obj.maxScore}}</span><md-button id="saveGrade" aria-label="save-grade" class="m-0 ml-1" data-translate="global.button.save" ng-click="saveGrade()" ng-disabled="form.$invalid"></md-button></div></form></md-content></div>');
$templateCache.put('app/account/assignments/peer-review/library/create-library.template.html','<md-dialog><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="peer-review.create-library.title"></h2></div></md-toolbar><md-dialog-content layout-padding><md-input-container class="md-block" flex flex-xs="100"><input name="newLibrary" ng-model="vm.newLibraryName" ng-required="true" placeholder="{{\'peer-review.new-library-name\' | translate}}"></md-input-container></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div class="loader" layout="row" layout-sm="column" layout-align="space-around" ng-if="vm.isLoading"><md-progress-circular md-mode="small" ng-show="vm.isLoading"></md-progress-circular></div><md-button ng-click="vm.cancel()" data-translate="global.button.cancel" aria-label="cancel"></md-button><md-button class="md-raised md-primary" aria-label="add" data-translate="peer-review.new-library-button" ng-click="vm.addNewLibrary()" ng-disabled="vm.isLoading || !vm.newLibraryName"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/account/assignments/peer-review/manual-assigment/add-reviewer.controller.html','<md-dialog><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="peer-review.form.manual-pair.button.show-details.tooltip"></h2></div></md-toolbar><md-dialog-content layout-padding><small><span data-translate="peer-review.manual-pair.modal.subheader"></span> <b>{{vm.docOwnerFullName}}</b></small><div ng-repeat="reviewer in vm.reviewers"><md-checkbox class="md-primary" ng-model="vm.checked[$index]" ng-disabled="vm.disabled"><div>{{reviewer.fullName}}</div></md-checkbox></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><span ng-style="{\'color\': vm.getSelected().length > vm.max ? \'red\' : \'black\'}"><span data-translate="peer-review.manual-pair.modal.selected-counter"></span>: {{vm.getSelected().length}} / {{vm.max}}</span><md-button ng-click="vm.cancel()" aria-label="cancel" data-translate="global.button.cancel"></md-button><md-button ng-click="vm.confirm()" aria-label="confirm" ng-disabled="vm.getSelected().length > vm.max || vm.disabled" data-translate="global.button.confirm"></md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/account/documents/document/document-form/document-form-assignment.template.html','<div class="add-document-wrapper client-metric" ng-class="{\'active\': $ctrl.onUploadIsActive}"><md-toolbar><div class="md-toolbar-tools" flex layout="row"><span flex="40" class="add-document-text" data-translate="document.metric.add-document">Dodaj dokument</span><div flex="60" ng-if="!$ctrl.onUploadTextFlag"><span class="add-file-text" data-translate="document.metric.file-uploaded">Dodano plik:</span> <i class="material-icons doc-remove" ng-click="$ctrl.resetUploadForm()">cancel</i><md-tooltip md-delay="100" md-direction="bottom">{{$ctrl.onUploadObj.docuTitle}}</md-tooltip><div flex class="document-title">{{$ctrl.onUploadObj.docuTitle}}</div></div></div></md-toolbar><form name="form"><div layout="row" layout-wrap><div layout="row" layout-wrap layout-margin flex="100"><md-input-container flex class="md-block"><input name="docuTitle" placeholder="{{!$ctrl.onUploadObj.docuTitle ? \'document.metric.placeholder.title\' : \'document.metric.document-title\' | translate}}" ng-model="$ctrl.onAssignmentSubmitForm.title" ng-required="true" md-maxlength="700" ng-maxlength="700"><plagiat-ng-messages form-element="form.docuTitle" translate-values="{maxlength: \'document.messages.max700\'}"></plagiat-ng-messages></md-input-container></div><div layout="row" layout-wrap layout-margin flex="100"><md-input-container class="md-block" flex flex-xs="100"><input placeholder="{{\'document.model.author\' | translate}}" ng-model="$ctrl.onAssignmentSubmitForm.authorName" ng-disabled="true"></md-input-container></div><div layout="row" layout-wrap layout-margin flex="100"><md-input-container class="md-block" flex flex-xs="100"><input placeholder="{{$ctrl.clientTypeSchool ? \'document.metric.client-type.school.teacher\' : \'document.metric.client.promoter.placeholder.fullname\' | translate}}" ng-model="$ctrl.onAssignmentSubmitForm.coordinatorName" ng-disabled="true"></md-input-container></div><div layout="row" layout-wrap layout-margin flex="100"><md-input-container class="md-block" flex flex-xs="100"><input placeholder="{{ \'document.metric.client.promoter.type\' | translate}}" ng-model="$ctrl.onAssignmentSubmitForm.documentKind" ng-disabled="true"></md-input-container></div><div layout="row" flex="100" layout-align="end center"><md-button aria-label="cancel" data-translate="document.metric.cancel" ng-click="$ctrl.resetUploadForm()">Anuluj</md-button><md-button aria-label="add" ng-disabled="$ctrl.loading" class="md-raised md-primary button-waiting" data-translate="document.metric.client.add" ng-click="$ctrl.submitAssignment(form)">Dodaj</md-button></div></div></form></div>');
$templateCache.put('app/account/documents/document/document-form/document-form-universal.template.html','<div class="add-document-wrapper client-metric" ng-class="{ \'active\': $ctrl.onUploadIsActive}"><md-toolbar><div class="md-toolbar-tools" flex layout="row"><span flex="40" class="add-document-text" data-translate="document.metric.add-document">Dodaj dokument</span><div flex="60" ng-if="!$ctrl.onUploadTextFlag"><span class="add-file-text" data-translate="document.metric.file-uploaded">Dodano plik:</span> <i class="material-icons doc-remove" ng-click="$ctrl.resetUploadForm()">cancel</i><md-tooltip md-delay="100" md-direction="bottom">{{$ctrl.onUploadObj.filename}}</md-tooltip><div flex class="document-title">{{$ctrl.onUploadObj.filename}}</div></div><div flex="60" ng-if="$ctrl.onUploadTextFlag"><span class="add-file-text" data-translate="document.metric.textuploaded">Dodano tekst!</span><md-button ng-click="$ctrl.uploadText()" data-translate="document.metric.edittext">Anuluj</md-button><md-button ng-click="$ctrl.resetUploadForm()" data-translate="document.metric.deletetext">Anuluj</md-button></div></div></md-toolbar><form name="form"><div layout="row" layout-wrap><div layout="row" layout-wrap layout-margin flex="100"><md-input-container class="md-block add-without-checking" flex="100" ng-if="$ctrl.onUploadObj.addWithoutCheckingInfo.isPresent"><md-switch id="addWithoutCheckingSwitch" class="md-primary" name="notify" aria-label="{{\'document.metric.client.add-without-checking\'| translate}}" ng-disabled="$ctrl.onUploadObj.addWithoutCheckingDisabled" ng-model="$ctrl.onUploadObj.addWithoutChecking" ng-change="$ctrl.verifyAiDetectionVsAutoTranslation(\'addWithoutChecking\')"><span class="add-without-checking-switch-text" id="addWithoutCheckingSwitchText" data-translate="document.metric.client.add-without-checking"></span> <span id="addWithoutCheckingError" ng-if="$ctrl.onUploadObj.addWithoutCheckingError">(<span data-translate="{{$ctrl.onUploadObj.addWithoutCheckingErrorText}}" class="md-input-messages-error"></span>)</span></md-switch></md-input-container><md-input-container class="md-block add-without-checking" flex="100" ng-if="!$ctrl.onUploadObj.addWithoutCheckingInfo.isPresent && $ctrl.onUploadObj.addWithoutCheckingError && $ctrl.isStudent"><span data-translate="{{$ctrl.onUploadObj.addWithoutCheckingErrorText}}" class="md-input-messages-error"></span></md-input-container></div><div layout="row" layout-wrap layout-margin flex="100" ng-if="$ctrl.onUploadObj.autoTranslationsInfo.isPresent"><md-input-container class="md-block auto-translations mt-0 mb-0" flex="80"><md-switch id="autoTranslationsEnabledSwitch" class="md-primary mt-1 mb-1" name="autoTranslationsEnabled" aria-label="document.metric.client.auto-tr" ng-model="$ctrl.onUploadObj.autoTranslations" ng-change="$ctrl.verifyAiDetectionVsAutoTranslation(\'autoTranslation\')"><div layout="row"><span class="auto-translations-switch-text" id="autoTranslationsEnabledSwitchText" data-translate="document.metric.auto-translations.label"></span><div class="ml-2"><i class="material-icons-outlined options">info</i><md-tooltip md-delay="100" md-direction="bottom" class="auto-translations-tooltip">{{\'document.metric.auto-translations.tooltip\'| translate}}</md-tooltip></div></div><span id="autoTranslationsEnabledError" ng-if="$ctrl.onUploadObj.autoTranslationsError">(<span data-translate="{{$ctrl.onUploadObj.autoTranslationsErrorText}}" class="md-input-messages-error"></span>)</span></md-switch></md-input-container><div flex></div></div><div layout="row" layout-wrap layout-margin flex="100" ng-if="$ctrl.onUploadObj.autoTranslations === true"><div layout-align="end end" layout="column"><div><span layout-align="center end" data-translate="document.metric.auto-translations.translate-lang-text"></span></div></div><md-input-container flex="15" flex-xs="100" ng-if="$ctrl.autoTranslationsLangSelection"><label data-translate="document.metric.auto-translations.from-lang-placeholder">J\u0119zyk \u017Ar\xF3d\u0142owy</label><md-select id="fromLangSelect" name="fromLangSelect" aria-label="fromLang" layout-align="center center" ng-model="$ctrl.onUploadObj.autoTranslationsFromLang" ng-required="true"><md-option id="autoTranslationLangsFrom{{val.code}}" ng-value="val.code" ng-repeat="val in $ctrl.autoTranslationLangs">{{val.translated}}</md-option></md-select><plagiat-ng-messages form-element="form.fromLangSelect"></plagiat-ng-messages></md-input-container><div layout-align="end end" layout="column" ng-if="$ctrl.autoTranslationsLangSelection"><div><i class="material-icons">east</i></div></div><md-input-container flex="15" flex-xs="100"><label data-translate="document.metric.auto-translations.to-lang-placeholder">J\u0119zyk docelowy</label><md-select id="toLangSelect" name="toLangSelect" aria-label="toLang" layout-align="center center" ng-model="$ctrl.onUploadObj.autoTranslationsToLang" ng-required="true"><md-option id="autoTranslationLangsTo{{val.code}}" ng-value="val.code" ng-repeat="val in $ctrl.autoTranslationLangs">{{val.translated}}</md-option></md-select><plagiat-ng-messages form-element="form.toLangSelect"></plagiat-ng-messages></md-input-container><div flex></div></div><div layout="row" flex="100"><div flex="50"><div layout="row" layout-wrap layout-margin flex="100" ng-if="$ctrl.onUploadObj.aiDetectionInfo.isPresent"><md-input-container flex><md-switch id="aiDetectionEnabledSwitch" class="md-primary mt-1 mb-1" name="aiDetectionEnabled" aria-label="document.metric.client.aiDetection" ng-model="$ctrl.onUploadObj.aiDetection" ng-disabled="$ctrl.aiDetectionDisabled()" ng-change="$ctrl.verifyAiDetectionVsAutoTranslation(\'aiDetection\')"><div layout="row"><span class="auto-translations-switch-text" id="aiDetectionEnabledSwitchText" data-translate="document.metric.ai-detection.label"></span><div class="ml-2"><i class="material-icons-outlined options">info</i><md-tooltip md-delay="100" md-direction="bottom" class="auto-translations-tooltip">{{\'document.metric.ai-detection.tooltip\'| translate}}</md-tooltip></div><span ng-if="$ctrl.aiDetectionPoolExhausted()" data-translate="document.metric.ai-detection.pool.exhausted"></span></div></md-switch></md-input-container></div><div layout="row" layout-wrap layout-margin flex="100" ng-if="$ctrl.onUploadObj.grammarCheckInfo.isPresent"><md-input-container flex><md-switch id="grammarCheckEnabledSwitch" class="md-primary mt-1 mb-1" name="grammarCheckEnabled" aria-label="document.metric.client.grammarCheck" ng-model="$ctrl.onUploadObj.grammarCheck" ng-disabled="$ctrl.grammarCheckDisabled()" ng-change="$ctrl.verifyAiDetectionVsAutoTranslation(\'grammarCheck\')"><div layout="row"><span class="auto-translations-switch-text" id="grammarCheckEnabledSwitchText" data-translate="document.metric.grammar-check.label"></span><div class="ml-2"><i class="material-icons-outlined options">info</i><md-tooltip md-delay="100" md-direction="bottom" class="auto-translations-tooltip">{{\'document.metric.grammar-check.tooltip\'| translate}}</md-tooltip></div></div></md-switch></md-input-container></div><div layout="row" layout-wrap layout-margin flex="100" ng-if="$ctrl.onUploadObj.restrictingDatabasesInfo.isPresent"><md-input-container flex><md-switch id="restrictingDatabasesInfoSwitch" class="md-primary mt-1 mb-1" name="restrictingDatabasesEnabled" aria-label="document.metric.client.restrictingDatabasesInfo" ng-model="$ctrl.onUploadObj.restrictingDatabases"><div layout="row"><span class="auto-translations-switch-text" id="restrictingDatabasesInfoSwitchText" data-translate="document.metric.restricting-databases.label"></span><div class="ml-2"><i class="material-icons-outlined options">info</i><md-tooltip md-delay="100" md-direction="bottom" class="auto-translations-tooltip">{{\'document.metric.restricting-databases.tooltip\'| translate}}</md-tooltip></div></div></md-switch></md-input-container></div></div><div flex="50"><div ng-if="$ctrl.onUploadObj.restrictingDatabases" layout="column"><md-input-container flex ng-if="$ctrl.onUploadObj.restrictingDatabasesInfoRefbooks.isPresent"><md-switch id="restrictingDatabasesOptionSwitchRefbooks" class="md-primary mt-1 mb-1" name="restrictingDatabasesOptionRefbooks" aria-label="document.metric.client.restrictingDatabasesOptionRefbooks" ng-model="$ctrl.onUploadObj.restrictingDatabasesOptions[64]"><div layout="row"><span class="auto-translations-switch-text" id="restrictingDatabasesOptionSwitchTextRefbooks" data-translate="document.metric.restricting-databases.refbooks"></span></div></md-switch></md-input-container><md-input-container flex ng-if="$ctrl.onUploadObj.restrictingDatabasesInfoLocalDb.isPresent"><md-switch id="restrictingDatabasesOptionSwitchLocalDb" class="md-primary mt-1 mb-1" name="restrictingDatabasesOptionLocalDb" aria-label="document.metric.client.restrictingDatabasesOptionLocalDb" ng-model="$ctrl.onUploadObj.restrictingDatabasesOptions[128]" ng-disabled="$ctrl.onUploadObj.restrictingDatabasesOptions[256]"><div layout="row"><span class="auto-translations-switch-text" id="restrictingDatabasesOptionSwitchTextLocalDb" data-translate="document.metric.restricting-databases.local-db"></span></div></md-switch></md-input-container><md-input-container flex ng-if="$ctrl.onUploadObj.restrictingDatabasesInfoDep.isPresent"><md-switch id="restrictingDatabasesOptionSwitchDep" class="md-primary mt-1 mb-1" name="restrictingDatabasesOptionDep" aria-label="document.metric.client.restrictingDatabasesOptionDep" ng-model="$ctrl.onUploadObj.restrictingDatabasesOptions[256]" ng-disabled="$ctrl.onUploadObj.restrictingDatabasesOptions[128]"><div layout="row"><span class="auto-translations-switch-text" id="restrictingDatabasesOptionSwitchTextDep" data-translate="document.metric.restricting-databases.dep"></span></div></md-switch></md-input-container><md-input-container flex ng-if="$ctrl.onUploadObj.restrictingDatabasesInfoInternet.isPresent"><md-switch id="restrictingDatabasesOptionSwitchInternet" class="md-primary mt-1 mb-1" name="restrictingDatabasesOptionInternet" aria-label="document.metric.client.restrictingDatabasesOptionInternet" ng-model="$ctrl.onUploadObj.restrictingDatabasesOptions[512]"><div layout="row"><span class="auto-translations-switch-text" id="restrictingDatabasesOptionSwitchTextInternet" data-translate="document.metric.restricting-databases.internet"></span></div></md-switch></md-input-container><md-input-container flex ng-if="$ctrl.onUploadObj.restrictingDatabasesInfoUkrnti.isPresent"><md-switch id="restrictingDatabasesOptionSwitchUkrnti" class="md-primary mt-1 mb-1" name="restrictingDatabasesOptionUkrnti" aria-label="document.metric.client.restrictingDatabasesOptionUkrnti" ng-model="$ctrl.onUploadObj.restrictingDatabasesOptions[1024]"><div layout="row"><span class="auto-translations-switch-text" id="restrictingDatabasesOptionSwitchTextUkrnti" data-translate="document.metric.restricting-databases.ukrnti"></span></div></md-switch></md-input-container></div></div></div><div layout="row" layout-wrap layout-margin flex="100"><md-input-container flex class="md-block" ng-if="$ctrl.onUploadObj.docuTitleInfo.isPresent"><input name="docuTitle" placeholder="{{!$ctrl.onUploadObj.docuTitle ? \'document.metric.placeholder.title\' : \'document.metric.document-title\' | translate}}" ng-model="$ctrl.onUploadObj.docuTitle" ng-required="$ctrl.onUploadObj.docuTitleInfo.isMandatory" md-maxlength="700" ng-maxlength="700"><plagiat-ng-messages form-element="form.docuTitle" translate-values="{maxlength: \'document.messages.max700\'}"></plagiat-ng-messages></md-input-container></div><div layout="row" layout-wrap layout-margin flex="100" ng-if="$ctrl.onUploadObj.oldPhdYearInfo.isPresent"><md-input-container flex="25" flex-xs="100" class="md-block"><input name="oldPhdYear" placeholder="{{\'document.metric.old-phd-year\' | translate}}" type="number" ng-minlength="4" ng-maxlength="50" min="1990" max="2021" ng-pattern="/^[0-9]+$/" ng-model="$ctrl.onUploadObj.oldPhdYear" ng-required="$ctrl.onUploadObj.oldPhdYearInfo.isMandatory"><plagiat-ng-messages form-element="form.oldPhdYear"></plagiat-ng-messages></md-input-container></div><div layout="row" layout-wrap layout-margin flex="100" ng-if="$ctrl.onUploadObj.docuAuthorInfo.isPresent && $ctrl.authorFromUsersList"><!-- AUTHOR AUTOCOMPLETE --><md-input-container flex><md-autocomplete md-input-name="user-autocomplete" md-floating-label="{{\'document.metric.authorfullname\'| translate}}" md-item-text="item.label" md-items="item in $ctrl.authorsQuerySearch($ctrl.authorsSearchText)" md-min-length="0" md-no-cache="$ctrl.noCache" md-search-text="$ctrl.authorsSearchText" md-search-text-change="$ctrl.authorsSearchTextChange($ctrl.authorsSearchText)" md-selected-item="$ctrl.authorSelectedItem" md-selected-item-change="$ctrl.authorsSelectedItemChange(item)" md-require-match="true" md-select-on-match="true" ng-disabled="false" ng-required="$ctrl.onUploadObj.docuAuthorInfo.isMandatory"><md-item-template><span md-highlight-flags="^i" md-highlight-text="ctrl.authorsSearchText">{{item.label}}</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{$ctrl.authorsSearchText}}"</md-not-found><plagiat-ng-messages form-element="form.user-autocomplete"></plagiat-ng-messages></md-autocomplete></md-input-container></div><div layout="row" layout-wrap layout-margin flex="100" ng-if="$ctrl.onUploadObj.docuAuthorInfo.isPresent && !$ctrl.authorFromUsersList"><md-input-container class="md-block" flex flex-xs="100" ng-if="!$ctrl.authorsSimplifiedFields"><input name="firstAuthorFirstNameInput" placeholder="{{!$ctrl.onUploadObj.authors[\'idx\' + 0].firstName ? \'document.metric.placeholder.name\' : \'document.metric.author-first-name\' | translate}}" ng-required="$ctrl.onUploadObj.docuAuthorInfo.isMandatory" ng-model="$ctrl.onUploadObj.authors.idx0.firstName" ng-disabled="$ctrl.isStudent"><plagiat-ng-messages form-element="form.firstAuthorFirstNameInput"></plagiat-ng-messages></md-input-container><md-input-container class="md-block m-top" flex flex-xs="100" ng-if="!$ctrl.authorsSimplifiedFields"><input name="firstAuthorLastNameInput" placeholder="{{!$ctrl.onUploadObj.authors[\'idx\' + 0].lastName ?\'document.metric.placeholder.surname\' : \'document.metric.author-last-name\'| translate}}" ng-required="$ctrl.onUploadObj.docuAuthorInfo.isMandatory" ng-model="$ctrl.onUploadObj.authors.idx0.lastName" ng-disabled="$ctrl.isStudent"><plagiat-ng-messages form-element="form.firstAuthorLastNameInput"></plagiat-ng-messages></md-input-container><md-input-container class="md-block" flex flex-xs="100" ng-if="$ctrl.authorsSimplifiedFields"><input id="firstAuthorInput" placeholder="{{\'document.metric.authorfullname\' | translate}}" ng-required="$ctrl.onUploadObj.docuAuthorInfo.isMandatory" ng-model="$ctrl.onUploadObj.authors[\'idx\' + 0].firstName" ng-disabled="$ctrl.isStudent"> <input type="hidden" ng-model="$ctrl.onUploadObj.authors[\'idx\' + 0].lastName"><plagiat-ng-messages form-element="form.firstAuthorInput"></plagiat-ng-messages></md-input-container><md-input-container class="md-block" flex flex-xs="100" ng-if="$ctrl.onUploadObj.indexNumberInfo.isPresent"><input name="authorIndex" ng-model="$ctrl.onUploadObj.authors[\'idx\' + 0].index" placeholder="{{!$ctrl.onUploadObj.authors[\'idx\' + 0].index ? \'document.metric.placeholder.index\' : \'document.metric.client.index\' | translate}}" ng-required="$ctrl.onUploadObj.indexNumberInfo.isMandatory"><plagiat-ng-messages form-element="form.authorIndex"></plagiat-ng-messages></md-input-container><md-input-container class="md-block plagiat-input-color" flex flex-xs="100" ng-if="$ctrl.onUploadObj.schoolClassInfo.isPresent"><input name="documentClass" ng-model="$ctrl.onUploadObj.schoolClass" ng-required="$ctrl.onUploadObj.schoolClassInfo.isMandatory" placeholder="{{\'document.metric.school-class.placeholder\' | translate}}"><plagiat-ng-messages form-element="form.documentClass"></plagiat-ng-messages></md-input-container></div></div><div class="cooauthors-add" layout="row" flex="100" ng-if="$ctrl.onUploadObj.docuAuthorInfo.isPresent && !$ctrl.authorFromUsersList"><md-button ng-click="$ctrl.addAuthor()" class="md-raised md-primary" data-translate="document.metric.client.add-author">Dodaj wsp\xF3\u0142autora</md-button></div><div layout="row" layout-wrap layout-margin flex="100" ng-repeat="n in $ctrl.authorsArr" ng-if="$ctrl.authorsArr.length > 0 && $ctrl.onUploadObj.docuTitleInfo.isPresent"><!-- SEPARATE FIRSTNAME AND SURNAME --><md-input-container class="md-block" flex flex-xs="100" ng-if="!$ctrl.authorsSimplifiedFields"><input placeholder="{{!$ctrl.onUploadObj.authors[\'idx\' + n].firstName ? \'document.metric.placeholder.name\' : \'document.metric.author-first-name\' | translate}}" ng-model="$ctrl.onUploadObj.authors[\'idx\' + n].firstName"></md-input-container><md-input-container class="md-block" flex flex-xs="100" ng-if="!$ctrl.authorsSimplifiedFields"><input placeholder="{{!$ctrl.onUploadObj.authors[\'idx\' + n].lastName ? \'document.metric.placeholder.surname\' : \'document.metric.author-last-name\' | translate}}" ng-model="$ctrl.onUploadObj.authors[\'idx\' + n].lastName"></md-input-container><!-- ONLY ONE AUTHOR FIELD: BOTH NAME AND SURNAME COMBINED --><md-input-container class="md-block" flex flex-xs="100" ng-if="$ctrl.authorsSimplifiedFields"><input placeholder="{{\'document.metric.placeholder.coauthorfullname\' | translate}}" ng-model="$ctrl.onUploadObj.authors[\'idx\' + n].firstName"> <input type="hidden" ng-model="$ctrl.onUploadObj.authors[\'idx\' + n].lastName"></md-input-container><!-- AUTHOR INDEX --><md-input-container class="md-block plagiat-input-color" flex flex-xs="100" ng-if="$ctrl.onUploadObj.indexNumberInfo.isPresent"><input placeholder="{{!$ctrl.onUploadObj.authors[\'idx\' + n].index ? \'document.metric.placeholder.index\' : \'document.metric.client.index\' | translate}}" ng-model="$ctrl.onUploadObj.authors[\'idx\' + n].index"></md-input-container><md-input-container class="md-block" flex="15" flex-xs="100"><md-button ng-click="$ctrl.removeAuthor($event, \'idx\' + n)" class="md-raised md-primary">X</md-button></md-input-container></div><div layout="row" layout-wrap layout-margin flex ng-if="::$ctrl.isCoordinatorVisible() && $ctrl.canUserChangeCoordinator()"><!-- SEPARATE COORDINATOR TITLE, FIRSTNAME AND SURNAME --><md-input-container class="md-block" flex="20" flex-xs="100" ng-if="!$ctrl.authorsSimplifiedFields"><input placeholder="{{$ctrl.clientTypeSchool ? \'document.metric.client.teacher.title\' : \'document.metric.client.promoter.title\' | translate}}" ng-model="$ctrl.onUploadObj.coordinatorDTO.title"></md-input-container><md-input-container class="md-block" flex flex-xs="100" ng-if="!$ctrl.authorsSimplifiedFields"><input name="coordinatorFirstName" placeholder="{{$ctrl.clientTypeSchool ? \'document.metric.client.teacher.first-name\' : \'document.metric.client.promoter.firstname\' | translate}}" ng-model="$ctrl.onUploadObj.coordinatorDTO.firstName" ng-required="$ctrl.onUploadObj.coordinatorInfo.isMandatory && !$ctrl.onIsLecturer"><plagiat-ng-messages form-element="form.coordinatorFirstName"></plagiat-ng-messages></md-input-container><md-input-container class="md-block" flex flex-xs="100" ng-if="!$ctrl.authorsSimplifiedFields"><input name="coordinatorLastName" placeholder="{{$ctrl.clientTypeSchool ? \'document.metric.client.teacher.last-name\' : \'document.metric.client.promoter.surname\' | translate}}" ng-model="$ctrl.onUploadObj.coordinatorDTO.lastName" ng-required="$ctrl.onUploadObj.coordinatorInfo.isMandatory && !$ctrl.onIsLecturer"><plagiat-ng-messages form-element="form.coordinatorLastName"></plagiat-ng-messages></md-input-container><!-- ONLY ONE COORDINATOR FIELD: BOTH TITLE,NAME AND SURNAME COMBINED --><md-input-container class="md-block" flex flex-xs="100" ng-if="$ctrl.authorsSimplifiedFields"><input name="coordinatorSimplifiedFields" placeholder="{{$ctrl.clientTypeSchool ? \'document.metric.client-type.school.teacher\' : \'document.metric.client.promoter.placeholder.fullname\' | translate}}" ng-model="$ctrl.onUploadObj.coordinatorDTO.firstName" ng-required="$ctrl.onUploadObj.coordinatorInfo.isMandatory && !$ctrl.onIsLecturer"><plagiat-ng-messages form-element="form.coordinatorSimplifiedFields"></plagiat-ng-messages></md-input-container></div><div layout="row" layout-wrap layout-margin flex="100"><!-- COORDINATOR AUTOCOMPLETE --><md-input-container flex flex-xs="70" ng-if="$ctrl.coordinatorAutocompleteAvailable()"><md-autocomplete md-input-name="coordinator" md-floating-label="{{$ctrl.clientTypeSchool ? \'document.metric.client-type.school.teacher\' : \'document.model.docu-coordinator\'| translate}}" md-item-text="item.label" md-items="item in $ctrl.querySearch($ctrl.searchText)" md-min-length="0" md-no-cache="$ctrl.noCache" md-search-text="$ctrl.searchText" md-search-text-change="$ctrl.searchTextChange(ctrl.searchText)" md-selected-item="$ctrl.selectedItem" md-selected-item-change="$ctrl.selectedItemChange(item)" md-require-match="true" md-select-on-match="true" ng-disabled="$ctrl.isDisabled || $ctrl.coordinatorNotApplicable" ng-required="$ctrl.onUploadObj.coordinatorInfo.isMandatory && !$ctrl.onIsLecturer && !$ctrl.coordinatorNotApplicable"><md-item-template><span md-highlight-flags="^i" md-highlight-text="ctrl.searchText">{{item.label}}</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{$ctrl.searchText}}"</md-not-found><plagiat-ng-messages form-element="form.coordinator"></plagiat-ng-messages></md-autocomplete></md-input-container><md-input-container class="coordinator-not-applicable-switch" flex-gt-lg-none flex-xs="20" ng-if="$ctrl.coordinatorAutocompleteAvailable() && !($ctrl.isStudent && $ctrl.clientTypeSchool)"><md-switch aria-label="coordinator not applicable switch" class="md-primary" ng-model="$ctrl.coordinatorNotApplicable"><i class="material-icons">info</i><md-tooltip ng-bind-html="\'document.form.cordinator-not-applicable-switch.tooltip\' | translate"></md-tooltip></md-switch></md-input-container><md-input-container flex flex-xs="100" ng-if="$ctrl.onUploadObj.docuKindInfo.isPresent"><label data-translate="document.metric.client.promoter.type">Rodzaj dokumentu</label><md-select id="documentKindSelect" name="documentKindSelect" aria-label="docu kinds" layout-align="center center" ng-model="$ctrl.onUploadObj.documentKindId" ng-required="$ctrl.onUploadObj.docuKindInfo.isMandatory"><md-option id="idOptionDocuKind{{$index}}" ng-value="val.value" ng-repeat="val in $ctrl.onUploadObj.docuKindInfo.selectItems">{{val.label}}</md-option></md-select><plagiat-ng-messages form-element="form.documentKindSelect"></plagiat-ng-messages></md-input-container><md-input-container flex flex-xs="100" ng-if="$ctrl.onUploadObj.orgUnitInfo.isPresent"><md-autocomplete md-input-name="organizationAutocomplete" md-selected-item="$ctrl.selectedOrganization" md-search-text="$ctrl.searchOrganizationText" md-items="organization in $ctrl.querySearchOrganizations()" md-selected-item-change="$ctrl.selectedOrganizationChange(organization)" md-item-text="organization.label" md-min-length="0" md-floating-label="{{\'document.metric.client.promoter.unit\'| translate}}" md-no-cache="true" md-clear-button="$ctrl.canChangeOrganisationUnit" md-require-match="true" md-select-on-match="true" ng-disabled="!$ctrl.canChangeOrganisationUnit" ng-required="$ctrl.onUploadObj.orgUnitInfo.isMandatory"><md-item-template><span md-highlight-text="$ctrl.searchOrganizationText" md-highlight-flags="^i">{{organization.label}}</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{$ctrl.searchOrganizationText}}"</md-not-found><plagiat-ng-messages form-element="form.organizationAutocomplete"></plagiat-ng-messages></md-autocomplete></md-input-container></div><div layout="row" layout-wrap layout-margin flex="100"><div layout="row" flex="33" flex-xs="100" ng-repeat="p in $ctrl.onUploadObj.documentParameterDefinitions" id="idParameter{{p.dopadeName}}"><md-input-container class="md-block" flex ng-if="p.dopadeType==0"><input id="idInput{{p.dopadeName}}" placeholder="{{p.dopadeName}}" ng-model="$ctrl.onUploadObj.documentParameters[p.id]" ng-init="$ctrl.onUploadObj.documentParameters[p.id]=p.dopadeDefault"></md-input-container><md-input-container class="md-block" flex ng-if="p.dopadeType==1"><label for="idSelect{{p.dopadeName}}">{{p.dopadeName}}</label><md-select id="idSelect{{p.dopadeName}}" aria-label="docu parameters" layout-align="center center" ng-model="$ctrl.onUploadObj.documentParameters[p.id]" ng-init="$ctrl.onUploadObj.documentParameters[p.id]=p.dopadeDefault"><md-option ng-value="val" ng-repeat="val in p.comboBoxValues"><em>{{val}}</em></md-option></md-select></md-input-container></div></div><div layout="row" layout-margin ng-if="$ctrl.account.clientSettings.ignoringBibliography"><span data-translate="document.form.ignoring.bibliography.info"></span> <i class="material-icons">info</i><md-tooltip class="tooltip-with-long-text" md-direction="top" ng-bind-html="\'document.form.ignoring.bibliography.tooltip\' | translate"></md-tooltip></div><div layout="row" layout-margin ng-if="$ctrl.showSkipUrl()"><md-input-container flex="100"><md-switch aria-label="document skip addresses flag" name="documentSkipAddressesFlag" class="md-primary m-1" ng-init="$ctrl.onUploadObj.documentSkipAddressesFlag = $ctrl.onUploadObj.documentSkipAddresses.length > 0" ng-model="$ctrl.onUploadObj.documentSkipAddressesFlag" ng-change="$ctrl.setAddressesBlock()" ng-disabled="$ctrl.onUploadObj.skipAddresses.isPresent"><span data-translate="document.form.skip-addresses"></span> <i class="material-icons">info</i><md-tooltip class="tooltip-with-long-text" md-direction="top" ng-bind-html="\'document.form.skip-addresses.tooltip\' | translate"></md-tooltip></md-switch></md-input-container></div><div layout="row" flex="100" class="document-metric-authors" ng-if="$ctrl.onUploadObj.documentSkipAddressesFlag"><md-chips layout-margin flex flex-xs="100" aria-label="address to skip" min-width="400" name="documentSkipAddresses" placeholder="{{\'document.form.skip-addresses-placeholder\' | translate}}" ng-model="$ctrl.onUploadObj.documentSkipAddresses" md-removable="true" md-add-on-blur="true" md-transform-chip="$ctrl.getDocumentSkipAddress($chip)" readonly="false"><md-chip-template>{{$chip.address}}</md-chip-template></md-chips></div><div layout="row" layout-wrap layout-margin ng-if="$ctrl.skipAddressesInvalidError"><div class="errors" ng-messages="form.documentSkipAddresses.$error"><span data-translate="document.form.skip-addresses.invalid-url"></span> : {{$ctrl.skipAddressesInvalidUrl}}</div></div><div layout="row" layout-wrap layout-margin ng-if="$ctrl.shouldShowCodeAccountCheckModal"><three-state-radio class="ml-3" ng-model="$ctrl.priorityCode" data-label="{{\'document.form.priority-code.label\' | translate}}"></three-state-radio><span class="ml-5 flex-60 flex-xs-100 font-weight-bold" data-translate="document.form.priority-code.description"></span></div><div layout="row" ng-if="$ctrl.showDocumentVerification() && !$ctrl.onUploadObj.addWithoutChecking"><md-input-container flex="100"><md-switch aria-label="confirm paper form validity" class="md-primary m-1" name="paperFormValidityFlag" ng-model="$ctrl.onUploadObj.paperFormValidityFlag" required><span data-translate="document.form.paper.validity"></span> <span>{{$ctrl.onUploadObj.size | numberOfPages}}</span> <i class="material-icons">info</i><md-tooltip class="tooltip-with-long-text" md-direction="top" ng-bind-html="\'global.messages.info.paper.validity\' | translate"></md-tooltip></md-switch><div class="ml-3"><plagiat-ng-messages form-element="form.paperFormValidityFlag"></plagiat-ng-messages></div></md-input-container></div><div layout="row" layout-margin><div class="doc-tokens-info" flex="50" flex-md="30" flex-sm="100" flex-xs="100" layout-align="start center"><span data-translate="document.metric.chars"></span><br><b>{{$ctrl.onUploadObj.size}}</b></div><div layout="row" flex="50" layout-align="end center"><md-button aria-label="cancel" data-translate="document.metric.cancel" ng-click="$ctrl.resetUploadForm()">Anuluj</md-button><md-button aria-label="add" class="md-raised md-primary button-waiting" data-translate="document.metric.client.add" id="buttonAddWithChecking" ng-click="$ctrl.addDocumentUniversal($ctrl.onUploadObj, $event, form)" ng-disabled="$ctrl.isLoading" ng-if="!$ctrl.shouldShowCodeAccountCheckModal && !$ctrl.onUploadObj.addWithoutChecking">Dodaj</md-button><md-button aria-label="add without checking" class="md-raised md-primary button-waiting" data-translate="document.metric.client.add-without" id="buttonAddWithoutChecking" ng-click="$ctrl.addWithoutChecking($ctrl.onUploadObj, $event, form)" ng-disabled="$ctrl.hideAddWithoutChecking || ($ctrl.isStudent && $ctrl.onUploadObj.addWithoutCheckingError)" ng-if="!$ctrl.shouldShowCodeAccountCheckModal && $ctrl.onUploadObj.addWithoutChecking">Dodaj bez sprawdzania</md-button><md-button aria-label="add without checking" class="md-raised md-primary button-waiting" data-translate="{{$ctrl.onUploadObj.addWithoutChecking ? \'document.metric.client.add-without\' : \'document.metric.client.add\'}}" id="buttonAddCodeAccount" ng-click="$ctrl.checkDocumentCodeAccountProcess($ctrl.onUploadObj, $event, form)" ng-if="$ctrl.shouldShowCodeAccountCheckModal">Wybierz rodzaj p\u0142atno\u015Bci za sprawdzenie (konto na kody)</md-button></div></div></form></div>');
$templateCache.put('app/account/documents/document-actions/check-later/check-later.template.html','<md-button ng-click="$ctrl.checkLater($ctrl.onUploadObj,$event)" data-translate="document.metric.check-later" ng-disabled="form.$invalid">Sprawd\u017A p\xF3\u017Aniej</md-button>');
$templateCache.put('app/account/documents/document-text/add-text/add-text.template.html','<form name="form" ng-cloak><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="document.upload-text.title"></h2></div></md-toolbar><md-dialog-content><div class="md-dialog-content" layout-margin><md-input-container class="md-block"><textarea ng-model="$ctrl.textToUpload" placeholder="{{!$ctrl.textToUpload ? \'document.upload-text.placeholder\' : \'document.upload-text.title\' | translate}}" rows="7" md-autofocus required></textarea><div class="md-input-messages-info ng-active" ng-class="{\'md-input-messages-error\': $ctrl.textToUpload.length < 30 }"><div data-translate="document.upload-text.minlength" ng-show="$ctrl.textToUpload.length < 30" translate-values="{n: \'{{$ctrl.textToUpload.length}}\'}"></div><div data-translate="document.upload-text.wordsno" ng-show="$ctrl.textToUpload.length >= 30" translate-values="{n: \'{{$ctrl.textToUpload.length}}\'}"></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="$ctrl.closeDialog()" data-translate="global.button.cancel">Anuluj</md-button><md-button ng-click="$ctrl.sendUploadedText()" ng-disabled="form.$invalid || $ctrl.textToUpload.length < 30" class="md-raised md-primary" data-translate="global.button.send">Wy\u015Blij</md-button></md-dialog-actions></form>');
$templateCache.put('app/account/documents/document-text/view-text/view-text.template.html','<form name="form" ng-cloak><md-toolbar><div class="md-toolbar-tools"><h2 data-translate="document.upload-text.title1"></h2></div></md-toolbar><md-dialog-content><div class="md-dialog-content" layout-margin><md-input-container class="md-block" ng-class="{\'no-padding-margin\': $ctrl.rendered}"><textarea ng-class="{\'no-padding-margin\': $ctrl.rendered}" ng-model="$ctrl.textToUpload" md-select-on-focus readonly="readonly" aria-label="ta"></textarea></md-input-container><div class="md-input-messages-info ng-active" ng-class="{\'md-input-messages-error\': $ctrl.textToUpload.length < 30 }"><div data-translate="document.upload-text.minlength" ng-show="$ctrl.textToUpload.length < 30" translate-values="{n: \'{{$ctrl.textToUpload.length}}\'}"></div><div data-translate="document.upload-text.wordsno" ng-show="$ctrl.textToUpload.length >= 30" translate-values="{n: \'{{$ctrl.textToUpload.length}}\'}"></div></div></div></md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="$ctrl.closeDialog()" data-translate="global.button.close">Zamknij</md-button></md-dialog-actions></form>');
$templateCache.put('app/account/documents/documents-list/document-buttons/document-buttons.template.html','<div flex layout="row" layout-align="end center"><md-menu-bar flex layout="row"><md-menu><md-button aria-label="open" class="md-icon-button" ng-click="$mdMenu.open()"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item ng-if="vm.onDocumentHasReport"><md-button aria-label="short report" ng-click="vm.getDocumentReport(\'full\')">{{\'document.table.menu.fullreport\'| translate}}</md-button></md-menu-item><md-menu-item ng-if="vm.onDocumentHasReport && !vm.isReport2020()"><md-button aria-label="short report" ng-click="vm.getDocumentReport(\'short\')">{{\'document.table.menu.shortreport\'| translate}}</md-button></md-menu-item><md-menu-item ng-if="vm.onDocumentHasReport && vm.canDownloadPdfReport()"><md-button aria-label="document.table.menu.pdf.full" ng-click="vm.onClickReportSimilarity2017Pdf(\'full\')">{{\'document.table.menu.pdf.full\'| translate}}</md-button></md-menu-item><md-menu-item ng-if="vm.onDocumentHasReport && vm.canDownloadPdfReport()"><md-button aria-label="document.table.menu.pdf.short" ng-click="vm.onClickReportSimilarity2017Pdf(\'short\')">{{\'document.table.menu.pdf.short\'| translate}}</md-button></md-menu-item><md-menu-item ng-if="vm.onDocumentHasJsaReport"><md-button aria-label="document.action.report.short.jsa" ng-click="vm.getShortJsaReport()">{{\'document.action.report.short.jsa\'| translate}}</md-button></md-menu-item><md-menu-item ng-if="vm.onCanAcceptJsaReport" ng-click="vm.acceptJsaReport(vm.onDocumentId)"><md-button aria-label="accept jsa report">{{\'document.table.menu.acceptjsareport\'| translate}}</md-button></md-menu-item><md-menu-item><md-button aria-label="show text" ng-click="vm.showText($event)" data-translate="document.table.menu.showtext"></md-button></md-menu-item><md-menu-item ng-if="::vm.canEditDocument()"><md-button aria-label="edit" data-translate="document.table.menu.edit" ng-click="vm.editDocument($event)"></md-button></md-menu-item><md-menu-item ng-if="vm.onDocumentStatus === vm.DOCUMENT_STATUS.JSA_ERROR.id"><md-button aria-label="edit" data-translate="document.table.menu.resend-jsa" ng-click="vm.resendJsaDocument($event)"></md-button></md-menu-item><md-menu-item ng-if="vm.onDocumentStatus == 1 && vm.onIsSuperAdmin"><md-button aria-label="edit" ng-click="vm.checkDocumentAgain(vm.onDocumentId)" data-translate="document.table.menu.check.again"></md-button></md-menu-item><md-menu-item ng-if="vm.canRestoreDocument()"><md-button aria-label="restore" ng-click="vm.restoreFromDatabase(vm.onDocumentId)" data-translate="document.table.menu.restore"></md-button></md-menu-item><md-menu-item ng-if="vm.canRejectDocument()"><md-button aria-label="rejectDocument" ng-click="vm.rejectFromDatabase(vm.onDocumentId)" data-translate="document.table.menu.reject"></md-button></md-menu-item><md-menu-item ng-if="vm.canAddDocumentToDatabase()"><md-button aria-label="addToDatabase" ng-click="vm.addToDatabase(vm.onDocumentId)" data-translate="document.table.menu.add-to-database"></md-button></md-menu-item><md-menu-item ng-if="vm.canWithdrawDocumentFromDatabase()"><md-button aria-label="withdrawFromDatabase" ng-click="vm.withdrawFromDatabase(vm.onDocumentId)" data-translate="document.table.menu.withdraw-from-database"></md-button></md-menu-item><md-menu-item ng-if="vm.canSendDocumentToOrppd()"><md-button aria-label="send document to orppd" ui-sref="send-to-orppd({docId: vm.onDocumentId})" data-translate="{{vm.getOrppdActionTranslationKey()}}"></md-button></md-menu-item><md-menu-item ng-if="vm.onDocumentHasReport && vm.onIsSuperAdmin"><md-button aria-label="sendReport" ng-click="vm.sendReport(vm.onDocumentId)" data-translate="document.table.menu.send.report"></md-button></md-menu-item><md-menu-item ng-if="vm.canShowDocumentHistory()"><md-button aria-label="show history" ng-click="vm.showHistory($event)" data-translate="document.table.menu.showhistory"></md-button></md-menu-item><md-menu-item ng-if="vm.canShowRecheckAiDetection()"><md-button aria-label="recheck ai detection" ng-click="vm.recheckAiDetection(vm.onDocumentId, $event)" data-translate="document.table.menu.recheck-ai-detection"></md-button></md-menu-item><md-menu-item ng-if="(vm.jsa || vm.onIsSuperAdmin) && !vm.isJsaDocument()"><md-button aria-label="DocumentSendToJsa" class="pt-0" ui-sref="documentSendToJsa({docId: vm.onDocumentId})" data-translate="document.table.menu.send-document-to-jsa"></md-button></md-menu-item><md-menu-item ng-if="vm.canShowDownloadOriginalFile()" has-any-authority="PERM_USER_DOWNLOAD_DOCUMENT_COPY_FILE,PERM_USER_SUPERADMIN"><md-button aria-label="document.table.menu.file" ng-click="vm.getDocumentFile()">{{\'document.table.menu.file\'| translate}}</md-button></md-menu-item><md-divider></md-divider><md-menu-item ng-if="vm.onIsIndividual || vm.onIsAdmin || (vm.onIsLecturer && vm.allUsersCanDeleteDocuments)"><md-button ng-disabled="vm.onDocumentStatus == 0" aria-label="remove" ng-click="vm.removeDocument()" data-translate="document.table.menu.delete"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div>');
$templateCache.put('app/account/documents/documents-list/document-buttons-report/document-buttons-report.template.html','<!-- ng-class="{\'status-alert-cell\': $ctrl.onForeignAlphabetAlertCount>=$ctrl.onClieForeignAlphabetAlertLimit}" --><div class="d-inline-flex documents-buttons-report"><md-button aria-label="check" ng-if="$ctrl.onDocumentStatus == -2 && $ctrl.isIndividual" class="md-raised button-waiting" ng-disabled="$ctrl.checkDisabled" ng-click="$ctrl.checkTokens($ctrl.onDocumentId)" data-translate="document.table.menu.check"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.button.check.info\'| translate}}</md-tooltip></md-button><md-button aria-label="priority-check" ng-if="$ctrl.canAddPriority()" ng-click="$ctrl.showAddPriorityDialog()" class="md-raised md-button priority-check"><i class="material-icons">fast_forward</i> <span data-translate="document.table.add-priority.button.label"></span><md-tooltip md-delay="100" md-direction="top">{{\'document.table.add-priority.button.tooltip\'| translate}}</md-tooltip></md-button><md-button aria-label="priority-check-admin" ng-if="$ctrl.canAddPriorityFromContract()" ng-click="$ctrl.addPriorityFromContract()" class="md-raised md-button priority-check"><i class="material-icons">fast_forward</i> <span data-translate="document.table.add-priority-admin.button.label"></span><md-tooltip md-delay="100" md-direction="top">{{\'document.table.add-priority-admin.button.tooltip\'| translate}}</md-tooltip></md-button><div ng-if="$ctrl.canSubmitAssignment()" class="button" name="submit-assignment-input" ngf-max-size="\'100MB\'" ngf-accept="$ctrl.onAvailableExtensions" ngf-pattern="$ctrl.onAvailableExtensions" ngf-select="$ctrl.onSubmitAssignment($ctrl.onDocumentId, $files,$invalidFiles)"><md-button aria-label="submit-assignment" class="md-raised md-button priority-check"><span data-translate="document.table.submit-assignment.button.label"></span><md-tooltip md-delay="100" md-direction="top">{{\'document.table.submit-assignment.button.tooltip\'| translate}}</md-tooltip></md-button></div><div ng-if="$ctrl.canSubmitAssignmentCorrection()" class="button" name="submit-assignment-correction-input" ngf-max-size="\'100MB\'" ngf-accept="$ctrl.onAvailableExtensions" ngf-pattern="$ctrl.onAvailableExtensions" ngf-select="$ctrl.onSubmitAssignmentCorrection($ctrl.onDocumentId, $files,$invalidFiles)"><md-button aria-label="submit-assignment-correction" class="md-raised md-button priority-check"><span data-translate="document.table.submit-assignment-correction.button.label"></span><md-tooltip md-delay="100" md-direction="top">{{\'document.table.submit-assignment-correction.button.tooltip\'| translate}}</md-tooltip></md-button></div><div ng-if="$ctrl.canSubmitAssignmentPaidCorrection()" class="button" name="submit-assignment-paid-correction-input" ngf-max-size="\'100MB\'" ngf-accept="$ctrl.onAvailableExtensions" ngf-pattern="$ctrl.onAvailableExtensions" ngf-select="$ctrl.onSubmitAssignmentPaidCorrection($ctrl.onDocumentId, $files,$invalidFiles)"><md-button aria-label="submit-assignment-paid-correction" class="md-raised md-button priority-check" ng-disabled="$ctrl.onIsLoaderActive"><span data-translate="document.table.submit-assignment-paid-correction.button.label"></span><md-tooltip md-delay="100" md-direction="top">{{\'document.table.submit-assignment-paid-correction.button.tooltip\'| translate}}</md-tooltip></md-button></div><md-button aria-label="check" ng-if="$ctrl.onDocumentStatus == 3 && !$ctrl.onDocumentHasReport && !$ctrl.shouldShowCodeAccountCheckModal && !$ctrl.isIndividual" ng-disabled="$ctrl.checkDisabled" class="md-raised" ng-click="$ctrl.checkDocument($ctrl.onDocumentId)" data-translate="document.table.menu.check"></md-button><md-button aria-label="check" ng-if="($ctrl.onDocumentStatus == -2 || $ctrl.onDocumentStatus == 3) && !$ctrl.onDocumentHasReport && $ctrl.shouldShowCodeAccountCheckModal && !$ctrl.isIndividual" class="md-raised" ng-click="$ctrl.checkDocumentCodeAccount($ctrl.onDocumentId, $ctrl.onDocumentSize)" data-translate="document.table.menu.check"></md-button><md-button aria-label="get report" class="md-icon-button m-0" ng-click="$ctrl.getDocumentReport()" ng-if="$ctrl.onDocumentHasReport"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.menu.fullreport\'| translate}}</md-tooltip><i class="material-icons">open_in_browser</i></md-button><md-button aria-label="get report" class="md-icon-button m-0" ng-click="$ctrl.getFullJsaReport()" ng-if="$ctrl.onDocumentHasJsaReport"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.menu.fulljsareport\'| translate}}</md-tooltip><i class="material-icons" ng-class="{\'jsa-report-accepted\': $ctrl.onDocumentJsaStatus === $ctrl.jsaOrderStatus.ACCEPTED,\n             \'jsa-report-complete\': $ctrl.onDocumentJsaStatus === $ctrl.jsaOrderStatus.COMPLETE}">assignment_returned</i></md-button><span class="status-alert-block" ng-if="$ctrl.onHasAlert"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.statuses.alphabet-alert-count\'| translate}}</md-tooltip><i class="material-icons icon-alphabet-alert-count">error_outline</i> </span><span class="jsa-search" ng-if="$ctrl.onDocumentHasReport && $ctrl.onDocumentJsaStatus == $ctrl.jsaOrderStatus.NEW"><md-tooltip md-delay="100" md-direction="top">{{\'document.table.menu.processing-jsa\'| translate}}</md-tooltip><div class="out-circle"><div class="rotate anim1"><div class="counterrotate"><i id="jsa-icon-search" class="inner material-icons">search</i></div></div></div></span></div>');
$templateCache.put('app/account/documents/documents-list/document-protocol/document-protocol.template.html','<section layout="row" ng-if="$ctrl.document.hasReport" layout-align="center center" layout-wrap><md-button aria-label="protocol {{item.code}}" class="md-icon-button m-0 p-0" style="width: 1.3rem; height: 1rem" ng-repeat="item in $ctrl.protocolForDocuments" ng-click="$ctrl.getProtocolForDocument(item)"><i class="material-icons">description</i><md-tooltip md-direction="top">{{item.fileName}}_{{$ctrl.document.docuTitle}}</md-tooltip></md-button></section>');
$templateCache.put('app/account/pap/reports/document-details-reports/document-details-reports.template.html','<div class="border-top pl-5" layout="row" layout-padding flex><div layout="row" flex="50" class="pr-5"><div layout="column" flex="100"><!--\n            <div layout="row" class="document-row-details">\n                <small flex class="text-muted" data-translate="document.table.details.id">ID dokumentu</small>\n                <small flex >{{$ctrl.onDocumentDetails.documentId}}</small>\n            </div>\n            --><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="document.table.details.author">U\u017Cytkownik</small> <small flex>{{$ctrl.onDocumentDetails.userName}}</small></div><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="document.table.details.author">U\u017Cytkownik</small> <small flex>{{$ctrl.onDocumentDetails.userEmail}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onDocumentDetails.docuSize > 0"><small flex class="text-muted" data-translate="document.table.details.upload-date">Data wgrania pracy</small> <small flex>{{$ctrl.onDocumentDetails.docuSubmitDate | date: \'yyyy-MM-dd HH:mm\'}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onDocumentDetails.docuSize > 0"><small flex class="text-muted" data-translate="document.table.details.report">Raport podobie\u0144stwa</small> <small flex>{{$ctrl.onDocumentDetails.docuReportDate | date: \'yyyy-MM-dd HH:mm\'}}</small></div><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="document.metric.client.promoter.unit">Jednostka</small> <small flex>{{$ctrl.onDocumentDetails.orguniLabel}}</small></div><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="document.metric.client.promoter.type">rodzaj</small> <small flex>{{$ctrl.onDocumentDetails.docuKindLabel}}</small></div><div layout="row" class="document-row-details" ng-if="$ctrl.onDocumentDetails.docuSize > 0"><small flex class="text-muted" data-translate="document.table.details.size">Rozmiar</small> <small flex>{{$ctrl.onDocumentDetails.docuSize}}</small></div><div layout="row" class="document-row-details"><small flex class="text-muted" data-translate="reports.details.external-id">id</small> <small flex>{{$ctrl.onDocumentDetails.docuExternalId}}</small></div></div></div><div layout="row" flex="50"><div layout="column" flex="100"><div layout="row" class="document-row-details p-1"><small flex="35" class="text-muted" data-translate="reports.details.keywords">rodzaj</small> <small flex="65">{{$ctrl.onDocumentDetails.keywords}}</small></div><div layout="row" class="document-row-details p-1"><small flex="35" class="text-muted" data-translate="reports.details.department">rodzaj</small> <small flex="65">{{$ctrl.onDocumentDetails.department}}</small></div><div layout="row" class="document-row-details p-1"><small flex="35" class="text-muted" data-translate="reports.details.services">rodzaj</small> <small flex="65">{{$ctrl.onDocumentDetails.services}}</small></div><div layout="row" class="document-row-details p-1"><small flex="35" class="text-muted" data-translate="reports.details.categories">rodzaj</small> <small flex="65">{{$ctrl.onDocumentDetails.categories}}</small></div></div></div></div>');
$templateCache.put('app/account/settings/ap-keys/ap-keys-buttons/ap-keys-buttons.template.html','<div flex layout="row" layout-align="end center"><md-menu-bar flex layout="row"><md-menu><md-button aria-label="open" class="md-icon-button" ng-click="$mdMenu.open()"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item><md-button aria-label="invalidate" ng-click="vm.invalidate($event, vm.onId)" data-translate="global.button.invalidate"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div>');
$templateCache.put('app/account/settings/ap-keys/ap-keys-details/ap-keys-details.template.html','<div class="border-top" layout="row" layout-padding><div layout="row" flex="40"><div layout="column" flex="50"><div layout="column" flex><small class="text-muted" data-translate="api.keys.key.value"></small></div></div><div layout="column" flex="50"><div layout="row" flex><small>{{vm.details.keyValue}}</small></div></div></div></div>');
$templateCache.put('app/account/settings/ap-keys/ap-keys-form/ap-keys-form.html','<div layout="column" class="site-container"><md-content class="users" layout="row"><div layout-align="center center"><header class="header"><h5 ng-if="!vm.form.id" data-translate="api.keys.form.new"></h5><h5 ng-if="vm.form.id" data-translate="api.keys.form.edit"></h5></header></div></md-content><md-content layout="row" layout-padding><form name="form" flex><div layout="row" layout-xs="column"><md-input-container layout="row" layout-xs="column" flex="33" flex-xs="100"><md-autocomplete class="white-background" id="search-clients" md-input-minlength="2" ng-disabled="vm.isDisabled" md-no-cache="vm.noCache" md-selected-item="vm.form.selectedClient" md-search-text="vm.searchClient" md-items="client in vm.querySearchClients(vm.searchClient)" md-item-text="client.id+\' \'+client.clieName" md-min-length="0" ng-required="true" md-selected-item-change="vm.selectedClientChange(client)" md-delay="vm.simpleSearchDelay" md-floating-label="{{\'global.model.clientname\'| translate}}" md-clear-button="true"><md-item-template><span md-highlight-text="vm.searchClient" md-highlight-flags="^i">{{client.clieName}} [{{client.id}}]</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{vm.searchClient}}"</md-not-found></md-autocomplete></md-input-container><md-input-container layout="row" layout-xs="column" flex="33" flex-xs="100"><md-switch class="md-primary" aria-label="withoutUser" ng-model="vm.form.withoutUser"><span data-translate="api.keys.client-level"></span> <span><md-tooltip md-delay="100" md-direction="top" class="accept-data-processing-tooltip">{{\'api.keys.client-level-description\' | translate}}</md-tooltip><i class="material-icons-outlined">info</i></span></md-switch></md-input-container><md-input-container layout="row" layout-xs="column" flex="33" flex-xs="100" ng-if="!vm.form.withoutUser"><md-autocomplete class="white-background" id="search-users" md-input-minlength="2" ng-disabled="vm.isDisabled || !vm.clientId" md-no-cache="vm.noCache" md-selected-item="vm.form.selectedUser" md-search-text-change="vm.searchTextChange(vm.searchText)" md-search-text="vm.searchText" md-items="user in vm.querySearchUsers(vm.searchText)" md-item-text="user.userName+\' \'+user.userSurname+\' \'+user.userEmail" md-min-length="0" ng-required="true" md-delay="vm.simpleSearchDelay" md-floating-label="{{\'global.model.user\'| translate}}"><md-item-template><span md-highlight-text="ctrl.searchText" md-highlight-flags="^i">{{user.userName}} {{user.userSurname}} {{user.userEmail}}</span></md-item-template></md-autocomplete></md-input-container></div><div layout="row" layout-xs="column"><md-input-container flex="33" flex-sm="100" flex-xs="100"><label data-translate="{{\'api.keys.expiry.date\'| translate}}"></label><md-datepicker ng-model="vm.form.expiryDate" ng-required="true" input-date></md-datepicker></md-input-container></div><div layout="row" flex layout-align="end center"><md-button id="cancelButton" ng-click="vm.backToMainList()" data-translate="global.form.button.cancel"></md-button><md-button id="saveButton" ng-click="vm.save(vm.form, $event)" class="md-raised md-primary button-waiting" ng-disabled="form.$invalid"><span data-translate="global.form.button.save"></span></md-button></div></form></md-content></div>');
$templateCache.put('app/account/settings/ap-keys/ap-keys-list/ap-keys.html','<div layout="column" class="site-container"><settings-menu active-tab="vm.activeTab"></settings-menu><div class="table-container" flex><md-content layout="row" layout-margin><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch aria-hidden="false" flex><div flex layout="row" layout-align="end center"><md-button aria-label="client add" class="md-raised md-primary button-waiting" data-translate="api.keys.add" id="addBtn" ui-sref="ap-keys-add"></md-button></div><ap-keys-search on-clear="vm.clear" on-get-data="vm.getData" on-query-request="vm.queryRequest" on-search-request="vm.searchRequest" simple-search="vm.simpleSearch"></ap-keys-search><md-table-container><table id="tableApiKeys" md-table md-row-select="vm.options.rowSelection" multiple="{{vm.options.multiSelect}}" ng-model="vm.selected" md-progress="vm.promise" id="tableDocumentParameterDefinitions"><thead md-head md-order="vm.queryRequest.order" md-on-reorder="vm.prepareMapping"><tr md-row><th md-column><span>#</span></th><th md-column md-order-by="client.clieName"><span data-translate="api.keys.client.name"></span></th><th md-column md-order-by="client.id"><span data-translate="api.keys.client.id"></span></th><th md-column md-order-by="user.userEmail"><span data-translate="api.keys.user.email"></span></th><th md-column md-order-by="client.contracts.contStatus"><span data-translate="api.keys.client.status"></span></th><th md-column md-order-by="createdAt"><span data-translate="api.keys.created.at"></span></th><th md-column md-order-by="lastUsed"><span data-translate="api.keys.last.use.date"></span></th><th md-column md-order-by="expiryDate"><span data-translate="api.keys.expiry.date"></span></th><th md-column class="table-actions"><span data-translate="global.table.actions"></span></th></tr></thead><tbody md-body><tr md-row md-select="row" md-on-select="vm.openBottomSheet" md-select-id="row.id" ng-repeat-start="row in vm.apiKeys"><td md-cell ng-click="vm.getDetails(row)"><span ng-show="!vm.isLoadingData">{{($index + 1) + ((vm.queryRequest.page - 1) * vm.queryRequest.limit)}}</span></td><td md-cell ng-click="vm.getDetails(row)">{{row.clientName}}</td><td md-cell ng-click="vm.getDetails(row)">{{row.clientId}}</td><td md-cell ng-click="vm.getDetails(row)">{{row.userEmail}}</td><td md-cell ng-click="vm.getDetails(row)"><md-tooltip md-delay="100" md-direction="top">{{ vm.isApikeyActive(row) ? \'global.status.active\' : \'global.status.inactive\'| translate}}</md-tooltip><i class="material-icons {{ vm.isApikeyActive(row) ? \'icon-paid\': \'icon-rejected\'}}">{{ vm.isApikeyActive(row) ? \'done\' : \'error\'}} </i><i class="material-icons icon-paid" ng-if="!row.userEmail">{{ \'key\' }}</i></td><td md-cell ng-click="vm.getDetails(row)">{{row.createdAt | date: \'yyyy-MM-dd\'}}</td><td md-cell ng-click="vm.getDetails(row)">{{row.lastUsed | date: \'yyyy-MM-dd\'}}</td><td md-cell ng-click="vm.getDetails(row)">{{row.expiryDate | date: \'yyyy-MM-dd HH:mm\'}}</td><td md-cell><ap-keys-buttons on-id="row.id" on-get-data="vm.getData"></ap-keys-buttons></td></tr><tr ng-if="vm.showDetailsBlock && vm.pickedElement == row.id" ng-repeat-end><td colspan="8"><ap-key-details details="vm.details"></ap-key-details></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoadingData"></md-progress-circular></div></md-table-container><!-- TABLE --><div flex><div layout="row" layout-align="start center"><md-button id="removeCheckedButton" aria-label="remove" ng-click="vm.removeItems()" ng-disabled="vm.selected.length == 0" data-translate="global.table.menu.delete"></md-button><md-button type="submit" aria-label="generate" class="md-raised md-primary search-buttons" ng-click="vm.generateExcelFile()" ng-disabled="vm.selected.length == 0" data-translate="users.generate-report"></md-button></div><div layout="row" layout-align="end center" layout-wrap><paging page="vm.queryRequest.page" page-size="vm.queryRequest.limit" total="vm.totalElements" show-prev-next="true" show-first-last="true" paging-action="vm.startPaging(page)"></paging><div layout="row" class="go-to" flex-xs="100" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to next page" ng-model="vm.queryRequest.page" type="number" ng-keyup="vm.prepareMapping()" ng-change="vm.prepareMapping()"></md-input-container></div></div></div></md-card></md-content></div></div>');
$templateCache.put('app/account/settings/ap-keys/ap-keys-search/ap-keys-search.template.html','<form name="formSearchApiKeys"><div layout-padding><div layout="row" layout-xs="column"><select-page-size query-request="$ctrl.onQueryRequest" on-value-chosen="$ctrl.getData()" layout="row" flex="70" flex-xs="100" layout-align="start center"></select-page-size></div><div layout="row" layout-xs="column"><md-input-container layout="row" layout-xs="column" flex="33" flex-xs="100"><md-autocomplete class="white-background" id="search-clients" md-input-minlength="2" ng-disabled="$ctrl.isDisabled" md-no-cache="$ctrl.noCache" md-selected-item="$ctrl.selectedClient" md-search-text="$ctrl.searchClient" md-selected-item-change="$ctrl.selectedClientChange(client)" md-items="client in $ctrl.querySearchClients($ctrl.searchClient)" md-item-text="client.id+\' \'+client.clieName" md-min-length="0" md-floating-label="{{\'global.model.clientname\'| translate}}" md-clear-button="true"><md-item-template><span md-highlight-text="$ctrl.searchClient" md-highlight-flags="^i">{{client.clieName}} [{{client.id}}]</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{$ctrl.searchClient}}"</md-not-found></md-autocomplete></md-input-container><md-input-container layout="row" layout-xs="column" flex="33" flex-xs="100"><md-autocomplete class="white-background" id="search-users" md-input-minlength="2" ng-disabled="$ctrl.isDisabled" md-no-cache="$ctrl.noCache" md-selected-item="$ctrl.selectedUser" md-search-text="$ctrl.searchText" md-selected-item-change="$ctrl.selectedUserChange(user)" md-items="user in $ctrl.querySearchUsers($ctrl.searchText)" md-item-text="user.userName+\' \'+user.userSurname+\' \'+user.userEmail" md-min-length="0" md-floating-label="{{\'global.model.user\'| translate}}"><md-item-template><span md-highlight-text="ctrl.searchText" md-highlight-flags="^i">{{user.userName}} {{user.userSurname}} {{user.userEmail}}</span></md-item-template></md-autocomplete></md-input-container><md-input-container flex="34" flex-xs="100"><input ng-model="$ctrl.onSearchRequest.search.keyValue" placeholder="{{\'api.keys.key.value\'| translate}}"></md-input-container></div><div layout="row" layout-xs="column"><md-input-container class="md-block" flex="33" flex-xs="100"><label data-translate="client.model.status">Status</label><md-select aria-label="clients statuses" layout-align="center center" ng-change="$ctrl.getData()" ng-model="$ctrl.onSearchRequest.search.contractStatus" placeholder="{{\'client.model.status\' | translate }}"><md-option ng-if="$ctrl.onSearchRequest.search.contractStatus || $ctrl.onSearchRequest.search.contractStatus === 0 " ng-value="">{{\'global.button.clear\'| translate}}: {{\'client.model.status\' | translate}}</md-option><md-option ng-repeat="status in $ctrl.statuses" ng-value="status.id">{{status.label| translate}}</md-option></md-select></md-input-container><md-input-container flex="17"><label data-translate="api.keys.api.ever.used"></label><md-select ng-change="$ctrl.getData()" placeholder="{{\'api.keys.api.ever.used\' | translate }}" ng-model="$ctrl.onSearchRequest.search.apiEverUsed"><md-option ng-value="" ng-if="$ctrl.onSearchRequest.search.apiEverUsed || $ctrl.onSearchRequest.search.apiEverUsed === false "><em>{{\'global.button.clear\'| translate}}: {{\'api.keys.api.ever.used\' | translate}}</em></md-option><md-option ng-value="true" data-translate="global.search.yes"></md-option><md-option ng-value="false" data-translate="global.search.no"></md-option></md-select></md-input-container><md-input-container flex="17"><label data-translate="api.keys.api.key.expired"></label><md-select ng-change="$ctrl.getData()" placeholder="{{\'api.keys.api.key.expired\' | translate }}" ng-model="$ctrl.onSearchRequest.search.apiKeyExpired"><md-option ng-value="" ng-if="$ctrl.onSearchRequest.search.apiKeyExpired || $ctrl.onSearchRequest.search.apiKeyExpired === false "><em>{{\'global.button.clear\'| translate}}: {{\'api.keys.api.key.expired\' | translate}}</em></md-option><md-option ng-value="true" data-translate="global.search.yes"></md-option><md-option ng-value="false" data-translate="global.search.no"></md-option></md-select></md-input-container></div><div layout="row" layout-xs="column"><md-input-container flex="33"><label data-translate="client.model.country"></label><md-select ng-change="$ctrl.getData()" placeholder="{{\'client.model.country\' | translate }}" ng-model="$ctrl.onSearchRequest.search.clientCountryId"><md-option ng-value="" ng-if="$ctrl.onSearchRequest.search.clientCountryId || $ctrl.onSearchRequest.search.clientCountryId === 0"><em>{{\'global.button.clear\'| translate}}: {{\'users.model.country\' | translate}}</em></md-option><md-option ng-repeat="country in $ctrl.countries" ng-value="country.id">{{country.translationKey | translate}}</md-option></md-select><plagiat-ng-messages form-element="form.country"></plagiat-ng-messages></md-input-container></div><div layout="row" layout-padding layout-xs="column" layout-align="start"><md-button aria-label="clear" class="md-raised search-buttons" ng-click="$ctrl.clear()" data-translate="global.button.clear.search"></md-button><md-button type="submit" aria-label="search" id="searchBtn" class="md-raised md-primary search-buttons" ng-click="$ctrl.getData()" data-translate="global.button.search">Szukaj</md-button></div></div></form>');
$templateCache.put('app/account/settings/database-exchange-program-members/database-exchange-program-members-list/database-exchange-program-members.html','<div layout="column" class="site-container"><settings-menu active-tab="vm.activeTab"></settings-menu><div class="table-container" flex><md-content layout="row" layout-margin><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch aria-hidden="false" flex><div class="participation-info"><div ng-if="vm.isDatabaseExchangeProgramMember === true"><span data-translate="database.exchange.program.participation.info"></span><div ng-if="!vm.showDbExchangeProgramList"><br><span class="no-participation-part2" data-translate="database.exchange.program.participation.info2"></span></div></div><div ng-if="vm.isDatabaseExchangeProgramMember === false"><span data-translate="database.exchange.program.no.participation.info1"></span><br><span class="no-participation-part2" data-translate="database.exchange.program.no.participation.info2"></span></div></div><div ng-if="vm.showDbExchangeProgramList"><md-divider md-inset></md-divider><database-exchange-program-members-search on-clear="vm.clear" on-get-clients="vm.getClients" on-query-request="vm.queryRequest" on-search-request="vm.searchRequest"></database-exchange-program-members-search><md-table-container><table md-table md-progress="vm.promise" id="tableClients"><thead md-head md-order="vm.queryRequest.order" md-on-reorder="vm.getClients"><tr md-row><th md-column class="lp"><span>#</span></th><th md-column md-order-by="clieName"><span data-translate="database.exchange.program.client.name"></span></th></tr></thead><tbody md-body><tr md-row ng-repeat-start="client in vm.clients"><td md-cell class="lp"><span ng-show="!vm.isLoadingData">{{($index + 1) + ((vm.queryRequest.page - 1) * vm.queryRequest.limit)}}</span></td><td md-cell>{{client.clieName}}</td></tr><tr ng-if="vm.showDetailsBlock && vm.pickedClient == client.id" ng-repeat-end=""><td colspan="8"><client-details client="vm.details"></client-details></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoaderActive"></md-progress-circular></div></md-table-container><div flex><div layout="row" layout-align="end center" layout-wrap><paging page="vm.queryRequest.page" page-size="vm.queryRequest.limit" paging-action="vm.pagingAction(page)" show-first-last="true" show-prev-next="true" total="vm.totalClients"></paging><div layout="row" class="go-to" flex-xs="100" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to next page" ng-model="vm.queryRequest.page" type="number" ng-keyup="vm.getClients()" ng-change="vm.getClients()"></md-input-container></div></div></div></div></md-card></md-content></div></div>');
$templateCache.put('app/account/settings/database-exchange-program-members/database-exchange-program-members-search/database-exchange-program-members-search.template.html','<form name="formSearchClients"><div layout-padding><div layout="row" layout-xs="column"><select-page-size query-request="$ctrl.onQueryRequest" on-value-chosen="$ctrl.getClients()" flex="30" flex-xs="100" layout="row" layout-align="start center"></select-page-size><div flex="70" flex-sm="70" flex-xs="100" layout="row" layout-align="end center" layout-sm="column"><md-input-container class="md-block" flex="70" flex-xs="100" layout-align="end center" md-no-float ng-if="$ctrl.simpleSearch"><input ng-change="$ctrl.getClients()" ng-model="$ctrl.onSearchRequest.simpleSearch" ng-model-options="{ debounce: $ctrl.simpleSearchDelay }" placeholder="{{\'global.search.title\'| translate}}"></md-input-container></div></div></div></form>');
$templateCache.put('app/account/settings/document-kinds/edit-thresholds/edit-thresholds.html','<div layout="column" class="site-container"><md-content class="users" layout="row"><div layout-align="center center"><header class="header"><h5 data-translate="client.document-kinds.form.edit-thresholds"></h5></header></div></md-content><md-content layout="row" layout-padding><form name="form" flex><div layout="column" layout-margin><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="50" flex-xs="100"><input name="warning1" ng-pattern="/^[0-9]+$/" type="number" min="0" max="100" placeholder="{{\'client.report.settings.form.warning-threshold-1\' | translate}}" ng-model="vm.form.warning1" ng-required="true"></md-input-container></div><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="50" flex-xs="100"><input name="warning2" ng-pattern="/^[0-9]+$/" type="number" min="0" max="100" placeholder="{{\'client.report.settings.form.warning-threshold-2\' | translate}}" ng-model="vm.form.warning2" ng-required="true"></md-input-container></div></div><div layout="row" flex layout-align="end center"><md-button id="cancelButton" ng-click="vm.backToMainList()" aria-label="cancel" data-translate="global.form.button.cancel"></md-button><md-button id="saveButton" ng-click="vm.save(vm.form)" aria-label="ok" class="md-raised md-primary button-waiting" ng-disabled="form.$invalid"><span data-translate="global.form.button.save"></span></md-button></div></form></md-content></div>');
$templateCache.put('app/account/settings/document-parameter-definitions/document-parameter-definitions-buttons/document-parameter-definitions-buttons.template.html','<div flex layout="row" layout-align="end center"><md-menu-bar flex layout="row"><md-menu><md-button id="tableOptionsButton{{$ctrl.buttonLp}}" aria-label="open" class="md-icon-button" ng-click="$mdMenu.open()"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item><md-button id="tableOptionEdit{{$ctrl.buttonLp}}" aria-label="full report" ng-click="$ctrl.edit($ctrl.parameterId)" data-translate="global.table.menu.edit"></md-button></md-menu-item><md-menu-item><md-button id="tableOptionDelete{{$ctrl.buttonLp}}" aria-label="remove" ng-click="$ctrl.remove($ctrl.parameterId, $event)" data-translate="global.table.menu.delete"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div>');
$templateCache.put('app/account/settings/document-parameter-definitions/document-parameter-definitions-form/document-parameter-definitions-form.html','<div layout="column" class="site-container"><md-content class="users" layout="row"><div layout-align="center center"><header class="header"><h5 ng-if="!vm.form.id" data-translate="document.parameter.definitions.form.new-parameter"></h5><h5 ng-if="vm.form.id" data-translate="document.parameter.definitions.form.edit-parameter"></h5></header></div></md-content><md-content layout="row" layout-padding><form name="form" flex><div layout="row" layout-wrap><div layout="row" layout-wrap flex="100" flex-xs="100"><md-input-container flex="50" flex-sm="100" flex-xs="100"><input name="firstName" placeholder="{{!vm.form.dopadeName ? \'document.parameter.definitions.form.name.placeholder\' : \'document.parameter.definitions.form.name\' | translate}}" ng-model="vm.form.dopadeName" ng-required="true"></md-input-container><md-switch id="requiredCheckbox" class="md-primary" name="notify" ng-model="vm.form.dopadeIsMandatoryBoolean" flex="100" flex-xs="100"><span class="add-without-checking-switch-text" id="addWithoutChecingSwitchText" data-translate="document.parameter.definitions.form.is-required"></span> <span id="addWithoutCheckingError" ng-if="$ctrl.onUploadObj.addWithoutCheckingError"><span>(</span><span data-translate="{{$ctrl.onUploadObj.addWithoutCheckingErrorText}}" class="md-input-messages-error"></span><span>)</span></span></md-switch></div><div layout="row" layout-wrap flex="100" flex-xs="100"><md-input-container class="md-block md-radio-group-block" flex="50" flex-xs="100"><md-radio-group ng-model="vm.form.dopadeType" class="md-primary" layout="row" ng-change="vm.dopadeTypeListener()"><md-radio-button id="dopadeType{{val.id}}" ng-repeat="val in vm.dopadeTypes" ng-value="val.id" aria-label="{{val.label}}" ng-disabled="vm.form.id">{{val.label}}</md-radio-button></md-radio-group></md-input-container></div><div layout="row" layout-wrap flex="100" flex-xs="100"><md-input-container class="md-block" flex="50" flex-sm="100" flex-xs="100" ng-show="vm.form.dopadeType==0"><input id="defaultValueInput" name="dopadeDefault" placeholder="{{!vm.form.dopadeDefault ? \'document.parameter.definitions.form.default-value.placeholder\' : \'document.parameter.definitions.form.default-value\' | translate}}" ng-model="vm.form.dopadeDefault" ng-required="false"></md-input-container><md-input-container class="md-block" flex="25" flex-xs="100" ng-show="vm.form.dopadeType==1"><label for="defaultValueSelect" data-translate="document.parameter.definitions.form.default-value"></label><md-select id="defaultValueSelect" ng-model="vm.form.dopadeDefault" placeholder="{{\'document.parameter.definitions.form.default-value\' | translate}}" layout-align="center center" ng-required="false"><md-option ng-value="val" ng-repeat="val in vm.form.comboBoxValues"><em>{{val}}</em></md-option></md-select></md-input-container></div><div layout="row" flex="100" flex-xs="100" class="document-metric-authors" ng-show="vm.form.dopadeType==1"><md-chips md-add-on-blur="true" id="parameterListChip" ng-required="(vm.form.dopadeIsMandatoryBoolean && vm.form.dopadeType==1) || vm.form.dopadeType==1" aria-label="parameter list" min-width="400" ng-model="vm.form.comboBoxValues" name="parameterList" readonly="false" md-removable="true" placeholder="{{\'document.parameter.definitions.form.parameter-list.placeholder\' | translate}}"><md-chip-template>{{$chip}}</md-chip-template></md-chips></div><div layout="row" flex="100" flex-xs="100" layout-align="end center"><md-button id="cancelButton" ng-click="vm.backToMainList()" data-translate="document.parameter.definitions.form.cancel"></md-button><md-button id="saveButton" ng-click="vm.save(vm.form, $event)" class="md-raised md-primary button-waiting" ng-disabled="form.$invalid"><span ng-if="!vm.form.id" data-translate="document.parameter.definitions.form.add-parameter"></span> <span ng-if="vm.form.id" data-translate="document.parameter.definitions.form.save-parameter"></span></md-button></div></div></form></md-content></div>');
$templateCache.put('app/account/settings/document-parameter-definitions/document-parameter-definitions-list/document-parameter-definitions.html','<div layout="column" class="site-container"><settings-menu active-tab="vm.activeTab"></settings-menu><div class="table-container" flex><md-content layout="row" layout-margin><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch aria-hidden="false" flex><document-parameter-definitions-search on-search-data="vm.searchData" on-query-request="vm.queryRequest" on-get-data="vm.getData"></document-parameter-definitions-search><md-table-container><table md-table md-row-select="vm.options.rowSelection" multiple="{{vm.options.multiSelect}}" ng-model="vm.selected" md-progress="vm.promise" id="tableDocumentParameterDefinitions"><thead md-head md-order="vm.queryRequest.order" md-on-reorder="vm.prepareMapping"><tr md-row><th md-column><span>#</span></th><th md-column md-order-by="dopadeName"><span data-translate="document.parameter.definitions.list.name"></span></th><th md-column md-order-by="dopadeType"><span data-translate="document.parameter.definitions.list.type"></span></th><th md-column md-order-by="dopadeIsMandatory"><span data-translate="document.parameter.definitions.list.is-required"></span></th><th md-column class="table-actions"><span data-translate="global.table.actions"></span></th></tr></thead><tbody md-body><tr md-row md-select="row" md-on-select="vm.openBottomSheet" md-select-id="row.id" ng-repeat="row in vm.documentParameterDefinitions"><td md-cell><span ng-show="!vm.isLoadingData">{{($index + 1) + ((vm.queryRequest.page - 1) * vm.queryRequest.limit)}}</span></td><td md-cell>{{row.dopadeName}}</td><td md-cell><span ng-if="row.dopadeType==0" data-translate="document.parameter.definitions.dopade-type.text"></span> <span ng-if="row.dopadeType==1" data-translate="document.parameter.definitions.dopade-type.enum"></span></td><td md-cell><span ng-if="row.dopadeIsMandatory==1" data-translate="global.msg.yes"></span> <span ng-if="row.dopadeIsMandatory!=1" data-translate="global.msg.no"></span></td><td md-cell><document-parameter-definitions-buttons button-lp="$index" parameter-id="row.id" get-data="vm.getData"></document-parameter-definitions-buttons></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoadingData"></md-progress-circular></div></md-table-container><!-- TABLE --><div flex><div layout="row" layout-align="start center"><md-button id="removeCheckedButton" aria-label="remove" ng-click="vm.removeParameters($event)" ng-disabled="vm.selected.length == 0" data-translate="global.table.menu.delete"></md-button></div><div layout="row" layout-align="end center" layout-wrap><paging page="vm.queryRequest.page" page-size="vm.queryRequest.limit" total="vm.totalElements" show-prev-next="true" show-first-last="true" paging-action="vm.startPaging(page)"></paging><div layout="row" class="go-to" flex-xs="100" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to next page" ng-model="vm.queryRequest.page" type="number" ng-keyup="vm.prepareMapping()" ng-change="vm.prepareMapping()"></md-input-container></div></div></div></md-card></md-content></div></div>');
$templateCache.put('app/account/settings/document-parameter-definitions/document-parameter-definitions-search/document-parameter-definitions-search.template.html','<div layout-padding><div layout="row" layout-xs="column"><select-page-size query-request="$ctrl.onQueryRequest" on-value-chosen="$ctrl.getData()" flex="70" flex-xs="100" layout="row" layout-align="start center"></select-page-size><div layout="column" flex="30" flex-xs="100" layout-align="end center" class="layout-align-end-center layout-column flex-xs-100 flex-30"><md-button id="addDocumentParameterDefinitionButton" ng-click="$ctrl.goToAddPage()" class="md-raised md-primary button-waiting" data-translate="users.settings.parameter.definitions.add-btn" aria-label="add-btn"></md-button></div></div></div>');
$templateCache.put('app/account/settings/organisational-units/organisational-units-buttons/organisational-units-buttons.template.html','<div flex layout="row" layout-align="end center"><md-menu-bar flex layout="row"><md-menu><md-button id="tableOptionsButton{{$ctrl.buttonLp}}" aria-label="open" class="md-icon-button" ng-click="$mdMenu.open()"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item><md-button id="tableOptionEdit{{$ctrl.buttonLp}}" aria-label="full report" ng-click="$ctrl.edit($ctrl.organisationalUnitId)" data-translate="global.table.menu.edit"></md-button></md-menu-item><md-menu-item><md-button id="tableOptionDelete{{$ctrl.buttonLp}}" aria-label="remove" ng-click="$ctrl.remove($ctrl.organisationalUnitId, $event)" data-translate="global.table.menu.delete"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div>');
$templateCache.put('app/account/settings/organisational-units/organisational-units-form/organisational-units-form.html','<div layout="column" class="site-container"><md-content class="users" layout="row"><div layout-align="center center"><header class="header"><h5 ng-if="!vm.form.id" data-translate="organisational.units.form.new"></h5><h5 ng-if="vm.form.id" data-translate="organisational.units.form.edit"></h5></header></div></md-content><md-content layout="row" layout-padding><form name="form" flex><div layout="column" layout-margin><div layout="row" layout-xs="column" flex flex-xs="100"><md-input-container class="md-block" flex="50" flex-xs="100"><input name="orguniLabel" placeholder="{{!vm.form.orguniLabel ? \'organisational.units.form.name.placeholder\' : \'organisational.units.form.name\' | translate}}" ng-model="vm.form.orguniLabel" ng-required="true"></md-input-container></div><h3 class="mt-5" ng-if="vm.doesClientHaveJsaIntegration" data-translate="organisational.units.form.polon-studies"></h3><div layout="column" ng-if="vm.doesClientHaveJsaIntegration"><div ng-repeat="associatedStudy in vm.form.polonStudies | orderBy:\'name\'"><span class="font-weight-bold">{{associatedStudy.name}}, </span><span ng-if="associatedStudy.title">{{ (\'document.jsa.title.\' + associatedStudy.title) | translate }}, </span><span ng-if="associatedStudy.form">{{ associatedStudy.form }}, </span>UID: {{associatedStudy.uid}}<md-button class="md-icon-button associated-study-delete-button" ng-click="vm.disassociatePolonStudy(associatedStudy)"><i class="material-icons">clear</i></md-button></div></div><div layout="row" layout-xs="column" flex flex-xs="100" ng-if="vm.doesClientHaveJsaIntegration"><md-autocomplete class="white-background" flex="50" flex-xs="100" md-floating-label="{{\'organisational.units.form.polon-study.associate\' | translate}}" md-no-cache="true" md-selected-item="vm.selectedPolonStudy" md-selected-item-change="vm.associatePolonStudy(item)" md-search-text="vm.polonStudySearchText" md-items="item in vm.getMatchingPolonStudies(vm.polonStudySearchText) | orderBy:\'name\'" md-item-text="\' \'" md-min-length="0" md-select-on-match="true" md-require-match="true" md-clear-button="true"><md-item-template><span ng-bind-html="vm.formatPolonStudy(item)"></span></md-item-template></md-autocomplete></div></div><div layout="row" flex layout-align="end center"><md-button id="cancelButton" ng-click="vm.backToMainList()" data-translate="global.form.button.cancel"></md-button><md-button id="saveButton" ng-click="vm.save(vm.form, $event)" class="md-raised md-primary button-waiting" ng-disabled="form.$invalid"><span data-translate="global.form.button.save"></span></md-button></div></form></md-content></div>');
$templateCache.put('app/account/settings/organisational-units/organisational-units-list/organisational-units.html','<div layout="column" class="site-container"><settings-menu active-tab="vm.activeTab"></settings-menu><div class="table-container" flex><md-content layout="row" layout-margin><md-card md-theme="{{ showDarkTheme ? \'dark-grey\' : \'default\' }}" md-theme-watch aria-hidden="false" flex><organisational-units-search on-search-data="vm.searchData" on-query-request="vm.queryRequest" on-get-data="vm.getData"></organisational-units-search><md-table-container><table id="tableOrganisationalUnits" md-table md-row-select="vm.options.rowSelection" multiple="{{vm.options.multiSelect}}" ng-model="vm.selected" md-progress="vm.promise" id="tableDocumentParameterDefinitions"><thead md-head md-order="vm.queryRequest.order" md-on-reorder="vm.prepareMapping"><tr md-row><th md-column><span>#</span></th><th md-column md-order-by="orguniLabel"><span data-translate="organisational.units.list.name"></span></th><th md-column ng-if="vm.doesClientHaveJsaIntegration"><span data-translate="organisational.units.list.polon-study-names"></span></th><th md-column class="table-actions"><span data-translate="global.table.actions"></span></th></tr></thead><tbody md-body><tr md-row md-select="row" md-on-select="vm.openBottomSheet" md-select-id="row.id" ng-repeat="row in vm.organisationalUnits"><td md-cell><span ng-show="!vm.isLoadingData">{{($index + 1) + ((vm.queryRequest.page - 1) * vm.queryRequest.limit)}}</span></td><td md-cell>{{row.orguniLabel}}</td><td md-cell ng-if="vm.doesClientHaveJsaIntegration"><span ng-repeat="polonStudyName in row.polonStudyNames">{{ polonStudyName }}<br></span></td><td md-cell><organisational-units-buttons button-lp="$index" organisational-unit-id="row.id" get-data="vm.getData"></organisational-units-buttons></td></tr></tbody></table><div class="loader" layout="row" layout-sm="column" layout-align="space-around"><md-progress-circular md-mode="indeterminate" ng-show="vm.isLoadingData"></md-progress-circular></div></md-table-container><!-- TABLE --><div flex><div layout="row" layout-align="start center"><md-button id="removeCheckedButton" aria-label="remove" ng-click="vm.removeItems($event)" ng-disabled="vm.selected.length == 0" data-translate="global.table.menu.delete"></md-button></div><div layout="row" layout-align="end center" layout-wrap><paging page="vm.queryRequest.page" page-size="vm.queryRequest.limit" total="vm.totalElements" show-prev-next="true" show-first-last="true" paging-action="vm.startPaging(page)"></paging><div layout="row" class="go-to" flex-xs="100" layout-margin layout-align="end center"><span class="to-to-text" data-translate="global.table.search.goto"></span><md-input-container><input aria-label="go to next page" ng-model="vm.queryRequest.page" type="number" ng-keyup="vm.prepareMapping()" ng-change="vm.prepareMapping()"></md-input-container></div></div></div></md-card></md-content></div></div>');
$templateCache.put('app/account/settings/organisational-units/organisational-units-search/organisational-units-search.template.html','<div layout-padding><div layout="row" layout-xs="column"><select-page-size query-request="$ctrl.onQueryRequest" on-value-chosen="$ctrl.getData()" flex="70" flex-xs="100" layout="row" layout-align="start center"></select-page-size><div layout="column" flex="30" flex-xs="100" layout-align="end center" class="layout-align-end-center layout-column flex-xs-100 flex-30"><md-button id="addOrganisationalUnitButton" ng-click="$ctrl.goToAddPage()" class="md-raised md-primary button-waiting" data-translate="users.settings.organisational.unit.add-btn"></md-button></div></div></div>');
$templateCache.put('app/account/settings/popup/popup-detail/popup-detail.template.html','<div class="popup-details-info" hide-xs layout="column" layout-padding><div layout="row" flex="100"><div layout="column" flex="20"><span class="detail-label" data-translate="popup.options.choose"></span></div><div layout="column" flex="80"><span ng-repeat="option in $ctrl.options" ng-if="$ctrl.popup.options[option.id] == true" class="detail-info">{{option.key | translate}}</span></div></div><div layout="row" flex="100"><div layout="column" flex="20"><span class="detail-label" data-translate="popup.form.email"></span></div><div layout="column" flex="80"><span class="detail-info">{{$ctrl.popup.email}}</span></div></div><div layout="row" flex="100"><div layout="column" flex="20"><span class="detail-label" data-translate="popup.form.client-ids"></span></div><div layout="column" flex="80"><span class="detail-info">{{$ctrl.popup.criteria.clientIds}}</span></div></div><div layout="row" flex="100"><div layout="column" flex="20"><span class="detail-label" data-translate="popup.form.roles.choose"></span></div><div layout="column" flex="80"><span ng-repeat="role in $ctrl.roles" ng-if="$ctrl.popup.criteria.roles[role.type.id] == true" class="detail-info">{{role.translationKey | translate}}</span></div></div></div>');
$templateCache.put('app/account/users/users-list/users-buttons/users-buttons.template.html','<div flex layout="row" layout-align="end center"><md-menu-bar flex layout="row"><md-menu><md-button aria-label="open" class="md-icon-button" ng-click="$mdMenu.open()"><i class="material-icons">more_vert</i></md-button><md-menu-content><md-menu-item ng-if="$ctrl.onLoggedUserIsAdmin || $ctrl.onLoggedUserIsSuperAdmin || ($ctrl.onLoggedUserIsOrgUnitAdmin && !$ctrl.onUserAdmin())"><md-button aria-label="Edit" ng-click="$ctrl.editUser()" data-translate="global.button.edit"></md-button></md-menu-item><md-menu-item ng-if="$ctrl.onLoggedUserIsMainSuperAdmin && $ctrl.canEditRegions()"><md-button aria-label="Edit" ui-sref="userRegions({userId: $ctrl.onUser.id})" data-translate="users.table.menu.edit-client-regions"></md-button></md-menu-item><md-menu-item ng-if="($ctrl.onLoggedUserIsAdmin || $ctrl.onLoggedUserIsOrgUnitAdmin) && !$ctrl.hideUserHistory"><md-button aria-label="show history" ng-click="$ctrl.showHistory($event)" data-translate="users.table.menu.show.history"></md-button></md-menu-item><md-menu-item ng-if="$ctrl.onLoggedUserIsSuperAdmin"><md-button aria-label="show login history" class="pt-0" ui-sref="userLoginHistory({userId: $ctrl.onUser.id})" data-translate="users.table.menu.show.login-history"></md-button></md-menu-item><md-menu-item ng-if="$ctrl.onLoggedUserIsSuperAdmin && $ctrl.onUser.userSchoolTypeEnum == \'USER_SCHOOL_TYPE_INDIVIDUAL\'"><md-button aria-label="Add free tokens" ng-click="$ctrl.showAddFreeTokensForm($event)" data-translate="users.table.menu.add.free.tokens"></md-button></md-menu-item><md-menu-item><md-button aria-label="Remind" ng-click="$ctrl.remindPassword($event)" data-translate="users.remind.password"></md-button></md-menu-item><md-menu-item ng-if="$ctrl.onUser.userStatusEnum == \'PRESENT\' && !($ctrl.onLoggedUserIsOrgUnitAdmin && $ctrl.onUserAdmin()) && !$ctrl.isReseller && !$ctrl.isMinistry"><md-button aria-label="Hibernate" ng-click="$ctrl.hibernateUser()" data-translate="global.button.hibernate"></md-button></md-menu-item><md-menu-item ng-if="($ctrl.onUser.userStatusEnum == \'ACTIVE_HIBERNATE\' || $ctrl.onUser.userStatusEnum == \'INACTIVE_HIBERNATE\') && !($ctrl.onLoggedUserIsOrgUnitAdmin && $ctrl.onUserAdmin()) && !$ctrl.isReseller && !$ctrl.isMinistry"><md-button aria-label="Activate" ng-click="$ctrl.activateUser()" data-translate="global.button.activate"></md-button></md-menu-item><md-menu-item ng-if="($ctrl.onUser.userSchoolTypeEnum == \'USER_SCHOOL_TYPE_ADMINISTRATOR\' || $ctrl.onUser.userSchoolTypeEnum == \'USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR\') && !$ctrl.onUser.mainAdmin && $ctrl.onLoggedUserIsSuperAdmin"><md-button aria-label="Grant Admin Rights" ng-click="$ctrl.grantMainAdminRights($ctrl.onUser.id, $event)" data-translate="users.grant.main.admin.rights"></md-button></md-menu-item><md-menu-item ng-if="($ctrl.onUser.userSchoolTypeEnum == \'USER_SCHOOL_TYPE_ADMINISTRATOR\' || $ctrl.onUser.userSchoolTypeEnum == \'USER_SCHOOL_TYPE_OPERATOR_ADMINISTRATOR\') && $ctrl.onUser.mainAdmin && $ctrl.onLoggedUserIsSuperAdmin"><md-button aria-label="Revoke Admin Rights" ng-click="$ctrl.revokeMainAdminRights($ctrl.onUser.id, $event)" data-translate="users.revoke.main.admin.rights"></md-button></md-menu-item><md-menu-item ng-if="!$ctrl.isMinistry && ($ctrl.onLoggedUserIsSuperAdmin || ($ctrl.onLoggedUserIsMainAdmin && !$ctrl.onUser.mainAdmin) || !$ctrl.onUserAdmin())"><md-button aria-label="Remove" ng-click="$ctrl.removeUser()" data-translate="global.button.remove"></md-button></md-menu-item><md-menu-item ng-if="$ctrl.onUser.canSuperAdminLoginOnUser && ($ctrl.onUser.userStatus == 0 || $ctrl.onUser.userStatus == -3)"><md-button aria-label="Login" ng-click="$ctrl.loginAs($ctrl.onUser.userEmail, $event)" data-translate="global.button.login-as"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div>');
$templateCache.put('app/account/documents/document/document-form/document-form-individual/document-metric-individual.template.html','<div class="add-document-wrapper" ng-class="{ \'active\': $ctrl.onUploadIsActive}"><md-toolbar><div class="md-toolbar-tools" flex layout="row"><span flex="40" class="add-document-text" data-translate="document.metric.add-document">Dodaj dokument</span><div flex="60" ng-if="!$ctrl.onUploadTextFlag"><span class="add-file-text" data-translate="document.metric.file-uploaded">Dodano plik:</span> <i class="material-icons doc-remove" ng-click="$ctrl.resetUploadForm()">cancel</i><md-tooltip md-delay="100" md-direction="bottom">{{$ctrl.onUploadObj.docuTitle}}</md-tooltip><div flex class="document-title">{{$ctrl.onUploadObj.docuTitle}}</div></div><div flex="60" ng-if="$ctrl.onUploadTextFlag"><span class="add-file-text" data-translate="document.metric.textuploaded">Dodano tekst!</span><md-button ng-click="$ctrl.uploadText()" data-translate="document.metric.edittext">Anuluj</md-button><md-button ng-click="$ctrl.resetUploadForm()" data-translate="document.metric.deletetext">Anuluj</md-button></div></div></md-toolbar><div layout-padding>&nbsp;</div><form ng-show="$ctrl.step === 1" name="metadata_form"><div layout="row" layout-margin layout-wrap><md-input-container class="md-block" flex="100" flex-xs="100"><input placeholder="{{!$ctrl.onUploadObj.docuTitle ? \'document.metric.placeholder.title\' : \'document.metric.document-title\' | translate}}" ng-model="$ctrl.onUploadObj.docuTitle" required name="docuTitle" md-maxlength="700" ng-maxlength="700"><plagiat-ng-messages form-element="metadata_form.docuTitle" translate-values="{maxlength: \'document.messages.max700\'}"></plagiat-ng-messages></md-input-container><md-input-container class="md-block" flex flex-xs="100"><input placeholder="{{!$ctrl.onUploadObj.authorFirstName ? \'document.metric.placeholder.name\' : \'document.metric.author-first-name\' | translate}}" required ng-model="$ctrl.onUploadObj.authorFirstName"></md-input-container><md-input-container class="md-block" flex flex-xs="100"><input placeholder="{{!$ctrl.onUploadObj.authorLastName ? \'document.metric.placeholder.surname\' : \'document.metric.author-last-name\' | translate}}" required ng-model="$ctrl.onUploadObj.authorLastName"></md-input-container></div><div layout="row mt-4" layout-margin layout-wrap><md-switch flex="100" flex-xs="100" aria-label="skip addressess" class="md-primary document-skip-address" name="documentSkipAddressesFlag" ng-model="$ctrl.onUploadObj.documentSkipAddressesFlag" ng-change="$ctrl.setAddressesBlock()" ng-init="$ctrl.onUploadObj.documentSkipAddressesFlag = $ctrl.onUploadObj.documentSkipAddresses.length>0"><div layout="row" layout-align="start center"><h4 data-translate="document.form.skip-addresses"></h4><i class="material-icons ml-1">info</i></div><md-tooltip ng-bind-html="\'document.form.skip-addresses.tooltip\' | translate" class="tooltip-with-long-text" md-direction="top"></md-tooltip></md-switch><md-chips flex="100" flex-xs="100" ng-if="$ctrl.onUploadObj.documentSkipAddressesFlag" aria-label="address to skip" ng-model="$ctrl.onUploadObj.documentSkipAddresses" name="documentSkipAddresses" readonly="false" md-removable="true" placeholder="{{\'document.form.skip-addresses-placeholder\' | translate}}" md-add-on-blur="true" md-transform-chip="$ctrl.getDocumentSkipAddress($chip)"><md-chip-template>{{$chip.address}}</md-chip-template></md-chips><div class="errors" ng-messages="metadata_form.documentSkipAddresses.$error" ng-if="$ctrl.skipAddressesInvalidError" flex flex-xs="100"><span data-translate="document.form.skip-addresses.invalid-url"></span> : {{$ctrl.skipAddressesInvalidUrl}}</div></div><div layout-padding><div class="doc-tokens-info" flex="50" flex-md="30" flex-sm="100" flex-xs="100" layout-align="start center"><span data-translate="document.metric.chars"></span> <b>{{$ctrl.onUploadObj.size}}</b></div></div></form><form ng-show="$ctrl.step === 2" name="extra_options_form" class="extra-options-form" layout="column" layout-padding><div layout="row"><span data-translate="document.form.extra.options.story"></span></div><div class="price" layout="row"><span data-translate="document.form.extra.options.initial.price" data-translate-values="{value: $ctrl.basePrice, size: $ctrl.onUploadObj.size}"></span> <span><md-tooltip md-delay="100" md-direction="top" class="accept-data-processing-tooltip">{{\'document.form.tooltip.extra.options.initial.price\' | translate}}</md-tooltip><i class="material-icons-outlined">info</i></span></div><div layout="row" layout-wrap ng-repeat="option in $ctrl.documentExtraOptions"><md-switch class="m-0 md-primary aligned-checkbox flex-xs-100 flex-sm-40 flex-md-30 flex-gt-md-20" ng-model="option.chosen" ng-change="$ctrl.recalculatePrices()" ng-disabled="$ctrl.isOptionDisabled(option)"><span class="font-weight-bold">{{(\'document.form.extra.option\' + option.id) | translate}}</span></md-switch><div class="flex-xs-100 flex-sm-40 flex-md-30 flex-gt-sm-10 option-price" layout="row" layout-align="center center"><span data-translate="document.form.extra.option.price" data-translate-values="{value: option.price}"></span></div><span class="flex-xs-100 flex-sm-100 flex-md-40 flex-gt-sm-50 option-description" ng-if="!$ctrl.isOptionDisabled(option)">{{(\'document.form.tooltip.extra.option\' + option.id) | translate}} </span><span class="flex-xs-100 flex-sm-100 flex-md-40 flex-gt-sm-50 option-description" ng-if="$ctrl.isOptionDisabled(option)">{{(\'document.form.tooltip.extra.disabled.option\' + option.id) | translate}}</span><md-tooltip md-delay="100" md-direction="top" ng-if="!$ctrl.isOptionDisabled(option) && option.id === 32 && $ctrl.isBg">{{\'document.form.tooltip.ai-detection-bg\'| translate}}</md-tooltip></div><div layout="row" layout-wrap><md-switch class="m-0 md-primary aligned-checkbox flex-xs-100 flex-sm-40 flex-md-30 flex-gt-md-20" ng-model="$ctrl.translation.chosen" ng-change="$ctrl.recalculatePrices()" ng-disabled="$ctrl.isAiDetectionEnabled()"><span class="font-weight-bold">{{(\'document.form.extra.option-translation\') | translate}}</span></md-switch><div class="flex-xs-100 flex-sm-40 flex-md-30 flex-gt-sm-10 option-price" layout="row" layout-align="center center"><span>&nbsp;</span></div><span class="flex-xs-100 flex-sm-100 flex-md-40 flex-gt-sm-50 option-description" ng-bind-html="\'document.form.tooltip.extra.option-translation\' | translate"></span></div><div layout="row" layout-wrap flex="100" ng-if="$ctrl.translation.chosen"><div layout-align="end end" layout="column" class="pr-1"><div><span layout-align="center end" data-translate="document.metric.auto-translations.translate-lang-text"></span></div></div><md-input-container flex="25" flex-md="35" flex-xs="100"><label data-translate="document.metric.auto-translations.to-lang-placeholder">J\u0119zyk docelowy</label><md-select id="toLangSelect" name="toLangSelect" aria-label="toLang" layout-align="center center" ng-model="$ctrl.translation.autoTranslationsToLang" ng-required="true" class="mt-0"><md-option id="autoTranslationLangsTo{{val.code}}" ng-value="val.code" ng-repeat="val in $ctrl.autoTranslationLangs">{{val.translated}}</md-option></md-select><plagiat-ng-messages form-element="form.toLangSelect"></plagiat-ng-messages></md-input-container><div></div></div><div layout="row" class="price"><span data-translate="document.form.extra.options.total.price" data-translate-values="{value: $ctrl.totalPrice}"></span></div></form><div layout="row" flex layout-xs="column" layout-margin class="mt-4"><div layout="row" flex="35" flex-md="30" flex-sm="20" flex-xs="100" layout-align="start center"><span class="document-metric-step" data-translate="document.metric.step" data-translate-values="{currentStep: $ctrl.step, stepsCount: 2}"></span></div><div class="doc-check-button" layout="row" flex="65" flex-md="70" flex-sm="80" flex-xs="100" layout-align="end center"><md-button ng-if="$ctrl.step === 1" ng-click="$ctrl.resetUploadForm()" data-translate="document.metric.cancel" aria-label="2">Anuluj</md-button><md-button ng-if="$ctrl.step === 2" ng-click="$ctrl.step = 1" data-translate="document.metric.step.previous" aria-label="1"></md-button><md-button ng-if="$ctrl.step === 2" ng-click="$ctrl.checkLater(extra_options_form, $event)" data-translate="document.metric.check-later" aria-label="checkLater">Sprawd\u017A p\xF3\u017Aniej</md-button><md-button ng-if="$ctrl.step === 2" ng-click="$ctrl.check(extra_options_form)" aria-label="check" ng-disabled="$ctrl.isLoading" class="md-raised md-primary button-waiting" data-translate="document.metric.check">Sprawd\u017A</md-button><md-button ng-if="$ctrl.step === 1" ng-click="$ctrl.goToExtraOptions(metadata_form)" aria-label="goToExtraOptions" ng-disabled="$ctrl.isLoading" class="md-raised md-primary button-waiting" data-translate="document.metric.step.next"></md-button></div></div></div>');
$templateCache.put('app/account/documents/document/document-form/jsa-document-form/jsa-document-form.template.html','<div class="add-document-wrapper client-metric" ng-class="{\'active\': vm.onUploadIsActive}"><md-toolbar><div class="md-toolbar-tools" flex layout="row"><span flex="40" class="add-document-text" data-translate="document.metric.add-document">Dodaj dokument</span><div flex="60" ng-if="!vm.onUploadTextFlag"><span class="add-file-text" data-translate="document.metric.file-uploaded">Dodano plik:</span> <i class="material-icons doc-remove" ng-click="vm.resetUploadForm()">cancel</i><md-tooltip md-delay="100" md-direction="bottom">{{vm.onUploadObj.docuTitle}}</md-tooltip><div flex class="document-title">{{vm.onUploadObj.docuTitle}}</div></div><div flex="60" ng-if="vm.onUploadTextFlag"><span class="add-file-text" data-translate="document.metric.textuploaded">Dodano tekst!</span><md-button ng-click="vm.uploadText()" data-translate="document.metric.edittext">Anuluj</md-button><md-button ng-click="vm.resetUploadForm()" data-translate="document.metric.deletetext">Anuluj</md-button></div></div></md-toolbar><form name="form" layout-padding><div ng-include src="\'app/account/documents/document/document-form/jsa-document-form/jsa-document-metadata-form.template.html\'"></div><div layout="row" ng-if="vm.showDocumentVerification() && !vm.onUploadObj.addWithoutChecking"><md-input-container flex="100"><md-switch aria-label="confirm paper form validity " class="md-primary m-1" name="paperFormValidityFlag" ng-model="vm.onUploadObj.paperFormValidityFlag" required><span data-translate="document.form.paper.validity"></span> <span>&nbsp;{{vm.onUploadObj.size | numberOfPages}}</span> <i class="material-icons">info</i></md-switch><div class="ml-3"><plagiat-ng-messages form-element="form.paperFormValidityFlag"></plagiat-ng-messages></div></md-input-container></div><div layout="row"><md-input-container flex="100"><md-switch aria-label="document skip addresses flag" class="md-primary m-1" name="documentSkipAddressesFlag" ng-model="vm.onUploadObj.documentSkipAddressesFlag" ng-change="vm.setAddressesBlock()" ng-init="vm.onUploadObj.documentSkipAddressesFlag = vm.onUploadObj.documentSkipAddresses.length>0" ng-disabled="vm.isJsaDisabled"><span data-translate="document.form.skip-addresses"></span> <i class="material-icons">info</i><md-tooltip class="tooltip-with-long-text" md-direction="top" ng-bind-html="\'document.form.skip-addresses.tooltip\' | translate"></md-tooltip></md-switch></md-input-container></div><div layout="row" class="document-metric-authors" ng-if="vm.onUploadObj.documentSkipAddressesFlag"><md-chips aria-label="address to skip" min-width="400" ng-model="vm.onUploadObj.documentSkipAddresses" name="documentSkipAddresses" readonly="false" md-add-on-blur="true" md-removable="true" placeholder="{{\'document.form.skip-addresses-placeholder\' | translate}}" md-transform-chip="vm.getDocumentSkipAddress($chip)" ng-disabled="vm.isJsaDisabled"><md-chip-template>{{$chip.address}}</md-chip-template></md-chips></div><div layout="row"><div class="doc-tokens-info" flex="50" flex-md="30" flex-sm="100" flex-xs="100" layout-align="start center"><span data-translate="document.metric.chars"></span><br><b>{{vm.onUploadObj.size}}</b></div><div layout="row" flex="50" flex="50" flex-xs="100" layout-align="end center"><md-button aria-label="cancel" ng-click="vm.resetUploadForm()" data-translate="document.metric.cancel">Anuluj</md-button><md-button ng-if="!vm.onUploadObj.addWithoutChecking" id="buttonAddWithChecking" aria-label="add" class="md-raised md-primary button-waiting" data-translate="document.metric.client.add" ng-click="vm.addDocumentJsa(vm.onUploadObj, form)">Dodaj</md-button></div></div></form></div>');
$templateCache.put('app/account/documents/document/document-form/jsa-document-form/jsa-document-metadata-form.template.html','<div layout="column" layout-margin><span id="addWithoutCheckingError" ng-if="vm.onUploadObj.addWithoutCheckingError"><span data-translate="{{vm.onUploadObj.addWithoutCheckingErrorText}}" class="md-input-messages-error"></span></span><md-divider></md-divider><div layout="row" class="document-metric-title" ng-if="vm.onUploadObj.docuTitleInfo.isPresent"><md-input-container flex="100" flex-xs="100"><input placeholder="{{!vm.onUploadObj.title ? \'document.metric.placeholder.title\' : \'document.metric.document-title\' | translate}}" ng-model="vm.onUploadObj.title" name="docuTitle" ng-maxlength="700" ng-disabled="vm.isJsaDisabled" required><plagiat-ng-messages form-element="form.docuTitle" translate-values="{maxlength: \'document.messages.max700\'}"></plagiat-ng-messages></md-input-container></div><div layout="row" ng-if="vm.onUploadObj.docuAuthorInfo.isPresent"><md-input-container flex="50" flex-xs="100"><md-autocomplete md-input-name="jsaAuthor" md-floating-label="{{\'document.metric.authorfullname\' | translate}}" md-no-cache="vm.noCache" md-selected-item="vm.selectedItem[0]" md-search-text-change="vm.searchTextChange(vm.searchText[0])" md-search-text="vm.searchText[0]" md-selected-item-change="vm.selectedAuthorChanged(item, 0)" md-items="item in vm.searchAuthors(vm.searchText[0])" md-item-text="vm.formatAuthor(item)" md-min-length="0" md-select-on-match="true" md-require-match="true" md-clear-button="true" md-delay="500" ng-disabled="vm.isDisabled || vm.isJsaDisabled" required><md-item-template><span md-highlight-text="vm.searchText[0]" md-highlight-flags="^i">{{vm.formatAuthor(item)}}</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{vm.searchText[0]}}"</md-not-found><plagiat-ng-messages form-element="form.jsaAuthor"></plagiat-ng-messages></md-autocomplete></md-input-container><!--PolonStudy of selected author--><md-input-container flex="35" flex-xs="100" ng-if="!vm.isPhdThesis"><label data-translate="document.jsa.author.study"></label><md-select name="authorStudy" aria-label="author study" layout-align="center center" ng-model="vm.onUploadObj.authors[0].selectedStudy" ng-disabled="vm.isJsaDisabled || vm.onUploadObj.authors.length == 0 || vm.onUploadObj.authors[0] == null" ng-change="vm.selectedStudyChanged()" required><md-option id="\'optionalAuthorStudy\' + {{val.id}}" ng-selected="val.id == vm.selectedItem[0].selectedStudy.id" ng-value="val" ng-repeat="val in vm.selectedItem[0].studies">{{val.name}}, UID: {{val.uid}} <span ng-if="val.title">,{{\'document.jsa.title.\' + val.title | translate}}</span> <span ng-if="val.form">,{{val.form}}</span></md-option></md-select><plagiat-ng-messages form-element="form.authorStudy"></plagiat-ng-messages></md-input-container><!-- AUTHOR INDEX --><md-input-container class="m-top plagiat-input-color" flex="15" flex-xs="100" ng-if="!vm.isPhdThesis"><input name="authorIndex" placeholder="{{!vm.onUploadObj.authors[0].index ? \'document.metric.placeholder.index\' : \'document.metric.client.index\' | translate}}" ng-model="vm.onUploadObj.authors[0].index" ng-required="vm.shouldRequireIndexNumber()" ng-disabled="vm.isJsaDisabled"><plagiat-ng-messages form-element="form.authorIndex"></plagiat-ng-messages></md-input-container></div><div class="cooauthors-add" layout="row" ng-if="vm.onUploadObj.docuAuthorInfo.isPresent"><md-button ng-click="vm.addAuthor()" class="md-raised md-primary" data-translate="document.metric.client.add-author" ng-disabled="vm.isJsaDisabled">Dodaj wsp\xF3\u0142autora</md-button></div><div layout="row" class="document-metric-authors" ng-repeat="author in vm.onUploadObj.authors" ng-if="vm.onUploadObj.docuTitleInfo.isPresent && $index != 0"><md-input-container flex="40" flex-xs="100"><md-autocomplete md-input-name="{{\'jsaCoAuthor\' + $index}}" md-floating-label="{{\'document.metric.placeholder.coauthorfullname\' | translate}}" ng-disabled="vm.isDisabled" md-no-cache="vm.noCache" md-selected-item="vm.selectedItem[$index]" md-search-text-change="vm.searchTextChange(vm.searchText[$index])" md-search-text="vm.searchText[$index]" md-selected-item-change="vm.selectedAuthorChanged(item, $index)" md-items="item in vm.searchAuthors(vm.searchText[$index])" md-item-text="vm.formatAuthor(item)" md-min-length="0" md-clear-button="true" ng-disabled="vm.isJsaDisabled" md-select-on-match="true" md-require-match="true" md-delay="500" required><md-item-template><span md-highlight-text="vm.searchText[$index]" md-highlight-flags="^i">{{ vm.formatAuthor(item)}}</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{vm.searchText[$index]}}"</md-not-found><plagiat-ng-messages form-element="form[\'jsaCoAuthor\' + $index]"></plagiat-ng-messages></md-autocomplete></md-input-container><!--PolonStudy of selected coauthor--><md-input-container flex="35" flex-xs="100" ng-if="!vm.isPhdThesis"><label data-translate="document.jsa.author.study"></label><md-select name="{{\'jsaCoAuthorStudy\' + $index}}" aria-label="{{\'jsaCoAuthorStudy\' + $index}}" ng-model="vm.onUploadObj.authors[$index].selectedStudy" ng-disabled="vm.isJsaDisabled || vm.onUploadObj.authors.length == 0 || vm.onUploadObj.authors[$index] == null" required><md-option id="{{\'optionJsaCoAuthorStudy\' + $index}}" ng-selected="val.id == vm.selectedItem[$index].selectedStudy.id" ng-value="val" ng-repeat="val in vm.selectedItem[$index].studies">{{val.name}}, UID: {{val.uid}} <span ng-if="val.title">,{{\'document.jsa.title.\' + val.title | translate}}</span> <span ng-if="val.form">,{{val.form}}</span></md-option></md-select><plagiat-ng-messages form-element="form[\'jsaCoAuthorStudy\' + $index]"></plagiat-ng-messages></md-input-container><!-- COAUTHOR INDEX --><md-input-container class="plagiat-input-color" flex="15" flex-xs="100" ng-if="!vm.isPhdThesis"><input name="{{\'jsaCoAuthorIndex\' + $index}}" placeholder="{{!vm.onUploadObj.authors[$index].index ? \'document.metric.placeholder.index\' : \'document.metric.client.index\' | translate}}" ng-model="vm.onUploadObj.authors[$index].index" ng-required="vm.shouldRequireIndexNumber()" ng-disabled="vm.isJsaDisabled"><plagiat-ng-messages form-element="form[\'jsaCoAuthorIndex\' + $index]"></plagiat-ng-messages></md-input-container><md-input-container flex="10" flex-xs="100"><md-button ng-click="vm.removeAuthor($event, $index)" class="md-raised md-primary">X</md-button></md-input-container></div><div layout="row"><!--Promotor--><md-input-container flex="25" flex-xs="100" ng-if="vm.onUploadObj.coordinatorInfo.isPresent"><md-autocomplete md-input-name="coordinator" md-floating-label="{{\'document.model.docu-coordinator\'| translate}}" md-selected-item="vm.selectedPromoter" md-search-text="vm.searchValuePromoter" md-selected-item-change="vm.selectPromoter(item)" md-items="item in vm.searchPromoters(vm.searchValuePromoter)" md-item-text="item.name + \' \' + item.surname + \', UID: \' + item.polonUid" md-min-length="0" md-clear-button="true && !vm.promoterNotEditable" ng-disabled="vm.isJsaDisabled || vm.promoterNotEditable" md-select-on-match="true" md-require-match="true" md-delay="500" required><md-item-template><span md-highlight-text="vm.searchValuePromoter" md-highlight-flags="^i">{{item.name}} {{item.surname}}, UID: {{item.polonUid}}</span></md-item-template><md-not-found>{{\'global.search.notfound\'| translate}} "{{vm.searchValuePromoter}}"</md-not-found><plagiat-ng-messages form-element="form.coordinator"></plagiat-ng-messages></md-autocomplete></md-input-container><!--Promotor - Rodzaj dokumentu--><md-input-container flex="25" flex-xs="100" ng-if="vm.onUploadObj.docuKindInfo.isPresent"><label data-translate="document.metric.client.promoter.type"></label><md-select name="documentKind" aria-label="docu kinds" layout-align="center center" ng-required="vm.onUploadObj.docuKindInfo.isMandatory" ng-model="vm.onUploadObj.documentKindId" ng-disabled="vm.isJsaDisabled || vm.isPhdThesis"><md-option ng-selected="val.id == vm.selectedDocumentKindId" id="\'idOptionDocuKind\' + {{val.id}}" ng-repeat="val in vm.typeOfDocuments" ng-value="val.id"><em>{{val.label}}</em></md-option></md-select><plagiat-ng-messages form-element="form.documentKind"></plagiat-ng-messages></md-input-container><md-input-container flex="25" flex-xs="50" ng-if="vm.onUploadObj.docuKindInfo.isPresent"><md-autocomplete md-input-name="language" md-floating-label="{{\'document.model.language\'| translate}}" md-selected-item="vm.selectedLanguage" md-search-text="vm.querySearchForLanguage" md-selected-item-change="vm.selectLanguage(item)" md-items="item in vm.searchLanguages(vm.querySearchForLanguage)" md-item-text="vm.getLanguageItemText(item)" md-min-length="0" md-clear-button="true" ng-disabled="vm.isJsaDisabled" md-select-on-match="true" md-require-match="true" required><md-item-template><span md-highlight-text="vm.querySearchForLanguage" md-highlight-flags="^i">{{\'dictionary.language.\' + item.code | translate}}</span></md-item-template><md-not-found>Nie znaleziono "{{vm.searchValueLanguage}}".</md-not-found><plagiat-ng-messages form-element="form.language"></plagiat-ng-messages></md-autocomplete></md-input-container><!--Jednostka organizacyjna--><md-input-container flex="25" flex-xs="50" ng-if="vm.onUploadObj.orgUnitInfo.isPresent"><label data-translate="document.metric.client.promoter.unit"></label><md-select name="polonUnit" aria-label="polon units" ng-model="vm.onUploadObj.polonUnitId" ng-disabled="vm.isJsaDisabled || !vm.availableUnits || vm.availableUnits.length === 0" required><md-option ng-value="val.id" ng-repeat="val in vm.availableUnits" ng-selected="val.id == vm.onUploadObj.polonUnitId"><em>{{val.name + (val.uid ? \', UID: \' + val.uid : \'\')}}</em></md-option></md-select><plagiat-ng-messages form-element="form.polonUnit"></plagiat-ng-messages></md-input-container></div><div layout="row" layout-wrap layout-margin flex="100" ng-if="vm.onUploadObj.aiDetectionInfo.isPresent"><md-input-container flex><md-switch id="aiDetectionEnabledSwitch" class="md-primary mt-1 mb-1" name="aiDetectionEnabled" aria-label="document.metric.client.aiDetection" ng-model="vm.onUploadObj.aiDetection" ng-disabled="vm.aiDetectionDisabled()"><div layout="row"><span class="auto-translations-switch-text" id="aiDetectionEnabledSwitchText" data-translate="document.metric.ai-detection.label"></span><div class="ml-2"><i class="material-icons-outlined options">info</i><md-tooltip md-delay="100" md-direction="bottom" class="auto-translations-tooltip">{{\'document.metric.ai-detection.tooltip\'| translate}}</md-tooltip></div><span ng-if="vm.aiDetectionPoolExhausted()" data-translate="document.metric.ai-detection.pool.exhausted"></span></div></md-switch></md-input-container><div flex></div></div></div>');
$templateCache.put('app/client/client-add/steps/components/contract/contract.template.html','<div layout="row"><div flex="100"><md-card-title><md-card-title-text><span class="md-title" data-translate="client.model.active-contract">Aktywny kontrakt</span></md-card-title-text></md-card-title><div ng-if="!vm.client.contract"><span data-translate="client.model.no-active-contract">Brak aktywnego kontrakt</span></div><div ng-if="vm.client.contract"><div layout="row" layout-padding><md-input-container flex="50"><label data-translate="client.model.contract.date-from">Data od</label><md-datepicker required ng-model="vm.client.contract.contDateFrom" md-max-date="vm.onIsEdit ? vm.today : vm.client.contract.contDateTo" input-date md-open-on-focus></md-datepicker></md-input-container><md-input-container flex="50"><label data-translate="client.model.contract.date-to">Data do</label><md-datepicker required ng-model="vm.client.contract.contDateTo" input-date md-min-date="vm.client.contract.contDateFrom" md-max-date="vm.contractMaxDate" ng-change="vm.contractToDateChange()" md-open-on-focus></md-datepicker></md-input-container></div><md-divider></md-divider><md-card-title><md-card-title-text><span class="md-title" data-translate="client.edit.contract.cont-num-of-plag-reports">Spos\xF3b liczenia</span></md-card-title-text></md-card-title><div layout="row" layout-padding><md-radio-group ng-model="vm.client.contract.contType" class="md-primary" layout="row" required><md-radio-button value="{{vm.contractType.CONT_TYPE_PER_DOCUMENT.id}}">{{vm.contractType.CONT_TYPE_PER_DOCUMENT.key | translate}}</md-radio-button><md-radio-button value="{{vm.contractType.CONT_TYPE_PER_CHARACTER.id}}">{{vm.contractType.CONT_TYPE_PER_CHARACTER.key | translate}}</md-radio-button><md-radio-button value="{{vm.contractType.CONT_TYPE_PER_USER.id}}">{{vm.contractType.CONT_TYPE_PER_USER.key | translate}}</md-radio-button><md-radio-button value="{{vm.contractType.CONT_TYPE_PER_AUTHOR.id}}">{{vm.contractType.CONT_TYPE_PER_AUTHOR.key | translate}}</md-radio-button></md-radio-group></div><div layout="row" layout-padding><md-input-container flex="50"><label data-translate="client.model.contract.cont-num-of-plag-reports">Maksymalna liczba dokument\xF3w lub znak\xF3w</label><input required type="number" min="0" max="9223372036854775807" ng-model="vm.client.contract.contNumOfPlagReports"></md-input-container></div><div layout="row" ng-if="vm.onIsEdit" layout-padding><md-input-container flex="50"><label data-translate="client.model.contract.cont-num-of-plag-reports-left">Licznik dokument\xF3w lub znak\xF3w</label><input required type="number" min="0" max="{{vm.client.contract.contNumOfPlagReports}}" ng-model="vm.client.contract.contNumOfPlagReportsLeft" ng-disabled="(vm.client.contract.contType == vm.contractType.CONT_TYPE_PER_USER.id) || (vm.client.contract.contType == vm.contractType.CONT_TYPE_PER_AUTHOR.id)"></md-input-container><md-input-container flex="50"><label data-translate="client.model.contract.percent-of-plag-reports-used">Procent Dokument\xF3w lub znak\xF3w</label><input disabled="disabled" type="text" ng-value="vm.countPercentOfPlagReportsUsed(vm.client.contract)"></md-input-container></div><md-divider></md-divider><md-card-title><md-card-title-text><md-checkbox ng-model="vm.client.contract.contAiDetectionEnabled" aria-label="a"></md-checkbox><span class="md-title" data-translate="client.edit.contract.ai.detection.enabled">Detekcja AI</span></md-card-title-text></md-card-title><div layout="row" ng-if="vm.client.contract.contAiDetectionEnabled" layout-padding><md-input-container layout="row"><span data-translate="client.edit.contract.ai.detection.unlimited">Bez limitowania</span><md-switch ng-model="vm.client.contract.contAiDetectionPool" aria-label="a" class="m-0 pl-3 pr-1"></md-switch><span data-translate="client.edit.contract.ai.detection.pool">Oddzielna pula na detekcj\u0119 AI</span></md-input-container></div><div layout="row" ng-if="vm.client.contract.contAiDetectionEnabled && vm.client.contract.contAiDetectionPool" layout-padding><md-input-container flex="50"><label data-translate="client.model.contract.cont-num-of-ai-detection">Maksymalna liczba dokument\xF3w lub znak\xF3w AI</label><input required type="number" min="0" max="9223372036854775807" ng-model="vm.client.contract.contNumOfAiDetection"></md-input-container></div><div layout="row" ng-if="vm.client.contract.contAiDetectionEnabled && !vm.client.contract.contAiDetectionPool && (vm.client.contract.contType == vm.contractType.CONT_TYPE_PER_USER.id)" layout-padding><md-input-container flex="50"><label data-translate="client.model.contract.cont-ai-document-limit-per-user">limit per user</label><input type="number" min="0" max="{{vm.client.contract.contNumOfPlagReportsLeft}}" ng-model="vm.client.contract.contAiDocumentLimitPerUser"></md-input-container></div><div layout="row" ng-if="vm.onIsEdit && vm.client.contract.contAiDetectionEnabled && vm.client.contract.contAiDetectionPool" layout-padding><md-input-container flex="50"><label data-translate="client.model.contract.cont-num-of-ai-detection-left">Licznik dokument\xF3w lub znak\xF3w AI</label><input required type="number" min="0" max="{{vm.client.contract.contNumOfAiDetection}}" ng-model="vm.client.contract.contNumOfAiDetectionLeft"></md-input-container><md-input-container flex="50"><label data-translate="client.model.contract.percent-of-ai-detection-used">Procent Dokument\xF3w lub znak\xF3w AI</label><input disabled="disabled" type="text" ng-value="vm.countPercentOfAiDetectionUsed(vm.client.contract)"></md-input-container></div><md-divider></md-divider><md-card-title><md-card-title-text><md-checkbox ng-model="vm.client.contract.contGrammarCheckEnabled" aria-label="a"></md-checkbox><span class="md-title" data-translate="client.edit.configuration.grammar-check.grammar-check">Grammar Check</span></md-card-title-text></md-card-title><md-divider></md-divider><md-card-title><md-card-title-text><span class="md-title" data-translate="client.edit.contract.cont-max-doc-plag-size">Rozmiar dokument\xF3w</span></md-card-title-text></md-card-title><div layout="row" layout-padding><md-input-container flex="50"><label data-translate="client.model.contract.cont-max-doc-plag-size">Praca standardowa (pula test\xF3w)</label><input required type="number" min="0" ng-model="vm.client.contract.contMaxDocPlagSize"></md-input-container></div><md-divider></md-divider><div layout="row" layout-padding><md-input-container flex="100"><label data-translate="client.model.contract.notes">Notatka</label><textarea name="contractNotes" ng-model="vm.client.contract.notes"></textarea></md-input-container></div></div></div><md-divider class="vertical-divider"></md-divider><div flex="100"><md-card-title><md-card-title-text><span ng-if="vm.client.contract" class="md-title" data-translate="client.model.forthcoming-contract">Nadchodz\u0105cy kontrakt</span></md-card-title-text></md-card-title><div ng-if="!vm.client.forthcomingContract"><md-button id="prevStep" aria-label="prevStep" class="md-raised md-primary" data-translate="{{vm.client.contract ? \'client.model.contract.add-forthcoming\' : \'client.model.contract.add-contract\'}}" ng-click="vm.createForthcomingContract()"></md-button></div><div ng-if="vm.client.forthcomingContract"><div layout="row" layout-padding><md-input-container flex="50"><label data-translate="client.model.contract.date-from">Data od</label><md-datepicker required ng-model="vm.client.forthcomingContract.contDateFrom" md-min-date="vm.forthcomingContractFromMinDate" md-max-date="vm.client.forthcomingContract.contDateTo" ng-change="vm.forthcomingContractFromDateChange()" input-date md-open-on-focus></md-datepicker></md-input-container><md-input-container flex="50"><label data-translate="client.model.contract.date-to">Data do</label><md-datepicker required ng-model="vm.client.forthcomingContract.contDateTo" input-date md-min-date="vm.client.forthcomingContract.contDateFrom" md-open-on-focus></md-datepicker></md-input-container></div><md-divider></md-divider><md-card-title><md-card-title-text><span class="md-title" data-translate="client.edit.contract.cont-num-of-plag-reports">Spos\xF3b liczenia</span></md-card-title-text></md-card-title><div layout="row" layout-padding><md-radio-group ng-model="vm.client.forthcomingContract.contType" class="md-primary" layout="row" required><md-radio-button value="{{vm.contractType.CONT_TYPE_PER_DOCUMENT.id}}">{{vm.contractType.CONT_TYPE_PER_DOCUMENT.key | translate}}</md-radio-button><md-radio-button value="{{vm.contractType.CONT_TYPE_PER_CHARACTER.id}}">{{vm.contractType.CONT_TYPE_PER_CHARACTER.key | translate}}</md-radio-button><md-radio-button value="{{vm.contractType.CONT_TYPE_PER_USER.id}}">{{vm.contractType.CONT_TYPE_PER_USER.key | translate}}</md-radio-button><md-radio-button value="{{vm.contractType.CONT_TYPE_PER_AUTHOR.id}}">{{vm.contractType.CONT_TYPE_PER_AUTHOR.key | translate}}</md-radio-button></md-radio-group></div><div layout="row" layout-padding><md-input-container flex="50"><label data-translate="client.model.contract.cont-num-of-plag-reports">Maksymalna liczba dokument\xF3w lub znak\xF3w</label><input required type="number" min="0" ng-model="vm.client.forthcomingContract.contNumOfPlagReports"></md-input-container></div><md-divider></md-divider><md-card-title><md-card-title-text><md-checkbox ng-model="vm.client.forthcomingContract.contAiDetectionEnabled" aria-label="a"></md-checkbox><span class="md-title" data-translate="client.edit.contract.ai.detection.enabled">Detekcja AI</span></md-card-title-text></md-card-title><div layout="row" ng-if="vm.client.forthcomingContract.contAiDetectionEnabled" layout-padding><md-input-container layout="row"><span data-translate="client.edit.contract.ai.detection.unlimited">Bez limitowania</span><md-switch ng-model="vm.client.forthcomingContract.contAiDetectionPool" aria-label="a" class="m-0 pl-3 pr-1"></md-switch><span data-translate="client.edit.contract.ai.detection.pool">Oddzielna pula na detekcj\u0119 AI</span></md-input-container></div><div layout="row" ng-if="vm.client.forthcomingContract.contAiDetectionEnabled && vm.client.forthcomingContract.contAiDetectionPool" layout-padding><md-input-container flex="50"><label data-translate="client.model.contract.cont-num-of-ai-detection">Maksymalna liczba dokument\xF3w lub znak\xF3w AI</label><input required type="number" min="0" max="9223372036854775807" ng-model="vm.client.forthcomingContract.contNumOfAiDetection"></md-input-container></div><div layout="row" ng-if="vm.client.forthcomingContract.contAiDetectionEnabled && !vm.client.forthcomingContract.contAiDetectionPool && (vm.client.forthcomingContract.contType == vm.contractType.CONT_TYPE_PER_USER.id)" layout-padding><md-input-container flex="50"><label data-translate="client.model.contract.cont-ai-document-limit-per-user">limit per user</label><input type="number" min="0" max="{{vm.client.contract.contNumOfPlagReports}}" ng-model="vm.client.forthcomingContract.contAiDocumentLimitPerUser"></md-input-container></div><md-divider></md-divider><md-card-title><md-card-title-text><md-checkbox ng-model="vm.client.forthcomingContract.contGrammarCheckEnabled" aria-label="a"></md-checkbox><span class="md-title" data-translate="client.edit.configuration.grammar-check.grammar-check">Grammar Check</span></md-card-title-text></md-card-title><md-divider></md-divider><md-card-title><md-card-title-text><span class="md-title" data-translate="client.edit.contract.cont-max-doc-plag-size">Rozmiar dokument\xF3w</span></md-card-title-text></md-card-title><div layout="row" layout-padding><md-input-container flex="50"><label data-translate="client.model.contract.cont-max-doc-plag-size">Praca standardowa (pula test\xF3w)</label><input required type="number" min="0" ng-model="vm.client.forthcomingContract.contMaxDocPlagSize"></md-input-container></div><md-divider></md-divider><div layout="row" layout-padding><md-input-container flex="100"><label data-translate="client.model.contract.notes">Notatka</label><textarea name="contractNotes" ng-model="vm.client.forthcomingContract.notes"></textarea></md-input-container></div><div layout="row" layout-padding><md-button id="cancelContract" aria-label="cancelContract" class="md-raised md-primary" data-translate="{{vm.client.forthcomingContract.id ? \'global.button.remove\' : \'global.button.cancel\'}}" ng-click="vm.disableForthcoming()"></md-button></div></div></div></div>');}]);})();